/******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId])
/******/ 			return installedModules[moduleId].exports;
/******/
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			exports: {},
/******/ 			id: moduleId,
/******/ 			loaded: false
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.loaded = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "/static/build/";
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(0);
/******/ })
/************************************************************************/
/******/ ([
/* 0 */
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(1);
	module.exports = __webpack_require__(151);


/***/ }),
/* 1 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var _jquery = __webpack_require__(2);
	
	var _jquery2 = _interopRequireDefault(_jquery);
	
	__webpack_require__(3);
	
	__webpack_require__(4);
	
	var _browser = __webpack_require__(5);
	
	var Sentry = _interopRequireWildcard(_browser);
	
	__webpack_require__(70);
	
	__webpack_require__(72);
	
	__webpack_require__(83);
	
	__webpack_require__(86);
	
	__webpack_require__(89);
	
	__webpack_require__(90);
	
	__webpack_require__(91);
	
	__webpack_require__(97);
	
	__webpack_require__(98);
	
	__webpack_require__(99);
	
	__webpack_require__(100);
	
	__webpack_require__(102);
	
	__webpack_require__(103);
	
	__webpack_require__(74);
	
	__webpack_require__(104);
	
	__webpack_require__(107);
	
	__webpack_require__(108);
	
	__webpack_require__(115);
	
	__webpack_require__(116);
	
	__webpack_require__(117);
	
	__webpack_require__(85);
	
	__webpack_require__(118);
	
	__webpack_require__(120);
	
	__webpack_require__(122);
	
	__webpack_require__(124);
	
	__webpack_require__(126);
	
	__webpack_require__(128);
	
	__webpack_require__(131);
	
	__webpack_require__(132);
	
	__webpack_require__(133);
	
	__webpack_require__(134);
	
	__webpack_require__(135);
	
	__webpack_require__(137);
	
	__webpack_require__(138);
	
	__webpack_require__(139);
	
	__webpack_require__(140);
	
	__webpack_require__(141);
	
	__webpack_require__(142);
	
	__webpack_require__(143);
	
	__webpack_require__(144);
	
	__webpack_require__(147);
	
	var _offCanvas = __webpack_require__(150);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	// hotfix Math-round in line :128 to solve smooth-scroll issue
	
	// import 'allink-core-static/js/modules/infobox';
	
	/* * * * * * * * * * * * * * * * * * * * * * * * * * * * * *
	
	 Custom Scripts
	
	 */
	
	// import 'allink-core-static/js/modules/form-modal';
	
	
	/* * * * * * * * * * * * * * * * * * * * * * * * * * * * * *
	
	 allink CORE (NPM package)
	
	 ===
	
	 These modules provide core functionality.
	
	 Note: Should you need a customzied project specific version of one of
	 the following modules:
	
	 Head over to the 'allink-core-static' repo, comment out the module below,
	 download the latest version and place it in the ./modules folder.
	
	 */
	
	// needs to be BEFORE the main script
	/* * * * * * * * * * * * * * * * * * * * * * * * * * * * * *
	
	 Essentals
	
	 */
	
	(0, _jquery2.default)(document).ready(function () {
	
	  /* * * * * * * * * * * * * * * * * * * * * * * * * * * * * *
	    Newsletter Form Toggle
	    Update: Not in use anymore
	    */
	
	  // $('[data-toggle-newsletter-form]').on('click', function (e) {
	  //     // init
	  //     e.preventDefault();
	  //     var $trigger = $(this);
	  //     var $newsletter_container = $('#mailchimp-form-container');
	  //     var opened_class = 'opened';
	  //     // check state:
	  //     // about to be visible
	  //     if ($trigger.hasClass(opened_class)) {
	  //         $trigger.removeClass(opened_class);
	  //     }
	  //     // about to be hidden
	  //     else {
	  //         $trigger.addClass(opened_class);
	  //         $newsletter_container.focus();
	  //     }
	  //     // toggle
	  //     $newsletter_container.toggle(150);
	  // })
	
	  /* * * * * * * * * * * * * * * * * * * * * * * * * * * * * *
	    Initialize CMS-Plugins after Ajax-Request
	    */
	
	  var offCanvasContainer = (0, _jquery2.default)('[data-offcanvas]');
	
	  if (offCanvasContainer) {
	    new _offCanvas.OffCanvas(offCanvasContainer);
	  }
	
	  if (typeof CMS !== 'undefined') {
	    (0, _jquery2.default)(window).on('ajaxLoadItems:success', function (event) {
	      console.log('init');
	      CMS.Plugin._initializeTree();
	    });
	  }
	
	  // Sentry.init({
	  //   dsn: 'https://96809a472df942eca6a10e2e3838a6d6@sentry.io/141587',
	  // });
	});
	// import 'allink-core-static/js/modules/video';
	
	
	/* * * * * * * * * * * * * * * * * * * * * * * * * * * * * *
	
	 NPM Packages

	 */

/***/ }),
/* 2 */
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/*!
	 * jQuery JavaScript Library v3.6.0
	 * https://jquery.com/
	 *
	 * Includes Sizzle.js
	 * https://sizzlejs.com/
	 *
	 * Copyright OpenJS Foundation and other contributors
	 * Released under the MIT license
	 * https://jquery.org/license
	 *
	 * Date: 2021-03-02T17:08Z
	 */
	( function( global, factory ) {
	
		"use strict";
	
		if ( typeof module === "object" && typeof module.exports === "object" ) {
	
			// For CommonJS and CommonJS-like environments where a proper `window`
			// is present, execute the factory and get jQuery.
			// For environments that do not have a `window` with a `document`
			// (such as Node.js), expose a factory as module.exports.
			// This accentuates the need for the creation of a real `window`.
			// e.g. var jQuery = require("jquery")(window);
			// See ticket #14549 for more info.
			module.exports = global.document ?
				factory( global, true ) :
				function( w ) {
					if ( !w.document ) {
						throw new Error( "jQuery requires a window with a document" );
					}
					return factory( w );
				};
		} else {
			factory( global );
		}
	
	// Pass this if window is not defined yet
	} )( typeof window !== "undefined" ? window : this, function( window, noGlobal ) {
	
	// Edge <= 12 - 13+, Firefox <=18 - 45+, IE 10 - 11, Safari 5.1 - 9+, iOS 6 - 9.1
	// throw exceptions when non-strict code (e.g., ASP.NET 4.5) accesses strict mode
	// arguments.callee.caller (trac-13335). But as of jQuery 3.0 (2016), strict mode should be common
	// enough that all such attempts are guarded in a try block.
	"use strict";
	
	var arr = [];
	
	var getProto = Object.getPrototypeOf;
	
	var slice = arr.slice;
	
	var flat = arr.flat ? function( array ) {
		return arr.flat.call( array );
	} : function( array ) {
		return arr.concat.apply( [], array );
	};
	
	
	var push = arr.push;
	
	var indexOf = arr.indexOf;
	
	var class2type = {};
	
	var toString = class2type.toString;
	
	var hasOwn = class2type.hasOwnProperty;
	
	var fnToString = hasOwn.toString;
	
	var ObjectFunctionString = fnToString.call( Object );
	
	var support = {};
	
	var isFunction = function isFunction( obj ) {
	
			// Support: Chrome <=57, Firefox <=52
			// In some browsers, typeof returns "function" for HTML <object> elements
			// (i.e., `typeof document.createElement( "object" ) === "function"`).
			// We don't want to classify *any* DOM node as a function.
			// Support: QtWeb <=3.8.5, WebKit <=534.34, wkhtmltopdf tool <=0.12.5
			// Plus for old WebKit, typeof returns "function" for HTML collections
			// (e.g., `typeof document.getElementsByTagName("div") === "function"`). (gh-4756)
			return typeof obj === "function" && typeof obj.nodeType !== "number" &&
				typeof obj.item !== "function";
		};
	
	
	var isWindow = function isWindow( obj ) {
			return obj != null && obj === obj.window;
		};
	
	
	var document = window.document;
	
	
	
		var preservedScriptAttributes = {
			type: true,
			src: true,
			nonce: true,
			noModule: true
		};
	
		function DOMEval( code, node, doc ) {
			doc = doc || document;
	
			var i, val,
				script = doc.createElement( "script" );
	
			script.text = code;
			if ( node ) {
				for ( i in preservedScriptAttributes ) {
	
					// Support: Firefox 64+, Edge 18+
					// Some browsers don't support the "nonce" property on scripts.
					// On the other hand, just using `getAttribute` is not enough as
					// the `nonce` attribute is reset to an empty string whenever it
					// becomes browsing-context connected.
					// See https://github.com/whatwg/html/issues/2369
					// See https://html.spec.whatwg.org/#nonce-attributes
					// The `node.getAttribute` check was added for the sake of
					// `jQuery.globalEval` so that it can fake a nonce-containing node
					// via an object.
					val = node[ i ] || node.getAttribute && node.getAttribute( i );
					if ( val ) {
						script.setAttribute( i, val );
					}
				}
			}
			doc.head.appendChild( script ).parentNode.removeChild( script );
		}
	
	
	function toType( obj ) {
		if ( obj == null ) {
			return obj + "";
		}
	
		// Support: Android <=2.3 only (functionish RegExp)
		return typeof obj === "object" || typeof obj === "function" ?
			class2type[ toString.call( obj ) ] || "object" :
			typeof obj;
	}
	/* global Symbol */
	// Defining this global in .eslintrc.json would create a danger of using the global
	// unguarded in another place, it seems safer to define global only for this module
	
	
	
	var
		version = "3.6.0",
	
		// Define a local copy of jQuery
		jQuery = function( selector, context ) {
	
			// The jQuery object is actually just the init constructor 'enhanced'
			// Need init if jQuery is called (just allow error to be thrown if not included)
			return new jQuery.fn.init( selector, context );
		};
	
	jQuery.fn = jQuery.prototype = {
	
		// The current version of jQuery being used
		jquery: version,
	
		constructor: jQuery,
	
		// The default length of a jQuery object is 0
		length: 0,
	
		toArray: function() {
			return slice.call( this );
		},
	
		// Get the Nth element in the matched element set OR
		// Get the whole matched element set as a clean array
		get: function( num ) {
	
			// Return all the elements in a clean array
			if ( num == null ) {
				return slice.call( this );
			}
	
			// Return just the one element from the set
			return num < 0 ? this[ num + this.length ] : this[ num ];
		},
	
		// Take an array of elements and push it onto the stack
		// (returning the new matched element set)
		pushStack: function( elems ) {
	
			// Build a new jQuery matched element set
			var ret = jQuery.merge( this.constructor(), elems );
	
			// Add the old object onto the stack (as a reference)
			ret.prevObject = this;
	
			// Return the newly-formed element set
			return ret;
		},
	
		// Execute a callback for every element in the matched set.
		each: function( callback ) {
			return jQuery.each( this, callback );
		},
	
		map: function( callback ) {
			return this.pushStack( jQuery.map( this, function( elem, i ) {
				return callback.call( elem, i, elem );
			} ) );
		},
	
		slice: function() {
			return this.pushStack( slice.apply( this, arguments ) );
		},
	
		first: function() {
			return this.eq( 0 );
		},
	
		last: function() {
			return this.eq( -1 );
		},
	
		even: function() {
			return this.pushStack( jQuery.grep( this, function( _elem, i ) {
				return ( i + 1 ) % 2;
			} ) );
		},
	
		odd: function() {
			return this.pushStack( jQuery.grep( this, function( _elem, i ) {
				return i % 2;
			} ) );
		},
	
		eq: function( i ) {
			var len = this.length,
				j = +i + ( i < 0 ? len : 0 );
			return this.pushStack( j >= 0 && j < len ? [ this[ j ] ] : [] );
		},
	
		end: function() {
			return this.prevObject || this.constructor();
		},
	
		// For internal use only.
		// Behaves like an Array's method, not like a jQuery method.
		push: push,
		sort: arr.sort,
		splice: arr.splice
	};
	
	jQuery.extend = jQuery.fn.extend = function() {
		var options, name, src, copy, copyIsArray, clone,
			target = arguments[ 0 ] || {},
			i = 1,
			length = arguments.length,
			deep = false;
	
		// Handle a deep copy situation
		if ( typeof target === "boolean" ) {
			deep = target;
	
			// Skip the boolean and the target
			target = arguments[ i ] || {};
			i++;
		}
	
		// Handle case when target is a string or something (possible in deep copy)
		if ( typeof target !== "object" && !isFunction( target ) ) {
			target = {};
		}
	
		// Extend jQuery itself if only one argument is passed
		if ( i === length ) {
			target = this;
			i--;
		}
	
		for ( ; i < length; i++ ) {
	
			// Only deal with non-null/undefined values
			if ( ( options = arguments[ i ] ) != null ) {
	
				// Extend the base object
				for ( name in options ) {
					copy = options[ name ];
	
					// Prevent Object.prototype pollution
					// Prevent never-ending loop
					if ( name === "__proto__" || target === copy ) {
						continue;
					}
	
					// Recurse if we're merging plain objects or arrays
					if ( deep && copy && ( jQuery.isPlainObject( copy ) ||
						( copyIsArray = Array.isArray( copy ) ) ) ) {
						src = target[ name ];
	
						// Ensure proper type for the source value
						if ( copyIsArray && !Array.isArray( src ) ) {
							clone = [];
						} else if ( !copyIsArray && !jQuery.isPlainObject( src ) ) {
							clone = {};
						} else {
							clone = src;
						}
						copyIsArray = false;
	
						// Never move original objects, clone them
						target[ name ] = jQuery.extend( deep, clone, copy );
	
					// Don't bring in undefined values
					} else if ( copy !== undefined ) {
						target[ name ] = copy;
					}
				}
			}
		}
	
		// Return the modified object
		return target;
	};
	
	jQuery.extend( {
	
		// Unique for each copy of jQuery on the page
		expando: "jQuery" + ( version + Math.random() ).replace( /\D/g, "" ),
	
		// Assume jQuery is ready without the ready module
		isReady: true,
	
		error: function( msg ) {
			throw new Error( msg );
		},
	
		noop: function() {},
	
		isPlainObject: function( obj ) {
			var proto, Ctor;
	
			// Detect obvious negatives
			// Use toString instead of jQuery.type to catch host objects
			if ( !obj || toString.call( obj ) !== "[object Object]" ) {
				return false;
			}
	
			proto = getProto( obj );
	
			// Objects with no prototype (e.g., `Object.create( null )`) are plain
			if ( !proto ) {
				return true;
			}
	
			// Objects with prototype are plain iff they were constructed by a global Object function
			Ctor = hasOwn.call( proto, "constructor" ) && proto.constructor;
			return typeof Ctor === "function" && fnToString.call( Ctor ) === ObjectFunctionString;
		},
	
		isEmptyObject: function( obj ) {
			var name;
	
			for ( name in obj ) {
				return false;
			}
			return true;
		},
	
		// Evaluates a script in a provided context; falls back to the global one
		// if not specified.
		globalEval: function( code, options, doc ) {
			DOMEval( code, { nonce: options && options.nonce }, doc );
		},
	
		each: function( obj, callback ) {
			var length, i = 0;
	
			if ( isArrayLike( obj ) ) {
				length = obj.length;
				for ( ; i < length; i++ ) {
					if ( callback.call( obj[ i ], i, obj[ i ] ) === false ) {
						break;
					}
				}
			} else {
				for ( i in obj ) {
					if ( callback.call( obj[ i ], i, obj[ i ] ) === false ) {
						break;
					}
				}
			}
	
			return obj;
		},
	
		// results is for internal usage only
		makeArray: function( arr, results ) {
			var ret = results || [];
	
			if ( arr != null ) {
				if ( isArrayLike( Object( arr ) ) ) {
					jQuery.merge( ret,
						typeof arr === "string" ?
							[ arr ] : arr
					);
				} else {
					push.call( ret, arr );
				}
			}
	
			return ret;
		},
	
		inArray: function( elem, arr, i ) {
			return arr == null ? -1 : indexOf.call( arr, elem, i );
		},
	
		// Support: Android <=4.0 only, PhantomJS 1 only
		// push.apply(_, arraylike) throws on ancient WebKit
		merge: function( first, second ) {
			var len = +second.length,
				j = 0,
				i = first.length;
	
			for ( ; j < len; j++ ) {
				first[ i++ ] = second[ j ];
			}
	
			first.length = i;
	
			return first;
		},
	
		grep: function( elems, callback, invert ) {
			var callbackInverse,
				matches = [],
				i = 0,
				length = elems.length,
				callbackExpect = !invert;
	
			// Go through the array, only saving the items
			// that pass the validator function
			for ( ; i < length; i++ ) {
				callbackInverse = !callback( elems[ i ], i );
				if ( callbackInverse !== callbackExpect ) {
					matches.push( elems[ i ] );
				}
			}
	
			return matches;
		},
	
		// arg is for internal usage only
		map: function( elems, callback, arg ) {
			var length, value,
				i = 0,
				ret = [];
	
			// Go through the array, translating each of the items to their new values
			if ( isArrayLike( elems ) ) {
				length = elems.length;
				for ( ; i < length; i++ ) {
					value = callback( elems[ i ], i, arg );
	
					if ( value != null ) {
						ret.push( value );
					}
				}
	
			// Go through every key on the object,
			} else {
				for ( i in elems ) {
					value = callback( elems[ i ], i, arg );
	
					if ( value != null ) {
						ret.push( value );
					}
				}
			}
	
			// Flatten any nested arrays
			return flat( ret );
		},
	
		// A global GUID counter for objects
		guid: 1,
	
		// jQuery.support is not used in Core but other projects attach their
		// properties to it so it needs to exist.
		support: support
	} );
	
	if ( typeof Symbol === "function" ) {
		jQuery.fn[ Symbol.iterator ] = arr[ Symbol.iterator ];
	}
	
	// Populate the class2type map
	jQuery.each( "Boolean Number String Function Array Date RegExp Object Error Symbol".split( " " ),
		function( _i, name ) {
			class2type[ "[object " + name + "]" ] = name.toLowerCase();
		} );
	
	function isArrayLike( obj ) {
	
		// Support: real iOS 8.2 only (not reproducible in simulator)
		// `in` check used to prevent JIT error (gh-2145)
		// hasOwn isn't used here due to false negatives
		// regarding Nodelist length in IE
		var length = !!obj && "length" in obj && obj.length,
			type = toType( obj );
	
		if ( isFunction( obj ) || isWindow( obj ) ) {
			return false;
		}
	
		return type === "array" || length === 0 ||
			typeof length === "number" && length > 0 && ( length - 1 ) in obj;
	}
	var Sizzle =
	/*!
	 * Sizzle CSS Selector Engine v2.3.6
	 * https://sizzlejs.com/
	 *
	 * Copyright JS Foundation and other contributors
	 * Released under the MIT license
	 * https://js.foundation/
	 *
	 * Date: 2021-02-16
	 */
	( function( window ) {
	var i,
		support,
		Expr,
		getText,
		isXML,
		tokenize,
		compile,
		select,
		outermostContext,
		sortInput,
		hasDuplicate,
	
		// Local document vars
		setDocument,
		document,
		docElem,
		documentIsHTML,
		rbuggyQSA,
		rbuggyMatches,
		matches,
		contains,
	
		// Instance-specific data
		expando = "sizzle" + 1 * new Date(),
		preferredDoc = window.document,
		dirruns = 0,
		done = 0,
		classCache = createCache(),
		tokenCache = createCache(),
		compilerCache = createCache(),
		nonnativeSelectorCache = createCache(),
		sortOrder = function( a, b ) {
			if ( a === b ) {
				hasDuplicate = true;
			}
			return 0;
		},
	
		// Instance methods
		hasOwn = ( {} ).hasOwnProperty,
		arr = [],
		pop = arr.pop,
		pushNative = arr.push,
		push = arr.push,
		slice = arr.slice,
	
		// Use a stripped-down indexOf as it's faster than native
		// https://jsperf.com/thor-indexof-vs-for/5
		indexOf = function( list, elem ) {
			var i = 0,
				len = list.length;
			for ( ; i < len; i++ ) {
				if ( list[ i ] === elem ) {
					return i;
				}
			}
			return -1;
		},
	
		booleans = "checked|selected|async|autofocus|autoplay|controls|defer|disabled|hidden|" +
			"ismap|loop|multiple|open|readonly|required|scoped",
	
		// Regular expressions
	
		// http://www.w3.org/TR/css3-selectors/#whitespace
		whitespace = "[\\x20\\t\\r\\n\\f]",
	
		// https://www.w3.org/TR/css-syntax-3/#ident-token-diagram
		identifier = "(?:\\\\[\\da-fA-F]{1,6}" + whitespace +
			"?|\\\\[^\\r\\n\\f]|[\\w-]|[^\0-\\x7f])+",
	
		// Attribute selectors: http://www.w3.org/TR/selectors/#attribute-selectors
		attributes = "\\[" + whitespace + "*(" + identifier + ")(?:" + whitespace +
	
			// Operator (capture 2)
			"*([*^$|!~]?=)" + whitespace +
	
			// "Attribute values must be CSS identifiers [capture 5]
			// or strings [capture 3 or capture 4]"
			"*(?:'((?:\\\\.|[^\\\\'])*)'|\"((?:\\\\.|[^\\\\\"])*)\"|(" + identifier + "))|)" +
			whitespace + "*\\]",
	
		pseudos = ":(" + identifier + ")(?:\\((" +
	
			// To reduce the number of selectors needing tokenize in the preFilter, prefer arguments:
			// 1. quoted (capture 3; capture 4 or capture 5)
			"('((?:\\\\.|[^\\\\'])*)'|\"((?:\\\\.|[^\\\\\"])*)\")|" +
	
			// 2. simple (capture 6)
			"((?:\\\\.|[^\\\\()[\\]]|" + attributes + ")*)|" +
	
			// 3. anything else (capture 2)
			".*" +
			")\\)|)",
	
		// Leading and non-escaped trailing whitespace, capturing some non-whitespace characters preceding the latter
		rwhitespace = new RegExp( whitespace + "+", "g" ),
		rtrim = new RegExp( "^" + whitespace + "+|((?:^|[^\\\\])(?:\\\\.)*)" +
			whitespace + "+$", "g" ),
	
		rcomma = new RegExp( "^" + whitespace + "*," + whitespace + "*" ),
		rcombinators = new RegExp( "^" + whitespace + "*([>+~]|" + whitespace + ")" + whitespace +
			"*" ),
		rdescend = new RegExp( whitespace + "|>" ),
	
		rpseudo = new RegExp( pseudos ),
		ridentifier = new RegExp( "^" + identifier + "$" ),
	
		matchExpr = {
			"ID": new RegExp( "^#(" + identifier + ")" ),
			"CLASS": new RegExp( "^\\.(" + identifier + ")" ),
			"TAG": new RegExp( "^(" + identifier + "|[*])" ),
			"ATTR": new RegExp( "^" + attributes ),
			"PSEUDO": new RegExp( "^" + pseudos ),
			"CHILD": new RegExp( "^:(only|first|last|nth|nth-last)-(child|of-type)(?:\\(" +
				whitespace + "*(even|odd|(([+-]|)(\\d*)n|)" + whitespace + "*(?:([+-]|)" +
				whitespace + "*(\\d+)|))" + whitespace + "*\\)|)", "i" ),
			"bool": new RegExp( "^(?:" + booleans + ")$", "i" ),
	
			// For use in libraries implementing .is()
			// We use this for POS matching in `select`
			"needsContext": new RegExp( "^" + whitespace +
				"*[>+~]|:(even|odd|eq|gt|lt|nth|first|last)(?:\\(" + whitespace +
				"*((?:-\\d)?\\d*)" + whitespace + "*\\)|)(?=[^-]|$)", "i" )
		},
	
		rhtml = /HTML$/i,
		rinputs = /^(?:input|select|textarea|button)$/i,
		rheader = /^h\d$/i,
	
		rnative = /^[^{]+\{\s*\[native \w/,
	
		// Easily-parseable/retrievable ID or TAG or CLASS selectors
		rquickExpr = /^(?:#([\w-]+)|(\w+)|\.([\w-]+))$/,
	
		rsibling = /[+~]/,
	
		// CSS escapes
		// http://www.w3.org/TR/CSS21/syndata.html#escaped-characters
		runescape = new RegExp( "\\\\[\\da-fA-F]{1,6}" + whitespace + "?|\\\\([^\\r\\n\\f])", "g" ),
		funescape = function( escape, nonHex ) {
			var high = "0x" + escape.slice( 1 ) - 0x10000;
	
			return nonHex ?
	
				// Strip the backslash prefix from a non-hex escape sequence
				nonHex :
	
				// Replace a hexadecimal escape sequence with the encoded Unicode code point
				// Support: IE <=11+
				// For values outside the Basic Multilingual Plane (BMP), manually construct a
				// surrogate pair
				high < 0 ?
					String.fromCharCode( high + 0x10000 ) :
					String.fromCharCode( high >> 10 | 0xD800, high & 0x3FF | 0xDC00 );
		},
	
		// CSS string/identifier serialization
		// https://drafts.csswg.org/cssom/#common-serializing-idioms
		rcssescape = /([\0-\x1f\x7f]|^-?\d)|^-$|[^\0-\x1f\x7f-\uFFFF\w-]/g,
		fcssescape = function( ch, asCodePoint ) {
			if ( asCodePoint ) {
	
				// U+0000 NULL becomes U+FFFD REPLACEMENT CHARACTER
				if ( ch === "\0" ) {
					return "\uFFFD";
				}
	
				// Control characters and (dependent upon position) numbers get escaped as code points
				return ch.slice( 0, -1 ) + "\\" +
					ch.charCodeAt( ch.length - 1 ).toString( 16 ) + " ";
			}
	
			// Other potentially-special ASCII characters get backslash-escaped
			return "\\" + ch;
		},
	
		// Used for iframes
		// See setDocument()
		// Removing the function wrapper causes a "Permission Denied"
		// error in IE
		unloadHandler = function() {
			setDocument();
		},
	
		inDisabledFieldset = addCombinator(
			function( elem ) {
				return elem.disabled === true && elem.nodeName.toLowerCase() === "fieldset";
			},
			{ dir: "parentNode", next: "legend" }
		);
	
	// Optimize for push.apply( _, NodeList )
	try {
		push.apply(
			( arr = slice.call( preferredDoc.childNodes ) ),
			preferredDoc.childNodes
		);
	
		// Support: Android<4.0
		// Detect silently failing push.apply
		// eslint-disable-next-line no-unused-expressions
		arr[ preferredDoc.childNodes.length ].nodeType;
	} catch ( e ) {
		push = { apply: arr.length ?
	
			// Leverage slice if possible
			function( target, els ) {
				pushNative.apply( target, slice.call( els ) );
			} :
	
			// Support: IE<9
			// Otherwise append directly
			function( target, els ) {
				var j = target.length,
					i = 0;
	
				// Can't trust NodeList.length
				while ( ( target[ j++ ] = els[ i++ ] ) ) {}
				target.length = j - 1;
			}
		};
	}
	
	function Sizzle( selector, context, results, seed ) {
		var m, i, elem, nid, match, groups, newSelector,
			newContext = context && context.ownerDocument,
	
			// nodeType defaults to 9, since context defaults to document
			nodeType = context ? context.nodeType : 9;
	
		results = results || [];
	
		// Return early from calls with invalid selector or context
		if ( typeof selector !== "string" || !selector ||
			nodeType !== 1 && nodeType !== 9 && nodeType !== 11 ) {
	
			return results;
		}
	
		// Try to shortcut find operations (as opposed to filters) in HTML documents
		if ( !seed ) {
			setDocument( context );
			context = context || document;
	
			if ( documentIsHTML ) {
	
				// If the selector is sufficiently simple, try using a "get*By*" DOM method
				// (excepting DocumentFragment context, where the methods don't exist)
				if ( nodeType !== 11 && ( match = rquickExpr.exec( selector ) ) ) {
	
					// ID selector
					if ( ( m = match[ 1 ] ) ) {
	
						// Document context
						if ( nodeType === 9 ) {
							if ( ( elem = context.getElementById( m ) ) ) {
	
								// Support: IE, Opera, Webkit
								// TODO: identify versions
								// getElementById can match elements by name instead of ID
								if ( elem.id === m ) {
									results.push( elem );
									return results;
								}
							} else {
								return results;
							}
	
						// Element context
						} else {
	
							// Support: IE, Opera, Webkit
							// TODO: identify versions
							// getElementById can match elements by name instead of ID
							if ( newContext && ( elem = newContext.getElementById( m ) ) &&
								contains( context, elem ) &&
								elem.id === m ) {
	
								results.push( elem );
								return results;
							}
						}
	
					// Type selector
					} else if ( match[ 2 ] ) {
						push.apply( results, context.getElementsByTagName( selector ) );
						return results;
	
					// Class selector
					} else if ( ( m = match[ 3 ] ) && support.getElementsByClassName &&
						context.getElementsByClassName ) {
	
						push.apply( results, context.getElementsByClassName( m ) );
						return results;
					}
				}
	
				// Take advantage of querySelectorAll
				if ( support.qsa &&
					!nonnativeSelectorCache[ selector + " " ] &&
					( !rbuggyQSA || !rbuggyQSA.test( selector ) ) &&
	
					// Support: IE 8 only
					// Exclude object elements
					( nodeType !== 1 || context.nodeName.toLowerCase() !== "object" ) ) {
	
					newSelector = selector;
					newContext = context;
	
					// qSA considers elements outside a scoping root when evaluating child or
					// descendant combinators, which is not what we want.
					// In such cases, we work around the behavior by prefixing every selector in the
					// list with an ID selector referencing the scope context.
					// The technique has to be used as well when a leading combinator is used
					// as such selectors are not recognized by querySelectorAll.
					// Thanks to Andrew Dupont for this technique.
					if ( nodeType === 1 &&
						( rdescend.test( selector ) || rcombinators.test( selector ) ) ) {
	
						// Expand context for sibling selectors
						newContext = rsibling.test( selector ) && testContext( context.parentNode ) ||
							context;
	
						// We can use :scope instead of the ID hack if the browser
						// supports it & if we're not changing the context.
						if ( newContext !== context || !support.scope ) {
	
							// Capture the context ID, setting it first if necessary
							if ( ( nid = context.getAttribute( "id" ) ) ) {
								nid = nid.replace( rcssescape, fcssescape );
							} else {
								context.setAttribute( "id", ( nid = expando ) );
							}
						}
	
						// Prefix every selector in the list
						groups = tokenize( selector );
						i = groups.length;
						while ( i-- ) {
							groups[ i ] = ( nid ? "#" + nid : ":scope" ) + " " +
								toSelector( groups[ i ] );
						}
						newSelector = groups.join( "," );
					}
	
					try {
						push.apply( results,
							newContext.querySelectorAll( newSelector )
						);
						return results;
					} catch ( qsaError ) {
						nonnativeSelectorCache( selector, true );
					} finally {
						if ( nid === expando ) {
							context.removeAttribute( "id" );
						}
					}
				}
			}
		}
	
		// All others
		return select( selector.replace( rtrim, "$1" ), context, results, seed );
	}
	
	/**
	 * Create key-value caches of limited size
	 * @returns {function(string, object)} Returns the Object data after storing it on itself with
	 *	property name the (space-suffixed) string and (if the cache is larger than Expr.cacheLength)
	 *	deleting the oldest entry
	 */
	function createCache() {
		var keys = [];
	
		function cache( key, value ) {
	
			// Use (key + " ") to avoid collision with native prototype properties (see Issue #157)
			if ( keys.push( key + " " ) > Expr.cacheLength ) {
	
				// Only keep the most recent entries
				delete cache[ keys.shift() ];
			}
			return ( cache[ key + " " ] = value );
		}
		return cache;
	}
	
	/**
	 * Mark a function for special use by Sizzle
	 * @param {Function} fn The function to mark
	 */
	function markFunction( fn ) {
		fn[ expando ] = true;
		return fn;
	}
	
	/**
	 * Support testing using an element
	 * @param {Function} fn Passed the created element and returns a boolean result
	 */
	function assert( fn ) {
		var el = document.createElement( "fieldset" );
	
		try {
			return !!fn( el );
		} catch ( e ) {
			return false;
		} finally {
	
			// Remove from its parent by default
			if ( el.parentNode ) {
				el.parentNode.removeChild( el );
			}
	
			// release memory in IE
			el = null;
		}
	}
	
	/**
	 * Adds the same handler for all of the specified attrs
	 * @param {String} attrs Pipe-separated list of attributes
	 * @param {Function} handler The method that will be applied
	 */
	function addHandle( attrs, handler ) {
		var arr = attrs.split( "|" ),
			i = arr.length;
	
		while ( i-- ) {
			Expr.attrHandle[ arr[ i ] ] = handler;
		}
	}
	
	/**
	 * Checks document order of two siblings
	 * @param {Element} a
	 * @param {Element} b
	 * @returns {Number} Returns less than 0 if a precedes b, greater than 0 if a follows b
	 */
	function siblingCheck( a, b ) {
		var cur = b && a,
			diff = cur && a.nodeType === 1 && b.nodeType === 1 &&
				a.sourceIndex - b.sourceIndex;
	
		// Use IE sourceIndex if available on both nodes
		if ( diff ) {
			return diff;
		}
	
		// Check if b follows a
		if ( cur ) {
			while ( ( cur = cur.nextSibling ) ) {
				if ( cur === b ) {
					return -1;
				}
			}
		}
	
		return a ? 1 : -1;
	}
	
	/**
	 * Returns a function to use in pseudos for input types
	 * @param {String} type
	 */
	function createInputPseudo( type ) {
		return function( elem ) {
			var name = elem.nodeName.toLowerCase();
			return name === "input" && elem.type === type;
		};
	}
	
	/**
	 * Returns a function to use in pseudos for buttons
	 * @param {String} type
	 */
	function createButtonPseudo( type ) {
		return function( elem ) {
			var name = elem.nodeName.toLowerCase();
			return ( name === "input" || name === "button" ) && elem.type === type;
		};
	}
	
	/**
	 * Returns a function to use in pseudos for :enabled/:disabled
	 * @param {Boolean} disabled true for :disabled; false for :enabled
	 */
	function createDisabledPseudo( disabled ) {
	
		// Known :disabled false positives: fieldset[disabled] > legend:nth-of-type(n+2) :can-disable
		return function( elem ) {
	
			// Only certain elements can match :enabled or :disabled
			// https://html.spec.whatwg.org/multipage/scripting.html#selector-enabled
			// https://html.spec.whatwg.org/multipage/scripting.html#selector-disabled
			if ( "form" in elem ) {
	
				// Check for inherited disabledness on relevant non-disabled elements:
				// * listed form-associated elements in a disabled fieldset
				//   https://html.spec.whatwg.org/multipage/forms.html#category-listed
				//   https://html.spec.whatwg.org/multipage/forms.html#concept-fe-disabled
				// * option elements in a disabled optgroup
				//   https://html.spec.whatwg.org/multipage/forms.html#concept-option-disabled
				// All such elements have a "form" property.
				if ( elem.parentNode && elem.disabled === false ) {
	
					// Option elements defer to a parent optgroup if present
					if ( "label" in elem ) {
						if ( "label" in elem.parentNode ) {
							return elem.parentNode.disabled === disabled;
						} else {
							return elem.disabled === disabled;
						}
					}
	
					// Support: IE 6 - 11
					// Use the isDisabled shortcut property to check for disabled fieldset ancestors
					return elem.isDisabled === disabled ||
	
						// Where there is no isDisabled, check manually
						/* jshint -W018 */
						elem.isDisabled !== !disabled &&
						inDisabledFieldset( elem ) === disabled;
				}
	
				return elem.disabled === disabled;
	
			// Try to winnow out elements that can't be disabled before trusting the disabled property.
			// Some victims get caught in our net (label, legend, menu, track), but it shouldn't
			// even exist on them, let alone have a boolean value.
			} else if ( "label" in elem ) {
				return elem.disabled === disabled;
			}
	
			// Remaining elements are neither :enabled nor :disabled
			return false;
		};
	}
	
	/**
	 * Returns a function to use in pseudos for positionals
	 * @param {Function} fn
	 */
	function createPositionalPseudo( fn ) {
		return markFunction( function( argument ) {
			argument = +argument;
			return markFunction( function( seed, matches ) {
				var j,
					matchIndexes = fn( [], seed.length, argument ),
					i = matchIndexes.length;
	
				// Match elements found at the specified indexes
				while ( i-- ) {
					if ( seed[ ( j = matchIndexes[ i ] ) ] ) {
						seed[ j ] = !( matches[ j ] = seed[ j ] );
					}
				}
			} );
		} );
	}
	
	/**
	 * Checks a node for validity as a Sizzle context
	 * @param {Element|Object=} context
	 * @returns {Element|Object|Boolean} The input node if acceptable, otherwise a falsy value
	 */
	function testContext( context ) {
		return context && typeof context.getElementsByTagName !== "undefined" && context;
	}
	
	// Expose support vars for convenience
	support = Sizzle.support = {};
	
	/**
	 * Detects XML nodes
	 * @param {Element|Object} elem An element or a document
	 * @returns {Boolean} True iff elem is a non-HTML XML node
	 */
	isXML = Sizzle.isXML = function( elem ) {
		var namespace = elem && elem.namespaceURI,
			docElem = elem && ( elem.ownerDocument || elem ).documentElement;
	
		// Support: IE <=8
		// Assume HTML when documentElement doesn't yet exist, such as inside loading iframes
		// https://bugs.jquery.com/ticket/4833
		return !rhtml.test( namespace || docElem && docElem.nodeName || "HTML" );
	};
	
	/**
	 * Sets document-related variables once based on the current document
	 * @param {Element|Object} [doc] An element or document object to use to set the document
	 * @returns {Object} Returns the current document
	 */
	setDocument = Sizzle.setDocument = function( node ) {
		var hasCompare, subWindow,
			doc = node ? node.ownerDocument || node : preferredDoc;
	
		// Return early if doc is invalid or already selected
		// Support: IE 11+, Edge 17 - 18+
		// IE/Edge sometimes throw a "Permission denied" error when strict-comparing
		// two documents; shallow comparisons work.
		// eslint-disable-next-line eqeqeq
		if ( doc == document || doc.nodeType !== 9 || !doc.documentElement ) {
			return document;
		}
	
		// Update global variables
		document = doc;
		docElem = document.documentElement;
		documentIsHTML = !isXML( document );
	
		// Support: IE 9 - 11+, Edge 12 - 18+
		// Accessing iframe documents after unload throws "permission denied" errors (jQuery #13936)
		// Support: IE 11+, Edge 17 - 18+
		// IE/Edge sometimes throw a "Permission denied" error when strict-comparing
		// two documents; shallow comparisons work.
		// eslint-disable-next-line eqeqeq
		if ( preferredDoc != document &&
			( subWindow = document.defaultView ) && subWindow.top !== subWindow ) {
	
			// Support: IE 11, Edge
			if ( subWindow.addEventListener ) {
				subWindow.addEventListener( "unload", unloadHandler, false );
	
			// Support: IE 9 - 10 only
			} else if ( subWindow.attachEvent ) {
				subWindow.attachEvent( "onunload", unloadHandler );
			}
		}
	
		// Support: IE 8 - 11+, Edge 12 - 18+, Chrome <=16 - 25 only, Firefox <=3.6 - 31 only,
		// Safari 4 - 5 only, Opera <=11.6 - 12.x only
		// IE/Edge & older browsers don't support the :scope pseudo-class.
		// Support: Safari 6.0 only
		// Safari 6.0 supports :scope but it's an alias of :root there.
		support.scope = assert( function( el ) {
			docElem.appendChild( el ).appendChild( document.createElement( "div" ) );
			return typeof el.querySelectorAll !== "undefined" &&
				!el.querySelectorAll( ":scope fieldset div" ).length;
		} );
	
		/* Attributes
		---------------------------------------------------------------------- */
	
		// Support: IE<8
		// Verify that getAttribute really returns attributes and not properties
		// (excepting IE8 booleans)
		support.attributes = assert( function( el ) {
			el.className = "i";
			return !el.getAttribute( "className" );
		} );
	
		/* getElement(s)By*
		---------------------------------------------------------------------- */
	
		// Check if getElementsByTagName("*") returns only elements
		support.getElementsByTagName = assert( function( el ) {
			el.appendChild( document.createComment( "" ) );
			return !el.getElementsByTagName( "*" ).length;
		} );
	
		// Support: IE<9
		support.getElementsByClassName = rnative.test( document.getElementsByClassName );
	
		// Support: IE<10
		// Check if getElementById returns elements by name
		// The broken getElementById methods don't pick up programmatically-set names,
		// so use a roundabout getElementsByName test
		support.getById = assert( function( el ) {
			docElem.appendChild( el ).id = expando;
			return !document.getElementsByName || !document.getElementsByName( expando ).length;
		} );
	
		// ID filter and find
		if ( support.getById ) {
			Expr.filter[ "ID" ] = function( id ) {
				var attrId = id.replace( runescape, funescape );
				return function( elem ) {
					return elem.getAttribute( "id" ) === attrId;
				};
			};
			Expr.find[ "ID" ] = function( id, context ) {
				if ( typeof context.getElementById !== "undefined" && documentIsHTML ) {
					var elem = context.getElementById( id );
					return elem ? [ elem ] : [];
				}
			};
		} else {
			Expr.filter[ "ID" ] =  function( id ) {
				var attrId = id.replace( runescape, funescape );
				return function( elem ) {
					var node = typeof elem.getAttributeNode !== "undefined" &&
						elem.getAttributeNode( "id" );
					return node && node.value === attrId;
				};
			};
	
			// Support: IE 6 - 7 only
			// getElementById is not reliable as a find shortcut
			Expr.find[ "ID" ] = function( id, context ) {
				if ( typeof context.getElementById !== "undefined" && documentIsHTML ) {
					var node, i, elems,
						elem = context.getElementById( id );
	
					if ( elem ) {
	
						// Verify the id attribute
						node = elem.getAttributeNode( "id" );
						if ( node && node.value === id ) {
							return [ elem ];
						}
	
						// Fall back on getElementsByName
						elems = context.getElementsByName( id );
						i = 0;
						while ( ( elem = elems[ i++ ] ) ) {
							node = elem.getAttributeNode( "id" );
							if ( node && node.value === id ) {
								return [ elem ];
							}
						}
					}
	
					return [];
				}
			};
		}
	
		// Tag
		Expr.find[ "TAG" ] = support.getElementsByTagName ?
			function( tag, context ) {
				if ( typeof context.getElementsByTagName !== "undefined" ) {
					return context.getElementsByTagName( tag );
	
				// DocumentFragment nodes don't have gEBTN
				} else if ( support.qsa ) {
					return context.querySelectorAll( tag );
				}
			} :
	
			function( tag, context ) {
				var elem,
					tmp = [],
					i = 0,
	
					// By happy coincidence, a (broken) gEBTN appears on DocumentFragment nodes too
					results = context.getElementsByTagName( tag );
	
				// Filter out possible comments
				if ( tag === "*" ) {
					while ( ( elem = results[ i++ ] ) ) {
						if ( elem.nodeType === 1 ) {
							tmp.push( elem );
						}
					}
	
					return tmp;
				}
				return results;
			};
	
		// Class
		Expr.find[ "CLASS" ] = support.getElementsByClassName && function( className, context ) {
			if ( typeof context.getElementsByClassName !== "undefined" && documentIsHTML ) {
				return context.getElementsByClassName( className );
			}
		};
	
		/* QSA/matchesSelector
		---------------------------------------------------------------------- */
	
		// QSA and matchesSelector support
	
		// matchesSelector(:active) reports false when true (IE9/Opera 11.5)
		rbuggyMatches = [];
	
		// qSa(:focus) reports false when true (Chrome 21)
		// We allow this because of a bug in IE8/9 that throws an error
		// whenever `document.activeElement` is accessed on an iframe
		// So, we allow :focus to pass through QSA all the time to avoid the IE error
		// See https://bugs.jquery.com/ticket/13378
		rbuggyQSA = [];
	
		if ( ( support.qsa = rnative.test( document.querySelectorAll ) ) ) {
	
			// Build QSA regex
			// Regex strategy adopted from Diego Perini
			assert( function( el ) {
	
				var input;
	
				// Select is set to empty string on purpose
				// This is to test IE's treatment of not explicitly
				// setting a boolean content attribute,
				// since its presence should be enough
				// https://bugs.jquery.com/ticket/12359
				docElem.appendChild( el ).innerHTML = "<a id='" + expando + "'></a>" +
					"<select id='" + expando + "-\r\\' msallowcapture=''>" +
					"<option selected=''></option></select>";
	
				// Support: IE8, Opera 11-12.16
				// Nothing should be selected when empty strings follow ^= or $= or *=
				// The test attribute must be unknown in Opera but "safe" for WinRT
				// https://msdn.microsoft.com/en-us/library/ie/hh465388.aspx#attribute_section
				if ( el.querySelectorAll( "[msallowcapture^='']" ).length ) {
					rbuggyQSA.push( "[*^$]=" + whitespace + "*(?:''|\"\")" );
				}
	
				// Support: IE8
				// Boolean attributes and "value" are not treated correctly
				if ( !el.querySelectorAll( "[selected]" ).length ) {
					rbuggyQSA.push( "\\[" + whitespace + "*(?:value|" + booleans + ")" );
				}
	
				// Support: Chrome<29, Android<4.4, Safari<7.0+, iOS<7.0+, PhantomJS<1.9.8+
				if ( !el.querySelectorAll( "[id~=" + expando + "-]" ).length ) {
					rbuggyQSA.push( "~=" );
				}
	
				// Support: IE 11+, Edge 15 - 18+
				// IE 11/Edge don't find elements on a `[name='']` query in some cases.
				// Adding a temporary attribute to the document before the selection works
				// around the issue.
				// Interestingly, IE 10 & older don't seem to have the issue.
				input = document.createElement( "input" );
				input.setAttribute( "name", "" );
				el.appendChild( input );
				if ( !el.querySelectorAll( "[name='']" ).length ) {
					rbuggyQSA.push( "\\[" + whitespace + "*name" + whitespace + "*=" +
						whitespace + "*(?:''|\"\")" );
				}
	
				// Webkit/Opera - :checked should return selected option elements
				// http://www.w3.org/TR/2011/REC-css3-selectors-20110929/#checked
				// IE8 throws error here and will not see later tests
				if ( !el.querySelectorAll( ":checked" ).length ) {
					rbuggyQSA.push( ":checked" );
				}
	
				// Support: Safari 8+, iOS 8+
				// https://bugs.webkit.org/show_bug.cgi?id=136851
				// In-page `selector#id sibling-combinator selector` fails
				if ( !el.querySelectorAll( "a#" + expando + "+*" ).length ) {
					rbuggyQSA.push( ".#.+[+~]" );
				}
	
				// Support: Firefox <=3.6 - 5 only
				// Old Firefox doesn't throw on a badly-escaped identifier.
				el.querySelectorAll( "\\\f" );
				rbuggyQSA.push( "[\\r\\n\\f]" );
			} );
	
			assert( function( el ) {
				el.innerHTML = "<a href='' disabled='disabled'></a>" +
					"<select disabled='disabled'><option/></select>";
	
				// Support: Windows 8 Native Apps
				// The type and name attributes are restricted during .innerHTML assignment
				var input = document.createElement( "input" );
				input.setAttribute( "type", "hidden" );
				el.appendChild( input ).setAttribute( "name", "D" );
	
				// Support: IE8
				// Enforce case-sensitivity of name attribute
				if ( el.querySelectorAll( "[name=d]" ).length ) {
					rbuggyQSA.push( "name" + whitespace + "*[*^$|!~]?=" );
				}
	
				// FF 3.5 - :enabled/:disabled and hidden elements (hidden elements are still enabled)
				// IE8 throws error here and will not see later tests
				if ( el.querySelectorAll( ":enabled" ).length !== 2 ) {
					rbuggyQSA.push( ":enabled", ":disabled" );
				}
	
				// Support: IE9-11+
				// IE's :disabled selector does not pick up the children of disabled fieldsets
				docElem.appendChild( el ).disabled = true;
				if ( el.querySelectorAll( ":disabled" ).length !== 2 ) {
					rbuggyQSA.push( ":enabled", ":disabled" );
				}
	
				// Support: Opera 10 - 11 only
				// Opera 10-11 does not throw on post-comma invalid pseudos
				el.querySelectorAll( "*,:x" );
				rbuggyQSA.push( ",.*:" );
			} );
		}
	
		if ( ( support.matchesSelector = rnative.test( ( matches = docElem.matches ||
			docElem.webkitMatchesSelector ||
			docElem.mozMatchesSelector ||
			docElem.oMatchesSelector ||
			docElem.msMatchesSelector ) ) ) ) {
	
			assert( function( el ) {
	
				// Check to see if it's possible to do matchesSelector
				// on a disconnected node (IE 9)
				support.disconnectedMatch = matches.call( el, "*" );
	
				// This should fail with an exception
				// Gecko does not error, returns false instead
				matches.call( el, "[s!='']:x" );
				rbuggyMatches.push( "!=", pseudos );
			} );
		}
	
		rbuggyQSA = rbuggyQSA.length && new RegExp( rbuggyQSA.join( "|" ) );
		rbuggyMatches = rbuggyMatches.length && new RegExp( rbuggyMatches.join( "|" ) );
	
		/* Contains
		---------------------------------------------------------------------- */
		hasCompare = rnative.test( docElem.compareDocumentPosition );
	
		// Element contains another
		// Purposefully self-exclusive
		// As in, an element does not contain itself
		contains = hasCompare || rnative.test( docElem.contains ) ?
			function( a, b ) {
				var adown = a.nodeType === 9 ? a.documentElement : a,
					bup = b && b.parentNode;
				return a === bup || !!( bup && bup.nodeType === 1 && (
					adown.contains ?
						adown.contains( bup ) :
						a.compareDocumentPosition && a.compareDocumentPosition( bup ) & 16
				) );
			} :
			function( a, b ) {
				if ( b ) {
					while ( ( b = b.parentNode ) ) {
						if ( b === a ) {
							return true;
						}
					}
				}
				return false;
			};
	
		/* Sorting
		---------------------------------------------------------------------- */
	
		// Document order sorting
		sortOrder = hasCompare ?
		function( a, b ) {
	
			// Flag for duplicate removal
			if ( a === b ) {
				hasDuplicate = true;
				return 0;
			}
	
			// Sort on method existence if only one input has compareDocumentPosition
			var compare = !a.compareDocumentPosition - !b.compareDocumentPosition;
			if ( compare ) {
				return compare;
			}
	
			// Calculate position if both inputs belong to the same document
			// Support: IE 11+, Edge 17 - 18+
			// IE/Edge sometimes throw a "Permission denied" error when strict-comparing
			// two documents; shallow comparisons work.
			// eslint-disable-next-line eqeqeq
			compare = ( a.ownerDocument || a ) == ( b.ownerDocument || b ) ?
				a.compareDocumentPosition( b ) :
	
				// Otherwise we know they are disconnected
				1;
	
			// Disconnected nodes
			if ( compare & 1 ||
				( !support.sortDetached && b.compareDocumentPosition( a ) === compare ) ) {
	
				// Choose the first element that is related to our preferred document
				// Support: IE 11+, Edge 17 - 18+
				// IE/Edge sometimes throw a "Permission denied" error when strict-comparing
				// two documents; shallow comparisons work.
				// eslint-disable-next-line eqeqeq
				if ( a == document || a.ownerDocument == preferredDoc &&
					contains( preferredDoc, a ) ) {
					return -1;
				}
	
				// Support: IE 11+, Edge 17 - 18+
				// IE/Edge sometimes throw a "Permission denied" error when strict-comparing
				// two documents; shallow comparisons work.
				// eslint-disable-next-line eqeqeq
				if ( b == document || b.ownerDocument == preferredDoc &&
					contains( preferredDoc, b ) ) {
					return 1;
				}
	
				// Maintain original order
				return sortInput ?
					( indexOf( sortInput, a ) - indexOf( sortInput, b ) ) :
					0;
			}
	
			return compare & 4 ? -1 : 1;
		} :
		function( a, b ) {
	
			// Exit early if the nodes are identical
			if ( a === b ) {
				hasDuplicate = true;
				return 0;
			}
	
			var cur,
				i = 0,
				aup = a.parentNode,
				bup = b.parentNode,
				ap = [ a ],
				bp = [ b ];
	
			// Parentless nodes are either documents or disconnected
			if ( !aup || !bup ) {
	
				// Support: IE 11+, Edge 17 - 18+
				// IE/Edge sometimes throw a "Permission denied" error when strict-comparing
				// two documents; shallow comparisons work.
				/* eslint-disable eqeqeq */
				return a == document ? -1 :
					b == document ? 1 :
					/* eslint-enable eqeqeq */
					aup ? -1 :
					bup ? 1 :
					sortInput ?
					( indexOf( sortInput, a ) - indexOf( sortInput, b ) ) :
					0;
	
			// If the nodes are siblings, we can do a quick check
			} else if ( aup === bup ) {
				return siblingCheck( a, b );
			}
	
			// Otherwise we need full lists of their ancestors for comparison
			cur = a;
			while ( ( cur = cur.parentNode ) ) {
				ap.unshift( cur );
			}
			cur = b;
			while ( ( cur = cur.parentNode ) ) {
				bp.unshift( cur );
			}
	
			// Walk down the tree looking for a discrepancy
			while ( ap[ i ] === bp[ i ] ) {
				i++;
			}
	
			return i ?
	
				// Do a sibling check if the nodes have a common ancestor
				siblingCheck( ap[ i ], bp[ i ] ) :
	
				// Otherwise nodes in our document sort first
				// Support: IE 11+, Edge 17 - 18+
				// IE/Edge sometimes throw a "Permission denied" error when strict-comparing
				// two documents; shallow comparisons work.
				/* eslint-disable eqeqeq */
				ap[ i ] == preferredDoc ? -1 :
				bp[ i ] == preferredDoc ? 1 :
				/* eslint-enable eqeqeq */
				0;
		};
	
		return document;
	};
	
	Sizzle.matches = function( expr, elements ) {
		return Sizzle( expr, null, null, elements );
	};
	
	Sizzle.matchesSelector = function( elem, expr ) {
		setDocument( elem );
	
		if ( support.matchesSelector && documentIsHTML &&
			!nonnativeSelectorCache[ expr + " " ] &&
			( !rbuggyMatches || !rbuggyMatches.test( expr ) ) &&
			( !rbuggyQSA     || !rbuggyQSA.test( expr ) ) ) {
	
			try {
				var ret = matches.call( elem, expr );
	
				// IE 9's matchesSelector returns false on disconnected nodes
				if ( ret || support.disconnectedMatch ||
	
					// As well, disconnected nodes are said to be in a document
					// fragment in IE 9
					elem.document && elem.document.nodeType !== 11 ) {
					return ret;
				}
			} catch ( e ) {
				nonnativeSelectorCache( expr, true );
			}
		}
	
		return Sizzle( expr, document, null, [ elem ] ).length > 0;
	};
	
	Sizzle.contains = function( context, elem ) {
	
		// Set document vars if needed
		// Support: IE 11+, Edge 17 - 18+
		// IE/Edge sometimes throw a "Permission denied" error when strict-comparing
		// two documents; shallow comparisons work.
		// eslint-disable-next-line eqeqeq
		if ( ( context.ownerDocument || context ) != document ) {
			setDocument( context );
		}
		return contains( context, elem );
	};
	
	Sizzle.attr = function( elem, name ) {
	
		// Set document vars if needed
		// Support: IE 11+, Edge 17 - 18+
		// IE/Edge sometimes throw a "Permission denied" error when strict-comparing
		// two documents; shallow comparisons work.
		// eslint-disable-next-line eqeqeq
		if ( ( elem.ownerDocument || elem ) != document ) {
			setDocument( elem );
		}
	
		var fn = Expr.attrHandle[ name.toLowerCase() ],
	
			// Don't get fooled by Object.prototype properties (jQuery #13807)
			val = fn && hasOwn.call( Expr.attrHandle, name.toLowerCase() ) ?
				fn( elem, name, !documentIsHTML ) :
				undefined;
	
		return val !== undefined ?
			val :
			support.attributes || !documentIsHTML ?
				elem.getAttribute( name ) :
				( val = elem.getAttributeNode( name ) ) && val.specified ?
					val.value :
					null;
	};
	
	Sizzle.escape = function( sel ) {
		return ( sel + "" ).replace( rcssescape, fcssescape );
	};
	
	Sizzle.error = function( msg ) {
		throw new Error( "Syntax error, unrecognized expression: " + msg );
	};
	
	/**
	 * Document sorting and removing duplicates
	 * @param {ArrayLike} results
	 */
	Sizzle.uniqueSort = function( results ) {
		var elem,
			duplicates = [],
			j = 0,
			i = 0;
	
		// Unless we *know* we can detect duplicates, assume their presence
		hasDuplicate = !support.detectDuplicates;
		sortInput = !support.sortStable && results.slice( 0 );
		results.sort( sortOrder );
	
		if ( hasDuplicate ) {
			while ( ( elem = results[ i++ ] ) ) {
				if ( elem === results[ i ] ) {
					j = duplicates.push( i );
				}
			}
			while ( j-- ) {
				results.splice( duplicates[ j ], 1 );
			}
		}
	
		// Clear input after sorting to release objects
		// See https://github.com/jquery/sizzle/pull/225
		sortInput = null;
	
		return results;
	};
	
	/**
	 * Utility function for retrieving the text value of an array of DOM nodes
	 * @param {Array|Element} elem
	 */
	getText = Sizzle.getText = function( elem ) {
		var node,
			ret = "",
			i = 0,
			nodeType = elem.nodeType;
	
		if ( !nodeType ) {
	
			// If no nodeType, this is expected to be an array
			while ( ( node = elem[ i++ ] ) ) {
	
				// Do not traverse comment nodes
				ret += getText( node );
			}
		} else if ( nodeType === 1 || nodeType === 9 || nodeType === 11 ) {
	
			// Use textContent for elements
			// innerText usage removed for consistency of new lines (jQuery #11153)
			if ( typeof elem.textContent === "string" ) {
				return elem.textContent;
			} else {
	
				// Traverse its children
				for ( elem = elem.firstChild; elem; elem = elem.nextSibling ) {
					ret += getText( elem );
				}
			}
		} else if ( nodeType === 3 || nodeType === 4 ) {
			return elem.nodeValue;
		}
	
		// Do not include comment or processing instruction nodes
	
		return ret;
	};
	
	Expr = Sizzle.selectors = {
	
		// Can be adjusted by the user
		cacheLength: 50,
	
		createPseudo: markFunction,
	
		match: matchExpr,
	
		attrHandle: {},
	
		find: {},
	
		relative: {
			">": { dir: "parentNode", first: true },
			" ": { dir: "parentNode" },
			"+": { dir: "previousSibling", first: true },
			"~": { dir: "previousSibling" }
		},
	
		preFilter: {
			"ATTR": function( match ) {
				match[ 1 ] = match[ 1 ].replace( runescape, funescape );
	
				// Move the given value to match[3] whether quoted or unquoted
				match[ 3 ] = ( match[ 3 ] || match[ 4 ] ||
					match[ 5 ] || "" ).replace( runescape, funescape );
	
				if ( match[ 2 ] === "~=" ) {
					match[ 3 ] = " " + match[ 3 ] + " ";
				}
	
				return match.slice( 0, 4 );
			},
	
			"CHILD": function( match ) {
	
				/* matches from matchExpr["CHILD"]
					1 type (only|nth|...)
					2 what (child|of-type)
					3 argument (even|odd|\d*|\d*n([+-]\d+)?|...)
					4 xn-component of xn+y argument ([+-]?\d*n|)
					5 sign of xn-component
					6 x of xn-component
					7 sign of y-component
					8 y of y-component
				*/
				match[ 1 ] = match[ 1 ].toLowerCase();
	
				if ( match[ 1 ].slice( 0, 3 ) === "nth" ) {
	
					// nth-* requires argument
					if ( !match[ 3 ] ) {
						Sizzle.error( match[ 0 ] );
					}
	
					// numeric x and y parameters for Expr.filter.CHILD
					// remember that false/true cast respectively to 0/1
					match[ 4 ] = +( match[ 4 ] ?
						match[ 5 ] + ( match[ 6 ] || 1 ) :
						2 * ( match[ 3 ] === "even" || match[ 3 ] === "odd" ) );
					match[ 5 ] = +( ( match[ 7 ] + match[ 8 ] ) || match[ 3 ] === "odd" );
	
					// other types prohibit arguments
				} else if ( match[ 3 ] ) {
					Sizzle.error( match[ 0 ] );
				}
	
				return match;
			},
	
			"PSEUDO": function( match ) {
				var excess,
					unquoted = !match[ 6 ] && match[ 2 ];
	
				if ( matchExpr[ "CHILD" ].test( match[ 0 ] ) ) {
					return null;
				}
	
				// Accept quoted arguments as-is
				if ( match[ 3 ] ) {
					match[ 2 ] = match[ 4 ] || match[ 5 ] || "";
	
				// Strip excess characters from unquoted arguments
				} else if ( unquoted && rpseudo.test( unquoted ) &&
	
					// Get excess from tokenize (recursively)
					( excess = tokenize( unquoted, true ) ) &&
	
					// advance to the next closing parenthesis
					( excess = unquoted.indexOf( ")", unquoted.length - excess ) - unquoted.length ) ) {
	
					// excess is a negative index
					match[ 0 ] = match[ 0 ].slice( 0, excess );
					match[ 2 ] = unquoted.slice( 0, excess );
				}
	
				// Return only captures needed by the pseudo filter method (type and argument)
				return match.slice( 0, 3 );
			}
		},
	
		filter: {
	
			"TAG": function( nodeNameSelector ) {
				var nodeName = nodeNameSelector.replace( runescape, funescape ).toLowerCase();
				return nodeNameSelector === "*" ?
					function() {
						return true;
					} :
					function( elem ) {
						return elem.nodeName && elem.nodeName.toLowerCase() === nodeName;
					};
			},
	
			"CLASS": function( className ) {
				var pattern = classCache[ className + " " ];
	
				return pattern ||
					( pattern = new RegExp( "(^|" + whitespace +
						")" + className + "(" + whitespace + "|$)" ) ) && classCache(
							className, function( elem ) {
								return pattern.test(
									typeof elem.className === "string" && elem.className ||
									typeof elem.getAttribute !== "undefined" &&
										elem.getAttribute( "class" ) ||
									""
								);
					} );
			},
	
			"ATTR": function( name, operator, check ) {
				return function( elem ) {
					var result = Sizzle.attr( elem, name );
	
					if ( result == null ) {
						return operator === "!=";
					}
					if ( !operator ) {
						return true;
					}
	
					result += "";
	
					/* eslint-disable max-len */
	
					return operator === "=" ? result === check :
						operator === "!=" ? result !== check :
						operator === "^=" ? check && result.indexOf( check ) === 0 :
						operator === "*=" ? check && result.indexOf( check ) > -1 :
						operator === "$=" ? check && result.slice( -check.length ) === check :
						operator === "~=" ? ( " " + result.replace( rwhitespace, " " ) + " " ).indexOf( check ) > -1 :
						operator === "|=" ? result === check || result.slice( 0, check.length + 1 ) === check + "-" :
						false;
					/* eslint-enable max-len */
	
				};
			},
	
			"CHILD": function( type, what, _argument, first, last ) {
				var simple = type.slice( 0, 3 ) !== "nth",
					forward = type.slice( -4 ) !== "last",
					ofType = what === "of-type";
	
				return first === 1 && last === 0 ?
	
					// Shortcut for :nth-*(n)
					function( elem ) {
						return !!elem.parentNode;
					} :
	
					function( elem, _context, xml ) {
						var cache, uniqueCache, outerCache, node, nodeIndex, start,
							dir = simple !== forward ? "nextSibling" : "previousSibling",
							parent = elem.parentNode,
							name = ofType && elem.nodeName.toLowerCase(),
							useCache = !xml && !ofType,
							diff = false;
	
						if ( parent ) {
	
							// :(first|last|only)-(child|of-type)
							if ( simple ) {
								while ( dir ) {
									node = elem;
									while ( ( node = node[ dir ] ) ) {
										if ( ofType ?
											node.nodeName.toLowerCase() === name :
											node.nodeType === 1 ) {
	
											return false;
										}
									}
	
									// Reverse direction for :only-* (if we haven't yet done so)
									start = dir = type === "only" && !start && "nextSibling";
								}
								return true;
							}
	
							start = [ forward ? parent.firstChild : parent.lastChild ];
	
							// non-xml :nth-child(...) stores cache data on `parent`
							if ( forward && useCache ) {
	
								// Seek `elem` from a previously-cached index
	
								// ...in a gzip-friendly way
								node = parent;
								outerCache = node[ expando ] || ( node[ expando ] = {} );
	
								// Support: IE <9 only
								// Defend against cloned attroperties (jQuery gh-1709)
								uniqueCache = outerCache[ node.uniqueID ] ||
									( outerCache[ node.uniqueID ] = {} );
	
								cache = uniqueCache[ type ] || [];
								nodeIndex = cache[ 0 ] === dirruns && cache[ 1 ];
								diff = nodeIndex && cache[ 2 ];
								node = nodeIndex && parent.childNodes[ nodeIndex ];
	
								while ( ( node = ++nodeIndex && node && node[ dir ] ||
	
									// Fallback to seeking `elem` from the start
									( diff = nodeIndex = 0 ) || start.pop() ) ) {
	
									// When found, cache indexes on `parent` and break
									if ( node.nodeType === 1 && ++diff && node === elem ) {
										uniqueCache[ type ] = [ dirruns, nodeIndex, diff ];
										break;
									}
								}
	
							} else {
	
								// Use previously-cached element index if available
								if ( useCache ) {
	
									// ...in a gzip-friendly way
									node = elem;
									outerCache = node[ expando ] || ( node[ expando ] = {} );
	
									// Support: IE <9 only
									// Defend against cloned attroperties (jQuery gh-1709)
									uniqueCache = outerCache[ node.uniqueID ] ||
										( outerCache[ node.uniqueID ] = {} );
	
									cache = uniqueCache[ type ] || [];
									nodeIndex = cache[ 0 ] === dirruns && cache[ 1 ];
									diff = nodeIndex;
								}
	
								// xml :nth-child(...)
								// or :nth-last-child(...) or :nth(-last)?-of-type(...)
								if ( diff === false ) {
	
									// Use the same loop as above to seek `elem` from the start
									while ( ( node = ++nodeIndex && node && node[ dir ] ||
										( diff = nodeIndex = 0 ) || start.pop() ) ) {
	
										if ( ( ofType ?
											node.nodeName.toLowerCase() === name :
											node.nodeType === 1 ) &&
											++diff ) {
	
											// Cache the index of each encountered element
											if ( useCache ) {
												outerCache = node[ expando ] ||
													( node[ expando ] = {} );
	
												// Support: IE <9 only
												// Defend against cloned attroperties (jQuery gh-1709)
												uniqueCache = outerCache[ node.uniqueID ] ||
													( outerCache[ node.uniqueID ] = {} );
	
												uniqueCache[ type ] = [ dirruns, diff ];
											}
	
											if ( node === elem ) {
												break;
											}
										}
									}
								}
							}
	
							// Incorporate the offset, then check against cycle size
							diff -= last;
							return diff === first || ( diff % first === 0 && diff / first >= 0 );
						}
					};
			},
	
			"PSEUDO": function( pseudo, argument ) {
	
				// pseudo-class names are case-insensitive
				// http://www.w3.org/TR/selectors/#pseudo-classes
				// Prioritize by case sensitivity in case custom pseudos are added with uppercase letters
				// Remember that setFilters inherits from pseudos
				var args,
					fn = Expr.pseudos[ pseudo ] || Expr.setFilters[ pseudo.toLowerCase() ] ||
						Sizzle.error( "unsupported pseudo: " + pseudo );
	
				// The user may use createPseudo to indicate that
				// arguments are needed to create the filter function
				// just as Sizzle does
				if ( fn[ expando ] ) {
					return fn( argument );
				}
	
				// But maintain support for old signatures
				if ( fn.length > 1 ) {
					args = [ pseudo, pseudo, "", argument ];
					return Expr.setFilters.hasOwnProperty( pseudo.toLowerCase() ) ?
						markFunction( function( seed, matches ) {
							var idx,
								matched = fn( seed, argument ),
								i = matched.length;
							while ( i-- ) {
								idx = indexOf( seed, matched[ i ] );
								seed[ idx ] = !( matches[ idx ] = matched[ i ] );
							}
						} ) :
						function( elem ) {
							return fn( elem, 0, args );
						};
				}
	
				return fn;
			}
		},
	
		pseudos: {
	
			// Potentially complex pseudos
			"not": markFunction( function( selector ) {
	
				// Trim the selector passed to compile
				// to avoid treating leading and trailing
				// spaces as combinators
				var input = [],
					results = [],
					matcher = compile( selector.replace( rtrim, "$1" ) );
	
				return matcher[ expando ] ?
					markFunction( function( seed, matches, _context, xml ) {
						var elem,
							unmatched = matcher( seed, null, xml, [] ),
							i = seed.length;
	
						// Match elements unmatched by `matcher`
						while ( i-- ) {
							if ( ( elem = unmatched[ i ] ) ) {
								seed[ i ] = !( matches[ i ] = elem );
							}
						}
					} ) :
					function( elem, _context, xml ) {
						input[ 0 ] = elem;
						matcher( input, null, xml, results );
	
						// Don't keep the element (issue #299)
						input[ 0 ] = null;
						return !results.pop();
					};
			} ),
	
			"has": markFunction( function( selector ) {
				return function( elem ) {
					return Sizzle( selector, elem ).length > 0;
				};
			} ),
	
			"contains": markFunction( function( text ) {
				text = text.replace( runescape, funescape );
				return function( elem ) {
					return ( elem.textContent || getText( elem ) ).indexOf( text ) > -1;
				};
			} ),
	
			// "Whether an element is represented by a :lang() selector
			// is based solely on the element's language value
			// being equal to the identifier C,
			// or beginning with the identifier C immediately followed by "-".
			// The matching of C against the element's language value is performed case-insensitively.
			// The identifier C does not have to be a valid language name."
			// http://www.w3.org/TR/selectors/#lang-pseudo
			"lang": markFunction( function( lang ) {
	
				// lang value must be a valid identifier
				if ( !ridentifier.test( lang || "" ) ) {
					Sizzle.error( "unsupported lang: " + lang );
				}
				lang = lang.replace( runescape, funescape ).toLowerCase();
				return function( elem ) {
					var elemLang;
					do {
						if ( ( elemLang = documentIsHTML ?
							elem.lang :
							elem.getAttribute( "xml:lang" ) || elem.getAttribute( "lang" ) ) ) {
	
							elemLang = elemLang.toLowerCase();
							return elemLang === lang || elemLang.indexOf( lang + "-" ) === 0;
						}
					} while ( ( elem = elem.parentNode ) && elem.nodeType === 1 );
					return false;
				};
			} ),
	
			// Miscellaneous
			"target": function( elem ) {
				var hash = window.location && window.location.hash;
				return hash && hash.slice( 1 ) === elem.id;
			},
	
			"root": function( elem ) {
				return elem === docElem;
			},
	
			"focus": function( elem ) {
				return elem === document.activeElement &&
					( !document.hasFocus || document.hasFocus() ) &&
					!!( elem.type || elem.href || ~elem.tabIndex );
			},
	
			// Boolean properties
			"enabled": createDisabledPseudo( false ),
			"disabled": createDisabledPseudo( true ),
	
			"checked": function( elem ) {
	
				// In CSS3, :checked should return both checked and selected elements
				// http://www.w3.org/TR/2011/REC-css3-selectors-20110929/#checked
				var nodeName = elem.nodeName.toLowerCase();
				return ( nodeName === "input" && !!elem.checked ) ||
					( nodeName === "option" && !!elem.selected );
			},
	
			"selected": function( elem ) {
	
				// Accessing this property makes selected-by-default
				// options in Safari work properly
				if ( elem.parentNode ) {
					// eslint-disable-next-line no-unused-expressions
					elem.parentNode.selectedIndex;
				}
	
				return elem.selected === true;
			},
	
			// Contents
			"empty": function( elem ) {
	
				// http://www.w3.org/TR/selectors/#empty-pseudo
				// :empty is negated by element (1) or content nodes (text: 3; cdata: 4; entity ref: 5),
				//   but not by others (comment: 8; processing instruction: 7; etc.)
				// nodeType < 6 works because attributes (2) do not appear as children
				for ( elem = elem.firstChild; elem; elem = elem.nextSibling ) {
					if ( elem.nodeType < 6 ) {
						return false;
					}
				}
				return true;
			},
	
			"parent": function( elem ) {
				return !Expr.pseudos[ "empty" ]( elem );
			},
	
			// Element/input types
			"header": function( elem ) {
				return rheader.test( elem.nodeName );
			},
	
			"input": function( elem ) {
				return rinputs.test( elem.nodeName );
			},
	
			"button": function( elem ) {
				var name = elem.nodeName.toLowerCase();
				return name === "input" && elem.type === "button" || name === "button";
			},
	
			"text": function( elem ) {
				var attr;
				return elem.nodeName.toLowerCase() === "input" &&
					elem.type === "text" &&
	
					// Support: IE<8
					// New HTML5 attribute values (e.g., "search") appear with elem.type === "text"
					( ( attr = elem.getAttribute( "type" ) ) == null ||
						attr.toLowerCase() === "text" );
			},
	
			// Position-in-collection
			"first": createPositionalPseudo( function() {
				return [ 0 ];
			} ),
	
			"last": createPositionalPseudo( function( _matchIndexes, length ) {
				return [ length - 1 ];
			} ),
	
			"eq": createPositionalPseudo( function( _matchIndexes, length, argument ) {
				return [ argument < 0 ? argument + length : argument ];
			} ),
	
			"even": createPositionalPseudo( function( matchIndexes, length ) {
				var i = 0;
				for ( ; i < length; i += 2 ) {
					matchIndexes.push( i );
				}
				return matchIndexes;
			} ),
	
			"odd": createPositionalPseudo( function( matchIndexes, length ) {
				var i = 1;
				for ( ; i < length; i += 2 ) {
					matchIndexes.push( i );
				}
				return matchIndexes;
			} ),
	
			"lt": createPositionalPseudo( function( matchIndexes, length, argument ) {
				var i = argument < 0 ?
					argument + length :
					argument > length ?
						length :
						argument;
				for ( ; --i >= 0; ) {
					matchIndexes.push( i );
				}
				return matchIndexes;
			} ),
	
			"gt": createPositionalPseudo( function( matchIndexes, length, argument ) {
				var i = argument < 0 ? argument + length : argument;
				for ( ; ++i < length; ) {
					matchIndexes.push( i );
				}
				return matchIndexes;
			} )
		}
	};
	
	Expr.pseudos[ "nth" ] = Expr.pseudos[ "eq" ];
	
	// Add button/input type pseudos
	for ( i in { radio: true, checkbox: true, file: true, password: true, image: true } ) {
		Expr.pseudos[ i ] = createInputPseudo( i );
	}
	for ( i in { submit: true, reset: true } ) {
		Expr.pseudos[ i ] = createButtonPseudo( i );
	}
	
	// Easy API for creating new setFilters
	function setFilters() {}
	setFilters.prototype = Expr.filters = Expr.pseudos;
	Expr.setFilters = new setFilters();
	
	tokenize = Sizzle.tokenize = function( selector, parseOnly ) {
		var matched, match, tokens, type,
			soFar, groups, preFilters,
			cached = tokenCache[ selector + " " ];
	
		if ( cached ) {
			return parseOnly ? 0 : cached.slice( 0 );
		}
	
		soFar = selector;
		groups = [];
		preFilters = Expr.preFilter;
	
		while ( soFar ) {
	
			// Comma and first run
			if ( !matched || ( match = rcomma.exec( soFar ) ) ) {
				if ( match ) {
	
					// Don't consume trailing commas as valid
					soFar = soFar.slice( match[ 0 ].length ) || soFar;
				}
				groups.push( ( tokens = [] ) );
			}
	
			matched = false;
	
			// Combinators
			if ( ( match = rcombinators.exec( soFar ) ) ) {
				matched = match.shift();
				tokens.push( {
					value: matched,
	
					// Cast descendant combinators to space
					type: match[ 0 ].replace( rtrim, " " )
				} );
				soFar = soFar.slice( matched.length );
			}
	
			// Filters
			for ( type in Expr.filter ) {
				if ( ( match = matchExpr[ type ].exec( soFar ) ) && ( !preFilters[ type ] ||
					( match = preFilters[ type ]( match ) ) ) ) {
					matched = match.shift();
					tokens.push( {
						value: matched,
						type: type,
						matches: match
					} );
					soFar = soFar.slice( matched.length );
				}
			}
	
			if ( !matched ) {
				break;
			}
		}
	
		// Return the length of the invalid excess
		// if we're just parsing
		// Otherwise, throw an error or return tokens
		return parseOnly ?
			soFar.length :
			soFar ?
				Sizzle.error( selector ) :
	
				// Cache the tokens
				tokenCache( selector, groups ).slice( 0 );
	};
	
	function toSelector( tokens ) {
		var i = 0,
			len = tokens.length,
			selector = "";
		for ( ; i < len; i++ ) {
			selector += tokens[ i ].value;
		}
		return selector;
	}
	
	function addCombinator( matcher, combinator, base ) {
		var dir = combinator.dir,
			skip = combinator.next,
			key = skip || dir,
			checkNonElements = base && key === "parentNode",
			doneName = done++;
	
		return combinator.first ?
	
			// Check against closest ancestor/preceding element
			function( elem, context, xml ) {
				while ( ( elem = elem[ dir ] ) ) {
					if ( elem.nodeType === 1 || checkNonElements ) {
						return matcher( elem, context, xml );
					}
				}
				return false;
			} :
	
			// Check against all ancestor/preceding elements
			function( elem, context, xml ) {
				var oldCache, uniqueCache, outerCache,
					newCache = [ dirruns, doneName ];
	
				// We can't set arbitrary data on XML nodes, so they don't benefit from combinator caching
				if ( xml ) {
					while ( ( elem = elem[ dir ] ) ) {
						if ( elem.nodeType === 1 || checkNonElements ) {
							if ( matcher( elem, context, xml ) ) {
								return true;
							}
						}
					}
				} else {
					while ( ( elem = elem[ dir ] ) ) {
						if ( elem.nodeType === 1 || checkNonElements ) {
							outerCache = elem[ expando ] || ( elem[ expando ] = {} );
	
							// Support: IE <9 only
							// Defend against cloned attroperties (jQuery gh-1709)
							uniqueCache = outerCache[ elem.uniqueID ] ||
								( outerCache[ elem.uniqueID ] = {} );
	
							if ( skip && skip === elem.nodeName.toLowerCase() ) {
								elem = elem[ dir ] || elem;
							} else if ( ( oldCache = uniqueCache[ key ] ) &&
								oldCache[ 0 ] === dirruns && oldCache[ 1 ] === doneName ) {
	
								// Assign to newCache so results back-propagate to previous elements
								return ( newCache[ 2 ] = oldCache[ 2 ] );
							} else {
	
								// Reuse newcache so results back-propagate to previous elements
								uniqueCache[ key ] = newCache;
	
								// A match means we're done; a fail means we have to keep checking
								if ( ( newCache[ 2 ] = matcher( elem, context, xml ) ) ) {
									return true;
								}
							}
						}
					}
				}
				return false;
			};
	}
	
	function elementMatcher( matchers ) {
		return matchers.length > 1 ?
			function( elem, context, xml ) {
				var i = matchers.length;
				while ( i-- ) {
					if ( !matchers[ i ]( elem, context, xml ) ) {
						return false;
					}
				}
				return true;
			} :
			matchers[ 0 ];
	}
	
	function multipleContexts( selector, contexts, results ) {
		var i = 0,
			len = contexts.length;
		for ( ; i < len; i++ ) {
			Sizzle( selector, contexts[ i ], results );
		}
		return results;
	}
	
	function condense( unmatched, map, filter, context, xml ) {
		var elem,
			newUnmatched = [],
			i = 0,
			len = unmatched.length,
			mapped = map != null;
	
		for ( ; i < len; i++ ) {
			if ( ( elem = unmatched[ i ] ) ) {
				if ( !filter || filter( elem, context, xml ) ) {
					newUnmatched.push( elem );
					if ( mapped ) {
						map.push( i );
					}
				}
			}
		}
	
		return newUnmatched;
	}
	
	function setMatcher( preFilter, selector, matcher, postFilter, postFinder, postSelector ) {
		if ( postFilter && !postFilter[ expando ] ) {
			postFilter = setMatcher( postFilter );
		}
		if ( postFinder && !postFinder[ expando ] ) {
			postFinder = setMatcher( postFinder, postSelector );
		}
		return markFunction( function( seed, results, context, xml ) {
			var temp, i, elem,
				preMap = [],
				postMap = [],
				preexisting = results.length,
	
				// Get initial elements from seed or context
				elems = seed || multipleContexts(
					selector || "*",
					context.nodeType ? [ context ] : context,
					[]
				),
	
				// Prefilter to get matcher input, preserving a map for seed-results synchronization
				matcherIn = preFilter && ( seed || !selector ) ?
					condense( elems, preMap, preFilter, context, xml ) :
					elems,
	
				matcherOut = matcher ?
	
					// If we have a postFinder, or filtered seed, or non-seed postFilter or preexisting results,
					postFinder || ( seed ? preFilter : preexisting || postFilter ) ?
	
						// ...intermediate processing is necessary
						[] :
	
						// ...otherwise use results directly
						results :
					matcherIn;
	
			// Find primary matches
			if ( matcher ) {
				matcher( matcherIn, matcherOut, context, xml );
			}
	
			// Apply postFilter
			if ( postFilter ) {
				temp = condense( matcherOut, postMap );
				postFilter( temp, [], context, xml );
	
				// Un-match failing elements by moving them back to matcherIn
				i = temp.length;
				while ( i-- ) {
					if ( ( elem = temp[ i ] ) ) {
						matcherOut[ postMap[ i ] ] = !( matcherIn[ postMap[ i ] ] = elem );
					}
				}
			}
	
			if ( seed ) {
				if ( postFinder || preFilter ) {
					if ( postFinder ) {
	
						// Get the final matcherOut by condensing this intermediate into postFinder contexts
						temp = [];
						i = matcherOut.length;
						while ( i-- ) {
							if ( ( elem = matcherOut[ i ] ) ) {
	
								// Restore matcherIn since elem is not yet a final match
								temp.push( ( matcherIn[ i ] = elem ) );
							}
						}
						postFinder( null, ( matcherOut = [] ), temp, xml );
					}
	
					// Move matched elements from seed to results to keep them synchronized
					i = matcherOut.length;
					while ( i-- ) {
						if ( ( elem = matcherOut[ i ] ) &&
							( temp = postFinder ? indexOf( seed, elem ) : preMap[ i ] ) > -1 ) {
	
							seed[ temp ] = !( results[ temp ] = elem );
						}
					}
				}
	
			// Add elements to results, through postFinder if defined
			} else {
				matcherOut = condense(
					matcherOut === results ?
						matcherOut.splice( preexisting, matcherOut.length ) :
						matcherOut
				);
				if ( postFinder ) {
					postFinder( null, results, matcherOut, xml );
				} else {
					push.apply( results, matcherOut );
				}
			}
		} );
	}
	
	function matcherFromTokens( tokens ) {
		var checkContext, matcher, j,
			len = tokens.length,
			leadingRelative = Expr.relative[ tokens[ 0 ].type ],
			implicitRelative = leadingRelative || Expr.relative[ " " ],
			i = leadingRelative ? 1 : 0,
	
			// The foundational matcher ensures that elements are reachable from top-level context(s)
			matchContext = addCombinator( function( elem ) {
				return elem === checkContext;
			}, implicitRelative, true ),
			matchAnyContext = addCombinator( function( elem ) {
				return indexOf( checkContext, elem ) > -1;
			}, implicitRelative, true ),
			matchers = [ function( elem, context, xml ) {
				var ret = ( !leadingRelative && ( xml || context !== outermostContext ) ) || (
					( checkContext = context ).nodeType ?
						matchContext( elem, context, xml ) :
						matchAnyContext( elem, context, xml ) );
	
				// Avoid hanging onto element (issue #299)
				checkContext = null;
				return ret;
			} ];
	
		for ( ; i < len; i++ ) {
			if ( ( matcher = Expr.relative[ tokens[ i ].type ] ) ) {
				matchers = [ addCombinator( elementMatcher( matchers ), matcher ) ];
			} else {
				matcher = Expr.filter[ tokens[ i ].type ].apply( null, tokens[ i ].matches );
	
				// Return special upon seeing a positional matcher
				if ( matcher[ expando ] ) {
	
					// Find the next relative operator (if any) for proper handling
					j = ++i;
					for ( ; j < len; j++ ) {
						if ( Expr.relative[ tokens[ j ].type ] ) {
							break;
						}
					}
					return setMatcher(
						i > 1 && elementMatcher( matchers ),
						i > 1 && toSelector(
	
						// If the preceding token was a descendant combinator, insert an implicit any-element `*`
						tokens
							.slice( 0, i - 1 )
							.concat( { value: tokens[ i - 2 ].type === " " ? "*" : "" } )
						).replace( rtrim, "$1" ),
						matcher,
						i < j && matcherFromTokens( tokens.slice( i, j ) ),
						j < len && matcherFromTokens( ( tokens = tokens.slice( j ) ) ),
						j < len && toSelector( tokens )
					);
				}
				matchers.push( matcher );
			}
		}
	
		return elementMatcher( matchers );
	}
	
	function matcherFromGroupMatchers( elementMatchers, setMatchers ) {
		var bySet = setMatchers.length > 0,
			byElement = elementMatchers.length > 0,
			superMatcher = function( seed, context, xml, results, outermost ) {
				var elem, j, matcher,
					matchedCount = 0,
					i = "0",
					unmatched = seed && [],
					setMatched = [],
					contextBackup = outermostContext,
	
					// We must always have either seed elements or outermost context
					elems = seed || byElement && Expr.find[ "TAG" ]( "*", outermost ),
	
					// Use integer dirruns iff this is the outermost matcher
					dirrunsUnique = ( dirruns += contextBackup == null ? 1 : Math.random() || 0.1 ),
					len = elems.length;
	
				if ( outermost ) {
	
					// Support: IE 11+, Edge 17 - 18+
					// IE/Edge sometimes throw a "Permission denied" error when strict-comparing
					// two documents; shallow comparisons work.
					// eslint-disable-next-line eqeqeq
					outermostContext = context == document || context || outermost;
				}
	
				// Add elements passing elementMatchers directly to results
				// Support: IE<9, Safari
				// Tolerate NodeList properties (IE: "length"; Safari: <number>) matching elements by id
				for ( ; i !== len && ( elem = elems[ i ] ) != null; i++ ) {
					if ( byElement && elem ) {
						j = 0;
	
						// Support: IE 11+, Edge 17 - 18+
						// IE/Edge sometimes throw a "Permission denied" error when strict-comparing
						// two documents; shallow comparisons work.
						// eslint-disable-next-line eqeqeq
						if ( !context && elem.ownerDocument != document ) {
							setDocument( elem );
							xml = !documentIsHTML;
						}
						while ( ( matcher = elementMatchers[ j++ ] ) ) {
							if ( matcher( elem, context || document, xml ) ) {
								results.push( elem );
								break;
							}
						}
						if ( outermost ) {
							dirruns = dirrunsUnique;
						}
					}
	
					// Track unmatched elements for set filters
					if ( bySet ) {
	
						// They will have gone through all possible matchers
						if ( ( elem = !matcher && elem ) ) {
							matchedCount--;
						}
	
						// Lengthen the array for every element, matched or not
						if ( seed ) {
							unmatched.push( elem );
						}
					}
				}
	
				// `i` is now the count of elements visited above, and adding it to `matchedCount`
				// makes the latter nonnegative.
				matchedCount += i;
	
				// Apply set filters to unmatched elements
				// NOTE: This can be skipped if there are no unmatched elements (i.e., `matchedCount`
				// equals `i`), unless we didn't visit _any_ elements in the above loop because we have
				// no element matchers and no seed.
				// Incrementing an initially-string "0" `i` allows `i` to remain a string only in that
				// case, which will result in a "00" `matchedCount` that differs from `i` but is also
				// numerically zero.
				if ( bySet && i !== matchedCount ) {
					j = 0;
					while ( ( matcher = setMatchers[ j++ ] ) ) {
						matcher( unmatched, setMatched, context, xml );
					}
	
					if ( seed ) {
	
						// Reintegrate element matches to eliminate the need for sorting
						if ( matchedCount > 0 ) {
							while ( i-- ) {
								if ( !( unmatched[ i ] || setMatched[ i ] ) ) {
									setMatched[ i ] = pop.call( results );
								}
							}
						}
	
						// Discard index placeholder values to get only actual matches
						setMatched = condense( setMatched );
					}
	
					// Add matches to results
					push.apply( results, setMatched );
	
					// Seedless set matches succeeding multiple successful matchers stipulate sorting
					if ( outermost && !seed && setMatched.length > 0 &&
						( matchedCount + setMatchers.length ) > 1 ) {
	
						Sizzle.uniqueSort( results );
					}
				}
	
				// Override manipulation of globals by nested matchers
				if ( outermost ) {
					dirruns = dirrunsUnique;
					outermostContext = contextBackup;
				}
	
				return unmatched;
			};
	
		return bySet ?
			markFunction( superMatcher ) :
			superMatcher;
	}
	
	compile = Sizzle.compile = function( selector, match /* Internal Use Only */ ) {
		var i,
			setMatchers = [],
			elementMatchers = [],
			cached = compilerCache[ selector + " " ];
	
		if ( !cached ) {
	
			// Generate a function of recursive functions that can be used to check each element
			if ( !match ) {
				match = tokenize( selector );
			}
			i = match.length;
			while ( i-- ) {
				cached = matcherFromTokens( match[ i ] );
				if ( cached[ expando ] ) {
					setMatchers.push( cached );
				} else {
					elementMatchers.push( cached );
				}
			}
	
			// Cache the compiled function
			cached = compilerCache(
				selector,
				matcherFromGroupMatchers( elementMatchers, setMatchers )
			);
	
			// Save selector and tokenization
			cached.selector = selector;
		}
		return cached;
	};
	
	/**
	 * A low-level selection function that works with Sizzle's compiled
	 *  selector functions
	 * @param {String|Function} selector A selector or a pre-compiled
	 *  selector function built with Sizzle.compile
	 * @param {Element} context
	 * @param {Array} [results]
	 * @param {Array} [seed] A set of elements to match against
	 */
	select = Sizzle.select = function( selector, context, results, seed ) {
		var i, tokens, token, type, find,
			compiled = typeof selector === "function" && selector,
			match = !seed && tokenize( ( selector = compiled.selector || selector ) );
	
		results = results || [];
	
		// Try to minimize operations if there is only one selector in the list and no seed
		// (the latter of which guarantees us context)
		if ( match.length === 1 ) {
	
			// Reduce context if the leading compound selector is an ID
			tokens = match[ 0 ] = match[ 0 ].slice( 0 );
			if ( tokens.length > 2 && ( token = tokens[ 0 ] ).type === "ID" &&
				context.nodeType === 9 && documentIsHTML && Expr.relative[ tokens[ 1 ].type ] ) {
	
				context = ( Expr.find[ "ID" ]( token.matches[ 0 ]
					.replace( runescape, funescape ), context ) || [] )[ 0 ];
				if ( !context ) {
					return results;
	
				// Precompiled matchers will still verify ancestry, so step up a level
				} else if ( compiled ) {
					context = context.parentNode;
				}
	
				selector = selector.slice( tokens.shift().value.length );
			}
	
			// Fetch a seed set for right-to-left matching
			i = matchExpr[ "needsContext" ].test( selector ) ? 0 : tokens.length;
			while ( i-- ) {
				token = tokens[ i ];
	
				// Abort if we hit a combinator
				if ( Expr.relative[ ( type = token.type ) ] ) {
					break;
				}
				if ( ( find = Expr.find[ type ] ) ) {
	
					// Search, expanding context for leading sibling combinators
					if ( ( seed = find(
						token.matches[ 0 ].replace( runescape, funescape ),
						rsibling.test( tokens[ 0 ].type ) && testContext( context.parentNode ) ||
							context
					) ) ) {
	
						// If seed is empty or no tokens remain, we can return early
						tokens.splice( i, 1 );
						selector = seed.length && toSelector( tokens );
						if ( !selector ) {
							push.apply( results, seed );
							return results;
						}
	
						break;
					}
				}
			}
		}
	
		// Compile and execute a filtering function if one is not provided
		// Provide `match` to avoid retokenization if we modified the selector above
		( compiled || compile( selector, match ) )(
			seed,
			context,
			!documentIsHTML,
			results,
			!context || rsibling.test( selector ) && testContext( context.parentNode ) || context
		);
		return results;
	};
	
	// One-time assignments
	
	// Sort stability
	support.sortStable = expando.split( "" ).sort( sortOrder ).join( "" ) === expando;
	
	// Support: Chrome 14-35+
	// Always assume duplicates if they aren't passed to the comparison function
	support.detectDuplicates = !!hasDuplicate;
	
	// Initialize against the default document
	setDocument();
	
	// Support: Webkit<537.32 - Safari 6.0.3/Chrome 25 (fixed in Chrome 27)
	// Detached nodes confoundingly follow *each other*
	support.sortDetached = assert( function( el ) {
	
		// Should return 1, but returns 4 (following)
		return el.compareDocumentPosition( document.createElement( "fieldset" ) ) & 1;
	} );
	
	// Support: IE<8
	// Prevent attribute/property "interpolation"
	// https://msdn.microsoft.com/en-us/library/ms536429%28VS.85%29.aspx
	if ( !assert( function( el ) {
		el.innerHTML = "<a href='#'></a>";
		return el.firstChild.getAttribute( "href" ) === "#";
	} ) ) {
		addHandle( "type|href|height|width", function( elem, name, isXML ) {
			if ( !isXML ) {
				return elem.getAttribute( name, name.toLowerCase() === "type" ? 1 : 2 );
			}
		} );
	}
	
	// Support: IE<9
	// Use defaultValue in place of getAttribute("value")
	if ( !support.attributes || !assert( function( el ) {
		el.innerHTML = "<input/>";
		el.firstChild.setAttribute( "value", "" );
		return el.firstChild.getAttribute( "value" ) === "";
	} ) ) {
		addHandle( "value", function( elem, _name, isXML ) {
			if ( !isXML && elem.nodeName.toLowerCase() === "input" ) {
				return elem.defaultValue;
			}
		} );
	}
	
	// Support: IE<9
	// Use getAttributeNode to fetch booleans when getAttribute lies
	if ( !assert( function( el ) {
		return el.getAttribute( "disabled" ) == null;
	} ) ) {
		addHandle( booleans, function( elem, name, isXML ) {
			var val;
			if ( !isXML ) {
				return elem[ name ] === true ? name.toLowerCase() :
					( val = elem.getAttributeNode( name ) ) && val.specified ?
						val.value :
						null;
			}
		} );
	}
	
	return Sizzle;
	
	} )( window );
	
	
	
	jQuery.find = Sizzle;
	jQuery.expr = Sizzle.selectors;
	
	// Deprecated
	jQuery.expr[ ":" ] = jQuery.expr.pseudos;
	jQuery.uniqueSort = jQuery.unique = Sizzle.uniqueSort;
	jQuery.text = Sizzle.getText;
	jQuery.isXMLDoc = Sizzle.isXML;
	jQuery.contains = Sizzle.contains;
	jQuery.escapeSelector = Sizzle.escape;
	
	
	
	
	var dir = function( elem, dir, until ) {
		var matched = [],
			truncate = until !== undefined;
	
		while ( ( elem = elem[ dir ] ) && elem.nodeType !== 9 ) {
			if ( elem.nodeType === 1 ) {
				if ( truncate && jQuery( elem ).is( until ) ) {
					break;
				}
				matched.push( elem );
			}
		}
		return matched;
	};
	
	
	var siblings = function( n, elem ) {
		var matched = [];
	
		for ( ; n; n = n.nextSibling ) {
			if ( n.nodeType === 1 && n !== elem ) {
				matched.push( n );
			}
		}
	
		return matched;
	};
	
	
	var rneedsContext = jQuery.expr.match.needsContext;
	
	
	
	function nodeName( elem, name ) {
	
		return elem.nodeName && elem.nodeName.toLowerCase() === name.toLowerCase();
	
	}
	var rsingleTag = ( /^<([a-z][^\/\0>:\x20\t\r\n\f]*)[\x20\t\r\n\f]*\/?>(?:<\/\1>|)$/i );
	
	
	
	// Implement the identical functionality for filter and not
	function winnow( elements, qualifier, not ) {
		if ( isFunction( qualifier ) ) {
			return jQuery.grep( elements, function( elem, i ) {
				return !!qualifier.call( elem, i, elem ) !== not;
			} );
		}
	
		// Single element
		if ( qualifier.nodeType ) {
			return jQuery.grep( elements, function( elem ) {
				return ( elem === qualifier ) !== not;
			} );
		}
	
		// Arraylike of elements (jQuery, arguments, Array)
		if ( typeof qualifier !== "string" ) {
			return jQuery.grep( elements, function( elem ) {
				return ( indexOf.call( qualifier, elem ) > -1 ) !== not;
			} );
		}
	
		// Filtered directly for both simple and complex selectors
		return jQuery.filter( qualifier, elements, not );
	}
	
	jQuery.filter = function( expr, elems, not ) {
		var elem = elems[ 0 ];
	
		if ( not ) {
			expr = ":not(" + expr + ")";
		}
	
		if ( elems.length === 1 && elem.nodeType === 1 ) {
			return jQuery.find.matchesSelector( elem, expr ) ? [ elem ] : [];
		}
	
		return jQuery.find.matches( expr, jQuery.grep( elems, function( elem ) {
			return elem.nodeType === 1;
		} ) );
	};
	
	jQuery.fn.extend( {
		find: function( selector ) {
			var i, ret,
				len = this.length,
				self = this;
	
			if ( typeof selector !== "string" ) {
				return this.pushStack( jQuery( selector ).filter( function() {
					for ( i = 0; i < len; i++ ) {
						if ( jQuery.contains( self[ i ], this ) ) {
							return true;
						}
					}
				} ) );
			}
	
			ret = this.pushStack( [] );
	
			for ( i = 0; i < len; i++ ) {
				jQuery.find( selector, self[ i ], ret );
			}
	
			return len > 1 ? jQuery.uniqueSort( ret ) : ret;
		},
		filter: function( selector ) {
			return this.pushStack( winnow( this, selector || [], false ) );
		},
		not: function( selector ) {
			return this.pushStack( winnow( this, selector || [], true ) );
		},
		is: function( selector ) {
			return !!winnow(
				this,
	
				// If this is a positional/relative selector, check membership in the returned set
				// so $("p:first").is("p:last") won't return true for a doc with two "p".
				typeof selector === "string" && rneedsContext.test( selector ) ?
					jQuery( selector ) :
					selector || [],
				false
			).length;
		}
	} );
	
	
	// Initialize a jQuery object
	
	
	// A central reference to the root jQuery(document)
	var rootjQuery,
	
		// A simple way to check for HTML strings
		// Prioritize #id over <tag> to avoid XSS via location.hash (#9521)
		// Strict HTML recognition (#11290: must start with <)
		// Shortcut simple #id case for speed
		rquickExpr = /^(?:\s*(<[\w\W]+>)[^>]*|#([\w-]+))$/,
	
		init = jQuery.fn.init = function( selector, context, root ) {
			var match, elem;
	
			// HANDLE: $(""), $(null), $(undefined), $(false)
			if ( !selector ) {
				return this;
			}
	
			// Method init() accepts an alternate rootjQuery
			// so migrate can support jQuery.sub (gh-2101)
			root = root || rootjQuery;
	
			// Handle HTML strings
			if ( typeof selector === "string" ) {
				if ( selector[ 0 ] === "<" &&
					selector[ selector.length - 1 ] === ">" &&
					selector.length >= 3 ) {
	
					// Assume that strings that start and end with <> are HTML and skip the regex check
					match = [ null, selector, null ];
	
				} else {
					match = rquickExpr.exec( selector );
				}
	
				// Match html or make sure no context is specified for #id
				if ( match && ( match[ 1 ] || !context ) ) {
	
					// HANDLE: $(html) -> $(array)
					if ( match[ 1 ] ) {
						context = context instanceof jQuery ? context[ 0 ] : context;
	
						// Option to run scripts is true for back-compat
						// Intentionally let the error be thrown if parseHTML is not present
						jQuery.merge( this, jQuery.parseHTML(
							match[ 1 ],
							context && context.nodeType ? context.ownerDocument || context : document,
							true
						) );
	
						// HANDLE: $(html, props)
						if ( rsingleTag.test( match[ 1 ] ) && jQuery.isPlainObject( context ) ) {
							for ( match in context ) {
	
								// Properties of context are called as methods if possible
								if ( isFunction( this[ match ] ) ) {
									this[ match ]( context[ match ] );
	
								// ...and otherwise set as attributes
								} else {
									this.attr( match, context[ match ] );
								}
							}
						}
	
						return this;
	
					// HANDLE: $(#id)
					} else {
						elem = document.getElementById( match[ 2 ] );
	
						if ( elem ) {
	
							// Inject the element directly into the jQuery object
							this[ 0 ] = elem;
							this.length = 1;
						}
						return this;
					}
	
				// HANDLE: $(expr, $(...))
				} else if ( !context || context.jquery ) {
					return ( context || root ).find( selector );
	
				// HANDLE: $(expr, context)
				// (which is just equivalent to: $(context).find(expr)
				} else {
					return this.constructor( context ).find( selector );
				}
	
			// HANDLE: $(DOMElement)
			} else if ( selector.nodeType ) {
				this[ 0 ] = selector;
				this.length = 1;
				return this;
	
			// HANDLE: $(function)
			// Shortcut for document ready
			} else if ( isFunction( selector ) ) {
				return root.ready !== undefined ?
					root.ready( selector ) :
	
					// Execute immediately if ready is not present
					selector( jQuery );
			}
	
			return jQuery.makeArray( selector, this );
		};
	
	// Give the init function the jQuery prototype for later instantiation
	init.prototype = jQuery.fn;
	
	// Initialize central reference
	rootjQuery = jQuery( document );
	
	
	var rparentsprev = /^(?:parents|prev(?:Until|All))/,
	
		// Methods guaranteed to produce a unique set when starting from a unique set
		guaranteedUnique = {
			children: true,
			contents: true,
			next: true,
			prev: true
		};
	
	jQuery.fn.extend( {
		has: function( target ) {
			var targets = jQuery( target, this ),
				l = targets.length;
	
			return this.filter( function() {
				var i = 0;
				for ( ; i < l; i++ ) {
					if ( jQuery.contains( this, targets[ i ] ) ) {
						return true;
					}
				}
			} );
		},
	
		closest: function( selectors, context ) {
			var cur,
				i = 0,
				l = this.length,
				matched = [],
				targets = typeof selectors !== "string" && jQuery( selectors );
	
			// Positional selectors never match, since there's no _selection_ context
			if ( !rneedsContext.test( selectors ) ) {
				for ( ; i < l; i++ ) {
					for ( cur = this[ i ]; cur && cur !== context; cur = cur.parentNode ) {
	
						// Always skip document fragments
						if ( cur.nodeType < 11 && ( targets ?
							targets.index( cur ) > -1 :
	
							// Don't pass non-elements to Sizzle
							cur.nodeType === 1 &&
								jQuery.find.matchesSelector( cur, selectors ) ) ) {
	
							matched.push( cur );
							break;
						}
					}
				}
			}
	
			return this.pushStack( matched.length > 1 ? jQuery.uniqueSort( matched ) : matched );
		},
	
		// Determine the position of an element within the set
		index: function( elem ) {
	
			// No argument, return index in parent
			if ( !elem ) {
				return ( this[ 0 ] && this[ 0 ].parentNode ) ? this.first().prevAll().length : -1;
			}
	
			// Index in selector
			if ( typeof elem === "string" ) {
				return indexOf.call( jQuery( elem ), this[ 0 ] );
			}
	
			// Locate the position of the desired element
			return indexOf.call( this,
	
				// If it receives a jQuery object, the first element is used
				elem.jquery ? elem[ 0 ] : elem
			);
		},
	
		add: function( selector, context ) {
			return this.pushStack(
				jQuery.uniqueSort(
					jQuery.merge( this.get(), jQuery( selector, context ) )
				)
			);
		},
	
		addBack: function( selector ) {
			return this.add( selector == null ?
				this.prevObject : this.prevObject.filter( selector )
			);
		}
	} );
	
	function sibling( cur, dir ) {
		while ( ( cur = cur[ dir ] ) && cur.nodeType !== 1 ) {}
		return cur;
	}
	
	jQuery.each( {
		parent: function( elem ) {
			var parent = elem.parentNode;
			return parent && parent.nodeType !== 11 ? parent : null;
		},
		parents: function( elem ) {
			return dir( elem, "parentNode" );
		},
		parentsUntil: function( elem, _i, until ) {
			return dir( elem, "parentNode", until );
		},
		next: function( elem ) {
			return sibling( elem, "nextSibling" );
		},
		prev: function( elem ) {
			return sibling( elem, "previousSibling" );
		},
		nextAll: function( elem ) {
			return dir( elem, "nextSibling" );
		},
		prevAll: function( elem ) {
			return dir( elem, "previousSibling" );
		},
		nextUntil: function( elem, _i, until ) {
			return dir( elem, "nextSibling", until );
		},
		prevUntil: function( elem, _i, until ) {
			return dir( elem, "previousSibling", until );
		},
		siblings: function( elem ) {
			return siblings( ( elem.parentNode || {} ).firstChild, elem );
		},
		children: function( elem ) {
			return siblings( elem.firstChild );
		},
		contents: function( elem ) {
			if ( elem.contentDocument != null &&
	
				// Support: IE 11+
				// <object> elements with no `data` attribute has an object
				// `contentDocument` with a `null` prototype.
				getProto( elem.contentDocument ) ) {
	
				return elem.contentDocument;
			}
	
			// Support: IE 9 - 11 only, iOS 7 only, Android Browser <=4.3 only
			// Treat the template element as a regular one in browsers that
			// don't support it.
			if ( nodeName( elem, "template" ) ) {
				elem = elem.content || elem;
			}
	
			return jQuery.merge( [], elem.childNodes );
		}
	}, function( name, fn ) {
		jQuery.fn[ name ] = function( until, selector ) {
			var matched = jQuery.map( this, fn, until );
	
			if ( name.slice( -5 ) !== "Until" ) {
				selector = until;
			}
	
			if ( selector && typeof selector === "string" ) {
				matched = jQuery.filter( selector, matched );
			}
	
			if ( this.length > 1 ) {
	
				// Remove duplicates
				if ( !guaranteedUnique[ name ] ) {
					jQuery.uniqueSort( matched );
				}
	
				// Reverse order for parents* and prev-derivatives
				if ( rparentsprev.test( name ) ) {
					matched.reverse();
				}
			}
	
			return this.pushStack( matched );
		};
	} );
	var rnothtmlwhite = ( /[^\x20\t\r\n\f]+/g );
	
	
	
	// Convert String-formatted options into Object-formatted ones
	function createOptions( options ) {
		var object = {};
		jQuery.each( options.match( rnothtmlwhite ) || [], function( _, flag ) {
			object[ flag ] = true;
		} );
		return object;
	}
	
	/*
	 * Create a callback list using the following parameters:
	 *
	 *	options: an optional list of space-separated options that will change how
	 *			the callback list behaves or a more traditional option object
	 *
	 * By default a callback list will act like an event callback list and can be
	 * "fired" multiple times.
	 *
	 * Possible options:
	 *
	 *	once:			will ensure the callback list can only be fired once (like a Deferred)
	 *
	 *	memory:			will keep track of previous values and will call any callback added
	 *					after the list has been fired right away with the latest "memorized"
	 *					values (like a Deferred)
	 *
	 *	unique:			will ensure a callback can only be added once (no duplicate in the list)
	 *
	 *	stopOnFalse:	interrupt callings when a callback returns false
	 *
	 */
	jQuery.Callbacks = function( options ) {
	
		// Convert options from String-formatted to Object-formatted if needed
		// (we check in cache first)
		options = typeof options === "string" ?
			createOptions( options ) :
			jQuery.extend( {}, options );
	
		var // Flag to know if list is currently firing
			firing,
	
			// Last fire value for non-forgettable lists
			memory,
	
			// Flag to know if list was already fired
			fired,
	
			// Flag to prevent firing
			locked,
	
			// Actual callback list
			list = [],
	
			// Queue of execution data for repeatable lists
			queue = [],
	
			// Index of currently firing callback (modified by add/remove as needed)
			firingIndex = -1,
	
			// Fire callbacks
			fire = function() {
	
				// Enforce single-firing
				locked = locked || options.once;
	
				// Execute callbacks for all pending executions,
				// respecting firingIndex overrides and runtime changes
				fired = firing = true;
				for ( ; queue.length; firingIndex = -1 ) {
					memory = queue.shift();
					while ( ++firingIndex < list.length ) {
	
						// Run callback and check for early termination
						if ( list[ firingIndex ].apply( memory[ 0 ], memory[ 1 ] ) === false &&
							options.stopOnFalse ) {
	
							// Jump to end and forget the data so .add doesn't re-fire
							firingIndex = list.length;
							memory = false;
						}
					}
				}
	
				// Forget the data if we're done with it
				if ( !options.memory ) {
					memory = false;
				}
	
				firing = false;
	
				// Clean up if we're done firing for good
				if ( locked ) {
	
					// Keep an empty list if we have data for future add calls
					if ( memory ) {
						list = [];
	
					// Otherwise, this object is spent
					} else {
						list = "";
					}
				}
			},
	
			// Actual Callbacks object
			self = {
	
				// Add a callback or a collection of callbacks to the list
				add: function() {
					if ( list ) {
	
						// If we have memory from a past run, we should fire after adding
						if ( memory && !firing ) {
							firingIndex = list.length - 1;
							queue.push( memory );
						}
	
						( function add( args ) {
							jQuery.each( args, function( _, arg ) {
								if ( isFunction( arg ) ) {
									if ( !options.unique || !self.has( arg ) ) {
										list.push( arg );
									}
								} else if ( arg && arg.length && toType( arg ) !== "string" ) {
	
									// Inspect recursively
									add( arg );
								}
							} );
						} )( arguments );
	
						if ( memory && !firing ) {
							fire();
						}
					}
					return this;
				},
	
				// Remove a callback from the list
				remove: function() {
					jQuery.each( arguments, function( _, arg ) {
						var index;
						while ( ( index = jQuery.inArray( arg, list, index ) ) > -1 ) {
							list.splice( index, 1 );
	
							// Handle firing indexes
							if ( index <= firingIndex ) {
								firingIndex--;
							}
						}
					} );
					return this;
				},
	
				// Check if a given callback is in the list.
				// If no argument is given, return whether or not list has callbacks attached.
				has: function( fn ) {
					return fn ?
						jQuery.inArray( fn, list ) > -1 :
						list.length > 0;
				},
	
				// Remove all callbacks from the list
				empty: function() {
					if ( list ) {
						list = [];
					}
					return this;
				},
	
				// Disable .fire and .add
				// Abort any current/pending executions
				// Clear all callbacks and values
				disable: function() {
					locked = queue = [];
					list = memory = "";
					return this;
				},
				disabled: function() {
					return !list;
				},
	
				// Disable .fire
				// Also disable .add unless we have memory (since it would have no effect)
				// Abort any pending executions
				lock: function() {
					locked = queue = [];
					if ( !memory && !firing ) {
						list = memory = "";
					}
					return this;
				},
				locked: function() {
					return !!locked;
				},
	
				// Call all callbacks with the given context and arguments
				fireWith: function( context, args ) {
					if ( !locked ) {
						args = args || [];
						args = [ context, args.slice ? args.slice() : args ];
						queue.push( args );
						if ( !firing ) {
							fire();
						}
					}
					return this;
				},
	
				// Call all the callbacks with the given arguments
				fire: function() {
					self.fireWith( this, arguments );
					return this;
				},
	
				// To know if the callbacks have already been called at least once
				fired: function() {
					return !!fired;
				}
			};
	
		return self;
	};
	
	
	function Identity( v ) {
		return v;
	}
	function Thrower( ex ) {
		throw ex;
	}
	
	function adoptValue( value, resolve, reject, noValue ) {
		var method;
	
		try {
	
			// Check for promise aspect first to privilege synchronous behavior
			if ( value && isFunction( ( method = value.promise ) ) ) {
				method.call( value ).done( resolve ).fail( reject );
	
			// Other thenables
			} else if ( value && isFunction( ( method = value.then ) ) ) {
				method.call( value, resolve, reject );
	
			// Other non-thenables
			} else {
	
				// Control `resolve` arguments by letting Array#slice cast boolean `noValue` to integer:
				// * false: [ value ].slice( 0 ) => resolve( value )
				// * true: [ value ].slice( 1 ) => resolve()
				resolve.apply( undefined, [ value ].slice( noValue ) );
			}
	
		// For Promises/A+, convert exceptions into rejections
		// Since jQuery.when doesn't unwrap thenables, we can skip the extra checks appearing in
		// Deferred#then to conditionally suppress rejection.
		} catch ( value ) {
	
			// Support: Android 4.0 only
			// Strict mode functions invoked without .call/.apply get global-object context
			reject.apply( undefined, [ value ] );
		}
	}
	
	jQuery.extend( {
	
		Deferred: function( func ) {
			var tuples = [
	
					// action, add listener, callbacks,
					// ... .then handlers, argument index, [final state]
					[ "notify", "progress", jQuery.Callbacks( "memory" ),
						jQuery.Callbacks( "memory" ), 2 ],
					[ "resolve", "done", jQuery.Callbacks( "once memory" ),
						jQuery.Callbacks( "once memory" ), 0, "resolved" ],
					[ "reject", "fail", jQuery.Callbacks( "once memory" ),
						jQuery.Callbacks( "once memory" ), 1, "rejected" ]
				],
				state = "pending",
				promise = {
					state: function() {
						return state;
					},
					always: function() {
						deferred.done( arguments ).fail( arguments );
						return this;
					},
					"catch": function( fn ) {
						return promise.then( null, fn );
					},
	
					// Keep pipe for back-compat
					pipe: function( /* fnDone, fnFail, fnProgress */ ) {
						var fns = arguments;
	
						return jQuery.Deferred( function( newDefer ) {
							jQuery.each( tuples, function( _i, tuple ) {
	
								// Map tuples (progress, done, fail) to arguments (done, fail, progress)
								var fn = isFunction( fns[ tuple[ 4 ] ] ) && fns[ tuple[ 4 ] ];
	
								// deferred.progress(function() { bind to newDefer or newDefer.notify })
								// deferred.done(function() { bind to newDefer or newDefer.resolve })
								// deferred.fail(function() { bind to newDefer or newDefer.reject })
								deferred[ tuple[ 1 ] ]( function() {
									var returned = fn && fn.apply( this, arguments );
									if ( returned && isFunction( returned.promise ) ) {
										returned.promise()
											.progress( newDefer.notify )
											.done( newDefer.resolve )
											.fail( newDefer.reject );
									} else {
										newDefer[ tuple[ 0 ] + "With" ](
											this,
											fn ? [ returned ] : arguments
										);
									}
								} );
							} );
							fns = null;
						} ).promise();
					},
					then: function( onFulfilled, onRejected, onProgress ) {
						var maxDepth = 0;
						function resolve( depth, deferred, handler, special ) {
							return function() {
								var that = this,
									args = arguments,
									mightThrow = function() {
										var returned, then;
	
										// Support: Promises/A+ section 2.3.3.3.3
										// https://promisesaplus.com/#point-59
										// Ignore double-resolution attempts
										if ( depth < maxDepth ) {
											return;
										}
	
										returned = handler.apply( that, args );
	
										// Support: Promises/A+ section 2.3.1
										// https://promisesaplus.com/#point-48
										if ( returned === deferred.promise() ) {
											throw new TypeError( "Thenable self-resolution" );
										}
	
										// Support: Promises/A+ sections 2.3.3.1, 3.5
										// https://promisesaplus.com/#point-54
										// https://promisesaplus.com/#point-75
										// Retrieve `then` only once
										then = returned &&
	
											// Support: Promises/A+ section 2.3.4
											// https://promisesaplus.com/#point-64
											// Only check objects and functions for thenability
											( typeof returned === "object" ||
												typeof returned === "function" ) &&
											returned.then;
	
										// Handle a returned thenable
										if ( isFunction( then ) ) {
	
											// Special processors (notify) just wait for resolution
											if ( special ) {
												then.call(
													returned,
													resolve( maxDepth, deferred, Identity, special ),
													resolve( maxDepth, deferred, Thrower, special )
												);
	
											// Normal processors (resolve) also hook into progress
											} else {
	
												// ...and disregard older resolution values
												maxDepth++;
	
												then.call(
													returned,
													resolve( maxDepth, deferred, Identity, special ),
													resolve( maxDepth, deferred, Thrower, special ),
													resolve( maxDepth, deferred, Identity,
														deferred.notifyWith )
												);
											}
	
										// Handle all other returned values
										} else {
	
											// Only substitute handlers pass on context
											// and multiple values (non-spec behavior)
											if ( handler !== Identity ) {
												that = undefined;
												args = [ returned ];
											}
	
											// Process the value(s)
											// Default process is resolve
											( special || deferred.resolveWith )( that, args );
										}
									},
	
									// Only normal processors (resolve) catch and reject exceptions
									process = special ?
										mightThrow :
										function() {
											try {
												mightThrow();
											} catch ( e ) {
	
												if ( jQuery.Deferred.exceptionHook ) {
													jQuery.Deferred.exceptionHook( e,
														process.stackTrace );
												}
	
												// Support: Promises/A+ section 2.3.3.3.4.1
												// https://promisesaplus.com/#point-61
												// Ignore post-resolution exceptions
												if ( depth + 1 >= maxDepth ) {
	
													// Only substitute handlers pass on context
													// and multiple values (non-spec behavior)
													if ( handler !== Thrower ) {
														that = undefined;
														args = [ e ];
													}
	
													deferred.rejectWith( that, args );
												}
											}
										};
	
								// Support: Promises/A+ section 2.3.3.3.1
								// https://promisesaplus.com/#point-57
								// Re-resolve promises immediately to dodge false rejection from
								// subsequent errors
								if ( depth ) {
									process();
								} else {
	
									// Call an optional hook to record the stack, in case of exception
									// since it's otherwise lost when execution goes async
									if ( jQuery.Deferred.getStackHook ) {
										process.stackTrace = jQuery.Deferred.getStackHook();
									}
									window.setTimeout( process );
								}
							};
						}
	
						return jQuery.Deferred( function( newDefer ) {
	
							// progress_handlers.add( ... )
							tuples[ 0 ][ 3 ].add(
								resolve(
									0,
									newDefer,
									isFunction( onProgress ) ?
										onProgress :
										Identity,
									newDefer.notifyWith
								)
							);
	
							// fulfilled_handlers.add( ... )
							tuples[ 1 ][ 3 ].add(
								resolve(
									0,
									newDefer,
									isFunction( onFulfilled ) ?
										onFulfilled :
										Identity
								)
							);
	
							// rejected_handlers.add( ... )
							tuples[ 2 ][ 3 ].add(
								resolve(
									0,
									newDefer,
									isFunction( onRejected ) ?
										onRejected :
										Thrower
								)
							);
						} ).promise();
					},
	
					// Get a promise for this deferred
					// If obj is provided, the promise aspect is added to the object
					promise: function( obj ) {
						return obj != null ? jQuery.extend( obj, promise ) : promise;
					}
				},
				deferred = {};
	
			// Add list-specific methods
			jQuery.each( tuples, function( i, tuple ) {
				var list = tuple[ 2 ],
					stateString = tuple[ 5 ];
	
				// promise.progress = list.add
				// promise.done = list.add
				// promise.fail = list.add
				promise[ tuple[ 1 ] ] = list.add;
	
				// Handle state
				if ( stateString ) {
					list.add(
						function() {
	
							// state = "resolved" (i.e., fulfilled)
							// state = "rejected"
							state = stateString;
						},
	
						// rejected_callbacks.disable
						// fulfilled_callbacks.disable
						tuples[ 3 - i ][ 2 ].disable,
	
						// rejected_handlers.disable
						// fulfilled_handlers.disable
						tuples[ 3 - i ][ 3 ].disable,
	
						// progress_callbacks.lock
						tuples[ 0 ][ 2 ].lock,
	
						// progress_handlers.lock
						tuples[ 0 ][ 3 ].lock
					);
				}
	
				// progress_handlers.fire
				// fulfilled_handlers.fire
				// rejected_handlers.fire
				list.add( tuple[ 3 ].fire );
	
				// deferred.notify = function() { deferred.notifyWith(...) }
				// deferred.resolve = function() { deferred.resolveWith(...) }
				// deferred.reject = function() { deferred.rejectWith(...) }
				deferred[ tuple[ 0 ] ] = function() {
					deferred[ tuple[ 0 ] + "With" ]( this === deferred ? undefined : this, arguments );
					return this;
				};
	
				// deferred.notifyWith = list.fireWith
				// deferred.resolveWith = list.fireWith
				// deferred.rejectWith = list.fireWith
				deferred[ tuple[ 0 ] + "With" ] = list.fireWith;
			} );
	
			// Make the deferred a promise
			promise.promise( deferred );
	
			// Call given func if any
			if ( func ) {
				func.call( deferred, deferred );
			}
	
			// All done!
			return deferred;
		},
	
		// Deferred helper
		when: function( singleValue ) {
			var
	
				// count of uncompleted subordinates
				remaining = arguments.length,
	
				// count of unprocessed arguments
				i = remaining,
	
				// subordinate fulfillment data
				resolveContexts = Array( i ),
				resolveValues = slice.call( arguments ),
	
				// the primary Deferred
				primary = jQuery.Deferred(),
	
				// subordinate callback factory
				updateFunc = function( i ) {
					return function( value ) {
						resolveContexts[ i ] = this;
						resolveValues[ i ] = arguments.length > 1 ? slice.call( arguments ) : value;
						if ( !( --remaining ) ) {
							primary.resolveWith( resolveContexts, resolveValues );
						}
					};
				};
	
			// Single- and empty arguments are adopted like Promise.resolve
			if ( remaining <= 1 ) {
				adoptValue( singleValue, primary.done( updateFunc( i ) ).resolve, primary.reject,
					!remaining );
	
				// Use .then() to unwrap secondary thenables (cf. gh-3000)
				if ( primary.state() === "pending" ||
					isFunction( resolveValues[ i ] && resolveValues[ i ].then ) ) {
	
					return primary.then();
				}
			}
	
			// Multiple arguments are aggregated like Promise.all array elements
			while ( i-- ) {
				adoptValue( resolveValues[ i ], updateFunc( i ), primary.reject );
			}
	
			return primary.promise();
		}
	} );
	
	
	// These usually indicate a programmer mistake during development,
	// warn about them ASAP rather than swallowing them by default.
	var rerrorNames = /^(Eval|Internal|Range|Reference|Syntax|Type|URI)Error$/;
	
	jQuery.Deferred.exceptionHook = function( error, stack ) {
	
		// Support: IE 8 - 9 only
		// Console exists when dev tools are open, which can happen at any time
		if ( window.console && window.console.warn && error && rerrorNames.test( error.name ) ) {
			window.console.warn( "jQuery.Deferred exception: " + error.message, error.stack, stack );
		}
	};
	
	
	
	
	jQuery.readyException = function( error ) {
		window.setTimeout( function() {
			throw error;
		} );
	};
	
	
	
	
	// The deferred used on DOM ready
	var readyList = jQuery.Deferred();
	
	jQuery.fn.ready = function( fn ) {
	
		readyList
			.then( fn )
	
			// Wrap jQuery.readyException in a function so that the lookup
			// happens at the time of error handling instead of callback
			// registration.
			.catch( function( error ) {
				jQuery.readyException( error );
			} );
	
		return this;
	};
	
	jQuery.extend( {
	
		// Is the DOM ready to be used? Set to true once it occurs.
		isReady: false,
	
		// A counter to track how many items to wait for before
		// the ready event fires. See #6781
		readyWait: 1,
	
		// Handle when the DOM is ready
		ready: function( wait ) {
	
			// Abort if there are pending holds or we're already ready
			if ( wait === true ? --jQuery.readyWait : jQuery.isReady ) {
				return;
			}
	
			// Remember that the DOM is ready
			jQuery.isReady = true;
	
			// If a normal DOM Ready event fired, decrement, and wait if need be
			if ( wait !== true && --jQuery.readyWait > 0 ) {
				return;
			}
	
			// If there are functions bound, to execute
			readyList.resolveWith( document, [ jQuery ] );
		}
	} );
	
	jQuery.ready.then = readyList.then;
	
	// The ready event handler and self cleanup method
	function completed() {
		document.removeEventListener( "DOMContentLoaded", completed );
		window.removeEventListener( "load", completed );
		jQuery.ready();
	}
	
	// Catch cases where $(document).ready() is called
	// after the browser event has already occurred.
	// Support: IE <=9 - 10 only
	// Older IE sometimes signals "interactive" too soon
	if ( document.readyState === "complete" ||
		( document.readyState !== "loading" && !document.documentElement.doScroll ) ) {
	
		// Handle it asynchronously to allow scripts the opportunity to delay ready
		window.setTimeout( jQuery.ready );
	
	} else {
	
		// Use the handy event callback
		document.addEventListener( "DOMContentLoaded", completed );
	
		// A fallback to window.onload, that will always work
		window.addEventListener( "load", completed );
	}
	
	
	
	
	// Multifunctional method to get and set values of a collection
	// The value/s can optionally be executed if it's a function
	var access = function( elems, fn, key, value, chainable, emptyGet, raw ) {
		var i = 0,
			len = elems.length,
			bulk = key == null;
	
		// Sets many values
		if ( toType( key ) === "object" ) {
			chainable = true;
			for ( i in key ) {
				access( elems, fn, i, key[ i ], true, emptyGet, raw );
			}
	
		// Sets one value
		} else if ( value !== undefined ) {
			chainable = true;
	
			if ( !isFunction( value ) ) {
				raw = true;
			}
	
			if ( bulk ) {
	
				// Bulk operations run against the entire set
				if ( raw ) {
					fn.call( elems, value );
					fn = null;
	
				// ...except when executing function values
				} else {
					bulk = fn;
					fn = function( elem, _key, value ) {
						return bulk.call( jQuery( elem ), value );
					};
				}
			}
	
			if ( fn ) {
				for ( ; i < len; i++ ) {
					fn(
						elems[ i ], key, raw ?
							value :
							value.call( elems[ i ], i, fn( elems[ i ], key ) )
					);
				}
			}
		}
	
		if ( chainable ) {
			return elems;
		}
	
		// Gets
		if ( bulk ) {
			return fn.call( elems );
		}
	
		return len ? fn( elems[ 0 ], key ) : emptyGet;
	};
	
	
	// Matches dashed string for camelizing
	var rmsPrefix = /^-ms-/,
		rdashAlpha = /-([a-z])/g;
	
	// Used by camelCase as callback to replace()
	function fcamelCase( _all, letter ) {
		return letter.toUpperCase();
	}
	
	// Convert dashed to camelCase; used by the css and data modules
	// Support: IE <=9 - 11, Edge 12 - 15
	// Microsoft forgot to hump their vendor prefix (#9572)
	function camelCase( string ) {
		return string.replace( rmsPrefix, "ms-" ).replace( rdashAlpha, fcamelCase );
	}
	var acceptData = function( owner ) {
	
		// Accepts only:
		//  - Node
		//    - Node.ELEMENT_NODE
		//    - Node.DOCUMENT_NODE
		//  - Object
		//    - Any
		return owner.nodeType === 1 || owner.nodeType === 9 || !( +owner.nodeType );
	};
	
	
	
	
	function Data() {
		this.expando = jQuery.expando + Data.uid++;
	}
	
	Data.uid = 1;
	
	Data.prototype = {
	
		cache: function( owner ) {
	
			// Check if the owner object already has a cache
			var value = owner[ this.expando ];
	
			// If not, create one
			if ( !value ) {
				value = {};
	
				// We can accept data for non-element nodes in modern browsers,
				// but we should not, see #8335.
				// Always return an empty object.
				if ( acceptData( owner ) ) {
	
					// If it is a node unlikely to be stringify-ed or looped over
					// use plain assignment
					if ( owner.nodeType ) {
						owner[ this.expando ] = value;
	
					// Otherwise secure it in a non-enumerable property
					// configurable must be true to allow the property to be
					// deleted when data is removed
					} else {
						Object.defineProperty( owner, this.expando, {
							value: value,
							configurable: true
						} );
					}
				}
			}
	
			return value;
		},
		set: function( owner, data, value ) {
			var prop,
				cache = this.cache( owner );
	
			// Handle: [ owner, key, value ] args
			// Always use camelCase key (gh-2257)
			if ( typeof data === "string" ) {
				cache[ camelCase( data ) ] = value;
	
			// Handle: [ owner, { properties } ] args
			} else {
	
				// Copy the properties one-by-one to the cache object
				for ( prop in data ) {
					cache[ camelCase( prop ) ] = data[ prop ];
				}
			}
			return cache;
		},
		get: function( owner, key ) {
			return key === undefined ?
				this.cache( owner ) :
	
				// Always use camelCase key (gh-2257)
				owner[ this.expando ] && owner[ this.expando ][ camelCase( key ) ];
		},
		access: function( owner, key, value ) {
	
			// In cases where either:
			//
			//   1. No key was specified
			//   2. A string key was specified, but no value provided
			//
			// Take the "read" path and allow the get method to determine
			// which value to return, respectively either:
			//
			//   1. The entire cache object
			//   2. The data stored at the key
			//
			if ( key === undefined ||
					( ( key && typeof key === "string" ) && value === undefined ) ) {
	
				return this.get( owner, key );
			}
	
			// When the key is not a string, or both a key and value
			// are specified, set or extend (existing objects) with either:
			//
			//   1. An object of properties
			//   2. A key and value
			//
			this.set( owner, key, value );
	
			// Since the "set" path can have two possible entry points
			// return the expected data based on which path was taken[*]
			return value !== undefined ? value : key;
		},
		remove: function( owner, key ) {
			var i,
				cache = owner[ this.expando ];
	
			if ( cache === undefined ) {
				return;
			}
	
			if ( key !== undefined ) {
	
				// Support array or space separated string of keys
				if ( Array.isArray( key ) ) {
	
					// If key is an array of keys...
					// We always set camelCase keys, so remove that.
					key = key.map( camelCase );
				} else {
					key = camelCase( key );
	
					// If a key with the spaces exists, use it.
					// Otherwise, create an array by matching non-whitespace
					key = key in cache ?
						[ key ] :
						( key.match( rnothtmlwhite ) || [] );
				}
	
				i = key.length;
	
				while ( i-- ) {
					delete cache[ key[ i ] ];
				}
			}
	
			// Remove the expando if there's no more data
			if ( key === undefined || jQuery.isEmptyObject( cache ) ) {
	
				// Support: Chrome <=35 - 45
				// Webkit & Blink performance suffers when deleting properties
				// from DOM nodes, so set to undefined instead
				// https://bugs.chromium.org/p/chromium/issues/detail?id=378607 (bug restricted)
				if ( owner.nodeType ) {
					owner[ this.expando ] = undefined;
				} else {
					delete owner[ this.expando ];
				}
			}
		},
		hasData: function( owner ) {
			var cache = owner[ this.expando ];
			return cache !== undefined && !jQuery.isEmptyObject( cache );
		}
	};
	var dataPriv = new Data();
	
	var dataUser = new Data();
	
	
	
	//	Implementation Summary
	//
	//	1. Enforce API surface and semantic compatibility with 1.9.x branch
	//	2. Improve the module's maintainability by reducing the storage
	//		paths to a single mechanism.
	//	3. Use the same single mechanism to support "private" and "user" data.
	//	4. _Never_ expose "private" data to user code (TODO: Drop _data, _removeData)
	//	5. Avoid exposing implementation details on user objects (eg. expando properties)
	//	6. Provide a clear path for implementation upgrade to WeakMap in 2014
	
	var rbrace = /^(?:\{[\w\W]*\}|\[[\w\W]*\])$/,
		rmultiDash = /[A-Z]/g;
	
	function getData( data ) {
		if ( data === "true" ) {
			return true;
		}
	
		if ( data === "false" ) {
			return false;
		}
	
		if ( data === "null" ) {
			return null;
		}
	
		// Only convert to a number if it doesn't change the string
		if ( data === +data + "" ) {
			return +data;
		}
	
		if ( rbrace.test( data ) ) {
			return JSON.parse( data );
		}
	
		return data;
	}
	
	function dataAttr( elem, key, data ) {
		var name;
	
		// If nothing was found internally, try to fetch any
		// data from the HTML5 data-* attribute
		if ( data === undefined && elem.nodeType === 1 ) {
			name = "data-" + key.replace( rmultiDash, "-$&" ).toLowerCase();
			data = elem.getAttribute( name );
	
			if ( typeof data === "string" ) {
				try {
					data = getData( data );
				} catch ( e ) {}
	
				// Make sure we set the data so it isn't changed later
				dataUser.set( elem, key, data );
			} else {
				data = undefined;
			}
		}
		return data;
	}
	
	jQuery.extend( {
		hasData: function( elem ) {
			return dataUser.hasData( elem ) || dataPriv.hasData( elem );
		},
	
		data: function( elem, name, data ) {
			return dataUser.access( elem, name, data );
		},
	
		removeData: function( elem, name ) {
			dataUser.remove( elem, name );
		},
	
		// TODO: Now that all calls to _data and _removeData have been replaced
		// with direct calls to dataPriv methods, these can be deprecated.
		_data: function( elem, name, data ) {
			return dataPriv.access( elem, name, data );
		},
	
		_removeData: function( elem, name ) {
			dataPriv.remove( elem, name );
		}
	} );
	
	jQuery.fn.extend( {
		data: function( key, value ) {
			var i, name, data,
				elem = this[ 0 ],
				attrs = elem && elem.attributes;
	
			// Gets all values
			if ( key === undefined ) {
				if ( this.length ) {
					data = dataUser.get( elem );
	
					if ( elem.nodeType === 1 && !dataPriv.get( elem, "hasDataAttrs" ) ) {
						i = attrs.length;
						while ( i-- ) {
	
							// Support: IE 11 only
							// The attrs elements can be null (#14894)
							if ( attrs[ i ] ) {
								name = attrs[ i ].name;
								if ( name.indexOf( "data-" ) === 0 ) {
									name = camelCase( name.slice( 5 ) );
									dataAttr( elem, name, data[ name ] );
								}
							}
						}
						dataPriv.set( elem, "hasDataAttrs", true );
					}
				}
	
				return data;
			}
	
			// Sets multiple values
			if ( typeof key === "object" ) {
				return this.each( function() {
					dataUser.set( this, key );
				} );
			}
	
			return access( this, function( value ) {
				var data;
	
				// The calling jQuery object (element matches) is not empty
				// (and therefore has an element appears at this[ 0 ]) and the
				// `value` parameter was not undefined. An empty jQuery object
				// will result in `undefined` for elem = this[ 0 ] which will
				// throw an exception if an attempt to read a data cache is made.
				if ( elem && value === undefined ) {
	
					// Attempt to get data from the cache
					// The key will always be camelCased in Data
					data = dataUser.get( elem, key );
					if ( data !== undefined ) {
						return data;
					}
	
					// Attempt to "discover" the data in
					// HTML5 custom data-* attrs
					data = dataAttr( elem, key );
					if ( data !== undefined ) {
						return data;
					}
	
					// We tried really hard, but the data doesn't exist.
					return;
				}
	
				// Set the data...
				this.each( function() {
	
					// We always store the camelCased key
					dataUser.set( this, key, value );
				} );
			}, null, value, arguments.length > 1, null, true );
		},
	
		removeData: function( key ) {
			return this.each( function() {
				dataUser.remove( this, key );
			} );
		}
	} );
	
	
	jQuery.extend( {
		queue: function( elem, type, data ) {
			var queue;
	
			if ( elem ) {
				type = ( type || "fx" ) + "queue";
				queue = dataPriv.get( elem, type );
	
				// Speed up dequeue by getting out quickly if this is just a lookup
				if ( data ) {
					if ( !queue || Array.isArray( data ) ) {
						queue = dataPriv.access( elem, type, jQuery.makeArray( data ) );
					} else {
						queue.push( data );
					}
				}
				return queue || [];
			}
		},
	
		dequeue: function( elem, type ) {
			type = type || "fx";
	
			var queue = jQuery.queue( elem, type ),
				startLength = queue.length,
				fn = queue.shift(),
				hooks = jQuery._queueHooks( elem, type ),
				next = function() {
					jQuery.dequeue( elem, type );
				};
	
			// If the fx queue is dequeued, always remove the progress sentinel
			if ( fn === "inprogress" ) {
				fn = queue.shift();
				startLength--;
			}
	
			if ( fn ) {
	
				// Add a progress sentinel to prevent the fx queue from being
				// automatically dequeued
				if ( type === "fx" ) {
					queue.unshift( "inprogress" );
				}
	
				// Clear up the last queue stop function
				delete hooks.stop;
				fn.call( elem, next, hooks );
			}
	
			if ( !startLength && hooks ) {
				hooks.empty.fire();
			}
		},
	
		// Not public - generate a queueHooks object, or return the current one
		_queueHooks: function( elem, type ) {
			var key = type + "queueHooks";
			return dataPriv.get( elem, key ) || dataPriv.access( elem, key, {
				empty: jQuery.Callbacks( "once memory" ).add( function() {
					dataPriv.remove( elem, [ type + "queue", key ] );
				} )
			} );
		}
	} );
	
	jQuery.fn.extend( {
		queue: function( type, data ) {
			var setter = 2;
	
			if ( typeof type !== "string" ) {
				data = type;
				type = "fx";
				setter--;
			}
	
			if ( arguments.length < setter ) {
				return jQuery.queue( this[ 0 ], type );
			}
	
			return data === undefined ?
				this :
				this.each( function() {
					var queue = jQuery.queue( this, type, data );
	
					// Ensure a hooks for this queue
					jQuery._queueHooks( this, type );
	
					if ( type === "fx" && queue[ 0 ] !== "inprogress" ) {
						jQuery.dequeue( this, type );
					}
				} );
		},
		dequeue: function( type ) {
			return this.each( function() {
				jQuery.dequeue( this, type );
			} );
		},
		clearQueue: function( type ) {
			return this.queue( type || "fx", [] );
		},
	
		// Get a promise resolved when queues of a certain type
		// are emptied (fx is the type by default)
		promise: function( type, obj ) {
			var tmp,
				count = 1,
				defer = jQuery.Deferred(),
				elements = this,
				i = this.length,
				resolve = function() {
					if ( !( --count ) ) {
						defer.resolveWith( elements, [ elements ] );
					}
				};
	
			if ( typeof type !== "string" ) {
				obj = type;
				type = undefined;
			}
			type = type || "fx";
	
			while ( i-- ) {
				tmp = dataPriv.get( elements[ i ], type + "queueHooks" );
				if ( tmp && tmp.empty ) {
					count++;
					tmp.empty.add( resolve );
				}
			}
			resolve();
			return defer.promise( obj );
		}
	} );
	var pnum = ( /[+-]?(?:\d*\.|)\d+(?:[eE][+-]?\d+|)/ ).source;
	
	var rcssNum = new RegExp( "^(?:([+-])=|)(" + pnum + ")([a-z%]*)$", "i" );
	
	
	var cssExpand = [ "Top", "Right", "Bottom", "Left" ];
	
	var documentElement = document.documentElement;
	
	
	
		var isAttached = function( elem ) {
				return jQuery.contains( elem.ownerDocument, elem );
			},
			composed = { composed: true };
	
		// Support: IE 9 - 11+, Edge 12 - 18+, iOS 10.0 - 10.2 only
		// Check attachment across shadow DOM boundaries when possible (gh-3504)
		// Support: iOS 10.0-10.2 only
		// Early iOS 10 versions support `attachShadow` but not `getRootNode`,
		// leading to errors. We need to check for `getRootNode`.
		if ( documentElement.getRootNode ) {
			isAttached = function( elem ) {
				return jQuery.contains( elem.ownerDocument, elem ) ||
					elem.getRootNode( composed ) === elem.ownerDocument;
			};
		}
	var isHiddenWithinTree = function( elem, el ) {
	
			// isHiddenWithinTree might be called from jQuery#filter function;
			// in that case, element will be second argument
			elem = el || elem;
	
			// Inline style trumps all
			return elem.style.display === "none" ||
				elem.style.display === "" &&
	
				// Otherwise, check computed style
				// Support: Firefox <=43 - 45
				// Disconnected elements can have computed display: none, so first confirm that elem is
				// in the document.
				isAttached( elem ) &&
	
				jQuery.css( elem, "display" ) === "none";
		};
	
	
	
	function adjustCSS( elem, prop, valueParts, tween ) {
		var adjusted, scale,
			maxIterations = 20,
			currentValue = tween ?
				function() {
					return tween.cur();
				} :
				function() {
					return jQuery.css( elem, prop, "" );
				},
			initial = currentValue(),
			unit = valueParts && valueParts[ 3 ] || ( jQuery.cssNumber[ prop ] ? "" : "px" ),
	
			// Starting value computation is required for potential unit mismatches
			initialInUnit = elem.nodeType &&
				( jQuery.cssNumber[ prop ] || unit !== "px" && +initial ) &&
				rcssNum.exec( jQuery.css( elem, prop ) );
	
		if ( initialInUnit && initialInUnit[ 3 ] !== unit ) {
	
			// Support: Firefox <=54
			// Halve the iteration target value to prevent interference from CSS upper bounds (gh-2144)
			initial = initial / 2;
	
			// Trust units reported by jQuery.css
			unit = unit || initialInUnit[ 3 ];
	
			// Iteratively approximate from a nonzero starting point
			initialInUnit = +initial || 1;
	
			while ( maxIterations-- ) {
	
				// Evaluate and update our best guess (doubling guesses that zero out).
				// Finish if the scale equals or crosses 1 (making the old*new product non-positive).
				jQuery.style( elem, prop, initialInUnit + unit );
				if ( ( 1 - scale ) * ( 1 - ( scale = currentValue() / initial || 0.5 ) ) <= 0 ) {
					maxIterations = 0;
				}
				initialInUnit = initialInUnit / scale;
	
			}
	
			initialInUnit = initialInUnit * 2;
			jQuery.style( elem, prop, initialInUnit + unit );
	
			// Make sure we update the tween properties later on
			valueParts = valueParts || [];
		}
	
		if ( valueParts ) {
			initialInUnit = +initialInUnit || +initial || 0;
	
			// Apply relative offset (+=/-=) if specified
			adjusted = valueParts[ 1 ] ?
				initialInUnit + ( valueParts[ 1 ] + 1 ) * valueParts[ 2 ] :
				+valueParts[ 2 ];
			if ( tween ) {
				tween.unit = unit;
				tween.start = initialInUnit;
				tween.end = adjusted;
			}
		}
		return adjusted;
	}
	
	
	var defaultDisplayMap = {};
	
	function getDefaultDisplay( elem ) {
		var temp,
			doc = elem.ownerDocument,
			nodeName = elem.nodeName,
			display = defaultDisplayMap[ nodeName ];
	
		if ( display ) {
			return display;
		}
	
		temp = doc.body.appendChild( doc.createElement( nodeName ) );
		display = jQuery.css( temp, "display" );
	
		temp.parentNode.removeChild( temp );
	
		if ( display === "none" ) {
			display = "block";
		}
		defaultDisplayMap[ nodeName ] = display;
	
		return display;
	}
	
	function showHide( elements, show ) {
		var display, elem,
			values = [],
			index = 0,
			length = elements.length;
	
		// Determine new display value for elements that need to change
		for ( ; index < length; index++ ) {
			elem = elements[ index ];
			if ( !elem.style ) {
				continue;
			}
	
			display = elem.style.display;
			if ( show ) {
	
				// Since we force visibility upon cascade-hidden elements, an immediate (and slow)
				// check is required in this first loop unless we have a nonempty display value (either
				// inline or about-to-be-restored)
				if ( display === "none" ) {
					values[ index ] = dataPriv.get( elem, "display" ) || null;
					if ( !values[ index ] ) {
						elem.style.display = "";
					}
				}
				if ( elem.style.display === "" && isHiddenWithinTree( elem ) ) {
					values[ index ] = getDefaultDisplay( elem );
				}
			} else {
				if ( display !== "none" ) {
					values[ index ] = "none";
	
					// Remember what we're overwriting
					dataPriv.set( elem, "display", display );
				}
			}
		}
	
		// Set the display of the elements in a second loop to avoid constant reflow
		for ( index = 0; index < length; index++ ) {
			if ( values[ index ] != null ) {
				elements[ index ].style.display = values[ index ];
			}
		}
	
		return elements;
	}
	
	jQuery.fn.extend( {
		show: function() {
			return showHide( this, true );
		},
		hide: function() {
			return showHide( this );
		},
		toggle: function( state ) {
			if ( typeof state === "boolean" ) {
				return state ? this.show() : this.hide();
			}
	
			return this.each( function() {
				if ( isHiddenWithinTree( this ) ) {
					jQuery( this ).show();
				} else {
					jQuery( this ).hide();
				}
			} );
		}
	} );
	var rcheckableType = ( /^(?:checkbox|radio)$/i );
	
	var rtagName = ( /<([a-z][^\/\0>\x20\t\r\n\f]*)/i );
	
	var rscriptType = ( /^$|^module$|\/(?:java|ecma)script/i );
	
	
	
	( function() {
		var fragment = document.createDocumentFragment(),
			div = fragment.appendChild( document.createElement( "div" ) ),
			input = document.createElement( "input" );
	
		// Support: Android 4.0 - 4.3 only
		// Check state lost if the name is set (#11217)
		// Support: Windows Web Apps (WWA)
		// `name` and `type` must use .setAttribute for WWA (#14901)
		input.setAttribute( "type", "radio" );
		input.setAttribute( "checked", "checked" );
		input.setAttribute( "name", "t" );
	
		div.appendChild( input );
	
		// Support: Android <=4.1 only
		// Older WebKit doesn't clone checked state correctly in fragments
		support.checkClone = div.cloneNode( true ).cloneNode( true ).lastChild.checked;
	
		// Support: IE <=11 only
		// Make sure textarea (and checkbox) defaultValue is properly cloned
		div.innerHTML = "<textarea>x</textarea>";
		support.noCloneChecked = !!div.cloneNode( true ).lastChild.defaultValue;
	
		// Support: IE <=9 only
		// IE <=9 replaces <option> tags with their contents when inserted outside of
		// the select element.
		div.innerHTML = "<option></option>";
		support.option = !!div.lastChild;
	} )();
	
	
	// We have to close these tags to support XHTML (#13200)
	var wrapMap = {
	
		// XHTML parsers do not magically insert elements in the
		// same way that tag soup parsers do. So we cannot shorten
		// this by omitting <tbody> or other required elements.
		thead: [ 1, "<table>", "</table>" ],
		col: [ 2, "<table><colgroup>", "</colgroup></table>" ],
		tr: [ 2, "<table><tbody>", "</tbody></table>" ],
		td: [ 3, "<table><tbody><tr>", "</tr></tbody></table>" ],
	
		_default: [ 0, "", "" ]
	};
	
	wrapMap.tbody = wrapMap.tfoot = wrapMap.colgroup = wrapMap.caption = wrapMap.thead;
	wrapMap.th = wrapMap.td;
	
	// Support: IE <=9 only
	if ( !support.option ) {
		wrapMap.optgroup = wrapMap.option = [ 1, "<select multiple='multiple'>", "</select>" ];
	}
	
	
	function getAll( context, tag ) {
	
		// Support: IE <=9 - 11 only
		// Use typeof to avoid zero-argument method invocation on host objects (#15151)
		var ret;
	
		if ( typeof context.getElementsByTagName !== "undefined" ) {
			ret = context.getElementsByTagName( tag || "*" );
	
		} else if ( typeof context.querySelectorAll !== "undefined" ) {
			ret = context.querySelectorAll( tag || "*" );
	
		} else {
			ret = [];
		}
	
		if ( tag === undefined || tag && nodeName( context, tag ) ) {
			return jQuery.merge( [ context ], ret );
		}
	
		return ret;
	}
	
	
	// Mark scripts as having already been evaluated
	function setGlobalEval( elems, refElements ) {
		var i = 0,
			l = elems.length;
	
		for ( ; i < l; i++ ) {
			dataPriv.set(
				elems[ i ],
				"globalEval",
				!refElements || dataPriv.get( refElements[ i ], "globalEval" )
			);
		}
	}
	
	
	var rhtml = /<|&#?\w+;/;
	
	function buildFragment( elems, context, scripts, selection, ignored ) {
		var elem, tmp, tag, wrap, attached, j,
			fragment = context.createDocumentFragment(),
			nodes = [],
			i = 0,
			l = elems.length;
	
		for ( ; i < l; i++ ) {
			elem = elems[ i ];
	
			if ( elem || elem === 0 ) {
	
				// Add nodes directly
				if ( toType( elem ) === "object" ) {
	
					// Support: Android <=4.0 only, PhantomJS 1 only
					// push.apply(_, arraylike) throws on ancient WebKit
					jQuery.merge( nodes, elem.nodeType ? [ elem ] : elem );
	
				// Convert non-html into a text node
				} else if ( !rhtml.test( elem ) ) {
					nodes.push( context.createTextNode( elem ) );
	
				// Convert html into DOM nodes
				} else {
					tmp = tmp || fragment.appendChild( context.createElement( "div" ) );
	
					// Deserialize a standard representation
					tag = ( rtagName.exec( elem ) || [ "", "" ] )[ 1 ].toLowerCase();
					wrap = wrapMap[ tag ] || wrapMap._default;
					tmp.innerHTML = wrap[ 1 ] + jQuery.htmlPrefilter( elem ) + wrap[ 2 ];
	
					// Descend through wrappers to the right content
					j = wrap[ 0 ];
					while ( j-- ) {
						tmp = tmp.lastChild;
					}
	
					// Support: Android <=4.0 only, PhantomJS 1 only
					// push.apply(_, arraylike) throws on ancient WebKit
					jQuery.merge( nodes, tmp.childNodes );
	
					// Remember the top-level container
					tmp = fragment.firstChild;
	
					// Ensure the created nodes are orphaned (#12392)
					tmp.textContent = "";
				}
			}
		}
	
		// Remove wrapper from fragment
		fragment.textContent = "";
	
		i = 0;
		while ( ( elem = nodes[ i++ ] ) ) {
	
			// Skip elements already in the context collection (trac-4087)
			if ( selection && jQuery.inArray( elem, selection ) > -1 ) {
				if ( ignored ) {
					ignored.push( elem );
				}
				continue;
			}
	
			attached = isAttached( elem );
	
			// Append to fragment
			tmp = getAll( fragment.appendChild( elem ), "script" );
	
			// Preserve script evaluation history
			if ( attached ) {
				setGlobalEval( tmp );
			}
	
			// Capture executables
			if ( scripts ) {
				j = 0;
				while ( ( elem = tmp[ j++ ] ) ) {
					if ( rscriptType.test( elem.type || "" ) ) {
						scripts.push( elem );
					}
				}
			}
		}
	
		return fragment;
	}
	
	
	var rtypenamespace = /^([^.]*)(?:\.(.+)|)/;
	
	function returnTrue() {
		return true;
	}
	
	function returnFalse() {
		return false;
	}
	
	// Support: IE <=9 - 11+
	// focus() and blur() are asynchronous, except when they are no-op.
	// So expect focus to be synchronous when the element is already active,
	// and blur to be synchronous when the element is not already active.
	// (focus and blur are always synchronous in other supported browsers,
	// this just defines when we can count on it).
	function expectSync( elem, type ) {
		return ( elem === safeActiveElement() ) === ( type === "focus" );
	}
	
	// Support: IE <=9 only
	// Accessing document.activeElement can throw unexpectedly
	// https://bugs.jquery.com/ticket/13393
	function safeActiveElement() {
		try {
			return document.activeElement;
		} catch ( err ) { }
	}
	
	function on( elem, types, selector, data, fn, one ) {
		var origFn, type;
	
		// Types can be a map of types/handlers
		if ( typeof types === "object" ) {
	
			// ( types-Object, selector, data )
			if ( typeof selector !== "string" ) {
	
				// ( types-Object, data )
				data = data || selector;
				selector = undefined;
			}
			for ( type in types ) {
				on( elem, type, selector, data, types[ type ], one );
			}
			return elem;
		}
	
		if ( data == null && fn == null ) {
	
			// ( types, fn )
			fn = selector;
			data = selector = undefined;
		} else if ( fn == null ) {
			if ( typeof selector === "string" ) {
	
				// ( types, selector, fn )
				fn = data;
				data = undefined;
			} else {
	
				// ( types, data, fn )
				fn = data;
				data = selector;
				selector = undefined;
			}
		}
		if ( fn === false ) {
			fn = returnFalse;
		} else if ( !fn ) {
			return elem;
		}
	
		if ( one === 1 ) {
			origFn = fn;
			fn = function( event ) {
	
				// Can use an empty set, since event contains the info
				jQuery().off( event );
				return origFn.apply( this, arguments );
			};
	
			// Use same guid so caller can remove using origFn
			fn.guid = origFn.guid || ( origFn.guid = jQuery.guid++ );
		}
		return elem.each( function() {
			jQuery.event.add( this, types, fn, data, selector );
		} );
	}
	
	/*
	 * Helper functions for managing events -- not part of the public interface.
	 * Props to Dean Edwards' addEvent library for many of the ideas.
	 */
	jQuery.event = {
	
		global: {},
	
		add: function( elem, types, handler, data, selector ) {
	
			var handleObjIn, eventHandle, tmp,
				events, t, handleObj,
				special, handlers, type, namespaces, origType,
				elemData = dataPriv.get( elem );
	
			// Only attach events to objects that accept data
			if ( !acceptData( elem ) ) {
				return;
			}
	
			// Caller can pass in an object of custom data in lieu of the handler
			if ( handler.handler ) {
				handleObjIn = handler;
				handler = handleObjIn.handler;
				selector = handleObjIn.selector;
			}
	
			// Ensure that invalid selectors throw exceptions at attach time
			// Evaluate against documentElement in case elem is a non-element node (e.g., document)
			if ( selector ) {
				jQuery.find.matchesSelector( documentElement, selector );
			}
	
			// Make sure that the handler has a unique ID, used to find/remove it later
			if ( !handler.guid ) {
				handler.guid = jQuery.guid++;
			}
	
			// Init the element's event structure and main handler, if this is the first
			if ( !( events = elemData.events ) ) {
				events = elemData.events = Object.create( null );
			}
			if ( !( eventHandle = elemData.handle ) ) {
				eventHandle = elemData.handle = function( e ) {
	
					// Discard the second event of a jQuery.event.trigger() and
					// when an event is called after a page has unloaded
					return typeof jQuery !== "undefined" && jQuery.event.triggered !== e.type ?
						jQuery.event.dispatch.apply( elem, arguments ) : undefined;
				};
			}
	
			// Handle multiple events separated by a space
			types = ( types || "" ).match( rnothtmlwhite ) || [ "" ];
			t = types.length;
			while ( t-- ) {
				tmp = rtypenamespace.exec( types[ t ] ) || [];
				type = origType = tmp[ 1 ];
				namespaces = ( tmp[ 2 ] || "" ).split( "." ).sort();
	
				// There *must* be a type, no attaching namespace-only handlers
				if ( !type ) {
					continue;
				}
	
				// If event changes its type, use the special event handlers for the changed type
				special = jQuery.event.special[ type ] || {};
	
				// If selector defined, determine special event api type, otherwise given type
				type = ( selector ? special.delegateType : special.bindType ) || type;
	
				// Update special based on newly reset type
				special = jQuery.event.special[ type ] || {};
	
				// handleObj is passed to all event handlers
				handleObj = jQuery.extend( {
					type: type,
					origType: origType,
					data: data,
					handler: handler,
					guid: handler.guid,
					selector: selector,
					needsContext: selector && jQuery.expr.match.needsContext.test( selector ),
					namespace: namespaces.join( "." )
				}, handleObjIn );
	
				// Init the event handler queue if we're the first
				if ( !( handlers = events[ type ] ) ) {
					handlers = events[ type ] = [];
					handlers.delegateCount = 0;
	
					// Only use addEventListener if the special events handler returns false
					if ( !special.setup ||
						special.setup.call( elem, data, namespaces, eventHandle ) === false ) {
	
						if ( elem.addEventListener ) {
							elem.addEventListener( type, eventHandle );
						}
					}
				}
	
				if ( special.add ) {
					special.add.call( elem, handleObj );
	
					if ( !handleObj.handler.guid ) {
						handleObj.handler.guid = handler.guid;
					}
				}
	
				// Add to the element's handler list, delegates in front
				if ( selector ) {
					handlers.splice( handlers.delegateCount++, 0, handleObj );
				} else {
					handlers.push( handleObj );
				}
	
				// Keep track of which events have ever been used, for event optimization
				jQuery.event.global[ type ] = true;
			}
	
		},
	
		// Detach an event or set of events from an element
		remove: function( elem, types, handler, selector, mappedTypes ) {
	
			var j, origCount, tmp,
				events, t, handleObj,
				special, handlers, type, namespaces, origType,
				elemData = dataPriv.hasData( elem ) && dataPriv.get( elem );
	
			if ( !elemData || !( events = elemData.events ) ) {
				return;
			}
	
			// Once for each type.namespace in types; type may be omitted
			types = ( types || "" ).match( rnothtmlwhite ) || [ "" ];
			t = types.length;
			while ( t-- ) {
				tmp = rtypenamespace.exec( types[ t ] ) || [];
				type = origType = tmp[ 1 ];
				namespaces = ( tmp[ 2 ] || "" ).split( "." ).sort();
	
				// Unbind all events (on this namespace, if provided) for the element
				if ( !type ) {
					for ( type in events ) {
						jQuery.event.remove( elem, type + types[ t ], handler, selector, true );
					}
					continue;
				}
	
				special = jQuery.event.special[ type ] || {};
				type = ( selector ? special.delegateType : special.bindType ) || type;
				handlers = events[ type ] || [];
				tmp = tmp[ 2 ] &&
					new RegExp( "(^|\\.)" + namespaces.join( "\\.(?:.*\\.|)" ) + "(\\.|$)" );
	
				// Remove matching events
				origCount = j = handlers.length;
				while ( j-- ) {
					handleObj = handlers[ j ];
	
					if ( ( mappedTypes || origType === handleObj.origType ) &&
						( !handler || handler.guid === handleObj.guid ) &&
						( !tmp || tmp.test( handleObj.namespace ) ) &&
						( !selector || selector === handleObj.selector ||
							selector === "**" && handleObj.selector ) ) {
						handlers.splice( j, 1 );
	
						if ( handleObj.selector ) {
							handlers.delegateCount--;
						}
						if ( special.remove ) {
							special.remove.call( elem, handleObj );
						}
					}
				}
	
				// Remove generic event handler if we removed something and no more handlers exist
				// (avoids potential for endless recursion during removal of special event handlers)
				if ( origCount && !handlers.length ) {
					if ( !special.teardown ||
						special.teardown.call( elem, namespaces, elemData.handle ) === false ) {
	
						jQuery.removeEvent( elem, type, elemData.handle );
					}
	
					delete events[ type ];
				}
			}
	
			// Remove data and the expando if it's no longer used
			if ( jQuery.isEmptyObject( events ) ) {
				dataPriv.remove( elem, "handle events" );
			}
		},
	
		dispatch: function( nativeEvent ) {
	
			var i, j, ret, matched, handleObj, handlerQueue,
				args = new Array( arguments.length ),
	
				// Make a writable jQuery.Event from the native event object
				event = jQuery.event.fix( nativeEvent ),
	
				handlers = (
					dataPriv.get( this, "events" ) || Object.create( null )
				)[ event.type ] || [],
				special = jQuery.event.special[ event.type ] || {};
	
			// Use the fix-ed jQuery.Event rather than the (read-only) native event
			args[ 0 ] = event;
	
			for ( i = 1; i < arguments.length; i++ ) {
				args[ i ] = arguments[ i ];
			}
	
			event.delegateTarget = this;
	
			// Call the preDispatch hook for the mapped type, and let it bail if desired
			if ( special.preDispatch && special.preDispatch.call( this, event ) === false ) {
				return;
			}
	
			// Determine handlers
			handlerQueue = jQuery.event.handlers.call( this, event, handlers );
	
			// Run delegates first; they may want to stop propagation beneath us
			i = 0;
			while ( ( matched = handlerQueue[ i++ ] ) && !event.isPropagationStopped() ) {
				event.currentTarget = matched.elem;
	
				j = 0;
				while ( ( handleObj = matched.handlers[ j++ ] ) &&
					!event.isImmediatePropagationStopped() ) {
	
					// If the event is namespaced, then each handler is only invoked if it is
					// specially universal or its namespaces are a superset of the event's.
					if ( !event.rnamespace || handleObj.namespace === false ||
						event.rnamespace.test( handleObj.namespace ) ) {
	
						event.handleObj = handleObj;
						event.data = handleObj.data;
	
						ret = ( ( jQuery.event.special[ handleObj.origType ] || {} ).handle ||
							handleObj.handler ).apply( matched.elem, args );
	
						if ( ret !== undefined ) {
							if ( ( event.result = ret ) === false ) {
								event.preventDefault();
								event.stopPropagation();
							}
						}
					}
				}
			}
	
			// Call the postDispatch hook for the mapped type
			if ( special.postDispatch ) {
				special.postDispatch.call( this, event );
			}
	
			return event.result;
		},
	
		handlers: function( event, handlers ) {
			var i, handleObj, sel, matchedHandlers, matchedSelectors,
				handlerQueue = [],
				delegateCount = handlers.delegateCount,
				cur = event.target;
	
			// Find delegate handlers
			if ( delegateCount &&
	
				// Support: IE <=9
				// Black-hole SVG <use> instance trees (trac-13180)
				cur.nodeType &&
	
				// Support: Firefox <=42
				// Suppress spec-violating clicks indicating a non-primary pointer button (trac-3861)
				// https://www.w3.org/TR/DOM-Level-3-Events/#event-type-click
				// Support: IE 11 only
				// ...but not arrow key "clicks" of radio inputs, which can have `button` -1 (gh-2343)
				!( event.type === "click" && event.button >= 1 ) ) {
	
				for ( ; cur !== this; cur = cur.parentNode || this ) {
	
					// Don't check non-elements (#13208)
					// Don't process clicks on disabled elements (#6911, #8165, #11382, #11764)
					if ( cur.nodeType === 1 && !( event.type === "click" && cur.disabled === true ) ) {
						matchedHandlers = [];
						matchedSelectors = {};
						for ( i = 0; i < delegateCount; i++ ) {
							handleObj = handlers[ i ];
	
							// Don't conflict with Object.prototype properties (#13203)
							sel = handleObj.selector + " ";
	
							if ( matchedSelectors[ sel ] === undefined ) {
								matchedSelectors[ sel ] = handleObj.needsContext ?
									jQuery( sel, this ).index( cur ) > -1 :
									jQuery.find( sel, this, null, [ cur ] ).length;
							}
							if ( matchedSelectors[ sel ] ) {
								matchedHandlers.push( handleObj );
							}
						}
						if ( matchedHandlers.length ) {
							handlerQueue.push( { elem: cur, handlers: matchedHandlers } );
						}
					}
				}
			}
	
			// Add the remaining (directly-bound) handlers
			cur = this;
			if ( delegateCount < handlers.length ) {
				handlerQueue.push( { elem: cur, handlers: handlers.slice( delegateCount ) } );
			}
	
			return handlerQueue;
		},
	
		addProp: function( name, hook ) {
			Object.defineProperty( jQuery.Event.prototype, name, {
				enumerable: true,
				configurable: true,
	
				get: isFunction( hook ) ?
					function() {
						if ( this.originalEvent ) {
							return hook( this.originalEvent );
						}
					} :
					function() {
						if ( this.originalEvent ) {
							return this.originalEvent[ name ];
						}
					},
	
				set: function( value ) {
					Object.defineProperty( this, name, {
						enumerable: true,
						configurable: true,
						writable: true,
						value: value
					} );
				}
			} );
		},
	
		fix: function( originalEvent ) {
			return originalEvent[ jQuery.expando ] ?
				originalEvent :
				new jQuery.Event( originalEvent );
		},
	
		special: {
			load: {
	
				// Prevent triggered image.load events from bubbling to window.load
				noBubble: true
			},
			click: {
	
				// Utilize native event to ensure correct state for checkable inputs
				setup: function( data ) {
	
					// For mutual compressibility with _default, replace `this` access with a local var.
					// `|| data` is dead code meant only to preserve the variable through minification.
					var el = this || data;
	
					// Claim the first handler
					if ( rcheckableType.test( el.type ) &&
						el.click && nodeName( el, "input" ) ) {
	
						// dataPriv.set( el, "click", ... )
						leverageNative( el, "click", returnTrue );
					}
	
					// Return false to allow normal processing in the caller
					return false;
				},
				trigger: function( data ) {
	
					// For mutual compressibility with _default, replace `this` access with a local var.
					// `|| data` is dead code meant only to preserve the variable through minification.
					var el = this || data;
	
					// Force setup before triggering a click
					if ( rcheckableType.test( el.type ) &&
						el.click && nodeName( el, "input" ) ) {
	
						leverageNative( el, "click" );
					}
	
					// Return non-false to allow normal event-path propagation
					return true;
				},
	
				// For cross-browser consistency, suppress native .click() on links
				// Also prevent it if we're currently inside a leveraged native-event stack
				_default: function( event ) {
					var target = event.target;
					return rcheckableType.test( target.type ) &&
						target.click && nodeName( target, "input" ) &&
						dataPriv.get( target, "click" ) ||
						nodeName( target, "a" );
				}
			},
	
			beforeunload: {
				postDispatch: function( event ) {
	
					// Support: Firefox 20+
					// Firefox doesn't alert if the returnValue field is not set.
					if ( event.result !== undefined && event.originalEvent ) {
						event.originalEvent.returnValue = event.result;
					}
				}
			}
		}
	};
	
	// Ensure the presence of an event listener that handles manually-triggered
	// synthetic events by interrupting progress until reinvoked in response to
	// *native* events that it fires directly, ensuring that state changes have
	// already occurred before other listeners are invoked.
	function leverageNative( el, type, expectSync ) {
	
		// Missing expectSync indicates a trigger call, which must force setup through jQuery.event.add
		if ( !expectSync ) {
			if ( dataPriv.get( el, type ) === undefined ) {
				jQuery.event.add( el, type, returnTrue );
			}
			return;
		}
	
		// Register the controller as a special universal handler for all event namespaces
		dataPriv.set( el, type, false );
		jQuery.event.add( el, type, {
			namespace: false,
			handler: function( event ) {
				var notAsync, result,
					saved = dataPriv.get( this, type );
	
				if ( ( event.isTrigger & 1 ) && this[ type ] ) {
	
					// Interrupt processing of the outer synthetic .trigger()ed event
					// Saved data should be false in such cases, but might be a leftover capture object
					// from an async native handler (gh-4350)
					if ( !saved.length ) {
	
						// Store arguments for use when handling the inner native event
						// There will always be at least one argument (an event object), so this array
						// will not be confused with a leftover capture object.
						saved = slice.call( arguments );
						dataPriv.set( this, type, saved );
	
						// Trigger the native event and capture its result
						// Support: IE <=9 - 11+
						// focus() and blur() are asynchronous
						notAsync = expectSync( this, type );
						this[ type ]();
						result = dataPriv.get( this, type );
						if ( saved !== result || notAsync ) {
							dataPriv.set( this, type, false );
						} else {
							result = {};
						}
						if ( saved !== result ) {
	
							// Cancel the outer synthetic event
							event.stopImmediatePropagation();
							event.preventDefault();
	
							// Support: Chrome 86+
							// In Chrome, if an element having a focusout handler is blurred by
							// clicking outside of it, it invokes the handler synchronously. If
							// that handler calls `.remove()` on the element, the data is cleared,
							// leaving `result` undefined. We need to guard against this.
							return result && result.value;
						}
	
					// If this is an inner synthetic event for an event with a bubbling surrogate
					// (focus or blur), assume that the surrogate already propagated from triggering the
					// native event and prevent that from happening again here.
					// This technically gets the ordering wrong w.r.t. to `.trigger()` (in which the
					// bubbling surrogate propagates *after* the non-bubbling base), but that seems
					// less bad than duplication.
					} else if ( ( jQuery.event.special[ type ] || {} ).delegateType ) {
						event.stopPropagation();
					}
	
				// If this is a native event triggered above, everything is now in order
				// Fire an inner synthetic event with the original arguments
				} else if ( saved.length ) {
	
					// ...and capture the result
					dataPriv.set( this, type, {
						value: jQuery.event.trigger(
	
							// Support: IE <=9 - 11+
							// Extend with the prototype to reset the above stopImmediatePropagation()
							jQuery.extend( saved[ 0 ], jQuery.Event.prototype ),
							saved.slice( 1 ),
							this
						)
					} );
	
					// Abort handling of the native event
					event.stopImmediatePropagation();
				}
			}
		} );
	}
	
	jQuery.removeEvent = function( elem, type, handle ) {
	
		// This "if" is needed for plain objects
		if ( elem.removeEventListener ) {
			elem.removeEventListener( type, handle );
		}
	};
	
	jQuery.Event = function( src, props ) {
	
		// Allow instantiation without the 'new' keyword
		if ( !( this instanceof jQuery.Event ) ) {
			return new jQuery.Event( src, props );
		}
	
		// Event object
		if ( src && src.type ) {
			this.originalEvent = src;
			this.type = src.type;
	
			// Events bubbling up the document may have been marked as prevented
			// by a handler lower down the tree; reflect the correct value.
			this.isDefaultPrevented = src.defaultPrevented ||
					src.defaultPrevented === undefined &&
	
					// Support: Android <=2.3 only
					src.returnValue === false ?
				returnTrue :
				returnFalse;
	
			// Create target properties
			// Support: Safari <=6 - 7 only
			// Target should not be a text node (#504, #13143)
			this.target = ( src.target && src.target.nodeType === 3 ) ?
				src.target.parentNode :
				src.target;
	
			this.currentTarget = src.currentTarget;
			this.relatedTarget = src.relatedTarget;
	
		// Event type
		} else {
			this.type = src;
		}
	
		// Put explicitly provided properties onto the event object
		if ( props ) {
			jQuery.extend( this, props );
		}
	
		// Create a timestamp if incoming event doesn't have one
		this.timeStamp = src && src.timeStamp || Date.now();
	
		// Mark it as fixed
		this[ jQuery.expando ] = true;
	};
	
	// jQuery.Event is based on DOM3 Events as specified by the ECMAScript Language Binding
	// https://www.w3.org/TR/2003/WD-DOM-Level-3-Events-20030331/ecma-script-binding.html
	jQuery.Event.prototype = {
		constructor: jQuery.Event,
		isDefaultPrevented: returnFalse,
		isPropagationStopped: returnFalse,
		isImmediatePropagationStopped: returnFalse,
		isSimulated: false,
	
		preventDefault: function() {
			var e = this.originalEvent;
	
			this.isDefaultPrevented = returnTrue;
	
			if ( e && !this.isSimulated ) {
				e.preventDefault();
			}
		},
		stopPropagation: function() {
			var e = this.originalEvent;
	
			this.isPropagationStopped = returnTrue;
	
			if ( e && !this.isSimulated ) {
				e.stopPropagation();
			}
		},
		stopImmediatePropagation: function() {
			var e = this.originalEvent;
	
			this.isImmediatePropagationStopped = returnTrue;
	
			if ( e && !this.isSimulated ) {
				e.stopImmediatePropagation();
			}
	
			this.stopPropagation();
		}
	};
	
	// Includes all common event props including KeyEvent and MouseEvent specific props
	jQuery.each( {
		altKey: true,
		bubbles: true,
		cancelable: true,
		changedTouches: true,
		ctrlKey: true,
		detail: true,
		eventPhase: true,
		metaKey: true,
		pageX: true,
		pageY: true,
		shiftKey: true,
		view: true,
		"char": true,
		code: true,
		charCode: true,
		key: true,
		keyCode: true,
		button: true,
		buttons: true,
		clientX: true,
		clientY: true,
		offsetX: true,
		offsetY: true,
		pointerId: true,
		pointerType: true,
		screenX: true,
		screenY: true,
		targetTouches: true,
		toElement: true,
		touches: true,
		which: true
	}, jQuery.event.addProp );
	
	jQuery.each( { focus: "focusin", blur: "focusout" }, function( type, delegateType ) {
		jQuery.event.special[ type ] = {
	
			// Utilize native event if possible so blur/focus sequence is correct
			setup: function() {
	
				// Claim the first handler
				// dataPriv.set( this, "focus", ... )
				// dataPriv.set( this, "blur", ... )
				leverageNative( this, type, expectSync );
	
				// Return false to allow normal processing in the caller
				return false;
			},
			trigger: function() {
	
				// Force setup before trigger
				leverageNative( this, type );
	
				// Return non-false to allow normal event-path propagation
				return true;
			},
	
			// Suppress native focus or blur as it's already being fired
			// in leverageNative.
			_default: function() {
				return true;
			},
	
			delegateType: delegateType
		};
	} );
	
	// Create mouseenter/leave events using mouseover/out and event-time checks
	// so that event delegation works in jQuery.
	// Do the same for pointerenter/pointerleave and pointerover/pointerout
	//
	// Support: Safari 7 only
	// Safari sends mouseenter too often; see:
	// https://bugs.chromium.org/p/chromium/issues/detail?id=470258
	// for the description of the bug (it existed in older Chrome versions as well).
	jQuery.each( {
		mouseenter: "mouseover",
		mouseleave: "mouseout",
		pointerenter: "pointerover",
		pointerleave: "pointerout"
	}, function( orig, fix ) {
		jQuery.event.special[ orig ] = {
			delegateType: fix,
			bindType: fix,
	
			handle: function( event ) {
				var ret,
					target = this,
					related = event.relatedTarget,
					handleObj = event.handleObj;
	
				// For mouseenter/leave call the handler if related is outside the target.
				// NB: No relatedTarget if the mouse left/entered the browser window
				if ( !related || ( related !== target && !jQuery.contains( target, related ) ) ) {
					event.type = handleObj.origType;
					ret = handleObj.handler.apply( this, arguments );
					event.type = fix;
				}
				return ret;
			}
		};
	} );
	
	jQuery.fn.extend( {
	
		on: function( types, selector, data, fn ) {
			return on( this, types, selector, data, fn );
		},
		one: function( types, selector, data, fn ) {
			return on( this, types, selector, data, fn, 1 );
		},
		off: function( types, selector, fn ) {
			var handleObj, type;
			if ( types && types.preventDefault && types.handleObj ) {
	
				// ( event )  dispatched jQuery.Event
				handleObj = types.handleObj;
				jQuery( types.delegateTarget ).off(
					handleObj.namespace ?
						handleObj.origType + "." + handleObj.namespace :
						handleObj.origType,
					handleObj.selector,
					handleObj.handler
				);
				return this;
			}
			if ( typeof types === "object" ) {
	
				// ( types-object [, selector] )
				for ( type in types ) {
					this.off( type, selector, types[ type ] );
				}
				return this;
			}
			if ( selector === false || typeof selector === "function" ) {
	
				// ( types [, fn] )
				fn = selector;
				selector = undefined;
			}
			if ( fn === false ) {
				fn = returnFalse;
			}
			return this.each( function() {
				jQuery.event.remove( this, types, fn, selector );
			} );
		}
	} );
	
	
	var
	
		// Support: IE <=10 - 11, Edge 12 - 13 only
		// In IE/Edge using regex groups here causes severe slowdowns.
		// See https://connect.microsoft.com/IE/feedback/details/1736512/
		rnoInnerhtml = /<script|<style|<link/i,
	
		// checked="checked" or checked
		rchecked = /checked\s*(?:[^=]|=\s*.checked.)/i,
		rcleanScript = /^\s*<!(?:\[CDATA\[|--)|(?:\]\]|--)>\s*$/g;
	
	// Prefer a tbody over its parent table for containing new rows
	function manipulationTarget( elem, content ) {
		if ( nodeName( elem, "table" ) &&
			nodeName( content.nodeType !== 11 ? content : content.firstChild, "tr" ) ) {
	
			return jQuery( elem ).children( "tbody" )[ 0 ] || elem;
		}
	
		return elem;
	}
	
	// Replace/restore the type attribute of script elements for safe DOM manipulation
	function disableScript( elem ) {
		elem.type = ( elem.getAttribute( "type" ) !== null ) + "/" + elem.type;
		return elem;
	}
	function restoreScript( elem ) {
		if ( ( elem.type || "" ).slice( 0, 5 ) === "true/" ) {
			elem.type = elem.type.slice( 5 );
		} else {
			elem.removeAttribute( "type" );
		}
	
		return elem;
	}
	
	function cloneCopyEvent( src, dest ) {
		var i, l, type, pdataOld, udataOld, udataCur, events;
	
		if ( dest.nodeType !== 1 ) {
			return;
		}
	
		// 1. Copy private data: events, handlers, etc.
		if ( dataPriv.hasData( src ) ) {
			pdataOld = dataPriv.get( src );
			events = pdataOld.events;
	
			if ( events ) {
				dataPriv.remove( dest, "handle events" );
	
				for ( type in events ) {
					for ( i = 0, l = events[ type ].length; i < l; i++ ) {
						jQuery.event.add( dest, type, events[ type ][ i ] );
					}
				}
			}
		}
	
		// 2. Copy user data
		if ( dataUser.hasData( src ) ) {
			udataOld = dataUser.access( src );
			udataCur = jQuery.extend( {}, udataOld );
	
			dataUser.set( dest, udataCur );
		}
	}
	
	// Fix IE bugs, see support tests
	function fixInput( src, dest ) {
		var nodeName = dest.nodeName.toLowerCase();
	
		// Fails to persist the checked state of a cloned checkbox or radio button.
		if ( nodeName === "input" && rcheckableType.test( src.type ) ) {
			dest.checked = src.checked;
	
		// Fails to return the selected option to the default selected state when cloning options
		} else if ( nodeName === "input" || nodeName === "textarea" ) {
			dest.defaultValue = src.defaultValue;
		}
	}
	
	function domManip( collection, args, callback, ignored ) {
	
		// Flatten any nested arrays
		args = flat( args );
	
		var fragment, first, scripts, hasScripts, node, doc,
			i = 0,
			l = collection.length,
			iNoClone = l - 1,
			value = args[ 0 ],
			valueIsFunction = isFunction( value );
	
		// We can't cloneNode fragments that contain checked, in WebKit
		if ( valueIsFunction ||
				( l > 1 && typeof value === "string" &&
					!support.checkClone && rchecked.test( value ) ) ) {
			return collection.each( function( index ) {
				var self = collection.eq( index );
				if ( valueIsFunction ) {
					args[ 0 ] = value.call( this, index, self.html() );
				}
				domManip( self, args, callback, ignored );
			} );
		}
	
		if ( l ) {
			fragment = buildFragment( args, collection[ 0 ].ownerDocument, false, collection, ignored );
			first = fragment.firstChild;
	
			if ( fragment.childNodes.length === 1 ) {
				fragment = first;
			}
	
			// Require either new content or an interest in ignored elements to invoke the callback
			if ( first || ignored ) {
				scripts = jQuery.map( getAll( fragment, "script" ), disableScript );
				hasScripts = scripts.length;
	
				// Use the original fragment for the last item
				// instead of the first because it can end up
				// being emptied incorrectly in certain situations (#8070).
				for ( ; i < l; i++ ) {
					node = fragment;
	
					if ( i !== iNoClone ) {
						node = jQuery.clone( node, true, true );
	
						// Keep references to cloned scripts for later restoration
						if ( hasScripts ) {
	
							// Support: Android <=4.0 only, PhantomJS 1 only
							// push.apply(_, arraylike) throws on ancient WebKit
							jQuery.merge( scripts, getAll( node, "script" ) );
						}
					}
	
					callback.call( collection[ i ], node, i );
				}
	
				if ( hasScripts ) {
					doc = scripts[ scripts.length - 1 ].ownerDocument;
	
					// Reenable scripts
					jQuery.map( scripts, restoreScript );
	
					// Evaluate executable scripts on first document insertion
					for ( i = 0; i < hasScripts; i++ ) {
						node = scripts[ i ];
						if ( rscriptType.test( node.type || "" ) &&
							!dataPriv.access( node, "globalEval" ) &&
							jQuery.contains( doc, node ) ) {
	
							if ( node.src && ( node.type || "" ).toLowerCase()  !== "module" ) {
	
								// Optional AJAX dependency, but won't run scripts if not present
								if ( jQuery._evalUrl && !node.noModule ) {
									jQuery._evalUrl( node.src, {
										nonce: node.nonce || node.getAttribute( "nonce" )
									}, doc );
								}
							} else {
								DOMEval( node.textContent.replace( rcleanScript, "" ), node, doc );
							}
						}
					}
				}
			}
		}
	
		return collection;
	}
	
	function remove( elem, selector, keepData ) {
		var node,
			nodes = selector ? jQuery.filter( selector, elem ) : elem,
			i = 0;
	
		for ( ; ( node = nodes[ i ] ) != null; i++ ) {
			if ( !keepData && node.nodeType === 1 ) {
				jQuery.cleanData( getAll( node ) );
			}
	
			if ( node.parentNode ) {
				if ( keepData && isAttached( node ) ) {
					setGlobalEval( getAll( node, "script" ) );
				}
				node.parentNode.removeChild( node );
			}
		}
	
		return elem;
	}
	
	jQuery.extend( {
		htmlPrefilter: function( html ) {
			return html;
		},
	
		clone: function( elem, dataAndEvents, deepDataAndEvents ) {
			var i, l, srcElements, destElements,
				clone = elem.cloneNode( true ),
				inPage = isAttached( elem );
	
			// Fix IE cloning issues
			if ( !support.noCloneChecked && ( elem.nodeType === 1 || elem.nodeType === 11 ) &&
					!jQuery.isXMLDoc( elem ) ) {
	
				// We eschew Sizzle here for performance reasons: https://jsperf.com/getall-vs-sizzle/2
				destElements = getAll( clone );
				srcElements = getAll( elem );
	
				for ( i = 0, l = srcElements.length; i < l; i++ ) {
					fixInput( srcElements[ i ], destElements[ i ] );
				}
			}
	
			// Copy the events from the original to the clone
			if ( dataAndEvents ) {
				if ( deepDataAndEvents ) {
					srcElements = srcElements || getAll( elem );
					destElements = destElements || getAll( clone );
	
					for ( i = 0, l = srcElements.length; i < l; i++ ) {
						cloneCopyEvent( srcElements[ i ], destElements[ i ] );
					}
				} else {
					cloneCopyEvent( elem, clone );
				}
			}
	
			// Preserve script evaluation history
			destElements = getAll( clone, "script" );
			if ( destElements.length > 0 ) {
				setGlobalEval( destElements, !inPage && getAll( elem, "script" ) );
			}
	
			// Return the cloned set
			return clone;
		},
	
		cleanData: function( elems ) {
			var data, elem, type,
				special = jQuery.event.special,
				i = 0;
	
			for ( ; ( elem = elems[ i ] ) !== undefined; i++ ) {
				if ( acceptData( elem ) ) {
					if ( ( data = elem[ dataPriv.expando ] ) ) {
						if ( data.events ) {
							for ( type in data.events ) {
								if ( special[ type ] ) {
									jQuery.event.remove( elem, type );
	
								// This is a shortcut to avoid jQuery.event.remove's overhead
								} else {
									jQuery.removeEvent( elem, type, data.handle );
								}
							}
						}
	
						// Support: Chrome <=35 - 45+
						// Assign undefined instead of using delete, see Data#remove
						elem[ dataPriv.expando ] = undefined;
					}
					if ( elem[ dataUser.expando ] ) {
	
						// Support: Chrome <=35 - 45+
						// Assign undefined instead of using delete, see Data#remove
						elem[ dataUser.expando ] = undefined;
					}
				}
			}
		}
	} );
	
	jQuery.fn.extend( {
		detach: function( selector ) {
			return remove( this, selector, true );
		},
	
		remove: function( selector ) {
			return remove( this, selector );
		},
	
		text: function( value ) {
			return access( this, function( value ) {
				return value === undefined ?
					jQuery.text( this ) :
					this.empty().each( function() {
						if ( this.nodeType === 1 || this.nodeType === 11 || this.nodeType === 9 ) {
							this.textContent = value;
						}
					} );
			}, null, value, arguments.length );
		},
	
		append: function() {
			return domManip( this, arguments, function( elem ) {
				if ( this.nodeType === 1 || this.nodeType === 11 || this.nodeType === 9 ) {
					var target = manipulationTarget( this, elem );
					target.appendChild( elem );
				}
			} );
		},
	
		prepend: function() {
			return domManip( this, arguments, function( elem ) {
				if ( this.nodeType === 1 || this.nodeType === 11 || this.nodeType === 9 ) {
					var target = manipulationTarget( this, elem );
					target.insertBefore( elem, target.firstChild );
				}
			} );
		},
	
		before: function() {
			return domManip( this, arguments, function( elem ) {
				if ( this.parentNode ) {
					this.parentNode.insertBefore( elem, this );
				}
			} );
		},
	
		after: function() {
			return domManip( this, arguments, function( elem ) {
				if ( this.parentNode ) {
					this.parentNode.insertBefore( elem, this.nextSibling );
				}
			} );
		},
	
		empty: function() {
			var elem,
				i = 0;
	
			for ( ; ( elem = this[ i ] ) != null; i++ ) {
				if ( elem.nodeType === 1 ) {
	
					// Prevent memory leaks
					jQuery.cleanData( getAll( elem, false ) );
	
					// Remove any remaining nodes
					elem.textContent = "";
				}
			}
	
			return this;
		},
	
		clone: function( dataAndEvents, deepDataAndEvents ) {
			dataAndEvents = dataAndEvents == null ? false : dataAndEvents;
			deepDataAndEvents = deepDataAndEvents == null ? dataAndEvents : deepDataAndEvents;
	
			return this.map( function() {
				return jQuery.clone( this, dataAndEvents, deepDataAndEvents );
			} );
		},
	
		html: function( value ) {
			return access( this, function( value ) {
				var elem = this[ 0 ] || {},
					i = 0,
					l = this.length;
	
				if ( value === undefined && elem.nodeType === 1 ) {
					return elem.innerHTML;
				}
	
				// See if we can take a shortcut and just use innerHTML
				if ( typeof value === "string" && !rnoInnerhtml.test( value ) &&
					!wrapMap[ ( rtagName.exec( value ) || [ "", "" ] )[ 1 ].toLowerCase() ] ) {
	
					value = jQuery.htmlPrefilter( value );
	
					try {
						for ( ; i < l; i++ ) {
							elem = this[ i ] || {};
	
							// Remove element nodes and prevent memory leaks
							if ( elem.nodeType === 1 ) {
								jQuery.cleanData( getAll( elem, false ) );
								elem.innerHTML = value;
							}
						}
	
						elem = 0;
	
					// If using innerHTML throws an exception, use the fallback method
					} catch ( e ) {}
				}
	
				if ( elem ) {
					this.empty().append( value );
				}
			}, null, value, arguments.length );
		},
	
		replaceWith: function() {
			var ignored = [];
	
			// Make the changes, replacing each non-ignored context element with the new content
			return domManip( this, arguments, function( elem ) {
				var parent = this.parentNode;
	
				if ( jQuery.inArray( this, ignored ) < 0 ) {
					jQuery.cleanData( getAll( this ) );
					if ( parent ) {
						parent.replaceChild( elem, this );
					}
				}
	
			// Force callback invocation
			}, ignored );
		}
	} );
	
	jQuery.each( {
		appendTo: "append",
		prependTo: "prepend",
		insertBefore: "before",
		insertAfter: "after",
		replaceAll: "replaceWith"
	}, function( name, original ) {
		jQuery.fn[ name ] = function( selector ) {
			var elems,
				ret = [],
				insert = jQuery( selector ),
				last = insert.length - 1,
				i = 0;
	
			for ( ; i <= last; i++ ) {
				elems = i === last ? this : this.clone( true );
				jQuery( insert[ i ] )[ original ]( elems );
	
				// Support: Android <=4.0 only, PhantomJS 1 only
				// .get() because push.apply(_, arraylike) throws on ancient WebKit
				push.apply( ret, elems.get() );
			}
	
			return this.pushStack( ret );
		};
	} );
	var rnumnonpx = new RegExp( "^(" + pnum + ")(?!px)[a-z%]+$", "i" );
	
	var getStyles = function( elem ) {
	
			// Support: IE <=11 only, Firefox <=30 (#15098, #14150)
			// IE throws on elements created in popups
			// FF meanwhile throws on frame elements through "defaultView.getComputedStyle"
			var view = elem.ownerDocument.defaultView;
	
			if ( !view || !view.opener ) {
				view = window;
			}
	
			return view.getComputedStyle( elem );
		};
	
	var swap = function( elem, options, callback ) {
		var ret, name,
			old = {};
	
		// Remember the old values, and insert the new ones
		for ( name in options ) {
			old[ name ] = elem.style[ name ];
			elem.style[ name ] = options[ name ];
		}
	
		ret = callback.call( elem );
	
		// Revert the old values
		for ( name in options ) {
			elem.style[ name ] = old[ name ];
		}
	
		return ret;
	};
	
	
	var rboxStyle = new RegExp( cssExpand.join( "|" ), "i" );
	
	
	
	( function() {
	
		// Executing both pixelPosition & boxSizingReliable tests require only one layout
		// so they're executed at the same time to save the second computation.
		function computeStyleTests() {
	
			// This is a singleton, we need to execute it only once
			if ( !div ) {
				return;
			}
	
			container.style.cssText = "position:absolute;left:-11111px;width:60px;" +
				"margin-top:1px;padding:0;border:0";
			div.style.cssText =
				"position:relative;display:block;box-sizing:border-box;overflow:scroll;" +
				"margin:auto;border:1px;padding:1px;" +
				"width:60%;top:1%";
			documentElement.appendChild( container ).appendChild( div );
	
			var divStyle = window.getComputedStyle( div );
			pixelPositionVal = divStyle.top !== "1%";
	
			// Support: Android 4.0 - 4.3 only, Firefox <=3 - 44
			reliableMarginLeftVal = roundPixelMeasures( divStyle.marginLeft ) === 12;
	
			// Support: Android 4.0 - 4.3 only, Safari <=9.1 - 10.1, iOS <=7.0 - 9.3
			// Some styles come back with percentage values, even though they shouldn't
			div.style.right = "60%";
			pixelBoxStylesVal = roundPixelMeasures( divStyle.right ) === 36;
	
			// Support: IE 9 - 11 only
			// Detect misreporting of content dimensions for box-sizing:border-box elements
			boxSizingReliableVal = roundPixelMeasures( divStyle.width ) === 36;
	
			// Support: IE 9 only
			// Detect overflow:scroll screwiness (gh-3699)
			// Support: Chrome <=64
			// Don't get tricked when zoom affects offsetWidth (gh-4029)
			div.style.position = "absolute";
			scrollboxSizeVal = roundPixelMeasures( div.offsetWidth / 3 ) === 12;
	
			documentElement.removeChild( container );
	
			// Nullify the div so it wouldn't be stored in the memory and
			// it will also be a sign that checks already performed
			div = null;
		}
	
		function roundPixelMeasures( measure ) {
			return Math.round( parseFloat( measure ) );
		}
	
		var pixelPositionVal, boxSizingReliableVal, scrollboxSizeVal, pixelBoxStylesVal,
			reliableTrDimensionsVal, reliableMarginLeftVal,
			container = document.createElement( "div" ),
			div = document.createElement( "div" );
	
		// Finish early in limited (non-browser) environments
		if ( !div.style ) {
			return;
		}
	
		// Support: IE <=9 - 11 only
		// Style of cloned element affects source element cloned (#8908)
		div.style.backgroundClip = "content-box";
		div.cloneNode( true ).style.backgroundClip = "";
		support.clearCloneStyle = div.style.backgroundClip === "content-box";
	
		jQuery.extend( support, {
			boxSizingReliable: function() {
				computeStyleTests();
				return boxSizingReliableVal;
			},
			pixelBoxStyles: function() {
				computeStyleTests();
				return pixelBoxStylesVal;
			},
			pixelPosition: function() {
				computeStyleTests();
				return pixelPositionVal;
			},
			reliableMarginLeft: function() {
				computeStyleTests();
				return reliableMarginLeftVal;
			},
			scrollboxSize: function() {
				computeStyleTests();
				return scrollboxSizeVal;
			},
	
			// Support: IE 9 - 11+, Edge 15 - 18+
			// IE/Edge misreport `getComputedStyle` of table rows with width/height
			// set in CSS while `offset*` properties report correct values.
			// Behavior in IE 9 is more subtle than in newer versions & it passes
			// some versions of this test; make sure not to make it pass there!
			//
			// Support: Firefox 70+
			// Only Firefox includes border widths
			// in computed dimensions. (gh-4529)
			reliableTrDimensions: function() {
				var table, tr, trChild, trStyle;
				if ( reliableTrDimensionsVal == null ) {
					table = document.createElement( "table" );
					tr = document.createElement( "tr" );
					trChild = document.createElement( "div" );
	
					table.style.cssText = "position:absolute;left:-11111px;border-collapse:separate";
					tr.style.cssText = "border:1px solid";
	
					// Support: Chrome 86+
					// Height set through cssText does not get applied.
					// Computed height then comes back as 0.
					tr.style.height = "1px";
					trChild.style.height = "9px";
	
					// Support: Android 8 Chrome 86+
					// In our bodyBackground.html iframe,
					// display for all div elements is set to "inline",
					// which causes a problem only in Android 8 Chrome 86.
					// Ensuring the div is display: block
					// gets around this issue.
					trChild.style.display = "block";
	
					documentElement
						.appendChild( table )
						.appendChild( tr )
						.appendChild( trChild );
	
					trStyle = window.getComputedStyle( tr );
					reliableTrDimensionsVal = ( parseInt( trStyle.height, 10 ) +
						parseInt( trStyle.borderTopWidth, 10 ) +
						parseInt( trStyle.borderBottomWidth, 10 ) ) === tr.offsetHeight;
	
					documentElement.removeChild( table );
				}
				return reliableTrDimensionsVal;
			}
		} );
	} )();
	
	
	function curCSS( elem, name, computed ) {
		var width, minWidth, maxWidth, ret,
	
			// Support: Firefox 51+
			// Retrieving style before computed somehow
			// fixes an issue with getting wrong values
			// on detached elements
			style = elem.style;
	
		computed = computed || getStyles( elem );
	
		// getPropertyValue is needed for:
		//   .css('filter') (IE 9 only, #12537)
		//   .css('--customProperty) (#3144)
		if ( computed ) {
			ret = computed.getPropertyValue( name ) || computed[ name ];
	
			if ( ret === "" && !isAttached( elem ) ) {
				ret = jQuery.style( elem, name );
			}
	
			// A tribute to the "awesome hack by Dean Edwards"
			// Android Browser returns percentage for some values,
			// but width seems to be reliably pixels.
			// This is against the CSSOM draft spec:
			// https://drafts.csswg.org/cssom/#resolved-values
			if ( !support.pixelBoxStyles() && rnumnonpx.test( ret ) && rboxStyle.test( name ) ) {
	
				// Remember the original values
				width = style.width;
				minWidth = style.minWidth;
				maxWidth = style.maxWidth;
	
				// Put in the new values to get a computed value out
				style.minWidth = style.maxWidth = style.width = ret;
				ret = computed.width;
	
				// Revert the changed values
				style.width = width;
				style.minWidth = minWidth;
				style.maxWidth = maxWidth;
			}
		}
	
		return ret !== undefined ?
	
			// Support: IE <=9 - 11 only
			// IE returns zIndex value as an integer.
			ret + "" :
			ret;
	}
	
	
	function addGetHookIf( conditionFn, hookFn ) {
	
		// Define the hook, we'll check on the first run if it's really needed.
		return {
			get: function() {
				if ( conditionFn() ) {
	
					// Hook not needed (or it's not possible to use it due
					// to missing dependency), remove it.
					delete this.get;
					return;
				}
	
				// Hook needed; redefine it so that the support test is not executed again.
				return ( this.get = hookFn ).apply( this, arguments );
			}
		};
	}
	
	
	var cssPrefixes = [ "Webkit", "Moz", "ms" ],
		emptyStyle = document.createElement( "div" ).style,
		vendorProps = {};
	
	// Return a vendor-prefixed property or undefined
	function vendorPropName( name ) {
	
		// Check for vendor prefixed names
		var capName = name[ 0 ].toUpperCase() + name.slice( 1 ),
			i = cssPrefixes.length;
	
		while ( i-- ) {
			name = cssPrefixes[ i ] + capName;
			if ( name in emptyStyle ) {
				return name;
			}
		}
	}
	
	// Return a potentially-mapped jQuery.cssProps or vendor prefixed property
	function finalPropName( name ) {
		var final = jQuery.cssProps[ name ] || vendorProps[ name ];
	
		if ( final ) {
			return final;
		}
		if ( name in emptyStyle ) {
			return name;
		}
		return vendorProps[ name ] = vendorPropName( name ) || name;
	}
	
	
	var
	
		// Swappable if display is none or starts with table
		// except "table", "table-cell", or "table-caption"
		// See here for display values: https://developer.mozilla.org/en-US/docs/CSS/display
		rdisplayswap = /^(none|table(?!-c[ea]).+)/,
		rcustomProp = /^--/,
		cssShow = { position: "absolute", visibility: "hidden", display: "block" },
		cssNormalTransform = {
			letterSpacing: "0",
			fontWeight: "400"
		};
	
	function setPositiveNumber( _elem, value, subtract ) {
	
		// Any relative (+/-) values have already been
		// normalized at this point
		var matches = rcssNum.exec( value );
		return matches ?
	
			// Guard against undefined "subtract", e.g., when used as in cssHooks
			Math.max( 0, matches[ 2 ] - ( subtract || 0 ) ) + ( matches[ 3 ] || "px" ) :
			value;
	}
	
	function boxModelAdjustment( elem, dimension, box, isBorderBox, styles, computedVal ) {
		var i = dimension === "width" ? 1 : 0,
			extra = 0,
			delta = 0;
	
		// Adjustment may not be necessary
		if ( box === ( isBorderBox ? "border" : "content" ) ) {
			return 0;
		}
	
		for ( ; i < 4; i += 2 ) {
	
			// Both box models exclude margin
			if ( box === "margin" ) {
				delta += jQuery.css( elem, box + cssExpand[ i ], true, styles );
			}
	
			// If we get here with a content-box, we're seeking "padding" or "border" or "margin"
			if ( !isBorderBox ) {
	
				// Add padding
				delta += jQuery.css( elem, "padding" + cssExpand[ i ], true, styles );
	
				// For "border" or "margin", add border
				if ( box !== "padding" ) {
					delta += jQuery.css( elem, "border" + cssExpand[ i ] + "Width", true, styles );
	
				// But still keep track of it otherwise
				} else {
					extra += jQuery.css( elem, "border" + cssExpand[ i ] + "Width", true, styles );
				}
	
			// If we get here with a border-box (content + padding + border), we're seeking "content" or
			// "padding" or "margin"
			} else {
	
				// For "content", subtract padding
				if ( box === "content" ) {
					delta -= jQuery.css( elem, "padding" + cssExpand[ i ], true, styles );
				}
	
				// For "content" or "padding", subtract border
				if ( box !== "margin" ) {
					delta -= jQuery.css( elem, "border" + cssExpand[ i ] + "Width", true, styles );
				}
			}
		}
	
		// Account for positive content-box scroll gutter when requested by providing computedVal
		if ( !isBorderBox && computedVal >= 0 ) {
	
			// offsetWidth/offsetHeight is a rounded sum of content, padding, scroll gutter, and border
			// Assuming integer scroll gutter, subtract the rest and round down
			delta += Math.max( 0, Math.ceil(
				elem[ "offset" + dimension[ 0 ].toUpperCase() + dimension.slice( 1 ) ] -
				computedVal -
				delta -
				extra -
				0.5
	
			// If offsetWidth/offsetHeight is unknown, then we can't determine content-box scroll gutter
			// Use an explicit zero to avoid NaN (gh-3964)
			) ) || 0;
		}
	
		return delta;
	}
	
	function getWidthOrHeight( elem, dimension, extra ) {
	
		// Start with computed style
		var styles = getStyles( elem ),
	
			// To avoid forcing a reflow, only fetch boxSizing if we need it (gh-4322).
			// Fake content-box until we know it's needed to know the true value.
			boxSizingNeeded = !support.boxSizingReliable() || extra,
			isBorderBox = boxSizingNeeded &&
				jQuery.css( elem, "boxSizing", false, styles ) === "border-box",
			valueIsBorderBox = isBorderBox,
	
			val = curCSS( elem, dimension, styles ),
			offsetProp = "offset" + dimension[ 0 ].toUpperCase() + dimension.slice( 1 );
	
		// Support: Firefox <=54
		// Return a confounding non-pixel value or feign ignorance, as appropriate.
		if ( rnumnonpx.test( val ) ) {
			if ( !extra ) {
				return val;
			}
			val = "auto";
		}
	
	
		// Support: IE 9 - 11 only
		// Use offsetWidth/offsetHeight for when box sizing is unreliable.
		// In those cases, the computed value can be trusted to be border-box.
		if ( ( !support.boxSizingReliable() && isBorderBox ||
	
			// Support: IE 10 - 11+, Edge 15 - 18+
			// IE/Edge misreport `getComputedStyle` of table rows with width/height
			// set in CSS while `offset*` properties report correct values.
			// Interestingly, in some cases IE 9 doesn't suffer from this issue.
			!support.reliableTrDimensions() && nodeName( elem, "tr" ) ||
	
			// Fall back to offsetWidth/offsetHeight when value is "auto"
			// This happens for inline elements with no explicit setting (gh-3571)
			val === "auto" ||
	
			// Support: Android <=4.1 - 4.3 only
			// Also use offsetWidth/offsetHeight for misreported inline dimensions (gh-3602)
			!parseFloat( val ) && jQuery.css( elem, "display", false, styles ) === "inline" ) &&
	
			// Make sure the element is visible & connected
			elem.getClientRects().length ) {
	
			isBorderBox = jQuery.css( elem, "boxSizing", false, styles ) === "border-box";
	
			// Where available, offsetWidth/offsetHeight approximate border box dimensions.
			// Where not available (e.g., SVG), assume unreliable box-sizing and interpret the
			// retrieved value as a content box dimension.
			valueIsBorderBox = offsetProp in elem;
			if ( valueIsBorderBox ) {
				val = elem[ offsetProp ];
			}
		}
	
		// Normalize "" and auto
		val = parseFloat( val ) || 0;
	
		// Adjust for the element's box model
		return ( val +
			boxModelAdjustment(
				elem,
				dimension,
				extra || ( isBorderBox ? "border" : "content" ),
				valueIsBorderBox,
				styles,
	
				// Provide the current computed size to request scroll gutter calculation (gh-3589)
				val
			)
		) + "px";
	}
	
	jQuery.extend( {
	
		// Add in style property hooks for overriding the default
		// behavior of getting and setting a style property
		cssHooks: {
			opacity: {
				get: function( elem, computed ) {
					if ( computed ) {
	
						// We should always get a number back from opacity
						var ret = curCSS( elem, "opacity" );
						return ret === "" ? "1" : ret;
					}
				}
			}
		},
	
		// Don't automatically add "px" to these possibly-unitless properties
		cssNumber: {
			"animationIterationCount": true,
			"columnCount": true,
			"fillOpacity": true,
			"flexGrow": true,
			"flexShrink": true,
			"fontWeight": true,
			"gridArea": true,
			"gridColumn": true,
			"gridColumnEnd": true,
			"gridColumnStart": true,
			"gridRow": true,
			"gridRowEnd": true,
			"gridRowStart": true,
			"lineHeight": true,
			"opacity": true,
			"order": true,
			"orphans": true,
			"widows": true,
			"zIndex": true,
			"zoom": true
		},
	
		// Add in properties whose names you wish to fix before
		// setting or getting the value
		cssProps: {},
	
		// Get and set the style property on a DOM Node
		style: function( elem, name, value, extra ) {
	
			// Don't set styles on text and comment nodes
			if ( !elem || elem.nodeType === 3 || elem.nodeType === 8 || !elem.style ) {
				return;
			}
	
			// Make sure that we're working with the right name
			var ret, type, hooks,
				origName = camelCase( name ),
				isCustomProp = rcustomProp.test( name ),
				style = elem.style;
	
			// Make sure that we're working with the right name. We don't
			// want to query the value if it is a CSS custom property
			// since they are user-defined.
			if ( !isCustomProp ) {
				name = finalPropName( origName );
			}
	
			// Gets hook for the prefixed version, then unprefixed version
			hooks = jQuery.cssHooks[ name ] || jQuery.cssHooks[ origName ];
	
			// Check if we're setting a value
			if ( value !== undefined ) {
				type = typeof value;
	
				// Convert "+=" or "-=" to relative numbers (#7345)
				if ( type === "string" && ( ret = rcssNum.exec( value ) ) && ret[ 1 ] ) {
					value = adjustCSS( elem, name, ret );
	
					// Fixes bug #9237
					type = "number";
				}
	
				// Make sure that null and NaN values aren't set (#7116)
				if ( value == null || value !== value ) {
					return;
				}
	
				// If a number was passed in, add the unit (except for certain CSS properties)
				// The isCustomProp check can be removed in jQuery 4.0 when we only auto-append
				// "px" to a few hardcoded values.
				if ( type === "number" && !isCustomProp ) {
					value += ret && ret[ 3 ] || ( jQuery.cssNumber[ origName ] ? "" : "px" );
				}
	
				// background-* props affect original clone's values
				if ( !support.clearCloneStyle && value === "" && name.indexOf( "background" ) === 0 ) {
					style[ name ] = "inherit";
				}
	
				// If a hook was provided, use that value, otherwise just set the specified value
				if ( !hooks || !( "set" in hooks ) ||
					( value = hooks.set( elem, value, extra ) ) !== undefined ) {
	
					if ( isCustomProp ) {
						style.setProperty( name, value );
					} else {
						style[ name ] = value;
					}
				}
	
			} else {
	
				// If a hook was provided get the non-computed value from there
				if ( hooks && "get" in hooks &&
					( ret = hooks.get( elem, false, extra ) ) !== undefined ) {
	
					return ret;
				}
	
				// Otherwise just get the value from the style object
				return style[ name ];
			}
		},
	
		css: function( elem, name, extra, styles ) {
			var val, num, hooks,
				origName = camelCase( name ),
				isCustomProp = rcustomProp.test( name );
	
			// Make sure that we're working with the right name. We don't
			// want to modify the value if it is a CSS custom property
			// since they are user-defined.
			if ( !isCustomProp ) {
				name = finalPropName( origName );
			}
	
			// Try prefixed name followed by the unprefixed name
			hooks = jQuery.cssHooks[ name ] || jQuery.cssHooks[ origName ];
	
			// If a hook was provided get the computed value from there
			if ( hooks && "get" in hooks ) {
				val = hooks.get( elem, true, extra );
			}
	
			// Otherwise, if a way to get the computed value exists, use that
			if ( val === undefined ) {
				val = curCSS( elem, name, styles );
			}
	
			// Convert "normal" to computed value
			if ( val === "normal" && name in cssNormalTransform ) {
				val = cssNormalTransform[ name ];
			}
	
			// Make numeric if forced or a qualifier was provided and val looks numeric
			if ( extra === "" || extra ) {
				num = parseFloat( val );
				return extra === true || isFinite( num ) ? num || 0 : val;
			}
	
			return val;
		}
	} );
	
	jQuery.each( [ "height", "width" ], function( _i, dimension ) {
		jQuery.cssHooks[ dimension ] = {
			get: function( elem, computed, extra ) {
				if ( computed ) {
	
					// Certain elements can have dimension info if we invisibly show them
					// but it must have a current display style that would benefit
					return rdisplayswap.test( jQuery.css( elem, "display" ) ) &&
	
						// Support: Safari 8+
						// Table columns in Safari have non-zero offsetWidth & zero
						// getBoundingClientRect().width unless display is changed.
						// Support: IE <=11 only
						// Running getBoundingClientRect on a disconnected node
						// in IE throws an error.
						( !elem.getClientRects().length || !elem.getBoundingClientRect().width ) ?
						swap( elem, cssShow, function() {
							return getWidthOrHeight( elem, dimension, extra );
						} ) :
						getWidthOrHeight( elem, dimension, extra );
				}
			},
	
			set: function( elem, value, extra ) {
				var matches,
					styles = getStyles( elem ),
	
					// Only read styles.position if the test has a chance to fail
					// to avoid forcing a reflow.
					scrollboxSizeBuggy = !support.scrollboxSize() &&
						styles.position === "absolute",
	
					// To avoid forcing a reflow, only fetch boxSizing if we need it (gh-3991)
					boxSizingNeeded = scrollboxSizeBuggy || extra,
					isBorderBox = boxSizingNeeded &&
						jQuery.css( elem, "boxSizing", false, styles ) === "border-box",
					subtract = extra ?
						boxModelAdjustment(
							elem,
							dimension,
							extra,
							isBorderBox,
							styles
						) :
						0;
	
				// Account for unreliable border-box dimensions by comparing offset* to computed and
				// faking a content-box to get border and padding (gh-3699)
				if ( isBorderBox && scrollboxSizeBuggy ) {
					subtract -= Math.ceil(
						elem[ "offset" + dimension[ 0 ].toUpperCase() + dimension.slice( 1 ) ] -
						parseFloat( styles[ dimension ] ) -
						boxModelAdjustment( elem, dimension, "border", false, styles ) -
						0.5
					);
				}
	
				// Convert to pixels if value adjustment is needed
				if ( subtract && ( matches = rcssNum.exec( value ) ) &&
					( matches[ 3 ] || "px" ) !== "px" ) {
	
					elem.style[ dimension ] = value;
					value = jQuery.css( elem, dimension );
				}
	
				return setPositiveNumber( elem, value, subtract );
			}
		};
	} );
	
	jQuery.cssHooks.marginLeft = addGetHookIf( support.reliableMarginLeft,
		function( elem, computed ) {
			if ( computed ) {
				return ( parseFloat( curCSS( elem, "marginLeft" ) ) ||
					elem.getBoundingClientRect().left -
						swap( elem, { marginLeft: 0 }, function() {
							return elem.getBoundingClientRect().left;
						} )
				) + "px";
			}
		}
	);
	
	// These hooks are used by animate to expand properties
	jQuery.each( {
		margin: "",
		padding: "",
		border: "Width"
	}, function( prefix, suffix ) {
		jQuery.cssHooks[ prefix + suffix ] = {
			expand: function( value ) {
				var i = 0,
					expanded = {},
	
					// Assumes a single number if not a string
					parts = typeof value === "string" ? value.split( " " ) : [ value ];
	
				for ( ; i < 4; i++ ) {
					expanded[ prefix + cssExpand[ i ] + suffix ] =
						parts[ i ] || parts[ i - 2 ] || parts[ 0 ];
				}
	
				return expanded;
			}
		};
	
		if ( prefix !== "margin" ) {
			jQuery.cssHooks[ prefix + suffix ].set = setPositiveNumber;
		}
	} );
	
	jQuery.fn.extend( {
		css: function( name, value ) {
			return access( this, function( elem, name, value ) {
				var styles, len,
					map = {},
					i = 0;
	
				if ( Array.isArray( name ) ) {
					styles = getStyles( elem );
					len = name.length;
	
					for ( ; i < len; i++ ) {
						map[ name[ i ] ] = jQuery.css( elem, name[ i ], false, styles );
					}
	
					return map;
				}
	
				return value !== undefined ?
					jQuery.style( elem, name, value ) :
					jQuery.css( elem, name );
			}, name, value, arguments.length > 1 );
		}
	} );
	
	
	function Tween( elem, options, prop, end, easing ) {
		return new Tween.prototype.init( elem, options, prop, end, easing );
	}
	jQuery.Tween = Tween;
	
	Tween.prototype = {
		constructor: Tween,
		init: function( elem, options, prop, end, easing, unit ) {
			this.elem = elem;
			this.prop = prop;
			this.easing = easing || jQuery.easing._default;
			this.options = options;
			this.start = this.now = this.cur();
			this.end = end;
			this.unit = unit || ( jQuery.cssNumber[ prop ] ? "" : "px" );
		},
		cur: function() {
			var hooks = Tween.propHooks[ this.prop ];
	
			return hooks && hooks.get ?
				hooks.get( this ) :
				Tween.propHooks._default.get( this );
		},
		run: function( percent ) {
			var eased,
				hooks = Tween.propHooks[ this.prop ];
	
			if ( this.options.duration ) {
				this.pos = eased = jQuery.easing[ this.easing ](
					percent, this.options.duration * percent, 0, 1, this.options.duration
				);
			} else {
				this.pos = eased = percent;
			}
			this.now = ( this.end - this.start ) * eased + this.start;
	
			if ( this.options.step ) {
				this.options.step.call( this.elem, this.now, this );
			}
	
			if ( hooks && hooks.set ) {
				hooks.set( this );
			} else {
				Tween.propHooks._default.set( this );
			}
			return this;
		}
	};
	
	Tween.prototype.init.prototype = Tween.prototype;
	
	Tween.propHooks = {
		_default: {
			get: function( tween ) {
				var result;
	
				// Use a property on the element directly when it is not a DOM element,
				// or when there is no matching style property that exists.
				if ( tween.elem.nodeType !== 1 ||
					tween.elem[ tween.prop ] != null && tween.elem.style[ tween.prop ] == null ) {
					return tween.elem[ tween.prop ];
				}
	
				// Passing an empty string as a 3rd parameter to .css will automatically
				// attempt a parseFloat and fallback to a string if the parse fails.
				// Simple values such as "10px" are parsed to Float;
				// complex values such as "rotate(1rad)" are returned as-is.
				result = jQuery.css( tween.elem, tween.prop, "" );
	
				// Empty strings, null, undefined and "auto" are converted to 0.
				return !result || result === "auto" ? 0 : result;
			},
			set: function( tween ) {
	
				// Use step hook for back compat.
				// Use cssHook if its there.
				// Use .style if available and use plain properties where available.
				if ( jQuery.fx.step[ tween.prop ] ) {
					jQuery.fx.step[ tween.prop ]( tween );
				} else if ( tween.elem.nodeType === 1 && (
					jQuery.cssHooks[ tween.prop ] ||
						tween.elem.style[ finalPropName( tween.prop ) ] != null ) ) {
					jQuery.style( tween.elem, tween.prop, tween.now + tween.unit );
				} else {
					tween.elem[ tween.prop ] = tween.now;
				}
			}
		}
	};
	
	// Support: IE <=9 only
	// Panic based approach to setting things on disconnected nodes
	Tween.propHooks.scrollTop = Tween.propHooks.scrollLeft = {
		set: function( tween ) {
			if ( tween.elem.nodeType && tween.elem.parentNode ) {
				tween.elem[ tween.prop ] = tween.now;
			}
		}
	};
	
	jQuery.easing = {
		linear: function( p ) {
			return p;
		},
		swing: function( p ) {
			return 0.5 - Math.cos( p * Math.PI ) / 2;
		},
		_default: "swing"
	};
	
	jQuery.fx = Tween.prototype.init;
	
	// Back compat <1.8 extension point
	jQuery.fx.step = {};
	
	
	
	
	var
		fxNow, inProgress,
		rfxtypes = /^(?:toggle|show|hide)$/,
		rrun = /queueHooks$/;
	
	function schedule() {
		if ( inProgress ) {
			if ( document.hidden === false && window.requestAnimationFrame ) {
				window.requestAnimationFrame( schedule );
			} else {
				window.setTimeout( schedule, jQuery.fx.interval );
			}
	
			jQuery.fx.tick();
		}
	}
	
	// Animations created synchronously will run synchronously
	function createFxNow() {
		window.setTimeout( function() {
			fxNow = undefined;
		} );
		return ( fxNow = Date.now() );
	}
	
	// Generate parameters to create a standard animation
	function genFx( type, includeWidth ) {
		var which,
			i = 0,
			attrs = { height: type };
	
		// If we include width, step value is 1 to do all cssExpand values,
		// otherwise step value is 2 to skip over Left and Right
		includeWidth = includeWidth ? 1 : 0;
		for ( ; i < 4; i += 2 - includeWidth ) {
			which = cssExpand[ i ];
			attrs[ "margin" + which ] = attrs[ "padding" + which ] = type;
		}
	
		if ( includeWidth ) {
			attrs.opacity = attrs.width = type;
		}
	
		return attrs;
	}
	
	function createTween( value, prop, animation ) {
		var tween,
			collection = ( Animation.tweeners[ prop ] || [] ).concat( Animation.tweeners[ "*" ] ),
			index = 0,
			length = collection.length;
		for ( ; index < length; index++ ) {
			if ( ( tween = collection[ index ].call( animation, prop, value ) ) ) {
	
				// We're done with this property
				return tween;
			}
		}
	}
	
	function defaultPrefilter( elem, props, opts ) {
		var prop, value, toggle, hooks, oldfire, propTween, restoreDisplay, display,
			isBox = "width" in props || "height" in props,
			anim = this,
			orig = {},
			style = elem.style,
			hidden = elem.nodeType && isHiddenWithinTree( elem ),
			dataShow = dataPriv.get( elem, "fxshow" );
	
		// Queue-skipping animations hijack the fx hooks
		if ( !opts.queue ) {
			hooks = jQuery._queueHooks( elem, "fx" );
			if ( hooks.unqueued == null ) {
				hooks.unqueued = 0;
				oldfire = hooks.empty.fire;
				hooks.empty.fire = function() {
					if ( !hooks.unqueued ) {
						oldfire();
					}
				};
			}
			hooks.unqueued++;
	
			anim.always( function() {
	
				// Ensure the complete handler is called before this completes
				anim.always( function() {
					hooks.unqueued--;
					if ( !jQuery.queue( elem, "fx" ).length ) {
						hooks.empty.fire();
					}
				} );
			} );
		}
	
		// Detect show/hide animations
		for ( prop in props ) {
			value = props[ prop ];
			if ( rfxtypes.test( value ) ) {
				delete props[ prop ];
				toggle = toggle || value === "toggle";
				if ( value === ( hidden ? "hide" : "show" ) ) {
	
					// Pretend to be hidden if this is a "show" and
					// there is still data from a stopped show/hide
					if ( value === "show" && dataShow && dataShow[ prop ] !== undefined ) {
						hidden = true;
	
					// Ignore all other no-op show/hide data
					} else {
						continue;
					}
				}
				orig[ prop ] = dataShow && dataShow[ prop ] || jQuery.style( elem, prop );
			}
		}
	
		// Bail out if this is a no-op like .hide().hide()
		propTween = !jQuery.isEmptyObject( props );
		if ( !propTween && jQuery.isEmptyObject( orig ) ) {
			return;
		}
	
		// Restrict "overflow" and "display" styles during box animations
		if ( isBox && elem.nodeType === 1 ) {
	
			// Support: IE <=9 - 11, Edge 12 - 15
			// Record all 3 overflow attributes because IE does not infer the shorthand
			// from identically-valued overflowX and overflowY and Edge just mirrors
			// the overflowX value there.
			opts.overflow = [ style.overflow, style.overflowX, style.overflowY ];
	
			// Identify a display type, preferring old show/hide data over the CSS cascade
			restoreDisplay = dataShow && dataShow.display;
			if ( restoreDisplay == null ) {
				restoreDisplay = dataPriv.get( elem, "display" );
			}
			display = jQuery.css( elem, "display" );
			if ( display === "none" ) {
				if ( restoreDisplay ) {
					display = restoreDisplay;
				} else {
	
					// Get nonempty value(s) by temporarily forcing visibility
					showHide( [ elem ], true );
					restoreDisplay = elem.style.display || restoreDisplay;
					display = jQuery.css( elem, "display" );
					showHide( [ elem ] );
				}
			}
	
			// Animate inline elements as inline-block
			if ( display === "inline" || display === "inline-block" && restoreDisplay != null ) {
				if ( jQuery.css( elem, "float" ) === "none" ) {
	
					// Restore the original display value at the end of pure show/hide animations
					if ( !propTween ) {
						anim.done( function() {
							style.display = restoreDisplay;
						} );
						if ( restoreDisplay == null ) {
							display = style.display;
							restoreDisplay = display === "none" ? "" : display;
						}
					}
					style.display = "inline-block";
				}
			}
		}
	
		if ( opts.overflow ) {
			style.overflow = "hidden";
			anim.always( function() {
				style.overflow = opts.overflow[ 0 ];
				style.overflowX = opts.overflow[ 1 ];
				style.overflowY = opts.overflow[ 2 ];
			} );
		}
	
		// Implement show/hide animations
		propTween = false;
		for ( prop in orig ) {
	
			// General show/hide setup for this element animation
			if ( !propTween ) {
				if ( dataShow ) {
					if ( "hidden" in dataShow ) {
						hidden = dataShow.hidden;
					}
				} else {
					dataShow = dataPriv.access( elem, "fxshow", { display: restoreDisplay } );
				}
	
				// Store hidden/visible for toggle so `.stop().toggle()` "reverses"
				if ( toggle ) {
					dataShow.hidden = !hidden;
				}
	
				// Show elements before animating them
				if ( hidden ) {
					showHide( [ elem ], true );
				}
	
				/* eslint-disable no-loop-func */
	
				anim.done( function() {
	
					/* eslint-enable no-loop-func */
	
					// The final step of a "hide" animation is actually hiding the element
					if ( !hidden ) {
						showHide( [ elem ] );
					}
					dataPriv.remove( elem, "fxshow" );
					for ( prop in orig ) {
						jQuery.style( elem, prop, orig[ prop ] );
					}
				} );
			}
	
			// Per-property setup
			propTween = createTween( hidden ? dataShow[ prop ] : 0, prop, anim );
			if ( !( prop in dataShow ) ) {
				dataShow[ prop ] = propTween.start;
				if ( hidden ) {
					propTween.end = propTween.start;
					propTween.start = 0;
				}
			}
		}
	}
	
	function propFilter( props, specialEasing ) {
		var index, name, easing, value, hooks;
	
		// camelCase, specialEasing and expand cssHook pass
		for ( index in props ) {
			name = camelCase( index );
			easing = specialEasing[ name ];
			value = props[ index ];
			if ( Array.isArray( value ) ) {
				easing = value[ 1 ];
				value = props[ index ] = value[ 0 ];
			}
	
			if ( index !== name ) {
				props[ name ] = value;
				delete props[ index ];
			}
	
			hooks = jQuery.cssHooks[ name ];
			if ( hooks && "expand" in hooks ) {
				value = hooks.expand( value );
				delete props[ name ];
	
				// Not quite $.extend, this won't overwrite existing keys.
				// Reusing 'index' because we have the correct "name"
				for ( index in value ) {
					if ( !( index in props ) ) {
						props[ index ] = value[ index ];
						specialEasing[ index ] = easing;
					}
				}
			} else {
				specialEasing[ name ] = easing;
			}
		}
	}
	
	function Animation( elem, properties, options ) {
		var result,
			stopped,
			index = 0,
			length = Animation.prefilters.length,
			deferred = jQuery.Deferred().always( function() {
	
				// Don't match elem in the :animated selector
				delete tick.elem;
			} ),
			tick = function() {
				if ( stopped ) {
					return false;
				}
				var currentTime = fxNow || createFxNow(),
					remaining = Math.max( 0, animation.startTime + animation.duration - currentTime ),
	
					// Support: Android 2.3 only
					// Archaic crash bug won't allow us to use `1 - ( 0.5 || 0 )` (#12497)
					temp = remaining / animation.duration || 0,
					percent = 1 - temp,
					index = 0,
					length = animation.tweens.length;
	
				for ( ; index < length; index++ ) {
					animation.tweens[ index ].run( percent );
				}
	
				deferred.notifyWith( elem, [ animation, percent, remaining ] );
	
				// If there's more to do, yield
				if ( percent < 1 && length ) {
					return remaining;
				}
	
				// If this was an empty animation, synthesize a final progress notification
				if ( !length ) {
					deferred.notifyWith( elem, [ animation, 1, 0 ] );
				}
	
				// Resolve the animation and report its conclusion
				deferred.resolveWith( elem, [ animation ] );
				return false;
			},
			animation = deferred.promise( {
				elem: elem,
				props: jQuery.extend( {}, properties ),
				opts: jQuery.extend( true, {
					specialEasing: {},
					easing: jQuery.easing._default
				}, options ),
				originalProperties: properties,
				originalOptions: options,
				startTime: fxNow || createFxNow(),
				duration: options.duration,
				tweens: [],
				createTween: function( prop, end ) {
					var tween = jQuery.Tween( elem, animation.opts, prop, end,
						animation.opts.specialEasing[ prop ] || animation.opts.easing );
					animation.tweens.push( tween );
					return tween;
				},
				stop: function( gotoEnd ) {
					var index = 0,
	
						// If we are going to the end, we want to run all the tweens
						// otherwise we skip this part
						length = gotoEnd ? animation.tweens.length : 0;
					if ( stopped ) {
						return this;
					}
					stopped = true;
					for ( ; index < length; index++ ) {
						animation.tweens[ index ].run( 1 );
					}
	
					// Resolve when we played the last frame; otherwise, reject
					if ( gotoEnd ) {
						deferred.notifyWith( elem, [ animation, 1, 0 ] );
						deferred.resolveWith( elem, [ animation, gotoEnd ] );
					} else {
						deferred.rejectWith( elem, [ animation, gotoEnd ] );
					}
					return this;
				}
			} ),
			props = animation.props;
	
		propFilter( props, animation.opts.specialEasing );
	
		for ( ; index < length; index++ ) {
			result = Animation.prefilters[ index ].call( animation, elem, props, animation.opts );
			if ( result ) {
				if ( isFunction( result.stop ) ) {
					jQuery._queueHooks( animation.elem, animation.opts.queue ).stop =
						result.stop.bind( result );
				}
				return result;
			}
		}
	
		jQuery.map( props, createTween, animation );
	
		if ( isFunction( animation.opts.start ) ) {
			animation.opts.start.call( elem, animation );
		}
	
		// Attach callbacks from options
		animation
			.progress( animation.opts.progress )
			.done( animation.opts.done, animation.opts.complete )
			.fail( animation.opts.fail )
			.always( animation.opts.always );
	
		jQuery.fx.timer(
			jQuery.extend( tick, {
				elem: elem,
				anim: animation,
				queue: animation.opts.queue
			} )
		);
	
		return animation;
	}
	
	jQuery.Animation = jQuery.extend( Animation, {
	
		tweeners: {
			"*": [ function( prop, value ) {
				var tween = this.createTween( prop, value );
				adjustCSS( tween.elem, prop, rcssNum.exec( value ), tween );
				return tween;
			} ]
		},
	
		tweener: function( props, callback ) {
			if ( isFunction( props ) ) {
				callback = props;
				props = [ "*" ];
			} else {
				props = props.match( rnothtmlwhite );
			}
	
			var prop,
				index = 0,
				length = props.length;
	
			for ( ; index < length; index++ ) {
				prop = props[ index ];
				Animation.tweeners[ prop ] = Animation.tweeners[ prop ] || [];
				Animation.tweeners[ prop ].unshift( callback );
			}
		},
	
		prefilters: [ defaultPrefilter ],
	
		prefilter: function( callback, prepend ) {
			if ( prepend ) {
				Animation.prefilters.unshift( callback );
			} else {
				Animation.prefilters.push( callback );
			}
		}
	} );
	
	jQuery.speed = function( speed, easing, fn ) {
		var opt = speed && typeof speed === "object" ? jQuery.extend( {}, speed ) : {
			complete: fn || !fn && easing ||
				isFunction( speed ) && speed,
			duration: speed,
			easing: fn && easing || easing && !isFunction( easing ) && easing
		};
	
		// Go to the end state if fx are off
		if ( jQuery.fx.off ) {
			opt.duration = 0;
	
		} else {
			if ( typeof opt.duration !== "number" ) {
				if ( opt.duration in jQuery.fx.speeds ) {
					opt.duration = jQuery.fx.speeds[ opt.duration ];
	
				} else {
					opt.duration = jQuery.fx.speeds._default;
				}
			}
		}
	
		// Normalize opt.queue - true/undefined/null -> "fx"
		if ( opt.queue == null || opt.queue === true ) {
			opt.queue = "fx";
		}
	
		// Queueing
		opt.old = opt.complete;
	
		opt.complete = function() {
			if ( isFunction( opt.old ) ) {
				opt.old.call( this );
			}
	
			if ( opt.queue ) {
				jQuery.dequeue( this, opt.queue );
			}
		};
	
		return opt;
	};
	
	jQuery.fn.extend( {
		fadeTo: function( speed, to, easing, callback ) {
	
			// Show any hidden elements after setting opacity to 0
			return this.filter( isHiddenWithinTree ).css( "opacity", 0 ).show()
	
				// Animate to the value specified
				.end().animate( { opacity: to }, speed, easing, callback );
		},
		animate: function( prop, speed, easing, callback ) {
			var empty = jQuery.isEmptyObject( prop ),
				optall = jQuery.speed( speed, easing, callback ),
				doAnimation = function() {
	
					// Operate on a copy of prop so per-property easing won't be lost
					var anim = Animation( this, jQuery.extend( {}, prop ), optall );
	
					// Empty animations, or finishing resolves immediately
					if ( empty || dataPriv.get( this, "finish" ) ) {
						anim.stop( true );
					}
				};
	
			doAnimation.finish = doAnimation;
	
			return empty || optall.queue === false ?
				this.each( doAnimation ) :
				this.queue( optall.queue, doAnimation );
		},
		stop: function( type, clearQueue, gotoEnd ) {
			var stopQueue = function( hooks ) {
				var stop = hooks.stop;
				delete hooks.stop;
				stop( gotoEnd );
			};
	
			if ( typeof type !== "string" ) {
				gotoEnd = clearQueue;
				clearQueue = type;
				type = undefined;
			}
			if ( clearQueue ) {
				this.queue( type || "fx", [] );
			}
	
			return this.each( function() {
				var dequeue = true,
					index = type != null && type + "queueHooks",
					timers = jQuery.timers,
					data = dataPriv.get( this );
	
				if ( index ) {
					if ( data[ index ] && data[ index ].stop ) {
						stopQueue( data[ index ] );
					}
				} else {
					for ( index in data ) {
						if ( data[ index ] && data[ index ].stop && rrun.test( index ) ) {
							stopQueue( data[ index ] );
						}
					}
				}
	
				for ( index = timers.length; index--; ) {
					if ( timers[ index ].elem === this &&
						( type == null || timers[ index ].queue === type ) ) {
	
						timers[ index ].anim.stop( gotoEnd );
						dequeue = false;
						timers.splice( index, 1 );
					}
				}
	
				// Start the next in the queue if the last step wasn't forced.
				// Timers currently will call their complete callbacks, which
				// will dequeue but only if they were gotoEnd.
				if ( dequeue || !gotoEnd ) {
					jQuery.dequeue( this, type );
				}
			} );
		},
		finish: function( type ) {
			if ( type !== false ) {
				type = type || "fx";
			}
			return this.each( function() {
				var index,
					data = dataPriv.get( this ),
					queue = data[ type + "queue" ],
					hooks = data[ type + "queueHooks" ],
					timers = jQuery.timers,
					length = queue ? queue.length : 0;
	
				// Enable finishing flag on private data
				data.finish = true;
	
				// Empty the queue first
				jQuery.queue( this, type, [] );
	
				if ( hooks && hooks.stop ) {
					hooks.stop.call( this, true );
				}
	
				// Look for any active animations, and finish them
				for ( index = timers.length; index--; ) {
					if ( timers[ index ].elem === this && timers[ index ].queue === type ) {
						timers[ index ].anim.stop( true );
						timers.splice( index, 1 );
					}
				}
	
				// Look for any animations in the old queue and finish them
				for ( index = 0; index < length; index++ ) {
					if ( queue[ index ] && queue[ index ].finish ) {
						queue[ index ].finish.call( this );
					}
				}
	
				// Turn off finishing flag
				delete data.finish;
			} );
		}
	} );
	
	jQuery.each( [ "toggle", "show", "hide" ], function( _i, name ) {
		var cssFn = jQuery.fn[ name ];
		jQuery.fn[ name ] = function( speed, easing, callback ) {
			return speed == null || typeof speed === "boolean" ?
				cssFn.apply( this, arguments ) :
				this.animate( genFx( name, true ), speed, easing, callback );
		};
	} );
	
	// Generate shortcuts for custom animations
	jQuery.each( {
		slideDown: genFx( "show" ),
		slideUp: genFx( "hide" ),
		slideToggle: genFx( "toggle" ),
		fadeIn: { opacity: "show" },
		fadeOut: { opacity: "hide" },
		fadeToggle: { opacity: "toggle" }
	}, function( name, props ) {
		jQuery.fn[ name ] = function( speed, easing, callback ) {
			return this.animate( props, speed, easing, callback );
		};
	} );
	
	jQuery.timers = [];
	jQuery.fx.tick = function() {
		var timer,
			i = 0,
			timers = jQuery.timers;
	
		fxNow = Date.now();
	
		for ( ; i < timers.length; i++ ) {
			timer = timers[ i ];
	
			// Run the timer and safely remove it when done (allowing for external removal)
			if ( !timer() && timers[ i ] === timer ) {
				timers.splice( i--, 1 );
			}
		}
	
		if ( !timers.length ) {
			jQuery.fx.stop();
		}
		fxNow = undefined;
	};
	
	jQuery.fx.timer = function( timer ) {
		jQuery.timers.push( timer );
		jQuery.fx.start();
	};
	
	jQuery.fx.interval = 13;
	jQuery.fx.start = function() {
		if ( inProgress ) {
			return;
		}
	
		inProgress = true;
		schedule();
	};
	
	jQuery.fx.stop = function() {
		inProgress = null;
	};
	
	jQuery.fx.speeds = {
		slow: 600,
		fast: 200,
	
		// Default speed
		_default: 400
	};
	
	
	// Based off of the plugin by Clint Helfers, with permission.
	// https://web.archive.org/web/20100324014747/http://blindsignals.com/index.php/2009/07/jquery-delay/
	jQuery.fn.delay = function( time, type ) {
		time = jQuery.fx ? jQuery.fx.speeds[ time ] || time : time;
		type = type || "fx";
	
		return this.queue( type, function( next, hooks ) {
			var timeout = window.setTimeout( next, time );
			hooks.stop = function() {
				window.clearTimeout( timeout );
			};
		} );
	};
	
	
	( function() {
		var input = document.createElement( "input" ),
			select = document.createElement( "select" ),
			opt = select.appendChild( document.createElement( "option" ) );
	
		input.type = "checkbox";
	
		// Support: Android <=4.3 only
		// Default value for a checkbox should be "on"
		support.checkOn = input.value !== "";
	
		// Support: IE <=11 only
		// Must access selectedIndex to make default options select
		support.optSelected = opt.selected;
	
		// Support: IE <=11 only
		// An input loses its value after becoming a radio
		input = document.createElement( "input" );
		input.value = "t";
		input.type = "radio";
		support.radioValue = input.value === "t";
	} )();
	
	
	var boolHook,
		attrHandle = jQuery.expr.attrHandle;
	
	jQuery.fn.extend( {
		attr: function( name, value ) {
			return access( this, jQuery.attr, name, value, arguments.length > 1 );
		},
	
		removeAttr: function( name ) {
			return this.each( function() {
				jQuery.removeAttr( this, name );
			} );
		}
	} );
	
	jQuery.extend( {
		attr: function( elem, name, value ) {
			var ret, hooks,
				nType = elem.nodeType;
	
			// Don't get/set attributes on text, comment and attribute nodes
			if ( nType === 3 || nType === 8 || nType === 2 ) {
				return;
			}
	
			// Fallback to prop when attributes are not supported
			if ( typeof elem.getAttribute === "undefined" ) {
				return jQuery.prop( elem, name, value );
			}
	
			// Attribute hooks are determined by the lowercase version
			// Grab necessary hook if one is defined
			if ( nType !== 1 || !jQuery.isXMLDoc( elem ) ) {
				hooks = jQuery.attrHooks[ name.toLowerCase() ] ||
					( jQuery.expr.match.bool.test( name ) ? boolHook : undefined );
			}
	
			if ( value !== undefined ) {
				if ( value === null ) {
					jQuery.removeAttr( elem, name );
					return;
				}
	
				if ( hooks && "set" in hooks &&
					( ret = hooks.set( elem, value, name ) ) !== undefined ) {
					return ret;
				}
	
				elem.setAttribute( name, value + "" );
				return value;
			}
	
			if ( hooks && "get" in hooks && ( ret = hooks.get( elem, name ) ) !== null ) {
				return ret;
			}
	
			ret = jQuery.find.attr( elem, name );
	
			// Non-existent attributes return null, we normalize to undefined
			return ret == null ? undefined : ret;
		},
	
		attrHooks: {
			type: {
				set: function( elem, value ) {
					if ( !support.radioValue && value === "radio" &&
						nodeName( elem, "input" ) ) {
						var val = elem.value;
						elem.setAttribute( "type", value );
						if ( val ) {
							elem.value = val;
						}
						return value;
					}
				}
			}
		},
	
		removeAttr: function( elem, value ) {
			var name,
				i = 0,
	
				// Attribute names can contain non-HTML whitespace characters
				// https://html.spec.whatwg.org/multipage/syntax.html#attributes-2
				attrNames = value && value.match( rnothtmlwhite );
	
			if ( attrNames && elem.nodeType === 1 ) {
				while ( ( name = attrNames[ i++ ] ) ) {
					elem.removeAttribute( name );
				}
			}
		}
	} );
	
	// Hooks for boolean attributes
	boolHook = {
		set: function( elem, value, name ) {
			if ( value === false ) {
	
				// Remove boolean attributes when set to false
				jQuery.removeAttr( elem, name );
			} else {
				elem.setAttribute( name, name );
			}
			return name;
		}
	};
	
	jQuery.each( jQuery.expr.match.bool.source.match( /\w+/g ), function( _i, name ) {
		var getter = attrHandle[ name ] || jQuery.find.attr;
	
		attrHandle[ name ] = function( elem, name, isXML ) {
			var ret, handle,
				lowercaseName = name.toLowerCase();
	
			if ( !isXML ) {
	
				// Avoid an infinite loop by temporarily removing this function from the getter
				handle = attrHandle[ lowercaseName ];
				attrHandle[ lowercaseName ] = ret;
				ret = getter( elem, name, isXML ) != null ?
					lowercaseName :
					null;
				attrHandle[ lowercaseName ] = handle;
			}
			return ret;
		};
	} );
	
	
	
	
	var rfocusable = /^(?:input|select|textarea|button)$/i,
		rclickable = /^(?:a|area)$/i;
	
	jQuery.fn.extend( {
		prop: function( name, value ) {
			return access( this, jQuery.prop, name, value, arguments.length > 1 );
		},
	
		removeProp: function( name ) {
			return this.each( function() {
				delete this[ jQuery.propFix[ name ] || name ];
			} );
		}
	} );
	
	jQuery.extend( {
		prop: function( elem, name, value ) {
			var ret, hooks,
				nType = elem.nodeType;
	
			// Don't get/set properties on text, comment and attribute nodes
			if ( nType === 3 || nType === 8 || nType === 2 ) {
				return;
			}
	
			if ( nType !== 1 || !jQuery.isXMLDoc( elem ) ) {
	
				// Fix name and attach hooks
				name = jQuery.propFix[ name ] || name;
				hooks = jQuery.propHooks[ name ];
			}
	
			if ( value !== undefined ) {
				if ( hooks && "set" in hooks &&
					( ret = hooks.set( elem, value, name ) ) !== undefined ) {
					return ret;
				}
	
				return ( elem[ name ] = value );
			}
	
			if ( hooks && "get" in hooks && ( ret = hooks.get( elem, name ) ) !== null ) {
				return ret;
			}
	
			return elem[ name ];
		},
	
		propHooks: {
			tabIndex: {
				get: function( elem ) {
	
					// Support: IE <=9 - 11 only
					// elem.tabIndex doesn't always return the
					// correct value when it hasn't been explicitly set
					// https://web.archive.org/web/20141116233347/http://fluidproject.org/blog/2008/01/09/getting-setting-and-removing-tabindex-values-with-javascript/
					// Use proper attribute retrieval(#12072)
					var tabindex = jQuery.find.attr( elem, "tabindex" );
	
					if ( tabindex ) {
						return parseInt( tabindex, 10 );
					}
	
					if (
						rfocusable.test( elem.nodeName ) ||
						rclickable.test( elem.nodeName ) &&
						elem.href
					) {
						return 0;
					}
	
					return -1;
				}
			}
		},
	
		propFix: {
			"for": "htmlFor",
			"class": "className"
		}
	} );
	
	// Support: IE <=11 only
	// Accessing the selectedIndex property
	// forces the browser to respect setting selected
	// on the option
	// The getter ensures a default option is selected
	// when in an optgroup
	// eslint rule "no-unused-expressions" is disabled for this code
	// since it considers such accessions noop
	if ( !support.optSelected ) {
		jQuery.propHooks.selected = {
			get: function( elem ) {
	
				/* eslint no-unused-expressions: "off" */
	
				var parent = elem.parentNode;
				if ( parent && parent.parentNode ) {
					parent.parentNode.selectedIndex;
				}
				return null;
			},
			set: function( elem ) {
	
				/* eslint no-unused-expressions: "off" */
	
				var parent = elem.parentNode;
				if ( parent ) {
					parent.selectedIndex;
	
					if ( parent.parentNode ) {
						parent.parentNode.selectedIndex;
					}
				}
			}
		};
	}
	
	jQuery.each( [
		"tabIndex",
		"readOnly",
		"maxLength",
		"cellSpacing",
		"cellPadding",
		"rowSpan",
		"colSpan",
		"useMap",
		"frameBorder",
		"contentEditable"
	], function() {
		jQuery.propFix[ this.toLowerCase() ] = this;
	} );
	
	
	
	
		// Strip and collapse whitespace according to HTML spec
		// https://infra.spec.whatwg.org/#strip-and-collapse-ascii-whitespace
		function stripAndCollapse( value ) {
			var tokens = value.match( rnothtmlwhite ) || [];
			return tokens.join( " " );
		}
	
	
	function getClass( elem ) {
		return elem.getAttribute && elem.getAttribute( "class" ) || "";
	}
	
	function classesToArray( value ) {
		if ( Array.isArray( value ) ) {
			return value;
		}
		if ( typeof value === "string" ) {
			return value.match( rnothtmlwhite ) || [];
		}
		return [];
	}
	
	jQuery.fn.extend( {
		addClass: function( value ) {
			var classes, elem, cur, curValue, clazz, j, finalValue,
				i = 0;
	
			if ( isFunction( value ) ) {
				return this.each( function( j ) {
					jQuery( this ).addClass( value.call( this, j, getClass( this ) ) );
				} );
			}
	
			classes = classesToArray( value );
	
			if ( classes.length ) {
				while ( ( elem = this[ i++ ] ) ) {
					curValue = getClass( elem );
					cur = elem.nodeType === 1 && ( " " + stripAndCollapse( curValue ) + " " );
	
					if ( cur ) {
						j = 0;
						while ( ( clazz = classes[ j++ ] ) ) {
							if ( cur.indexOf( " " + clazz + " " ) < 0 ) {
								cur += clazz + " ";
							}
						}
	
						// Only assign if different to avoid unneeded rendering.
						finalValue = stripAndCollapse( cur );
						if ( curValue !== finalValue ) {
							elem.setAttribute( "class", finalValue );
						}
					}
				}
			}
	
			return this;
		},
	
		removeClass: function( value ) {
			var classes, elem, cur, curValue, clazz, j, finalValue,
				i = 0;
	
			if ( isFunction( value ) ) {
				return this.each( function( j ) {
					jQuery( this ).removeClass( value.call( this, j, getClass( this ) ) );
				} );
			}
	
			if ( !arguments.length ) {
				return this.attr( "class", "" );
			}
	
			classes = classesToArray( value );
	
			if ( classes.length ) {
				while ( ( elem = this[ i++ ] ) ) {
					curValue = getClass( elem );
	
					// This expression is here for better compressibility (see addClass)
					cur = elem.nodeType === 1 && ( " " + stripAndCollapse( curValue ) + " " );
	
					if ( cur ) {
						j = 0;
						while ( ( clazz = classes[ j++ ] ) ) {
	
							// Remove *all* instances
							while ( cur.indexOf( " " + clazz + " " ) > -1 ) {
								cur = cur.replace( " " + clazz + " ", " " );
							}
						}
	
						// Only assign if different to avoid unneeded rendering.
						finalValue = stripAndCollapse( cur );
						if ( curValue !== finalValue ) {
							elem.setAttribute( "class", finalValue );
						}
					}
				}
			}
	
			return this;
		},
	
		toggleClass: function( value, stateVal ) {
			var type = typeof value,
				isValidValue = type === "string" || Array.isArray( value );
	
			if ( typeof stateVal === "boolean" && isValidValue ) {
				return stateVal ? this.addClass( value ) : this.removeClass( value );
			}
	
			if ( isFunction( value ) ) {
				return this.each( function( i ) {
					jQuery( this ).toggleClass(
						value.call( this, i, getClass( this ), stateVal ),
						stateVal
					);
				} );
			}
	
			return this.each( function() {
				var className, i, self, classNames;
	
				if ( isValidValue ) {
	
					// Toggle individual class names
					i = 0;
					self = jQuery( this );
					classNames = classesToArray( value );
	
					while ( ( className = classNames[ i++ ] ) ) {
	
						// Check each className given, space separated list
						if ( self.hasClass( className ) ) {
							self.removeClass( className );
						} else {
							self.addClass( className );
						}
					}
	
				// Toggle whole class name
				} else if ( value === undefined || type === "boolean" ) {
					className = getClass( this );
					if ( className ) {
	
						// Store className if set
						dataPriv.set( this, "__className__", className );
					}
	
					// If the element has a class name or if we're passed `false`,
					// then remove the whole classname (if there was one, the above saved it).
					// Otherwise bring back whatever was previously saved (if anything),
					// falling back to the empty string if nothing was stored.
					if ( this.setAttribute ) {
						this.setAttribute( "class",
							className || value === false ?
								"" :
								dataPriv.get( this, "__className__" ) || ""
						);
					}
				}
			} );
		},
	
		hasClass: function( selector ) {
			var className, elem,
				i = 0;
	
			className = " " + selector + " ";
			while ( ( elem = this[ i++ ] ) ) {
				if ( elem.nodeType === 1 &&
					( " " + stripAndCollapse( getClass( elem ) ) + " " ).indexOf( className ) > -1 ) {
					return true;
				}
			}
	
			return false;
		}
	} );
	
	
	
	
	var rreturn = /\r/g;
	
	jQuery.fn.extend( {
		val: function( value ) {
			var hooks, ret, valueIsFunction,
				elem = this[ 0 ];
	
			if ( !arguments.length ) {
				if ( elem ) {
					hooks = jQuery.valHooks[ elem.type ] ||
						jQuery.valHooks[ elem.nodeName.toLowerCase() ];
	
					if ( hooks &&
						"get" in hooks &&
						( ret = hooks.get( elem, "value" ) ) !== undefined
					) {
						return ret;
					}
	
					ret = elem.value;
	
					// Handle most common string cases
					if ( typeof ret === "string" ) {
						return ret.replace( rreturn, "" );
					}
	
					// Handle cases where value is null/undef or number
					return ret == null ? "" : ret;
				}
	
				return;
			}
	
			valueIsFunction = isFunction( value );
	
			return this.each( function( i ) {
				var val;
	
				if ( this.nodeType !== 1 ) {
					return;
				}
	
				if ( valueIsFunction ) {
					val = value.call( this, i, jQuery( this ).val() );
				} else {
					val = value;
				}
	
				// Treat null/undefined as ""; convert numbers to string
				if ( val == null ) {
					val = "";
	
				} else if ( typeof val === "number" ) {
					val += "";
	
				} else if ( Array.isArray( val ) ) {
					val = jQuery.map( val, function( value ) {
						return value == null ? "" : value + "";
					} );
				}
	
				hooks = jQuery.valHooks[ this.type ] || jQuery.valHooks[ this.nodeName.toLowerCase() ];
	
				// If set returns undefined, fall back to normal setting
				if ( !hooks || !( "set" in hooks ) || hooks.set( this, val, "value" ) === undefined ) {
					this.value = val;
				}
			} );
		}
	} );
	
	jQuery.extend( {
		valHooks: {
			option: {
				get: function( elem ) {
	
					var val = jQuery.find.attr( elem, "value" );
					return val != null ?
						val :
	
						// Support: IE <=10 - 11 only
						// option.text throws exceptions (#14686, #14858)
						// Strip and collapse whitespace
						// https://html.spec.whatwg.org/#strip-and-collapse-whitespace
						stripAndCollapse( jQuery.text( elem ) );
				}
			},
			select: {
				get: function( elem ) {
					var value, option, i,
						options = elem.options,
						index = elem.selectedIndex,
						one = elem.type === "select-one",
						values = one ? null : [],
						max = one ? index + 1 : options.length;
	
					if ( index < 0 ) {
						i = max;
	
					} else {
						i = one ? index : 0;
					}
	
					// Loop through all the selected options
					for ( ; i < max; i++ ) {
						option = options[ i ];
	
						// Support: IE <=9 only
						// IE8-9 doesn't update selected after form reset (#2551)
						if ( ( option.selected || i === index ) &&
	
								// Don't return options that are disabled or in a disabled optgroup
								!option.disabled &&
								( !option.parentNode.disabled ||
									!nodeName( option.parentNode, "optgroup" ) ) ) {
	
							// Get the specific value for the option
							value = jQuery( option ).val();
	
							// We don't need an array for one selects
							if ( one ) {
								return value;
							}
	
							// Multi-Selects return an array
							values.push( value );
						}
					}
	
					return values;
				},
	
				set: function( elem, value ) {
					var optionSet, option,
						options = elem.options,
						values = jQuery.makeArray( value ),
						i = options.length;
	
					while ( i-- ) {
						option = options[ i ];
	
						/* eslint-disable no-cond-assign */
	
						if ( option.selected =
							jQuery.inArray( jQuery.valHooks.option.get( option ), values ) > -1
						) {
							optionSet = true;
						}
	
						/* eslint-enable no-cond-assign */
					}
	
					// Force browsers to behave consistently when non-matching value is set
					if ( !optionSet ) {
						elem.selectedIndex = -1;
					}
					return values;
				}
			}
		}
	} );
	
	// Radios and checkboxes getter/setter
	jQuery.each( [ "radio", "checkbox" ], function() {
		jQuery.valHooks[ this ] = {
			set: function( elem, value ) {
				if ( Array.isArray( value ) ) {
					return ( elem.checked = jQuery.inArray( jQuery( elem ).val(), value ) > -1 );
				}
			}
		};
		if ( !support.checkOn ) {
			jQuery.valHooks[ this ].get = function( elem ) {
				return elem.getAttribute( "value" ) === null ? "on" : elem.value;
			};
		}
	} );
	
	
	
	
	// Return jQuery for attributes-only inclusion
	
	
	support.focusin = "onfocusin" in window;
	
	
	var rfocusMorph = /^(?:focusinfocus|focusoutblur)$/,
		stopPropagationCallback = function( e ) {
			e.stopPropagation();
		};
	
	jQuery.extend( jQuery.event, {
	
		trigger: function( event, data, elem, onlyHandlers ) {
	
			var i, cur, tmp, bubbleType, ontype, handle, special, lastElement,
				eventPath = [ elem || document ],
				type = hasOwn.call( event, "type" ) ? event.type : event,
				namespaces = hasOwn.call( event, "namespace" ) ? event.namespace.split( "." ) : [];
	
			cur = lastElement = tmp = elem = elem || document;
	
			// Don't do events on text and comment nodes
			if ( elem.nodeType === 3 || elem.nodeType === 8 ) {
				return;
			}
	
			// focus/blur morphs to focusin/out; ensure we're not firing them right now
			if ( rfocusMorph.test( type + jQuery.event.triggered ) ) {
				return;
			}
	
			if ( type.indexOf( "." ) > -1 ) {
	
				// Namespaced trigger; create a regexp to match event type in handle()
				namespaces = type.split( "." );
				type = namespaces.shift();
				namespaces.sort();
			}
			ontype = type.indexOf( ":" ) < 0 && "on" + type;
	
			// Caller can pass in a jQuery.Event object, Object, or just an event type string
			event = event[ jQuery.expando ] ?
				event :
				new jQuery.Event( type, typeof event === "object" && event );
	
			// Trigger bitmask: & 1 for native handlers; & 2 for jQuery (always true)
			event.isTrigger = onlyHandlers ? 2 : 3;
			event.namespace = namespaces.join( "." );
			event.rnamespace = event.namespace ?
				new RegExp( "(^|\\.)" + namespaces.join( "\\.(?:.*\\.|)" ) + "(\\.|$)" ) :
				null;
	
			// Clean up the event in case it is being reused
			event.result = undefined;
			if ( !event.target ) {
				event.target = elem;
			}
	
			// Clone any incoming data and prepend the event, creating the handler arg list
			data = data == null ?
				[ event ] :
				jQuery.makeArray( data, [ event ] );
	
			// Allow special events to draw outside the lines
			special = jQuery.event.special[ type ] || {};
			if ( !onlyHandlers && special.trigger && special.trigger.apply( elem, data ) === false ) {
				return;
			}
	
			// Determine event propagation path in advance, per W3C events spec (#9951)
			// Bubble up to document, then to window; watch for a global ownerDocument var (#9724)
			if ( !onlyHandlers && !special.noBubble && !isWindow( elem ) ) {
	
				bubbleType = special.delegateType || type;
				if ( !rfocusMorph.test( bubbleType + type ) ) {
					cur = cur.parentNode;
				}
				for ( ; cur; cur = cur.parentNode ) {
					eventPath.push( cur );
					tmp = cur;
				}
	
				// Only add window if we got to document (e.g., not plain obj or detached DOM)
				if ( tmp === ( elem.ownerDocument || document ) ) {
					eventPath.push( tmp.defaultView || tmp.parentWindow || window );
				}
			}
	
			// Fire handlers on the event path
			i = 0;
			while ( ( cur = eventPath[ i++ ] ) && !event.isPropagationStopped() ) {
				lastElement = cur;
				event.type = i > 1 ?
					bubbleType :
					special.bindType || type;
	
				// jQuery handler
				handle = ( dataPriv.get( cur, "events" ) || Object.create( null ) )[ event.type ] &&
					dataPriv.get( cur, "handle" );
				if ( handle ) {
					handle.apply( cur, data );
				}
	
				// Native handler
				handle = ontype && cur[ ontype ];
				if ( handle && handle.apply && acceptData( cur ) ) {
					event.result = handle.apply( cur, data );
					if ( event.result === false ) {
						event.preventDefault();
					}
				}
			}
			event.type = type;
	
			// If nobody prevented the default action, do it now
			if ( !onlyHandlers && !event.isDefaultPrevented() ) {
	
				if ( ( !special._default ||
					special._default.apply( eventPath.pop(), data ) === false ) &&
					acceptData( elem ) ) {
	
					// Call a native DOM method on the target with the same name as the event.
					// Don't do default actions on window, that's where global variables be (#6170)
					if ( ontype && isFunction( elem[ type ] ) && !isWindow( elem ) ) {
	
						// Don't re-trigger an onFOO event when we call its FOO() method
						tmp = elem[ ontype ];
	
						if ( tmp ) {
							elem[ ontype ] = null;
						}
	
						// Prevent re-triggering of the same event, since we already bubbled it above
						jQuery.event.triggered = type;
	
						if ( event.isPropagationStopped() ) {
							lastElement.addEventListener( type, stopPropagationCallback );
						}
	
						elem[ type ]();
	
						if ( event.isPropagationStopped() ) {
							lastElement.removeEventListener( type, stopPropagationCallback );
						}
	
						jQuery.event.triggered = undefined;
	
						if ( tmp ) {
							elem[ ontype ] = tmp;
						}
					}
				}
			}
	
			return event.result;
		},
	
		// Piggyback on a donor event to simulate a different one
		// Used only for `focus(in | out)` events
		simulate: function( type, elem, event ) {
			var e = jQuery.extend(
				new jQuery.Event(),
				event,
				{
					type: type,
					isSimulated: true
				}
			);
	
			jQuery.event.trigger( e, null, elem );
		}
	
	} );
	
	jQuery.fn.extend( {
	
		trigger: function( type, data ) {
			return this.each( function() {
				jQuery.event.trigger( type, data, this );
			} );
		},
		triggerHandler: function( type, data ) {
			var elem = this[ 0 ];
			if ( elem ) {
				return jQuery.event.trigger( type, data, elem, true );
			}
		}
	} );
	
	
	// Support: Firefox <=44
	// Firefox doesn't have focus(in | out) events
	// Related ticket - https://bugzilla.mozilla.org/show_bug.cgi?id=687787
	//
	// Support: Chrome <=48 - 49, Safari <=9.0 - 9.1
	// focus(in | out) events fire after focus & blur events,
	// which is spec violation - http://www.w3.org/TR/DOM-Level-3-Events/#events-focusevent-event-order
	// Related ticket - https://bugs.chromium.org/p/chromium/issues/detail?id=449857
	if ( !support.focusin ) {
		jQuery.each( { focus: "focusin", blur: "focusout" }, function( orig, fix ) {
	
			// Attach a single capturing handler on the document while someone wants focusin/focusout
			var handler = function( event ) {
				jQuery.event.simulate( fix, event.target, jQuery.event.fix( event ) );
			};
	
			jQuery.event.special[ fix ] = {
				setup: function() {
	
					// Handle: regular nodes (via `this.ownerDocument`), window
					// (via `this.document`) & document (via `this`).
					var doc = this.ownerDocument || this.document || this,
						attaches = dataPriv.access( doc, fix );
	
					if ( !attaches ) {
						doc.addEventListener( orig, handler, true );
					}
					dataPriv.access( doc, fix, ( attaches || 0 ) + 1 );
				},
				teardown: function() {
					var doc = this.ownerDocument || this.document || this,
						attaches = dataPriv.access( doc, fix ) - 1;
	
					if ( !attaches ) {
						doc.removeEventListener( orig, handler, true );
						dataPriv.remove( doc, fix );
	
					} else {
						dataPriv.access( doc, fix, attaches );
					}
				}
			};
		} );
	}
	var location = window.location;
	
	var nonce = { guid: Date.now() };
	
	var rquery = ( /\?/ );
	
	
	
	// Cross-browser xml parsing
	jQuery.parseXML = function( data ) {
		var xml, parserErrorElem;
		if ( !data || typeof data !== "string" ) {
			return null;
		}
	
		// Support: IE 9 - 11 only
		// IE throws on parseFromString with invalid input.
		try {
			xml = ( new window.DOMParser() ).parseFromString( data, "text/xml" );
		} catch ( e ) {}
	
		parserErrorElem = xml && xml.getElementsByTagName( "parsererror" )[ 0 ];
		if ( !xml || parserErrorElem ) {
			jQuery.error( "Invalid XML: " + (
				parserErrorElem ?
					jQuery.map( parserErrorElem.childNodes, function( el ) {
						return el.textContent;
					} ).join( "\n" ) :
					data
			) );
		}
		return xml;
	};
	
	
	var
		rbracket = /\[\]$/,
		rCRLF = /\r?\n/g,
		rsubmitterTypes = /^(?:submit|button|image|reset|file)$/i,
		rsubmittable = /^(?:input|select|textarea|keygen)/i;
	
	function buildParams( prefix, obj, traditional, add ) {
		var name;
	
		if ( Array.isArray( obj ) ) {
	
			// Serialize array item.
			jQuery.each( obj, function( i, v ) {
				if ( traditional || rbracket.test( prefix ) ) {
	
					// Treat each array item as a scalar.
					add( prefix, v );
	
				} else {
	
					// Item is non-scalar (array or object), encode its numeric index.
					buildParams(
						prefix + "[" + ( typeof v === "object" && v != null ? i : "" ) + "]",
						v,
						traditional,
						add
					);
				}
			} );
	
		} else if ( !traditional && toType( obj ) === "object" ) {
	
			// Serialize object item.
			for ( name in obj ) {
				buildParams( prefix + "[" + name + "]", obj[ name ], traditional, add );
			}
	
		} else {
	
			// Serialize scalar item.
			add( prefix, obj );
		}
	}
	
	// Serialize an array of form elements or a set of
	// key/values into a query string
	jQuery.param = function( a, traditional ) {
		var prefix,
			s = [],
			add = function( key, valueOrFunction ) {
	
				// If value is a function, invoke it and use its return value
				var value = isFunction( valueOrFunction ) ?
					valueOrFunction() :
					valueOrFunction;
	
				s[ s.length ] = encodeURIComponent( key ) + "=" +
					encodeURIComponent( value == null ? "" : value );
			};
	
		if ( a == null ) {
			return "";
		}
	
		// If an array was passed in, assume that it is an array of form elements.
		if ( Array.isArray( a ) || ( a.jquery && !jQuery.isPlainObject( a ) ) ) {
	
			// Serialize the form elements
			jQuery.each( a, function() {
				add( this.name, this.value );
			} );
	
		} else {
	
			// If traditional, encode the "old" way (the way 1.3.2 or older
			// did it), otherwise encode params recursively.
			for ( prefix in a ) {
				buildParams( prefix, a[ prefix ], traditional, add );
			}
		}
	
		// Return the resulting serialization
		return s.join( "&" );
	};
	
	jQuery.fn.extend( {
		serialize: function() {
			return jQuery.param( this.serializeArray() );
		},
		serializeArray: function() {
			return this.map( function() {
	
				// Can add propHook for "elements" to filter or add form elements
				var elements = jQuery.prop( this, "elements" );
				return elements ? jQuery.makeArray( elements ) : this;
			} ).filter( function() {
				var type = this.type;
	
				// Use .is( ":disabled" ) so that fieldset[disabled] works
				return this.name && !jQuery( this ).is( ":disabled" ) &&
					rsubmittable.test( this.nodeName ) && !rsubmitterTypes.test( type ) &&
					( this.checked || !rcheckableType.test( type ) );
			} ).map( function( _i, elem ) {
				var val = jQuery( this ).val();
	
				if ( val == null ) {
					return null;
				}
	
				if ( Array.isArray( val ) ) {
					return jQuery.map( val, function( val ) {
						return { name: elem.name, value: val.replace( rCRLF, "\r\n" ) };
					} );
				}
	
				return { name: elem.name, value: val.replace( rCRLF, "\r\n" ) };
			} ).get();
		}
	} );
	
	
	var
		r20 = /%20/g,
		rhash = /#.*$/,
		rantiCache = /([?&])_=[^&]*/,
		rheaders = /^(.*?):[ \t]*([^\r\n]*)$/mg,
	
		// #7653, #8125, #8152: local protocol detection
		rlocalProtocol = /^(?:about|app|app-storage|.+-extension|file|res|widget):$/,
		rnoContent = /^(?:GET|HEAD)$/,
		rprotocol = /^\/\//,
	
		/* Prefilters
		 * 1) They are useful to introduce custom dataTypes (see ajax/jsonp.js for an example)
		 * 2) These are called:
		 *    - BEFORE asking for a transport
		 *    - AFTER param serialization (s.data is a string if s.processData is true)
		 * 3) key is the dataType
		 * 4) the catchall symbol "*" can be used
		 * 5) execution will start with transport dataType and THEN continue down to "*" if needed
		 */
		prefilters = {},
	
		/* Transports bindings
		 * 1) key is the dataType
		 * 2) the catchall symbol "*" can be used
		 * 3) selection will start with transport dataType and THEN go to "*" if needed
		 */
		transports = {},
	
		// Avoid comment-prolog char sequence (#10098); must appease lint and evade compression
		allTypes = "*/".concat( "*" ),
	
		// Anchor tag for parsing the document origin
		originAnchor = document.createElement( "a" );
	
	originAnchor.href = location.href;
	
	// Base "constructor" for jQuery.ajaxPrefilter and jQuery.ajaxTransport
	function addToPrefiltersOrTransports( structure ) {
	
		// dataTypeExpression is optional and defaults to "*"
		return function( dataTypeExpression, func ) {
	
			if ( typeof dataTypeExpression !== "string" ) {
				func = dataTypeExpression;
				dataTypeExpression = "*";
			}
	
			var dataType,
				i = 0,
				dataTypes = dataTypeExpression.toLowerCase().match( rnothtmlwhite ) || [];
	
			if ( isFunction( func ) ) {
	
				// For each dataType in the dataTypeExpression
				while ( ( dataType = dataTypes[ i++ ] ) ) {
	
					// Prepend if requested
					if ( dataType[ 0 ] === "+" ) {
						dataType = dataType.slice( 1 ) || "*";
						( structure[ dataType ] = structure[ dataType ] || [] ).unshift( func );
	
					// Otherwise append
					} else {
						( structure[ dataType ] = structure[ dataType ] || [] ).push( func );
					}
				}
			}
		};
	}
	
	// Base inspection function for prefilters and transports
	function inspectPrefiltersOrTransports( structure, options, originalOptions, jqXHR ) {
	
		var inspected = {},
			seekingTransport = ( structure === transports );
	
		function inspect( dataType ) {
			var selected;
			inspected[ dataType ] = true;
			jQuery.each( structure[ dataType ] || [], function( _, prefilterOrFactory ) {
				var dataTypeOrTransport = prefilterOrFactory( options, originalOptions, jqXHR );
				if ( typeof dataTypeOrTransport === "string" &&
					!seekingTransport && !inspected[ dataTypeOrTransport ] ) {
	
					options.dataTypes.unshift( dataTypeOrTransport );
					inspect( dataTypeOrTransport );
					return false;
				} else if ( seekingTransport ) {
					return !( selected = dataTypeOrTransport );
				}
			} );
			return selected;
		}
	
		return inspect( options.dataTypes[ 0 ] ) || !inspected[ "*" ] && inspect( "*" );
	}
	
	// A special extend for ajax options
	// that takes "flat" options (not to be deep extended)
	// Fixes #9887
	function ajaxExtend( target, src ) {
		var key, deep,
			flatOptions = jQuery.ajaxSettings.flatOptions || {};
	
		for ( key in src ) {
			if ( src[ key ] !== undefined ) {
				( flatOptions[ key ] ? target : ( deep || ( deep = {} ) ) )[ key ] = src[ key ];
			}
		}
		if ( deep ) {
			jQuery.extend( true, target, deep );
		}
	
		return target;
	}
	
	/* Handles responses to an ajax request:
	 * - finds the right dataType (mediates between content-type and expected dataType)
	 * - returns the corresponding response
	 */
	function ajaxHandleResponses( s, jqXHR, responses ) {
	
		var ct, type, finalDataType, firstDataType,
			contents = s.contents,
			dataTypes = s.dataTypes;
	
		// Remove auto dataType and get content-type in the process
		while ( dataTypes[ 0 ] === "*" ) {
			dataTypes.shift();
			if ( ct === undefined ) {
				ct = s.mimeType || jqXHR.getResponseHeader( "Content-Type" );
			}
		}
	
		// Check if we're dealing with a known content-type
		if ( ct ) {
			for ( type in contents ) {
				if ( contents[ type ] && contents[ type ].test( ct ) ) {
					dataTypes.unshift( type );
					break;
				}
			}
		}
	
		// Check to see if we have a response for the expected dataType
		if ( dataTypes[ 0 ] in responses ) {
			finalDataType = dataTypes[ 0 ];
		} else {
	
			// Try convertible dataTypes
			for ( type in responses ) {
				if ( !dataTypes[ 0 ] || s.converters[ type + " " + dataTypes[ 0 ] ] ) {
					finalDataType = type;
					break;
				}
				if ( !firstDataType ) {
					firstDataType = type;
				}
			}
	
			// Or just use first one
			finalDataType = finalDataType || firstDataType;
		}
	
		// If we found a dataType
		// We add the dataType to the list if needed
		// and return the corresponding response
		if ( finalDataType ) {
			if ( finalDataType !== dataTypes[ 0 ] ) {
				dataTypes.unshift( finalDataType );
			}
			return responses[ finalDataType ];
		}
	}
	
	/* Chain conversions given the request and the original response
	 * Also sets the responseXXX fields on the jqXHR instance
	 */
	function ajaxConvert( s, response, jqXHR, isSuccess ) {
		var conv2, current, conv, tmp, prev,
			converters = {},
	
			// Work with a copy of dataTypes in case we need to modify it for conversion
			dataTypes = s.dataTypes.slice();
	
		// Create converters map with lowercased keys
		if ( dataTypes[ 1 ] ) {
			for ( conv in s.converters ) {
				converters[ conv.toLowerCase() ] = s.converters[ conv ];
			}
		}
	
		current = dataTypes.shift();
	
		// Convert to each sequential dataType
		while ( current ) {
	
			if ( s.responseFields[ current ] ) {
				jqXHR[ s.responseFields[ current ] ] = response;
			}
	
			// Apply the dataFilter if provided
			if ( !prev && isSuccess && s.dataFilter ) {
				response = s.dataFilter( response, s.dataType );
			}
	
			prev = current;
			current = dataTypes.shift();
	
			if ( current ) {
	
				// There's only work to do if current dataType is non-auto
				if ( current === "*" ) {
	
					current = prev;
	
				// Convert response if prev dataType is non-auto and differs from current
				} else if ( prev !== "*" && prev !== current ) {
	
					// Seek a direct converter
					conv = converters[ prev + " " + current ] || converters[ "* " + current ];
	
					// If none found, seek a pair
					if ( !conv ) {
						for ( conv2 in converters ) {
	
							// If conv2 outputs current
							tmp = conv2.split( " " );
							if ( tmp[ 1 ] === current ) {
	
								// If prev can be converted to accepted input
								conv = converters[ prev + " " + tmp[ 0 ] ] ||
									converters[ "* " + tmp[ 0 ] ];
								if ( conv ) {
	
									// Condense equivalence converters
									if ( conv === true ) {
										conv = converters[ conv2 ];
	
									// Otherwise, insert the intermediate dataType
									} else if ( converters[ conv2 ] !== true ) {
										current = tmp[ 0 ];
										dataTypes.unshift( tmp[ 1 ] );
									}
									break;
								}
							}
						}
					}
	
					// Apply converter (if not an equivalence)
					if ( conv !== true ) {
	
						// Unless errors are allowed to bubble, catch and return them
						if ( conv && s.throws ) {
							response = conv( response );
						} else {
							try {
								response = conv( response );
							} catch ( e ) {
								return {
									state: "parsererror",
									error: conv ? e : "No conversion from " + prev + " to " + current
								};
							}
						}
					}
				}
			}
		}
	
		return { state: "success", data: response };
	}
	
	jQuery.extend( {
	
		// Counter for holding the number of active queries
		active: 0,
	
		// Last-Modified header cache for next request
		lastModified: {},
		etag: {},
	
		ajaxSettings: {
			url: location.href,
			type: "GET",
			isLocal: rlocalProtocol.test( location.protocol ),
			global: true,
			processData: true,
			async: true,
			contentType: "application/x-www-form-urlencoded; charset=UTF-8",
	
			/*
			timeout: 0,
			data: null,
			dataType: null,
			username: null,
			password: null,
			cache: null,
			throws: false,
			traditional: false,
			headers: {},
			*/
	
			accepts: {
				"*": allTypes,
				text: "text/plain",
				html: "text/html",
				xml: "application/xml, text/xml",
				json: "application/json, text/javascript"
			},
	
			contents: {
				xml: /\bxml\b/,
				html: /\bhtml/,
				json: /\bjson\b/
			},
	
			responseFields: {
				xml: "responseXML",
				text: "responseText",
				json: "responseJSON"
			},
	
			// Data converters
			// Keys separate source (or catchall "*") and destination types with a single space
			converters: {
	
				// Convert anything to text
				"* text": String,
	
				// Text to html (true = no transformation)
				"text html": true,
	
				// Evaluate text as a json expression
				"text json": JSON.parse,
	
				// Parse text as xml
				"text xml": jQuery.parseXML
			},
	
			// For options that shouldn't be deep extended:
			// you can add your own custom options here if
			// and when you create one that shouldn't be
			// deep extended (see ajaxExtend)
			flatOptions: {
				url: true,
				context: true
			}
		},
	
		// Creates a full fledged settings object into target
		// with both ajaxSettings and settings fields.
		// If target is omitted, writes into ajaxSettings.
		ajaxSetup: function( target, settings ) {
			return settings ?
	
				// Building a settings object
				ajaxExtend( ajaxExtend( target, jQuery.ajaxSettings ), settings ) :
	
				// Extending ajaxSettings
				ajaxExtend( jQuery.ajaxSettings, target );
		},
	
		ajaxPrefilter: addToPrefiltersOrTransports( prefilters ),
		ajaxTransport: addToPrefiltersOrTransports( transports ),
	
		// Main method
		ajax: function( url, options ) {
	
			// If url is an object, simulate pre-1.5 signature
			if ( typeof url === "object" ) {
				options = url;
				url = undefined;
			}
	
			// Force options to be an object
			options = options || {};
	
			var transport,
	
				// URL without anti-cache param
				cacheURL,
	
				// Response headers
				responseHeadersString,
				responseHeaders,
	
				// timeout handle
				timeoutTimer,
	
				// Url cleanup var
				urlAnchor,
	
				// Request state (becomes false upon send and true upon completion)
				completed,
	
				// To know if global events are to be dispatched
				fireGlobals,
	
				// Loop variable
				i,
	
				// uncached part of the url
				uncached,
	
				// Create the final options object
				s = jQuery.ajaxSetup( {}, options ),
	
				// Callbacks context
				callbackContext = s.context || s,
	
				// Context for global events is callbackContext if it is a DOM node or jQuery collection
				globalEventContext = s.context &&
					( callbackContext.nodeType || callbackContext.jquery ) ?
					jQuery( callbackContext ) :
					jQuery.event,
	
				// Deferreds
				deferred = jQuery.Deferred(),
				completeDeferred = jQuery.Callbacks( "once memory" ),
	
				// Status-dependent callbacks
				statusCode = s.statusCode || {},
	
				// Headers (they are sent all at once)
				requestHeaders = {},
				requestHeadersNames = {},
	
				// Default abort message
				strAbort = "canceled",
	
				// Fake xhr
				jqXHR = {
					readyState: 0,
	
					// Builds headers hashtable if needed
					getResponseHeader: function( key ) {
						var match;
						if ( completed ) {
							if ( !responseHeaders ) {
								responseHeaders = {};
								while ( ( match = rheaders.exec( responseHeadersString ) ) ) {
									responseHeaders[ match[ 1 ].toLowerCase() + " " ] =
										( responseHeaders[ match[ 1 ].toLowerCase() + " " ] || [] )
											.concat( match[ 2 ] );
								}
							}
							match = responseHeaders[ key.toLowerCase() + " " ];
						}
						return match == null ? null : match.join( ", " );
					},
	
					// Raw string
					getAllResponseHeaders: function() {
						return completed ? responseHeadersString : null;
					},
	
					// Caches the header
					setRequestHeader: function( name, value ) {
						if ( completed == null ) {
							name = requestHeadersNames[ name.toLowerCase() ] =
								requestHeadersNames[ name.toLowerCase() ] || name;
							requestHeaders[ name ] = value;
						}
						return this;
					},
	
					// Overrides response content-type header
					overrideMimeType: function( type ) {
						if ( completed == null ) {
							s.mimeType = type;
						}
						return this;
					},
	
					// Status-dependent callbacks
					statusCode: function( map ) {
						var code;
						if ( map ) {
							if ( completed ) {
	
								// Execute the appropriate callbacks
								jqXHR.always( map[ jqXHR.status ] );
							} else {
	
								// Lazy-add the new callbacks in a way that preserves old ones
								for ( code in map ) {
									statusCode[ code ] = [ statusCode[ code ], map[ code ] ];
								}
							}
						}
						return this;
					},
	
					// Cancel the request
					abort: function( statusText ) {
						var finalText = statusText || strAbort;
						if ( transport ) {
							transport.abort( finalText );
						}
						done( 0, finalText );
						return this;
					}
				};
	
			// Attach deferreds
			deferred.promise( jqXHR );
	
			// Add protocol if not provided (prefilters might expect it)
			// Handle falsy url in the settings object (#10093: consistency with old signature)
			// We also use the url parameter if available
			s.url = ( ( url || s.url || location.href ) + "" )
				.replace( rprotocol, location.protocol + "//" );
	
			// Alias method option to type as per ticket #12004
			s.type = options.method || options.type || s.method || s.type;
	
			// Extract dataTypes list
			s.dataTypes = ( s.dataType || "*" ).toLowerCase().match( rnothtmlwhite ) || [ "" ];
	
			// A cross-domain request is in order when the origin doesn't match the current origin.
			if ( s.crossDomain == null ) {
				urlAnchor = document.createElement( "a" );
	
				// Support: IE <=8 - 11, Edge 12 - 15
				// IE throws exception on accessing the href property if url is malformed,
				// e.g. http://example.com:80x/
				try {
					urlAnchor.href = s.url;
	
					// Support: IE <=8 - 11 only
					// Anchor's host property isn't correctly set when s.url is relative
					urlAnchor.href = urlAnchor.href;
					s.crossDomain = originAnchor.protocol + "//" + originAnchor.host !==
						urlAnchor.protocol + "//" + urlAnchor.host;
				} catch ( e ) {
	
					// If there is an error parsing the URL, assume it is crossDomain,
					// it can be rejected by the transport if it is invalid
					s.crossDomain = true;
				}
			}
	
			// Convert data if not already a string
			if ( s.data && s.processData && typeof s.data !== "string" ) {
				s.data = jQuery.param( s.data, s.traditional );
			}
	
			// Apply prefilters
			inspectPrefiltersOrTransports( prefilters, s, options, jqXHR );
	
			// If request was aborted inside a prefilter, stop there
			if ( completed ) {
				return jqXHR;
			}
	
			// We can fire global events as of now if asked to
			// Don't fire events if jQuery.event is undefined in an AMD-usage scenario (#15118)
			fireGlobals = jQuery.event && s.global;
	
			// Watch for a new set of requests
			if ( fireGlobals && jQuery.active++ === 0 ) {
				jQuery.event.trigger( "ajaxStart" );
			}
	
			// Uppercase the type
			s.type = s.type.toUpperCase();
	
			// Determine if request has content
			s.hasContent = !rnoContent.test( s.type );
	
			// Save the URL in case we're toying with the If-Modified-Since
			// and/or If-None-Match header later on
			// Remove hash to simplify url manipulation
			cacheURL = s.url.replace( rhash, "" );
	
			// More options handling for requests with no content
			if ( !s.hasContent ) {
	
				// Remember the hash so we can put it back
				uncached = s.url.slice( cacheURL.length );
	
				// If data is available and should be processed, append data to url
				if ( s.data && ( s.processData || typeof s.data === "string" ) ) {
					cacheURL += ( rquery.test( cacheURL ) ? "&" : "?" ) + s.data;
	
					// #9682: remove data so that it's not used in an eventual retry
					delete s.data;
				}
	
				// Add or update anti-cache param if needed
				if ( s.cache === false ) {
					cacheURL = cacheURL.replace( rantiCache, "$1" );
					uncached = ( rquery.test( cacheURL ) ? "&" : "?" ) + "_=" + ( nonce.guid++ ) +
						uncached;
				}
	
				// Put hash and anti-cache on the URL that will be requested (gh-1732)
				s.url = cacheURL + uncached;
	
			// Change '%20' to '+' if this is encoded form body content (gh-2658)
			} else if ( s.data && s.processData &&
				( s.contentType || "" ).indexOf( "application/x-www-form-urlencoded" ) === 0 ) {
				s.data = s.data.replace( r20, "+" );
			}
	
			// Set the If-Modified-Since and/or If-None-Match header, if in ifModified mode.
			if ( s.ifModified ) {
				if ( jQuery.lastModified[ cacheURL ] ) {
					jqXHR.setRequestHeader( "If-Modified-Since", jQuery.lastModified[ cacheURL ] );
				}
				if ( jQuery.etag[ cacheURL ] ) {
					jqXHR.setRequestHeader( "If-None-Match", jQuery.etag[ cacheURL ] );
				}
			}
	
			// Set the correct header, if data is being sent
			if ( s.data && s.hasContent && s.contentType !== false || options.contentType ) {
				jqXHR.setRequestHeader( "Content-Type", s.contentType );
			}
	
			// Set the Accepts header for the server, depending on the dataType
			jqXHR.setRequestHeader(
				"Accept",
				s.dataTypes[ 0 ] && s.accepts[ s.dataTypes[ 0 ] ] ?
					s.accepts[ s.dataTypes[ 0 ] ] +
						( s.dataTypes[ 0 ] !== "*" ? ", " + allTypes + "; q=0.01" : "" ) :
					s.accepts[ "*" ]
			);
	
			// Check for headers option
			for ( i in s.headers ) {
				jqXHR.setRequestHeader( i, s.headers[ i ] );
			}
	
			// Allow custom headers/mimetypes and early abort
			if ( s.beforeSend &&
				( s.beforeSend.call( callbackContext, jqXHR, s ) === false || completed ) ) {
	
				// Abort if not done already and return
				return jqXHR.abort();
			}
	
			// Aborting is no longer a cancellation
			strAbort = "abort";
	
			// Install callbacks on deferreds
			completeDeferred.add( s.complete );
			jqXHR.done( s.success );
			jqXHR.fail( s.error );
	
			// Get transport
			transport = inspectPrefiltersOrTransports( transports, s, options, jqXHR );
	
			// If no transport, we auto-abort
			if ( !transport ) {
				done( -1, "No Transport" );
			} else {
				jqXHR.readyState = 1;
	
				// Send global event
				if ( fireGlobals ) {
					globalEventContext.trigger( "ajaxSend", [ jqXHR, s ] );
				}
	
				// If request was aborted inside ajaxSend, stop there
				if ( completed ) {
					return jqXHR;
				}
	
				// Timeout
				if ( s.async && s.timeout > 0 ) {
					timeoutTimer = window.setTimeout( function() {
						jqXHR.abort( "timeout" );
					}, s.timeout );
				}
	
				try {
					completed = false;
					transport.send( requestHeaders, done );
				} catch ( e ) {
	
					// Rethrow post-completion exceptions
					if ( completed ) {
						throw e;
					}
	
					// Propagate others as results
					done( -1, e );
				}
			}
	
			// Callback for when everything is done
			function done( status, nativeStatusText, responses, headers ) {
				var isSuccess, success, error, response, modified,
					statusText = nativeStatusText;
	
				// Ignore repeat invocations
				if ( completed ) {
					return;
				}
	
				completed = true;
	
				// Clear timeout if it exists
				if ( timeoutTimer ) {
					window.clearTimeout( timeoutTimer );
				}
	
				// Dereference transport for early garbage collection
				// (no matter how long the jqXHR object will be used)
				transport = undefined;
	
				// Cache response headers
				responseHeadersString = headers || "";
	
				// Set readyState
				jqXHR.readyState = status > 0 ? 4 : 0;
	
				// Determine if successful
				isSuccess = status >= 200 && status < 300 || status === 304;
	
				// Get response data
				if ( responses ) {
					response = ajaxHandleResponses( s, jqXHR, responses );
				}
	
				// Use a noop converter for missing script but not if jsonp
				if ( !isSuccess &&
					jQuery.inArray( "script", s.dataTypes ) > -1 &&
					jQuery.inArray( "json", s.dataTypes ) < 0 ) {
					s.converters[ "text script" ] = function() {};
				}
	
				// Convert no matter what (that way responseXXX fields are always set)
				response = ajaxConvert( s, response, jqXHR, isSuccess );
	
				// If successful, handle type chaining
				if ( isSuccess ) {
	
					// Set the If-Modified-Since and/or If-None-Match header, if in ifModified mode.
					if ( s.ifModified ) {
						modified = jqXHR.getResponseHeader( "Last-Modified" );
						if ( modified ) {
							jQuery.lastModified[ cacheURL ] = modified;
						}
						modified = jqXHR.getResponseHeader( "etag" );
						if ( modified ) {
							jQuery.etag[ cacheURL ] = modified;
						}
					}
	
					// if no content
					if ( status === 204 || s.type === "HEAD" ) {
						statusText = "nocontent";
	
					// if not modified
					} else if ( status === 304 ) {
						statusText = "notmodified";
	
					// If we have data, let's convert it
					} else {
						statusText = response.state;
						success = response.data;
						error = response.error;
						isSuccess = !error;
					}
				} else {
	
					// Extract error from statusText and normalize for non-aborts
					error = statusText;
					if ( status || !statusText ) {
						statusText = "error";
						if ( status < 0 ) {
							status = 0;
						}
					}
				}
	
				// Set data for the fake xhr object
				jqXHR.status = status;
				jqXHR.statusText = ( nativeStatusText || statusText ) + "";
	
				// Success/Error
				if ( isSuccess ) {
					deferred.resolveWith( callbackContext, [ success, statusText, jqXHR ] );
				} else {
					deferred.rejectWith( callbackContext, [ jqXHR, statusText, error ] );
				}
	
				// Status-dependent callbacks
				jqXHR.statusCode( statusCode );
				statusCode = undefined;
	
				if ( fireGlobals ) {
					globalEventContext.trigger( isSuccess ? "ajaxSuccess" : "ajaxError",
						[ jqXHR, s, isSuccess ? success : error ] );
				}
	
				// Complete
				completeDeferred.fireWith( callbackContext, [ jqXHR, statusText ] );
	
				if ( fireGlobals ) {
					globalEventContext.trigger( "ajaxComplete", [ jqXHR, s ] );
	
					// Handle the global AJAX counter
					if ( !( --jQuery.active ) ) {
						jQuery.event.trigger( "ajaxStop" );
					}
				}
			}
	
			return jqXHR;
		},
	
		getJSON: function( url, data, callback ) {
			return jQuery.get( url, data, callback, "json" );
		},
	
		getScript: function( url, callback ) {
			return jQuery.get( url, undefined, callback, "script" );
		}
	} );
	
	jQuery.each( [ "get", "post" ], function( _i, method ) {
		jQuery[ method ] = function( url, data, callback, type ) {
	
			// Shift arguments if data argument was omitted
			if ( isFunction( data ) ) {
				type = type || callback;
				callback = data;
				data = undefined;
			}
	
			// The url can be an options object (which then must have .url)
			return jQuery.ajax( jQuery.extend( {
				url: url,
				type: method,
				dataType: type,
				data: data,
				success: callback
			}, jQuery.isPlainObject( url ) && url ) );
		};
	} );
	
	jQuery.ajaxPrefilter( function( s ) {
		var i;
		for ( i in s.headers ) {
			if ( i.toLowerCase() === "content-type" ) {
				s.contentType = s.headers[ i ] || "";
			}
		}
	} );
	
	
	jQuery._evalUrl = function( url, options, doc ) {
		return jQuery.ajax( {
			url: url,
	
			// Make this explicit, since user can override this through ajaxSetup (#11264)
			type: "GET",
			dataType: "script",
			cache: true,
			async: false,
			global: false,
	
			// Only evaluate the response if it is successful (gh-4126)
			// dataFilter is not invoked for failure responses, so using it instead
			// of the default converter is kludgy but it works.
			converters: {
				"text script": function() {}
			},
			dataFilter: function( response ) {
				jQuery.globalEval( response, options, doc );
			}
		} );
	};
	
	
	jQuery.fn.extend( {
		wrapAll: function( html ) {
			var wrap;
	
			if ( this[ 0 ] ) {
				if ( isFunction( html ) ) {
					html = html.call( this[ 0 ] );
				}
	
				// The elements to wrap the target around
				wrap = jQuery( html, this[ 0 ].ownerDocument ).eq( 0 ).clone( true );
	
				if ( this[ 0 ].parentNode ) {
					wrap.insertBefore( this[ 0 ] );
				}
	
				wrap.map( function() {
					var elem = this;
	
					while ( elem.firstElementChild ) {
						elem = elem.firstElementChild;
					}
	
					return elem;
				} ).append( this );
			}
	
			return this;
		},
	
		wrapInner: function( html ) {
			if ( isFunction( html ) ) {
				return this.each( function( i ) {
					jQuery( this ).wrapInner( html.call( this, i ) );
				} );
			}
	
			return this.each( function() {
				var self = jQuery( this ),
					contents = self.contents();
	
				if ( contents.length ) {
					contents.wrapAll( html );
	
				} else {
					self.append( html );
				}
			} );
		},
	
		wrap: function( html ) {
			var htmlIsFunction = isFunction( html );
	
			return this.each( function( i ) {
				jQuery( this ).wrapAll( htmlIsFunction ? html.call( this, i ) : html );
			} );
		},
	
		unwrap: function( selector ) {
			this.parent( selector ).not( "body" ).each( function() {
				jQuery( this ).replaceWith( this.childNodes );
			} );
			return this;
		}
	} );
	
	
	jQuery.expr.pseudos.hidden = function( elem ) {
		return !jQuery.expr.pseudos.visible( elem );
	};
	jQuery.expr.pseudos.visible = function( elem ) {
		return !!( elem.offsetWidth || elem.offsetHeight || elem.getClientRects().length );
	};
	
	
	
	
	jQuery.ajaxSettings.xhr = function() {
		try {
			return new window.XMLHttpRequest();
		} catch ( e ) {}
	};
	
	var xhrSuccessStatus = {
	
			// File protocol always yields status code 0, assume 200
			0: 200,
	
			// Support: IE <=9 only
			// #1450: sometimes IE returns 1223 when it should be 204
			1223: 204
		},
		xhrSupported = jQuery.ajaxSettings.xhr();
	
	support.cors = !!xhrSupported && ( "withCredentials" in xhrSupported );
	support.ajax = xhrSupported = !!xhrSupported;
	
	jQuery.ajaxTransport( function( options ) {
		var callback, errorCallback;
	
		// Cross domain only allowed if supported through XMLHttpRequest
		if ( support.cors || xhrSupported && !options.crossDomain ) {
			return {
				send: function( headers, complete ) {
					var i,
						xhr = options.xhr();
	
					xhr.open(
						options.type,
						options.url,
						options.async,
						options.username,
						options.password
					);
	
					// Apply custom fields if provided
					if ( options.xhrFields ) {
						for ( i in options.xhrFields ) {
							xhr[ i ] = options.xhrFields[ i ];
						}
					}
	
					// Override mime type if needed
					if ( options.mimeType && xhr.overrideMimeType ) {
						xhr.overrideMimeType( options.mimeType );
					}
	
					// X-Requested-With header
					// For cross-domain requests, seeing as conditions for a preflight are
					// akin to a jigsaw puzzle, we simply never set it to be sure.
					// (it can always be set on a per-request basis or even using ajaxSetup)
					// For same-domain requests, won't change header if already provided.
					if ( !options.crossDomain && !headers[ "X-Requested-With" ] ) {
						headers[ "X-Requested-With" ] = "XMLHttpRequest";
					}
	
					// Set headers
					for ( i in headers ) {
						xhr.setRequestHeader( i, headers[ i ] );
					}
	
					// Callback
					callback = function( type ) {
						return function() {
							if ( callback ) {
								callback = errorCallback = xhr.onload =
									xhr.onerror = xhr.onabort = xhr.ontimeout =
										xhr.onreadystatechange = null;
	
								if ( type === "abort" ) {
									xhr.abort();
								} else if ( type === "error" ) {
	
									// Support: IE <=9 only
									// On a manual native abort, IE9 throws
									// errors on any property access that is not readyState
									if ( typeof xhr.status !== "number" ) {
										complete( 0, "error" );
									} else {
										complete(
	
											// File: protocol always yields status 0; see #8605, #14207
											xhr.status,
											xhr.statusText
										);
									}
								} else {
									complete(
										xhrSuccessStatus[ xhr.status ] || xhr.status,
										xhr.statusText,
	
										// Support: IE <=9 only
										// IE9 has no XHR2 but throws on binary (trac-11426)
										// For XHR2 non-text, let the caller handle it (gh-2498)
										( xhr.responseType || "text" ) !== "text"  ||
										typeof xhr.responseText !== "string" ?
											{ binary: xhr.response } :
											{ text: xhr.responseText },
										xhr.getAllResponseHeaders()
									);
								}
							}
						};
					};
	
					// Listen to events
					xhr.onload = callback();
					errorCallback = xhr.onerror = xhr.ontimeout = callback( "error" );
	
					// Support: IE 9 only
					// Use onreadystatechange to replace onabort
					// to handle uncaught aborts
					if ( xhr.onabort !== undefined ) {
						xhr.onabort = errorCallback;
					} else {
						xhr.onreadystatechange = function() {
	
							// Check readyState before timeout as it changes
							if ( xhr.readyState === 4 ) {
	
								// Allow onerror to be called first,
								// but that will not handle a native abort
								// Also, save errorCallback to a variable
								// as xhr.onerror cannot be accessed
								window.setTimeout( function() {
									if ( callback ) {
										errorCallback();
									}
								} );
							}
						};
					}
	
					// Create the abort callback
					callback = callback( "abort" );
	
					try {
	
						// Do send the request (this may raise an exception)
						xhr.send( options.hasContent && options.data || null );
					} catch ( e ) {
	
						// #14683: Only rethrow if this hasn't been notified as an error yet
						if ( callback ) {
							throw e;
						}
					}
				},
	
				abort: function() {
					if ( callback ) {
						callback();
					}
				}
			};
		}
	} );
	
	
	
	
	// Prevent auto-execution of scripts when no explicit dataType was provided (See gh-2432)
	jQuery.ajaxPrefilter( function( s ) {
		if ( s.crossDomain ) {
			s.contents.script = false;
		}
	} );
	
	// Install script dataType
	jQuery.ajaxSetup( {
		accepts: {
			script: "text/javascript, application/javascript, " +
				"application/ecmascript, application/x-ecmascript"
		},
		contents: {
			script: /\b(?:java|ecma)script\b/
		},
		converters: {
			"text script": function( text ) {
				jQuery.globalEval( text );
				return text;
			}
		}
	} );
	
	// Handle cache's special case and crossDomain
	jQuery.ajaxPrefilter( "script", function( s ) {
		if ( s.cache === undefined ) {
			s.cache = false;
		}
		if ( s.crossDomain ) {
			s.type = "GET";
		}
	} );
	
	// Bind script tag hack transport
	jQuery.ajaxTransport( "script", function( s ) {
	
		// This transport only deals with cross domain or forced-by-attrs requests
		if ( s.crossDomain || s.scriptAttrs ) {
			var script, callback;
			return {
				send: function( _, complete ) {
					script = jQuery( "<script>" )
						.attr( s.scriptAttrs || {} )
						.prop( { charset: s.scriptCharset, src: s.url } )
						.on( "load error", callback = function( evt ) {
							script.remove();
							callback = null;
							if ( evt ) {
								complete( evt.type === "error" ? 404 : 200, evt.type );
							}
						} );
	
					// Use native DOM manipulation to avoid our domManip AJAX trickery
					document.head.appendChild( script[ 0 ] );
				},
				abort: function() {
					if ( callback ) {
						callback();
					}
				}
			};
		}
	} );
	
	
	
	
	var oldCallbacks = [],
		rjsonp = /(=)\?(?=&|$)|\?\?/;
	
	// Default jsonp settings
	jQuery.ajaxSetup( {
		jsonp: "callback",
		jsonpCallback: function() {
			var callback = oldCallbacks.pop() || ( jQuery.expando + "_" + ( nonce.guid++ ) );
			this[ callback ] = true;
			return callback;
		}
	} );
	
	// Detect, normalize options and install callbacks for jsonp requests
	jQuery.ajaxPrefilter( "json jsonp", function( s, originalSettings, jqXHR ) {
	
		var callbackName, overwritten, responseContainer,
			jsonProp = s.jsonp !== false && ( rjsonp.test( s.url ) ?
				"url" :
				typeof s.data === "string" &&
					( s.contentType || "" )
						.indexOf( "application/x-www-form-urlencoded" ) === 0 &&
					rjsonp.test( s.data ) && "data"
			);
	
		// Handle iff the expected data type is "jsonp" or we have a parameter to set
		if ( jsonProp || s.dataTypes[ 0 ] === "jsonp" ) {
	
			// Get callback name, remembering preexisting value associated with it
			callbackName = s.jsonpCallback = isFunction( s.jsonpCallback ) ?
				s.jsonpCallback() :
				s.jsonpCallback;
	
			// Insert callback into url or form data
			if ( jsonProp ) {
				s[ jsonProp ] = s[ jsonProp ].replace( rjsonp, "$1" + callbackName );
			} else if ( s.jsonp !== false ) {
				s.url += ( rquery.test( s.url ) ? "&" : "?" ) + s.jsonp + "=" + callbackName;
			}
	
			// Use data converter to retrieve json after script execution
			s.converters[ "script json" ] = function() {
				if ( !responseContainer ) {
					jQuery.error( callbackName + " was not called" );
				}
				return responseContainer[ 0 ];
			};
	
			// Force json dataType
			s.dataTypes[ 0 ] = "json";
	
			// Install callback
			overwritten = window[ callbackName ];
			window[ callbackName ] = function() {
				responseContainer = arguments;
			};
	
			// Clean-up function (fires after converters)
			jqXHR.always( function() {
	
				// If previous value didn't exist - remove it
				if ( overwritten === undefined ) {
					jQuery( window ).removeProp( callbackName );
	
				// Otherwise restore preexisting value
				} else {
					window[ callbackName ] = overwritten;
				}
	
				// Save back as free
				if ( s[ callbackName ] ) {
	
					// Make sure that re-using the options doesn't screw things around
					s.jsonpCallback = originalSettings.jsonpCallback;
	
					// Save the callback name for future use
					oldCallbacks.push( callbackName );
				}
	
				// Call if it was a function and we have a response
				if ( responseContainer && isFunction( overwritten ) ) {
					overwritten( responseContainer[ 0 ] );
				}
	
				responseContainer = overwritten = undefined;
			} );
	
			// Delegate to script
			return "script";
		}
	} );
	
	
	
	
	// Support: Safari 8 only
	// In Safari 8 documents created via document.implementation.createHTMLDocument
	// collapse sibling forms: the second one becomes a child of the first one.
	// Because of that, this security measure has to be disabled in Safari 8.
	// https://bugs.webkit.org/show_bug.cgi?id=137337
	support.createHTMLDocument = ( function() {
		var body = document.implementation.createHTMLDocument( "" ).body;
		body.innerHTML = "<form></form><form></form>";
		return body.childNodes.length === 2;
	} )();
	
	
	// Argument "data" should be string of html
	// context (optional): If specified, the fragment will be created in this context,
	// defaults to document
	// keepScripts (optional): If true, will include scripts passed in the html string
	jQuery.parseHTML = function( data, context, keepScripts ) {
		if ( typeof data !== "string" ) {
			return [];
		}
		if ( typeof context === "boolean" ) {
			keepScripts = context;
			context = false;
		}
	
		var base, parsed, scripts;
	
		if ( !context ) {
	
			// Stop scripts or inline event handlers from being executed immediately
			// by using document.implementation
			if ( support.createHTMLDocument ) {
				context = document.implementation.createHTMLDocument( "" );
	
				// Set the base href for the created document
				// so any parsed elements with URLs
				// are based on the document's URL (gh-2965)
				base = context.createElement( "base" );
				base.href = document.location.href;
				context.head.appendChild( base );
			} else {
				context = document;
			}
		}
	
		parsed = rsingleTag.exec( data );
		scripts = !keepScripts && [];
	
		// Single tag
		if ( parsed ) {
			return [ context.createElement( parsed[ 1 ] ) ];
		}
	
		parsed = buildFragment( [ data ], context, scripts );
	
		if ( scripts && scripts.length ) {
			jQuery( scripts ).remove();
		}
	
		return jQuery.merge( [], parsed.childNodes );
	};
	
	
	/**
	 * Load a url into a page
	 */
	jQuery.fn.load = function( url, params, callback ) {
		var selector, type, response,
			self = this,
			off = url.indexOf( " " );
	
		if ( off > -1 ) {
			selector = stripAndCollapse( url.slice( off ) );
			url = url.slice( 0, off );
		}
	
		// If it's a function
		if ( isFunction( params ) ) {
	
			// We assume that it's the callback
			callback = params;
			params = undefined;
	
		// Otherwise, build a param string
		} else if ( params && typeof params === "object" ) {
			type = "POST";
		}
	
		// If we have elements to modify, make the request
		if ( self.length > 0 ) {
			jQuery.ajax( {
				url: url,
	
				// If "type" variable is undefined, then "GET" method will be used.
				// Make value of this field explicit since
				// user can override it through ajaxSetup method
				type: type || "GET",
				dataType: "html",
				data: params
			} ).done( function( responseText ) {
	
				// Save response for use in complete callback
				response = arguments;
	
				self.html( selector ?
	
					// If a selector was specified, locate the right elements in a dummy div
					// Exclude scripts to avoid IE 'Permission Denied' errors
					jQuery( "<div>" ).append( jQuery.parseHTML( responseText ) ).find( selector ) :
	
					// Otherwise use the full result
					responseText );
	
			// If the request succeeds, this function gets "data", "status", "jqXHR"
			// but they are ignored because response was set above.
			// If it fails, this function gets "jqXHR", "status", "error"
			} ).always( callback && function( jqXHR, status ) {
				self.each( function() {
					callback.apply( this, response || [ jqXHR.responseText, status, jqXHR ] );
				} );
			} );
		}
	
		return this;
	};
	
	
	
	
	jQuery.expr.pseudos.animated = function( elem ) {
		return jQuery.grep( jQuery.timers, function( fn ) {
			return elem === fn.elem;
		} ).length;
	};
	
	
	
	
	jQuery.offset = {
		setOffset: function( elem, options, i ) {
			var curPosition, curLeft, curCSSTop, curTop, curOffset, curCSSLeft, calculatePosition,
				position = jQuery.css( elem, "position" ),
				curElem = jQuery( elem ),
				props = {};
	
			// Set position first, in-case top/left are set even on static elem
			if ( position === "static" ) {
				elem.style.position = "relative";
			}
	
			curOffset = curElem.offset();
			curCSSTop = jQuery.css( elem, "top" );
			curCSSLeft = jQuery.css( elem, "left" );
			calculatePosition = ( position === "absolute" || position === "fixed" ) &&
				( curCSSTop + curCSSLeft ).indexOf( "auto" ) > -1;
	
			// Need to be able to calculate position if either
			// top or left is auto and position is either absolute or fixed
			if ( calculatePosition ) {
				curPosition = curElem.position();
				curTop = curPosition.top;
				curLeft = curPosition.left;
	
			} else {
				curTop = parseFloat( curCSSTop ) || 0;
				curLeft = parseFloat( curCSSLeft ) || 0;
			}
	
			if ( isFunction( options ) ) {
	
				// Use jQuery.extend here to allow modification of coordinates argument (gh-1848)
				options = options.call( elem, i, jQuery.extend( {}, curOffset ) );
			}
	
			if ( options.top != null ) {
				props.top = ( options.top - curOffset.top ) + curTop;
			}
			if ( options.left != null ) {
				props.left = ( options.left - curOffset.left ) + curLeft;
			}
	
			if ( "using" in options ) {
				options.using.call( elem, props );
	
			} else {
				curElem.css( props );
			}
		}
	};
	
	jQuery.fn.extend( {
	
		// offset() relates an element's border box to the document origin
		offset: function( options ) {
	
			// Preserve chaining for setter
			if ( arguments.length ) {
				return options === undefined ?
					this :
					this.each( function( i ) {
						jQuery.offset.setOffset( this, options, i );
					} );
			}
	
			var rect, win,
				elem = this[ 0 ];
	
			if ( !elem ) {
				return;
			}
	
			// Return zeros for disconnected and hidden (display: none) elements (gh-2310)
			// Support: IE <=11 only
			// Running getBoundingClientRect on a
			// disconnected node in IE throws an error
			if ( !elem.getClientRects().length ) {
				return { top: 0, left: 0 };
			}
	
			// Get document-relative position by adding viewport scroll to viewport-relative gBCR
			rect = elem.getBoundingClientRect();
			win = elem.ownerDocument.defaultView;
			return {
				top: rect.top + win.pageYOffset,
				left: rect.left + win.pageXOffset
			};
		},
	
		// position() relates an element's margin box to its offset parent's padding box
		// This corresponds to the behavior of CSS absolute positioning
		position: function() {
			if ( !this[ 0 ] ) {
				return;
			}
	
			var offsetParent, offset, doc,
				elem = this[ 0 ],
				parentOffset = { top: 0, left: 0 };
	
			// position:fixed elements are offset from the viewport, which itself always has zero offset
			if ( jQuery.css( elem, "position" ) === "fixed" ) {
	
				// Assume position:fixed implies availability of getBoundingClientRect
				offset = elem.getBoundingClientRect();
	
			} else {
				offset = this.offset();
	
				// Account for the *real* offset parent, which can be the document or its root element
				// when a statically positioned element is identified
				doc = elem.ownerDocument;
				offsetParent = elem.offsetParent || doc.documentElement;
				while ( offsetParent &&
					( offsetParent === doc.body || offsetParent === doc.documentElement ) &&
					jQuery.css( offsetParent, "position" ) === "static" ) {
	
					offsetParent = offsetParent.parentNode;
				}
				if ( offsetParent && offsetParent !== elem && offsetParent.nodeType === 1 ) {
	
					// Incorporate borders into its offset, since they are outside its content origin
					parentOffset = jQuery( offsetParent ).offset();
					parentOffset.top += jQuery.css( offsetParent, "borderTopWidth", true );
					parentOffset.left += jQuery.css( offsetParent, "borderLeftWidth", true );
				}
			}
	
			// Subtract parent offsets and element margins
			return {
				top: offset.top - parentOffset.top - jQuery.css( elem, "marginTop", true ),
				left: offset.left - parentOffset.left - jQuery.css( elem, "marginLeft", true )
			};
		},
	
		// This method will return documentElement in the following cases:
		// 1) For the element inside the iframe without offsetParent, this method will return
		//    documentElement of the parent window
		// 2) For the hidden or detached element
		// 3) For body or html element, i.e. in case of the html node - it will return itself
		//
		// but those exceptions were never presented as a real life use-cases
		// and might be considered as more preferable results.
		//
		// This logic, however, is not guaranteed and can change at any point in the future
		offsetParent: function() {
			return this.map( function() {
				var offsetParent = this.offsetParent;
	
				while ( offsetParent && jQuery.css( offsetParent, "position" ) === "static" ) {
					offsetParent = offsetParent.offsetParent;
				}
	
				return offsetParent || documentElement;
			} );
		}
	} );
	
	// Create scrollLeft and scrollTop methods
	jQuery.each( { scrollLeft: "pageXOffset", scrollTop: "pageYOffset" }, function( method, prop ) {
		var top = "pageYOffset" === prop;
	
		jQuery.fn[ method ] = function( val ) {
			return access( this, function( elem, method, val ) {
	
				// Coalesce documents and windows
				var win;
				if ( isWindow( elem ) ) {
					win = elem;
				} else if ( elem.nodeType === 9 ) {
					win = elem.defaultView;
				}
	
				if ( val === undefined ) {
					return win ? win[ prop ] : elem[ method ];
				}
	
				if ( win ) {
					win.scrollTo(
						!top ? val : win.pageXOffset,
						top ? val : win.pageYOffset
					);
	
				} else {
					elem[ method ] = val;
				}
			}, method, val, arguments.length );
		};
	} );
	
	// Support: Safari <=7 - 9.1, Chrome <=37 - 49
	// Add the top/left cssHooks using jQuery.fn.position
	// Webkit bug: https://bugs.webkit.org/show_bug.cgi?id=29084
	// Blink bug: https://bugs.chromium.org/p/chromium/issues/detail?id=589347
	// getComputedStyle returns percent when specified for top/left/bottom/right;
	// rather than make the css module depend on the offset module, just check for it here
	jQuery.each( [ "top", "left" ], function( _i, prop ) {
		jQuery.cssHooks[ prop ] = addGetHookIf( support.pixelPosition,
			function( elem, computed ) {
				if ( computed ) {
					computed = curCSS( elem, prop );
	
					// If curCSS returns percentage, fallback to offset
					return rnumnonpx.test( computed ) ?
						jQuery( elem ).position()[ prop ] + "px" :
						computed;
				}
			}
		);
	} );
	
	
	// Create innerHeight, innerWidth, height, width, outerHeight and outerWidth methods
	jQuery.each( { Height: "height", Width: "width" }, function( name, type ) {
		jQuery.each( {
			padding: "inner" + name,
			content: type,
			"": "outer" + name
		}, function( defaultExtra, funcName ) {
	
			// Margin is only for outerHeight, outerWidth
			jQuery.fn[ funcName ] = function( margin, value ) {
				var chainable = arguments.length && ( defaultExtra || typeof margin !== "boolean" ),
					extra = defaultExtra || ( margin === true || value === true ? "margin" : "border" );
	
				return access( this, function( elem, type, value ) {
					var doc;
	
					if ( isWindow( elem ) ) {
	
						// $( window ).outerWidth/Height return w/h including scrollbars (gh-1729)
						return funcName.indexOf( "outer" ) === 0 ?
							elem[ "inner" + name ] :
							elem.document.documentElement[ "client" + name ];
					}
	
					// Get document width or height
					if ( elem.nodeType === 9 ) {
						doc = elem.documentElement;
	
						// Either scroll[Width/Height] or offset[Width/Height] or client[Width/Height],
						// whichever is greatest
						return Math.max(
							elem.body[ "scroll" + name ], doc[ "scroll" + name ],
							elem.body[ "offset" + name ], doc[ "offset" + name ],
							doc[ "client" + name ]
						);
					}
	
					return value === undefined ?
	
						// Get width or height on the element, requesting but not forcing parseFloat
						jQuery.css( elem, type, extra ) :
	
						// Set width or height on the element
						jQuery.style( elem, type, value, extra );
				}, type, chainable ? margin : undefined, chainable );
			};
		} );
	} );
	
	
	jQuery.each( [
		"ajaxStart",
		"ajaxStop",
		"ajaxComplete",
		"ajaxError",
		"ajaxSuccess",
		"ajaxSend"
	], function( _i, type ) {
		jQuery.fn[ type ] = function( fn ) {
			return this.on( type, fn );
		};
	} );
	
	
	
	
	jQuery.fn.extend( {
	
		bind: function( types, data, fn ) {
			return this.on( types, null, data, fn );
		},
		unbind: function( types, fn ) {
			return this.off( types, null, fn );
		},
	
		delegate: function( selector, types, data, fn ) {
			return this.on( types, selector, data, fn );
		},
		undelegate: function( selector, types, fn ) {
	
			// ( namespace ) or ( selector, types [, fn] )
			return arguments.length === 1 ?
				this.off( selector, "**" ) :
				this.off( types, selector || "**", fn );
		},
	
		hover: function( fnOver, fnOut ) {
			return this.mouseenter( fnOver ).mouseleave( fnOut || fnOver );
		}
	} );
	
	jQuery.each(
		( "blur focus focusin focusout resize scroll click dblclick " +
		"mousedown mouseup mousemove mouseover mouseout mouseenter mouseleave " +
		"change select submit keydown keypress keyup contextmenu" ).split( " " ),
		function( _i, name ) {
	
			// Handle event binding
			jQuery.fn[ name ] = function( data, fn ) {
				return arguments.length > 0 ?
					this.on( name, null, data, fn ) :
					this.trigger( name );
			};
		}
	);
	
	
	
	
	// Support: Android <=4.0 only
	// Make sure we trim BOM and NBSP
	var rtrim = /^[\s\uFEFF\xA0]+|[\s\uFEFF\xA0]+$/g;
	
	// Bind a function to a context, optionally partially applying any
	// arguments.
	// jQuery.proxy is deprecated to promote standards (specifically Function#bind)
	// However, it is not slated for removal any time soon
	jQuery.proxy = function( fn, context ) {
		var tmp, args, proxy;
	
		if ( typeof context === "string" ) {
			tmp = fn[ context ];
			context = fn;
			fn = tmp;
		}
	
		// Quick check to determine if target is callable, in the spec
		// this throws a TypeError, but we will just return undefined.
		if ( !isFunction( fn ) ) {
			return undefined;
		}
	
		// Simulated bind
		args = slice.call( arguments, 2 );
		proxy = function() {
			return fn.apply( context || this, args.concat( slice.call( arguments ) ) );
		};
	
		// Set the guid of unique handler to the same of original handler, so it can be removed
		proxy.guid = fn.guid = fn.guid || jQuery.guid++;
	
		return proxy;
	};
	
	jQuery.holdReady = function( hold ) {
		if ( hold ) {
			jQuery.readyWait++;
		} else {
			jQuery.ready( true );
		}
	};
	jQuery.isArray = Array.isArray;
	jQuery.parseJSON = JSON.parse;
	jQuery.nodeName = nodeName;
	jQuery.isFunction = isFunction;
	jQuery.isWindow = isWindow;
	jQuery.camelCase = camelCase;
	jQuery.type = toType;
	
	jQuery.now = Date.now;
	
	jQuery.isNumeric = function( obj ) {
	
		// As of jQuery 3.0, isNumeric is limited to
		// strings and numbers (primitives or objects)
		// that can be coerced to finite numbers (gh-2662)
		var type = jQuery.type( obj );
		return ( type === "number" || type === "string" ) &&
	
			// parseFloat NaNs numeric-cast false positives ("")
			// ...but misinterprets leading-number strings, particularly hex literals ("0x...")
			// subtraction forces infinities to NaN
			!isNaN( obj - parseFloat( obj ) );
	};
	
	jQuery.trim = function( text ) {
		return text == null ?
			"" :
			( text + "" ).replace( rtrim, "" );
	};
	
	
	
	// Register as a named AMD module, since jQuery can be concatenated with other
	// files that may use define, but not via a proper concatenation script that
	// understands anonymous AMD modules. A named AMD is safest and most robust
	// way to register. Lowercase jquery is used because AMD module names are
	// derived from file names, and jQuery is normally delivered in a lowercase
	// file name. Do this after creating the global so that if an AMD module wants
	// to call noConflict to hide this version of jQuery, it will work.
	
	// Note that for maximum portability, libraries that are not jQuery should
	// declare themselves as anonymous modules, and avoid setting a global if an
	// AMD loader is present. jQuery is a special case. For more information, see
	// https://github.com/jrburke/requirejs/wiki/Updating-existing-libraries#wiki-anon
	
	if ( true ) {
		!(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_RESULT__ = function() {
			return jQuery;
		}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	}
	
	
	
	
	var
	
		// Map over jQuery in case of overwrite
		_jQuery = window.jQuery,
	
		// Map over the $ in case of overwrite
		_$ = window.$;
	
	jQuery.noConflict = function( deep ) {
		if ( window.$ === jQuery ) {
			window.$ = _$;
		}
	
		if ( deep && window.jQuery === jQuery ) {
			window.jQuery = _jQuery;
		}
	
		return jQuery;
	};
	
	// Expose jQuery and $ identifiers, even in AMD
	// (#7102#comment:10, https://github.com/jquery/jquery/pull/557)
	// and CommonJS for browser emulators (#13566)
	if ( typeof noGlobal === "undefined" ) {
		window.jQuery = window.$ = jQuery;
	}
	
	
	
	
	return jQuery;
	} );


/***/ }),
/* 3 */
/***/ (function(module, exports) {

	/*
	This lazySizes extension adds better support for print.
	In case the user starts to print lazysizes will load all images.
	*/
	(function(window){
		/*jshint eqnull:true */
		'use strict';
		var config, elements, onprint, printMedia;
		// see also: http://tjvantoll.com/2012/06/15/detecting-print-requests-with-javascript/
		if(window.addEventListener){
			config = (window.lazySizes && lazySizes.cfg) || window.lazySizesConfig || {};
			elements = config.lazyClass || 'lazyload';
			onprint = function(){
				var i, len;
				if(typeof elements == 'string'){
					elements = document.getElementsByClassName(elements);
				}
	
				if(window.lazySizes){
					for(i = 0, len = elements.length; i < len; i++){
						lazySizes.loader.unveil(elements[i]);
					}
				}
			};
	
			addEventListener('beforeprint', onprint, false);
	
			if(!('onbeforeprint' in window) && window.matchMedia && (printMedia = matchMedia('print')) && printMedia.addListener){
				printMedia.addListener(function(){
					if(printMedia.matches){
						onprint();
					}
				});
			}
		}
	})(window);


/***/ }),
/* 4 */
/***/ (function(module, exports) {

	(function(window, factory) {
		var lazySizes = factory(window, window.document);
		window.lazySizes = lazySizes;
		if(typeof module == 'object' && module.exports){
			module.exports = lazySizes;
		}
	}(window, function l(window, document) {
		'use strict';
		/*jshint eqnull:true */
		if(!document.getElementsByClassName){return;}
	
		var lazySizesConfig;
	
		var docElem = document.documentElement;
	
		var Date = window.Date;
	
		var supportPicture = window.HTMLPictureElement;
	
		var _addEventListener = 'addEventListener';
	
		var _getAttribute = 'getAttribute';
	
		var addEventListener = window[_addEventListener];
	
		var setTimeout = window.setTimeout;
	
		var requestAnimationFrame = window.requestAnimationFrame || setTimeout;
	
		var requestIdleCallback = window.requestIdleCallback;
	
		var regPicture = /^picture$/i;
	
		var loadEvents = ['load', 'error', 'lazyincluded', '_lazyloaded'];
	
		var regClassCache = {};
	
		var forEach = Array.prototype.forEach;
	
		var hasClass = function(ele, cls) {
			if(!regClassCache[cls]){
				regClassCache[cls] = new RegExp('(\\s|^)'+cls+'(\\s|$)');
			}
			return regClassCache[cls].test(ele[_getAttribute]('class') || '') && regClassCache[cls];
		};
	
		var addClass = function(ele, cls) {
			if (!hasClass(ele, cls)){
				ele.setAttribute('class', (ele[_getAttribute]('class') || '').trim() + ' ' + cls);
			}
		};
	
		var removeClass = function(ele, cls) {
			var reg;
			if ((reg = hasClass(ele,cls))) {
				ele.setAttribute('class', (ele[_getAttribute]('class') || '').replace(reg, ' '));
			}
		};
	
		var addRemoveLoadEvents = function(dom, fn, add){
			var action = add ? _addEventListener : 'removeEventListener';
			if(add){
				addRemoveLoadEvents(dom, fn);
			}
			loadEvents.forEach(function(evt){
				dom[action](evt, fn);
			});
		};
	
		var triggerEvent = function(elem, name, detail, noBubbles, noCancelable){
			var event = document.createEvent('CustomEvent');
	
			event.initCustomEvent(name, !noBubbles, !noCancelable, detail || {});
	
			elem.dispatchEvent(event);
			return event;
		};
	
		var updatePolyfill = function (el, full){
			var polyfill;
			if( !supportPicture && ( polyfill = (window.picturefill || lazySizesConfig.pf) ) ){
				polyfill({reevaluate: true, elements: [el]});
			} else if(full && full.src){
				el.src = full.src;
			}
		};
	
		var getCSS = function (elem, style){
			return (getComputedStyle(elem, null) || {})[style];
		};
	
		var getWidth = function(elem, parent, width){
			width = width || elem.offsetWidth;
	
			while(width < lazySizesConfig.minSize && parent && !elem._lazysizesWidth){
				width =  parent.offsetWidth;
				parent = parent.parentNode;
			}
	
			return width;
		};
	
		var rAF = (function(){
			var running, waiting;
			var fns = [];
	
			var run = function(){
				var fn;
				running = true;
				waiting = false;
				while(fns.length){
					fn = fns.shift();
					fn[0].apply(fn[1], fn[2]);
				}
				running = false;
			};
	
			var rafBatch = function(fn){
				if(running){
					fn.apply(this, arguments);
				} else {
					fns.push([fn, this, arguments]);
	
					if(!waiting){
						waiting = true;
						(document.hidden ? setTimeout : requestAnimationFrame)(run);
					}
				}
			};
	
			rafBatch._lsFlush = run;
	
			return rafBatch;
		})();
	
		var rAFIt = function(fn, simple){
			return simple ?
				function() {
					rAF(fn);
				} :
				function(){
					var that = this;
					var args = arguments;
					rAF(function(){
						fn.apply(that, args);
					});
				}
			;
		};
	
		var throttle = function(fn){
			var running;
			var lastTime = 0;
			var gDelay = 125;
			var RIC_DEFAULT_TIMEOUT = 666;
			var rICTimeout = RIC_DEFAULT_TIMEOUT;
			var run = function(){
				running = false;
				lastTime = Date.now();
				fn();
			};
			var idleCallback = requestIdleCallback ?
				function(){
					requestIdleCallback(run, {timeout: rICTimeout});
					if(rICTimeout !== RIC_DEFAULT_TIMEOUT){
						rICTimeout = RIC_DEFAULT_TIMEOUT;
					}
				}:
				rAFIt(function(){
					setTimeout(run);
				}, true)
			;
	
			return function(isPriority){
				var delay;
				if((isPriority = isPriority === true)){
					rICTimeout = 44;
				}
	
				if(running){
					return;
				}
	
				running =  true;
	
				delay = gDelay - (Date.now() - lastTime);
	
				if(delay < 0){
					delay = 0;
				}
	
				if(isPriority || (delay < 9 && requestIdleCallback)){
					idleCallback();
				} else {
					setTimeout(idleCallback, delay);
				}
			};
		};
	
		//based on http://modernjavascript.blogspot.de/2013/08/building-better-debounce.html
		var debounce = function(func) {
			var timeout, timestamp;
			var wait = 99;
			var run = function(){
				timeout = null;
				func();
			};
			var later = function() {
				var last = Date.now() - timestamp;
	
				if (last < wait) {
					setTimeout(later, wait - last);
				} else {
					(requestIdleCallback || run)(run);
				}
			};
	
			return function() {
				timestamp = Date.now();
	
				if (!timeout) {
					timeout = setTimeout(later, wait);
				}
			};
		};
	
	
		var loader = (function(){
			var lazyloadElems, preloadElems, isCompleted, resetPreloadingTimer, loadMode, started;
	
			var eLvW, elvH, eLtop, eLleft, eLright, eLbottom;
	
			var defaultExpand, preloadExpand, hFac;
	
			var regImg = /^img$/i;
			var regIframe = /^iframe$/i;
	
			var supportScroll = ('onscroll' in window) && !(/glebot/.test(navigator.userAgent));
	
			var shrinkExpand = 0;
			var currentExpand = 0;
	
			var isLoading = 0;
			var lowRuns = -1;
	
			var resetPreloading = function(e){
				isLoading--;
				if(e && e.target){
					addRemoveLoadEvents(e.target, resetPreloading);
				}
	
				if(!e || isLoading < 0 || !e.target){
					isLoading = 0;
				}
			};
	
			var isNestedVisible = function(elem, elemExpand){
				var outerRect;
				var parent = elem;
				var visible = getCSS(document.body, 'visibility') == 'hidden' || getCSS(elem, 'visibility') != 'hidden';
	
				eLtop -= elemExpand;
				eLbottom += elemExpand;
				eLleft -= elemExpand;
				eLright += elemExpand;
	
				while(visible && (parent = parent.offsetParent) && parent != document.body && parent != docElem){
					visible = ((getCSS(parent, 'opacity') || 1) > 0);
	
					if(visible && getCSS(parent, 'overflow') != 'visible'){
						outerRect = parent.getBoundingClientRect();
						visible = eLright > outerRect.left &&
							eLleft < outerRect.right &&
							eLbottom > outerRect.top - 1 &&
							eLtop < outerRect.bottom + 1
						;
					}
				}
	
				return visible;
			};
	
			var checkElements = function() {
				var eLlen, i, rect, autoLoadElem, loadedSomething, elemExpand, elemNegativeExpand, elemExpandVal, beforeExpandVal;
	
				if((loadMode = lazySizesConfig.loadMode) && isLoading < 8 && (eLlen = lazyloadElems.length)){
	
					i = 0;
	
					lowRuns++;
	
					if(preloadExpand == null){
						if(!('expand' in lazySizesConfig)){
							lazySizesConfig.expand = docElem.clientHeight > 500 && docElem.clientWidth > 500 ? 500 : 370;
						}
	
						defaultExpand = lazySizesConfig.expand;
						preloadExpand = defaultExpand * lazySizesConfig.expFactor;
					}
	
					if(currentExpand < preloadExpand && isLoading < 1 && lowRuns > 2 && loadMode > 2 && !document.hidden){
						currentExpand = preloadExpand;
						lowRuns = 0;
					} else if(loadMode > 1 && lowRuns > 1 && isLoading < 6){
						currentExpand = defaultExpand;
					} else {
						currentExpand = shrinkExpand;
					}
	
					for(; i < eLlen; i++){
	
						if(!lazyloadElems[i] || lazyloadElems[i]._lazyRace){continue;}
	
						if(!supportScroll){unveilElement(lazyloadElems[i]);continue;}
	
						if(!(elemExpandVal = lazyloadElems[i][_getAttribute]('data-expand')) || !(elemExpand = elemExpandVal * 1)){
							elemExpand = currentExpand;
						}
	
						if(beforeExpandVal !== elemExpand){
							eLvW = innerWidth + (elemExpand * hFac);
							elvH = innerHeight + elemExpand;
							elemNegativeExpand = elemExpand * -1;
							beforeExpandVal = elemExpand;
						}
	
						rect = lazyloadElems[i].getBoundingClientRect();
	
						if ((eLbottom = rect.bottom) >= elemNegativeExpand &&
							(eLtop = rect.top) <= elvH &&
							(eLright = rect.right) >= elemNegativeExpand * hFac &&
							(eLleft = rect.left) <= eLvW &&
							(eLbottom || eLright || eLleft || eLtop) &&
							((isCompleted && isLoading < 3 && !elemExpandVal && (loadMode < 3 || lowRuns < 4)) || isNestedVisible(lazyloadElems[i], elemExpand))){
							unveilElement(lazyloadElems[i]);
							loadedSomething = true;
							if(isLoading > 9){break;}
						} else if(!loadedSomething && isCompleted && !autoLoadElem &&
							isLoading < 4 && lowRuns < 4 && loadMode > 2 &&
							(preloadElems[0] || lazySizesConfig.preloadAfterLoad) &&
							(preloadElems[0] || (!elemExpandVal && ((eLbottom || eLright || eLleft || eLtop) || lazyloadElems[i][_getAttribute](lazySizesConfig.sizesAttr) != 'auto')))){
							autoLoadElem = preloadElems[0] || lazyloadElems[i];
						}
					}
	
					if(autoLoadElem && !loadedSomething){
						unveilElement(autoLoadElem);
					}
				}
			};
	
			var throttledCheckElements = throttle(checkElements);
	
			var switchLoadingClass = function(e){
				addClass(e.target, lazySizesConfig.loadedClass);
				removeClass(e.target, lazySizesConfig.loadingClass);
				addRemoveLoadEvents(e.target, rafSwitchLoadingClass);
			};
			var rafedSwitchLoadingClass = rAFIt(switchLoadingClass);
			var rafSwitchLoadingClass = function(e){
				rafedSwitchLoadingClass({target: e.target});
			};
	
			var changeIframeSrc = function(elem, src){
				try {
					elem.contentWindow.location.replace(src);
				} catch(e){
					elem.src = src;
				}
			};
	
			var handleSources = function(source){
				var customMedia, parent;
	
				var sourceSrcset = source[_getAttribute](lazySizesConfig.srcsetAttr);
	
				if( (customMedia = lazySizesConfig.customMedia[source[_getAttribute]('data-media') || source[_getAttribute]('media')]) ){
					source.setAttribute('media', customMedia);
				}
	
				if(sourceSrcset){
					source.setAttribute('srcset', sourceSrcset);
				}
	
				//https://bugzilla.mozilla.org/show_bug.cgi?id=1170572
				if(customMedia){
					parent = source.parentNode;
					parent.insertBefore(source.cloneNode(), source);
					parent.removeChild(source);
				}
			};
	
			var lazyUnveil = rAFIt(function (elem, detail, isAuto, sizes, isImg){
				var src, srcset, parent, isPicture, event, firesLoad;
	
				if(!(event = triggerEvent(elem, 'lazybeforeunveil', detail)).defaultPrevented){
	
					if(sizes){
						if(isAuto){
							addClass(elem, lazySizesConfig.autosizesClass);
						} else {
							elem.setAttribute('sizes', sizes);
						}
					}
	
					srcset = elem[_getAttribute](lazySizesConfig.srcsetAttr);
					src = elem[_getAttribute](lazySizesConfig.srcAttr);
	
					if(isImg) {
						parent = elem.parentNode;
						isPicture = parent && regPicture.test(parent.nodeName || '');
					}
	
					firesLoad = detail.firesLoad || (('src' in elem) && (srcset || src || isPicture));
	
					event = {target: elem};
	
					if(firesLoad){
						addRemoveLoadEvents(elem, resetPreloading, true);
						clearTimeout(resetPreloadingTimer);
						resetPreloadingTimer = setTimeout(resetPreloading, 2500);
	
						addClass(elem, lazySizesConfig.loadingClass);
						addRemoveLoadEvents(elem, rafSwitchLoadingClass, true);
					}
	
					if(isPicture){
						forEach.call(parent.getElementsByTagName('source'), handleSources);
					}
	
					if(srcset){
						elem.setAttribute('srcset', srcset);
					} else if(src && !isPicture){
						if(regIframe.test(elem.nodeName)){
							changeIframeSrc(elem, src);
						} else {
							elem.src = src;
						}
					}
	
					if(srcset || isPicture){
						updatePolyfill(elem, {src: src});
					}
				}
	
				rAF(function(){
					if(elem._lazyRace){
						delete elem._lazyRace;
					}
					removeClass(elem, lazySizesConfig.lazyClass);
	
					if( !firesLoad || elem.complete ){
						if(firesLoad){
							resetPreloading(event);
						} else {
							isLoading--;
						}
						switchLoadingClass(event);
					}
				});
			});
	
			var unveilElement = function (elem){
				var detail;
	
				var isImg = regImg.test(elem.nodeName);
	
				//allow using sizes="auto", but don't use. it's invalid. Use data-sizes="auto" or a valid value for sizes instead (i.e.: sizes="80vw")
				var sizes = isImg && (elem[_getAttribute](lazySizesConfig.sizesAttr) || elem[_getAttribute]('sizes'));
				var isAuto = sizes == 'auto';
	
				if( (isAuto || !isCompleted) && isImg && (elem.src || elem.srcset) && !elem.complete && !hasClass(elem, lazySizesConfig.errorClass)){return;}
	
				detail = triggerEvent(elem, 'lazyunveilread').detail;
	
				if(isAuto){
					 autoSizer.updateElem(elem, true, elem.offsetWidth);
				}
	
				elem._lazyRace = true;
				isLoading++;
	
				lazyUnveil(elem, detail, isAuto, sizes, isImg);
			};
	
			var onload = function(){
				if(isCompleted){return;}
				if(Date.now() - started < 999){
					setTimeout(onload, 999);
					return;
				}
				var afterScroll = debounce(function(){
					lazySizesConfig.loadMode = 3;
					throttledCheckElements();
				});
	
				isCompleted = true;
	
				lazySizesConfig.loadMode = 3;
	
				throttledCheckElements();
	
				addEventListener('scroll', function(){
					if(lazySizesConfig.loadMode == 3){
						lazySizesConfig.loadMode = 2;
					}
					afterScroll();
				}, true);
			};
	
			return {
				_: function(){
					started = Date.now();
	
					lazyloadElems = document.getElementsByClassName(lazySizesConfig.lazyClass);
					preloadElems = document.getElementsByClassName(lazySizesConfig.lazyClass + ' ' + lazySizesConfig.preloadClass);
					hFac = lazySizesConfig.hFac;
	
					addEventListener('scroll', throttledCheckElements, true);
	
					addEventListener('resize', throttledCheckElements, true);
	
					if(window.MutationObserver){
						new MutationObserver( throttledCheckElements ).observe( docElem, {childList: true, subtree: true, attributes: true} );
					} else {
						docElem[_addEventListener]('DOMNodeInserted', throttledCheckElements, true);
						docElem[_addEventListener]('DOMAttrModified', throttledCheckElements, true);
						setInterval(throttledCheckElements, 999);
					}
	
					addEventListener('hashchange', throttledCheckElements, true);
	
					//, 'fullscreenchange'
					['focus', 'mouseover', 'click', 'load', 'transitionend', 'animationend', 'webkitAnimationEnd'].forEach(function(name){
						document[_addEventListener](name, throttledCheckElements, true);
					});
	
					if((/d$|^c/.test(document.readyState))){
						onload();
					} else {
						addEventListener('load', onload);
						document[_addEventListener]('DOMContentLoaded', throttledCheckElements);
						setTimeout(onload, 20000);
					}
	
					if(lazyloadElems.length){
						checkElements();
					} else {
						throttledCheckElements();
					}
				},
				checkElems: throttledCheckElements,
				unveil: unveilElement
			};
		})();
	
	
		var autoSizer = (function(){
			var autosizesElems;
	
			var sizeElement = rAFIt(function(elem, parent, event, width){
				var sources, i, len;
				elem._lazysizesWidth = width;
				width += 'px';
	
				elem.setAttribute('sizes', width);
	
				if(regPicture.test(parent.nodeName || '')){
					sources = parent.getElementsByTagName('source');
					for(i = 0, len = sources.length; i < len; i++){
						sources[i].setAttribute('sizes', width);
					}
				}
	
				if(!event.detail.dataAttr){
					updatePolyfill(elem, event.detail);
				}
			});
			var getSizeElement = function (elem, dataAttr, width){
				var event;
				var parent = elem.parentNode;
	
				if(parent){
					width = getWidth(elem, parent, width);
					event = triggerEvent(elem, 'lazybeforesizes', {width: width, dataAttr: !!dataAttr});
	
					if(!event.defaultPrevented){
						width = event.detail.width;
	
						if(width && width !== elem._lazysizesWidth){
							sizeElement(elem, parent, event, width);
						}
					}
				}
			};
	
			var updateElementsSizes = function(){
				var i;
				var len = autosizesElems.length;
				if(len){
					i = 0;
	
					for(; i < len; i++){
						getSizeElement(autosizesElems[i]);
					}
				}
			};
	
			var debouncedUpdateElementsSizes = debounce(updateElementsSizes);
	
			return {
				_: function(){
					autosizesElems = document.getElementsByClassName(lazySizesConfig.autosizesClass);
					addEventListener('resize', debouncedUpdateElementsSizes);
				},
				checkElems: debouncedUpdateElementsSizes,
				updateElem: getSizeElement
			};
		})();
	
		var init = function(){
			if(!init.i){
				init.i = true;
				autoSizer._();
				loader._();
			}
		};
	
		(function(){
			var prop;
	
			var lazySizesDefaults = {
				lazyClass: 'lazyload',
				loadedClass: 'lazyloaded',
				loadingClass: 'lazyloading',
				preloadClass: 'lazypreload',
				errorClass: 'lazyerror',
				//strictClass: 'lazystrict',
				autosizesClass: 'lazyautosizes',
				srcAttr: 'data-src',
				srcsetAttr: 'data-srcset',
				sizesAttr: 'data-sizes',
				//preloadAfterLoad: false,
				minSize: 40,
				customMedia: {},
				init: true,
				expFactor: 1.5,
				hFac: 0.8,
				loadMode: 2
			};
	
			lazySizesConfig = window.lazySizesConfig || window.lazysizesConfig || {};
	
			for(prop in lazySizesDefaults){
				if(!(prop in lazySizesConfig)){
					lazySizesConfig[prop] = lazySizesDefaults[prop];
				}
			}
	
			window.lazySizesConfig = lazySizesConfig;
	
			setTimeout(function(){
				if(lazySizesConfig.init){
					init();
				}
			});
		})();
	
		return {
			cfg: lazySizesConfig,
			autoSizer: autoSizer,
			loader: loader,
			init: init,
			uP: updatePolyfill,
			aC: addClass,
			rC: removeClass,
			hC: hasClass,
			fire: triggerEvent,
			gW: getWidth,
			rAF: rAF,
		};
	}
	));


/***/ }),
/* 5 */
/***/ (function(module, exports, __webpack_require__) {

	Object.defineProperty(exports, "__esModule", { value: true });
	var tslib_1 = __webpack_require__(6);
	tslib_1.__exportStar(__webpack_require__(7), exports);
	var core_1 = __webpack_require__(14);
	var utils_1 = __webpack_require__(18);
	var BrowserIntegrations = __webpack_require__(62);
	var Transports = __webpack_require__(57);
	exports.Transports = Transports;
	var windowIntegrations = {};
	// This block is needed to add compatibility with the integrations packages when used with a CDN
	var _window = utils_1.getGlobalObject();
	if (_window.Sentry && _window.Sentry.Integrations) {
	    windowIntegrations = _window.Sentry.Integrations;
	}
	var INTEGRATIONS = tslib_1.__assign(tslib_1.__assign(tslib_1.__assign({}, windowIntegrations), core_1.Integrations), BrowserIntegrations);
	exports.Integrations = INTEGRATIONS;
	//# sourceMappingURL=index.js.map

/***/ }),
/* 6 */
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/* WEBPACK VAR INJECTION */(function(global) {/*! *****************************************************************************
	Copyright (c) Microsoft Corporation.
	
	Permission to use, copy, modify, and/or distribute this software for any
	purpose with or without fee is hereby granted.
	
	THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
	REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
	AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
	INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
	LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
	OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
	PERFORMANCE OF THIS SOFTWARE.
	***************************************************************************** */
	
	/* global global, define, System, Reflect, Promise */
	var __extends;
	var __assign;
	var __rest;
	var __decorate;
	var __param;
	var __metadata;
	var __awaiter;
	var __generator;
	var __exportStar;
	var __values;
	var __read;
	var __spread;
	var __spreadArrays;
	var __await;
	var __asyncGenerator;
	var __asyncDelegator;
	var __asyncValues;
	var __makeTemplateObject;
	var __importStar;
	var __importDefault;
	var __classPrivateFieldGet;
	var __classPrivateFieldSet;
	var __createBinding;
	(function (factory) {
	    var root = typeof global === "object" ? global : typeof self === "object" ? self : typeof this === "object" ? this : {};
	    if (true) {
	        !(__WEBPACK_AMD_DEFINE_ARRAY__ = [exports], __WEBPACK_AMD_DEFINE_RESULT__ = function (exports) { factory(createExporter(root, createExporter(exports))); }.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	    }
	    else if (typeof module === "object" && typeof module.exports === "object") {
	        factory(createExporter(root, createExporter(module.exports)));
	    }
	    else {
	        factory(createExporter(root));
	    }
	    function createExporter(exports, previous) {
	        if (exports !== root) {
	            if (typeof Object.create === "function") {
	                Object.defineProperty(exports, "__esModule", { value: true });
	            }
	            else {
	                exports.__esModule = true;
	            }
	        }
	        return function (id, v) { return exports[id] = previous ? previous(id, v) : v; };
	    }
	})
	(function (exporter) {
	    var extendStatics = Object.setPrototypeOf ||
	        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
	        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
	
	    __extends = function (d, b) {
	        extendStatics(d, b);
	        function __() { this.constructor = d; }
	        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	    };
	
	    __assign = Object.assign || function (t) {
	        for (var s, i = 1, n = arguments.length; i < n; i++) {
	            s = arguments[i];
	            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
	        }
	        return t;
	    };
	
	    __rest = function (s, e) {
	        var t = {};
	        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
	            t[p] = s[p];
	        if (s != null && typeof Object.getOwnPropertySymbols === "function")
	            for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
	                if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
	                    t[p[i]] = s[p[i]];
	            }
	        return t;
	    };
	
	    __decorate = function (decorators, target, key, desc) {
	        var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	        if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	        else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	        return c > 3 && r && Object.defineProperty(target, key, r), r;
	    };
	
	    __param = function (paramIndex, decorator) {
	        return function (target, key) { decorator(target, key, paramIndex); }
	    };
	
	    __metadata = function (metadataKey, metadataValue) {
	        if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(metadataKey, metadataValue);
	    };
	
	    __awaiter = function (thisArg, _arguments, P, generator) {
	        function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
	        return new (P || (P = Promise))(function (resolve, reject) {
	            function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
	            function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
	            function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
	            step((generator = generator.apply(thisArg, _arguments || [])).next());
	        });
	    };
	
	    __generator = function (thisArg, body) {
	        var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
	        return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
	        function verb(n) { return function (v) { return step([n, v]); }; }
	        function step(op) {
	            if (f) throw new TypeError("Generator is already executing.");
	            while (_) try {
	                if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
	                if (y = 0, t) op = [op[0] & 2, t.value];
	                switch (op[0]) {
	                    case 0: case 1: t = op; break;
	                    case 4: _.label++; return { value: op[1], done: false };
	                    case 5: _.label++; y = op[1]; op = [0]; continue;
	                    case 7: op = _.ops.pop(); _.trys.pop(); continue;
	                    default:
	                        if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
	                        if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
	                        if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
	                        if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
	                        if (t[2]) _.ops.pop();
	                        _.trys.pop(); continue;
	                }
	                op = body.call(thisArg, _);
	            } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
	            if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
	        }
	    };
	
	    __createBinding = function(o, m, k, k2) {
	        if (k2 === undefined) k2 = k;
	        o[k2] = m[k];
	    };
	
	    __exportStar = function (m, exports) {
	        for (var p in m) if (p !== "default" && !exports.hasOwnProperty(p)) exports[p] = m[p];
	    };
	
	    __values = function (o) {
	        var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
	        if (m) return m.call(o);
	        if (o && typeof o.length === "number") return {
	            next: function () {
	                if (o && i >= o.length) o = void 0;
	                return { value: o && o[i++], done: !o };
	            }
	        };
	        throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
	    };
	
	    __read = function (o, n) {
	        var m = typeof Symbol === "function" && o[Symbol.iterator];
	        if (!m) return o;
	        var i = m.call(o), r, ar = [], e;
	        try {
	            while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
	        }
	        catch (error) { e = { error: error }; }
	        finally {
	            try {
	                if (r && !r.done && (m = i["return"])) m.call(i);
	            }
	            finally { if (e) throw e.error; }
	        }
	        return ar;
	    };
	
	    __spread = function () {
	        for (var ar = [], i = 0; i < arguments.length; i++)
	            ar = ar.concat(__read(arguments[i]));
	        return ar;
	    };
	
	    __spreadArrays = function () {
	        for (var s = 0, i = 0, il = arguments.length; i < il; i++) s += arguments[i].length;
	        for (var r = Array(s), k = 0, i = 0; i < il; i++)
	            for (var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)
	                r[k] = a[j];
	        return r;
	    };
	
	    __await = function (v) {
	        return this instanceof __await ? (this.v = v, this) : new __await(v);
	    };
	
	    __asyncGenerator = function (thisArg, _arguments, generator) {
	        if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
	        var g = generator.apply(thisArg, _arguments || []), i, q = [];
	        return i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function () { return this; }, i;
	        function verb(n) { if (g[n]) i[n] = function (v) { return new Promise(function (a, b) { q.push([n, v, a, b]) > 1 || resume(n, v); }); }; }
	        function resume(n, v) { try { step(g[n](v)); } catch (e) { settle(q[0][3], e); } }
	        function step(r) { r.value instanceof __await ? Promise.resolve(r.value.v).then(fulfill, reject) : settle(q[0][2], r);  }
	        function fulfill(value) { resume("next", value); }
	        function reject(value) { resume("throw", value); }
	        function settle(f, v) { if (f(v), q.shift(), q.length) resume(q[0][0], q[0][1]); }
	    };
	
	    __asyncDelegator = function (o) {
	        var i, p;
	        return i = {}, verb("next"), verb("throw", function (e) { throw e; }), verb("return"), i[Symbol.iterator] = function () { return this; }, i;
	        function verb(n, f) { i[n] = o[n] ? function (v) { return (p = !p) ? { value: __await(o[n](v)), done: n === "return" } : f ? f(v) : v; } : f; }
	    };
	
	    __asyncValues = function (o) {
	        if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
	        var m = o[Symbol.asyncIterator], i;
	        return m ? m.call(o) : (o = typeof __values === "function" ? __values(o) : o[Symbol.iterator](), i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function () { return this; }, i);
	        function verb(n) { i[n] = o[n] && function (v) { return new Promise(function (resolve, reject) { v = o[n](v), settle(resolve, reject, v.done, v.value); }); }; }
	        function settle(resolve, reject, d, v) { Promise.resolve(v).then(function(v) { resolve({ value: v, done: d }); }, reject); }
	    };
	
	    __makeTemplateObject = function (cooked, raw) {
	        if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
	        return cooked;
	    };
	
	    __importStar = function (mod) {
	        if (mod && mod.__esModule) return mod;
	        var result = {};
	        if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
	        result["default"] = mod;
	        return result;
	    };
	
	    __importDefault = function (mod) {
	        return (mod && mod.__esModule) ? mod : { "default": mod };
	    };
	
	    __classPrivateFieldGet = function (receiver, privateMap) {
	        if (!privateMap.has(receiver)) {
	            throw new TypeError("attempted to get private field on non-instance");
	        }
	        return privateMap.get(receiver);
	    };
	
	    __classPrivateFieldSet = function (receiver, privateMap, value) {
	        if (!privateMap.has(receiver)) {
	            throw new TypeError("attempted to set private field on non-instance");
	        }
	        privateMap.set(receiver, value);
	        return value;
	    };
	
	    exporter("__extends", __extends);
	    exporter("__assign", __assign);
	    exporter("__rest", __rest);
	    exporter("__decorate", __decorate);
	    exporter("__param", __param);
	    exporter("__metadata", __metadata);
	    exporter("__awaiter", __awaiter);
	    exporter("__generator", __generator);
	    exporter("__exportStar", __exportStar);
	    exporter("__createBinding", __createBinding);
	    exporter("__values", __values);
	    exporter("__read", __read);
	    exporter("__spread", __spread);
	    exporter("__spreadArrays", __spreadArrays);
	    exporter("__await", __await);
	    exporter("__asyncGenerator", __asyncGenerator);
	    exporter("__asyncDelegator", __asyncDelegator);
	    exporter("__asyncValues", __asyncValues);
	    exporter("__makeTemplateObject", __makeTemplateObject);
	    exporter("__importStar", __importStar);
	    exporter("__importDefault", __importDefault);
	    exporter("__classPrivateFieldGet", __classPrivateFieldGet);
	    exporter("__classPrivateFieldSet", __classPrivateFieldSet);
	});
	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ }),
/* 7 */
/***/ (function(module, exports, __webpack_require__) {

	Object.defineProperty(exports, "__esModule", { value: true });
	var types_1 = __webpack_require__(8);
	exports.Severity = types_1.Severity;
	exports.Status = types_1.Status;
	var core_1 = __webpack_require__(14);
	exports.addGlobalEventProcessor = core_1.addGlobalEventProcessor;
	exports.addBreadcrumb = core_1.addBreadcrumb;
	exports.captureException = core_1.captureException;
	exports.captureEvent = core_1.captureEvent;
	exports.captureMessage = core_1.captureMessage;
	exports.configureScope = core_1.configureScope;
	exports.getHubFromCarrier = core_1.getHubFromCarrier;
	exports.getCurrentHub = core_1.getCurrentHub;
	exports.Hub = core_1.Hub;
	exports.makeMain = core_1.makeMain;
	exports.Scope = core_1.Scope;
	exports.startTransaction = core_1.startTransaction;
	exports.setContext = core_1.setContext;
	exports.setExtra = core_1.setExtra;
	exports.setExtras = core_1.setExtras;
	exports.setTag = core_1.setTag;
	exports.setTags = core_1.setTags;
	exports.setUser = core_1.setUser;
	exports.withScope = core_1.withScope;
	var client_1 = __webpack_require__(52);
	exports.BrowserClient = client_1.BrowserClient;
	var helpers_1 = __webpack_require__(61);
	exports.injectReportDialog = helpers_1.injectReportDialog;
	var eventbuilder_1 = __webpack_require__(54);
	exports.eventFromException = eventbuilder_1.eventFromException;
	exports.eventFromMessage = eventbuilder_1.eventFromMessage;
	var sdk_1 = __webpack_require__(69);
	exports.defaultIntegrations = sdk_1.defaultIntegrations;
	exports.forceLoad = sdk_1.forceLoad;
	exports.init = sdk_1.init;
	exports.lastEventId = sdk_1.lastEventId;
	exports.onLoad = sdk_1.onLoad;
	exports.showReportDialog = sdk_1.showReportDialog;
	exports.flush = sdk_1.flush;
	exports.close = sdk_1.close;
	exports.wrap = sdk_1.wrap;
	var version_1 = __webpack_require__(68);
	exports.SDK_NAME = version_1.SDK_NAME;
	exports.SDK_VERSION = version_1.SDK_VERSION;
	//# sourceMappingURL=exports.js.map

/***/ }),
/* 8 */
/***/ (function(module, exports, __webpack_require__) {

	Object.defineProperty(exports, "__esModule", { value: true });
	var loglevel_1 = __webpack_require__(9);
	exports.LogLevel = loglevel_1.LogLevel;
	var session_1 = __webpack_require__(10);
	exports.SessionStatus = session_1.SessionStatus;
	var severity_1 = __webpack_require__(11);
	exports.Severity = severity_1.Severity;
	var status_1 = __webpack_require__(12);
	exports.Status = status_1.Status;
	var transaction_1 = __webpack_require__(13);
	exports.TransactionSamplingMethod = transaction_1.TransactionSamplingMethod;
	//# sourceMappingURL=index.js.map

/***/ }),
/* 9 */
/***/ (function(module, exports) {

	Object.defineProperty(exports, "__esModule", { value: true });
	/** Console logging verbosity for the SDK. */
	var LogLevel;
	(function (LogLevel) {
	    /** No logs will be generated. */
	    LogLevel[LogLevel["None"] = 0] = "None";
	    /** Only SDK internal errors will be logged. */
	    LogLevel[LogLevel["Error"] = 1] = "Error";
	    /** Information useful for debugging the SDK will be logged. */
	    LogLevel[LogLevel["Debug"] = 2] = "Debug";
	    /** All SDK actions will be logged. */
	    LogLevel[LogLevel["Verbose"] = 3] = "Verbose";
	})(LogLevel = exports.LogLevel || (exports.LogLevel = {}));
	//# sourceMappingURL=loglevel.js.map

/***/ }),
/* 10 */
/***/ (function(module, exports) {

	Object.defineProperty(exports, "__esModule", { value: true });
	/**
	 * Session Status
	 */
	var SessionStatus;
	(function (SessionStatus) {
	    /** JSDoc */
	    SessionStatus["Ok"] = "ok";
	    /** JSDoc */
	    SessionStatus["Exited"] = "exited";
	    /** JSDoc */
	    SessionStatus["Crashed"] = "crashed";
	    /** JSDoc */
	    SessionStatus["Abnormal"] = "abnormal";
	})(SessionStatus = exports.SessionStatus || (exports.SessionStatus = {}));
	//# sourceMappingURL=session.js.map

/***/ }),
/* 11 */
/***/ (function(module, exports) {

	Object.defineProperty(exports, "__esModule", { value: true });
	/** JSDoc */
	// eslint-disable-next-line import/export
	var Severity;
	(function (Severity) {
	    /** JSDoc */
	    Severity["Fatal"] = "fatal";
	    /** JSDoc */
	    Severity["Error"] = "error";
	    /** JSDoc */
	    Severity["Warning"] = "warning";
	    /** JSDoc */
	    Severity["Log"] = "log";
	    /** JSDoc */
	    Severity["Info"] = "info";
	    /** JSDoc */
	    Severity["Debug"] = "debug";
	    /** JSDoc */
	    Severity["Critical"] = "critical";
	})(Severity = exports.Severity || (exports.Severity = {}));
	// eslint-disable-next-line @typescript-eslint/no-namespace, import/export
	(function (Severity) {
	    /**
	     * Converts a string-based level into a {@link Severity}.
	     *
	     * @param level string representation of Severity
	     * @returns Severity
	     */
	    function fromString(level) {
	        switch (level) {
	            case 'debug':
	                return Severity.Debug;
	            case 'info':
	                return Severity.Info;
	            case 'warn':
	            case 'warning':
	                return Severity.Warning;
	            case 'error':
	                return Severity.Error;
	            case 'fatal':
	                return Severity.Fatal;
	            case 'critical':
	                return Severity.Critical;
	            case 'log':
	            default:
	                return Severity.Log;
	        }
	    }
	    Severity.fromString = fromString;
	})(Severity = exports.Severity || (exports.Severity = {}));
	//# sourceMappingURL=severity.js.map

/***/ }),
/* 12 */
/***/ (function(module, exports) {

	Object.defineProperty(exports, "__esModule", { value: true });
	/** The status of an event. */
	// eslint-disable-next-line import/export
	var Status;
	(function (Status) {
	    /** The status could not be determined. */
	    Status["Unknown"] = "unknown";
	    /** The event was skipped due to configuration or callbacks. */
	    Status["Skipped"] = "skipped";
	    /** The event was sent to Sentry successfully. */
	    Status["Success"] = "success";
	    /** The client is currently rate limited and will try again later. */
	    Status["RateLimit"] = "rate_limit";
	    /** The event could not be processed. */
	    Status["Invalid"] = "invalid";
	    /** A server-side error ocurred during submission. */
	    Status["Failed"] = "failed";
	})(Status = exports.Status || (exports.Status = {}));
	// eslint-disable-next-line @typescript-eslint/no-namespace, import/export
	(function (Status) {
	    /**
	     * Converts a HTTP status code into a {@link Status}.
	     *
	     * @param code The HTTP response status code.
	     * @returns The send status or {@link Status.Unknown}.
	     */
	    function fromHttpCode(code) {
	        if (code >= 200 && code < 300) {
	            return Status.Success;
	        }
	        if (code === 429) {
	            return Status.RateLimit;
	        }
	        if (code >= 400 && code < 500) {
	            return Status.Invalid;
	        }
	        if (code >= 500) {
	            return Status.Failed;
	        }
	        return Status.Unknown;
	    }
	    Status.fromHttpCode = fromHttpCode;
	})(Status = exports.Status || (exports.Status = {}));
	//# sourceMappingURL=status.js.map

/***/ }),
/* 13 */
/***/ (function(module, exports) {

	Object.defineProperty(exports, "__esModule", { value: true });
	var TransactionSamplingMethod;
	(function (TransactionSamplingMethod) {
	    TransactionSamplingMethod["Explicit"] = "explicitly_set";
	    TransactionSamplingMethod["Sampler"] = "client_sampler";
	    TransactionSamplingMethod["Rate"] = "client_rate";
	    TransactionSamplingMethod["Inheritance"] = "inheritance";
	})(TransactionSamplingMethod = exports.TransactionSamplingMethod || (exports.TransactionSamplingMethod = {}));
	//# sourceMappingURL=transaction.js.map

/***/ }),
/* 14 */
/***/ (function(module, exports, __webpack_require__) {

	Object.defineProperty(exports, "__esModule", { value: true });
	var minimal_1 = __webpack_require__(15);
	exports.addBreadcrumb = minimal_1.addBreadcrumb;
	exports.captureException = minimal_1.captureException;
	exports.captureEvent = minimal_1.captureEvent;
	exports.captureMessage = minimal_1.captureMessage;
	exports.configureScope = minimal_1.configureScope;
	exports.startTransaction = minimal_1.startTransaction;
	exports.setContext = minimal_1.setContext;
	exports.setExtra = minimal_1.setExtra;
	exports.setExtras = minimal_1.setExtras;
	exports.setTag = minimal_1.setTag;
	exports.setTags = minimal_1.setTags;
	exports.setUser = minimal_1.setUser;
	exports.withScope = minimal_1.withScope;
	var hub_1 = __webpack_require__(16);
	exports.addGlobalEventProcessor = hub_1.addGlobalEventProcessor;
	exports.getCurrentHub = hub_1.getCurrentHub;
	exports.getHubFromCarrier = hub_1.getHubFromCarrier;
	exports.Hub = hub_1.Hub;
	exports.makeMain = hub_1.makeMain;
	exports.Scope = hub_1.Scope;
	var api_1 = __webpack_require__(42);
	exports.API = api_1.API;
	var baseclient_1 = __webpack_require__(43);
	exports.BaseClient = baseclient_1.BaseClient;
	var basebackend_1 = __webpack_require__(45);
	exports.BaseBackend = basebackend_1.BaseBackend;
	var request_1 = __webpack_require__(47);
	exports.eventToSentryRequest = request_1.eventToSentryRequest;
	exports.sessionToSentryRequest = request_1.sessionToSentryRequest;
	var sdk_1 = __webpack_require__(48);
	exports.initAndBind = sdk_1.initAndBind;
	var noop_1 = __webpack_require__(46);
	exports.NoopTransport = noop_1.NoopTransport;
	var Integrations = __webpack_require__(49);
	exports.Integrations = Integrations;
	//# sourceMappingURL=index.js.map

/***/ }),
/* 15 */
/***/ (function(module, exports, __webpack_require__) {

	Object.defineProperty(exports, "__esModule", { value: true });
	var tslib_1 = __webpack_require__(6);
	var hub_1 = __webpack_require__(16);
	/**
	 * This calls a function on the current hub.
	 * @param method function to call on hub.
	 * @param args to pass to function.
	 */
	// eslint-disable-next-line @typescript-eslint/no-explicit-any
	function callOnHub(method) {
	    var args = [];
	    for (var _i = 1; _i < arguments.length; _i++) {
	        args[_i - 1] = arguments[_i];
	    }
	    var hub = hub_1.getCurrentHub();
	    if (hub && hub[method]) {
	        // eslint-disable-next-line @typescript-eslint/no-explicit-any
	        return hub[method].apply(hub, tslib_1.__spread(args));
	    }
	    throw new Error("No hub defined or " + method + " was not found on the hub, please open a bug report.");
	}
	/**
	 * Captures an exception event and sends it to Sentry.
	 *
	 * @param exception An exception-like object.
	 * @returns The generated eventId.
	 */
	// eslint-disable-next-line @typescript-eslint/no-explicit-any, @typescript-eslint/explicit-module-boundary-types
	function captureException(exception, captureContext) {
	    var syntheticException;
	    try {
	        throw new Error('Sentry syntheticException');
	    }
	    catch (exception) {
	        syntheticException = exception;
	    }
	    return callOnHub('captureException', exception, {
	        captureContext: captureContext,
	        originalException: exception,
	        syntheticException: syntheticException,
	    });
	}
	exports.captureException = captureException;
	/**
	 * Captures a message event and sends it to Sentry.
	 *
	 * @param message The message to send to Sentry.
	 * @param level Define the level of the message.
	 * @returns The generated eventId.
	 */
	function captureMessage(message, captureContext) {
	    var syntheticException;
	    try {
	        throw new Error(message);
	    }
	    catch (exception) {
	        syntheticException = exception;
	    }
	    // This is necessary to provide explicit scopes upgrade, without changing the original
	    // arity of the `captureMessage(message, level)` method.
	    var level = typeof captureContext === 'string' ? captureContext : undefined;
	    var context = typeof captureContext !== 'string' ? { captureContext: captureContext } : undefined;
	    return callOnHub('captureMessage', message, level, tslib_1.__assign({ originalException: message, syntheticException: syntheticException }, context));
	}
	exports.captureMessage = captureMessage;
	/**
	 * Captures a manually created event and sends it to Sentry.
	 *
	 * @param event The event to send to Sentry.
	 * @returns The generated eventId.
	 */
	function captureEvent(event) {
	    return callOnHub('captureEvent', event);
	}
	exports.captureEvent = captureEvent;
	/**
	 * Callback to set context information onto the scope.
	 * @param callback Callback function that receives Scope.
	 */
	function configureScope(callback) {
	    callOnHub('configureScope', callback);
	}
	exports.configureScope = configureScope;
	/**
	 * Records a new breadcrumb which will be attached to future events.
	 *
	 * Breadcrumbs will be added to subsequent events to provide more context on
	 * user's actions prior to an error or crash.
	 *
	 * @param breadcrumb The breadcrumb to record.
	 */
	function addBreadcrumb(breadcrumb) {
	    callOnHub('addBreadcrumb', breadcrumb);
	}
	exports.addBreadcrumb = addBreadcrumb;
	/**
	 * Sets context data with the given name.
	 * @param name of the context
	 * @param context Any kind of data. This data will be normalized.
	 */
	// eslint-disable-next-line @typescript-eslint/no-explicit-any
	function setContext(name, context) {
	    callOnHub('setContext', name, context);
	}
	exports.setContext = setContext;
	/**
	 * Set an object that will be merged sent as extra data with the event.
	 * @param extras Extras object to merge into current context.
	 */
	function setExtras(extras) {
	    callOnHub('setExtras', extras);
	}
	exports.setExtras = setExtras;
	/**
	 * Set an object that will be merged sent as tags data with the event.
	 * @param tags Tags context object to merge into current context.
	 */
	function setTags(tags) {
	    callOnHub('setTags', tags);
	}
	exports.setTags = setTags;
	/**
	 * Set key:value that will be sent as extra data with the event.
	 * @param key String of extra
	 * @param extra Any kind of data. This data will be normalized.
	 */
	function setExtra(key, extra) {
	    callOnHub('setExtra', key, extra);
	}
	exports.setExtra = setExtra;
	/**
	 * Set key:value that will be sent as tags data with the event.
	 *
	 * Can also be used to unset a tag, by passing `undefined`.
	 *
	 * @param key String key of tag
	 * @param value Value of tag
	 */
	function setTag(key, value) {
	    callOnHub('setTag', key, value);
	}
	exports.setTag = setTag;
	/**
	 * Updates user context information for future events.
	 *
	 * @param user User context object to be set in the current context. Pass `null` to unset the user.
	 */
	function setUser(user) {
	    callOnHub('setUser', user);
	}
	exports.setUser = setUser;
	/**
	 * Creates a new scope with and executes the given operation within.
	 * The scope is automatically removed once the operation
	 * finishes or throws.
	 *
	 * This is essentially a convenience function for:
	 *
	 *     pushScope();
	 *     callback();
	 *     popScope();
	 *
	 * @param callback that will be enclosed into push/popScope.
	 */
	function withScope(callback) {
	    callOnHub('withScope', callback);
	}
	exports.withScope = withScope;
	/**
	 * Calls a function on the latest client. Use this with caution, it's meant as
	 * in "internal" helper so we don't need to expose every possible function in
	 * the shim. It is not guaranteed that the client actually implements the
	 * function.
	 *
	 * @param method The method to call on the client/client.
	 * @param args Arguments to pass to the client/fontend.
	 * @hidden
	 */
	// eslint-disable-next-line @typescript-eslint/no-explicit-any
	function _callOnClient(method) {
	    var args = [];
	    for (var _i = 1; _i < arguments.length; _i++) {
	        args[_i - 1] = arguments[_i];
	    }
	    callOnHub.apply(void 0, tslib_1.__spread(['_invokeClient', method], args));
	}
	exports._callOnClient = _callOnClient;
	/**
	 * Starts a new `Transaction` and returns it. This is the entry point to manual tracing instrumentation.
	 *
	 * A tree structure can be built by adding child spans to the transaction, and child spans to other spans. To start a
	 * new child span within the transaction or any span, call the respective `.startChild()` method.
	 *
	 * Every child span must be finished before the transaction is finished, otherwise the unfinished spans are discarded.
	 *
	 * The transaction must be finished with a call to its `.finish()` method, at which point the transaction with all its
	 * finished child spans will be sent to Sentry.
	 *
	 * @param context Properties of the new `Transaction`.
	 * @param customSamplingContext Information given to the transaction sampling function (along with context-dependent
	 * default values). See {@link Options.tracesSampler}.
	 *
	 * @returns The transaction which was just started
	 */
	function startTransaction(context, customSamplingContext) {
	    return callOnHub('startTransaction', tslib_1.__assign({}, context), customSamplingContext);
	}
	exports.startTransaction = startTransaction;
	//# sourceMappingURL=index.js.map

/***/ }),
/* 16 */
/***/ (function(module, exports, __webpack_require__) {

	Object.defineProperty(exports, "__esModule", { value: true });
	var scope_1 = __webpack_require__(17);
	exports.addGlobalEventProcessor = scope_1.addGlobalEventProcessor;
	exports.Scope = scope_1.Scope;
	var session_1 = __webpack_require__(40);
	exports.Session = session_1.Session;
	var hub_1 = __webpack_require__(41);
	exports.getActiveDomain = hub_1.getActiveDomain;
	exports.getCurrentHub = hub_1.getCurrentHub;
	exports.getHubFromCarrier = hub_1.getHubFromCarrier;
	exports.getMainCarrier = hub_1.getMainCarrier;
	exports.Hub = hub_1.Hub;
	exports.makeMain = hub_1.makeMain;
	exports.setHubOnCarrier = hub_1.setHubOnCarrier;
	//# sourceMappingURL=index.js.map

/***/ }),
/* 17 */
/***/ (function(module, exports, __webpack_require__) {

	Object.defineProperty(exports, "__esModule", { value: true });
	var tslib_1 = __webpack_require__(6);
	var utils_1 = __webpack_require__(18);
	/**
	 * Holds additional event information. {@link Scope.applyToEvent} will be
	 * called by the client before an event will be sent.
	 */
	var Scope = /** @class */ (function () {
	    function Scope() {
	        /** Flag if notifiying is happening. */
	        this._notifyingListeners = false;
	        /** Callback for client to receive scope changes. */
	        this._scopeListeners = [];
	        /** Callback list that will be called after {@link applyToEvent}. */
	        this._eventProcessors = [];
	        /** Array of breadcrumbs. */
	        this._breadcrumbs = [];
	        /** User */
	        this._user = {};
	        /** Tags */
	        this._tags = {};
	        /** Extra */
	        this._extra = {};
	        /** Contexts */
	        this._contexts = {};
	    }
	    /**
	     * Inherit values from the parent scope.
	     * @param scope to clone.
	     */
	    Scope.clone = function (scope) {
	        var newScope = new Scope();
	        if (scope) {
	            newScope._breadcrumbs = tslib_1.__spread(scope._breadcrumbs);
	            newScope._tags = tslib_1.__assign({}, scope._tags);
	            newScope._extra = tslib_1.__assign({}, scope._extra);
	            newScope._contexts = tslib_1.__assign({}, scope._contexts);
	            newScope._user = scope._user;
	            newScope._level = scope._level;
	            newScope._span = scope._span;
	            newScope._session = scope._session;
	            newScope._transactionName = scope._transactionName;
	            newScope._fingerprint = scope._fingerprint;
	            newScope._eventProcessors = tslib_1.__spread(scope._eventProcessors);
	        }
	        return newScope;
	    };
	    /**
	     * Add internal on change listener. Used for sub SDKs that need to store the scope.
	     * @hidden
	     */
	    Scope.prototype.addScopeListener = function (callback) {
	        this._scopeListeners.push(callback);
	    };
	    /**
	     * @inheritDoc
	     */
	    Scope.prototype.addEventProcessor = function (callback) {
	        this._eventProcessors.push(callback);
	        return this;
	    };
	    /**
	     * @inheritDoc
	     */
	    Scope.prototype.setUser = function (user) {
	        this._user = user || {};
	        if (this._session) {
	            this._session.update({ user: user });
	        }
	        this._notifyScopeListeners();
	        return this;
	    };
	    /**
	     * @inheritDoc
	     */
	    Scope.prototype.getUser = function () {
	        return this._user;
	    };
	    /**
	     * @inheritDoc
	     */
	    Scope.prototype.setTags = function (tags) {
	        this._tags = tslib_1.__assign(tslib_1.__assign({}, this._tags), tags);
	        this._notifyScopeListeners();
	        return this;
	    };
	    /**
	     * @inheritDoc
	     */
	    Scope.prototype.setTag = function (key, value) {
	        var _a;
	        this._tags = tslib_1.__assign(tslib_1.__assign({}, this._tags), (_a = {}, _a[key] = value, _a));
	        this._notifyScopeListeners();
	        return this;
	    };
	    /**
	     * @inheritDoc
	     */
	    Scope.prototype.setExtras = function (extras) {
	        this._extra = tslib_1.__assign(tslib_1.__assign({}, this._extra), extras);
	        this._notifyScopeListeners();
	        return this;
	    };
	    /**
	     * @inheritDoc
	     */
	    Scope.prototype.setExtra = function (key, extra) {
	        var _a;
	        this._extra = tslib_1.__assign(tslib_1.__assign({}, this._extra), (_a = {}, _a[key] = extra, _a));
	        this._notifyScopeListeners();
	        return this;
	    };
	    /**
	     * @inheritDoc
	     */
	    Scope.prototype.setFingerprint = function (fingerprint) {
	        this._fingerprint = fingerprint;
	        this._notifyScopeListeners();
	        return this;
	    };
	    /**
	     * @inheritDoc
	     */
	    Scope.prototype.setLevel = function (level) {
	        this._level = level;
	        this._notifyScopeListeners();
	        return this;
	    };
	    /**
	     * @inheritDoc
	     */
	    Scope.prototype.setTransactionName = function (name) {
	        this._transactionName = name;
	        this._notifyScopeListeners();
	        return this;
	    };
	    /**
	     * Can be removed in major version.
	     * @deprecated in favor of {@link this.setTransactionName}
	     */
	    Scope.prototype.setTransaction = function (name) {
	        return this.setTransactionName(name);
	    };
	    /**
	     * @inheritDoc
	     */
	    Scope.prototype.setContext = function (key, context) {
	        var _a;
	        if (context === null) {
	            // eslint-disable-next-line @typescript-eslint/no-dynamic-delete
	            delete this._contexts[key];
	        }
	        else {
	            this._contexts = tslib_1.__assign(tslib_1.__assign({}, this._contexts), (_a = {}, _a[key] = context, _a));
	        }
	        this._notifyScopeListeners();
	        return this;
	    };
	    /**
	     * @inheritDoc
	     */
	    Scope.prototype.setSpan = function (span) {
	        this._span = span;
	        this._notifyScopeListeners();
	        return this;
	    };
	    /**
	     * @inheritDoc
	     */
	    Scope.prototype.getSpan = function () {
	        return this._span;
	    };
	    /**
	     * @inheritDoc
	     */
	    Scope.prototype.getTransaction = function () {
	        var _a, _b, _c, _d;
	        // often, this span will be a transaction, but it's not guaranteed to be
	        var span = this.getSpan();
	        // try it the new way first
	        if ((_a = span) === null || _a === void 0 ? void 0 : _a.transaction) {
	            return (_b = span) === null || _b === void 0 ? void 0 : _b.transaction;
	        }
	        // fallback to the old way (known bug: this only finds transactions with sampled = true)
	        if ((_d = (_c = span) === null || _c === void 0 ? void 0 : _c.spanRecorder) === null || _d === void 0 ? void 0 : _d.spans[0]) {
	            return span.spanRecorder.spans[0];
	        }
	        // neither way found a transaction
	        return undefined;
	    };
	    /**
	     * @inheritDoc
	     */
	    Scope.prototype.setSession = function (session) {
	        if (!session) {
	            delete this._session;
	        }
	        else {
	            this._session = session;
	        }
	        this._notifyScopeListeners();
	        return this;
	    };
	    /**
	     * @inheritDoc
	     */
	    Scope.prototype.getSession = function () {
	        return this._session;
	    };
	    /**
	     * @inheritDoc
	     */
	    Scope.prototype.update = function (captureContext) {
	        if (!captureContext) {
	            return this;
	        }
	        if (typeof captureContext === 'function') {
	            var updatedScope = captureContext(this);
	            return updatedScope instanceof Scope ? updatedScope : this;
	        }
	        if (captureContext instanceof Scope) {
	            this._tags = tslib_1.__assign(tslib_1.__assign({}, this._tags), captureContext._tags);
	            this._extra = tslib_1.__assign(tslib_1.__assign({}, this._extra), captureContext._extra);
	            this._contexts = tslib_1.__assign(tslib_1.__assign({}, this._contexts), captureContext._contexts);
	            if (captureContext._user && Object.keys(captureContext._user).length) {
	                this._user = captureContext._user;
	            }
	            if (captureContext._level) {
	                this._level = captureContext._level;
	            }
	            if (captureContext._fingerprint) {
	                this._fingerprint = captureContext._fingerprint;
	            }
	        }
	        else if (utils_1.isPlainObject(captureContext)) {
	            // eslint-disable-next-line no-param-reassign
	            captureContext = captureContext;
	            this._tags = tslib_1.__assign(tslib_1.__assign({}, this._tags), captureContext.tags);
	            this._extra = tslib_1.__assign(tslib_1.__assign({}, this._extra), captureContext.extra);
	            this._contexts = tslib_1.__assign(tslib_1.__assign({}, this._contexts), captureContext.contexts);
	            if (captureContext.user) {
	                this._user = captureContext.user;
	            }
	            if (captureContext.level) {
	                this._level = captureContext.level;
	            }
	            if (captureContext.fingerprint) {
	                this._fingerprint = captureContext.fingerprint;
	            }
	        }
	        return this;
	    };
	    /**
	     * @inheritDoc
	     */
	    Scope.prototype.clear = function () {
	        this._breadcrumbs = [];
	        this._tags = {};
	        this._extra = {};
	        this._user = {};
	        this._contexts = {};
	        this._level = undefined;
	        this._transactionName = undefined;
	        this._fingerprint = undefined;
	        this._span = undefined;
	        this._session = undefined;
	        this._notifyScopeListeners();
	        return this;
	    };
	    /**
	     * @inheritDoc
	     */
	    Scope.prototype.addBreadcrumb = function (breadcrumb, maxBreadcrumbs) {
	        var mergedBreadcrumb = tslib_1.__assign({ timestamp: utils_1.dateTimestampInSeconds() }, breadcrumb);
	        this._breadcrumbs =
	            maxBreadcrumbs !== undefined && maxBreadcrumbs >= 0
	                ? tslib_1.__spread(this._breadcrumbs, [mergedBreadcrumb]).slice(-maxBreadcrumbs)
	                : tslib_1.__spread(this._breadcrumbs, [mergedBreadcrumb]);
	        this._notifyScopeListeners();
	        return this;
	    };
	    /**
	     * @inheritDoc
	     */
	    Scope.prototype.clearBreadcrumbs = function () {
	        this._breadcrumbs = [];
	        this._notifyScopeListeners();
	        return this;
	    };
	    /**
	     * Applies the current context and fingerprint to the event.
	     * Note that breadcrumbs will be added by the client.
	     * Also if the event has already breadcrumbs on it, we do not merge them.
	     * @param event Event
	     * @param hint May contain additional informartion about the original exception.
	     * @hidden
	     */
	    Scope.prototype.applyToEvent = function (event, hint) {
	        var _a;
	        if (this._extra && Object.keys(this._extra).length) {
	            event.extra = tslib_1.__assign(tslib_1.__assign({}, this._extra), event.extra);
	        }
	        if (this._tags && Object.keys(this._tags).length) {
	            event.tags = tslib_1.__assign(tslib_1.__assign({}, this._tags), event.tags);
	        }
	        if (this._user && Object.keys(this._user).length) {
	            event.user = tslib_1.__assign(tslib_1.__assign({}, this._user), event.user);
	        }
	        if (this._contexts && Object.keys(this._contexts).length) {
	            event.contexts = tslib_1.__assign(tslib_1.__assign({}, this._contexts), event.contexts);
	        }
	        if (this._level) {
	            event.level = this._level;
	        }
	        if (this._transactionName) {
	            event.transaction = this._transactionName;
	        }
	        // We want to set the trace context for normal events only if there isn't already
	        // a trace context on the event. There is a product feature in place where we link
	        // errors with transaction and it relys on that.
	        if (this._span) {
	            event.contexts = tslib_1.__assign({ trace: this._span.getTraceContext() }, event.contexts);
	            var transactionName = (_a = this._span.transaction) === null || _a === void 0 ? void 0 : _a.name;
	            if (transactionName) {
	                event.tags = tslib_1.__assign({ transaction: transactionName }, event.tags);
	            }
	        }
	        this._applyFingerprint(event);
	        event.breadcrumbs = tslib_1.__spread((event.breadcrumbs || []), this._breadcrumbs);
	        event.breadcrumbs = event.breadcrumbs.length > 0 ? event.breadcrumbs : undefined;
	        return this._notifyEventProcessors(tslib_1.__spread(getGlobalEventProcessors(), this._eventProcessors), event, hint);
	    };
	    /**
	     * This will be called after {@link applyToEvent} is finished.
	     */
	    Scope.prototype._notifyEventProcessors = function (processors, event, hint, index) {
	        var _this = this;
	        if (index === void 0) { index = 0; }
	        return new utils_1.SyncPromise(function (resolve, reject) {
	            var processor = processors[index];
	            if (event === null || typeof processor !== 'function') {
	                resolve(event);
	            }
	            else {
	                var result = processor(tslib_1.__assign({}, event), hint);
	                if (utils_1.isThenable(result)) {
	                    result
	                        .then(function (final) { return _this._notifyEventProcessors(processors, final, hint, index + 1).then(resolve); })
	                        .then(null, reject);
	                }
	                else {
	                    _this._notifyEventProcessors(processors, result, hint, index + 1)
	                        .then(resolve)
	                        .then(null, reject);
	                }
	            }
	        });
	    };
	    /**
	     * This will be called on every set call.
	     */
	    Scope.prototype._notifyScopeListeners = function () {
	        var _this = this;
	        // We need this check for this._notifyingListeners to be able to work on scope during updates
	        // If this check is not here we'll produce endless recursion when something is done with the scope
	        // during the callback.
	        if (!this._notifyingListeners) {
	            this._notifyingListeners = true;
	            this._scopeListeners.forEach(function (callback) {
	                callback(_this);
	            });
	            this._notifyingListeners = false;
	        }
	    };
	    /**
	     * Applies fingerprint from the scope to the event if there's one,
	     * uses message if there's one instead or get rid of empty fingerprint
	     */
	    Scope.prototype._applyFingerprint = function (event) {
	        // Make sure it's an array first and we actually have something in place
	        event.fingerprint = event.fingerprint
	            ? Array.isArray(event.fingerprint)
	                ? event.fingerprint
	                : [event.fingerprint]
	            : [];
	        // If we have something on the scope, then merge it with event
	        if (this._fingerprint) {
	            event.fingerprint = event.fingerprint.concat(this._fingerprint);
	        }
	        // If we have no data at all, remove empty array default
	        if (event.fingerprint && !event.fingerprint.length) {
	            delete event.fingerprint;
	        }
	    };
	    return Scope;
	}());
	exports.Scope = Scope;
	/**
	 * Retruns the global event processors.
	 */
	function getGlobalEventProcessors() {
	    /* eslint-disable @typescript-eslint/no-explicit-any, @typescript-eslint/no-unsafe-member-access  */
	    var global = utils_1.getGlobalObject();
	    global.__SENTRY__ = global.__SENTRY__ || {};
	    global.__SENTRY__.globalEventProcessors = global.__SENTRY__.globalEventProcessors || [];
	    return global.__SENTRY__.globalEventProcessors;
	    /* eslint-enable @typescript-eslint/no-explicit-any, @typescript-eslint/no-unsafe-member-access */
	}
	/**
	 * Add a EventProcessor to be kept globally.
	 * @param callback EventProcessor to add
	 */
	function addGlobalEventProcessor(callback) {
	    getGlobalEventProcessors().push(callback);
	}
	exports.addGlobalEventProcessor = addGlobalEventProcessor;
	//# sourceMappingURL=scope.js.map

/***/ }),
/* 18 */
/***/ (function(module, exports, __webpack_require__) {

	Object.defineProperty(exports, "__esModule", { value: true });
	var tslib_1 = __webpack_require__(6);
	tslib_1.__exportStar(__webpack_require__(19), exports);
	tslib_1.__exportStar(__webpack_require__(20), exports);
	tslib_1.__exportStar(__webpack_require__(22), exports);
	tslib_1.__exportStar(__webpack_require__(23), exports);
	tslib_1.__exportStar(__webpack_require__(25), exports);
	tslib_1.__exportStar(__webpack_require__(21), exports);
	tslib_1.__exportStar(__webpack_require__(26), exports);
	tslib_1.__exportStar(__webpack_require__(32), exports);
	tslib_1.__exportStar(__webpack_require__(27), exports);
	tslib_1.__exportStar(__webpack_require__(28), exports);
	tslib_1.__exportStar(__webpack_require__(31), exports);
	tslib_1.__exportStar(__webpack_require__(36), exports);
	tslib_1.__exportStar(__webpack_require__(37), exports);
	tslib_1.__exportStar(__webpack_require__(33), exports);
	tslib_1.__exportStar(__webpack_require__(34), exports);
	tslib_1.__exportStar(__webpack_require__(35), exports);
	tslib_1.__exportStar(__webpack_require__(38), exports);
	tslib_1.__exportStar(__webpack_require__(39), exports);
	//# sourceMappingURL=index.js.map

/***/ }),
/* 19 */
/***/ (function(module, exports) {

	Object.defineProperty(exports, "__esModule", { value: true });
	/**
	 * Consumes the promise and logs the error when it rejects.
	 * @param promise A promise to forget.
	 */
	// eslint-disable-next-line @typescript-eslint/no-explicit-any
	function forget(promise) {
	    promise.then(null, function (e) {
	        // TODO: Use a better logging mechanism
	        // eslint-disable-next-line no-console
	        console.error(e);
	    });
	}
	exports.forget = forget;
	//# sourceMappingURL=async.js.map

/***/ }),
/* 20 */
/***/ (function(module, exports, __webpack_require__) {

	Object.defineProperty(exports, "__esModule", { value: true });
	var is_1 = __webpack_require__(21);
	/**
	 * Given a child DOM element, returns a query-selector statement describing that
	 * and its ancestors
	 * e.g. [HTMLElement] => body > div > input#foo.btn[name=baz]
	 * @returns generated DOM path
	 */
	function htmlTreeAsString(elem) {
	    // try/catch both:
	    // - accessing event.target (see getsentry/raven-js#838, #768)
	    // - `htmlTreeAsString` because it's complex, and just accessing the DOM incorrectly
	    // - can throw an exception in some circumstances.
	    try {
	        var currentElem = elem;
	        var MAX_TRAVERSE_HEIGHT = 5;
	        var MAX_OUTPUT_LEN = 80;
	        var out = [];
	        var height = 0;
	        var len = 0;
	        var separator = ' > ';
	        var sepLength = separator.length;
	        var nextStr = void 0;
	        // eslint-disable-next-line no-plusplus
	        while (currentElem && height++ < MAX_TRAVERSE_HEIGHT) {
	            nextStr = _htmlElementAsString(currentElem);
	            // bail out if
	            // - nextStr is the 'html' element
	            // - the length of the string that would be created exceeds MAX_OUTPUT_LEN
	            //   (ignore this limit if we are on the first iteration)
	            if (nextStr === 'html' || (height > 1 && len + out.length * sepLength + nextStr.length >= MAX_OUTPUT_LEN)) {
	                break;
	            }
	            out.push(nextStr);
	            len += nextStr.length;
	            currentElem = currentElem.parentNode;
	        }
	        return out.reverse().join(separator);
	    }
	    catch (_oO) {
	        return '<unknown>';
	    }
	}
	exports.htmlTreeAsString = htmlTreeAsString;
	/**
	 * Returns a simple, query-selector representation of a DOM element
	 * e.g. [HTMLElement] => input#foo.btn[name=baz]
	 * @returns generated DOM path
	 */
	function _htmlElementAsString(el) {
	    var elem = el;
	    var out = [];
	    var className;
	    var classes;
	    var key;
	    var attr;
	    var i;
	    if (!elem || !elem.tagName) {
	        return '';
	    }
	    out.push(elem.tagName.toLowerCase());
	    if (elem.id) {
	        out.push("#" + elem.id);
	    }
	    // eslint-disable-next-line prefer-const
	    className = elem.className;
	    if (className && is_1.isString(className)) {
	        classes = className.split(/\s+/);
	        for (i = 0; i < classes.length; i++) {
	            out.push("." + classes[i]);
	        }
	    }
	    var allowedAttrs = ['type', 'name', 'title', 'alt'];
	    for (i = 0; i < allowedAttrs.length; i++) {
	        key = allowedAttrs[i];
	        attr = elem.getAttribute(key);
	        if (attr) {
	            out.push("[" + key + "=\"" + attr + "\"]");
	        }
	    }
	    return out.join('');
	}
	//# sourceMappingURL=browser.js.map

/***/ }),
/* 21 */
/***/ (function(module, exports) {

	/* eslint-disable @typescript-eslint/no-explicit-any */
	/* eslint-disable @typescript-eslint/explicit-module-boundary-types */
	Object.defineProperty(exports, "__esModule", { value: true });
	/**
	 * Checks whether given value's type is one of a few Error or Error-like
	 * {@link isError}.
	 *
	 * @param wat A value to be checked.
	 * @returns A boolean representing the result.
	 */
	function isError(wat) {
	    switch (Object.prototype.toString.call(wat)) {
	        case '[object Error]':
	            return true;
	        case '[object Exception]':
	            return true;
	        case '[object DOMException]':
	            return true;
	        default:
	            return isInstanceOf(wat, Error);
	    }
	}
	exports.isError = isError;
	/**
	 * Checks whether given value's type is ErrorEvent
	 * {@link isErrorEvent}.
	 *
	 * @param wat A value to be checked.
	 * @returns A boolean representing the result.
	 */
	function isErrorEvent(wat) {
	    return Object.prototype.toString.call(wat) === '[object ErrorEvent]';
	}
	exports.isErrorEvent = isErrorEvent;
	/**
	 * Checks whether given value's type is DOMError
	 * {@link isDOMError}.
	 *
	 * @param wat A value to be checked.
	 * @returns A boolean representing the result.
	 */
	function isDOMError(wat) {
	    return Object.prototype.toString.call(wat) === '[object DOMError]';
	}
	exports.isDOMError = isDOMError;
	/**
	 * Checks whether given value's type is DOMException
	 * {@link isDOMException}.
	 *
	 * @param wat A value to be checked.
	 * @returns A boolean representing the result.
	 */
	function isDOMException(wat) {
	    return Object.prototype.toString.call(wat) === '[object DOMException]';
	}
	exports.isDOMException = isDOMException;
	/**
	 * Checks whether given value's type is a string
	 * {@link isString}.
	 *
	 * @param wat A value to be checked.
	 * @returns A boolean representing the result.
	 */
	function isString(wat) {
	    return Object.prototype.toString.call(wat) === '[object String]';
	}
	exports.isString = isString;
	/**
	 * Checks whether given value's is a primitive (undefined, null, number, boolean, string, bigint, symbol)
	 * {@link isPrimitive}.
	 *
	 * @param wat A value to be checked.
	 * @returns A boolean representing the result.
	 */
	function isPrimitive(wat) {
	    return wat === null || (typeof wat !== 'object' && typeof wat !== 'function');
	}
	exports.isPrimitive = isPrimitive;
	/**
	 * Checks whether given value's type is an object literal
	 * {@link isPlainObject}.
	 *
	 * @param wat A value to be checked.
	 * @returns A boolean representing the result.
	 */
	function isPlainObject(wat) {
	    return Object.prototype.toString.call(wat) === '[object Object]';
	}
	exports.isPlainObject = isPlainObject;
	/**
	 * Checks whether given value's type is an Event instance
	 * {@link isEvent}.
	 *
	 * @param wat A value to be checked.
	 * @returns A boolean representing the result.
	 */
	function isEvent(wat) {
	    return typeof Event !== 'undefined' && isInstanceOf(wat, Event);
	}
	exports.isEvent = isEvent;
	/**
	 * Checks whether given value's type is an Element instance
	 * {@link isElement}.
	 *
	 * @param wat A value to be checked.
	 * @returns A boolean representing the result.
	 */
	function isElement(wat) {
	    return typeof Element !== 'undefined' && isInstanceOf(wat, Element);
	}
	exports.isElement = isElement;
	/**
	 * Checks whether given value's type is an regexp
	 * {@link isRegExp}.
	 *
	 * @param wat A value to be checked.
	 * @returns A boolean representing the result.
	 */
	function isRegExp(wat) {
	    return Object.prototype.toString.call(wat) === '[object RegExp]';
	}
	exports.isRegExp = isRegExp;
	/**
	 * Checks whether given value has a then function.
	 * @param wat A value to be checked.
	 */
	function isThenable(wat) {
	    // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
	    return Boolean(wat && wat.then && typeof wat.then === 'function');
	}
	exports.isThenable = isThenable;
	/**
	 * Checks whether given value's type is a SyntheticEvent
	 * {@link isSyntheticEvent}.
	 *
	 * @param wat A value to be checked.
	 * @returns A boolean representing the result.
	 */
	function isSyntheticEvent(wat) {
	    return isPlainObject(wat) && 'nativeEvent' in wat && 'preventDefault' in wat && 'stopPropagation' in wat;
	}
	exports.isSyntheticEvent = isSyntheticEvent;
	/**
	 * Checks whether given value's type is an instance of provided constructor.
	 * {@link isInstanceOf}.
	 *
	 * @param wat A value to be checked.
	 * @param base A constructor to be used in a check.
	 * @returns A boolean representing the result.
	 */
	function isInstanceOf(wat, base) {
	    try {
	        return wat instanceof base;
	    }
	    catch (_e) {
	        return false;
	    }
	}
	exports.isInstanceOf = isInstanceOf;
	//# sourceMappingURL=is.js.map

/***/ }),
/* 22 */
/***/ (function(module, exports, __webpack_require__) {

	Object.defineProperty(exports, "__esModule", { value: true });
	var tslib_1 = __webpack_require__(6);
	var error_1 = __webpack_require__(23);
	/** Regular expression used to parse a Dsn. */
	var DSN_REGEX = /^(?:(\w+):)\/\/(?:(\w+)(?::(\w+))?@)([\w.-]+)(?::(\d+))?\/(.+)/;
	/** Error message */
	var ERROR_MESSAGE = 'Invalid Dsn';
	/** The Sentry Dsn, identifying a Sentry instance and project. */
	var Dsn = /** @class */ (function () {
	    /** Creates a new Dsn component */
	    function Dsn(from) {
	        if (typeof from === 'string') {
	            this._fromString(from);
	        }
	        else {
	            this._fromComponents(from);
	        }
	        this._validate();
	    }
	    /**
	     * Renders the string representation of this Dsn.
	     *
	     * By default, this will render the public representation without the password
	     * component. To get the deprecated private representation, set `withPassword`
	     * to true.
	     *
	     * @param withPassword When set to true, the password will be included.
	     */
	    Dsn.prototype.toString = function (withPassword) {
	        if (withPassword === void 0) { withPassword = false; }
	        var _a = this, host = _a.host, path = _a.path, pass = _a.pass, port = _a.port, projectId = _a.projectId, protocol = _a.protocol, user = _a.user;
	        return (protocol + "://" + user + (withPassword && pass ? ":" + pass : '') +
	            ("@" + host + (port ? ":" + port : '') + "/" + (path ? path + "/" : path) + projectId));
	    };
	    /** Parses a string into this Dsn. */
	    Dsn.prototype._fromString = function (str) {
	        var match = DSN_REGEX.exec(str);
	        if (!match) {
	            throw new error_1.SentryError(ERROR_MESSAGE);
	        }
	        var _a = tslib_1.__read(match.slice(1), 6), protocol = _a[0], user = _a[1], _b = _a[2], pass = _b === void 0 ? '' : _b, host = _a[3], _c = _a[4], port = _c === void 0 ? '' : _c, lastPath = _a[5];
	        var path = '';
	        var projectId = lastPath;
	        var split = projectId.split('/');
	        if (split.length > 1) {
	            path = split.slice(0, -1).join('/');
	            projectId = split.pop();
	        }
	        if (projectId) {
	            var projectMatch = projectId.match(/^\d+/);
	            if (projectMatch) {
	                projectId = projectMatch[0];
	            }
	        }
	        this._fromComponents({ host: host, pass: pass, path: path, projectId: projectId, port: port, protocol: protocol, user: user });
	    };
	    /** Maps Dsn components into this instance. */
	    Dsn.prototype._fromComponents = function (components) {
	        this.protocol = components.protocol;
	        this.user = components.user;
	        this.pass = components.pass || '';
	        this.host = components.host;
	        this.port = components.port || '';
	        this.path = components.path || '';
	        this.projectId = components.projectId;
	    };
	    /** Validates this Dsn and throws on error. */
	    Dsn.prototype._validate = function () {
	        var _this = this;
	        ['protocol', 'user', 'host', 'projectId'].forEach(function (component) {
	            if (!_this[component]) {
	                throw new error_1.SentryError(ERROR_MESSAGE + ": " + component + " missing");
	            }
	        });
	        if (!this.projectId.match(/^\d+$/)) {
	            throw new error_1.SentryError(ERROR_MESSAGE + ": Invalid projectId " + this.projectId);
	        }
	        if (this.protocol !== 'http' && this.protocol !== 'https') {
	            throw new error_1.SentryError(ERROR_MESSAGE + ": Invalid protocol " + this.protocol);
	        }
	        if (this.port && isNaN(parseInt(this.port, 10))) {
	            throw new error_1.SentryError(ERROR_MESSAGE + ": Invalid port " + this.port);
	        }
	    };
	    return Dsn;
	}());
	exports.Dsn = Dsn;
	//# sourceMappingURL=dsn.js.map

/***/ }),
/* 23 */
/***/ (function(module, exports, __webpack_require__) {

	Object.defineProperty(exports, "__esModule", { value: true });
	var tslib_1 = __webpack_require__(6);
	var polyfill_1 = __webpack_require__(24);
	/** An error emitted by Sentry SDKs and related utilities. */
	var SentryError = /** @class */ (function (_super) {
	    tslib_1.__extends(SentryError, _super);
	    function SentryError(message) {
	        var _newTarget = this.constructor;
	        var _this = _super.call(this, message) || this;
	        _this.message = message;
	        _this.name = _newTarget.prototype.constructor.name;
	        polyfill_1.setPrototypeOf(_this, _newTarget.prototype);
	        return _this;
	    }
	    return SentryError;
	}(Error));
	exports.SentryError = SentryError;
	//# sourceMappingURL=error.js.map

/***/ }),
/* 24 */
/***/ (function(module, exports) {

	Object.defineProperty(exports, "__esModule", { value: true });
	exports.setPrototypeOf = Object.setPrototypeOf || ({ __proto__: [] } instanceof Array ? setProtoOf : mixinProperties);
	/**
	 * setPrototypeOf polyfill using __proto__
	 */
	// eslint-disable-next-line @typescript-eslint/ban-types
	function setProtoOf(obj, proto) {
	    // @ts-ignore __proto__ does not exist on obj
	    obj.__proto__ = proto;
	    return obj;
	}
	/**
	 * setPrototypeOf polyfill using mixin
	 */
	// eslint-disable-next-line @typescript-eslint/ban-types
	function mixinProperties(obj, proto) {
	    for (var prop in proto) {
	        // eslint-disable-next-line no-prototype-builtins
	        if (!obj.hasOwnProperty(prop)) {
	            // @ts-ignore typescript complains about indexing so we remove
	            obj[prop] = proto[prop];
	        }
	    }
	    return obj;
	}
	//# sourceMappingURL=polyfill.js.map

/***/ }),
/* 25 */
/***/ (function(module, exports, __webpack_require__) {

	Object.defineProperty(exports, "__esModule", { value: true });
	var tslib_1 = __webpack_require__(6);
	var is_1 = __webpack_require__(21);
	var logger_1 = __webpack_require__(26);
	var misc_1 = __webpack_require__(27);
	var object_1 = __webpack_require__(31);
	var stacktrace_1 = __webpack_require__(33);
	var supports_1 = __webpack_require__(35);
	var global = misc_1.getGlobalObject();
	/**
	 * Instrument native APIs to call handlers that can be used to create breadcrumbs, APM spans etc.
	 *  - Console API
	 *  - Fetch API
	 *  - XHR API
	 *  - History API
	 *  - DOM API (click/typing)
	 *  - Error API
	 *  - UnhandledRejection API
	 */
	var handlers = {};
	var instrumented = {};
	/** Instruments given API */
	function instrument(type) {
	    if (instrumented[type]) {
	        return;
	    }
	    instrumented[type] = true;
	    switch (type) {
	        case 'console':
	            instrumentConsole();
	            break;
	        case 'dom':
	            instrumentDOM();
	            break;
	        case 'xhr':
	            instrumentXHR();
	            break;
	        case 'fetch':
	            instrumentFetch();
	            break;
	        case 'history':
	            instrumentHistory();
	            break;
	        case 'error':
	            instrumentError();
	            break;
	        case 'unhandledrejection':
	            instrumentUnhandledRejection();
	            break;
	        default:
	            logger_1.logger.warn('unknown instrumentation type:', type);
	    }
	}
	/**
	 * Add handler that will be called when given type of instrumentation triggers.
	 * Use at your own risk, this might break without changelog notice, only used internally.
	 * @hidden
	 */
	function addInstrumentationHandler(handler) {
	    if (!handler || typeof handler.type !== 'string' || typeof handler.callback !== 'function') {
	        return;
	    }
	    handlers[handler.type] = handlers[handler.type] || [];
	    handlers[handler.type].push(handler.callback);
	    instrument(handler.type);
	}
	exports.addInstrumentationHandler = addInstrumentationHandler;
	/** JSDoc */
	function triggerHandlers(type, data) {
	    var e_1, _a;
	    if (!type || !handlers[type]) {
	        return;
	    }
	    try {
	        for (var _b = tslib_1.__values(handlers[type] || []), _c = _b.next(); !_c.done; _c = _b.next()) {
	            var handler = _c.value;
	            try {
	                handler(data);
	            }
	            catch (e) {
	                logger_1.logger.error("Error while triggering instrumentation handler.\nType: " + type + "\nName: " + stacktrace_1.getFunctionName(handler) + "\nError: " + e);
	            }
	        }
	    }
	    catch (e_1_1) { e_1 = { error: e_1_1 }; }
	    finally {
	        try {
	            if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
	        }
	        finally { if (e_1) throw e_1.error; }
	    }
	}
	/** JSDoc */
	function instrumentConsole() {
	    if (!('console' in global)) {
	        return;
	    }
	    ['debug', 'info', 'warn', 'error', 'log', 'assert'].forEach(function (level) {
	        if (!(level in global.console)) {
	            return;
	        }
	        object_1.fill(global.console, level, function (originalConsoleLevel) {
	            return function () {
	                var args = [];
	                for (var _i = 0; _i < arguments.length; _i++) {
	                    args[_i] = arguments[_i];
	                }
	                triggerHandlers('console', { args: args, level: level });
	                // this fails for some browsers. :(
	                if (originalConsoleLevel) {
	                    Function.prototype.apply.call(originalConsoleLevel, global.console, args);
	                }
	            };
	        });
	    });
	}
	/** JSDoc */
	function instrumentFetch() {
	    if (!supports_1.supportsNativeFetch()) {
	        return;
	    }
	    object_1.fill(global, 'fetch', function (originalFetch) {
	        return function () {
	            var args = [];
	            for (var _i = 0; _i < arguments.length; _i++) {
	                args[_i] = arguments[_i];
	            }
	            var handlerData = {
	                args: args,
	                fetchData: {
	                    method: getFetchMethod(args),
	                    url: getFetchUrl(args),
	                },
	                startTimestamp: Date.now(),
	            };
	            triggerHandlers('fetch', tslib_1.__assign({}, handlerData));
	            // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
	            return originalFetch.apply(global, args).then(function (response) {
	                triggerHandlers('fetch', tslib_1.__assign(tslib_1.__assign({}, handlerData), { endTimestamp: Date.now(), response: response }));
	                return response;
	            }, function (error) {
	                triggerHandlers('fetch', tslib_1.__assign(tslib_1.__assign({}, handlerData), { endTimestamp: Date.now(), error: error }));
	                // NOTE: If you are a Sentry user, and you are seeing this stack frame,
	                //       it means the sentry.javascript SDK caught an error invoking your application code.
	                //       This is expected behavior and NOT indicative of a bug with sentry.javascript.
	                throw error;
	            });
	        };
	    });
	}
	/* eslint-disable @typescript-eslint/no-unsafe-member-access */
	/** Extract `method` from fetch call arguments */
	function getFetchMethod(fetchArgs) {
	    if (fetchArgs === void 0) { fetchArgs = []; }
	    if ('Request' in global && is_1.isInstanceOf(fetchArgs[0], Request) && fetchArgs[0].method) {
	        return String(fetchArgs[0].method).toUpperCase();
	    }
	    if (fetchArgs[1] && fetchArgs[1].method) {
	        return String(fetchArgs[1].method).toUpperCase();
	    }
	    return 'GET';
	}
	/** Extract `url` from fetch call arguments */
	function getFetchUrl(fetchArgs) {
	    if (fetchArgs === void 0) { fetchArgs = []; }
	    if (typeof fetchArgs[0] === 'string') {
	        return fetchArgs[0];
	    }
	    if ('Request' in global && is_1.isInstanceOf(fetchArgs[0], Request)) {
	        return fetchArgs[0].url;
	    }
	    return String(fetchArgs[0]);
	}
	/* eslint-enable @typescript-eslint/no-unsafe-member-access */
	/** JSDoc */
	function instrumentXHR() {
	    if (!('XMLHttpRequest' in global)) {
	        return;
	    }
	    // Poor man's implementation of ES6 `Map`, tracking and keeping in sync key and value separately.
	    var requestKeys = [];
	    var requestValues = [];
	    var xhrproto = XMLHttpRequest.prototype;
	    object_1.fill(xhrproto, 'open', function (originalOpen) {
	        return function () {
	            var args = [];
	            for (var _i = 0; _i < arguments.length; _i++) {
	                args[_i] = arguments[_i];
	            }
	            // eslint-disable-next-line @typescript-eslint/no-this-alias
	            var xhr = this;
	            var url = args[1];
	            xhr.__sentry_xhr__ = {
	                // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
	                method: is_1.isString(args[0]) ? args[0].toUpperCase() : args[0],
	                url: args[1],
	            };
	            // if Sentry key appears in URL, don't capture it as a request
	            // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
	            if (is_1.isString(url) && xhr.__sentry_xhr__.method === 'POST' && url.match(/sentry_key/)) {
	                xhr.__sentry_own_request__ = true;
	            }
	            var onreadystatechangeHandler = function () {
	                if (xhr.readyState === 4) {
	                    try {
	                        // touching statusCode in some platforms throws
	                        // an exception
	                        if (xhr.__sentry_xhr__) {
	                            xhr.__sentry_xhr__.status_code = xhr.status;
	                        }
	                    }
	                    catch (e) {
	                        /* do nothing */
	                    }
	                    try {
	                        var requestPos = requestKeys.indexOf(xhr);
	                        if (requestPos !== -1) {
	                            // Make sure to pop both key and value to keep it in sync.
	                            requestKeys.splice(requestPos);
	                            var args_1 = requestValues.splice(requestPos)[0];
	                            if (xhr.__sentry_xhr__ && args_1[0] !== undefined) {
	                                xhr.__sentry_xhr__.body = args_1[0];
	                            }
	                        }
	                    }
	                    catch (e) {
	                        /* do nothing */
	                    }
	                    triggerHandlers('xhr', {
	                        args: args,
	                        endTimestamp: Date.now(),
	                        startTimestamp: Date.now(),
	                        xhr: xhr,
	                    });
	                }
	            };
	            if ('onreadystatechange' in xhr && typeof xhr.onreadystatechange === 'function') {
	                object_1.fill(xhr, 'onreadystatechange', function (original) {
	                    return function () {
	                        var readyStateArgs = [];
	                        for (var _i = 0; _i < arguments.length; _i++) {
	                            readyStateArgs[_i] = arguments[_i];
	                        }
	                        onreadystatechangeHandler();
	                        return original.apply(xhr, readyStateArgs);
	                    };
	                });
	            }
	            else {
	                xhr.addEventListener('readystatechange', onreadystatechangeHandler);
	            }
	            return originalOpen.apply(xhr, args);
	        };
	    });
	    object_1.fill(xhrproto, 'send', function (originalSend) {
	        return function () {
	            var args = [];
	            for (var _i = 0; _i < arguments.length; _i++) {
	                args[_i] = arguments[_i];
	            }
	            requestKeys.push(this);
	            requestValues.push(args);
	            triggerHandlers('xhr', {
	                args: args,
	                startTimestamp: Date.now(),
	                xhr: this,
	            });
	            return originalSend.apply(this, args);
	        };
	    });
	}
	var lastHref;
	/** JSDoc */
	function instrumentHistory() {
	    if (!supports_1.supportsHistory()) {
	        return;
	    }
	    var oldOnPopState = global.onpopstate;
	    global.onpopstate = function () {
	        var args = [];
	        for (var _i = 0; _i < arguments.length; _i++) {
	            args[_i] = arguments[_i];
	        }
	        var to = global.location.href;
	        // keep track of the current URL state, as we always receive only the updated state
	        var from = lastHref;
	        lastHref = to;
	        triggerHandlers('history', {
	            from: from,
	            to: to,
	        });
	        if (oldOnPopState) {
	            return oldOnPopState.apply(this, args);
	        }
	    };
	    /** @hidden */
	    function historyReplacementFunction(originalHistoryFunction) {
	        return function () {
	            var args = [];
	            for (var _i = 0; _i < arguments.length; _i++) {
	                args[_i] = arguments[_i];
	            }
	            var url = args.length > 2 ? args[2] : undefined;
	            if (url) {
	                // coerce to string (this is what pushState does)
	                var from = lastHref;
	                var to = String(url);
	                // keep track of the current URL state, as we always receive only the updated state
	                lastHref = to;
	                triggerHandlers('history', {
	                    from: from,
	                    to: to,
	                });
	            }
	            return originalHistoryFunction.apply(this, args);
	        };
	    }
	    object_1.fill(global.history, 'pushState', historyReplacementFunction);
	    object_1.fill(global.history, 'replaceState', historyReplacementFunction);
	}
	/** JSDoc */
	function instrumentDOM() {
	    if (!('document' in global)) {
	        return;
	    }
	    // Capture breadcrumbs from any click that is unhandled / bubbled up all the way
	    // to the document. Do this before we instrument addEventListener.
	    global.document.addEventListener('click', domEventHandler('click', triggerHandlers.bind(null, 'dom')), false);
	    global.document.addEventListener('keypress', keypressEventHandler(triggerHandlers.bind(null, 'dom')), false);
	    // After hooking into document bubbled up click and keypresses events, we also hook into user handled click & keypresses.
	    ['EventTarget', 'Node'].forEach(function (target) {
	        /* eslint-disable @typescript-eslint/no-unsafe-member-access */
	        var proto = global[target] && global[target].prototype;
	        // eslint-disable-next-line no-prototype-builtins
	        if (!proto || !proto.hasOwnProperty || !proto.hasOwnProperty('addEventListener')) {
	            return;
	        }
	        /* eslint-enable @typescript-eslint/no-unsafe-member-access */
	        object_1.fill(proto, 'addEventListener', function (original) {
	            return function (eventName, fn, options) {
	                if (fn && fn.handleEvent) {
	                    if (eventName === 'click') {
	                        object_1.fill(fn, 'handleEvent', function (innerOriginal) {
	                            return function (event) {
	                                domEventHandler('click', triggerHandlers.bind(null, 'dom'))(event);
	                                return innerOriginal.call(this, event);
	                            };
	                        });
	                    }
	                    if (eventName === 'keypress') {
	                        object_1.fill(fn, 'handleEvent', function (innerOriginal) {
	                            return function (event) {
	                                keypressEventHandler(triggerHandlers.bind(null, 'dom'))(event);
	                                return innerOriginal.call(this, event);
	                            };
	                        });
	                    }
	                }
	                else {
	                    if (eventName === 'click') {
	                        domEventHandler('click', triggerHandlers.bind(null, 'dom'), true)(this);
	                    }
	                    if (eventName === 'keypress') {
	                        keypressEventHandler(triggerHandlers.bind(null, 'dom'))(this);
	                    }
	                }
	                return original.call(this, eventName, fn, options);
	            };
	        });
	        object_1.fill(proto, 'removeEventListener', function (original) {
	            return function (eventName, fn, options) {
	                try {
	                    original.call(this, eventName, fn.__sentry_wrapped__, options);
	                }
	                catch (e) {
	                    // ignore, accessing __sentry_wrapped__ will throw in some Selenium environments
	                }
	                return original.call(this, eventName, fn, options);
	            };
	        });
	    });
	}
	var debounceDuration = 1000;
	var debounceTimer = 0;
	var keypressTimeout;
	var lastCapturedEvent;
	/**
	 * Wraps addEventListener to capture UI breadcrumbs
	 * @param name the event name (e.g. "click")
	 * @param handler function that will be triggered
	 * @param debounce decides whether it should wait till another event loop
	 * @returns wrapped breadcrumb events handler
	 * @hidden
	 */
	function domEventHandler(name, handler, debounce) {
	    if (debounce === void 0) { debounce = false; }
	    return function (event) {
	        // reset keypress timeout; e.g. triggering a 'click' after
	        // a 'keypress' will reset the keypress debounce so that a new
	        // set of keypresses can be recorded
	        keypressTimeout = undefined;
	        // It's possible this handler might trigger multiple times for the same
	        // event (e.g. event propagation through node ancestors). Ignore if we've
	        // already captured the event.
	        if (!event || lastCapturedEvent === event) {
	            return;
	        }
	        lastCapturedEvent = event;
	        if (debounceTimer) {
	            clearTimeout(debounceTimer);
	        }
	        if (debounce) {
	            debounceTimer = setTimeout(function () {
	                handler({ event: event, name: name });
	            });
	        }
	        else {
	            handler({ event: event, name: name });
	        }
	    };
	}
	/**
	 * Wraps addEventListener to capture keypress UI events
	 * @param handler function that will be triggered
	 * @returns wrapped keypress events handler
	 * @hidden
	 */
	function keypressEventHandler(handler) {
	    // TODO: if somehow user switches keypress target before
	    //       debounce timeout is triggered, we will only capture
	    //       a single breadcrumb from the FIRST target (acceptable?)
	    return function (event) {
	        var target;
	        try {
	            target = event.target;
	        }
	        catch (e) {
	            // just accessing event properties can throw an exception in some rare circumstances
	            // see: https://github.com/getsentry/raven-js/issues/838
	            return;
	        }
	        var tagName = target && target.tagName;
	        // only consider keypress events on actual input elements
	        // this will disregard keypresses targeting body (e.g. tabbing
	        // through elements, hotkeys, etc)
	        if (!tagName || (tagName !== 'INPUT' && tagName !== 'TEXTAREA' && !target.isContentEditable)) {
	            return;
	        }
	        // record first keypress in a series, but ignore subsequent
	        // keypresses until debounce clears
	        if (!keypressTimeout) {
	            domEventHandler('input', handler)(event);
	        }
	        clearTimeout(keypressTimeout);
	        keypressTimeout = setTimeout(function () {
	            keypressTimeout = undefined;
	        }, debounceDuration);
	    };
	}
	var _oldOnErrorHandler = null;
	/** JSDoc */
	function instrumentError() {
	    _oldOnErrorHandler = global.onerror;
	    global.onerror = function (msg, url, line, column, error) {
	        triggerHandlers('error', {
	            column: column,
	            error: error,
	            line: line,
	            msg: msg,
	            url: url,
	        });
	        if (_oldOnErrorHandler) {
	            // eslint-disable-next-line prefer-rest-params
	            return _oldOnErrorHandler.apply(this, arguments);
	        }
	        return false;
	    };
	}
	var _oldOnUnhandledRejectionHandler = null;
	/** JSDoc */
	function instrumentUnhandledRejection() {
	    _oldOnUnhandledRejectionHandler = global.onunhandledrejection;
	    global.onunhandledrejection = function (e) {
	        triggerHandlers('unhandledrejection', e);
	        if (_oldOnUnhandledRejectionHandler) {
	            // eslint-disable-next-line prefer-rest-params
	            return _oldOnUnhandledRejectionHandler.apply(this, arguments);
	        }
	        return true;
	    };
	}
	//# sourceMappingURL=instrument.js.map

/***/ }),
/* 26 */
/***/ (function(module, exports, __webpack_require__) {

	Object.defineProperty(exports, "__esModule", { value: true });
	/* eslint-disable @typescript-eslint/no-explicit-any */
	var misc_1 = __webpack_require__(27);
	// TODO: Implement different loggers for different environments
	var global = misc_1.getGlobalObject();
	/** Prefix for logging strings */
	var PREFIX = 'Sentry Logger ';
	/** JSDoc */
	var Logger = /** @class */ (function () {
	    /** JSDoc */
	    function Logger() {
	        this._enabled = false;
	    }
	    /** JSDoc */
	    Logger.prototype.disable = function () {
	        this._enabled = false;
	    };
	    /** JSDoc */
	    Logger.prototype.enable = function () {
	        this._enabled = true;
	    };
	    /** JSDoc */
	    Logger.prototype.log = function () {
	        var args = [];
	        for (var _i = 0; _i < arguments.length; _i++) {
	            args[_i] = arguments[_i];
	        }
	        if (!this._enabled) {
	            return;
	        }
	        misc_1.consoleSandbox(function () {
	            global.console.log(PREFIX + "[Log]: " + args.join(' '));
	        });
	    };
	    /** JSDoc */
	    Logger.prototype.warn = function () {
	        var args = [];
	        for (var _i = 0; _i < arguments.length; _i++) {
	            args[_i] = arguments[_i];
	        }
	        if (!this._enabled) {
	            return;
	        }
	        misc_1.consoleSandbox(function () {
	            global.console.warn(PREFIX + "[Warn]: " + args.join(' '));
	        });
	    };
	    /** JSDoc */
	    Logger.prototype.error = function () {
	        var args = [];
	        for (var _i = 0; _i < arguments.length; _i++) {
	            args[_i] = arguments[_i];
	        }
	        if (!this._enabled) {
	            return;
	        }
	        misc_1.consoleSandbox(function () {
	            global.console.error(PREFIX + "[Error]: " + args.join(' '));
	        });
	    };
	    return Logger;
	}());
	// Ensure we only have a single logger instance, even if multiple versions of @sentry/utils are being used
	global.__SENTRY__ = global.__SENTRY__ || {};
	var logger = global.__SENTRY__.logger || (global.__SENTRY__.logger = new Logger());
	exports.logger = logger;
	//# sourceMappingURL=logger.js.map

/***/ }),
/* 27 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global) {Object.defineProperty(exports, "__esModule", { value: true });
	var node_1 = __webpack_require__(28);
	var string_1 = __webpack_require__(34);
	var fallbackGlobalObject = {};
	/**
	 * Safely get global scope object
	 *
	 * @returns Global scope object
	 */
	function getGlobalObject() {
	    return (node_1.isNodeEnv()
	        ? global
	        : typeof window !== 'undefined'
	            ? window
	            : typeof self !== 'undefined'
	                ? self
	                : fallbackGlobalObject);
	}
	exports.getGlobalObject = getGlobalObject;
	/**
	 * UUID4 generator
	 *
	 * @returns string Generated UUID4.
	 */
	function uuid4() {
	    var global = getGlobalObject();
	    var crypto = global.crypto || global.msCrypto;
	    if (!(crypto === void 0) && crypto.getRandomValues) {
	        // Use window.crypto API if available
	        var arr = new Uint16Array(8);
	        crypto.getRandomValues(arr);
	        // set 4 in byte 7
	        // eslint-disable-next-line no-bitwise
	        arr[3] = (arr[3] & 0xfff) | 0x4000;
	        // set 2 most significant bits of byte 9 to '10'
	        // eslint-disable-next-line no-bitwise
	        arr[4] = (arr[4] & 0x3fff) | 0x8000;
	        var pad = function (num) {
	            var v = num.toString(16);
	            while (v.length < 4) {
	                v = "0" + v;
	            }
	            return v;
	        };
	        return (pad(arr[0]) + pad(arr[1]) + pad(arr[2]) + pad(arr[3]) + pad(arr[4]) + pad(arr[5]) + pad(arr[6]) + pad(arr[7]));
	    }
	    // http://stackoverflow.com/questions/105034/how-to-create-a-guid-uuid-in-javascript/2117523#2117523
	    return 'xxxxxxxxxxxx4xxxyxxxxxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
	        // eslint-disable-next-line no-bitwise
	        var r = (Math.random() * 16) | 0;
	        // eslint-disable-next-line no-bitwise
	        var v = c === 'x' ? r : (r & 0x3) | 0x8;
	        return v.toString(16);
	    });
	}
	exports.uuid4 = uuid4;
	/**
	 * Parses string form of URL into an object
	 * // borrowed from https://tools.ietf.org/html/rfc3986#appendix-B
	 * // intentionally using regex and not <a/> href parsing trick because React Native and other
	 * // environments where DOM might not be available
	 * @returns parsed URL object
	 */
	function parseUrl(url) {
	    if (!url) {
	        return {};
	    }
	    var match = url.match(/^(([^:/?#]+):)?(\/\/([^/?#]*))?([^?#]*)(\?([^#]*))?(#(.*))?$/);
	    if (!match) {
	        return {};
	    }
	    // coerce to undefined values to empty string so we don't get 'undefined'
	    var query = match[6] || '';
	    var fragment = match[8] || '';
	    return {
	        host: match[4],
	        path: match[5],
	        protocol: match[2],
	        relative: match[5] + query + fragment,
	    };
	}
	exports.parseUrl = parseUrl;
	/**
	 * Extracts either message or type+value from an event that can be used for user-facing logs
	 * @returns event's description
	 */
	function getEventDescription(event) {
	    if (event.message) {
	        return event.message;
	    }
	    if (event.exception && event.exception.values && event.exception.values[0]) {
	        var exception = event.exception.values[0];
	        if (exception.type && exception.value) {
	            return exception.type + ": " + exception.value;
	        }
	        return exception.type || exception.value || event.event_id || '<unknown>';
	    }
	    return event.event_id || '<unknown>';
	}
	exports.getEventDescription = getEventDescription;
	/** JSDoc */
	function consoleSandbox(callback) {
	    var global = getGlobalObject();
	    var levels = ['debug', 'info', 'warn', 'error', 'log', 'assert'];
	    if (!('console' in global)) {
	        return callback();
	    }
	    // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
	    var originalConsole = global.console;
	    var wrappedLevels = {};
	    // Restore all wrapped console methods
	    levels.forEach(function (level) {
	        // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
	        if (level in global.console && originalConsole[level].__sentry_original__) {
	            wrappedLevels[level] = originalConsole[level];
	            originalConsole[level] = originalConsole[level].__sentry_original__;
	        }
	    });
	    // Perform callback manipulations
	    var result = callback();
	    // Revert restoration to wrapped state
	    Object.keys(wrappedLevels).forEach(function (level) {
	        originalConsole[level] = wrappedLevels[level];
	    });
	    return result;
	}
	exports.consoleSandbox = consoleSandbox;
	/**
	 * Adds exception values, type and value to an synthetic Exception.
	 * @param event The event to modify.
	 * @param value Value of the exception.
	 * @param type Type of the exception.
	 * @hidden
	 */
	function addExceptionTypeValue(event, value, type) {
	    event.exception = event.exception || {};
	    event.exception.values = event.exception.values || [];
	    event.exception.values[0] = event.exception.values[0] || {};
	    event.exception.values[0].value = event.exception.values[0].value || value || '';
	    event.exception.values[0].type = event.exception.values[0].type || type || 'Error';
	}
	exports.addExceptionTypeValue = addExceptionTypeValue;
	/**
	 * Adds exception mechanism to a given event.
	 * @param event The event to modify.
	 * @param mechanism Mechanism of the mechanism.
	 * @hidden
	 */
	function addExceptionMechanism(event, mechanism) {
	    if (mechanism === void 0) { mechanism = {}; }
	    // TODO: Use real type with `keyof Mechanism` thingy and maybe make it better?
	    try {
	        // @ts-ignore Type 'Mechanism | {}' is not assignable to type 'Mechanism | undefined'
	        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
	        event.exception.values[0].mechanism = event.exception.values[0].mechanism || {};
	        Object.keys(mechanism).forEach(function (key) {
	            // @ts-ignore Mechanism has no index signature
	            // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
	            event.exception.values[0].mechanism[key] = mechanism[key];
	        });
	    }
	    catch (_oO) {
	        // no-empty
	    }
	}
	exports.addExceptionMechanism = addExceptionMechanism;
	/**
	 * A safe form of location.href
	 */
	function getLocationHref() {
	    try {
	        return document.location.href;
	    }
	    catch (oO) {
	        return '';
	    }
	}
	exports.getLocationHref = getLocationHref;
	// https://semver.org/#is-there-a-suggested-regular-expression-regex-to-check-a-semver-string
	var SEMVER_REGEXP = /^(0|[1-9]\d*)\.(0|[1-9]\d*)\.(0|[1-9]\d*)(?:-((?:0|[1-9]\d*|\d*[a-zA-Z-][0-9a-zA-Z-]*)(?:\.(?:0|[1-9]\d*|\d*[a-zA-Z-][0-9a-zA-Z-]*))*))?(?:\+([0-9a-zA-Z-]+(?:\.[0-9a-zA-Z-]+)*))?$/;
	/**
	 * Parses input into a SemVer interface
	 * @param input string representation of a semver version
	 */
	function parseSemver(input) {
	    var match = input.match(SEMVER_REGEXP) || [];
	    var major = parseInt(match[1], 10);
	    var minor = parseInt(match[2], 10);
	    var patch = parseInt(match[3], 10);
	    return {
	        buildmetadata: match[5],
	        major: isNaN(major) ? undefined : major,
	        minor: isNaN(minor) ? undefined : minor,
	        patch: isNaN(patch) ? undefined : patch,
	        prerelease: match[4],
	    };
	}
	exports.parseSemver = parseSemver;
	var defaultRetryAfter = 60 * 1000; // 60 seconds
	/**
	 * Extracts Retry-After value from the request header or returns default value
	 * @param now current unix timestamp
	 * @param header string representation of 'Retry-After' header
	 */
	function parseRetryAfterHeader(now, header) {
	    if (!header) {
	        return defaultRetryAfter;
	    }
	    var headerDelay = parseInt("" + header, 10);
	    if (!isNaN(headerDelay)) {
	        return headerDelay * 1000;
	    }
	    var headerDate = Date.parse("" + header);
	    if (!isNaN(headerDate)) {
	        return headerDate - now;
	    }
	    return defaultRetryAfter;
	}
	exports.parseRetryAfterHeader = parseRetryAfterHeader;
	/**
	 * This function adds context (pre/post/line) lines to the provided frame
	 *
	 * @param lines string[] containing all lines
	 * @param frame StackFrame that will be mutated
	 * @param linesOfContext number of context lines we want to add pre/post
	 */
	function addContextToFrame(lines, frame, linesOfContext) {
	    if (linesOfContext === void 0) { linesOfContext = 5; }
	    var lineno = frame.lineno || 0;
	    var maxLines = lines.length;
	    var sourceLine = Math.max(Math.min(maxLines, lineno - 1), 0);
	    frame.pre_context = lines
	        .slice(Math.max(0, sourceLine - linesOfContext), sourceLine)
	        .map(function (line) { return string_1.snipLine(line, 0); });
	    frame.context_line = string_1.snipLine(lines[Math.min(maxLines - 1, sourceLine)], frame.colno || 0);
	    frame.post_context = lines
	        .slice(Math.min(sourceLine + 1, maxLines), sourceLine + 1 + linesOfContext)
	        .map(function (line) { return string_1.snipLine(line, 0); });
	}
	exports.addContextToFrame = addContextToFrame;
	/**
	 * Strip the query string and fragment off of a given URL or path (if present)
	 *
	 * @param urlPath Full URL or path, including possible query string and/or fragment
	 * @returns URL or path without query string or fragment
	 */
	function stripUrlQueryAndFragment(urlPath) {
	    // eslint-disable-next-line no-useless-escape
	    return urlPath.split(/[\?#]/, 1)[0];
	}
	exports.stripUrlQueryAndFragment = stripUrlQueryAndFragment;
	//# sourceMappingURL=misc.js.map
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ }),
/* 28 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(process, module) {Object.defineProperty(exports, "__esModule", { value: true });
	var is_1 = __webpack_require__(21);
	var object_1 = __webpack_require__(31);
	/**
	 * Checks whether we're in the Node.js or Browser environment
	 *
	 * @returns Answer to given question
	 */
	function isNodeEnv() {
	    return Object.prototype.toString.call(typeof process !== 'undefined' ? process : 0) === '[object process]';
	}
	exports.isNodeEnv = isNodeEnv;
	/**
	 * Requires a module which is protected against bundler minification.
	 *
	 * @param request The module path to resolve
	 */
	// eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
	function dynamicRequire(mod, request) {
	    // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
	    return mod.require(request);
	}
	exports.dynamicRequire = dynamicRequire;
	/** Default request keys that'll be used to extract data from the request */
	var DEFAULT_REQUEST_KEYS = ['cookies', 'data', 'headers', 'method', 'query_string', 'url'];
	/**
	 * Normalizes data from the request object, accounting for framework differences.
	 *
	 * @param req The request object from which to extract data
	 * @param keys An optional array of keys to include in the normalized data. Defaults to DEFAULT_REQUEST_KEYS if not
	 * provided.
	 * @returns An object containing normalized request data
	 */
	function extractNodeRequestData(req, keys) {
	    if (keys === void 0) { keys = DEFAULT_REQUEST_KEYS; }
	    // make sure we can safely use dynamicRequire below
	    if (!isNodeEnv()) {
	        throw new Error("Can't get node request data outside of a node environment");
	    }
	    var requestData = {};
	    // headers:
	    //   node, express: req.headers
	    //   koa: req.header
	    var headers = (req.headers || req.header || {});
	    // method:
	    //   node, express, koa: req.method
	    var method = req.method;
	    // host:
	    //   express: req.hostname in > 4 and req.host in < 4
	    //   koa: req.host
	    //   node: req.headers.host
	    var host = req.hostname || req.host || headers.host || '<no host>';
	    // protocol:
	    //   node: <n/a>
	    //   express, koa: req.protocol
	    var protocol = req.protocol === 'https' || req.secure || (req.socket || {}).encrypted
	        ? 'https'
	        : 'http';
	    // url (including path and query string):
	    //   node, express: req.originalUrl
	    //   koa: req.url
	    var originalUrl = (req.originalUrl || req.url || '');
	    // absolute url
	    var absoluteUrl = protocol + "://" + host + originalUrl;
	    keys.forEach(function (key) {
	        switch (key) {
	            case 'headers':
	                requestData.headers = headers;
	                break;
	            case 'method':
	                requestData.method = method;
	                break;
	            case 'url':
	                requestData.url = absoluteUrl;
	                break;
	            case 'cookies':
	                // cookies:
	                //   node, express, koa: req.headers.cookie
	                //   vercel, sails.js, express (w/ cookie middleware): req.cookies
	                // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
	                requestData.cookies = req.cookies || dynamicRequire(module, 'cookie').parse(headers.cookie || '');
	                break;
	            case 'query_string':
	                // query string:
	                //   node: req.url (raw)
	                //   express, koa: req.query
	                // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
	                requestData.query_string = dynamicRequire(module, 'url').parse(originalUrl || '', false).query;
	                break;
	            case 'data':
	                if (method === 'GET' || method === 'HEAD') {
	                    break;
	                }
	                // body data:
	                //   node, express, koa: req.body
	                if (req.body !== undefined) {
	                    requestData.data = is_1.isString(req.body) ? req.body : JSON.stringify(object_1.normalize(req.body));
	                }
	                break;
	            default:
	                if ({}.hasOwnProperty.call(req, key)) {
	                    requestData[key] = req[key];
	                }
	        }
	    });
	    return requestData;
	}
	exports.extractNodeRequestData = extractNodeRequestData;
	//# sourceMappingURL=node.js.map
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(29), __webpack_require__(30)(module)))

/***/ }),
/* 29 */
/***/ (function(module, exports) {

	// shim for using process in browser
	var process = module.exports = {};
	
	// cached from whatever global is present so that test runners that stub it
	// don't break things.  But we need to wrap it in a try catch in case it is
	// wrapped in strict mode code which doesn't define any globals.  It's inside a
	// function because try/catches deoptimize in certain engines.
	
	var cachedSetTimeout;
	var cachedClearTimeout;
	
	function defaultSetTimout() {
	    throw new Error('setTimeout has not been defined');
	}
	function defaultClearTimeout () {
	    throw new Error('clearTimeout has not been defined');
	}
	(function () {
	    try {
	        if (typeof setTimeout === 'function') {
	            cachedSetTimeout = setTimeout;
	        } else {
	            cachedSetTimeout = defaultSetTimout;
	        }
	    } catch (e) {
	        cachedSetTimeout = defaultSetTimout;
	    }
	    try {
	        if (typeof clearTimeout === 'function') {
	            cachedClearTimeout = clearTimeout;
	        } else {
	            cachedClearTimeout = defaultClearTimeout;
	        }
	    } catch (e) {
	        cachedClearTimeout = defaultClearTimeout;
	    }
	} ())
	function runTimeout(fun) {
	    if (cachedSetTimeout === setTimeout) {
	        //normal enviroments in sane situations
	        return setTimeout(fun, 0);
	    }
	    // if setTimeout wasn't available but was latter defined
	    if ((cachedSetTimeout === defaultSetTimout || !cachedSetTimeout) && setTimeout) {
	        cachedSetTimeout = setTimeout;
	        return setTimeout(fun, 0);
	    }
	    try {
	        // when when somebody has screwed with setTimeout but no I.E. maddness
	        return cachedSetTimeout(fun, 0);
	    } catch(e){
	        try {
	            // When we are in I.E. but the script has been evaled so I.E. doesn't trust the global object when called normally
	            return cachedSetTimeout.call(null, fun, 0);
	        } catch(e){
	            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error
	            return cachedSetTimeout.call(this, fun, 0);
	        }
	    }
	
	
	}
	function runClearTimeout(marker) {
	    if (cachedClearTimeout === clearTimeout) {
	        //normal enviroments in sane situations
	        return clearTimeout(marker);
	    }
	    // if clearTimeout wasn't available but was latter defined
	    if ((cachedClearTimeout === defaultClearTimeout || !cachedClearTimeout) && clearTimeout) {
	        cachedClearTimeout = clearTimeout;
	        return clearTimeout(marker);
	    }
	    try {
	        // when when somebody has screwed with setTimeout but no I.E. maddness
	        return cachedClearTimeout(marker);
	    } catch (e){
	        try {
	            // When we are in I.E. but the script has been evaled so I.E. doesn't  trust the global object when called normally
	            return cachedClearTimeout.call(null, marker);
	        } catch (e){
	            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error.
	            // Some versions of I.E. have different rules for clearTimeout vs setTimeout
	            return cachedClearTimeout.call(this, marker);
	        }
	    }
	
	
	
	}
	var queue = [];
	var draining = false;
	var currentQueue;
	var queueIndex = -1;
	
	function cleanUpNextTick() {
	    if (!draining || !currentQueue) {
	        return;
	    }
	    draining = false;
	    if (currentQueue.length) {
	        queue = currentQueue.concat(queue);
	    } else {
	        queueIndex = -1;
	    }
	    if (queue.length) {
	        drainQueue();
	    }
	}
	
	function drainQueue() {
	    if (draining) {
	        return;
	    }
	    var timeout = runTimeout(cleanUpNextTick);
	    draining = true;
	
	    var len = queue.length;
	    while(len) {
	        currentQueue = queue;
	        queue = [];
	        while (++queueIndex < len) {
	            if (currentQueue) {
	                currentQueue[queueIndex].run();
	            }
	        }
	        queueIndex = -1;
	        len = queue.length;
	    }
	    currentQueue = null;
	    draining = false;
	    runClearTimeout(timeout);
	}
	
	process.nextTick = function (fun) {
	    var args = new Array(arguments.length - 1);
	    if (arguments.length > 1) {
	        for (var i = 1; i < arguments.length; i++) {
	            args[i - 1] = arguments[i];
	        }
	    }
	    queue.push(new Item(fun, args));
	    if (queue.length === 1 && !draining) {
	        runTimeout(drainQueue);
	    }
	};
	
	// v8 likes predictible objects
	function Item(fun, array) {
	    this.fun = fun;
	    this.array = array;
	}
	Item.prototype.run = function () {
	    this.fun.apply(null, this.array);
	};
	process.title = 'browser';
	process.browser = true;
	process.env = {};
	process.argv = [];
	process.version = ''; // empty string to avoid regexp issues
	process.versions = {};
	
	function noop() {}
	
	process.on = noop;
	process.addListener = noop;
	process.once = noop;
	process.off = noop;
	process.removeListener = noop;
	process.removeAllListeners = noop;
	process.emit = noop;
	process.prependListener = noop;
	process.prependOnceListener = noop;
	
	process.listeners = function (name) { return [] }
	
	process.binding = function (name) {
	    throw new Error('process.binding is not supported');
	};
	
	process.cwd = function () { return '/' };
	process.chdir = function (dir) {
	    throw new Error('process.chdir is not supported');
	};
	process.umask = function() { return 0; };


/***/ }),
/* 30 */
/***/ (function(module, exports) {

	module.exports = function(module) {
		if(!module.webpackPolyfill) {
			module.deprecate = function() {};
			module.paths = [];
			// module.parent = undefined by default
			module.children = [];
			module.webpackPolyfill = 1;
		}
		return module;
	}


/***/ }),
/* 31 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global) {Object.defineProperty(exports, "__esModule", { value: true });
	var tslib_1 = __webpack_require__(6);
	var browser_1 = __webpack_require__(20);
	var is_1 = __webpack_require__(21);
	var memo_1 = __webpack_require__(32);
	var stacktrace_1 = __webpack_require__(33);
	var string_1 = __webpack_require__(34);
	/**
	 * Wrap a given object method with a higher-order function
	 *
	 * @param source An object that contains a method to be wrapped.
	 * @param name A name of method to be wrapped.
	 * @param replacementFactory A function that should be used to wrap a given method, returning the wrapped method which
	 * will be substituted in for `source[name]`.
	 * @returns void
	 */
	function fill(source, name, replacementFactory) {
	    if (!(name in source)) {
	        return;
	    }
	    var original = source[name];
	    var wrapped = replacementFactory(original);
	    // Make sure it's a function first, as we need to attach an empty prototype for `defineProperties` to work
	    // otherwise it'll throw "TypeError: Object.defineProperties called on non-object"
	    if (typeof wrapped === 'function') {
	        try {
	            wrapped.prototype = wrapped.prototype || {};
	            Object.defineProperties(wrapped, {
	                __sentry_original__: {
	                    enumerable: false,
	                    value: original,
	                },
	            });
	        }
	        catch (_Oo) {
	            // This can throw if multiple fill happens on a global object like XMLHttpRequest
	            // Fixes https://github.com/getsentry/sentry-javascript/issues/2043
	        }
	    }
	    source[name] = wrapped;
	}
	exports.fill = fill;
	/**
	 * Encodes given object into url-friendly format
	 *
	 * @param object An object that contains serializable values
	 * @returns string Encoded
	 */
	function urlEncode(object) {
	    return Object.keys(object)
	        .map(function (key) { return encodeURIComponent(key) + "=" + encodeURIComponent(object[key]); })
	        .join('&');
	}
	exports.urlEncode = urlEncode;
	/**
	 * Transforms any object into an object literal with all its attributes
	 * attached to it.
	 *
	 * @param value Initial source that we have to transform in order for it to be usable by the serializer
	 */
	function getWalkSource(value) {
	    if (is_1.isError(value)) {
	        var error = value;
	        var err = {
	            message: error.message,
	            name: error.name,
	            stack: error.stack,
	        };
	        for (var i in error) {
	            if (Object.prototype.hasOwnProperty.call(error, i)) {
	                err[i] = error[i];
	            }
	        }
	        return err;
	    }
	    if (is_1.isEvent(value)) {
	        var event_1 = value;
	        var source = {};
	        source.type = event_1.type;
	        // Accessing event.target can throw (see getsentry/raven-js#838, #768)
	        try {
	            source.target = is_1.isElement(event_1.target)
	                ? browser_1.htmlTreeAsString(event_1.target)
	                : Object.prototype.toString.call(event_1.target);
	        }
	        catch (_oO) {
	            source.target = '<unknown>';
	        }
	        try {
	            source.currentTarget = is_1.isElement(event_1.currentTarget)
	                ? browser_1.htmlTreeAsString(event_1.currentTarget)
	                : Object.prototype.toString.call(event_1.currentTarget);
	        }
	        catch (_oO) {
	            source.currentTarget = '<unknown>';
	        }
	        if (typeof CustomEvent !== 'undefined' && is_1.isInstanceOf(value, CustomEvent)) {
	            source.detail = event_1.detail;
	        }
	        for (var i in event_1) {
	            if (Object.prototype.hasOwnProperty.call(event_1, i)) {
	                source[i] = event_1;
	            }
	        }
	        return source;
	    }
	    return value;
	}
	/** Calculates bytes size of input string */
	function utf8Length(value) {
	    // eslint-disable-next-line no-bitwise
	    return ~-encodeURI(value).split(/%..|./).length;
	}
	/** Calculates bytes size of input object */
	function jsonSize(value) {
	    return utf8Length(JSON.stringify(value));
	}
	/** JSDoc */
	function normalizeToSize(object, 
	// Default Node.js REPL depth
	depth, 
	// 100kB, as 200kB is max payload size, so half sounds reasonable
	maxSize) {
	    if (depth === void 0) { depth = 3; }
	    if (maxSize === void 0) { maxSize = 100 * 1024; }
	    var serialized = normalize(object, depth);
	    if (jsonSize(serialized) > maxSize) {
	        return normalizeToSize(object, depth - 1, maxSize);
	    }
	    return serialized;
	}
	exports.normalizeToSize = normalizeToSize;
	/**
	 * Transform any non-primitive, BigInt, or Symbol-type value into a string. Acts as a no-op on strings, numbers,
	 * booleans, null, and undefined.
	 *
	 * @param value The value to stringify
	 * @returns For non-primitive, BigInt, and Symbol-type values, a string denoting the value's type, type and value, or
	 *  type and `description` property, respectively. For non-BigInt, non-Symbol primitives, returns the original value,
	 *  unchanged.
	 */
	function serializeValue(value) {
	    var type = Object.prototype.toString.call(value);
	    // Node.js REPL notation
	    if (typeof value === 'string') {
	        return value;
	    }
	    if (type === '[object Object]') {
	        return '[Object]';
	    }
	    if (type === '[object Array]') {
	        return '[Array]';
	    }
	    var normalized = normalizeValue(value);
	    return is_1.isPrimitive(normalized) ? normalized : type;
	}
	/**
	 * normalizeValue()
	 *
	 * Takes unserializable input and make it serializable friendly
	 *
	 * - translates undefined/NaN values to "[undefined]"/"[NaN]" respectively,
	 * - serializes Error objects
	 * - filter global objects
	 */
	function normalizeValue(value, key) {
	    if (key === 'domain' && value && typeof value === 'object' && value._events) {
	        return '[Domain]';
	    }
	    if (key === 'domainEmitter') {
	        return '[DomainEmitter]';
	    }
	    if (typeof global !== 'undefined' && value === global) {
	        return '[Global]';
	    }
	    if (typeof window !== 'undefined' && value === window) {
	        return '[Window]';
	    }
	    if (typeof document !== 'undefined' && value === document) {
	        return '[Document]';
	    }
	    // React's SyntheticEvent thingy
	    if (is_1.isSyntheticEvent(value)) {
	        return '[SyntheticEvent]';
	    }
	    if (typeof value === 'number' && value !== value) {
	        return '[NaN]';
	    }
	    if (value === void 0) {
	        return '[undefined]';
	    }
	    if (typeof value === 'function') {
	        return "[Function: " + stacktrace_1.getFunctionName(value) + "]";
	    }
	    // symbols and bigints are considered primitives by TS, but aren't natively JSON-serilaizable
	    if (typeof value === 'symbol') {
	        return "[" + String(value) + "]";
	    }
	    if (typeof value === 'bigint') {
	        return "[BigInt: " + String(value) + "]";
	    }
	    return value;
	}
	/**
	 * Walks an object to perform a normalization on it
	 *
	 * @param key of object that's walked in current iteration
	 * @param value object to be walked
	 * @param depth Optional number indicating how deep should walking be performed
	 * @param memo Optional Memo class handling decycling
	 */
	// eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
	function walk(key, value, depth, memo) {
	    if (depth === void 0) { depth = +Infinity; }
	    if (memo === void 0) { memo = new memo_1.Memo(); }
	    // If we reach the maximum depth, serialize whatever has left
	    if (depth === 0) {
	        return serializeValue(value);
	    }
	    /* eslint-disable @typescript-eslint/no-unsafe-member-access */
	    // If value implements `toJSON` method, call it and return early
	    if (value !== null && value !== undefined && typeof value.toJSON === 'function') {
	        return value.toJSON();
	    }
	    /* eslint-enable @typescript-eslint/no-unsafe-member-access */
	    // If normalized value is a primitive, there are no branches left to walk, so we can just bail out, as theres no point in going down that branch any further
	    var normalized = normalizeValue(value, key);
	    if (is_1.isPrimitive(normalized)) {
	        return normalized;
	    }
	    // Create source that we will use for next itterations, either objectified error object (Error type with extracted keys:value pairs) or the input itself
	    var source = getWalkSource(value);
	    // Create an accumulator that will act as a parent for all future itterations of that branch
	    var acc = Array.isArray(value) ? [] : {};
	    // If we already walked that branch, bail out, as it's circular reference
	    if (memo.memoize(value)) {
	        return '[Circular ~]';
	    }
	    // Walk all keys of the source
	    for (var innerKey in source) {
	        // Avoid iterating over fields in the prototype if they've somehow been exposed to enumeration.
	        if (!Object.prototype.hasOwnProperty.call(source, innerKey)) {
	            continue;
	        }
	        // Recursively walk through all the child nodes
	        acc[innerKey] = walk(innerKey, source[innerKey], depth - 1, memo);
	    }
	    // Once walked through all the branches, remove the parent from memo storage
	    memo.unmemoize(value);
	    // Return accumulated values
	    return acc;
	}
	exports.walk = walk;
	/**
	 * normalize()
	 *
	 * - Creates a copy to prevent original input mutation
	 * - Skip non-enumerablers
	 * - Calls `toJSON` if implemented
	 * - Removes circular references
	 * - Translates non-serializeable values (undefined/NaN/Functions) to serializable format
	 * - Translates known global objects/Classes to a string representations
	 * - Takes care of Error objects serialization
	 * - Optionally limit depth of final output
	 */
	// eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
	function normalize(input, depth) {
	    try {
	        return JSON.parse(JSON.stringify(input, function (key, value) { return walk(key, value, depth); }));
	    }
	    catch (_oO) {
	        return '**non-serializable**';
	    }
	}
	exports.normalize = normalize;
	/**
	 * Given any captured exception, extract its keys and create a sorted
	 * and truncated list that will be used inside the event message.
	 * eg. `Non-error exception captured with keys: foo, bar, baz`
	 */
	// eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
	function extractExceptionKeysForMessage(exception, maxLength) {
	    if (maxLength === void 0) { maxLength = 40; }
	    var keys = Object.keys(getWalkSource(exception));
	    keys.sort();
	    if (!keys.length) {
	        return '[object has no keys]';
	    }
	    if (keys[0].length >= maxLength) {
	        return string_1.truncate(keys[0], maxLength);
	    }
	    for (var includedKeys = keys.length; includedKeys > 0; includedKeys--) {
	        var serialized = keys.slice(0, includedKeys).join(', ');
	        if (serialized.length > maxLength) {
	            continue;
	        }
	        if (includedKeys === keys.length) {
	            return serialized;
	        }
	        return string_1.truncate(serialized, maxLength);
	    }
	    return '';
	}
	exports.extractExceptionKeysForMessage = extractExceptionKeysForMessage;
	/**
	 * Given any object, return the new object with removed keys that value was `undefined`.
	 * Works recursively on objects and arrays.
	 */
	function dropUndefinedKeys(val) {
	    var e_1, _a;
	    if (is_1.isPlainObject(val)) {
	        var obj = val;
	        var rv = {};
	        try {
	            for (var _b = tslib_1.__values(Object.keys(obj)), _c = _b.next(); !_c.done; _c = _b.next()) {
	                var key = _c.value;
	                if (typeof obj[key] !== 'undefined') {
	                    rv[key] = dropUndefinedKeys(obj[key]);
	                }
	            }
	        }
	        catch (e_1_1) { e_1 = { error: e_1_1 }; }
	        finally {
	            try {
	                if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
	            }
	            finally { if (e_1) throw e_1.error; }
	        }
	        return rv;
	    }
	    if (Array.isArray(val)) {
	        return val.map(dropUndefinedKeys);
	    }
	    return val;
	}
	exports.dropUndefinedKeys = dropUndefinedKeys;
	//# sourceMappingURL=object.js.map
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ }),
/* 32 */
/***/ (function(module, exports) {

	Object.defineProperty(exports, "__esModule", { value: true });
	/* eslint-disable @typescript-eslint/no-unsafe-member-access */
	/* eslint-disable @typescript-eslint/no-explicit-any */
	/* eslint-disable @typescript-eslint/explicit-module-boundary-types */
	/**
	 * Memo class used for decycle json objects. Uses WeakSet if available otherwise array.
	 */
	var Memo = /** @class */ (function () {
	    function Memo() {
	        this._hasWeakSet = typeof WeakSet === 'function';
	        this._inner = this._hasWeakSet ? new WeakSet() : [];
	    }
	    /**
	     * Sets obj to remember.
	     * @param obj Object to remember
	     */
	    Memo.prototype.memoize = function (obj) {
	        if (this._hasWeakSet) {
	            if (this._inner.has(obj)) {
	                return true;
	            }
	            this._inner.add(obj);
	            return false;
	        }
	        // eslint-disable-next-line @typescript-eslint/prefer-for-of
	        for (var i = 0; i < this._inner.length; i++) {
	            var value = this._inner[i];
	            if (value === obj) {
	                return true;
	            }
	        }
	        this._inner.push(obj);
	        return false;
	    };
	    /**
	     * Removes object from internal storage.
	     * @param obj Object to forget
	     */
	    Memo.prototype.unmemoize = function (obj) {
	        if (this._hasWeakSet) {
	            this._inner.delete(obj);
	        }
	        else {
	            for (var i = 0; i < this._inner.length; i++) {
	                if (this._inner[i] === obj) {
	                    this._inner.splice(i, 1);
	                    break;
	                }
	            }
	        }
	    };
	    return Memo;
	}());
	exports.Memo = Memo;
	//# sourceMappingURL=memo.js.map

/***/ }),
/* 33 */
/***/ (function(module, exports) {

	Object.defineProperty(exports, "__esModule", { value: true });
	var defaultFunctionName = '<anonymous>';
	/**
	 * Safely extract function name from itself
	 */
	function getFunctionName(fn) {
	    try {
	        if (!fn || typeof fn !== 'function') {
	            return defaultFunctionName;
	        }
	        return fn.name || defaultFunctionName;
	    }
	    catch (e) {
	        // Just accessing custom props in some Selenium environments
	        // can cause a "Permission denied" exception (see raven-js#495).
	        return defaultFunctionName;
	    }
	}
	exports.getFunctionName = getFunctionName;
	//# sourceMappingURL=stacktrace.js.map

/***/ }),
/* 34 */
/***/ (function(module, exports, __webpack_require__) {

	Object.defineProperty(exports, "__esModule", { value: true });
	var is_1 = __webpack_require__(21);
	/**
	 * Truncates given string to the maximum characters count
	 *
	 * @param str An object that contains serializable values
	 * @param max Maximum number of characters in truncated string (0 = unlimited)
	 * @returns string Encoded
	 */
	function truncate(str, max) {
	    if (max === void 0) { max = 0; }
	    if (typeof str !== 'string' || max === 0) {
	        return str;
	    }
	    return str.length <= max ? str : str.substr(0, max) + "...";
	}
	exports.truncate = truncate;
	/**
	 * This is basically just `trim_line` from
	 * https://github.com/getsentry/sentry/blob/master/src/sentry/lang/javascript/processor.py#L67
	 *
	 * @param str An object that contains serializable values
	 * @param max Maximum number of characters in truncated string
	 * @returns string Encoded
	 */
	function snipLine(line, colno) {
	    var newLine = line;
	    var ll = newLine.length;
	    if (ll <= 150) {
	        return newLine;
	    }
	    if (colno > ll) {
	        // eslint-disable-next-line no-param-reassign
	        colno = ll;
	    }
	    var start = Math.max(colno - 60, 0);
	    if (start < 5) {
	        start = 0;
	    }
	    var end = Math.min(start + 140, ll);
	    if (end > ll - 5) {
	        end = ll;
	    }
	    if (end === ll) {
	        start = Math.max(end - 140, 0);
	    }
	    newLine = newLine.slice(start, end);
	    if (start > 0) {
	        newLine = "'{snip} " + newLine;
	    }
	    if (end < ll) {
	        newLine += ' {snip}';
	    }
	    return newLine;
	}
	exports.snipLine = snipLine;
	/**
	 * Join values in array
	 * @param input array of values to be joined together
	 * @param delimiter string to be placed in-between values
	 * @returns Joined values
	 */
	// eslint-disable-next-line @typescript-eslint/no-explicit-any
	function safeJoin(input, delimiter) {
	    if (!Array.isArray(input)) {
	        return '';
	    }
	    var output = [];
	    // eslint-disable-next-line @typescript-eslint/prefer-for-of
	    for (var i = 0; i < input.length; i++) {
	        var value = input[i];
	        try {
	            output.push(String(value));
	        }
	        catch (e) {
	            output.push('[value cannot be serialized]');
	        }
	    }
	    return output.join(delimiter);
	}
	exports.safeJoin = safeJoin;
	/**
	 * Checks if the value matches a regex or includes the string
	 * @param value The string value to be checked against
	 * @param pattern Either a regex or a string that must be contained in value
	 */
	function isMatchingPattern(value, pattern) {
	    if (!is_1.isString(value)) {
	        return false;
	    }
	    if (is_1.isRegExp(pattern)) {
	        return pattern.test(value);
	    }
	    if (typeof pattern === 'string') {
	        return value.indexOf(pattern) !== -1;
	    }
	    return false;
	}
	exports.isMatchingPattern = isMatchingPattern;
	//# sourceMappingURL=string.js.map

/***/ }),
/* 35 */
/***/ (function(module, exports, __webpack_require__) {

	Object.defineProperty(exports, "__esModule", { value: true });
	var logger_1 = __webpack_require__(26);
	var misc_1 = __webpack_require__(27);
	/**
	 * Tells whether current environment supports ErrorEvent objects
	 * {@link supportsErrorEvent}.
	 *
	 * @returns Answer to the given question.
	 */
	function supportsErrorEvent() {
	    try {
	        new ErrorEvent('');
	        return true;
	    }
	    catch (e) {
	        return false;
	    }
	}
	exports.supportsErrorEvent = supportsErrorEvent;
	/**
	 * Tells whether current environment supports DOMError objects
	 * {@link supportsDOMError}.
	 *
	 * @returns Answer to the given question.
	 */
	function supportsDOMError() {
	    try {
	        // Chrome: VM89:1 Uncaught TypeError: Failed to construct 'DOMError':
	        // 1 argument required, but only 0 present.
	        // @ts-ignore It really needs 1 argument, not 0.
	        new DOMError('');
	        return true;
	    }
	    catch (e) {
	        return false;
	    }
	}
	exports.supportsDOMError = supportsDOMError;
	/**
	 * Tells whether current environment supports DOMException objects
	 * {@link supportsDOMException}.
	 *
	 * @returns Answer to the given question.
	 */
	function supportsDOMException() {
	    try {
	        new DOMException('');
	        return true;
	    }
	    catch (e) {
	        return false;
	    }
	}
	exports.supportsDOMException = supportsDOMException;
	/**
	 * Tells whether current environment supports Fetch API
	 * {@link supportsFetch}.
	 *
	 * @returns Answer to the given question.
	 */
	function supportsFetch() {
	    if (!('fetch' in misc_1.getGlobalObject())) {
	        return false;
	    }
	    try {
	        new Headers();
	        new Request('');
	        new Response();
	        return true;
	    }
	    catch (e) {
	        return false;
	    }
	}
	exports.supportsFetch = supportsFetch;
	/**
	 * isNativeFetch checks if the given function is a native implementation of fetch()
	 */
	// eslint-disable-next-line @typescript-eslint/ban-types
	function isNativeFetch(func) {
	    return func && /^function fetch\(\)\s+\{\s+\[native code\]\s+\}$/.test(func.toString());
	}
	/**
	 * Tells whether current environment supports Fetch API natively
	 * {@link supportsNativeFetch}.
	 *
	 * @returns true if `window.fetch` is natively implemented, false otherwise
	 */
	function supportsNativeFetch() {
	    if (!supportsFetch()) {
	        return false;
	    }
	    var global = misc_1.getGlobalObject();
	    // Fast path to avoid DOM I/O
	    // eslint-disable-next-line @typescript-eslint/unbound-method
	    if (isNativeFetch(global.fetch)) {
	        return true;
	    }
	    // window.fetch is implemented, but is polyfilled or already wrapped (e.g: by a chrome extension)
	    // so create a "pure" iframe to see if that has native fetch
	    var result = false;
	    var doc = global.document;
	    // eslint-disable-next-line deprecation/deprecation
	    if (doc && typeof doc.createElement === "function") {
	        try {
	            var sandbox = doc.createElement('iframe');
	            sandbox.hidden = true;
	            doc.head.appendChild(sandbox);
	            if (sandbox.contentWindow && sandbox.contentWindow.fetch) {
	                // eslint-disable-next-line @typescript-eslint/unbound-method
	                result = isNativeFetch(sandbox.contentWindow.fetch);
	            }
	            doc.head.removeChild(sandbox);
	        }
	        catch (err) {
	            logger_1.logger.warn('Could not create sandbox iframe for pure fetch check, bailing to window.fetch: ', err);
	        }
	    }
	    return result;
	}
	exports.supportsNativeFetch = supportsNativeFetch;
	/**
	 * Tells whether current environment supports ReportingObserver API
	 * {@link supportsReportingObserver}.
	 *
	 * @returns Answer to the given question.
	 */
	function supportsReportingObserver() {
	    return 'ReportingObserver' in misc_1.getGlobalObject();
	}
	exports.supportsReportingObserver = supportsReportingObserver;
	/**
	 * Tells whether current environment supports Referrer Policy API
	 * {@link supportsReferrerPolicy}.
	 *
	 * @returns Answer to the given question.
	 */
	function supportsReferrerPolicy() {
	    // Despite all stars in the sky saying that Edge supports old draft syntax, aka 'never', 'always', 'origin' and 'default
	    // https://caniuse.com/#feat=referrer-policy
	    // It doesn't. And it throw exception instead of ignoring this parameter...
	    // REF: https://github.com/getsentry/raven-js/issues/1233
	    if (!supportsFetch()) {
	        return false;
	    }
	    try {
	        new Request('_', {
	            referrerPolicy: 'origin',
	        });
	        return true;
	    }
	    catch (e) {
	        return false;
	    }
	}
	exports.supportsReferrerPolicy = supportsReferrerPolicy;
	/**
	 * Tells whether current environment supports History API
	 * {@link supportsHistory}.
	 *
	 * @returns Answer to the given question.
	 */
	function supportsHistory() {
	    // NOTE: in Chrome App environment, touching history.pushState, *even inside
	    //       a try/catch block*, will cause Chrome to output an error to console.error
	    // borrowed from: https://github.com/angular/angular.js/pull/13945/files
	    var global = misc_1.getGlobalObject();
	    /* eslint-disable @typescript-eslint/no-unsafe-member-access */
	    // eslint-disable-next-line @typescript-eslint/no-explicit-any
	    var chrome = global.chrome;
	    var isChromePackagedApp = chrome && chrome.app && chrome.app.runtime;
	    /* eslint-enable @typescript-eslint/no-unsafe-member-access */
	    var hasHistoryApi = 'history' in global && !!global.history.pushState && !!global.history.replaceState;
	    return !isChromePackagedApp && hasHistoryApi;
	}
	exports.supportsHistory = supportsHistory;
	//# sourceMappingURL=supports.js.map

/***/ }),
/* 36 */
/***/ (function(module, exports) {

	// Slightly modified (no IE8 support, ES6) and transcribed to TypeScript
	// https://raw.githubusercontent.com/calvinmetcalf/rollup-plugin-node-builtins/master/src/es6/path.js
	Object.defineProperty(exports, "__esModule", { value: true });
	/** JSDoc */
	function normalizeArray(parts, allowAboveRoot) {
	    // if the path tries to go above the root, `up` ends up > 0
	    var up = 0;
	    for (var i = parts.length - 1; i >= 0; i--) {
	        var last = parts[i];
	        if (last === '.') {
	            parts.splice(i, 1);
	        }
	        else if (last === '..') {
	            parts.splice(i, 1);
	            // eslint-disable-next-line no-plusplus
	            up++;
	        }
	        else if (up) {
	            parts.splice(i, 1);
	            // eslint-disable-next-line no-plusplus
	            up--;
	        }
	    }
	    // if the path is allowed to go above the root, restore leading ..s
	    if (allowAboveRoot) {
	        // eslint-disable-next-line no-plusplus
	        for (; up--; up) {
	            parts.unshift('..');
	        }
	    }
	    return parts;
	}
	// Split a filename into [root, dir, basename, ext], unix version
	// 'root' is just a slash, or nothing.
	var splitPathRe = /^(\/?|)([\s\S]*?)((?:\.{1,2}|[^/]+?|)(\.[^./]*|))(?:[/]*)$/;
	/** JSDoc */
	function splitPath(filename) {
	    var parts = splitPathRe.exec(filename);
	    return parts ? parts.slice(1) : [];
	}
	// path.resolve([from ...], to)
	// posix version
	/** JSDoc */
	function resolve() {
	    var args = [];
	    for (var _i = 0; _i < arguments.length; _i++) {
	        args[_i] = arguments[_i];
	    }
	    var resolvedPath = '';
	    var resolvedAbsolute = false;
	    for (var i = args.length - 1; i >= -1 && !resolvedAbsolute; i--) {
	        var path = i >= 0 ? args[i] : '/';
	        // Skip empty entries
	        if (!path) {
	            continue;
	        }
	        resolvedPath = path + "/" + resolvedPath;
	        resolvedAbsolute = path.charAt(0) === '/';
	    }
	    // At this point the path should be resolved to a full absolute path, but
	    // handle relative paths to be safe (might happen when process.cwd() fails)
	    // Normalize the path
	    resolvedPath = normalizeArray(resolvedPath.split('/').filter(function (p) { return !!p; }), !resolvedAbsolute).join('/');
	    return (resolvedAbsolute ? '/' : '') + resolvedPath || '.';
	}
	exports.resolve = resolve;
	/** JSDoc */
	function trim(arr) {
	    var start = 0;
	    for (; start < arr.length; start++) {
	        if (arr[start] !== '') {
	            break;
	        }
	    }
	    var end = arr.length - 1;
	    for (; end >= 0; end--) {
	        if (arr[end] !== '') {
	            break;
	        }
	    }
	    if (start > end) {
	        return [];
	    }
	    return arr.slice(start, end - start + 1);
	}
	// path.relative(from, to)
	// posix version
	/** JSDoc */
	function relative(from, to) {
	    /* eslint-disable no-param-reassign */
	    from = resolve(from).substr(1);
	    to = resolve(to).substr(1);
	    /* eslint-enable no-param-reassign */
	    var fromParts = trim(from.split('/'));
	    var toParts = trim(to.split('/'));
	    var length = Math.min(fromParts.length, toParts.length);
	    var samePartsLength = length;
	    for (var i = 0; i < length; i++) {
	        if (fromParts[i] !== toParts[i]) {
	            samePartsLength = i;
	            break;
	        }
	    }
	    var outputParts = [];
	    for (var i = samePartsLength; i < fromParts.length; i++) {
	        outputParts.push('..');
	    }
	    outputParts = outputParts.concat(toParts.slice(samePartsLength));
	    return outputParts.join('/');
	}
	exports.relative = relative;
	// path.normalize(path)
	// posix version
	/** JSDoc */
	function normalizePath(path) {
	    var isPathAbsolute = isAbsolute(path);
	    var trailingSlash = path.substr(-1) === '/';
	    // Normalize the path
	    var normalizedPath = normalizeArray(path.split('/').filter(function (p) { return !!p; }), !isPathAbsolute).join('/');
	    if (!normalizedPath && !isPathAbsolute) {
	        normalizedPath = '.';
	    }
	    if (normalizedPath && trailingSlash) {
	        normalizedPath += '/';
	    }
	    return (isPathAbsolute ? '/' : '') + normalizedPath;
	}
	exports.normalizePath = normalizePath;
	// posix version
	/** JSDoc */
	function isAbsolute(path) {
	    return path.charAt(0) === '/';
	}
	exports.isAbsolute = isAbsolute;
	// posix version
	/** JSDoc */
	function join() {
	    var args = [];
	    for (var _i = 0; _i < arguments.length; _i++) {
	        args[_i] = arguments[_i];
	    }
	    return normalizePath(args.join('/'));
	}
	exports.join = join;
	/** JSDoc */
	function dirname(path) {
	    var result = splitPath(path);
	    var root = result[0];
	    var dir = result[1];
	    if (!root && !dir) {
	        // No dirname whatsoever
	        return '.';
	    }
	    if (dir) {
	        // It has a dirname, strip trailing slash
	        dir = dir.substr(0, dir.length - 1);
	    }
	    return root + dir;
	}
	exports.dirname = dirname;
	/** JSDoc */
	function basename(path, ext) {
	    var f = splitPath(path)[2];
	    if (ext && f.substr(ext.length * -1) === ext) {
	        f = f.substr(0, f.length - ext.length);
	    }
	    return f;
	}
	exports.basename = basename;
	//# sourceMappingURL=path.js.map

/***/ }),
/* 37 */
/***/ (function(module, exports, __webpack_require__) {

	Object.defineProperty(exports, "__esModule", { value: true });
	var error_1 = __webpack_require__(23);
	var syncpromise_1 = __webpack_require__(38);
	/** A simple queue that holds promises. */
	var PromiseBuffer = /** @class */ (function () {
	    function PromiseBuffer(_limit) {
	        this._limit = _limit;
	        /** Internal set of queued Promises */
	        this._buffer = [];
	    }
	    /**
	     * Says if the buffer is ready to take more requests
	     */
	    PromiseBuffer.prototype.isReady = function () {
	        return this._limit === undefined || this.length() < this._limit;
	    };
	    /**
	     * Add a promise to the queue.
	     *
	     * @param task Can be any PromiseLike<T>
	     * @returns The original promise.
	     */
	    PromiseBuffer.prototype.add = function (task) {
	        var _this = this;
	        if (!this.isReady()) {
	            return syncpromise_1.SyncPromise.reject(new error_1.SentryError('Not adding Promise due to buffer limit reached.'));
	        }
	        if (this._buffer.indexOf(task) === -1) {
	            this._buffer.push(task);
	        }
	        task
	            .then(function () { return _this.remove(task); })
	            .then(null, function () {
	            return _this.remove(task).then(null, function () {
	                // We have to add this catch here otherwise we have an unhandledPromiseRejection
	                // because it's a new Promise chain.
	            });
	        });
	        return task;
	    };
	    /**
	     * Remove a promise to the queue.
	     *
	     * @param task Can be any PromiseLike<T>
	     * @returns Removed promise.
	     */
	    PromiseBuffer.prototype.remove = function (task) {
	        var removedTask = this._buffer.splice(this._buffer.indexOf(task), 1)[0];
	        return removedTask;
	    };
	    /**
	     * This function returns the number of unresolved promises in the queue.
	     */
	    PromiseBuffer.prototype.length = function () {
	        return this._buffer.length;
	    };
	    /**
	     * This will drain the whole queue, returns true if queue is empty or drained.
	     * If timeout is provided and the queue takes longer to drain, the promise still resolves but with false.
	     *
	     * @param timeout Number in ms to wait until it resolves with false.
	     */
	    PromiseBuffer.prototype.drain = function (timeout) {
	        var _this = this;
	        return new syncpromise_1.SyncPromise(function (resolve) {
	            var capturedSetTimeout = setTimeout(function () {
	                if (timeout && timeout > 0) {
	                    resolve(false);
	                }
	            }, timeout);
	            syncpromise_1.SyncPromise.all(_this._buffer)
	                .then(function () {
	                clearTimeout(capturedSetTimeout);
	                resolve(true);
	            })
	                .then(null, function () {
	                resolve(true);
	            });
	        });
	    };
	    return PromiseBuffer;
	}());
	exports.PromiseBuffer = PromiseBuffer;
	//# sourceMappingURL=promisebuffer.js.map

/***/ }),
/* 38 */
/***/ (function(module, exports, __webpack_require__) {

	Object.defineProperty(exports, "__esModule", { value: true });
	/* eslint-disable @typescript-eslint/explicit-function-return-type */
	/* eslint-disable @typescript-eslint/typedef */
	/* eslint-disable @typescript-eslint/explicit-module-boundary-types */
	/* eslint-disable @typescript-eslint/no-explicit-any */
	var is_1 = __webpack_require__(21);
	/** SyncPromise internal states */
	var States;
	(function (States) {
	    /** Pending */
	    States["PENDING"] = "PENDING";
	    /** Resolved / OK */
	    States["RESOLVED"] = "RESOLVED";
	    /** Rejected / Error */
	    States["REJECTED"] = "REJECTED";
	})(States || (States = {}));
	/**
	 * Thenable class that behaves like a Promise and follows it's interface
	 * but is not async internally
	 */
	var SyncPromise = /** @class */ (function () {
	    function SyncPromise(executor) {
	        var _this = this;
	        this._state = States.PENDING;
	        this._handlers = [];
	        /** JSDoc */
	        this._resolve = function (value) {
	            _this._setResult(States.RESOLVED, value);
	        };
	        /** JSDoc */
	        this._reject = function (reason) {
	            _this._setResult(States.REJECTED, reason);
	        };
	        /** JSDoc */
	        this._setResult = function (state, value) {
	            if (_this._state !== States.PENDING) {
	                return;
	            }
	            if (is_1.isThenable(value)) {
	                value.then(_this._resolve, _this._reject);
	                return;
	            }
	            _this._state = state;
	            _this._value = value;
	            _this._executeHandlers();
	        };
	        // TODO: FIXME
	        /** JSDoc */
	        this._attachHandler = function (handler) {
	            _this._handlers = _this._handlers.concat(handler);
	            _this._executeHandlers();
	        };
	        /** JSDoc */
	        this._executeHandlers = function () {
	            if (_this._state === States.PENDING) {
	                return;
	            }
	            var cachedHandlers = _this._handlers.slice();
	            _this._handlers = [];
	            cachedHandlers.forEach(function (handler) {
	                if (handler.done) {
	                    return;
	                }
	                if (_this._state === States.RESOLVED) {
	                    if (handler.onfulfilled) {
	                        // eslint-disable-next-line @typescript-eslint/no-floating-promises
	                        handler.onfulfilled(_this._value);
	                    }
	                }
	                if (_this._state === States.REJECTED) {
	                    if (handler.onrejected) {
	                        handler.onrejected(_this._value);
	                    }
	                }
	                handler.done = true;
	            });
	        };
	        try {
	            executor(this._resolve, this._reject);
	        }
	        catch (e) {
	            this._reject(e);
	        }
	    }
	    /** JSDoc */
	    SyncPromise.resolve = function (value) {
	        return new SyncPromise(function (resolve) {
	            resolve(value);
	        });
	    };
	    /** JSDoc */
	    SyncPromise.reject = function (reason) {
	        return new SyncPromise(function (_, reject) {
	            reject(reason);
	        });
	    };
	    /** JSDoc */
	    SyncPromise.all = function (collection) {
	        return new SyncPromise(function (resolve, reject) {
	            if (!Array.isArray(collection)) {
	                reject(new TypeError("Promise.all requires an array as input."));
	                return;
	            }
	            if (collection.length === 0) {
	                resolve([]);
	                return;
	            }
	            var counter = collection.length;
	            var resolvedCollection = [];
	            collection.forEach(function (item, index) {
	                SyncPromise.resolve(item)
	                    .then(function (value) {
	                    resolvedCollection[index] = value;
	                    counter -= 1;
	                    if (counter !== 0) {
	                        return;
	                    }
	                    resolve(resolvedCollection);
	                })
	                    .then(null, reject);
	            });
	        });
	    };
	    /** JSDoc */
	    SyncPromise.prototype.then = function (onfulfilled, onrejected) {
	        var _this = this;
	        return new SyncPromise(function (resolve, reject) {
	            _this._attachHandler({
	                done: false,
	                onfulfilled: function (result) {
	                    if (!onfulfilled) {
	                        // TODO: ¯\_(ツ)_/¯
	                        // TODO: FIXME
	                        resolve(result);
	                        return;
	                    }
	                    try {
	                        resolve(onfulfilled(result));
	                        return;
	                    }
	                    catch (e) {
	                        reject(e);
	                        return;
	                    }
	                },
	                onrejected: function (reason) {
	                    if (!onrejected) {
	                        reject(reason);
	                        return;
	                    }
	                    try {
	                        resolve(onrejected(reason));
	                        return;
	                    }
	                    catch (e) {
	                        reject(e);
	                        return;
	                    }
	                },
	            });
	        });
	    };
	    /** JSDoc */
	    SyncPromise.prototype.catch = function (onrejected) {
	        return this.then(function (val) { return val; }, onrejected);
	    };
	    /** JSDoc */
	    SyncPromise.prototype.finally = function (onfinally) {
	        var _this = this;
	        return new SyncPromise(function (resolve, reject) {
	            var val;
	            var isRejected;
	            return _this.then(function (value) {
	                isRejected = false;
	                val = value;
	                if (onfinally) {
	                    onfinally();
	                }
	            }, function (reason) {
	                isRejected = true;
	                val = reason;
	                if (onfinally) {
	                    onfinally();
	                }
	            }).then(function () {
	                if (isRejected) {
	                    reject(val);
	                    return;
	                }
	                resolve(val);
	            });
	        });
	    };
	    /** JSDoc */
	    SyncPromise.prototype.toString = function () {
	        return '[object SyncPromise]';
	    };
	    return SyncPromise;
	}());
	exports.SyncPromise = SyncPromise;
	//# sourceMappingURL=syncpromise.js.map

/***/ }),
/* 39 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {Object.defineProperty(exports, "__esModule", { value: true });
	var misc_1 = __webpack_require__(27);
	var node_1 = __webpack_require__(28);
	/**
	 * A TimestampSource implementation for environments that do not support the Performance Web API natively.
	 *
	 * Note that this TimestampSource does not use a monotonic clock. A call to `nowSeconds` may return a timestamp earlier
	 * than a previously returned value. We do not try to emulate a monotonic behavior in order to facilitate debugging. It
	 * is more obvious to explain "why does my span have negative duration" than "why my spans have zero duration".
	 */
	var dateTimestampSource = {
	    nowSeconds: function () { return Date.now() / 1000; },
	};
	/**
	 * Returns a wrapper around the native Performance API browser implementation, or undefined for browsers that do not
	 * support the API.
	 *
	 * Wrapping the native API works around differences in behavior from different browsers.
	 */
	function getBrowserPerformance() {
	    var performance = misc_1.getGlobalObject().performance;
	    if (!performance || !performance.now) {
	        return undefined;
	    }
	    // Replace performance.timeOrigin with our own timeOrigin based on Date.now().
	    //
	    // This is a partial workaround for browsers reporting performance.timeOrigin such that performance.timeOrigin +
	    // performance.now() gives a date arbitrarily in the past.
	    //
	    // Additionally, computing timeOrigin in this way fills the gap for browsers where performance.timeOrigin is
	    // undefined.
	    //
	    // The assumption that performance.timeOrigin + performance.now() ~= Date.now() is flawed, but we depend on it to
	    // interact with data coming out of performance entries.
	    //
	    // Note that despite recommendations against it in the spec, browsers implement the Performance API with a clock that
	    // might stop when the computer is asleep (and perhaps under other circumstances). Such behavior causes
	    // performance.timeOrigin + performance.now() to have an arbitrary skew over Date.now(). In laptop computers, we have
	    // observed skews that can be as long as days, weeks or months.
	    //
	    // See https://github.com/getsentry/sentry-javascript/issues/2590.
	    //
	    // BUG: despite our best intentions, this workaround has its limitations. It mostly addresses timings of pageload
	    // transactions, but ignores the skew built up over time that can aversely affect timestamps of navigation
	    // transactions of long-lived web pages.
	    var timeOrigin = Date.now() - performance.now();
	    return {
	        now: function () { return performance.now(); },
	        timeOrigin: timeOrigin,
	    };
	}
	/**
	 * Returns the native Performance API implementation from Node.js. Returns undefined in old Node.js versions that don't
	 * implement the API.
	 */
	function getNodePerformance() {
	    try {
	        var perfHooks = node_1.dynamicRequire(module, 'perf_hooks');
	        return perfHooks.performance;
	    }
	    catch (_) {
	        return undefined;
	    }
	}
	/**
	 * The Performance API implementation for the current platform, if available.
	 */
	var platformPerformance = node_1.isNodeEnv() ? getNodePerformance() : getBrowserPerformance();
	var timestampSource = platformPerformance === undefined
	    ? dateTimestampSource
	    : {
	        nowSeconds: function () { return (platformPerformance.timeOrigin + platformPerformance.now()) / 1000; },
	    };
	/**
	 * Returns a timestamp in seconds since the UNIX epoch using the Date API.
	 */
	exports.dateTimestampInSeconds = dateTimestampSource.nowSeconds.bind(dateTimestampSource);
	/**
	 * Returns a timestamp in seconds since the UNIX epoch using either the Performance or Date APIs, depending on the
	 * availability of the Performance API.
	 *
	 * See `usingPerformanceAPI` to test whether the Performance API is used.
	 *
	 * BUG: Note that because of how browsers implement the Performance API, the clock might stop when the computer is
	 * asleep. This creates a skew between `dateTimestampInSeconds` and `timestampInSeconds`. The
	 * skew can grow to arbitrary amounts like days, weeks or months.
	 * See https://github.com/getsentry/sentry-javascript/issues/2590.
	 */
	exports.timestampInSeconds = timestampSource.nowSeconds.bind(timestampSource);
	// Re-exported with an old name for backwards-compatibility.
	exports.timestampWithMs = exports.timestampInSeconds;
	/**
	 * A boolean that is true when timestampInSeconds uses the Performance API to produce monotonic timestamps.
	 */
	exports.usingPerformanceAPI = platformPerformance !== undefined;
	/**
	 * The number of milliseconds since the UNIX epoch. This value is only usable in a browser, and only when the
	 * performance API is available.
	 */
	exports.browserPerformanceTimeOrigin = (function () {
	    var performance = misc_1.getGlobalObject().performance;
	    if (!performance) {
	        return undefined;
	    }
	    if (performance.timeOrigin) {
	        return performance.timeOrigin;
	    }
	    // While performance.timing.navigationStart is deprecated in favor of performance.timeOrigin, performance.timeOrigin
	    // is not as widely supported. Namely, performance.timeOrigin is undefined in Safari as of writing.
	    // Also as of writing, performance.timing is not available in Web Workers in mainstream browsers, so it is not always
	    // a valid fallback. In the absence of an initial time provided by the browser, fallback to the current time from the
	    // Date API.
	    // eslint-disable-next-line deprecation/deprecation
	    return (performance.timing && performance.timing.navigationStart) || Date.now();
	})();
	//# sourceMappingURL=time.js.map
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(30)(module)))

/***/ }),
/* 40 */
/***/ (function(module, exports, __webpack_require__) {

	Object.defineProperty(exports, "__esModule", { value: true });
	var types_1 = __webpack_require__(8);
	var utils_1 = __webpack_require__(18);
	/**
	 * @inheritdoc
	 */
	var Session = /** @class */ (function () {
	    function Session(context) {
	        this.errors = 0;
	        this.sid = utils_1.uuid4();
	        this.timestamp = Date.now();
	        this.started = Date.now();
	        this.duration = 0;
	        this.status = types_1.SessionStatus.Ok;
	        if (context) {
	            this.update(context);
	        }
	    }
	    /** JSDoc */
	    // eslint-disable-next-line complexity
	    Session.prototype.update = function (context) {
	        if (context === void 0) { context = {}; }
	        if (context.user) {
	            if (context.user.ip_address) {
	                this.ipAddress = context.user.ip_address;
	            }
	            if (!context.did) {
	                this.did = context.user.id || context.user.email || context.user.username;
	            }
	        }
	        this.timestamp = context.timestamp || Date.now();
	        if (context.sid) {
	            // Good enough uuid validation. — Kamil
	            this.sid = context.sid.length === 32 ? context.sid : utils_1.uuid4();
	        }
	        if (context.did) {
	            this.did = "" + context.did;
	        }
	        if (typeof context.started === 'number') {
	            this.started = context.started;
	        }
	        if (typeof context.duration === 'number') {
	            this.duration = context.duration;
	        }
	        else {
	            this.duration = this.timestamp - this.started;
	        }
	        if (context.release) {
	            this.release = context.release;
	        }
	        if (context.environment) {
	            this.environment = context.environment;
	        }
	        if (context.ipAddress) {
	            this.ipAddress = context.ipAddress;
	        }
	        if (context.userAgent) {
	            this.userAgent = context.userAgent;
	        }
	        if (typeof context.errors === 'number') {
	            this.errors = context.errors;
	        }
	        if (context.status) {
	            this.status = context.status;
	        }
	    };
	    /** JSDoc */
	    Session.prototype.close = function (status) {
	        if (status) {
	            this.update({ status: status });
	        }
	        else if (this.status === types_1.SessionStatus.Ok) {
	            this.update({ status: types_1.SessionStatus.Exited });
	        }
	        else {
	            this.update();
	        }
	    };
	    /** JSDoc */
	    Session.prototype.toJSON = function () {
	        return utils_1.dropUndefinedKeys({
	            sid: "" + this.sid,
	            init: true,
	            started: new Date(this.started).toISOString(),
	            timestamp: new Date(this.timestamp).toISOString(),
	            status: this.status,
	            errors: this.errors,
	            did: typeof this.did === 'number' || typeof this.did === 'string' ? "" + this.did : undefined,
	            duration: this.duration,
	            attrs: utils_1.dropUndefinedKeys({
	                release: this.release,
	                environment: this.environment,
	                ip_address: this.ipAddress,
	                user_agent: this.userAgent,
	            }),
	        });
	    };
	    return Session;
	}());
	exports.Session = Session;
	//# sourceMappingURL=session.js.map

/***/ }),
/* 41 */
/***/ (function(module, exports, __webpack_require__) {

	Object.defineProperty(exports, "__esModule", { value: true });
	var tslib_1 = __webpack_require__(6);
	var utils_1 = __webpack_require__(18);
	var scope_1 = __webpack_require__(17);
	var session_1 = __webpack_require__(40);
	/**
	 * API compatibility version of this hub.
	 *
	 * WARNING: This number should only be increased when the global interface
	 * changes and new methods are introduced.
	 *
	 * @hidden
	 */
	exports.API_VERSION = 3;
	/**
	 * Default maximum number of breadcrumbs added to an event. Can be overwritten
	 * with {@link Options.maxBreadcrumbs}.
	 */
	var DEFAULT_BREADCRUMBS = 100;
	/**
	 * Absolute maximum number of breadcrumbs added to an event. The
	 * `maxBreadcrumbs` option cannot be higher than this value.
	 */
	var MAX_BREADCRUMBS = 100;
	/**
	 * @inheritDoc
	 */
	var Hub = /** @class */ (function () {
	    /**
	     * Creates a new instance of the hub, will push one {@link Layer} into the
	     * internal stack on creation.
	     *
	     * @param client bound to the hub.
	     * @param scope bound to the hub.
	     * @param version number, higher number means higher priority.
	     */
	    function Hub(client, scope, _version) {
	        if (scope === void 0) { scope = new scope_1.Scope(); }
	        if (_version === void 0) { _version = exports.API_VERSION; }
	        this._version = _version;
	        /** Is a {@link Layer}[] containing the client and scope */
	        this._stack = [{}];
	        this.getStackTop().scope = scope;
	        this.bindClient(client);
	    }
	    /**
	     * @inheritDoc
	     */
	    Hub.prototype.isOlderThan = function (version) {
	        return this._version < version;
	    };
	    /**
	     * @inheritDoc
	     */
	    Hub.prototype.bindClient = function (client) {
	        var top = this.getStackTop();
	        top.client = client;
	        if (client && client.setupIntegrations) {
	            client.setupIntegrations();
	        }
	    };
	    /**
	     * @inheritDoc
	     */
	    Hub.prototype.pushScope = function () {
	        // We want to clone the content of prev scope
	        var scope = scope_1.Scope.clone(this.getScope());
	        this.getStack().push({
	            client: this.getClient(),
	            scope: scope,
	        });
	        return scope;
	    };
	    /**
	     * @inheritDoc
	     */
	    Hub.prototype.popScope = function () {
	        if (this.getStack().length <= 1)
	            return false;
	        return !!this.getStack().pop();
	    };
	    /**
	     * @inheritDoc
	     */
	    Hub.prototype.withScope = function (callback) {
	        var scope = this.pushScope();
	        try {
	            callback(scope);
	        }
	        finally {
	            this.popScope();
	        }
	    };
	    /**
	     * @inheritDoc
	     */
	    Hub.prototype.getClient = function () {
	        return this.getStackTop().client;
	    };
	    /** Returns the scope of the top stack. */
	    Hub.prototype.getScope = function () {
	        return this.getStackTop().scope;
	    };
	    /** Returns the scope stack for domains or the process. */
	    Hub.prototype.getStack = function () {
	        return this._stack;
	    };
	    /** Returns the topmost scope layer in the order domain > local > process. */
	    Hub.prototype.getStackTop = function () {
	        return this._stack[this._stack.length - 1];
	    };
	    /**
	     * @inheritDoc
	     */
	    // eslint-disable-next-line @typescript-eslint/no-explicit-any, @typescript-eslint/explicit-module-boundary-types
	    Hub.prototype.captureException = function (exception, hint) {
	        var eventId = (this._lastEventId = utils_1.uuid4());
	        var finalHint = hint;
	        // If there's no explicit hint provided, mimick the same thing that would happen
	        // in the minimal itself to create a consistent behavior.
	        // We don't do this in the client, as it's the lowest level API, and doing this,
	        // would prevent user from having full control over direct calls.
	        if (!hint) {
	            var syntheticException = void 0;
	            try {
	                throw new Error('Sentry syntheticException');
	            }
	            catch (exception) {
	                syntheticException = exception;
	            }
	            finalHint = {
	                originalException: exception,
	                syntheticException: syntheticException,
	            };
	        }
	        this._invokeClient('captureException', exception, tslib_1.__assign(tslib_1.__assign({}, finalHint), { event_id: eventId }));
	        return eventId;
	    };
	    /**
	     * @inheritDoc
	     */
	    Hub.prototype.captureMessage = function (message, level, hint) {
	        var eventId = (this._lastEventId = utils_1.uuid4());
	        var finalHint = hint;
	        // If there's no explicit hint provided, mimick the same thing that would happen
	        // in the minimal itself to create a consistent behavior.
	        // We don't do this in the client, as it's the lowest level API, and doing this,
	        // would prevent user from having full control over direct calls.
	        if (!hint) {
	            var syntheticException = void 0;
	            try {
	                throw new Error(message);
	            }
	            catch (exception) {
	                syntheticException = exception;
	            }
	            finalHint = {
	                originalException: message,
	                syntheticException: syntheticException,
	            };
	        }
	        this._invokeClient('captureMessage', message, level, tslib_1.__assign(tslib_1.__assign({}, finalHint), { event_id: eventId }));
	        return eventId;
	    };
	    /**
	     * @inheritDoc
	     */
	    Hub.prototype.captureEvent = function (event, hint) {
	        var eventId = (this._lastEventId = utils_1.uuid4());
	        this._invokeClient('captureEvent', event, tslib_1.__assign(tslib_1.__assign({}, hint), { event_id: eventId }));
	        return eventId;
	    };
	    /**
	     * @inheritDoc
	     */
	    Hub.prototype.lastEventId = function () {
	        return this._lastEventId;
	    };
	    /**
	     * @inheritDoc
	     */
	    Hub.prototype.addBreadcrumb = function (breadcrumb, hint) {
	        var _a = this.getStackTop(), scope = _a.scope, client = _a.client;
	        if (!scope || !client)
	            return;
	        // eslint-disable-next-line @typescript-eslint/unbound-method
	        var _b = (client.getOptions && client.getOptions()) || {}, _c = _b.beforeBreadcrumb, beforeBreadcrumb = _c === void 0 ? null : _c, _d = _b.maxBreadcrumbs, maxBreadcrumbs = _d === void 0 ? DEFAULT_BREADCRUMBS : _d;
	        if (maxBreadcrumbs <= 0)
	            return;
	        var timestamp = utils_1.dateTimestampInSeconds();
	        var mergedBreadcrumb = tslib_1.__assign({ timestamp: timestamp }, breadcrumb);
	        var finalBreadcrumb = beforeBreadcrumb
	            ? utils_1.consoleSandbox(function () { return beforeBreadcrumb(mergedBreadcrumb, hint); })
	            : mergedBreadcrumb;
	        if (finalBreadcrumb === null)
	            return;
	        scope.addBreadcrumb(finalBreadcrumb, Math.min(maxBreadcrumbs, MAX_BREADCRUMBS));
	    };
	    /**
	     * @inheritDoc
	     */
	    Hub.prototype.setUser = function (user) {
	        var scope = this.getScope();
	        if (scope)
	            scope.setUser(user);
	    };
	    /**
	     * @inheritDoc
	     */
	    Hub.prototype.setTags = function (tags) {
	        var scope = this.getScope();
	        if (scope)
	            scope.setTags(tags);
	    };
	    /**
	     * @inheritDoc
	     */
	    Hub.prototype.setExtras = function (extras) {
	        var scope = this.getScope();
	        if (scope)
	            scope.setExtras(extras);
	    };
	    /**
	     * @inheritDoc
	     */
	    Hub.prototype.setTag = function (key, value) {
	        var scope = this.getScope();
	        if (scope)
	            scope.setTag(key, value);
	    };
	    /**
	     * @inheritDoc
	     */
	    Hub.prototype.setExtra = function (key, extra) {
	        var scope = this.getScope();
	        if (scope)
	            scope.setExtra(key, extra);
	    };
	    /**
	     * @inheritDoc
	     */
	    // eslint-disable-next-line @typescript-eslint/no-explicit-any
	    Hub.prototype.setContext = function (name, context) {
	        var scope = this.getScope();
	        if (scope)
	            scope.setContext(name, context);
	    };
	    /**
	     * @inheritDoc
	     */
	    Hub.prototype.configureScope = function (callback) {
	        var _a = this.getStackTop(), scope = _a.scope, client = _a.client;
	        if (scope && client) {
	            callback(scope);
	        }
	    };
	    /**
	     * @inheritDoc
	     */
	    Hub.prototype.run = function (callback) {
	        var oldHub = makeMain(this);
	        try {
	            callback(this);
	        }
	        finally {
	            makeMain(oldHub);
	        }
	    };
	    /**
	     * @inheritDoc
	     */
	    Hub.prototype.getIntegration = function (integration) {
	        var client = this.getClient();
	        if (!client)
	            return null;
	        try {
	            return client.getIntegration(integration);
	        }
	        catch (_oO) {
	            utils_1.logger.warn("Cannot retrieve integration " + integration.id + " from the current Hub");
	            return null;
	        }
	    };
	    /**
	     * @inheritDoc
	     */
	    Hub.prototype.startSpan = function (context) {
	        return this._callExtensionMethod('startSpan', context);
	    };
	    /**
	     * @inheritDoc
	     */
	    Hub.prototype.startTransaction = function (context, customSamplingContext) {
	        return this._callExtensionMethod('startTransaction', context, customSamplingContext);
	    };
	    /**
	     * @inheritDoc
	     */
	    Hub.prototype.traceHeaders = function () {
	        return this._callExtensionMethod('traceHeaders');
	    };
	    /**
	     * @inheritDoc
	     */
	    Hub.prototype.startSession = function (context) {
	        // End existing session if there's one
	        this.endSession();
	        var _a = this.getStackTop(), scope = _a.scope, client = _a.client;
	        var _b = (client && client.getOptions()) || {}, release = _b.release, environment = _b.environment;
	        var session = new session_1.Session(tslib_1.__assign(tslib_1.__assign({ release: release,
	            environment: environment }, (scope && { user: scope.getUser() })), context));
	        if (scope) {
	            scope.setSession(session);
	        }
	        return session;
	    };
	    /**
	     * @inheritDoc
	     */
	    Hub.prototype.endSession = function () {
	        var _a = this.getStackTop(), scope = _a.scope, client = _a.client;
	        if (!scope)
	            return;
	        var session = scope.getSession && scope.getSession();
	        if (session) {
	            session.close();
	            if (client && client.captureSession) {
	                client.captureSession(session);
	            }
	            scope.setSession();
	        }
	    };
	    /**
	     * Internal helper function to call a method on the top client if it exists.
	     *
	     * @param method The method to call on the client.
	     * @param args Arguments to pass to the client function.
	     */
	    // eslint-disable-next-line @typescript-eslint/no-explicit-any
	    Hub.prototype._invokeClient = function (method) {
	        var _a;
	        var args = [];
	        for (var _i = 1; _i < arguments.length; _i++) {
	            args[_i - 1] = arguments[_i];
	        }
	        var _b = this.getStackTop(), scope = _b.scope, client = _b.client;
	        if (client && client[method]) {
	            // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access, @typescript-eslint/no-explicit-any
	            (_a = client)[method].apply(_a, tslib_1.__spread(args, [scope]));
	        }
	    };
	    /**
	     * Calls global extension method and binding current instance to the function call
	     */
	    // @ts-ignore Function lacks ending return statement and return type does not include 'undefined'. ts(2366)
	    // eslint-disable-next-line @typescript-eslint/no-explicit-any
	    Hub.prototype._callExtensionMethod = function (method) {
	        var args = [];
	        for (var _i = 1; _i < arguments.length; _i++) {
	            args[_i - 1] = arguments[_i];
	        }
	        var carrier = getMainCarrier();
	        var sentry = carrier.__SENTRY__;
	        if (sentry && sentry.extensions && typeof sentry.extensions[method] === 'function') {
	            return sentry.extensions[method].apply(this, args);
	        }
	        utils_1.logger.warn("Extension method " + method + " couldn't be found, doing nothing.");
	    };
	    return Hub;
	}());
	exports.Hub = Hub;
	/** Returns the global shim registry. */
	function getMainCarrier() {
	    var carrier = utils_1.getGlobalObject();
	    carrier.__SENTRY__ = carrier.__SENTRY__ || {
	        extensions: {},
	        hub: undefined,
	    };
	    return carrier;
	}
	exports.getMainCarrier = getMainCarrier;
	/**
	 * Replaces the current main hub with the passed one on the global object
	 *
	 * @returns The old replaced hub
	 */
	function makeMain(hub) {
	    var registry = getMainCarrier();
	    var oldHub = getHubFromCarrier(registry);
	    setHubOnCarrier(registry, hub);
	    return oldHub;
	}
	exports.makeMain = makeMain;
	/**
	 * Returns the default hub instance.
	 *
	 * If a hub is already registered in the global carrier but this module
	 * contains a more recent version, it replaces the registered version.
	 * Otherwise, the currently registered hub will be returned.
	 */
	function getCurrentHub() {
	    // Get main carrier (global for every environment)
	    var registry = getMainCarrier();
	    // If there's no hub, or its an old API, assign a new one
	    if (!hasHubOnCarrier(registry) || getHubFromCarrier(registry).isOlderThan(exports.API_VERSION)) {
	        setHubOnCarrier(registry, new Hub());
	    }
	    // Prefer domains over global if they are there (applicable only to Node environment)
	    if (utils_1.isNodeEnv()) {
	        return getHubFromActiveDomain(registry);
	    }
	    // Return hub that lives on a global object
	    return getHubFromCarrier(registry);
	}
	exports.getCurrentHub = getCurrentHub;
	/**
	 * Returns the active domain, if one exists
	 *
	 * @returns The domain, or undefined if there is no active domain
	 */
	function getActiveDomain() {
	    var sentry = getMainCarrier().__SENTRY__;
	    return sentry && sentry.extensions && sentry.extensions.domain && sentry.extensions.domain.active;
	}
	exports.getActiveDomain = getActiveDomain;
	/**
	 * Try to read the hub from an active domain, and fallback to the registry if one doesn't exist
	 * @returns discovered hub
	 */
	function getHubFromActiveDomain(registry) {
	    try {
	        var activeDomain = getActiveDomain();
	        // If there's no active domain, just return global hub
	        if (!activeDomain) {
	            return getHubFromCarrier(registry);
	        }
	        // If there's no hub on current domain, or it's an old API, assign a new one
	        if (!hasHubOnCarrier(activeDomain) || getHubFromCarrier(activeDomain).isOlderThan(exports.API_VERSION)) {
	            var registryHubTopStack = getHubFromCarrier(registry).getStackTop();
	            setHubOnCarrier(activeDomain, new Hub(registryHubTopStack.client, scope_1.Scope.clone(registryHubTopStack.scope)));
	        }
	        // Return hub that lives on a domain
	        return getHubFromCarrier(activeDomain);
	    }
	    catch (_Oo) {
	        // Return hub that lives on a global object
	        return getHubFromCarrier(registry);
	    }
	}
	/**
	 * This will tell whether a carrier has a hub on it or not
	 * @param carrier object
	 */
	function hasHubOnCarrier(carrier) {
	    return !!(carrier && carrier.__SENTRY__ && carrier.__SENTRY__.hub);
	}
	/**
	 * This will create a new {@link Hub} and add to the passed object on
	 * __SENTRY__.hub.
	 * @param carrier object
	 * @hidden
	 */
	function getHubFromCarrier(carrier) {
	    if (carrier && carrier.__SENTRY__ && carrier.__SENTRY__.hub)
	        return carrier.__SENTRY__.hub;
	    carrier.__SENTRY__ = carrier.__SENTRY__ || {};
	    carrier.__SENTRY__.hub = new Hub();
	    return carrier.__SENTRY__.hub;
	}
	exports.getHubFromCarrier = getHubFromCarrier;
	/**
	 * This will set passed {@link Hub} on the passed object's __SENTRY__.hub attribute
	 * @param carrier object
	 * @param hub Hub
	 */
	function setHubOnCarrier(carrier, hub) {
	    if (!carrier)
	        return false;
	    carrier.__SENTRY__ = carrier.__SENTRY__ || {};
	    carrier.__SENTRY__.hub = hub;
	    return true;
	}
	exports.setHubOnCarrier = setHubOnCarrier;
	//# sourceMappingURL=hub.js.map

/***/ }),
/* 42 */
/***/ (function(module, exports, __webpack_require__) {

	Object.defineProperty(exports, "__esModule", { value: true });
	var utils_1 = __webpack_require__(18);
	var SENTRY_API_VERSION = '7';
	/** Helper class to provide urls to different Sentry endpoints. */
	var API = /** @class */ (function () {
	    /** Create a new instance of API */
	    function API(dsn) {
	        this.dsn = dsn;
	        this._dsnObject = new utils_1.Dsn(dsn);
	    }
	    /** Returns the Dsn object. */
	    API.prototype.getDsn = function () {
	        return this._dsnObject;
	    };
	    /** Returns the prefix to construct Sentry ingestion API endpoints. */
	    API.prototype.getBaseApiEndpoint = function () {
	        var dsn = this._dsnObject;
	        var protocol = dsn.protocol ? dsn.protocol + ":" : '';
	        var port = dsn.port ? ":" + dsn.port : '';
	        return protocol + "//" + dsn.host + port + (dsn.path ? "/" + dsn.path : '') + "/api/";
	    };
	    /** Returns the store endpoint URL. */
	    API.prototype.getStoreEndpoint = function () {
	        return this._getIngestEndpoint('store');
	    };
	    /**
	     * Returns the store endpoint URL with auth in the query string.
	     *
	     * Sending auth as part of the query string and not as custom HTTP headers avoids CORS preflight requests.
	     */
	    API.prototype.getStoreEndpointWithUrlEncodedAuth = function () {
	        return this.getStoreEndpoint() + "?" + this._encodedAuth();
	    };
	    /**
	     * Returns the envelope endpoint URL with auth in the query string.
	     *
	     * Sending auth as part of the query string and not as custom HTTP headers avoids CORS preflight requests.
	     */
	    API.prototype.getEnvelopeEndpointWithUrlEncodedAuth = function () {
	        return this._getEnvelopeEndpoint() + "?" + this._encodedAuth();
	    };
	    /** Returns only the path component for the store endpoint. */
	    API.prototype.getStoreEndpointPath = function () {
	        var dsn = this._dsnObject;
	        return (dsn.path ? "/" + dsn.path : '') + "/api/" + dsn.projectId + "/store/";
	    };
	    /**
	     * Returns an object that can be used in request headers.
	     * This is needed for node and the old /store endpoint in sentry
	     */
	    API.prototype.getRequestHeaders = function (clientName, clientVersion) {
	        var dsn = this._dsnObject;
	        var header = ["Sentry sentry_version=" + SENTRY_API_VERSION];
	        header.push("sentry_client=" + clientName + "/" + clientVersion);
	        header.push("sentry_key=" + dsn.user);
	        if (dsn.pass) {
	            header.push("sentry_secret=" + dsn.pass);
	        }
	        return {
	            'Content-Type': 'application/json',
	            'X-Sentry-Auth': header.join(', '),
	        };
	    };
	    /** Returns the url to the report dialog endpoint. */
	    API.prototype.getReportDialogEndpoint = function (dialogOptions) {
	        if (dialogOptions === void 0) { dialogOptions = {}; }
	        var dsn = this._dsnObject;
	        var endpoint = this.getBaseApiEndpoint() + "embed/error-page/";
	        var encodedOptions = [];
	        encodedOptions.push("dsn=" + dsn.toString());
	        for (var key in dialogOptions) {
	            if (key === 'dsn') {
	                continue;
	            }
	            if (key === 'user') {
	                if (!dialogOptions.user) {
	                    continue;
	                }
	                if (dialogOptions.user.name) {
	                    encodedOptions.push("name=" + encodeURIComponent(dialogOptions.user.name));
	                }
	                if (dialogOptions.user.email) {
	                    encodedOptions.push("email=" + encodeURIComponent(dialogOptions.user.email));
	                }
	            }
	            else {
	                encodedOptions.push(encodeURIComponent(key) + "=" + encodeURIComponent(dialogOptions[key]));
	            }
	        }
	        if (encodedOptions.length) {
	            return endpoint + "?" + encodedOptions.join('&');
	        }
	        return endpoint;
	    };
	    /** Returns the envelope endpoint URL. */
	    API.prototype._getEnvelopeEndpoint = function () {
	        return this._getIngestEndpoint('envelope');
	    };
	    /** Returns the ingest API endpoint for target. */
	    API.prototype._getIngestEndpoint = function (target) {
	        var base = this.getBaseApiEndpoint();
	        var dsn = this._dsnObject;
	        return "" + base + dsn.projectId + "/" + target + "/";
	    };
	    /** Returns a URL-encoded string with auth config suitable for a query string. */
	    API.prototype._encodedAuth = function () {
	        var dsn = this._dsnObject;
	        var auth = {
	            // We send only the minimum set of required information. See
	            // https://github.com/getsentry/sentry-javascript/issues/2572.
	            sentry_key: dsn.user,
	            sentry_version: SENTRY_API_VERSION,
	        };
	        return utils_1.urlEncode(auth);
	    };
	    return API;
	}());
	exports.API = API;
	//# sourceMappingURL=api.js.map

/***/ }),
/* 43 */
/***/ (function(module, exports, __webpack_require__) {

	Object.defineProperty(exports, "__esModule", { value: true });
	var tslib_1 = __webpack_require__(6);
	/* eslint-disable max-lines */
	var hub_1 = __webpack_require__(16);
	var types_1 = __webpack_require__(8);
	var utils_1 = __webpack_require__(18);
	var integration_1 = __webpack_require__(44);
	/**
	 * Base implementation for all JavaScript SDK clients.
	 *
	 * Call the constructor with the corresponding backend constructor and options
	 * specific to the client subclass. To access these options later, use
	 * {@link Client.getOptions}. Also, the Backend instance is available via
	 * {@link Client.getBackend}.
	 *
	 * If a Dsn is specified in the options, it will be parsed and stored. Use
	 * {@link Client.getDsn} to retrieve the Dsn at any moment. In case the Dsn is
	 * invalid, the constructor will throw a {@link SentryException}. Note that
	 * without a valid Dsn, the SDK will not send any events to Sentry.
	 *
	 * Before sending an event via the backend, it is passed through
	 * {@link BaseClient.prepareEvent} to add SDK information and scope data
	 * (breadcrumbs and context). To add more custom information, override this
	 * method and extend the resulting prepared event.
	 *
	 * To issue automatically created events (e.g. via instrumentation), use
	 * {@link Client.captureEvent}. It will prepare the event and pass it through
	 * the callback lifecycle. To issue auto-breadcrumbs, use
	 * {@link Client.addBreadcrumb}.
	 *
	 * @example
	 * class NodeClient extends BaseClient<NodeBackend, NodeOptions> {
	 *   public constructor(options: NodeOptions) {
	 *     super(NodeBackend, options);
	 *   }
	 *
	 *   // ...
	 * }
	 */
	var BaseClient = /** @class */ (function () {
	    /**
	     * Initializes this client instance.
	     *
	     * @param backendClass A constructor function to create the backend.
	     * @param options Options for the client.
	     */
	    function BaseClient(backendClass, options) {
	        /** Array of used integrations. */
	        this._integrations = {};
	        /** Number of call being processed */
	        this._processing = 0;
	        this._backend = new backendClass(options);
	        this._options = options;
	        if (options.dsn) {
	            this._dsn = new utils_1.Dsn(options.dsn);
	        }
	    }
	    /**
	     * @inheritDoc
	     */
	    // eslint-disable-next-line @typescript-eslint/no-explicit-any, @typescript-eslint/explicit-module-boundary-types
	    BaseClient.prototype.captureException = function (exception, hint, scope) {
	        var _this = this;
	        var eventId = hint && hint.event_id;
	        this._process(this._getBackend()
	            .eventFromException(exception, hint)
	            .then(function (event) { return _this._captureEvent(event, hint, scope); })
	            .then(function (result) {
	            eventId = result;
	        }));
	        return eventId;
	    };
	    /**
	     * @inheritDoc
	     */
	    BaseClient.prototype.captureMessage = function (message, level, hint, scope) {
	        var _this = this;
	        var eventId = hint && hint.event_id;
	        var promisedEvent = utils_1.isPrimitive(message)
	            ? this._getBackend().eventFromMessage(String(message), level, hint)
	            : this._getBackend().eventFromException(message, hint);
	        this._process(promisedEvent
	            .then(function (event) { return _this._captureEvent(event, hint, scope); })
	            .then(function (result) {
	            eventId = result;
	        }));
	        return eventId;
	    };
	    /**
	     * @inheritDoc
	     */
	    BaseClient.prototype.captureEvent = function (event, hint, scope) {
	        var eventId = hint && hint.event_id;
	        this._process(this._captureEvent(event, hint, scope).then(function (result) {
	            eventId = result;
	        }));
	        return eventId;
	    };
	    /**
	     * @inheritDoc
	     */
	    BaseClient.prototype.captureSession = function (session) {
	        if (!session.release) {
	            utils_1.logger.warn('Discarded session because of missing release');
	        }
	        else {
	            this._sendSession(session);
	        }
	    };
	    /**
	     * @inheritDoc
	     */
	    BaseClient.prototype.getDsn = function () {
	        return this._dsn;
	    };
	    /**
	     * @inheritDoc
	     */
	    BaseClient.prototype.getOptions = function () {
	        return this._options;
	    };
	    /**
	     * @inheritDoc
	     */
	    BaseClient.prototype.flush = function (timeout) {
	        var _this = this;
	        return this._isClientProcessing(timeout).then(function (ready) {
	            return _this._getBackend()
	                .getTransport()
	                .close(timeout)
	                .then(function (transportFlushed) { return ready && transportFlushed; });
	        });
	    };
	    /**
	     * @inheritDoc
	     */
	    BaseClient.prototype.close = function (timeout) {
	        var _this = this;
	        return this.flush(timeout).then(function (result) {
	            _this.getOptions().enabled = false;
	            return result;
	        });
	    };
	    /**
	     * Sets up the integrations
	     */
	    BaseClient.prototype.setupIntegrations = function () {
	        if (this._isEnabled()) {
	            this._integrations = integration_1.setupIntegrations(this._options);
	        }
	    };
	    /**
	     * @inheritDoc
	     */
	    BaseClient.prototype.getIntegration = function (integration) {
	        try {
	            return this._integrations[integration.id] || null;
	        }
	        catch (_oO) {
	            utils_1.logger.warn("Cannot retrieve integration " + integration.id + " from the current Client");
	            return null;
	        }
	    };
	    /** Updates existing session based on the provided event */
	    BaseClient.prototype._updateSessionFromEvent = function (session, event) {
	        var e_1, _a;
	        var crashed = false;
	        var errored = false;
	        var userAgent;
	        var exceptions = event.exception && event.exception.values;
	        if (exceptions) {
	            errored = true;
	            try {
	                for (var exceptions_1 = tslib_1.__values(exceptions), exceptions_1_1 = exceptions_1.next(); !exceptions_1_1.done; exceptions_1_1 = exceptions_1.next()) {
	                    var ex = exceptions_1_1.value;
	                    var mechanism = ex.mechanism;
	                    if (mechanism && mechanism.handled === false) {
	                        crashed = true;
	                        break;
	                    }
	                }
	            }
	            catch (e_1_1) { e_1 = { error: e_1_1 }; }
	            finally {
	                try {
	                    if (exceptions_1_1 && !exceptions_1_1.done && (_a = exceptions_1.return)) _a.call(exceptions_1);
	                }
	                finally { if (e_1) throw e_1.error; }
	            }
	        }
	        var user = event.user;
	        if (!session.userAgent) {
	            var headers = event.request ? event.request.headers : {};
	            for (var key in headers) {
	                if (key.toLowerCase() === 'user-agent') {
	                    userAgent = headers[key];
	                    break;
	                }
	            }
	        }
	        session.update(tslib_1.__assign(tslib_1.__assign({}, (crashed && { status: types_1.SessionStatus.Crashed })), { user: user,
	            userAgent: userAgent, errors: session.errors + Number(errored || crashed) }));
	    };
	    /** Deliver captured session to Sentry */
	    BaseClient.prototype._sendSession = function (session) {
	        this._getBackend().sendSession(session);
	    };
	    /** Waits for the client to be done with processing. */
	    BaseClient.prototype._isClientProcessing = function (timeout) {
	        var _this = this;
	        return new utils_1.SyncPromise(function (resolve) {
	            var ticked = 0;
	            var tick = 1;
	            var interval = setInterval(function () {
	                if (_this._processing == 0) {
	                    clearInterval(interval);
	                    resolve(true);
	                }
	                else {
	                    ticked += tick;
	                    if (timeout && ticked >= timeout) {
	                        clearInterval(interval);
	                        resolve(false);
	                    }
	                }
	            }, tick);
	        });
	    };
	    /** Returns the current backend. */
	    BaseClient.prototype._getBackend = function () {
	        return this._backend;
	    };
	    /** Determines whether this SDK is enabled and a valid Dsn is present. */
	    BaseClient.prototype._isEnabled = function () {
	        return this.getOptions().enabled !== false && this._dsn !== undefined;
	    };
	    /**
	     * Adds common information to events.
	     *
	     * The information includes release and environment from `options`,
	     * breadcrumbs and context (extra, tags and user) from the scope.
	     *
	     * Information that is already present in the event is never overwritten. For
	     * nested objects, such as the context, keys are merged.
	     *
	     * @param event The original event.
	     * @param hint May contain additional information about the original exception.
	     * @param scope A scope containing event metadata.
	     * @returns A new event with more information.
	     */
	    BaseClient.prototype._prepareEvent = function (event, scope, hint) {
	        var _this = this;
	        var _a = this.getOptions().normalizeDepth, normalizeDepth = _a === void 0 ? 3 : _a;
	        var prepared = tslib_1.__assign(tslib_1.__assign({}, event), { event_id: event.event_id || (hint && hint.event_id ? hint.event_id : utils_1.uuid4()), timestamp: event.timestamp || utils_1.dateTimestampInSeconds() });
	        this._applyClientOptions(prepared);
	        this._applyIntegrationsMetadata(prepared);
	        // If we have scope given to us, use it as the base for further modifications.
	        // This allows us to prevent unnecessary copying of data if `captureContext` is not provided.
	        var finalScope = scope;
	        if (hint && hint.captureContext) {
	            finalScope = hub_1.Scope.clone(finalScope).update(hint.captureContext);
	        }
	        // We prepare the result here with a resolved Event.
	        var result = utils_1.SyncPromise.resolve(prepared);
	        // This should be the last thing called, since we want that
	        // {@link Hub.addEventProcessor} gets the finished prepared event.
	        if (finalScope) {
	            // In case we have a hub we reassign it.
	            result = finalScope.applyToEvent(prepared, hint);
	        }
	        return result.then(function (evt) {
	            if (typeof normalizeDepth === 'number' && normalizeDepth > 0) {
	                return _this._normalizeEvent(evt, normalizeDepth);
	            }
	            return evt;
	        });
	    };
	    /**
	     * Applies `normalize` function on necessary `Event` attributes to make them safe for serialization.
	     * Normalized keys:
	     * - `breadcrumbs.data`
	     * - `user`
	     * - `contexts`
	     * - `extra`
	     * @param event Event
	     * @returns Normalized event
	     */
	    BaseClient.prototype._normalizeEvent = function (event, depth) {
	        if (!event) {
	            return null;
	        }
	        var normalized = tslib_1.__assign(tslib_1.__assign(tslib_1.__assign(tslib_1.__assign(tslib_1.__assign({}, event), (event.breadcrumbs && {
	            breadcrumbs: event.breadcrumbs.map(function (b) { return (tslib_1.__assign(tslib_1.__assign({}, b), (b.data && {
	                data: utils_1.normalize(b.data, depth),
	            }))); }),
	        })), (event.user && {
	            user: utils_1.normalize(event.user, depth),
	        })), (event.contexts && {
	            contexts: utils_1.normalize(event.contexts, depth),
	        })), (event.extra && {
	            extra: utils_1.normalize(event.extra, depth),
	        }));
	        // event.contexts.trace stores information about a Transaction. Similarly,
	        // event.spans[] stores information about child Spans. Given that a
	        // Transaction is conceptually a Span, normalization should apply to both
	        // Transactions and Spans consistently.
	        // For now the decision is to skip normalization of Transactions and Spans,
	        // so this block overwrites the normalized event to add back the original
	        // Transaction information prior to normalization.
	        if (event.contexts && event.contexts.trace) {
	            // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
	            normalized.contexts.trace = event.contexts.trace;
	        }
	        return normalized;
	    };
	    /**
	     *  Enhances event using the client configuration.
	     *  It takes care of all "static" values like environment, release and `dist`,
	     *  as well as truncating overly long values.
	     * @param event event instance to be enhanced
	     */
	    BaseClient.prototype._applyClientOptions = function (event) {
	        var options = this.getOptions();
	        var environment = options.environment, release = options.release, dist = options.dist, _a = options.maxValueLength, maxValueLength = _a === void 0 ? 250 : _a;
	        if (!('environment' in event)) {
	            event.environment = 'environment' in options ? environment : 'production';
	        }
	        if (event.release === undefined && release !== undefined) {
	            event.release = release;
	        }
	        if (event.dist === undefined && dist !== undefined) {
	            event.dist = dist;
	        }
	        if (event.message) {
	            event.message = utils_1.truncate(event.message, maxValueLength);
	        }
	        var exception = event.exception && event.exception.values && event.exception.values[0];
	        if (exception && exception.value) {
	            exception.value = utils_1.truncate(exception.value, maxValueLength);
	        }
	        var request = event.request;
	        if (request && request.url) {
	            request.url = utils_1.truncate(request.url, maxValueLength);
	        }
	    };
	    /**
	     * This function adds all used integrations to the SDK info in the event.
	     * @param sdkInfo The sdkInfo of the event that will be filled with all integrations.
	     */
	    BaseClient.prototype._applyIntegrationsMetadata = function (event) {
	        var sdkInfo = event.sdk;
	        var integrationsArray = Object.keys(this._integrations);
	        if (sdkInfo && integrationsArray.length > 0) {
	            sdkInfo.integrations = integrationsArray;
	        }
	    };
	    /**
	     * Tells the backend to send this event
	     * @param event The Sentry event to send
	     */
	    BaseClient.prototype._sendEvent = function (event) {
	        this._getBackend().sendEvent(event);
	    };
	    /**
	     * Processes the event and logs an error in case of rejection
	     * @param event
	     * @param hint
	     * @param scope
	     */
	    BaseClient.prototype._captureEvent = function (event, hint, scope) {
	        return this._processEvent(event, hint, scope).then(function (finalEvent) {
	            return finalEvent.event_id;
	        }, function (reason) {
	            utils_1.logger.error(reason);
	            return undefined;
	        });
	    };
	    /**
	     * Processes an event (either error or message) and sends it to Sentry.
	     *
	     * This also adds breadcrumbs and context information to the event. However,
	     * platform specific meta data (such as the User's IP address) must be added
	     * by the SDK implementor.
	     *
	     *
	     * @param event The event to send to Sentry.
	     * @param hint May contain additional information about the original exception.
	     * @param scope A scope containing event metadata.
	     * @returns A SyncPromise that resolves with the event or rejects in case event was/will not be send.
	     */
	    BaseClient.prototype._processEvent = function (event, hint, scope) {
	        var _this = this;
	        // eslint-disable-next-line @typescript-eslint/unbound-method
	        var _a = this.getOptions(), beforeSend = _a.beforeSend, sampleRate = _a.sampleRate;
	        if (!this._isEnabled()) {
	            return utils_1.SyncPromise.reject(new utils_1.SentryError('SDK not enabled, will not send event.'));
	        }
	        var isTransaction = event.type === 'transaction';
	        // 1.0 === 100% events are sent
	        // 0.0 === 0% events are sent
	        // Sampling for transaction happens somewhere else
	        if (!isTransaction && typeof sampleRate === 'number' && Math.random() > sampleRate) {
	            return utils_1.SyncPromise.reject(new utils_1.SentryError("Discarding event because it's not included in the random sample (sampling rate = " + sampleRate + ")"));
	        }
	        return this._prepareEvent(event, scope, hint)
	            .then(function (prepared) {
	            if (prepared === null) {
	                throw new utils_1.SentryError('An event processor returned null, will not send event.');
	            }
	            var isInternalException = hint && hint.data && hint.data.__sentry__ === true;
	            if (isInternalException || isTransaction || !beforeSend) {
	                return prepared;
	            }
	            var beforeSendResult = beforeSend(prepared, hint);
	            if (typeof beforeSendResult === 'undefined') {
	                throw new utils_1.SentryError('`beforeSend` method has to return `null` or a valid event.');
	            }
	            else if (utils_1.isThenable(beforeSendResult)) {
	                return beforeSendResult.then(function (event) { return event; }, function (e) {
	                    throw new utils_1.SentryError("beforeSend rejected with " + e);
	                });
	            }
	            return beforeSendResult;
	        })
	            .then(function (processedEvent) {
	            if (processedEvent === null) {
	                throw new utils_1.SentryError('`beforeSend` returned `null`, will not send event.');
	            }
	            var session = scope && scope.getSession && scope.getSession();
	            if (!isTransaction && session) {
	                _this._updateSessionFromEvent(session, processedEvent);
	            }
	            _this._sendEvent(processedEvent);
	            return processedEvent;
	        })
	            .then(null, function (reason) {
	            if (reason instanceof utils_1.SentryError) {
	                throw reason;
	            }
	            _this.captureException(reason, {
	                data: {
	                    __sentry__: true,
	                },
	                originalException: reason,
	            });
	            throw new utils_1.SentryError("Event processing pipeline threw an error, original event will not be sent. Details have been sent as a new event.\nReason: " + reason);
	        });
	    };
	    /**
	     * Occupies the client with processing and event
	     */
	    BaseClient.prototype._process = function (promise) {
	        var _this = this;
	        this._processing += 1;
	        promise.then(function (value) {
	            _this._processing -= 1;
	            return value;
	        }, function (reason) {
	            _this._processing -= 1;
	            return reason;
	        });
	    };
	    return BaseClient;
	}());
	exports.BaseClient = BaseClient;
	//# sourceMappingURL=baseclient.js.map

/***/ }),
/* 44 */
/***/ (function(module, exports, __webpack_require__) {

	Object.defineProperty(exports, "__esModule", { value: true });
	var tslib_1 = __webpack_require__(6);
	var hub_1 = __webpack_require__(16);
	var utils_1 = __webpack_require__(18);
	exports.installedIntegrations = [];
	/** Gets integration to install */
	function getIntegrationsToSetup(options) {
	    var defaultIntegrations = (options.defaultIntegrations && tslib_1.__spread(options.defaultIntegrations)) || [];
	    var userIntegrations = options.integrations;
	    var integrations = [];
	    if (Array.isArray(userIntegrations)) {
	        var userIntegrationsNames_1 = userIntegrations.map(function (i) { return i.name; });
	        var pickedIntegrationsNames_1 = [];
	        // Leave only unique default integrations, that were not overridden with provided user integrations
	        defaultIntegrations.forEach(function (defaultIntegration) {
	            if (userIntegrationsNames_1.indexOf(defaultIntegration.name) === -1 &&
	                pickedIntegrationsNames_1.indexOf(defaultIntegration.name) === -1) {
	                integrations.push(defaultIntegration);
	                pickedIntegrationsNames_1.push(defaultIntegration.name);
	            }
	        });
	        // Don't add same user integration twice
	        userIntegrations.forEach(function (userIntegration) {
	            if (pickedIntegrationsNames_1.indexOf(userIntegration.name) === -1) {
	                integrations.push(userIntegration);
	                pickedIntegrationsNames_1.push(userIntegration.name);
	            }
	        });
	    }
	    else if (typeof userIntegrations === 'function') {
	        integrations = userIntegrations(defaultIntegrations);
	        integrations = Array.isArray(integrations) ? integrations : [integrations];
	    }
	    else {
	        integrations = tslib_1.__spread(defaultIntegrations);
	    }
	    // Make sure that if present, `Debug` integration will always run last
	    var integrationsNames = integrations.map(function (i) { return i.name; });
	    var alwaysLastToRun = 'Debug';
	    if (integrationsNames.indexOf(alwaysLastToRun) !== -1) {
	        integrations.push.apply(integrations, tslib_1.__spread(integrations.splice(integrationsNames.indexOf(alwaysLastToRun), 1)));
	    }
	    return integrations;
	}
	exports.getIntegrationsToSetup = getIntegrationsToSetup;
	/** Setup given integration */
	function setupIntegration(integration) {
	    if (exports.installedIntegrations.indexOf(integration.name) !== -1) {
	        return;
	    }
	    integration.setupOnce(hub_1.addGlobalEventProcessor, hub_1.getCurrentHub);
	    exports.installedIntegrations.push(integration.name);
	    utils_1.logger.log("Integration installed: " + integration.name);
	}
	exports.setupIntegration = setupIntegration;
	/**
	 * Given a list of integration instances this installs them all. When `withDefaults` is set to `true` then all default
	 * integrations are added unless they were already provided before.
	 * @param integrations array of integration instances
	 * @param withDefault should enable default integrations
	 */
	function setupIntegrations(options) {
	    var integrations = {};
	    getIntegrationsToSetup(options).forEach(function (integration) {
	        integrations[integration.name] = integration;
	        setupIntegration(integration);
	    });
	    return integrations;
	}
	exports.setupIntegrations = setupIntegrations;
	//# sourceMappingURL=integration.js.map

/***/ }),
/* 45 */
/***/ (function(module, exports, __webpack_require__) {

	Object.defineProperty(exports, "__esModule", { value: true });
	var utils_1 = __webpack_require__(18);
	var noop_1 = __webpack_require__(46);
	/**
	 * This is the base implemention of a Backend.
	 * @hidden
	 */
	var BaseBackend = /** @class */ (function () {
	    /** Creates a new backend instance. */
	    function BaseBackend(options) {
	        this._options = options;
	        if (!this._options.dsn) {
	            utils_1.logger.warn('No DSN provided, backend will not do anything.');
	        }
	        this._transport = this._setupTransport();
	    }
	    /**
	     * @inheritDoc
	     */
	    // eslint-disable-next-line @typescript-eslint/no-explicit-any, @typescript-eslint/explicit-module-boundary-types
	    BaseBackend.prototype.eventFromException = function (_exception, _hint) {
	        throw new utils_1.SentryError('Backend has to implement `eventFromException` method');
	    };
	    /**
	     * @inheritDoc
	     */
	    BaseBackend.prototype.eventFromMessage = function (_message, _level, _hint) {
	        throw new utils_1.SentryError('Backend has to implement `eventFromMessage` method');
	    };
	    /**
	     * @inheritDoc
	     */
	    BaseBackend.prototype.sendEvent = function (event) {
	        this._transport.sendEvent(event).then(null, function (reason) {
	            utils_1.logger.error("Error while sending event: " + reason);
	        });
	    };
	    /**
	     * @inheritDoc
	     */
	    BaseBackend.prototype.sendSession = function (session) {
	        if (!this._transport.sendSession) {
	            utils_1.logger.warn("Dropping session because custom transport doesn't implement sendSession");
	            return;
	        }
	        this._transport.sendSession(session).then(null, function (reason) {
	            utils_1.logger.error("Error while sending session: " + reason);
	        });
	    };
	    /**
	     * @inheritDoc
	     */
	    BaseBackend.prototype.getTransport = function () {
	        return this._transport;
	    };
	    /**
	     * Sets up the transport so it can be used later to send requests.
	     */
	    BaseBackend.prototype._setupTransport = function () {
	        return new noop_1.NoopTransport();
	    };
	    return BaseBackend;
	}());
	exports.BaseBackend = BaseBackend;
	//# sourceMappingURL=basebackend.js.map

/***/ }),
/* 46 */
/***/ (function(module, exports, __webpack_require__) {

	Object.defineProperty(exports, "__esModule", { value: true });
	var types_1 = __webpack_require__(8);
	var utils_1 = __webpack_require__(18);
	/** Noop transport */
	var NoopTransport = /** @class */ (function () {
	    function NoopTransport() {
	    }
	    /**
	     * @inheritDoc
	     */
	    NoopTransport.prototype.sendEvent = function (_) {
	        return utils_1.SyncPromise.resolve({
	            reason: "NoopTransport: Event has been skipped because no Dsn is configured.",
	            status: types_1.Status.Skipped,
	        });
	    };
	    /**
	     * @inheritDoc
	     */
	    NoopTransport.prototype.close = function (_) {
	        return utils_1.SyncPromise.resolve(true);
	    };
	    return NoopTransport;
	}());
	exports.NoopTransport = NoopTransport;
	//# sourceMappingURL=noop.js.map

/***/ }),
/* 47 */
/***/ (function(module, exports, __webpack_require__) {

	Object.defineProperty(exports, "__esModule", { value: true });
	var tslib_1 = __webpack_require__(6);
	/** Creates a SentryRequest from an event. */
	function sessionToSentryRequest(session, api) {
	    var envelopeHeaders = JSON.stringify({
	        sent_at: new Date().toISOString(),
	    });
	    var itemHeaders = JSON.stringify({
	        type: 'session',
	    });
	    return {
	        body: envelopeHeaders + "\n" + itemHeaders + "\n" + JSON.stringify(session),
	        type: 'session',
	        url: api.getEnvelopeEndpointWithUrlEncodedAuth(),
	    };
	}
	exports.sessionToSentryRequest = sessionToSentryRequest;
	/** Creates a SentryRequest from an event. */
	function eventToSentryRequest(event, api) {
	    // since JS has no Object.prototype.pop()
	    var _a = event.tags || {}, samplingMethod = _a.__sentry_samplingMethod, sampleRate = _a.__sentry_sampleRate, otherTags = tslib_1.__rest(_a, ["__sentry_samplingMethod", "__sentry_sampleRate"]);
	    event.tags = otherTags;
	    var useEnvelope = event.type === 'transaction';
	    var req = {
	        body: JSON.stringify(event),
	        type: event.type || 'event',
	        url: useEnvelope ? api.getEnvelopeEndpointWithUrlEncodedAuth() : api.getStoreEndpointWithUrlEncodedAuth(),
	    };
	    // https://develop.sentry.dev/sdk/envelopes/
	    // Since we don't need to manipulate envelopes nor store them, there is no
	    // exported concept of an Envelope with operations including serialization and
	    // deserialization. Instead, we only implement a minimal subset of the spec to
	    // serialize events inline here.
	    if (useEnvelope) {
	        var envelopeHeaders = JSON.stringify({
	            event_id: event.event_id,
	            sent_at: new Date().toISOString(),
	        });
	        var itemHeaders = JSON.stringify({
	            type: event.type,
	            // TODO: Right now, sampleRate may or may not be defined (it won't be in the cases of inheritance and
	            // explicitly-set sampling decisions). Are we good with that?
	            sample_rates: [{ id: samplingMethod, rate: sampleRate }],
	        });
	        // The trailing newline is optional. We intentionally don't send it to avoid
	        // sending unnecessary bytes.
	        //
	        // const envelope = `${envelopeHeaders}\n${itemHeaders}\n${req.body}\n`;
	        var envelope = envelopeHeaders + "\n" + itemHeaders + "\n" + req.body;
	        req.body = envelope;
	    }
	    return req;
	}
	exports.eventToSentryRequest = eventToSentryRequest;
	//# sourceMappingURL=request.js.map

/***/ }),
/* 48 */
/***/ (function(module, exports, __webpack_require__) {

	Object.defineProperty(exports, "__esModule", { value: true });
	var hub_1 = __webpack_require__(16);
	var utils_1 = __webpack_require__(18);
	/**
	 * Internal function to create a new SDK client instance. The client is
	 * installed and then bound to the current scope.
	 *
	 * @param clientClass The client class to instantiate.
	 * @param options Options to pass to the client.
	 */
	function initAndBind(clientClass, options) {
	    if (options.debug === true) {
	        utils_1.logger.enable();
	    }
	    var hub = hub_1.getCurrentHub();
	    var client = new clientClass(options);
	    hub.bindClient(client);
	}
	exports.initAndBind = initAndBind;
	//# sourceMappingURL=sdk.js.map

/***/ }),
/* 49 */
/***/ (function(module, exports, __webpack_require__) {

	Object.defineProperty(exports, "__esModule", { value: true });
	var functiontostring_1 = __webpack_require__(50);
	exports.FunctionToString = functiontostring_1.FunctionToString;
	var inboundfilters_1 = __webpack_require__(51);
	exports.InboundFilters = inboundfilters_1.InboundFilters;
	//# sourceMappingURL=index.js.map

/***/ }),
/* 50 */
/***/ (function(module, exports) {

	Object.defineProperty(exports, "__esModule", { value: true });
	var originalFunctionToString;
	/** Patch toString calls to return proper name for wrapped functions */
	var FunctionToString = /** @class */ (function () {
	    function FunctionToString() {
	        /**
	         * @inheritDoc
	         */
	        this.name = FunctionToString.id;
	    }
	    /**
	     * @inheritDoc
	     */
	    FunctionToString.prototype.setupOnce = function () {
	        // eslint-disable-next-line @typescript-eslint/unbound-method
	        originalFunctionToString = Function.prototype.toString;
	        // eslint-disable-next-line @typescript-eslint/no-explicit-any
	        Function.prototype.toString = function () {
	            var args = [];
	            for (var _i = 0; _i < arguments.length; _i++) {
	                args[_i] = arguments[_i];
	            }
	            var context = this.__sentry_original__ || this;
	            return originalFunctionToString.apply(context, args);
	        };
	    };
	    /**
	     * @inheritDoc
	     */
	    FunctionToString.id = 'FunctionToString';
	    return FunctionToString;
	}());
	exports.FunctionToString = FunctionToString;
	//# sourceMappingURL=functiontostring.js.map

/***/ }),
/* 51 */
/***/ (function(module, exports, __webpack_require__) {

	Object.defineProperty(exports, "__esModule", { value: true });
	var tslib_1 = __webpack_require__(6);
	var hub_1 = __webpack_require__(16);
	var utils_1 = __webpack_require__(18);
	// "Script error." is hard coded into browsers for errors that it can't read.
	// this is the result of a script being pulled in from an external domain and CORS.
	var DEFAULT_IGNORE_ERRORS = [/^Script error\.?$/, /^Javascript error: Script error\.? on line 0$/];
	/** Inbound filters configurable by the user */
	var InboundFilters = /** @class */ (function () {
	    function InboundFilters(_options) {
	        if (_options === void 0) { _options = {}; }
	        this._options = _options;
	        /**
	         * @inheritDoc
	         */
	        this.name = InboundFilters.id;
	    }
	    /**
	     * @inheritDoc
	     */
	    InboundFilters.prototype.setupOnce = function () {
	        hub_1.addGlobalEventProcessor(function (event) {
	            var hub = hub_1.getCurrentHub();
	            if (!hub) {
	                return event;
	            }
	            var self = hub.getIntegration(InboundFilters);
	            if (self) {
	                var client = hub.getClient();
	                var clientOptions = client ? client.getOptions() : {};
	                var options = self._mergeOptions(clientOptions);
	                if (self._shouldDropEvent(event, options)) {
	                    return null;
	                }
	            }
	            return event;
	        });
	    };
	    /** JSDoc */
	    InboundFilters.prototype._shouldDropEvent = function (event, options) {
	        if (this._isSentryError(event, options)) {
	            utils_1.logger.warn("Event dropped due to being internal Sentry Error.\nEvent: " + utils_1.getEventDescription(event));
	            return true;
	        }
	        if (this._isIgnoredError(event, options)) {
	            utils_1.logger.warn("Event dropped due to being matched by `ignoreErrors` option.\nEvent: " + utils_1.getEventDescription(event));
	            return true;
	        }
	        if (this._isDeniedUrl(event, options)) {
	            utils_1.logger.warn("Event dropped due to being matched by `denyUrls` option.\nEvent: " + utils_1.getEventDescription(event) + ".\nUrl: " + this._getEventFilterUrl(event));
	            return true;
	        }
	        if (!this._isAllowedUrl(event, options)) {
	            utils_1.logger.warn("Event dropped due to not being matched by `allowUrls` option.\nEvent: " + utils_1.getEventDescription(event) + ".\nUrl: " + this._getEventFilterUrl(event));
	            return true;
	        }
	        return false;
	    };
	    /** JSDoc */
	    InboundFilters.prototype._isSentryError = function (event, options) {
	        if (!options.ignoreInternal) {
	            return false;
	        }
	        try {
	            return ((event &&
	                event.exception &&
	                event.exception.values &&
	                event.exception.values[0] &&
	                event.exception.values[0].type === 'SentryError') ||
	                false);
	        }
	        catch (_oO) {
	            return false;
	        }
	    };
	    /** JSDoc */
	    InboundFilters.prototype._isIgnoredError = function (event, options) {
	        if (!options.ignoreErrors || !options.ignoreErrors.length) {
	            return false;
	        }
	        return this._getPossibleEventMessages(event).some(function (message) {
	            // Not sure why TypeScript complains here...
	            return options.ignoreErrors.some(function (pattern) { return utils_1.isMatchingPattern(message, pattern); });
	        });
	    };
	    /** JSDoc */
	    InboundFilters.prototype._isDeniedUrl = function (event, options) {
	        // TODO: Use Glob instead?
	        if (!options.denyUrls || !options.denyUrls.length) {
	            return false;
	        }
	        var url = this._getEventFilterUrl(event);
	        return !url ? false : options.denyUrls.some(function (pattern) { return utils_1.isMatchingPattern(url, pattern); });
	    };
	    /** JSDoc */
	    InboundFilters.prototype._isAllowedUrl = function (event, options) {
	        // TODO: Use Glob instead?
	        if (!options.allowUrls || !options.allowUrls.length) {
	            return true;
	        }
	        var url = this._getEventFilterUrl(event);
	        return !url ? true : options.allowUrls.some(function (pattern) { return utils_1.isMatchingPattern(url, pattern); });
	    };
	    /** JSDoc */
	    InboundFilters.prototype._mergeOptions = function (clientOptions) {
	        if (clientOptions === void 0) { clientOptions = {}; }
	        return {
	            allowUrls: tslib_1.__spread((this._options.whitelistUrls || []), (this._options.allowUrls || []), (clientOptions.whitelistUrls || []), (clientOptions.allowUrls || [])),
	            denyUrls: tslib_1.__spread((this._options.blacklistUrls || []), (this._options.denyUrls || []), (clientOptions.blacklistUrls || []), (clientOptions.denyUrls || [])),
	            ignoreErrors: tslib_1.__spread((this._options.ignoreErrors || []), (clientOptions.ignoreErrors || []), DEFAULT_IGNORE_ERRORS),
	            ignoreInternal: typeof this._options.ignoreInternal !== 'undefined' ? this._options.ignoreInternal : true,
	        };
	    };
	    /** JSDoc */
	    InboundFilters.prototype._getPossibleEventMessages = function (event) {
	        if (event.message) {
	            return [event.message];
	        }
	        if (event.exception) {
	            try {
	                var _a = (event.exception.values && event.exception.values[0]) || {}, _b = _a.type, type = _b === void 0 ? '' : _b, _c = _a.value, value = _c === void 0 ? '' : _c;
	                return ["" + value, type + ": " + value];
	            }
	            catch (oO) {
	                utils_1.logger.error("Cannot extract message for event " + utils_1.getEventDescription(event));
	                return [];
	            }
	        }
	        return [];
	    };
	    /** JSDoc */
	    InboundFilters.prototype._getEventFilterUrl = function (event) {
	        try {
	            if (event.stacktrace) {
	                var frames_1 = event.stacktrace.frames;
	                return (frames_1 && frames_1[frames_1.length - 1].filename) || null;
	            }
	            if (event.exception) {
	                var frames_2 = event.exception.values && event.exception.values[0].stacktrace && event.exception.values[0].stacktrace.frames;
	                return (frames_2 && frames_2[frames_2.length - 1].filename) || null;
	            }
	            return null;
	        }
	        catch (oO) {
	            utils_1.logger.error("Cannot extract url for event " + utils_1.getEventDescription(event));
	            return null;
	        }
	    };
	    /**
	     * @inheritDoc
	     */
	    InboundFilters.id = 'InboundFilters';
	    return InboundFilters;
	}());
	exports.InboundFilters = InboundFilters;
	//# sourceMappingURL=inboundfilters.js.map

/***/ }),
/* 52 */
/***/ (function(module, exports, __webpack_require__) {

	Object.defineProperty(exports, "__esModule", { value: true });
	var tslib_1 = __webpack_require__(6);
	var core_1 = __webpack_require__(14);
	var utils_1 = __webpack_require__(18);
	var backend_1 = __webpack_require__(53);
	var helpers_1 = __webpack_require__(61);
	var integrations_1 = __webpack_require__(62);
	var version_1 = __webpack_require__(68);
	/**
	 * The Sentry Browser SDK Client.
	 *
	 * @see BrowserOptions for documentation on configuration options.
	 * @see SentryClient for usage documentation.
	 */
	var BrowserClient = /** @class */ (function (_super) {
	    tslib_1.__extends(BrowserClient, _super);
	    /**
	     * Creates a new Browser SDK instance.
	     *
	     * @param options Configuration options for this SDK.
	     */
	    function BrowserClient(options) {
	        if (options === void 0) { options = {}; }
	        return _super.call(this, backend_1.BrowserBackend, options) || this;
	    }
	    /**
	     * Show a report dialog to the user to send feedback to a specific event.
	     *
	     * @param options Set individual options for the dialog
	     */
	    BrowserClient.prototype.showReportDialog = function (options) {
	        if (options === void 0) { options = {}; }
	        // doesn't work without a document (React Native)
	        var document = utils_1.getGlobalObject().document;
	        if (!document) {
	            return;
	        }
	        if (!this._isEnabled()) {
	            utils_1.logger.error('Trying to call showReportDialog with Sentry Client disabled');
	            return;
	        }
	        helpers_1.injectReportDialog(tslib_1.__assign(tslib_1.__assign({}, options), { dsn: options.dsn || this.getDsn() }));
	    };
	    /**
	     * @inheritDoc
	     */
	    BrowserClient.prototype._prepareEvent = function (event, scope, hint) {
	        event.platform = event.platform || 'javascript';
	        event.sdk = tslib_1.__assign(tslib_1.__assign({}, event.sdk), { name: version_1.SDK_NAME, packages: tslib_1.__spread(((event.sdk && event.sdk.packages) || []), [
	                {
	                    name: 'npm:@sentry/browser',
	                    version: version_1.SDK_VERSION,
	                },
	            ]), version: version_1.SDK_VERSION });
	        return _super.prototype._prepareEvent.call(this, event, scope, hint);
	    };
	    /**
	     * @inheritDoc
	     */
	    BrowserClient.prototype._sendEvent = function (event) {
	        var integration = this.getIntegration(integrations_1.Breadcrumbs);
	        if (integration) {
	            integration.addSentryBreadcrumb(event);
	        }
	        _super.prototype._sendEvent.call(this, event);
	    };
	    return BrowserClient;
	}(core_1.BaseClient));
	exports.BrowserClient = BrowserClient;
	//# sourceMappingURL=client.js.map

/***/ }),
/* 53 */
/***/ (function(module, exports, __webpack_require__) {

	Object.defineProperty(exports, "__esModule", { value: true });
	var tslib_1 = __webpack_require__(6);
	var core_1 = __webpack_require__(14);
	var types_1 = __webpack_require__(8);
	var utils_1 = __webpack_require__(18);
	var eventbuilder_1 = __webpack_require__(54);
	var transports_1 = __webpack_require__(57);
	/**
	 * The Sentry Browser SDK Backend.
	 * @hidden
	 */
	var BrowserBackend = /** @class */ (function (_super) {
	    tslib_1.__extends(BrowserBackend, _super);
	    function BrowserBackend() {
	        return _super !== null && _super.apply(this, arguments) || this;
	    }
	    /**
	     * @inheritDoc
	     */
	    BrowserBackend.prototype.eventFromException = function (exception, hint) {
	        return eventbuilder_1.eventFromException(this._options, exception, hint);
	    };
	    /**
	     * @inheritDoc
	     */
	    BrowserBackend.prototype.eventFromMessage = function (message, level, hint) {
	        if (level === void 0) { level = types_1.Severity.Info; }
	        return eventbuilder_1.eventFromMessage(this._options, message, level, hint);
	    };
	    /**
	     * @inheritDoc
	     */
	    BrowserBackend.prototype._setupTransport = function () {
	        if (!this._options.dsn) {
	            // We return the noop transport here in case there is no Dsn.
	            return _super.prototype._setupTransport.call(this);
	        }
	        var transportOptions = tslib_1.__assign(tslib_1.__assign({}, this._options.transportOptions), { dsn: this._options.dsn });
	        if (this._options.transport) {
	            return new this._options.transport(transportOptions);
	        }
	        if (utils_1.supportsFetch()) {
	            return new transports_1.FetchTransport(transportOptions);
	        }
	        return new transports_1.XHRTransport(transportOptions);
	    };
	    return BrowserBackend;
	}(core_1.BaseBackend));
	exports.BrowserBackend = BrowserBackend;
	//# sourceMappingURL=backend.js.map

/***/ }),
/* 54 */
/***/ (function(module, exports, __webpack_require__) {

	Object.defineProperty(exports, "__esModule", { value: true });
	var tslib_1 = __webpack_require__(6);
	var types_1 = __webpack_require__(8);
	var utils_1 = __webpack_require__(18);
	var parsers_1 = __webpack_require__(55);
	var tracekit_1 = __webpack_require__(56);
	/**
	 * Builds and Event from a Exception
	 * @hidden
	 */
	function eventFromException(options, exception, hint) {
	    var syntheticException = (hint && hint.syntheticException) || undefined;
	    var event = eventFromUnknownInput(exception, syntheticException, {
	        attachStacktrace: options.attachStacktrace,
	    });
	    utils_1.addExceptionMechanism(event, {
	        handled: true,
	        type: 'generic',
	    });
	    event.level = types_1.Severity.Error;
	    if (hint && hint.event_id) {
	        event.event_id = hint.event_id;
	    }
	    return utils_1.SyncPromise.resolve(event);
	}
	exports.eventFromException = eventFromException;
	/**
	 * Builds and Event from a Message
	 * @hidden
	 */
	function eventFromMessage(options, message, level, hint) {
	    if (level === void 0) { level = types_1.Severity.Info; }
	    var syntheticException = (hint && hint.syntheticException) || undefined;
	    var event = eventFromString(message, syntheticException, {
	        attachStacktrace: options.attachStacktrace,
	    });
	    event.level = level;
	    if (hint && hint.event_id) {
	        event.event_id = hint.event_id;
	    }
	    return utils_1.SyncPromise.resolve(event);
	}
	exports.eventFromMessage = eventFromMessage;
	/**
	 * @hidden
	 */
	function eventFromUnknownInput(exception, syntheticException, options) {
	    if (options === void 0) { options = {}; }
	    var event;
	    if (utils_1.isErrorEvent(exception) && exception.error) {
	        // If it is an ErrorEvent with `error` property, extract it to get actual Error
	        var errorEvent = exception;
	        // eslint-disable-next-line no-param-reassign
	        exception = errorEvent.error;
	        event = parsers_1.eventFromStacktrace(tracekit_1.computeStackTrace(exception));
	        return event;
	    }
	    if (utils_1.isDOMError(exception) || utils_1.isDOMException(exception)) {
	        // If it is a DOMError or DOMException (which are legacy APIs, but still supported in some browsers)
	        // then we just extract the name, code, and message, as they don't provide anything else
	        // https://developer.mozilla.org/en-US/docs/Web/API/DOMError
	        // https://developer.mozilla.org/en-US/docs/Web/API/DOMException
	        var domException = exception;
	        var name_1 = domException.name || (utils_1.isDOMError(domException) ? 'DOMError' : 'DOMException');
	        var message = domException.message ? name_1 + ": " + domException.message : name_1;
	        event = eventFromString(message, syntheticException, options);
	        utils_1.addExceptionTypeValue(event, message);
	        if ('code' in domException) {
	            event.tags = tslib_1.__assign(tslib_1.__assign({}, event.tags), { 'DOMException.code': "" + domException.code });
	        }
	        return event;
	    }
	    if (utils_1.isError(exception)) {
	        // we have a real Error object, do nothing
	        event = parsers_1.eventFromStacktrace(tracekit_1.computeStackTrace(exception));
	        return event;
	    }
	    if (utils_1.isPlainObject(exception) || utils_1.isEvent(exception)) {
	        // If it is plain Object or Event, serialize it manually and extract options
	        // This will allow us to group events based on top-level keys
	        // which is much better than creating new group when any key/value change
	        var objectException = exception;
	        event = parsers_1.eventFromPlainObject(objectException, syntheticException, options.rejection);
	        utils_1.addExceptionMechanism(event, {
	            synthetic: true,
	        });
	        return event;
	    }
	    // If none of previous checks were valid, then it means that it's not:
	    // - an instance of DOMError
	    // - an instance of DOMException
	    // - an instance of Event
	    // - an instance of Error
	    // - a valid ErrorEvent (one with an error property)
	    // - a plain Object
	    //
	    // So bail out and capture it as a simple message:
	    event = eventFromString(exception, syntheticException, options);
	    utils_1.addExceptionTypeValue(event, "" + exception, undefined);
	    utils_1.addExceptionMechanism(event, {
	        synthetic: true,
	    });
	    return event;
	}
	exports.eventFromUnknownInput = eventFromUnknownInput;
	/**
	 * @hidden
	 */
	function eventFromString(input, syntheticException, options) {
	    if (options === void 0) { options = {}; }
	    var event = {
	        message: input,
	    };
	    if (options.attachStacktrace && syntheticException) {
	        var stacktrace = tracekit_1.computeStackTrace(syntheticException);
	        var frames_1 = parsers_1.prepareFramesForEvent(stacktrace.stack);
	        event.stacktrace = {
	            frames: frames_1,
	        };
	    }
	    return event;
	}
	exports.eventFromString = eventFromString;
	//# sourceMappingURL=eventbuilder.js.map

/***/ }),
/* 55 */
/***/ (function(module, exports, __webpack_require__) {

	Object.defineProperty(exports, "__esModule", { value: true });
	var utils_1 = __webpack_require__(18);
	var tracekit_1 = __webpack_require__(56);
	var STACKTRACE_LIMIT = 50;
	/**
	 * This function creates an exception from an TraceKitStackTrace
	 * @param stacktrace TraceKitStackTrace that will be converted to an exception
	 * @hidden
	 */
	function exceptionFromStacktrace(stacktrace) {
	    var frames = prepareFramesForEvent(stacktrace.stack);
	    var exception = {
	        type: stacktrace.name,
	        value: stacktrace.message,
	    };
	    if (frames && frames.length) {
	        exception.stacktrace = { frames: frames };
	    }
	    if (exception.type === undefined && exception.value === '') {
	        exception.value = 'Unrecoverable error caught';
	    }
	    return exception;
	}
	exports.exceptionFromStacktrace = exceptionFromStacktrace;
	/**
	 * @hidden
	 */
	function eventFromPlainObject(exception, syntheticException, rejection) {
	    var event = {
	        exception: {
	            values: [
	                {
	                    type: utils_1.isEvent(exception) ? exception.constructor.name : rejection ? 'UnhandledRejection' : 'Error',
	                    value: "Non-Error " + (rejection ? 'promise rejection' : 'exception') + " captured with keys: " + utils_1.extractExceptionKeysForMessage(exception),
	                },
	            ],
	        },
	        extra: {
	            __serialized__: utils_1.normalizeToSize(exception),
	        },
	    };
	    if (syntheticException) {
	        var stacktrace = tracekit_1.computeStackTrace(syntheticException);
	        var frames_1 = prepareFramesForEvent(stacktrace.stack);
	        event.stacktrace = {
	            frames: frames_1,
	        };
	    }
	    return event;
	}
	exports.eventFromPlainObject = eventFromPlainObject;
	/**
	 * @hidden
	 */
	function eventFromStacktrace(stacktrace) {
	    var exception = exceptionFromStacktrace(stacktrace);
	    return {
	        exception: {
	            values: [exception],
	        },
	    };
	}
	exports.eventFromStacktrace = eventFromStacktrace;
	/**
	 * @hidden
	 */
	function prepareFramesForEvent(stack) {
	    if (!stack || !stack.length) {
	        return [];
	    }
	    var localStack = stack;
	    var firstFrameFunction = localStack[0].func || '';
	    var lastFrameFunction = localStack[localStack.length - 1].func || '';
	    // If stack starts with one of our API calls, remove it (starts, meaning it's the top of the stack - aka last call)
	    if (firstFrameFunction.indexOf('captureMessage') !== -1 || firstFrameFunction.indexOf('captureException') !== -1) {
	        localStack = localStack.slice(1);
	    }
	    // If stack ends with one of our internal API calls, remove it (ends, meaning it's the bottom of the stack - aka top-most call)
	    if (lastFrameFunction.indexOf('sentryWrapped') !== -1) {
	        localStack = localStack.slice(0, -1);
	    }
	    // The frame where the crash happened, should be the last entry in the array
	    return localStack
	        .slice(0, STACKTRACE_LIMIT)
	        .map(function (frame) { return ({
	        colno: frame.column === null ? undefined : frame.column,
	        filename: frame.url || localStack[0].url,
	        function: frame.func || '?',
	        in_app: true,
	        lineno: frame.line === null ? undefined : frame.line,
	    }); })
	        .reverse();
	}
	exports.prepareFramesForEvent = prepareFramesForEvent;
	//# sourceMappingURL=parsers.js.map

/***/ }),
/* 56 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * This was originally forked from https://github.com/occ/TraceKit, but has since been
	 * largely modified and is now maintained as part of Sentry JS SDK.
	 */
	Object.defineProperty(exports, "__esModule", { value: true });
	var tslib_1 = __webpack_require__(6);
	// global reference to slice
	var UNKNOWN_FUNCTION = '?';
	// Chromium based browsers: Chrome, Brave, new Opera, new Edge
	var chrome = /^\s*at (?:(.*?) ?\()?((?:file|https?|blob|chrome-extension|address|native|eval|webpack|<anonymous>|[-a-z]+:|.*bundle|\/).*?)(?::(\d+))?(?::(\d+))?\)?\s*$/i;
	// gecko regex: `(?:bundle|\d+\.js)`: `bundle` is for react native, `\d+\.js` also but specifically for ram bundles because it
	// generates filenames without a prefix like `file://` the filenames in the stacktrace are just 42.js
	// We need this specific case for now because we want no other regex to match.
	var gecko = /^\s*(.*?)(?:\((.*?)\))?(?:^|@)?((?:file|https?|blob|chrome|webpack|resource|moz-extension|capacitor).*?:\/.*?|\[native code\]|[^@]*(?:bundle|\d+\.js)|\/[\w\-. /=]+)(?::(\d+))?(?::(\d+))?\s*$/i;
	var winjs = /^\s*at (?:((?:\[object object\])?.+) )?\(?((?:file|ms-appx|https?|webpack|blob):.*?):(\d+)(?::(\d+))?\)?\s*$/i;
	var geckoEval = /(\S+) line (\d+)(?: > eval line \d+)* > eval/i;
	var chromeEval = /\((\S*)(?::(\d+))(?::(\d+))\)/;
	// Based on our own mapping pattern - https://github.com/getsentry/sentry/blob/9f08305e09866c8bd6d0c24f5b0aabdd7dd6c59c/src/sentry/lang/javascript/errormapping.py#L83-L108
	var reactMinifiedRegexp = /Minified React error #\d+;/i;
	/** JSDoc */
	// eslint-disable-next-line @typescript-eslint/no-explicit-any, @typescript-eslint/explicit-module-boundary-types
	function computeStackTrace(ex) {
	    var stack = null;
	    var popSize = 0;
	    if (ex) {
	        if (typeof ex.framesToPop === 'number') {
	            popSize = ex.framesToPop;
	        }
	        else if (reactMinifiedRegexp.test(ex.message)) {
	            popSize = 1;
	        }
	    }
	    try {
	        // This must be tried first because Opera 10 *destroys*
	        // its stacktrace property if you try to access the stack
	        // property first!!
	        stack = computeStackTraceFromStacktraceProp(ex);
	        if (stack) {
	            return popFrames(stack, popSize);
	        }
	    }
	    catch (e) {
	        // no-empty
	    }
	    try {
	        stack = computeStackTraceFromStackProp(ex);
	        if (stack) {
	            return popFrames(stack, popSize);
	        }
	    }
	    catch (e) {
	        // no-empty
	    }
	    return {
	        message: extractMessage(ex),
	        name: ex && ex.name,
	        stack: [],
	        failed: true,
	    };
	}
	exports.computeStackTrace = computeStackTrace;
	/** JSDoc */
	// eslint-disable-next-line @typescript-eslint/no-explicit-any, complexity
	function computeStackTraceFromStackProp(ex) {
	    if (!ex || !ex.stack) {
	        return null;
	    }
	    var stack = [];
	    var lines = ex.stack.split('\n');
	    var isEval;
	    var submatch;
	    var parts;
	    var element;
	    for (var i = 0; i < lines.length; ++i) {
	        if ((parts = chrome.exec(lines[i]))) {
	            var isNative = parts[2] && parts[2].indexOf('native') === 0; // start of line
	            isEval = parts[2] && parts[2].indexOf('eval') === 0; // start of line
	            if (isEval && (submatch = chromeEval.exec(parts[2]))) {
	                // throw out eval line/column and use top-most line/column number
	                parts[2] = submatch[1]; // url
	                parts[3] = submatch[2]; // line
	                parts[4] = submatch[3]; // column
	            }
	            element = {
	                // working with the regexp above is super painful. it is quite a hack, but just stripping the `address at `
	                // prefix here seems like the quickest solution for now.
	                url: parts[2] && parts[2].indexOf('address at ') === 0 ? parts[2].substr('address at '.length) : parts[2],
	                func: parts[1] || UNKNOWN_FUNCTION,
	                args: isNative ? [parts[2]] : [],
	                line: parts[3] ? +parts[3] : null,
	                column: parts[4] ? +parts[4] : null,
	            };
	        }
	        else if ((parts = winjs.exec(lines[i]))) {
	            element = {
	                url: parts[2],
	                func: parts[1] || UNKNOWN_FUNCTION,
	                args: [],
	                line: +parts[3],
	                column: parts[4] ? +parts[4] : null,
	            };
	        }
	        else if ((parts = gecko.exec(lines[i]))) {
	            isEval = parts[3] && parts[3].indexOf(' > eval') > -1;
	            if (isEval && (submatch = geckoEval.exec(parts[3]))) {
	                // throw out eval line/column and use top-most line number
	                parts[1] = parts[1] || "eval";
	                parts[3] = submatch[1];
	                parts[4] = submatch[2];
	                parts[5] = ''; // no column when eval
	            }
	            else if (i === 0 && !parts[5] && ex.columnNumber !== void 0) {
	                // FireFox uses this awesome columnNumber property for its top frame
	                // Also note, Firefox's column number is 0-based and everything else expects 1-based,
	                // so adding 1
	                // NOTE: this hack doesn't work if top-most frame is eval
	                stack[0].column = ex.columnNumber + 1;
	            }
	            element = {
	                url: parts[3],
	                func: parts[1] || UNKNOWN_FUNCTION,
	                args: parts[2] ? parts[2].split(',') : [],
	                line: parts[4] ? +parts[4] : null,
	                column: parts[5] ? +parts[5] : null,
	            };
	        }
	        else {
	            continue;
	        }
	        if (!element.func && element.line) {
	            element.func = UNKNOWN_FUNCTION;
	        }
	        stack.push(element);
	    }
	    if (!stack.length) {
	        return null;
	    }
	    return {
	        message: extractMessage(ex),
	        name: ex.name,
	        stack: stack,
	    };
	}
	/** JSDoc */
	// eslint-disable-next-line @typescript-eslint/no-explicit-any
	function computeStackTraceFromStacktraceProp(ex) {
	    if (!ex || !ex.stacktrace) {
	        return null;
	    }
	    // Access and store the stacktrace property before doing ANYTHING
	    // else to it because Opera is not very good at providing it
	    // reliably in other circumstances.
	    var stacktrace = ex.stacktrace;
	    var opera10Regex = / line (\d+).*script (?:in )?(\S+)(?:: in function (\S+))?$/i;
	    var opera11Regex = / line (\d+), column (\d+)\s*(?:in (?:<anonymous function: ([^>]+)>|([^)]+))\((.*)\))? in (.*):\s*$/i;
	    var lines = stacktrace.split('\n');
	    var stack = [];
	    var parts;
	    for (var line = 0; line < lines.length; line += 2) {
	        var element = null;
	        if ((parts = opera10Regex.exec(lines[line]))) {
	            element = {
	                url: parts[2],
	                func: parts[3],
	                args: [],
	                line: +parts[1],
	                column: null,
	            };
	        }
	        else if ((parts = opera11Regex.exec(lines[line]))) {
	            element = {
	                url: parts[6],
	                func: parts[3] || parts[4],
	                args: parts[5] ? parts[5].split(',') : [],
	                line: +parts[1],
	                column: +parts[2],
	            };
	        }
	        if (element) {
	            if (!element.func && element.line) {
	                element.func = UNKNOWN_FUNCTION;
	            }
	            stack.push(element);
	        }
	    }
	    if (!stack.length) {
	        return null;
	    }
	    return {
	        message: extractMessage(ex),
	        name: ex.name,
	        stack: stack,
	    };
	}
	/** Remove N number of frames from the stack */
	function popFrames(stacktrace, popSize) {
	    try {
	        return tslib_1.__assign(tslib_1.__assign({}, stacktrace), { stack: stacktrace.stack.slice(popSize) });
	    }
	    catch (e) {
	        return stacktrace;
	    }
	}
	/**
	 * There are cases where stacktrace.message is an Event object
	 * https://github.com/getsentry/sentry-javascript/issues/1949
	 * In this specific case we try to extract stacktrace.message.error.message
	 */
	// eslint-disable-next-line @typescript-eslint/no-explicit-any
	function extractMessage(ex) {
	    var message = ex && ex.message;
	    if (!message) {
	        return 'No error message';
	    }
	    if (message.error && typeof message.error.message === 'string') {
	        return message.error.message;
	    }
	    return message;
	}
	//# sourceMappingURL=tracekit.js.map

/***/ }),
/* 57 */
/***/ (function(module, exports, __webpack_require__) {

	Object.defineProperty(exports, "__esModule", { value: true });
	var base_1 = __webpack_require__(58);
	exports.BaseTransport = base_1.BaseTransport;
	var fetch_1 = __webpack_require__(59);
	exports.FetchTransport = fetch_1.FetchTransport;
	var xhr_1 = __webpack_require__(60);
	exports.XHRTransport = xhr_1.XHRTransport;
	//# sourceMappingURL=index.js.map

/***/ }),
/* 58 */
/***/ (function(module, exports, __webpack_require__) {

	Object.defineProperty(exports, "__esModule", { value: true });
	var tslib_1 = __webpack_require__(6);
	var core_1 = __webpack_require__(14);
	var types_1 = __webpack_require__(8);
	var utils_1 = __webpack_require__(18);
	/** Base Transport class implementation */
	var BaseTransport = /** @class */ (function () {
	    function BaseTransport(options) {
	        this.options = options;
	        /** A simple buffer holding all requests. */
	        this._buffer = new utils_1.PromiseBuffer(30);
	        /** Locks transport after receiving rate limits in a response */
	        this._rateLimits = {};
	        this._api = new core_1.API(this.options.dsn);
	        // eslint-disable-next-line deprecation/deprecation
	        this.url = this._api.getStoreEndpointWithUrlEncodedAuth();
	    }
	    /**
	     * @inheritDoc
	     */
	    BaseTransport.prototype.sendEvent = function (_) {
	        throw new utils_1.SentryError('Transport Class has to implement `sendEvent` method');
	    };
	    /**
	     * @inheritDoc
	     */
	    BaseTransport.prototype.close = function (timeout) {
	        return this._buffer.drain(timeout);
	    };
	    /**
	     * Handle Sentry repsonse for promise-based transports.
	     */
	    BaseTransport.prototype._handleResponse = function (_a) {
	        var requestType = _a.requestType, response = _a.response, headers = _a.headers, resolve = _a.resolve, reject = _a.reject;
	        var status = types_1.Status.fromHttpCode(response.status);
	        /**
	         * "The name is case-insensitive."
	         * https://developer.mozilla.org/en-US/docs/Web/API/Headers/get
	         */
	        var limited = this._handleRateLimit(headers);
	        if (limited)
	            utils_1.logger.warn("Too many requests, backing off until: " + this._disabledUntil(requestType));
	        if (status === types_1.Status.Success) {
	            resolve({ status: status });
	            return;
	        }
	        reject(response);
	    };
	    /**
	     * Gets the time that given category is disabled until for rate limiting
	     */
	    BaseTransport.prototype._disabledUntil = function (category) {
	        return this._rateLimits[category] || this._rateLimits.all;
	    };
	    /**
	     * Checks if a category is rate limited
	     */
	    BaseTransport.prototype._isRateLimited = function (category) {
	        return this._disabledUntil(category) > new Date(Date.now());
	    };
	    /**
	     * Sets internal _rateLimits from incoming headers. Returns true if headers contains a non-empty rate limiting header.
	     */
	    BaseTransport.prototype._handleRateLimit = function (headers) {
	        var e_1, _a, e_2, _b;
	        var now = Date.now();
	        var rlHeader = headers['x-sentry-rate-limits'];
	        var raHeader = headers['retry-after'];
	        if (rlHeader) {
	            try {
	                // rate limit headers are of the form
	                //     <header>,<header>,..
	                // where each <header> is of the form
	                //     <retry_after>: <categories>: <scope>: <reason_code>
	                // where
	                //     <retry_after> is a delay in ms
	                //     <categories> is the event type(s) (error, transaction, etc) being rate limited and is of the form
	                //         <category>;<category>;...
	                //     <scope> is what's being limited (org, project, or key) - ignored by SDK
	                //     <reason_code> is an arbitrary string like "org_quota" - ignored by SDK
	                for (var _c = tslib_1.__values(rlHeader.trim().split(',')), _d = _c.next(); !_d.done; _d = _c.next()) {
	                    var limit = _d.value;
	                    var parameters = limit.split(':', 2);
	                    var headerDelay = parseInt(parameters[0], 10);
	                    var delay = (!isNaN(headerDelay) ? headerDelay : 60) * 1000; // 60sec default
	                    try {
	                        for (var _e = (e_2 = void 0, tslib_1.__values(parameters[1].split(';'))), _f = _e.next(); !_f.done; _f = _e.next()) {
	                            var category = _f.value;
	                            this._rateLimits[category || 'all'] = new Date(now + delay);
	                        }
	                    }
	                    catch (e_2_1) { e_2 = { error: e_2_1 }; }
	                    finally {
	                        try {
	                            if (_f && !_f.done && (_b = _e.return)) _b.call(_e);
	                        }
	                        finally { if (e_2) throw e_2.error; }
	                    }
	                }
	            }
	            catch (e_1_1) { e_1 = { error: e_1_1 }; }
	            finally {
	                try {
	                    if (_d && !_d.done && (_a = _c.return)) _a.call(_c);
	                }
	                finally { if (e_1) throw e_1.error; }
	            }
	            return true;
	        }
	        else if (raHeader) {
	            this._rateLimits.all = new Date(now + utils_1.parseRetryAfterHeader(now, raHeader));
	            return true;
	        }
	        return false;
	    };
	    return BaseTransport;
	}());
	exports.BaseTransport = BaseTransport;
	//# sourceMappingURL=base.js.map

/***/ }),
/* 59 */
/***/ (function(module, exports, __webpack_require__) {

	Object.defineProperty(exports, "__esModule", { value: true });
	var tslib_1 = __webpack_require__(6);
	var core_1 = __webpack_require__(14);
	var utils_1 = __webpack_require__(18);
	var base_1 = __webpack_require__(58);
	var global = utils_1.getGlobalObject();
	/** `fetch` based transport */
	var FetchTransport = /** @class */ (function (_super) {
	    tslib_1.__extends(FetchTransport, _super);
	    function FetchTransport() {
	        return _super !== null && _super.apply(this, arguments) || this;
	    }
	    /**
	     * @inheritDoc
	     */
	    FetchTransport.prototype.sendEvent = function (event) {
	        return this._sendRequest(core_1.eventToSentryRequest(event, this._api), event);
	    };
	    /**
	     * @inheritDoc
	     */
	    FetchTransport.prototype.sendSession = function (session) {
	        return this._sendRequest(core_1.sessionToSentryRequest(session, this._api), session);
	    };
	    /**
	     * @param sentryRequest Prepared SentryRequest to be delivered
	     * @param originalPayload Original payload used to create SentryRequest
	     */
	    FetchTransport.prototype._sendRequest = function (sentryRequest, originalPayload) {
	        var _this = this;
	        if (this._isRateLimited(sentryRequest.type)) {
	            return Promise.reject({
	                event: originalPayload,
	                type: sentryRequest.type,
	                reason: "Transport locked till " + this._disabledUntil(sentryRequest.type) + " due to too many requests.",
	                status: 429,
	            });
	        }
	        var options = {
	            body: sentryRequest.body,
	            method: 'POST',
	            // Despite all stars in the sky saying that Edge supports old draft syntax, aka 'never', 'always', 'origin' and 'default
	            // https://caniuse.com/#feat=referrer-policy
	            // It doesn't. And it throw exception instead of ignoring this parameter...
	            // REF: https://github.com/getsentry/raven-js/issues/1233
	            referrerPolicy: (utils_1.supportsReferrerPolicy() ? 'origin' : ''),
	        };
	        if (this.options.fetchParameters !== undefined) {
	            Object.assign(options, this.options.fetchParameters);
	        }
	        if (this.options.headers !== undefined) {
	            options.headers = this.options.headers;
	        }
	        return this._buffer.add(new utils_1.SyncPromise(function (resolve, reject) {
	            global
	                .fetch(sentryRequest.url, options)
	                .then(function (response) {
	                var headers = {
	                    'x-sentry-rate-limits': response.headers.get('X-Sentry-Rate-Limits'),
	                    'retry-after': response.headers.get('Retry-After'),
	                };
	                _this._handleResponse({
	                    requestType: sentryRequest.type,
	                    response: response,
	                    headers: headers,
	                    resolve: resolve,
	                    reject: reject,
	                });
	            })
	                .catch(reject);
	        }));
	    };
	    return FetchTransport;
	}(base_1.BaseTransport));
	exports.FetchTransport = FetchTransport;
	//# sourceMappingURL=fetch.js.map

/***/ }),
/* 60 */
/***/ (function(module, exports, __webpack_require__) {

	Object.defineProperty(exports, "__esModule", { value: true });
	var tslib_1 = __webpack_require__(6);
	var core_1 = __webpack_require__(14);
	var utils_1 = __webpack_require__(18);
	var base_1 = __webpack_require__(58);
	/** `XHR` based transport */
	var XHRTransport = /** @class */ (function (_super) {
	    tslib_1.__extends(XHRTransport, _super);
	    function XHRTransport() {
	        return _super !== null && _super.apply(this, arguments) || this;
	    }
	    /**
	     * @inheritDoc
	     */
	    XHRTransport.prototype.sendEvent = function (event) {
	        return this._sendRequest(core_1.eventToSentryRequest(event, this._api), event);
	    };
	    /**
	     * @inheritDoc
	     */
	    XHRTransport.prototype.sendSession = function (session) {
	        return this._sendRequest(core_1.sessionToSentryRequest(session, this._api), session);
	    };
	    /**
	     * @param sentryRequest Prepared SentryRequest to be delivered
	     * @param originalPayload Original payload used to create SentryRequest
	     */
	    XHRTransport.prototype._sendRequest = function (sentryRequest, originalPayload) {
	        var _this = this;
	        if (this._isRateLimited(sentryRequest.type)) {
	            return Promise.reject({
	                event: originalPayload,
	                type: sentryRequest.type,
	                reason: "Transport locked till " + this._disabledUntil(sentryRequest.type) + " due to too many requests.",
	                status: 429,
	            });
	        }
	        return this._buffer.add(new utils_1.SyncPromise(function (resolve, reject) {
	            var request = new XMLHttpRequest();
	            request.onreadystatechange = function () {
	                if (request.readyState === 4) {
	                    var headers = {
	                        'x-sentry-rate-limits': request.getResponseHeader('X-Sentry-Rate-Limits'),
	                        'retry-after': request.getResponseHeader('Retry-After'),
	                    };
	                    _this._handleResponse({ requestType: sentryRequest.type, response: request, headers: headers, resolve: resolve, reject: reject });
	                }
	            };
	            request.open('POST', sentryRequest.url);
	            for (var header in _this.options.headers) {
	                if (_this.options.headers.hasOwnProperty(header)) {
	                    request.setRequestHeader(header, _this.options.headers[header]);
	                }
	            }
	            request.send(sentryRequest.body);
	        }));
	    };
	    return XHRTransport;
	}(base_1.BaseTransport));
	exports.XHRTransport = XHRTransport;
	//# sourceMappingURL=xhr.js.map

/***/ }),
/* 61 */
/***/ (function(module, exports, __webpack_require__) {

	Object.defineProperty(exports, "__esModule", { value: true });
	var tslib_1 = __webpack_require__(6);
	var core_1 = __webpack_require__(14);
	var utils_1 = __webpack_require__(18);
	var ignoreOnError = 0;
	/**
	 * @hidden
	 */
	function shouldIgnoreOnError() {
	    return ignoreOnError > 0;
	}
	exports.shouldIgnoreOnError = shouldIgnoreOnError;
	/**
	 * @hidden
	 */
	function ignoreNextOnError() {
	    // onerror should trigger before setTimeout
	    ignoreOnError += 1;
	    setTimeout(function () {
	        ignoreOnError -= 1;
	    });
	}
	exports.ignoreNextOnError = ignoreNextOnError;
	/**
	 * Instruments the given function and sends an event to Sentry every time the
	 * function throws an exception.
	 *
	 * @param fn A function to wrap.
	 * @returns The wrapped function.
	 * @hidden
	 */
	function wrap(fn, options, before) {
	    if (options === void 0) { options = {}; }
	    if (typeof fn !== 'function') {
	        return fn;
	    }
	    try {
	        // We don't wanna wrap it twice
	        if (fn.__sentry__) {
	            return fn;
	        }
	        // If this has already been wrapped in the past, return that wrapped function
	        if (fn.__sentry_wrapped__) {
	            return fn.__sentry_wrapped__;
	        }
	    }
	    catch (e) {
	        // Just accessing custom props in some Selenium environments
	        // can cause a "Permission denied" exception (see raven-js#495).
	        // Bail on wrapping and return the function as-is (defers to window.onerror).
	        return fn;
	    }
	    /* eslint-disable prefer-rest-params */
	    // eslint-disable-next-line @typescript-eslint/no-explicit-any
	    var sentryWrapped = function () {
	        var args = Array.prototype.slice.call(arguments);
	        try {
	            if (before && typeof before === 'function') {
	                before.apply(this, arguments);
	            }
	            // eslint-disable-next-line @typescript-eslint/no-explicit-any, @typescript-eslint/no-unsafe-member-access
	            var wrappedArguments = args.map(function (arg) { return wrap(arg, options); });
	            if (fn.handleEvent) {
	                // Attempt to invoke user-land function
	                // NOTE: If you are a Sentry user, and you are seeing this stack frame, it
	                //       means the sentry.javascript SDK caught an error invoking your application code. This
	                //       is expected behavior and NOT indicative of a bug with sentry.javascript.
	                // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
	                return fn.handleEvent.apply(this, wrappedArguments);
	            }
	            // Attempt to invoke user-land function
	            // NOTE: If you are a Sentry user, and you are seeing this stack frame, it
	            //       means the sentry.javascript SDK caught an error invoking your application code. This
	            //       is expected behavior and NOT indicative of a bug with sentry.javascript.
	            return fn.apply(this, wrappedArguments);
	        }
	        catch (ex) {
	            ignoreNextOnError();
	            core_1.withScope(function (scope) {
	                scope.addEventProcessor(function (event) {
	                    var processedEvent = tslib_1.__assign({}, event);
	                    if (options.mechanism) {
	                        utils_1.addExceptionTypeValue(processedEvent, undefined, undefined);
	                        utils_1.addExceptionMechanism(processedEvent, options.mechanism);
	                    }
	                    processedEvent.extra = tslib_1.__assign(tslib_1.__assign({}, processedEvent.extra), { arguments: args });
	                    return processedEvent;
	                });
	                core_1.captureException(ex);
	            });
	            throw ex;
	        }
	    };
	    /* eslint-enable prefer-rest-params */
	    // Accessing some objects may throw
	    // ref: https://github.com/getsentry/sentry-javascript/issues/1168
	    try {
	        for (var property in fn) {
	            if (Object.prototype.hasOwnProperty.call(fn, property)) {
	                sentryWrapped[property] = fn[property];
	            }
	        }
	    }
	    catch (_oO) { } // eslint-disable-line no-empty
	    fn.prototype = fn.prototype || {};
	    sentryWrapped.prototype = fn.prototype;
	    Object.defineProperty(fn, '__sentry_wrapped__', {
	        enumerable: false,
	        value: sentryWrapped,
	    });
	    // Signal that this function has been wrapped/filled already
	    // for both debugging and to prevent it to being wrapped/filled twice
	    Object.defineProperties(sentryWrapped, {
	        __sentry__: {
	            enumerable: false,
	            value: true,
	        },
	        __sentry_original__: {
	            enumerable: false,
	            value: fn,
	        },
	    });
	    // Restore original function name (not all browsers allow that)
	    try {
	        var descriptor = Object.getOwnPropertyDescriptor(sentryWrapped, 'name');
	        if (descriptor.configurable) {
	            Object.defineProperty(sentryWrapped, 'name', {
	                get: function () {
	                    return fn.name;
	                },
	            });
	        }
	        // eslint-disable-next-line no-empty
	    }
	    catch (_oO) { }
	    return sentryWrapped;
	}
	exports.wrap = wrap;
	/**
	 * Injects the Report Dialog script
	 * @hidden
	 */
	function injectReportDialog(options) {
	    if (options === void 0) { options = {}; }
	    if (!options.eventId) {
	        utils_1.logger.error("Missing eventId option in showReportDialog call");
	        return;
	    }
	    if (!options.dsn) {
	        utils_1.logger.error("Missing dsn option in showReportDialog call");
	        return;
	    }
	    var script = document.createElement('script');
	    script.async = true;
	    script.src = new core_1.API(options.dsn).getReportDialogEndpoint(options);
	    if (options.onLoad) {
	        // eslint-disable-next-line @typescript-eslint/unbound-method
	        script.onload = options.onLoad;
	    }
	    (document.head || document.body).appendChild(script);
	}
	exports.injectReportDialog = injectReportDialog;
	//# sourceMappingURL=helpers.js.map

/***/ }),
/* 62 */
/***/ (function(module, exports, __webpack_require__) {

	Object.defineProperty(exports, "__esModule", { value: true });
	var globalhandlers_1 = __webpack_require__(63);
	exports.GlobalHandlers = globalhandlers_1.GlobalHandlers;
	var trycatch_1 = __webpack_require__(64);
	exports.TryCatch = trycatch_1.TryCatch;
	var breadcrumbs_1 = __webpack_require__(65);
	exports.Breadcrumbs = breadcrumbs_1.Breadcrumbs;
	var linkederrors_1 = __webpack_require__(66);
	exports.LinkedErrors = linkederrors_1.LinkedErrors;
	var useragent_1 = __webpack_require__(67);
	exports.UserAgent = useragent_1.UserAgent;
	//# sourceMappingURL=index.js.map

/***/ }),
/* 63 */
/***/ (function(module, exports, __webpack_require__) {

	Object.defineProperty(exports, "__esModule", { value: true });
	var tslib_1 = __webpack_require__(6);
	/* eslint-disable @typescript-eslint/no-unsafe-member-access */
	var core_1 = __webpack_require__(14);
	var types_1 = __webpack_require__(8);
	var utils_1 = __webpack_require__(18);
	var eventbuilder_1 = __webpack_require__(54);
	var helpers_1 = __webpack_require__(61);
	/** Global handlers */
	var GlobalHandlers = /** @class */ (function () {
	    /** JSDoc */
	    function GlobalHandlers(options) {
	        /**
	         * @inheritDoc
	         */
	        this.name = GlobalHandlers.id;
	        /** JSDoc */
	        this._onErrorHandlerInstalled = false;
	        /** JSDoc */
	        this._onUnhandledRejectionHandlerInstalled = false;
	        this._options = tslib_1.__assign({ onerror: true, onunhandledrejection: true }, options);
	    }
	    /**
	     * @inheritDoc
	     */
	    GlobalHandlers.prototype.setupOnce = function () {
	        Error.stackTraceLimit = 50;
	        if (this._options.onerror) {
	            utils_1.logger.log('Global Handler attached: onerror');
	            this._installGlobalOnErrorHandler();
	        }
	        if (this._options.onunhandledrejection) {
	            utils_1.logger.log('Global Handler attached: onunhandledrejection');
	            this._installGlobalOnUnhandledRejectionHandler();
	        }
	    };
	    /** JSDoc */
	    GlobalHandlers.prototype._installGlobalOnErrorHandler = function () {
	        var _this = this;
	        if (this._onErrorHandlerInstalled) {
	            return;
	        }
	        utils_1.addInstrumentationHandler({
	            // eslint-disable-next-line @typescript-eslint/no-explicit-any
	            callback: function (data) {
	                var error = data.error;
	                var currentHub = core_1.getCurrentHub();
	                var hasIntegration = currentHub.getIntegration(GlobalHandlers);
	                var isFailedOwnDelivery = error && error.__sentry_own_request__ === true;
	                if (!hasIntegration || helpers_1.shouldIgnoreOnError() || isFailedOwnDelivery) {
	                    return;
	                }
	                var client = currentHub.getClient();
	                var event = utils_1.isPrimitive(error)
	                    ? _this._eventFromIncompleteOnError(data.msg, data.url, data.line, data.column)
	                    : _this._enhanceEventWithInitialFrame(eventbuilder_1.eventFromUnknownInput(error, undefined, {
	                        attachStacktrace: client && client.getOptions().attachStacktrace,
	                        rejection: false,
	                    }), data.url, data.line, data.column);
	                utils_1.addExceptionMechanism(event, {
	                    handled: false,
	                    type: 'onerror',
	                });
	                currentHub.captureEvent(event, {
	                    originalException: error,
	                });
	            },
	            type: 'error',
	        });
	        this._onErrorHandlerInstalled = true;
	    };
	    /** JSDoc */
	    GlobalHandlers.prototype._installGlobalOnUnhandledRejectionHandler = function () {
	        var _this = this;
	        if (this._onUnhandledRejectionHandlerInstalled) {
	            return;
	        }
	        utils_1.addInstrumentationHandler({
	            // eslint-disable-next-line @typescript-eslint/no-explicit-any
	            callback: function (e) {
	                var error = e;
	                // dig the object of the rejection out of known event types
	                try {
	                    // PromiseRejectionEvents store the object of the rejection under 'reason'
	                    // see https://developer.mozilla.org/en-US/docs/Web/API/PromiseRejectionEvent
	                    if ('reason' in e) {
	                        error = e.reason;
	                    }
	                    // something, somewhere, (likely a browser extension) effectively casts PromiseRejectionEvents
	                    // to CustomEvents, moving the `promise` and `reason` attributes of the PRE into
	                    // the CustomEvent's `detail` attribute, since they're not part of CustomEvent's spec
	                    // see https://developer.mozilla.org/en-US/docs/Web/API/CustomEvent and
	                    // https://github.com/getsentry/sentry-javascript/issues/2380
	                    else if ('detail' in e && 'reason' in e.detail) {
	                        error = e.detail.reason;
	                    }
	                }
	                catch (_oO) {
	                    // no-empty
	                }
	                var currentHub = core_1.getCurrentHub();
	                var hasIntegration = currentHub.getIntegration(GlobalHandlers);
	                var isFailedOwnDelivery = error && error.__sentry_own_request__ === true;
	                if (!hasIntegration || helpers_1.shouldIgnoreOnError() || isFailedOwnDelivery) {
	                    return true;
	                }
	                var client = currentHub.getClient();
	                var event = utils_1.isPrimitive(error)
	                    ? _this._eventFromRejectionWithPrimitive(error)
	                    : eventbuilder_1.eventFromUnknownInput(error, undefined, {
	                        attachStacktrace: client && client.getOptions().attachStacktrace,
	                        rejection: true,
	                    });
	                event.level = types_1.Severity.Error;
	                utils_1.addExceptionMechanism(event, {
	                    handled: false,
	                    type: 'onunhandledrejection',
	                });
	                currentHub.captureEvent(event, {
	                    originalException: error,
	                });
	                return;
	            },
	            type: 'unhandledrejection',
	        });
	        this._onUnhandledRejectionHandlerInstalled = true;
	    };
	    /**
	     * This function creates a stack from an old, error-less onerror handler.
	     */
	    // eslint-disable-next-line @typescript-eslint/no-explicit-any
	    GlobalHandlers.prototype._eventFromIncompleteOnError = function (msg, url, line, column) {
	        var ERROR_TYPES_RE = /^(?:[Uu]ncaught (?:exception: )?)?(?:((?:Eval|Internal|Range|Reference|Syntax|Type|URI|)Error): )?(.*)$/i;
	        // If 'message' is ErrorEvent, get real message from inside
	        var message = utils_1.isErrorEvent(msg) ? msg.message : msg;
	        var name;
	        if (utils_1.isString(message)) {
	            var groups = message.match(ERROR_TYPES_RE);
	            if (groups) {
	                name = groups[1];
	                message = groups[2];
	            }
	        }
	        var event = {
	            exception: {
	                values: [
	                    {
	                        type: name || 'Error',
	                        value: message,
	                    },
	                ],
	            },
	        };
	        return this._enhanceEventWithInitialFrame(event, url, line, column);
	    };
	    /**
	     * Create an event from a promise rejection where the `reason` is a primitive.
	     *
	     * @param reason: The `reason` property of the promise rejection
	     * @returns An Event object with an appropriate `exception` value
	     */
	    GlobalHandlers.prototype._eventFromRejectionWithPrimitive = function (reason) {
	        return {
	            exception: {
	                values: [
	                    {
	                        type: 'UnhandledRejection',
	                        // String() is needed because the Primitive type includes symbols (which can't be automatically stringified)
	                        value: "Non-Error promise rejection captured with value: " + String(reason),
	                    },
	                ],
	            },
	        };
	    };
	    /** JSDoc */
	    // eslint-disable-next-line @typescript-eslint/no-explicit-any
	    GlobalHandlers.prototype._enhanceEventWithInitialFrame = function (event, url, line, column) {
	        event.exception = event.exception || {};
	        event.exception.values = event.exception.values || [];
	        event.exception.values[0] = event.exception.values[0] || {};
	        event.exception.values[0].stacktrace = event.exception.values[0].stacktrace || {};
	        event.exception.values[0].stacktrace.frames = event.exception.values[0].stacktrace.frames || [];
	        var colno = isNaN(parseInt(column, 10)) ? undefined : column;
	        var lineno = isNaN(parseInt(line, 10)) ? undefined : line;
	        var filename = utils_1.isString(url) && url.length > 0 ? url : utils_1.getLocationHref();
	        if (event.exception.values[0].stacktrace.frames.length === 0) {
	            event.exception.values[0].stacktrace.frames.push({
	                colno: colno,
	                filename: filename,
	                function: '?',
	                in_app: true,
	                lineno: lineno,
	            });
	        }
	        return event;
	    };
	    /**
	     * @inheritDoc
	     */
	    GlobalHandlers.id = 'GlobalHandlers';
	    return GlobalHandlers;
	}());
	exports.GlobalHandlers = GlobalHandlers;
	//# sourceMappingURL=globalhandlers.js.map

/***/ }),
/* 64 */
/***/ (function(module, exports, __webpack_require__) {

	Object.defineProperty(exports, "__esModule", { value: true });
	var tslib_1 = __webpack_require__(6);
	var utils_1 = __webpack_require__(18);
	var helpers_1 = __webpack_require__(61);
	var DEFAULT_EVENT_TARGET = [
	    'EventTarget',
	    'Window',
	    'Node',
	    'ApplicationCache',
	    'AudioTrackList',
	    'ChannelMergerNode',
	    'CryptoOperation',
	    'EventSource',
	    'FileReader',
	    'HTMLUnknownElement',
	    'IDBDatabase',
	    'IDBRequest',
	    'IDBTransaction',
	    'KeyOperation',
	    'MediaController',
	    'MessagePort',
	    'ModalWindow',
	    'Notification',
	    'SVGElementInstance',
	    'Screen',
	    'TextTrack',
	    'TextTrackCue',
	    'TextTrackList',
	    'WebSocket',
	    'WebSocketWorker',
	    'Worker',
	    'XMLHttpRequest',
	    'XMLHttpRequestEventTarget',
	    'XMLHttpRequestUpload',
	];
	/** Wrap timer functions and event targets to catch errors and provide better meta data */
	var TryCatch = /** @class */ (function () {
	    /**
	     * @inheritDoc
	     */
	    function TryCatch(options) {
	        /**
	         * @inheritDoc
	         */
	        this.name = TryCatch.id;
	        this._options = tslib_1.__assign({ XMLHttpRequest: true, eventTarget: true, requestAnimationFrame: true, setInterval: true, setTimeout: true }, options);
	    }
	    /**
	     * Wrap timer functions and event targets to catch errors
	     * and provide better metadata.
	     */
	    TryCatch.prototype.setupOnce = function () {
	        var global = utils_1.getGlobalObject();
	        if (this._options.setTimeout) {
	            utils_1.fill(global, 'setTimeout', this._wrapTimeFunction.bind(this));
	        }
	        if (this._options.setInterval) {
	            utils_1.fill(global, 'setInterval', this._wrapTimeFunction.bind(this));
	        }
	        if (this._options.requestAnimationFrame) {
	            utils_1.fill(global, 'requestAnimationFrame', this._wrapRAF.bind(this));
	        }
	        if (this._options.XMLHttpRequest && 'XMLHttpRequest' in global) {
	            utils_1.fill(XMLHttpRequest.prototype, 'send', this._wrapXHR.bind(this));
	        }
	        if (this._options.eventTarget) {
	            var eventTarget = Array.isArray(this._options.eventTarget) ? this._options.eventTarget : DEFAULT_EVENT_TARGET;
	            eventTarget.forEach(this._wrapEventTarget.bind(this));
	        }
	    };
	    /** JSDoc */
	    TryCatch.prototype._wrapTimeFunction = function (original) {
	        // eslint-disable-next-line @typescript-eslint/no-explicit-any
	        return function () {
	            var args = [];
	            for (var _i = 0; _i < arguments.length; _i++) {
	                args[_i] = arguments[_i];
	            }
	            var originalCallback = args[0];
	            args[0] = helpers_1.wrap(originalCallback, {
	                mechanism: {
	                    data: { function: utils_1.getFunctionName(original) },
	                    handled: true,
	                    type: 'instrument',
	                },
	            });
	            return original.apply(this, args);
	        };
	    };
	    /** JSDoc */
	    // eslint-disable-next-line @typescript-eslint/no-explicit-any
	    TryCatch.prototype._wrapRAF = function (original) {
	        // eslint-disable-next-line @typescript-eslint/no-explicit-any
	        return function (callback) {
	            // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
	            return original.call(this, helpers_1.wrap(callback, {
	                mechanism: {
	                    data: {
	                        function: 'requestAnimationFrame',
	                        handler: utils_1.getFunctionName(original),
	                    },
	                    handled: true,
	                    type: 'instrument',
	                },
	            }));
	        };
	    };
	    /** JSDoc */
	    TryCatch.prototype._wrapEventTarget = function (target) {
	        // eslint-disable-next-line @typescript-eslint/no-explicit-any
	        var global = utils_1.getGlobalObject();
	        // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
	        var proto = global[target] && global[target].prototype;
	        // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
	        if (!proto || !proto.hasOwnProperty || !proto.hasOwnProperty('addEventListener')) {
	            return;
	        }
	        utils_1.fill(proto, 'addEventListener', function (original) {
	            return function (eventName, fn, options) {
	                try {
	                    if (typeof fn.handleEvent === 'function') {
	                        fn.handleEvent = helpers_1.wrap(fn.handleEvent.bind(fn), {
	                            mechanism: {
	                                data: {
	                                    function: 'handleEvent',
	                                    handler: utils_1.getFunctionName(fn),
	                                    target: target,
	                                },
	                                handled: true,
	                                type: 'instrument',
	                            },
	                        });
	                    }
	                }
	                catch (err) {
	                    // can sometimes get 'Permission denied to access property "handle Event'
	                }
	                return original.call(this, eventName, 
	                // eslint-disable-next-line @typescript-eslint/no-explicit-any
	                helpers_1.wrap(fn, {
	                    mechanism: {
	                        data: {
	                            function: 'addEventListener',
	                            handler: utils_1.getFunctionName(fn),
	                            target: target,
	                        },
	                        handled: true,
	                        type: 'instrument',
	                    },
	                }), options);
	            };
	        });
	        utils_1.fill(proto, 'removeEventListener', function (originalRemoveEventListener) {
	            return function (eventName, fn, options) {
	                var _a;
	                /**
	                 * There are 2 possible scenarios here:
	                 *
	                 * 1. Someone passes a callback, which was attached prior to Sentry initialization, or by using unmodified
	                 * method, eg. `document.addEventListener.call(el, name, handler). In this case, we treat this function
	                 * as a pass-through, and call original `removeEventListener` with it.
	                 *
	                 * 2. Someone passes a callback, which was attached after Sentry was initialized, which means that it was using
	                 * our wrapped version of `addEventListener`, which internally calls `wrap` helper.
	                 * This helper "wraps" whole callback inside a try/catch statement, and attached appropriate metadata to it,
	                 * in order for us to make a distinction between wrapped/non-wrapped functions possible.
	                 * If a function was wrapped, it has additional property of `__sentry_wrapped__`, holding the handler.
	                 *
	                 * When someone adds a handler prior to initialization, and then do it again, but after,
	                 * then we have to detach both of them. Otherwise, if we'd detach only wrapped one, it'd be impossible
	                 * to get rid of the initial handler and it'd stick there forever.
	                 */
	                var wrappedEventHandler = fn;
	                try {
	                    var originalEventHandler = (_a = wrappedEventHandler) === null || _a === void 0 ? void 0 : _a.__sentry_wrapped__;
	                    if (originalEventHandler) {
	                        originalRemoveEventListener.call(this, eventName, originalEventHandler, options);
	                    }
	                }
	                catch (e) {
	                    // ignore, accessing __sentry_wrapped__ will throw in some Selenium environments
	                }
	                return originalRemoveEventListener.call(this, eventName, wrappedEventHandler, options);
	            };
	        });
	    };
	    /** JSDoc */
	    TryCatch.prototype._wrapXHR = function (originalSend) {
	        // eslint-disable-next-line @typescript-eslint/no-explicit-any
	        return function () {
	            var args = [];
	            for (var _i = 0; _i < arguments.length; _i++) {
	                args[_i] = arguments[_i];
	            }
	            // eslint-disable-next-line @typescript-eslint/no-this-alias
	            var xhr = this;
	            var xmlHttpRequestProps = ['onload', 'onerror', 'onprogress', 'onreadystatechange'];
	            xmlHttpRequestProps.forEach(function (prop) {
	                if (prop in xhr && typeof xhr[prop] === 'function') {
	                    // eslint-disable-next-line @typescript-eslint/no-explicit-any
	                    utils_1.fill(xhr, prop, function (original) {
	                        var wrapOptions = {
	                            mechanism: {
	                                data: {
	                                    function: prop,
	                                    handler: utils_1.getFunctionName(original),
	                                },
	                                handled: true,
	                                type: 'instrument',
	                            },
	                        };
	                        // If Instrument integration has been called before TryCatch, get the name of original function
	                        if (original.__sentry_original__) {
	                            wrapOptions.mechanism.data.handler = utils_1.getFunctionName(original.__sentry_original__);
	                        }
	                        // Otherwise wrap directly
	                        return helpers_1.wrap(original, wrapOptions);
	                    });
	                }
	            });
	            return originalSend.apply(this, args);
	        };
	    };
	    /**
	     * @inheritDoc
	     */
	    TryCatch.id = 'TryCatch';
	    return TryCatch;
	}());
	exports.TryCatch = TryCatch;
	//# sourceMappingURL=trycatch.js.map

/***/ }),
/* 65 */
/***/ (function(module, exports, __webpack_require__) {

	Object.defineProperty(exports, "__esModule", { value: true });
	var tslib_1 = __webpack_require__(6);
	/* eslint-disable @typescript-eslint/no-unsafe-member-access */
	/* eslint-disable max-lines */
	var core_1 = __webpack_require__(14);
	var types_1 = __webpack_require__(8);
	var utils_1 = __webpack_require__(18);
	/**
	 * Default Breadcrumbs instrumentations
	 * TODO: Deprecated - with v6, this will be renamed to `Instrument`
	 */
	var Breadcrumbs = /** @class */ (function () {
	    /**
	     * @inheritDoc
	     */
	    function Breadcrumbs(options) {
	        /**
	         * @inheritDoc
	         */
	        this.name = Breadcrumbs.id;
	        this._options = tslib_1.__assign({ console: true, dom: true, fetch: true, history: true, sentry: true, xhr: true }, options);
	    }
	    /**
	     * Create a breadcrumb of `sentry` from the events themselves
	     */
	    Breadcrumbs.prototype.addSentryBreadcrumb = function (event) {
	        if (!this._options.sentry) {
	            return;
	        }
	        core_1.getCurrentHub().addBreadcrumb({
	            category: "sentry." + (event.type === 'transaction' ? 'transaction' : 'event'),
	            event_id: event.event_id,
	            level: event.level,
	            message: utils_1.getEventDescription(event),
	        }, {
	            event: event,
	        });
	    };
	    /**
	     * Instrument browser built-ins w/ breadcrumb capturing
	     *  - Console API
	     *  - DOM API (click/typing)
	     *  - XMLHttpRequest API
	     *  - Fetch API
	     *  - History API
	     */
	    Breadcrumbs.prototype.setupOnce = function () {
	        var _this = this;
	        if (this._options.console) {
	            utils_1.addInstrumentationHandler({
	                callback: function () {
	                    var args = [];
	                    for (var _i = 0; _i < arguments.length; _i++) {
	                        args[_i] = arguments[_i];
	                    }
	                    _this._consoleBreadcrumb.apply(_this, tslib_1.__spread(args));
	                },
	                type: 'console',
	            });
	        }
	        if (this._options.dom) {
	            utils_1.addInstrumentationHandler({
	                callback: function () {
	                    var args = [];
	                    for (var _i = 0; _i < arguments.length; _i++) {
	                        args[_i] = arguments[_i];
	                    }
	                    _this._domBreadcrumb.apply(_this, tslib_1.__spread(args));
	                },
	                type: 'dom',
	            });
	        }
	        if (this._options.xhr) {
	            utils_1.addInstrumentationHandler({
	                callback: function () {
	                    var args = [];
	                    for (var _i = 0; _i < arguments.length; _i++) {
	                        args[_i] = arguments[_i];
	                    }
	                    _this._xhrBreadcrumb.apply(_this, tslib_1.__spread(args));
	                },
	                type: 'xhr',
	            });
	        }
	        if (this._options.fetch) {
	            utils_1.addInstrumentationHandler({
	                callback: function () {
	                    var args = [];
	                    for (var _i = 0; _i < arguments.length; _i++) {
	                        args[_i] = arguments[_i];
	                    }
	                    _this._fetchBreadcrumb.apply(_this, tslib_1.__spread(args));
	                },
	                type: 'fetch',
	            });
	        }
	        if (this._options.history) {
	            utils_1.addInstrumentationHandler({
	                callback: function () {
	                    var args = [];
	                    for (var _i = 0; _i < arguments.length; _i++) {
	                        args[_i] = arguments[_i];
	                    }
	                    _this._historyBreadcrumb.apply(_this, tslib_1.__spread(args));
	                },
	                type: 'history',
	            });
	        }
	    };
	    /**
	     * Creates breadcrumbs from console API calls
	     */
	    // eslint-disable-next-line @typescript-eslint/no-explicit-any
	    Breadcrumbs.prototype._consoleBreadcrumb = function (handlerData) {
	        var breadcrumb = {
	            category: 'console',
	            data: {
	                arguments: handlerData.args,
	                logger: 'console',
	            },
	            level: types_1.Severity.fromString(handlerData.level),
	            message: utils_1.safeJoin(handlerData.args, ' '),
	        };
	        if (handlerData.level === 'assert') {
	            if (handlerData.args[0] === false) {
	                breadcrumb.message = "Assertion failed: " + (utils_1.safeJoin(handlerData.args.slice(1), ' ') || 'console.assert');
	                breadcrumb.data.arguments = handlerData.args.slice(1);
	            }
	            else {
	                // Don't capture a breadcrumb for passed assertions
	                return;
	            }
	        }
	        core_1.getCurrentHub().addBreadcrumb(breadcrumb, {
	            input: handlerData.args,
	            level: handlerData.level,
	        });
	    };
	    /**
	     * Creates breadcrumbs from DOM API calls
	     */
	    // eslint-disable-next-line @typescript-eslint/no-explicit-any
	    Breadcrumbs.prototype._domBreadcrumb = function (handlerData) {
	        var target;
	        // Accessing event.target can throw (see getsentry/raven-js#838, #768)
	        try {
	            target = handlerData.event.target
	                ? utils_1.htmlTreeAsString(handlerData.event.target)
	                : utils_1.htmlTreeAsString(handlerData.event);
	        }
	        catch (e) {
	            target = '<unknown>';
	        }
	        if (target.length === 0) {
	            return;
	        }
	        core_1.getCurrentHub().addBreadcrumb({
	            category: "ui." + handlerData.name,
	            message: target,
	        }, {
	            event: handlerData.event,
	            name: handlerData.name,
	        });
	    };
	    /**
	     * Creates breadcrumbs from XHR API calls
	     */
	    // eslint-disable-next-line @typescript-eslint/no-explicit-any
	    Breadcrumbs.prototype._xhrBreadcrumb = function (handlerData) {
	        if (handlerData.endTimestamp) {
	            // We only capture complete, non-sentry requests
	            if (handlerData.xhr.__sentry_own_request__) {
	                return;
	            }
	            var _a = handlerData.xhr.__sentry_xhr__ || {}, method = _a.method, url = _a.url, status_code = _a.status_code, body = _a.body;
	            core_1.getCurrentHub().addBreadcrumb({
	                category: 'xhr',
	                data: {
	                    method: method,
	                    url: url,
	                    status_code: status_code,
	                },
	                type: 'http',
	            }, {
	                xhr: handlerData.xhr,
	                input: body,
	            });
	            return;
	        }
	    };
	    /**
	     * Creates breadcrumbs from fetch API calls
	     */
	    // eslint-disable-next-line @typescript-eslint/no-explicit-any
	    Breadcrumbs.prototype._fetchBreadcrumb = function (handlerData) {
	        // We only capture complete fetch requests
	        if (!handlerData.endTimestamp) {
	            return;
	        }
	        if (handlerData.fetchData.url.match(/sentry_key/) && handlerData.fetchData.method === 'POST') {
	            // We will not create breadcrumbs for fetch requests that contain `sentry_key` (internal sentry requests)
	            return;
	        }
	        if (handlerData.error) {
	            core_1.getCurrentHub().addBreadcrumb({
	                category: 'fetch',
	                data: handlerData.fetchData,
	                level: types_1.Severity.Error,
	                type: 'http',
	            }, {
	                data: handlerData.error,
	                input: handlerData.args,
	            });
	        }
	        else {
	            core_1.getCurrentHub().addBreadcrumb({
	                category: 'fetch',
	                data: tslib_1.__assign(tslib_1.__assign({}, handlerData.fetchData), { status_code: handlerData.response.status }),
	                type: 'http',
	            }, {
	                input: handlerData.args,
	                response: handlerData.response,
	            });
	        }
	    };
	    /**
	     * Creates breadcrumbs from history API calls
	     */
	    // eslint-disable-next-line @typescript-eslint/no-explicit-any
	    Breadcrumbs.prototype._historyBreadcrumb = function (handlerData) {
	        var global = utils_1.getGlobalObject();
	        var from = handlerData.from;
	        var to = handlerData.to;
	        var parsedLoc = utils_1.parseUrl(global.location.href);
	        var parsedFrom = utils_1.parseUrl(from);
	        var parsedTo = utils_1.parseUrl(to);
	        // Initial pushState doesn't provide `from` information
	        if (!parsedFrom.path) {
	            parsedFrom = parsedLoc;
	        }
	        // Use only the path component of the URL if the URL matches the current
	        // document (almost all the time when using pushState)
	        if (parsedLoc.protocol === parsedTo.protocol && parsedLoc.host === parsedTo.host) {
	            to = parsedTo.relative;
	        }
	        if (parsedLoc.protocol === parsedFrom.protocol && parsedLoc.host === parsedFrom.host) {
	            from = parsedFrom.relative;
	        }
	        core_1.getCurrentHub().addBreadcrumb({
	            category: 'navigation',
	            data: {
	                from: from,
	                to: to,
	            },
	        });
	    };
	    /**
	     * @inheritDoc
	     */
	    Breadcrumbs.id = 'Breadcrumbs';
	    return Breadcrumbs;
	}());
	exports.Breadcrumbs = Breadcrumbs;
	//# sourceMappingURL=breadcrumbs.js.map

/***/ }),
/* 66 */
/***/ (function(module, exports, __webpack_require__) {

	Object.defineProperty(exports, "__esModule", { value: true });
	var tslib_1 = __webpack_require__(6);
	var core_1 = __webpack_require__(14);
	var utils_1 = __webpack_require__(18);
	var parsers_1 = __webpack_require__(55);
	var tracekit_1 = __webpack_require__(56);
	var DEFAULT_KEY = 'cause';
	var DEFAULT_LIMIT = 5;
	/** Adds SDK info to an event. */
	var LinkedErrors = /** @class */ (function () {
	    /**
	     * @inheritDoc
	     */
	    function LinkedErrors(options) {
	        if (options === void 0) { options = {}; }
	        /**
	         * @inheritDoc
	         */
	        this.name = LinkedErrors.id;
	        this._key = options.key || DEFAULT_KEY;
	        this._limit = options.limit || DEFAULT_LIMIT;
	    }
	    /**
	     * @inheritDoc
	     */
	    LinkedErrors.prototype.setupOnce = function () {
	        core_1.addGlobalEventProcessor(function (event, hint) {
	            var self = core_1.getCurrentHub().getIntegration(LinkedErrors);
	            if (self) {
	                return self._handler(event, hint);
	            }
	            return event;
	        });
	    };
	    /**
	     * @inheritDoc
	     */
	    LinkedErrors.prototype._handler = function (event, hint) {
	        if (!event.exception || !event.exception.values || !hint || !utils_1.isInstanceOf(hint.originalException, Error)) {
	            return event;
	        }
	        var linkedErrors = this._walkErrorTree(hint.originalException, this._key);
	        event.exception.values = tslib_1.__spread(linkedErrors, event.exception.values);
	        return event;
	    };
	    /**
	     * @inheritDoc
	     */
	    LinkedErrors.prototype._walkErrorTree = function (error, key, stack) {
	        if (stack === void 0) { stack = []; }
	        if (!utils_1.isInstanceOf(error[key], Error) || stack.length + 1 >= this._limit) {
	            return stack;
	        }
	        var stacktrace = tracekit_1.computeStackTrace(error[key]);
	        var exception = parsers_1.exceptionFromStacktrace(stacktrace);
	        return this._walkErrorTree(error[key], key, tslib_1.__spread([exception], stack));
	    };
	    /**
	     * @inheritDoc
	     */
	    LinkedErrors.id = 'LinkedErrors';
	    return LinkedErrors;
	}());
	exports.LinkedErrors = LinkedErrors;
	//# sourceMappingURL=linkederrors.js.map

/***/ }),
/* 67 */
/***/ (function(module, exports, __webpack_require__) {

	Object.defineProperty(exports, "__esModule", { value: true });
	var tslib_1 = __webpack_require__(6);
	var core_1 = __webpack_require__(14);
	var utils_1 = __webpack_require__(18);
	var global = utils_1.getGlobalObject();
	/** UserAgent */
	var UserAgent = /** @class */ (function () {
	    function UserAgent() {
	        /**
	         * @inheritDoc
	         */
	        this.name = UserAgent.id;
	    }
	    /**
	     * @inheritDoc
	     */
	    UserAgent.prototype.setupOnce = function () {
	        core_1.addGlobalEventProcessor(function (event) {
	            var _a, _b, _c;
	            if (core_1.getCurrentHub().getIntegration(UserAgent)) {
	                // if none of the information we want exists, don't bother
	                if (!global.navigator && !global.location && !global.document) {
	                    return event;
	                }
	                // grab as much info as exists and add it to the event
	                var url = ((_a = event.request) === null || _a === void 0 ? void 0 : _a.url) || ((_b = global.location) === null || _b === void 0 ? void 0 : _b.href);
	                var referrer = (global.document || {}).referrer;
	                var userAgent = (global.navigator || {}).userAgent;
	                var headers = tslib_1.__assign(tslib_1.__assign(tslib_1.__assign({}, (_c = event.request) === null || _c === void 0 ? void 0 : _c.headers), (referrer && { Referer: referrer })), (userAgent && { 'User-Agent': userAgent }));
	                var request = tslib_1.__assign(tslib_1.__assign({}, (url && { url: url })), { headers: headers });
	                return tslib_1.__assign(tslib_1.__assign({}, event), { request: request });
	            }
	            return event;
	        });
	    };
	    /**
	     * @inheritDoc
	     */
	    UserAgent.id = 'UserAgent';
	    return UserAgent;
	}());
	exports.UserAgent = UserAgent;
	//# sourceMappingURL=useragent.js.map

/***/ }),
/* 68 */
/***/ (function(module, exports) {

	Object.defineProperty(exports, "__esModule", { value: true });
	exports.SDK_NAME = 'sentry.javascript.browser';
	exports.SDK_VERSION = '5.30.0';
	//# sourceMappingURL=version.js.map

/***/ }),
/* 69 */
/***/ (function(module, exports, __webpack_require__) {

	Object.defineProperty(exports, "__esModule", { value: true });
	var core_1 = __webpack_require__(14);
	var utils_1 = __webpack_require__(18);
	var client_1 = __webpack_require__(52);
	var helpers_1 = __webpack_require__(61);
	var integrations_1 = __webpack_require__(62);
	exports.defaultIntegrations = [
	    new core_1.Integrations.InboundFilters(),
	    new core_1.Integrations.FunctionToString(),
	    new integrations_1.TryCatch(),
	    new integrations_1.Breadcrumbs(),
	    new integrations_1.GlobalHandlers(),
	    new integrations_1.LinkedErrors(),
	    new integrations_1.UserAgent(),
	];
	/**
	 * The Sentry Browser SDK Client.
	 *
	 * To use this SDK, call the {@link init} function as early as possible when
	 * loading the web page. To set context information or send manual events, use
	 * the provided methods.
	 *
	 * @example
	 *
	 * ```
	 *
	 * import { init } from '@sentry/browser';
	 *
	 * init({
	 *   dsn: '__DSN__',
	 *   // ...
	 * });
	 * ```
	 *
	 * @example
	 * ```
	 *
	 * import { configureScope } from '@sentry/browser';
	 * configureScope((scope: Scope) => {
	 *   scope.setExtra({ battery: 0.7 });
	 *   scope.setTag({ user_mode: 'admin' });
	 *   scope.setUser({ id: '4711' });
	 * });
	 * ```
	 *
	 * @example
	 * ```
	 *
	 * import { addBreadcrumb } from '@sentry/browser';
	 * addBreadcrumb({
	 *   message: 'My Breadcrumb',
	 *   // ...
	 * });
	 * ```
	 *
	 * @example
	 *
	 * ```
	 *
	 * import * as Sentry from '@sentry/browser';
	 * Sentry.captureMessage('Hello, world!');
	 * Sentry.captureException(new Error('Good bye'));
	 * Sentry.captureEvent({
	 *   message: 'Manual',
	 *   stacktrace: [
	 *     // ...
	 *   ],
	 * });
	 * ```
	 *
	 * @see {@link BrowserOptions} for documentation on configuration options.
	 */
	function init(options) {
	    if (options === void 0) { options = {}; }
	    if (options.defaultIntegrations === undefined) {
	        options.defaultIntegrations = exports.defaultIntegrations;
	    }
	    if (options.release === undefined) {
	        var window_1 = utils_1.getGlobalObject();
	        // This supports the variable that sentry-webpack-plugin injects
	        if (window_1.SENTRY_RELEASE && window_1.SENTRY_RELEASE.id) {
	            options.release = window_1.SENTRY_RELEASE.id;
	        }
	    }
	    if (options.autoSessionTracking === undefined) {
	        options.autoSessionTracking = false;
	    }
	    core_1.initAndBind(client_1.BrowserClient, options);
	    if (options.autoSessionTracking) {
	        startSessionTracking();
	    }
	}
	exports.init = init;
	/**
	 * Present the user with a report dialog.
	 *
	 * @param options Everything is optional, we try to fetch all info need from the global scope.
	 */
	function showReportDialog(options) {
	    if (options === void 0) { options = {}; }
	    if (!options.eventId) {
	        options.eventId = core_1.getCurrentHub().lastEventId();
	    }
	    var client = core_1.getCurrentHub().getClient();
	    if (client) {
	        client.showReportDialog(options);
	    }
	}
	exports.showReportDialog = showReportDialog;
	/**
	 * This is the getter for lastEventId.
	 *
	 * @returns The last event id of a captured event.
	 */
	function lastEventId() {
	    return core_1.getCurrentHub().lastEventId();
	}
	exports.lastEventId = lastEventId;
	/**
	 * This function is here to be API compatible with the loader.
	 * @hidden
	 */
	function forceLoad() {
	    // Noop
	}
	exports.forceLoad = forceLoad;
	/**
	 * This function is here to be API compatible with the loader.
	 * @hidden
	 */
	function onLoad(callback) {
	    callback();
	}
	exports.onLoad = onLoad;
	/**
	 * A promise that resolves when all current events have been sent.
	 * If you provide a timeout and the queue takes longer to drain the promise returns false.
	 *
	 * @param timeout Maximum time in ms the client should wait.
	 */
	function flush(timeout) {
	    var client = core_1.getCurrentHub().getClient();
	    if (client) {
	        return client.flush(timeout);
	    }
	    return utils_1.SyncPromise.reject(false);
	}
	exports.flush = flush;
	/**
	 * A promise that resolves when all current events have been sent.
	 * If you provide a timeout and the queue takes longer to drain the promise returns false.
	 *
	 * @param timeout Maximum time in ms the client should wait.
	 */
	function close(timeout) {
	    var client = core_1.getCurrentHub().getClient();
	    if (client) {
	        return client.close(timeout);
	    }
	    return utils_1.SyncPromise.reject(false);
	}
	exports.close = close;
	/**
	 * Wrap code within a try/catch block so the SDK is able to capture errors.
	 *
	 * @param fn A function to wrap.
	 *
	 * @returns The result of wrapped function call.
	 */
	// eslint-disable-next-line @typescript-eslint/no-explicit-any
	function wrap(fn) {
	    return helpers_1.wrap(fn)();
	}
	exports.wrap = wrap;
	/**
	 * Enable automatic Session Tracking for the initial page load.
	 */
	function startSessionTracking() {
	    var window = utils_1.getGlobalObject();
	    var hub = core_1.getCurrentHub();
	    /**
	     * We should be using `Promise.all([windowLoaded, firstContentfulPaint])` here,
	     * but, as always, it's not available in the IE10-11. Thanks IE.
	     */
	    var loadResolved = document.readyState === 'complete';
	    var fcpResolved = false;
	    var possiblyEndSession = function () {
	        if (fcpResolved && loadResolved) {
	            hub.endSession();
	        }
	    };
	    var resolveWindowLoaded = function () {
	        loadResolved = true;
	        possiblyEndSession();
	        window.removeEventListener('load', resolveWindowLoaded);
	    };
	    hub.startSession();
	    if (!loadResolved) {
	        // IE doesn't support `{ once: true }` for event listeners, so we have to manually
	        // attach and then detach it once completed.
	        window.addEventListener('load', resolveWindowLoaded);
	    }
	    try {
	        var po = new PerformanceObserver(function (entryList, po) {
	            entryList.getEntries().forEach(function (entry) {
	                if (entry.name === 'first-contentful-paint' && entry.startTime < firstHiddenTime_1) {
	                    po.disconnect();
	                    fcpResolved = true;
	                    possiblyEndSession();
	                }
	            });
	        });
	        // There's no need to even attach this listener if `PerformanceObserver` constructor will fail,
	        // so we do it below here.
	        var firstHiddenTime_1 = document.visibilityState === 'hidden' ? 0 : Infinity;
	        document.addEventListener('visibilitychange', function (event) {
	            firstHiddenTime_1 = Math.min(firstHiddenTime_1, event.timeStamp);
	        }, { once: true });
	        po.observe({
	            type: 'paint',
	            buffered: true,
	        });
	    }
	    catch (e) {
	        fcpResolved = true;
	        possiblyEndSession();
	    }
	}
	//# sourceMappingURL=sdk.js.map

/***/ }),
/* 70 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function($) {'use strict';
	
	var _tingle = __webpack_require__(71);
	
	var _tingle2 = _interopRequireDefault(_tingle);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	$(function () {
	
	    // initialize modal
	    var form_modal = new _tingle2.default.modal({
	        cssClass: ['form-modal'],
	        onClose: function onClose() {
	            // remove class from html
	            document.querySelector('html').classList.remove('form-modal-visible');
	            // trigger class
	            $(window).trigger('form-modal:closed');
	            // if the softpage is still open in the brackground, we have to keep the overlay, otherwise we can close it
	            if ($('.tingle-modal.softpage').hasClass('tingle-modal--visible')) {
	                // tingle removes the class from the body, so let's re-add it
	                document.querySelector('body').classList.add('tingle-enabled');
	            } else {
	                $(window).trigger('hideSiteOverlay');
	            }
	        },
	        onOpen: function onOpen() {
	            // trigger custom events
	            $(window).trigger('form-modal:opened');
	            $(window).trigger('initFormModalClose');
	        },
	        closeMethods: ['button']
	    });
	
	    // modify tingle markup on page load (while the modal is hidden)
	    setTimeout(function () {
	        // relocate close button
	        var $form_modal = $('.tingle-modal.form-modal');
	        var close_btn = $form_modal.find('.tingle-modal__close').get(0);
	        var modal_content = $form_modal.find('.tingle-modal-box').get(0);
	        modal_content.appendChild(close_btn);
	    }, 500);
	
	    // click handler
	    function openFormModal(element, event) {
	        // init
	        event.preventDefault();
	
	        // in case we opened a form modal from within a softpage, we need to hide the softpage
	        document.querySelector('html').classList.add('form-modal-visible');
	        // document.querySelector('.softpage').classList.remove('tingle-modal--visible');
	
	        // get and set content
	        var url = element.getAttribute('href');
	
	        $.get(url, function (data) {
	            // set modal content and open
	            form_modal.setContent(data);
	            form_modal.open();
	            // scroll to top everytime a modal is opened
	            form_modal.modal.scrollTop = 0;
	        });
	    }
	
	    function onSubmit() {
	        // init
	        var $form = $('.ajax-form');
	        // timout to make sure the recaptcha is set
	        var recaptcha_token = '';
	        recaptcha_token = grecaptcha.getResponse();
	
	        // get token
	        // checkif form is valid
	        if ($form.valid() && recaptcha_token.length > 0) {
	            // get token
	            // add token to form
	            // // submit form
	            $form.find(".btn").addClass("btn-blocked");
	            $form.submit();
	            // reset recaptcha
	        } else {
	            console.log("form not valid");
	        }
	    }
	
	    function initFormModalTrigger() {
	        // init all trigger links and loop
	        $('.toggle-form-modal:not([data-softpage-disabled]),[data-trigger-form-modal]:not([data-softpage-disabled])').each(function (i) {
	            var $recaptcha = $('.g-recaptcha');
	            if ($recaptcha.length > 0) {
	                $.getScript('https://www.google.com/recaptcha/api.js', function () {
	                    grecaptcha.render($recaptcha.get(0), {
	                        'sitekey': $recaptcha.data('sitekey'),
	                        'callback': onSubmit
	                    });
	                });
	            }
	            // stop multiple event listeners on the same element by adding an initialized attribute that we can check the next time we call this function
	            // init
	            var $trigger = $(this);
	            var initialized_attr = 'data-trigger-initialized';
	            // check for initialized trigger
	            var trigger_initialized = $trigger.attr(initialized_attr);
	            // NOT initialized yet
	            if (typeof trigger_initialized === 'undefined') {
	                $trigger.on('click', function (event) {
	                    // instantly toggle site overlay (improves "felt performance")
	                    $(window).trigger('showSiteOverlay');
	                    // load softpage
	                    event.preventDefault();
	                    openFormModal(this, event);
	                });
	                // mark as initialized
	                $trigger.attr(initialized_attr, '');
	            }
	        });
	    }
	
	    // on page load
	    initFormModalTrigger();
	
	    // custom event
	    $(window).on('initFormModalTrigger softpage:opened form-modal:opened', function () {
	        initFormModalTrigger();
	    });
	
	    function initFormModalClose() {
	        // look for triggers
	        if (document.querySelector('.close-form-modal,[data-close-form-modal]')) {
	            var close_form_modal = document.querySelector('.close-form-modal,[data-close-form-modal]');
	            close_form_modal.addEventListener('click', function (event) {
	                event.preventDefault();
	                form_modal.close();
	            });
	        }
	    }
	
	    // custom event
	    $(window).on('initFormModalClose', function () {
	        initFormModalClose();
	    });
	}); /* * * * * * * * * * * * * * * * * * * * * * * * * * * * * *
	    
	    Link with class '.toggle-form-modal' will trigger the form lightbox
	    
	    Custom Events:
	    
	    form-modal:opened
	    form-modal:closed
	    
	    */
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(2)))

/***/ }),
/* 71 */
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_RESULT__;!function(t,o){ true?!(__WEBPACK_AMD_DEFINE_FACTORY__ = (o), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.call(exports, __webpack_require__, exports, module)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__)):"object"==typeof exports?module.exports=o():t.tingle=o()}(this,function(){function t(t){var o={onClose:null,onOpen:null,beforeClose:null,stickyFooter:!1,footer:!1,cssClass:[],closeLabel:"Close",closeMethods:["overlay","button","escape"]};this.opts=h({},o,t),this.init()}function o(){this.modal.classList.contains("tingle-modal--visible")&&(this.isOverflow()?this.modal.classList.add("tingle-modal--overflow"):this.modal.classList.remove("tingle-modal--overflow"),!this.isOverflow()&&this.opts.stickyFooter?this.setStickyFooter(!1):this.isOverflow()&&this.opts.stickyFooter&&(e.call(this),this.setStickyFooter(!0)))}function e(){this.modalBoxFooter&&(this.modalBoxFooter.style.width=this.modalBox.clientWidth+"px",this.modalBoxFooter.style.left=this.modalBox.offsetLeft+"px")}function s(){this.modal=document.createElement("div"),this.modal.classList.add("tingle-modal"),0!==this.opts.closeMethods.length&&this.opts.closeMethods.indexOf("overlay")!==-1||this.modal.classList.add("tingle-modal--noOverlayClose"),this.modal.style.display="none",this.opts.cssClass.forEach(function(t){"string"==typeof t&&this.modal.classList.add(t)},this),this.opts.closeMethods.indexOf("button")!==-1&&(this.modalCloseBtn=document.createElement("button"),this.modalCloseBtn.classList.add("tingle-modal__close"),this.modalCloseBtnIcon=document.createElement("span"),this.modalCloseBtnIcon.classList.add("tingle-modal__closeIcon"),this.modalCloseBtnIcon.innerHTML="×",this.modalCloseBtnLabel=document.createElement("span"),this.modalCloseBtnLabel.classList.add("tingle-modal__closeLabel"),this.modalCloseBtnLabel.innerHTML=this.opts.closeLabel,this.modalCloseBtn.appendChild(this.modalCloseBtnIcon),this.modalCloseBtn.appendChild(this.modalCloseBtnLabel)),this.modalBox=document.createElement("div"),this.modalBox.classList.add("tingle-modal-box"),this.modalBoxContent=document.createElement("div"),this.modalBoxContent.classList.add("tingle-modal-box__content"),this.modalBox.appendChild(this.modalBoxContent),this.opts.closeMethods.indexOf("button")!==-1&&this.modal.appendChild(this.modalCloseBtn),this.modal.appendChild(this.modalBox)}function i(){this.modalBoxFooter=document.createElement("div"),this.modalBoxFooter.classList.add("tingle-modal-box__footer"),this.modalBox.appendChild(this.modalBoxFooter)}function n(){this._events={clickCloseBtn:this.close.bind(this),clickOverlay:d.bind(this),resize:o.bind(this),keyboardNav:l.bind(this)},this.opts.closeMethods.indexOf("button")!==-1&&this.modalCloseBtn.addEventListener("click",this._events.clickCloseBtn),this.modal.addEventListener("mousedown",this._events.clickOverlay),window.addEventListener("resize",this._events.resize),document.addEventListener("keydown",this._events.keyboardNav)}function l(t){this.opts.closeMethods.indexOf("escape")!==-1&&27===t.which&&this.isOpen()&&this.close()}function d(t){this.opts.closeMethods.indexOf("overlay")!==-1&&!a(t.target,"tingle-modal")&&t.clientX<this.modal.clientWidth&&this.close()}function a(t,o){for(;(t=t.parentElement)&&!t.classList.contains(o););return t}function r(){this.opts.closeMethods.indexOf("button")!==-1&&this.modalCloseBtn.removeEventListener("click",this._events.clickCloseBtn),this.modal.removeEventListener("mousedown",this._events.clickOverlay),window.removeEventListener("resize",this._events.resize),document.removeEventListener("keydown",this._events.keyboardNav)}function h(){for(var t=1;t<arguments.length;t++)for(var o in arguments[t])arguments[t].hasOwnProperty(o)&&(arguments[0][o]=arguments[t][o]);return arguments[0]}function c(){var t,o=document.createElement("tingle-test-transition"),e={transition:"transitionend",OTransition:"oTransitionEnd",MozTransition:"transitionend",WebkitTransition:"webkitTransitionEnd"};for(t in e)if(void 0!==o.style[t])return e[t]}var m=c();return t.prototype.init=function(){this.modal||(s.call(this),n.call(this),document.body.insertBefore(this.modal,document.body.firstChild),this.opts.footer&&this.addFooter())},t.prototype.destroy=function(){null!==this.modal&&(r.call(this),this.modal.parentNode.removeChild(this.modal),this.modal=null)},t.prototype.open=function(){this.modal.style.removeProperty?this.modal.style.removeProperty("display"):this.modal.style.removeAttribute("display"),document.body.classList.add("tingle-enabled"),this.setStickyFooter(this.opts.stickyFooter),this.modal.classList.add("tingle-modal--visible");var t=this;m?this.modal.addEventListener(m,function o(){"function"==typeof t.opts.onOpen&&t.opts.onOpen.call(t),t.modal.removeEventListener(m,o,!1)},!1):"function"==typeof t.opts.onOpen&&t.opts.onOpen.call(t),o.call(this)},t.prototype.isOpen=function(){return!!this.modal.classList.contains("tingle-modal--visible")},t.prototype.close=function(){if("function"==typeof this.opts.beforeClose){var t=this.opts.beforeClose.call(this);if(!t)return}document.body.classList.remove("tingle-enabled"),this.modal.classList.remove("tingle-modal--visible");var o=this;m?this.modal.addEventListener(m,function t(){o.modal.removeEventListener(m,t,!1),o.modal.style.display="none","function"==typeof o.opts.onClose&&o.opts.onClose.call(this)},!1):(o.modal.style.display="none","function"==typeof o.opts.onClose&&o.opts.onClose.call(this))},t.prototype.setContent=function(t){"string"==typeof t?this.modalBoxContent.innerHTML=t:(this.modalBoxContent.innerHTML="",this.modalBoxContent.appendChild(t))},t.prototype.getContent=function(){return this.modalBoxContent},t.prototype.addFooter=function(){i.call(this)},t.prototype.setFooterContent=function(t){this.modalBoxFooter.innerHTML=t},t.prototype.getFooterContent=function(){return this.modalBoxFooter},t.prototype.setStickyFooter=function(t){this.isOverflow()||(t=!1),t?this.modalBox.contains(this.modalBoxFooter)&&(this.modalBox.removeChild(this.modalBoxFooter),this.modal.appendChild(this.modalBoxFooter),this.modalBoxFooter.classList.add("tingle-modal-box__footer--sticky"),e.call(this),this.modalBoxContent.style["padding-bottom"]=this.modalBoxFooter.clientHeight+20+"px"):this.modalBoxFooter&&(this.modalBox.contains(this.modalBoxFooter)||(this.modal.removeChild(this.modalBoxFooter),this.modalBox.appendChild(this.modalBoxFooter),this.modalBoxFooter.style.width="auto",this.modalBoxFooter.style.left="",this.modalBoxContent.style["padding-bottom"]="",this.modalBoxFooter.classList.remove("tingle-modal-box__footer--sticky")))},t.prototype.addFooterBtn=function(t,o,e){var s=document.createElement("button");return s.innerHTML=t,s.addEventListener("click",e),"string"==typeof o&&o.length&&o.split(" ").forEach(function(t){s.classList.add(t)}),this.modalBoxFooter.appendChild(s),s},t.prototype.resize=function(){console.warn("Resize is deprecated and will be removed in version 1.0")},t.prototype.isOverflow=function(){var t=window.innerHeight,o=this.modalBox.clientHeight;return o>=t},{modal:t}});

/***/ }),
/* 72 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function($) {'use strict';
	
	var _ajaxLoadItems = __webpack_require__(73);
	
	var _masonry = __webpack_require__(74);
	
	$(function () {
	
	    var options = {
	        ajax_load_transition_duration: 100
	    };
	
	    // init modules
	    (0, _ajaxLoadItems.initAjaxLoadItemsTrigger)(options);
	    (0, _masonry.initMasonry)(options);
	
	    // re-init when softpage has been opened
	    $(window).on('softpage:opened', function () {
	        (0, _ajaxLoadItems.initAjaxLoadItemsTrigger)(options);
	        (0, _masonry.initMasonry)(options);
	
	        console.log(options);
	        $('.schedule-table').each(function (key, val) {
	            var $val = $(val);
	            var $inner = $val.find('.inner');
	            var initHeight = $inner.height();
	            if ($val.height() > 500) {
	                $val.addClass('cover');
	                $inner.height(500);
	                $val.find('.show-more-button a').click(function (event) {
	                    event.preventDefault();
	                    $inner.height(initHeight);
	                    $val.addClass('show-full');
	                });
	            } else {
	                $val.addClass('show-full');
	            }
	        });
	    });
	});
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(2)))

/***/ }),
/* 73 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function($) {'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.initAjaxLoadItemsTrigger = initAjaxLoadItemsTrigger;
	exports.loadAjaxItems = loadAjaxItems;
	/* * * * * * * * * * * * * * * * * * * * * * * * * * * * * *
	
	Loading items using AJAX
	
	Supported functionality:
	
	- Replacing all items (use case: switching category)
	- Appending items (use case: load more)
	
	To make the "Load Items" functionality work, it REQUIRES the following elements:
	
	<!-- Section container -->
	<div class="content-section app-content-plugin">
	    <!-- Categories -->
	    <ul class="app-content-categories">
	        <li>
	            <a class="ajax-load-items" href="{{AJAX_URL}}">Category 1</a>
	        </li>
	        <li>
	            <a class="ajax-load-items" href="{{AJAX_URL}}">Category 2</a>
	        </li>
	    </ul>
	    <!-- The actual container where the items are to be exchanged, or appended to -->
	    <div class="ajax-items-container">
	        ...
	    </div>
	    <!-- Load More Button -->
	    <div class="load-more-container">
	        <a href="{{ next_page_url }}" class="ajax-load-items append">
	            Load More
	        </a>
	    </div>
	</div>
	
	*/
	
	/* * * * * * * * * * * * * * * * * * * * * * * * * * * * * *
	
	Initialize the app content filter and listen for the change event
	
	Next, determine the active category and call the `loadAjaxItems` function
	as simulation it was the trigger. 2 in 1!
	
	*/
	
	function initAjaxFilter(options) {
	    // find and loop through filter containers
	    $('.filter-container').each(function () {
	        var $filter_container = $(this);
	        var $plugin_container = $(this).parents('.app-content-plugin');
	        // find all selects and loop
	        $(this).find('select').each(function () {
	            // when a filter (select) is changed:
	            $(this).change(function (e) {
	                // combined with categories?
	                var $category_container = $plugin_container.find('.app-content-categories');
	                if ($category_container.length > 0) {
	                    var $active_category = $category_container.find('.active a');
	                    loadAjaxItems($active_category, options);
	                }
	                // only filters: in this case, our filter-container is the trigger
	                else {
	                        loadAjaxItems($filter_container, options);
	                    }
	            });
	        });
	    });
	}
	
	/* * * * * * * * * * * * * * * * * * * * * * * * * * * * * *
	
	Function that appends the filters values (= selected options) to the active category
	
	*/
	
	function appendFilterToURL(ajax_url, $filter_container) {
	    $filter_container.find('select').each(function () {
	        var selected_value = $(this).find('option:selected').val();
	        if (selected_value) {
	            // determine field name
	            var field_name = $(this).attr('name');
	            //
	            ajax_url += '&' + field_name + '=' + selected_value;
	        }
	    });
	    return ajax_url;
	}
	
	/* * * * * * * * * * * * * * * * * * * * * * * * * * * * * *
	
	Function that searches for elements
	
	*/
	
	function initAjaxLoadItemsTrigger(options) {
	
	    // initialize options
	    var options = options || {};
	
	    // find links and load items
	    $('.ajax-load-items').each(function () {
	        // init
	        var $trigger = $(this);
	        var initialized_attr = 'data-trigger-initialized';
	        // check for initialized trigger
	        var trigger_initialized = $trigger.attr(initialized_attr);
	
	        // NOT initialized yet
	        if (typeof trigger_initialized === 'undefined') {
	            // add event listener
	            $trigger.on('click', function (e) {
	                // init
	                var $trigger = $(this);
	                // let me handle this ;)
	                e.preventDefault();
	                // special case 1: adios, when clicking on a category that is already active.
	                if ($trigger.parent('li').hasClass('active')) {
	                    return false;
	                }
	                // special case 2: the dynamic grid (masonry.js) handles appending items by itself
	                if ($trigger.parents('.grid_dynamic-template').length > 0) {
	                    return false;
	                }
	                // default
	                else {
	                        loadAjaxItems($trigger, options);
	                    }
	            });
	            // mark as initialized
	            $trigger.attr(initialized_attr, '');
	        }
	    });
	
	    // init the filter switch
	    initAjaxFilter(options);
	}
	
	/* * * * * * * * * * * * * * * * * * * * * * * * * * * * * *
	
	Function that loads the new or appended items
	
	@param $trigger: The clicked link (either 'load more' or a 'category' in the category navigation)
	@param (optional) masonry_grid: Vanilla JS Node item of the masonry grid
	@param (optional) masonry_instance: Masonry Instance
	
	*/
	
	function loadAjaxItems($trigger, options, masonry_grid, masonry_instance) {
	
	    // initialize options
	    var options = options || {};
	
	    // init
	    var masonry_grid = masonry_grid || null,
	        masonry_instance = masonry_instance || null,
	        ajax_url = $trigger.attr('href'),
	        ajax_filter_base_url = $trigger.attr('data-ajax-filter-base-url'),
	        $plugin_container = $trigger.parents('.app-content-plugin'),
	        $filter_container = $plugin_container.find('.filter-container'),
	        $items_container = $plugin_container.find('.ajax-items-container'),
	        $category_container = $trigger.parents('.app-content-categories'),
	        $load_more_container = $plugin_container.find('.load-more-container'),
	        $load_more_btn = $load_more_container.find('.btn-load-more'),
	        category_active_class = 'active',
	        loading_class = 'loading',
	        append = false,
	        transtion_duration = options.ajax_load_transition_duration || 100; // has to be equal SCSS variable $load-more-swop-category-transition-duration
	
	    // Per default, we replace all items. But if an additional class '.append' is set on the trigger element, we obviously append items (load more)
	    if ($trigger.hasClass('append')) {
	        append = true;
	    } else {
	        $items_container.addClass(loading_class);
	        $load_more_container.addClass(loading_class);
	    }
	
	    // are we browsing through the categories? if so, set active state
	    if ($category_container.length > 0) {
	        // remove all active classes
	        $category_container.find('li').removeClass(category_active_class);
	        // set active class on clicked element
	        $trigger.parents('li').addClass(category_active_class);
	    }
	
	    // with disabled categories we don't get a href, which mean we get a base url from the filter-container
	    if (typeof ajax_url === 'undefined') {
	        ajax_url = ajax_filter_base_url;
	    }
	
	    // append filter values to URL
	    ajax_url = appendFilterToURL(ajax_url, $filter_container);
	
	    $.ajax({
	        type: 'GET',
	        url: ajax_url,
	        contentType: 'application/json',
	        success: function success(data, textStatus, jqXHR) {
	
	            // init
	            var final_transition_duration = 0;
	
	            // duration of CSS transition when EXCHANGING the content
	            if (append === false) {
	                final_transition_duration = transtion_duration;
	            }
	
	            // depending on the CSS transition settings, do stuff with or without delay
	            setTimeout(function () {
	
	                // temporary quick and dirty fix: toggle class on plugin container if the response contains the string 'no-results-container'
	                if (jqXHR.status === 206) {
	                    $plugin_container.addClass('no-results');
	                } else {
	                    $plugin_container.removeClass('no-results');
	                }
	
	                // masonry grid: requires different appending technique
	                if (masonry_instance !== null) {
	                    getRenderedContent(masonry_grid, masonry_instance, data.rendered_content, append);
	                }
	                // default
	                else {
	                        // append
	                        if (append === true) {
	                            $items_container.append(data.rendered_content);
	                        }
	                        // exchange entire content
	                        else {
	                                $items_container.html(data.rendered_content);
	                            }
	                    }
	
	                // load more button: hide if there are no further pages
	                if (!data.next_page_url || data.next_page_url === null) {
	                    $load_more_container.hide();
	                }
	                // load more buton: modify the link and make sure the button is shown
	                else {
	                        $load_more_container.show();
	                        $load_more_btn.attr('href', data.next_page_url);
	                    }
	
	                // trigger custom events
	                $(window).trigger('initSoftpageTrigger');
	                $(window).trigger('btnAjaxLoaderDone');
	                $(window).trigger('ajaxLoadItems:success');
	                // reveals next section in case there are no results when filtering
	                $(window).trigger('initOnScreen');
	
	                // remove loading class
	                $items_container.removeClass(loading_class);
	                $load_more_container.removeClass(loading_class);
	            }, final_transition_duration);
	        },
	        error: function error(xhr, status, _error) {
	            var err = "(" + xhr.responseText + ")";
	            $(window).trigger('ajaxLoadItems:error');
	        }
	    });
	}
	
	/* * * * * * * * * * * * * * * * * * * * * * * * * * * * * *
	
	Masonry (Grid Dynamic) exchanging/appending items
	
	@param masonry_grid: Vanilla JS Node item of the masonry grid
	@param masonry_instance: Masonry Instance
	@param rendered_content: Items markup as a STRING
	@param append: Boolean value, if we should append or exchange items
	
	*/
	
	function getRenderedContent(masonry_grid, masonry_instance, rendered_content, append) {
	
	    // init
	    var grid_items_array = [];
	    var i = 0;
	    var fragment = document.createDocumentFragment();
	
	    // create and fill tempoary container with our items markup
	    var tmp_container = document.createElement('div');
	    tmp_container.innerHTML = rendered_content;
	    var tmp_grid_items = tmp_container.children;
	
	    // fill our items array with the just created items
	    var _iteratorNormalCompletion = true;
	    var _didIteratorError = false;
	    var _iteratorError = undefined;
	
	    try {
	        for (var _iterator = tmp_grid_items[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
	            var item = _step.value;
	
	            grid_items_array.push(item);
	        }
	
	        // add this markup to our fragment
	    } catch (err) {
	        _didIteratorError = true;
	        _iteratorError = err;
	    } finally {
	        try {
	            if (!_iteratorNormalCompletion && _iterator.return) {
	                _iterator.return();
	            }
	        } finally {
	            if (_didIteratorError) {
	                throw _iteratorError;
	            }
	        }
	    }
	
	    fragment.appendChild(tmp_container);
	
	    // exchange items: remove all existing items first
	    if (append === false) {
	        var items_to_be_removed = masonry_grid.querySelectorAll('.grid-item');
	        for (i = 0; i < items_to_be_removed.length; i++) {
	            items_to_be_removed[i].remove();
	        }
	    }
	
	    // append items
	    masonry_grid.appendChild(fragment);
	    masonry_instance.appended(grid_items_array);
	
	    // Required delay: Redraw grid and re-calculate height
	    setTimeout(function () {
	        masonry_instance.layout();
	    }, 10);
	};
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(2)))

/***/ }),
/* 74 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function($) {'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.initMasonry = initMasonry;
	
	var _masonryLayout = __webpack_require__(75);
	
	var _masonryLayout2 = _interopRequireDefault(_masonryLayout);
	
	var _helperFunctions = __webpack_require__(82);
	
	var _ajaxLoadItems = __webpack_require__(73);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function initMasonry(options) {
	
	    // initialize options
	    var options = options || {};
	
	    // initialize grid
	    if (document.querySelector('.grid-dynamic-container')) {
	        var grids_on_page = document.querySelectorAll('.grid-dynamic-container');
	
	        var MasonryImagesReveal = function MasonryImagesReveal(masonry, items) {
	            var itemSelector = masonry.options.itemSelector;
	
	            var displayItem = function displayItem(index, items) {
	                if (items.length <= index) {
	                    return;
	                }
	
	                var item = items[index];
	
	                masonry.element.appendChild(item);
	                masonry.appended(item);
	                displayItem(index + 1, items);
	            };
	
	            displayItem(0, items);
	
	            return this;
	        };
	
	        for (var i = 0, len = grids_on_page.length; i < len; i++) {
	
	            // init
	            var masonry_grid = grids_on_page[i].querySelector('.the-grid');
	            var $content_section = $(masonry_grid).parents('.content-section');
	
	            // instanciate grid
	            var masonry_instance = new _masonryLayout2.default(masonry_grid, {
	                columnWidth: '.grid-sizer',
	                percentagePosition: true,
	                transitionDuration: '0'
	            });
	
	            // handle AJAX requests (usually done with ajax-load-items.js, but masonry is a bit trickier so we handle it separately)
	            $content_section.find('.ajax-load-items').on('click', function (e) {
	
	                // init
	                var $trigger = $(this);
	                e.preventDefault();
	
	                // Do AJAX stuff
	                (0, _ajaxLoadItems.loadAjaxItems)($trigger, options, masonry_grid, masonry_instance);
	            });
	
	            // reveal Masonry Images
	            new MasonryImagesReveal(masonry_instance, grids_on_page[i].querySelectorAll('.grid-items .grid-item'));
	        }
	    }
	}
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(2)))

/***/ }),
/* 75 */
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/*!
	 * Masonry v4.2.2
	 * Cascading grid layout library
	 * https://masonry.desandro.com
	 * MIT License
	 * by David DeSandro
	 */
	
	( function( window, factory ) {
	  // universal module definition
	  /* jshint strict: false */ /*globals define, module, require */
	  if ( true ) {
	    // AMD
	    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [
	        __webpack_require__(76),
	        __webpack_require__(78)
	      ], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	  } else if ( typeof module == 'object' && module.exports ) {
	    // CommonJS
	    module.exports = factory(
	      require('outlayer'),
	      require('get-size')
	    );
	  } else {
	    // browser global
	    window.Masonry = factory(
	      window.Outlayer,
	      window.getSize
	    );
	  }
	
	}( window, function factory( Outlayer, getSize ) {
	
	'use strict';
	
	// -------------------------- masonryDefinition -------------------------- //
	
	  // create an Outlayer layout class
	  var Masonry = Outlayer.create('masonry');
	  // isFitWidth -> fitWidth
	  Masonry.compatOptions.fitWidth = 'isFitWidth';
	
	  var proto = Masonry.prototype;
	
	  proto._resetLayout = function() {
	    this.getSize();
	    this._getMeasurement( 'columnWidth', 'outerWidth' );
	    this._getMeasurement( 'gutter', 'outerWidth' );
	    this.measureColumns();
	
	    // reset column Y
	    this.colYs = [];
	    for ( var i=0; i < this.cols; i++ ) {
	      this.colYs.push( 0 );
	    }
	
	    this.maxY = 0;
	    this.horizontalColIndex = 0;
	  };
	
	  proto.measureColumns = function() {
	    this.getContainerWidth();
	    // if columnWidth is 0, default to outerWidth of first item
	    if ( !this.columnWidth ) {
	      var firstItem = this.items[0];
	      var firstItemElem = firstItem && firstItem.element;
	      // columnWidth fall back to item of first element
	      this.columnWidth = firstItemElem && getSize( firstItemElem ).outerWidth ||
	        // if first elem has no width, default to size of container
	        this.containerWidth;
	    }
	
	    var columnWidth = this.columnWidth += this.gutter;
	
	    // calculate columns
	    var containerWidth = this.containerWidth + this.gutter;
	    var cols = containerWidth / columnWidth;
	    // fix rounding errors, typically with gutters
	    var excess = columnWidth - containerWidth % columnWidth;
	    // if overshoot is less than a pixel, round up, otherwise floor it
	    var mathMethod = excess && excess < 1 ? 'round' : 'floor';
	    cols = Math[ mathMethod ]( cols );
	    this.cols = Math.max( cols, 1 );
	  };
	
	  proto.getContainerWidth = function() {
	    // container is parent if fit width
	    var isFitWidth = this._getOption('fitWidth');
	    var container = isFitWidth ? this.element.parentNode : this.element;
	    // check that this.size and size are there
	    // IE8 triggers resize on body size change, so they might not be
	    var size = getSize( container );
	    this.containerWidth = size && size.innerWidth;
	  };
	
	  proto._getItemLayoutPosition = function( item ) {
	    item.getSize();
	    // how many columns does this brick span
	    var remainder = item.size.outerWidth % this.columnWidth;
	    var mathMethod = remainder && remainder < 1 ? 'round' : 'ceil';
	    // round if off by 1 pixel, otherwise use ceil
	    var colSpan = Math[ mathMethod ]( item.size.outerWidth / this.columnWidth );
	    colSpan = Math.min( colSpan, this.cols );
	    // use horizontal or top column position
	    var colPosMethod = this.options.horizontalOrder ?
	      '_getHorizontalColPosition' : '_getTopColPosition';
	    var colPosition = this[ colPosMethod ]( colSpan, item );
	    // position the brick
	    var position = {
	      x: this.columnWidth * colPosition.col,
	      y: colPosition.y
	    };
	    // apply setHeight to necessary columns
	    var setHeight = colPosition.y + item.size.outerHeight;
	    var setMax = colSpan + colPosition.col;
	    for ( var i = colPosition.col; i < setMax; i++ ) {
	      this.colYs[i] = setHeight;
	    }
	
	    return position;
	  };
	
	  proto._getTopColPosition = function( colSpan ) {
	    var colGroup = this._getTopColGroup( colSpan );
	    // get the minimum Y value from the columns
	    var minimumY = Math.min.apply( Math, colGroup );
	
	    return {
	      col: colGroup.indexOf( minimumY ),
	      y: minimumY,
	    };
	  };
	
	  /**
	   * @param {Number} colSpan - number of columns the element spans
	   * @returns {Array} colGroup
	   */
	  proto._getTopColGroup = function( colSpan ) {
	    if ( colSpan < 2 ) {
	      // if brick spans only one column, use all the column Ys
	      return this.colYs;
	    }
	
	    var colGroup = [];
	    // how many different places could this brick fit horizontally
	    var groupCount = this.cols + 1 - colSpan;
	    // for each group potential horizontal position
	    for ( var i = 0; i < groupCount; i++ ) {
	      colGroup[i] = this._getColGroupY( i, colSpan );
	    }
	    return colGroup;
	  };
	
	  proto._getColGroupY = function( col, colSpan ) {
	    if ( colSpan < 2 ) {
	      return this.colYs[ col ];
	    }
	    // make an array of colY values for that one group
	    var groupColYs = this.colYs.slice( col, col + colSpan );
	    // and get the max value of the array
	    return Math.max.apply( Math, groupColYs );
	  };
	
	  // get column position based on horizontal index. #873
	  proto._getHorizontalColPosition = function( colSpan, item ) {
	    var col = this.horizontalColIndex % this.cols;
	    var isOver = colSpan > 1 && col + colSpan > this.cols;
	    // shift to next row if item can't fit on current row
	    col = isOver ? 0 : col;
	    // don't let zero-size items take up space
	    var hasSize = item.size.outerWidth && item.size.outerHeight;
	    this.horizontalColIndex = hasSize ? col + colSpan : this.horizontalColIndex;
	
	    return {
	      col: col,
	      y: this._getColGroupY( col, colSpan ),
	    };
	  };
	
	  proto._manageStamp = function( stamp ) {
	    var stampSize = getSize( stamp );
	    var offset = this._getElementOffset( stamp );
	    // get the columns that this stamp affects
	    var isOriginLeft = this._getOption('originLeft');
	    var firstX = isOriginLeft ? offset.left : offset.right;
	    var lastX = firstX + stampSize.outerWidth;
	    var firstCol = Math.floor( firstX / this.columnWidth );
	    firstCol = Math.max( 0, firstCol );
	    var lastCol = Math.floor( lastX / this.columnWidth );
	    // lastCol should not go over if multiple of columnWidth #425
	    lastCol -= lastX % this.columnWidth ? 0 : 1;
	    lastCol = Math.min( this.cols - 1, lastCol );
	    // set colYs to bottom of the stamp
	
	    var isOriginTop = this._getOption('originTop');
	    var stampMaxY = ( isOriginTop ? offset.top : offset.bottom ) +
	      stampSize.outerHeight;
	    for ( var i = firstCol; i <= lastCol; i++ ) {
	      this.colYs[i] = Math.max( stampMaxY, this.colYs[i] );
	    }
	  };
	
	  proto._getContainerSize = function() {
	    this.maxY = Math.max.apply( Math, this.colYs );
	    var size = {
	      height: this.maxY
	    };
	
	    if ( this._getOption('fitWidth') ) {
	      size.width = this._getContainerFitWidth();
	    }
	
	    return size;
	  };
	
	  proto._getContainerFitWidth = function() {
	    var unusedCols = 0;
	    // count unused columns
	    var i = this.cols;
	    while ( --i ) {
	      if ( this.colYs[i] !== 0 ) {
	        break;
	      }
	      unusedCols++;
	    }
	    // fit container to columns that have been used
	    return ( this.cols - unusedCols ) * this.columnWidth - this.gutter;
	  };
	
	  proto.needsResizeLayout = function() {
	    var previousWidth = this.containerWidth;
	    this.getContainerWidth();
	    return previousWidth != this.containerWidth;
	  };
	
	  return Masonry;
	
	}));


/***/ }),
/* 76 */
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/*!
	 * Outlayer v2.1.1
	 * the brains and guts of a layout library
	 * MIT license
	 */
	
	( function( window, factory ) {
	  'use strict';
	  // universal module definition
	  /* jshint strict: false */ /* globals define, module, require */
	  if ( true ) {
	    // AMD - RequireJS
	    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [
	        __webpack_require__(77),
	        __webpack_require__(78),
	        __webpack_require__(79),
	        __webpack_require__(81)
	      ], __WEBPACK_AMD_DEFINE_RESULT__ = function( EvEmitter, getSize, utils, Item ) {
	        return factory( window, EvEmitter, getSize, utils, Item);
	      }.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	  } else if ( typeof module == 'object' && module.exports ) {
	    // CommonJS - Browserify, Webpack
	    module.exports = factory(
	      window,
	      require('ev-emitter'),
	      require('get-size'),
	      require('fizzy-ui-utils'),
	      require('./item')
	    );
	  } else {
	    // browser global
	    window.Outlayer = factory(
	      window,
	      window.EvEmitter,
	      window.getSize,
	      window.fizzyUIUtils,
	      window.Outlayer.Item
	    );
	  }
	
	}( window, function factory( window, EvEmitter, getSize, utils, Item ) {
	'use strict';
	
	// ----- vars ----- //
	
	var console = window.console;
	var jQuery = window.jQuery;
	var noop = function() {};
	
	// -------------------------- Outlayer -------------------------- //
	
	// globally unique identifiers
	var GUID = 0;
	// internal store of all Outlayer intances
	var instances = {};
	
	
	/**
	 * @param {Element, String} element
	 * @param {Object} options
	 * @constructor
	 */
	function Outlayer( element, options ) {
	  var queryElement = utils.getQueryElement( element );
	  if ( !queryElement ) {
	    if ( console ) {
	      console.error( 'Bad element for ' + this.constructor.namespace +
	        ': ' + ( queryElement || element ) );
	    }
	    return;
	  }
	  this.element = queryElement;
	  // add jQuery
	  if ( jQuery ) {
	    this.$element = jQuery( this.element );
	  }
	
	  // options
	  this.options = utils.extend( {}, this.constructor.defaults );
	  this.option( options );
	
	  // add id for Outlayer.getFromElement
	  var id = ++GUID;
	  this.element.outlayerGUID = id; // expando
	  instances[ id ] = this; // associate via id
	
	  // kick it off
	  this._create();
	
	  var isInitLayout = this._getOption('initLayout');
	  if ( isInitLayout ) {
	    this.layout();
	  }
	}
	
	// settings are for internal use only
	Outlayer.namespace = 'outlayer';
	Outlayer.Item = Item;
	
	// default options
	Outlayer.defaults = {
	  containerStyle: {
	    position: 'relative'
	  },
	  initLayout: true,
	  originLeft: true,
	  originTop: true,
	  resize: true,
	  resizeContainer: true,
	  // item options
	  transitionDuration: '0.4s',
	  hiddenStyle: {
	    opacity: 0,
	    transform: 'scale(0.001)'
	  },
	  visibleStyle: {
	    opacity: 1,
	    transform: 'scale(1)'
	  }
	};
	
	var proto = Outlayer.prototype;
	// inherit EvEmitter
	utils.extend( proto, EvEmitter.prototype );
	
	/**
	 * set options
	 * @param {Object} opts
	 */
	proto.option = function( opts ) {
	  utils.extend( this.options, opts );
	};
	
	/**
	 * get backwards compatible option value, check old name
	 */
	proto._getOption = function( option ) {
	  var oldOption = this.constructor.compatOptions[ option ];
	  return oldOption && this.options[ oldOption ] !== undefined ?
	    this.options[ oldOption ] : this.options[ option ];
	};
	
	Outlayer.compatOptions = {
	  // currentName: oldName
	  initLayout: 'isInitLayout',
	  horizontal: 'isHorizontal',
	  layoutInstant: 'isLayoutInstant',
	  originLeft: 'isOriginLeft',
	  originTop: 'isOriginTop',
	  resize: 'isResizeBound',
	  resizeContainer: 'isResizingContainer'
	};
	
	proto._create = function() {
	  // get items from children
	  this.reloadItems();
	  // elements that affect layout, but are not laid out
	  this.stamps = [];
	  this.stamp( this.options.stamp );
	  // set container style
	  utils.extend( this.element.style, this.options.containerStyle );
	
	  // bind resize method
	  var canBindResize = this._getOption('resize');
	  if ( canBindResize ) {
	    this.bindResize();
	  }
	};
	
	// goes through all children again and gets bricks in proper order
	proto.reloadItems = function() {
	  // collection of item elements
	  this.items = this._itemize( this.element.children );
	};
	
	
	/**
	 * turn elements into Outlayer.Items to be used in layout
	 * @param {Array or NodeList or HTMLElement} elems
	 * @returns {Array} items - collection of new Outlayer Items
	 */
	proto._itemize = function( elems ) {
	
	  var itemElems = this._filterFindItemElements( elems );
	  var Item = this.constructor.Item;
	
	  // create new Outlayer Items for collection
	  var items = [];
	  for ( var i=0; i < itemElems.length; i++ ) {
	    var elem = itemElems[i];
	    var item = new Item( elem, this );
	    items.push( item );
	  }
	
	  return items;
	};
	
	/**
	 * get item elements to be used in layout
	 * @param {Array or NodeList or HTMLElement} elems
	 * @returns {Array} items - item elements
	 */
	proto._filterFindItemElements = function( elems ) {
	  return utils.filterFindElements( elems, this.options.itemSelector );
	};
	
	/**
	 * getter method for getting item elements
	 * @returns {Array} elems - collection of item elements
	 */
	proto.getItemElements = function() {
	  return this.items.map( function( item ) {
	    return item.element;
	  });
	};
	
	// ----- init & layout ----- //
	
	/**
	 * lays out all items
	 */
	proto.layout = function() {
	  this._resetLayout();
	  this._manageStamps();
	
	  // don't animate first layout
	  var layoutInstant = this._getOption('layoutInstant');
	  var isInstant = layoutInstant !== undefined ?
	    layoutInstant : !this._isLayoutInited;
	  this.layoutItems( this.items, isInstant );
	
	  // flag for initalized
	  this._isLayoutInited = true;
	};
	
	// _init is alias for layout
	proto._init = proto.layout;
	
	/**
	 * logic before any new layout
	 */
	proto._resetLayout = function() {
	  this.getSize();
	};
	
	
	proto.getSize = function() {
	  this.size = getSize( this.element );
	};
	
	/**
	 * get measurement from option, for columnWidth, rowHeight, gutter
	 * if option is String -> get element from selector string, & get size of element
	 * if option is Element -> get size of element
	 * else use option as a number
	 *
	 * @param {String} measurement
	 * @param {String} size - width or height
	 * @private
	 */
	proto._getMeasurement = function( measurement, size ) {
	  var option = this.options[ measurement ];
	  var elem;
	  if ( !option ) {
	    // default to 0
	    this[ measurement ] = 0;
	  } else {
	    // use option as an element
	    if ( typeof option == 'string' ) {
	      elem = this.element.querySelector( option );
	    } else if ( option instanceof HTMLElement ) {
	      elem = option;
	    }
	    // use size of element, if element
	    this[ measurement ] = elem ? getSize( elem )[ size ] : option;
	  }
	};
	
	/**
	 * layout a collection of item elements
	 * @api public
	 */
	proto.layoutItems = function( items, isInstant ) {
	  items = this._getItemsForLayout( items );
	
	  this._layoutItems( items, isInstant );
	
	  this._postLayout();
	};
	
	/**
	 * get the items to be laid out
	 * you may want to skip over some items
	 * @param {Array} items
	 * @returns {Array} items
	 */
	proto._getItemsForLayout = function( items ) {
	  return items.filter( function( item ) {
	    return !item.isIgnored;
	  });
	};
	
	/**
	 * layout items
	 * @param {Array} items
	 * @param {Boolean} isInstant
	 */
	proto._layoutItems = function( items, isInstant ) {
	  this._emitCompleteOnItems( 'layout', items );
	
	  if ( !items || !items.length ) {
	    // no items, emit event with empty array
	    return;
	  }
	
	  var queue = [];
	
	  items.forEach( function( item ) {
	    // get x/y object from method
	    var position = this._getItemLayoutPosition( item );
	    // enqueue
	    position.item = item;
	    position.isInstant = isInstant || item.isLayoutInstant;
	    queue.push( position );
	  }, this );
	
	  this._processLayoutQueue( queue );
	};
	
	/**
	 * get item layout position
	 * @param {Outlayer.Item} item
	 * @returns {Object} x and y position
	 */
	proto._getItemLayoutPosition = function( /* item */ ) {
	  return {
	    x: 0,
	    y: 0
	  };
	};
	
	/**
	 * iterate over array and position each item
	 * Reason being - separating this logic prevents 'layout invalidation'
	 * thx @paul_irish
	 * @param {Array} queue
	 */
	proto._processLayoutQueue = function( queue ) {
	  this.updateStagger();
	  queue.forEach( function( obj, i ) {
	    this._positionItem( obj.item, obj.x, obj.y, obj.isInstant, i );
	  }, this );
	};
	
	// set stagger from option in milliseconds number
	proto.updateStagger = function() {
	  var stagger = this.options.stagger;
	  if ( stagger === null || stagger === undefined ) {
	    this.stagger = 0;
	    return;
	  }
	  this.stagger = getMilliseconds( stagger );
	  return this.stagger;
	};
	
	/**
	 * Sets position of item in DOM
	 * @param {Outlayer.Item} item
	 * @param {Number} x - horizontal position
	 * @param {Number} y - vertical position
	 * @param {Boolean} isInstant - disables transitions
	 */
	proto._positionItem = function( item, x, y, isInstant, i ) {
	  if ( isInstant ) {
	    // if not transition, just set CSS
	    item.goTo( x, y );
	  } else {
	    item.stagger( i * this.stagger );
	    item.moveTo( x, y );
	  }
	};
	
	/**
	 * Any logic you want to do after each layout,
	 * i.e. size the container
	 */
	proto._postLayout = function() {
	  this.resizeContainer();
	};
	
	proto.resizeContainer = function() {
	  var isResizingContainer = this._getOption('resizeContainer');
	  if ( !isResizingContainer ) {
	    return;
	  }
	  var size = this._getContainerSize();
	  if ( size ) {
	    this._setContainerMeasure( size.width, true );
	    this._setContainerMeasure( size.height, false );
	  }
	};
	
	/**
	 * Sets width or height of container if returned
	 * @returns {Object} size
	 *   @param {Number} width
	 *   @param {Number} height
	 */
	proto._getContainerSize = noop;
	
	/**
	 * @param {Number} measure - size of width or height
	 * @param {Boolean} isWidth
	 */
	proto._setContainerMeasure = function( measure, isWidth ) {
	  if ( measure === undefined ) {
	    return;
	  }
	
	  var elemSize = this.size;
	  // add padding and border width if border box
	  if ( elemSize.isBorderBox ) {
	    measure += isWidth ? elemSize.paddingLeft + elemSize.paddingRight +
	      elemSize.borderLeftWidth + elemSize.borderRightWidth :
	      elemSize.paddingBottom + elemSize.paddingTop +
	      elemSize.borderTopWidth + elemSize.borderBottomWidth;
	  }
	
	  measure = Math.max( measure, 0 );
	  this.element.style[ isWidth ? 'width' : 'height' ] = measure + 'px';
	};
	
	/**
	 * emit eventComplete on a collection of items events
	 * @param {String} eventName
	 * @param {Array} items - Outlayer.Items
	 */
	proto._emitCompleteOnItems = function( eventName, items ) {
	  var _this = this;
	  function onComplete() {
	    _this.dispatchEvent( eventName + 'Complete', null, [ items ] );
	  }
	
	  var count = items.length;
	  if ( !items || !count ) {
	    onComplete();
	    return;
	  }
	
	  var doneCount = 0;
	  function tick() {
	    doneCount++;
	    if ( doneCount == count ) {
	      onComplete();
	    }
	  }
	
	  // bind callback
	  items.forEach( function( item ) {
	    item.once( eventName, tick );
	  });
	};
	
	/**
	 * emits events via EvEmitter and jQuery events
	 * @param {String} type - name of event
	 * @param {Event} event - original event
	 * @param {Array} args - extra arguments
	 */
	proto.dispatchEvent = function( type, event, args ) {
	  // add original event to arguments
	  var emitArgs = event ? [ event ].concat( args ) : args;
	  this.emitEvent( type, emitArgs );
	
	  if ( jQuery ) {
	    // set this.$element
	    this.$element = this.$element || jQuery( this.element );
	    if ( event ) {
	      // create jQuery event
	      var $event = jQuery.Event( event );
	      $event.type = type;
	      this.$element.trigger( $event, args );
	    } else {
	      // just trigger with type if no event available
	      this.$element.trigger( type, args );
	    }
	  }
	};
	
	// -------------------------- ignore & stamps -------------------------- //
	
	
	/**
	 * keep item in collection, but do not lay it out
	 * ignored items do not get skipped in layout
	 * @param {Element} elem
	 */
	proto.ignore = function( elem ) {
	  var item = this.getItem( elem );
	  if ( item ) {
	    item.isIgnored = true;
	  }
	};
	
	/**
	 * return item to layout collection
	 * @param {Element} elem
	 */
	proto.unignore = function( elem ) {
	  var item = this.getItem( elem );
	  if ( item ) {
	    delete item.isIgnored;
	  }
	};
	
	/**
	 * adds elements to stamps
	 * @param {NodeList, Array, Element, or String} elems
	 */
	proto.stamp = function( elems ) {
	  elems = this._find( elems );
	  if ( !elems ) {
	    return;
	  }
	
	  this.stamps = this.stamps.concat( elems );
	  // ignore
	  elems.forEach( this.ignore, this );
	};
	
	/**
	 * removes elements to stamps
	 * @param {NodeList, Array, or Element} elems
	 */
	proto.unstamp = function( elems ) {
	  elems = this._find( elems );
	  if ( !elems ){
	    return;
	  }
	
	  elems.forEach( function( elem ) {
	    // filter out removed stamp elements
	    utils.removeFrom( this.stamps, elem );
	    this.unignore( elem );
	  }, this );
	};
	
	/**
	 * finds child elements
	 * @param {NodeList, Array, Element, or String} elems
	 * @returns {Array} elems
	 */
	proto._find = function( elems ) {
	  if ( !elems ) {
	    return;
	  }
	  // if string, use argument as selector string
	  if ( typeof elems == 'string' ) {
	    elems = this.element.querySelectorAll( elems );
	  }
	  elems = utils.makeArray( elems );
	  return elems;
	};
	
	proto._manageStamps = function() {
	  if ( !this.stamps || !this.stamps.length ) {
	    return;
	  }
	
	  this._getBoundingRect();
	
	  this.stamps.forEach( this._manageStamp, this );
	};
	
	// update boundingLeft / Top
	proto._getBoundingRect = function() {
	  // get bounding rect for container element
	  var boundingRect = this.element.getBoundingClientRect();
	  var size = this.size;
	  this._boundingRect = {
	    left: boundingRect.left + size.paddingLeft + size.borderLeftWidth,
	    top: boundingRect.top + size.paddingTop + size.borderTopWidth,
	    right: boundingRect.right - ( size.paddingRight + size.borderRightWidth ),
	    bottom: boundingRect.bottom - ( size.paddingBottom + size.borderBottomWidth )
	  };
	};
	
	/**
	 * @param {Element} stamp
	**/
	proto._manageStamp = noop;
	
	/**
	 * get x/y position of element relative to container element
	 * @param {Element} elem
	 * @returns {Object} offset - has left, top, right, bottom
	 */
	proto._getElementOffset = function( elem ) {
	  var boundingRect = elem.getBoundingClientRect();
	  var thisRect = this._boundingRect;
	  var size = getSize( elem );
	  var offset = {
	    left: boundingRect.left - thisRect.left - size.marginLeft,
	    top: boundingRect.top - thisRect.top - size.marginTop,
	    right: thisRect.right - boundingRect.right - size.marginRight,
	    bottom: thisRect.bottom - boundingRect.bottom - size.marginBottom
	  };
	  return offset;
	};
	
	// -------------------------- resize -------------------------- //
	
	// enable event handlers for listeners
	// i.e. resize -> onresize
	proto.handleEvent = utils.handleEvent;
	
	/**
	 * Bind layout to window resizing
	 */
	proto.bindResize = function() {
	  window.addEventListener( 'resize', this );
	  this.isResizeBound = true;
	};
	
	/**
	 * Unbind layout to window resizing
	 */
	proto.unbindResize = function() {
	  window.removeEventListener( 'resize', this );
	  this.isResizeBound = false;
	};
	
	proto.onresize = function() {
	  this.resize();
	};
	
	utils.debounceMethod( Outlayer, 'onresize', 100 );
	
	proto.resize = function() {
	  // don't trigger if size did not change
	  // or if resize was unbound. See #9
	  if ( !this.isResizeBound || !this.needsResizeLayout() ) {
	    return;
	  }
	
	  this.layout();
	};
	
	/**
	 * check if layout is needed post layout
	 * @returns Boolean
	 */
	proto.needsResizeLayout = function() {
	  var size = getSize( this.element );
	  // check that this.size and size are there
	  // IE8 triggers resize on body size change, so they might not be
	  var hasSizes = this.size && size;
	  return hasSizes && size.innerWidth !== this.size.innerWidth;
	};
	
	// -------------------------- methods -------------------------- //
	
	/**
	 * add items to Outlayer instance
	 * @param {Array or NodeList or Element} elems
	 * @returns {Array} items - Outlayer.Items
	**/
	proto.addItems = function( elems ) {
	  var items = this._itemize( elems );
	  // add items to collection
	  if ( items.length ) {
	    this.items = this.items.concat( items );
	  }
	  return items;
	};
	
	/**
	 * Layout newly-appended item elements
	 * @param {Array or NodeList or Element} elems
	 */
	proto.appended = function( elems ) {
	  var items = this.addItems( elems );
	  if ( !items.length ) {
	    return;
	  }
	  // layout and reveal just the new items
	  this.layoutItems( items, true );
	  this.reveal( items );
	};
	
	/**
	 * Layout prepended elements
	 * @param {Array or NodeList or Element} elems
	 */
	proto.prepended = function( elems ) {
	  var items = this._itemize( elems );
	  if ( !items.length ) {
	    return;
	  }
	  // add items to beginning of collection
	  var previousItems = this.items.slice(0);
	  this.items = items.concat( previousItems );
	  // start new layout
	  this._resetLayout();
	  this._manageStamps();
	  // layout new stuff without transition
	  this.layoutItems( items, true );
	  this.reveal( items );
	  // layout previous items
	  this.layoutItems( previousItems );
	};
	
	/**
	 * reveal a collection of items
	 * @param {Array of Outlayer.Items} items
	 */
	proto.reveal = function( items ) {
	  this._emitCompleteOnItems( 'reveal', items );
	  if ( !items || !items.length ) {
	    return;
	  }
	  var stagger = this.updateStagger();
	  items.forEach( function( item, i ) {
	    item.stagger( i * stagger );
	    item.reveal();
	  });
	};
	
	/**
	 * hide a collection of items
	 * @param {Array of Outlayer.Items} items
	 */
	proto.hide = function( items ) {
	  this._emitCompleteOnItems( 'hide', items );
	  if ( !items || !items.length ) {
	    return;
	  }
	  var stagger = this.updateStagger();
	  items.forEach( function( item, i ) {
	    item.stagger( i * stagger );
	    item.hide();
	  });
	};
	
	/**
	 * reveal item elements
	 * @param {Array}, {Element}, {NodeList} items
	 */
	proto.revealItemElements = function( elems ) {
	  var items = this.getItems( elems );
	  this.reveal( items );
	};
	
	/**
	 * hide item elements
	 * @param {Array}, {Element}, {NodeList} items
	 */
	proto.hideItemElements = function( elems ) {
	  var items = this.getItems( elems );
	  this.hide( items );
	};
	
	/**
	 * get Outlayer.Item, given an Element
	 * @param {Element} elem
	 * @param {Function} callback
	 * @returns {Outlayer.Item} item
	 */
	proto.getItem = function( elem ) {
	  // loop through items to get the one that matches
	  for ( var i=0; i < this.items.length; i++ ) {
	    var item = this.items[i];
	    if ( item.element == elem ) {
	      // return item
	      return item;
	    }
	  }
	};
	
	/**
	 * get collection of Outlayer.Items, given Elements
	 * @param {Array} elems
	 * @returns {Array} items - Outlayer.Items
	 */
	proto.getItems = function( elems ) {
	  elems = utils.makeArray( elems );
	  var items = [];
	  elems.forEach( function( elem ) {
	    var item = this.getItem( elem );
	    if ( item ) {
	      items.push( item );
	    }
	  }, this );
	
	  return items;
	};
	
	/**
	 * remove element(s) from instance and DOM
	 * @param {Array or NodeList or Element} elems
	 */
	proto.remove = function( elems ) {
	  var removeItems = this.getItems( elems );
	
	  this._emitCompleteOnItems( 'remove', removeItems );
	
	  // bail if no items to remove
	  if ( !removeItems || !removeItems.length ) {
	    return;
	  }
	
	  removeItems.forEach( function( item ) {
	    item.remove();
	    // remove item from collection
	    utils.removeFrom( this.items, item );
	  }, this );
	};
	
	// ----- destroy ----- //
	
	// remove and disable Outlayer instance
	proto.destroy = function() {
	  // clean up dynamic styles
	  var style = this.element.style;
	  style.height = '';
	  style.position = '';
	  style.width = '';
	  // destroy items
	  this.items.forEach( function( item ) {
	    item.destroy();
	  });
	
	  this.unbindResize();
	
	  var id = this.element.outlayerGUID;
	  delete instances[ id ]; // remove reference to instance by id
	  delete this.element.outlayerGUID;
	  // remove data for jQuery
	  if ( jQuery ) {
	    jQuery.removeData( this.element, this.constructor.namespace );
	  }
	
	};
	
	// -------------------------- data -------------------------- //
	
	/**
	 * get Outlayer instance from element
	 * @param {Element} elem
	 * @returns {Outlayer}
	 */
	Outlayer.data = function( elem ) {
	  elem = utils.getQueryElement( elem );
	  var id = elem && elem.outlayerGUID;
	  return id && instances[ id ];
	};
	
	
	// -------------------------- create Outlayer class -------------------------- //
	
	/**
	 * create a layout class
	 * @param {String} namespace
	 */
	Outlayer.create = function( namespace, options ) {
	  // sub-class Outlayer
	  var Layout = subclass( Outlayer );
	  // apply new options and compatOptions
	  Layout.defaults = utils.extend( {}, Outlayer.defaults );
	  utils.extend( Layout.defaults, options );
	  Layout.compatOptions = utils.extend( {}, Outlayer.compatOptions  );
	
	  Layout.namespace = namespace;
	
	  Layout.data = Outlayer.data;
	
	  // sub-class Item
	  Layout.Item = subclass( Item );
	
	  // -------------------------- declarative -------------------------- //
	
	  utils.htmlInit( Layout, namespace );
	
	  // -------------------------- jQuery bridge -------------------------- //
	
	  // make into jQuery plugin
	  if ( jQuery && jQuery.bridget ) {
	    jQuery.bridget( namespace, Layout );
	  }
	
	  return Layout;
	};
	
	function subclass( Parent ) {
	  function SubClass() {
	    Parent.apply( this, arguments );
	  }
	
	  SubClass.prototype = Object.create( Parent.prototype );
	  SubClass.prototype.constructor = SubClass;
	
	  return SubClass;
	}
	
	// ----- helpers ----- //
	
	// how many milliseconds are in each unit
	var msUnits = {
	  ms: 1,
	  s: 1000
	};
	
	// munge time-like parameter into millisecond number
	// '0.4s' -> 40
	function getMilliseconds( time ) {
	  if ( typeof time == 'number' ) {
	    return time;
	  }
	  var matches = time.match( /(^\d*\.?\d*)(\w*)/ );
	  var num = matches && matches[1];
	  var unit = matches && matches[2];
	  if ( !num.length ) {
	    return 0;
	  }
	  num = parseFloat( num );
	  var mult = msUnits[ unit ] || 1;
	  return num * mult;
	}
	
	// ----- fin ----- //
	
	// back in global
	Outlayer.Item = Item;
	
	return Outlayer;
	
	}));


/***/ }),
/* 77 */
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_RESULT__;/**
	 * EvEmitter v1.1.0
	 * Lil' event emitter
	 * MIT License
	 */
	
	/* jshint unused: true, undef: true, strict: true */
	
	( function( global, factory ) {
	  // universal module definition
	  /* jshint strict: false */ /* globals define, module, window */
	  if ( true ) {
	    // AMD - RequireJS
	    !(__WEBPACK_AMD_DEFINE_FACTORY__ = (factory), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.call(exports, __webpack_require__, exports, module)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	  } else if ( typeof module == 'object' && module.exports ) {
	    // CommonJS - Browserify, Webpack
	    module.exports = factory();
	  } else {
	    // Browser globals
	    global.EvEmitter = factory();
	  }
	
	}( typeof window != 'undefined' ? window : this, function() {
	
	"use strict";
	
	function EvEmitter() {}
	
	var proto = EvEmitter.prototype;
	
	proto.on = function( eventName, listener ) {
	  if ( !eventName || !listener ) {
	    return;
	  }
	  // set events hash
	  var events = this._events = this._events || {};
	  // set listeners array
	  var listeners = events[ eventName ] = events[ eventName ] || [];
	  // only add once
	  if ( listeners.indexOf( listener ) == -1 ) {
	    listeners.push( listener );
	  }
	
	  return this;
	};
	
	proto.once = function( eventName, listener ) {
	  if ( !eventName || !listener ) {
	    return;
	  }
	  // add event
	  this.on( eventName, listener );
	  // set once flag
	  // set onceEvents hash
	  var onceEvents = this._onceEvents = this._onceEvents || {};
	  // set onceListeners object
	  var onceListeners = onceEvents[ eventName ] = onceEvents[ eventName ] || {};
	  // set flag
	  onceListeners[ listener ] = true;
	
	  return this;
	};
	
	proto.off = function( eventName, listener ) {
	  var listeners = this._events && this._events[ eventName ];
	  if ( !listeners || !listeners.length ) {
	    return;
	  }
	  var index = listeners.indexOf( listener );
	  if ( index != -1 ) {
	    listeners.splice( index, 1 );
	  }
	
	  return this;
	};
	
	proto.emitEvent = function( eventName, args ) {
	  var listeners = this._events && this._events[ eventName ];
	  if ( !listeners || !listeners.length ) {
	    return;
	  }
	  // copy over to avoid interference if .off() in listener
	  listeners = listeners.slice(0);
	  args = args || [];
	  // once stuff
	  var onceListeners = this._onceEvents && this._onceEvents[ eventName ];
	
	  for ( var i=0; i < listeners.length; i++ ) {
	    var listener = listeners[i]
	    var isOnce = onceListeners && onceListeners[ listener ];
	    if ( isOnce ) {
	      // remove listener
	      // remove before trigger to prevent recursion
	      this.off( eventName, listener );
	      // unset once flag
	      delete onceListeners[ listener ];
	    }
	    // trigger listener
	    listener.apply( this, args );
	  }
	
	  return this;
	};
	
	proto.allOff = function() {
	  delete this._events;
	  delete this._onceEvents;
	};
	
	return EvEmitter;
	
	}));


/***/ }),
/* 78 */
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_RESULT__;/*!
	 * getSize v2.0.3
	 * measure size of elements
	 * MIT license
	 */
	
	/* jshint browser: true, strict: true, undef: true, unused: true */
	/* globals console: false */
	
	( function( window, factory ) {
	  /* jshint strict: false */ /* globals define, module */
	  if ( true ) {
	    // AMD
	    !(__WEBPACK_AMD_DEFINE_FACTORY__ = (factory), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.call(exports, __webpack_require__, exports, module)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	  } else if ( typeof module == 'object' && module.exports ) {
	    // CommonJS
	    module.exports = factory();
	  } else {
	    // browser global
	    window.getSize = factory();
	  }
	
	})( window, function factory() {
	'use strict';
	
	// -------------------------- helpers -------------------------- //
	
	// get a number from a string, not a percentage
	function getStyleSize( value ) {
	  var num = parseFloat( value );
	  // not a percent like '100%', and a number
	  var isValid = value.indexOf('%') == -1 && !isNaN( num );
	  return isValid && num;
	}
	
	function noop() {}
	
	var logError = typeof console == 'undefined' ? noop :
	  function( message ) {
	    console.error( message );
	  };
	
	// -------------------------- measurements -------------------------- //
	
	var measurements = [
	  'paddingLeft',
	  'paddingRight',
	  'paddingTop',
	  'paddingBottom',
	  'marginLeft',
	  'marginRight',
	  'marginTop',
	  'marginBottom',
	  'borderLeftWidth',
	  'borderRightWidth',
	  'borderTopWidth',
	  'borderBottomWidth'
	];
	
	var measurementsLength = measurements.length;
	
	function getZeroSize() {
	  var size = {
	    width: 0,
	    height: 0,
	    innerWidth: 0,
	    innerHeight: 0,
	    outerWidth: 0,
	    outerHeight: 0
	  };
	  for ( var i=0; i < measurementsLength; i++ ) {
	    var measurement = measurements[i];
	    size[ measurement ] = 0;
	  }
	  return size;
	}
	
	// -------------------------- getStyle -------------------------- //
	
	/**
	 * getStyle, get style of element, check for Firefox bug
	 * https://bugzilla.mozilla.org/show_bug.cgi?id=548397
	 */
	function getStyle( elem ) {
	  var style = getComputedStyle( elem );
	  if ( !style ) {
	    logError( 'Style returned ' + style +
	      '. Are you running this code in a hidden iframe on Firefox? ' +
	      'See https://bit.ly/getsizebug1' );
	  }
	  return style;
	}
	
	// -------------------------- setup -------------------------- //
	
	var isSetup = false;
	
	var isBoxSizeOuter;
	
	/**
	 * setup
	 * check isBoxSizerOuter
	 * do on first getSize() rather than on page load for Firefox bug
	 */
	function setup() {
	  // setup once
	  if ( isSetup ) {
	    return;
	  }
	  isSetup = true;
	
	  // -------------------------- box sizing -------------------------- //
	
	  /**
	   * Chrome & Safari measure the outer-width on style.width on border-box elems
	   * IE11 & Firefox<29 measures the inner-width
	   */
	  var div = document.createElement('div');
	  div.style.width = '200px';
	  div.style.padding = '1px 2px 3px 4px';
	  div.style.borderStyle = 'solid';
	  div.style.borderWidth = '1px 2px 3px 4px';
	  div.style.boxSizing = 'border-box';
	
	  var body = document.body || document.documentElement;
	  body.appendChild( div );
	  var style = getStyle( div );
	  // round value for browser zoom. desandro/masonry#928
	  isBoxSizeOuter = Math.round( getStyleSize( style.width ) ) == 200;
	  getSize.isBoxSizeOuter = isBoxSizeOuter;
	
	  body.removeChild( div );
	}
	
	// -------------------------- getSize -------------------------- //
	
	function getSize( elem ) {
	  setup();
	
	  // use querySeletor if elem is string
	  if ( typeof elem == 'string' ) {
	    elem = document.querySelector( elem );
	  }
	
	  // do not proceed on non-objects
	  if ( !elem || typeof elem != 'object' || !elem.nodeType ) {
	    return;
	  }
	
	  var style = getStyle( elem );
	
	  // if hidden, everything is 0
	  if ( style.display == 'none' ) {
	    return getZeroSize();
	  }
	
	  var size = {};
	  size.width = elem.offsetWidth;
	  size.height = elem.offsetHeight;
	
	  var isBorderBox = size.isBorderBox = style.boxSizing == 'border-box';
	
	  // get all measurements
	  for ( var i=0; i < measurementsLength; i++ ) {
	    var measurement = measurements[i];
	    var value = style[ measurement ];
	    var num = parseFloat( value );
	    // any 'auto', 'medium' value will be 0
	    size[ measurement ] = !isNaN( num ) ? num : 0;
	  }
	
	  var paddingWidth = size.paddingLeft + size.paddingRight;
	  var paddingHeight = size.paddingTop + size.paddingBottom;
	  var marginWidth = size.marginLeft + size.marginRight;
	  var marginHeight = size.marginTop + size.marginBottom;
	  var borderWidth = size.borderLeftWidth + size.borderRightWidth;
	  var borderHeight = size.borderTopWidth + size.borderBottomWidth;
	
	  var isBorderBoxSizeOuter = isBorderBox && isBoxSizeOuter;
	
	  // overwrite width and height if we can get it from style
	  var styleWidth = getStyleSize( style.width );
	  if ( styleWidth !== false ) {
	    size.width = styleWidth +
	      // add padding and border unless it's already including it
	      ( isBorderBoxSizeOuter ? 0 : paddingWidth + borderWidth );
	  }
	
	  var styleHeight = getStyleSize( style.height );
	  if ( styleHeight !== false ) {
	    size.height = styleHeight +
	      // add padding and border unless it's already including it
	      ( isBorderBoxSizeOuter ? 0 : paddingHeight + borderHeight );
	  }
	
	  size.innerWidth = size.width - ( paddingWidth + borderWidth );
	  size.innerHeight = size.height - ( paddingHeight + borderHeight );
	
	  size.outerWidth = size.width + marginWidth;
	  size.outerHeight = size.height + marginHeight;
	
	  return size;
	}
	
	return getSize;
	
	});


/***/ }),
/* 79 */
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/**
	 * Fizzy UI utils v2.0.7
	 * MIT license
	 */
	
	/*jshint browser: true, undef: true, unused: true, strict: true */
	
	( function( window, factory ) {
	  // universal module definition
	  /*jshint strict: false */ /*globals define, module, require */
	
	  if ( true ) {
	    // AMD
	    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [
	      __webpack_require__(80)
	    ], __WEBPACK_AMD_DEFINE_RESULT__ = function( matchesSelector ) {
	      return factory( window, matchesSelector );
	    }.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	  } else if ( typeof module == 'object' && module.exports ) {
	    // CommonJS
	    module.exports = factory(
	      window,
	      require('desandro-matches-selector')
	    );
	  } else {
	    // browser global
	    window.fizzyUIUtils = factory(
	      window,
	      window.matchesSelector
	    );
	  }
	
	}( window, function factory( window, matchesSelector ) {
	
	'use strict';
	
	var utils = {};
	
	// ----- extend ----- //
	
	// extends objects
	utils.extend = function( a, b ) {
	  for ( var prop in b ) {
	    a[ prop ] = b[ prop ];
	  }
	  return a;
	};
	
	// ----- modulo ----- //
	
	utils.modulo = function( num, div ) {
	  return ( ( num % div ) + div ) % div;
	};
	
	// ----- makeArray ----- //
	
	var arraySlice = Array.prototype.slice;
	
	// turn element or nodeList into an array
	utils.makeArray = function( obj ) {
	  if ( Array.isArray( obj ) ) {
	    // use object if already an array
	    return obj;
	  }
	  // return empty array if undefined or null. #6
	  if ( obj === null || obj === undefined ) {
	    return [];
	  }
	
	  var isArrayLike = typeof obj == 'object' && typeof obj.length == 'number';
	  if ( isArrayLike ) {
	    // convert nodeList to array
	    return arraySlice.call( obj );
	  }
	
	  // array of single index
	  return [ obj ];
	};
	
	// ----- removeFrom ----- //
	
	utils.removeFrom = function( ary, obj ) {
	  var index = ary.indexOf( obj );
	  if ( index != -1 ) {
	    ary.splice( index, 1 );
	  }
	};
	
	// ----- getParent ----- //
	
	utils.getParent = function( elem, selector ) {
	  while ( elem.parentNode && elem != document.body ) {
	    elem = elem.parentNode;
	    if ( matchesSelector( elem, selector ) ) {
	      return elem;
	    }
	  }
	};
	
	// ----- getQueryElement ----- //
	
	// use element as selector string
	utils.getQueryElement = function( elem ) {
	  if ( typeof elem == 'string' ) {
	    return document.querySelector( elem );
	  }
	  return elem;
	};
	
	// ----- handleEvent ----- //
	
	// enable .ontype to trigger from .addEventListener( elem, 'type' )
	utils.handleEvent = function( event ) {
	  var method = 'on' + event.type;
	  if ( this[ method ] ) {
	    this[ method ]( event );
	  }
	};
	
	// ----- filterFindElements ----- //
	
	utils.filterFindElements = function( elems, selector ) {
	  // make array of elems
	  elems = utils.makeArray( elems );
	  var ffElems = [];
	
	  elems.forEach( function( elem ) {
	    // check that elem is an actual element
	    if ( !( elem instanceof HTMLElement ) ) {
	      return;
	    }
	    // add elem if no selector
	    if ( !selector ) {
	      ffElems.push( elem );
	      return;
	    }
	    // filter & find items if we have a selector
	    // filter
	    if ( matchesSelector( elem, selector ) ) {
	      ffElems.push( elem );
	    }
	    // find children
	    var childElems = elem.querySelectorAll( selector );
	    // concat childElems to filterFound array
	    for ( var i=0; i < childElems.length; i++ ) {
	      ffElems.push( childElems[i] );
	    }
	  });
	
	  return ffElems;
	};
	
	// ----- debounceMethod ----- //
	
	utils.debounceMethod = function( _class, methodName, threshold ) {
	  threshold = threshold || 100;
	  // original method
	  var method = _class.prototype[ methodName ];
	  var timeoutName = methodName + 'Timeout';
	
	  _class.prototype[ methodName ] = function() {
	    var timeout = this[ timeoutName ];
	    clearTimeout( timeout );
	
	    var args = arguments;
	    var _this = this;
	    this[ timeoutName ] = setTimeout( function() {
	      method.apply( _this, args );
	      delete _this[ timeoutName ];
	    }, threshold );
	  };
	};
	
	// ----- docReady ----- //
	
	utils.docReady = function( callback ) {
	  var readyState = document.readyState;
	  if ( readyState == 'complete' || readyState == 'interactive' ) {
	    // do async to allow for other scripts to run. metafizzy/flickity#441
	    setTimeout( callback );
	  } else {
	    document.addEventListener( 'DOMContentLoaded', callback );
	  }
	};
	
	// ----- htmlInit ----- //
	
	// http://jamesroberts.name/blog/2010/02/22/string-functions-for-javascript-trim-to-camel-case-to-dashed-and-to-underscore/
	utils.toDashed = function( str ) {
	  return str.replace( /(.)([A-Z])/g, function( match, $1, $2 ) {
	    return $1 + '-' + $2;
	  }).toLowerCase();
	};
	
	var console = window.console;
	/**
	 * allow user to initialize classes via [data-namespace] or .js-namespace class
	 * htmlInit( Widget, 'widgetName' )
	 * options are parsed from data-namespace-options
	 */
	utils.htmlInit = function( WidgetClass, namespace ) {
	  utils.docReady( function() {
	    var dashedNamespace = utils.toDashed( namespace );
	    var dataAttr = 'data-' + dashedNamespace;
	    var dataAttrElems = document.querySelectorAll( '[' + dataAttr + ']' );
	    var jsDashElems = document.querySelectorAll( '.js-' + dashedNamespace );
	    var elems = utils.makeArray( dataAttrElems )
	      .concat( utils.makeArray( jsDashElems ) );
	    var dataOptionsAttr = dataAttr + '-options';
	    var jQuery = window.jQuery;
	
	    elems.forEach( function( elem ) {
	      var attr = elem.getAttribute( dataAttr ) ||
	        elem.getAttribute( dataOptionsAttr );
	      var options;
	      try {
	        options = attr && JSON.parse( attr );
	      } catch ( error ) {
	        // log error, do not initialize
	        if ( console ) {
	          console.error( 'Error parsing ' + dataAttr + ' on ' + elem.className +
	          ': ' + error );
	        }
	        return;
	      }
	      // initialize
	      var instance = new WidgetClass( elem, options );
	      // make available via $().data('namespace')
	      if ( jQuery ) {
	        jQuery.data( elem, namespace, instance );
	      }
	    });
	
	  });
	};
	
	// -----  ----- //
	
	return utils;
	
	}));


/***/ }),
/* 80 */
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_RESULT__;/**
	 * matchesSelector v2.0.2
	 * matchesSelector( element, '.selector' )
	 * MIT license
	 */
	
	/*jshint browser: true, strict: true, undef: true, unused: true */
	
	( function( window, factory ) {
	  /*global define: false, module: false */
	  'use strict';
	  // universal module definition
	  if ( true ) {
	    // AMD
	    !(__WEBPACK_AMD_DEFINE_FACTORY__ = (factory), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.call(exports, __webpack_require__, exports, module)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	  } else if ( typeof module == 'object' && module.exports ) {
	    // CommonJS
	    module.exports = factory();
	  } else {
	    // browser global
	    window.matchesSelector = factory();
	  }
	
	}( window, function factory() {
	  'use strict';
	
	  var matchesMethod = ( function() {
	    var ElemProto = window.Element.prototype;
	    // check for the standard method name first
	    if ( ElemProto.matches ) {
	      return 'matches';
	    }
	    // check un-prefixed
	    if ( ElemProto.matchesSelector ) {
	      return 'matchesSelector';
	    }
	    // check vendor prefixes
	    var prefixes = [ 'webkit', 'moz', 'ms', 'o' ];
	
	    for ( var i=0; i < prefixes.length; i++ ) {
	      var prefix = prefixes[i];
	      var method = prefix + 'MatchesSelector';
	      if ( ElemProto[ method ] ) {
	        return method;
	      }
	    }
	  })();
	
	  return function matchesSelector( elem, selector ) {
	    return elem[ matchesMethod ]( selector );
	  };
	
	}));


/***/ }),
/* 81 */
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/**
	 * Outlayer Item
	 */
	
	( function( window, factory ) {
	  // universal module definition
	  /* jshint strict: false */ /* globals define, module, require */
	  if ( true ) {
	    // AMD - RequireJS
	    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [
	        __webpack_require__(77),
	        __webpack_require__(78)
	      ], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	  } else if ( typeof module == 'object' && module.exports ) {
	    // CommonJS - Browserify, Webpack
	    module.exports = factory(
	      require('ev-emitter'),
	      require('get-size')
	    );
	  } else {
	    // browser global
	    window.Outlayer = {};
	    window.Outlayer.Item = factory(
	      window.EvEmitter,
	      window.getSize
	    );
	  }
	
	}( window, function factory( EvEmitter, getSize ) {
	'use strict';
	
	// ----- helpers ----- //
	
	function isEmptyObj( obj ) {
	  for ( var prop in obj ) {
	    return false;
	  }
	  prop = null;
	  return true;
	}
	
	// -------------------------- CSS3 support -------------------------- //
	
	
	var docElemStyle = document.documentElement.style;
	
	var transitionProperty = typeof docElemStyle.transition == 'string' ?
	  'transition' : 'WebkitTransition';
	var transformProperty = typeof docElemStyle.transform == 'string' ?
	  'transform' : 'WebkitTransform';
	
	var transitionEndEvent = {
	  WebkitTransition: 'webkitTransitionEnd',
	  transition: 'transitionend'
	}[ transitionProperty ];
	
	// cache all vendor properties that could have vendor prefix
	var vendorProperties = {
	  transform: transformProperty,
	  transition: transitionProperty,
	  transitionDuration: transitionProperty + 'Duration',
	  transitionProperty: transitionProperty + 'Property',
	  transitionDelay: transitionProperty + 'Delay'
	};
	
	// -------------------------- Item -------------------------- //
	
	function Item( element, layout ) {
	  if ( !element ) {
	    return;
	  }
	
	  this.element = element;
	  // parent layout class, i.e. Masonry, Isotope, or Packery
	  this.layout = layout;
	  this.position = {
	    x: 0,
	    y: 0
	  };
	
	  this._create();
	}
	
	// inherit EvEmitter
	var proto = Item.prototype = Object.create( EvEmitter.prototype );
	proto.constructor = Item;
	
	proto._create = function() {
	  // transition objects
	  this._transn = {
	    ingProperties: {},
	    clean: {},
	    onEnd: {}
	  };
	
	  this.css({
	    position: 'absolute'
	  });
	};
	
	// trigger specified handler for event type
	proto.handleEvent = function( event ) {
	  var method = 'on' + event.type;
	  if ( this[ method ] ) {
	    this[ method ]( event );
	  }
	};
	
	proto.getSize = function() {
	  this.size = getSize( this.element );
	};
	
	/**
	 * apply CSS styles to element
	 * @param {Object} style
	 */
	proto.css = function( style ) {
	  var elemStyle = this.element.style;
	
	  for ( var prop in style ) {
	    // use vendor property if available
	    var supportedProp = vendorProperties[ prop ] || prop;
	    elemStyle[ supportedProp ] = style[ prop ];
	  }
	};
	
	 // measure position, and sets it
	proto.getPosition = function() {
	  var style = getComputedStyle( this.element );
	  var isOriginLeft = this.layout._getOption('originLeft');
	  var isOriginTop = this.layout._getOption('originTop');
	  var xValue = style[ isOriginLeft ? 'left' : 'right' ];
	  var yValue = style[ isOriginTop ? 'top' : 'bottom' ];
	  var x = parseFloat( xValue );
	  var y = parseFloat( yValue );
	  // convert percent to pixels
	  var layoutSize = this.layout.size;
	  if ( xValue.indexOf('%') != -1 ) {
	    x = ( x / 100 ) * layoutSize.width;
	  }
	  if ( yValue.indexOf('%') != -1 ) {
	    y = ( y / 100 ) * layoutSize.height;
	  }
	  // clean up 'auto' or other non-integer values
	  x = isNaN( x ) ? 0 : x;
	  y = isNaN( y ) ? 0 : y;
	  // remove padding from measurement
	  x -= isOriginLeft ? layoutSize.paddingLeft : layoutSize.paddingRight;
	  y -= isOriginTop ? layoutSize.paddingTop : layoutSize.paddingBottom;
	
	  this.position.x = x;
	  this.position.y = y;
	};
	
	// set settled position, apply padding
	proto.layoutPosition = function() {
	  var layoutSize = this.layout.size;
	  var style = {};
	  var isOriginLeft = this.layout._getOption('originLeft');
	  var isOriginTop = this.layout._getOption('originTop');
	
	  // x
	  var xPadding = isOriginLeft ? 'paddingLeft' : 'paddingRight';
	  var xProperty = isOriginLeft ? 'left' : 'right';
	  var xResetProperty = isOriginLeft ? 'right' : 'left';
	
	  var x = this.position.x + layoutSize[ xPadding ];
	  // set in percentage or pixels
	  style[ xProperty ] = this.getXValue( x );
	  // reset other property
	  style[ xResetProperty ] = '';
	
	  // y
	  var yPadding = isOriginTop ? 'paddingTop' : 'paddingBottom';
	  var yProperty = isOriginTop ? 'top' : 'bottom';
	  var yResetProperty = isOriginTop ? 'bottom' : 'top';
	
	  var y = this.position.y + layoutSize[ yPadding ];
	  // set in percentage or pixels
	  style[ yProperty ] = this.getYValue( y );
	  // reset other property
	  style[ yResetProperty ] = '';
	
	  this.css( style );
	  this.emitEvent( 'layout', [ this ] );
	};
	
	proto.getXValue = function( x ) {
	  var isHorizontal = this.layout._getOption('horizontal');
	  return this.layout.options.percentPosition && !isHorizontal ?
	    ( ( x / this.layout.size.width ) * 100 ) + '%' : x + 'px';
	};
	
	proto.getYValue = function( y ) {
	  var isHorizontal = this.layout._getOption('horizontal');
	  return this.layout.options.percentPosition && isHorizontal ?
	    ( ( y / this.layout.size.height ) * 100 ) + '%' : y + 'px';
	};
	
	proto._transitionTo = function( x, y ) {
	  this.getPosition();
	  // get current x & y from top/left
	  var curX = this.position.x;
	  var curY = this.position.y;
	
	  var didNotMove = x == this.position.x && y == this.position.y;
	
	  // save end position
	  this.setPosition( x, y );
	
	  // if did not move and not transitioning, just go to layout
	  if ( didNotMove && !this.isTransitioning ) {
	    this.layoutPosition();
	    return;
	  }
	
	  var transX = x - curX;
	  var transY = y - curY;
	  var transitionStyle = {};
	  transitionStyle.transform = this.getTranslate( transX, transY );
	
	  this.transition({
	    to: transitionStyle,
	    onTransitionEnd: {
	      transform: this.layoutPosition
	    },
	    isCleaning: true
	  });
	};
	
	proto.getTranslate = function( x, y ) {
	  // flip cooridinates if origin on right or bottom
	  var isOriginLeft = this.layout._getOption('originLeft');
	  var isOriginTop = this.layout._getOption('originTop');
	  x = isOriginLeft ? x : -x;
	  y = isOriginTop ? y : -y;
	  return 'translate3d(' + x + 'px, ' + y + 'px, 0)';
	};
	
	// non transition + transform support
	proto.goTo = function( x, y ) {
	  this.setPosition( x, y );
	  this.layoutPosition();
	};
	
	proto.moveTo = proto._transitionTo;
	
	proto.setPosition = function( x, y ) {
	  this.position.x = parseFloat( x );
	  this.position.y = parseFloat( y );
	};
	
	// ----- transition ----- //
	
	/**
	 * @param {Object} style - CSS
	 * @param {Function} onTransitionEnd
	 */
	
	// non transition, just trigger callback
	proto._nonTransition = function( args ) {
	  this.css( args.to );
	  if ( args.isCleaning ) {
	    this._removeStyles( args.to );
	  }
	  for ( var prop in args.onTransitionEnd ) {
	    args.onTransitionEnd[ prop ].call( this );
	  }
	};
	
	/**
	 * proper transition
	 * @param {Object} args - arguments
	 *   @param {Object} to - style to transition to
	 *   @param {Object} from - style to start transition from
	 *   @param {Boolean} isCleaning - removes transition styles after transition
	 *   @param {Function} onTransitionEnd - callback
	 */
	proto.transition = function( args ) {
	  // redirect to nonTransition if no transition duration
	  if ( !parseFloat( this.layout.options.transitionDuration ) ) {
	    this._nonTransition( args );
	    return;
	  }
	
	  var _transition = this._transn;
	  // keep track of onTransitionEnd callback by css property
	  for ( var prop in args.onTransitionEnd ) {
	    _transition.onEnd[ prop ] = args.onTransitionEnd[ prop ];
	  }
	  // keep track of properties that are transitioning
	  for ( prop in args.to ) {
	    _transition.ingProperties[ prop ] = true;
	    // keep track of properties to clean up when transition is done
	    if ( args.isCleaning ) {
	      _transition.clean[ prop ] = true;
	    }
	  }
	
	  // set from styles
	  if ( args.from ) {
	    this.css( args.from );
	    // force redraw. http://blog.alexmaccaw.com/css-transitions
	    var h = this.element.offsetHeight;
	    // hack for JSHint to hush about unused var
	    h = null;
	  }
	  // enable transition
	  this.enableTransition( args.to );
	  // set styles that are transitioning
	  this.css( args.to );
	
	  this.isTransitioning = true;
	
	};
	
	// dash before all cap letters, including first for
	// WebkitTransform => -webkit-transform
	function toDashedAll( str ) {
	  return str.replace( /([A-Z])/g, function( $1 ) {
	    return '-' + $1.toLowerCase();
	  });
	}
	
	var transitionProps = 'opacity,' + toDashedAll( transformProperty );
	
	proto.enableTransition = function(/* style */) {
	  // HACK changing transitionProperty during a transition
	  // will cause transition to jump
	  if ( this.isTransitioning ) {
	    return;
	  }
	
	  // make `transition: foo, bar, baz` from style object
	  // HACK un-comment this when enableTransition can work
	  // while a transition is happening
	  // var transitionValues = [];
	  // for ( var prop in style ) {
	  //   // dash-ify camelCased properties like WebkitTransition
	  //   prop = vendorProperties[ prop ] || prop;
	  //   transitionValues.push( toDashedAll( prop ) );
	  // }
	  // munge number to millisecond, to match stagger
	  var duration = this.layout.options.transitionDuration;
	  duration = typeof duration == 'number' ? duration + 'ms' : duration;
	  // enable transition styles
	  this.css({
	    transitionProperty: transitionProps,
	    transitionDuration: duration,
	    transitionDelay: this.staggerDelay || 0
	  });
	  // listen for transition end event
	  this.element.addEventListener( transitionEndEvent, this, false );
	};
	
	// ----- events ----- //
	
	proto.onwebkitTransitionEnd = function( event ) {
	  this.ontransitionend( event );
	};
	
	proto.onotransitionend = function( event ) {
	  this.ontransitionend( event );
	};
	
	// properties that I munge to make my life easier
	var dashedVendorProperties = {
	  '-webkit-transform': 'transform'
	};
	
	proto.ontransitionend = function( event ) {
	  // disregard bubbled events from children
	  if ( event.target !== this.element ) {
	    return;
	  }
	  var _transition = this._transn;
	  // get property name of transitioned property, convert to prefix-free
	  var propertyName = dashedVendorProperties[ event.propertyName ] || event.propertyName;
	
	  // remove property that has completed transitioning
	  delete _transition.ingProperties[ propertyName ];
	  // check if any properties are still transitioning
	  if ( isEmptyObj( _transition.ingProperties ) ) {
	    // all properties have completed transitioning
	    this.disableTransition();
	  }
	  // clean style
	  if ( propertyName in _transition.clean ) {
	    // clean up style
	    this.element.style[ event.propertyName ] = '';
	    delete _transition.clean[ propertyName ];
	  }
	  // trigger onTransitionEnd callback
	  if ( propertyName in _transition.onEnd ) {
	    var onTransitionEnd = _transition.onEnd[ propertyName ];
	    onTransitionEnd.call( this );
	    delete _transition.onEnd[ propertyName ];
	  }
	
	  this.emitEvent( 'transitionEnd', [ this ] );
	};
	
	proto.disableTransition = function() {
	  this.removeTransitionStyles();
	  this.element.removeEventListener( transitionEndEvent, this, false );
	  this.isTransitioning = false;
	};
	
	/**
	 * removes style property from element
	 * @param {Object} style
	**/
	proto._removeStyles = function( style ) {
	  // clean up transition styles
	  var cleanStyle = {};
	  for ( var prop in style ) {
	    cleanStyle[ prop ] = '';
	  }
	  this.css( cleanStyle );
	};
	
	var cleanTransitionStyle = {
	  transitionProperty: '',
	  transitionDuration: '',
	  transitionDelay: ''
	};
	
	proto.removeTransitionStyles = function() {
	  // remove transition
	  this.css( cleanTransitionStyle );
	};
	
	// ----- stagger ----- //
	
	proto.stagger = function( delay ) {
	  delay = isNaN( delay ) ? 0 : delay;
	  this.staggerDelay = delay + 'ms';
	};
	
	// ----- show/hide/remove ----- //
	
	// remove element from DOM
	proto.removeElem = function() {
	  this.element.parentNode.removeChild( this.element );
	  // remove display: none
	  this.css({ display: '' });
	  this.emitEvent( 'remove', [ this ] );
	};
	
	proto.remove = function() {
	  // just remove element if no transition support or no transition
	  if ( !transitionProperty || !parseFloat( this.layout.options.transitionDuration ) ) {
	    this.removeElem();
	    return;
	  }
	
	  // start transition
	  this.once( 'transitionEnd', function() {
	    this.removeElem();
	  });
	  this.hide();
	};
	
	proto.reveal = function() {
	  delete this.isHidden;
	  // remove display: none
	  this.css({ display: '' });
	
	  var options = this.layout.options;
	
	  var onTransitionEnd = {};
	  var transitionEndProperty = this.getHideRevealTransitionEndProperty('visibleStyle');
	  onTransitionEnd[ transitionEndProperty ] = this.onRevealTransitionEnd;
	
	  this.transition({
	    from: options.hiddenStyle,
	    to: options.visibleStyle,
	    isCleaning: true,
	    onTransitionEnd: onTransitionEnd
	  });
	};
	
	proto.onRevealTransitionEnd = function() {
	  // check if still visible
	  // during transition, item may have been hidden
	  if ( !this.isHidden ) {
	    this.emitEvent('reveal');
	  }
	};
	
	/**
	 * get style property use for hide/reveal transition end
	 * @param {String} styleProperty - hiddenStyle/visibleStyle
	 * @returns {String}
	 */
	proto.getHideRevealTransitionEndProperty = function( styleProperty ) {
	  var optionStyle = this.layout.options[ styleProperty ];
	  // use opacity
	  if ( optionStyle.opacity ) {
	    return 'opacity';
	  }
	  // get first property
	  for ( var prop in optionStyle ) {
	    return prop;
	  }
	};
	
	proto.hide = function() {
	  // set flag
	  this.isHidden = true;
	  // remove display: none
	  this.css({ display: '' });
	
	  var options = this.layout.options;
	
	  var onTransitionEnd = {};
	  var transitionEndProperty = this.getHideRevealTransitionEndProperty('hiddenStyle');
	  onTransitionEnd[ transitionEndProperty ] = this.onHideTransitionEnd;
	
	  this.transition({
	    from: options.visibleStyle,
	    to: options.hiddenStyle,
	    // keep hidden stuff hidden
	    isCleaning: true,
	    onTransitionEnd: onTransitionEnd
	  });
	};
	
	proto.onHideTransitionEnd = function() {
	  // check if still hidden
	  // during transition, item may have been un-hidden
	  if ( this.isHidden ) {
	    this.css({ display: 'none' });
	    this.emitEvent('hide');
	  }
	};
	
	proto.destroy = function() {
	  this.css({
	    position: '',
	    left: '',
	    right: '',
	    top: '',
	    bottom: '',
	    transition: '',
	    transform: ''
	  });
	};
	
	return Item;
	
	}));


/***/ }),
/* 82 */
/***/ (function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.getClosest = getClosest;
	exports.nodeListToArray = nodeListToArray;
	exports.countObjectProperties = countObjectProperties;
	exports.debounce = debounce;
	/* * * * * * * * * * * * * * * * * * * * * * * * * * * * * *
	
	Get the closest matching element up the DOM tree.
	
	@param  {Element} elem     Starting element
	@param  {String}  selector Selector to match against
	@return {Boolean|Element}  Returns null if not match found
	
	https://gomakethings.com/ditching-jquery/#climb-up-the-dom
	
	*/
	
	function getClosest(elem, selector) {
	
	    // Element.matches() polyfill
	    if (!Element.prototype.matches) {
	        Element.prototype.matches = Element.prototype.matchesSelector || Element.prototype.mozMatchesSelector || Element.prototype.msMatchesSelector || Element.prototype.oMatchesSelector || Element.prototype.webkitMatchesSelector || function (s) {
	            var matches = (this.document || this.ownerDocument).querySelectorAll(s),
	                i = matches.length;
	            while (--i >= 0 && matches.item(i) !== this) {}
	            return i > -1;
	        };
	    }
	
	    // Get closest match
	    for (; elem && elem !== document; elem = elem.parentNode) {
	        if (elem.matches(selector)) return elem;
	    }
	
	    return null;
	};
	
	/* * * * * * * * * * * * * * * * * * * * * * * * * * * * * *
	
	Turning a node list into an array
	
	*/
	
	function nodeListToArray(node_list) {
	    var array_list = [];
	    for (var i = 0; i < node_list.length; i++) {
	        array_list.push(node_list[i]);
	    }
	    return array_list;
	};
	
	/* * * * * * * * * * * * * * * * * * * * * * * * * * * * * *
	
	Count an objects properties
	
	*/
	
	function countObjectProperties(obj) {
	    return Object.keys(obj).length;
	}
	
	/* * * * * * * * * * * * * * * * * * * * * * * * * * * * * *
	
	Execute function delayed (such as scroll events)
	
	Inspiration: https://davidwalsh.name/javascript-debounce-function
	
	*/
	
	// Returns a function, that, as long as it continues to be invoked, will not
	// be triggered. The function will be called after it stops being called for
	// N milliseconds. If `immediate` is passed, trigger the function on the
	// leading edge, instead of the trailing.
	function debounce(func, wait, immediate) {
	    var timeout;
	    return function () {
	        var context = this,
	            args = arguments;
	        var later = function later() {
	            timeout = null;
	            if (!immediate) func.apply(context, args);
	        };
	        var callNow = immediate && !timeout;
	        clearTimeout(timeout);
	        timeout = setTimeout(later, wait);
	        if (callNow) func.apply(context, args);
	    };
	};

/***/ }),
/* 83 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function($) {'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.initFormValidation = initFormValidation;
	
	var _jqueryValidation = __webpack_require__(84);
	
	var _jqueryValidation2 = _interopRequireDefault(_jqueryValidation);
	
	var _ajaxForm = __webpack_require__(85);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/* * * * * * * * * * * * * * * * * * * * * * * * * * * * * *
	
	jQuery Validation
	
	Usage:
	
	<form class="validate-form">
	    ...
	        <!-- Mark a field as required -->
	        <input type="text" name="example" required>
	    ...
	</form>
	
	Optional: Validate on page load by adding a class to the form:
	
	<form class="validate-form validate-on-page-load">
	    ...
	</form>
	
	Docs:
	
	https://jqueryvalidation.org/validate/
	
	*/
	
	function initFormValidation() {
	    $('form.validate-form').each(function () {
	        // init
	        var $form = $(this);
	        // init form validation
	        var form_to_validate = $form.validate({
	            onkeyup: false,
	            onfocusout: function onfocusout(element) {
	                // option 1: INSTANT validation after leaving a form field
	                // this.element(element);
	                // option 2: validate on submit
	                return false;
	            },
	            errorPlacement: function errorPlacement(error, element) {
	                return false;
	            },
	            submitHandler: function submitHandler(form) {
	                var $form_to_be_submitted = $(form);
	                // ajax form
	                if ($form_to_be_submitted.hasClass('ajax-form') === true) {
	                    (0, _ajaxForm.sendAjaxForm)($form);
	                }
	                // default form
	                else {
	                        window.onbeforeunload = null;
	                        return true;
	                    }
	            },
	            invalidHandler: function invalidHandler(event, validator) {
	                $form.addClass('has-errors');
	            },
	            unhighlight: function unhighlight(element) {
	                // form element itself
	                $(element).removeClass('error');
	                // form group, or error state handler (in case of multi column forms)
	                var $error_state_handler = $(element).parents('.error-state-handler');
	                if ($error_state_handler.length > 0) {
	                    $error_state_handler.removeClass('has-error');
	                } else {
	                    $(element).parents('.form-group').first().removeClass('has-error');
	                }
	            },
	            highlight: function highlight(element) {
	                // form element itself
	                $(element).addClass('error');
	                // form group, or error state handler (in case of multi column forms)
	                var $error_state_handler = $(element).parents('.error-state-handler');
	                if ($error_state_handler.length > 0) {
	                    $error_state_handler.addClass('has-error');
	                } else {
	                    $(element).parents('.form-group').first().addClass('has-error');
	                }
	            }
	        });
	        // optional: validate on page load by adding a class to the form
	        if ($form.hasClass('validate-on-page-load')) {
	            $form.validate().form();
	        }
	    });
	}
	
	$(function () {
	
	    // on page load
	    initFormValidation();
	
	    // custom event
	    $(window).on('initFormValidation softpage:opened form-modal:opened', function () {
	        console.log("initFormValidation");
	        initFormValidation();
	    });
	});
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(2)))

/***/ }),
/* 84 */
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/*!
	 * jQuery Validation Plugin v1.19.3
	 *
	 * https://jqueryvalidation.org/
	 *
	 * Copyright (c) 2021 Jörn Zaefferer
	 * Released under the MIT license
	 */
	(function( factory ) {
		if ( true ) {
			!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(2)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
		} else if (typeof module === "object" && module.exports) {
			module.exports = factory( require( "jquery" ) );
		} else {
			factory( jQuery );
		}
	}(function( $ ) {
	
	$.extend( $.fn, {
	
		// https://jqueryvalidation.org/validate/
		validate: function( options ) {
	
			// If nothing is selected, return nothing; can't chain anyway
			if ( !this.length ) {
				if ( options && options.debug && window.console ) {
					console.warn( "Nothing selected, can't validate, returning nothing." );
				}
				return;
			}
	
			// Check if a validator for this form was already created
			var validator = $.data( this[ 0 ], "validator" );
			if ( validator ) {
				return validator;
			}
	
			// Add novalidate tag if HTML5.
			this.attr( "novalidate", "novalidate" );
	
			validator = new $.validator( options, this[ 0 ] );
			$.data( this[ 0 ], "validator", validator );
	
			if ( validator.settings.onsubmit ) {
	
				this.on( "click.validate", ":submit", function( event ) {
	
					// Track the used submit button to properly handle scripted
					// submits later.
					validator.submitButton = event.currentTarget;
	
					// Allow suppressing validation by adding a cancel class to the submit button
					if ( $( this ).hasClass( "cancel" ) ) {
						validator.cancelSubmit = true;
					}
	
					// Allow suppressing validation by adding the html5 formnovalidate attribute to the submit button
					if ( $( this ).attr( "formnovalidate" ) !== undefined ) {
						validator.cancelSubmit = true;
					}
				} );
	
				// Validate the form on submit
				this.on( "submit.validate", function( event ) {
					if ( validator.settings.debug ) {
	
						// Prevent form submit to be able to see console output
						event.preventDefault();
					}
	
					function handle() {
						var hidden, result;
	
						// Insert a hidden input as a replacement for the missing submit button
						// The hidden input is inserted in two cases:
						//   - A user defined a `submitHandler`
						//   - There was a pending request due to `remote` method and `stopRequest()`
						//     was called to submit the form in case it's valid
						if ( validator.submitButton && ( validator.settings.submitHandler || validator.formSubmitted ) ) {
							hidden = $( "<input type='hidden'/>" )
								.attr( "name", validator.submitButton.name )
								.val( $( validator.submitButton ).val() )
								.appendTo( validator.currentForm );
						}
	
						if ( validator.settings.submitHandler && !validator.settings.debug ) {
							result = validator.settings.submitHandler.call( validator, validator.currentForm, event );
							if ( hidden ) {
	
								// And clean up afterwards; thanks to no-block-scope, hidden can be referenced
								hidden.remove();
							}
							if ( result !== undefined ) {
								return result;
							}
							return false;
						}
						return true;
					}
	
					// Prevent submit for invalid forms or custom submit handlers
					if ( validator.cancelSubmit ) {
						validator.cancelSubmit = false;
						return handle();
					}
					if ( validator.form() ) {
						if ( validator.pendingRequest ) {
							validator.formSubmitted = true;
							return false;
						}
						return handle();
					} else {
						validator.focusInvalid();
						return false;
					}
				} );
			}
	
			return validator;
		},
	
		// https://jqueryvalidation.org/valid/
		valid: function() {
			var valid, validator, errorList;
	
			if ( $( this[ 0 ] ).is( "form" ) ) {
				valid = this.validate().form();
			} else {
				errorList = [];
				valid = true;
				validator = $( this[ 0 ].form ).validate();
				this.each( function() {
					valid = validator.element( this ) && valid;
					if ( !valid ) {
						errorList = errorList.concat( validator.errorList );
					}
				} );
				validator.errorList = errorList;
			}
			return valid;
		},
	
		// https://jqueryvalidation.org/rules/
		rules: function( command, argument ) {
			var element = this[ 0 ],
				isContentEditable = typeof this.attr( "contenteditable" ) !== "undefined" && this.attr( "contenteditable" ) !== "false",
				settings, staticRules, existingRules, data, param, filtered;
	
			// If nothing is selected, return empty object; can't chain anyway
			if ( element == null ) {
				return;
			}
	
			if ( !element.form && isContentEditable ) {
				element.form = this.closest( "form" )[ 0 ];
				element.name = this.attr( "name" );
			}
	
			if ( element.form == null ) {
				return;
			}
	
			if ( command ) {
				settings = $.data( element.form, "validator" ).settings;
				staticRules = settings.rules;
				existingRules = $.validator.staticRules( element );
				switch ( command ) {
				case "add":
					$.extend( existingRules, $.validator.normalizeRule( argument ) );
	
					// Remove messages from rules, but allow them to be set separately
					delete existingRules.messages;
					staticRules[ element.name ] = existingRules;
					if ( argument.messages ) {
						settings.messages[ element.name ] = $.extend( settings.messages[ element.name ], argument.messages );
					}
					break;
				case "remove":
					if ( !argument ) {
						delete staticRules[ element.name ];
						return existingRules;
					}
					filtered = {};
					$.each( argument.split( /\s/ ), function( index, method ) {
						filtered[ method ] = existingRules[ method ];
						delete existingRules[ method ];
					} );
					return filtered;
				}
			}
	
			data = $.validator.normalizeRules(
			$.extend(
				{},
				$.validator.classRules( element ),
				$.validator.attributeRules( element ),
				$.validator.dataRules( element ),
				$.validator.staticRules( element )
			), element );
	
			// Make sure required is at front
			if ( data.required ) {
				param = data.required;
				delete data.required;
				data = $.extend( { required: param }, data );
			}
	
			// Make sure remote is at back
			if ( data.remote ) {
				param = data.remote;
				delete data.remote;
				data = $.extend( data, { remote: param } );
			}
	
			return data;
		}
	} );
	
	// JQuery trim is deprecated, provide a trim method based on String.prototype.trim
	var trim = function( str ) {
	
		// https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/String/trim#Polyfill
		return str.replace( /^[\s\uFEFF\xA0]+|[\s\uFEFF\xA0]+$/g, "" );
	};
	
	// Custom selectors
	$.extend( $.expr.pseudos || $.expr[ ":" ], {		// '|| $.expr[ ":" ]' here enables backwards compatibility to jQuery 1.7. Can be removed when dropping jQ 1.7.x support
	
		// https://jqueryvalidation.org/blank-selector/
		blank: function( a ) {
			return !trim( "" + $( a ).val() );
		},
	
		// https://jqueryvalidation.org/filled-selector/
		filled: function( a ) {
			var val = $( a ).val();
			return val !== null && !!trim( "" + val );
		},
	
		// https://jqueryvalidation.org/unchecked-selector/
		unchecked: function( a ) {
			return !$( a ).prop( "checked" );
		}
	} );
	
	// Constructor for validator
	$.validator = function( options, form ) {
		this.settings = $.extend( true, {}, $.validator.defaults, options );
		this.currentForm = form;
		this.init();
	};
	
	// https://jqueryvalidation.org/jQuery.validator.format/
	$.validator.format = function( source, params ) {
		if ( arguments.length === 1 ) {
			return function() {
				var args = $.makeArray( arguments );
				args.unshift( source );
				return $.validator.format.apply( this, args );
			};
		}
		if ( params === undefined ) {
			return source;
		}
		if ( arguments.length > 2 && params.constructor !== Array  ) {
			params = $.makeArray( arguments ).slice( 1 );
		}
		if ( params.constructor !== Array ) {
			params = [ params ];
		}
		$.each( params, function( i, n ) {
			source = source.replace( new RegExp( "\\{" + i + "\\}", "g" ), function() {
				return n;
			} );
		} );
		return source;
	};
	
	$.extend( $.validator, {
	
		defaults: {
			messages: {},
			groups: {},
			rules: {},
			errorClass: "error",
			pendingClass: "pending",
			validClass: "valid",
			errorElement: "label",
			focusCleanup: false,
			focusInvalid: true,
			errorContainer: $( [] ),
			errorLabelContainer: $( [] ),
			onsubmit: true,
			ignore: ":hidden",
			ignoreTitle: false,
			onfocusin: function( element ) {
				this.lastActive = element;
	
				// Hide error label and remove error class on focus if enabled
				if ( this.settings.focusCleanup ) {
					if ( this.settings.unhighlight ) {
						this.settings.unhighlight.call( this, element, this.settings.errorClass, this.settings.validClass );
					}
					this.hideThese( this.errorsFor( element ) );
				}
			},
			onfocusout: function( element ) {
				if ( !this.checkable( element ) && ( element.name in this.submitted || !this.optional( element ) ) ) {
					this.element( element );
				}
			},
			onkeyup: function( element, event ) {
	
				// Avoid revalidate the field when pressing one of the following keys
				// Shift       => 16
				// Ctrl        => 17
				// Alt         => 18
				// Caps lock   => 20
				// End         => 35
				// Home        => 36
				// Left arrow  => 37
				// Up arrow    => 38
				// Right arrow => 39
				// Down arrow  => 40
				// Insert      => 45
				// Num lock    => 144
				// AltGr key   => 225
				var excludedKeys = [
					16, 17, 18, 20, 35, 36, 37,
					38, 39, 40, 45, 144, 225
				];
	
				if ( event.which === 9 && this.elementValue( element ) === "" || $.inArray( event.keyCode, excludedKeys ) !== -1 ) {
					return;
				} else if ( element.name in this.submitted || element.name in this.invalid ) {
					this.element( element );
				}
			},
			onclick: function( element ) {
	
				// Click on selects, radiobuttons and checkboxes
				if ( element.name in this.submitted ) {
					this.element( element );
	
				// Or option elements, check parent select in that case
				} else if ( element.parentNode.name in this.submitted ) {
					this.element( element.parentNode );
				}
			},
			highlight: function( element, errorClass, validClass ) {
				if ( element.type === "radio" ) {
					this.findByName( element.name ).addClass( errorClass ).removeClass( validClass );
				} else {
					$( element ).addClass( errorClass ).removeClass( validClass );
				}
			},
			unhighlight: function( element, errorClass, validClass ) {
				if ( element.type === "radio" ) {
					this.findByName( element.name ).removeClass( errorClass ).addClass( validClass );
				} else {
					$( element ).removeClass( errorClass ).addClass( validClass );
				}
			}
		},
	
		// https://jqueryvalidation.org/jQuery.validator.setDefaults/
		setDefaults: function( settings ) {
			$.extend( $.validator.defaults, settings );
		},
	
		messages: {
			required: "This field is required.",
			remote: "Please fix this field.",
			email: "Please enter a valid email address.",
			url: "Please enter a valid URL.",
			date: "Please enter a valid date.",
			dateISO: "Please enter a valid date (ISO).",
			number: "Please enter a valid number.",
			digits: "Please enter only digits.",
			equalTo: "Please enter the same value again.",
			maxlength: $.validator.format( "Please enter no more than {0} characters." ),
			minlength: $.validator.format( "Please enter at least {0} characters." ),
			rangelength: $.validator.format( "Please enter a value between {0} and {1} characters long." ),
			range: $.validator.format( "Please enter a value between {0} and {1}." ),
			max: $.validator.format( "Please enter a value less than or equal to {0}." ),
			min: $.validator.format( "Please enter a value greater than or equal to {0}." ),
			step: $.validator.format( "Please enter a multiple of {0}." )
		},
	
		autoCreateRanges: false,
	
		prototype: {
	
			init: function() {
				this.labelContainer = $( this.settings.errorLabelContainer );
				this.errorContext = this.labelContainer.length && this.labelContainer || $( this.currentForm );
				this.containers = $( this.settings.errorContainer ).add( this.settings.errorLabelContainer );
				this.submitted = {};
				this.valueCache = {};
				this.pendingRequest = 0;
				this.pending = {};
				this.invalid = {};
				this.reset();
	
				var currentForm = this.currentForm,
					groups = ( this.groups = {} ),
					rules;
				$.each( this.settings.groups, function( key, value ) {
					if ( typeof value === "string" ) {
						value = value.split( /\s/ );
					}
					$.each( value, function( index, name ) {
						groups[ name ] = key;
					} );
				} );
				rules = this.settings.rules;
				$.each( rules, function( key, value ) {
					rules[ key ] = $.validator.normalizeRule( value );
				} );
	
				function delegate( event ) {
					var isContentEditable = typeof $( this ).attr( "contenteditable" ) !== "undefined" && $( this ).attr( "contenteditable" ) !== "false";
	
					// Set form expando on contenteditable
					if ( !this.form && isContentEditable ) {
						this.form = $( this ).closest( "form" )[ 0 ];
						this.name = $( this ).attr( "name" );
					}
	
					// Ignore the element if it belongs to another form. This will happen mainly
					// when setting the `form` attribute of an input to the id of another form.
					if ( currentForm !== this.form ) {
						return;
					}
	
					var validator = $.data( this.form, "validator" ),
						eventType = "on" + event.type.replace( /^validate/, "" ),
						settings = validator.settings;
					if ( settings[ eventType ] && !$( this ).is( settings.ignore ) ) {
						settings[ eventType ].call( validator, this, event );
					}
				}
	
				$( this.currentForm )
					.on( "focusin.validate focusout.validate keyup.validate",
						":text, [type='password'], [type='file'], select, textarea, [type='number'], [type='search'], " +
						"[type='tel'], [type='url'], [type='email'], [type='datetime'], [type='date'], [type='month'], " +
						"[type='week'], [type='time'], [type='datetime-local'], [type='range'], [type='color'], " +
						"[type='radio'], [type='checkbox'], [contenteditable], [type='button']", delegate )
	
					// Support: Chrome, oldIE
					// "select" is provided as event.target when clicking a option
					.on( "click.validate", "select, option, [type='radio'], [type='checkbox']", delegate );
	
				if ( this.settings.invalidHandler ) {
					$( this.currentForm ).on( "invalid-form.validate", this.settings.invalidHandler );
				}
			},
	
			// https://jqueryvalidation.org/Validator.form/
			form: function() {
				this.checkForm();
				$.extend( this.submitted, this.errorMap );
				this.invalid = $.extend( {}, this.errorMap );
				if ( !this.valid() ) {
					$( this.currentForm ).triggerHandler( "invalid-form", [ this ] );
				}
				this.showErrors();
				return this.valid();
			},
	
			checkForm: function() {
				this.prepareForm();
				for ( var i = 0, elements = ( this.currentElements = this.elements() ); elements[ i ]; i++ ) {
					this.check( elements[ i ] );
				}
				return this.valid();
			},
	
			// https://jqueryvalidation.org/Validator.element/
			element: function( element ) {
				var cleanElement = this.clean( element ),
					checkElement = this.validationTargetFor( cleanElement ),
					v = this,
					result = true,
					rs, group;
	
				if ( checkElement === undefined ) {
					delete this.invalid[ cleanElement.name ];
				} else {
					this.prepareElement( checkElement );
					this.currentElements = $( checkElement );
	
					// If this element is grouped, then validate all group elements already
					// containing a value
					group = this.groups[ checkElement.name ];
					if ( group ) {
						$.each( this.groups, function( name, testgroup ) {
							if ( testgroup === group && name !== checkElement.name ) {
								cleanElement = v.validationTargetFor( v.clean( v.findByName( name ) ) );
								if ( cleanElement && cleanElement.name in v.invalid ) {
									v.currentElements.push( cleanElement );
									result = v.check( cleanElement ) && result;
								}
							}
						} );
					}
	
					rs = this.check( checkElement ) !== false;
					result = result && rs;
					if ( rs ) {
						this.invalid[ checkElement.name ] = false;
					} else {
						this.invalid[ checkElement.name ] = true;
					}
	
					if ( !this.numberOfInvalids() ) {
	
						// Hide error containers on last error
						this.toHide = this.toHide.add( this.containers );
					}
					this.showErrors();
	
					// Add aria-invalid status for screen readers
					$( element ).attr( "aria-invalid", !rs );
				}
	
				return result;
			},
	
			// https://jqueryvalidation.org/Validator.showErrors/
			showErrors: function( errors ) {
				if ( errors ) {
					var validator = this;
	
					// Add items to error list and map
					$.extend( this.errorMap, errors );
					this.errorList = $.map( this.errorMap, function( message, name ) {
						return {
							message: message,
							element: validator.findByName( name )[ 0 ]
						};
					} );
	
					// Remove items from success list
					this.successList = $.grep( this.successList, function( element ) {
						return !( element.name in errors );
					} );
				}
				if ( this.settings.showErrors ) {
					this.settings.showErrors.call( this, this.errorMap, this.errorList );
				} else {
					this.defaultShowErrors();
				}
			},
	
			// https://jqueryvalidation.org/Validator.resetForm/
			resetForm: function() {
				if ( $.fn.resetForm ) {
					$( this.currentForm ).resetForm();
				}
				this.invalid = {};
				this.submitted = {};
				this.prepareForm();
				this.hideErrors();
				var elements = this.elements()
					.removeData( "previousValue" )
					.removeAttr( "aria-invalid" );
	
				this.resetElements( elements );
			},
	
			resetElements: function( elements ) {
				var i;
	
				if ( this.settings.unhighlight ) {
					for ( i = 0; elements[ i ]; i++ ) {
						this.settings.unhighlight.call( this, elements[ i ],
							this.settings.errorClass, "" );
						this.findByName( elements[ i ].name ).removeClass( this.settings.validClass );
					}
				} else {
					elements
						.removeClass( this.settings.errorClass )
						.removeClass( this.settings.validClass );
				}
			},
	
			numberOfInvalids: function() {
				return this.objectLength( this.invalid );
			},
	
			objectLength: function( obj ) {
				/* jshint unused: false */
				var count = 0,
					i;
				for ( i in obj ) {
	
					// This check allows counting elements with empty error
					// message as invalid elements
					if ( obj[ i ] !== undefined && obj[ i ] !== null && obj[ i ] !== false ) {
						count++;
					}
				}
				return count;
			},
	
			hideErrors: function() {
				this.hideThese( this.toHide );
			},
	
			hideThese: function( errors ) {
				errors.not( this.containers ).text( "" );
				this.addWrapper( errors ).hide();
			},
	
			valid: function() {
				return this.size() === 0;
			},
	
			size: function() {
				return this.errorList.length;
			},
	
			focusInvalid: function() {
				if ( this.settings.focusInvalid ) {
					try {
						$( this.findLastActive() || this.errorList.length && this.errorList[ 0 ].element || [] )
						.filter( ":visible" )
						.trigger( "focus" )
	
						// Manually trigger focusin event; without it, focusin handler isn't called, findLastActive won't have anything to find
						.trigger( "focusin" );
					} catch ( e ) {
	
						// Ignore IE throwing errors when focusing hidden elements
					}
				}
			},
	
			findLastActive: function() {
				var lastActive = this.lastActive;
				return lastActive && $.grep( this.errorList, function( n ) {
					return n.element.name === lastActive.name;
				} ).length === 1 && lastActive;
			},
	
			elements: function() {
				var validator = this,
					rulesCache = {};
	
				// Select all valid inputs inside the form (no submit or reset buttons)
				return $( this.currentForm )
				.find( "input, select, textarea, [contenteditable]" )
				.not( ":submit, :reset, :image, :disabled" )
				.not( this.settings.ignore )
				.filter( function() {
					var name = this.name || $( this ).attr( "name" ); // For contenteditable
					var isContentEditable = typeof $( this ).attr( "contenteditable" ) !== "undefined" && $( this ).attr( "contenteditable" ) !== "false";
	
					if ( !name && validator.settings.debug && window.console ) {
						console.error( "%o has no name assigned", this );
					}
	
					// Set form expando on contenteditable
					if ( isContentEditable ) {
						this.form = $( this ).closest( "form" )[ 0 ];
						this.name = name;
					}
	
					// Ignore elements that belong to other/nested forms
					if ( this.form !== validator.currentForm ) {
						return false;
					}
	
					// Select only the first element for each name, and only those with rules specified
					if ( name in rulesCache || !validator.objectLength( $( this ).rules() ) ) {
						return false;
					}
	
					rulesCache[ name ] = true;
					return true;
				} );
			},
	
			clean: function( selector ) {
				return $( selector )[ 0 ];
			},
	
			errors: function() {
				var errorClass = this.settings.errorClass.split( " " ).join( "." );
				return $( this.settings.errorElement + "." + errorClass, this.errorContext );
			},
	
			resetInternals: function() {
				this.successList = [];
				this.errorList = [];
				this.errorMap = {};
				this.toShow = $( [] );
				this.toHide = $( [] );
			},
	
			reset: function() {
				this.resetInternals();
				this.currentElements = $( [] );
			},
	
			prepareForm: function() {
				this.reset();
				this.toHide = this.errors().add( this.containers );
			},
	
			prepareElement: function( element ) {
				this.reset();
				this.toHide = this.errorsFor( element );
			},
	
			elementValue: function( element ) {
				var $element = $( element ),
					type = element.type,
					isContentEditable = typeof $element.attr( "contenteditable" ) !== "undefined" && $element.attr( "contenteditable" ) !== "false",
					val, idx;
	
				if ( type === "radio" || type === "checkbox" ) {
					return this.findByName( element.name ).filter( ":checked" ).val();
				} else if ( type === "number" && typeof element.validity !== "undefined" ) {
					return element.validity.badInput ? "NaN" : $element.val();
				}
	
				if ( isContentEditable ) {
					val = $element.text();
				} else {
					val = $element.val();
				}
	
				if ( type === "file" ) {
	
					// Modern browser (chrome & safari)
					if ( val.substr( 0, 12 ) === "C:\\fakepath\\" ) {
						return val.substr( 12 );
					}
	
					// Legacy browsers
					// Unix-based path
					idx = val.lastIndexOf( "/" );
					if ( idx >= 0 ) {
						return val.substr( idx + 1 );
					}
	
					// Windows-based path
					idx = val.lastIndexOf( "\\" );
					if ( idx >= 0 ) {
						return val.substr( idx + 1 );
					}
	
					// Just the file name
					return val;
				}
	
				if ( typeof val === "string" ) {
					return val.replace( /\r/g, "" );
				}
				return val;
			},
	
			check: function( element ) {
				element = this.validationTargetFor( this.clean( element ) );
	
				var rules = $( element ).rules(),
					rulesCount = $.map( rules, function( n, i ) {
						return i;
					} ).length,
					dependencyMismatch = false,
					val = this.elementValue( element ),
					result, method, rule, normalizer;
	
				// Prioritize the local normalizer defined for this element over the global one
				// if the former exists, otherwise user the global one in case it exists.
				if ( typeof rules.normalizer === "function" ) {
					normalizer = rules.normalizer;
				} else if (	typeof this.settings.normalizer === "function" ) {
					normalizer = this.settings.normalizer;
				}
	
				// If normalizer is defined, then call it to retreive the changed value instead
				// of using the real one.
				// Note that `this` in the normalizer is `element`.
				if ( normalizer ) {
					val = normalizer.call( element, val );
	
					// Delete the normalizer from rules to avoid treating it as a pre-defined method.
					delete rules.normalizer;
				}
	
				for ( method in rules ) {
					rule = { method: method, parameters: rules[ method ] };
					try {
						result = $.validator.methods[ method ].call( this, val, element, rule.parameters );
	
						// If a method indicates that the field is optional and therefore valid,
						// don't mark it as valid when there are no other rules
						if ( result === "dependency-mismatch" && rulesCount === 1 ) {
							dependencyMismatch = true;
							continue;
						}
						dependencyMismatch = false;
	
						if ( result === "pending" ) {
							this.toHide = this.toHide.not( this.errorsFor( element ) );
							return;
						}
	
						if ( !result ) {
							this.formatAndAdd( element, rule );
							return false;
						}
					} catch ( e ) {
						if ( this.settings.debug && window.console ) {
							console.log( "Exception occurred when checking element " + element.id + ", check the '" + rule.method + "' method.", e );
						}
						if ( e instanceof TypeError ) {
							e.message += ".  Exception occurred when checking element " + element.id + ", check the '" + rule.method + "' method.";
						}
	
						throw e;
					}
				}
				if ( dependencyMismatch ) {
					return;
				}
				if ( this.objectLength( rules ) ) {
					this.successList.push( element );
				}
				return true;
			},
	
			// Return the custom message for the given element and validation method
			// specified in the element's HTML5 data attribute
			// return the generic message if present and no method specific message is present
			customDataMessage: function( element, method ) {
				return $( element ).data( "msg" + method.charAt( 0 ).toUpperCase() +
					method.substring( 1 ).toLowerCase() ) || $( element ).data( "msg" );
			},
	
			// Return the custom message for the given element name and validation method
			customMessage: function( name, method ) {
				var m = this.settings.messages[ name ];
				return m && ( m.constructor === String ? m : m[ method ] );
			},
	
			// Return the first defined argument, allowing empty strings
			findDefined: function() {
				for ( var i = 0; i < arguments.length; i++ ) {
					if ( arguments[ i ] !== undefined ) {
						return arguments[ i ];
					}
				}
				return undefined;
			},
	
			// The second parameter 'rule' used to be a string, and extended to an object literal
			// of the following form:
			// rule = {
			//     method: "method name",
			//     parameters: "the given method parameters"
			// }
			//
			// The old behavior still supported, kept to maintain backward compatibility with
			// old code, and will be removed in the next major release.
			defaultMessage: function( element, rule ) {
				if ( typeof rule === "string" ) {
					rule = { method: rule };
				}
	
				var message = this.findDefined(
						this.customMessage( element.name, rule.method ),
						this.customDataMessage( element, rule.method ),
	
						// 'title' is never undefined, so handle empty string as undefined
						!this.settings.ignoreTitle && element.title || undefined,
						$.validator.messages[ rule.method ],
						"<strong>Warning: No message defined for " + element.name + "</strong>"
					),
					theregex = /\$?\{(\d+)\}/g;
				if ( typeof message === "function" ) {
					message = message.call( this, rule.parameters, element );
				} else if ( theregex.test( message ) ) {
					message = $.validator.format( message.replace( theregex, "{$1}" ), rule.parameters );
				}
	
				return message;
			},
	
			formatAndAdd: function( element, rule ) {
				var message = this.defaultMessage( element, rule );
	
				this.errorList.push( {
					message: message,
					element: element,
					method: rule.method
				} );
	
				this.errorMap[ element.name ] = message;
				this.submitted[ element.name ] = message;
			},
	
			addWrapper: function( toToggle ) {
				if ( this.settings.wrapper ) {
					toToggle = toToggle.add( toToggle.parent( this.settings.wrapper ) );
				}
				return toToggle;
			},
	
			defaultShowErrors: function() {
				var i, elements, error;
				for ( i = 0; this.errorList[ i ]; i++ ) {
					error = this.errorList[ i ];
					if ( this.settings.highlight ) {
						this.settings.highlight.call( this, error.element, this.settings.errorClass, this.settings.validClass );
					}
					this.showLabel( error.element, error.message );
				}
				if ( this.errorList.length ) {
					this.toShow = this.toShow.add( this.containers );
				}
				if ( this.settings.success ) {
					for ( i = 0; this.successList[ i ]; i++ ) {
						this.showLabel( this.successList[ i ] );
					}
				}
				if ( this.settings.unhighlight ) {
					for ( i = 0, elements = this.validElements(); elements[ i ]; i++ ) {
						this.settings.unhighlight.call( this, elements[ i ], this.settings.errorClass, this.settings.validClass );
					}
				}
				this.toHide = this.toHide.not( this.toShow );
				this.hideErrors();
				this.addWrapper( this.toShow ).show();
			},
	
			validElements: function() {
				return this.currentElements.not( this.invalidElements() );
			},
	
			invalidElements: function() {
				return $( this.errorList ).map( function() {
					return this.element;
				} );
			},
	
			showLabel: function( element, message ) {
				var place, group, errorID, v,
					error = this.errorsFor( element ),
					elementID = this.idOrName( element ),
					describedBy = $( element ).attr( "aria-describedby" );
	
				if ( error.length ) {
	
					// Refresh error/success class
					error.removeClass( this.settings.validClass ).addClass( this.settings.errorClass );
	
					// Replace message on existing label
					error.html( message );
				} else {
	
					// Create error element
					error = $( "<" + this.settings.errorElement + ">" )
						.attr( "id", elementID + "-error" )
						.addClass( this.settings.errorClass )
						.html( message || "" );
	
					// Maintain reference to the element to be placed into the DOM
					place = error;
					if ( this.settings.wrapper ) {
	
						// Make sure the element is visible, even in IE
						// actually showing the wrapped element is handled elsewhere
						place = error.hide().show().wrap( "<" + this.settings.wrapper + "/>" ).parent();
					}
					if ( this.labelContainer.length ) {
						this.labelContainer.append( place );
					} else if ( this.settings.errorPlacement ) {
						this.settings.errorPlacement.call( this, place, $( element ) );
					} else {
						place.insertAfter( element );
					}
	
					// Link error back to the element
					if ( error.is( "label" ) ) {
	
						// If the error is a label, then associate using 'for'
						error.attr( "for", elementID );
	
						// If the element is not a child of an associated label, then it's necessary
						// to explicitly apply aria-describedby
					} else if ( error.parents( "label[for='" + this.escapeCssMeta( elementID ) + "']" ).length === 0 ) {
						errorID = error.attr( "id" );
	
						// Respect existing non-error aria-describedby
						if ( !describedBy ) {
							describedBy = errorID;
						} else if ( !describedBy.match( new RegExp( "\\b" + this.escapeCssMeta( errorID ) + "\\b" ) ) ) {
	
							// Add to end of list if not already present
							describedBy += " " + errorID;
						}
						$( element ).attr( "aria-describedby", describedBy );
	
						// If this element is grouped, then assign to all elements in the same group
						group = this.groups[ element.name ];
						if ( group ) {
							v = this;
							$.each( v.groups, function( name, testgroup ) {
								if ( testgroup === group ) {
									$( "[name='" + v.escapeCssMeta( name ) + "']", v.currentForm )
										.attr( "aria-describedby", error.attr( "id" ) );
								}
							} );
						}
					}
				}
				if ( !message && this.settings.success ) {
					error.text( "" );
					if ( typeof this.settings.success === "string" ) {
						error.addClass( this.settings.success );
					} else {
						this.settings.success( error, element );
					}
				}
				this.toShow = this.toShow.add( error );
			},
	
			errorsFor: function( element ) {
				var name = this.escapeCssMeta( this.idOrName( element ) ),
					describer = $( element ).attr( "aria-describedby" ),
					selector = "label[for='" + name + "'], label[for='" + name + "'] *";
	
				// 'aria-describedby' should directly reference the error element
				if ( describer ) {
					selector = selector + ", #" + this.escapeCssMeta( describer )
						.replace( /\s+/g, ", #" );
				}
	
				return this
					.errors()
					.filter( selector );
			},
	
			// See https://api.jquery.com/category/selectors/, for CSS
			// meta-characters that should be escaped in order to be used with JQuery
			// as a literal part of a name/id or any selector.
			escapeCssMeta: function( string ) {
				return string.replace( /([\\!"#$%&'()*+,./:;<=>?@\[\]^`{|}~])/g, "\\$1" );
			},
	
			idOrName: function( element ) {
				return this.groups[ element.name ] || ( this.checkable( element ) ? element.name : element.id || element.name );
			},
	
			validationTargetFor: function( element ) {
	
				// If radio/checkbox, validate first element in group instead
				if ( this.checkable( element ) ) {
					element = this.findByName( element.name );
				}
	
				// Always apply ignore filter
				return $( element ).not( this.settings.ignore )[ 0 ];
			},
	
			checkable: function( element ) {
				return ( /radio|checkbox/i ).test( element.type );
			},
	
			findByName: function( name ) {
				return $( this.currentForm ).find( "[name='" + this.escapeCssMeta( name ) + "']" );
			},
	
			getLength: function( value, element ) {
				switch ( element.nodeName.toLowerCase() ) {
				case "select":
					return $( "option:selected", element ).length;
				case "input":
					if ( this.checkable( element ) ) {
						return this.findByName( element.name ).filter( ":checked" ).length;
					}
				}
				return value.length;
			},
	
			depend: function( param, element ) {
				return this.dependTypes[ typeof param ] ? this.dependTypes[ typeof param ]( param, element ) : true;
			},
	
			dependTypes: {
				"boolean": function( param ) {
					return param;
				},
				"string": function( param, element ) {
					return !!$( param, element.form ).length;
				},
				"function": function( param, element ) {
					return param( element );
				}
			},
	
			optional: function( element ) {
				var val = this.elementValue( element );
				return !$.validator.methods.required.call( this, val, element ) && "dependency-mismatch";
			},
	
			startRequest: function( element ) {
				if ( !this.pending[ element.name ] ) {
					this.pendingRequest++;
					$( element ).addClass( this.settings.pendingClass );
					this.pending[ element.name ] = true;
				}
			},
	
			stopRequest: function( element, valid ) {
				this.pendingRequest--;
	
				// Sometimes synchronization fails, make sure pendingRequest is never < 0
				if ( this.pendingRequest < 0 ) {
					this.pendingRequest = 0;
				}
				delete this.pending[ element.name ];
				$( element ).removeClass( this.settings.pendingClass );
				if ( valid && this.pendingRequest === 0 && this.formSubmitted && this.form() ) {
					$( this.currentForm ).submit();
	
					// Remove the hidden input that was used as a replacement for the
					// missing submit button. The hidden input is added by `handle()`
					// to ensure that the value of the used submit button is passed on
					// for scripted submits triggered by this method
					if ( this.submitButton ) {
						$( "input:hidden[name='" + this.submitButton.name + "']", this.currentForm ).remove();
					}
	
					this.formSubmitted = false;
				} else if ( !valid && this.pendingRequest === 0 && this.formSubmitted ) {
					$( this.currentForm ).triggerHandler( "invalid-form", [ this ] );
					this.formSubmitted = false;
				}
			},
	
			previousValue: function( element, method ) {
				method = typeof method === "string" && method || "remote";
	
				return $.data( element, "previousValue" ) || $.data( element, "previousValue", {
					old: null,
					valid: true,
					message: this.defaultMessage( element, { method: method } )
				} );
			},
	
			// Cleans up all forms and elements, removes validator-specific events
			destroy: function() {
				this.resetForm();
	
				$( this.currentForm )
					.off( ".validate" )
					.removeData( "validator" )
					.find( ".validate-equalTo-blur" )
						.off( ".validate-equalTo" )
						.removeClass( "validate-equalTo-blur" )
					.find( ".validate-lessThan-blur" )
						.off( ".validate-lessThan" )
						.removeClass( "validate-lessThan-blur" )
					.find( ".validate-lessThanEqual-blur" )
						.off( ".validate-lessThanEqual" )
						.removeClass( "validate-lessThanEqual-blur" )
					.find( ".validate-greaterThanEqual-blur" )
						.off( ".validate-greaterThanEqual" )
						.removeClass( "validate-greaterThanEqual-blur" )
					.find( ".validate-greaterThan-blur" )
						.off( ".validate-greaterThan" )
						.removeClass( "validate-greaterThan-blur" );
			}
	
		},
	
		classRuleSettings: {
			required: { required: true },
			email: { email: true },
			url: { url: true },
			date: { date: true },
			dateISO: { dateISO: true },
			number: { number: true },
			digits: { digits: true },
			creditcard: { creditcard: true }
		},
	
		addClassRules: function( className, rules ) {
			if ( className.constructor === String ) {
				this.classRuleSettings[ className ] = rules;
			} else {
				$.extend( this.classRuleSettings, className );
			}
		},
	
		classRules: function( element ) {
			var rules = {},
				classes = $( element ).attr( "class" );
	
			if ( classes ) {
				$.each( classes.split( " " ), function() {
					if ( this in $.validator.classRuleSettings ) {
						$.extend( rules, $.validator.classRuleSettings[ this ] );
					}
				} );
			}
			return rules;
		},
	
		normalizeAttributeRule: function( rules, type, method, value ) {
	
			// Convert the value to a number for number inputs, and for text for backwards compability
			// allows type="date" and others to be compared as strings
			if ( /min|max|step/.test( method ) && ( type === null || /number|range|text/.test( type ) ) ) {
				value = Number( value );
	
				// Support Opera Mini, which returns NaN for undefined minlength
				if ( isNaN( value ) ) {
					value = undefined;
				}
			}
	
			if ( value || value === 0 ) {
				rules[ method ] = value;
			} else if ( type === method && type !== "range" ) {
	
				// Exception: the jquery validate 'range' method
				// does not test for the html5 'range' type
				rules[ method ] = true;
			}
		},
	
		attributeRules: function( element ) {
			var rules = {},
				$element = $( element ),
				type = element.getAttribute( "type" ),
				method, value;
	
			for ( method in $.validator.methods ) {
	
				// Support for <input required> in both html5 and older browsers
				if ( method === "required" ) {
					value = element.getAttribute( method );
	
					// Some browsers return an empty string for the required attribute
					// and non-HTML5 browsers might have required="" markup
					if ( value === "" ) {
						value = true;
					}
	
					// Force non-HTML5 browsers to return bool
					value = !!value;
				} else {
					value = $element.attr( method );
				}
	
				this.normalizeAttributeRule( rules, type, method, value );
			}
	
			// 'maxlength' may be returned as -1, 2147483647 ( IE ) and 524288 ( safari ) for text inputs
			if ( rules.maxlength && /-1|2147483647|524288/.test( rules.maxlength ) ) {
				delete rules.maxlength;
			}
	
			return rules;
		},
	
		dataRules: function( element ) {
			var rules = {},
				$element = $( element ),
				type = element.getAttribute( "type" ),
				method, value;
	
			for ( method in $.validator.methods ) {
				value = $element.data( "rule" + method.charAt( 0 ).toUpperCase() + method.substring( 1 ).toLowerCase() );
	
				// Cast empty attributes like `data-rule-required` to `true`
				if ( value === "" ) {
					value = true;
				}
	
				this.normalizeAttributeRule( rules, type, method, value );
			}
			return rules;
		},
	
		staticRules: function( element ) {
			var rules = {},
				validator = $.data( element.form, "validator" );
	
			if ( validator.settings.rules ) {
				rules = $.validator.normalizeRule( validator.settings.rules[ element.name ] ) || {};
			}
			return rules;
		},
	
		normalizeRules: function( rules, element ) {
	
			// Handle dependency check
			$.each( rules, function( prop, val ) {
	
				// Ignore rule when param is explicitly false, eg. required:false
				if ( val === false ) {
					delete rules[ prop ];
					return;
				}
				if ( val.param || val.depends ) {
					var keepRule = true;
					switch ( typeof val.depends ) {
					case "string":
						keepRule = !!$( val.depends, element.form ).length;
						break;
					case "function":
						keepRule = val.depends.call( element, element );
						break;
					}
					if ( keepRule ) {
						rules[ prop ] = val.param !== undefined ? val.param : true;
					} else {
						$.data( element.form, "validator" ).resetElements( $( element ) );
						delete rules[ prop ];
					}
				}
			} );
	
			// Evaluate parameters
			$.each( rules, function( rule, parameter ) {
				rules[ rule ] = typeof parameter === "function" && rule !== "normalizer" ? parameter( element ) : parameter;
			} );
	
			// Clean number parameters
			$.each( [ "minlength", "maxlength" ], function() {
				if ( rules[ this ] ) {
					rules[ this ] = Number( rules[ this ] );
				}
			} );
			$.each( [ "rangelength", "range" ], function() {
				var parts;
				if ( rules[ this ] ) {
					if ( Array.isArray( rules[ this ] ) ) {
						rules[ this ] = [ Number( rules[ this ][ 0 ] ), Number( rules[ this ][ 1 ] ) ];
					} else if ( typeof rules[ this ] === "string" ) {
						parts = rules[ this ].replace( /[\[\]]/g, "" ).split( /[\s,]+/ );
						rules[ this ] = [ Number( parts[ 0 ] ), Number( parts[ 1 ] ) ];
					}
				}
			} );
	
			if ( $.validator.autoCreateRanges ) {
	
				// Auto-create ranges
				if ( rules.min != null && rules.max != null ) {
					rules.range = [ rules.min, rules.max ];
					delete rules.min;
					delete rules.max;
				}
				if ( rules.minlength != null && rules.maxlength != null ) {
					rules.rangelength = [ rules.minlength, rules.maxlength ];
					delete rules.minlength;
					delete rules.maxlength;
				}
			}
	
			return rules;
		},
	
		// Converts a simple string to a {string: true} rule, e.g., "required" to {required:true}
		normalizeRule: function( data ) {
			if ( typeof data === "string" ) {
				var transformed = {};
				$.each( data.split( /\s/ ), function() {
					transformed[ this ] = true;
				} );
				data = transformed;
			}
			return data;
		},
	
		// https://jqueryvalidation.org/jQuery.validator.addMethod/
		addMethod: function( name, method, message ) {
			$.validator.methods[ name ] = method;
			$.validator.messages[ name ] = message !== undefined ? message : $.validator.messages[ name ];
			if ( method.length < 3 ) {
				$.validator.addClassRules( name, $.validator.normalizeRule( name ) );
			}
		},
	
		// https://jqueryvalidation.org/jQuery.validator.methods/
		methods: {
	
			// https://jqueryvalidation.org/required-method/
			required: function( value, element, param ) {
	
				// Check if dependency is met
				if ( !this.depend( param, element ) ) {
					return "dependency-mismatch";
				}
				if ( element.nodeName.toLowerCase() === "select" ) {
	
					// Could be an array for select-multiple or a string, both are fine this way
					var val = $( element ).val();
					return val && val.length > 0;
				}
				if ( this.checkable( element ) ) {
					return this.getLength( value, element ) > 0;
				}
				return value !== undefined && value !== null && value.length > 0;
			},
	
			// https://jqueryvalidation.org/email-method/
			email: function( value, element ) {
	
				// From https://html.spec.whatwg.org/multipage/forms.html#valid-e-mail-address
				// Retrieved 2014-01-14
				// If you have a problem with this implementation, report a bug against the above spec
				// Or use custom methods to implement your own email validation
				return this.optional( element ) || /^[a-zA-Z0-9.!#$%&'*+\/=?^_`{|}~-]+@[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?(?:\.[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?)*$/.test( value );
			},
	
			// https://jqueryvalidation.org/url-method/
			url: function( value, element ) {
	
				// Copyright (c) 2010-2013 Diego Perini, MIT licensed
				// https://gist.github.com/dperini/729294
				// see also https://mathiasbynens.be/demo/url-regex
				// modified to allow protocol-relative URLs
				return this.optional( element ) || /^(?:(?:(?:https?|ftp):)?\/\/)(?:\S+(?::\S*)?@)?(?:(?!(?:10|127)(?:\.\d{1,3}){3})(?!(?:169\.254|192\.168)(?:\.\d{1,3}){2})(?!172\.(?:1[6-9]|2\d|3[0-1])(?:\.\d{1,3}){2})(?:[1-9]\d?|1\d\d|2[01]\d|22[0-3])(?:\.(?:1?\d{1,2}|2[0-4]\d|25[0-5])){2}(?:\.(?:[1-9]\d?|1\d\d|2[0-4]\d|25[0-4]))|(?:(?:[a-z0-9\u00a1-\uffff][a-z0-9\u00a1-\uffff_-]{0,62})?[a-z0-9\u00a1-\uffff]\.)+(?:[a-z\u00a1-\uffff]{2,}\.?))(?::\d{2,5})?(?:[/?#]\S*)?$/i.test( value );
			},
	
			// https://jqueryvalidation.org/date-method/
			date: ( function() {
				var called = false;
	
				return function( value, element ) {
					if ( !called ) {
						called = true;
						if ( this.settings.debug && window.console ) {
							console.warn(
								"The `date` method is deprecated and will be removed in version '2.0.0'.\n" +
								"Please don't use it, since it relies on the Date constructor, which\n" +
								"behaves very differently across browsers and locales. Use `dateISO`\n" +
								"instead or one of the locale specific methods in `localizations/`\n" +
								"and `additional-methods.js`."
							);
						}
					}
	
					return this.optional( element ) || !/Invalid|NaN/.test( new Date( value ).toString() );
				};
			}() ),
	
			// https://jqueryvalidation.org/dateISO-method/
			dateISO: function( value, element ) {
				return this.optional( element ) || /^\d{4}[\/\-](0?[1-9]|1[012])[\/\-](0?[1-9]|[12][0-9]|3[01])$/.test( value );
			},
	
			// https://jqueryvalidation.org/number-method/
			number: function( value, element ) {
				return this.optional( element ) || /^(?:-?\d+|-?\d{1,3}(?:,\d{3})+)?(?:\.\d+)?$/.test( value );
			},
	
			// https://jqueryvalidation.org/digits-method/
			digits: function( value, element ) {
				return this.optional( element ) || /^\d+$/.test( value );
			},
	
			// https://jqueryvalidation.org/minlength-method/
			minlength: function( value, element, param ) {
				var length = Array.isArray( value ) ? value.length : this.getLength( value, element );
				return this.optional( element ) || length >= param;
			},
	
			// https://jqueryvalidation.org/maxlength-method/
			maxlength: function( value, element, param ) {
				var length = Array.isArray( value ) ? value.length : this.getLength( value, element );
				return this.optional( element ) || length <= param;
			},
	
			// https://jqueryvalidation.org/rangelength-method/
			rangelength: function( value, element, param ) {
				var length = Array.isArray( value ) ? value.length : this.getLength( value, element );
				return this.optional( element ) || ( length >= param[ 0 ] && length <= param[ 1 ] );
			},
	
			// https://jqueryvalidation.org/min-method/
			min: function( value, element, param ) {
				return this.optional( element ) || value >= param;
			},
	
			// https://jqueryvalidation.org/max-method/
			max: function( value, element, param ) {
				return this.optional( element ) || value <= param;
			},
	
			// https://jqueryvalidation.org/range-method/
			range: function( value, element, param ) {
				return this.optional( element ) || ( value >= param[ 0 ] && value <= param[ 1 ] );
			},
	
			// https://jqueryvalidation.org/step-method/
			step: function( value, element, param ) {
				var type = $( element ).attr( "type" ),
					errorMessage = "Step attribute on input type " + type + " is not supported.",
					supportedTypes = [ "text", "number", "range" ],
					re = new RegExp( "\\b" + type + "\\b" ),
					notSupported = type && !re.test( supportedTypes.join() ),
					decimalPlaces = function( num ) {
						var match = ( "" + num ).match( /(?:\.(\d+))?$/ );
						if ( !match ) {
							return 0;
						}
	
						// Number of digits right of decimal point.
						return match[ 1 ] ? match[ 1 ].length : 0;
					},
					toInt = function( num ) {
						return Math.round( num * Math.pow( 10, decimals ) );
					},
					valid = true,
					decimals;
	
				// Works only for text, number and range input types
				// TODO find a way to support input types date, datetime, datetime-local, month, time and week
				if ( notSupported ) {
					throw new Error( errorMessage );
				}
	
				decimals = decimalPlaces( param );
	
				// Value can't have too many decimals
				if ( decimalPlaces( value ) > decimals || toInt( value ) % toInt( param ) !== 0 ) {
					valid = false;
				}
	
				return this.optional( element ) || valid;
			},
	
			// https://jqueryvalidation.org/equalTo-method/
			equalTo: function( value, element, param ) {
	
				// Bind to the blur event of the target in order to revalidate whenever the target field is updated
				var target = $( param );
				if ( this.settings.onfocusout && target.not( ".validate-equalTo-blur" ).length ) {
					target.addClass( "validate-equalTo-blur" ).on( "blur.validate-equalTo", function() {
						$( element ).valid();
					} );
				}
				return value === target.val();
			},
	
			// https://jqueryvalidation.org/remote-method/
			remote: function( value, element, param, method ) {
				if ( this.optional( element ) ) {
					return "dependency-mismatch";
				}
	
				method = typeof method === "string" && method || "remote";
	
				var previous = this.previousValue( element, method ),
					validator, data, optionDataString;
	
				if ( !this.settings.messages[ element.name ] ) {
					this.settings.messages[ element.name ] = {};
				}
				previous.originalMessage = previous.originalMessage || this.settings.messages[ element.name ][ method ];
				this.settings.messages[ element.name ][ method ] = previous.message;
	
				param = typeof param === "string" && { url: param } || param;
				optionDataString = $.param( $.extend( { data: value }, param.data ) );
				if ( previous.old === optionDataString ) {
					return previous.valid;
				}
	
				previous.old = optionDataString;
				validator = this;
				this.startRequest( element );
				data = {};
				data[ element.name ] = value;
				$.ajax( $.extend( true, {
					mode: "abort",
					port: "validate" + element.name,
					dataType: "json",
					data: data,
					context: validator.currentForm,
					success: function( response ) {
						var valid = response === true || response === "true",
							errors, message, submitted;
	
						validator.settings.messages[ element.name ][ method ] = previous.originalMessage;
						if ( valid ) {
							submitted = validator.formSubmitted;
							validator.resetInternals();
							validator.toHide = validator.errorsFor( element );
							validator.formSubmitted = submitted;
							validator.successList.push( element );
							validator.invalid[ element.name ] = false;
							validator.showErrors();
						} else {
							errors = {};
							message = response || validator.defaultMessage( element, { method: method, parameters: value } );
							errors[ element.name ] = previous.message = message;
							validator.invalid[ element.name ] = true;
							validator.showErrors( errors );
						}
						previous.valid = valid;
						validator.stopRequest( element, valid );
					}
				}, param ) );
				return "pending";
			}
		}
	
	} );
	
	// Ajax mode: abort
	// usage: $.ajax({ mode: "abort"[, port: "uniqueport"]});
	// if mode:"abort" is used, the previous request on that port (port can be undefined) is aborted via XMLHttpRequest.abort()
	
	var pendingRequests = {},
		ajax;
	
	// Use a prefilter if available (1.5+)
	if ( $.ajaxPrefilter ) {
		$.ajaxPrefilter( function( settings, _, xhr ) {
			var port = settings.port;
			if ( settings.mode === "abort" ) {
				if ( pendingRequests[ port ] ) {
					pendingRequests[ port ].abort();
				}
				pendingRequests[ port ] = xhr;
			}
		} );
	} else {
	
		// Proxy ajax
		ajax = $.ajax;
		$.ajax = function( settings ) {
			var mode = ( "mode" in settings ? settings : $.ajaxSettings ).mode,
				port = ( "port" in settings ? settings : $.ajaxSettings ).port;
			if ( mode === "abort" ) {
				if ( pendingRequests[ port ] ) {
					pendingRequests[ port ].abort();
				}
				pendingRequests[ port ] = ajax.apply( this, arguments );
				return pendingRequests[ port ];
			}
			return ajax.apply( this, arguments );
		};
	}
	return $;
	}));

/***/ }),
/* 85 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function($) {'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.sendAjaxForm = sendAjaxForm;
	exports.initAjaxForm = initAjaxForm;
	/* * * * * * * * * * * * * * * * * * * * * * * * * * * * * *
	
	Global solution for simple AJAX forms
	
	Usage:
	
	<div id="example-form-container">
	    <form class="ajax-form" data-form-container-id="example-form-container" data-success-data-layer-event="newsletter.sent" action="/example-url/">
	        <div
	            data-layer-variable="example-variable-1"
	            data-layer-value="example-value-1"
	            >
	        </div>
	        ...
	    </form>
	</div>
	
	Google Tag Manager GTM note:
	
	Send a custom event to GTM by adding the 'data-success-data-layer-event' attribute to the <form> and pass a value e.g. 'newsletter.sent' that matched your GTM settings.
	
	Important:
	
	Obviously, the container ID ("example-form-container") has to be unique, not just to pass the HTML validator.
	
	*/
	
	function sendAjaxForm($form) {
	
	    // init
	    var url = $form.attr('action');
	    var custom_event = $form.attr('data-success-data-layer-event');
	    var custom_event_id = $form.attr('data-success-data-layer-event-identifier');
	    if (!custom_event_id) custom_event_id = '';
	    var success_url = $form.attr('data-success-url');
	    var container_id = $form.attr('data-form-container-id');
	    var postData = $form.serialize();
	
	    // define the container in which the ajax response will be written into
	    // 1. in case an ID is defined, select that element
	    if (container_id) {
	        var $form_container = $('#' + container_id);
	        if ($form_container.length == 0) {
	            console.warn('The form\'s "data-form-container-id" is set to "' + container_id + '" but element can not be found in DOM');
	        }
	    }
	    // 2. default: use immediate parent
	    else {
	            var $form_container = $form.parent();
	        }
	
	    // AJAX magic
	    $.ajax({
	        type: "POST",
	        url: url,
	        data: postData,
	        success: function success(data, textStatus, jqXHR) {
	            // do we get a custom URL from view?
	            if (data.success_url) {
	                window.location.href = data.success_url;
	            }
	            // otherwise, write HTML
	            else {
	                    $form_container.html(data);
	                }
	            // Note: If there are errors that we couldn't catch with the JavaScript form validation we get a '206' status code from the form's view
	            if (jqXHR.status === 206) {}
	            // something wrong while sending the form
	
	            // made it.. finally!
	            else {
	                    // Google Tag Manager in use?
	                    if (typeof dataLayer !== 'undefined') {
	                        // Is there a custom event defined?
	                        if (custom_event) {
	                            // add values to array
	                            // send postData as object
	                            var formData = {};
	                            $form.serializeArray().map(function (item) {
	                                formData[item.name] = item.value;
	                            });
	                            dataLayer.push({
	                                'event': custom_event,
	                                'form_id': custom_event_id,
	                                'formData': formData
	                            });
	                        }
	                    }
	                }
	
	            // trigger custom events
	            $(window).trigger('ajaxFormSuccess');
	            $(window).trigger('initAjaxForm');
	            $(window).trigger('initDatepicker');
	            $(window).trigger('initFormModalClose');
	            $(window).trigger('initFormValidation');
	        },
	        error: function error(jqXHR, textStatus, errorThrown) {
	            //if fails
	        }
	    });
	}
	
	function initAjaxForm() {
	
	    // find .ajax-form elements and loop!
	    var ajax_forms = document.querySelectorAll('.ajax-form');
	    if (ajax_forms.length > 0) {
	        for (var i = 0; i < ajax_forms.length; i++) {
	            // init
	            var $form = $(ajax_forms[i]);
	            // only listen for the submit event, if the form is not being validated
	            if ($form.hasClass('validate-form') === false) {
	                $form.on('submit', function (event) {
	                    sendAjaxForm($form);
	                    event.preventDefault();
	                });
	            }
	        }
	    }
	}
	
	$(function () {
	
	    // on page load
	    initAjaxForm();
	    // custom event
	    $(window).on('initAjaxForm', function () {
	        initAjaxForm();
	    });
	});
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(2)))

/***/ }),
/* 86 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function($) {'use strict';
	
	__webpack_require__(87);
	
	__webpack_require__(88);
	
	/* * * * * * * * * * * * * * * * * * * * * * * * * * * * * *
	
	Bootstrap Select
	
	Docs: https://silviomoreto.github.io/bootstrap-select/options/
	
	*/
	
	$(function () {
	
	    function initBootstrapSelect() {
	        // dynamically define offset of select because of fixed site header
	        var bs_select_offset_top = $('.site-header').outerHeight();
	        $('.selectpicker').selectpicker({
	            style: 'btn-default bs-placeholder',
	            size: 'auto',
	            dropupAuto: true, // per default, let bootstrap select choose where to dislpay the dropdown (above or below). Should you want to force to display the form below, add the `data-dropup-auto="false"` attribute to the desired <select> element.
	            windowPadding: [bs_select_offset_top, 0, 0, 0]
	        });
	    }
	
	    // on page load
	    initBootstrapSelect();
	
	    // custom event
	    $(window).on('initBootstrapSelect ajaxFormSuccess softpage:opened form-modal:opened', function () {
	        initBootstrapSelect();
	    });
	});
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(2)))

/***/ }),
/* 87 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(jQuery) {/* ========================================================================
	 * Bootstrap: dropdown.js v3.4.1
	 * https://getbootstrap.com/docs/3.4/javascript/#dropdowns
	 * ========================================================================
	 * Copyright 2011-2019 Twitter, Inc.
	 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/master/LICENSE)
	 * ======================================================================== */
	
	
	+function ($) {
	  'use strict';
	
	  // DROPDOWN CLASS DEFINITION
	  // =========================
	
	  var backdrop = '.dropdown-backdrop'
	  var toggle   = '[data-toggle="dropdown"]'
	  var Dropdown = function (element) {
	    $(element).on('click.bs.dropdown', this.toggle)
	  }
	
	  Dropdown.VERSION = '3.4.1'
	
	  function getParent($this) {
	    var selector = $this.attr('data-target')
	
	    if (!selector) {
	      selector = $this.attr('href')
	      selector = selector && /#[A-Za-z]/.test(selector) && selector.replace(/.*(?=#[^\s]*$)/, '') // strip for ie7
	    }
	
	    var $parent = selector !== '#' ? $(document).find(selector) : null
	
	    return $parent && $parent.length ? $parent : $this.parent()
	  }
	
	  function clearMenus(e) {
	    if (e && e.which === 3) return
	    $(backdrop).remove()
	    $(toggle).each(function () {
	      var $this         = $(this)
	      var $parent       = getParent($this)
	      var relatedTarget = { relatedTarget: this }
	
	      if (!$parent.hasClass('open')) return
	
	      if (e && e.type == 'click' && /input|textarea/i.test(e.target.tagName) && $.contains($parent[0], e.target)) return
	
	      $parent.trigger(e = $.Event('hide.bs.dropdown', relatedTarget))
	
	      if (e.isDefaultPrevented()) return
	
	      $this.attr('aria-expanded', 'false')
	      $parent.removeClass('open').trigger($.Event('hidden.bs.dropdown', relatedTarget))
	    })
	  }
	
	  Dropdown.prototype.toggle = function (e) {
	    var $this = $(this)
	
	    if ($this.is('.disabled, :disabled')) return
	
	    var $parent  = getParent($this)
	    var isActive = $parent.hasClass('open')
	
	    clearMenus()
	
	    if (!isActive) {
	      if ('ontouchstart' in document.documentElement && !$parent.closest('.navbar-nav').length) {
	        // if mobile we use a backdrop because click events don't delegate
	        $(document.createElement('div'))
	          .addClass('dropdown-backdrop')
	          .insertAfter($(this))
	          .on('click', clearMenus)
	      }
	
	      var relatedTarget = { relatedTarget: this }
	      $parent.trigger(e = $.Event('show.bs.dropdown', relatedTarget))
	
	      if (e.isDefaultPrevented()) return
	
	      $this
	        .trigger('focus')
	        .attr('aria-expanded', 'true')
	
	      $parent
	        .toggleClass('open')
	        .trigger($.Event('shown.bs.dropdown', relatedTarget))
	    }
	
	    return false
	  }
	
	  Dropdown.prototype.keydown = function (e) {
	    if (!/(38|40|27|32)/.test(e.which) || /input|textarea/i.test(e.target.tagName)) return
	
	    var $this = $(this)
	
	    e.preventDefault()
	    e.stopPropagation()
	
	    if ($this.is('.disabled, :disabled')) return
	
	    var $parent  = getParent($this)
	    var isActive = $parent.hasClass('open')
	
	    if (!isActive && e.which != 27 || isActive && e.which == 27) {
	      if (e.which == 27) $parent.find(toggle).trigger('focus')
	      return $this.trigger('click')
	    }
	
	    var desc = ' li:not(.disabled):visible a'
	    var $items = $parent.find('.dropdown-menu' + desc)
	
	    if (!$items.length) return
	
	    var index = $items.index(e.target)
	
	    if (e.which == 38 && index > 0)                 index--         // up
	    if (e.which == 40 && index < $items.length - 1) index++         // down
	    if (!~index)                                    index = 0
	
	    $items.eq(index).trigger('focus')
	  }
	
	
	  // DROPDOWN PLUGIN DEFINITION
	  // ==========================
	
	  function Plugin(option) {
	    return this.each(function () {
	      var $this = $(this)
	      var data  = $this.data('bs.dropdown')
	
	      if (!data) $this.data('bs.dropdown', (data = new Dropdown(this)))
	      if (typeof option == 'string') data[option].call($this)
	    })
	  }
	
	  var old = $.fn.dropdown
	
	  $.fn.dropdown             = Plugin
	  $.fn.dropdown.Constructor = Dropdown
	
	
	  // DROPDOWN NO CONFLICT
	  // ====================
	
	  $.fn.dropdown.noConflict = function () {
	    $.fn.dropdown = old
	    return this
	  }
	
	
	  // APPLY TO STANDARD DROPDOWN ELEMENTS
	  // ===================================
	
	  $(document)
	    .on('click.bs.dropdown.data-api', clearMenus)
	    .on('click.bs.dropdown.data-api', '.dropdown form', function (e) { e.stopPropagation() })
	    .on('click.bs.dropdown.data-api', toggle, Dropdown.prototype.toggle)
	    .on('keydown.bs.dropdown.data-api', toggle, Dropdown.prototype.keydown)
	    .on('keydown.bs.dropdown.data-api', '.dropdown-menu', Dropdown.prototype.keydown)
	
	}(jQuery);
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(2)))

/***/ }),
/* 88 */
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/*!
	 * Bootstrap-select v1.13.18 (https://developer.snapappointments.com/bootstrap-select)
	 *
	 * Copyright 2012-2020 SnapAppointments, LLC
	 * Licensed under MIT (https://github.com/snapappointments/bootstrap-select/blob/master/LICENSE)
	 */
	
	(function (root, factory) {
	  if (root === undefined && window !== undefined) root = window;
	  if (true) {
	    // AMD. Register as an anonymous module unless amdModuleId is set
	    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(2)], __WEBPACK_AMD_DEFINE_RESULT__ = function (a0) {
	      return (factory(a0));
	    }.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	  } else if (typeof module === 'object' && module.exports) {
	    // Node. Does not work with strict CommonJS, but
	    // only CommonJS-like environments that support module.exports,
	    // like Node.
	    module.exports = factory(require("jquery"));
	  } else {
	    factory(root["jQuery"]);
	  }
	}(this, function (jQuery) {
	
	(function ($) {
	  'use strict';
	
	  var DISALLOWED_ATTRIBUTES = ['sanitize', 'whiteList', 'sanitizeFn'];
	
	  var uriAttrs = [
	    'background',
	    'cite',
	    'href',
	    'itemtype',
	    'longdesc',
	    'poster',
	    'src',
	    'xlink:href'
	  ];
	
	  var ARIA_ATTRIBUTE_PATTERN = /^aria-[\w-]*$/i;
	
	  var DefaultWhitelist = {
	    // Global attributes allowed on any supplied element below.
	    '*': ['class', 'dir', 'id', 'lang', 'role', 'tabindex', 'style', ARIA_ATTRIBUTE_PATTERN],
	    a: ['target', 'href', 'title', 'rel'],
	    area: [],
	    b: [],
	    br: [],
	    col: [],
	    code: [],
	    div: [],
	    em: [],
	    hr: [],
	    h1: [],
	    h2: [],
	    h3: [],
	    h4: [],
	    h5: [],
	    h6: [],
	    i: [],
	    img: ['src', 'alt', 'title', 'width', 'height'],
	    li: [],
	    ol: [],
	    p: [],
	    pre: [],
	    s: [],
	    small: [],
	    span: [],
	    sub: [],
	    sup: [],
	    strong: [],
	    u: [],
	    ul: []
	  }
	
	  /**
	   * A pattern that recognizes a commonly useful subset of URLs that are safe.
	   *
	   * Shoutout to Angular 7 https://github.com/angular/angular/blob/7.2.4/packages/core/src/sanitization/url_sanitizer.ts
	   */
	  var SAFE_URL_PATTERN = /^(?:(?:https?|mailto|ftp|tel|file):|[^&:/?#]*(?:[/?#]|$))/gi;
	
	  /**
	   * A pattern that matches safe data URLs. Only matches image, video and audio types.
	   *
	   * Shoutout to Angular 7 https://github.com/angular/angular/blob/7.2.4/packages/core/src/sanitization/url_sanitizer.ts
	   */
	  var DATA_URL_PATTERN = /^data:(?:image\/(?:bmp|gif|jpeg|jpg|png|tiff|webp)|video\/(?:mpeg|mp4|ogg|webm)|audio\/(?:mp3|oga|ogg|opus));base64,[a-z0-9+/]+=*$/i;
	
	  function allowedAttribute (attr, allowedAttributeList) {
	    var attrName = attr.nodeName.toLowerCase()
	
	    if ($.inArray(attrName, allowedAttributeList) !== -1) {
	      if ($.inArray(attrName, uriAttrs) !== -1) {
	        return Boolean(attr.nodeValue.match(SAFE_URL_PATTERN) || attr.nodeValue.match(DATA_URL_PATTERN))
	      }
	
	      return true
	    }
	
	    var regExp = $(allowedAttributeList).filter(function (index, value) {
	      return value instanceof RegExp
	    })
	
	    // Check if a regular expression validates the attribute.
	    for (var i = 0, l = regExp.length; i < l; i++) {
	      if (attrName.match(regExp[i])) {
	        return true
	      }
	    }
	
	    return false
	  }
	
	  function sanitizeHtml (unsafeElements, whiteList, sanitizeFn) {
	    if (sanitizeFn && typeof sanitizeFn === 'function') {
	      return sanitizeFn(unsafeElements);
	    }
	
	    var whitelistKeys = Object.keys(whiteList);
	
	    for (var i = 0, len = unsafeElements.length; i < len; i++) {
	      var elements = unsafeElements[i].querySelectorAll('*');
	
	      for (var j = 0, len2 = elements.length; j < len2; j++) {
	        var el = elements[j];
	        var elName = el.nodeName.toLowerCase();
	
	        if (whitelistKeys.indexOf(elName) === -1) {
	          el.parentNode.removeChild(el);
	
	          continue;
	        }
	
	        var attributeList = [].slice.call(el.attributes);
	        var whitelistedAttributes = [].concat(whiteList['*'] || [], whiteList[elName] || []);
	
	        for (var k = 0, len3 = attributeList.length; k < len3; k++) {
	          var attr = attributeList[k];
	
	          if (!allowedAttribute(attr, whitelistedAttributes)) {
	            el.removeAttribute(attr.nodeName);
	          }
	        }
	      }
	    }
	  }
	
	  // Polyfill for browsers with no classList support
	  // Remove in v2
	  if (!('classList' in document.createElement('_'))) {
	    (function (view) {
	      if (!('Element' in view)) return;
	
	      var classListProp = 'classList',
	          protoProp = 'prototype',
	          elemCtrProto = view.Element[protoProp],
	          objCtr = Object,
	          classListGetter = function () {
	            var $elem = $(this);
	
	            return {
	              add: function (classes) {
	                classes = Array.prototype.slice.call(arguments).join(' ');
	                return $elem.addClass(classes);
	              },
	              remove: function (classes) {
	                classes = Array.prototype.slice.call(arguments).join(' ');
	                return $elem.removeClass(classes);
	              },
	              toggle: function (classes, force) {
	                return $elem.toggleClass(classes, force);
	              },
	              contains: function (classes) {
	                return $elem.hasClass(classes);
	              }
	            }
	          };
	
	      if (objCtr.defineProperty) {
	        var classListPropDesc = {
	          get: classListGetter,
	          enumerable: true,
	          configurable: true
	        };
	        try {
	          objCtr.defineProperty(elemCtrProto, classListProp, classListPropDesc);
	        } catch (ex) { // IE 8 doesn't support enumerable:true
	          // adding undefined to fight this issue https://github.com/eligrey/classList.js/issues/36
	          // modernie IE8-MSW7 machine has IE8 8.0.6001.18702 and is affected
	          if (ex.number === undefined || ex.number === -0x7FF5EC54) {
	            classListPropDesc.enumerable = false;
	            objCtr.defineProperty(elemCtrProto, classListProp, classListPropDesc);
	          }
	        }
	      } else if (objCtr[protoProp].__defineGetter__) {
	        elemCtrProto.__defineGetter__(classListProp, classListGetter);
	      }
	    }(window));
	  }
	
	  var testElement = document.createElement('_');
	
	  testElement.classList.add('c1', 'c2');
	
	  if (!testElement.classList.contains('c2')) {
	    var _add = DOMTokenList.prototype.add,
	        _remove = DOMTokenList.prototype.remove;
	
	    DOMTokenList.prototype.add = function () {
	      Array.prototype.forEach.call(arguments, _add.bind(this));
	    }
	
	    DOMTokenList.prototype.remove = function () {
	      Array.prototype.forEach.call(arguments, _remove.bind(this));
	    }
	  }
	
	  testElement.classList.toggle('c3', false);
	
	  // Polyfill for IE 10 and Firefox <24, where classList.toggle does not
	  // support the second argument.
	  if (testElement.classList.contains('c3')) {
	    var _toggle = DOMTokenList.prototype.toggle;
	
	    DOMTokenList.prototype.toggle = function (token, force) {
	      if (1 in arguments && !this.contains(token) === !force) {
	        return force;
	      } else {
	        return _toggle.call(this, token);
	      }
	    };
	  }
	
	  testElement = null;
	
	  // shallow array comparison
	  function isEqual (array1, array2) {
	    return array1.length === array2.length && array1.every(function (element, index) {
	      return element === array2[index];
	    });
	  };
	
	  // <editor-fold desc="Shims">
	  if (!String.prototype.startsWith) {
	    (function () {
	      'use strict'; // needed to support `apply`/`call` with `undefined`/`null`
	      var defineProperty = (function () {
	        // IE 8 only supports `Object.defineProperty` on DOM elements
	        try {
	          var object = {};
	          var $defineProperty = Object.defineProperty;
	          var result = $defineProperty(object, object, object) && $defineProperty;
	        } catch (error) {
	        }
	        return result;
	      }());
	      var toString = {}.toString;
	      var startsWith = function (search) {
	        if (this == null) {
	          throw new TypeError();
	        }
	        var string = String(this);
	        if (search && toString.call(search) == '[object RegExp]') {
	          throw new TypeError();
	        }
	        var stringLength = string.length;
	        var searchString = String(search);
	        var searchLength = searchString.length;
	        var position = arguments.length > 1 ? arguments[1] : undefined;
	        // `ToInteger`
	        var pos = position ? Number(position) : 0;
	        if (pos != pos) { // better `isNaN`
	          pos = 0;
	        }
	        var start = Math.min(Math.max(pos, 0), stringLength);
	        // Avoid the `indexOf` call if no match is possible
	        if (searchLength + start > stringLength) {
	          return false;
	        }
	        var index = -1;
	        while (++index < searchLength) {
	          if (string.charCodeAt(start + index) != searchString.charCodeAt(index)) {
	            return false;
	          }
	        }
	        return true;
	      };
	      if (defineProperty) {
	        defineProperty(String.prototype, 'startsWith', {
	          'value': startsWith,
	          'configurable': true,
	          'writable': true
	        });
	      } else {
	        String.prototype.startsWith = startsWith;
	      }
	    }());
	  }
	
	  if (!Object.keys) {
	    Object.keys = function (
	      o, // object
	      k, // key
	      r  // result array
	    ) {
	      // initialize object and result
	      r = [];
	      // iterate over object keys
	      for (k in o) {
	        // fill result array with non-prototypical keys
	        r.hasOwnProperty.call(o, k) && r.push(k);
	      }
	      // return result
	      return r;
	    };
	  }
	
	  if (HTMLSelectElement && !HTMLSelectElement.prototype.hasOwnProperty('selectedOptions')) {
	    Object.defineProperty(HTMLSelectElement.prototype, 'selectedOptions', {
	      get: function () {
	        return this.querySelectorAll(':checked');
	      }
	    });
	  }
	
	  function getSelectedOptions (select, ignoreDisabled) {
	    var selectedOptions = select.selectedOptions,
	        options = [],
	        opt;
	
	    if (ignoreDisabled) {
	      for (var i = 0, len = selectedOptions.length; i < len; i++) {
	        opt = selectedOptions[i];
	
	        if (!(opt.disabled || opt.parentNode.tagName === 'OPTGROUP' && opt.parentNode.disabled)) {
	          options.push(opt);
	        }
	      }
	
	      return options;
	    }
	
	    return selectedOptions;
	  }
	
	  // much faster than $.val()
	  function getSelectValues (select, selectedOptions) {
	    var value = [],
	        options = selectedOptions || select.selectedOptions,
	        opt;
	
	    for (var i = 0, len = options.length; i < len; i++) {
	      opt = options[i];
	
	      if (!(opt.disabled || opt.parentNode.tagName === 'OPTGROUP' && opt.parentNode.disabled)) {
	        value.push(opt.value);
	      }
	    }
	
	    if (!select.multiple) {
	      return !value.length ? null : value[0];
	    }
	
	    return value;
	  }
	
	  // set data-selected on select element if the value has been programmatically selected
	  // prior to initialization of bootstrap-select
	  // * consider removing or replacing an alternative method *
	  var valHooks = {
	    useDefault: false,
	    _set: $.valHooks.select.set
	  };
	
	  $.valHooks.select.set = function (elem, value) {
	    if (value && !valHooks.useDefault) $(elem).data('selected', true);
	
	    return valHooks._set.apply(this, arguments);
	  };
	
	  var changedArguments = null;
	
	  var EventIsSupported = (function () {
	    try {
	      new Event('change');
	      return true;
	    } catch (e) {
	      return false;
	    }
	  })();
	
	  $.fn.triggerNative = function (eventName) {
	    var el = this[0],
	        event;
	
	    if (el.dispatchEvent) { // for modern browsers & IE9+
	      if (EventIsSupported) {
	        // For modern browsers
	        event = new Event(eventName, {
	          bubbles: true
	        });
	      } else {
	        // For IE since it doesn't support Event constructor
	        event = document.createEvent('Event');
	        event.initEvent(eventName, true, false);
	      }
	
	      el.dispatchEvent(event);
	    } else if (el.fireEvent) { // for IE8
	      event = document.createEventObject();
	      event.eventType = eventName;
	      el.fireEvent('on' + eventName, event);
	    } else {
	      // fall back to jQuery.trigger
	      this.trigger(eventName);
	    }
	  };
	  // </editor-fold>
	
	  function stringSearch (li, searchString, method, normalize) {
	    var stringTypes = [
	          'display',
	          'subtext',
	          'tokens'
	        ],
	        searchSuccess = false;
	
	    for (var i = 0; i < stringTypes.length; i++) {
	      var stringType = stringTypes[i],
	          string = li[stringType];
	
	      if (string) {
	        string = string.toString();
	
	        // Strip HTML tags. This isn't perfect, but it's much faster than any other method
	        if (stringType === 'display') {
	          string = string.replace(/<[^>]+>/g, '');
	        }
	
	        if (normalize) string = normalizeToBase(string);
	        string = string.toUpperCase();
	
	        if (method === 'contains') {
	          searchSuccess = string.indexOf(searchString) >= 0;
	        } else {
	          searchSuccess = string.startsWith(searchString);
	        }
	
	        if (searchSuccess) break;
	      }
	    }
	
	    return searchSuccess;
	  }
	
	  function toInteger (value) {
	    return parseInt(value, 10) || 0;
	  }
	
	  // Borrowed from Lodash (_.deburr)
	  /** Used to map Latin Unicode letters to basic Latin letters. */
	  var deburredLetters = {
	    // Latin-1 Supplement block.
	    '\xc0': 'A',  '\xc1': 'A', '\xc2': 'A', '\xc3': 'A', '\xc4': 'A', '\xc5': 'A',
	    '\xe0': 'a',  '\xe1': 'a', '\xe2': 'a', '\xe3': 'a', '\xe4': 'a', '\xe5': 'a',
	    '\xc7': 'C',  '\xe7': 'c',
	    '\xd0': 'D',  '\xf0': 'd',
	    '\xc8': 'E',  '\xc9': 'E', '\xca': 'E', '\xcb': 'E',
	    '\xe8': 'e',  '\xe9': 'e', '\xea': 'e', '\xeb': 'e',
	    '\xcc': 'I',  '\xcd': 'I', '\xce': 'I', '\xcf': 'I',
	    '\xec': 'i',  '\xed': 'i', '\xee': 'i', '\xef': 'i',
	    '\xd1': 'N',  '\xf1': 'n',
	    '\xd2': 'O',  '\xd3': 'O', '\xd4': 'O', '\xd5': 'O', '\xd6': 'O', '\xd8': 'O',
	    '\xf2': 'o',  '\xf3': 'o', '\xf4': 'o', '\xf5': 'o', '\xf6': 'o', '\xf8': 'o',
	    '\xd9': 'U',  '\xda': 'U', '\xdb': 'U', '\xdc': 'U',
	    '\xf9': 'u',  '\xfa': 'u', '\xfb': 'u', '\xfc': 'u',
	    '\xdd': 'Y',  '\xfd': 'y', '\xff': 'y',
	    '\xc6': 'Ae', '\xe6': 'ae',
	    '\xde': 'Th', '\xfe': 'th',
	    '\xdf': 'ss',
	    // Latin Extended-A block.
	    '\u0100': 'A',  '\u0102': 'A', '\u0104': 'A',
	    '\u0101': 'a',  '\u0103': 'a', '\u0105': 'a',
	    '\u0106': 'C',  '\u0108': 'C', '\u010a': 'C', '\u010c': 'C',
	    '\u0107': 'c',  '\u0109': 'c', '\u010b': 'c', '\u010d': 'c',
	    '\u010e': 'D',  '\u0110': 'D', '\u010f': 'd', '\u0111': 'd',
	    '\u0112': 'E',  '\u0114': 'E', '\u0116': 'E', '\u0118': 'E', '\u011a': 'E',
	    '\u0113': 'e',  '\u0115': 'e', '\u0117': 'e', '\u0119': 'e', '\u011b': 'e',
	    '\u011c': 'G',  '\u011e': 'G', '\u0120': 'G', '\u0122': 'G',
	    '\u011d': 'g',  '\u011f': 'g', '\u0121': 'g', '\u0123': 'g',
	    '\u0124': 'H',  '\u0126': 'H', '\u0125': 'h', '\u0127': 'h',
	    '\u0128': 'I',  '\u012a': 'I', '\u012c': 'I', '\u012e': 'I', '\u0130': 'I',
	    '\u0129': 'i',  '\u012b': 'i', '\u012d': 'i', '\u012f': 'i', '\u0131': 'i',
	    '\u0134': 'J',  '\u0135': 'j',
	    '\u0136': 'K',  '\u0137': 'k', '\u0138': 'k',
	    '\u0139': 'L',  '\u013b': 'L', '\u013d': 'L', '\u013f': 'L', '\u0141': 'L',
	    '\u013a': 'l',  '\u013c': 'l', '\u013e': 'l', '\u0140': 'l', '\u0142': 'l',
	    '\u0143': 'N',  '\u0145': 'N', '\u0147': 'N', '\u014a': 'N',
	    '\u0144': 'n',  '\u0146': 'n', '\u0148': 'n', '\u014b': 'n',
	    '\u014c': 'O',  '\u014e': 'O', '\u0150': 'O',
	    '\u014d': 'o',  '\u014f': 'o', '\u0151': 'o',
	    '\u0154': 'R',  '\u0156': 'R', '\u0158': 'R',
	    '\u0155': 'r',  '\u0157': 'r', '\u0159': 'r',
	    '\u015a': 'S',  '\u015c': 'S', '\u015e': 'S', '\u0160': 'S',
	    '\u015b': 's',  '\u015d': 's', '\u015f': 's', '\u0161': 's',
	    '\u0162': 'T',  '\u0164': 'T', '\u0166': 'T',
	    '\u0163': 't',  '\u0165': 't', '\u0167': 't',
	    '\u0168': 'U',  '\u016a': 'U', '\u016c': 'U', '\u016e': 'U', '\u0170': 'U', '\u0172': 'U',
	    '\u0169': 'u',  '\u016b': 'u', '\u016d': 'u', '\u016f': 'u', '\u0171': 'u', '\u0173': 'u',
	    '\u0174': 'W',  '\u0175': 'w',
	    '\u0176': 'Y',  '\u0177': 'y', '\u0178': 'Y',
	    '\u0179': 'Z',  '\u017b': 'Z', '\u017d': 'Z',
	    '\u017a': 'z',  '\u017c': 'z', '\u017e': 'z',
	    '\u0132': 'IJ', '\u0133': 'ij',
	    '\u0152': 'Oe', '\u0153': 'oe',
	    '\u0149': "'n", '\u017f': 's'
	  };
	
	  /** Used to match Latin Unicode letters (excluding mathematical operators). */
	  var reLatin = /[\xc0-\xd6\xd8-\xf6\xf8-\xff\u0100-\u017f]/g;
	
	  /** Used to compose unicode character classes. */
	  var rsComboMarksRange = '\\u0300-\\u036f',
	      reComboHalfMarksRange = '\\ufe20-\\ufe2f',
	      rsComboSymbolsRange = '\\u20d0-\\u20ff',
	      rsComboMarksExtendedRange = '\\u1ab0-\\u1aff',
	      rsComboMarksSupplementRange = '\\u1dc0-\\u1dff',
	      rsComboRange = rsComboMarksRange + reComboHalfMarksRange + rsComboSymbolsRange + rsComboMarksExtendedRange + rsComboMarksSupplementRange;
	
	  /** Used to compose unicode capture groups. */
	  var rsCombo = '[' + rsComboRange + ']';
	
	  /**
	   * Used to match [combining diacritical marks](https://en.wikipedia.org/wiki/Combining_Diacritical_Marks) and
	   * [combining diacritical marks for symbols](https://en.wikipedia.org/wiki/Combining_Diacritical_Marks_for_Symbols).
	   */
	  var reComboMark = RegExp(rsCombo, 'g');
	
	  function deburrLetter (key) {
	    return deburredLetters[key];
	  };
	
	  function normalizeToBase (string) {
	    string = string.toString();
	    return string && string.replace(reLatin, deburrLetter).replace(reComboMark, '');
	  }
	
	  // List of HTML entities for escaping.
	  var escapeMap = {
	    '&': '&amp;',
	    '<': '&lt;',
	    '>': '&gt;',
	    '"': '&quot;',
	    "'": '&#x27;',
	    '`': '&#x60;'
	  };
	
	  // Functions for escaping and unescaping strings to/from HTML interpolation.
	  var createEscaper = function (map) {
	    var escaper = function (match) {
	      return map[match];
	    };
	    // Regexes for identifying a key that needs to be escaped.
	    var source = '(?:' + Object.keys(map).join('|') + ')';
	    var testRegexp = RegExp(source);
	    var replaceRegexp = RegExp(source, 'g');
	    return function (string) {
	      string = string == null ? '' : '' + string;
	      return testRegexp.test(string) ? string.replace(replaceRegexp, escaper) : string;
	    };
	  };
	
	  var htmlEscape = createEscaper(escapeMap);
	
	  /**
	   * ------------------------------------------------------------------------
	   * Constants
	   * ------------------------------------------------------------------------
	   */
	
	  var keyCodeMap = {
	    32: ' ',
	    48: '0',
	    49: '1',
	    50: '2',
	    51: '3',
	    52: '4',
	    53: '5',
	    54: '6',
	    55: '7',
	    56: '8',
	    57: '9',
	    59: ';',
	    65: 'A',
	    66: 'B',
	    67: 'C',
	    68: 'D',
	    69: 'E',
	    70: 'F',
	    71: 'G',
	    72: 'H',
	    73: 'I',
	    74: 'J',
	    75: 'K',
	    76: 'L',
	    77: 'M',
	    78: 'N',
	    79: 'O',
	    80: 'P',
	    81: 'Q',
	    82: 'R',
	    83: 'S',
	    84: 'T',
	    85: 'U',
	    86: 'V',
	    87: 'W',
	    88: 'X',
	    89: 'Y',
	    90: 'Z',
	    96: '0',
	    97: '1',
	    98: '2',
	    99: '3',
	    100: '4',
	    101: '5',
	    102: '6',
	    103: '7',
	    104: '8',
	    105: '9'
	  };
	
	  var keyCodes = {
	    ESCAPE: 27, // KeyboardEvent.which value for Escape (Esc) key
	    ENTER: 13, // KeyboardEvent.which value for Enter key
	    SPACE: 32, // KeyboardEvent.which value for space key
	    TAB: 9, // KeyboardEvent.which value for tab key
	    ARROW_UP: 38, // KeyboardEvent.which value for up arrow key
	    ARROW_DOWN: 40 // KeyboardEvent.which value for down arrow key
	  }
	
	  var version = {
	    success: false,
	    major: '3'
	  };
	
	  try {
	    version.full = ($.fn.dropdown.Constructor.VERSION || '').split(' ')[0].split('.');
	    version.major = version.full[0];
	    version.success = true;
	  } catch (err) {
	    // do nothing
	  }
	
	  var selectId = 0;
	
	  var EVENT_KEY = '.bs.select';
	
	  var classNames = {
	    DISABLED: 'disabled',
	    DIVIDER: 'divider',
	    SHOW: 'open',
	    DROPUP: 'dropup',
	    MENU: 'dropdown-menu',
	    MENURIGHT: 'dropdown-menu-right',
	    MENULEFT: 'dropdown-menu-left',
	    // to-do: replace with more advanced template/customization options
	    BUTTONCLASS: 'btn-default',
	    POPOVERHEADER: 'popover-title',
	    ICONBASE: 'glyphicon',
	    TICKICON: 'glyphicon-ok'
	  }
	
	  var Selector = {
	    MENU: '.' + classNames.MENU
	  }
	
	  var elementTemplates = {
	    div: document.createElement('div'),
	    span: document.createElement('span'),
	    i: document.createElement('i'),
	    subtext: document.createElement('small'),
	    a: document.createElement('a'),
	    li: document.createElement('li'),
	    whitespace: document.createTextNode('\u00A0'),
	    fragment: document.createDocumentFragment()
	  }
	
	  elementTemplates.noResults = elementTemplates.li.cloneNode(false);
	  elementTemplates.noResults.className = 'no-results';
	
	  elementTemplates.a.setAttribute('role', 'option');
	  elementTemplates.a.className = 'dropdown-item';
	
	  elementTemplates.subtext.className = 'text-muted';
	
	  elementTemplates.text = elementTemplates.span.cloneNode(false);
	  elementTemplates.text.className = 'text';
	
	  elementTemplates.checkMark = elementTemplates.span.cloneNode(false);
	
	  var REGEXP_ARROW = new RegExp(keyCodes.ARROW_UP + '|' + keyCodes.ARROW_DOWN);
	  var REGEXP_TAB_OR_ESCAPE = new RegExp('^' + keyCodes.TAB + '$|' + keyCodes.ESCAPE);
	
	  var generateOption = {
	    li: function (content, classes, optgroup) {
	      var li = elementTemplates.li.cloneNode(false);
	
	      if (content) {
	        if (content.nodeType === 1 || content.nodeType === 11) {
	          li.appendChild(content);
	        } else {
	          li.innerHTML = content;
	        }
	      }
	
	      if (typeof classes !== 'undefined' && classes !== '') li.className = classes;
	      if (typeof optgroup !== 'undefined' && optgroup !== null) li.classList.add('optgroup-' + optgroup);
	
	      return li;
	    },
	
	    a: function (text, classes, inline) {
	      var a = elementTemplates.a.cloneNode(true);
	
	      if (text) {
	        if (text.nodeType === 11) {
	          a.appendChild(text);
	        } else {
	          a.insertAdjacentHTML('beforeend', text);
	        }
	      }
	
	      if (typeof classes !== 'undefined' && classes !== '') a.classList.add.apply(a.classList, classes.split(/\s+/));
	      if (inline) a.setAttribute('style', inline);
	
	      return a;
	    },
	
	    text: function (options, useFragment) {
	      var textElement = elementTemplates.text.cloneNode(false),
	          subtextElement,
	          iconElement;
	
	      if (options.content) {
	        textElement.innerHTML = options.content;
	      } else {
	        textElement.textContent = options.text;
	
	        if (options.icon) {
	          var whitespace = elementTemplates.whitespace.cloneNode(false);
	
	          // need to use <i> for icons in the button to prevent a breaking change
	          // note: switch to span in next major release
	          iconElement = (useFragment === true ? elementTemplates.i : elementTemplates.span).cloneNode(false);
	          iconElement.className = this.options.iconBase + ' ' + options.icon;
	
	          elementTemplates.fragment.appendChild(iconElement);
	          elementTemplates.fragment.appendChild(whitespace);
	        }
	
	        if (options.subtext) {
	          subtextElement = elementTemplates.subtext.cloneNode(false);
	          subtextElement.textContent = options.subtext;
	          textElement.appendChild(subtextElement);
	        }
	      }
	
	      if (useFragment === true) {
	        while (textElement.childNodes.length > 0) {
	          elementTemplates.fragment.appendChild(textElement.childNodes[0]);
	        }
	      } else {
	        elementTemplates.fragment.appendChild(textElement);
	      }
	
	      return elementTemplates.fragment;
	    },
	
	    label: function (options) {
	      var textElement = elementTemplates.text.cloneNode(false),
	          subtextElement,
	          iconElement;
	
	      textElement.innerHTML = options.display;
	
	      if (options.icon) {
	        var whitespace = elementTemplates.whitespace.cloneNode(false);
	
	        iconElement = elementTemplates.span.cloneNode(false);
	        iconElement.className = this.options.iconBase + ' ' + options.icon;
	
	        elementTemplates.fragment.appendChild(iconElement);
	        elementTemplates.fragment.appendChild(whitespace);
	      }
	
	      if (options.subtext) {
	        subtextElement = elementTemplates.subtext.cloneNode(false);
	        subtextElement.textContent = options.subtext;
	        textElement.appendChild(subtextElement);
	      }
	
	      elementTemplates.fragment.appendChild(textElement);
	
	      return elementTemplates.fragment;
	    }
	  }
	
	  function showNoResults (searchMatch, searchValue) {
	    if (!searchMatch.length) {
	      elementTemplates.noResults.innerHTML = this.options.noneResultsText.replace('{0}', '"' + htmlEscape(searchValue) + '"');
	      this.$menuInner[0].firstChild.appendChild(elementTemplates.noResults);
	    }
	  }
	
	  var Selectpicker = function (element, options) {
	    var that = this;
	
	    // bootstrap-select has been initialized - revert valHooks.select.set back to its original function
	    if (!valHooks.useDefault) {
	      $.valHooks.select.set = valHooks._set;
	      valHooks.useDefault = true;
	    }
	
	    this.$element = $(element);
	    this.$newElement = null;
	    this.$button = null;
	    this.$menu = null;
	    this.options = options;
	    this.selectpicker = {
	      main: {},
	      search: {},
	      current: {}, // current changes if a search is in progress
	      view: {},
	      isSearching: false,
	      keydown: {
	        keyHistory: '',
	        resetKeyHistory: {
	          start: function () {
	            return setTimeout(function () {
	              that.selectpicker.keydown.keyHistory = '';
	            }, 800);
	          }
	        }
	      }
	    };
	
	    this.sizeInfo = {};
	
	    // If we have no title yet, try to pull it from the html title attribute (jQuery doesnt' pick it up as it's not a
	    // data-attribute)
	    if (this.options.title === null) {
	      this.options.title = this.$element.attr('title');
	    }
	
	    // Format window padding
	    var winPad = this.options.windowPadding;
	    if (typeof winPad === 'number') {
	      this.options.windowPadding = [winPad, winPad, winPad, winPad];
	    }
	
	    // Expose public methods
	    this.val = Selectpicker.prototype.val;
	    this.render = Selectpicker.prototype.render;
	    this.refresh = Selectpicker.prototype.refresh;
	    this.setStyle = Selectpicker.prototype.setStyle;
	    this.selectAll = Selectpicker.prototype.selectAll;
	    this.deselectAll = Selectpicker.prototype.deselectAll;
	    this.destroy = Selectpicker.prototype.destroy;
	    this.remove = Selectpicker.prototype.remove;
	    this.show = Selectpicker.prototype.show;
	    this.hide = Selectpicker.prototype.hide;
	
	    this.init();
	  };
	
	  Selectpicker.VERSION = '1.13.18';
	
	  // part of this is duplicated in i18n/defaults-en_US.js. Make sure to update both.
	  Selectpicker.DEFAULTS = {
	    noneSelectedText: 'Nothing selected',
	    noneResultsText: 'No results matched {0}',
	    countSelectedText: function (numSelected, numTotal) {
	      return (numSelected == 1) ? '{0} item selected' : '{0} items selected';
	    },
	    maxOptionsText: function (numAll, numGroup) {
	      return [
	        (numAll == 1) ? 'Limit reached ({n} item max)' : 'Limit reached ({n} items max)',
	        (numGroup == 1) ? 'Group limit reached ({n} item max)' : 'Group limit reached ({n} items max)'
	      ];
	    },
	    selectAllText: 'Select All',
	    deselectAllText: 'Deselect All',
	    doneButton: false,
	    doneButtonText: 'Close',
	    multipleSeparator: ', ',
	    styleBase: 'btn',
	    style: classNames.BUTTONCLASS,
	    size: 'auto',
	    title: null,
	    selectedTextFormat: 'values',
	    width: false,
	    container: false,
	    hideDisabled: false,
	    showSubtext: false,
	    showIcon: true,
	    showContent: true,
	    dropupAuto: true,
	    header: false,
	    liveSearch: false,
	    liveSearchPlaceholder: null,
	    liveSearchNormalize: false,
	    liveSearchStyle: 'contains',
	    actionsBox: false,
	    iconBase: classNames.ICONBASE,
	    tickIcon: classNames.TICKICON,
	    showTick: false,
	    template: {
	      caret: '<span class="caret"></span>'
	    },
	    maxOptions: false,
	    mobile: false,
	    selectOnTab: false,
	    dropdownAlignRight: false,
	    windowPadding: 0,
	    virtualScroll: 600,
	    display: false,
	    sanitize: true,
	    sanitizeFn: null,
	    whiteList: DefaultWhitelist
	  };
	
	  Selectpicker.prototype = {
	
	    constructor: Selectpicker,
	
	    init: function () {
	      var that = this,
	          id = this.$element.attr('id'),
	          element = this.$element[0],
	          form = element.form;
	
	      selectId++;
	      this.selectId = 'bs-select-' + selectId;
	
	      element.classList.add('bs-select-hidden');
	
	      this.multiple = this.$element.prop('multiple');
	      this.autofocus = this.$element.prop('autofocus');
	
	      if (element.classList.contains('show-tick')) {
	        this.options.showTick = true;
	      }
	
	      this.$newElement = this.createDropdown();
	      this.buildData();
	      this.$element
	        .after(this.$newElement)
	        .prependTo(this.$newElement);
	
	      // ensure select is associated with form element if it got unlinked after moving it inside newElement
	      if (form && element.form === null) {
	        if (!form.id) form.id = 'form-' + this.selectId;
	        element.setAttribute('form', form.id);
	      }
	
	      this.$button = this.$newElement.children('button');
	      this.$menu = this.$newElement.children(Selector.MENU);
	      this.$menuInner = this.$menu.children('.inner');
	      this.$searchbox = this.$menu.find('input');
	
	      element.classList.remove('bs-select-hidden');
	
	      if (this.options.dropdownAlignRight === true) this.$menu[0].classList.add(classNames.MENURIGHT);
	
	      if (typeof id !== 'undefined') {
	        this.$button.attr('data-id', id);
	      }
	
	      this.checkDisabled();
	      this.clickListener();
	
	      if (this.options.liveSearch) {
	        this.liveSearchListener();
	        this.focusedParent = this.$searchbox[0];
	      } else {
	        this.focusedParent = this.$menuInner[0];
	      }
	
	      this.setStyle();
	      this.render();
	      this.setWidth();
	      if (this.options.container) {
	        this.selectPosition();
	      } else {
	        this.$element.on('hide' + EVENT_KEY, function () {
	          if (that.isVirtual()) {
	            // empty menu on close
	            var menuInner = that.$menuInner[0],
	                emptyMenu = menuInner.firstChild.cloneNode(false);
	
	            // replace the existing UL with an empty one - this is faster than $.empty() or innerHTML = ''
	            menuInner.replaceChild(emptyMenu, menuInner.firstChild);
	            menuInner.scrollTop = 0;
	          }
	        });
	      }
	      this.$menu.data('this', this);
	      this.$newElement.data('this', this);
	      if (this.options.mobile) this.mobile();
	
	      this.$newElement.on({
	        'hide.bs.dropdown': function (e) {
	          that.$element.trigger('hide' + EVENT_KEY, e);
	        },
	        'hidden.bs.dropdown': function (e) {
	          that.$element.trigger('hidden' + EVENT_KEY, e);
	        },
	        'show.bs.dropdown': function (e) {
	          that.$element.trigger('show' + EVENT_KEY, e);
	        },
	        'shown.bs.dropdown': function (e) {
	          that.$element.trigger('shown' + EVENT_KEY, e);
	        }
	      });
	
	      if (element.hasAttribute('required')) {
	        this.$element.on('invalid' + EVENT_KEY, function () {
	          that.$button[0].classList.add('bs-invalid');
	
	          that.$element
	            .on('shown' + EVENT_KEY + '.invalid', function () {
	              that.$element
	                .val(that.$element.val()) // set the value to hide the validation message in Chrome when menu is opened
	                .off('shown' + EVENT_KEY + '.invalid');
	            })
	            .on('rendered' + EVENT_KEY, function () {
	              // if select is no longer invalid, remove the bs-invalid class
	              if (this.validity.valid) that.$button[0].classList.remove('bs-invalid');
	              that.$element.off('rendered' + EVENT_KEY);
	            });
	
	          that.$button.on('blur' + EVENT_KEY, function () {
	            that.$element.trigger('focus').trigger('blur');
	            that.$button.off('blur' + EVENT_KEY);
	          });
	        });
	      }
	
	      setTimeout(function () {
	        that.buildList();
	        that.$element.trigger('loaded' + EVENT_KEY);
	      });
	    },
	
	    createDropdown: function () {
	      // Options
	      // If we are multiple or showTick option is set, then add the show-tick class
	      var showTick = (this.multiple || this.options.showTick) ? ' show-tick' : '',
	          multiselectable = this.multiple ? ' aria-multiselectable="true"' : '',
	          inputGroup = '',
	          autofocus = this.autofocus ? ' autofocus' : '';
	
	      if (version.major < 4 && this.$element.parent().hasClass('input-group')) {
	        inputGroup = ' input-group-btn';
	      }
	
	      // Elements
	      var drop,
	          header = '',
	          searchbox = '',
	          actionsbox = '',
	          donebutton = '';
	
	      if (this.options.header) {
	        header =
	          '<div class="' + classNames.POPOVERHEADER + '">' +
	            '<button type="button" class="close" aria-hidden="true">&times;</button>' +
	              this.options.header +
	          '</div>';
	      }
	
	      if (this.options.liveSearch) {
	        searchbox =
	          '<div class="bs-searchbox">' +
	            '<input type="search" class="form-control" autocomplete="off"' +
	              (
	                this.options.liveSearchPlaceholder === null ? ''
	                :
	                ' placeholder="' + htmlEscape(this.options.liveSearchPlaceholder) + '"'
	              ) +
	              ' role="combobox" aria-label="Search" aria-controls="' + this.selectId + '" aria-autocomplete="list">' +
	          '</div>';
	      }
	
	      if (this.multiple && this.options.actionsBox) {
	        actionsbox =
	          '<div class="bs-actionsbox">' +
	            '<div class="btn-group btn-group-sm btn-block">' +
	              '<button type="button" class="actions-btn bs-select-all btn ' + classNames.BUTTONCLASS + '">' +
	                this.options.selectAllText +
	              '</button>' +
	              '<button type="button" class="actions-btn bs-deselect-all btn ' + classNames.BUTTONCLASS + '">' +
	                this.options.deselectAllText +
	              '</button>' +
	            '</div>' +
	          '</div>';
	      }
	
	      if (this.multiple && this.options.doneButton) {
	        donebutton =
	          '<div class="bs-donebutton">' +
	            '<div class="btn-group btn-block">' +
	              '<button type="button" class="btn btn-sm ' + classNames.BUTTONCLASS + '">' +
	                this.options.doneButtonText +
	              '</button>' +
	            '</div>' +
	          '</div>';
	      }
	
	      drop =
	        '<div class="dropdown bootstrap-select' + showTick + inputGroup + '">' +
	          '<button type="button" tabindex="-1" class="' + this.options.styleBase + ' dropdown-toggle" ' + (this.options.display === 'static' ? 'data-display="static"' : '') + 'data-toggle="dropdown"' + autofocus + ' role="combobox" aria-owns="' + this.selectId + '" aria-haspopup="listbox" aria-expanded="false">' +
	            '<div class="filter-option">' +
	              '<div class="filter-option-inner">' +
	                '<div class="filter-option-inner-inner"></div>' +
	              '</div> ' +
	            '</div>' +
	            (
	              version.major === '4' ? ''
	              :
	              '<span class="bs-caret">' +
	                this.options.template.caret +
	              '</span>'
	            ) +
	          '</button>' +
	          '<div class="' + classNames.MENU + ' ' + (version.major === '4' ? '' : classNames.SHOW) + '">' +
	            header +
	            searchbox +
	            actionsbox +
	            '<div class="inner ' + classNames.SHOW + '" role="listbox" id="' + this.selectId + '" tabindex="-1" ' + multiselectable + '>' +
	                '<ul class="' + classNames.MENU + ' inner ' + (version.major === '4' ? classNames.SHOW : '') + '" role="presentation">' +
	                '</ul>' +
	            '</div>' +
	            donebutton +
	          '</div>' +
	        '</div>';
	
	      return $(drop);
	    },
	
	    setPositionData: function () {
	      this.selectpicker.view.canHighlight = [];
	      this.selectpicker.view.size = 0;
	      this.selectpicker.view.firstHighlightIndex = false;
	
	      for (var i = 0; i < this.selectpicker.current.data.length; i++) {
	        var li = this.selectpicker.current.data[i],
	            canHighlight = true;
	
	        if (li.type === 'divider') {
	          canHighlight = false;
	          li.height = this.sizeInfo.dividerHeight;
	        } else if (li.type === 'optgroup-label') {
	          canHighlight = false;
	          li.height = this.sizeInfo.dropdownHeaderHeight;
	        } else {
	          li.height = this.sizeInfo.liHeight;
	        }
	
	        if (li.disabled) canHighlight = false;
	
	        this.selectpicker.view.canHighlight.push(canHighlight);
	
	        if (canHighlight) {
	          this.selectpicker.view.size++;
	          li.posinset = this.selectpicker.view.size;
	          if (this.selectpicker.view.firstHighlightIndex === false) this.selectpicker.view.firstHighlightIndex = i;
	        }
	
	        li.position = (i === 0 ? 0 : this.selectpicker.current.data[i - 1].position) + li.height;
	      }
	    },
	
	    isVirtual: function () {
	      return (this.options.virtualScroll !== false) && (this.selectpicker.main.elements.length >= this.options.virtualScroll) || this.options.virtualScroll === true;
	    },
	
	    createView: function (isSearching, setSize, refresh) {
	      var that = this,
	          scrollTop = 0,
	          active = [],
	          selected,
	          prevActive;
	
	      this.selectpicker.isSearching = isSearching;
	      this.selectpicker.current = isSearching ? this.selectpicker.search : this.selectpicker.main;
	
	      this.setPositionData();
	
	      if (setSize) {
	        if (refresh) {
	          scrollTop = this.$menuInner[0].scrollTop;
	        } else if (!that.multiple) {
	          var element = that.$element[0],
	              selectedIndex = (element.options[element.selectedIndex] || {}).liIndex;
	
	          if (typeof selectedIndex === 'number' && that.options.size !== false) {
	            var selectedData = that.selectpicker.main.data[selectedIndex],
	                position = selectedData && selectedData.position;
	
	            if (position) {
	              scrollTop = position - ((that.sizeInfo.menuInnerHeight + that.sizeInfo.liHeight) / 2);
	            }
	          }
	        }
	      }
	
	      scroll(scrollTop, true);
	
	      this.$menuInner.off('scroll.createView').on('scroll.createView', function (e, updateValue) {
	        if (!that.noScroll) scroll(this.scrollTop, updateValue);
	        that.noScroll = false;
	      });
	
	      function scroll (scrollTop, init) {
	        var size = that.selectpicker.current.elements.length,
	            chunks = [],
	            chunkSize,
	            chunkCount,
	            firstChunk,
	            lastChunk,
	            currentChunk,
	            prevPositions,
	            positionIsDifferent,
	            previousElements,
	            menuIsDifferent = true,
	            isVirtual = that.isVirtual();
	
	        that.selectpicker.view.scrollTop = scrollTop;
	
	        chunkSize = Math.ceil(that.sizeInfo.menuInnerHeight / that.sizeInfo.liHeight * 1.5); // number of options in a chunk
	        chunkCount = Math.round(size / chunkSize) || 1; // number of chunks
	
	        for (var i = 0; i < chunkCount; i++) {
	          var endOfChunk = (i + 1) * chunkSize;
	
	          if (i === chunkCount - 1) {
	            endOfChunk = size;
	          }
	
	          chunks[i] = [
	            (i) * chunkSize + (!i ? 0 : 1),
	            endOfChunk
	          ];
	
	          if (!size) break;
	
	          if (currentChunk === undefined && scrollTop - 1 <= that.selectpicker.current.data[endOfChunk - 1].position - that.sizeInfo.menuInnerHeight) {
	            currentChunk = i;
	          }
	        }
	
	        if (currentChunk === undefined) currentChunk = 0;
	
	        prevPositions = [that.selectpicker.view.position0, that.selectpicker.view.position1];
	
	        // always display previous, current, and next chunks
	        firstChunk = Math.max(0, currentChunk - 1);
	        lastChunk = Math.min(chunkCount - 1, currentChunk + 1);
	
	        that.selectpicker.view.position0 = isVirtual === false ? 0 : (Math.max(0, chunks[firstChunk][0]) || 0);
	        that.selectpicker.view.position1 = isVirtual === false ? size : (Math.min(size, chunks[lastChunk][1]) || 0);
	
	        positionIsDifferent = prevPositions[0] !== that.selectpicker.view.position0 || prevPositions[1] !== that.selectpicker.view.position1;
	
	        if (that.activeIndex !== undefined) {
	          prevActive = that.selectpicker.main.elements[that.prevActiveIndex];
	          active = that.selectpicker.main.elements[that.activeIndex];
	          selected = that.selectpicker.main.elements[that.selectedIndex];
	
	          if (init) {
	            if (that.activeIndex !== that.selectedIndex) {
	              that.defocusItem(active);
	            }
	            that.activeIndex = undefined;
	          }
	
	          if (that.activeIndex && that.activeIndex !== that.selectedIndex) {
	            that.defocusItem(selected);
	          }
	        }
	
	        if (that.prevActiveIndex !== undefined && that.prevActiveIndex !== that.activeIndex && that.prevActiveIndex !== that.selectedIndex) {
	          that.defocusItem(prevActive);
	        }
	
	        if (init || positionIsDifferent) {
	          previousElements = that.selectpicker.view.visibleElements ? that.selectpicker.view.visibleElements.slice() : [];
	
	          if (isVirtual === false) {
	            that.selectpicker.view.visibleElements = that.selectpicker.current.elements;
	          } else {
	            that.selectpicker.view.visibleElements = that.selectpicker.current.elements.slice(that.selectpicker.view.position0, that.selectpicker.view.position1);
	          }
	
	          that.setOptionStatus();
	
	          // if searching, check to make sure the list has actually been updated before updating DOM
	          // this prevents unnecessary repaints
	          if (isSearching || (isVirtual === false && init)) menuIsDifferent = !isEqual(previousElements, that.selectpicker.view.visibleElements);
	
	          // if virtual scroll is disabled and not searching,
	          // menu should never need to be updated more than once
	          if ((init || isVirtual === true) && menuIsDifferent) {
	            var menuInner = that.$menuInner[0],
	                menuFragment = document.createDocumentFragment(),
	                emptyMenu = menuInner.firstChild.cloneNode(false),
	                marginTop,
	                marginBottom,
	                elements = that.selectpicker.view.visibleElements,
	                toSanitize = [];
	
	            // replace the existing UL with an empty one - this is faster than $.empty()
	            menuInner.replaceChild(emptyMenu, menuInner.firstChild);
	
	            for (var i = 0, visibleElementsLen = elements.length; i < visibleElementsLen; i++) {
	              var element = elements[i],
	                  elText,
	                  elementData;
	
	              if (that.options.sanitize) {
	                elText = element.lastChild;
	
	                if (elText) {
	                  elementData = that.selectpicker.current.data[i + that.selectpicker.view.position0];
	
	                  if (elementData && elementData.content && !elementData.sanitized) {
	                    toSanitize.push(elText);
	                    elementData.sanitized = true;
	                  }
	                }
	              }
	
	              menuFragment.appendChild(element);
	            }
	
	            if (that.options.sanitize && toSanitize.length) {
	              sanitizeHtml(toSanitize, that.options.whiteList, that.options.sanitizeFn);
	            }
	
	            if (isVirtual === true) {
	              marginTop = (that.selectpicker.view.position0 === 0 ? 0 : that.selectpicker.current.data[that.selectpicker.view.position0 - 1].position);
	              marginBottom = (that.selectpicker.view.position1 > size - 1 ? 0 : that.selectpicker.current.data[size - 1].position - that.selectpicker.current.data[that.selectpicker.view.position1 - 1].position);
	
	              menuInner.firstChild.style.marginTop = marginTop + 'px';
	              menuInner.firstChild.style.marginBottom = marginBottom + 'px';
	            } else {
	              menuInner.firstChild.style.marginTop = 0;
	              menuInner.firstChild.style.marginBottom = 0;
	            }
	
	            menuInner.firstChild.appendChild(menuFragment);
	
	            // if an option is encountered that is wider than the current menu width, update the menu width accordingly
	            // switch to ResizeObserver with increased browser support
	            if (isVirtual === true && that.sizeInfo.hasScrollBar) {
	              var menuInnerInnerWidth = menuInner.firstChild.offsetWidth;
	
	              if (init && menuInnerInnerWidth < that.sizeInfo.menuInnerInnerWidth && that.sizeInfo.totalMenuWidth > that.sizeInfo.selectWidth) {
	                menuInner.firstChild.style.minWidth = that.sizeInfo.menuInnerInnerWidth + 'px';
	              } else if (menuInnerInnerWidth > that.sizeInfo.menuInnerInnerWidth) {
	                // set to 0 to get actual width of menu
	                that.$menu[0].style.minWidth = 0;
	
	                var actualMenuWidth = menuInner.firstChild.offsetWidth;
	
	                if (actualMenuWidth > that.sizeInfo.menuInnerInnerWidth) {
	                  that.sizeInfo.menuInnerInnerWidth = actualMenuWidth;
	                  menuInner.firstChild.style.minWidth = that.sizeInfo.menuInnerInnerWidth + 'px';
	                }
	
	                // reset to default CSS styling
	                that.$menu[0].style.minWidth = '';
	              }
	            }
	          }
	        }
	
	        that.prevActiveIndex = that.activeIndex;
	
	        if (!that.options.liveSearch) {
	          that.$menuInner.trigger('focus');
	        } else if (isSearching && init) {
	          var index = 0,
	              newActive;
	
	          if (!that.selectpicker.view.canHighlight[index]) {
	            index = 1 + that.selectpicker.view.canHighlight.slice(1).indexOf(true);
	          }
	
	          newActive = that.selectpicker.view.visibleElements[index];
	
	          that.defocusItem(that.selectpicker.view.currentActive);
	
	          that.activeIndex = (that.selectpicker.current.data[index] || {}).index;
	
	          that.focusItem(newActive);
	        }
	      }
	
	      $(window)
	        .off('resize' + EVENT_KEY + '.' + this.selectId + '.createView')
	        .on('resize' + EVENT_KEY + '.' + this.selectId + '.createView', function () {
	          var isActive = that.$newElement.hasClass(classNames.SHOW);
	
	          if (isActive) scroll(that.$menuInner[0].scrollTop);
	        });
	    },
	
	    focusItem: function (li, liData, noStyle) {
	      if (li) {
	        liData = liData || this.selectpicker.main.data[this.activeIndex];
	        var a = li.firstChild;
	
	        if (a) {
	          a.setAttribute('aria-setsize', this.selectpicker.view.size);
	          a.setAttribute('aria-posinset', liData.posinset);
	
	          if (noStyle !== true) {
	            this.focusedParent.setAttribute('aria-activedescendant', a.id);
	            li.classList.add('active');
	            a.classList.add('active');
	          }
	        }
	      }
	    },
	
	    defocusItem: function (li) {
	      if (li) {
	        li.classList.remove('active');
	        if (li.firstChild) li.firstChild.classList.remove('active');
	      }
	    },
	
	    setPlaceholder: function () {
	      var that = this,
	          updateIndex = false;
	
	      if (this.options.title && !this.multiple) {
	        if (!this.selectpicker.view.titleOption) this.selectpicker.view.titleOption = document.createElement('option');
	
	        // this option doesn't create a new <li> element, but does add a new option at the start,
	        // so startIndex should increase to prevent having to check every option for the bs-title-option class
	        updateIndex = true;
	
	        var element = this.$element[0],
	            selectTitleOption = false,
	            titleNotAppended = !this.selectpicker.view.titleOption.parentNode,
	            selectedIndex = element.selectedIndex,
	            selectedOption = element.options[selectedIndex],
	            navigation = window.performance && window.performance.getEntriesByType('navigation'),
	            // Safari doesn't support getEntriesByType('navigation') - fall back to performance.navigation
	            isNotBackForward = (navigation && navigation.length) ? navigation[0].type !== 'back_forward' : window.performance.navigation.type !== 2;
	
	        if (titleNotAppended) {
	          // Use native JS to prepend option (faster)
	          this.selectpicker.view.titleOption.className = 'bs-title-option';
	          this.selectpicker.view.titleOption.value = '';
	
	          // Check if selected or data-selected attribute is already set on an option. If not, select the titleOption option.
	          // the selected item may have been changed by user or programmatically before the bootstrap select plugin runs,
	          // if so, the select will have the data-selected attribute
	          selectTitleOption = !selectedOption || (selectedIndex === 0 && selectedOption.defaultSelected === false && this.$element.data('selected') === undefined);
	        }
	
	        if (titleNotAppended || this.selectpicker.view.titleOption.index !== 0) {
	          element.insertBefore(this.selectpicker.view.titleOption, element.firstChild);
	        }
	
	        // Set selected *after* appending to select,
	        // otherwise the option doesn't get selected in IE
	        // set using selectedIndex, as setting the selected attr to true here doesn't work in IE11
	        if (selectTitleOption && isNotBackForward) {
	          element.selectedIndex = 0;
	        } else if (document.readyState !== 'complete') {
	          // if navigation type is back_forward, there's a chance the select will have its value set by BFCache
	          // wait for that value to be set, then run render again
	          window.addEventListener('pageshow', function () {
	            if (that.selectpicker.view.displayedValue !== element.value) that.render();
	          });
	        }
	      }
	
	      return updateIndex;
	    },
	
	    buildData: function () {
	      var optionSelector = ':not([hidden]):not([data-hidden="true"])',
	          mainData = [],
	          optID = 0,
	          startIndex = this.setPlaceholder() ? 1 : 0; // append the titleOption if necessary and skip the first option in the loop
	
	      if (this.options.hideDisabled) optionSelector += ':not(:disabled)';
	
	      var selectOptions = this.$element[0].querySelectorAll('select > *' + optionSelector);
	
	      function addDivider (config) {
	        var previousData = mainData[mainData.length - 1];
	
	        // ensure optgroup doesn't create back-to-back dividers
	        if (
	          previousData &&
	          previousData.type === 'divider' &&
	          (previousData.optID || config.optID)
	        ) {
	          return;
	        }
	
	        config = config || {};
	        config.type = 'divider';
	
	        mainData.push(config);
	      }
	
	      function addOption (option, config) {
	        config = config || {};
	
	        config.divider = option.getAttribute('data-divider') === 'true';
	
	        if (config.divider) {
	          addDivider({
	            optID: config.optID
	          });
	        } else {
	          var liIndex = mainData.length,
	              cssText = option.style.cssText,
	              inlineStyle = cssText ? htmlEscape(cssText) : '',
	              optionClass = (option.className || '') + (config.optgroupClass || '');
	
	          if (config.optID) optionClass = 'opt ' + optionClass;
	
	          config.optionClass = optionClass.trim();
	          config.inlineStyle = inlineStyle;
	          config.text = option.textContent;
	
	          config.content = option.getAttribute('data-content');
	          config.tokens = option.getAttribute('data-tokens');
	          config.subtext = option.getAttribute('data-subtext');
	          config.icon = option.getAttribute('data-icon');
	
	          option.liIndex = liIndex;
	
	          config.display = config.content || config.text;
	          config.type = 'option';
	          config.index = liIndex;
	          config.option = option;
	          config.selected = !!option.selected;
	          config.disabled = config.disabled || !!option.disabled;
	
	          mainData.push(config);
	        }
	      }
	
	      function addOptgroup (index, selectOptions) {
	        var optgroup = selectOptions[index],
	            // skip placeholder option
	            previous = index - 1 < startIndex ? false : selectOptions[index - 1],
	            next = selectOptions[index + 1],
	            options = optgroup.querySelectorAll('option' + optionSelector);
	
	        if (!options.length) return;
	
	        var config = {
	              display: htmlEscape(optgroup.label),
	              subtext: optgroup.getAttribute('data-subtext'),
	              icon: optgroup.getAttribute('data-icon'),
	              type: 'optgroup-label',
	              optgroupClass: ' ' + (optgroup.className || '')
	            },
	            headerIndex,
	            lastIndex;
	
	        optID++;
	
	        if (previous) {
	          addDivider({ optID: optID });
	        }
	
	        config.optID = optID;
	
	        mainData.push(config);
	
	        for (var j = 0, len = options.length; j < len; j++) {
	          var option = options[j];
	
	          if (j === 0) {
	            headerIndex = mainData.length - 1;
	            lastIndex = headerIndex + len;
	          }
	
	          addOption(option, {
	            headerIndex: headerIndex,
	            lastIndex: lastIndex,
	            optID: config.optID,
	            optgroupClass: config.optgroupClass,
	            disabled: optgroup.disabled
	          });
	        }
	
	        if (next) {
	          addDivider({ optID: optID });
	        }
	      }
	
	      for (var len = selectOptions.length, i = startIndex; i < len; i++) {
	        var item = selectOptions[i];
	
	        if (item.tagName !== 'OPTGROUP') {
	          addOption(item, {});
	        } else {
	          addOptgroup(i, selectOptions);
	        }
	      }
	
	      this.selectpicker.main.data = this.selectpicker.current.data = mainData;
	    },
	
	    buildList: function () {
	      var that = this,
	          selectData = this.selectpicker.main.data,
	          mainElements = [],
	          widestOptionLength = 0;
	
	      if ((that.options.showTick || that.multiple) && !elementTemplates.checkMark.parentNode) {
	        elementTemplates.checkMark.className = this.options.iconBase + ' ' + that.options.tickIcon + ' check-mark';
	        elementTemplates.a.appendChild(elementTemplates.checkMark);
	      }
	
	      function buildElement (item) {
	        var liElement,
	            combinedLength = 0;
	
	        switch (item.type) {
	          case 'divider':
	            liElement = generateOption.li(
	              false,
	              classNames.DIVIDER,
	              (item.optID ? item.optID + 'div' : undefined)
	            );
	
	            break;
	
	          case 'option':
	            liElement = generateOption.li(
	              generateOption.a(
	                generateOption.text.call(that, item),
	                item.optionClass,
	                item.inlineStyle
	              ),
	              '',
	              item.optID
	            );
	
	            if (liElement.firstChild) {
	              liElement.firstChild.id = that.selectId + '-' + item.index;
	            }
	
	            break;
	
	          case 'optgroup-label':
	            liElement = generateOption.li(
	              generateOption.label.call(that, item),
	              'dropdown-header' + item.optgroupClass,
	              item.optID
	            );
	
	            break;
	        }
	
	        item.element = liElement;
	        mainElements.push(liElement);
	
	        // count the number of characters in the option - not perfect, but should work in most cases
	        if (item.display) combinedLength += item.display.length;
	        if (item.subtext) combinedLength += item.subtext.length;
	        // if there is an icon, ensure this option's width is checked
	        if (item.icon) combinedLength += 1;
	
	        if (combinedLength > widestOptionLength) {
	          widestOptionLength = combinedLength;
	
	          // guess which option is the widest
	          // use this when calculating menu width
	          // not perfect, but it's fast, and the width will be updating accordingly when scrolling
	          that.selectpicker.view.widestOption = mainElements[mainElements.length - 1];
	        }
	      }
	
	      for (var len = selectData.length, i = 0; i < len; i++) {
	        var item = selectData[i];
	
	        buildElement(item);
	      }
	
	      this.selectpicker.main.elements = this.selectpicker.current.elements = mainElements;
	    },
	
	    findLis: function () {
	      return this.$menuInner.find('.inner > li');
	    },
	
	    render: function () {
	      var that = this,
	          element = this.$element[0],
	          // ensure titleOption is appended and selected (if necessary) before getting selectedOptions
	          placeholderSelected = this.setPlaceholder() && element.selectedIndex === 0,
	          selectedOptions = getSelectedOptions(element, this.options.hideDisabled),
	          selectedCount = selectedOptions.length,
	          button = this.$button[0],
	          buttonInner = button.querySelector('.filter-option-inner-inner'),
	          multipleSeparator = document.createTextNode(this.options.multipleSeparator),
	          titleFragment = elementTemplates.fragment.cloneNode(false),
	          showCount,
	          countMax,
	          hasContent = false;
	
	      button.classList.toggle('bs-placeholder', that.multiple ? !selectedCount : !getSelectValues(element, selectedOptions));
	
	      if (!that.multiple && selectedOptions.length === 1) {
	        that.selectpicker.view.displayedValue = getSelectValues(element, selectedOptions);
	      }
	
	      if (this.options.selectedTextFormat === 'static') {
	        titleFragment = generateOption.text.call(this, { text: this.options.title }, true);
	      } else {
	        showCount = this.multiple && this.options.selectedTextFormat.indexOf('count') !== -1 && selectedCount > 1;
	
	        // determine if the number of selected options will be shown (showCount === true)
	        if (showCount) {
	          countMax = this.options.selectedTextFormat.split('>');
	          showCount = (countMax.length > 1 && selectedCount > countMax[1]) || (countMax.length === 1 && selectedCount >= 2);
	        }
	
	        // only loop through all selected options if the count won't be shown
	        if (showCount === false) {
	          if (!placeholderSelected) {
	            for (var selectedIndex = 0; selectedIndex < selectedCount; selectedIndex++) {
	              if (selectedIndex < 50) {
	                var option = selectedOptions[selectedIndex],
	                    thisData = this.selectpicker.main.data[option.liIndex],
	                    titleOptions = {};
	
	                if (this.multiple && selectedIndex > 0) {
	                  titleFragment.appendChild(multipleSeparator.cloneNode(false));
	                }
	
	                if (option.title) {
	                  titleOptions.text = option.title;
	                } else if (thisData) {
	                  if (thisData.content && that.options.showContent) {
	                    titleOptions.content = thisData.content.toString();
	                    hasContent = true;
	                  } else {
	                    if (that.options.showIcon) {
	                      titleOptions.icon = thisData.icon;
	                    }
	                    if (that.options.showSubtext && !that.multiple && thisData.subtext) titleOptions.subtext = ' ' + thisData.subtext;
	                    titleOptions.text = option.textContent.trim();
	                  }
	                }
	
	                titleFragment.appendChild(generateOption.text.call(this, titleOptions, true));
	              } else {
	                break;
	              }
	            }
	
	            // add ellipsis
	            if (selectedCount > 49) {
	              titleFragment.appendChild(document.createTextNode('...'));
	            }
	          }
	        } else {
	          var optionSelector = ':not([hidden]):not([data-hidden="true"]):not([data-divider="true"])';
	          if (this.options.hideDisabled) optionSelector += ':not(:disabled)';
	
	          // If this is a multiselect, and selectedTextFormat is count, then show 1 of 2 selected, etc.
	          var totalCount = this.$element[0].querySelectorAll('select > option' + optionSelector + ', optgroup' + optionSelector + ' option' + optionSelector).length,
	              tr8nText = (typeof this.options.countSelectedText === 'function') ? this.options.countSelectedText(selectedCount, totalCount) : this.options.countSelectedText;
	
	          titleFragment = generateOption.text.call(this, {
	            text: tr8nText.replace('{0}', selectedCount.toString()).replace('{1}', totalCount.toString())
	          }, true);
	        }
	      }
	
	      if (this.options.title == undefined) {
	        // use .attr to ensure undefined is returned if title attribute is not set
	        this.options.title = this.$element.attr('title');
	      }
	
	      // If the select doesn't have a title, then use the default, or if nothing is set at all, use noneSelectedText
	      if (!titleFragment.childNodes.length) {
	        titleFragment = generateOption.text.call(this, {
	          text: typeof this.options.title !== 'undefined' ? this.options.title : this.options.noneSelectedText
	        }, true);
	      }
	
	      // strip all HTML tags and trim the result, then unescape any escaped tags
	      button.title = titleFragment.textContent.replace(/<[^>]*>?/g, '').trim();
	
	      if (this.options.sanitize && hasContent) {
	        sanitizeHtml([titleFragment], that.options.whiteList, that.options.sanitizeFn);
	      }
	
	      buttonInner.innerHTML = '';
	      buttonInner.appendChild(titleFragment);
	
	      if (version.major < 4 && this.$newElement[0].classList.contains('bs3-has-addon')) {
	        var filterExpand = button.querySelector('.filter-expand'),
	            clone = buttonInner.cloneNode(true);
	
	        clone.className = 'filter-expand';
	
	        if (filterExpand) {
	          button.replaceChild(clone, filterExpand);
	        } else {
	          button.appendChild(clone);
	        }
	      }
	
	      this.$element.trigger('rendered' + EVENT_KEY);
	    },
	
	    /**
	     * @param [style]
	     * @param [status]
	     */
	    setStyle: function (newStyle, status) {
	      var button = this.$button[0],
	          newElement = this.$newElement[0],
	          style = this.options.style.trim(),
	          buttonClass;
	
	      if (this.$element.attr('class')) {
	        this.$newElement.addClass(this.$element.attr('class').replace(/selectpicker|mobile-device|bs-select-hidden|validate\[.*\]/gi, ''));
	      }
	
	      if (version.major < 4) {
	        newElement.classList.add('bs3');
	
	        if (newElement.parentNode.classList && newElement.parentNode.classList.contains('input-group') &&
	            (newElement.previousElementSibling || newElement.nextElementSibling) &&
	            (newElement.previousElementSibling || newElement.nextElementSibling).classList.contains('input-group-addon')
	        ) {
	          newElement.classList.add('bs3-has-addon');
	        }
	      }
	
	      if (newStyle) {
	        buttonClass = newStyle.trim();
	      } else {
	        buttonClass = style;
	      }
	
	      if (status == 'add') {
	        if (buttonClass) button.classList.add.apply(button.classList, buttonClass.split(' '));
	      } else if (status == 'remove') {
	        if (buttonClass) button.classList.remove.apply(button.classList, buttonClass.split(' '));
	      } else {
	        if (style) button.classList.remove.apply(button.classList, style.split(' '));
	        if (buttonClass) button.classList.add.apply(button.classList, buttonClass.split(' '));
	      }
	    },
	
	    liHeight: function (refresh) {
	      if (!refresh && (this.options.size === false || Object.keys(this.sizeInfo).length)) return;
	
	      var newElement = elementTemplates.div.cloneNode(false),
	          menu = elementTemplates.div.cloneNode(false),
	          menuInner = elementTemplates.div.cloneNode(false),
	          menuInnerInner = document.createElement('ul'),
	          divider = elementTemplates.li.cloneNode(false),
	          dropdownHeader = elementTemplates.li.cloneNode(false),
	          li,
	          a = elementTemplates.a.cloneNode(false),
	          text = elementTemplates.span.cloneNode(false),
	          header = this.options.header && this.$menu.find('.' + classNames.POPOVERHEADER).length > 0 ? this.$menu.find('.' + classNames.POPOVERHEADER)[0].cloneNode(true) : null,
	          search = this.options.liveSearch ? elementTemplates.div.cloneNode(false) : null,
	          actions = this.options.actionsBox && this.multiple && this.$menu.find('.bs-actionsbox').length > 0 ? this.$menu.find('.bs-actionsbox')[0].cloneNode(true) : null,
	          doneButton = this.options.doneButton && this.multiple && this.$menu.find('.bs-donebutton').length > 0 ? this.$menu.find('.bs-donebutton')[0].cloneNode(true) : null,
	          firstOption = this.$element.find('option')[0];
	
	      this.sizeInfo.selectWidth = this.$newElement[0].offsetWidth;
	
	      text.className = 'text';
	      a.className = 'dropdown-item ' + (firstOption ? firstOption.className : '');
	      newElement.className = this.$menu[0].parentNode.className + ' ' + classNames.SHOW;
	      newElement.style.width = 0; // ensure button width doesn't affect natural width of menu when calculating
	      if (this.options.width === 'auto') menu.style.minWidth = 0;
	      menu.className = classNames.MENU + ' ' + classNames.SHOW;
	      menuInner.className = 'inner ' + classNames.SHOW;
	      menuInnerInner.className = classNames.MENU + ' inner ' + (version.major === '4' ? classNames.SHOW : '');
	      divider.className = classNames.DIVIDER;
	      dropdownHeader.className = 'dropdown-header';
	
	      text.appendChild(document.createTextNode('\u200b'));
	
	      if (this.selectpicker.current.data.length) {
	        for (var i = 0; i < this.selectpicker.current.data.length; i++) {
	          var data = this.selectpicker.current.data[i];
	          if (data.type === 'option') {
	            li = data.element;
	            break;
	          }
	        }
	      } else {
	        li = elementTemplates.li.cloneNode(false);
	        a.appendChild(text);
	        li.appendChild(a);
	      }
	
	      dropdownHeader.appendChild(text.cloneNode(true));
	
	      if (this.selectpicker.view.widestOption) {
	        menuInnerInner.appendChild(this.selectpicker.view.widestOption.cloneNode(true));
	      }
	
	      menuInnerInner.appendChild(li);
	      menuInnerInner.appendChild(divider);
	      menuInnerInner.appendChild(dropdownHeader);
	      if (header) menu.appendChild(header);
	      if (search) {
	        var input = document.createElement('input');
	        search.className = 'bs-searchbox';
	        input.className = 'form-control';
	        search.appendChild(input);
	        menu.appendChild(search);
	      }
	      if (actions) menu.appendChild(actions);
	      menuInner.appendChild(menuInnerInner);
	      menu.appendChild(menuInner);
	      if (doneButton) menu.appendChild(doneButton);
	      newElement.appendChild(menu);
	
	      document.body.appendChild(newElement);
	
	      var liHeight = li.offsetHeight,
	          dropdownHeaderHeight = dropdownHeader ? dropdownHeader.offsetHeight : 0,
	          headerHeight = header ? header.offsetHeight : 0,
	          searchHeight = search ? search.offsetHeight : 0,
	          actionsHeight = actions ? actions.offsetHeight : 0,
	          doneButtonHeight = doneButton ? doneButton.offsetHeight : 0,
	          dividerHeight = $(divider).outerHeight(true),
	          // fall back to jQuery if getComputedStyle is not supported
	          menuStyle = window.getComputedStyle ? window.getComputedStyle(menu) : false,
	          menuWidth = menu.offsetWidth,
	          $menu = menuStyle ? null : $(menu),
	          menuPadding = {
	            vert: toInteger(menuStyle ? menuStyle.paddingTop : $menu.css('paddingTop')) +
	                  toInteger(menuStyle ? menuStyle.paddingBottom : $menu.css('paddingBottom')) +
	                  toInteger(menuStyle ? menuStyle.borderTopWidth : $menu.css('borderTopWidth')) +
	                  toInteger(menuStyle ? menuStyle.borderBottomWidth : $menu.css('borderBottomWidth')),
	            horiz: toInteger(menuStyle ? menuStyle.paddingLeft : $menu.css('paddingLeft')) +
	                  toInteger(menuStyle ? menuStyle.paddingRight : $menu.css('paddingRight')) +
	                  toInteger(menuStyle ? menuStyle.borderLeftWidth : $menu.css('borderLeftWidth')) +
	                  toInteger(menuStyle ? menuStyle.borderRightWidth : $menu.css('borderRightWidth'))
	          },
	          menuExtras = {
	            vert: menuPadding.vert +
	                  toInteger(menuStyle ? menuStyle.marginTop : $menu.css('marginTop')) +
	                  toInteger(menuStyle ? menuStyle.marginBottom : $menu.css('marginBottom')) + 2,
	            horiz: menuPadding.horiz +
	                  toInteger(menuStyle ? menuStyle.marginLeft : $menu.css('marginLeft')) +
	                  toInteger(menuStyle ? menuStyle.marginRight : $menu.css('marginRight')) + 2
	          },
	          scrollBarWidth;
	
	      menuInner.style.overflowY = 'scroll';
	
	      scrollBarWidth = menu.offsetWidth - menuWidth;
	
	      document.body.removeChild(newElement);
	
	      this.sizeInfo.liHeight = liHeight;
	      this.sizeInfo.dropdownHeaderHeight = dropdownHeaderHeight;
	      this.sizeInfo.headerHeight = headerHeight;
	      this.sizeInfo.searchHeight = searchHeight;
	      this.sizeInfo.actionsHeight = actionsHeight;
	      this.sizeInfo.doneButtonHeight = doneButtonHeight;
	      this.sizeInfo.dividerHeight = dividerHeight;
	      this.sizeInfo.menuPadding = menuPadding;
	      this.sizeInfo.menuExtras = menuExtras;
	      this.sizeInfo.menuWidth = menuWidth;
	      this.sizeInfo.menuInnerInnerWidth = menuWidth - menuPadding.horiz;
	      this.sizeInfo.totalMenuWidth = this.sizeInfo.menuWidth;
	      this.sizeInfo.scrollBarWidth = scrollBarWidth;
	      this.sizeInfo.selectHeight = this.$newElement[0].offsetHeight;
	
	      this.setPositionData();
	    },
	
	    getSelectPosition: function () {
	      var that = this,
	          $window = $(window),
	          pos = that.$newElement.offset(),
	          $container = $(that.options.container),
	          containerPos;
	
	      if (that.options.container && $container.length && !$container.is('body')) {
	        containerPos = $container.offset();
	        containerPos.top += parseInt($container.css('borderTopWidth'));
	        containerPos.left += parseInt($container.css('borderLeftWidth'));
	      } else {
	        containerPos = { top: 0, left: 0 };
	      }
	
	      var winPad = that.options.windowPadding;
	
	      this.sizeInfo.selectOffsetTop = pos.top - containerPos.top - $window.scrollTop();
	      this.sizeInfo.selectOffsetBot = $window.height() - this.sizeInfo.selectOffsetTop - this.sizeInfo.selectHeight - containerPos.top - winPad[2];
	      this.sizeInfo.selectOffsetLeft = pos.left - containerPos.left - $window.scrollLeft();
	      this.sizeInfo.selectOffsetRight = $window.width() - this.sizeInfo.selectOffsetLeft - this.sizeInfo.selectWidth - containerPos.left - winPad[1];
	      this.sizeInfo.selectOffsetTop -= winPad[0];
	      this.sizeInfo.selectOffsetLeft -= winPad[3];
	    },
	
	    setMenuSize: function (isAuto) {
	      this.getSelectPosition();
	
	      var selectWidth = this.sizeInfo.selectWidth,
	          liHeight = this.sizeInfo.liHeight,
	          headerHeight = this.sizeInfo.headerHeight,
	          searchHeight = this.sizeInfo.searchHeight,
	          actionsHeight = this.sizeInfo.actionsHeight,
	          doneButtonHeight = this.sizeInfo.doneButtonHeight,
	          divHeight = this.sizeInfo.dividerHeight,
	          menuPadding = this.sizeInfo.menuPadding,
	          menuInnerHeight,
	          menuHeight,
	          divLength = 0,
	          minHeight,
	          _minHeight,
	          maxHeight,
	          menuInnerMinHeight,
	          estimate,
	          isDropup;
	
	      if (this.options.dropupAuto) {
	        // Get the estimated height of the menu without scrollbars.
	        // This is useful for smaller menus, where there might be plenty of room
	        // below the button without setting dropup, but we can't know
	        // the exact height of the menu until createView is called later
	        estimate = liHeight * this.selectpicker.current.elements.length + menuPadding.vert;
	
	        isDropup = this.sizeInfo.selectOffsetTop - this.sizeInfo.selectOffsetBot > this.sizeInfo.menuExtras.vert && estimate + this.sizeInfo.menuExtras.vert + 50 > this.sizeInfo.selectOffsetBot;
	
	        // ensure dropup doesn't change while searching (so menu doesn't bounce back and forth)
	        if (this.selectpicker.isSearching === true) {
	          isDropup = this.selectpicker.dropup;
	        }
	
	        this.$newElement.toggleClass(classNames.DROPUP, isDropup);
	        this.selectpicker.dropup = isDropup;
	      }
	
	      if (this.options.size === 'auto') {
	        _minHeight = this.selectpicker.current.elements.length > 3 ? this.sizeInfo.liHeight * 3 + this.sizeInfo.menuExtras.vert - 2 : 0;
	        menuHeight = this.sizeInfo.selectOffsetBot - this.sizeInfo.menuExtras.vert;
	        minHeight = _minHeight + headerHeight + searchHeight + actionsHeight + doneButtonHeight;
	        menuInnerMinHeight = Math.max(_minHeight - menuPadding.vert, 0);
	
	        if (this.$newElement.hasClass(classNames.DROPUP)) {
	          menuHeight = this.sizeInfo.selectOffsetTop - this.sizeInfo.menuExtras.vert;
	        }
	
	        maxHeight = menuHeight;
	        menuInnerHeight = menuHeight - headerHeight - searchHeight - actionsHeight - doneButtonHeight - menuPadding.vert;
	      } else if (this.options.size && this.options.size != 'auto' && this.selectpicker.current.elements.length > this.options.size) {
	        for (var i = 0; i < this.options.size; i++) {
	          if (this.selectpicker.current.data[i].type === 'divider') divLength++;
	        }
	
	        menuHeight = liHeight * this.options.size + divLength * divHeight + menuPadding.vert;
	        menuInnerHeight = menuHeight - menuPadding.vert;
	        maxHeight = menuHeight + headerHeight + searchHeight + actionsHeight + doneButtonHeight;
	        minHeight = menuInnerMinHeight = '';
	      }
	
	      this.$menu.css({
	        'max-height': maxHeight + 'px',
	        'overflow': 'hidden',
	        'min-height': minHeight + 'px'
	      });
	
	      this.$menuInner.css({
	        'max-height': menuInnerHeight + 'px',
	        'overflow-y': 'auto',
	        'min-height': menuInnerMinHeight + 'px'
	      });
	
	      // ensure menuInnerHeight is always a positive number to prevent issues calculating chunkSize in createView
	      this.sizeInfo.menuInnerHeight = Math.max(menuInnerHeight, 1);
	
	      if (this.selectpicker.current.data.length && this.selectpicker.current.data[this.selectpicker.current.data.length - 1].position > this.sizeInfo.menuInnerHeight) {
	        this.sizeInfo.hasScrollBar = true;
	        this.sizeInfo.totalMenuWidth = this.sizeInfo.menuWidth + this.sizeInfo.scrollBarWidth;
	      }
	
	      if (this.options.dropdownAlignRight === 'auto') {
	        this.$menu.toggleClass(classNames.MENURIGHT, this.sizeInfo.selectOffsetLeft > this.sizeInfo.selectOffsetRight && this.sizeInfo.selectOffsetRight < (this.sizeInfo.totalMenuWidth - selectWidth));
	      }
	
	      if (this.dropdown && this.dropdown._popper) this.dropdown._popper.update();
	    },
	
	    setSize: function (refresh) {
	      this.liHeight(refresh);
	
	      if (this.options.header) this.$menu.css('padding-top', 0);
	
	      if (this.options.size !== false) {
	        var that = this,
	            $window = $(window);
	
	        this.setMenuSize();
	
	        if (this.options.liveSearch) {
	          this.$searchbox
	            .off('input.setMenuSize propertychange.setMenuSize')
	            .on('input.setMenuSize propertychange.setMenuSize', function () {
	              return that.setMenuSize();
	            });
	        }
	
	        if (this.options.size === 'auto') {
	          $window
	            .off('resize' + EVENT_KEY + '.' + this.selectId + '.setMenuSize' + ' scroll' + EVENT_KEY + '.' + this.selectId + '.setMenuSize')
	            .on('resize' + EVENT_KEY + '.' + this.selectId + '.setMenuSize' + ' scroll' + EVENT_KEY + '.' + this.selectId + '.setMenuSize', function () {
	              return that.setMenuSize();
	            });
	        } else if (this.options.size && this.options.size != 'auto' && this.selectpicker.current.elements.length > this.options.size) {
	          $window.off('resize' + EVENT_KEY + '.' + this.selectId + '.setMenuSize' + ' scroll' + EVENT_KEY + '.' + this.selectId + '.setMenuSize');
	        }
	      }
	
	      this.createView(false, true, refresh);
	    },
	
	    setWidth: function () {
	      var that = this;
	
	      if (this.options.width === 'auto') {
	        requestAnimationFrame(function () {
	          that.$menu.css('min-width', '0');
	
	          that.$element.on('loaded' + EVENT_KEY, function () {
	            that.liHeight();
	            that.setMenuSize();
	
	            // Get correct width if element is hidden
	            var $selectClone = that.$newElement.clone().appendTo('body'),
	                btnWidth = $selectClone.css('width', 'auto').children('button').outerWidth();
	
	            $selectClone.remove();
	
	            // Set width to whatever's larger, button title or longest option
	            that.sizeInfo.selectWidth = Math.max(that.sizeInfo.totalMenuWidth, btnWidth);
	            that.$newElement.css('width', that.sizeInfo.selectWidth + 'px');
	          });
	        });
	      } else if (this.options.width === 'fit') {
	        // Remove inline min-width so width can be changed from 'auto'
	        this.$menu.css('min-width', '');
	        this.$newElement.css('width', '').addClass('fit-width');
	      } else if (this.options.width) {
	        // Remove inline min-width so width can be changed from 'auto'
	        this.$menu.css('min-width', '');
	        this.$newElement.css('width', this.options.width);
	      } else {
	        // Remove inline min-width/width so width can be changed
	        this.$menu.css('min-width', '');
	        this.$newElement.css('width', '');
	      }
	      // Remove fit-width class if width is changed programmatically
	      if (this.$newElement.hasClass('fit-width') && this.options.width !== 'fit') {
	        this.$newElement[0].classList.remove('fit-width');
	      }
	    },
	
	    selectPosition: function () {
	      this.$bsContainer = $('<div class="bs-container" />');
	
	      var that = this,
	          $container = $(this.options.container),
	          pos,
	          containerPos,
	          actualHeight,
	          getPlacement = function ($element) {
	            var containerPosition = {},
	                // fall back to dropdown's default display setting if display is not manually set
	                display = that.options.display || (
	                  // Bootstrap 3 doesn't have $.fn.dropdown.Constructor.Default
	                  $.fn.dropdown.Constructor.Default ? $.fn.dropdown.Constructor.Default.display
	                  : false
	                );
	
	            that.$bsContainer.addClass($element.attr('class').replace(/form-control|fit-width/gi, '')).toggleClass(classNames.DROPUP, $element.hasClass(classNames.DROPUP));
	            pos = $element.offset();
	
	            if (!$container.is('body')) {
	              containerPos = $container.offset();
	              containerPos.top += parseInt($container.css('borderTopWidth')) - $container.scrollTop();
	              containerPos.left += parseInt($container.css('borderLeftWidth')) - $container.scrollLeft();
	            } else {
	              containerPos = { top: 0, left: 0 };
	            }
	
	            actualHeight = $element.hasClass(classNames.DROPUP) ? 0 : $element[0].offsetHeight;
	
	            // Bootstrap 4+ uses Popper for menu positioning
	            if (version.major < 4 || display === 'static') {
	              containerPosition.top = pos.top - containerPos.top + actualHeight;
	              containerPosition.left = pos.left - containerPos.left;
	            }
	
	            containerPosition.width = $element[0].offsetWidth;
	
	            that.$bsContainer.css(containerPosition);
	          };
	
	      this.$button.on('click.bs.dropdown.data-api', function () {
	        if (that.isDisabled()) {
	          return;
	        }
	
	        getPlacement(that.$newElement);
	
	        that.$bsContainer
	          .appendTo(that.options.container)
	          .toggleClass(classNames.SHOW, !that.$button.hasClass(classNames.SHOW))
	          .append(that.$menu);
	      });
	
	      $(window)
	        .off('resize' + EVENT_KEY + '.' + this.selectId + ' scroll' + EVENT_KEY + '.' + this.selectId)
	        .on('resize' + EVENT_KEY + '.' + this.selectId + ' scroll' + EVENT_KEY + '.' + this.selectId, function () {
	          var isActive = that.$newElement.hasClass(classNames.SHOW);
	
	          if (isActive) getPlacement(that.$newElement);
	        });
	
	      this.$element.on('hide' + EVENT_KEY, function () {
	        that.$menu.data('height', that.$menu.height());
	        that.$bsContainer.detach();
	      });
	    },
	
	    setOptionStatus: function (selectedOnly) {
	      var that = this;
	
	      that.noScroll = false;
	
	      if (that.selectpicker.view.visibleElements && that.selectpicker.view.visibleElements.length) {
	        for (var i = 0; i < that.selectpicker.view.visibleElements.length; i++) {
	          var liData = that.selectpicker.current.data[i + that.selectpicker.view.position0],
	              option = liData.option;
	
	          if (option) {
	            if (selectedOnly !== true) {
	              that.setDisabled(
	                liData.index,
	                liData.disabled
	              );
	            }
	
	            that.setSelected(
	              liData.index,
	              option.selected
	            );
	          }
	        }
	      }
	    },
	
	    /**
	     * @param {number} index - the index of the option that is being changed
	     * @param {boolean} selected - true if the option is being selected, false if being deselected
	     */
	    setSelected: function (index, selected) {
	      var li = this.selectpicker.main.elements[index],
	          liData = this.selectpicker.main.data[index],
	          activeIndexIsSet = this.activeIndex !== undefined,
	          thisIsActive = this.activeIndex === index,
	          prevActive,
	          a,
	          // if current option is already active
	          // OR
	          // if the current option is being selected, it's NOT multiple, and
	          // activeIndex is undefined:
	          //  - when the menu is first being opened, OR
	          //  - after a search has been performed, OR
	          //  - when retainActive is false when selecting a new option (i.e. index of the newly selected option is not the same as the current activeIndex)
	          keepActive = thisIsActive || (selected && !this.multiple && !activeIndexIsSet);
	
	      liData.selected = selected;
	
	      a = li.firstChild;
	
	      if (selected) {
	        this.selectedIndex = index;
	      }
	
	      li.classList.toggle('selected', selected);
	
	      if (keepActive) {
	        this.focusItem(li, liData);
	        this.selectpicker.view.currentActive = li;
	        this.activeIndex = index;
	      } else {
	        this.defocusItem(li);
	      }
	
	      if (a) {
	        a.classList.toggle('selected', selected);
	
	        if (selected) {
	          a.setAttribute('aria-selected', true);
	        } else {
	          if (this.multiple) {
	            a.setAttribute('aria-selected', false);
	          } else {
	            a.removeAttribute('aria-selected');
	          }
	        }
	      }
	
	      if (!keepActive && !activeIndexIsSet && selected && this.prevActiveIndex !== undefined) {
	        prevActive = this.selectpicker.main.elements[this.prevActiveIndex];
	
	        this.defocusItem(prevActive);
	      }
	    },
	
	    /**
	     * @param {number} index - the index of the option that is being disabled
	     * @param {boolean} disabled - true if the option is being disabled, false if being enabled
	     */
	    setDisabled: function (index, disabled) {
	      var li = this.selectpicker.main.elements[index],
	          a;
	
	      this.selectpicker.main.data[index].disabled = disabled;
	
	      a = li.firstChild;
	
	      li.classList.toggle(classNames.DISABLED, disabled);
	
	      if (a) {
	        if (version.major === '4') a.classList.toggle(classNames.DISABLED, disabled);
	
	        if (disabled) {
	          a.setAttribute('aria-disabled', disabled);
	          a.setAttribute('tabindex', -1);
	        } else {
	          a.removeAttribute('aria-disabled');
	          a.setAttribute('tabindex', 0);
	        }
	      }
	    },
	
	    isDisabled: function () {
	      return this.$element[0].disabled;
	    },
	
	    checkDisabled: function () {
	      if (this.isDisabled()) {
	        this.$newElement[0].classList.add(classNames.DISABLED);
	        this.$button.addClass(classNames.DISABLED).attr('aria-disabled', true);
	      } else {
	        if (this.$button[0].classList.contains(classNames.DISABLED)) {
	          this.$newElement[0].classList.remove(classNames.DISABLED);
	          this.$button.removeClass(classNames.DISABLED).attr('aria-disabled', false);
	        }
	      }
	    },
	
	    clickListener: function () {
	      var that = this,
	          $document = $(document);
	
	      $document.data('spaceSelect', false);
	
	      this.$button.on('keyup', function (e) {
	        if (/(32)/.test(e.keyCode.toString(10)) && $document.data('spaceSelect')) {
	          e.preventDefault();
	          $document.data('spaceSelect', false);
	        }
	      });
	
	      this.$newElement.on('show.bs.dropdown', function () {
	        if (version.major > 3 && !that.dropdown) {
	          that.dropdown = that.$button.data('bs.dropdown');
	          that.dropdown._menu = that.$menu[0];
	        }
	      });
	
	      this.$button.on('click.bs.dropdown.data-api', function () {
	        if (!that.$newElement.hasClass(classNames.SHOW)) {
	          that.setSize();
	        }
	      });
	
	      function setFocus () {
	        if (that.options.liveSearch) {
	          that.$searchbox.trigger('focus');
	        } else {
	          that.$menuInner.trigger('focus');
	        }
	      }
	
	      function checkPopperExists () {
	        if (that.dropdown && that.dropdown._popper && that.dropdown._popper.state.isCreated) {
	          setFocus();
	        } else {
	          requestAnimationFrame(checkPopperExists);
	        }
	      }
	
	      this.$element.on('shown' + EVENT_KEY, function () {
	        if (that.$menuInner[0].scrollTop !== that.selectpicker.view.scrollTop) {
	          that.$menuInner[0].scrollTop = that.selectpicker.view.scrollTop;
	        }
	
	        if (version.major > 3) {
	          requestAnimationFrame(checkPopperExists);
	        } else {
	          setFocus();
	        }
	      });
	
	      // ensure posinset and setsize are correct before selecting an option via a click
	      this.$menuInner.on('mouseenter', 'li a', function (e) {
	        var hoverLi = this.parentElement,
	            position0 = that.isVirtual() ? that.selectpicker.view.position0 : 0,
	            index = Array.prototype.indexOf.call(hoverLi.parentElement.children, hoverLi),
	            hoverData = that.selectpicker.current.data[index + position0];
	
	        that.focusItem(hoverLi, hoverData, true);
	      });
	
	      this.$menuInner.on('click', 'li a', function (e, retainActive) {
	        var $this = $(this),
	            element = that.$element[0],
	            position0 = that.isVirtual() ? that.selectpicker.view.position0 : 0,
	            clickedData = that.selectpicker.current.data[$this.parent().index() + position0],
	            clickedIndex = clickedData.index,
	            prevValue = getSelectValues(element),
	            prevIndex = element.selectedIndex,
	            prevOption = element.options[prevIndex],
	            triggerChange = true;
	
	        // Don't close on multi choice menu
	        if (that.multiple && that.options.maxOptions !== 1) {
	          e.stopPropagation();
	        }
	
	        e.preventDefault();
	
	        // Don't run if the select is disabled
	        if (!that.isDisabled() && !$this.parent().hasClass(classNames.DISABLED)) {
	          var option = clickedData.option,
	              $option = $(option),
	              state = option.selected,
	              $optgroup = $option.parent('optgroup'),
	              $optgroupOptions = $optgroup.find('option'),
	              maxOptions = that.options.maxOptions,
	              maxOptionsGrp = $optgroup.data('maxOptions') || false;
	
	          if (clickedIndex === that.activeIndex) retainActive = true;
	
	          if (!retainActive) {
	            that.prevActiveIndex = that.activeIndex;
	            that.activeIndex = undefined;
	          }
	
	          if (!that.multiple) { // Deselect all others if not multi select box
	            if (prevOption) prevOption.selected = false;
	            option.selected = true;
	            that.setSelected(clickedIndex, true);
	          } else { // Toggle the one we have chosen if we are multi select.
	            option.selected = !state;
	
	            that.setSelected(clickedIndex, !state);
	            that.focusedParent.focus();
	
	            if (maxOptions !== false || maxOptionsGrp !== false) {
	              var maxReached = maxOptions < getSelectedOptions(element).length,
	                  maxReachedGrp = maxOptionsGrp < $optgroup.find('option:selected').length;
	
	              if ((maxOptions && maxReached) || (maxOptionsGrp && maxReachedGrp)) {
	                if (maxOptions && maxOptions == 1) {
	                  element.selectedIndex = -1;
	                  option.selected = true;
	                  that.setOptionStatus(true);
	                } else if (maxOptionsGrp && maxOptionsGrp == 1) {
	                  for (var i = 0; i < $optgroupOptions.length; i++) {
	                    var _option = $optgroupOptions[i];
	                    _option.selected = false;
	                    that.setSelected(_option.liIndex, false);
	                  }
	
	                  option.selected = true;
	                  that.setSelected(clickedIndex, true);
	                } else {
	                  var maxOptionsText = typeof that.options.maxOptionsText === 'string' ? [that.options.maxOptionsText, that.options.maxOptionsText] : that.options.maxOptionsText,
	                      maxOptionsArr = typeof maxOptionsText === 'function' ? maxOptionsText(maxOptions, maxOptionsGrp) : maxOptionsText,
	                      maxTxt = maxOptionsArr[0].replace('{n}', maxOptions),
	                      maxTxtGrp = maxOptionsArr[1].replace('{n}', maxOptionsGrp),
	                      $notify = $('<div class="notify"></div>');
	                  // If {var} is set in array, replace it
	                  /** @deprecated */
	                  if (maxOptionsArr[2]) {
	                    maxTxt = maxTxt.replace('{var}', maxOptionsArr[2][maxOptions > 1 ? 0 : 1]);
	                    maxTxtGrp = maxTxtGrp.replace('{var}', maxOptionsArr[2][maxOptionsGrp > 1 ? 0 : 1]);
	                  }
	
	                  option.selected = false;
	
	                  that.$menu.append($notify);
	
	                  if (maxOptions && maxReached) {
	                    $notify.append($('<div>' + maxTxt + '</div>'));
	                    triggerChange = false;
	                    that.$element.trigger('maxReached' + EVENT_KEY);
	                  }
	
	                  if (maxOptionsGrp && maxReachedGrp) {
	                    $notify.append($('<div>' + maxTxtGrp + '</div>'));
	                    triggerChange = false;
	                    that.$element.trigger('maxReachedGrp' + EVENT_KEY);
	                  }
	
	                  setTimeout(function () {
	                    that.setSelected(clickedIndex, false);
	                  }, 10);
	
	                  $notify[0].classList.add('fadeOut');
	
	                  setTimeout(function () {
	                    $notify.remove();
	                  }, 1050);
	                }
	              }
	            }
	          }
	
	          if (!that.multiple || (that.multiple && that.options.maxOptions === 1)) {
	            that.$button.trigger('focus');
	          } else if (that.options.liveSearch) {
	            that.$searchbox.trigger('focus');
	          }
	
	          // Trigger select 'change'
	          if (triggerChange) {
	            if (that.multiple || prevIndex !== element.selectedIndex) {
	              // $option.prop('selected') is current option state (selected/unselected). prevValue is the value of the select prior to being changed.
	              changedArguments = [option.index, $option.prop('selected'), prevValue];
	              that.$element
	                .triggerNative('change');
	            }
	          }
	        }
	      });
	
	      this.$menu.on('click', 'li.' + classNames.DISABLED + ' a, .' + classNames.POPOVERHEADER + ', .' + classNames.POPOVERHEADER + ' :not(.close)', function (e) {
	        if (e.currentTarget == this) {
	          e.preventDefault();
	          e.stopPropagation();
	          if (that.options.liveSearch && !$(e.target).hasClass('close')) {
	            that.$searchbox.trigger('focus');
	          } else {
	            that.$button.trigger('focus');
	          }
	        }
	      });
	
	      this.$menuInner.on('click', '.divider, .dropdown-header', function (e) {
	        e.preventDefault();
	        e.stopPropagation();
	        if (that.options.liveSearch) {
	          that.$searchbox.trigger('focus');
	        } else {
	          that.$button.trigger('focus');
	        }
	      });
	
	      this.$menu.on('click', '.' + classNames.POPOVERHEADER + ' .close', function () {
	        that.$button.trigger('click');
	      });
	
	      this.$searchbox.on('click', function (e) {
	        e.stopPropagation();
	      });
	
	      this.$menu.on('click', '.actions-btn', function (e) {
	        if (that.options.liveSearch) {
	          that.$searchbox.trigger('focus');
	        } else {
	          that.$button.trigger('focus');
	        }
	
	        e.preventDefault();
	        e.stopPropagation();
	
	        if ($(this).hasClass('bs-select-all')) {
	          that.selectAll();
	        } else {
	          that.deselectAll();
	        }
	      });
	
	      this.$button
	        .on('focus' + EVENT_KEY, function (e) {
	          var tabindex = that.$element[0].getAttribute('tabindex');
	
	          // only change when button is actually focused
	          if (tabindex !== undefined && e.originalEvent && e.originalEvent.isTrusted) {
	            // apply select element's tabindex to ensure correct order is followed when tabbing to the next element
	            this.setAttribute('tabindex', tabindex);
	            // set element's tabindex to -1 to allow for reverse tabbing
	            that.$element[0].setAttribute('tabindex', -1);
	            that.selectpicker.view.tabindex = tabindex;
	          }
	        })
	        .on('blur' + EVENT_KEY, function (e) {
	          // revert everything to original tabindex
	          if (that.selectpicker.view.tabindex !== undefined && e.originalEvent && e.originalEvent.isTrusted) {
	            that.$element[0].setAttribute('tabindex', that.selectpicker.view.tabindex);
	            this.setAttribute('tabindex', -1);
	            that.selectpicker.view.tabindex = undefined;
	          }
	        });
	
	      this.$element
	        .on('change' + EVENT_KEY, function () {
	          that.render();
	          that.$element.trigger('changed' + EVENT_KEY, changedArguments);
	          changedArguments = null;
	        })
	        .on('focus' + EVENT_KEY, function () {
	          if (!that.options.mobile) that.$button[0].focus();
	        });
	    },
	
	    liveSearchListener: function () {
	      var that = this;
	
	      this.$button.on('click.bs.dropdown.data-api', function () {
	        if (!!that.$searchbox.val()) {
	          that.$searchbox.val('');
	          that.selectpicker.search.previousValue = undefined;
	        }
	      });
	
	      this.$searchbox.on('click.bs.dropdown.data-api focus.bs.dropdown.data-api touchend.bs.dropdown.data-api', function (e) {
	        e.stopPropagation();
	      });
	
	      this.$searchbox.on('input propertychange', function () {
	        var searchValue = that.$searchbox[0].value;
	
	        that.selectpicker.search.elements = [];
	        that.selectpicker.search.data = [];
	
	        if (searchValue) {
	          var i,
	              searchMatch = [],
	              q = searchValue.toUpperCase(),
	              cache = {},
	              cacheArr = [],
	              searchStyle = that._searchStyle(),
	              normalizeSearch = that.options.liveSearchNormalize;
	
	          if (normalizeSearch) q = normalizeToBase(q);
	
	          for (var i = 0; i < that.selectpicker.main.data.length; i++) {
	            var li = that.selectpicker.main.data[i];
	
	            if (!cache[i]) {
	              cache[i] = stringSearch(li, q, searchStyle, normalizeSearch);
	            }
	
	            if (cache[i] && li.headerIndex !== undefined && cacheArr.indexOf(li.headerIndex) === -1) {
	              if (li.headerIndex > 0) {
	                cache[li.headerIndex - 1] = true;
	                cacheArr.push(li.headerIndex - 1);
	              }
	
	              cache[li.headerIndex] = true;
	              cacheArr.push(li.headerIndex);
	
	              cache[li.lastIndex + 1] = true;
	            }
	
	            if (cache[i] && li.type !== 'optgroup-label') cacheArr.push(i);
	          }
	
	          for (var i = 0, cacheLen = cacheArr.length; i < cacheLen; i++) {
	            var index = cacheArr[i],
	                prevIndex = cacheArr[i - 1],
	                li = that.selectpicker.main.data[index],
	                liPrev = that.selectpicker.main.data[prevIndex];
	
	            if (li.type !== 'divider' || (li.type === 'divider' && liPrev && liPrev.type !== 'divider' && cacheLen - 1 !== i)) {
	              that.selectpicker.search.data.push(li);
	              searchMatch.push(that.selectpicker.main.elements[index]);
	            }
	          }
	
	          that.activeIndex = undefined;
	          that.noScroll = true;
	          that.$menuInner.scrollTop(0);
	          that.selectpicker.search.elements = searchMatch;
	          that.createView(true);
	          showNoResults.call(that, searchMatch, searchValue);
	        } else if (that.selectpicker.search.previousValue) { // for IE11 (#2402)
	          that.$menuInner.scrollTop(0);
	          that.createView(false);
	        }
	
	        that.selectpicker.search.previousValue =  searchValue;
	      });
	    },
	
	    _searchStyle: function () {
	      return this.options.liveSearchStyle || 'contains';
	    },
	
	    val: function (value) {
	      var element = this.$element[0];
	
	      if (typeof value !== 'undefined') {
	        var prevValue = getSelectValues(element);
	
	        changedArguments = [null, null, prevValue];
	
	        this.$element
	          .val(value)
	          .trigger('changed' + EVENT_KEY, changedArguments);
	
	        if (this.$newElement.hasClass(classNames.SHOW)) {
	          if (this.multiple) {
	            this.setOptionStatus(true);
	          } else {
	            var liSelectedIndex = (element.options[element.selectedIndex] || {}).liIndex;
	
	            if (typeof liSelectedIndex === 'number') {
	              this.setSelected(this.selectedIndex, false);
	              this.setSelected(liSelectedIndex, true);
	            }
	          }
	        }
	
	        this.render();
	
	        changedArguments = null;
	
	        return this.$element;
	      } else {
	        return this.$element.val();
	      }
	    },
	
	    changeAll: function (status) {
	      if (!this.multiple) return;
	      if (typeof status === 'undefined') status = true;
	
	      var element = this.$element[0],
	          previousSelected = 0,
	          currentSelected = 0,
	          prevValue = getSelectValues(element);
	
	      element.classList.add('bs-select-hidden');
	
	      for (var i = 0, data = this.selectpicker.current.data, len = data.length; i < len; i++) {
	        var liData = data[i],
	            option = liData.option;
	
	        if (option && !liData.disabled && liData.type !== 'divider') {
	          if (liData.selected) previousSelected++;
	          option.selected = status;
	          if (status === true) currentSelected++;
	        }
	      }
	
	      element.classList.remove('bs-select-hidden');
	
	      if (previousSelected === currentSelected) return;
	
	      this.setOptionStatus();
	
	      changedArguments = [null, null, prevValue];
	
	      this.$element
	        .triggerNative('change');
	    },
	
	    selectAll: function () {
	      return this.changeAll(true);
	    },
	
	    deselectAll: function () {
	      return this.changeAll(false);
	    },
	
	    toggle: function (e) {
	      e = e || window.event;
	
	      if (e) e.stopPropagation();
	
	      this.$button.trigger('click.bs.dropdown.data-api');
	    },
	
	    keydown: function (e) {
	      var $this = $(this),
	          isToggle = $this.hasClass('dropdown-toggle'),
	          $parent = isToggle ? $this.closest('.dropdown') : $this.closest(Selector.MENU),
	          that = $parent.data('this'),
	          $items = that.findLis(),
	          index,
	          isActive,
	          liActive,
	          activeLi,
	          offset,
	          updateScroll = false,
	          downOnTab = e.which === keyCodes.TAB && !isToggle && !that.options.selectOnTab,
	          isArrowKey = REGEXP_ARROW.test(e.which) || downOnTab,
	          scrollTop = that.$menuInner[0].scrollTop,
	          isVirtual = that.isVirtual(),
	          position0 = isVirtual === true ? that.selectpicker.view.position0 : 0;
	
	      // do nothing if a function key is pressed
	      if (e.which >= 112 && e.which <= 123) return;
	
	      isActive = that.$newElement.hasClass(classNames.SHOW);
	
	      if (
	        !isActive &&
	        (
	          isArrowKey ||
	          (e.which >= 48 && e.which <= 57) ||
	          (e.which >= 96 && e.which <= 105) ||
	          (e.which >= 65 && e.which <= 90)
	        )
	      ) {
	        that.$button.trigger('click.bs.dropdown.data-api');
	
	        if (that.options.liveSearch) {
	          that.$searchbox.trigger('focus');
	          return;
	        }
	      }
	
	      if (e.which === keyCodes.ESCAPE && isActive) {
	        e.preventDefault();
	        that.$button.trigger('click.bs.dropdown.data-api').trigger('focus');
	      }
	
	      if (isArrowKey) { // if up or down
	        if (!$items.length) return;
	
	        liActive = that.selectpicker.main.elements[that.activeIndex];
	        index = liActive ? Array.prototype.indexOf.call(liActive.parentElement.children, liActive) : -1;
	
	        if (index !== -1) {
	          that.defocusItem(liActive);
	        }
	
	        if (e.which === keyCodes.ARROW_UP) { // up
	          if (index !== -1) index--;
	          if (index + position0 < 0) index += $items.length;
	
	          if (!that.selectpicker.view.canHighlight[index + position0]) {
	            index = that.selectpicker.view.canHighlight.slice(0, index + position0).lastIndexOf(true) - position0;
	            if (index === -1) index = $items.length - 1;
	          }
	        } else if (e.which === keyCodes.ARROW_DOWN || downOnTab) { // down
	          index++;
	          if (index + position0 >= that.selectpicker.view.canHighlight.length) index = that.selectpicker.view.firstHighlightIndex;
	
	          if (!that.selectpicker.view.canHighlight[index + position0]) {
	            index = index + 1 + that.selectpicker.view.canHighlight.slice(index + position0 + 1).indexOf(true);
	          }
	        }
	
	        e.preventDefault();
	
	        var liActiveIndex = position0 + index;
	
	        if (e.which === keyCodes.ARROW_UP) { // up
	          // scroll to bottom and highlight last option
	          if (position0 === 0 && index === $items.length - 1) {
	            that.$menuInner[0].scrollTop = that.$menuInner[0].scrollHeight;
	
	            liActiveIndex = that.selectpicker.current.elements.length - 1;
	          } else {
	            activeLi = that.selectpicker.current.data[liActiveIndex];
	            offset = activeLi.position - activeLi.height;
	
	            updateScroll = offset < scrollTop;
	          }
	        } else if (e.which === keyCodes.ARROW_DOWN || downOnTab) { // down
	          // scroll to top and highlight first option
	          if (index === that.selectpicker.view.firstHighlightIndex) {
	            that.$menuInner[0].scrollTop = 0;
	
	            liActiveIndex = that.selectpicker.view.firstHighlightIndex;
	          } else {
	            activeLi = that.selectpicker.current.data[liActiveIndex];
	            offset = activeLi.position - that.sizeInfo.menuInnerHeight;
	
	            updateScroll = offset > scrollTop;
	          }
	        }
	
	        liActive = that.selectpicker.current.elements[liActiveIndex];
	
	        that.activeIndex = that.selectpicker.current.data[liActiveIndex].index;
	
	        that.focusItem(liActive);
	
	        that.selectpicker.view.currentActive = liActive;
	
	        if (updateScroll) that.$menuInner[0].scrollTop = offset;
	
	        if (that.options.liveSearch) {
	          that.$searchbox.trigger('focus');
	        } else {
	          $this.trigger('focus');
	        }
	      } else if (
	        (!$this.is('input') && !REGEXP_TAB_OR_ESCAPE.test(e.which)) ||
	        (e.which === keyCodes.SPACE && that.selectpicker.keydown.keyHistory)
	      ) {
	        var searchMatch,
	            matches = [],
	            keyHistory;
	
	        e.preventDefault();
	
	        that.selectpicker.keydown.keyHistory += keyCodeMap[e.which];
	
	        if (that.selectpicker.keydown.resetKeyHistory.cancel) clearTimeout(that.selectpicker.keydown.resetKeyHistory.cancel);
	        that.selectpicker.keydown.resetKeyHistory.cancel = that.selectpicker.keydown.resetKeyHistory.start();
	
	        keyHistory = that.selectpicker.keydown.keyHistory;
	
	        // if all letters are the same, set keyHistory to just the first character when searching
	        if (/^(.)\1+$/.test(keyHistory)) {
	          keyHistory = keyHistory.charAt(0);
	        }
	
	        // find matches
	        for (var i = 0; i < that.selectpicker.current.data.length; i++) {
	          var li = that.selectpicker.current.data[i],
	              hasMatch;
	
	          hasMatch = stringSearch(li, keyHistory, 'startsWith', true);
	
	          if (hasMatch && that.selectpicker.view.canHighlight[i]) {
	            matches.push(li.index);
	          }
	        }
	
	        if (matches.length) {
	          var matchIndex = 0;
	
	          $items.removeClass('active').find('a').removeClass('active');
	
	          // either only one key has been pressed or they are all the same key
	          if (keyHistory.length === 1) {
	            matchIndex = matches.indexOf(that.activeIndex);
	
	            if (matchIndex === -1 || matchIndex === matches.length - 1) {
	              matchIndex = 0;
	            } else {
	              matchIndex++;
	            }
	          }
	
	          searchMatch = matches[matchIndex];
	
	          activeLi = that.selectpicker.main.data[searchMatch];
	
	          if (scrollTop - activeLi.position > 0) {
	            offset = activeLi.position - activeLi.height;
	            updateScroll = true;
	          } else {
	            offset = activeLi.position - that.sizeInfo.menuInnerHeight;
	            // if the option is already visible at the current scroll position, just keep it the same
	            updateScroll = activeLi.position > scrollTop + that.sizeInfo.menuInnerHeight;
	          }
	
	          liActive = that.selectpicker.main.elements[searchMatch];
	
	          that.activeIndex = matches[matchIndex];
	
	          that.focusItem(liActive);
	
	          if (liActive) liActive.firstChild.focus();
	
	          if (updateScroll) that.$menuInner[0].scrollTop = offset;
	
	          $this.trigger('focus');
	        }
	      }
	
	      // Select focused option if "Enter", "Spacebar" or "Tab" (when selectOnTab is true) are pressed inside the menu.
	      if (
	        isActive &&
	        (
	          (e.which === keyCodes.SPACE && !that.selectpicker.keydown.keyHistory) ||
	          e.which === keyCodes.ENTER ||
	          (e.which === keyCodes.TAB && that.options.selectOnTab)
	        )
	      ) {
	        if (e.which !== keyCodes.SPACE) e.preventDefault();
	
	        if (!that.options.liveSearch || e.which !== keyCodes.SPACE) {
	          that.$menuInner.find('.active a').trigger('click', true); // retain active class
	          $this.trigger('focus');
	
	          if (!that.options.liveSearch) {
	            // Prevent screen from scrolling if the user hits the spacebar
	            e.preventDefault();
	            // Fixes spacebar selection of dropdown items in FF & IE
	            $(document).data('spaceSelect', true);
	          }
	        }
	      }
	    },
	
	    mobile: function () {
	      // ensure mobile is set to true if mobile function is called after init
	      this.options.mobile = true;
	      this.$element[0].classList.add('mobile-device');
	    },
	
	    refresh: function () {
	      // update options if data attributes have been changed
	      var config = $.extend({}, this.options, this.$element.data());
	      this.options = config;
	
	      this.checkDisabled();
	      this.buildData();
	      this.setStyle();
	      this.render();
	      this.buildList();
	      this.setWidth();
	
	      this.setSize(true);
	
	      this.$element.trigger('refreshed' + EVENT_KEY);
	    },
	
	    hide: function () {
	      this.$newElement.hide();
	    },
	
	    show: function () {
	      this.$newElement.show();
	    },
	
	    remove: function () {
	      this.$newElement.remove();
	      this.$element.remove();
	    },
	
	    destroy: function () {
	      this.$newElement.before(this.$element).remove();
	
	      if (this.$bsContainer) {
	        this.$bsContainer.remove();
	      } else {
	        this.$menu.remove();
	      }
	
	      if (this.selectpicker.view.titleOption && this.selectpicker.view.titleOption.parentNode) {
	        this.selectpicker.view.titleOption.parentNode.removeChild(this.selectpicker.view.titleOption);
	      }
	
	      this.$element
	        .off(EVENT_KEY)
	        .removeData('selectpicker')
	        .removeClass('bs-select-hidden selectpicker');
	
	      $(window).off(EVENT_KEY + '.' + this.selectId);
	    }
	  };
	
	  // SELECTPICKER PLUGIN DEFINITION
	  // ==============================
	  function Plugin (option) {
	    // get the args of the outer function..
	    var args = arguments;
	    // The arguments of the function are explicitly re-defined from the argument list, because the shift causes them
	    // to get lost/corrupted in android 2.3 and IE9 #715 #775
	    var _option = option;
	
	    [].shift.apply(args);
	
	    // if the version was not set successfully
	    if (!version.success) {
	      // try to retreive it again
	      try {
	        version.full = ($.fn.dropdown.Constructor.VERSION || '').split(' ')[0].split('.');
	      } catch (err) {
	        // fall back to use BootstrapVersion if set
	        if (Selectpicker.BootstrapVersion) {
	          version.full = Selectpicker.BootstrapVersion.split(' ')[0].split('.');
	        } else {
	          version.full = [version.major, '0', '0'];
	
	          console.warn(
	            'There was an issue retrieving Bootstrap\'s version. ' +
	            'Ensure Bootstrap is being loaded before bootstrap-select and there is no namespace collision. ' +
	            'If loading Bootstrap asynchronously, the version may need to be manually specified via $.fn.selectpicker.Constructor.BootstrapVersion.',
	            err
	          );
	        }
	      }
	
	      version.major = version.full[0];
	      version.success = true;
	    }
	
	    if (version.major === '4') {
	      // some defaults need to be changed if using Bootstrap 4
	      // check to see if they have already been manually changed before forcing them to update
	      var toUpdate = [];
	
	      if (Selectpicker.DEFAULTS.style === classNames.BUTTONCLASS) toUpdate.push({ name: 'style', className: 'BUTTONCLASS' });
	      if (Selectpicker.DEFAULTS.iconBase === classNames.ICONBASE) toUpdate.push({ name: 'iconBase', className: 'ICONBASE' });
	      if (Selectpicker.DEFAULTS.tickIcon === classNames.TICKICON) toUpdate.push({ name: 'tickIcon', className: 'TICKICON' });
	
	      classNames.DIVIDER = 'dropdown-divider';
	      classNames.SHOW = 'show';
	      classNames.BUTTONCLASS = 'btn-light';
	      classNames.POPOVERHEADER = 'popover-header';
	      classNames.ICONBASE = '';
	      classNames.TICKICON = 'bs-ok-default';
	
	      for (var i = 0; i < toUpdate.length; i++) {
	        var option = toUpdate[i];
	        Selectpicker.DEFAULTS[option.name] = classNames[option.className];
	      }
	    }
	
	    var value;
	    var chain = this.each(function () {
	      var $this = $(this);
	      if ($this.is('select')) {
	        var data = $this.data('selectpicker'),
	            options = typeof _option == 'object' && _option;
	
	        if (!data) {
	          var dataAttributes = $this.data();
	
	          for (var dataAttr in dataAttributes) {
	            if (Object.prototype.hasOwnProperty.call(dataAttributes, dataAttr) && $.inArray(dataAttr, DISALLOWED_ATTRIBUTES) !== -1) {
	              delete dataAttributes[dataAttr];
	            }
	          }
	
	          var config = $.extend({}, Selectpicker.DEFAULTS, $.fn.selectpicker.defaults || {}, dataAttributes, options);
	          config.template = $.extend({}, Selectpicker.DEFAULTS.template, ($.fn.selectpicker.defaults ? $.fn.selectpicker.defaults.template : {}), dataAttributes.template, options.template);
	          $this.data('selectpicker', (data = new Selectpicker(this, config)));
	        } else if (options) {
	          for (var i in options) {
	            if (Object.prototype.hasOwnProperty.call(options, i)) {
	              data.options[i] = options[i];
	            }
	          }
	        }
	
	        if (typeof _option == 'string') {
	          if (data[_option] instanceof Function) {
	            value = data[_option].apply(data, args);
	          } else {
	            value = data.options[_option];
	          }
	        }
	      }
	    });
	
	    if (typeof value !== 'undefined') {
	      // noinspection JSUnusedAssignment
	      return value;
	    } else {
	      return chain;
	    }
	  }
	
	  var old = $.fn.selectpicker;
	  $.fn.selectpicker = Plugin;
	  $.fn.selectpicker.Constructor = Selectpicker;
	
	  // SELECTPICKER NO CONFLICT
	  // ========================
	  $.fn.selectpicker.noConflict = function () {
	    $.fn.selectpicker = old;
	    return this;
	  };
	
	  // get Bootstrap's keydown event handler for either Bootstrap 4 or Bootstrap 3
	  function keydownHandler () {
	    if ($.fn.dropdown) {
	      // wait to define until function is called in case Bootstrap isn't loaded yet
	      var bootstrapKeydown = $.fn.dropdown.Constructor._dataApiKeydownHandler || $.fn.dropdown.Constructor.prototype.keydown;
	      return bootstrapKeydown.apply(this, arguments);
	    }
	  }
	
	  $(document)
	    .off('keydown.bs.dropdown.data-api')
	    .on('keydown.bs.dropdown.data-api', ':not(.bootstrap-select) > [data-toggle="dropdown"]', keydownHandler)
	    .on('keydown.bs.dropdown.data-api', ':not(.bootstrap-select) > .dropdown-menu', keydownHandler)
	    .on('keydown' + EVENT_KEY, '.bootstrap-select [data-toggle="dropdown"], .bootstrap-select [role="listbox"], .bootstrap-select .bs-searchbox input', Selectpicker.prototype.keydown)
	    .on('focusin.modal', '.bootstrap-select [data-toggle="dropdown"], .bootstrap-select [role="listbox"], .bootstrap-select .bs-searchbox input', function (e) {
	      e.stopPropagation();
	    });
	
	  // SELECTPICKER DATA-API
	  // =====================
	  $(window).on('load' + EVENT_KEY + '.data-api', function () {
	    $('.selectpicker').each(function () {
	      var $selectpicker = $(this);
	      Plugin.call($selectpicker, $selectpicker.data());
	    })
	  });
	})(jQuery);
	
	
	}));
	//# sourceMappingURL=bootstrap-select.js.map

/***/ }),
/* 89 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function($) {'use strict';
	
	/* * * * * * * * * * * * * * * * * * * * * * * * * * * * * *
	
	Adds loading animation to all elements with the attribute [data-btn-ajax-loader].
	
	It ist meant for 'load more' button elements.
	
	How it works:
	
	1. When clicking on an element, a 'loader' icon appears within the button
	2. As soon as the 'btnAjaxLoaderDone' event is triggered, the icon is hidden
	the buton goes back to normal.
	
	Required markup (button style can vary, of course:
	
	<a href="#" class="btn btn-default" data-btn-ajax-loader>
	    <span class="btn-text"></span>
	</a>
	
	*/
	
	function resetBtnAjaxLoader($btn) {
	    $btn.removeClass('loading');
	}
	
	function setBtnAjaxLoader($btn) {
	    $btn.addClass('loading');
	}
	
	function setBtnAjaxLoaderSize($btn) {
	    // set dimensions...
	    var width = $btn.outerWidth();
	    var height = $btn.outerHeight();
	    // ...but only if the item is visible (in case the element is within an elemnt with display:none, we get 0)
	    if (width > 0) {
	        $btn.css('width', width).css('height', height);
	    }
	}
	
	function initBtnAjaxLoader() {
	    // find buttons and loop!
	    var btn_elements = document.querySelectorAll('[data-btn-ajax-loader]');
	    if (btn_elements.length > 0) {
	        for (var i = 0; i < btn_elements.length; i++) {
	            // init
	            var $element = $(btn_elements[i]);
	            var initialized_attr = 'data-trigger-initialized';
	            // listen for click event
	            $element.on('click', function (e) {
	                // init
	                var $btn = $(this);
	                // are we validation the form? Delayed check so we can check if the error class has been added in the meanwhile
	                if ($btn.parents('form').hasClass('validate-form') === true) {
	                    // only apply 'loading' styles when there are NO errors
	                    // required mini-delay to check if the class has been added
	                    setTimeout(function () {
	                        if ($btn.parents('form').hasClass('has-errors') === false) {
	                            setBtnAjaxLoaderSize($btn);
	                            setBtnAjaxLoader($btn);
	                        }
	                    }, 10);
	                }
	                // otherwise, let it load right away!
	                else {
	                        setBtnAjaxLoaderSize($btn);
	                        setBtnAjaxLoader($btn);
	                    }
	            });
	        }
	    }
	    return btn_elements;
	}
	
	function btnAjaxLoaderDone() {
	    // find buttons and loop!
	    var btn_elements = initBtnAjaxLoader();
	    if (btn_elements.length > 0) {
	        for (var i = 0; i < btn_elements.length; i++) {
	            var $element = $(btn_elements[i]);
	            resetBtnAjaxLoader($element);
	        }
	    }
	}
	
	function resetBtnAjaxLoaderSize() {
	    // find buttons and loop!
	    var btn_elements = document.querySelectorAll('[data-btn-ajax-loader]');
	    if (btn_elements.length > 0) {
	        for (var i = 0; i < btn_elements.length; i++) {
	            // init
	            var $element = $(btn_elements[i]);
	            // re-set dimensions
	            $element.css('width', '').css('height', '');
	        }
	    }
	}
	
	$(function () {
	
	    // on page load
	    initBtnAjaxLoader();
	
	    // custom event
	    $(window).on('initBtnAjaxLoader softpage:opened', function () {
	        initBtnAjaxLoader();
	    });
	
	    // custom event
	    $(window).on('btnAjaxLoaderDone ajaxLoadItems:success', function () {
	        btnAjaxLoaderDone();
	    });
	
	    // listen for a viewport width change and re-init the loaders (because of resizing the)
	    $(window).on('viewportWidthHasChanged', function () {
	        resetBtnAjaxLoaderSize();
	    });
	});
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(2)))

/***/ }),
/* 90 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function($) {'use strict';
	
	/* * * * * * * * * * * * * * * * * * * * * * * * * * * * * *
	
	Default Contact Form
	
	*/
	
	$(function () {
	
	    function initContactForm() {
	
	        // init
	        var $the_form = $('.default-contact-form');
	        var $phone_container = $the_form.find('.phone-container');
	        var $email_container = $the_form.find('.email-container');
	        var $contact_type_select = $the_form.find('#id_contact_type');
	
	        var updateFields = function updateFields() {
	            // show PHONE option
	            if ($contact_type_select.val() == 10) {
	                $phone_container.find('input').attr('disabled', false);
	                $phone_container.show();
	                $email_container.find('input').attr('disabled', true);
	                $email_container.hide();
	            }
	            // show EMAIL option
	            else if ($contact_type_select.val() == 20) {
	                    $email_container.find('input').attr('disabled', false);
	                    $email_container.show();
	                    $phone_container.find('input').attr('disabled', true);
	                    $phone_container.hide();
	                }
	                // no option (hide everything)
	                else {
	                        $phone_container.find('input').attr('disabled', true);
	                        $phone_container.hide();
	                        $email_container.find('input').attr('disabled', true);
	                        $email_container.hide();
	                    }
	        };
	
	        var initSelect = function initSelect($the_form, $contact_type_select) {
	            // change option
	            $the_form.on('change', $contact_type_select, function () {
	                updateFields();
	            });
	        };
	
	        // initial update
	        updateFields();
	        // init select listener
	        initSelect($the_form, $contact_type_select);
	    }
	
	    // on page load
	    initContactForm();
	
	    // custom event
	    $(window).on('initContactForm ajaxFormSuccess softpage:opened form-modal:opened', function () {
	        initContactForm();
	    });
	});
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(2)))

/***/ }),
/* 91 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function($) {'use strict';
	
	var _flatpickr = __webpack_require__(92);
	
	var _flatpickr2 = _interopRequireDefault(_flatpickr);
	
	var _de = __webpack_require__(93);
	
	var _de2 = _interopRequireDefault(_de);
	
	var _fr = __webpack_require__(94);
	
	var _fr2 = _interopRequireDefault(_fr);
	
	var _it = __webpack_require__(95);
	
	var _it2 = _interopRequireDefault(_it);
	
	var _es = __webpack_require__(96);
	
	var _es2 = _interopRequireDefault(_es);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	// Let's load and add the most common languages
	function initDatepicker() {
	
	    // Extend the existing localization object with additional langugaes
	
	    // German
	    _flatpickr2.default.l10ns.de = _de2.default.de;
	    _flatpickr2.default.l10ns.de.firstDayOfWeek = 1; // Our week starts with Monday
	
	    // French
	    _flatpickr2.default.l10ns.fr = _fr2.default.fr;
	    _flatpickr2.default.l10ns.fr.firstDayOfWeek = 1; // Our week starts with Monday
	
	    // Italian
	    _flatpickr2.default.l10ns.it = _it2.default.it;
	    _flatpickr2.default.l10ns.it.firstDayOfWeek = 1; // Our week starts with Monday
	
	    // Spanish
	    _flatpickr2.default.l10ns.es = _es2.default.es;
	    _flatpickr2.default.l10ns.es.firstDayOfWeek = 1; // Our week starts with Monday
	
	    // determine currently active language
	    var active_lang = document.querySelector('html').getAttribute('lang');
	    // fallback lang
	    if (!active_lang) {
	        active_lang = 'en';
	    }
	
	    // find datepicker elements and loop!
	    var datepicker_elements = document.querySelectorAll('.datepicker');
	    if (datepicker_elements.length > 0) {
	        var _loop = function _loop() {
	
	            /* * * * * * * * * * * * * * * * * * * * * * * * * * * * * *
	             get custom options from the input's data-attribute or set default options
	             */
	
	            // init
	            element = datepicker_elements[i];
	            $datepicker_element = $(element);
	            $datepicker_container = $datepicker_element.parents('.datepicker-container');
	            has_value_class = 'has-value';
	
	            // TIME only
	
	            noCalendar = $datepicker_element.attr('data-noCalendar');
	
	            if (typeof noCalendar === 'undefined') {
	                noCalendar = false;
	            } else {
	                noCalendar = true;
	            }
	            // date AND time
	            enableTime = $datepicker_element.attr('data-enableTime');
	
	            if (typeof enableTime === 'undefined') {
	                enableTime = false;
	            } else {
	                enableTime = true;
	            }
	            // technical format
	            dateFormat = $datepicker_element.attr('data-dateFormat');
	
	            if (!dateFormat) {
	                dateFormat = 'Y-m-d';
	            }
	            // Pretty Format
	            altFormat = $datepicker_element.attr('data-altFormat');
	
	            if (!altFormat) {
	                altFormat = 'D, j. F Y';
	            }
	            // MAX date
	            maxDate = $datepicker_element.attr('data-maxDate');
	
	            if (!maxDate) {
	                maxDate = false;
	            }
	            // MIN date
	            minDate = $datepicker_element.attr('data-minDate');
	
	            if (!minDate) {
	                minDate = 'today';
	            }
	            // set options
	            var options = {
	                locale: active_lang, // IMPORTANT: We're gonna select the language according to the "lang" attribute of the <html> element
	                time_24hr: true,
	                altInput: true,
	                altInputClass: 'form-control datepicker-rendered',
	                disableMobile: true,
	                altFormat: altFormat,
	                clickOpens: true,
	                allowInput: false,
	                dateFormat: dateFormat,
	                minDate: minDate,
	                maxDate: maxDate,
	                wrap: false,
	                enableTime: enableTime,
	                noCalendar: noCalendar,
	                onValueUpdate: function onValueUpdate(selectedDates, dateStr, instance) {
	                    // get parent container
	                    var $datepicker_container = $(instance.element).parents('.datepicker-container');
	                    // add class, so we can show the clear button
	                    $datepicker_container.addClass(has_value_class);
	                }
	            };
	
	            // init
	            var flatpickr_instance = new _flatpickr2.default(element, options);
	
	            // clear value
	            var $clear_btn = $(element).siblings('.clear-btn');
	            $clear_btn.on('click', function () {
	                // a click outside the datepicker input field closes it. So we gotta "delay" it.
	                setTimeout(function () {
	                    flatpickr_instance.clear();
	                    // add class, so we can show the clear button
	                    $datepicker_container.removeClass(has_value_class);
	                }, 0);
	            });
	
	            // calendar toggle
	            var $datetime_btn = $(element).siblings('.calendar-btn, .time-btn');
	            $datetime_btn.on('click', function () {
	                // a click outside the datepicker input field closes it. So we gotta "delay" it.
	                setTimeout(function () {
	                    flatpickr_instance.toggle();
	                }, 0);
	            });
	
	            // label toggle
	            var $label = $(element).parents('.form-field-container').siblings('.control-label');
	            $label.on('click', function () {
	                // a click outside the datepicker input field closes it. By delaying the call we can
	                setTimeout(function () {
	                    flatpickr_instance.toggle();
	                }, 0);
	            });
	        };
	
	        for (var i = 0; i < datepicker_elements.length; i++) {
	            var element;
	            var $datepicker_element;
	            var $datepicker_container;
	            var has_value_class;
	            var noCalendar;
	            var enableTime;
	            var dateFormat;
	            var altFormat;
	            var maxDate;
	            var minDate;
	
	            _loop();
	        }
	    }
	} /* * * * * * * * * * * * * * * * * * * * * * * * * * * * * *
	  
	  Datepicker
	  
	  We use the package "Flatpickr"
	  
	  Docs: https://chmln.github.io/flatpickr/
	  Options: https://chmln.github.io/flatpickr/#options
	  
	  Available Attribute Options (Django Form):
	  
	  date_time = forms.DateTimeField(
	      label=_(u'Date and Time'),
	      widget=forms.widgets.DateTimeInput(
	          attrs={
	              'placeholder': _(u'Please choose date and time'),
	              'data-dateFormat': 'Y-m-d H:i',
	              'data-altFormat': 'D, j. F Y, H:i',
	              'data-minDate': str(datetime.date.today() - datetime.timedelta(days=180)),
	              'data-maxDate': 'today',
	              'data-enableTime': True,
	              'data-noCalendar': True,
	          }
	      ),
	  )
	  
	  */
	
	$(function () {
	
	    // on page load
	    initDatepicker();
	
	    // custom event
	    $(window).on('initDatepicker softpage:opened form-modal:opened', function () {
	        initDatepicker();
	    });
	});
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(2)))

/***/ }),
/* 92 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(jQuery) {var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	/*! flatpickr v2.3.4, @license MIT */
	function Flatpickr(element, config) {
		var self = this;
	
		function init() {
			if (element._flatpickr) destroy(element._flatpickr);
	
			element._flatpickr = self;
	
			self.element = element;
			self.instanceConfig = config || {};
	
			setupFormats();
	
			parseConfig();
			setupLocale();
			setupInputs();
			setupDates();
			setupHelperFunctions();
	
			self.isOpen = self.config.inline;
			self.changeMonth = changeMonth;
			self.clear = clear;
			self.close = close;
			self.destroy = destroy;
			self.formatDate = formatDate;
			self.jumpToDate = jumpToDate;
			self.open = open;
			self.redraw = redraw;
			self.set = set;
			self.setDate = setDate;
			self.toggle = toggle;
	
			self.isMobile = !self.config.disableMobile && !self.config.inline && self.config.mode === "single" && !self.config.disable.length && !self.config.enable.length && !self.config.weekNumbers && /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent);
	
			if (!self.isMobile) build();
	
			bind();
	
			if (!self.isMobile) {
				Object.defineProperty(self, "dateIsPicked", {
					set: function set(bool) {
						if (bool) return self.calendarContainer.classList.add("dateIsPicked");
						self.calendarContainer.classList.remove("dateIsPicked");
					}
				});
			}
	
			self.dateIsPicked = self.selectedDates.length > 0 || self.config.noCalendar;
	
			if (self.selectedDates.length) {
				if (self.config.enableTime) setHoursFromDate();
				updateValue();
			}
	
			if (self.config.weekNumbers) {
				self.calendarContainer.style.width = self.days.clientWidth + self.weekWrapper.clientWidth + "px";
			}
	
			triggerEvent("Ready");
		}
	
		function updateTime(e) {
			if (self.config.noCalendar && !self.selectedDates.length)
				// picking time only
				self.selectedDates = [self.now];
	
			timeWrapper(e);
	
			if (!self.selectedDates.length) return;
	
			if (!self.minDateHasTime || e.type !== "input" || e.target.value.length >= 2) {
				setHoursFromInputs();
				updateValue();
			} else {
				setTimeout(function () {
					setHoursFromInputs();
					updateValue();
				}, 1000);
			}
		}
	
		function setHoursFromInputs() {
			if (!self.config.enableTime) return;
	
			var hours = parseInt(self.hourElement.value, 10) || 0,
			    minutes = parseInt(self.minuteElement.value, 10) || 0,
			    seconds = self.config.enableSeconds ? parseInt(self.secondElement.value, 10) || 0 : 0;
	
			if (self.amPM) hours = hours % 12 + 12 * (self.amPM.textContent === "PM");
	
			if (self.minDateHasTime && compareDates(self.latestSelectedDateObj, self.config.minDate) === 0) {
	
				hours = Math.max(hours, self.config.minDate.getHours());
				if (hours === self.config.minDate.getHours()) minutes = Math.max(minutes, self.config.minDate.getMinutes());
			} else if (self.maxDateHasTime && compareDates(self.latestSelectedDateObj, self.config.maxDate) === 0) {
				hours = Math.min(hours, self.config.maxDate.getHours());
				if (hours === self.config.maxDate.getHours()) minutes = Math.min(minutes, self.config.maxDate.getMinutes());
			}
	
			setHours(hours, minutes, seconds);
		}
	
		function setHoursFromDate(dateObj) {
			var date = dateObj || self.latestSelectedDateObj;
	
			if (date) setHours(date.getHours(), date.getMinutes(), date.getSeconds());
		}
	
		function setHours(hours, minutes, seconds) {
			if (self.selectedDates.length) {
				self.latestSelectedDateObj.setHours(hours % 24, minutes, seconds || 0, 0);
			}
	
			if (!self.config.enableTime || self.isMobile) return;
	
			self.hourElement.value = self.pad(!self.config.time_24hr ? (12 + hours) % 12 + 12 * (hours % 12 === 0) : hours);
	
			self.minuteElement.value = self.pad(minutes);
	
			if (!self.config.time_24hr && self.selectedDates.length) self.amPM.textContent = self.latestSelectedDateObj.getHours() >= 12 ? "PM" : "AM";
	
			if (self.config.enableSeconds) self.secondElement.value = self.pad(seconds);
		}
	
		function onYearInput(event) {
			if (event.target.value.length === 4) {
				self.currentYearElement.blur();
				handleYearChange(event.target.value);
				event.target.value = self.currentYear;
			}
		}
	
		function bind() {
			if (self.config.wrap) {
				["open", "close", "toggle", "clear"].forEach(function (el) {
					try {
						self.element.querySelector("[data-" + el + "]").addEventListener("click", self[el]);
					} catch (e) {
						//
					}
				});
			}
	
			if (window.document.createEvent !== undefined) {
				self.changeEvent = window.document.createEvent("HTMLEvents");
				self.changeEvent.initEvent("change", false, true);
			}
	
			if (self.isMobile) return setupMobile();
	
			self.debouncedResize = debounce(onResize, 50);
			self.triggerChange = function () {
				triggerEvent("Change");
			};
			self.debouncedChange = debounce(self.triggerChange, 300);
	
			if (self.config.mode === "range" && self.days) self.days.addEventListener("mouseover", onMouseOver);
	
			window.document.addEventListener("keydown", onKeyDown);
	
			if (!self.config.inline && !self.config.static) window.addEventListener("resize", self.debouncedResize);
	
			if (window.ontouchstart) window.document.addEventListener("touchstart", documentClick);
	
			window.document.addEventListener("click", documentClick);
			window.document.addEventListener("blur", documentClick);
	
			if (self.config.clickOpens) (self.altInput || self.input).addEventListener("focus", open);
	
			if (!self.config.noCalendar) {
				self.prevMonthNav.addEventListener("click", function () {
					return changeMonth(-1);
				});
				self.nextMonthNav.addEventListener("click", function () {
					return changeMonth(1);
				});
	
				self.currentYearElement.addEventListener("wheel", function (e) {
					return debounce(yearScroll(e), 50);
				});
				self.currentYearElement.addEventListener("focus", function () {
					self.currentYearElement.select();
				});
	
				self.currentYearElement.addEventListener("input", onYearInput);
				self.currentYearElement.addEventListener("increment", onYearInput);
	
				self.days.addEventListener("click", selectDate);
			}
	
			if (self.config.enableTime) {
				self.timeContainer.addEventListener("transitionend", positionCalendar);
				self.timeContainer.addEventListener("wheel", function (e) {
					return debounce(updateTime(e), 5);
				});
				self.timeContainer.addEventListener("input", updateTime);
				self.timeContainer.addEventListener("increment", updateTime);
				self.timeContainer.addEventListener("increment", self.debouncedChange);
	
				self.timeContainer.addEventListener("wheel", self.debouncedChange);
				self.timeContainer.addEventListener("input", self.triggerChange);
	
				self.hourElement.addEventListener("focus", function () {
					self.hourElement.select();
				});
				self.minuteElement.addEventListener("focus", function () {
					self.minuteElement.select();
				});
	
				if (self.secondElement) {
					self.secondElement.addEventListener("focus", function () {
						self.secondElement.select();
					});
				}
	
				if (self.amPM) {
					self.amPM.addEventListener("click", function (e) {
						updateTime(e);
						self.triggerChange(e);
					});
				}
			}
		}
	
		function jumpToDate(jumpDate) {
			jumpDate = jumpDate ? self.parseDate(jumpDate) : self.latestSelectedDateObj || (self.config.minDate > self.now ? self.config.minDate : self.config.maxDate && self.config.maxDate < self.now ? self.config.maxDate : self.now);
	
			try {
				self.currentYear = jumpDate.getFullYear();
				self.currentMonth = jumpDate.getMonth();
			} catch (e) {
				console.error(e.stack);
				console.warn("Invalid date supplied: " + jumpDate);
			}
	
			self.redraw();
		}
	
		function incrementNumInput(e, delta) {
			var input = e.target.parentNode.childNodes[0];
			input.value = parseInt(input.value, 10) + delta * (input.step || 1);
	
			try {
				input.dispatchEvent(new Event("increment", { "bubbles": true }));
			} catch (e) {
				var ev = window.document.createEvent("CustomEvent");
				ev.initCustomEvent("increment", true, true, {});
				input.dispatchEvent(ev);
			}
		}
	
		function createNumberInput(inputClassName) {
			var wrapper = createElement("div", "numInputWrapper"),
			    numInput = createElement("input", "numInput " + inputClassName),
			    arrowUp = createElement("span", "arrowUp"),
			    arrowDown = createElement("span", "arrowDown");
	
			numInput.type = "text";
			wrapper.appendChild(numInput);
			wrapper.appendChild(arrowUp);
			wrapper.appendChild(arrowDown);
	
			arrowUp.addEventListener("click", function (e) {
				return incrementNumInput(e, 1);
			});
			arrowDown.addEventListener("click", function (e) {
				return incrementNumInput(e, -1);
			});
			return wrapper;
		}
	
		function build() {
			var fragment = window.document.createDocumentFragment();
			self.calendarContainer = createElement("div", "flatpickr-calendar");
			self.numInputType = navigator.userAgent.indexOf("MSIE 9.0") > 0 ? "text" : "number";
	
			if (!self.config.noCalendar) {
				fragment.appendChild(buildMonthNav());
				self.innerContainer = createElement("div", "flatpickr-innerContainer");
	
				if (self.config.weekNumbers) self.innerContainer.appendChild(buildWeeks());
	
				self.rContainer = createElement("div", "flatpickr-rContainer");
				self.rContainer.appendChild(buildWeekdays());
				self.rContainer.appendChild(buildDays());
				self.innerContainer.appendChild(self.rContainer);
				fragment.appendChild(self.innerContainer);
			}
	
			if (self.config.enableTime) fragment.appendChild(buildTime());
	
			if (self.config.mode === "range") self.calendarContainer.classList.add("rangeMode");
	
			self.calendarContainer.appendChild(fragment);
	
			if (self.config.inline || self.config.static) {
				self.calendarContainer.classList.add(self.config.inline ? "inline" : "static");
				positionCalendar();
	
				if (self.config.appendTo && self.config.appendTo.nodeType) self.config.appendTo.appendChild(self.calendarContainer);else {
					self.element.parentNode.insertBefore(self.calendarContainer, (self.altInput || self.input).nextSibling);
				}
			} else window.document.body.appendChild(self.calendarContainer);
		}
	
		function createDay(className, date, dayNumber) {
			var dateIsEnabled = isEnabled(date, true),
			    dayElement = createElement("span", "flatpickr-day " + className, date.getDate());
	
			dayElement.dateObj = date;
	
			if (compareDates(date, self.now) === 0) dayElement.classList.add("today");
	
			if (dateIsEnabled) {
				dayElement.tabIndex = 0;
	
				if (isDateSelected(date)) {
					dayElement.classList.add("selected");
	
					if (self.config.mode === "range") {
						dayElement.classList.add(compareDates(date, self.selectedDates[0]) === 0 ? "startRange" : "endRange");
					} else self.selectedDateElem = dayElement;
				}
			} else {
				dayElement.classList.add("disabled");
				if (self.selectedDates[0] && date > self.minRangeDate && date < self.selectedDates[0]) self.minRangeDate = date;else if (self.selectedDates[0] && date < self.maxRangeDate && date > self.selectedDates[0]) self.maxRangeDate = date;
			}
	
			if (self.config.mode === "range") {
				if (isDateInRange(date) && !isDateSelected(date)) dayElement.classList.add("inRange");
	
				if (self.selectedDates.length === 1 && (date < self.minRangeDate || date > self.maxRangeDate)) dayElement.classList.add("notAllowed");
			}
	
			if (self.config.weekNumbers && className !== "prevMonthDay" && dayNumber % 7 === 1) {
				self.weekNumbers.insertAdjacentHTML("beforeend", "<span class='disabled flatpickr-day'>" + self.config.getWeek(date) + "</span>");
			}
	
			triggerEvent("DayCreate", dayElement);
	
			return dayElement;
		}
	
		function buildDays() {
			if (!self.days) {
				self.days = createElement("div", "flatpickr-days");
				self.days.tabIndex = -1;
			}
	
			self.firstOfMonth = (new Date(self.currentYear, self.currentMonth, 1).getDay() - self.l10n.firstDayOfWeek + 7) % 7;
	
			self.prevMonthDays = self.utils.getDaysinMonth((self.currentMonth - 1 + 12) % 12);
	
			var daysInMonth = self.utils.getDaysinMonth(),
			    days = window.document.createDocumentFragment();
	
			var dayNumber = self.prevMonthDays + 1 - self.firstOfMonth;
	
			if (self.config.weekNumbers && self.weekNumbers.firstChild) self.weekNumbers.textContent = "";
	
			if (self.config.mode === "range") {
				// const dateLimits = self.config.enable.length || self.config.disable.length || self.config.mixDate || self.config.maxDate;
				self.minRangeDate = new Date(self.currentYear, self.currentMonth - 1, dayNumber);
				self.maxRangeDate = new Date(self.currentYear, self.currentMonth + 1, (42 - self.firstOfMonth) % daysInMonth);
			}
	
			if (self.days.firstChild) self.days.textContent = "";
	
			// prepend days from the ending of previous month
			for (var i = 0; dayNumber <= self.prevMonthDays; i++, dayNumber++) {
				days.appendChild(createDay("prevMonthDay", new Date(self.currentYear, self.currentMonth - 1, dayNumber), dayNumber));
			}
	
			// Start at 1 since there is no 0th day
			for (dayNumber = 1; dayNumber <= daysInMonth; dayNumber++) {
				days.appendChild(createDay("", new Date(self.currentYear, self.currentMonth, dayNumber), dayNumber));
			}
	
			// append days from the next month
			for (var dayNum = daysInMonth + 1; dayNum <= 42 - self.firstOfMonth; dayNum++) {
				days.appendChild(createDay("nextMonthDay", new Date(self.currentYear, self.currentMonth + 1, dayNum % daysInMonth), dayNum));
			}
	
			self.days.appendChild(days);
			return self.days;
		}
	
		function buildMonthNav() {
			var monthNavFragment = window.document.createDocumentFragment();
			self.monthNav = createElement("div", "flatpickr-month");
	
			self.prevMonthNav = createElement("span", "flatpickr-prev-month");
			self.prevMonthNav.innerHTML = self.config.prevArrow;
	
			self.currentMonthElement = createElement("span", "cur-month");
	
			var yearInput = createNumberInput("cur-year");
			self.currentYearElement = yearInput.childNodes[0];
			self.currentYearElement.title = self.l10n.scrollTitle;
	
			if (self.config.minDate) self.currentYearElement.min = self.config.minDate.getFullYear();
	
			if (self.config.maxDate) {
				self.currentYearElement.max = self.config.maxDate.getFullYear();
	
				self.currentYearElement.disabled = self.config.minDate && self.config.minDate.getFullYear() === self.config.maxDate.getFullYear();
			}
	
			self.nextMonthNav = createElement("span", "flatpickr-next-month");
			self.nextMonthNav.innerHTML = self.config.nextArrow;
	
			self.navigationCurrentMonth = createElement("span", "flatpickr-current-month");
			self.navigationCurrentMonth.appendChild(self.currentMonthElement);
			self.navigationCurrentMonth.appendChild(yearInput);
	
			monthNavFragment.appendChild(self.prevMonthNav);
			monthNavFragment.appendChild(self.navigationCurrentMonth);
			monthNavFragment.appendChild(self.nextMonthNav);
			self.monthNav.appendChild(monthNavFragment);
	
			updateNavigationCurrentMonth();
	
			return self.monthNav;
		}
	
		function buildTime() {
			self.calendarContainer.classList.add("hasTime");
			if (self.config.noCalendar) self.calendarContainer.classList.add("noCalendar");
			self.timeContainer = createElement("div", "flatpickr-time");
			self.timeContainer.tabIndex = -1;
			var separator = createElement("span", "flatpickr-time-separator", ":");
	
			var hourInput = createNumberInput("flatpickr-hour");
			self.hourElement = hourInput.childNodes[0];
	
			var minuteInput = createNumberInput("flatpickr-minute");
			self.minuteElement = minuteInput.childNodes[0];
	
			self.hourElement.tabIndex = self.minuteElement.tabIndex = 0;
			self.hourElement.pattern = self.minuteElement.pattern = "\\d*";
	
			self.hourElement.value = self.pad(self.latestSelectedDateObj ? self.latestSelectedDateObj.getHours() : self.config.defaultHour);
	
			self.minuteElement.value = self.pad(self.latestSelectedDateObj ? self.latestSelectedDateObj.getMinutes() : self.config.defaultMinute);
	
			self.hourElement.step = self.config.hourIncrement;
			self.minuteElement.step = self.config.minuteIncrement;
	
			self.hourElement.min = self.config.time_24hr ? 0 : 1;
			self.hourElement.max = self.config.time_24hr ? 23 : 12;
	
			self.minuteElement.min = 0;
			self.minuteElement.max = 59;
	
			self.hourElement.title = self.minuteElement.title = self.l10n.scrollTitle;
	
			self.timeContainer.appendChild(hourInput);
			self.timeContainer.appendChild(separator);
			self.timeContainer.appendChild(minuteInput);
	
			if (self.config.time_24hr) self.timeContainer.classList.add("time24hr");
	
			if (self.config.enableSeconds) {
				self.timeContainer.classList.add("hasSeconds");
	
				var secondInput = createNumberInput("flatpickr-second");
				self.secondElement = secondInput.childNodes[0];
	
				self.secondElement.pattern = self.hourElement.pattern;
				self.secondElement.value = self.latestSelectedDateObj ? self.pad(self.latestSelectedDateObj.getSeconds()) : "00";
	
				self.secondElement.step = self.minuteElement.step;
				self.secondElement.min = self.minuteElement.min;
				self.secondElement.max = self.minuteElement.max;
	
				self.timeContainer.appendChild(createElement("span", "flatpickr-time-separator", ":"));
				self.timeContainer.appendChild(secondInput);
			}
	
			if (!self.config.time_24hr) {
				// add self.amPM if appropriate
				self.amPM = createElement("span", "flatpickr-am-pm", ["AM", "PM"][self.hourElement.value > 11 | 0]);
				self.amPM.title = self.l10n.toggleTitle;
				self.amPM.tabIndex = 0;
				self.timeContainer.appendChild(self.amPM);
			}
	
			return self.timeContainer;
		}
	
		function buildWeekdays() {
			if (!self.weekdayContainer) self.weekdayContainer = createElement("div", "flatpickr-weekdays");
	
			var firstDayOfWeek = self.l10n.firstDayOfWeek;
			var weekdays = self.l10n.weekdays.shorthand.slice();
	
			if (firstDayOfWeek > 0 && firstDayOfWeek < weekdays.length) {
				weekdays = [].concat(weekdays.splice(firstDayOfWeek, weekdays.length), weekdays.splice(0, firstDayOfWeek));
			}
	
			self.weekdayContainer.innerHTML = "\n\t\t<span class=flatpickr-weekday>\n\t\t\t" + weekdays.join("</span><span class=flatpickr-weekday>") + "\n\t\t</span>\n\t\t";
	
			return self.weekdayContainer;
		}
	
		/* istanbul ignore next */
		function buildWeeks() {
			self.calendarContainer.classList.add("hasWeeks");
			self.weekWrapper = createElement("div", "flatpickr-weekwrapper");
			self.weekWrapper.appendChild(createElement("span", "flatpickr-weekday", self.l10n.weekAbbreviation));
			self.weekNumbers = createElement("div", "flatpickr-weeks");
			self.weekWrapper.appendChild(self.weekNumbers);
	
			return self.weekWrapper;
		}
	
		function changeMonth(value, is_offset) {
			self.currentMonth = typeof is_offset === "undefined" || is_offset ? self.currentMonth + value : value;
	
			handleYearChange();
			updateNavigationCurrentMonth();
			buildDays();
	
			if (!self.config.noCalendar) self.days.focus();
	
			triggerEvent("MonthChange");
		}
	
		function clear(triggerChangeEvent) {
			self.input.value = "";
	
			if (self.altInput) self.altInput.value = "";
	
			if (self.mobileInput) self.mobileInput.value = "";
	
			self.selectedDates = [];
			self.latestSelectedDateObj = null;
			self.dateIsPicked = false;
	
			self.redraw();
	
			if (triggerChangeEvent !== false)
				// triggerChangeEvent is true (default) or an Event
				triggerEvent("Change");
		}
	
		function close() {
			self.isOpen = false;
	
			if (!self.isMobile) {
				self.calendarContainer.classList.remove("open");
				(self.altInput || self.input).classList.remove("active");
			}
	
			triggerEvent("Close");
		}
	
		function destroy(instance) {
			instance = instance || self;
			instance.clear(false);
	
			window.document.removeEventListener("keydown", onKeyDown);
			window.removeEventListener("resize", instance.debouncedResize);
	
			window.document.removeEventListener("click", documentClick);
			window.document.removeEventListener("touchstart", documentClick);
			window.document.removeEventListener("blur", documentClick);
	
			if (instance.timeContainer) instance.timeContainer.removeEventListener("transitionend", positionCalendar);
	
			if (instance.mobileInput && instance.mobileInput.parentNode) instance.mobileInput.parentNode.removeChild(instance.mobileInput);else if (instance.calendarContainer && instance.calendarContainer.parentNode) instance.calendarContainer.parentNode.removeChild(instance.calendarContainer);
	
			if (instance.altInput) {
				instance.input.type = "text";
				if (instance.altInput.parentNode) instance.altInput.parentNode.removeChild(instance.altInput);
			}
	
			instance.input.type = instance.input._type;
			instance.input.classList.remove("flatpickr-input");
			instance.input.removeEventListener("focus", open);
			instance.input.removeAttribute("readonly");
	
			delete instance.input._flatpickr;
		}
	
		function isCalendarElem(elem) {
			var e = elem;
			while (e) {
				if (/flatpickr-day|flatpickr-calendar/.test(e.className)) return true;
				e = e.parentNode;
			}
	
			return false;
		}
	
		function documentClick(e) {
			var isInput = self.element.contains(e.target) || e.target === self.input || e.target === self.altInput || e.path && (~e.path.indexOf(self.input) || ~e.path.indexOf(self.altInput));
	
			if (self.isOpen && !self.config.inline && !isCalendarElem(e.target) && !isInput) {
				e.preventDefault();
				self.close();
	
				if (self.config.mode === "range" && self.selectedDates.length === 1) {
					self.clear();
					self.redraw();
				}
			}
		}
	
		function formatDate(frmt, dateObj) {
			if (self.config.formatDate) return self.config.formatDate(frmt, dateObj);
	
			var chars = frmt.split("");
			return chars.map(function (c, i) {
				return self.formats[c] && chars[i - 1] !== "\\" ? self.formats[c](dateObj) : c !== "\\" ? c : "";
			}).join("");
		}
	
		function handleYearChange(newYear) {
			if (self.currentMonth < 0 || self.currentMonth > 11) {
				self.currentYear += self.currentMonth % 11;
				self.currentMonth = (self.currentMonth + 12) % 12;
	
				triggerEvent("YearChange");
			} else if (newYear && (!self.currentYearElement.min || newYear >= self.currentYearElement.min) && (!self.currentYearElement.max || newYear <= self.currentYearElement.max)) {
				self.currentYear = parseInt(newYear, 10) || self.currentYear;
	
				if (self.config.maxDate && self.currentYear === self.config.maxDate.getFullYear()) {
					self.currentMonth = Math.min(self.config.maxDate.getMonth(), self.currentMonth);
				} else if (self.config.minDate && self.currentYear === self.config.minDate.getFullYear()) {
					self.currentMonth = Math.max(self.config.minDate.getMonth(), self.currentMonth);
				}
	
				self.redraw();
				triggerEvent("YearChange");
			}
		}
	
		function isEnabled(date, timeless) {
			var ltmin = compareDates(date, self.config.minDate, typeof timeless !== "undefined" ? timeless : !self.minDateHasTime) < 0;
			var gtmax = compareDates(date, self.config.maxDate, typeof timeless !== "undefined" ? timeless : !self.maxDateHasTime) > 0;
	
			if (ltmin || gtmax) return false;
	
			if (!self.config.enable.length && !self.config.disable.length) return true;
	
			var dateToCheck = self.parseDate(date, true); // timeless
	
			var bool = self.config.enable.length > 0,
			    array = bool ? self.config.enable : self.config.disable;
	
			for (var i = 0, d; i < array.length; i++) {
				d = array[i];
	
				if (d instanceof Function && d(dateToCheck)) // disabled by function
					return bool;else if (d instanceof Date && d.getTime() === dateToCheck.getTime())
					// disabled by date
					return bool;else if (typeof d === "string" && self.parseDate(d, true).getTime() === dateToCheck.getTime())
					// disabled by date string
					return bool;else if ( // disabled by range
				(typeof d === "undefined" ? "undefined" : _typeof(d)) === "object" && d.from && d.to && dateToCheck >= d.from && dateToCheck <= d.to) return bool;
			}
	
			return !bool;
		}
	
		function onKeyDown(e) {
			if (self.isOpen) {
				switch (e.which) {
					case 13:
						if (self.timeContainer && self.timeContainer.contains(e.target)) updateValue();else selectDate(e);
	
						break;
	
					case 27:
						// escape
						self.clear();
						self.redraw();
						self.close();
						break;
	
					case 37:
						if (e.target !== self.input & e.target !== self.altInput) changeMonth(-1);
						break;
	
					case 38:
						e.preventDefault();
	
						if (self.timeContainer && self.timeContainer.contains(e.target)) updateTime(e);else {
							self.currentYear++;
							self.redraw();
						}
	
						break;
	
					case 39:
						if (e.target !== self.input & e.target !== self.altInput) changeMonth(1);
						break;
	
					case 40:
						e.preventDefault();
						if (self.timeContainer && self.timeContainer.contains(e.target)) updateTime(e);else {
							self.currentYear--;
							self.redraw();
						}
	
						break;
	
					default:
						break;
				}
			}
		}
	
		function onMouseOver(e) {
			if (self.selectedDates.length !== 1 || !e.target.classList.contains("flatpickr-day")) return;
	
			var hoverDate = e.target.dateObj,
			    initialDate = self.parseDate(self.selectedDates[0], true),
			    rangeStartDate = Math.min(hoverDate.getTime(), self.selectedDates[0].getTime()),
			    rangeEndDate = Math.max(hoverDate.getTime(), self.selectedDates[0].getTime()),
			    containsDisabled = false;
	
			for (var t = rangeStartDate; t < rangeEndDate; t += self.utils.duration.DAY) {
				if (!isEnabled(new Date(t))) {
					containsDisabled = true;
					break;
				}
			}
	
			for (var timestamp = self.days.childNodes[0].dateObj.getTime(), i = 0; i < 42; i++, timestamp += self.utils.duration.DAY) {
				var outOfRange = timestamp < self.minRangeDate.getTime() || timestamp > self.maxRangeDate.getTime();
	
				if (outOfRange) {
					self.days.childNodes[i].classList.add("notAllowed");
					self.days.childNodes[i].classList.remove("inRange", "startRange", "endRange");
					continue;
				} else if (containsDisabled && !outOfRange) continue;
	
				self.days.childNodes[i].classList.remove("startRange", "inRange", "endRange", "notAllowed");
	
				var minRangeDate = Math.max(self.minRangeDate.getTime(), rangeStartDate),
				    maxRangeDate = Math.min(self.maxRangeDate.getTime(), rangeEndDate);
	
				e.target.classList.add(hoverDate < self.selectedDates[0] ? "startRange" : "endRange");
	
				if (initialDate > hoverDate && timestamp === initialDate.getTime()) self.days.childNodes[i].classList.add("endRange");else if (initialDate < hoverDate && timestamp === initialDate.getTime()) self.days.childNodes[i].classList.add("startRange");else if (timestamp > minRangeDate && timestamp < maxRangeDate) self.days.childNodes[i].classList.add("inRange");
			}
		}
	
		function onResize() {
			if (self.isOpen && !self.config.static && !self.config.inline) positionCalendar();
		}
	
		function open(e) {
			if (self.isMobile) {
				if (e) {
					e.preventDefault();
					e.target.blur();
				}
	
				setTimeout(function () {
					self.mobileInput.click();
				}, 0);
	
				triggerEvent("Open");
				return;
			} else if (self.isOpen || (self.altInput || self.input).disabled || self.config.inline) return;
	
			self.calendarContainer.classList.add("open");
	
			if (!self.config.static && !self.config.inline) positionCalendar();
	
			self.isOpen = true;
	
			if (!self.config.allowInput) {
				(self.altInput || self.input).blur();
				(self.config.noCalendar ? self.timeContainer : self.selectedDateElem ? self.selectedDateElem : self.days).focus();
			}
	
			(self.altInput || self.input).classList.add("active");
			triggerEvent("Open");
		}
	
		function minMaxDateSetter(type) {
			return function (date) {
				var dateObj = self.config["_" + type + "Date"] = self.parseDate(date);
				var inverseDateObj = self.config["_" + (type === "min" ? "max" : "min") + "Date"];
	
				if (self.selectedDates) {
					self.selectedDates = self.selectedDates.filter(isEnabled);
					updateValue();
				}
	
				if (self.days) redraw();
	
				if (!self.currentYearElement) return;
	
				if (date && dateObj instanceof Date) {
					self[type + "DateHasTime"] = dateObj.getHours() || dateObj.getMinutes() || dateObj.getSeconds();
	
					self.currentYearElement[type] = dateObj.getFullYear();
				} else self.currentYearElement.removeAttribute(type);
	
				self.currentYearElement.disabled = inverseDateObj && dateObj && inverseDateObj.getFullYear() === dateObj.getFullYear();
			};
		}
	
		function parseConfig() {
			var boolOpts = ["utc", "wrap", "weekNumbers", "allowInput", "clickOpens", "time_24hr", "enableTime", "noCalendar", "altInput", "shorthandCurrentMonth", "inline", "static", "enableSeconds", "disableMobile"];
			self.config = Object.create(Flatpickr.defaultConfig);
	
			Object.defineProperty(self.config, "minDate", {
				get: function get() {
					return this._minDate;
				},
				set: minMaxDateSetter("min")
			});
	
			Object.defineProperty(self.config, "maxDate", {
				get: function get() {
					return this._maxDate;
				},
				set: minMaxDateSetter("max")
			});
	
			var userConfig = _extends({}, self.instanceConfig, JSON.parse(JSON.stringify(self.element.dataset || {})));
	
			_extends(self.config, userConfig);
	
			for (var i = 0; i < boolOpts.length; i++) {
				self.config[boolOpts[i]] = self.config[boolOpts[i]] === true || self.config[boolOpts[i]] === "true";
			}if (!userConfig.dateFormat && userConfig.enableTime) {
				self.config.dateFormat = self.config.noCalendar ? "H:i" + (self.config.enableSeconds ? ":S" : "") : Flatpickr.defaultConfig.dateFormat + " H:i" + (self.config.enableSeconds ? ":S" : "");
			}
	
			if (userConfig.altInput && userConfig.enableTime && !userConfig.altFormat) {
				self.config.altFormat = self.config.noCalendar ? "h:i" + (self.config.enableSeconds ? ":S K" : " K") : Flatpickr.defaultConfig.altFormat + (" h:i" + (self.config.enableSeconds ? ":S" : "") + " K");
			}
		}
	
		function setupLocale() {
			if (_typeof(self.config.locale) !== "object" && typeof Flatpickr.l10ns[self.config.locale] === "undefined") console.warn("flatpickr: invalid locale " + self.config.locale);
	
			self.l10n = _extends(Object.create(Flatpickr.l10ns.default), _typeof(self.config.locale) === "object" ? self.config.locale : self.config.locale !== "default" ? Flatpickr.l10ns[self.config.locale] || {} : {});
		}
	
		function positionCalendar(e) {
			if (e && e.target !== self.timeContainer) return;
	
			var calendarHeight = self.calendarContainer.offsetHeight,
			    calendarWidth = self.calendarContainer.offsetWidth,
			    input = self.altInput || self.input,
			    inputBounds = input.getBoundingClientRect(),
			    distanceFromBottom = window.innerHeight - inputBounds.bottom + input.offsetHeight;
	
			var top = void 0;
	
			if (distanceFromBottom < calendarHeight + 60) {
				top = window.pageYOffset - calendarHeight + inputBounds.top - 2;
				self.calendarContainer.classList.remove("arrowTop");
				self.calendarContainer.classList.add("arrowBottom");
			} else {
				top = window.pageYOffset + input.offsetHeight + inputBounds.top + 2;
				self.calendarContainer.classList.remove("arrowBottom");
				self.calendarContainer.classList.add("arrowTop");
			}
	
			if (!self.config.static && !self.config.inline) {
				self.calendarContainer.style.top = top + "px";
	
				var left = window.pageXOffset + inputBounds.left;
				var right = window.document.body.offsetWidth - inputBounds.right;
	
				if (left + calendarWidth <= window.document.body.offsetWidth) {
					self.calendarContainer.style.left = left + "px";
					self.calendarContainer.style.right = "auto";
	
					self.calendarContainer.classList.remove("rightMost");
				} else {
					self.calendarContainer.style.left = "auto";
					self.calendarContainer.style.right = right + "px";
	
					self.calendarContainer.classList.add("rightMost");
				}
			}
		}
	
		function redraw() {
			if (self.config.noCalendar || self.isMobile) return;
	
			buildWeekdays();
			updateNavigationCurrentMonth();
			buildDays();
		}
	
		function selectDate(e) {
			e.preventDefault();
			if (self.config.allowInput && e.which === 13 && e.target === (self.altInput || self.input)) return self.setDate((self.altInput || self.input).value), e.target.blur();
	
			if (!e.target.classList.contains("flatpickr-day") || e.target.classList.contains("disabled") || e.target.classList.contains("notAllowed")) return;
	
			var selectedDate = self.latestSelectedDateObj = new Date(e.target.dateObj.getTime());
	
			self.selectedDateElem = e.target;
	
			if (self.config.mode === "single") self.selectedDates = [selectedDate];else if (self.config.mode === "multiple") {
				var selectedIndex = isDateSelected(selectedDate);
				if (selectedIndex) self.selectedDates.splice(selectedIndex, 1);else self.selectedDates.push(selectedDate);
			} else if (self.config.mode === "range") {
				if (self.selectedDates.length === 2) self.clear();
	
				self.selectedDates.push(selectedDate);
				self.selectedDates.sort(function (a, b) {
					return a.getTime() - b.getTime();
				});
			}
	
			setHoursFromInputs();
	
			if (selectedDate.getMonth() !== self.currentMonth && self.config.mode !== "range") {
				self.currentYear = selectedDate.getFullYear();
				self.currentMonth = selectedDate.getMonth();
				updateNavigationCurrentMonth();
			}
	
			buildDays();
	
			if (self.minDateHasTime && self.config.enableTime && compareDates(selectedDate, self.config.minDate) === 0) setHoursFromDate(self.config.minDate);
	
			updateValue();
	
			setTimeout(function () {
				return self.dateIsPicked = true;
			}, 50);
	
			if (self.config.mode === "range" && self.selectedDates.length === 1) onMouseOver(e);
	
			if (self.config.mode === "single" && !self.config.enableTime) self.close();
	
			triggerEvent("Change");
		}
	
		function set(option, value) {
			self.config[option] = value;
			self.redraw();
			jumpToDate();
		}
	
		function setSelectedDate(inputDate) {
			if (Array.isArray(inputDate)) self.selectedDates = inputDate.map(self.parseDate);else if (inputDate) {
				switch (self.config.mode) {
					case "single":
						self.selectedDates = [self.parseDate(inputDate)];
						break;
	
					case "multiple":
						self.selectedDates = inputDate.split("; ").map(self.parseDate);
						break;
	
					case "range":
						self.selectedDates = inputDate.split(self.l10n.rangeSeparator).map(self.parseDate);
						break;
	
					default:
						break;
				}
			}
	
			self.selectedDates = self.selectedDates.filter(function (d) {
				return d instanceof Date && d.getTime() && isEnabled(d, false);
			});
	
			self.selectedDates.sort(function (a, b) {
				return a.getTime() - b.getTime();
			});
		}
	
		function setDate(date, triggerChange) {
			if (!date) return self.clear();
	
			setSelectedDate(date);
	
			if (self.selectedDates.length > 0) {
				self.dateIsPicked = true;
				self.latestSelectedDateObj = self.selectedDates[0];
			} else self.latestSelectedDateObj = null;
	
			self.redraw();
			jumpToDate();
	
			setHoursFromDate();
			updateValue();
	
			if (triggerChange === true) triggerEvent("Change");
		}
	
		function setupDates() {
			function parseDateRules(arr) {
				for (var i = arr.length; i--;) {
					if (typeof arr[i] === "string" || +arr[i]) arr[i] = self.parseDate(arr[i], true);else if (arr[i] && arr[i].from && arr[i].to) {
						arr[i].from = self.parseDate(arr[i].from);
						arr[i].to = self.parseDate(arr[i].to);
					}
				}
	
				return arr.filter(function (x) {
					return x;
				}); // remove falsy values
			}
	
			self.selectedDates = [];
			self.now = new Date();
	
			setSelectedDate(self.config.defaultDate || self.input.value);
	
			if (self.config.disable.length) self.config.disable = parseDateRules(self.config.disable);
	
			if (self.config.enable.length) self.config.enable = parseDateRules(self.config.enable);
	
			var initialDate = self.selectedDates.length ? self.selectedDates[0] : self.config.minDate && self.config.minDate.getTime() > self.now ? self.config.minDate : self.config.maxDate && self.config.maxDate.getTime() < self.now ? self.config.maxDate : self.now;
	
			self.currentYear = initialDate.getFullYear();
			self.currentMonth = initialDate.getMonth();
	
			if (self.selectedDates.length) self.latestSelectedDateObj = self.selectedDates[0];
	
			self.minDateHasTime = self.config.minDate && (self.config.minDate.getHours() || self.config.minDate.getMinutes() || self.config.minDate.getSeconds());
	
			self.maxDateHasTime = self.config.maxDate && (self.config.maxDate.getHours() || self.config.maxDate.getMinutes() || self.config.maxDate.getSeconds());
	
			Object.defineProperty(self, "latestSelectedDateObj", {
				get: function get() {
					return self._selectedDateObj || self.selectedDates[self.selectedDates.length - 1] || null;
				},
				set: function set(date) {
					self._selectedDateObj = date;
				}
			});
		}
	
		function setupHelperFunctions() {
			self.utils = {
				duration: {
					DAY: 86400000
				},
				getDaysinMonth: function getDaysinMonth(month, yr) {
					month = typeof month === "undefined" ? self.currentMonth : month;
	
					yr = typeof yr === "undefined" ? self.currentYear : yr;
	
					if (month === 1 && (yr % 4 === 0 && yr % 100 !== 0 || yr % 400 === 0)) return 29;
	
					return self.l10n.daysInMonth[month];
				},
				monthToStr: function monthToStr(monthNumber, shorthand) {
					shorthand = typeof shorthand === "undefined" ? self.config.shorthandCurrentMonth : shorthand;
	
					return self.l10n.months[(shorthand ? "short" : "long") + "hand"][monthNumber];
				}
			};
		}
	
		/* istanbul ignore next */
		function setupFormats() {
			self.formats = {
				// weekday name, short, e.g. Thu
				D: function D(date) {
					return self.l10n.weekdays.shorthand[self.formats.w(date)];
				},
	
				// full month name e.g. January
				F: function F(date) {
					return self.utils.monthToStr(self.formats.n(date) - 1, false);
				},
	
				// hours with leading zero e.g. 03
				H: function H(date) {
					return Flatpickr.prototype.pad(date.getHours());
				},
	
				// day (1-30) with ordinal suffix e.g. 1st, 2nd
				J: function J(date) {
					return date.getDate() + self.l10n.ordinal(date.getDate());
				},
	
				// AM/PM
				K: function K(date) {
					return date.getHours() > 11 ? "PM" : "AM";
				},
	
				// shorthand month e.g. Jan, Sep, Oct, etc
				M: function M(date) {
					return self.utils.monthToStr(date.getMonth(), true);
				},
	
				// seconds 00-59
				S: function S(date) {
					return Flatpickr.prototype.pad(date.getSeconds());
				},
	
				// unix timestamp
				U: function U(date) {
					return date.getTime() / 1000;
				},
	
				// full year e.g. 2016
				Y: function Y(date) {
					return date.getFullYear();
				},
	
				// day in month, padded (01-30)
				d: function d(date) {
					return Flatpickr.prototype.pad(self.formats.j(date));
				},
	
				// hour from 1-12 (am/pm)
				h: function h(date) {
					return date.getHours() % 12 ? date.getHours() % 12 : 12;
				},
	
				// minutes, padded with leading zero e.g. 09
				i: function i(date) {
					return Flatpickr.prototype.pad(date.getMinutes());
				},
	
				// day in month (1-30)
				j: function j(date) {
					return date.getDate();
				},
	
				// weekday name, full, e.g. Thursday
				l: function l(date) {
					return self.l10n.weekdays.longhand[self.formats.w(date)];
				},
	
				// padded month number (01-12)
				m: function m(date) {
					return Flatpickr.prototype.pad(self.formats.n(date));
				},
	
				// the month number (1-12)
				n: function n(date) {
					return date.getMonth() + 1;
				},
	
				// seconds 0-59
				s: function s(date) {
					return date.getSeconds();
				},
	
				// number of the day of the week
				w: function w(date) {
					return date.getDay();
				},
	
				// last two digits of year e.g. 16 for 2016
				y: function y(date) {
					return String(self.formats.Y(date)).substring(2);
				}
			};
		}
	
		function setupInputs() {
			self.input = self.config.wrap ? self.element.querySelector("[data-input]") : self.element;
	
			if (!self.input) return console.warn("Error: invalid input element specified", self.input);
	
			self.input._type = self.input.type;
			self.input.type = "text";
			self.input.classList.add("flatpickr-input");
	
			if (self.config.altInput) {
				// replicate self.element
				self.altInput = createElement(self.input.nodeName, self.input.className + " " + self.config.altInputClass);
				self.altInput.placeholder = self.input.placeholder;
				self.altInput.type = "text";
	
				self.input.type = "hidden";
				if (self.input.parentNode) self.input.parentNode.insertBefore(self.altInput, self.input.nextSibling);
			}
	
			if (!self.config.allowInput) (self.altInput || self.input).setAttribute("readonly", "readonly");
		}
	
		function setupMobile() {
			var inputType = self.config.enableTime ? self.config.noCalendar ? "time" : "datetime-local" : "date";
	
			self.mobileInput = createElement("input", self.input.className + " flatpickr-mobile");
			self.mobileInput.step = "any";
			self.mobileInput.tabIndex = 1;
			self.mobileInput.type = inputType;
			self.mobileInput.disabled = self.input.disabled;
	
			self.mobileFormatStr = inputType === "datetime-local" ? "Y-m-d\\TH:i:S" : inputType === "date" ? "Y-m-d" : "H:i:S";
	
			if (self.selectedDates.length) {
				self.mobileInput.defaultValue = self.mobileInput.value = formatDate(self.mobileFormatStr, self.selectedDates[0]);
			}
	
			if (self.config.minDate) self.mobileInput.min = formatDate("Y-m-d", self.config.minDate);
	
			if (self.config.maxDate) self.mobileInput.max = formatDate("Y-m-d", self.config.maxDate);
	
			self.input.type = "hidden";
			if (self.config.altInput) self.altInput.type = "hidden";
	
			try {
				self.input.parentNode.insertBefore(self.mobileInput, self.input.nextSibling);
			} catch (e) {
				//
			}
	
			self.mobileInput.addEventListener("change", function (e) {
				self.latestSelectedDateObj = self.parseDate(e.target.value);
				self.setDate(self.latestSelectedDateObj);
				triggerEvent("Change");
				triggerEvent("Close");
			});
		}
	
		function toggle() {
			if (self.isOpen) self.close();else self.open();
		}
	
		function triggerEvent(event, data) {
			if (self.config["on" + event]) {
				var hooks = Array.isArray(self.config["on" + event]) ? self.config["on" + event] : [self.config["on" + event]];
	
				for (var i = 0; i < hooks.length; i++) {
					hooks[i](self.selectedDates, self.input.value, self, data);
				}
			}
	
			if (event === "Change") {
				if (typeof Event === "function" && Event.constructor) {
					self.input.dispatchEvent(new Event("change", { "bubbles": true }));
	
					// many front-end frameworks bind to the input event
					self.input.dispatchEvent(new Event("input", { "bubbles": true }));
				} else {
					if (window.document.createEvent !== undefined) return self.input.dispatchEvent(self.changeEvent);
	
					self.input.fireEvent("onchange");
				}
			}
		}
	
		function isDateSelected(date) {
			for (var i = 0; i < self.selectedDates.length; i++) {
				if (compareDates(self.selectedDates[i], date) === 0) return "" + i;
			}
	
			return false;
		}
	
		function isDateInRange(date) {
			if (self.config.mode !== "range" || self.selectedDates.length < 2) return false;
			return compareDates(date, self.selectedDates[0]) >= 0 && compareDates(date, self.selectedDates[1]) <= 0;
		}
	
		function updateNavigationCurrentMonth() {
			if (self.config.noCalendar || self.isMobile || !self.monthNav) return;
	
			self.currentMonthElement.textContent = self.utils.monthToStr(self.currentMonth) + " ";
			self.currentYearElement.value = self.currentYear;
	
			if (self.config.minDate) {
				var hidePrevMonthArrow = self.currentYear === self.config.minDate.getFullYear() ? self.currentMonth <= self.config.minDate.getMonth() : self.currentYear < self.config.minDate.getFullYear();
	
				self.prevMonthNav.style.display = hidePrevMonthArrow ? "none" : "block";
			} else self.prevMonthNav.style.display = "block";
	
			if (self.config.maxDate) {
				var hideNextMonthArrow = self.currentYear === self.config.maxDate.getFullYear() ? self.currentMonth + 1 > self.config.maxDate.getMonth() : self.currentYear > self.config.maxDate.getFullYear();
	
				self.nextMonthNav.style.display = hideNextMonthArrow ? "none" : "block";
			} else self.nextMonthNav.style.display = "block";
		}
	
		function updateValue() {
			if (!self.selectedDates.length) return self.clear();
	
			if (self.isMobile) {
				self.mobileInput.value = self.selectedDates.length ? formatDate(self.mobileFormatStr, self.latestSelectedDateObj) : "";
			}
	
			var joinChar = self.config.mode !== "range" ? "; " : self.l10n.rangeSeparator;
	
			self.input.value = self.selectedDates.map(function (dObj) {
				return formatDate(self.config.dateFormat, dObj);
			}).join(joinChar);
	
			if (self.config.altInput) {
				self.altInput.value = self.selectedDates.map(function (dObj) {
					return formatDate(self.config.altFormat, dObj);
				}).join(joinChar);
			}
	
			triggerEvent("ValueUpdate");
		}
	
		function yearScroll(e) {
			e.preventDefault();
	
			var delta = Math.max(-1, Math.min(1, e.wheelDelta || -e.deltaY)),
			    newYear = parseInt(e.target.value, 10) + delta;
	
			handleYearChange(newYear);
			e.target.value = self.currentYear;
		}
	
		function createElement(tag, className, content) {
			var e = window.document.createElement(tag);
			className = className || "";
			content = content || "";
	
			e.className = className;
	
			if (content) e.textContent = content;
	
			return e;
		}
	
		/* istanbul ignore next */
		function debounce(func, wait, immediate) {
			var timeout = void 0;
			return function () {
				for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
					args[_key] = arguments[_key];
				}
	
				var context = this;
				var later = function later() {
					timeout = null;
					if (!immediate) func.apply(context, args);
				};
	
				clearTimeout(timeout);
				timeout = setTimeout(later, wait);
				if (immediate && !timeout) func.apply(context, args);
			};
		}
	
		function compareDates(date1, date2, timeless) {
			if (!(date1 instanceof Date) || !(date2 instanceof Date)) return false;
	
			if (timeless !== false) {
				return new Date(date1.getTime()).setHours(0, 0, 0, 0) - new Date(date2.getTime()).setHours(0, 0, 0, 0);
			}
	
			return date1.getTime() - date2.getTime();
		}
	
		function timeWrapper(e) {
			e.preventDefault();
			if (e && ((e.target.value || e.target.textContent).length >= 2 || // typed two digits
			e.type !== "keydown" && e.type !== "input" // scroll event
			)) e.target.blur();
	
			if (self.amPM && e.target === self.amPM) return e.target.textContent = ["AM", "PM"][e.target.textContent === "AM" | 0];
	
			var min = Number(e.target.min),
			    max = Number(e.target.max),
			    step = Number(e.target.step),
			    curValue = parseInt(e.target.value, 10),
			    delta = Math.max(-1, Math.min(1, e.wheelDelta || -e.deltaY));
	
			var newValue = Number(curValue);
	
			switch (e.type) {
				case "wheel":
					newValue = curValue + step * delta;
					break;
	
				case "keydown":
					newValue = curValue + step * (e.which === 38 ? 1 : -1);
					break;
			}
	
			if (e.type !== "input" || e.target.value.length === 2) {
				if (newValue < min) {
					newValue = max + newValue + (e.target !== self.hourElement) + (e.target === self.hourElement && !self.amPM);
				} else if (newValue > max) {
					newValue = e.target === self.hourElement ? newValue - max - !self.amPM : min;
				}
	
				if (self.amPM && e.target === self.hourElement && (step === 1 ? newValue + curValue === 23 : Math.abs(newValue - curValue) > step)) self.amPM.textContent = self.amPM.textContent === "PM" ? "AM" : "PM";
	
				e.target.value = self.pad(newValue);
			} else e.target.value = newValue;
		}
	
		init();
		return self;
	}
	
	/* istanbul ignore next */
	Flatpickr.defaultConfig = {
	
		mode: "single",
	
		/* if true, dates will be parsed, formatted, and displayed in UTC.
	 preloading date strings w/ timezones is recommended but not necessary */
		utc: false,
	
		// wrap: see https://chmln.github.io/flatpickr/#strap
		wrap: false,
	
		// enables week numbers
		weekNumbers: false,
	
		// allow manual datetime input
		allowInput: false,
	
		/*
	 	clicking on input opens the date(time)picker.
	 	disable if you wish to open the calendar manually with .open()
	 */
		clickOpens: true,
	
		// display time picker in 24 hour mode
		time_24hr: false,
	
		// enables the time picker functionality
		enableTime: false,
	
		// noCalendar: true will hide the calendar. use for a time picker along w/ enableTime
		noCalendar: false,
	
		// more date format chars at https://chmln.github.io/flatpickr/#dateformat
		dateFormat: "Y-m-d",
	
		// altInput - see https://chmln.github.io/flatpickr/#altinput
		altInput: false,
	
		// the created altInput element will have this class.
		altInputClass: "flatpickr-input form-control input",
	
		// same as dateFormat, but for altInput
		altFormat: "F j, Y", // defaults to e.g. June 10, 2016
	
		// defaultDate - either a datestring or a date object. used for datetimepicker"s initial value
		defaultDate: null,
	
		// the minimum date that user can pick (inclusive)
		minDate: null,
	
		// the maximum date that user can pick (inclusive)
		maxDate: null,
	
		// dateparser that transforms a given string to a date object
		parseDate: null,
	
		// dateformatter that transforms a given date object to a string, according to passed format
		formatDate: null,
	
		getWeek: function getWeek(givenDate) {
			var date = new Date(givenDate.getTime());
			date.setHours(0, 0, 0, 0);
	
			// Thursday in current week decides the year.
			date.setDate(date.getDate() + 3 - (date.getDay() + 6) % 7);
			// January 4 is always in week 1.
			var week1 = new Date(date.getFullYear(), 0, 4);
			// Adjust to Thursday in week 1 and count number of weeks from date to week1.
			return 1 + Math.round(((date.getTime() - week1.getTime()) / 86400000 - 3 + (week1.getDay() + 6) % 7) / 7);
		},
	
		// see https://chmln.github.io/flatpickr/#disable
		enable: [],
	
		// see https://chmln.github.io/flatpickr/#disable
		disable: [],
	
		// display the short version of month names - e.g. Sep instead of September
		shorthandCurrentMonth: false,
	
		// displays calendar inline. see https://chmln.github.io/flatpickr/#inline-calendar
		inline: false,
	
		// position calendar inside wrapper and next to the input element
		// leave at false unless you know what you"re doing
		static: false,
	
		// DOM node to append the calendar to in *static* mode
		appendTo: null,
	
		// code for previous/next icons. this is where you put your custom icon code e.g. fontawesome
		prevArrow: "<svg version='1.1' xmlns='http://www.w3.org/2000/svg' xmlns:xlink='http://www.w3.org/1999/xlink' viewBox='0 0 17 17'><g></g><path d='M5.207 8.471l7.146 7.147-0.707 0.707-7.853-7.854 7.854-7.853 0.707 0.707-7.147 7.146z' /></svg>",
		nextArrow: "<svg version='1.1' xmlns='http://www.w3.org/2000/svg' xmlns:xlink='http://www.w3.org/1999/xlink' viewBox='0 0 17 17'><g></g><path d='M13.207 8.472l-7.854 7.854-0.707-0.707 7.146-7.146-7.146-7.148 0.707-0.707 7.854 7.854z' /></svg>",
	
		// enables seconds in the time picker
		enableSeconds: false,
	
		// step size used when scrolling/incrementing the hour element
		hourIncrement: 1,
	
		// step size used when scrolling/incrementing the minute element
		minuteIncrement: 5,
	
		// initial value in the hour element
		defaultHour: 12,
	
		// initial value in the minute element
		defaultMinute: 0,
	
		// disable native mobile datetime input support
		disableMobile: false,
	
		// default locale
		locale: "default",
	
		// onChange callback when user selects a date or time
		onChange: null, // function (dateObj, dateStr) {}
	
		// called every time calendar is opened
		onOpen: null, // function (dateObj, dateStr) {}
	
		// called every time calendar is closed
		onClose: null, // function (dateObj, dateStr) {}
	
		// called after calendar is ready
		onReady: null, // function (dateObj, dateStr) {}
	
		onValueUpdate: null,
	
		onDayCreate: null
	};
	
	/* istanbul ignore next */
	Flatpickr.l10ns = {
		en: {
			weekdays: {
				shorthand: ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"],
				longhand: ["Sunday", "Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday"]
			},
			months: {
				shorthand: ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"],
				longhand: ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"]
			},
			daysInMonth: [31, 28, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31],
			firstDayOfWeek: 0,
			ordinal: function ordinal(nth) {
				var s = nth % 100;
				if (s > 3 && s < 21) return "th";
				switch (s % 10) {
					case 1:
						return "st";
					case 2:
						return "nd";
					case 3:
						return "rd";
					default:
						return "th";
				}
			},
			rangeSeparator: " to ",
			weekAbbreviation: "Wk",
			scrollTitle: "Scroll to increment",
			toggleTitle: "Click to toggle"
		}
	};
	
	Flatpickr.l10ns.default = Object.create(Flatpickr.l10ns.en);
	Flatpickr.localize = function (l10n) {
		return _extends(Flatpickr.l10ns.default, l10n || {});
	};
	Flatpickr.setDefaults = function (config) {
		return _extends(Flatpickr.defaultConfig, config || {});
	};
	
	Flatpickr.prototype = {
		pad: function pad(number) {
			return ("0" + number).slice(-2);
		},
		parseDate: function parseDate(date, timeless) {
			if (!date) return null;
	
			var dateTimeRegex = /(\d+)/g,
			    timeRegex = /^(\d{1,2})[:\s](\d\d)?[:\s]?(\d\d)?\s?(a|p)?/i,
			    timestamp = /^(\d+)$/g,
			    date_orig = date;
	
			if (date.toFixed || timestamp.test(date)) // timestamp
				date = new Date(date);else if (typeof date === "string") {
				date = date.trim();
	
				if (date === "today") {
					date = new Date();
					timeless = true;
				} else if (this.config && this.config.parseDate) date = this.config.parseDate(date);else if (timeRegex.test(date)) {
					// time picker
					var m = date.match(timeRegex),
					    hours = !m[4] ? m[1] // military time, no conversion needed
					: m[1] % 12 + (m[4].toLowerCase() === "p" ? 12 : 0); // am/pm
	
					date = new Date();
					date.setHours(hours, m[2] || 0, m[3] || 0);
				} else if (/Z$/.test(date) || /GMT$/.test(date)) // datestrings w/ timezone
					date = new Date(date);else if (dateTimeRegex.test(date) && /^[0-9]/.test(date)) {
					var d = date.match(dateTimeRegex);
					date = new Date(d[0] + "/" + (d[1] || 1) + "/" + (d[2] || 1) + " " + (d[3] || 0) + ":" + (d[4] || 0) + ":" + (d[5] || 0));
				} else // fallback
					date = new Date(date);
			} else if (date instanceof Date) date = new Date(date.getTime()); // create a copy
	
			if (!(date instanceof Date)) {
				console.warn("flatpickr: invalid date " + date_orig);
				console.info(this.element);
				return null;
			}
	
			if (this.config && this.config.utc && !date.fp_isUTC) date = date.fp_toUTC();
	
			if (timeless === true) date.setHours(0, 0, 0, 0);
	
			return date;
		}
	};
	
	function _flatpickr(nodeList, config) {
		var nodes = Array.prototype.slice.call(nodeList); // static list
		var instances = [];
		for (var i = 0; i < nodes.length; i++) {
			try {
				nodes[i]._flatpickr = new Flatpickr(nodes[i], config || {});
				instances.push(nodes[i]._flatpickr);
			} catch (e) {
				console.warn(e, e.stack);
			}
		}
	
		return instances.length === 1 ? instances[0] : instances;
	}
	
	if (typeof HTMLElement !== "undefined") {
		// browser env
		HTMLCollection.prototype.flatpickr = NodeList.prototype.flatpickr = function (config) {
			return _flatpickr(this, config);
		};
	
		HTMLElement.prototype.flatpickr = function (config) {
			return _flatpickr([this], config);
		};
	}
	
	function flatpickr(selector, config) {
		return _flatpickr(window.document.querySelectorAll(selector), config);
	}
	
	if (typeof jQuery !== "undefined") {
		jQuery.fn.flatpickr = function (config) {
			return _flatpickr(this, config);
		};
	}
	
	Date.prototype.fp_incr = function (days) {
		return new Date(this.getFullYear(), this.getMonth(), this.getDate() + parseInt(days, 10));
	};
	
	Date.prototype.fp_isUTC = false;
	Date.prototype.fp_toUTC = function () {
		var newDate = new Date(this.getUTCFullYear(), this.getUTCMonth(), this.getUTCDate(), this.getUTCHours(), this.getUTCMinutes(), this.getUTCSeconds());
	
		newDate.fp_isUTC = true;
		return newDate;
	};
	
	// IE9 classList polyfill
	/* istanbul ignore next */
	if (!window.document.documentElement.classList && Object.defineProperty && typeof HTMLElement !== "undefined") {
		Object.defineProperty(HTMLElement.prototype, "classList", {
			get: function get() {
				var self = this;
				function update(fn) {
					return function (value) {
						var classes = self.className.split(/\s+/),
						    index = classes.indexOf(value);
	
						fn(classes, index, value);
						self.className = classes.join(" ");
					};
				}
	
				var ret = {
					add: update(function (classes, index, value) {
						if (!~index) classes.push(value);
					}),
	
					remove: update(function (classes, index) {
						if (~index) classes.splice(index, 1);
					}),
	
					toggle: update(function (classes, index, value) {
						if (~index) classes.splice(index, 1);else classes.push(value);
					}),
	
					contains: function contains(value) {
						return !!~self.className.split(/\s+/).indexOf(value);
					},
	
					item: function item(i) {
						return self.className.split(/\s+/)[i] || null;
					}
				};
	
				Object.defineProperty(ret, "length", {
					get: function get() {
						return self.className.split(/\s+/).length;
					}
				});
	
				return ret;
			}
		});
	}
	
	if (true) module.exports = Flatpickr;
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(2)))

/***/ }),
/* 93 */
/***/ (function(module, exports, __webpack_require__) {

	/* German locals for flatpickr */
	var Flatpickr = Flatpickr || { l10ns: {} };
	Flatpickr.l10ns.de = {};
	
	Flatpickr.l10ns.de.weekdays = {
		shorthand: ['So', 'Mo', 'Di', 'Mi', 'Do', 'Fr', 'Sa'],
		longhand: ['Sonntag', 'Montag', 'Dienstag', 'Mittwoch', 'Donnerstag', 'Freitag', 'Samstag']
	};
	
	Flatpickr.l10ns.de.months = {
		shorthand: ['Jan', 'Feb', 'Mär', 'Apr', 'Mai', 'Jun', 'Jul', 'Aug', 'Sep', 'Okt', 'Nov', 'Dez'],
		longhand: ['Januar', 'Februar', 'März', 'April', 'Mai', 'Juni', 'Juli', 'August', 'September', 'Oktober', 'November', 'Dezember']
	};
	
	Flatpickr.l10ns.de.firstDayOfWeek = 1;
	Flatpickr.l10ns.de.weekAbbreviation = 'KW';
	
	if (true) {
		module.exports = Flatpickr.l10ns;
	}

/***/ }),
/* 94 */
/***/ (function(module, exports, __webpack_require__) {

	/* French locals for flatpickr */
	var Flatpickr = Flatpickr || { l10ns: {} };
	Flatpickr.l10ns.fr = {};
	
	Flatpickr.l10ns.fr.firstDayOfWeek = 1;
	
	Flatpickr.l10ns.fr.weekdays = {
		shorthand: ['Dim', 'Lun', 'Mar', 'Mer', 'Jeu', 'Ven', 'Sam'],
		longhand: ['Dimanche', 'Lundi', 'Mardi', 'Mercredi', 'Jeudi', 'Vendredi', 'Samedi']
	};
	
	Flatpickr.l10ns.fr.months = {
		shorthand: ['Janv', 'Févr', 'Mars', 'Avr', 'Mai', 'Juin', 'Juil', 'Août', 'Sept', 'Oct', 'Nov', 'Déc'],
		longhand: ['Janvier', 'Février', 'Mars', 'Avril', 'Mai', 'Juin', 'Juillet', 'Août', 'Septembre', 'Octobre', 'Novembre', 'Décembre']
	};
	
	Flatpickr.l10ns.fr.ordinal = function (nth) {
		if (nth > 1) {
			return "ème";
		}
	
		return "er";
	};
	if (true) {
		module.exports = Flatpickr.l10ns;
	}

/***/ }),
/* 95 */
/***/ (function(module, exports, __webpack_require__) {

	/* Italian locals for flatpickr */
	var Flatpickr = Flatpickr || { l10ns: {} };
	Flatpickr.l10ns.it = {};
	
	Flatpickr.l10ns.it.weekdays = {
		shorthand: ['Dom', 'Lun', 'Mar', 'Mer', 'Gio', 'Ven', 'Sab'],
		longhand: ['Domenica', 'Lunedì', 'Martedì', 'Mercoledì', 'Giovedì', 'Venerdì', 'Sabato']
	};
	
	Flatpickr.l10ns.it.months = {
		shorthand: ['Gen', 'Feb', 'Mar', 'Apr', 'Mag', 'Giu', 'Lug', 'Ago', 'Set', 'Ott', 'Nov', 'Dic'],
		longhand: ['Gennaio', 'Febbraio', 'Marzo', 'Aprile', 'Maggio', 'Giugno', 'Luglio', 'Agosto', 'Settembre', 'Ottobre', 'Novembre', 'Dicembre']
	};
	
	Flatpickr.l10ns.it.firstDayOfWeek = 1;
	
	Flatpickr.l10ns.it.ordinal = '°';
	
	Flatpickr.l10ns.it.weekAbbreviation = 'Se';
	
	Flatpickr.l10ns.it.scrollTitle = 'Scrolla per aumentare';
	
	Flatpickr.l10ns.it.toggleTitle = 'Clicca per cambiare';
	
	if (true) {
		module.exports = Flatpickr.l10ns;
	}

/***/ }),
/* 96 */
/***/ (function(module, exports, __webpack_require__) {

	/* Spanish locals for flatpickr */
	var Flatpickr = Flatpickr || { l10ns: {} };
	Flatpickr.l10ns.es = {};
	
	Flatpickr.l10ns.es.weekdays = {
		shorthand: ['Dom', 'Lun', 'Mar', 'Mié', 'Jue', 'Vie', 'Sáb'],
		longhand: ['Domingo', 'Lunes', 'Martes', 'Miércoles', 'Jueves', 'Viernes', 'Sábado']
	};
	
	Flatpickr.l10ns.es.months = {
		shorthand: ['Ene', 'Feb', 'Mar', 'Abr', 'May', 'Jun', 'Jul', 'Ago', 'Sep', 'Oct', 'Nov', 'Dic'],
		longhand: ['Enero', 'Febrero', 'Marzo', 'Abril', 'Mayo', 'Junio', 'Julio', 'Agosto', 'Septiembre', 'Octubre', 'Noviembre', 'Diciembre']
	};
	
	Flatpickr.l10ns.es.ordinal = function () {
		return "º";
	};
	
	Flatpickr.l10ns.es.firstDayOfWeek = 1;
	if (true) {
		module.exports = Flatpickr.l10ns;
	}

/***/ }),
/* 97 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function($) {'use strict';
	
	$(function () {
	
	    /* * * * * * * * * * * * * * * * * * * * * * * * * * * * * *
	     Disable Scrolling when Django Modal is open
	     Inspiration:
	     http://jsfiddle.net/ybGCF/
	     */
	
	    // init
	    var djangocms_modal, observer_config, djangocms_modal_observer;
	
	    // select element to be observed
	    djangocms_modal = document.querySelector('.cms-modal');
	
	    // only start observing if we're logged in and the element exists
	    if (djangocms_modal !== null) {
	
	        // observer settings
	        observer_config = {
	            attributes: true, // this is enough in our case
	            childList: false,
	            characterData: false
	        };
	
	        // instantuation MutationObserver
	        djangocms_modal_observer = new MutationObserver(function (mutations) {
	            mutations.forEach(function (mutation) {
	                var newVal = $(mutation.target).prop(mutation.attributeName);
	                if (mutation.attributeName === "class") {
	                    if (newVal.search('cms-modal-open') > 0) {
	                        $('html').addClass('scrolling-disabled');
	                    } else {
	                        $('html').removeClass('scrolling-disabled');
	                    }
	                }
	            });
	        });
	
	        // Let's observe!
	        djangocms_modal_observer.observe(djangocms_modal, observer_config);
	    }
	
	    /* * * * * * * * * * * * * * * * * * * * * * * * * * * * * *
	     Initialize CMS-Plugins after Ajax-Request
	     */
	
	    if (typeof CMS !== 'undefined') {
	        $(window).on('ajaxLoadItems:success', function (event) {
	            // CMS.Plugin._initializeTree();
	        });
	    }
	});
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(2)))

/***/ }),
/* 98 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function($) {'use strict';
	
	/* * * * * * * * * * * * * * * * * * * * * * * * * * * * * *
	
	Feature Detection
	
	At the time of writing, we only need to detect the following features in order to make the allink-core-static work.
	
	*/
	
	$(function () {
	
	    //  Swop class if JavaScript is enabled
	    $('html').removeClass('no-js').addClass('js');
	});
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(2)))

/***/ }),
/* 99 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function($) {'use strict';
	
	$(function () {
	
	    function initFormModifications() {
	
	        /* * * * * * * * * * * * * * * * * * * * * * * * * * * * * *
	         Submit form from trigger (that is not an input type 'submit')
	         */
	
	        $('[data-submit-form]').on('click', function (e) {
	            // init
	            e.preventDefault();
	            var $trigger = $(this);
	            // find and submit form
	            $trigger.parents('form').submit();
	        });
	
	        /* * * * * * * * * * * * * * * * * * * * * * * * * * * * * *
	         The maxlength attribute is being ignored on type="number" inputs. Let's make this work.
	         */
	
	        // find inputs with maxlength attribute
	        var $maxlength_inputs = $('form').find('input[maxlength]');
	        // loop elements and listen for key event
	        $maxlength_inputs.each(function (e) {
	            // init
	            var $input = $(this);
	            var maxlength = $input.attr('maxlength');
	            // listen to relevant events
	            $input.on('keydown', function (e) {
	                return handleInputMaxlength(this, e, maxlength);
	            });
	            $input.on('focus', function (e) {
	                return handleInputMaxlength(this, e, maxlength);
	            });
	            $input.on('click', function (e) {
	                return handleInputMaxlength(this, e, maxlength);
	            });
	        });
	
	        /* * * * * * * * * * * * * * * * * * * * * * * * * * * * * *
	         Disable scroll for input type "number" to prevent Chromium browsers change the value when scrolling
	         */
	
	        $('form').on('focus', 'input[type=number]', function (e) {
	            $(this).on('mousewheel.disableScroll', function (e) {
	                e.preventDefault();
	            });
	        });
	        $('form').on('blur', 'input[type=number]', function (e) {
	            $(this).off('mousewheel.disableScroll');
	        });
	
	        /* * * * * * * * * * * * * * * * * * * * * * * * * * * * * *
	         Custom File Upload
	         Inspired by: http://tympanus.net/codrops/2015/09/15/styling-customizing-file-inputs-smart-way/
	         */
	
	        $('.custom-file-upload').each(function () {
	            var $container = $(this),
	                $input = $container.find('input'),
	                $label = $container.find('label'),
	                labelVal = $label.html();
	
	            $input.on('change', function (e) {
	                var fileName = '';
	
	                if (this.files && this.files.length > 1) fileName = (this.getAttribute('data-multiple-caption') || '').replace('{count}', this.files.length);else if (e.target.value) fileName = e.target.value.split('\\').pop();
	
	                if (fileName) {
	                    $container.addClass('file-selected');
	                    $label.html(fileName);
	                } else {
	                    $label.html(labelVal);
	                }
	            });
	
	            // Firefox bug fix
	            $input.on('focus', function () {
	                $input.addClass('has-focus');
	            }).on('blur', function () {
	                $input.removeClass('has-focus');
	            });
	        });
	    }
	
	    function getSelectedText() {
	        var text = "";
	        if (typeof window.getSelection != "undefined") {
	            text = window.getSelection().toString();
	        } else if (typeof document.selection != "undefined" && document.selection.type == "Text") {
	            text = window.selection.createRange().text;
	        }
	        return text;
	    }
	
	    function handleInputMaxlength(input, e, maxlength) {
	        // store key code
	        var $input = $(input);
	        var input_field = input;
	        var key_code = parseInt(e.which);
	        var current_number_of_characters = parseInt($input.val().length);
	        var input_text_is_selected = false;
	        // try to get selected text
	        if (getSelectedText()) {
	            input_text_is_selected = true;
	        }
	        // always accepted: key codes 8 until 46 are general keys like space, delete, backspace, arrows, ...
	        if (key_code >= 8 && key_code <= 46) {}
	        // all good. keep going.
	
	        // any other system keys (and the COMMAND key of Macs)
	        else if (e.altKey || e.ctrlKey || e.shiftKey || key_code == 91) {}
	            // all good. keep going.
	
	            // any other case should be checked
	            else {
	                    // only block typing if NO text is selected
	                    if (input_text_is_selected === true) {
	                        // we're overwriting marked text, keep going!
	                    } else {
	                        // in case it's a character, make sure we respect the limit
	                        if (current_number_of_characters == maxlength) {
	                            return false;
	                        }
	                    }
	                }
	    }
	
	    // on page load
	    initFormModifications();
	
	    // custom event
	    $(window).on('initFormModifications softpage:opened form-modal:opened', function () {
	        initFormModifications();
	    });
	});
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(2)))

/***/ }),
/* 100 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function($) {'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.initFormValidation = initFormValidation;
	
	var _jqueryValidation = __webpack_require__(84);
	
	var _jqueryValidation2 = _interopRequireDefault(_jqueryValidation);
	
	var _ajaxForm = __webpack_require__(101);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/* * * * * * * * * * * * * * * * * * * * * * * * * * * * * *
	
	jQuery Validation
	
	Usage:
	
	<form class="validate-form">
	    ...
	        <!-- Mark a field as required -->
	        <input type="text" name="example" required>
	    ...
	</form>
	
	Optional: Validate on page load by adding a class to the form:
	
	<form class="validate-form validate-on-page-load">
	    ...
	</form>
	
	Docs:
	
	https://jqueryvalidation.org/validate/
	
	*/
	
	function initFormValidation() {
	    $('form.validate-form').each(function () {
	        // init
	        var $form = $(this);
	        // init form validation
	        var form_to_validate = $form.validate({
	            onkeyup: false,
	            onfocusout: function onfocusout(element) {
	                // option 1: INSTANT validation after leaving a form field
	                // this.element(element);
	                // option 2: validate on submit
	                return false;
	            },
	            errorPlacement: function errorPlacement(error, element) {
	                return false;
	            },
	            submitHandler: function submitHandler(form) {
	                var $form_to_be_submitted = $(form);
	                // ajax form
	                if ($form_to_be_submitted.hasClass('ajax-form') === true) {
	                    (0, _ajaxForm.sendAjaxForm)($form);
	                }
	                // default form
	                else {
	                        window.onbeforeunload = null;
	                        return true;
	                    }
	            },
	            invalidHandler: function invalidHandler(event, validator) {
	                $form.addClass('has-errors');
	            },
	            unhighlight: function unhighlight(element) {
	                // form element itself
	                $(element).removeClass('error');
	                // form group, or error state handler (in case of multi column forms)
	                var $error_state_handler = $(element).parents('.error-state-handler');
	                if ($error_state_handler.length > 0) {
	                    $error_state_handler.removeClass('has-error');
	                } else {
	                    $(element).parents('.form-group').first().removeClass('has-error');
	                }
	            },
	            highlight: function highlight(element) {
	                // form element itself
	                $(element).addClass('error');
	                // form group, or error state handler (in case of multi column forms)
	                var $error_state_handler = $(element).parents('.error-state-handler');
	                if ($error_state_handler.length > 0) {
	                    $error_state_handler.addClass('has-error');
	                } else {
	                    $(element).parents('.form-group').first().addClass('has-error');
	                }
	            }
	        });
	        // optional: validate on page load by adding a class to the form
	        if ($form.hasClass('validate-on-page-load')) {
	            $form.validate().form();
	        }
	    });
	}
	
	$(function () {
	
	    // on page load
	    initFormValidation();
	
	    // custom event
	    $(window).on('initFormValidation softpage:opened form-modal:opened', function () {
	        initFormValidation();
	    });
	});
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(2)))

/***/ }),
/* 101 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function($) {'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.sendAjaxForm = sendAjaxForm;
	exports.initAjaxForm = initAjaxForm;
	/* * * * * * * * * * * * * * * * * * * * * * * * * * * * * *
	
	Global solution for simple AJAX forms
	
	Usage:
	
	<div id="example-form-container">
	    <form class="ajax-form" data-form-container-id="example-form-container" data-success-data-layer-event="newsletter.sent" action="/example-url/">
	        <div
	            data-layer-variable="example-variable-1"
	            data-layer-value="example-value-1"
	            >
	        </div>
	        ...
	    </form>
	</div>
	
	Google Tag Manager GTM note:
	
	Send a custom event to GTM by adding the 'data-success-data-layer-event' attribute to the <form> and pass a value e.g. 'newsletter.sent' that matched your GTM settings.
	
	Important:
	
	Obviously, the container ID ("example-form-container") has to be unique, not just to pass the HTML validator.
	
	*/
	
	function sendAjaxForm($form) {
	
	    // init
	    var url = $form.attr('action');
	    var custom_event = $form.attr('data-success-data-layer-event');
	    var custom_event_id = $form.attr('data-success-data-layer-event-identifier');
	    if (!custom_event_id) custom_event_id = '';
	    var success_url = $form.attr('data-success-url');
	    var container_id = $form.attr('data-form-container-id');
	    var postData = $form.serialize();
	
	    // define the container in which the ajax response will be written into
	    // 1. in case an ID is defined, select that element
	    if (container_id) {
	        var $form_container = $('#' + container_id);
	        if ($form_container.length == 0) {
	            console.warn('The form\'s "data-form-container-id" is set to "' + container_id + '" but element can not be found in DOM');
	        }
	    }
	    // 2. default: use immediate parent
	    else {
	            var $form_container = $form.parent();
	        }
	
	    // AJAX magic
	    $.ajax({
	        type: "POST",
	        url: url,
	        data: postData,
	        success: function success(data, textStatus, jqXHR) {
	            // do we get a custom URL from view?
	            if (data.success_url) {
	                window.location.href = data.success_url;
	            }
	            // otherwise, write HTML
	            else {
	                    $form_container.html(data);
	                }
	            // Note: If there are errors that we couldn't catch with the JavaScript form validation we get a '206' status code from the form's view
	            if (jqXHR.status === 206) {}
	            // something wrong while sending the form
	
	            // made it.. finally!
	            else {
	                    // Google Tag Manager in use?
	                    if (typeof dataLayer !== 'undefined') {
	                        // Is there a custom event defined?
	                        if (custom_event) {
	                            // add values to array
	                            dataLayer.push({
	                                'event': custom_event,
	                                'form_id': custom_event_id
	                            });
	                        }
	                    }
	                }
	
	            // trigger custom events
	            $(window).trigger('ajaxFormSuccess');
	            $(window).trigger('initAjaxForm');
	            $(window).trigger('initDatepicker');
	            $(window).trigger('initFormModalClose');
	            $(window).trigger('initFormValidation');
	        },
	        error: function error(jqXHR, textStatus, errorThrown) {
	            //if fails
	        }
	    });
	}
	
	function initAjaxForm() {
	
	    // find .ajax-form elements and loop!
	    var ajax_forms = document.querySelectorAll('.ajax-form');
	    if (ajax_forms.length > 0) {
	        for (var i = 0; i < ajax_forms.length; i++) {
	            // init
	            var $form = $(ajax_forms[i]);
	            // only listen for the submit event, if the form is not being validated
	            if ($form.hasClass('validate-form') === false) {
	                $form.on('submit', function (event) {
	                    sendAjaxForm($form);
	                    event.preventDefault();
	                });
	            }
	        }
	    }
	}
	
	$(function () {
	
	    // on page load
	    initAjaxForm();
	
	    // custom event
	    $(window).on('initAjaxForm', function () {
	        initAjaxForm();
	    });
	});
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(2)))

/***/ }),
/* 102 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function($) {'use strict';
	
	/* * * * * * * * * * * * * * * * * * * * * * * * * * * * * *
	
	Prevent the viewport dependent container height (e.g. 100vh)
	to be adjust when scrolling (resulting in smaller address bar)
	on some Android devices by setting the height inline
	
	*/
	
	$(function () {
	
	    function remove_full_height() {
	        var elements = document.querySelectorAll('.full-height-enabled');
	        if (elements.length > 0) {
	            var _iteratorNormalCompletion = true;
	            var _didIteratorError = false;
	            var _iteratorError = undefined;
	
	            try {
	                for (var _iterator = elements[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
	                    var element = _step.value;
	
	                    element.style.minHeight = '';
	                }
	            } catch (err) {
	                _didIteratorError = true;
	                _iteratorError = err;
	            } finally {
	                try {
	                    if (!_iteratorNormalCompletion && _iterator.return) {
	                        _iterator.return();
	                    }
	                } finally {
	                    if (_didIteratorError) {
	                        throw _iteratorError;
	                    }
	                }
	            }
	        }
	    }
	
	    function set_full_height() {
	        // define the very minimum height of an element (very small screens or mobile devies in landscape)
	        var minimum_height = 450;
	        // find elements
	        var elements = document.querySelectorAll('.full-height-enabled');
	        if (elements.length > 0) {
	            // ..and looop through all items and set inline height
	            var _iteratorNormalCompletion2 = true;
	            var _didIteratorError2 = false;
	            var _iteratorError2 = undefined;
	
	            try {
	                for (var _iterator2 = elements[Symbol.iterator](), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
	                    var element = _step2.value;
	
	                    // get the calculated height of the element..
	                    var calculated_height_in_css = parseInt(getComputedStyle(element).minHeight);
	                    // in case of small screens in landscape mode, the height would be too small, so we apply a minimum height
	                    if (calculated_height_in_css < 450) {
	                        element.style.minHeight = minimum_height + 'px';
	                    }
	                    // oterhwise we set the calculated height
	                    else {
	                            element.style.minHeight = calculated_height_in_css + 'px';
	                        }
	                }
	            } catch (err) {
	                _didIteratorError2 = true;
	                _iteratorError2 = err;
	            } finally {
	                try {
	                    if (!_iteratorNormalCompletion2 && _iterator2.return) {
	                        _iterator2.return();
	                    }
	                } finally {
	                    if (_didIteratorError2) {
	                        throw _iteratorError2;
	                    }
	                }
	            }
	        }
	    }
	
	    // on page load
	    set_full_height();
	
	    // custom event
	    $(window).on('setFullHeight', function () {
	        // first we need to remove the inline CSS, so we can get the proper CSS calculations again..
	        remove_full_height();
	        // ..and then we set the height
	        set_full_height();
	    });
	
	    // initialize again when viewport width has changed
	    $(window).on('viewportWidthHasChanged', function () {
	        // first we need to remove the inline CSS, so we can get the proper CSS calculations again..
	        remove_full_height();
	        // ..and then we set the height
	        set_full_height();
	    });
	});
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(2)))

/***/ }),
/* 103 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function($) {'use strict';
	
	var _tingle = __webpack_require__(71);
	
	var _tingle2 = _interopRequireDefault(_tingle);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	$(function () {
	
	    // initialize modal
	    var image_modal = new _tingle2.default.modal({
	        cssClass: ['image-modal'],
	        onClose: function onClose() {
	            // init
	            var $modal = $('.tingle-modal.image-modal');
	            // remove class from html
	            document.querySelector('html').classList.remove('image-modal-visible');
	            // trigger class
	            $(window).trigger('image-modal:closed');
	            // remove any content (issue: video was still playing)
	            $modal.find('.tingle-modal-box__content').empty();
	            // if the softpage is still open in the brackground, we have to keep the overlay, otherwise we can close it
	            if ($('.tingle-modal.softpage').hasClass('tingle-modal--visible')) {
	                // tingle removes the class from the body, so let's re-add it
	                document.querySelector('body').classList.add('tingle-enabled');
	            } else {
	                $(window).trigger('hideSiteOverlay');
	            }
	        },
	        onOpen: function onOpen() {
	            // trigger custom events
	            $(window).trigger('image-modal:opened');
	            $(window).trigger('initImageModalClose');
	        }
	    });
	
	    // click handler
	    function openImageModal(element, event, $image_modal_content) {
	        // init
	        event.preventDefault();
	
	        // indicate that the image modal is visible
	        document.querySelector('html').classList.add('image-modal-visible');
	
	        // set content
	        $(image_modal.modalBoxContent).html($image_modal_content);
	        image_modal.open();
	    }
	
	    function initImageModalTrigger() {
	        // init all trigger links and loop
	        $('[data-trigger-image-modal]').each(function (i) {
	            // stop multiple event listeners on the same element by adding an initialized attribute that we can check the next time we call this function
	            // init
	            var $trigger = $(this);
	            var initialized_attr = 'data-trigger-initialized';
	            // check for initialized trigger
	            var trigger_initialized = $trigger.attr(initialized_attr);
	            // NOT initialized yet
	            if (typeof trigger_initialized === 'undefined') {
	                $trigger.on('click', function (event) {
	                    // init
	                    event.preventDefault();
	                    var $trigger = $(this);
	                    var href = $trigger.attr('href');
	                    var video_link_enabled = $trigger.attr('data-image-modal-video-link-enabled');
	                    var window_width = $(window).width();
	                    // mobile, show in new tab instead, unless it's an embedded video link
	                    if (window_width < 768 && typeof video_link_enabled === 'undefined') {
	                        window.open(href, '_blank');
	                    }
	                    // larger screens, show modal
	                    else {
	                            // get content of modal
	                            var $image_modal_content = $trigger.find('.image-modal-content').contents().clone();
	                            if ($image_modal_content.length > 0) {
	                                // instantly toggle site overlay (improves "felt performance")
	                                $(window).trigger('showSiteOverlay');
	                                // load softpage
	                                openImageModal(this, event, $image_modal_content);
	                            }
	                        }
	                });
	                // mark as initialized
	                $trigger.attr(initialized_attr, '');
	            }
	        });
	    }
	
	    // on page load
	    initImageModalTrigger();
	
	    // custom event
	    $(window).on('initImageModalTrigger softpage:opened image-modal:opened', function () {
	        initImageModalTrigger();
	    });
	
	    function initImageModalClose() {
	        // look for triggers
	        if (document.querySelector('.close-image-modal,[data-close-image-modal]')) {
	            var close_image_modal = document.querySelector('.close-image-modal,[data-close-image-modal]');
	            close_image_modal.addEventListener('click', function (event) {
	                event.preventDefault();
	                image_modal.close();
	            });
	        }
	    }
	
	    // custom event
	    $(window).on('initImageModalClose', function () {
	        initImageModalClose();
	    });
	}); /* * * * * * * * * * * * * * * * * * * * * * * * * * * * * *
	    
	    Link with class '.toggle-image-modal' will trigger the form lightbox
	    
	    Custom Events:
	    
	    image-modal:opened
	    image-modal:closed
	    
	    */
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(2)))

/***/ }),
/* 104 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function($) {'use strict';
	
	var _scrollDepth = __webpack_require__(105);
	
	var _scrollDepth2 = _interopRequireDefault(_scrollDepth);
	
	var _riveted = __webpack_require__(106);
	
	var _riveted2 = _interopRequireDefault(_riveted);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/* * * * * * * * * * * * * * * * * * * * * * * * * * * * * *
	
	SEO scripts for e.g. Google Tag Manager
	
	*/
	
	$(function () {
	
	  /* * * * * * * * * * * * * * * * * * * * * * * * * * * * * *
	   Scroll-Depth - Configuration
	   http://scrolldepth.parsnip.io/
	   */
	
	  $.scrollDepth({
	    minHeight: 0,
	    elements: [],
	    percentage: true,
	    userTiming: false,
	    pixelDepth: false,
	    nonInteraction: true
	  });
	
	  /* * * * * * * * * * * * * * * * * * * * * * * * * * * * * *
	   Riveted - Initialization
	   http://riveted.parsnip.io/
	   */
	
	  _riveted2.default.init();
	});
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(2)))

/***/ }),
/* 105 */
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/*!
	 * @preserve
	 * jquery.scrolldepth.js | v0.9.1
	 * Copyright (c) 2016 Rob Flaherty (@robflaherty)
	 * Licensed under the MIT and GPL licenses.
	 */
	
	/* Universal module definition */
	
	(function(factory) {
	  if (true) {
	    // AMD
	    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(2)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	  } else if (typeof module === 'object' && module.exports) {
	    // CommonJS
	    module.exports = factory(require('jquery'));
	  } else {
	    // Browser globals
	    factory(jQuery);
	  }
	}(function($) {
	
	/* Scroll Depth */
	
	    "use strict";
	
	    var defaults = {
	      minHeight: 0,
	      elements: [],
	      percentage: true,
	      userTiming: true,
	      pixelDepth: true,
	      nonInteraction: true,
	      gaGlobal: false,
	      gtmOverride: false
	    };
	
	    var $window = $(window),
	      cache = [],
	      scrollEventBound = false,
	      lastPixelDepth = 0,
	      universalGA,
	      classicGA,
	      gaGlobal,
	      standardEventHandler;
	
	    /*
	     * Plugin
	     */
	
	    $.scrollDepth = function(options) {
	
	      var startTime = +new Date;
	
	      options = $.extend({}, defaults, options);
	
	      // Return early if document height is too small
	      if ( $(document).height() < options.minHeight ) {
	        return;
	      }
	
	      /*
	       * Determine which version of GA is being used
	       * "ga", "__gaTracker", _gaq", and "dataLayer" are the possible globals
	       */
	
	      if (options.gaGlobal) {
	        universalGA = true;
	        gaGlobal = options.gaGlobal;
	      } else if (typeof ga === "function") {
	        universalGA = true;
	        gaGlobal = 'ga';
	      } else if (typeof __gaTracker === "function") {
	        universalGA = true;
	        gaGlobal = '__gaTracker';
	      }
	
	      if (typeof _gaq !== "undefined" && typeof _gaq.push === "function") {
	        classicGA = true;
	      }
	
	      if (typeof options.eventHandler === "function") {
	        standardEventHandler = options.eventHandler;
	      } else if (typeof dataLayer !== "undefined" && typeof dataLayer.push === "function" && !options.gtmOverride) {
	
	        standardEventHandler = function(data) {
	          dataLayer.push(data);
	        };
	      }
	
	      /*
	       * Functions
	       */
	
	      function sendEvent(action, label, scrollDistance, timing) {
	
	        if (standardEventHandler) {
	
	          standardEventHandler({'event': 'ScrollDistance', 'eventCategory': 'Scroll Depth', 'eventAction': action, 'eventLabel': label, 'eventValue': 1, 'eventNonInteraction': options.nonInteraction});
	
	          if (options.pixelDepth && arguments.length > 2 && scrollDistance > lastPixelDepth) {
	            lastPixelDepth = scrollDistance;
	            standardEventHandler({'event': 'ScrollDistance', 'eventCategory': 'Scroll Depth', 'eventAction': 'Pixel Depth', 'eventLabel': rounded(scrollDistance), 'eventValue': 1, 'eventNonInteraction': options.nonInteraction});
	          }
	
	          if (options.userTiming && arguments.length > 3) {
	            standardEventHandler({'event': 'ScrollTiming', 'eventCategory': 'Scroll Depth', 'eventAction': action, 'eventLabel': label, 'eventTiming': timing});
	          }
	
	        } else {
	
	          if (universalGA) {
	
	            window[gaGlobal]('send', 'event', 'Scroll Depth', action, label, 1, {'nonInteraction': options.nonInteraction});
	
	            if (options.pixelDepth && arguments.length > 2 && scrollDistance > lastPixelDepth) {
	              lastPixelDepth = scrollDistance;
	              window[gaGlobal]('send', 'event', 'Scroll Depth', 'Pixel Depth', rounded(scrollDistance), 1, {'nonInteraction': options.nonInteraction});
	            }
	
	            if (options.userTiming && arguments.length > 3) {
	              window[gaGlobal]('send', 'timing', 'Scroll Depth', action, timing, label);
	            }
	
	          }
	
	          if (classicGA) {
	
	            _gaq.push(['_trackEvent', 'Scroll Depth', action, label, 1, options.nonInteraction]);
	
	            if (options.pixelDepth && arguments.length > 2 && scrollDistance > lastPixelDepth) {
	              lastPixelDepth = scrollDistance;
	              _gaq.push(['_trackEvent', 'Scroll Depth', 'Pixel Depth', rounded(scrollDistance), 1, options.nonInteraction]);
	            }
	
	            if (options.userTiming && arguments.length > 3) {
	              _gaq.push(['_trackTiming', 'Scroll Depth', action, timing, label, 100]);
	            }
	
	          }
	
	        }
	
	      }
	
	      function calculateMarks(docHeight) {
	        return {
	          '25%' : parseInt(docHeight * 0.25, 10),
	          '50%' : parseInt(docHeight * 0.50, 10),
	          '75%' : parseInt(docHeight * 0.75, 10),
	          // Cushion to trigger 100% event in iOS
	          '100%': docHeight - 5
	        };
	      }
	
	      function checkMarks(marks, scrollDistance, timing) {
	        // Check each active mark
	        $.each(marks, function(key, val) {
	          if ( $.inArray(key, cache) === -1 && scrollDistance >= val ) {
	            sendEvent('Percentage', key, scrollDistance, timing);
	            cache.push(key);
	          }
	        });
	      }
	
	      function checkElements(elements, scrollDistance, timing) {
	        $.each(elements, function(index, elem) {
	          if ( $.inArray(elem, cache) === -1 && $(elem).length ) {
	            if ( scrollDistance >= $(elem).offset().top ) {
	              sendEvent('Elements', elem, scrollDistance, timing);
	              cache.push(elem);
	            }
	          }
	        });
	      }
	
	      function rounded(scrollDistance) {
	        // Returns String
	        return (Math.floor(scrollDistance/250) * 250).toString();
	      }
	
	      function init() {
	        bindScrollDepth();
	      }
	
	      /*
	       * Public Methods
	       */
	
	      // Reset Scroll Depth with the originally initialized options
	      $.scrollDepth.reset = function() {
	        cache = [];
	        lastPixelDepth = 0;
	        $window.off('scroll.scrollDepth');
	        bindScrollDepth();
	      };
	
	      // Add DOM elements to be tracked
	      $.scrollDepth.addElements = function(elems) {
	
	        if (typeof elems == "undefined" || !$.isArray(elems)) {
	          return;
	        }
	
	        $.merge(options.elements, elems);
	
	        // If scroll event has been unbound from window, rebind
	        if (!scrollEventBound) {
	          bindScrollDepth();
	        }
	
	      };
	
	      // Remove DOM elements currently tracked
	      $.scrollDepth.removeElements = function(elems) {
	
	        if (typeof elems == "undefined" || !$.isArray(elems)) {
	          return;
	        }
	
	        $.each(elems, function(index, elem) {
	
	          var inElementsArray = $.inArray(elem, options.elements);
	          var inCacheArray = $.inArray(elem, cache);
	
	          if (inElementsArray != -1) {
	            options.elements.splice(inElementsArray, 1);
	          }
	
	          if (inCacheArray != -1) {
	            cache.splice(inCacheArray, 1);
	          }
	
	        });
	
	      };
	
	      /*
	       * Throttle function borrowed from:
	       * Underscore.js 1.5.2
	       * http://underscorejs.org
	       * (c) 2009-2013 Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
	       * Underscore may be freely distributed under the MIT license.
	       */
	
	      function throttle(func, wait) {
	        var context, args, result;
	        var timeout = null;
	        var previous = 0;
	        var later = function() {
	          previous = new Date;
	          timeout = null;
	          result = func.apply(context, args);
	        };
	        return function() {
	          var now = new Date;
	          if (!previous) previous = now;
	          var remaining = wait - (now - previous);
	          context = this;
	          args = arguments;
	          if (remaining <= 0) {
	            clearTimeout(timeout);
	            timeout = null;
	            previous = now;
	            result = func.apply(context, args);
	          } else if (!timeout) {
	            timeout = setTimeout(later, remaining);
	          }
	          return result;
	        };
	      }
	
	      /*
	       * Scroll Event
	       */
	
	      function bindScrollDepth() {
	
	        scrollEventBound = true;
	
	        $window.on('scroll.scrollDepth', throttle(function() {
	          /*
	           * We calculate document and window height on each scroll event to
	           * account for dynamic DOM changes.
	           */
	
	          var docHeight = $(document).height(),
	            winHeight = window.innerHeight ? window.innerHeight : $window.height(),
	            scrollDistance = $window.scrollTop() + winHeight,
	
	            // Recalculate percentage marks
	            marks = calculateMarks(docHeight),
	
	            // Timing
	            timing = +new Date - startTime;
	
	          // If all marks already hit, unbind scroll event
	          if (cache.length >= options.elements.length + (options.percentage ? 4:0)) {
	            $window.off('scroll.scrollDepth');
	            scrollEventBound = false;
	            return;
	          }
	
	          // Check specified DOM elements
	          if (options.elements) {
	            checkElements(options.elements, scrollDistance, timing);
	          }
	
	          // Check standard marks
	          if (options.percentage) {
	            checkMarks(marks, scrollDistance, timing);
	          }
	        }, 500));
	
	      }
	
	      init();
	
	    };
	
	}));

/***/ }),
/* 106 */
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/*!
	 * @preserve
	 * riveted.js | v0.6.1
	 * Copyright (c) 2016 Rob Flaherty (@robflaherty)
	 * Licensed under the MIT license
	 */
	
	/* Universal module definition */
	
	(function (root, factory) {
	  if (true) {
	    // AMD
	    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	  } else if (typeof module === 'object' && module.exports) {
	    // CommonJS
	    module.exports = factory();
	  } else {
	    // Browser global
	    root.riveted = factory();
	  }
	}(this, function () {
	
	/* Riveted */
	
	var riveted = (function() {
	
	  var started = false,
	    stopped = false,
	    turnedOff = false,
	    clockTime = 0,
	    startTime = new Date(),
	    clockTimer = null,
	    idleTimer = null,
	    sendEvent,
	    sendUserTiming,
	    reportInterval,
	    idleTimeout,
	    nonInteraction,
	    universalGA,
	    classicGA,
	    universalSendCommand,
	    googleTagManager,
	    gaGlobal;
	
	    function init(options) {
	
	      // Set up options and defaults
	      options = options || {};
	      reportInterval = parseInt(options.reportInterval, 10) || 5;
	      idleTimeout = parseInt(options.idleTimeout, 10) || 30;
	      gaGlobal = options.gaGlobal || 'ga';
	
	      /*
	       * Determine which version of GA is being used
	       * "ga", "_gaq", and "dataLayer" are the possible globals
	       */
	
	      if (typeof window[gaGlobal] === "function") {
	        universalGA = true;
	      }
	
	      if (typeof _gaq !== "undefined" && typeof _gaq.push === "function") {
	        classicGA = true;
	      }
	
	      if (typeof dataLayer !== "undefined" && typeof dataLayer.push === "function") {
	        googleTagManager = true;
	      }
	
	      if ('gaTracker' in options && typeof options.gaTracker === 'string') {
	        universalSendCommand = options.gaTracker + '.send';
	      } else {
	        universalSendCommand = 'send';
	      }
	
	      if (typeof options.eventHandler == 'function') {
	        sendEvent = options.eventHandler;
	      }
	
	      if (typeof options.userTimingHandler == 'function') {
	        sendUserTiming = options.userTimingHandler;
	      }
	
	      if ('nonInteraction' in options && (options.nonInteraction === false || options.nonInteraction === 'false')) {
	        nonInteraction = false;
	      } else {
	        nonInteraction = true;
	      }
	
	      // Basic activity event listeners
	      addListener(document, 'keydown', trigger);
	      addListener(document, 'click', trigger);
	      addListener(window, 'mousemove', throttle(trigger, 500));
	      addListener(window, 'scroll', throttle(trigger, 500));
	
	      // Page visibility listeners
	      addListener(document, 'visibilitychange', visibilityChange);
	      addListener(document, 'webkitvisibilitychange', visibilityChange);
	    }
	
	
	    /*
	     * Throttle function borrowed from:
	     * Underscore.js 1.5.2
	     * http://underscorejs.org
	     * (c) 2009-2013 Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
	     * Underscore may be freely distributed under the MIT license.
	     */
	
	    function throttle(func, wait) {
	      var context, args, result;
	      var timeout = null;
	      var previous = 0;
	      var later = function() {
	        previous = new Date;
	        timeout = null;
	        result = func.apply(context, args);
	      };
	      return function() {
	        var now = new Date;
	        if (!previous) previous = now;
	        var remaining = wait - (now - previous);
	        context = this;
	        args = arguments;
	        if (remaining <= 0) {
	          clearTimeout(timeout);
	          timeout = null;
	          previous = now;
	          result = func.apply(context, args);
	        } else if (!timeout) {
	          timeout = setTimeout(later, remaining);
	        }
	        return result;
	      };
	    }
	
	    /*
	     * Cross-browser event listening
	     */
	
	    function addListener(element, eventName, handler) {
	      if (element.addEventListener) {
	        element.addEventListener(eventName, handler, false);
	      }
	      else if (element.attachEvent) {
	        element.attachEvent('on' + eventName, handler);
	      }
	      else {
	        element['on' + eventName] = handler;
	      }
	    }
	
	    /*
	     * Function for logging User Timing event on initial interaction
	     */
	
	    sendUserTiming = function (timingValue) {
	
	      if (googleTagManager) {
	
	        dataLayer.push({'event':'RivetedTiming', 'eventCategory':'Riveted', 'timingVar': 'First Interaction', 'timingValue': timingValue});
	
	      } else {
	
	        if (universalGA) {
	          window[gaGlobal](universalSendCommand, 'timing', 'Riveted', 'First Interaction', timingValue);
	        }
	
	        if (classicGA) {
	          _gaq.push(['_trackTiming', 'Riveted', 'First Interaction', timingValue, null, 100]);
	        }
	
	      }
	
	    };
	
	    /*
	     * Function for logging ping events
	     */
	
	    sendEvent = function (time) {
	
	      if (googleTagManager) {
	
	        dataLayer.push({'event':'Riveted', 'eventCategory':'Riveted', 'eventAction': 'Time Spent', 'eventLabel': time, 'eventValue': reportInterval, 'eventNonInteraction': nonInteraction});
	
	      } else {
	
	        if (universalGA) {
	          window[gaGlobal](universalSendCommand, 'event', 'Riveted', 'Time Spent', time.toString(), reportInterval, {'nonInteraction': nonInteraction});
	        }
	
	        if (classicGA) {
	          _gaq.push(['_trackEvent', 'Riveted', 'Time Spent', time.toString(), reportInterval, nonInteraction]);
	        }
	
	      }
	
	    };
	
	    function setIdle() {
	      clearTimeout(idleTimer);
	      stopClock();
	    }
	
	    function visibilityChange() {
	      if (document.hidden || document.webkitHidden) {
	        setIdle();
	      }
	    }
	
	    function clock() {
	      clockTime += 1;
	      if (clockTime > 0 && (clockTime % reportInterval === 0)) {
	        sendEvent(clockTime);
	      }
	
	    }
	
	    function stopClock() {
	      stopped = true;
	      clearInterval(clockTimer);
	    }
	
	    function turnOff() {
	      setIdle();
	      turnedOff = true;
	    }
	
	    function turnOn() {
	      turnedOff = false;
	    }
	
	    function restartClock() {
	      stopped = false;
	      clearInterval(clockTimer);
	      clockTimer = setInterval(clock, 1000);
	    }
	
	    function startRiveted() {
	
	      // Calculate seconds from start to first interaction
	      var currentTime = new Date();
	      var diff = currentTime - startTime;
	
	      // Set global
	      started = true;
	
	      // Send User Timing Event
	      sendUserTiming(diff);
	
	      // Start clock
	      clockTimer = setInterval(clock, 1000);
	
	    }
	
	    function resetRiveted() {
	      startTime = new Date();
	      clockTime = 0;
	      started = false;
	      stopped = false;
	      clearInterval(clockTimer);
	      clearTimeout(idleTimer);
	    }
	
	    function trigger() {
	
	      if (turnedOff) {
	        return;
	      }
	
	      if (!started) {
	        startRiveted();
	      }
	
	      if (stopped) {
	        restartClock();
	      }
	
	      clearTimeout(idleTimer);
	      idleTimer = setTimeout(setIdle, idleTimeout * 1000 + 100);
	    }
	
	    return {
	      init: init,
	      trigger: trigger,
	      setIdle: setIdle,
	      on: turnOn,
	      off: turnOff,
	      reset: resetRiveted
	    };
	
	  })();
	
	  return riveted;
	
	}));


/***/ }),
/* 107 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function($) {'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.showSiteOverlay = showSiteOverlay;
	exports.hideSiteOverlay = hideSiteOverlay;
	/* * * * * * * * * * * * * * * * * * * * * * * * * * * * * *
	
	Toggles the .site-overlay visibility
	
	This feature can be used in 2 ways:
	
	1. Calling the custom event from another script.
	2. Defining a custom toggle settings the 'data-trigger-site-overlay' attribute.
	
	Per default, a click on the .site-overlay doesn't to anything.
	
	If you want to enable the 'click close', pass the parameter 'false'
	to the function, or add an additional 'data-site-overlay-click-close'
	attribute to the custom toggle.
	
	Usage:
	
	// default: click close disabled
	$(window).trigger('showSiteOverlay');
	// click close ENABLED
	$(window).trigger('showSiteOverlay', [true]);
	
	*/
	
	function showSiteOverlay(click_close_enabled) {
	    // init
	    var $site_overlay = $('.site-overlay');
	    // helper class in case we need to modify any other elements if the site-overlay is visible
	    $('html').addClass('site-overlay-visible');
	    // make overlay visible
	    $site_overlay.addClass('visible');
	    // enable click close
	    if (click_close_enabled) {
	        $site_overlay.addClass('click-close-enabled');
	    }
	}
	
	function hideSiteOverlay() {
	    // init
	    var $site_overlay = $('.site-overlay');
	    // helper class in case we need to modify any other elements if the site-overlay is visible
	    $('html').removeClass('site-overlay-visible');
	    // remove classes
	    $site_overlay.removeClass('visible');
	    $site_overlay.removeClass('click-close-enabled');
	}
	
	$(function () {
	
	    // find site overlay triggers
	    if (document.querySelectorAll('[data-trigger-site-overlay]')) {
	        var site_overlay_trigger_elements = document.querySelectorAll('[data-trigger-site-overlay]');
	        for (var i = 0; i < site_overlay_trigger_elements.length; i++) {
	            site_overlay_trigger_elements[i].addEventListener('click', function (event) {
	                // in some cases, we might NOT want that an overlay can be closed by clicking on it. in this case an additional data attribute has to be set
	                var click_close_enabled = false;
	                if (this.hasAttribute('data-site-overlay-click-close')) {
	                    click_close_enabled = true;
	                }
	                showSiteOverlay(click_close_disabled);
	            });
	        }
	    }
	
	    $('.site-overlay').on('click', function () {
	        if ($(this).hasClass('click-close-enabled')) {
	            hideSiteOverlay();
	        }
	    });
	
	    // custom events
	    $(window).on('showSiteOverlay', function (event) {
	        var click_close_enabled = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
	
	        showSiteOverlay(click_close_enabled);
	    });
	    $(window).on('hideSiteOverlay', function () {
	        hideSiteOverlay();
	    });
	});
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(2)))

/***/ }),
/* 108 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function($) {'use strict';
	
	var _softpage = __webpack_require__(109);
	
	var _softpage2 = _interopRequireDefault(_softpage);
	
	var _helperFunctions = __webpack_require__(82);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/* * * * * * * * * * * * * * * * * * * * * * * * * * * * * *
	
	The SoftPage AJAX Trigger
	
	All child anchor-tags (<a>) of an element with a 'data-trigger-softpage' attribute
	will toggle a softpage.
	
	This feature can optionally be activated in an 'App Content Plugin' in the 'Display Options'.
	
	In some cases, not all links within a section should trigger a softpage. That's why
	we added the 'data-softpage-disabled' attribute for those links.
	
	Default (loading a links href-attribute:
	
	<div class"example-container" data-trigger-softpage>
	    <a href="/link-to-page">I will trigger a softpage</a>
	    <a href="/link-to-page" data-softpage-disabled>I will NOT trigger a softpage</a>
	</div>
	
	Optional (loading content of a specific element):
	
	<a href="/link-to-page" data-trigger-softpage data-softpage-content-id="example-element">I will trigger a softpage</a>
	
	<div id="example-element">
	    ...
	        <h1>Anything in here will be displayed in the Softpage</h1>
	    ...
	</div>
	
	Custom Events:
	
	softpage:opened
	softpage:closed
	
	Event Listeners:
	
	initSoftpageTrigger
	closeSoftpage
	
	*/
	
	$(function () {
	
	    var softpage = new _softpage2.default({
	        onPageLoaded: function onPageLoaded(obj) {
	            // scroll to top everytime a softpage is opened
	            obj.modal.modal.querySelector('.tingle-modal-box').scrollTop = 0;
	            // do stuff slighty delayed, so we get all the information we need
	            setTimeout(function () {
	                // init page meta
	                var modal_url = obj.modal.modal.baseURI;
	                var modal_page_title_element = obj.modal.modalBoxContent.querySelector('#softpage-page-title');
	                var modal_page_title = '';
	                // Info for developer, that #softpage-page-title is missing on the detail page
	                if (modal_page_title_element != null) {
	                    var modal_page_title = modal_page_title_element.textContent;
	                } else {}
	                // used during development phase, but no need anymore
	                // console.warn('Softpage is missing #softpage-page-title.');
	
	                // Google Tag Manager
	                if (typeof dataLayer !== 'undefined') {
	                    dataLayer.push({
	                        'event': 'VirtualPageview',
	                        'virtualPageURL': modal_url,
	                        'virtualPageTitle': modal_page_title
	                    });
	                }
	                // trigger custom events
	                $(window).trigger('softpage:opened');
	                $(window).trigger('initSoftpageTrigger');
	                $(window).trigger('initOnScreen');
	                $(window).trigger('initiSwiperInstances');
	            }, 50);
	        },
	        onSoftpageClosed: function onSoftpageClosed(obj) {
	            // hide site overlay
	            $(window).trigger('hideSiteOverlay');
	            $(window).trigger('softpage:closed');
	            // remove variation definition
	            $(obj.modal.modal).removeAttr('data-softpage-variation');
	            // remove any content (issue: video was still playing)
	            $(obj.modal.modal).find('.tingle-modal-box__content').empty();
	        },
	        onBeforeClose: function onBeforeClose() {
	            // prevent closing of the softpage as long as..
	            // 1. the form modal is opened
	            if ($('.tingle-modal.form-modal').hasClass('tingle-modal--visible')) {
	                return false;
	            }
	            // 2. the swiper fullscreen gallery is visible
	            else if ($('html').hasClass('swiper-fullscreen-visible')) {
	                    return false;
	                }
	                // default
	                else {
	                        return true;
	                    }
	        }
	    });
	
	    function initSoftpageTrigger() {
	        // init all softpage trigger links and loop
	        // 1. Text Editor > All links that should trigger a softpage (added by e.g. button link plugin)
	        // 2. App Content > If the Softpage option is enabled.
	        $('a[data-trigger-softpage]:not([data-softpage-disabled]), [data-trigger-softpage] a:not([data-softpage-disabled])').each(function (i) {
	            // stop multiple event listeners on the same element by adding an initialized attribute that we can check the next time we call this function
	            // init
	            var $trigger = $(this);
	            var initialized_attr = 'data-trigger-initialized';
	            // check for initialized trigger
	            var trigger_initialized = $trigger.attr(initialized_attr);
	            // NOT initialized yet
	            if (typeof trigger_initialized === 'undefined') {
	                // add event listener
	                $trigger.on('click', function (event) {
	                    // init
	                    var $trigger = $(this);
	                    var $softpage = $('.tingle-modal.softpage');
	                    var softpage_content_id = '';
	                    var href = event.currentTarget.href;
	                    // optional: use a node's content instead of href-attribute
	                    var softpage_content_id = $trigger.attr('data-softpage-content-id');
	                    // optional: get softpage variation string and set attribute
	                    var softpage_variation = $trigger.attr('data-softpage-variation');
	                    if (softpage_variation) {
	                        $softpage.attr('data-softpage-variation', softpage_variation);
	                    }
	                    // optional: we are about to display a CMS page within the softpage
	                    var softpage_cms_page = $trigger.attr('data-cms-page');
	                    if (typeof softpage_cms_page !== 'undefined' && softpage_cms_page !== false) {
	                        $softpage.attr('data-cms-page', '');
	                    }
	                    // otherwise, make sure the attribute is removed
	                    else {
	                            $softpage.removeAttr('data-cms-page');
	                        }
	                    // special case: prevent softpage reload in case of a menu that has been toggled already and is about to be closed
	                    var softpage_already_toggled = $trigger.attr('data-softpage-toggled');
	                    if (typeof softpage_already_toggled !== 'undefined' && softpage_already_toggled !== false) {
	                        return true;
	                    }
	                    // instantly toggle site overlay (improves "felt performance")
	                    $(window).trigger('showSiteOverlay');
	                    // load softpage
	                    event.preventDefault();
	                    softpage.loadPage(href, true, softpage_content_id);
	                    // fixes bug in firefox: softpage text was selected - let's remove any selection
	                    document.getSelection().removeAllRanges();
	                });
	                // mark as initialized
	                $trigger.attr(initialized_attr, '');
	            }
	        });
	    }
	
	    function closeSoftpage() {
	        softpage.closeSoftpage();
	    }
	
	    // on page load
	    initSoftpageTrigger();
	
	    // custom events
	    $(window).on('initSoftpageTrigger', function () {
	        initSoftpageTrigger();
	    });
	    $(window).on('closeSoftpage', function () {
	        closeSoftpage();
	    });
	
	    // clean up content when a CMS page is about to be displayed within a softpage
	    $(window).on('softpage:opened', function () {
	        // init
	        var $softpage = $('.softpage');
	        // check if CMS page attribute is set
	        var $softpage_content_container = $softpage.find('.tingle-modal-box__content');
	        var is_cms_page = $softpage.attr('data-cms-page');
	        if (typeof is_cms_page !== 'undefined' && is_cms_page !== false) {
	            // select/store the content we want to put inside the modal box content
	            var $ajax_page_container = $softpage.find('.site-content').children();
	            // empty the box content and append the just stored markup
	            $softpage_content_container.empty().append($ajax_page_container);
	        }
	    });
	});
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(2)))

/***/ }),
/* 109 */
/***/ (function(module, exports, __webpack_require__) {

	(function webpackUniversalModuleDefinition(root, factory) {
		if(true)
			module.exports = factory(__webpack_require__(71), __webpack_require__(110));
		else if(typeof define === 'function' && define.amd)
			define(["tingle.js", "superagent"], factory);
		else if(typeof exports === 'object')
			exports["SoftPage"] = factory(require("tingle.js"), require("superagent"));
		else
			root["SoftPage"] = factory(root["tingle.js"], root["superagent"]);
	})(this, function(__WEBPACK_EXTERNAL_MODULE_1__, __WEBPACK_EXTERNAL_MODULE_2__) {
	return /******/ (function(modules) { // webpackBootstrap
	/******/ 	// The module cache
	/******/ 	var installedModules = {};
	
	/******/ 	// The require function
	/******/ 	function __webpack_require__(moduleId) {
	
	/******/ 		// Check if module is in cache
	/******/ 		if(installedModules[moduleId])
	/******/ 			return installedModules[moduleId].exports;
	
	/******/ 		// Create a new module (and put it into the cache)
	/******/ 		var module = installedModules[moduleId] = {
	/******/ 			exports: {},
	/******/ 			id: moduleId,
	/******/ 			loaded: false
	/******/ 		};
	
	/******/ 		// Execute the module function
	/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
	
	/******/ 		// Flag the module as loaded
	/******/ 		module.loaded = true;
	
	/******/ 		// Return the exports of the module
	/******/ 		return module.exports;
	/******/ 	}
	
	
	/******/ 	// expose the modules object (__webpack_modules__)
	/******/ 	__webpack_require__.m = modules;
	
	/******/ 	// expose the module cache
	/******/ 	__webpack_require__.c = installedModules;
	
	/******/ 	// __webpack_public_path__
	/******/ 	__webpack_require__.p = "";
	
	/******/ 	// Load entry module and return exports
	/******/ 	return __webpack_require__(0);
	/******/ })
	/************************************************************************/
	/******/ ([
	/* 0 */
	/***/ (function(module, exports, __webpack_require__) {
	
		'use strict';
	
		Object.defineProperty(exports, "__esModule", {
		    value: true
		});
	
		var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
		var _tingle = __webpack_require__(1);
	
		var _tingle2 = _interopRequireDefault(_tingle);
	
		var _superagent = __webpack_require__(2);
	
		var _superagent2 = _interopRequireDefault(_superagent);
	
		function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
		function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
		var SoftPage = function () {
		    function SoftPage(options) {
		        _classCallCheck(this, SoftPage);
	
		        this.options = options || {};
		        this.base_url = window.location.href;
		        this.init();
		    }
	
		    _createClass(SoftPage, [{
		        key: 'init',
		        value: function init() {
		            var base_url = this.base_url;
		            var self = this;
		            this.modal = new _tingle2.default.modal({
		                cssClass: ['softpage'],
		                onClose: function onClose() {
		                    history.pushState({}, '', base_url);
		                    if (self.options.onSoftpageClosed) {
		                        self.options.onSoftpageClosed(self);
		                    }
		                },
		                beforeClose: function beforeClose() {
		                    if (self.options.onBeforeClose) {
		                        return self.options.onBeforeClose(self);
		                    }
		                }
		            });
	
		            // in case of browser history is changing
		            window.onpopstate = function (event) {
		                if (window.location.href !== base_url && event.state !== null) {
		                    // when changing to another page
		                    window.location.reload(); // after history change, reload to load server-side page
		                }
		                if (event.state && event.state.is_soft_page) {
		                    this.loadPage(window.location);
		                } else if (this.modal) {
		                    this.modal.close();
		                }
		            }.bind(this);
		        }
		    }, {
		        key: 'closeSoftpage',
		        value: function closeSoftpage() {
		            this.modal.close();
		        }
		    }, {
		        key: 'loadPage',
		        value: function loadPage(href, pushstate, softpage_content_id) {
		            var _this = this;
	
		            // init
		            var modal_content = this.modal.modal.querySelector('.tingle-modal-box__content');
		            // option 1: load content of element with ID
		            if (softpage_content_id && softpage_content_id.length > 0) {
		                var softpage_content_markup = document.getElementById(softpage_content_id).innerHTML;
		                this.modal.open();
		                this.modal.setContent(softpage_content_markup);
		                this.modal.modal.querySelector('.tingle-modal-box').scrollTop = 0;
		                // let us know that everything's alright
		                if (this.options.onPageLoaded) {
		                    this.options.onPageLoaded(this);
		                }
		            }
		            // otherwise, do it the regular way
		            else {
		                    _superagent2.default.get(href).set('X-Requested-With', 'XMLHttpRequest').end(function (error, result) {
		                        _this.modal.open();
		                        _this.modal.setContent(result.text);
		                        if (_this.options.onPageLoaded) {
		                            _this.options.onPageLoaded(_this);
		                        }
		                        if (pushstate) {
		                            history.pushState({ is_soft_page: true }, '', href);
		                        }
		                    });
		                }
		        }
		    }]);
	
		    return SoftPage;
		}();
	
		exports.default = SoftPage;
		module.exports = exports['default'];
	
	/***/ }),
	/* 1 */
	/***/ (function(module, exports) {
	
		module.exports = __WEBPACK_EXTERNAL_MODULE_1__;
	
	/***/ }),
	/* 2 */
	/***/ (function(module, exports) {
	
		module.exports = __WEBPACK_EXTERNAL_MODULE_2__;
	
	/***/ })
	/******/ ])
	});
	;

/***/ }),
/* 110 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Root reference for iframes.
	 */
	
	var root;
	if (typeof window !== 'undefined') { // Browser window
	  root = window;
	} else if (typeof self !== 'undefined') { // Web Worker
	  root = self;
	} else { // Other environments
	  console.warn("Using browser-only version of superagent in non-browser environment");
	  root = this;
	}
	
	var Emitter = __webpack_require__(111);
	var requestBase = __webpack_require__(112);
	var isObject = __webpack_require__(113);
	
	/**
	 * Noop.
	 */
	
	function noop(){};
	
	/**
	 * Expose `request`.
	 */
	
	var request = module.exports = __webpack_require__(114).bind(null, Request);
	
	/**
	 * Determine XHR.
	 */
	
	request.getXHR = function () {
	  if (root.XMLHttpRequest
	      && (!root.location || 'file:' != root.location.protocol
	          || !root.ActiveXObject)) {
	    return new XMLHttpRequest;
	  } else {
	    try { return new ActiveXObject('Microsoft.XMLHTTP'); } catch(e) {}
	    try { return new ActiveXObject('Msxml2.XMLHTTP.6.0'); } catch(e) {}
	    try { return new ActiveXObject('Msxml2.XMLHTTP.3.0'); } catch(e) {}
	    try { return new ActiveXObject('Msxml2.XMLHTTP'); } catch(e) {}
	  }
	  throw Error("Browser-only verison of superagent could not find XHR");
	};
	
	/**
	 * Removes leading and trailing whitespace, added to support IE.
	 *
	 * @param {String} s
	 * @return {String}
	 * @api private
	 */
	
	var trim = ''.trim
	  ? function(s) { return s.trim(); }
	  : function(s) { return s.replace(/(^\s*|\s*$)/g, ''); };
	
	/**
	 * Serialize the given `obj`.
	 *
	 * @param {Object} obj
	 * @return {String}
	 * @api private
	 */
	
	function serialize(obj) {
	  if (!isObject(obj)) return obj;
	  var pairs = [];
	  for (var key in obj) {
	    pushEncodedKeyValuePair(pairs, key, obj[key]);
	  }
	  return pairs.join('&');
	}
	
	/**
	 * Helps 'serialize' with serializing arrays.
	 * Mutates the pairs array.
	 *
	 * @param {Array} pairs
	 * @param {String} key
	 * @param {Mixed} val
	 */
	
	function pushEncodedKeyValuePair(pairs, key, val) {
	  if (val != null) {
	    if (Array.isArray(val)) {
	      val.forEach(function(v) {
	        pushEncodedKeyValuePair(pairs, key, v);
	      });
	    } else if (isObject(val)) {
	      for(var subkey in val) {
	        pushEncodedKeyValuePair(pairs, key + '[' + subkey + ']', val[subkey]);
	      }
	    } else {
	      pairs.push(encodeURIComponent(key)
	        + '=' + encodeURIComponent(val));
	    }
	  } else if (val === null) {
	    pairs.push(encodeURIComponent(key));
	  }
	}
	
	/**
	 * Expose serialization method.
	 */
	
	 request.serializeObject = serialize;
	
	 /**
	  * Parse the given x-www-form-urlencoded `str`.
	  *
	  * @param {String} str
	  * @return {Object}
	  * @api private
	  */
	
	function parseString(str) {
	  var obj = {};
	  var pairs = str.split('&');
	  var pair;
	  var pos;
	
	  for (var i = 0, len = pairs.length; i < len; ++i) {
	    pair = pairs[i];
	    pos = pair.indexOf('=');
	    if (pos == -1) {
	      obj[decodeURIComponent(pair)] = '';
	    } else {
	      obj[decodeURIComponent(pair.slice(0, pos))] =
	        decodeURIComponent(pair.slice(pos + 1));
	    }
	  }
	
	  return obj;
	}
	
	/**
	 * Expose parser.
	 */
	
	request.parseString = parseString;
	
	/**
	 * Default MIME type map.
	 *
	 *     superagent.types.xml = 'application/xml';
	 *
	 */
	
	request.types = {
	  html: 'text/html',
	  json: 'application/json',
	  xml: 'application/xml',
	  urlencoded: 'application/x-www-form-urlencoded',
	  'form': 'application/x-www-form-urlencoded',
	  'form-data': 'application/x-www-form-urlencoded'
	};
	
	/**
	 * Default serialization map.
	 *
	 *     superagent.serialize['application/xml'] = function(obj){
	 *       return 'generated xml here';
	 *     };
	 *
	 */
	
	 request.serialize = {
	   'application/x-www-form-urlencoded': serialize,
	   'application/json': JSON.stringify
	 };
	
	 /**
	  * Default parsers.
	  *
	  *     superagent.parse['application/xml'] = function(str){
	  *       return { object parsed from str };
	  *     };
	  *
	  */
	
	request.parse = {
	  'application/x-www-form-urlencoded': parseString,
	  'application/json': JSON.parse
	};
	
	/**
	 * Parse the given header `str` into
	 * an object containing the mapped fields.
	 *
	 * @param {String} str
	 * @return {Object}
	 * @api private
	 */
	
	function parseHeader(str) {
	  var lines = str.split(/\r?\n/);
	  var fields = {};
	  var index;
	  var line;
	  var field;
	  var val;
	
	  lines.pop(); // trailing CRLF
	
	  for (var i = 0, len = lines.length; i < len; ++i) {
	    line = lines[i];
	    index = line.indexOf(':');
	    field = line.slice(0, index).toLowerCase();
	    val = trim(line.slice(index + 1));
	    fields[field] = val;
	  }
	
	  return fields;
	}
	
	/**
	 * Check if `mime` is json or has +json structured syntax suffix.
	 *
	 * @param {String} mime
	 * @return {Boolean}
	 * @api private
	 */
	
	function isJSON(mime) {
	  return /[\/+]json\b/.test(mime);
	}
	
	/**
	 * Return the mime type for the given `str`.
	 *
	 * @param {String} str
	 * @return {String}
	 * @api private
	 */
	
	function type(str){
	  return str.split(/ *; */).shift();
	};
	
	/**
	 * Return header field parameters.
	 *
	 * @param {String} str
	 * @return {Object}
	 * @api private
	 */
	
	function params(str){
	  return str.split(/ *; */).reduce(function(obj, str){
	    var parts = str.split(/ *= */),
	        key = parts.shift(),
	        val = parts.shift();
	
	    if (key && val) obj[key] = val;
	    return obj;
	  }, {});
	};
	
	/**
	 * Initialize a new `Response` with the given `xhr`.
	 *
	 *  - set flags (.ok, .error, etc)
	 *  - parse header
	 *
	 * Examples:
	 *
	 *  Aliasing `superagent` as `request` is nice:
	 *
	 *      request = superagent;
	 *
	 *  We can use the promise-like API, or pass callbacks:
	 *
	 *      request.get('/').end(function(res){});
	 *      request.get('/', function(res){});
	 *
	 *  Sending data can be chained:
	 *
	 *      request
	 *        .post('/user')
	 *        .send({ name: 'tj' })
	 *        .end(function(res){});
	 *
	 *  Or passed to `.send()`:
	 *
	 *      request
	 *        .post('/user')
	 *        .send({ name: 'tj' }, function(res){});
	 *
	 *  Or passed to `.post()`:
	 *
	 *      request
	 *        .post('/user', { name: 'tj' })
	 *        .end(function(res){});
	 *
	 * Or further reduced to a single call for simple cases:
	 *
	 *      request
	 *        .post('/user', { name: 'tj' }, function(res){});
	 *
	 * @param {XMLHTTPRequest} xhr
	 * @param {Object} options
	 * @api private
	 */
	
	function Response(req, options) {
	  options = options || {};
	  this.req = req;
	  this.xhr = this.req.xhr;
	  // responseText is accessible only if responseType is '' or 'text' and on older browsers
	  this.text = ((this.req.method !='HEAD' && (this.xhr.responseType === '' || this.xhr.responseType === 'text')) || typeof this.xhr.responseType === 'undefined')
	     ? this.xhr.responseText
	     : null;
	  this.statusText = this.req.xhr.statusText;
	  this._setStatusProperties(this.xhr.status);
	  this.header = this.headers = parseHeader(this.xhr.getAllResponseHeaders());
	  // getAllResponseHeaders sometimes falsely returns "" for CORS requests, but
	  // getResponseHeader still works. so we get content-type even if getting
	  // other headers fails.
	  this.header['content-type'] = this.xhr.getResponseHeader('content-type');
	  this._setHeaderProperties(this.header);
	  this.body = this.req.method != 'HEAD'
	    ? this._parseBody(this.text ? this.text : this.xhr.response)
	    : null;
	}
	
	/**
	 * Get case-insensitive `field` value.
	 *
	 * @param {String} field
	 * @return {String}
	 * @api public
	 */
	
	Response.prototype.get = function(field){
	  return this.header[field.toLowerCase()];
	};
	
	/**
	 * Set header related properties:
	 *
	 *   - `.type` the content type without params
	 *
	 * A response of "Content-Type: text/plain; charset=utf-8"
	 * will provide you with a `.type` of "text/plain".
	 *
	 * @param {Object} header
	 * @api private
	 */
	
	Response.prototype._setHeaderProperties = function(header){
	  // content-type
	  var ct = this.header['content-type'] || '';
	  this.type = type(ct);
	
	  // params
	  var obj = params(ct);
	  for (var key in obj) this[key] = obj[key];
	};
	
	/**
	 * Parse the given body `str`.
	 *
	 * Used for auto-parsing of bodies. Parsers
	 * are defined on the `superagent.parse` object.
	 *
	 * @param {String} str
	 * @return {Mixed}
	 * @api private
	 */
	
	Response.prototype._parseBody = function(str){
	  var parse = request.parse[this.type];
	  if (!parse && isJSON(this.type)) {
	    parse = request.parse['application/json'];
	  }
	  return parse && str && (str.length || str instanceof Object)
	    ? parse(str)
	    : null;
	};
	
	/**
	 * Set flags such as `.ok` based on `status`.
	 *
	 * For example a 2xx response will give you a `.ok` of __true__
	 * whereas 5xx will be __false__ and `.error` will be __true__. The
	 * `.clientError` and `.serverError` are also available to be more
	 * specific, and `.statusType` is the class of error ranging from 1..5
	 * sometimes useful for mapping respond colors etc.
	 *
	 * "sugar" properties are also defined for common cases. Currently providing:
	 *
	 *   - .noContent
	 *   - .badRequest
	 *   - .unauthorized
	 *   - .notAcceptable
	 *   - .notFound
	 *
	 * @param {Number} status
	 * @api private
	 */
	
	Response.prototype._setStatusProperties = function(status){
	  // handle IE9 bug: http://stackoverflow.com/questions/10046972/msie-returns-status-code-of-1223-for-ajax-request
	  if (status === 1223) {
	    status = 204;
	  }
	
	  var type = status / 100 | 0;
	
	  // status / class
	  this.status = this.statusCode = status;
	  this.statusType = type;
	
	  // basics
	  this.info = 1 == type;
	  this.ok = 2 == type;
	  this.clientError = 4 == type;
	  this.serverError = 5 == type;
	  this.error = (4 == type || 5 == type)
	    ? this.toError()
	    : false;
	
	  // sugar
	  this.accepted = 202 == status;
	  this.noContent = 204 == status;
	  this.badRequest = 400 == status;
	  this.unauthorized = 401 == status;
	  this.notAcceptable = 406 == status;
	  this.notFound = 404 == status;
	  this.forbidden = 403 == status;
	};
	
	/**
	 * Return an `Error` representative of this response.
	 *
	 * @return {Error}
	 * @api public
	 */
	
	Response.prototype.toError = function(){
	  var req = this.req;
	  var method = req.method;
	  var url = req.url;
	
	  var msg = 'cannot ' + method + ' ' + url + ' (' + this.status + ')';
	  var err = new Error(msg);
	  err.status = this.status;
	  err.method = method;
	  err.url = url;
	
	  return err;
	};
	
	/**
	 * Expose `Response`.
	 */
	
	request.Response = Response;
	
	/**
	 * Initialize a new `Request` with the given `method` and `url`.
	 *
	 * @param {String} method
	 * @param {String} url
	 * @api public
	 */
	
	function Request(method, url) {
	  var self = this;
	  this._query = this._query || [];
	  this.method = method;
	  this.url = url;
	  this.header = {}; // preserves header name case
	  this._header = {}; // coerces header names to lowercase
	  this.on('end', function(){
	    var err = null;
	    var res = null;
	
	    try {
	      res = new Response(self);
	    } catch(e) {
	      err = new Error('Parser is unable to parse the response');
	      err.parse = true;
	      err.original = e;
	      // issue #675: return the raw response if the response parsing fails
	      err.rawResponse = self.xhr && self.xhr.responseText ? self.xhr.responseText : null;
	      // issue #876: return the http status code if the response parsing fails
	      err.statusCode = self.xhr && self.xhr.status ? self.xhr.status : null;
	      return self.callback(err);
	    }
	
	    self.emit('response', res);
	
	    var new_err;
	    try {
	      if (res.status < 200 || res.status >= 300) {
	        new_err = new Error(res.statusText || 'Unsuccessful HTTP response');
	        new_err.original = err;
	        new_err.response = res;
	        new_err.status = res.status;
	      }
	    } catch(e) {
	      new_err = e; // #985 touching res may cause INVALID_STATE_ERR on old Android
	    }
	
	    // #1000 don't catch errors from the callback to avoid double calling it
	    if (new_err) {
	      self.callback(new_err, res);
	    } else {
	      self.callback(null, res);
	    }
	  });
	}
	
	/**
	 * Mixin `Emitter` and `requestBase`.
	 */
	
	Emitter(Request.prototype);
	for (var key in requestBase) {
	  Request.prototype[key] = requestBase[key];
	}
	
	/**
	 * Set Content-Type to `type`, mapping values from `request.types`.
	 *
	 * Examples:
	 *
	 *      superagent.types.xml = 'application/xml';
	 *
	 *      request.post('/')
	 *        .type('xml')
	 *        .send(xmlstring)
	 *        .end(callback);
	 *
	 *      request.post('/')
	 *        .type('application/xml')
	 *        .send(xmlstring)
	 *        .end(callback);
	 *
	 * @param {String} type
	 * @return {Request} for chaining
	 * @api public
	 */
	
	Request.prototype.type = function(type){
	  this.set('Content-Type', request.types[type] || type);
	  return this;
	};
	
	/**
	 * Set responseType to `val`. Presently valid responseTypes are 'blob' and
	 * 'arraybuffer'.
	 *
	 * Examples:
	 *
	 *      req.get('/')
	 *        .responseType('blob')
	 *        .end(callback);
	 *
	 * @param {String} val
	 * @return {Request} for chaining
	 * @api public
	 */
	
	Request.prototype.responseType = function(val){
	  this._responseType = val;
	  return this;
	};
	
	/**
	 * Set Accept to `type`, mapping values from `request.types`.
	 *
	 * Examples:
	 *
	 *      superagent.types.json = 'application/json';
	 *
	 *      request.get('/agent')
	 *        .accept('json')
	 *        .end(callback);
	 *
	 *      request.get('/agent')
	 *        .accept('application/json')
	 *        .end(callback);
	 *
	 * @param {String} accept
	 * @return {Request} for chaining
	 * @api public
	 */
	
	Request.prototype.accept = function(type){
	  this.set('Accept', request.types[type] || type);
	  return this;
	};
	
	/**
	 * Set Authorization field value with `user` and `pass`.
	 *
	 * @param {String} user
	 * @param {String} pass
	 * @param {Object} options with 'type' property 'auto' or 'basic' (default 'basic')
	 * @return {Request} for chaining
	 * @api public
	 */
	
	Request.prototype.auth = function(user, pass, options){
	  if (!options) {
	    options = {
	      type: 'basic'
	    }
	  }
	
	  switch (options.type) {
	    case 'basic':
	      var str = btoa(user + ':' + pass);
	      this.set('Authorization', 'Basic ' + str);
	    break;
	
	    case 'auto':
	      this.username = user;
	      this.password = pass;
	    break;
	  }
	  return this;
	};
	
	/**
	* Add query-string `val`.
	*
	* Examples:
	*
	*   request.get('/shoes')
	*     .query('size=10')
	*     .query({ color: 'blue' })
	*
	* @param {Object|String} val
	* @return {Request} for chaining
	* @api public
	*/
	
	Request.prototype.query = function(val){
	  if ('string' != typeof val) val = serialize(val);
	  if (val) this._query.push(val);
	  return this;
	};
	
	/**
	 * Queue the given `file` as an attachment to the specified `field`,
	 * with optional `filename`.
	 *
	 * ``` js
	 * request.post('/upload')
	 *   .attach('content', new Blob(['<a id="a"><b id="b">hey!</b></a>'], { type: "text/html"}))
	 *   .end(callback);
	 * ```
	 *
	 * @param {String} field
	 * @param {Blob|File} file
	 * @param {String} filename
	 * @return {Request} for chaining
	 * @api public
	 */
	
	Request.prototype.attach = function(field, file, filename){
	  this._getFormData().append(field, file, filename || file.name);
	  return this;
	};
	
	Request.prototype._getFormData = function(){
	  if (!this._formData) {
	    this._formData = new root.FormData();
	  }
	  return this._formData;
	};
	
	/**
	 * Invoke the callback with `err` and `res`
	 * and handle arity check.
	 *
	 * @param {Error} err
	 * @param {Response} res
	 * @api private
	 */
	
	Request.prototype.callback = function(err, res){
	  var fn = this._callback;
	  this.clearTimeout();
	  fn(err, res);
	};
	
	/**
	 * Invoke callback with x-domain error.
	 *
	 * @api private
	 */
	
	Request.prototype.crossDomainError = function(){
	  var err = new Error('Request has been terminated\nPossible causes: the network is offline, Origin is not allowed by Access-Control-Allow-Origin, the page is being unloaded, etc.');
	  err.crossDomain = true;
	
	  err.status = this.status;
	  err.method = this.method;
	  err.url = this.url;
	
	  this.callback(err);
	};
	
	/**
	 * Invoke callback with timeout error.
	 *
	 * @api private
	 */
	
	Request.prototype._timeoutError = function(){
	  var timeout = this._timeout;
	  var err = new Error('timeout of ' + timeout + 'ms exceeded');
	  err.timeout = timeout;
	  this.callback(err);
	};
	
	/**
	 * Compose querystring to append to req.url
	 *
	 * @api private
	 */
	
	Request.prototype._appendQueryString = function(){
	  var query = this._query.join('&');
	  if (query) {
	    this.url += ~this.url.indexOf('?')
	      ? '&' + query
	      : '?' + query;
	  }
	};
	
	/**
	 * Initiate request, invoking callback `fn(res)`
	 * with an instanceof `Response`.
	 *
	 * @param {Function} fn
	 * @return {Request} for chaining
	 * @api public
	 */
	
	Request.prototype.end = function(fn){
	  var self = this;
	  var xhr = this.xhr = request.getXHR();
	  var timeout = this._timeout;
	  var data = this._formData || this._data;
	
	  // store callback
	  this._callback = fn || noop;
	
	  // state change
	  xhr.onreadystatechange = function(){
	    if (4 != xhr.readyState) return;
	
	    // In IE9, reads to any property (e.g. status) off of an aborted XHR will
	    // result in the error "Could not complete the operation due to error c00c023f"
	    var status;
	    try { status = xhr.status } catch(e) { status = 0; }
	
	    if (0 == status) {
	      if (self.timedout) return self._timeoutError();
	      if (self._aborted) return;
	      return self.crossDomainError();
	    }
	    self.emit('end');
	  };
	
	  // progress
	  var handleProgress = function(direction, e) {
	    if (e.total > 0) {
	      e.percent = e.loaded / e.total * 100;
	    }
	    e.direction = direction;
	    self.emit('progress', e);
	  }
	  if (this.hasListeners('progress')) {
	    try {
	      xhr.onprogress = handleProgress.bind(null, 'download');
	      if (xhr.upload) {
	        xhr.upload.onprogress = handleProgress.bind(null, 'upload');
	      }
	    } catch(e) {
	      // Accessing xhr.upload fails in IE from a web worker, so just pretend it doesn't exist.
	      // Reported here:
	      // https://connect.microsoft.com/IE/feedback/details/837245/xmlhttprequest-upload-throws-invalid-argument-when-used-from-web-worker-context
	    }
	  }
	
	  // timeout
	  if (timeout && !this._timer) {
	    this._timer = setTimeout(function(){
	      self.timedout = true;
	      self.abort();
	    }, timeout);
	  }
	
	  // querystring
	  this._appendQueryString();
	
	  // initiate request
	  if (this.username && this.password) {
	    xhr.open(this.method, this.url, true, this.username, this.password);
	  } else {
	    xhr.open(this.method, this.url, true);
	  }
	
	  // CORS
	  if (this._withCredentials) xhr.withCredentials = true;
	
	  // body
	  if ('GET' != this.method && 'HEAD' != this.method && 'string' != typeof data && !this._isHost(data)) {
	    // serialize stuff
	    var contentType = this._header['content-type'];
	    var serialize = this._serializer || request.serialize[contentType ? contentType.split(';')[0] : ''];
	    if (!serialize && isJSON(contentType)) serialize = request.serialize['application/json'];
	    if (serialize) data = serialize(data);
	  }
	
	  // set header fields
	  for (var field in this.header) {
	    if (null == this.header[field]) continue;
	    xhr.setRequestHeader(field, this.header[field]);
	  }
	
	  if (this._responseType) {
	    xhr.responseType = this._responseType;
	  }
	
	  // send stuff
	  this.emit('request', this);
	
	  // IE11 xhr.send(undefined) sends 'undefined' string as POST payload (instead of nothing)
	  // We need null here if data is undefined
	  xhr.send(typeof data !== 'undefined' ? data : null);
	  return this;
	};
	
	
	/**
	 * Expose `Request`.
	 */
	
	request.Request = Request;
	
	/**
	 * GET `url` with optional callback `fn(res)`.
	 *
	 * @param {String} url
	 * @param {Mixed|Function} [data] or fn
	 * @param {Function} [fn]
	 * @return {Request}
	 * @api public
	 */
	
	request.get = function(url, data, fn){
	  var req = request('GET', url);
	  if ('function' == typeof data) fn = data, data = null;
	  if (data) req.query(data);
	  if (fn) req.end(fn);
	  return req;
	};
	
	/**
	 * HEAD `url` with optional callback `fn(res)`.
	 *
	 * @param {String} url
	 * @param {Mixed|Function} [data] or fn
	 * @param {Function} [fn]
	 * @return {Request}
	 * @api public
	 */
	
	request.head = function(url, data, fn){
	  var req = request('HEAD', url);
	  if ('function' == typeof data) fn = data, data = null;
	  if (data) req.send(data);
	  if (fn) req.end(fn);
	  return req;
	};
	
	/**
	 * OPTIONS query to `url` with optional callback `fn(res)`.
	 *
	 * @param {String} url
	 * @param {Mixed|Function} [data] or fn
	 * @param {Function} [fn]
	 * @return {Request}
	 * @api public
	 */
	
	request.options = function(url, data, fn){
	  var req = request('OPTIONS', url);
	  if ('function' == typeof data) fn = data, data = null;
	  if (data) req.send(data);
	  if (fn) req.end(fn);
	  return req;
	};
	
	/**
	 * DELETE `url` with optional callback `fn(res)`.
	 *
	 * @param {String} url
	 * @param {Function} [fn]
	 * @return {Request}
	 * @api public
	 */
	
	function del(url, fn){
	  var req = request('DELETE', url);
	  if (fn) req.end(fn);
	  return req;
	};
	
	request['del'] = del;
	request['delete'] = del;
	
	/**
	 * PATCH `url` with optional `data` and callback `fn(res)`.
	 *
	 * @param {String} url
	 * @param {Mixed} [data]
	 * @param {Function} [fn]
	 * @return {Request}
	 * @api public
	 */
	
	request.patch = function(url, data, fn){
	  var req = request('PATCH', url);
	  if ('function' == typeof data) fn = data, data = null;
	  if (data) req.send(data);
	  if (fn) req.end(fn);
	  return req;
	};
	
	/**
	 * POST `url` with optional `data` and callback `fn(res)`.
	 *
	 * @param {String} url
	 * @param {Mixed} [data]
	 * @param {Function} [fn]
	 * @return {Request}
	 * @api public
	 */
	
	request.post = function(url, data, fn){
	  var req = request('POST', url);
	  if ('function' == typeof data) fn = data, data = null;
	  if (data) req.send(data);
	  if (fn) req.end(fn);
	  return req;
	};
	
	/**
	 * PUT `url` with optional `data` and callback `fn(res)`.
	 *
	 * @param {String} url
	 * @param {Mixed|Function} [data] or fn
	 * @param {Function} [fn]
	 * @return {Request}
	 * @api public
	 */
	
	request.put = function(url, data, fn){
	  var req = request('PUT', url);
	  if ('function' == typeof data) fn = data, data = null;
	  if (data) req.send(data);
	  if (fn) req.end(fn);
	  return req;
	};


/***/ }),
/* 111 */
/***/ (function(module, exports, __webpack_require__) {

	
	/**
	 * Expose `Emitter`.
	 */
	
	if (true) {
	  module.exports = Emitter;
	}
	
	/**
	 * Initialize a new `Emitter`.
	 *
	 * @api public
	 */
	
	function Emitter(obj) {
	  if (obj) return mixin(obj);
	};
	
	/**
	 * Mixin the emitter properties.
	 *
	 * @param {Object} obj
	 * @return {Object}
	 * @api private
	 */
	
	function mixin(obj) {
	  for (var key in Emitter.prototype) {
	    obj[key] = Emitter.prototype[key];
	  }
	  return obj;
	}
	
	/**
	 * Listen on the given `event` with `fn`.
	 *
	 * @param {String} event
	 * @param {Function} fn
	 * @return {Emitter}
	 * @api public
	 */
	
	Emitter.prototype.on =
	Emitter.prototype.addEventListener = function(event, fn){
	  this._callbacks = this._callbacks || {};
	  (this._callbacks['$' + event] = this._callbacks['$' + event] || [])
	    .push(fn);
	  return this;
	};
	
	/**
	 * Adds an `event` listener that will be invoked a single
	 * time then automatically removed.
	 *
	 * @param {String} event
	 * @param {Function} fn
	 * @return {Emitter}
	 * @api public
	 */
	
	Emitter.prototype.once = function(event, fn){
	  function on() {
	    this.off(event, on);
	    fn.apply(this, arguments);
	  }
	
	  on.fn = fn;
	  this.on(event, on);
	  return this;
	};
	
	/**
	 * Remove the given callback for `event` or all
	 * registered callbacks.
	 *
	 * @param {String} event
	 * @param {Function} fn
	 * @return {Emitter}
	 * @api public
	 */
	
	Emitter.prototype.off =
	Emitter.prototype.removeListener =
	Emitter.prototype.removeAllListeners =
	Emitter.prototype.removeEventListener = function(event, fn){
	  this._callbacks = this._callbacks || {};
	
	  // all
	  if (0 == arguments.length) {
	    this._callbacks = {};
	    return this;
	  }
	
	  // specific event
	  var callbacks = this._callbacks['$' + event];
	  if (!callbacks) return this;
	
	  // remove all handlers
	  if (1 == arguments.length) {
	    delete this._callbacks['$' + event];
	    return this;
	  }
	
	  // remove specific handler
	  var cb;
	  for (var i = 0; i < callbacks.length; i++) {
	    cb = callbacks[i];
	    if (cb === fn || cb.fn === fn) {
	      callbacks.splice(i, 1);
	      break;
	    }
	  }
	
	  // Remove event specific arrays for event types that no
	  // one is subscribed for to avoid memory leak.
	  if (callbacks.length === 0) {
	    delete this._callbacks['$' + event];
	  }
	
	  return this;
	};
	
	/**
	 * Emit `event` with the given args.
	 *
	 * @param {String} event
	 * @param {Mixed} ...
	 * @return {Emitter}
	 */
	
	Emitter.prototype.emit = function(event){
	  this._callbacks = this._callbacks || {};
	
	  var args = new Array(arguments.length - 1)
	    , callbacks = this._callbacks['$' + event];
	
	  for (var i = 1; i < arguments.length; i++) {
	    args[i - 1] = arguments[i];
	  }
	
	  if (callbacks) {
	    callbacks = callbacks.slice(0);
	    for (var i = 0, len = callbacks.length; i < len; ++i) {
	      callbacks[i].apply(this, args);
	    }
	  }
	
	  return this;
	};
	
	/**
	 * Return array of callbacks for `event`.
	 *
	 * @param {String} event
	 * @return {Array}
	 * @api public
	 */
	
	Emitter.prototype.listeners = function(event){
	  this._callbacks = this._callbacks || {};
	  return this._callbacks['$' + event] || [];
	};
	
	/**
	 * Check if this emitter has `event` handlers.
	 *
	 * @param {String} event
	 * @return {Boolean}
	 * @api public
	 */
	
	Emitter.prototype.hasListeners = function(event){
	  return !! this.listeners(event).length;
	};


/***/ }),
/* 112 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Module of mixed-in functions shared between node and client code
	 */
	var isObject = __webpack_require__(113);
	
	/**
	 * Clear previous timeout.
	 *
	 * @return {Request} for chaining
	 * @api public
	 */
	
	exports.clearTimeout = function _clearTimeout(){
	  this._timeout = 0;
	  clearTimeout(this._timer);
	  return this;
	};
	
	/**
	 * Override default response body parser
	 *
	 * This function will be called to convert incoming data into request.body
	 *
	 * @param {Function}
	 * @api public
	 */
	
	exports.parse = function parse(fn){
	  this._parser = fn;
	  return this;
	};
	
	/**
	 * Override default request body serializer
	 *
	 * This function will be called to convert data set via .send or .attach into payload to send
	 *
	 * @param {Function}
	 * @api public
	 */
	
	exports.serialize = function serialize(fn){
	  this._serializer = fn;
	  return this;
	};
	
	/**
	 * Set timeout to `ms`.
	 *
	 * @param {Number} ms
	 * @return {Request} for chaining
	 * @api public
	 */
	
	exports.timeout = function timeout(ms){
	  this._timeout = ms;
	  return this;
	};
	
	/**
	 * Promise support
	 *
	 * @param {Function} resolve
	 * @param {Function} reject
	 * @return {Request}
	 */
	
	exports.then = function then(resolve, reject) {
	  if (!this._fullfilledPromise) {
	    var self = this;
	    this._fullfilledPromise = new Promise(function(innerResolve, innerReject){
	      self.end(function(err, res){
	        if (err) innerReject(err); else innerResolve(res);
	      });
	    });
	  }
	  return this._fullfilledPromise.then(resolve, reject);
	}
	
	exports.catch = function(cb) {
	  return this.then(undefined, cb);
	};
	
	/**
	 * Allow for extension
	 */
	
	exports.use = function use(fn) {
	  fn(this);
	  return this;
	}
	
	
	/**
	 * Get request header `field`.
	 * Case-insensitive.
	 *
	 * @param {String} field
	 * @return {String}
	 * @api public
	 */
	
	exports.get = function(field){
	  return this._header[field.toLowerCase()];
	};
	
	/**
	 * Get case-insensitive header `field` value.
	 * This is a deprecated internal API. Use `.get(field)` instead.
	 *
	 * (getHeader is no longer used internally by the superagent code base)
	 *
	 * @param {String} field
	 * @return {String}
	 * @api private
	 * @deprecated
	 */
	
	exports.getHeader = exports.get;
	
	/**
	 * Set header `field` to `val`, or multiple fields with one object.
	 * Case-insensitive.
	 *
	 * Examples:
	 *
	 *      req.get('/')
	 *        .set('Accept', 'application/json')
	 *        .set('X-API-Key', 'foobar')
	 *        .end(callback);
	 *
	 *      req.get('/')
	 *        .set({ Accept: 'application/json', 'X-API-Key': 'foobar' })
	 *        .end(callback);
	 *
	 * @param {String|Object} field
	 * @param {String} val
	 * @return {Request} for chaining
	 * @api public
	 */
	
	exports.set = function(field, val){
	  if (isObject(field)) {
	    for (var key in field) {
	      this.set(key, field[key]);
	    }
	    return this;
	  }
	  this._header[field.toLowerCase()] = val;
	  this.header[field] = val;
	  return this;
	};
	
	/**
	 * Remove header `field`.
	 * Case-insensitive.
	 *
	 * Example:
	 *
	 *      req.get('/')
	 *        .unset('User-Agent')
	 *        .end(callback);
	 *
	 * @param {String} field
	 */
	exports.unset = function(field){
	  delete this._header[field.toLowerCase()];
	  delete this.header[field];
	  return this;
	};
	
	/**
	 * Write the field `name` and `val`, or multiple fields with one object
	 * for "multipart/form-data" request bodies.
	 *
	 * ``` js
	 * request.post('/upload')
	 *   .field('foo', 'bar')
	 *   .end(callback);
	 *
	 * request.post('/upload')
	 *   .field({ foo: 'bar', baz: 'qux' })
	 *   .end(callback);
	 * ```
	 *
	 * @param {String|Object} name
	 * @param {String|Blob|File|Buffer|fs.ReadStream} val
	 * @return {Request} for chaining
	 * @api public
	 */
	exports.field = function(name, val) {
	
	  // name should be either a string or an object.
	  if (null === name ||  undefined === name) {
	    throw new Error('.field(name, val) name can not be empty');
	  }
	
	  if (isObject(name)) {
	    for (var key in name) {
	      this.field(key, name[key]);
	    }
	    return this;
	  }
	
	  // val should be defined now
	  if (null === val || undefined === val) {
	    throw new Error('.field(name, val) val can not be empty');
	  }
	  this._getFormData().append(name, val);
	  return this;
	};
	
	/**
	 * Abort the request, and clear potential timeout.
	 *
	 * @return {Request}
	 * @api public
	 */
	exports.abort = function(){
	  if (this._aborted) {
	    return this;
	  }
	  this._aborted = true;
	  this.xhr && this.xhr.abort(); // browser
	  this.req && this.req.abort(); // node
	  this.clearTimeout();
	  this.emit('abort');
	  return this;
	};
	
	/**
	 * Enable transmission of cookies with x-domain requests.
	 *
	 * Note that for this to work the origin must not be
	 * using "Access-Control-Allow-Origin" with a wildcard,
	 * and also must set "Access-Control-Allow-Credentials"
	 * to "true".
	 *
	 * @api public
	 */
	
	exports.withCredentials = function(){
	  // This is browser-only functionality. Node side is no-op.
	  this._withCredentials = true;
	  return this;
	};
	
	/**
	 * Set the max redirects to `n`. Does noting in browser XHR implementation.
	 *
	 * @param {Number} n
	 * @return {Request} for chaining
	 * @api public
	 */
	
	exports.redirects = function(n){
	  this._maxRedirects = n;
	  return this;
	};
	
	/**
	 * Convert to a plain javascript object (not JSON string) of scalar properties.
	 * Note as this method is designed to return a useful non-this value,
	 * it cannot be chained.
	 *
	 * @return {Object} describing method, url, and data of this request
	 * @api public
	 */
	
	exports.toJSON = function(){
	  return {
	    method: this.method,
	    url: this.url,
	    data: this._data,
	    headers: this._header
	  };
	};
	
	/**
	 * Check if `obj` is a host object,
	 * we don't want to serialize these :)
	 *
	 * TODO: future proof, move to compoent land
	 *
	 * @param {Object} obj
	 * @return {Boolean}
	 * @api private
	 */
	
	exports._isHost = function _isHost(obj) {
	  var str = {}.toString.call(obj);
	
	  switch (str) {
	    case '[object File]':
	    case '[object Blob]':
	    case '[object FormData]':
	      return true;
	    default:
	      return false;
	  }
	}
	
	/**
	 * Send `data` as the request body, defaulting the `.type()` to "json" when
	 * an object is given.
	 *
	 * Examples:
	 *
	 *       // manual json
	 *       request.post('/user')
	 *         .type('json')
	 *         .send('{"name":"tj"}')
	 *         .end(callback)
	 *
	 *       // auto json
	 *       request.post('/user')
	 *         .send({ name: 'tj' })
	 *         .end(callback)
	 *
	 *       // manual x-www-form-urlencoded
	 *       request.post('/user')
	 *         .type('form')
	 *         .send('name=tj')
	 *         .end(callback)
	 *
	 *       // auto x-www-form-urlencoded
	 *       request.post('/user')
	 *         .type('form')
	 *         .send({ name: 'tj' })
	 *         .end(callback)
	 *
	 *       // defaults to x-www-form-urlencoded
	 *      request.post('/user')
	 *        .send('name=tobi')
	 *        .send('species=ferret')
	 *        .end(callback)
	 *
	 * @param {String|Object} data
	 * @return {Request} for chaining
	 * @api public
	 */
	
	exports.send = function(data){
	  var obj = isObject(data);
	  var type = this._header['content-type'];
	
	  // merge
	  if (obj && isObject(this._data)) {
	    for (var key in data) {
	      this._data[key] = data[key];
	    }
	  } else if ('string' == typeof data) {
	    // default to x-www-form-urlencoded
	    if (!type) this.type('form');
	    type = this._header['content-type'];
	    if ('application/x-www-form-urlencoded' == type) {
	      this._data = this._data
	        ? this._data + '&' + data
	        : data;
	    } else {
	      this._data = (this._data || '') + data;
	    }
	  } else {
	    this._data = data;
	  }
	
	  if (!obj || this._isHost(data)) return this;
	
	  // default to json
	  if (!type) this.type('json');
	  return this;
	};


/***/ }),
/* 113 */
/***/ (function(module, exports) {

	/**
	 * Check if `obj` is an object.
	 *
	 * @param {Object} obj
	 * @return {Boolean}
	 * @api private
	 */
	
	function isObject(obj) {
	  return null !== obj && 'object' === typeof obj;
	}
	
	module.exports = isObject;


/***/ }),
/* 114 */
/***/ (function(module, exports) {

	// The node and browser modules expose versions of this with the
	// appropriate constructor function bound as first argument
	/**
	 * Issue a request:
	 *
	 * Examples:
	 *
	 *    request('GET', '/users').end(callback)
	 *    request('/users').end(callback)
	 *    request('/users', callback)
	 *
	 * @param {String} method
	 * @param {String|Function} url or callback
	 * @return {Request}
	 * @api public
	 */
	
	function request(RequestConstructor, method, url) {
	  // callback
	  if ('function' == typeof url) {
	    return new RequestConstructor('GET', method).end(url);
	  }
	
	  // url first
	  if (2 == arguments.length) {
	    return new RequestConstructor('GET', method);
	  }
	
	  return new RequestConstructor(method, url);
	}
	
	module.exports = request;


/***/ }),
/* 115 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function($) {'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.initTableModifications = initTableModifications;
	/* * * * * * * * * * * * * * * * * * * * * * * * * * * * * *
	
	Responsive tables
	
	Add indicator when the table can be scrolled (usually on mobile)
	
	*/
	
	function initTableModifications() {
	
	    $('.table-container').each(function (i) {
	        // init
	        var $container = $(this);
	        // determine container width
	        var container_width = $container.outerWidth();
	        // find table inside the container
	        var $tables = $container.find('table');
	        // there might be multiple tables
	        $tables.each(function (i) {
	            // init
	            var $table = $(this);
	            // determine width and compare with container
	            var table_width = $table.outerWidth();
	            if (table_width > container_width) {
	                $container.addClass('scrolling-enabled');
	            }
	        });
	        var container_width = $container.outerWidth();
	    });
	}
	
	$(function () {
	
	    // on page load
	    initTableModifications();
	
	    // custom event
	    $(window).on('initTableModifications', function () {
	        initTableModifications();
	    });
	
	    // when vietport width changes
	    $(window).on('viewportWidthHasChanged', function () {
	        initTableModifications();
	    });
	});
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(2)))

/***/ }),
/* 116 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function($) {'use strict';
	
	/* * * * * * * * * * * * * * * * * * * * * * * * * * * * * *
	
	Modify Tingle Close Button
	
	*/
	
	function initTingleModifications() {
	    // Update button text (accessibility) and wrap with <span>
	    var btns = document.querySelectorAll('.tingle-modal__close');
	    for (var i = 0; i < btns.length; i++) {
	        // init
	        var btn = btns[i];
	        // create and set elements lang attribute
	        var btn_text_wrapper = document.createElement('span');
	        btn_text_wrapper.setAttribute('lang', 'en');
	        // remove button text
	        btn.textContent = '';
	        // set the created span
	        btn_text_wrapper.textContent = 'Close';
	        // and append it
	        btn.appendChild(btn_text_wrapper);
	    }
	}
	
	$(function () {
	    // on page load, but delayed
	    setTimeout(function () {
	        initTingleModifications();
	    }, 150);
	
	    // custom event
	    $(window).on('initTingleModifications', function () {
	        initTingleModifications();
	    });
	});
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(2)))

/***/ }),
/* 117 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function($) {'use strict';
	
	var _helperFunctions = __webpack_require__(82);
	
	/* * * * * * * * * * * * * * * * * * * * * * * * * * * * * *
	
	Store and update viewport dimensions for oriontation change
	detection
	
	*/
	
	function update_viewport_dimensions() {
	    $('html').attr('data-viewport-width', $(window).width());
	    $('html').attr('data-viewport-height', $(window).height());
	}
	
	function viewport_height_has_changed() {
	    var stored_height = $('html').attr('data-viewport-height');
	    var new_height = $(window).height();
	    if (stored_height != new_height) {
	        return true;
	    }
	}
	
	function viewport_width_has_changed() {
	    var stored_width = $('html').attr('data-viewport-width');
	    var new_width = $(window).width();
	    if (stored_width != new_width) {
	        return true;
	    }
	}
	
	$(function () {
	
	    // on page load
	    update_viewport_dimensions();
	
	    // delayed calling of functinos on 'resize'
	    var initViewportDimensions = (0, _helperFunctions.debounce)(function () {
	        // do stuff when viewport WIDTH has changed
	        if (viewport_width_has_changed()) {
	            update_viewport_dimensions();
	            // trigger custom events
	            $(window).trigger('viewportWidthHasChanged');
	        }
	        // do stuff when viewport HEIGHT has changed
	        if (viewport_height_has_changed()) {
	            update_viewport_dimensions();
	            // trigger custom event
	            $(window).trigger('viewportHeightHasChanged');
	        }
	    }, 500);
	    $(window).on('resize', initViewportDimensions);
	});
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(2)))

/***/ }),
/* 118 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function($) {'use strict';
	
	var _triggerClassOnScroll = __webpack_require__(119);
	
	$(function () {
	
	    /* * * * * * * * * * * * * * * * * * * * * * * * * * * * * *
	     Header
	     IMPORTANT: If the 'header buffer' is enabled, the scroll distance breakpoints have to be the same height (AT LEAST), otherwise the buffer becomes visible.
	     */
	
	    function initHeader() {
	
	        if (document.querySelector('.site-header.compact-mode-enabled')) {
	            var scroll_distance = 70;
	            if ($(window).width() >= 768) {
	                scroll_distance = 70;
	            }
	            if ($(window).width() >= 1024) {
	                scroll_distance = 125;
	            }
	            (0, _triggerClassOnScroll.triggerClassOnScroll)({
	                'scroll': scroll_distance,
	                'class_to_trigger': 'compact-mode',
	                'element': document.querySelector('.site-header.compact-mode-enabled')
	            });
	            (0, _triggerClassOnScroll.triggerClassOnScroll)({
	                'scroll': scroll_distance,
	                'class_to_trigger': 'header-compact-mode',
	                'element': document.querySelector('html')
	            });
	        }
	    }
	
	    // on page load
	    initHeader();
	
	    // custom event
	    $(window).on('initHeader', function () {
	        initHeader();
	    });
	
	    // initialize again when viewport width has changed
	    $(window).on('viewportWidthHasChanged', function () {
	        initHeader();
	    });
	});
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(2)))

/***/ }),
/* 119 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function($) {'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.triggerClassOnScroll = triggerClassOnScroll;
	function triggerClassOnScroll(options) {
	
	    // init options
	    if (!options.element) {
	        console.error('triggerClassOnScroll: No element set');
	    }
	
	    // init vars
	    var class_to_trigger = options.class_to_trigger,
	        scroll = options.scroll || 0,
	        element = options.element;
	
	    // handler
	    var scrollHandler = function scrollHandler() {
	        if (window.pageYOffset >= scroll && !$(element).hasClass(class_to_trigger)) {
	            $(element).addClass(class_to_trigger);
	        } else if (window.pageYOffset < scroll && $(element).hasClass(class_to_trigger)) {
	            $(element).removeClass(class_to_trigger);
	        }
	    };
	
	    // on page load
	    scrollHandler();
	
	    // on scroll
	    window.addEventListener('scroll', scrollHandler);
	
	    return this;
	}
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(2)))

/***/ }),
/* 120 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function($) {'use strict';
	
	var _map = __webpack_require__(121);
	
	$(function () {
	
	    var options = {
	        // define options here
	    };
	
	    (0, _map.initMap)(options);
	});
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(2)))

/***/ }),
/* 121 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function($) {'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.initMap = undefined;
	
	var _helperFunctions = __webpack_require__(82);
	
	var initMap = exports.initMap = function initMap(options) {
	
	    // initialize options
	    var options = options || {};
	
	    /* * * * * * * * * * * * * * * * * * * * * * * * * * * * * *
	     Default settings
	     */
	
	    if (!options.pin_url) {
	        options.pin_url = '/static/images/map/pin.png';
	    }
	    if (!options.pin_width) {
	        options.pin_width = 66;
	    }
	    if (!options.pin_height) {
	        options.pin_height = 109;
	    }
	    if (!options.fullscreen_enabled) {
	        options.fullscreen_enabled = false;
	    }
	    if (!options.map_styles) {
	        options.map_styles = [{
	            "featureType": "all",
	            "elementType": "labels.text.fill",
	            "stylers": [{
	                "saturation": 36
	            }, {
	                "color": "#333333"
	            }, {
	                "lightness": 40
	            }]
	        }, {
	            "featureType": "all",
	            "elementType": "labels.text.stroke",
	            "stylers": [{
	                "visibility": "on"
	            }, {
	                "color": "#ffffff"
	            }, {
	                "lightness": 16
	            }]
	        }, {
	            "featureType": "all",
	            "elementType": "labels.icon",
	            "stylers": [{
	                "visibility": "off"
	            }]
	        }, {
	            "featureType": "administrative",
	            "elementType": "geometry.fill",
	            "stylers": [{
	                "color": "#fefefe"
	            }, {
	                "lightness": 20
	            }]
	        }, {
	            "featureType": "administrative",
	            "elementType": "geometry.stroke",
	            "stylers": [{
	                "color": "#fefefe"
	            }, {
	                "lightness": 17
	            }, {
	                "weight": 1.2
	            }]
	        }, {
	            "featureType": "administrative.locality",
	            "elementType": "labels",
	            "stylers": [{
	                "visibility": "on"
	            }]
	        }, {
	            "featureType": "landscape",
	            "elementType": "geometry",
	            "stylers": [{
	                "color": "#ebebeb"
	            }, {
	                "lightness": 20
	            }]
	        }, {
	            "featureType": "poi",
	            "elementType": "geometry",
	            "stylers": [{
	                "color": "#f5f5f5"
	            }, {
	                "lightness": 21
	            }]
	        }, {
	            "featureType": "poi.park",
	            "elementType": "geometry",
	            "stylers": [{
	                "color": "#dedede"
	            }, {
	                "lightness": 21
	            }]
	        }, {
	            "featureType": "road.highway",
	            "elementType": "geometry.fill",
	            "stylers": [{
	                "color": "#ffffff"
	            }, {
	                "lightness": 17
	            }]
	        }, {
	            "featureType": "road.highway",
	            "elementType": "geometry.stroke",
	            "stylers": [{
	                "color": "#ffffff"
	            }, {
	                "lightness": 29
	            }, {
	                "weight": 0.2
	            }]
	        }, {
	            "featureType": "road.arterial",
	            "elementType": "geometry",
	            "stylers": [{
	                "color": "#ffffff"
	            }, {
	                "lightness": 18
	            }]
	        }, {
	            "featureType": "road.local",
	            "elementType": "geometry",
	            "stylers": [{
	                "color": "#ffffff"
	            }, {
	                "lightness": 16
	            }]
	        }, {
	            "featureType": "transit",
	            "elementType": "geometry",
	            "stylers": [{
	                "color": "#f2f2f2"
	            }, {
	                "lightness": 19
	            }]
	        }, {
	            "featureType": "water",
	            "elementType": "geometry",
	            "stylers": [{
	                "color": "#d1d8da"
	            }, {
	                "lightness": 17
	            }]
	        }];
	    }
	
	    function createMarker(options, markerPos, infowindow_content, map) {
	        var pin = {
	            url: options.pin_url,
	            size: new google.maps.Size(Math.floor(options.pin_width / 2), Math.floor(options.pin_height / 2)), // half the actual size (squeezed), otherwise the info window is not centered correctly
	            scaledSize: new google.maps.Size(Math.floor(options.pin_width / 2), Math.floor(options.pin_height / 2)),
	            origin: new google.maps.Point(0, 0),
	            anchor: new google.maps.Point(Math.floor(options.pin_width / 4), Math.floor(options.pin_height / 2)) };
	
	        var marker = new google.maps.Marker({
	            position: markerPos,
	            map: map,
	            icon: pin,
	            info: infowindow_content
	        });
	
	        return marker;
	    }
	
	    /* * * * * * * * * * * * * * * * * * * * * * * * * * * * * *
	     CallBack function assigned to window, so it can be called by
	    the Google Map script.
	     */
	
	    window.initMap = function () {
	
	        // init
	        var numberOfMaps = window.MAPS.length;
	
	        // / loop through instances
	        for (var i = window.MAPS.length - 1; i >= 0; i--) {
	
	            // init vars
	            var mapID = window.MAPS[i].id;
	            var mapInstance = document.getElementById('map-' + mapID);
	            var zoomLevel = parseInt(mapInstance.getAttribute('data-zoom-level'));
	            var numberOfMarkers = (0, _helperFunctions.countObjectProperties)(window.MAPS[i].locations);
	            var page_load_window_width = $(window).width();
	
	            // define map options
	            var mapOptions = {
	                mapTypeControl: false,
	                zoomControl: true,
	                scrollwheel: false,
	                zoomControlOptions: {
	                    position: google.maps.ControlPosition.RIGHT_CENTER,
	                    style: google.maps.ZoomControlStyle.LARGE
	                },
	                scaleControl: true,
	                streetViewControl: false,
	                fullscreenControl: options.fullscreen_enabled
	            };
	
	            // map styles and settings
	            var styledMap = new google.maps.StyledMapType(options.map_styles, { name: "Styled Map" });
	            var map = new google.maps.Map(mapInstance, mapOptions);
	            var bounds = new google.maps.LatLngBounds();
	            var infoWindow = new google.maps.InfoWindow({
	                content: 'Loading...'
	            });
	            map.mapTypes.set('map_style', styledMap);
	            map.setMapTypeId('map_style');
	
	            for (var counter = 1; counter <= numberOfMarkers; counter++) {
	
	                // init object
	                var marker_obj = window.MAPS[i].locations[counter];
	
	                // get merker values
	                var lat = parseFloat(marker_obj.lat.replace(',', '.'));
	                var lng = parseFloat(marker_obj.lng.replace(',', '.'));
	                var infowindow_content = marker_obj.infowindow_content;
	
	                // define and set marker
	                var markerPos = new google.maps.LatLng(lat, lng);
	                var marker = createMarker(options, markerPos, infowindow_content, map);
	
	                // only 1 marker? Set center and zoom level
	                if (numberOfMarkers === 1) {
	                    map.setCenter(markerPos);
	                    map.setZoom(zoomLevel);
	                }
	                // More than 1 markers? Automatically center the map fitting all markers on the screen
	                else {
	                        // extend map boundaries
	                        bounds.extend(markerPos);
	                        // fit to boundaries
	                        map.fitBounds(bounds);
	                    }
	
	                // fill info box with individual content
	                marker.addListener('click', function () {
	                    infoWindow.setContent(this.info);
	                    infoWindow.open(map, this);
	                });
	            }
	
	            // delayed re-center the map when a user resizes the window
	            var reCenterMap = (0, _helperFunctions.debounce)(function () {
	                // init
	                var window_width = $(window).width();
	                // only 1 marker? Set center and zoom level
	                if (numberOfMarkers === 1) {
	                    map.setZoom(zoomLevel);
	                }
	                // More than 1 markers? Automatically center the map fitting all markers on the screen
	                else {
	                        // fit to boundaries
	                        map.fitBounds(bounds);
	                    }
	            }, 500);
	            // only when viewport width has changed
	            $(window).on('viewportWidthHasChanged', function () {
	                reCenterMap();
	            });
	
	            // handle zoom levels for different scenarios
	            google.maps.event.addListenerOnce(map, 'bounds_changed', function (e) {
	                // only 1 marker? Set center and zoom level
	                if (numberOfMarkers === 1) {
	                    this.setZoom(zoomLevel);
	                }
	                // More than 1 markers? Automatically center the map fitting all markers on the screen
	                else {
	                        // fit to boundaries
	                        this.fitBounds(bounds);
	                    }
	            });
	        }
	    };
	
	    // 1. check if there is at least one map on the page
	    var map_exists = document.querySelectorAll('.locations-map');
	    if (map_exists.length > 0) {
	        // 2. check if the script has NOT been included already
	        if (typeof google == "undefined") {
	            // 3. load google maps api
	            var google_maps_script = document.createElement('script');
	            // fallback API key
	            var api_key = '';
	            // custom API key
	            if (window.GOOGLE_MAP_API_KEY && window.GOOGLE_MAP_API_KEY != 'None') {
	                api_key = window.GOOGLE_MAP_API_KEY;
	            }
	            // check if key exists and warn if not
	            if (api_key == '') {
	                console.warn('Google Map API key is missing');
	            } else {
	                // get document language
	                var lang = $('html').attr('lang');
	                // load script
	                google_maps_script.src = 'https://maps.googleapis.com/maps/api/js?key=' + api_key + '&callback=initMap&language=' + lang;
	                document.body.appendChild(google_maps_script);
	            }
	        }
	    }
	}; /* * * * * * * * * * * * * * * * * * * * * * * * * * * * * *
	   
	   Map core functionality
	   
	   Customize Map Styles:
	   
	   https://snazzymaps.com/style/105672/django-cms-default
	   
	   Requires the API key variable in base_root.html:
	   
	   <script type="text/javascript">
	       var GOOGLE_MAP_API_KEY = '{% settings_value "GOOGLE_MAP_API_KEY" %}';
	   </script>
	   
	   */
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(2)))

/***/ }),
/* 122 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function($) {'use strict';
	
	__webpack_require__(123);
	
	/* * * * * * * * * * * * * * * * * * * * * * * * * * * * * *
	
	Custom Navigation Dropdown and Tweaks
	
	*/
	
	function initNavigation() {
	
	    /* * * * * * * * * * * * * * * * * * * * * * * * * * * * * *
	     Toggle a class when mobile nav is expanded
	     */
	
	    // init
	    var $html = $('html');
	    var $softpage_menu_toggle = $('.softpage-menu-toggle');
	    var nav_expanded_class = 'nav-expanded';
	    var toggled_attr = 'data-softpage-toggled';
	    var toggled_class = 'toggled';
	
	    // default mobile toggle
	    $('.navbar-toggle').on('click', function (e) {
	        // init
	        var $toggle = $(this);
	        // already active
	        if ($toggle.hasClass(toggled_class)) {
	            $toggle.removeClass(toggled_class);
	            $html.removeClass(nav_expanded_class);
	        }
	        // about to toggle
	        else {
	                $toggle.addClass(toggled_class);
	                $html.addClass(nav_expanded_class);
	            }
	    });
	
	    // softpage menu toggle
	    $softpage_menu_toggle.on('click', function (e) {
	        // init
	        var $toggle = $(this);
	        e.preventDefault();
	        // already active
	        if ($toggle.hasClass(toggled_class)) {
	            $(window).trigger('closeSoftpage');
	        }
	        // about to toggle
	        else {
	                $toggle.attr(toggled_attr, '');
	                $toggle.addClass(toggled_class);
	                $html.addClass(nav_expanded_class);
	            }
	    });
	    $(window).on('softpage:closed', function () {
	        $softpage_menu_toggle.removeAttr(toggled_attr);
	        $softpage_menu_toggle.removeClass(toggled_class);
	    });
	
	    /* * * * * * * * * * * * * * * * * * * * * * * * * * * * * *
	     Toggle subnav on larger screens
	     */
	
	    // STEP 1: click anywhere on the DOM hides all subnavs
	    $(document).on('click touchend', function (e) {
	
	        // hide only if user has clicked somewhere ELSE but the opened subnav
	        if ($(e.target).parents('.nav-dropdown').hasClass('opened')) {
	            // don't do anything
	        } else {
	            hideExpandedSubnav();
	        }
	    });
	
	    // STEP 2 (overwrites STEP 1): toggle subnav visibility
	    $('.nav-dropdown > a').on('click', function (e) {
	
	        // init
	        var $current_subnav = $(this).siblings('.subnav');
	        var $overlay = $('.content-overlay');
	        var visible_class = 'visible';
	        var device_width = $(window).width();
	        var min_width_breakpoint = 992; // when is the full menu shown?
	
	        // stops climbing up the DOM, which overwrites STEP 1
	        e.stopPropagation();
	
	        // stop following the link
	        e.preventDefault();
	
	        // check if current subnav is visible
	        var child_is_visible = $current_subnav.hasClass(visible_class);
	
	        // hide all previously opened subnavs
	        hideExpandedSubnav();
	
	        // second, display the subnav if it was NOT visible before
	        if (child_is_visible) {
	            $current_subnav.removeClass(visible_class);
	            $current_subnav.parents('.nav-dropdown').removeClass('opened');
	            if (device_width >= min_width_breakpoint) {
	                $overlay.removeClass(visible_class);
	            }
	        } else {
	            $current_subnav.addClass(visible_class);
	            $current_subnav.parents('.nav-dropdown').addClass('opened');
	            if (device_width >= min_width_breakpoint) {
	                $overlay.addClass(visible_class);
	            }
	        }
	    });
	
	    // Optional: Selector of an element that closes the nav
	    $('.subnav-close').on('click', function (e) {
	        e.preventDefault();
	        hideExpandedSubnav();
	    });
	
	    // Close Subnave when hitting ESC
	    $(document).keydown(function (evt) {
	        evt = evt || window.event;
	        var isEscape = false;
	        if ("key" in evt) {
	            isEscape = evt.key == "Escape";
	        } else {
	            isEscape = evt.keyCode == 27;
	        }
	        if (isEscape) {
	            hideExpandedSubnav();
	        }
	    });
	}
	
	/* * * * * * * * * * * * * * * * * * * * * * * * * * * * * *
	
	Touch device navigation fixes
	
	*/
	
	/* * * * * * * * * * * * * * * * * * * * * * * * * * * * * *
	
	Mobile Nav Toggle
	
	http://getbootstrap.com/javascript/#collapse
	
	*/
	
	function hideExpandedSubnav() {
	
	    // init
	    var device_width = $(window).width();
	    var visible_class = 'visible';
	    var $overlay = $('.content-overlay');
	    var min_width_breakpoint = 992; // when is the full menu shown?
	
	    // hide overlay
	    $overlay.removeClass(visible_class);
	
	    // only apply on expanded navigation
	    if (device_width >= min_width_breakpoint) {
	        $('.subnav').each(function () {
	            var $this = $(this);
	            if ($this.hasClass(visible_class)) {
	                $this.removeClass(visible_class);
	                $this.parents('.nav-dropdown').removeClass('opened');
	            }
	        });
	    }
	}
	
	/* * * * * * * * * * * * * * * * * * * * * * * * * * * * * *
	
	Init
	
	*/
	
	$(function () {
	
	    // on page load
	    initNavigation();
	
	    // custom events
	    $(window).on('initNavigation', function () {
	        initNavigation();
	    });
	
	    $(window).on('hideExpandedSubnav', function () {
	        hideExpandedSubnav();
	    });
	
	    // initialize again when viewport width has changed
	    $(window).on('viewportWidthHasChanged', function () {
	        hideExpandedSubnav();
	    });
	});
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(2)))

/***/ }),
/* 123 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(jQuery) {/* ========================================================================
	 * Bootstrap: collapse.js v3.4.1
	 * https://getbootstrap.com/docs/3.4/javascript/#collapse
	 * ========================================================================
	 * Copyright 2011-2019 Twitter, Inc.
	 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/master/LICENSE)
	 * ======================================================================== */
	
	/* jshint latedef: false */
	
	+function ($) {
	  'use strict';
	
	  // COLLAPSE PUBLIC CLASS DEFINITION
	  // ================================
	
	  var Collapse = function (element, options) {
	    this.$element      = $(element)
	    this.options       = $.extend({}, Collapse.DEFAULTS, options)
	    this.$trigger      = $('[data-toggle="collapse"][href="#' + element.id + '"],' +
	                           '[data-toggle="collapse"][data-target="#' + element.id + '"]')
	    this.transitioning = null
	
	    if (this.options.parent) {
	      this.$parent = this.getParent()
	    } else {
	      this.addAriaAndCollapsedClass(this.$element, this.$trigger)
	    }
	
	    if (this.options.toggle) this.toggle()
	  }
	
	  Collapse.VERSION  = '3.4.1'
	
	  Collapse.TRANSITION_DURATION = 350
	
	  Collapse.DEFAULTS = {
	    toggle: true
	  }
	
	  Collapse.prototype.dimension = function () {
	    var hasWidth = this.$element.hasClass('width')
	    return hasWidth ? 'width' : 'height'
	  }
	
	  Collapse.prototype.show = function () {
	    if (this.transitioning || this.$element.hasClass('in')) return
	
	    var activesData
	    var actives = this.$parent && this.$parent.children('.panel').children('.in, .collapsing')
	
	    if (actives && actives.length) {
	      activesData = actives.data('bs.collapse')
	      if (activesData && activesData.transitioning) return
	    }
	
	    var startEvent = $.Event('show.bs.collapse')
	    this.$element.trigger(startEvent)
	    if (startEvent.isDefaultPrevented()) return
	
	    if (actives && actives.length) {
	      Plugin.call(actives, 'hide')
	      activesData || actives.data('bs.collapse', null)
	    }
	
	    var dimension = this.dimension()
	
	    this.$element
	      .removeClass('collapse')
	      .addClass('collapsing')[dimension](0)
	      .attr('aria-expanded', true)
	
	    this.$trigger
	      .removeClass('collapsed')
	      .attr('aria-expanded', true)
	
	    this.transitioning = 1
	
	    var complete = function () {
	      this.$element
	        .removeClass('collapsing')
	        .addClass('collapse in')[dimension]('')
	      this.transitioning = 0
	      this.$element
	        .trigger('shown.bs.collapse')
	    }
	
	    if (!$.support.transition) return complete.call(this)
	
	    var scrollSize = $.camelCase(['scroll', dimension].join('-'))
	
	    this.$element
	      .one('bsTransitionEnd', $.proxy(complete, this))
	      .emulateTransitionEnd(Collapse.TRANSITION_DURATION)[dimension](this.$element[0][scrollSize])
	  }
	
	  Collapse.prototype.hide = function () {
	    if (this.transitioning || !this.$element.hasClass('in')) return
	
	    var startEvent = $.Event('hide.bs.collapse')
	    this.$element.trigger(startEvent)
	    if (startEvent.isDefaultPrevented()) return
	
	    var dimension = this.dimension()
	
	    this.$element[dimension](this.$element[dimension]())[0].offsetHeight
	
	    this.$element
	      .addClass('collapsing')
	      .removeClass('collapse in')
	      .attr('aria-expanded', false)
	
	    this.$trigger
	      .addClass('collapsed')
	      .attr('aria-expanded', false)
	
	    this.transitioning = 1
	
	    var complete = function () {
	      this.transitioning = 0
	      this.$element
	        .removeClass('collapsing')
	        .addClass('collapse')
	        .trigger('hidden.bs.collapse')
	    }
	
	    if (!$.support.transition) return complete.call(this)
	
	    this.$element
	      [dimension](0)
	      .one('bsTransitionEnd', $.proxy(complete, this))
	      .emulateTransitionEnd(Collapse.TRANSITION_DURATION)
	  }
	
	  Collapse.prototype.toggle = function () {
	    this[this.$element.hasClass('in') ? 'hide' : 'show']()
	  }
	
	  Collapse.prototype.getParent = function () {
	    return $(document).find(this.options.parent)
	      .find('[data-toggle="collapse"][data-parent="' + this.options.parent + '"]')
	      .each($.proxy(function (i, element) {
	        var $element = $(element)
	        this.addAriaAndCollapsedClass(getTargetFromTrigger($element), $element)
	      }, this))
	      .end()
	  }
	
	  Collapse.prototype.addAriaAndCollapsedClass = function ($element, $trigger) {
	    var isOpen = $element.hasClass('in')
	
	    $element.attr('aria-expanded', isOpen)
	    $trigger
	      .toggleClass('collapsed', !isOpen)
	      .attr('aria-expanded', isOpen)
	  }
	
	  function getTargetFromTrigger($trigger) {
	    var href
	    var target = $trigger.attr('data-target')
	      || (href = $trigger.attr('href')) && href.replace(/.*(?=#[^\s]+$)/, '') // strip for ie7
	
	    return $(document).find(target)
	  }
	
	
	  // COLLAPSE PLUGIN DEFINITION
	  // ==========================
	
	  function Plugin(option) {
	    return this.each(function () {
	      var $this   = $(this)
	      var data    = $this.data('bs.collapse')
	      var options = $.extend({}, Collapse.DEFAULTS, $this.data(), typeof option == 'object' && option)
	
	      if (!data && options.toggle && /show|hide/.test(option)) options.toggle = false
	      if (!data) $this.data('bs.collapse', (data = new Collapse(this, options)))
	      if (typeof option == 'string') data[option]()
	    })
	  }
	
	  var old = $.fn.collapse
	
	  $.fn.collapse             = Plugin
	  $.fn.collapse.Constructor = Collapse
	
	
	  // COLLAPSE NO CONFLICT
	  // ====================
	
	  $.fn.collapse.noConflict = function () {
	    $.fn.collapse = old
	    return this
	  }
	
	
	  // COLLAPSE DATA-API
	  // =================
	
	  $(document).on('click.bs.collapse.data-api', '[data-toggle="collapse"]', function (e) {
	    var $this   = $(this)
	
	    if (!$this.attr('data-target')) e.preventDefault()
	
	    var $target = getTargetFromTrigger($this)
	    var data    = $target.data('bs.collapse')
	    var option  = data ? 'toggle' : $this.data()
	
	    Plugin.call($target, option)
	  })
	
	}(jQuery);
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(2)))

/***/ }),
/* 124 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function($) {'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.initOnScreen = initOnScreen;
	
	var _onscreen = __webpack_require__(125);
	
	var _onscreen2 = _interopRequireDefault(_onscreen);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function initOnScreen() {
	
	    // when to reveal item: tolerance breakpoints
	    var tolerance = 20;
	    if ($(window).width() >= 768) {
	        tolerance = 50;
	    }
	    if ($(window).width() >= 1024) {
	        tolerance = 50;
	    }
	
	    var os = new _onscreen2.default({
	        tolerance: tolerance, // options.tolerance is the number of pixels an element is allowed to enter its container boundaries before calling its callback. Defaults to 0.
	        debounce: 50, // options.debounce is the number of milliseconds to wait before calling an element's callback after the user has stopped scrolling. Defaults to 100.
	        container: window // options.container is the container of the elements you want to track. It accepts a string representing a CSS selector or an HTMLElement object. Defaults to window.
	    });
	
	    // Do something when an element enters the viewport
	    os.on('enter', '[data-scroll-spy]', function (element) {
	        // makes's the element's text red
	        element.classList.add('element-visible');
	    });
	} /* * * * * * * * * * * * * * * * * * * * * * * * * * * * * *
	  
	  OnScreen - Does stuff when an element is on screen.
	  
	  https://github.com/silvestreh/onScreen
	  
	  */
	
	$(function () {
	
	    // on page load
	    initOnScreen();
	
	    // custom event
	    $(window).on('initOnScreen', function () {
	        initOnScreen();
	    });
	});
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(2)))

/***/ }),
/* 125 */
/***/ (function(module, exports, __webpack_require__) {

	(function (global, factory) {
	     true ? module.exports = factory() :
	    typeof define === 'function' && define.amd ? define(factory) :
	    (global.OnScreen = factory());
	}(this, function () { 'use strict';
	
	    /**
	     * Observes DOM mutations and runs a callback function when
	     * detecting one.
	     *
	     * @param {node} obj The DOM node you want to observe
	     * @param {function} callback The callback function you want to call
	     * @return {MutationObserver} obs The mutation observer instance used to track DOM mutations
	     */
	    function observeDOM(obj, callback) {
	        var MutationObserver = window.MutationObserver || window.WebKitMutationObserver;
	
	        /* istanbul ignore else */
	        if (MutationObserver) {
	            var obs = new MutationObserver(callback);
	
	            obs.observe(obj, {
	                childList: true,
	                subtree: true
	            });
	
	            return obs;
	        }
	
	        obj.addEventListener('DOMNodeInserted', callback, false);
	        obj.addEventListener('DOMNodeRemoved', callback, false);
	
	        return null;
	    }
	
	    /**
	     * Attaches the scroll event handler
	     *
	     * @return {void}
	     */
	    function attach() {
	        var _this = this;
	
	        var container = this.options.container;
	
	        if (container instanceof HTMLElement) {
	            var style = window.getComputedStyle(container);
	
	            if (style.position === 'static') {
	                container.style.position = 'relative';
	            }
	        }
	
	        this._observer = observeDOM(document.querySelector('body'), function () {
	            Object.keys(_this.trackedElements).forEach(function (element) {
	                _this.on('enter', element);
	                _this.on('leave', element);
	            });
	        });
	
	        container.addEventListener('scroll', this._scroll, { passive: true });
	        window.addEventListener('resize', this._scroll, { passive: true });
	        this._scroll();
	        this.attached = true;
	    }
	
	    /**
	     * Checks an element's position in respect to the viewport
	     * and determines wether it's inside the viewport.
	     *
	     * @param {node} element The DOM node you want to check
	     * @return {boolean} A boolean value that indicates wether is on or off the viewport.
	     */
	    function inViewport(el) {
	        var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : { tolerance: 0 };
	
	        if (!el) {
	            throw new Error('You should specify the element you want to test');
	        }
	
	        if (typeof el === 'string') {
	            el = document.querySelector(el);
	        }
	
	        var elRect = el.getBoundingClientRect();
	
	        return (
	            // Check bottom boundary
	            elRect.bottom - options.tolerance > 0 &&
	
	            // Check right boundary
	            elRect.right - options.tolerance > 0 &&
	
	            // Check left boundary
	            elRect.left + options.tolerance < (window.innerWidth || document.documentElement.clientWidth) &&
	
	            // Check top boundary
	            elRect.top + options.tolerance < (window.innerHeight || document.documentElement.clientHeight)
	        );
	    }
	
	    /**
	     * Checks an element's position in respect to a HTMLElement
	     * and determines wether it's within its boundaries.
	     *
	     * @param {node} element The DOM node you want to check
	     * @return {boolean} A boolean value that indicates wether is on or off the container.
	     */
	    function inContainer(el) {
	        var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : { tolerance: 0, container: '' };
	
	        if (!el) {
	            throw new Error('You should specify the element you want to test');
	        }
	
	        if (typeof el === 'string') {
	            el = document.querySelector(el);
	        }
	        if (typeof options === 'string') {
	            options = {
	                tolerance: 0,
	                container: document.querySelector(options)
	            };
	        }
	        if (typeof options.container === 'string') {
	            options.container = document.querySelector(options.container);
	        }
	        if (options instanceof HTMLElement) {
	            options = {
	                tolerance: 0,
	                container: options
	            };
	        }
	        if (!options.container) {
	            throw new Error('You should specify a container element');
	        }
	
	        var containerRect = options.container.getBoundingClientRect();
	
	        return (
	            // // Check bottom boundary
	            el.offsetTop + el.clientHeight - options.tolerance > options.container.scrollTop &&
	
	            // Check right boundary
	            el.offsetLeft + el.clientWidth - options.tolerance > options.container.scrollLeft &&
	
	            // Check left boundary
	            el.offsetLeft + options.tolerance < containerRect.width + options.container.scrollLeft &&
	
	            // // Check top boundary
	            el.offsetTop + options.tolerance < containerRect.height + options.container.scrollTop
	        );
	    }
	
	    // TODO: Refactor this so it can be easily tested
	    /* istanbul ignore next */
	    function eventHandler() {
	        var trackedElements = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	        var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : { tolerance: 0 };
	
	        var selectors = Object.keys(trackedElements);
	        var testVisibility = void 0;
	
	        if (!selectors.length) return;
	
	        if (options.container === window) {
	            testVisibility = inViewport;
	        } else {
	            testVisibility = inContainer;
	        }
	
	        selectors.forEach(function (selector) {
	            trackedElements[selector].nodes.forEach(function (item) {
	                if (testVisibility(item.node, options)) {
	                    item.wasVisible = item.isVisible;
	                    item.isVisible = true;
	                } else {
	                    item.wasVisible = item.isVisible;
	                    item.isVisible = false;
	                }
	                if (item.isVisible === true && item.wasVisible === false) {
	                    if (!trackedElements[selector].enter) return;
	
	                    Object.keys(trackedElements[selector].enter).forEach(function (callback) {
	                        if (typeof trackedElements[selector].enter[callback] === 'function') {
	                            trackedElements[selector].enter[callback](item.node, 'enter');
	                        }
	                    });
	                }
	                if (item.isVisible === false && item.wasVisible === true) {
	                    if (!trackedElements[selector].leave) return;
	
	                    Object.keys(trackedElements[selector].leave).forEach(function (callback) {
	                        if (typeof trackedElements[selector].leave[callback] === 'function') {
	                            trackedElements[selector].leave[callback](item.node, 'leave');
	                        }
	                    });
	                }
	            });
	        });
	    }
	
	    /**
	     * Debounces the scroll event to avoid performance issues
	     *
	     * @return {void}
	     */
	    function debouncedScroll() {
	        var _this = this;
	
	        var timeout = void 0;
	
	        if (this.options.debounce === false) {
	            return function () {
	                return eventHandler(_this.trackedElements, _this.options);
	            };
	        }
	
	        return function () {
	            clearTimeout(timeout);
	
	            timeout = setTimeout(function () {
	                eventHandler(_this.trackedElements, _this.options);
	            }, _this.options.debounce);
	        };
	    }
	
	    /**
	     * Removes the scroll event handler
	     *
	     * @return {void}
	     */
	    function destroy() {
	        if (this._observer instanceof MutationObserver) {
	            this._observer.disconnect();
	        }
	
	        this.options.container.removeEventListener('scroll', this._scroll);
	        window.removeEventListener('resize', this._scroll);
	        this.attached = false;
	    }
	
	    /**
	     * Stops tracking elements matching a CSS selector. If a selector has no
	     * callbacks it gets removed.
	     *
	     * @param {string} event The event you want to stop tracking (enter or leave)
	     * @param {string} selector The CSS selector you want to stop tracking
	     * @return {void}
	     */
	    function off(event, selector, handler) {
	        var enterCallbacks = Object.keys(this.trackedElements[selector].enter || {});
	        var leaveCallbacks = Object.keys(this.trackedElements[selector].leave || {});
	
	        if ({}.hasOwnProperty.call(this.trackedElements, selector)) {
	            if (handler) {
	                if (this.trackedElements[selector][event]) {
	                    var callbackName = typeof handler === 'function' ? handler.name : handler;
	                    delete this.trackedElements[selector][event][callbackName];
	                }
	            } else {
	                delete this.trackedElements[selector][event];
	            }
	        }
	
	        if (!enterCallbacks.length && !leaveCallbacks.length) {
	            delete this.trackedElements[selector];
	        }
	    }
	
	    /**
	     * Starts tracking elements matching a CSS selector
	     *
	     * @param {string} event The event you want to track (enter or leave)
	     * @param {string} selector The element you want to track
	     * @param {function} callback The callback function to handle the event
	     * @return {void}
	     */
	    function on(event, selector, callback) {
	        var allowed = ['enter', 'leave'];
	
	        if (!event) throw new Error('No event given. Choose either enter or leave');
	        if (!selector) throw new Error('No selector to track');
	        if (allowed.indexOf(event) < 0) throw new Error(event + ' event is not supported');
	
	        if (!{}.hasOwnProperty.call(this.trackedElements, selector)) {
	            this.trackedElements[selector] = {};
	        }
	
	        this.trackedElements[selector].nodes = [];
	
	        for (var i = 0, elems = document.querySelectorAll(selector); i < elems.length; i++) {
	            var item = {
	                isVisible: false,
	                wasVisible: false,
	                node: elems[i]
	            };
	
	            this.trackedElements[selector].nodes.push(item);
	        }
	
	        if (typeof callback === 'function') {
	            if (!this.trackedElements[selector][event]) {
	                this.trackedElements[selector][event] = {};
	            }
	
	            this.trackedElements[selector][event][callback.name || 'anonymous'] = callback;
	        }
	    }
	
	    /**
	     * Detects wether DOM nodes enter or leave the viewport
	     *
	     * @constructor
	     * @param {object} options The configuration object
	     */
	    function OnScreen() {
	        var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : { tolerance: 0, debounce: 100, container: window };
	
	        this.options = {};
	        this.trackedElements = {};
	
	        Object.defineProperties(this.options, {
	            container: {
	                configurable: false,
	                enumerable: false,
	                get: function get() {
	                    var container = void 0;
	
	                    if (typeof options.container === 'string') {
	                        container = document.querySelector(options.container);
	                    } else if (options.container instanceof HTMLElement) {
	                        container = options.container;
	                    }
	
	                    return container || window;
	                },
	                set: function set(value) {
	                    options.container = value;
	                }
	            },
	            debounce: {
	                get: function get() {
	                    if (options.debounce === false) {
	                        return false;
	                    }
	
	                    return parseInt(options.debounce, 10) || 100;
	                },
	                set: function set(value) {
	                    options.debounce = value;
	                }
	            },
	            tolerance: {
	                get: function get() {
	                    return parseInt(options.tolerance, 10) || 0;
	                },
	                set: function set(value) {
	                    options.tolerance = value;
	                }
	            }
	        });
	
	        Object.defineProperty(this, '_scroll', {
	            enumerable: false,
	            configurable: false,
	            writable: false,
	            value: this._debouncedScroll.call(this)
	        });
	
	        this.attach();
	    }
	
	    Object.defineProperties(OnScreen.prototype, {
	        _debouncedScroll: {
	            configurable: false,
	            writable: false,
	            enumerable: false,
	            value: debouncedScroll
	        },
	        attach: {
	            configurable: false,
	            writable: false,
	            enumerable: false,
	            value: attach
	        },
	        destroy: {
	            configurable: false,
	            writable: false,
	            enumerable: false,
	            value: destroy
	        },
	        off: {
	            configurable: false,
	            writable: false,
	            enumerable: false,
	            value: off
	        },
	        on: {
	            configurable: false,
	            writable: false,
	            enumerable: false,
	            value: on
	        }
	    });
	
	    OnScreen.check = inViewport;
	
	    return OnScreen;
	
	}));
	//# sourceMappingURL=on-screen.umd.js.map


/***/ }),
/* 126 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function($) {'use strict';
	
	var _parallax = __webpack_require__(127);
	
	$(function () {
	
	    var options = {
	        // optional
	    };
	
	    // on page load
	    (0, _parallax.initParallax)(options);
	
	    // custom event
	    $(window).on('initParallax', function (options) {
	        (0, _parallax.initParallax)(options);
	    });
	});
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(2)))

/***/ }),
/* 127 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function($) {'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.initParallax = initParallax;
	/* * * * * * * * * * * * * * * * * * * * * * * * * * * * * *
	
	Parallax
	
	*/
	
	$.fn.parallax = function (options) {
	    var $window = $(window);
	    var options = options || {};
	    var $this = $(this);
	    var timer;
	
	    var getScrollTop = options.getScrollTop || function (scrollTop, parentTop) {
	        return scrollTop - parentTop + $window.height();
	    };
	
	    var positionParallaxImage = function positionParallaxImage($gallery) {
	        var $parent = $gallery.parent();
	        var height = $gallery.parent().outerHeight();
	        var difference = $gallery.outerHeight() - $parent.outerHeight();
	        var scrollTop = getScrollTop($window.scrollTop(), $parent.offset().top);
	        var scrollProgress = scrollTop / ($window.height() + height);
	
	        if (options.updateCallback) {
	            options.updateCallback($gallery, difference, scrollProgress);
	        }
	
	        if (options.reversed) {
	            $gallery.css('transform', 'translate3d(0, -' + difference * scrollProgress + 'px, 0)').css('-webkit-transform', 'translate3d(0, -' + difference * scrollProgress + 'px, 0)');
	        } else {
	            $gallery.css('transform', 'translate3d(0, ' + (difference * scrollProgress - difference) + 'px, 0)').css('-webkit-transform', 'translate3d(0, ' + (difference * scrollProgress - difference) + 'px, 0)');
	        }
	    };
	
	    var loopCall = function loopCall() {
	        $this.each(function (key, value) {
	            positionParallaxImage($(value));
	        });
	    };
	
	    $window.scroll(function () {
	        loopCall();
	    });
	
	    $window.resize(function () {
	        loopCall();
	    });
	
	    loopCall();
	    setTimeout(function () {
	        loopCall();
	    }, 10);
	};
	
	function initParallax(options) {
	    // init
	    var options = options || {};
	    // available options and default values
	    if (!options.selector) {
	        options.selector = '.parallax-enabled .bg-image';
	    }
	    // no selector, no honey
	    if (options.selector) {
	        $(options.selector).parallax(options);
	    } else {
	        console.warn('parallax() requires CSS selector.');
	    }
	}
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(2)))

/***/ }),
/* 128 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function($) {'use strict';
	
	var _swiper = __webpack_require__(129);
	
	$(function () {
	
	    var options = {
	        // define options here
	    };
	
	    // on page load
	    (0, _swiper.initiSwiperInstances)(options);
	
	    // custom event
	    $(window).on('initiSwiperInstances', function () {
	        (0, _swiper.initiSwiperInstances)(options);
	    });
	}); /* * * * * * * * * * * * * * * * * * * * * * * * * * * * * *
	    
	    Swiper by iDangero.us
	    
	    API:
	    
	    http://idangero.us/swiper/api/
	    
	    */
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(2)))

/***/ }),
/* 129 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function($) {'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.initiSwiperInstances = initiSwiperInstances;
	
	var _swiper = __webpack_require__(130);
	
	var _swiper2 = _interopRequireDefault(_swiper);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function initiSwiperInstances(options) {
	
	    // initialize options
	    var options = options || {};
	
	    // available options with default values
	    if (!options.transitionDurationBetweenSlides) {
	        options.transitionDurationBetweenSlides = 1000;
	    }
	    if (!options.durationPerSlide) {
	        options.durationPerSlide = 4000;
	    }
	    if (!options.effect) {
	        options.effect = 'fade';
	    }
	    if (!options.slidesPerView) {
	        options.slidesPerView = 'auto';
	    }
	    if (typeof options.loop === 'undefined') {
	        options.loop = true;
	    }
	    if (!options.initialSlide) {
	        options.initialSlide = 0;
	    }
	    if (!options.fullscreen_active_class_delay) {
	        options.fullscreen_active_class_delay = 300;
	    }
	
	    // loop through instances (that have NOT been initialized yet)
	    $('.swiper-default:not(.swiper-initialized)').each(function (i) {
	        // init
	        var $swiper_instance = $(this);
	        // determine number of slides
	        var number_of_slides = $swiper_instance.find('.swiper-slide').length;
	        // no point in initializing swiper if there is only one slide
	        if (number_of_slides < 2) {
	            $swiper_instance.addClass('swiper-disabled');
	            return true;
	        }
	        // swiper counter dom node
	        var $counter = $swiper_instance.find('.swiper-counter');
	
	        if ($counter) {
	            $counter.addClass('active');
	        }
	
	        // local variable for loop. options.loop is a global setting for all swiper instances
	        var loop = options.loop;
	        // disable loop when attribute data-autoplay on .swiper-default element is present
	        if ($swiper_instance.attr('data-autoplay') === "false") {
	            loop = false;
	        }
	
	        // default
	        var mySwiper = new _swiper2.default($swiper_instance, {
	            // global settings
	            onInit: function onInit(swiper) {
	                // leave a flag when an instance has been initialized in order to prevent re-initialization
	                $swiper_instance.addClass('swiper-initialized');
	                // trigger custom event
	                $(window).trigger('initSoftpageTrigger');
	                $(window).trigger('swiper:initialized');
	
	                if ($counter) {
	                    $counter.children('.total').html(number_of_slides);
	                    $counter.children('.current').html(swiper.realIndex + 1);
	                }
	
	                // if loop is false, stop autoplay
	                if (!loop) {
	                    swiper.stopAutoplay();
	                }
	            },
	            onSlideChangeStart: function onSlideChangeStart(swiper) {
	                // if counter dom node exists in template
	                if ($counter) {
	                    $counter.children('.current').html(swiper.realIndex + 1);
	                }
	            },
	            effect: options.effect,
	            speed: options.transitionDurationBetweenSlides, // Number: Duration of transition between slides (in ms)
	            autoplay: options.durationPerSlide, // Number: Delay between transitions (in ms). If this parameter is not specified, auto play will be disabled
	            slidesPerView: options.slidesPerView,
	            spaceBetween: 30,
	            direction: 'horizontal',
	            loop: loop, // important: Set to 'false' when scrollbar is enabled
	            grabCursor: true,
	            initialSlide: options.initialSlide,
	
	            // If we need pagination
	            pagination: '.swiper-pagination',
	            paginationElement: 'span',
	            paginationClickable: true,
	
	            // Navigation arrows
	            nextButton: '.swiper-button-next',
	            prevButton: '.swiper-button-prev'
	        });
	
	        // enter fullscreen mode
	        $swiper_instance.find('[data-trigger-swiper-fullscreen]').on('click', function (e) {
	
	            // init
	            e.preventDefault();
	            var $swiper_fullscreen_container = $('.swiper-fullscreen-container');
	            var $swiper_fullscreen = $('.swiper-fullscreen');
	
	            // prevent scrolling while lightbox is opened
	            $('html').addClass('scrolling-disabled');
	
	            // stop autoplay of default swiper
	            mySwiper.stopAutoplay();
	
	            // clone container, remove all inline styles of old swiper instance
	
	            $swiper_fullscreen_container.children('.swiper-fullscreen').html($swiper_instance.clone()).children('.swiper-default').removeClass('swiper-initialized').find('*').removeAttr('style').find('.swiper-slide-duplicate').remove();
	
	            // set new options
	            var fullscreen_options = options;
	            fullscreen_options.initialSlide = mySwiper.realIndex;
	            fullscreen_options.loop = false;
	
	            setTimeout(function () {
	                // init dimensions
	                initSwiperFullscreenDimensions();
	                // init close click
	                initSwiperFullscreenClose($swiper_fullscreen_container, $swiper_fullscreen);
	                // hide softpage if open
	                if ($('.tingle-modal.softpage').hasClass('tingle-modal--visible')) {
	                    // do nothing
	                } else {
	                    $(window).trigger('showSiteOverlay');
	                }
	                // instanciate swiper
	                initiSwiperInstances(fullscreen_options);
	                // make gallery visible
	                $('html').addClass('swiper-fullscreen-visible');
	                // add some delay
	                setTimeout(function () {
	                    $swiper_fullscreen_container.addClass('active');
	                }, options.fullscreen_active_class_delay);
	            }, 10);
	        });
	
	        $('[data-close-swiper-fullscreen]').on('click', function (e) {
	            e.preventDefault();
	            closeSwiperFullscreen();
	        });
	
	        // Close Subnave when hitting ESC
	        $(document).keydown(function (evt) {
	            evt = evt || window.event;
	            var isEscape = false;
	            if ("key" in evt) {
	                isEscape = evt.key == "Escape";
	            } else {
	                isEscape = evt.keyCode == 27;
	            }
	            if (isEscape) {
	                // only call if the swiper is actually visible
	                if ($('html').hasClass('swiper-fullscreen-visible')) {
	                    closeSwiperFullscreen();
	                }
	            }
	        });
	    });
	} /* * * * * * * * * * * * * * * * * * * * * * * * * * * * * *
	  
	  Swiper by iDangero.us
	  
	  API:
	  
	  http://idangero.us/swiper/api/
	  
	  Custom Events:
	  
	  swiper:initialized
	  
	  To enable the fullscreen mode of Swiper
	  add the following markup at the end in the body tag in the base template:
	  
	  <div class="swiper-fullscreen-container">
	      <a href="#" class="swiper-button-fullscreen-close" data-softpage-disabled data-close-swiper-fullscreen>
	          <i class="sr-only" lang="en">
	              {% trans "Close" %}
	          </i>
	      </a>
	      <div class="swiper-fullscreen"></div>
	  </div>
	  
	  The associated styles need to be added in the project's _swiper.scss file.
	  
	  */
	
	function initSwiperFullscreenClose($swiper_fullscreen_container, $swiper_fullscreen) {
	
	    // close fullscreen gallery when clicking anywhere on the container
	    $swiper_fullscreen_container.on('click', function (e) {
	        closeSwiperFullscreen();
	    });
	
	    // prevent closing the gallery when clicking inside the gallery itself
	    $swiper_fullscreen.on('click', function (e) {
	        e.stopPropagation();
	    });
	}
	
	function setSwiperFullscreenDimensions($inner, $gallery) {
	    // determine browser window dimensions
	    var window_width = $(window).width();
	    var window_height = $(window).height();
	    // TBD: option to leave some space for captions or spacings
	    var available_height = window_height - 100;
	    // determine swiper dimensions
	    var swiper_width = $gallery.width();
	    var swiper_height = $gallery.height();
	    // the gallery doesn't fit into the window, let's reset the dimensions
	    if (swiper_height > available_height) {
	        var adjusted_swiper_height = available_height;
	        var adjusted_swiper_width = available_height * swiper_width / swiper_height;
	        $inner.width(adjusted_swiper_width);
	        $inner.height(adjusted_swiper_height);
	        $inner.addClass('dimensions-set');
	    } else {
	        // reset dimensions
	        $inner.css({
	            'width': '',
	            'height': ''
	        });
	        $inner.removeClass('dimensions-set');
	    }
	}
	
	function initSwiperFullscreenDimensions() {
	    var width_has_changed = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
	
	
	    // init
	    var $container = $('.swiper-fullscreen-container');
	    var $inner = $container.find('.swiper-fullscreen');
	    var $gallery = $container.find('.swiper-container');
	
	    if (width_has_changed) {
	        // reset dimensions
	        $inner.css({
	            'width': '',
	            'height': ''
	        });
	        // remove initialized flag
	        $gallery.removeClass('swiper-initialized');
	        setTimeout(function () {
	            setSwiperFullscreenDimensions($inner, $gallery);
	            setTimeout(function () {
	                initiSwiperInstances();
	            }, 10);
	        }, 50);
	    } else {
	        setSwiperFullscreenDimensions($inner, $gallery);
	    }
	}
	
	function closeSwiperFullscreen() {
	    setTimeout(function () {
	        // if we opened a fullscreen gallery from within softpage, keep the site overlay visible
	        if ($('.tingle-modal.softpage').hasClass('tingle-modal--visible')) {}
	        // nada
	
	        // otherwise, hide it!
	        else {
	                $(window).trigger('hideSiteOverlay');
	            }
	        $('html').removeClass('swiper-fullscreen-visible');
	        // init
	        var $swiper_fullscreen_container = $('.swiper-fullscreen-container');
	        var $swiper_fullscreen = $swiper_fullscreen_container.find('.swiper-fullscreen');
	        // remove active state
	        $swiper_fullscreen_container.removeClass('active');
	        // remove content
	        $swiper_fullscreen.empty();
	        // reset dimensions
	        $swiper_fullscreen.css({
	            'width': '',
	            'height': ''
	        });
	        // enable scrolling again
	        $('html').removeClass('scrolling-disabled');
	    }, 10);
	}
	
	$(window).on('viewportWidthHasChanged', function () {
	    var width_has_changed = true;
	    initSwiperFullscreenDimensions(width_has_changed);
	});
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(2)))

/***/ }),
/* 130 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(jQuery) {/**
	 * Swiper 3.4.2
	 * Most modern mobile touch slider and framework with hardware accelerated transitions
	 * 
	 * http://www.idangero.us/swiper/
	 * 
	 * Copyright 2017, Vladimir Kharlampidi
	 * The iDangero.us
	 * http://www.idangero.us/
	 * 
	 * Licensed under MIT
	 * 
	 * Released on: March 10, 2017
	 */
	(function () {
	    'use strict';
	    var $;
	
	    /*===========================
	    Swiper
	    ===========================*/
	    var Swiper = function (container, params) {
	        if (!(this instanceof Swiper)) return new Swiper(container, params);
	    
	
	        var defaults = {
	            direction: 'horizontal',
	            touchEventsTarget: 'container',
	            initialSlide: 0,
	            speed: 300,
	            // autoplay
	            autoplay: false,
	            autoplayDisableOnInteraction: true,
	            autoplayStopOnLast: false,
	            // To support iOS's swipe-to-go-back gesture (when being used in-app, with UIWebView).
	            iOSEdgeSwipeDetection: false,
	            iOSEdgeSwipeThreshold: 20,
	            // Free mode
	            freeMode: false,
	            freeModeMomentum: true,
	            freeModeMomentumRatio: 1,
	            freeModeMomentumBounce: true,
	            freeModeMomentumBounceRatio: 1,
	            freeModeMomentumVelocityRatio: 1,
	            freeModeSticky: false,
	            freeModeMinimumVelocity: 0.02,
	            // Autoheight
	            autoHeight: false,
	            // Set wrapper width
	            setWrapperSize: false,
	            // Virtual Translate
	            virtualTranslate: false,
	            // Effects
	            effect: 'slide', // 'slide' or 'fade' or 'cube' or 'coverflow' or 'flip'
	            coverflow: {
	                rotate: 50,
	                stretch: 0,
	                depth: 100,
	                modifier: 1,
	                slideShadows : true
	            },
	            flip: {
	                slideShadows : true,
	                limitRotation: true
	            },
	            cube: {
	                slideShadows: true,
	                shadow: true,
	                shadowOffset: 20,
	                shadowScale: 0.94
	            },
	            fade: {
	                crossFade: false
	            },
	            // Parallax
	            parallax: false,
	            // Zoom
	            zoom: false,
	            zoomMax: 3,
	            zoomMin: 1,
	            zoomToggle: true,
	            // Scrollbar
	            scrollbar: null,
	            scrollbarHide: true,
	            scrollbarDraggable: false,
	            scrollbarSnapOnRelease: false,
	            // Keyboard Mousewheel
	            keyboardControl: false,
	            mousewheelControl: false,
	            mousewheelReleaseOnEdges: false,
	            mousewheelInvert: false,
	            mousewheelForceToAxis: false,
	            mousewheelSensitivity: 1,
	            mousewheelEventsTarged: 'container',
	            // Hash Navigation
	            hashnav: false,
	            hashnavWatchState: false,
	            // History
	            history: false,
	            // Commong Nav State
	            replaceState: false,
	            // Breakpoints
	            breakpoints: undefined,
	            // Slides grid
	            spaceBetween: 0,
	            slidesPerView: 1,
	            slidesPerColumn: 1,
	            slidesPerColumnFill: 'column',
	            slidesPerGroup: 1,
	            centeredSlides: false,
	            slidesOffsetBefore: 0, // in px
	            slidesOffsetAfter: 0, // in px
	            // Round length
	            roundLengths: false,
	            // Touches
	            touchRatio: 1,
	            touchAngle: 45,
	            simulateTouch: true,
	            shortSwipes: true,
	            longSwipes: true,
	            longSwipesRatio: 0.5,
	            longSwipesMs: 300,
	            followFinger: true,
	            onlyExternal: false,
	            threshold: 0,
	            touchMoveStopPropagation: true,
	            touchReleaseOnEdges: false,
	            // Unique Navigation Elements
	            uniqueNavElements: true,
	            // Pagination
	            pagination: null,
	            paginationElement: 'span',
	            paginationClickable: false,
	            paginationHide: false,
	            paginationBulletRender: null,
	            paginationProgressRender: null,
	            paginationFractionRender: null,
	            paginationCustomRender: null,
	            paginationType: 'bullets', // 'bullets' or 'progress' or 'fraction' or 'custom'
	            // Resistance
	            resistance: true,
	            resistanceRatio: 0.85,
	            // Next/prev buttons
	            nextButton: null,
	            prevButton: null,
	            // Progress
	            watchSlidesProgress: false,
	            watchSlidesVisibility: false,
	            // Cursor
	            grabCursor: false,
	            // Clicks
	            preventClicks: true,
	            preventClicksPropagation: true,
	            slideToClickedSlide: false,
	            // Lazy Loading
	            lazyLoading: false,
	            lazyLoadingInPrevNext: false,
	            lazyLoadingInPrevNextAmount: 1,
	            lazyLoadingOnTransitionStart: false,
	            // Images
	            preloadImages: true,
	            updateOnImagesReady: true,
	            // loop
	            loop: false,
	            loopAdditionalSlides: 0,
	            loopedSlides: null,
	            // Control
	            control: undefined,
	            controlInverse: false,
	            controlBy: 'slide', //or 'container'
	            normalizeSlideIndex: true,
	            // Swiping/no swiping
	            allowSwipeToPrev: true,
	            allowSwipeToNext: true,
	            swipeHandler: null, //'.swipe-handler',
	            noSwiping: true,
	            noSwipingClass: 'swiper-no-swiping',
	            // Passive Listeners
	            passiveListeners: true,
	            // NS
	            containerModifierClass: 'swiper-container-', // NEW
	            slideClass: 'swiper-slide',
	            slideActiveClass: 'swiper-slide-active',
	            slideDuplicateActiveClass: 'swiper-slide-duplicate-active',
	            slideVisibleClass: 'swiper-slide-visible',
	            slideDuplicateClass: 'swiper-slide-duplicate',
	            slideNextClass: 'swiper-slide-next',
	            slideDuplicateNextClass: 'swiper-slide-duplicate-next',
	            slidePrevClass: 'swiper-slide-prev',
	            slideDuplicatePrevClass: 'swiper-slide-duplicate-prev',
	            wrapperClass: 'swiper-wrapper',
	            bulletClass: 'swiper-pagination-bullet',
	            bulletActiveClass: 'swiper-pagination-bullet-active',
	            buttonDisabledClass: 'swiper-button-disabled',
	            paginationCurrentClass: 'swiper-pagination-current',
	            paginationTotalClass: 'swiper-pagination-total',
	            paginationHiddenClass: 'swiper-pagination-hidden',
	            paginationProgressbarClass: 'swiper-pagination-progressbar',
	            paginationClickableClass: 'swiper-pagination-clickable', // NEW
	            paginationModifierClass: 'swiper-pagination-', // NEW
	            lazyLoadingClass: 'swiper-lazy',
	            lazyStatusLoadingClass: 'swiper-lazy-loading',
	            lazyStatusLoadedClass: 'swiper-lazy-loaded',
	            lazyPreloaderClass: 'swiper-lazy-preloader',
	            notificationClass: 'swiper-notification',
	            preloaderClass: 'preloader',
	            zoomContainerClass: 'swiper-zoom-container',
	        
	            // Observer
	            observer: false,
	            observeParents: false,
	            // Accessibility
	            a11y: false,
	            prevSlideMessage: 'Previous slide',
	            nextSlideMessage: 'Next slide',
	            firstSlideMessage: 'This is the first slide',
	            lastSlideMessage: 'This is the last slide',
	            paginationBulletMessage: 'Go to slide {{index}}',
	            // Callbacks
	            runCallbacksOnInit: true
	            /*
	            Callbacks:
	            onInit: function (swiper)
	            onDestroy: function (swiper)
	            onBeforeResize: function (swiper)
	            onAfterResize: function (swiper)
	            onClick: function (swiper, e)
	            onTap: function (swiper, e)
	            onDoubleTap: function (swiper, e)
	            onSliderMove: function (swiper, e)
	            onSlideChangeStart: function (swiper)
	            onSlideChangeEnd: function (swiper)
	            onTransitionStart: function (swiper)
	            onTransitionEnd: function (swiper)
	            onImagesReady: function (swiper)
	            onProgress: function (swiper, progress)
	            onTouchStart: function (swiper, e)
	            onTouchMove: function (swiper, e)
	            onTouchMoveOpposite: function (swiper, e)
	            onTouchEnd: function (swiper, e)
	            onReachBeginning: function (swiper)
	            onReachEnd: function (swiper)
	            onSetTransition: function (swiper, duration)
	            onSetTranslate: function (swiper, translate)
	            onAutoplayStart: function (swiper)
	            onAutoplayStop: function (swiper),
	            onLazyImageLoad: function (swiper, slide, image)
	            onLazyImageReady: function (swiper, slide, image)
	            onKeyPress: function (swiper, keyCode)
	            */
	        
	        };
	        var initialVirtualTranslate = params && params.virtualTranslate;
	        
	        params = params || {};
	        var originalParams = {};
	        for (var param in params) {
	            if (typeof params[param] === 'object' && params[param] !== null && !(params[param].nodeType || params[param] === window || params[param] === document || (typeof Dom7 !== 'undefined' && params[param] instanceof Dom7) || (typeof jQuery !== 'undefined' && params[param] instanceof jQuery))) {
	                originalParams[param] = {};
	                for (var deepParam in params[param]) {
	                    originalParams[param][deepParam] = params[param][deepParam];
	                }
	            }
	            else {
	                originalParams[param] = params[param];
	            }
	        }
	        for (var def in defaults) {
	            if (typeof params[def] === 'undefined') {
	                params[def] = defaults[def];
	            }
	            else if (typeof params[def] === 'object') {
	                for (var deepDef in defaults[def]) {
	                    if (typeof params[def][deepDef] === 'undefined') {
	                        params[def][deepDef] = defaults[def][deepDef];
	                    }
	                }
	            }
	        }
	        
	        // Swiper
	        var s = this;
	        
	        // Params
	        s.params = params;
	        s.originalParams = originalParams;
	        
	        // Classname
	        s.classNames = [];
	        /*=========================
	          Dom Library and plugins
	          ===========================*/
	        if (typeof $ !== 'undefined' && typeof Dom7 !== 'undefined'){
	            $ = Dom7;
	        }
	        if (typeof $ === 'undefined') {
	            if (typeof Dom7 === 'undefined') {
	                $ = window.Dom7 || window.Zepto || window.jQuery;
	            }
	            else {
	                $ = Dom7;
	            }
	            if (!$) return;
	        }
	        // Export it to Swiper instance
	        s.$ = $;
	        
	        /*=========================
	          Breakpoints
	          ===========================*/
	        s.currentBreakpoint = undefined;
	        s.getActiveBreakpoint = function () {
	            //Get breakpoint for window width
	            if (!s.params.breakpoints) return false;
	            var breakpoint = false;
	            var points = [], point;
	            for ( point in s.params.breakpoints ) {
	                if (s.params.breakpoints.hasOwnProperty(point)) {
	                    points.push(point);
	                }
	            }
	            points.sort(function (a, b) {
	                return parseInt(a, 10) > parseInt(b, 10);
	            });
	            for (var i = 0; i < points.length; i++) {
	                point = points[i];
	                if (point >= window.innerWidth && !breakpoint) {
	                    breakpoint = point;
	                }
	            }
	            return breakpoint || 'max';
	        };
	        s.setBreakpoint = function () {
	            //Set breakpoint for window width and update parameters
	            var breakpoint = s.getActiveBreakpoint();
	            if (breakpoint && s.currentBreakpoint !== breakpoint) {
	                var breakPointsParams = breakpoint in s.params.breakpoints ? s.params.breakpoints[breakpoint] : s.originalParams;
	                var needsReLoop = s.params.loop && (breakPointsParams.slidesPerView !== s.params.slidesPerView);
	                for ( var param in breakPointsParams ) {
	                    s.params[param] = breakPointsParams[param];
	                }
	                s.currentBreakpoint = breakpoint;
	                if(needsReLoop && s.destroyLoop) {
	                    s.reLoop(true);
	                }
	            }
	        };
	        // Set breakpoint on load
	        if (s.params.breakpoints) {
	            s.setBreakpoint();
	        }
	        
	        /*=========================
	          Preparation - Define Container, Wrapper and Pagination
	          ===========================*/
	        s.container = $(container);
	        if (s.container.length === 0) return;
	        if (s.container.length > 1) {
	            var swipers = [];
	            s.container.each(function () {
	                var container = this;
	                swipers.push(new Swiper(this, params));
	            });
	            return swipers;
	        }
	        
	        // Save instance in container HTML Element and in data
	        s.container[0].swiper = s;
	        s.container.data('swiper', s);
	        
	        s.classNames.push(s.params.containerModifierClass + s.params.direction);
	        
	        if (s.params.freeMode) {
	            s.classNames.push(s.params.containerModifierClass + 'free-mode');
	        }
	        if (!s.support.flexbox) {
	            s.classNames.push(s.params.containerModifierClass + 'no-flexbox');
	            s.params.slidesPerColumn = 1;
	        }
	        if (s.params.autoHeight) {
	            s.classNames.push(s.params.containerModifierClass + 'autoheight');
	        }
	        // Enable slides progress when required
	        if (s.params.parallax || s.params.watchSlidesVisibility) {
	            s.params.watchSlidesProgress = true;
	        }
	        // Max resistance when touchReleaseOnEdges
	        if (s.params.touchReleaseOnEdges) {
	            s.params.resistanceRatio = 0;
	        }
	        // Coverflow / 3D
	        if (['cube', 'coverflow', 'flip'].indexOf(s.params.effect) >= 0) {
	            if (s.support.transforms3d) {
	                s.params.watchSlidesProgress = true;
	                s.classNames.push(s.params.containerModifierClass + '3d');
	            }
	            else {
	                s.params.effect = 'slide';
	            }
	        }
	        if (s.params.effect !== 'slide') {
	            s.classNames.push(s.params.containerModifierClass + s.params.effect);
	        }
	        if (s.params.effect === 'cube') {
	            s.params.resistanceRatio = 0;
	            s.params.slidesPerView = 1;
	            s.params.slidesPerColumn = 1;
	            s.params.slidesPerGroup = 1;
	            s.params.centeredSlides = false;
	            s.params.spaceBetween = 0;
	            s.params.virtualTranslate = true;
	        }
	        if (s.params.effect === 'fade' || s.params.effect === 'flip') {
	            s.params.slidesPerView = 1;
	            s.params.slidesPerColumn = 1;
	            s.params.slidesPerGroup = 1;
	            s.params.watchSlidesProgress = true;
	            s.params.spaceBetween = 0;
	            if (typeof initialVirtualTranslate === 'undefined') {
	                s.params.virtualTranslate = true;
	            }
	        }
	        
	        // Grab Cursor
	        if (s.params.grabCursor && s.support.touch) {
	            s.params.grabCursor = false;
	        }
	        
	        // Wrapper
	        s.wrapper = s.container.children('.' + s.params.wrapperClass);
	        
	        // Pagination
	        if (s.params.pagination) {
	            s.paginationContainer = $(s.params.pagination);
	            if (s.params.uniqueNavElements && typeof s.params.pagination === 'string' && s.paginationContainer.length > 1 && s.container.find(s.params.pagination).length === 1) {
	                s.paginationContainer = s.container.find(s.params.pagination);
	            }
	        
	            if (s.params.paginationType === 'bullets' && s.params.paginationClickable) {
	                s.paginationContainer.addClass(s.params.paginationModifierClass + 'clickable');
	            }
	            else {
	                s.params.paginationClickable = false;
	            }
	            s.paginationContainer.addClass(s.params.paginationModifierClass + s.params.paginationType);
	        }
	        // Next/Prev Buttons
	        if (s.params.nextButton || s.params.prevButton) {
	            if (s.params.nextButton) {
	                s.nextButton = $(s.params.nextButton);
	                if (s.params.uniqueNavElements && typeof s.params.nextButton === 'string' && s.nextButton.length > 1 && s.container.find(s.params.nextButton).length === 1) {
	                    s.nextButton = s.container.find(s.params.nextButton);
	                }
	            }
	            if (s.params.prevButton) {
	                s.prevButton = $(s.params.prevButton);
	                if (s.params.uniqueNavElements && typeof s.params.prevButton === 'string' && s.prevButton.length > 1 && s.container.find(s.params.prevButton).length === 1) {
	                    s.prevButton = s.container.find(s.params.prevButton);
	                }
	            }
	        }
	        
	        // Is Horizontal
	        s.isHorizontal = function () {
	            return s.params.direction === 'horizontal';
	        };
	        // s.isH = isH;
	        
	        // RTL
	        s.rtl = s.isHorizontal() && (s.container[0].dir.toLowerCase() === 'rtl' || s.container.css('direction') === 'rtl');
	        if (s.rtl) {
	            s.classNames.push(s.params.containerModifierClass + 'rtl');
	        }
	        
	        // Wrong RTL support
	        if (s.rtl) {
	            s.wrongRTL = s.wrapper.css('display') === '-webkit-box';
	        }
	        
	        // Columns
	        if (s.params.slidesPerColumn > 1) {
	            s.classNames.push(s.params.containerModifierClass + 'multirow');
	        }
	        
	        // Check for Android
	        if (s.device.android) {
	            s.classNames.push(s.params.containerModifierClass + 'android');
	        }
	        
	        // Add classes
	        s.container.addClass(s.classNames.join(' '));
	        
	        // Translate
	        s.translate = 0;
	        
	        // Progress
	        s.progress = 0;
	        
	        // Velocity
	        s.velocity = 0;
	        
	        /*=========================
	          Locks, unlocks
	          ===========================*/
	        s.lockSwipeToNext = function () {
	            s.params.allowSwipeToNext = false;
	            if (s.params.allowSwipeToPrev === false && s.params.grabCursor) {
	                s.unsetGrabCursor();
	            }
	        };
	        s.lockSwipeToPrev = function () {
	            s.params.allowSwipeToPrev = false;
	            if (s.params.allowSwipeToNext === false && s.params.grabCursor) {
	                s.unsetGrabCursor();
	            }
	        };
	        s.lockSwipes = function () {
	            s.params.allowSwipeToNext = s.params.allowSwipeToPrev = false;
	            if (s.params.grabCursor) s.unsetGrabCursor();
	        };
	        s.unlockSwipeToNext = function () {
	            s.params.allowSwipeToNext = true;
	            if (s.params.allowSwipeToPrev === true && s.params.grabCursor) {
	                s.setGrabCursor();
	            }
	        };
	        s.unlockSwipeToPrev = function () {
	            s.params.allowSwipeToPrev = true;
	            if (s.params.allowSwipeToNext === true && s.params.grabCursor) {
	                s.setGrabCursor();
	            }
	        };
	        s.unlockSwipes = function () {
	            s.params.allowSwipeToNext = s.params.allowSwipeToPrev = true;
	            if (s.params.grabCursor) s.setGrabCursor();
	        };
	        
	        /*=========================
	          Round helper
	          ===========================*/
	        function round(a) {
	            return Math.floor(a);
	        }
	        /*=========================
	          Set grab cursor
	          ===========================*/
	        s.setGrabCursor = function(moving) {
	            s.container[0].style.cursor = 'move';
	            s.container[0].style.cursor = moving ? '-webkit-grabbing' : '-webkit-grab';
	            s.container[0].style.cursor = moving ? '-moz-grabbin' : '-moz-grab';
	            s.container[0].style.cursor = moving ? 'grabbing': 'grab';
	        };
	        s.unsetGrabCursor = function () {
	            s.container[0].style.cursor = '';
	        };
	        if (s.params.grabCursor) {
	            s.setGrabCursor();
	        }
	        /*=========================
	          Update on Images Ready
	          ===========================*/
	        s.imagesToLoad = [];
	        s.imagesLoaded = 0;
	        
	        s.loadImage = function (imgElement, src, srcset, sizes, checkForComplete, callback) {
	            var image;
	            function onReady () {
	                if (callback) callback();
	            }
	            if (!imgElement.complete || !checkForComplete) {
	                if (src) {
	                    image = new window.Image();
	                    image.onload = onReady;
	                    image.onerror = onReady;
	                    if (sizes) {
	                        image.sizes = sizes;
	                    }
	                    if (srcset) {
	                        image.srcset = srcset;
	                    }
	                    if (src) {
	                        image.src = src;
	                    }
	                } else {
	                    onReady();
	                }
	        
	            } else {//image already loaded...
	                onReady();
	            }
	        };
	        s.preloadImages = function () {
	            s.imagesToLoad = s.container.find('img');
	            function _onReady() {
	                if (typeof s === 'undefined' || s === null || !s) return;
	                if (s.imagesLoaded !== undefined) s.imagesLoaded++;
	                if (s.imagesLoaded === s.imagesToLoad.length) {
	                    if (s.params.updateOnImagesReady) s.update();
	                    s.emit('onImagesReady', s);
	                }
	            }
	            for (var i = 0; i < s.imagesToLoad.length; i++) {
	                s.loadImage(s.imagesToLoad[i], (s.imagesToLoad[i].currentSrc || s.imagesToLoad[i].getAttribute('src')), (s.imagesToLoad[i].srcset || s.imagesToLoad[i].getAttribute('srcset')), s.imagesToLoad[i].sizes || s.imagesToLoad[i].getAttribute('sizes'), true, _onReady);
	            }
	        };
	        
	        /*=========================
	          Autoplay
	          ===========================*/
	        s.autoplayTimeoutId = undefined;
	        s.autoplaying = false;
	        s.autoplayPaused = false;
	        function autoplay() {
	            var autoplayDelay = s.params.autoplay;
	            var activeSlide = s.slides.eq(s.activeIndex);
	            if (activeSlide.attr('data-swiper-autoplay')) {
	                autoplayDelay = activeSlide.attr('data-swiper-autoplay') || s.params.autoplay;
	            }
	            s.autoplayTimeoutId = setTimeout(function () {
	                if (s.params.loop) {
	                    s.fixLoop();
	                    s._slideNext();
	                    s.emit('onAutoplay', s);
	                }
	                else {
	                    if (!s.isEnd) {
	                        s._slideNext();
	                        s.emit('onAutoplay', s);
	                    }
	                    else {
	                        if (!params.autoplayStopOnLast) {
	                            s._slideTo(0);
	                            s.emit('onAutoplay', s);
	                        }
	                        else {
	                            s.stopAutoplay();
	                        }
	                    }
	                }
	            }, autoplayDelay);
	        }
	        s.startAutoplay = function () {
	            if (typeof s.autoplayTimeoutId !== 'undefined') return false;
	            if (!s.params.autoplay) return false;
	            if (s.autoplaying) return false;
	            s.autoplaying = true;
	            s.emit('onAutoplayStart', s);
	            autoplay();
	        };
	        s.stopAutoplay = function (internal) {
	            if (!s.autoplayTimeoutId) return;
	            if (s.autoplayTimeoutId) clearTimeout(s.autoplayTimeoutId);
	            s.autoplaying = false;
	            s.autoplayTimeoutId = undefined;
	            s.emit('onAutoplayStop', s);
	        };
	        s.pauseAutoplay = function (speed) {
	            if (s.autoplayPaused) return;
	            if (s.autoplayTimeoutId) clearTimeout(s.autoplayTimeoutId);
	            s.autoplayPaused = true;
	            if (speed === 0) {
	                s.autoplayPaused = false;
	                autoplay();
	            }
	            else {
	                s.wrapper.transitionEnd(function () {
	                    if (!s) return;
	                    s.autoplayPaused = false;
	                    if (!s.autoplaying) {
	                        s.stopAutoplay();
	                    }
	                    else {
	                        autoplay();
	                    }
	                });
	            }
	        };
	        /*=========================
	          Min/Max Translate
	          ===========================*/
	        s.minTranslate = function () {
	            return (-s.snapGrid[0]);
	        };
	        s.maxTranslate = function () {
	            return (-s.snapGrid[s.snapGrid.length - 1]);
	        };
	        /*=========================
	          Slider/slides sizes
	          ===========================*/
	        s.updateAutoHeight = function () {
	            var activeSlides = [];
	            var newHeight = 0;
	            var i;
	        
	            // Find slides currently in view
	            if(s.params.slidesPerView !== 'auto' && s.params.slidesPerView > 1) {
	                for (i = 0; i < Math.ceil(s.params.slidesPerView); i++) {
	                    var index = s.activeIndex + i;
	                    if(index > s.slides.length) break;
	                    activeSlides.push(s.slides.eq(index)[0]);
	                }
	            } else {
	                activeSlides.push(s.slides.eq(s.activeIndex)[0]);
	            }
	        
	            // Find new height from heighest slide in view
	            for (i = 0; i < activeSlides.length; i++) {
	                if (typeof activeSlides[i] !== 'undefined') {
	                    var height = activeSlides[i].offsetHeight;
	                    newHeight = height > newHeight ? height : newHeight;
	                }
	            }
	        
	            // Update Height
	            if (newHeight) s.wrapper.css('height', newHeight + 'px');
	        };
	        s.updateContainerSize = function () {
	            var width, height;
	            if (typeof s.params.width !== 'undefined') {
	                width = s.params.width;
	            }
	            else {
	                width = s.container[0].clientWidth;
	            }
	            if (typeof s.params.height !== 'undefined') {
	                height = s.params.height;
	            }
	            else {
	                height = s.container[0].clientHeight;
	            }
	            if (width === 0 && s.isHorizontal() || height === 0 && !s.isHorizontal()) {
	                return;
	            }
	        
	            //Subtract paddings
	            width = width - parseInt(s.container.css('padding-left'), 10) - parseInt(s.container.css('padding-right'), 10);
	            height = height - parseInt(s.container.css('padding-top'), 10) - parseInt(s.container.css('padding-bottom'), 10);
	        
	            // Store values
	            s.width = width;
	            s.height = height;
	            s.size = s.isHorizontal() ? s.width : s.height;
	        };
	        
	        s.updateSlidesSize = function () {
	            s.slides = s.wrapper.children('.' + s.params.slideClass);
	            s.snapGrid = [];
	            s.slidesGrid = [];
	            s.slidesSizesGrid = [];
	        
	            var spaceBetween = s.params.spaceBetween,
	                slidePosition = -s.params.slidesOffsetBefore,
	                i,
	                prevSlideSize = 0,
	                index = 0;
	            if (typeof s.size === 'undefined') return;
	            if (typeof spaceBetween === 'string' && spaceBetween.indexOf('%') >= 0) {
	                spaceBetween = parseFloat(spaceBetween.replace('%', '')) / 100 * s.size;
	            }
	        
	            s.virtualSize = -spaceBetween;
	            // reset margins
	            if (s.rtl) s.slides.css({marginLeft: '', marginTop: ''});
	            else s.slides.css({marginRight: '', marginBottom: ''});
	        
	            var slidesNumberEvenToRows;
	            if (s.params.slidesPerColumn > 1) {
	                if (Math.floor(s.slides.length / s.params.slidesPerColumn) === s.slides.length / s.params.slidesPerColumn) {
	                    slidesNumberEvenToRows = s.slides.length;
	                }
	                else {
	                    slidesNumberEvenToRows = Math.ceil(s.slides.length / s.params.slidesPerColumn) * s.params.slidesPerColumn;
	                }
	                if (s.params.slidesPerView !== 'auto' && s.params.slidesPerColumnFill === 'row') {
	                    slidesNumberEvenToRows = Math.max(slidesNumberEvenToRows, s.params.slidesPerView * s.params.slidesPerColumn);
	                }
	            }
	        
	            // Calc slides
	            var slideSize;
	            var slidesPerColumn = s.params.slidesPerColumn;
	            var slidesPerRow = slidesNumberEvenToRows / slidesPerColumn;
	            var numFullColumns = slidesPerRow - (s.params.slidesPerColumn * slidesPerRow - s.slides.length);
	            for (i = 0; i < s.slides.length; i++) {
	                slideSize = 0;
	                var slide = s.slides.eq(i);
	                if (s.params.slidesPerColumn > 1) {
	                    // Set slides order
	                    var newSlideOrderIndex;
	                    var column, row;
	                    if (s.params.slidesPerColumnFill === 'column') {
	                        column = Math.floor(i / slidesPerColumn);
	                        row = i - column * slidesPerColumn;
	                        if (column > numFullColumns || (column === numFullColumns && row === slidesPerColumn-1)) {
	                            if (++row >= slidesPerColumn) {
	                                row = 0;
	                                column++;
	                            }
	                        }
	                        newSlideOrderIndex = column + row * slidesNumberEvenToRows / slidesPerColumn;
	                        slide
	                            .css({
	                                '-webkit-box-ordinal-group': newSlideOrderIndex,
	                                '-moz-box-ordinal-group': newSlideOrderIndex,
	                                '-ms-flex-order': newSlideOrderIndex,
	                                '-webkit-order': newSlideOrderIndex,
	                                'order': newSlideOrderIndex
	                            });
	                    }
	                    else {
	                        row = Math.floor(i / slidesPerRow);
	                        column = i - row * slidesPerRow;
	                    }
	                    slide
	                        .css(
	                            'margin-' + (s.isHorizontal() ? 'top' : 'left'),
	                            (row !== 0 && s.params.spaceBetween) && (s.params.spaceBetween + 'px')
	                        )
	                        .attr('data-swiper-column', column)
	                        .attr('data-swiper-row', row);
	        
	                }
	                if (slide.css('display') === 'none') continue;
	                if (s.params.slidesPerView === 'auto') {
	                    slideSize = s.isHorizontal() ? slide.outerWidth(true) : slide.outerHeight(true);
	                    if (s.params.roundLengths) slideSize = round(slideSize);
	                }
	                else {
	                    slideSize = (s.size - (s.params.slidesPerView - 1) * spaceBetween) / s.params.slidesPerView;
	                    if (s.params.roundLengths) slideSize = round(slideSize);
	        
	                    if (s.isHorizontal()) {
	                        s.slides[i].style.width = slideSize + 'px';
	                    }
	                    else {
	                        s.slides[i].style.height = slideSize + 'px';
	                    }
	                }
	                s.slides[i].swiperSlideSize = slideSize;
	                s.slidesSizesGrid.push(slideSize);
	        
	        
	                if (s.params.centeredSlides) {
	                    slidePosition = slidePosition + slideSize / 2 + prevSlideSize / 2 + spaceBetween;
	                    if(prevSlideSize === 0 && i !== 0) slidePosition = slidePosition - s.size / 2 - spaceBetween;
	                    if (i === 0) slidePosition = slidePosition - s.size / 2 - spaceBetween;
	                    if (Math.abs(slidePosition) < 1 / 1000) slidePosition = 0;
	                    if ((index) % s.params.slidesPerGroup === 0) s.snapGrid.push(slidePosition);
	                    s.slidesGrid.push(slidePosition);
	                }
	                else {
	                    if ((index) % s.params.slidesPerGroup === 0) s.snapGrid.push(slidePosition);
	                    s.slidesGrid.push(slidePosition);
	                    slidePosition = slidePosition + slideSize + spaceBetween;
	                }
	        
	                s.virtualSize += slideSize + spaceBetween;
	        
	                prevSlideSize = slideSize;
	        
	                index ++;
	            }
	            s.virtualSize = Math.max(s.virtualSize, s.size) + s.params.slidesOffsetAfter;
	            var newSlidesGrid;
	        
	            if (
	                s.rtl && s.wrongRTL && (s.params.effect === 'slide' || s.params.effect === 'coverflow')) {
	                s.wrapper.css({width: s.virtualSize + s.params.spaceBetween + 'px'});
	            }
	            if (!s.support.flexbox || s.params.setWrapperSize) {
	                if (s.isHorizontal()) s.wrapper.css({width: s.virtualSize + s.params.spaceBetween + 'px'});
	                else s.wrapper.css({height: s.virtualSize + s.params.spaceBetween + 'px'});
	            }
	        
	            if (s.params.slidesPerColumn > 1) {
	                s.virtualSize = (slideSize + s.params.spaceBetween) * slidesNumberEvenToRows;
	                s.virtualSize = Math.ceil(s.virtualSize / s.params.slidesPerColumn) - s.params.spaceBetween;
	                if (s.isHorizontal()) s.wrapper.css({width: s.virtualSize + s.params.spaceBetween + 'px'});
	                else s.wrapper.css({height: s.virtualSize + s.params.spaceBetween + 'px'});
	                if (s.params.centeredSlides) {
	                    newSlidesGrid = [];
	                    for (i = 0; i < s.snapGrid.length; i++) {
	                        if (s.snapGrid[i] < s.virtualSize + s.snapGrid[0]) newSlidesGrid.push(s.snapGrid[i]);
	                    }
	                    s.snapGrid = newSlidesGrid;
	                }
	            }
	        
	            // Remove last grid elements depending on width
	            if (!s.params.centeredSlides) {
	                newSlidesGrid = [];
	                for (i = 0; i < s.snapGrid.length; i++) {
	                    if (s.snapGrid[i] <= s.virtualSize - s.size) {
	                        newSlidesGrid.push(s.snapGrid[i]);
	                    }
	                }
	                s.snapGrid = newSlidesGrid;
	                if (Math.floor(s.virtualSize - s.size) - Math.floor(s.snapGrid[s.snapGrid.length - 1]) > 1) {
	                    s.snapGrid.push(s.virtualSize - s.size);
	                }
	            }
	            if (s.snapGrid.length === 0) s.snapGrid = [0];
	        
	            if (s.params.spaceBetween !== 0) {
	                if (s.isHorizontal()) {
	                    if (s.rtl) s.slides.css({marginLeft: spaceBetween + 'px'});
	                    else s.slides.css({marginRight: spaceBetween + 'px'});
	                }
	                else s.slides.css({marginBottom: spaceBetween + 'px'});
	            }
	            if (s.params.watchSlidesProgress) {
	                s.updateSlidesOffset();
	            }
	        };
	        s.updateSlidesOffset = function () {
	            for (var i = 0; i < s.slides.length; i++) {
	                s.slides[i].swiperSlideOffset = s.isHorizontal() ? s.slides[i].offsetLeft : s.slides[i].offsetTop;
	            }
	        };
	        
	        /*=========================
	          Dynamic Slides Per View
	          ===========================*/
	        s.currentSlidesPerView = function () {
	            var spv = 1, i, j;
	            if (s.params.centeredSlides) {
	                var size = s.slides[s.activeIndex].swiperSlideSize;
	                var breakLoop;
	                for (i = s.activeIndex + 1; i < s.slides.length; i++) {
	                    if (s.slides[i] && !breakLoop) {
	                        size += s.slides[i].swiperSlideSize;
	                        spv ++;
	                        if (size > s.size) breakLoop = true;
	                    }
	                }
	                for (j = s.activeIndex - 1; j >= 0; j--) {
	                    if (s.slides[j] && !breakLoop) {
	                        size += s.slides[j].swiperSlideSize;
	                        spv ++;
	                        if (size > s.size) breakLoop = true;
	                    }
	                }
	            }
	            else {
	                for (i = s.activeIndex + 1; i < s.slides.length; i++) {
	                    if (s.slidesGrid[i] - s.slidesGrid[s.activeIndex] < s.size) {
	                        spv++;
	                    }
	                }
	            }
	            return spv;
	        };
	        /*=========================
	          Slider/slides progress
	          ===========================*/
	        s.updateSlidesProgress = function (translate) {
	            if (typeof translate === 'undefined') {
	                translate = s.translate || 0;
	            }
	            if (s.slides.length === 0) return;
	            if (typeof s.slides[0].swiperSlideOffset === 'undefined') s.updateSlidesOffset();
	        
	            var offsetCenter = -translate;
	            if (s.rtl) offsetCenter = translate;
	        
	            // Visible Slides
	            s.slides.removeClass(s.params.slideVisibleClass);
	            for (var i = 0; i < s.slides.length; i++) {
	                var slide = s.slides[i];
	                var slideProgress = (offsetCenter + (s.params.centeredSlides ? s.minTranslate() : 0) - slide.swiperSlideOffset) / (slide.swiperSlideSize + s.params.spaceBetween);
	                if (s.params.watchSlidesVisibility) {
	                    var slideBefore = -(offsetCenter - slide.swiperSlideOffset);
	                    var slideAfter = slideBefore + s.slidesSizesGrid[i];
	                    var isVisible =
	                        (slideBefore >= 0 && slideBefore < s.size) ||
	                        (slideAfter > 0 && slideAfter <= s.size) ||
	                        (slideBefore <= 0 && slideAfter >= s.size);
	                    if (isVisible) {
	                        s.slides.eq(i).addClass(s.params.slideVisibleClass);
	                    }
	                }
	                slide.progress = s.rtl ? -slideProgress : slideProgress;
	            }
	        };
	        s.updateProgress = function (translate) {
	            if (typeof translate === 'undefined') {
	                translate = s.translate || 0;
	            }
	            var translatesDiff = s.maxTranslate() - s.minTranslate();
	            var wasBeginning = s.isBeginning;
	            var wasEnd = s.isEnd;
	            if (translatesDiff === 0) {
	                s.progress = 0;
	                s.isBeginning = s.isEnd = true;
	            }
	            else {
	                s.progress = (translate - s.minTranslate()) / (translatesDiff);
	                s.isBeginning = s.progress <= 0;
	                s.isEnd = s.progress >= 1;
	            }
	            if (s.isBeginning && !wasBeginning) s.emit('onReachBeginning', s);
	            if (s.isEnd && !wasEnd) s.emit('onReachEnd', s);
	        
	            if (s.params.watchSlidesProgress) s.updateSlidesProgress(translate);
	            s.emit('onProgress', s, s.progress);
	        };
	        s.updateActiveIndex = function () {
	            var translate = s.rtl ? s.translate : -s.translate;
	            var newActiveIndex, i, snapIndex;
	            for (i = 0; i < s.slidesGrid.length; i ++) {
	                if (typeof s.slidesGrid[i + 1] !== 'undefined') {
	                    if (translate >= s.slidesGrid[i] && translate < s.slidesGrid[i + 1] - (s.slidesGrid[i + 1] - s.slidesGrid[i]) / 2) {
	                        newActiveIndex = i;
	                    }
	                    else if (translate >= s.slidesGrid[i] && translate < s.slidesGrid[i + 1]) {
	                        newActiveIndex = i + 1;
	                    }
	                }
	                else {
	                    if (translate >= s.slidesGrid[i]) {
	                        newActiveIndex = i;
	                    }
	                }
	            }
	            // Normalize slideIndex
	            if(s.params.normalizeSlideIndex){
	                if (newActiveIndex < 0 || typeof newActiveIndex === 'undefined') newActiveIndex = 0;
	            }
	            // for (i = 0; i < s.slidesGrid.length; i++) {
	                // if (- translate >= s.slidesGrid[i]) {
	                    // newActiveIndex = i;
	                // }
	            // }
	            snapIndex = Math.floor(newActiveIndex / s.params.slidesPerGroup);
	            if (snapIndex >= s.snapGrid.length) snapIndex = s.snapGrid.length - 1;
	        
	            if (newActiveIndex === s.activeIndex) {
	                return;
	            }
	            s.snapIndex = snapIndex;
	            s.previousIndex = s.activeIndex;
	            s.activeIndex = newActiveIndex;
	            s.updateClasses();
	            s.updateRealIndex();
	        };
	        s.updateRealIndex = function(){
	            s.realIndex = parseInt(s.slides.eq(s.activeIndex).attr('data-swiper-slide-index') || s.activeIndex, 10);
	        };
	        
	        /*=========================
	          Classes
	          ===========================*/
	        s.updateClasses = function () {
	            s.slides.removeClass(s.params.slideActiveClass + ' ' + s.params.slideNextClass + ' ' + s.params.slidePrevClass + ' ' + s.params.slideDuplicateActiveClass + ' ' + s.params.slideDuplicateNextClass + ' ' + s.params.slideDuplicatePrevClass);
	            var activeSlide = s.slides.eq(s.activeIndex);
	            // Active classes
	            activeSlide.addClass(s.params.slideActiveClass);
	            if (params.loop) {
	                // Duplicate to all looped slides
	                if (activeSlide.hasClass(s.params.slideDuplicateClass)) {
	                    s.wrapper.children('.' + s.params.slideClass + ':not(.' + s.params.slideDuplicateClass + ')[data-swiper-slide-index="' + s.realIndex + '"]').addClass(s.params.slideDuplicateActiveClass);
	                }
	                else {
	                    s.wrapper.children('.' + s.params.slideClass + '.' + s.params.slideDuplicateClass + '[data-swiper-slide-index="' + s.realIndex + '"]').addClass(s.params.slideDuplicateActiveClass);
	                }
	            }
	            // Next Slide
	            var nextSlide = activeSlide.next('.' + s.params.slideClass).addClass(s.params.slideNextClass);
	            if (s.params.loop && nextSlide.length === 0) {
	                nextSlide = s.slides.eq(0);
	                nextSlide.addClass(s.params.slideNextClass);
	            }
	            // Prev Slide
	            var prevSlide = activeSlide.prev('.' + s.params.slideClass).addClass(s.params.slidePrevClass);
	            if (s.params.loop && prevSlide.length === 0) {
	                prevSlide = s.slides.eq(-1);
	                prevSlide.addClass(s.params.slidePrevClass);
	            }
	            if (params.loop) {
	                // Duplicate to all looped slides
	                if (nextSlide.hasClass(s.params.slideDuplicateClass)) {
	                    s.wrapper.children('.' + s.params.slideClass + ':not(.' + s.params.slideDuplicateClass + ')[data-swiper-slide-index="' + nextSlide.attr('data-swiper-slide-index') + '"]').addClass(s.params.slideDuplicateNextClass);
	                }
	                else {
	                    s.wrapper.children('.' + s.params.slideClass + '.' + s.params.slideDuplicateClass + '[data-swiper-slide-index="' + nextSlide.attr('data-swiper-slide-index') + '"]').addClass(s.params.slideDuplicateNextClass);
	                }
	                if (prevSlide.hasClass(s.params.slideDuplicateClass)) {
	                    s.wrapper.children('.' + s.params.slideClass + ':not(.' + s.params.slideDuplicateClass + ')[data-swiper-slide-index="' + prevSlide.attr('data-swiper-slide-index') + '"]').addClass(s.params.slideDuplicatePrevClass);
	                }
	                else {
	                    s.wrapper.children('.' + s.params.slideClass + '.' + s.params.slideDuplicateClass + '[data-swiper-slide-index="' + prevSlide.attr('data-swiper-slide-index') + '"]').addClass(s.params.slideDuplicatePrevClass);
	                }
	            }
	        
	            // Pagination
	            if (s.paginationContainer && s.paginationContainer.length > 0) {
	                // Current/Total
	                var current,
	                    total = s.params.loop ? Math.ceil((s.slides.length - s.loopedSlides * 2) / s.params.slidesPerGroup) : s.snapGrid.length;
	                if (s.params.loop) {
	                    current = Math.ceil((s.activeIndex - s.loopedSlides)/s.params.slidesPerGroup);
	                    if (current > s.slides.length - 1 - s.loopedSlides * 2) {
	                        current = current - (s.slides.length - s.loopedSlides * 2);
	                    }
	                    if (current > total - 1) current = current - total;
	                    if (current < 0 && s.params.paginationType !== 'bullets') current = total + current;
	                }
	                else {
	                    if (typeof s.snapIndex !== 'undefined') {
	                        current = s.snapIndex;
	                    }
	                    else {
	                        current = s.activeIndex || 0;
	                    }
	                }
	                // Types
	                if (s.params.paginationType === 'bullets' && s.bullets && s.bullets.length > 0) {
	                    s.bullets.removeClass(s.params.bulletActiveClass);
	                    if (s.paginationContainer.length > 1) {
	                        s.bullets.each(function () {
	                            if ($(this).index() === current) $(this).addClass(s.params.bulletActiveClass);
	                        });
	                    }
	                    else {
	                        s.bullets.eq(current).addClass(s.params.bulletActiveClass);
	                    }
	                }
	                if (s.params.paginationType === 'fraction') {
	                    s.paginationContainer.find('.' + s.params.paginationCurrentClass).text(current + 1);
	                    s.paginationContainer.find('.' + s.params.paginationTotalClass).text(total);
	                }
	                if (s.params.paginationType === 'progress') {
	                    var scale = (current + 1) / total,
	                        scaleX = scale,
	                        scaleY = 1;
	                    if (!s.isHorizontal()) {
	                        scaleY = scale;
	                        scaleX = 1;
	                    }
	                    s.paginationContainer.find('.' + s.params.paginationProgressbarClass).transform('translate3d(0,0,0) scaleX(' + scaleX + ') scaleY(' + scaleY + ')').transition(s.params.speed);
	                }
	                if (s.params.paginationType === 'custom' && s.params.paginationCustomRender) {
	                    s.paginationContainer.html(s.params.paginationCustomRender(s, current + 1, total));
	                    s.emit('onPaginationRendered', s, s.paginationContainer[0]);
	                }
	            }
	        
	            // Next/active buttons
	            if (!s.params.loop) {
	                if (s.params.prevButton && s.prevButton && s.prevButton.length > 0) {
	                    if (s.isBeginning) {
	                        s.prevButton.addClass(s.params.buttonDisabledClass);
	                        if (s.params.a11y && s.a11y) s.a11y.disable(s.prevButton);
	                    }
	                    else {
	                        s.prevButton.removeClass(s.params.buttonDisabledClass);
	                        if (s.params.a11y && s.a11y) s.a11y.enable(s.prevButton);
	                    }
	                }
	                if (s.params.nextButton && s.nextButton && s.nextButton.length > 0) {
	                    if (s.isEnd) {
	                        s.nextButton.addClass(s.params.buttonDisabledClass);
	                        if (s.params.a11y && s.a11y) s.a11y.disable(s.nextButton);
	                    }
	                    else {
	                        s.nextButton.removeClass(s.params.buttonDisabledClass);
	                        if (s.params.a11y && s.a11y) s.a11y.enable(s.nextButton);
	                    }
	                }
	            }
	        };
	        
	        /*=========================
	          Pagination
	          ===========================*/
	        s.updatePagination = function () {
	            if (!s.params.pagination) return;
	            if (s.paginationContainer && s.paginationContainer.length > 0) {
	                var paginationHTML = '';
	                if (s.params.paginationType === 'bullets') {
	                    var numberOfBullets = s.params.loop ? Math.ceil((s.slides.length - s.loopedSlides * 2) / s.params.slidesPerGroup) : s.snapGrid.length;
	                    for (var i = 0; i < numberOfBullets; i++) {
	                        if (s.params.paginationBulletRender) {
	                            paginationHTML += s.params.paginationBulletRender(s, i, s.params.bulletClass);
	                        }
	                        else {
	                            paginationHTML += '<' + s.params.paginationElement+' class="' + s.params.bulletClass + '"></' + s.params.paginationElement + '>';
	                        }
	                    }
	                    s.paginationContainer.html(paginationHTML);
	                    s.bullets = s.paginationContainer.find('.' + s.params.bulletClass);
	                    if (s.params.paginationClickable && s.params.a11y && s.a11y) {
	                        s.a11y.initPagination();
	                    }
	                }
	                if (s.params.paginationType === 'fraction') {
	                    if (s.params.paginationFractionRender) {
	                        paginationHTML = s.params.paginationFractionRender(s, s.params.paginationCurrentClass, s.params.paginationTotalClass);
	                    }
	                    else {
	                        paginationHTML =
	                            '<span class="' + s.params.paginationCurrentClass + '"></span>' +
	                            ' / ' +
	                            '<span class="' + s.params.paginationTotalClass+'"></span>';
	                    }
	                    s.paginationContainer.html(paginationHTML);
	                }
	                if (s.params.paginationType === 'progress') {
	                    if (s.params.paginationProgressRender) {
	                        paginationHTML = s.params.paginationProgressRender(s, s.params.paginationProgressbarClass);
	                    }
	                    else {
	                        paginationHTML = '<span class="' + s.params.paginationProgressbarClass + '"></span>';
	                    }
	                    s.paginationContainer.html(paginationHTML);
	                }
	                if (s.params.paginationType !== 'custom') {
	                    s.emit('onPaginationRendered', s, s.paginationContainer[0]);
	                }
	            }
	        };
	        /*=========================
	          Common update method
	          ===========================*/
	        s.update = function (updateTranslate) {
	            if (!s) return;
	            s.updateContainerSize();
	            s.updateSlidesSize();
	            s.updateProgress();
	            s.updatePagination();
	            s.updateClasses();
	            if (s.params.scrollbar && s.scrollbar) {
	                s.scrollbar.set();
	            }
	            var newTranslate;
	            function forceSetTranslate() {
	                var translate = s.rtl ? -s.translate : s.translate;
	                newTranslate = Math.min(Math.max(s.translate, s.maxTranslate()), s.minTranslate());
	                s.setWrapperTranslate(newTranslate);
	                s.updateActiveIndex();
	                s.updateClasses();
	            }
	            if (updateTranslate) {
	                var translated;
	                if (s.controller && s.controller.spline) {
	                    s.controller.spline = undefined;
	                }
	                if (s.params.freeMode) {
	                    forceSetTranslate();
	                    if (s.params.autoHeight) {
	                        s.updateAutoHeight();
	                    }
	                }
	                else {
	                    if ((s.params.slidesPerView === 'auto' || s.params.slidesPerView > 1) && s.isEnd && !s.params.centeredSlides) {
	                        translated = s.slideTo(s.slides.length - 1, 0, false, true);
	                    }
	                    else {
	                        translated = s.slideTo(s.activeIndex, 0, false, true);
	                    }
	                    if (!translated) {
	                        forceSetTranslate();
	                    }
	                }
	            }
	            else if (s.params.autoHeight) {
	                s.updateAutoHeight();
	            }
	        };
	        
	        /*=========================
	          Resize Handler
	          ===========================*/
	        s.onResize = function (forceUpdatePagination) {
	            if (s.params.onBeforeResize) s.params.onBeforeResize(s);
	            //Breakpoints
	            if (s.params.breakpoints) {
	                s.setBreakpoint();
	            }
	        
	            // Disable locks on resize
	            var allowSwipeToPrev = s.params.allowSwipeToPrev;
	            var allowSwipeToNext = s.params.allowSwipeToNext;
	            s.params.allowSwipeToPrev = s.params.allowSwipeToNext = true;
	        
	            s.updateContainerSize();
	            s.updateSlidesSize();
	            if (s.params.slidesPerView === 'auto' || s.params.freeMode || forceUpdatePagination) s.updatePagination();
	            if (s.params.scrollbar && s.scrollbar) {
	                s.scrollbar.set();
	            }
	            if (s.controller && s.controller.spline) {
	                s.controller.spline = undefined;
	            }
	            var slideChangedBySlideTo = false;
	            if (s.params.freeMode) {
	                var newTranslate = Math.min(Math.max(s.translate, s.maxTranslate()), s.minTranslate());
	                s.setWrapperTranslate(newTranslate);
	                s.updateActiveIndex();
	                s.updateClasses();
	        
	                if (s.params.autoHeight) {
	                    s.updateAutoHeight();
	                }
	            }
	            else {
	                s.updateClasses();
	                if ((s.params.slidesPerView === 'auto' || s.params.slidesPerView > 1) && s.isEnd && !s.params.centeredSlides) {
	                    slideChangedBySlideTo = s.slideTo(s.slides.length - 1, 0, false, true);
	                }
	                else {
	                    slideChangedBySlideTo = s.slideTo(s.activeIndex, 0, false, true);
	                }
	            }
	            if (s.params.lazyLoading && !slideChangedBySlideTo && s.lazy) {
	                s.lazy.load();
	            }
	            // Return locks after resize
	            s.params.allowSwipeToPrev = allowSwipeToPrev;
	            s.params.allowSwipeToNext = allowSwipeToNext;
	            if (s.params.onAfterResize) s.params.onAfterResize(s);
	        };
	        
	        /*=========================
	          Events
	          ===========================*/
	        
	        //Define Touch Events
	        s.touchEventsDesktop = {start: 'mousedown', move: 'mousemove', end: 'mouseup'};
	        if (window.navigator.pointerEnabled) s.touchEventsDesktop = {start: 'pointerdown', move: 'pointermove', end: 'pointerup'};
	        else if (window.navigator.msPointerEnabled) s.touchEventsDesktop = {start: 'MSPointerDown', move: 'MSPointerMove', end: 'MSPointerUp'};
	        s.touchEvents = {
	            start : s.support.touch || !s.params.simulateTouch  ? 'touchstart' : s.touchEventsDesktop.start,
	            move : s.support.touch || !s.params.simulateTouch ? 'touchmove' : s.touchEventsDesktop.move,
	            end : s.support.touch || !s.params.simulateTouch ? 'touchend' : s.touchEventsDesktop.end
	        };
	        
	        
	        // WP8 Touch Events Fix
	        if (window.navigator.pointerEnabled || window.navigator.msPointerEnabled) {
	            (s.params.touchEventsTarget === 'container' ? s.container : s.wrapper).addClass('swiper-wp8-' + s.params.direction);
	        }
	        
	        // Attach/detach events
	        s.initEvents = function (detach) {
	            var actionDom = detach ? 'off' : 'on';
	            var action = detach ? 'removeEventListener' : 'addEventListener';
	            var touchEventsTarget = s.params.touchEventsTarget === 'container' ? s.container[0] : s.wrapper[0];
	            var target = s.support.touch ? touchEventsTarget : document;
	        
	            var moveCapture = s.params.nested ? true : false;
	        
	            //Touch Events
	            if (s.browser.ie) {
	                touchEventsTarget[action](s.touchEvents.start, s.onTouchStart, false);
	                target[action](s.touchEvents.move, s.onTouchMove, moveCapture);
	                target[action](s.touchEvents.end, s.onTouchEnd, false);
	            }
	            else {
	                if (s.support.touch) {
	                    var passiveListener = s.touchEvents.start === 'touchstart' && s.support.passiveListener && s.params.passiveListeners ? {passive: true, capture: false} : false;
	                    touchEventsTarget[action](s.touchEvents.start, s.onTouchStart, passiveListener);
	                    touchEventsTarget[action](s.touchEvents.move, s.onTouchMove, moveCapture);
	                    touchEventsTarget[action](s.touchEvents.end, s.onTouchEnd, passiveListener);
	                }
	                if ((params.simulateTouch && !s.device.ios && !s.device.android) || (params.simulateTouch && !s.support.touch && s.device.ios)) {
	                    touchEventsTarget[action]('mousedown', s.onTouchStart, false);
	                    document[action]('mousemove', s.onTouchMove, moveCapture);
	                    document[action]('mouseup', s.onTouchEnd, false);
	                }
	            }
	            window[action]('resize', s.onResize);
	        
	            // Next, Prev, Index
	            if (s.params.nextButton && s.nextButton && s.nextButton.length > 0) {
	                s.nextButton[actionDom]('click', s.onClickNext);
	                if (s.params.a11y && s.a11y) s.nextButton[actionDom]('keydown', s.a11y.onEnterKey);
	            }
	            if (s.params.prevButton && s.prevButton && s.prevButton.length > 0) {
	                s.prevButton[actionDom]('click', s.onClickPrev);
	                if (s.params.a11y && s.a11y) s.prevButton[actionDom]('keydown', s.a11y.onEnterKey);
	            }
	            if (s.params.pagination && s.params.paginationClickable) {
	                s.paginationContainer[actionDom]('click', '.' + s.params.bulletClass, s.onClickIndex);
	                if (s.params.a11y && s.a11y) s.paginationContainer[actionDom]('keydown', '.' + s.params.bulletClass, s.a11y.onEnterKey);
	            }
	        
	            // Prevent Links Clicks
	            if (s.params.preventClicks || s.params.preventClicksPropagation) touchEventsTarget[action]('click', s.preventClicks, true);
	        };
	        s.attachEvents = function () {
	            s.initEvents();
	        };
	        s.detachEvents = function () {
	            s.initEvents(true);
	        };
	        
	        /*=========================
	          Handle Clicks
	          ===========================*/
	        // Prevent Clicks
	        s.allowClick = true;
	        s.preventClicks = function (e) {
	            if (!s.allowClick) {
	                if (s.params.preventClicks) e.preventDefault();
	                if (s.params.preventClicksPropagation && s.animating) {
	                    e.stopPropagation();
	                    e.stopImmediatePropagation();
	                }
	            }
	        };
	        // Clicks
	        s.onClickNext = function (e) {
	            e.preventDefault();
	            if (s.isEnd && !s.params.loop) return;
	            s.slideNext();
	        };
	        s.onClickPrev = function (e) {
	            e.preventDefault();
	            if (s.isBeginning && !s.params.loop) return;
	            s.slidePrev();
	        };
	        s.onClickIndex = function (e) {
	            e.preventDefault();
	            var index = $(this).index() * s.params.slidesPerGroup;
	            if (s.params.loop) index = index + s.loopedSlides;
	            s.slideTo(index);
	        };
	        
	        /*=========================
	          Handle Touches
	          ===========================*/
	        function findElementInEvent(e, selector) {
	            var el = $(e.target);
	            if (!el.is(selector)) {
	                if (typeof selector === 'string') {
	                    el = el.parents(selector);
	                }
	                else if (selector.nodeType) {
	                    var found;
	                    el.parents().each(function (index, _el) {
	                        if (_el === selector) found = selector;
	                    });
	                    if (!found) return undefined;
	                    else return selector;
	                }
	            }
	            if (el.length === 0) {
	                return undefined;
	            }
	            return el[0];
	        }
	        s.updateClickedSlide = function (e) {
	            var slide = findElementInEvent(e, '.' + s.params.slideClass);
	            var slideFound = false;
	            if (slide) {
	                for (var i = 0; i < s.slides.length; i++) {
	                    if (s.slides[i] === slide) slideFound = true;
	                }
	            }
	        
	            if (slide && slideFound) {
	                s.clickedSlide = slide;
	                s.clickedIndex = $(slide).index();
	            }
	            else {
	                s.clickedSlide = undefined;
	                s.clickedIndex = undefined;
	                return;
	            }
	            if (s.params.slideToClickedSlide && s.clickedIndex !== undefined && s.clickedIndex !== s.activeIndex) {
	                var slideToIndex = s.clickedIndex,
	                    realIndex,
	                    duplicatedSlides,
	                    slidesPerView = s.params.slidesPerView === 'auto' ? s.currentSlidesPerView() : s.params.slidesPerView;
	                if (s.params.loop) {
	                    if (s.animating) return;
	                    realIndex = parseInt($(s.clickedSlide).attr('data-swiper-slide-index'), 10);
	                    if (s.params.centeredSlides) {
	                        if ((slideToIndex < s.loopedSlides - slidesPerView/2) || (slideToIndex > s.slides.length - s.loopedSlides + slidesPerView/2)) {
	                            s.fixLoop();
	                            slideToIndex = s.wrapper.children('.' + s.params.slideClass + '[data-swiper-slide-index="' + realIndex + '"]:not(.' + s.params.slideDuplicateClass + ')').eq(0).index();
	                            setTimeout(function () {
	                                s.slideTo(slideToIndex);
	                            }, 0);
	                        }
	                        else {
	                            s.slideTo(slideToIndex);
	                        }
	                    }
	                    else {
	                        if (slideToIndex > s.slides.length - slidesPerView) {
	                            s.fixLoop();
	                            slideToIndex = s.wrapper.children('.' + s.params.slideClass + '[data-swiper-slide-index="' + realIndex + '"]:not(.' + s.params.slideDuplicateClass + ')').eq(0).index();
	                            setTimeout(function () {
	                                s.slideTo(slideToIndex);
	                            }, 0);
	                        }
	                        else {
	                            s.slideTo(slideToIndex);
	                        }
	                    }
	                }
	                else {
	                    s.slideTo(slideToIndex);
	                }
	            }
	        };
	        
	        var isTouched,
	            isMoved,
	            allowTouchCallbacks,
	            touchStartTime,
	            isScrolling,
	            currentTranslate,
	            startTranslate,
	            allowThresholdMove,
	            // Form elements to match
	            formElements = 'input, select, textarea, button, video',
	            // Last click time
	            lastClickTime = Date.now(), clickTimeout,
	            //Velocities
	            velocities = [],
	            allowMomentumBounce;
	        
	        // Animating Flag
	        s.animating = false;
	        
	        // Touches information
	        s.touches = {
	            startX: 0,
	            startY: 0,
	            currentX: 0,
	            currentY: 0,
	            diff: 0
	        };
	        
	        // Touch handlers
	        var isTouchEvent, startMoving;
	        s.onTouchStart = function (e) {
	            if (e.originalEvent) e = e.originalEvent;
	            isTouchEvent = e.type === 'touchstart';
	            if (!isTouchEvent && 'which' in e && e.which === 3) return;
	            if (s.params.noSwiping && findElementInEvent(e, '.' + s.params.noSwipingClass)) {
	                s.allowClick = true;
	                return;
	            }
	            if (s.params.swipeHandler) {
	                if (!findElementInEvent(e, s.params.swipeHandler)) return;
	            }
	        
	            var startX = s.touches.currentX = e.type === 'touchstart' ? e.targetTouches[0].pageX : e.pageX;
	            var startY = s.touches.currentY = e.type === 'touchstart' ? e.targetTouches[0].pageY : e.pageY;
	        
	            // Do NOT start if iOS edge swipe is detected. Otherwise iOS app (UIWebView) cannot swipe-to-go-back anymore
	            if(s.device.ios && s.params.iOSEdgeSwipeDetection && startX <= s.params.iOSEdgeSwipeThreshold) {
	                return;
	            }
	        
	            isTouched = true;
	            isMoved = false;
	            allowTouchCallbacks = true;
	            isScrolling = undefined;
	            startMoving = undefined;
	            s.touches.startX = startX;
	            s.touches.startY = startY;
	            touchStartTime = Date.now();
	            s.allowClick = true;
	            s.updateContainerSize();
	            s.swipeDirection = undefined;
	            if (s.params.threshold > 0) allowThresholdMove = false;
	            if (e.type !== 'touchstart') {
	                var preventDefault = true;
	                if ($(e.target).is(formElements)) preventDefault = false;
	                if (document.activeElement && $(document.activeElement).is(formElements)) {
	                    document.activeElement.blur();
	                }
	                if (preventDefault) {
	                    e.preventDefault();
	                }
	            }
	            s.emit('onTouchStart', s, e);
	        };
	        
	        s.onTouchMove = function (e) {
	            if (e.originalEvent) e = e.originalEvent;
	            if (isTouchEvent && e.type === 'mousemove') return;
	            if (e.preventedByNestedSwiper) {
	                s.touches.startX = e.type === 'touchmove' ? e.targetTouches[0].pageX : e.pageX;
	                s.touches.startY = e.type === 'touchmove' ? e.targetTouches[0].pageY : e.pageY;
	                return;
	            }
	            if (s.params.onlyExternal) {
	                // isMoved = true;
	                s.allowClick = false;
	                if (isTouched) {
	                    s.touches.startX = s.touches.currentX = e.type === 'touchmove' ? e.targetTouches[0].pageX : e.pageX;
	                    s.touches.startY = s.touches.currentY = e.type === 'touchmove' ? e.targetTouches[0].pageY : e.pageY;
	                    touchStartTime = Date.now();
	                }
	                return;
	            }
	            if (isTouchEvent && s.params.touchReleaseOnEdges && !s.params.loop) {
	                if (!s.isHorizontal()) {
	                    // Vertical
	                    if (
	                        (s.touches.currentY < s.touches.startY && s.translate <= s.maxTranslate()) ||
	                        (s.touches.currentY > s.touches.startY && s.translate >= s.minTranslate())
	                        ) {
	                        return;
	                    }
	                }
	                else {
	                    if (
	                        (s.touches.currentX < s.touches.startX && s.translate <= s.maxTranslate()) ||
	                        (s.touches.currentX > s.touches.startX && s.translate >= s.minTranslate())
	                        ) {
	                        return;
	                    }
	                }
	            }
	            if (isTouchEvent && document.activeElement) {
	                if (e.target === document.activeElement && $(e.target).is(formElements)) {
	                    isMoved = true;
	                    s.allowClick = false;
	                    return;
	                }
	            }
	            if (allowTouchCallbacks) {
	                s.emit('onTouchMove', s, e);
	            }
	            if (e.targetTouches && e.targetTouches.length > 1) return;
	        
	            s.touches.currentX = e.type === 'touchmove' ? e.targetTouches[0].pageX : e.pageX;
	            s.touches.currentY = e.type === 'touchmove' ? e.targetTouches[0].pageY : e.pageY;
	        
	            if (typeof isScrolling === 'undefined') {
	                var touchAngle;
	                if (s.isHorizontal() && s.touches.currentY === s.touches.startY || !s.isHorizontal() && s.touches.currentX === s.touches.startX) {
	                    isScrolling = false;
	                }
	                else {
	                    touchAngle = Math.atan2(Math.abs(s.touches.currentY - s.touches.startY), Math.abs(s.touches.currentX - s.touches.startX)) * 180 / Math.PI;
	                    isScrolling = s.isHorizontal() ? touchAngle > s.params.touchAngle : (90 - touchAngle > s.params.touchAngle);
	                }
	            }
	            if (isScrolling) {
	                s.emit('onTouchMoveOpposite', s, e);
	            }
	            if (typeof startMoving === 'undefined') {
	                if (s.touches.currentX !== s.touches.startX || s.touches.currentY !== s.touches.startY) {
	                    startMoving = true;
	                }
	            }
	            if (!isTouched) return;
	            if (isScrolling)  {
	                isTouched = false;
	                return;
	            }
	            if (!startMoving) {
	                return;
	            }
	            s.allowClick = false;
	            s.emit('onSliderMove', s, e);
	            e.preventDefault();
	            if (s.params.touchMoveStopPropagation && !s.params.nested) {
	                e.stopPropagation();
	            }
	        
	            if (!isMoved) {
	                if (params.loop) {
	                    s.fixLoop();
	                }
	                startTranslate = s.getWrapperTranslate();
	                s.setWrapperTransition(0);
	                if (s.animating) {
	                    s.wrapper.trigger('webkitTransitionEnd transitionend oTransitionEnd MSTransitionEnd msTransitionEnd');
	                }
	                if (s.params.autoplay && s.autoplaying) {
	                    if (s.params.autoplayDisableOnInteraction) {
	                        s.stopAutoplay();
	                    }
	                    else {
	                        s.pauseAutoplay();
	                    }
	                }
	                allowMomentumBounce = false;
	                //Grab Cursor
	                if (s.params.grabCursor && (s.params.allowSwipeToNext === true || s.params.allowSwipeToPrev === true)) {
	                    s.setGrabCursor(true);
	                }
	            }
	            isMoved = true;
	        
	            var diff = s.touches.diff = s.isHorizontal() ? s.touches.currentX - s.touches.startX : s.touches.currentY - s.touches.startY;
	        
	            diff = diff * s.params.touchRatio;
	            if (s.rtl) diff = -diff;
	        
	            s.swipeDirection = diff > 0 ? 'prev' : 'next';
	            currentTranslate = diff + startTranslate;
	        
	            var disableParentSwiper = true;
	            if ((diff > 0 && currentTranslate > s.minTranslate())) {
	                disableParentSwiper = false;
	                if (s.params.resistance) currentTranslate = s.minTranslate() - 1 + Math.pow(-s.minTranslate() + startTranslate + diff, s.params.resistanceRatio);
	            }
	            else if (diff < 0 && currentTranslate < s.maxTranslate()) {
	                disableParentSwiper = false;
	                if (s.params.resistance) currentTranslate = s.maxTranslate() + 1 - Math.pow(s.maxTranslate() - startTranslate - diff, s.params.resistanceRatio);
	            }
	        
	            if (disableParentSwiper) {
	                e.preventedByNestedSwiper = true;
	            }
	        
	            // Directions locks
	            if (!s.params.allowSwipeToNext && s.swipeDirection === 'next' && currentTranslate < startTranslate) {
	                currentTranslate = startTranslate;
	            }
	            if (!s.params.allowSwipeToPrev && s.swipeDirection === 'prev' && currentTranslate > startTranslate) {
	                currentTranslate = startTranslate;
	            }
	        
	        
	            // Threshold
	            if (s.params.threshold > 0) {
	                if (Math.abs(diff) > s.params.threshold || allowThresholdMove) {
	                    if (!allowThresholdMove) {
	                        allowThresholdMove = true;
	                        s.touches.startX = s.touches.currentX;
	                        s.touches.startY = s.touches.currentY;
	                        currentTranslate = startTranslate;
	                        s.touches.diff = s.isHorizontal() ? s.touches.currentX - s.touches.startX : s.touches.currentY - s.touches.startY;
	                        return;
	                    }
	                }
	                else {
	                    currentTranslate = startTranslate;
	                    return;
	                }
	            }
	        
	            if (!s.params.followFinger) return;
	        
	            // Update active index in free mode
	            if (s.params.freeMode || s.params.watchSlidesProgress) {
	                s.updateActiveIndex();
	            }
	            if (s.params.freeMode) {
	                //Velocity
	                if (velocities.length === 0) {
	                    velocities.push({
	                        position: s.touches[s.isHorizontal() ? 'startX' : 'startY'],
	                        time: touchStartTime
	                    });
	                }
	                velocities.push({
	                    position: s.touches[s.isHorizontal() ? 'currentX' : 'currentY'],
	                    time: (new window.Date()).getTime()
	                });
	            }
	            // Update progress
	            s.updateProgress(currentTranslate);
	            // Update translate
	            s.setWrapperTranslate(currentTranslate);
	        };
	        s.onTouchEnd = function (e) {
	            if (e.originalEvent) e = e.originalEvent;
	            if (allowTouchCallbacks) {
	                s.emit('onTouchEnd', s, e);
	            }
	            allowTouchCallbacks = false;
	            if (!isTouched) return;
	            //Return Grab Cursor
	            if (s.params.grabCursor && isMoved && isTouched  && (s.params.allowSwipeToNext === true || s.params.allowSwipeToPrev === true)) {
	                s.setGrabCursor(false);
	            }
	        
	            // Time diff
	            var touchEndTime = Date.now();
	            var timeDiff = touchEndTime - touchStartTime;
	        
	            // Tap, doubleTap, Click
	            if (s.allowClick) {
	                s.updateClickedSlide(e);
	                s.emit('onTap', s, e);
	                if (timeDiff < 300 && (touchEndTime - lastClickTime) > 300) {
	                    if (clickTimeout) clearTimeout(clickTimeout);
	                    clickTimeout = setTimeout(function () {
	                        if (!s) return;
	                        if (s.params.paginationHide && s.paginationContainer.length > 0 && !$(e.target).hasClass(s.params.bulletClass)) {
	                            s.paginationContainer.toggleClass(s.params.paginationHiddenClass);
	                        }
	                        s.emit('onClick', s, e);
	                    }, 300);
	        
	                }
	                if (timeDiff < 300 && (touchEndTime - lastClickTime) < 300) {
	                    if (clickTimeout) clearTimeout(clickTimeout);
	                    s.emit('onDoubleTap', s, e);
	                }
	            }
	        
	            lastClickTime = Date.now();
	            setTimeout(function () {
	                if (s) s.allowClick = true;
	            }, 0);
	        
	            if (!isTouched || !isMoved || !s.swipeDirection || s.touches.diff === 0 || currentTranslate === startTranslate) {
	                isTouched = isMoved = false;
	                return;
	            }
	            isTouched = isMoved = false;
	        
	            var currentPos;
	            if (s.params.followFinger) {
	                currentPos = s.rtl ? s.translate : -s.translate;
	            }
	            else {
	                currentPos = -currentTranslate;
	            }
	            if (s.params.freeMode) {
	                if (currentPos < -s.minTranslate()) {
	                    s.slideTo(s.activeIndex);
	                    return;
	                }
	                else if (currentPos > -s.maxTranslate()) {
	                    if (s.slides.length < s.snapGrid.length) {
	                        s.slideTo(s.snapGrid.length - 1);
	                    }
	                    else {
	                        s.slideTo(s.slides.length - 1);
	                    }
	                    return;
	                }
	        
	                if (s.params.freeModeMomentum) {
	                    if (velocities.length > 1) {
	                        var lastMoveEvent = velocities.pop(), velocityEvent = velocities.pop();
	        
	                        var distance = lastMoveEvent.position - velocityEvent.position;
	                        var time = lastMoveEvent.time - velocityEvent.time;
	                        s.velocity = distance / time;
	                        s.velocity = s.velocity / 2;
	                        if (Math.abs(s.velocity) < s.params.freeModeMinimumVelocity) {
	                            s.velocity = 0;
	                        }
	                        // this implies that the user stopped moving a finger then released.
	                        // There would be no events with distance zero, so the last event is stale.
	                        if (time > 150 || (new window.Date().getTime() - lastMoveEvent.time) > 300) {
	                            s.velocity = 0;
	                        }
	                    } else {
	                        s.velocity = 0;
	                    }
	                    s.velocity = s.velocity * s.params.freeModeMomentumVelocityRatio;
	        
	                    velocities.length = 0;
	                    var momentumDuration = 1000 * s.params.freeModeMomentumRatio;
	                    var momentumDistance = s.velocity * momentumDuration;
	        
	                    var newPosition = s.translate + momentumDistance;
	                    if (s.rtl) newPosition = - newPosition;
	                    var doBounce = false;
	                    var afterBouncePosition;
	                    var bounceAmount = Math.abs(s.velocity) * 20 * s.params.freeModeMomentumBounceRatio;
	                    if (newPosition < s.maxTranslate()) {
	                        if (s.params.freeModeMomentumBounce) {
	                            if (newPosition + s.maxTranslate() < -bounceAmount) {
	                                newPosition = s.maxTranslate() - bounceAmount;
	                            }
	                            afterBouncePosition = s.maxTranslate();
	                            doBounce = true;
	                            allowMomentumBounce = true;
	                        }
	                        else {
	                            newPosition = s.maxTranslate();
	                        }
	                    }
	                    else if (newPosition > s.minTranslate()) {
	                        if (s.params.freeModeMomentumBounce) {
	                            if (newPosition - s.minTranslate() > bounceAmount) {
	                                newPosition = s.minTranslate() + bounceAmount;
	                            }
	                            afterBouncePosition = s.minTranslate();
	                            doBounce = true;
	                            allowMomentumBounce = true;
	                        }
	                        else {
	                            newPosition = s.minTranslate();
	                        }
	                    }
	                    else if (s.params.freeModeSticky) {
	                        var j = 0,
	                            nextSlide;
	                        for (j = 0; j < s.snapGrid.length; j += 1) {
	                            if (s.snapGrid[j] > -newPosition) {
	                                nextSlide = j;
	                                break;
	                            }
	        
	                        }
	                        if (Math.abs(s.snapGrid[nextSlide] - newPosition) < Math.abs(s.snapGrid[nextSlide - 1] - newPosition) || s.swipeDirection === 'next') {
	                            newPosition = s.snapGrid[nextSlide];
	                        } else {
	                            newPosition = s.snapGrid[nextSlide - 1];
	                        }
	                        if (!s.rtl) newPosition = - newPosition;
	                    }
	                    //Fix duration
	                    if (s.velocity !== 0) {
	                        if (s.rtl) {
	                            momentumDuration = Math.abs((-newPosition - s.translate) / s.velocity);
	                        }
	                        else {
	                            momentumDuration = Math.abs((newPosition - s.translate) / s.velocity);
	                        }
	                    }
	                    else if (s.params.freeModeSticky) {
	                        s.slideReset();
	                        return;
	                    }
	        
	                    if (s.params.freeModeMomentumBounce && doBounce) {
	                        s.updateProgress(afterBouncePosition);
	                        s.setWrapperTransition(momentumDuration);
	                        s.setWrapperTranslate(newPosition);
	                        s.onTransitionStart();
	                        s.animating = true;
	                        s.wrapper.transitionEnd(function () {
	                            if (!s || !allowMomentumBounce) return;
	                            s.emit('onMomentumBounce', s);
	        
	                            s.setWrapperTransition(s.params.speed);
	                            s.setWrapperTranslate(afterBouncePosition);
	                            s.wrapper.transitionEnd(function () {
	                                if (!s) return;
	                                s.onTransitionEnd();
	                            });
	                        });
	                    } else if (s.velocity) {
	                        s.updateProgress(newPosition);
	                        s.setWrapperTransition(momentumDuration);
	                        s.setWrapperTranslate(newPosition);
	                        s.onTransitionStart();
	                        if (!s.animating) {
	                            s.animating = true;
	                            s.wrapper.transitionEnd(function () {
	                                if (!s) return;
	                                s.onTransitionEnd();
	                            });
	                        }
	        
	                    } else {
	                        s.updateProgress(newPosition);
	                    }
	        
	                    s.updateActiveIndex();
	                }
	                if (!s.params.freeModeMomentum || timeDiff >= s.params.longSwipesMs) {
	                    s.updateProgress();
	                    s.updateActiveIndex();
	                }
	                return;
	            }
	        
	            // Find current slide
	            var i, stopIndex = 0, groupSize = s.slidesSizesGrid[0];
	            for (i = 0; i < s.slidesGrid.length; i += s.params.slidesPerGroup) {
	                if (typeof s.slidesGrid[i + s.params.slidesPerGroup] !== 'undefined') {
	                    if (currentPos >= s.slidesGrid[i] && currentPos < s.slidesGrid[i + s.params.slidesPerGroup]) {
	                        stopIndex = i;
	                        groupSize = s.slidesGrid[i + s.params.slidesPerGroup] - s.slidesGrid[i];
	                    }
	                }
	                else {
	                    if (currentPos >= s.slidesGrid[i]) {
	                        stopIndex = i;
	                        groupSize = s.slidesGrid[s.slidesGrid.length - 1] - s.slidesGrid[s.slidesGrid.length - 2];
	                    }
	                }
	            }
	        
	            // Find current slide size
	            var ratio = (currentPos - s.slidesGrid[stopIndex]) / groupSize;
	        
	            if (timeDiff > s.params.longSwipesMs) {
	                // Long touches
	                if (!s.params.longSwipes) {
	                    s.slideTo(s.activeIndex);
	                    return;
	                }
	                if (s.swipeDirection === 'next') {
	                    if (ratio >= s.params.longSwipesRatio) s.slideTo(stopIndex + s.params.slidesPerGroup);
	                    else s.slideTo(stopIndex);
	        
	                }
	                if (s.swipeDirection === 'prev') {
	                    if (ratio > (1 - s.params.longSwipesRatio)) s.slideTo(stopIndex + s.params.slidesPerGroup);
	                    else s.slideTo(stopIndex);
	                }
	            }
	            else {
	                // Short swipes
	                if (!s.params.shortSwipes) {
	                    s.slideTo(s.activeIndex);
	                    return;
	                }
	                if (s.swipeDirection === 'next') {
	                    s.slideTo(stopIndex + s.params.slidesPerGroup);
	        
	                }
	                if (s.swipeDirection === 'prev') {
	                    s.slideTo(stopIndex);
	                }
	            }
	        };
	        /*=========================
	          Transitions
	          ===========================*/
	        s._slideTo = function (slideIndex, speed) {
	            return s.slideTo(slideIndex, speed, true, true);
	        };
	        s.slideTo = function (slideIndex, speed, runCallbacks, internal) {
	            if (typeof runCallbacks === 'undefined') runCallbacks = true;
	            if (typeof slideIndex === 'undefined') slideIndex = 0;
	            if (slideIndex < 0) slideIndex = 0;
	            s.snapIndex = Math.floor(slideIndex / s.params.slidesPerGroup);
	            if (s.snapIndex >= s.snapGrid.length) s.snapIndex = s.snapGrid.length - 1;
	        
	            var translate = - s.snapGrid[s.snapIndex];
	            // Stop autoplay
	            if (s.params.autoplay && s.autoplaying) {
	                if (internal || !s.params.autoplayDisableOnInteraction) {
	                    s.pauseAutoplay(speed);
	                }
	                else {
	                    s.stopAutoplay();
	                }
	            }
	            // Update progress
	            s.updateProgress(translate);
	        
	            // Normalize slideIndex
	            if(s.params.normalizeSlideIndex){
	                for (var i = 0; i < s.slidesGrid.length; i++) {
	                    if (- Math.floor(translate * 100) >= Math.floor(s.slidesGrid[i] * 100)) {
	                        slideIndex = i;
	                    }
	                }
	            }
	        
	            // Directions locks
	            if (!s.params.allowSwipeToNext && translate < s.translate && translate < s.minTranslate()) {
	                return false;
	            }
	            if (!s.params.allowSwipeToPrev && translate > s.translate && translate > s.maxTranslate()) {
	                if ((s.activeIndex || 0) !== slideIndex ) return false;
	            }
	        
	            // Update Index
	            if (typeof speed === 'undefined') speed = s.params.speed;
	            s.previousIndex = s.activeIndex || 0;
	            s.activeIndex = slideIndex;
	            s.updateRealIndex();
	            if ((s.rtl && -translate === s.translate) || (!s.rtl && translate === s.translate)) {
	                // Update Height
	                if (s.params.autoHeight) {
	                    s.updateAutoHeight();
	                }
	                s.updateClasses();
	                if (s.params.effect !== 'slide') {
	                    s.setWrapperTranslate(translate);
	                }
	                return false;
	            }
	            s.updateClasses();
	            s.onTransitionStart(runCallbacks);
	        
	            if (speed === 0 || s.browser.lteIE9) {
	                s.setWrapperTranslate(translate);
	                s.setWrapperTransition(0);
	                s.onTransitionEnd(runCallbacks);
	            }
	            else {
	                s.setWrapperTranslate(translate);
	                s.setWrapperTransition(speed);
	                if (!s.animating) {
	                    s.animating = true;
	                    s.wrapper.transitionEnd(function () {
	                        if (!s) return;
	                        s.onTransitionEnd(runCallbacks);
	                    });
	                }
	        
	            }
	        
	            return true;
	        };
	        
	        s.onTransitionStart = function (runCallbacks) {
	            if (typeof runCallbacks === 'undefined') runCallbacks = true;
	            if (s.params.autoHeight) {
	                s.updateAutoHeight();
	            }
	            if (s.lazy) s.lazy.onTransitionStart();
	            if (runCallbacks) {
	                s.emit('onTransitionStart', s);
	                if (s.activeIndex !== s.previousIndex) {
	                    s.emit('onSlideChangeStart', s);
	                    if (s.activeIndex > s.previousIndex) {
	                        s.emit('onSlideNextStart', s);
	                    }
	                    else {
	                        s.emit('onSlidePrevStart', s);
	                    }
	                }
	        
	            }
	        };
	        s.onTransitionEnd = function (runCallbacks) {
	            s.animating = false;
	            s.setWrapperTransition(0);
	            if (typeof runCallbacks === 'undefined') runCallbacks = true;
	            if (s.lazy) s.lazy.onTransitionEnd();
	            if (runCallbacks) {
	                s.emit('onTransitionEnd', s);
	                if (s.activeIndex !== s.previousIndex) {
	                    s.emit('onSlideChangeEnd', s);
	                    if (s.activeIndex > s.previousIndex) {
	                        s.emit('onSlideNextEnd', s);
	                    }
	                    else {
	                        s.emit('onSlidePrevEnd', s);
	                    }
	                }
	            }
	            if (s.params.history && s.history) {
	                s.history.setHistory(s.params.history, s.activeIndex);
	            }
	            if (s.params.hashnav && s.hashnav) {
	                s.hashnav.setHash();
	            }
	        
	        };
	        s.slideNext = function (runCallbacks, speed, internal) {
	            if (s.params.loop) {
	                if (s.animating) return false;
	                s.fixLoop();
	                var clientLeft = s.container[0].clientLeft;
	                return s.slideTo(s.activeIndex + s.params.slidesPerGroup, speed, runCallbacks, internal);
	            }
	            else return s.slideTo(s.activeIndex + s.params.slidesPerGroup, speed, runCallbacks, internal);
	        };
	        s._slideNext = function (speed) {
	            return s.slideNext(true, speed, true);
	        };
	        s.slidePrev = function (runCallbacks, speed, internal) {
	            if (s.params.loop) {
	                if (s.animating) return false;
	                s.fixLoop();
	                var clientLeft = s.container[0].clientLeft;
	                return s.slideTo(s.activeIndex - 1, speed, runCallbacks, internal);
	            }
	            else return s.slideTo(s.activeIndex - 1, speed, runCallbacks, internal);
	        };
	        s._slidePrev = function (speed) {
	            return s.slidePrev(true, speed, true);
	        };
	        s.slideReset = function (runCallbacks, speed, internal) {
	            return s.slideTo(s.activeIndex, speed, runCallbacks);
	        };
	        
	        s.disableTouchControl = function () {
	            s.params.onlyExternal = true;
	            return true;
	        };
	        s.enableTouchControl = function () {
	            s.params.onlyExternal = false;
	            return true;
	        };
	        
	        /*=========================
	          Translate/transition helpers
	          ===========================*/
	        s.setWrapperTransition = function (duration, byController) {
	            s.wrapper.transition(duration);
	            if (s.params.effect !== 'slide' && s.effects[s.params.effect]) {
	                s.effects[s.params.effect].setTransition(duration);
	            }
	            if (s.params.parallax && s.parallax) {
	                s.parallax.setTransition(duration);
	            }
	            if (s.params.scrollbar && s.scrollbar) {
	                s.scrollbar.setTransition(duration);
	            }
	            if (s.params.control && s.controller) {
	                s.controller.setTransition(duration, byController);
	            }
	            s.emit('onSetTransition', s, duration);
	        };
	        s.setWrapperTranslate = function (translate, updateActiveIndex, byController) {
	            var x = 0, y = 0, z = 0;
	            if (s.isHorizontal()) {
	                x = s.rtl ? -translate : translate;
	            }
	            else {
	                y = translate;
	            }
	        
	            if (s.params.roundLengths) {
	                x = round(x);
	                y = round(y);
	            }
	        
	            if (!s.params.virtualTranslate) {
	                if (s.support.transforms3d) s.wrapper.transform('translate3d(' + x + 'px, ' + y + 'px, ' + z + 'px)');
	                else s.wrapper.transform('translate(' + x + 'px, ' + y + 'px)');
	            }
	        
	            s.translate = s.isHorizontal() ? x : y;
	        
	            // Check if we need to update progress
	            var progress;
	            var translatesDiff = s.maxTranslate() - s.minTranslate();
	            if (translatesDiff === 0) {
	                progress = 0;
	            }
	            else {
	                progress = (translate - s.minTranslate()) / (translatesDiff);
	            }
	            if (progress !== s.progress) {
	                s.updateProgress(translate);
	            }
	        
	            if (updateActiveIndex) s.updateActiveIndex();
	            if (s.params.effect !== 'slide' && s.effects[s.params.effect]) {
	                s.effects[s.params.effect].setTranslate(s.translate);
	            }
	            if (s.params.parallax && s.parallax) {
	                s.parallax.setTranslate(s.translate);
	            }
	            if (s.params.scrollbar && s.scrollbar) {
	                s.scrollbar.setTranslate(s.translate);
	            }
	            if (s.params.control && s.controller) {
	                s.controller.setTranslate(s.translate, byController);
	            }
	            s.emit('onSetTranslate', s, s.translate);
	        };
	        
	        s.getTranslate = function (el, axis) {
	            var matrix, curTransform, curStyle, transformMatrix;
	        
	            // automatic axis detection
	            if (typeof axis === 'undefined') {
	                axis = 'x';
	            }
	        
	            if (s.params.virtualTranslate) {
	                return s.rtl ? -s.translate : s.translate;
	            }
	        
	            curStyle = window.getComputedStyle(el, null);
	            if (window.WebKitCSSMatrix) {
	                curTransform = curStyle.transform || curStyle.webkitTransform;
	                if (curTransform.split(',').length > 6) {
	                    curTransform = curTransform.split(', ').map(function(a){
	                        return a.replace(',','.');
	                    }).join(', ');
	                }
	                // Some old versions of Webkit choke when 'none' is passed; pass
	                // empty string instead in this case
	                transformMatrix = new window.WebKitCSSMatrix(curTransform === 'none' ? '' : curTransform);
	            }
	            else {
	                transformMatrix = curStyle.MozTransform || curStyle.OTransform || curStyle.MsTransform || curStyle.msTransform  || curStyle.transform || curStyle.getPropertyValue('transform').replace('translate(', 'matrix(1, 0, 0, 1,');
	                matrix = transformMatrix.toString().split(',');
	            }
	        
	            if (axis === 'x') {
	                //Latest Chrome and webkits Fix
	                if (window.WebKitCSSMatrix)
	                    curTransform = transformMatrix.m41;
	                //Crazy IE10 Matrix
	                else if (matrix.length === 16)
	                    curTransform = parseFloat(matrix[12]);
	                //Normal Browsers
	                else
	                    curTransform = parseFloat(matrix[4]);
	            }
	            if (axis === 'y') {
	                //Latest Chrome and webkits Fix
	                if (window.WebKitCSSMatrix)
	                    curTransform = transformMatrix.m42;
	                //Crazy IE10 Matrix
	                else if (matrix.length === 16)
	                    curTransform = parseFloat(matrix[13]);
	                //Normal Browsers
	                else
	                    curTransform = parseFloat(matrix[5]);
	            }
	            if (s.rtl && curTransform) curTransform = -curTransform;
	            return curTransform || 0;
	        };
	        s.getWrapperTranslate = function (axis) {
	            if (typeof axis === 'undefined') {
	                axis = s.isHorizontal() ? 'x' : 'y';
	            }
	            return s.getTranslate(s.wrapper[0], axis);
	        };
	        
	        /*=========================
	          Observer
	          ===========================*/
	        s.observers = [];
	        function initObserver(target, options) {
	            options = options || {};
	            // create an observer instance
	            var ObserverFunc = window.MutationObserver || window.WebkitMutationObserver;
	            var observer = new ObserverFunc(function (mutations) {
	                mutations.forEach(function (mutation) {
	                    s.onResize(true);
	                    s.emit('onObserverUpdate', s, mutation);
	                });
	            });
	        
	            observer.observe(target, {
	                attributes: typeof options.attributes === 'undefined' ? true : options.attributes,
	                childList: typeof options.childList === 'undefined' ? true : options.childList,
	                characterData: typeof options.characterData === 'undefined' ? true : options.characterData
	            });
	        
	            s.observers.push(observer);
	        }
	        s.initObservers = function () {
	            if (s.params.observeParents) {
	                var containerParents = s.container.parents();
	                for (var i = 0; i < containerParents.length; i++) {
	                    initObserver(containerParents[i]);
	                }
	            }
	        
	            // Observe container
	            initObserver(s.container[0], {childList: false});
	        
	            // Observe wrapper
	            initObserver(s.wrapper[0], {attributes: false});
	        };
	        s.disconnectObservers = function () {
	            for (var i = 0; i < s.observers.length; i++) {
	                s.observers[i].disconnect();
	            }
	            s.observers = [];
	        };
	        /*=========================
	          Loop
	          ===========================*/
	        // Create looped slides
	        s.createLoop = function () {
	            // Remove duplicated slides
	            s.wrapper.children('.' + s.params.slideClass + '.' + s.params.slideDuplicateClass).remove();
	        
	            var slides = s.wrapper.children('.' + s.params.slideClass);
	        
	            if(s.params.slidesPerView === 'auto' && !s.params.loopedSlides) s.params.loopedSlides = slides.length;
	        
	            s.loopedSlides = parseInt(s.params.loopedSlides || s.params.slidesPerView, 10);
	            s.loopedSlides = s.loopedSlides + s.params.loopAdditionalSlides;
	            if (s.loopedSlides > slides.length) {
	                s.loopedSlides = slides.length;
	            }
	        
	            var prependSlides = [], appendSlides = [], i;
	            slides.each(function (index, el) {
	                var slide = $(this);
	                if (index < s.loopedSlides) appendSlides.push(el);
	                if (index < slides.length && index >= slides.length - s.loopedSlides) prependSlides.push(el);
	                slide.attr('data-swiper-slide-index', index);
	            });
	            for (i = 0; i < appendSlides.length; i++) {
	                s.wrapper.append($(appendSlides[i].cloneNode(true)).addClass(s.params.slideDuplicateClass));
	            }
	            for (i = prependSlides.length - 1; i >= 0; i--) {
	                s.wrapper.prepend($(prependSlides[i].cloneNode(true)).addClass(s.params.slideDuplicateClass));
	            }
	        };
	        s.destroyLoop = function () {
	            s.wrapper.children('.' + s.params.slideClass + '.' + s.params.slideDuplicateClass).remove();
	            s.slides.removeAttr('data-swiper-slide-index');
	        };
	        s.reLoop = function (updatePosition) {
	            var oldIndex = s.activeIndex - s.loopedSlides;
	            s.destroyLoop();
	            s.createLoop();
	            s.updateSlidesSize();
	            if (updatePosition) {
	                s.slideTo(oldIndex + s.loopedSlides, 0, false);
	            }
	        
	        };
	        s.fixLoop = function () {
	            var newIndex;
	            //Fix For Negative Oversliding
	            if (s.activeIndex < s.loopedSlides) {
	                newIndex = s.slides.length - s.loopedSlides * 3 + s.activeIndex;
	                newIndex = newIndex + s.loopedSlides;
	                s.slideTo(newIndex, 0, false, true);
	            }
	            //Fix For Positive Oversliding
	            else if ((s.params.slidesPerView === 'auto' && s.activeIndex >= s.loopedSlides * 2) || (s.activeIndex > s.slides.length - s.params.slidesPerView * 2)) {
	                newIndex = -s.slides.length + s.activeIndex + s.loopedSlides;
	                newIndex = newIndex + s.loopedSlides;
	                s.slideTo(newIndex, 0, false, true);
	            }
	        };
	        /*=========================
	          Append/Prepend/Remove Slides
	          ===========================*/
	        s.appendSlide = function (slides) {
	            if (s.params.loop) {
	                s.destroyLoop();
	            }
	            if (typeof slides === 'object' && slides.length) {
	                for (var i = 0; i < slides.length; i++) {
	                    if (slides[i]) s.wrapper.append(slides[i]);
	                }
	            }
	            else {
	                s.wrapper.append(slides);
	            }
	            if (s.params.loop) {
	                s.createLoop();
	            }
	            if (!(s.params.observer && s.support.observer)) {
	                s.update(true);
	            }
	        };
	        s.prependSlide = function (slides) {
	            if (s.params.loop) {
	                s.destroyLoop();
	            }
	            var newActiveIndex = s.activeIndex + 1;
	            if (typeof slides === 'object' && slides.length) {
	                for (var i = 0; i < slides.length; i++) {
	                    if (slides[i]) s.wrapper.prepend(slides[i]);
	                }
	                newActiveIndex = s.activeIndex + slides.length;
	            }
	            else {
	                s.wrapper.prepend(slides);
	            }
	            if (s.params.loop) {
	                s.createLoop();
	            }
	            if (!(s.params.observer && s.support.observer)) {
	                s.update(true);
	            }
	            s.slideTo(newActiveIndex, 0, false);
	        };
	        s.removeSlide = function (slidesIndexes) {
	            if (s.params.loop) {
	                s.destroyLoop();
	                s.slides = s.wrapper.children('.' + s.params.slideClass);
	            }
	            var newActiveIndex = s.activeIndex,
	                indexToRemove;
	            if (typeof slidesIndexes === 'object' && slidesIndexes.length) {
	                for (var i = 0; i < slidesIndexes.length; i++) {
	                    indexToRemove = slidesIndexes[i];
	                    if (s.slides[indexToRemove]) s.slides.eq(indexToRemove).remove();
	                    if (indexToRemove < newActiveIndex) newActiveIndex--;
	                }
	                newActiveIndex = Math.max(newActiveIndex, 0);
	            }
	            else {
	                indexToRemove = slidesIndexes;
	                if (s.slides[indexToRemove]) s.slides.eq(indexToRemove).remove();
	                if (indexToRemove < newActiveIndex) newActiveIndex--;
	                newActiveIndex = Math.max(newActiveIndex, 0);
	            }
	        
	            if (s.params.loop) {
	                s.createLoop();
	            }
	        
	            if (!(s.params.observer && s.support.observer)) {
	                s.update(true);
	            }
	            if (s.params.loop) {
	                s.slideTo(newActiveIndex + s.loopedSlides, 0, false);
	            }
	            else {
	                s.slideTo(newActiveIndex, 0, false);
	            }
	        
	        };
	        s.removeAllSlides = function () {
	            var slidesIndexes = [];
	            for (var i = 0; i < s.slides.length; i++) {
	                slidesIndexes.push(i);
	            }
	            s.removeSlide(slidesIndexes);
	        };
	        
	
	        /*=========================
	          Effects
	          ===========================*/
	        s.effects = {
	            fade: {
	                setTranslate: function () {
	                    for (var i = 0; i < s.slides.length; i++) {
	                        var slide = s.slides.eq(i);
	                        var offset = slide[0].swiperSlideOffset;
	                        var tx = -offset;
	                        if (!s.params.virtualTranslate) tx = tx - s.translate;
	                        var ty = 0;
	                        if (!s.isHorizontal()) {
	                            ty = tx;
	                            tx = 0;
	                        }
	                        var slideOpacity = s.params.fade.crossFade ?
	                                Math.max(1 - Math.abs(slide[0].progress), 0) :
	                                1 + Math.min(Math.max(slide[0].progress, -1), 0);
	                        slide
	                            .css({
	                                opacity: slideOpacity
	                            })
	                            .transform('translate3d(' + tx + 'px, ' + ty + 'px, 0px)');
	        
	                    }
	        
	                },
	                setTransition: function (duration) {
	                    s.slides.transition(duration);
	                    if (s.params.virtualTranslate && duration !== 0) {
	                        var eventTriggered = false;
	                        s.slides.transitionEnd(function () {
	                            if (eventTriggered) return;
	                            if (!s) return;
	                            eventTriggered = true;
	                            s.animating = false;
	                            var triggerEvents = ['webkitTransitionEnd', 'transitionend', 'oTransitionEnd', 'MSTransitionEnd', 'msTransitionEnd'];
	                            for (var i = 0; i < triggerEvents.length; i++) {
	                                s.wrapper.trigger(triggerEvents[i]);
	                            }
	                        });
	                    }
	                }
	            },
	            flip: {
	                setTranslate: function () {
	                    for (var i = 0; i < s.slides.length; i++) {
	                        var slide = s.slides.eq(i);
	                        var progress = slide[0].progress;
	                        if (s.params.flip.limitRotation) {
	                            progress = Math.max(Math.min(slide[0].progress, 1), -1);
	                        }
	                        var offset = slide[0].swiperSlideOffset;
	                        var rotate = -180 * progress,
	                            rotateY = rotate,
	                            rotateX = 0,
	                            tx = -offset,
	                            ty = 0;
	                        if (!s.isHorizontal()) {
	                            ty = tx;
	                            tx = 0;
	                            rotateX = -rotateY;
	                            rotateY = 0;
	                        }
	                        else if (s.rtl) {
	                            rotateY = -rotateY;
	                        }
	        
	                        slide[0].style.zIndex = -Math.abs(Math.round(progress)) + s.slides.length;
	        
	                        if (s.params.flip.slideShadows) {
	                            //Set shadows
	                            var shadowBefore = s.isHorizontal() ? slide.find('.swiper-slide-shadow-left') : slide.find('.swiper-slide-shadow-top');
	                            var shadowAfter = s.isHorizontal() ? slide.find('.swiper-slide-shadow-right') : slide.find('.swiper-slide-shadow-bottom');
	                            if (shadowBefore.length === 0) {
	                                shadowBefore = $('<div class="swiper-slide-shadow-' + (s.isHorizontal() ? 'left' : 'top') + '"></div>');
	                                slide.append(shadowBefore);
	                            }
	                            if (shadowAfter.length === 0) {
	                                shadowAfter = $('<div class="swiper-slide-shadow-' + (s.isHorizontal() ? 'right' : 'bottom') + '"></div>');
	                                slide.append(shadowAfter);
	                            }
	                            if (shadowBefore.length) shadowBefore[0].style.opacity = Math.max(-progress, 0);
	                            if (shadowAfter.length) shadowAfter[0].style.opacity = Math.max(progress, 0);
	                        }
	        
	                        slide
	                            .transform('translate3d(' + tx + 'px, ' + ty + 'px, 0px) rotateX(' + rotateX + 'deg) rotateY(' + rotateY + 'deg)');
	                    }
	                },
	                setTransition: function (duration) {
	                    s.slides.transition(duration).find('.swiper-slide-shadow-top, .swiper-slide-shadow-right, .swiper-slide-shadow-bottom, .swiper-slide-shadow-left').transition(duration);
	                    if (s.params.virtualTranslate && duration !== 0) {
	                        var eventTriggered = false;
	                        s.slides.eq(s.activeIndex).transitionEnd(function () {
	                            if (eventTriggered) return;
	                            if (!s) return;
	                            if (!$(this).hasClass(s.params.slideActiveClass)) return;
	                            eventTriggered = true;
	                            s.animating = false;
	                            var triggerEvents = ['webkitTransitionEnd', 'transitionend', 'oTransitionEnd', 'MSTransitionEnd', 'msTransitionEnd'];
	                            for (var i = 0; i < triggerEvents.length; i++) {
	                                s.wrapper.trigger(triggerEvents[i]);
	                            }
	                        });
	                    }
	                }
	            },
	            cube: {
	                setTranslate: function () {
	                    var wrapperRotate = 0, cubeShadow;
	                    if (s.params.cube.shadow) {
	                        if (s.isHorizontal()) {
	                            cubeShadow = s.wrapper.find('.swiper-cube-shadow');
	                            if (cubeShadow.length === 0) {
	                                cubeShadow = $('<div class="swiper-cube-shadow"></div>');
	                                s.wrapper.append(cubeShadow);
	                            }
	                            cubeShadow.css({height: s.width + 'px'});
	                        }
	                        else {
	                            cubeShadow = s.container.find('.swiper-cube-shadow');
	                            if (cubeShadow.length === 0) {
	                                cubeShadow = $('<div class="swiper-cube-shadow"></div>');
	                                s.container.append(cubeShadow);
	                            }
	                        }
	                    }
	                    for (var i = 0; i < s.slides.length; i++) {
	                        var slide = s.slides.eq(i);
	                        var slideAngle = i * 90;
	                        var round = Math.floor(slideAngle / 360);
	                        if (s.rtl) {
	                            slideAngle = -slideAngle;
	                            round = Math.floor(-slideAngle / 360);
	                        }
	                        var progress = Math.max(Math.min(slide[0].progress, 1), -1);
	                        var tx = 0, ty = 0, tz = 0;
	                        if (i % 4 === 0) {
	                            tx = - round * 4 * s.size;
	                            tz = 0;
	                        }
	                        else if ((i - 1) % 4 === 0) {
	                            tx = 0;
	                            tz = - round * 4 * s.size;
	                        }
	                        else if ((i - 2) % 4 === 0) {
	                            tx = s.size + round * 4 * s.size;
	                            tz = s.size;
	                        }
	                        else if ((i - 3) % 4 === 0) {
	                            tx = - s.size;
	                            tz = 3 * s.size + s.size * 4 * round;
	                        }
	                        if (s.rtl) {
	                            tx = -tx;
	                        }
	        
	                        if (!s.isHorizontal()) {
	                            ty = tx;
	                            tx = 0;
	                        }
	        
	                        var transform = 'rotateX(' + (s.isHorizontal() ? 0 : -slideAngle) + 'deg) rotateY(' + (s.isHorizontal() ? slideAngle : 0) + 'deg) translate3d(' + tx + 'px, ' + ty + 'px, ' + tz + 'px)';
	                        if (progress <= 1 && progress > -1) {
	                            wrapperRotate = i * 90 + progress * 90;
	                            if (s.rtl) wrapperRotate = -i * 90 - progress * 90;
	                        }
	                        slide.transform(transform);
	                        if (s.params.cube.slideShadows) {
	                            //Set shadows
	                            var shadowBefore = s.isHorizontal() ? slide.find('.swiper-slide-shadow-left') : slide.find('.swiper-slide-shadow-top');
	                            var shadowAfter = s.isHorizontal() ? slide.find('.swiper-slide-shadow-right') : slide.find('.swiper-slide-shadow-bottom');
	                            if (shadowBefore.length === 0) {
	                                shadowBefore = $('<div class="swiper-slide-shadow-' + (s.isHorizontal() ? 'left' : 'top') + '"></div>');
	                                slide.append(shadowBefore);
	                            }
	                            if (shadowAfter.length === 0) {
	                                shadowAfter = $('<div class="swiper-slide-shadow-' + (s.isHorizontal() ? 'right' : 'bottom') + '"></div>');
	                                slide.append(shadowAfter);
	                            }
	                            if (shadowBefore.length) shadowBefore[0].style.opacity = Math.max(-progress, 0);
	                            if (shadowAfter.length) shadowAfter[0].style.opacity = Math.max(progress, 0);
	                        }
	                    }
	                    s.wrapper.css({
	                        '-webkit-transform-origin': '50% 50% -' + (s.size / 2) + 'px',
	                        '-moz-transform-origin': '50% 50% -' + (s.size / 2) + 'px',
	                        '-ms-transform-origin': '50% 50% -' + (s.size / 2) + 'px',
	                        'transform-origin': '50% 50% -' + (s.size / 2) + 'px'
	                    });
	        
	                    if (s.params.cube.shadow) {
	                        if (s.isHorizontal()) {
	                            cubeShadow.transform('translate3d(0px, ' + (s.width / 2 + s.params.cube.shadowOffset) + 'px, ' + (-s.width / 2) + 'px) rotateX(90deg) rotateZ(0deg) scale(' + (s.params.cube.shadowScale) + ')');
	                        }
	                        else {
	                            var shadowAngle = Math.abs(wrapperRotate) - Math.floor(Math.abs(wrapperRotate) / 90) * 90;
	                            var multiplier = 1.5 - (Math.sin(shadowAngle * 2 * Math.PI / 360) / 2 + Math.cos(shadowAngle * 2 * Math.PI / 360) / 2);
	                            var scale1 = s.params.cube.shadowScale,
	                                scale2 = s.params.cube.shadowScale / multiplier,
	                                offset = s.params.cube.shadowOffset;
	                            cubeShadow.transform('scale3d(' + scale1 + ', 1, ' + scale2 + ') translate3d(0px, ' + (s.height / 2 + offset) + 'px, ' + (-s.height / 2 / scale2) + 'px) rotateX(-90deg)');
	                        }
	                    }
	                    var zFactor = (s.isSafari || s.isUiWebView) ? (-s.size / 2) : 0;
	                    s.wrapper.transform('translate3d(0px,0,' + zFactor + 'px) rotateX(' + (s.isHorizontal() ? 0 : wrapperRotate) + 'deg) rotateY(' + (s.isHorizontal() ? -wrapperRotate : 0) + 'deg)');
	                },
	                setTransition: function (duration) {
	                    s.slides.transition(duration).find('.swiper-slide-shadow-top, .swiper-slide-shadow-right, .swiper-slide-shadow-bottom, .swiper-slide-shadow-left').transition(duration);
	                    if (s.params.cube.shadow && !s.isHorizontal()) {
	                        s.container.find('.swiper-cube-shadow').transition(duration);
	                    }
	                }
	            },
	            coverflow: {
	                setTranslate: function () {
	                    var transform = s.translate;
	                    var center = s.isHorizontal() ? -transform + s.width / 2 : -transform + s.height / 2;
	                    var rotate = s.isHorizontal() ? s.params.coverflow.rotate: -s.params.coverflow.rotate;
	                    var translate = s.params.coverflow.depth;
	                    //Each slide offset from center
	                    for (var i = 0, length = s.slides.length; i < length; i++) {
	                        var slide = s.slides.eq(i);
	                        var slideSize = s.slidesSizesGrid[i];
	                        var slideOffset = slide[0].swiperSlideOffset;
	                        var offsetMultiplier = (center - slideOffset - slideSize / 2) / slideSize * s.params.coverflow.modifier;
	        
	                        var rotateY = s.isHorizontal() ? rotate * offsetMultiplier : 0;
	                        var rotateX = s.isHorizontal() ? 0 : rotate * offsetMultiplier;
	                        // var rotateZ = 0
	                        var translateZ = -translate * Math.abs(offsetMultiplier);
	        
	                        var translateY = s.isHorizontal() ? 0 : s.params.coverflow.stretch * (offsetMultiplier);
	                        var translateX = s.isHorizontal() ? s.params.coverflow.stretch * (offsetMultiplier) : 0;
	        
	                        //Fix for ultra small values
	                        if (Math.abs(translateX) < 0.001) translateX = 0;
	                        if (Math.abs(translateY) < 0.001) translateY = 0;
	                        if (Math.abs(translateZ) < 0.001) translateZ = 0;
	                        if (Math.abs(rotateY) < 0.001) rotateY = 0;
	                        if (Math.abs(rotateX) < 0.001) rotateX = 0;
	        
	                        var slideTransform = 'translate3d(' + translateX + 'px,' + translateY + 'px,' + translateZ + 'px)  rotateX(' + rotateX + 'deg) rotateY(' + rotateY + 'deg)';
	        
	                        slide.transform(slideTransform);
	                        slide[0].style.zIndex = -Math.abs(Math.round(offsetMultiplier)) + 1;
	                        if (s.params.coverflow.slideShadows) {
	                            //Set shadows
	                            var shadowBefore = s.isHorizontal() ? slide.find('.swiper-slide-shadow-left') : slide.find('.swiper-slide-shadow-top');
	                            var shadowAfter = s.isHorizontal() ? slide.find('.swiper-slide-shadow-right') : slide.find('.swiper-slide-shadow-bottom');
	                            if (shadowBefore.length === 0) {
	                                shadowBefore = $('<div class="swiper-slide-shadow-' + (s.isHorizontal() ? 'left' : 'top') + '"></div>');
	                                slide.append(shadowBefore);
	                            }
	                            if (shadowAfter.length === 0) {
	                                shadowAfter = $('<div class="swiper-slide-shadow-' + (s.isHorizontal() ? 'right' : 'bottom') + '"></div>');
	                                slide.append(shadowAfter);
	                            }
	                            if (shadowBefore.length) shadowBefore[0].style.opacity = offsetMultiplier > 0 ? offsetMultiplier : 0;
	                            if (shadowAfter.length) shadowAfter[0].style.opacity = (-offsetMultiplier) > 0 ? -offsetMultiplier : 0;
	                        }
	                    }
	        
	                    //Set correct perspective for IE10
	                    if (s.browser.ie) {
	                        var ws = s.wrapper[0].style;
	                        ws.perspectiveOrigin = center + 'px 50%';
	                    }
	                },
	                setTransition: function (duration) {
	                    s.slides.transition(duration).find('.swiper-slide-shadow-top, .swiper-slide-shadow-right, .swiper-slide-shadow-bottom, .swiper-slide-shadow-left').transition(duration);
	                }
	            }
	        };
	        
	
	        /*=========================
	          Images Lazy Loading
	          ===========================*/
	        s.lazy = {
	            initialImageLoaded: false,
	            loadImageInSlide: function (index, loadInDuplicate) {
	                if (typeof index === 'undefined') return;
	                if (typeof loadInDuplicate === 'undefined') loadInDuplicate = true;
	                if (s.slides.length === 0) return;
	        
	                var slide = s.slides.eq(index);
	                var img = slide.find('.' + s.params.lazyLoadingClass + ':not(.' + s.params.lazyStatusLoadedClass + '):not(.' + s.params.lazyStatusLoadingClass + ')');
	                if (slide.hasClass(s.params.lazyLoadingClass) && !slide.hasClass(s.params.lazyStatusLoadedClass) && !slide.hasClass(s.params.lazyStatusLoadingClass)) {
	                    img = img.add(slide[0]);
	                }
	                if (img.length === 0) return;
	        
	                img.each(function () {
	                    var _img = $(this);
	                    _img.addClass(s.params.lazyStatusLoadingClass);
	                    var background = _img.attr('data-background');
	                    var src = _img.attr('data-src'),
	                        srcset = _img.attr('data-srcset'),
	                        sizes = _img.attr('data-sizes');
	                    s.loadImage(_img[0], (src || background), srcset, sizes, false, function () {
	                        if (typeof s === 'undefined' || s === null || !s) return;
	                        if (background) {
	                            _img.css('background-image', 'url("' + background + '")');
	                            _img.removeAttr('data-background');
	                        }
	                        else {
	                            if (srcset) {
	                                _img.attr('srcset', srcset);
	                                _img.removeAttr('data-srcset');
	                            }
	                            if (sizes) {
	                                _img.attr('sizes', sizes);
	                                _img.removeAttr('data-sizes');
	                            }
	                            if (src) {
	                                _img.attr('src', src);
	                                _img.removeAttr('data-src');
	                            }
	        
	                        }
	        
	                        _img.addClass(s.params.lazyStatusLoadedClass).removeClass(s.params.lazyStatusLoadingClass);
	                        slide.find('.' + s.params.lazyPreloaderClass + ', .' + s.params.preloaderClass).remove();
	                        if (s.params.loop && loadInDuplicate) {
	                            var slideOriginalIndex = slide.attr('data-swiper-slide-index');
	                            if (slide.hasClass(s.params.slideDuplicateClass)) {
	                                var originalSlide = s.wrapper.children('[data-swiper-slide-index="' + slideOriginalIndex + '"]:not(.' + s.params.slideDuplicateClass + ')');
	                                s.lazy.loadImageInSlide(originalSlide.index(), false);
	                            }
	                            else {
	                                var duplicatedSlide = s.wrapper.children('.' + s.params.slideDuplicateClass + '[data-swiper-slide-index="' + slideOriginalIndex + '"]');
	                                s.lazy.loadImageInSlide(duplicatedSlide.index(), false);
	                            }
	                        }
	                        s.emit('onLazyImageReady', s, slide[0], _img[0]);
	                    });
	        
	                    s.emit('onLazyImageLoad', s, slide[0], _img[0]);
	                });
	        
	            },
	            load: function () {
	                var i;
	                var slidesPerView = s.params.slidesPerView;
	                if (slidesPerView === 'auto') {
	                    slidesPerView = 0;
	                }
	                if (!s.lazy.initialImageLoaded) s.lazy.initialImageLoaded = true;
	                if (s.params.watchSlidesVisibility) {
	                    s.wrapper.children('.' + s.params.slideVisibleClass).each(function () {
	                        s.lazy.loadImageInSlide($(this).index());
	                    });
	                }
	                else {
	                    if (slidesPerView > 1) {
	                        for (i = s.activeIndex; i < s.activeIndex + slidesPerView ; i++) {
	                            if (s.slides[i]) s.lazy.loadImageInSlide(i);
	                        }
	                    }
	                    else {
	                        s.lazy.loadImageInSlide(s.activeIndex);
	                    }
	                }
	                if (s.params.lazyLoadingInPrevNext) {
	                    if (slidesPerView > 1 || (s.params.lazyLoadingInPrevNextAmount && s.params.lazyLoadingInPrevNextAmount > 1)) {
	                        var amount = s.params.lazyLoadingInPrevNextAmount;
	                        var spv = slidesPerView;
	                        var maxIndex = Math.min(s.activeIndex + spv + Math.max(amount, spv), s.slides.length);
	                        var minIndex = Math.max(s.activeIndex - Math.max(spv, amount), 0);
	                        // Next Slides
	                        for (i = s.activeIndex + slidesPerView; i < maxIndex; i++) {
	                            if (s.slides[i]) s.lazy.loadImageInSlide(i);
	                        }
	                        // Prev Slides
	                        for (i = minIndex; i < s.activeIndex ; i++) {
	                            if (s.slides[i]) s.lazy.loadImageInSlide(i);
	                        }
	                    }
	                    else {
	                        var nextSlide = s.wrapper.children('.' + s.params.slideNextClass);
	                        if (nextSlide.length > 0) s.lazy.loadImageInSlide(nextSlide.index());
	        
	                        var prevSlide = s.wrapper.children('.' + s.params.slidePrevClass);
	                        if (prevSlide.length > 0) s.lazy.loadImageInSlide(prevSlide.index());
	                    }
	                }
	            },
	            onTransitionStart: function () {
	                if (s.params.lazyLoading) {
	                    if (s.params.lazyLoadingOnTransitionStart || (!s.params.lazyLoadingOnTransitionStart && !s.lazy.initialImageLoaded)) {
	                        s.lazy.load();
	                    }
	                }
	            },
	            onTransitionEnd: function () {
	                if (s.params.lazyLoading && !s.params.lazyLoadingOnTransitionStart) {
	                    s.lazy.load();
	                }
	            }
	        };
	        
	
	        /*=========================
	          Scrollbar
	          ===========================*/
	        s.scrollbar = {
	            isTouched: false,
	            setDragPosition: function (e) {
	                var sb = s.scrollbar;
	                var x = 0, y = 0;
	                var translate;
	                var pointerPosition = s.isHorizontal() ?
	                    ((e.type === 'touchstart' || e.type === 'touchmove') ? e.targetTouches[0].pageX : e.pageX || e.clientX) :
	                    ((e.type === 'touchstart' || e.type === 'touchmove') ? e.targetTouches[0].pageY : e.pageY || e.clientY) ;
	                var position = (pointerPosition) - sb.track.offset()[s.isHorizontal() ? 'left' : 'top'] - sb.dragSize / 2;
	                var positionMin = -s.minTranslate() * sb.moveDivider;
	                var positionMax = -s.maxTranslate() * sb.moveDivider;
	                if (position < positionMin) {
	                    position = positionMin;
	                }
	                else if (position > positionMax) {
	                    position = positionMax;
	                }
	                position = -position / sb.moveDivider;
	                s.updateProgress(position);
	                s.setWrapperTranslate(position, true);
	            },
	            dragStart: function (e) {
	                var sb = s.scrollbar;
	                sb.isTouched = true;
	                e.preventDefault();
	                e.stopPropagation();
	        
	                sb.setDragPosition(e);
	                clearTimeout(sb.dragTimeout);
	        
	                sb.track.transition(0);
	                if (s.params.scrollbarHide) {
	                    sb.track.css('opacity', 1);
	                }
	                s.wrapper.transition(100);
	                sb.drag.transition(100);
	                s.emit('onScrollbarDragStart', s);
	            },
	            dragMove: function (e) {
	                var sb = s.scrollbar;
	                if (!sb.isTouched) return;
	                if (e.preventDefault) e.preventDefault();
	                else e.returnValue = false;
	                sb.setDragPosition(e);
	                s.wrapper.transition(0);
	                sb.track.transition(0);
	                sb.drag.transition(0);
	                s.emit('onScrollbarDragMove', s);
	            },
	            dragEnd: function (e) {
	                var sb = s.scrollbar;
	                if (!sb.isTouched) return;
	                sb.isTouched = false;
	                if (s.params.scrollbarHide) {
	                    clearTimeout(sb.dragTimeout);
	                    sb.dragTimeout = setTimeout(function () {
	                        sb.track.css('opacity', 0);
	                        sb.track.transition(400);
	                    }, 1000);
	        
	                }
	                s.emit('onScrollbarDragEnd', s);
	                if (s.params.scrollbarSnapOnRelease) {
	                    s.slideReset();
	                }
	            },
	            draggableEvents: (function () {
	                if ((s.params.simulateTouch === false && !s.support.touch)) return s.touchEventsDesktop;
	                else return s.touchEvents;
	            })(),
	            enableDraggable: function () {
	                var sb = s.scrollbar;
	                var target = s.support.touch ? sb.track : document;
	                $(sb.track).on(sb.draggableEvents.start, sb.dragStart);
	                $(target).on(sb.draggableEvents.move, sb.dragMove);
	                $(target).on(sb.draggableEvents.end, sb.dragEnd);
	            },
	            disableDraggable: function () {
	                var sb = s.scrollbar;
	                var target = s.support.touch ? sb.track : document;
	                $(sb.track).off(sb.draggableEvents.start, sb.dragStart);
	                $(target).off(sb.draggableEvents.move, sb.dragMove);
	                $(target).off(sb.draggableEvents.end, sb.dragEnd);
	            },
	            set: function () {
	                if (!s.params.scrollbar) return;
	                var sb = s.scrollbar;
	                sb.track = $(s.params.scrollbar);
	                if (s.params.uniqueNavElements && typeof s.params.scrollbar === 'string' && sb.track.length > 1 && s.container.find(s.params.scrollbar).length === 1) {
	                    sb.track = s.container.find(s.params.scrollbar);
	                }
	                sb.drag = sb.track.find('.swiper-scrollbar-drag');
	                if (sb.drag.length === 0) {
	                    sb.drag = $('<div class="swiper-scrollbar-drag"></div>');
	                    sb.track.append(sb.drag);
	                }
	                sb.drag[0].style.width = '';
	                sb.drag[0].style.height = '';
	                sb.trackSize = s.isHorizontal() ? sb.track[0].offsetWidth : sb.track[0].offsetHeight;
	        
	                sb.divider = s.size / s.virtualSize;
	                sb.moveDivider = sb.divider * (sb.trackSize / s.size);
	                sb.dragSize = sb.trackSize * sb.divider;
	        
	                if (s.isHorizontal()) {
	                    sb.drag[0].style.width = sb.dragSize + 'px';
	                }
	                else {
	                    sb.drag[0].style.height = sb.dragSize + 'px';
	                }
	        
	                if (sb.divider >= 1) {
	                    sb.track[0].style.display = 'none';
	                }
	                else {
	                    sb.track[0].style.display = '';
	                }
	                if (s.params.scrollbarHide) {
	                    sb.track[0].style.opacity = 0;
	                }
	            },
	            setTranslate: function () {
	                if (!s.params.scrollbar) return;
	                var diff;
	                var sb = s.scrollbar;
	                var translate = s.translate || 0;
	                var newPos;
	        
	                var newSize = sb.dragSize;
	                newPos = (sb.trackSize - sb.dragSize) * s.progress;
	                if (s.rtl && s.isHorizontal()) {
	                    newPos = -newPos;
	                    if (newPos > 0) {
	                        newSize = sb.dragSize - newPos;
	                        newPos = 0;
	                    }
	                    else if (-newPos + sb.dragSize > sb.trackSize) {
	                        newSize = sb.trackSize + newPos;
	                    }
	                }
	                else {
	                    if (newPos < 0) {
	                        newSize = sb.dragSize + newPos;
	                        newPos = 0;
	                    }
	                    else if (newPos + sb.dragSize > sb.trackSize) {
	                        newSize = sb.trackSize - newPos;
	                    }
	                }
	                if (s.isHorizontal()) {
	                    if (s.support.transforms3d) {
	                        sb.drag.transform('translate3d(' + (newPos) + 'px, 0, 0)');
	                    }
	                    else {
	                        sb.drag.transform('translateX(' + (newPos) + 'px)');
	                    }
	                    sb.drag[0].style.width = newSize + 'px';
	                }
	                else {
	                    if (s.support.transforms3d) {
	                        sb.drag.transform('translate3d(0px, ' + (newPos) + 'px, 0)');
	                    }
	                    else {
	                        sb.drag.transform('translateY(' + (newPos) + 'px)');
	                    }
	                    sb.drag[0].style.height = newSize + 'px';
	                }
	                if (s.params.scrollbarHide) {
	                    clearTimeout(sb.timeout);
	                    sb.track[0].style.opacity = 1;
	                    sb.timeout = setTimeout(function () {
	                        sb.track[0].style.opacity = 0;
	                        sb.track.transition(400);
	                    }, 1000);
	                }
	            },
	            setTransition: function (duration) {
	                if (!s.params.scrollbar) return;
	                s.scrollbar.drag.transition(duration);
	            }
	        };
	        
	
	        /*=========================
	          Controller
	          ===========================*/
	        s.controller = {
	            LinearSpline: function (x, y) {
	                var binarySearch = (function() {
	                    var maxIndex, minIndex, guess;
	                    return function(array, val) {
	                        minIndex = -1;
	                        maxIndex = array.length;
	                        while (maxIndex - minIndex > 1)
	                            if (array[guess = maxIndex + minIndex >> 1] <= val) {
	                                minIndex = guess;
	                            } else {
	                                maxIndex = guess;
	                            }
	                        return maxIndex;
	                    };
	                })();
	                this.x = x;
	                this.y = y;
	                this.lastIndex = x.length - 1;
	                // Given an x value (x2), return the expected y2 value:
	                // (x1,y1) is the known point before given value,
	                // (x3,y3) is the known point after given value.
	                var i1, i3;
	                var l = this.x.length;
	        
	                this.interpolate = function (x2) {
	                    if (!x2) return 0;
	        
	                    // Get the indexes of x1 and x3 (the array indexes before and after given x2):
	                    i3 = binarySearch(this.x, x2);
	                    i1 = i3 - 1;
	        
	                    // We have our indexes i1 & i3, so we can calculate already:
	                    // y2 := ((x2−x1) × (y3−y1)) ÷ (x3−x1) + y1
	                    return ((x2 - this.x[i1]) * (this.y[i3] - this.y[i1])) / (this.x[i3] - this.x[i1]) + this.y[i1];
	                };
	            },
	            //xxx: for now i will just save one spline function to to
	            getInterpolateFunction: function(c){
	                if(!s.controller.spline) s.controller.spline = s.params.loop ?
	                    new s.controller.LinearSpline(s.slidesGrid, c.slidesGrid) :
	                    new s.controller.LinearSpline(s.snapGrid, c.snapGrid);
	            },
	            setTranslate: function (translate, byController) {
	               var controlled = s.params.control;
	               var multiplier, controlledTranslate;
	               function setControlledTranslate(c) {
	                    // this will create an Interpolate function based on the snapGrids
	                    // x is the Grid of the scrolled scroller and y will be the controlled scroller
	                    // it makes sense to create this only once and recall it for the interpolation
	                    // the function does a lot of value caching for performance
	                    translate = c.rtl && c.params.direction === 'horizontal' ? -s.translate : s.translate;
	                    if (s.params.controlBy === 'slide') {
	                        s.controller.getInterpolateFunction(c);
	                        // i am not sure why the values have to be multiplicated this way, tried to invert the snapGrid
	                        // but it did not work out
	                        controlledTranslate = -s.controller.spline.interpolate(-translate);
	                    }
	        
	                    if(!controlledTranslate || s.params.controlBy === 'container'){
	                        multiplier = (c.maxTranslate() - c.minTranslate()) / (s.maxTranslate() - s.minTranslate());
	                        controlledTranslate = (translate - s.minTranslate()) * multiplier + c.minTranslate();
	                    }
	        
	                    if (s.params.controlInverse) {
	                        controlledTranslate = c.maxTranslate() - controlledTranslate;
	                    }
	                    c.updateProgress(controlledTranslate);
	                    c.setWrapperTranslate(controlledTranslate, false, s);
	                    c.updateActiveIndex();
	               }
	               if (Array.isArray(controlled)) {
	                   for (var i = 0; i < controlled.length; i++) {
	                       if (controlled[i] !== byController && controlled[i] instanceof Swiper) {
	                           setControlledTranslate(controlled[i]);
	                       }
	                   }
	               }
	               else if (controlled instanceof Swiper && byController !== controlled) {
	        
	                   setControlledTranslate(controlled);
	               }
	            },
	            setTransition: function (duration, byController) {
	                var controlled = s.params.control;
	                var i;
	                function setControlledTransition(c) {
	                    c.setWrapperTransition(duration, s);
	                    if (duration !== 0) {
	                        c.onTransitionStart();
	                        c.wrapper.transitionEnd(function(){
	                            if (!controlled) return;
	                            if (c.params.loop && s.params.controlBy === 'slide') {
	                                c.fixLoop();
	                            }
	                            c.onTransitionEnd();
	        
	                        });
	                    }
	                }
	                if (Array.isArray(controlled)) {
	                    for (i = 0; i < controlled.length; i++) {
	                        if (controlled[i] !== byController && controlled[i] instanceof Swiper) {
	                            setControlledTransition(controlled[i]);
	                        }
	                    }
	                }
	                else if (controlled instanceof Swiper && byController !== controlled) {
	                    setControlledTransition(controlled);
	                }
	            }
	        };
	        
	
	        /*=========================
	          Hash Navigation
	          ===========================*/
	        s.hashnav = {
	            onHashCange: function (e, a) {
	                var newHash = document.location.hash.replace('#', '');
	                var activeSlideHash = s.slides.eq(s.activeIndex).attr('data-hash');
	                if (newHash !== activeSlideHash) {
	                    s.slideTo(s.wrapper.children('.' + s.params.slideClass + '[data-hash="' + (newHash) + '"]').index());
	                }
	            },
	            attachEvents: function (detach) {
	                var action = detach ? 'off' : 'on';
	                $(window)[action]('hashchange', s.hashnav.onHashCange);
	            },
	            setHash: function () {
	                if (!s.hashnav.initialized || !s.params.hashnav) return;
	                if (s.params.replaceState && window.history && window.history.replaceState) {
	                    window.history.replaceState(null, null, ('#' + s.slides.eq(s.activeIndex).attr('data-hash') || ''));
	                } else {
	                    var slide = s.slides.eq(s.activeIndex);
	                    var hash = slide.attr('data-hash') || slide.attr('data-history');
	                    document.location.hash = hash || '';
	                }
	            },
	            init: function () {
	                if (!s.params.hashnav || s.params.history) return;
	                s.hashnav.initialized = true;
	                var hash = document.location.hash.replace('#', '');
	                if (hash) {
	                    var speed = 0;
	                    for (var i = 0, length = s.slides.length; i < length; i++) {
	                        var slide = s.slides.eq(i);
	                        var slideHash = slide.attr('data-hash') || slide.attr('data-history');
	                        if (slideHash === hash && !slide.hasClass(s.params.slideDuplicateClass)) {
	                            var index = slide.index();
	                            s.slideTo(index, speed, s.params.runCallbacksOnInit, true);
	                        }
	                    }
	                }
	                if (s.params.hashnavWatchState) s.hashnav.attachEvents();
	            },
	            destroy: function () {
	                if (s.params.hashnavWatchState) s.hashnav.attachEvents(true);
	            }
	        };
	        
	
	        /*=========================
	          History Api with fallback to Hashnav
	          ===========================*/
	        s.history = {
	            init: function () {
	                if (!s.params.history) return;
	                if (!window.history || !window.history.pushState) {
	                    s.params.history = false;
	                    s.params.hashnav = true;
	                    return;
	                }
	                s.history.initialized = true;
	                this.paths = this.getPathValues();
	                if (!this.paths.key && !this.paths.value) return;
	                this.scrollToSlide(0, this.paths.value, s.params.runCallbacksOnInit);
	                if (!s.params.replaceState) {
	                    window.addEventListener('popstate', this.setHistoryPopState);
	                }
	            },
	            setHistoryPopState: function() {
	                s.history.paths = s.history.getPathValues();
	                s.history.scrollToSlide(s.params.speed, s.history.paths.value, false);
	            },
	            getPathValues: function() {
	                var pathArray = window.location.pathname.slice(1).split('/');
	                var total = pathArray.length;
	                var key = pathArray[total - 2];
	                var value = pathArray[total - 1];
	                return { key: key, value: value };
	            },
	            setHistory: function (key, index) {
	                if (!s.history.initialized || !s.params.history) return;
	                var slide = s.slides.eq(index);
	                var value = this.slugify(slide.attr('data-history'));
	                if (!window.location.pathname.includes(key)) {
	                    value = key + '/' + value;
	                }
	                if (s.params.replaceState) {
	                    window.history.replaceState(null, null, value);
	                } else {
	                    window.history.pushState(null, null, value);
	                }
	            },
	            slugify: function(text) {
	                return text.toString().toLowerCase()
	                    .replace(/\s+/g, '-')
	                    .replace(/[^\w\-]+/g, '')
	                    .replace(/\-\-+/g, '-')
	                    .replace(/^-+/, '')
	                    .replace(/-+$/, '');
	            },
	            scrollToSlide: function(speed, value, runCallbacks) {
	                if (value) {
	                    for (var i = 0, length = s.slides.length; i < length; i++) {
	                        var slide = s.slides.eq(i);
	                        var slideHistory = this.slugify(slide.attr('data-history'));
	                        if (slideHistory === value && !slide.hasClass(s.params.slideDuplicateClass)) {
	                            var index = slide.index();
	                            s.slideTo(index, speed, runCallbacks);
	                        }
	                    }
	                } else {
	                    s.slideTo(0, speed, runCallbacks);
	                }
	            }
	        };
	        
	
	        /*=========================
	          Keyboard Control
	          ===========================*/
	        function handleKeyboard(e) {
	            if (e.originalEvent) e = e.originalEvent; //jquery fix
	            var kc = e.keyCode || e.charCode;
	            // Directions locks
	            if (!s.params.allowSwipeToNext && (s.isHorizontal() && kc === 39 || !s.isHorizontal() && kc === 40)) {
	                return false;
	            }
	            if (!s.params.allowSwipeToPrev && (s.isHorizontal() && kc === 37 || !s.isHorizontal() && kc === 38)) {
	                return false;
	            }
	            if (e.shiftKey || e.altKey || e.ctrlKey || e.metaKey) {
	                return;
	            }
	            if (document.activeElement && document.activeElement.nodeName && (document.activeElement.nodeName.toLowerCase() === 'input' || document.activeElement.nodeName.toLowerCase() === 'textarea')) {
	                return;
	            }
	            if (kc === 37 || kc === 39 || kc === 38 || kc === 40) {
	                var inView = false;
	                //Check that swiper should be inside of visible area of window
	                if (s.container.parents('.' + s.params.slideClass).length > 0 && s.container.parents('.' + s.params.slideActiveClass).length === 0) {
	                    return;
	                }
	                var windowScroll = {
	                    left: window.pageXOffset,
	                    top: window.pageYOffset
	                };
	                var windowWidth = window.innerWidth;
	                var windowHeight = window.innerHeight;
	                var swiperOffset = s.container.offset();
	                if (s.rtl) swiperOffset.left = swiperOffset.left - s.container[0].scrollLeft;
	                var swiperCoord = [
	                    [swiperOffset.left, swiperOffset.top],
	                    [swiperOffset.left + s.width, swiperOffset.top],
	                    [swiperOffset.left, swiperOffset.top + s.height],
	                    [swiperOffset.left + s.width, swiperOffset.top + s.height]
	                ];
	                for (var i = 0; i < swiperCoord.length; i++) {
	                    var point = swiperCoord[i];
	                    if (
	                        point[0] >= windowScroll.left && point[0] <= windowScroll.left + windowWidth &&
	                        point[1] >= windowScroll.top && point[1] <= windowScroll.top + windowHeight
	                    ) {
	                        inView = true;
	                    }
	        
	                }
	                if (!inView) return;
	            }
	            if (s.isHorizontal()) {
	                if (kc === 37 || kc === 39) {
	                    if (e.preventDefault) e.preventDefault();
	                    else e.returnValue = false;
	                }
	                if ((kc === 39 && !s.rtl) || (kc === 37 && s.rtl)) s.slideNext();
	                if ((kc === 37 && !s.rtl) || (kc === 39 && s.rtl)) s.slidePrev();
	            }
	            else {
	                if (kc === 38 || kc === 40) {
	                    if (e.preventDefault) e.preventDefault();
	                    else e.returnValue = false;
	                }
	                if (kc === 40) s.slideNext();
	                if (kc === 38) s.slidePrev();
	            }
	            s.emit('onKeyPress', s, kc);
	        }
	        s.disableKeyboardControl = function () {
	            s.params.keyboardControl = false;
	            $(document).off('keydown', handleKeyboard);
	        };
	        s.enableKeyboardControl = function () {
	            s.params.keyboardControl = true;
	            $(document).on('keydown', handleKeyboard);
	        };
	        
	
	        /*=========================
	          Mousewheel Control
	          ===========================*/
	        s.mousewheel = {
	            event: false,
	            lastScrollTime: (new window.Date()).getTime()
	        };
	        function isEventSupported() {
	            var eventName = 'onwheel';
	            var isSupported = eventName in document;
	        
	            if (!isSupported) {
	                var element = document.createElement('div');
	                element.setAttribute(eventName, 'return;');
	                isSupported = typeof element[eventName] === 'function';
	            }
	        
	            if (!isSupported &&
	                document.implementation &&
	                document.implementation.hasFeature &&
	                    // always returns true in newer browsers as per the standard.
	                    // @see http://dom.spec.whatwg.org/#dom-domimplementation-hasfeature
	                document.implementation.hasFeature('', '') !== true ) {
	                // This is the only way to test support for the `wheel` event in IE9+.
	                isSupported = document.implementation.hasFeature('Events.wheel', '3.0');
	            }
	        
	            return isSupported;
	        }
	        /**
	         * Mouse wheel (and 2-finger trackpad) support on the web sucks.  It is
	         * complicated, thus this doc is long and (hopefully) detailed enough to answer
	         * your questions.
	         *
	         * If you need to react to the mouse wheel in a predictable way, this code is
	         * like your bestest friend. * hugs *
	         *
	         * As of today, there are 4 DOM event types you can listen to:
	         *
	         *   'wheel'                -- Chrome(31+), FF(17+), IE(9+)
	         *   'mousewheel'           -- Chrome, IE(6+), Opera, Safari
	         *   'MozMousePixelScroll'  -- FF(3.5 only!) (2010-2013) -- don't bother!
	         *   'DOMMouseScroll'       -- FF(0.9.7+) since 2003
	         *
	         * So what to do?  The is the best:
	         *
	         *   normalizeWheel.getEventType();
	         *
	         * In your event callback, use this code to get sane interpretation of the
	         * deltas.  This code will return an object with properties:
	         *
	         *   spinX   -- normalized spin speed (use for zoom) - x plane
	         *   spinY   -- " - y plane
	         *   pixelX  -- normalized distance (to pixels) - x plane
	         *   pixelY  -- " - y plane
	         *
	         * Wheel values are provided by the browser assuming you are using the wheel to
	         * scroll a web page by a number of lines or pixels (or pages).  Values can vary
	         * significantly on different platforms and browsers, forgetting that you can
	         * scroll at different speeds.  Some devices (like trackpads) emit more events
	         * at smaller increments with fine granularity, and some emit massive jumps with
	         * linear speed or acceleration.
	         *
	         * This code does its best to normalize the deltas for you:
	         *
	         *   - spin is trying to normalize how far the wheel was spun (or trackpad
	         *     dragged).  This is super useful for zoom support where you want to
	         *     throw away the chunky scroll steps on the PC and make those equal to
	         *     the slow and smooth tiny steps on the Mac. Key data: This code tries to
	         *     resolve a single slow step on a wheel to 1.
	         *
	         *   - pixel is normalizing the desired scroll delta in pixel units.  You'll
	         *     get the crazy differences between browsers, but at least it'll be in
	         *     pixels!
	         *
	         *   - positive value indicates scrolling DOWN/RIGHT, negative UP/LEFT.  This
	         *     should translate to positive value zooming IN, negative zooming OUT.
	         *     This matches the newer 'wheel' event.
	         *
	         * Why are there spinX, spinY (or pixels)?
	         *
	         *   - spinX is a 2-finger side drag on the trackpad, and a shift + wheel turn
	         *     with a mouse.  It results in side-scrolling in the browser by default.
	         *
	         *   - spinY is what you expect -- it's the classic axis of a mouse wheel.
	         *
	         *   - I dropped spinZ/pixelZ.  It is supported by the DOM 3 'wheel' event and
	         *     probably is by browsers in conjunction with fancy 3D controllers .. but
	         *     you know.
	         *
	         * Implementation info:
	         *
	         * Examples of 'wheel' event if you scroll slowly (down) by one step with an
	         * average mouse:
	         *
	         *   OS X + Chrome  (mouse)     -    4   pixel delta  (wheelDelta -120)
	         *   OS X + Safari  (mouse)     -  N/A   pixel delta  (wheelDelta  -12)
	         *   OS X + Firefox (mouse)     -    0.1 line  delta  (wheelDelta  N/A)
	         *   Win8 + Chrome  (mouse)     -  100   pixel delta  (wheelDelta -120)
	         *   Win8 + Firefox (mouse)     -    3   line  delta  (wheelDelta -120)
	         *
	         * On the trackpad:
	         *
	         *   OS X + Chrome  (trackpad)  -    2   pixel delta  (wheelDelta   -6)
	         *   OS X + Firefox (trackpad)  -    1   pixel delta  (wheelDelta  N/A)
	         *
	         * On other/older browsers.. it's more complicated as there can be multiple and
	         * also missing delta values.
	         *
	         * The 'wheel' event is more standard:
	         *
	         * http://www.w3.org/TR/DOM-Level-3-Events/#events-wheelevents
	         *
	         * The basics is that it includes a unit, deltaMode (pixels, lines, pages), and
	         * deltaX, deltaY and deltaZ.  Some browsers provide other values to maintain
	         * backward compatibility with older events.  Those other values help us
	         * better normalize spin speed.  Example of what the browsers provide:
	         *
	         *                          | event.wheelDelta | event.detail
	         *        ------------------+------------------+--------------
	         *          Safari v5/OS X  |       -120       |       0
	         *          Safari v5/Win7  |       -120       |       0
	         *         Chrome v17/OS X  |       -120       |       0
	         *         Chrome v17/Win7  |       -120       |       0
	         *                IE9/Win7  |       -120       |   undefined
	         *         Firefox v4/OS X  |     undefined    |       1
	         *         Firefox v4/Win7  |     undefined    |       3
	         *
	         */
	        function normalizeWheel( /*object*/ event ) /*object*/ {
	            // Reasonable defaults
	            var PIXEL_STEP = 10;
	            var LINE_HEIGHT = 40;
	            var PAGE_HEIGHT = 800;
	        
	            var sX = 0, sY = 0,       // spinX, spinY
	                pX = 0, pY = 0;       // pixelX, pixelY
	        
	            // Legacy
	            if( 'detail' in event ) {
	                sY = event.detail;
	            }
	            if( 'wheelDelta' in event ) {
	                sY = -event.wheelDelta / 120;
	            }
	            if( 'wheelDeltaY' in event ) {
	                sY = -event.wheelDeltaY / 120;
	            }
	            if( 'wheelDeltaX' in event ) {
	                sX = -event.wheelDeltaX / 120;
	            }
	        
	            // side scrolling on FF with DOMMouseScroll
	            if( 'axis' in event && event.axis === event.HORIZONTAL_AXIS ) {
	                sX = sY;
	                sY = 0;
	            }
	        
	            pX = sX * PIXEL_STEP;
	            pY = sY * PIXEL_STEP;
	        
	            if( 'deltaY' in event ) {
	                pY = event.deltaY;
	            }
	            if( 'deltaX' in event ) {
	                pX = event.deltaX;
	            }
	        
	            if( (pX || pY) && event.deltaMode ) {
	                if( event.deltaMode === 1 ) {          // delta in LINE units
	                    pX *= LINE_HEIGHT;
	                    pY *= LINE_HEIGHT;
	                } else {                             // delta in PAGE units
	                    pX *= PAGE_HEIGHT;
	                    pY *= PAGE_HEIGHT;
	                }
	            }
	        
	            // Fall-back if spin cannot be determined
	            if( pX && !sX ) {
	                sX = (pX < 1) ? -1 : 1;
	            }
	            if( pY && !sY ) {
	                sY = (pY < 1) ? -1 : 1;
	            }
	        
	            return {
	                spinX: sX,
	                spinY: sY,
	                pixelX: pX,
	                pixelY: pY
	            };
	        }
	        if (s.params.mousewheelControl) {
	            /**
	             * The best combination if you prefer spinX + spinY normalization.  It favors
	             * the older DOMMouseScroll for Firefox, as FF does not include wheelDelta with
	             * 'wheel' event, making spin speed determination impossible.
	             */
	            s.mousewheel.event = (navigator.userAgent.indexOf('firefox') > -1) ?
	                'DOMMouseScroll' :
	                isEventSupported() ?
	                    'wheel' : 'mousewheel';
	        }
	        function handleMousewheel(e) {
	            if (e.originalEvent) e = e.originalEvent; //jquery fix
	            var delta = 0;
	            var rtlFactor = s.rtl ? -1 : 1;
	        
	            var data = normalizeWheel( e );
	        
	            if (s.params.mousewheelForceToAxis) {
	                if (s.isHorizontal()) {
	                    if (Math.abs(data.pixelX) > Math.abs(data.pixelY)) delta = data.pixelX * rtlFactor;
	                    else return;
	                }
	                else {
	                    if (Math.abs(data.pixelY) > Math.abs(data.pixelX)) delta = data.pixelY;
	                    else return;
	                }
	            }
	            else {
	                delta = Math.abs(data.pixelX) > Math.abs(data.pixelY) ? - data.pixelX * rtlFactor : - data.pixelY;
	            }
	        
	            if (delta === 0) return;
	        
	            if (s.params.mousewheelInvert) delta = -delta;
	        
	            if (!s.params.freeMode) {
	                if ((new window.Date()).getTime() - s.mousewheel.lastScrollTime > 60) {
	                    if (delta < 0) {
	                        if ((!s.isEnd || s.params.loop) && !s.animating) {
	                            s.slideNext();
	                            s.emit('onScroll', s, e);
	                        }
	                        else if (s.params.mousewheelReleaseOnEdges) return true;
	                    }
	                    else {
	                        if ((!s.isBeginning || s.params.loop) && !s.animating) {
	                            s.slidePrev();
	                            s.emit('onScroll', s, e);
	                        }
	                        else if (s.params.mousewheelReleaseOnEdges) return true;
	                    }
	                }
	                s.mousewheel.lastScrollTime = (new window.Date()).getTime();
	        
	            }
	            else {
	                //Freemode or scrollContainer:
	                var position = s.getWrapperTranslate() + delta * s.params.mousewheelSensitivity;
	                var wasBeginning = s.isBeginning,
	                    wasEnd = s.isEnd;
	        
	                if (position >= s.minTranslate()) position = s.minTranslate();
	                if (position <= s.maxTranslate()) position = s.maxTranslate();
	        
	                s.setWrapperTransition(0);
	                s.setWrapperTranslate(position);
	                s.updateProgress();
	                s.updateActiveIndex();
	        
	                if (!wasBeginning && s.isBeginning || !wasEnd && s.isEnd) {
	                    s.updateClasses();
	                }
	        
	                if (s.params.freeModeSticky) {
	                    clearTimeout(s.mousewheel.timeout);
	                    s.mousewheel.timeout = setTimeout(function () {
	                        s.slideReset();
	                    }, 300);
	                }
	                else {
	                    if (s.params.lazyLoading && s.lazy) {
	                        s.lazy.load();
	                    }
	                }
	                // Emit event
	                s.emit('onScroll', s, e);
	        
	                // Stop autoplay
	                if (s.params.autoplay && s.params.autoplayDisableOnInteraction) s.stopAutoplay();
	        
	                // Return page scroll on edge positions
	                if (position === 0 || position === s.maxTranslate()) return;
	            }
	        
	            if (e.preventDefault) e.preventDefault();
	            else e.returnValue = false;
	            return false;
	        }
	        s.disableMousewheelControl = function () {
	            if (!s.mousewheel.event) return false;
	            var target = s.container;
	            if (s.params.mousewheelEventsTarged !== 'container') {
	                target = $(s.params.mousewheelEventsTarged);
	            }
	            target.off(s.mousewheel.event, handleMousewheel);
	            s.params.mousewheelControl = false;
	            return true;
	        };
	        
	        s.enableMousewheelControl = function () {
	            if (!s.mousewheel.event) return false;
	            var target = s.container;
	            if (s.params.mousewheelEventsTarged !== 'container') {
	                target = $(s.params.mousewheelEventsTarged);
	            }
	            target.on(s.mousewheel.event, handleMousewheel);
	            s.params.mousewheelControl = true;
	            return true;
	        };
	        
	
	        /*=========================
	          Parallax
	          ===========================*/
	        function setParallaxTransform(el, progress) {
	            el = $(el);
	            var p, pX, pY;
	            var rtlFactor = s.rtl ? -1 : 1;
	        
	            p = el.attr('data-swiper-parallax') || '0';
	            pX = el.attr('data-swiper-parallax-x');
	            pY = el.attr('data-swiper-parallax-y');
	            if (pX || pY) {
	                pX = pX || '0';
	                pY = pY || '0';
	            }
	            else {
	                if (s.isHorizontal()) {
	                    pX = p;
	                    pY = '0';
	                }
	                else {
	                    pY = p;
	                    pX = '0';
	                }
	            }
	        
	            if ((pX).indexOf('%') >= 0) {
	                pX = parseInt(pX, 10) * progress * rtlFactor + '%';
	            }
	            else {
	                pX = pX * progress * rtlFactor + 'px' ;
	            }
	            if ((pY).indexOf('%') >= 0) {
	                pY = parseInt(pY, 10) * progress + '%';
	            }
	            else {
	                pY = pY * progress + 'px' ;
	            }
	        
	            el.transform('translate3d(' + pX + ', ' + pY + ',0px)');
	        }
	        s.parallax = {
	            setTranslate: function () {
	                s.container.children('[data-swiper-parallax], [data-swiper-parallax-x], [data-swiper-parallax-y]').each(function(){
	                    setParallaxTransform(this, s.progress);
	        
	                });
	                s.slides.each(function () {
	                    var slide = $(this);
	                    slide.find('[data-swiper-parallax], [data-swiper-parallax-x], [data-swiper-parallax-y]').each(function () {
	                        var progress = Math.min(Math.max(slide[0].progress, -1), 1);
	                        setParallaxTransform(this, progress);
	                    });
	                });
	            },
	            setTransition: function (duration) {
	                if (typeof duration === 'undefined') duration = s.params.speed;
	                s.container.find('[data-swiper-parallax], [data-swiper-parallax-x], [data-swiper-parallax-y]').each(function(){
	                    var el = $(this);
	                    var parallaxDuration = parseInt(el.attr('data-swiper-parallax-duration'), 10) || duration;
	                    if (duration === 0) parallaxDuration = 0;
	                    el.transition(parallaxDuration);
	                });
	            }
	        };
	        
	
	        /*=========================
	          Zoom
	          ===========================*/
	        s.zoom = {
	            // "Global" Props
	            scale: 1,
	            currentScale: 1,
	            isScaling: false,
	            gesture: {
	                slide: undefined,
	                slideWidth: undefined,
	                slideHeight: undefined,
	                image: undefined,
	                imageWrap: undefined,
	                zoomMax: s.params.zoomMax
	            },
	            image: {
	                isTouched: undefined,
	                isMoved: undefined,
	                currentX: undefined,
	                currentY: undefined,
	                minX: undefined,
	                minY: undefined,
	                maxX: undefined,
	                maxY: undefined,
	                width: undefined,
	                height: undefined,
	                startX: undefined,
	                startY: undefined,
	                touchesStart: {},
	                touchesCurrent: {}
	            },
	            velocity: {
	                x: undefined,
	                y: undefined,
	                prevPositionX: undefined,
	                prevPositionY: undefined,
	                prevTime: undefined
	            },
	            // Calc Scale From Multi-touches
	            getDistanceBetweenTouches: function (e) {
	                if (e.targetTouches.length < 2) return 1;
	                var x1 = e.targetTouches[0].pageX,
	                    y1 = e.targetTouches[0].pageY,
	                    x2 = e.targetTouches[1].pageX,
	                    y2 = e.targetTouches[1].pageY;
	                var distance = Math.sqrt(Math.pow(x2 - x1, 2) + Math.pow(y2 - y1, 2));
	                return distance;
	            },
	            // Events
	            onGestureStart: function (e) {
	                var z = s.zoom;
	                if (!s.support.gestures) {
	                    if (e.type !== 'touchstart' || e.type === 'touchstart' && e.targetTouches.length < 2) {
	                        return;
	                    }
	                    z.gesture.scaleStart = z.getDistanceBetweenTouches(e);
	                }
	                if (!z.gesture.slide || !z.gesture.slide.length) {
	                    z.gesture.slide = $(this);
	                    if (z.gesture.slide.length === 0) z.gesture.slide = s.slides.eq(s.activeIndex);
	                    z.gesture.image = z.gesture.slide.find('img, svg, canvas');
	                    z.gesture.imageWrap = z.gesture.image.parent('.' + s.params.zoomContainerClass);
	                    z.gesture.zoomMax = z.gesture.imageWrap.attr('data-swiper-zoom') || s.params.zoomMax ;
	                    if (z.gesture.imageWrap.length === 0) {
	                        z.gesture.image = undefined;
	                        return;
	                    }
	                }
	                z.gesture.image.transition(0);
	                z.isScaling = true;
	            },
	            onGestureChange: function (e) {
	                var z = s.zoom;
	                if (!s.support.gestures) {
	                    if (e.type !== 'touchmove' || e.type === 'touchmove' && e.targetTouches.length < 2) {
	                        return;
	                    }
	                    z.gesture.scaleMove = z.getDistanceBetweenTouches(e);
	                }
	                if (!z.gesture.image || z.gesture.image.length === 0) return;
	                if (s.support.gestures) {
	                    z.scale = e.scale * z.currentScale;
	                }
	                else {
	                    z.scale = (z.gesture.scaleMove / z.gesture.scaleStart) * z.currentScale;
	                }
	                if (z.scale > z.gesture.zoomMax) {
	                    z.scale = z.gesture.zoomMax - 1 + Math.pow((z.scale - z.gesture.zoomMax + 1), 0.5);
	                }
	                if (z.scale < s.params.zoomMin) {
	                    z.scale =  s.params.zoomMin + 1 - Math.pow((s.params.zoomMin - z.scale + 1), 0.5);
	                }
	                z.gesture.image.transform('translate3d(0,0,0) scale(' + z.scale + ')');
	            },
	            onGestureEnd: function (e) {
	                var z = s.zoom;
	                if (!s.support.gestures) {
	                    if (e.type !== 'touchend' || e.type === 'touchend' && e.changedTouches.length < 2) {
	                        return;
	                    }
	                }
	                if (!z.gesture.image || z.gesture.image.length === 0) return;
	                z.scale = Math.max(Math.min(z.scale, z.gesture.zoomMax), s.params.zoomMin);
	                z.gesture.image.transition(s.params.speed).transform('translate3d(0,0,0) scale(' + z.scale + ')');
	                z.currentScale = z.scale;
	                z.isScaling = false;
	                if (z.scale === 1) z.gesture.slide = undefined;
	            },
	            onTouchStart: function (s, e) {
	                var z = s.zoom;
	                if (!z.gesture.image || z.gesture.image.length === 0) return;
	                if (z.image.isTouched) return;
	                if (s.device.os === 'android') e.preventDefault();
	                z.image.isTouched = true;
	                z.image.touchesStart.x = e.type === 'touchstart' ? e.targetTouches[0].pageX : e.pageX;
	                z.image.touchesStart.y = e.type === 'touchstart' ? e.targetTouches[0].pageY : e.pageY;
	            },
	            onTouchMove: function (e) {
	                var z = s.zoom;
	                if (!z.gesture.image || z.gesture.image.length === 0) return;
	                s.allowClick = false;
	                if (!z.image.isTouched || !z.gesture.slide) return;
	        
	                if (!z.image.isMoved) {
	                    z.image.width = z.gesture.image[0].offsetWidth;
	                    z.image.height = z.gesture.image[0].offsetHeight;
	                    z.image.startX = s.getTranslate(z.gesture.imageWrap[0], 'x') || 0;
	                    z.image.startY = s.getTranslate(z.gesture.imageWrap[0], 'y') || 0;
	                    z.gesture.slideWidth = z.gesture.slide[0].offsetWidth;
	                    z.gesture.slideHeight = z.gesture.slide[0].offsetHeight;
	                    z.gesture.imageWrap.transition(0);
	                    if (s.rtl) z.image.startX = -z.image.startX;
	                    if (s.rtl) z.image.startY = -z.image.startY;
	                }
	                // Define if we need image drag
	                var scaledWidth = z.image.width * z.scale;
	                var scaledHeight = z.image.height * z.scale;
	        
	                if (scaledWidth < z.gesture.slideWidth && scaledHeight < z.gesture.slideHeight) return;
	        
	                z.image.minX = Math.min((z.gesture.slideWidth / 2 - scaledWidth / 2), 0);
	                z.image.maxX = -z.image.minX;
	                z.image.minY = Math.min((z.gesture.slideHeight / 2 - scaledHeight / 2), 0);
	                z.image.maxY = -z.image.minY;
	        
	                z.image.touchesCurrent.x = e.type === 'touchmove' ? e.targetTouches[0].pageX : e.pageX;
	                z.image.touchesCurrent.y = e.type === 'touchmove' ? e.targetTouches[0].pageY : e.pageY;
	        
	                if (!z.image.isMoved && !z.isScaling) {
	                    if (s.isHorizontal() &&
	                        (Math.floor(z.image.minX) === Math.floor(z.image.startX) && z.image.touchesCurrent.x < z.image.touchesStart.x) ||
	                        (Math.floor(z.image.maxX) === Math.floor(z.image.startX) && z.image.touchesCurrent.x > z.image.touchesStart.x)
	                        ) {
	                        z.image.isTouched = false;
	                        return;
	                    }
	                    else if (!s.isHorizontal() &&
	                        (Math.floor(z.image.minY) === Math.floor(z.image.startY) && z.image.touchesCurrent.y < z.image.touchesStart.y) ||
	                        (Math.floor(z.image.maxY) === Math.floor(z.image.startY) && z.image.touchesCurrent.y > z.image.touchesStart.y)
	                        ) {
	                        z.image.isTouched = false;
	                        return;
	                    }
	                }
	                e.preventDefault();
	                e.stopPropagation();
	        
	                z.image.isMoved = true;
	                z.image.currentX = z.image.touchesCurrent.x - z.image.touchesStart.x + z.image.startX;
	                z.image.currentY = z.image.touchesCurrent.y - z.image.touchesStart.y + z.image.startY;
	        
	                if (z.image.currentX < z.image.minX) {
	                    z.image.currentX =  z.image.minX + 1 - Math.pow((z.image.minX - z.image.currentX + 1), 0.8);
	                }
	                if (z.image.currentX > z.image.maxX) {
	                    z.image.currentX = z.image.maxX - 1 + Math.pow((z.image.currentX - z.image.maxX + 1), 0.8);
	                }
	        
	                if (z.image.currentY < z.image.minY) {
	                    z.image.currentY =  z.image.minY + 1 - Math.pow((z.image.minY - z.image.currentY + 1), 0.8);
	                }
	                if (z.image.currentY > z.image.maxY) {
	                    z.image.currentY = z.image.maxY - 1 + Math.pow((z.image.currentY - z.image.maxY + 1), 0.8);
	                }
	        
	                //Velocity
	                if (!z.velocity.prevPositionX) z.velocity.prevPositionX = z.image.touchesCurrent.x;
	                if (!z.velocity.prevPositionY) z.velocity.prevPositionY = z.image.touchesCurrent.y;
	                if (!z.velocity.prevTime) z.velocity.prevTime = Date.now();
	                z.velocity.x = (z.image.touchesCurrent.x - z.velocity.prevPositionX) / (Date.now() - z.velocity.prevTime) / 2;
	                z.velocity.y = (z.image.touchesCurrent.y - z.velocity.prevPositionY) / (Date.now() - z.velocity.prevTime) / 2;
	                if (Math.abs(z.image.touchesCurrent.x - z.velocity.prevPositionX) < 2) z.velocity.x = 0;
	                if (Math.abs(z.image.touchesCurrent.y - z.velocity.prevPositionY) < 2) z.velocity.y = 0;
	                z.velocity.prevPositionX = z.image.touchesCurrent.x;
	                z.velocity.prevPositionY = z.image.touchesCurrent.y;
	                z.velocity.prevTime = Date.now();
	        
	                z.gesture.imageWrap.transform('translate3d(' + z.image.currentX + 'px, ' + z.image.currentY + 'px,0)');
	            },
	            onTouchEnd: function (s, e) {
	                var z = s.zoom;
	                if (!z.gesture.image || z.gesture.image.length === 0) return;
	                if (!z.image.isTouched || !z.image.isMoved) {
	                    z.image.isTouched = false;
	                    z.image.isMoved = false;
	                    return;
	                }
	                z.image.isTouched = false;
	                z.image.isMoved = false;
	                var momentumDurationX = 300;
	                var momentumDurationY = 300;
	                var momentumDistanceX = z.velocity.x * momentumDurationX;
	                var newPositionX = z.image.currentX + momentumDistanceX;
	                var momentumDistanceY = z.velocity.y * momentumDurationY;
	                var newPositionY = z.image.currentY + momentumDistanceY;
	        
	                //Fix duration
	                if (z.velocity.x !== 0) momentumDurationX = Math.abs((newPositionX - z.image.currentX) / z.velocity.x);
	                if (z.velocity.y !== 0) momentumDurationY = Math.abs((newPositionY - z.image.currentY) / z.velocity.y);
	                var momentumDuration = Math.max(momentumDurationX, momentumDurationY);
	        
	                z.image.currentX = newPositionX;
	                z.image.currentY = newPositionY;
	        
	                // Define if we need image drag
	                var scaledWidth = z.image.width * z.scale;
	                var scaledHeight = z.image.height * z.scale;
	                z.image.minX = Math.min((z.gesture.slideWidth / 2 - scaledWidth / 2), 0);
	                z.image.maxX = -z.image.minX;
	                z.image.minY = Math.min((z.gesture.slideHeight / 2 - scaledHeight / 2), 0);
	                z.image.maxY = -z.image.minY;
	                z.image.currentX = Math.max(Math.min(z.image.currentX, z.image.maxX), z.image.minX);
	                z.image.currentY = Math.max(Math.min(z.image.currentY, z.image.maxY), z.image.minY);
	        
	                z.gesture.imageWrap.transition(momentumDuration).transform('translate3d(' + z.image.currentX + 'px, ' + z.image.currentY + 'px,0)');
	            },
	            onTransitionEnd: function (s) {
	                var z = s.zoom;
	                if (z.gesture.slide && s.previousIndex !== s.activeIndex) {
	                    z.gesture.image.transform('translate3d(0,0,0) scale(1)');
	                    z.gesture.imageWrap.transform('translate3d(0,0,0)');
	                    z.gesture.slide = z.gesture.image = z.gesture.imageWrap = undefined;
	                    z.scale = z.currentScale = 1;
	                }
	            },
	            // Toggle Zoom
	            toggleZoom: function (s, e) {
	                var z = s.zoom;
	                if (!z.gesture.slide) {
	                    z.gesture.slide = s.clickedSlide ? $(s.clickedSlide) : s.slides.eq(s.activeIndex);
	                    z.gesture.image = z.gesture.slide.find('img, svg, canvas');
	                    z.gesture.imageWrap = z.gesture.image.parent('.' + s.params.zoomContainerClass);
	                }
	                if (!z.gesture.image || z.gesture.image.length === 0) return;
	        
	                var touchX, touchY, offsetX, offsetY, diffX, diffY, translateX, translateY, imageWidth, imageHeight, scaledWidth, scaledHeight, translateMinX, translateMinY, translateMaxX, translateMaxY, slideWidth, slideHeight;
	        
	                if (typeof z.image.touchesStart.x === 'undefined' && e) {
	                    touchX = e.type === 'touchend' ? e.changedTouches[0].pageX : e.pageX;
	                    touchY = e.type === 'touchend' ? e.changedTouches[0].pageY : e.pageY;
	                }
	                else {
	                    touchX = z.image.touchesStart.x;
	                    touchY = z.image.touchesStart.y;
	                }
	        
	                if (z.scale && z.scale !== 1) {
	                    // Zoom Out
	                    z.scale = z.currentScale = 1;
	                    z.gesture.imageWrap.transition(300).transform('translate3d(0,0,0)');
	                    z.gesture.image.transition(300).transform('translate3d(0,0,0) scale(1)');
	                    z.gesture.slide = undefined;
	                }
	                else {
	                    // Zoom In
	                    z.scale = z.currentScale = z.gesture.imageWrap.attr('data-swiper-zoom') || s.params.zoomMax;
	                    if (e) {
	                        slideWidth = z.gesture.slide[0].offsetWidth;
	                        slideHeight = z.gesture.slide[0].offsetHeight;
	                        offsetX = z.gesture.slide.offset().left;
	                        offsetY = z.gesture.slide.offset().top;
	                        diffX = offsetX + slideWidth/2 - touchX;
	                        diffY = offsetY + slideHeight/2 - touchY;
	        
	                        imageWidth = z.gesture.image[0].offsetWidth;
	                        imageHeight = z.gesture.image[0].offsetHeight;
	                        scaledWidth = imageWidth * z.scale;
	                        scaledHeight = imageHeight * z.scale;
	        
	                        translateMinX = Math.min((slideWidth / 2 - scaledWidth / 2), 0);
	                        translateMinY = Math.min((slideHeight / 2 - scaledHeight / 2), 0);
	                        translateMaxX = -translateMinX;
	                        translateMaxY = -translateMinY;
	        
	                        translateX = diffX * z.scale;
	                        translateY = diffY * z.scale;
	        
	                        if (translateX < translateMinX) {
	                            translateX =  translateMinX;
	                        }
	                        if (translateX > translateMaxX) {
	                            translateX = translateMaxX;
	                        }
	        
	                        if (translateY < translateMinY) {
	                            translateY =  translateMinY;
	                        }
	                        if (translateY > translateMaxY) {
	                            translateY = translateMaxY;
	                        }
	                    }
	                    else {
	                        translateX = 0;
	                        translateY = 0;
	                    }
	                    z.gesture.imageWrap.transition(300).transform('translate3d(' + translateX + 'px, ' + translateY + 'px,0)');
	                    z.gesture.image.transition(300).transform('translate3d(0,0,0) scale(' + z.scale + ')');
	                }
	            },
	            // Attach/Detach Events
	            attachEvents: function (detach) {
	                var action = detach ? 'off' : 'on';
	        
	                if (s.params.zoom) {
	                    var target = s.slides;
	                    var passiveListener = s.touchEvents.start === 'touchstart' && s.support.passiveListener && s.params.passiveListeners ? {passive: true, capture: false} : false;
	                    // Scale image
	                    if (s.support.gestures) {
	                        s.slides[action]('gesturestart', s.zoom.onGestureStart, passiveListener);
	                        s.slides[action]('gesturechange', s.zoom.onGestureChange, passiveListener);
	                        s.slides[action]('gestureend', s.zoom.onGestureEnd, passiveListener);
	                    }
	                    else if (s.touchEvents.start === 'touchstart') {
	                        s.slides[action](s.touchEvents.start, s.zoom.onGestureStart, passiveListener);
	                        s.slides[action](s.touchEvents.move, s.zoom.onGestureChange, passiveListener);
	                        s.slides[action](s.touchEvents.end, s.zoom.onGestureEnd, passiveListener);
	                    }
	        
	                    // Move image
	                    s[action]('touchStart', s.zoom.onTouchStart);
	                    s.slides.each(function (index, slide){
	                        if ($(slide).find('.' + s.params.zoomContainerClass).length > 0) {
	                            $(slide)[action](s.touchEvents.move, s.zoom.onTouchMove);
	                        }
	                    });
	                    s[action]('touchEnd', s.zoom.onTouchEnd);
	        
	                    // Scale Out
	                    s[action]('transitionEnd', s.zoom.onTransitionEnd);
	                    if (s.params.zoomToggle) {
	                        s.on('doubleTap', s.zoom.toggleZoom);
	                    }
	                }
	            },
	            init: function () {
	                s.zoom.attachEvents();
	            },
	            destroy: function () {
	                s.zoom.attachEvents(true);
	            }
	        };
	        
	
	        /*=========================
	          Plugins API. Collect all and init all plugins
	          ===========================*/
	        s._plugins = [];
	        for (var plugin in s.plugins) {
	            var p = s.plugins[plugin](s, s.params[plugin]);
	            if (p) s._plugins.push(p);
	        }
	        // Method to call all plugins event/method
	        s.callPlugins = function (eventName) {
	            for (var i = 0; i < s._plugins.length; i++) {
	                if (eventName in s._plugins[i]) {
	                    s._plugins[i][eventName](arguments[1], arguments[2], arguments[3], arguments[4], arguments[5]);
	                }
	            }
	        };
	        
	
	        /*=========================
	          Events/Callbacks/Plugins Emitter
	          ===========================*/
	        function normalizeEventName (eventName) {
	            if (eventName.indexOf('on') !== 0) {
	                if (eventName[0] !== eventName[0].toUpperCase()) {
	                    eventName = 'on' + eventName[0].toUpperCase() + eventName.substring(1);
	                }
	                else {
	                    eventName = 'on' + eventName;
	                }
	            }
	            return eventName;
	        }
	        s.emitterEventListeners = {
	        
	        };
	        s.emit = function (eventName) {
	            // Trigger callbacks
	            if (s.params[eventName]) {
	                s.params[eventName](arguments[1], arguments[2], arguments[3], arguments[4], arguments[5]);
	            }
	            var i;
	            // Trigger events
	            if (s.emitterEventListeners[eventName]) {
	                for (i = 0; i < s.emitterEventListeners[eventName].length; i++) {
	                    s.emitterEventListeners[eventName][i](arguments[1], arguments[2], arguments[3], arguments[4], arguments[5]);
	                }
	            }
	            // Trigger plugins
	            if (s.callPlugins) s.callPlugins(eventName, arguments[1], arguments[2], arguments[3], arguments[4], arguments[5]);
	        };
	        s.on = function (eventName, handler) {
	            eventName = normalizeEventName(eventName);
	            if (!s.emitterEventListeners[eventName]) s.emitterEventListeners[eventName] = [];
	            s.emitterEventListeners[eventName].push(handler);
	            return s;
	        };
	        s.off = function (eventName, handler) {
	            var i;
	            eventName = normalizeEventName(eventName);
	            if (typeof handler === 'undefined') {
	                // Remove all handlers for such event
	                s.emitterEventListeners[eventName] = [];
	                return s;
	            }
	            if (!s.emitterEventListeners[eventName] || s.emitterEventListeners[eventName].length === 0) return;
	            for (i = 0; i < s.emitterEventListeners[eventName].length; i++) {
	                if(s.emitterEventListeners[eventName][i] === handler) s.emitterEventListeners[eventName].splice(i, 1);
	            }
	            return s;
	        };
	        s.once = function (eventName, handler) {
	            eventName = normalizeEventName(eventName);
	            var _handler = function () {
	                handler(arguments[0], arguments[1], arguments[2], arguments[3], arguments[4]);
	                s.off(eventName, _handler);
	            };
	            s.on(eventName, _handler);
	            return s;
	        };
	        
	
	        // Accessibility tools
	        s.a11y = {
	            makeFocusable: function ($el) {
	                $el.attr('tabIndex', '0');
	                return $el;
	            },
	            addRole: function ($el, role) {
	                $el.attr('role', role);
	                return $el;
	            },
	        
	            addLabel: function ($el, label) {
	                $el.attr('aria-label', label);
	                return $el;
	            },
	        
	            disable: function ($el) {
	                $el.attr('aria-disabled', true);
	                return $el;
	            },
	        
	            enable: function ($el) {
	                $el.attr('aria-disabled', false);
	                return $el;
	            },
	        
	            onEnterKey: function (event) {
	                if (event.keyCode !== 13) return;
	                if ($(event.target).is(s.params.nextButton)) {
	                    s.onClickNext(event);
	                    if (s.isEnd) {
	                        s.a11y.notify(s.params.lastSlideMessage);
	                    }
	                    else {
	                        s.a11y.notify(s.params.nextSlideMessage);
	                    }
	                }
	                else if ($(event.target).is(s.params.prevButton)) {
	                    s.onClickPrev(event);
	                    if (s.isBeginning) {
	                        s.a11y.notify(s.params.firstSlideMessage);
	                    }
	                    else {
	                        s.a11y.notify(s.params.prevSlideMessage);
	                    }
	                }
	                if ($(event.target).is('.' + s.params.bulletClass)) {
	                    $(event.target)[0].click();
	                }
	            },
	        
	            liveRegion: $('<span class="' + s.params.notificationClass + '" aria-live="assertive" aria-atomic="true"></span>'),
	        
	            notify: function (message) {
	                var notification = s.a11y.liveRegion;
	                if (notification.length === 0) return;
	                notification.html('');
	                notification.html(message);
	            },
	            init: function () {
	                // Setup accessibility
	                if (s.params.nextButton && s.nextButton && s.nextButton.length > 0) {
	                    s.a11y.makeFocusable(s.nextButton);
	                    s.a11y.addRole(s.nextButton, 'button');
	                    s.a11y.addLabel(s.nextButton, s.params.nextSlideMessage);
	                }
	                if (s.params.prevButton && s.prevButton && s.prevButton.length > 0) {
	                    s.a11y.makeFocusable(s.prevButton);
	                    s.a11y.addRole(s.prevButton, 'button');
	                    s.a11y.addLabel(s.prevButton, s.params.prevSlideMessage);
	                }
	        
	                $(s.container).append(s.a11y.liveRegion);
	            },
	            initPagination: function () {
	                if (s.params.pagination && s.params.paginationClickable && s.bullets && s.bullets.length) {
	                    s.bullets.each(function () {
	                        var bullet = $(this);
	                        s.a11y.makeFocusable(bullet);
	                        s.a11y.addRole(bullet, 'button');
	                        s.a11y.addLabel(bullet, s.params.paginationBulletMessage.replace(/{{index}}/, bullet.index() + 1));
	                    });
	                }
	            },
	            destroy: function () {
	                if (s.a11y.liveRegion && s.a11y.liveRegion.length > 0) s.a11y.liveRegion.remove();
	            }
	        };
	        
	
	        /*=========================
	          Init/Destroy
	          ===========================*/
	        s.init = function () {
	            if (s.params.loop) s.createLoop();
	            s.updateContainerSize();
	            s.updateSlidesSize();
	            s.updatePagination();
	            if (s.params.scrollbar && s.scrollbar) {
	                s.scrollbar.set();
	                if (s.params.scrollbarDraggable) {
	                    s.scrollbar.enableDraggable();
	                }
	            }
	            if (s.params.effect !== 'slide' && s.effects[s.params.effect]) {
	                if (!s.params.loop) s.updateProgress();
	                s.effects[s.params.effect].setTranslate();
	            }
	            if (s.params.loop) {
	                s.slideTo(s.params.initialSlide + s.loopedSlides, 0, s.params.runCallbacksOnInit);
	            }
	            else {
	                s.slideTo(s.params.initialSlide, 0, s.params.runCallbacksOnInit);
	                if (s.params.initialSlide === 0) {
	                    if (s.parallax && s.params.parallax) s.parallax.setTranslate();
	                    if (s.lazy && s.params.lazyLoading) {
	                        s.lazy.load();
	                        s.lazy.initialImageLoaded = true;
	                    }
	                }
	            }
	            s.attachEvents();
	            if (s.params.observer && s.support.observer) {
	                s.initObservers();
	            }
	            if (s.params.preloadImages && !s.params.lazyLoading) {
	                s.preloadImages();
	            }
	            if (s.params.zoom && s.zoom) {
	                s.zoom.init();
	            }
	            if (s.params.autoplay) {
	                s.startAutoplay();
	            }
	            if (s.params.keyboardControl) {
	                if (s.enableKeyboardControl) s.enableKeyboardControl();
	            }
	            if (s.params.mousewheelControl) {
	                if (s.enableMousewheelControl) s.enableMousewheelControl();
	            }
	            // Deprecated hashnavReplaceState changed to replaceState for use in hashnav and history
	            if (s.params.hashnavReplaceState) {
	                s.params.replaceState = s.params.hashnavReplaceState;
	            }
	            if (s.params.history) {
	                if (s.history) s.history.init();
	            }
	            if (s.params.hashnav) {
	                if (s.hashnav) s.hashnav.init();
	            }
	            if (s.params.a11y && s.a11y) s.a11y.init();
	            s.emit('onInit', s);
	        };
	        
	        // Cleanup dynamic styles
	        s.cleanupStyles = function () {
	            // Container
	            s.container.removeClass(s.classNames.join(' ')).removeAttr('style');
	        
	            // Wrapper
	            s.wrapper.removeAttr('style');
	        
	            // Slides
	            if (s.slides && s.slides.length) {
	                s.slides
	                    .removeClass([
	                      s.params.slideVisibleClass,
	                      s.params.slideActiveClass,
	                      s.params.slideNextClass,
	                      s.params.slidePrevClass
	                    ].join(' '))
	                    .removeAttr('style')
	                    .removeAttr('data-swiper-column')
	                    .removeAttr('data-swiper-row');
	            }
	        
	            // Pagination/Bullets
	            if (s.paginationContainer && s.paginationContainer.length) {
	                s.paginationContainer.removeClass(s.params.paginationHiddenClass);
	            }
	            if (s.bullets && s.bullets.length) {
	                s.bullets.removeClass(s.params.bulletActiveClass);
	            }
	        
	            // Buttons
	            if (s.params.prevButton) $(s.params.prevButton).removeClass(s.params.buttonDisabledClass);
	            if (s.params.nextButton) $(s.params.nextButton).removeClass(s.params.buttonDisabledClass);
	        
	            // Scrollbar
	            if (s.params.scrollbar && s.scrollbar) {
	                if (s.scrollbar.track && s.scrollbar.track.length) s.scrollbar.track.removeAttr('style');
	                if (s.scrollbar.drag && s.scrollbar.drag.length) s.scrollbar.drag.removeAttr('style');
	            }
	        };
	        
	        // Destroy
	        s.destroy = function (deleteInstance, cleanupStyles) {
	            // Detach evebts
	            s.detachEvents();
	            // Stop autoplay
	            s.stopAutoplay();
	            // Disable draggable
	            if (s.params.scrollbar && s.scrollbar) {
	                if (s.params.scrollbarDraggable) {
	                    s.scrollbar.disableDraggable();
	                }
	            }
	            // Destroy loop
	            if (s.params.loop) {
	                s.destroyLoop();
	            }
	            // Cleanup styles
	            if (cleanupStyles) {
	                s.cleanupStyles();
	            }
	            // Disconnect observer
	            s.disconnectObservers();
	        
	            // Destroy zoom
	            if (s.params.zoom && s.zoom) {
	                s.zoom.destroy();
	            }
	            // Disable keyboard/mousewheel
	            if (s.params.keyboardControl) {
	                if (s.disableKeyboardControl) s.disableKeyboardControl();
	            }
	            if (s.params.mousewheelControl) {
	                if (s.disableMousewheelControl) s.disableMousewheelControl();
	            }
	            // Disable a11y
	            if (s.params.a11y && s.a11y) s.a11y.destroy();
	            // Delete history popstate
	            if (s.params.history && !s.params.replaceState) {
	                window.removeEventListener('popstate', s.history.setHistoryPopState);
	            }
	            if (s.params.hashnav && s.hashnav)  {
	                s.hashnav.destroy();
	            }
	            // Destroy callback
	            s.emit('onDestroy');
	            // Delete instance
	            if (deleteInstance !== false) s = null;
	        };
	        
	        s.init();
	        
	
	    
	        // Return swiper instance
	        return s;
	    };
	    
	
	    /*==================================================
	        Prototype
	    ====================================================*/
	    Swiper.prototype = {
	        isSafari: (function () {
	            var ua = window.navigator.userAgent.toLowerCase();
	            return (ua.indexOf('safari') >= 0 && ua.indexOf('chrome') < 0 && ua.indexOf('android') < 0);
	        })(),
	        isUiWebView: /(iPhone|iPod|iPad).*AppleWebKit(?!.*Safari)/i.test(window.navigator.userAgent),
	        isArray: function (arr) {
	            return Object.prototype.toString.apply(arr) === '[object Array]';
	        },
	        /*==================================================
	        Browser
	        ====================================================*/
	        browser: {
	            ie: window.navigator.pointerEnabled || window.navigator.msPointerEnabled,
	            ieTouch: (window.navigator.msPointerEnabled && window.navigator.msMaxTouchPoints > 1) || (window.navigator.pointerEnabled && window.navigator.maxTouchPoints > 1),
	            lteIE9: (function() {
	                // create temporary DIV
	                var div = document.createElement('div');
	                // add content to tmp DIV which is wrapped into the IE HTML conditional statement
	                div.innerHTML = '<!--[if lte IE 9]><i></i><![endif]-->';
	                // return true / false value based on what will browser render
	                return div.getElementsByTagName('i').length === 1;
	            })()
	        },
	        /*==================================================
	        Devices
	        ====================================================*/
	        device: (function () {
	            var ua = window.navigator.userAgent;
	            var android = ua.match(/(Android);?[\s\/]+([\d.]+)?/);
	            var ipad = ua.match(/(iPad).*OS\s([\d_]+)/);
	            var ipod = ua.match(/(iPod)(.*OS\s([\d_]+))?/);
	            var iphone = !ipad && ua.match(/(iPhone\sOS|iOS)\s([\d_]+)/);
	            return {
	                ios: ipad || iphone || ipod,
	                android: android
	            };
	        })(),
	        /*==================================================
	        Feature Detection
	        ====================================================*/
	        support: {
	            touch : (window.Modernizr && Modernizr.touch === true) || (function () {
	                return !!(('ontouchstart' in window) || window.DocumentTouch && document instanceof DocumentTouch);
	            })(),
	    
	            transforms3d : (window.Modernizr && Modernizr.csstransforms3d === true) || (function () {
	                var div = document.createElement('div').style;
	                return ('webkitPerspective' in div || 'MozPerspective' in div || 'OPerspective' in div || 'MsPerspective' in div || 'perspective' in div);
	            })(),
	    
	            flexbox: (function () {
	                var div = document.createElement('div').style;
	                var styles = ('alignItems webkitAlignItems webkitBoxAlign msFlexAlign mozBoxAlign webkitFlexDirection msFlexDirection mozBoxDirection mozBoxOrient webkitBoxDirection webkitBoxOrient').split(' ');
	                for (var i = 0; i < styles.length; i++) {
	                    if (styles[i] in div) return true;
	                }
	            })(),
	    
	            observer: (function () {
	                return ('MutationObserver' in window || 'WebkitMutationObserver' in window);
	            })(),
	    
	            passiveListener: (function () {
	                var supportsPassive = false;
	                try {
	                    var opts = Object.defineProperty({}, 'passive', {
	                        get: function() {
	                            supportsPassive = true;
	                        }
	                    });
	                    window.addEventListener('testPassiveListener', null, opts);
	                } catch (e) {}
	                return supportsPassive;
	            })(),
	    
	            gestures: (function () {
	                return 'ongesturestart' in window;
	            })()
	        },
	        /*==================================================
	        Plugins
	        ====================================================*/
	        plugins: {}
	    };
	    
	
	    /*===========================
	    Dom7 Library
	    ===========================*/
	    var Dom7 = (function () {
	        var Dom7 = function (arr) {
	            var _this = this, i = 0;
	            // Create array-like object
	            for (i = 0; i < arr.length; i++) {
	                _this[i] = arr[i];
	            }
	            _this.length = arr.length;
	            // Return collection with methods
	            return this;
	        };
	        var $ = function (selector, context) {
	            var arr = [], i = 0;
	            if (selector && !context) {
	                if (selector instanceof Dom7) {
	                    return selector;
	                }
	            }
	            if (selector) {
	                // String
	                if (typeof selector === 'string') {
	                    var els, tempParent, html = selector.trim();
	                    if (html.indexOf('<') >= 0 && html.indexOf('>') >= 0) {
	                        var toCreate = 'div';
	                        if (html.indexOf('<li') === 0) toCreate = 'ul';
	                        if (html.indexOf('<tr') === 0) toCreate = 'tbody';
	                        if (html.indexOf('<td') === 0 || html.indexOf('<th') === 0) toCreate = 'tr';
	                        if (html.indexOf('<tbody') === 0) toCreate = 'table';
	                        if (html.indexOf('<option') === 0) toCreate = 'select';
	                        tempParent = document.createElement(toCreate);
	                        tempParent.innerHTML = selector;
	                        for (i = 0; i < tempParent.childNodes.length; i++) {
	                            arr.push(tempParent.childNodes[i]);
	                        }
	                    }
	                    else {
	                        if (!context && selector[0] === '#' && !selector.match(/[ .<>:~]/)) {
	                            // Pure ID selector
	                            els = [document.getElementById(selector.split('#')[1])];
	                        }
	                        else {
	                            // Other selectors
	                            els = (context || document).querySelectorAll(selector);
	                        }
	                        for (i = 0; i < els.length; i++) {
	                            if (els[i]) arr.push(els[i]);
	                        }
	                    }
	                }
	                // Node/element
	                else if (selector.nodeType || selector === window || selector === document) {
	                    arr.push(selector);
	                }
	                //Array of elements or instance of Dom
	                else if (selector.length > 0 && selector[0].nodeType) {
	                    for (i = 0; i < selector.length; i++) {
	                        arr.push(selector[i]);
	                    }
	                }
	            }
	            return new Dom7(arr);
	        };
	        Dom7.prototype = {
	            // Classes and attriutes
	            addClass: function (className) {
	                if (typeof className === 'undefined') {
	                    return this;
	                }
	                var classes = className.split(' ');
	                for (var i = 0; i < classes.length; i++) {
	                    for (var j = 0; j < this.length; j++) {
	                        this[j].classList.add(classes[i]);
	                    }
	                }
	                return this;
	            },
	            removeClass: function (className) {
	                var classes = className.split(' ');
	                for (var i = 0; i < classes.length; i++) {
	                    for (var j = 0; j < this.length; j++) {
	                        this[j].classList.remove(classes[i]);
	                    }
	                }
	                return this;
	            },
	            hasClass: function (className) {
	                if (!this[0]) return false;
	                else return this[0].classList.contains(className);
	            },
	            toggleClass: function (className) {
	                var classes = className.split(' ');
	                for (var i = 0; i < classes.length; i++) {
	                    for (var j = 0; j < this.length; j++) {
	                        this[j].classList.toggle(classes[i]);
	                    }
	                }
	                return this;
	            },
	            attr: function (attrs, value) {
	                if (arguments.length === 1 && typeof attrs === 'string') {
	                    // Get attr
	                    if (this[0]) return this[0].getAttribute(attrs);
	                    else return undefined;
	                }
	                else {
	                    // Set attrs
	                    for (var i = 0; i < this.length; i++) {
	                        if (arguments.length === 2) {
	                            // String
	                            this[i].setAttribute(attrs, value);
	                        }
	                        else {
	                            // Object
	                            for (var attrName in attrs) {
	                                this[i][attrName] = attrs[attrName];
	                                this[i].setAttribute(attrName, attrs[attrName]);
	                            }
	                        }
	                    }
	                    return this;
	                }
	            },
	            removeAttr: function (attr) {
	                for (var i = 0; i < this.length; i++) {
	                    this[i].removeAttribute(attr);
	                }
	                return this;
	            },
	            data: function (key, value) {
	                if (typeof value === 'undefined') {
	                    // Get value
	                    if (this[0]) {
	                        var dataKey = this[0].getAttribute('data-' + key);
	                        if (dataKey) return dataKey;
	                        else if (this[0].dom7ElementDataStorage && (key in this[0].dom7ElementDataStorage)) return this[0].dom7ElementDataStorage[key];
	                        else return undefined;
	                    }
	                    else return undefined;
	                }
	                else {
	                    // Set value
	                    for (var i = 0; i < this.length; i++) {
	                        var el = this[i];
	                        if (!el.dom7ElementDataStorage) el.dom7ElementDataStorage = {};
	                        el.dom7ElementDataStorage[key] = value;
	                    }
	                    return this;
	                }
	            },
	            // Transforms
	            transform : function (transform) {
	                for (var i = 0; i < this.length; i++) {
	                    var elStyle = this[i].style;
	                    elStyle.webkitTransform = elStyle.MsTransform = elStyle.msTransform = elStyle.MozTransform = elStyle.OTransform = elStyle.transform = transform;
	                }
	                return this;
	            },
	            transition: function (duration) {
	                if (typeof duration !== 'string') {
	                    duration = duration + 'ms';
	                }
	                for (var i = 0; i < this.length; i++) {
	                    var elStyle = this[i].style;
	                    elStyle.webkitTransitionDuration = elStyle.MsTransitionDuration = elStyle.msTransitionDuration = elStyle.MozTransitionDuration = elStyle.OTransitionDuration = elStyle.transitionDuration = duration;
	                }
	                return this;
	            },
	            //Events
	            on: function (eventName, targetSelector, listener, capture) {
	                function handleLiveEvent(e) {
	                    var target = e.target;
	                    if ($(target).is(targetSelector)) listener.call(target, e);
	                    else {
	                        var parents = $(target).parents();
	                        for (var k = 0; k < parents.length; k++) {
	                            if ($(parents[k]).is(targetSelector)) listener.call(parents[k], e);
	                        }
	                    }
	                }
	                var events = eventName.split(' ');
	                var i, j;
	                for (i = 0; i < this.length; i++) {
	                    if (typeof targetSelector === 'function' || targetSelector === false) {
	                        // Usual events
	                        if (typeof targetSelector === 'function') {
	                            listener = arguments[1];
	                            capture = arguments[2] || false;
	                        }
	                        for (j = 0; j < events.length; j++) {
	                            this[i].addEventListener(events[j], listener, capture);
	                        }
	                    }
	                    else {
	                        //Live events
	                        for (j = 0; j < events.length; j++) {
	                            if (!this[i].dom7LiveListeners) this[i].dom7LiveListeners = [];
	                            this[i].dom7LiveListeners.push({listener: listener, liveListener: handleLiveEvent});
	                            this[i].addEventListener(events[j], handleLiveEvent, capture);
	                        }
	                    }
	                }
	    
	                return this;
	            },
	            off: function (eventName, targetSelector, listener, capture) {
	                var events = eventName.split(' ');
	                for (var i = 0; i < events.length; i++) {
	                    for (var j = 0; j < this.length; j++) {
	                        if (typeof targetSelector === 'function' || targetSelector === false) {
	                            // Usual events
	                            if (typeof targetSelector === 'function') {
	                                listener = arguments[1];
	                                capture = arguments[2] || false;
	                            }
	                            this[j].removeEventListener(events[i], listener, capture);
	                        }
	                        else {
	                            // Live event
	                            if (this[j].dom7LiveListeners) {
	                                for (var k = 0; k < this[j].dom7LiveListeners.length; k++) {
	                                    if (this[j].dom7LiveListeners[k].listener === listener) {
	                                        this[j].removeEventListener(events[i], this[j].dom7LiveListeners[k].liveListener, capture);
	                                    }
	                                }
	                            }
	                        }
	                    }
	                }
	                return this;
	            },
	            once: function (eventName, targetSelector, listener, capture) {
	                var dom = this;
	                if (typeof targetSelector === 'function') {
	                    targetSelector = false;
	                    listener = arguments[1];
	                    capture = arguments[2];
	                }
	                function proxy(e) {
	                    listener(e);
	                    dom.off(eventName, targetSelector, proxy, capture);
	                }
	                dom.on(eventName, targetSelector, proxy, capture);
	            },
	            trigger: function (eventName, eventData) {
	                for (var i = 0; i < this.length; i++) {
	                    var evt;
	                    try {
	                        evt = new window.CustomEvent(eventName, {detail: eventData, bubbles: true, cancelable: true});
	                    }
	                    catch (e) {
	                        evt = document.createEvent('Event');
	                        evt.initEvent(eventName, true, true);
	                        evt.detail = eventData;
	                    }
	                    this[i].dispatchEvent(evt);
	                }
	                return this;
	            },
	            transitionEnd: function (callback) {
	                var events = ['webkitTransitionEnd', 'transitionend', 'oTransitionEnd', 'MSTransitionEnd', 'msTransitionEnd'],
	                    i, j, dom = this;
	                function fireCallBack(e) {
	                    /*jshint validthis:true */
	                    if (e.target !== this) return;
	                    callback.call(this, e);
	                    for (i = 0; i < events.length; i++) {
	                        dom.off(events[i], fireCallBack);
	                    }
	                }
	                if (callback) {
	                    for (i = 0; i < events.length; i++) {
	                        dom.on(events[i], fireCallBack);
	                    }
	                }
	                return this;
	            },
	            // Sizing/Styles
	            width: function () {
	                if (this[0] === window) {
	                    return window.innerWidth;
	                }
	                else {
	                    if (this.length > 0) {
	                        return parseFloat(this.css('width'));
	                    }
	                    else {
	                        return null;
	                    }
	                }
	            },
	            outerWidth: function (includeMargins) {
	                if (this.length > 0) {
	                    if (includeMargins)
	                        return this[0].offsetWidth + parseFloat(this.css('margin-right')) + parseFloat(this.css('margin-left'));
	                    else
	                        return this[0].offsetWidth;
	                }
	                else return null;
	            },
	            height: function () {
	                if (this[0] === window) {
	                    return window.innerHeight;
	                }
	                else {
	                    if (this.length > 0) {
	                        return parseFloat(this.css('height'));
	                    }
	                    else {
	                        return null;
	                    }
	                }
	            },
	            outerHeight: function (includeMargins) {
	                if (this.length > 0) {
	                    if (includeMargins)
	                        return this[0].offsetHeight + parseFloat(this.css('margin-top')) + parseFloat(this.css('margin-bottom'));
	                    else
	                        return this[0].offsetHeight;
	                }
	                else return null;
	            },
	            offset: function () {
	                if (this.length > 0) {
	                    var el = this[0];
	                    var box = el.getBoundingClientRect();
	                    var body = document.body;
	                    var clientTop  = el.clientTop  || body.clientTop  || 0;
	                    var clientLeft = el.clientLeft || body.clientLeft || 0;
	                    var scrollTop  = window.pageYOffset || el.scrollTop;
	                    var scrollLeft = window.pageXOffset || el.scrollLeft;
	                    return {
	                        top: box.top  + scrollTop  - clientTop,
	                        left: box.left + scrollLeft - clientLeft
	                    };
	                }
	                else {
	                    return null;
	                }
	            },
	            css: function (props, value) {
	                var i;
	                if (arguments.length === 1) {
	                    if (typeof props === 'string') {
	                        if (this[0]) return window.getComputedStyle(this[0], null).getPropertyValue(props);
	                    }
	                    else {
	                        for (i = 0; i < this.length; i++) {
	                            for (var prop in props) {
	                                this[i].style[prop] = props[prop];
	                            }
	                        }
	                        return this;
	                    }
	                }
	                if (arguments.length === 2 && typeof props === 'string') {
	                    for (i = 0; i < this.length; i++) {
	                        this[i].style[props] = value;
	                    }
	                    return this;
	                }
	                return this;
	            },
	    
	            //Dom manipulation
	            each: function (callback) {
	                for (var i = 0; i < this.length; i++) {
	                    callback.call(this[i], i, this[i]);
	                }
	                return this;
	            },
	            html: function (html) {
	                if (typeof html === 'undefined') {
	                    return this[0] ? this[0].innerHTML : undefined;
	                }
	                else {
	                    for (var i = 0; i < this.length; i++) {
	                        this[i].innerHTML = html;
	                    }
	                    return this;
	                }
	            },
	            text: function (text) {
	                if (typeof text === 'undefined') {
	                    if (this[0]) {
	                        return this[0].textContent.trim();
	                    }
	                    else return null;
	                }
	                else {
	                    for (var i = 0; i < this.length; i++) {
	                        this[i].textContent = text;
	                    }
	                    return this;
	                }
	            },
	            is: function (selector) {
	                if (!this[0]) return false;
	                var compareWith, i;
	                if (typeof selector === 'string') {
	                    var el = this[0];
	                    if (el === document) return selector === document;
	                    if (el === window) return selector === window;
	    
	                    if (el.matches) return el.matches(selector);
	                    else if (el.webkitMatchesSelector) return el.webkitMatchesSelector(selector);
	                    else if (el.mozMatchesSelector) return el.mozMatchesSelector(selector);
	                    else if (el.msMatchesSelector) return el.msMatchesSelector(selector);
	                    else {
	                        compareWith = $(selector);
	                        for (i = 0; i < compareWith.length; i++) {
	                            if (compareWith[i] === this[0]) return true;
	                        }
	                        return false;
	                    }
	                }
	                else if (selector === document) return this[0] === document;
	                else if (selector === window) return this[0] === window;
	                else {
	                    if (selector.nodeType || selector instanceof Dom7) {
	                        compareWith = selector.nodeType ? [selector] : selector;
	                        for (i = 0; i < compareWith.length; i++) {
	                            if (compareWith[i] === this[0]) return true;
	                        }
	                        return false;
	                    }
	                    return false;
	                }
	    
	            },
	            index: function () {
	                if (this[0]) {
	                    var child = this[0];
	                    var i = 0;
	                    while ((child = child.previousSibling) !== null) {
	                        if (child.nodeType === 1) i++;
	                    }
	                    return i;
	                }
	                else return undefined;
	            },
	            eq: function (index) {
	                if (typeof index === 'undefined') return this;
	                var length = this.length;
	                var returnIndex;
	                if (index > length - 1) {
	                    return new Dom7([]);
	                }
	                if (index < 0) {
	                    returnIndex = length + index;
	                    if (returnIndex < 0) return new Dom7([]);
	                    else return new Dom7([this[returnIndex]]);
	                }
	                return new Dom7([this[index]]);
	            },
	            append: function (newChild) {
	                var i, j;
	                for (i = 0; i < this.length; i++) {
	                    if (typeof newChild === 'string') {
	                        var tempDiv = document.createElement('div');
	                        tempDiv.innerHTML = newChild;
	                        while (tempDiv.firstChild) {
	                            this[i].appendChild(tempDiv.firstChild);
	                        }
	                    }
	                    else if (newChild instanceof Dom7) {
	                        for (j = 0; j < newChild.length; j++) {
	                            this[i].appendChild(newChild[j]);
	                        }
	                    }
	                    else {
	                        this[i].appendChild(newChild);
	                    }
	                }
	                return this;
	            },
	            prepend: function (newChild) {
	                var i, j;
	                for (i = 0; i < this.length; i++) {
	                    if (typeof newChild === 'string') {
	                        var tempDiv = document.createElement('div');
	                        tempDiv.innerHTML = newChild;
	                        for (j = tempDiv.childNodes.length - 1; j >= 0; j--) {
	                            this[i].insertBefore(tempDiv.childNodes[j], this[i].childNodes[0]);
	                        }
	                        // this[i].insertAdjacentHTML('afterbegin', newChild);
	                    }
	                    else if (newChild instanceof Dom7) {
	                        for (j = 0; j < newChild.length; j++) {
	                            this[i].insertBefore(newChild[j], this[i].childNodes[0]);
	                        }
	                    }
	                    else {
	                        this[i].insertBefore(newChild, this[i].childNodes[0]);
	                    }
	                }
	                return this;
	            },
	            insertBefore: function (selector) {
	                var before = $(selector);
	                for (var i = 0; i < this.length; i++) {
	                    if (before.length === 1) {
	                        before[0].parentNode.insertBefore(this[i], before[0]);
	                    }
	                    else if (before.length > 1) {
	                        for (var j = 0; j < before.length; j++) {
	                            before[j].parentNode.insertBefore(this[i].cloneNode(true), before[j]);
	                        }
	                    }
	                }
	            },
	            insertAfter: function (selector) {
	                var after = $(selector);
	                for (var i = 0; i < this.length; i++) {
	                    if (after.length === 1) {
	                        after[0].parentNode.insertBefore(this[i], after[0].nextSibling);
	                    }
	                    else if (after.length > 1) {
	                        for (var j = 0; j < after.length; j++) {
	                            after[j].parentNode.insertBefore(this[i].cloneNode(true), after[j].nextSibling);
	                        }
	                    }
	                }
	            },
	            next: function (selector) {
	                if (this.length > 0) {
	                    if (selector) {
	                        if (this[0].nextElementSibling && $(this[0].nextElementSibling).is(selector)) return new Dom7([this[0].nextElementSibling]);
	                        else return new Dom7([]);
	                    }
	                    else {
	                        if (this[0].nextElementSibling) return new Dom7([this[0].nextElementSibling]);
	                        else return new Dom7([]);
	                    }
	                }
	                else return new Dom7([]);
	            },
	            nextAll: function (selector) {
	                var nextEls = [];
	                var el = this[0];
	                if (!el) return new Dom7([]);
	                while (el.nextElementSibling) {
	                    var next = el.nextElementSibling;
	                    if (selector) {
	                        if($(next).is(selector)) nextEls.push(next);
	                    }
	                    else nextEls.push(next);
	                    el = next;
	                }
	                return new Dom7(nextEls);
	            },
	            prev: function (selector) {
	                if (this.length > 0) {
	                    if (selector) {
	                        if (this[0].previousElementSibling && $(this[0].previousElementSibling).is(selector)) return new Dom7([this[0].previousElementSibling]);
	                        else return new Dom7([]);
	                    }
	                    else {
	                        if (this[0].previousElementSibling) return new Dom7([this[0].previousElementSibling]);
	                        else return new Dom7([]);
	                    }
	                }
	                else return new Dom7([]);
	            },
	            prevAll: function (selector) {
	                var prevEls = [];
	                var el = this[0];
	                if (!el) return new Dom7([]);
	                while (el.previousElementSibling) {
	                    var prev = el.previousElementSibling;
	                    if (selector) {
	                        if($(prev).is(selector)) prevEls.push(prev);
	                    }
	                    else prevEls.push(prev);
	                    el = prev;
	                }
	                return new Dom7(prevEls);
	            },
	            parent: function (selector) {
	                var parents = [];
	                for (var i = 0; i < this.length; i++) {
	                    if (selector) {
	                        if ($(this[i].parentNode).is(selector)) parents.push(this[i].parentNode);
	                    }
	                    else {
	                        parents.push(this[i].parentNode);
	                    }
	                }
	                return $($.unique(parents));
	            },
	            parents: function (selector) {
	                var parents = [];
	                for (var i = 0; i < this.length; i++) {
	                    var parent = this[i].parentNode;
	                    while (parent) {
	                        if (selector) {
	                            if ($(parent).is(selector)) parents.push(parent);
	                        }
	                        else {
	                            parents.push(parent);
	                        }
	                        parent = parent.parentNode;
	                    }
	                }
	                return $($.unique(parents));
	            },
	            find : function (selector) {
	                var foundElements = [];
	                for (var i = 0; i < this.length; i++) {
	                    var found = this[i].querySelectorAll(selector);
	                    for (var j = 0; j < found.length; j++) {
	                        foundElements.push(found[j]);
	                    }
	                }
	                return new Dom7(foundElements);
	            },
	            children: function (selector) {
	                var children = [];
	                for (var i = 0; i < this.length; i++) {
	                    var childNodes = this[i].childNodes;
	    
	                    for (var j = 0; j < childNodes.length; j++) {
	                        if (!selector) {
	                            if (childNodes[j].nodeType === 1) children.push(childNodes[j]);
	                        }
	                        else {
	                            if (childNodes[j].nodeType === 1 && $(childNodes[j]).is(selector)) children.push(childNodes[j]);
	                        }
	                    }
	                }
	                return new Dom7($.unique(children));
	            },
	            remove: function () {
	                for (var i = 0; i < this.length; i++) {
	                    if (this[i].parentNode) this[i].parentNode.removeChild(this[i]);
	                }
	                return this;
	            },
	            add: function () {
	                var dom = this;
	                var i, j;
	                for (i = 0; i < arguments.length; i++) {
	                    var toAdd = $(arguments[i]);
	                    for (j = 0; j < toAdd.length; j++) {
	                        dom[dom.length] = toAdd[j];
	                        dom.length++;
	                    }
	                }
	                return dom;
	            }
	        };
	        $.fn = Dom7.prototype;
	        $.unique = function (arr) {
	            var unique = [];
	            for (var i = 0; i < arr.length; i++) {
	                if (unique.indexOf(arr[i]) === -1) unique.push(arr[i]);
	            }
	            return unique;
	        };
	    
	        return $;
	    })();
	    
	
	    /*===========================
	     Get Dom libraries
	     ===========================*/
	    var swiperDomPlugins = ['jQuery', 'Zepto', 'Dom7'];
	    for (var i = 0; i < swiperDomPlugins.length; i++) {
	    	if (window[swiperDomPlugins[i]]) {
	    		addLibraryPlugin(window[swiperDomPlugins[i]]);
	    	}
	    }
	    // Required DOM Plugins
	    var domLib;
	    if (typeof Dom7 === 'undefined') {
	    	domLib = window.Dom7 || window.Zepto || window.jQuery;
	    }
	    else {
	    	domLib = Dom7;
	    }
	    
	
	    /*===========================
	    Add .swiper plugin from Dom libraries
	    ===========================*/
	    function addLibraryPlugin(lib) {
	        lib.fn.swiper = function (params) {
	            var firstInstance;
	            lib(this).each(function () {
	                var s = new Swiper(this, params);
	                if (!firstInstance) firstInstance = s;
	            });
	            return firstInstance;
	        };
	    }
	    
	    if (domLib) {
	        if (!('transitionEnd' in domLib.fn)) {
	            domLib.fn.transitionEnd = function (callback) {
	                var events = ['webkitTransitionEnd', 'transitionend', 'oTransitionEnd', 'MSTransitionEnd', 'msTransitionEnd'],
	                    i, j, dom = this;
	                function fireCallBack(e) {
	                    /*jshint validthis:true */
	                    if (e.target !== this) return;
	                    callback.call(this, e);
	                    for (i = 0; i < events.length; i++) {
	                        dom.off(events[i], fireCallBack);
	                    }
	                }
	                if (callback) {
	                    for (i = 0; i < events.length; i++) {
	                        dom.on(events[i], fireCallBack);
	                    }
	                }
	                return this;
	            };
	        }
	        if (!('transform' in domLib.fn)) {
	            domLib.fn.transform = function (transform) {
	                for (var i = 0; i < this.length; i++) {
	                    var elStyle = this[i].style;
	                    elStyle.webkitTransform = elStyle.MsTransform = elStyle.msTransform = elStyle.MozTransform = elStyle.OTransform = elStyle.transform = transform;
	                }
	                return this;
	            };
	        }
	        if (!('transition' in domLib.fn)) {
	            domLib.fn.transition = function (duration) {
	                if (typeof duration !== 'string') {
	                    duration = duration + 'ms';
	                }
	                for (var i = 0; i < this.length; i++) {
	                    var elStyle = this[i].style;
	                    elStyle.webkitTransitionDuration = elStyle.MsTransitionDuration = elStyle.msTransitionDuration = elStyle.MozTransitionDuration = elStyle.OTransitionDuration = elStyle.transitionDuration = duration;
	                }
	                return this;
	            };
	        }
	        if (!('outerWidth' in domLib.fn)) {
	            domLib.fn.outerWidth = function (includeMargins) {
	                if (this.length > 0) {
	                    if (includeMargins)
	                        return this[0].offsetWidth + parseFloat(this.css('margin-right')) + parseFloat(this.css('margin-left'));
	                    else
	                        return this[0].offsetWidth;
	                }
	                else return null;
	            };
	        }
	    }
	    
	
	    window.Swiper = Swiper;
	})();
	
	/*===========================
	Swiper AMD Export
	===========================*/
	if (true)
	{
	    module.exports = window.Swiper;
	}
	else if (typeof define === 'function' && define.amd) {
	    define([], function () {
	        'use strict';
	        return window.Swiper;
	    });
	}
	
	//# sourceMappingURL=maps/swiper.js.map
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(2)))

/***/ }),
/* 131 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function($) {'use strict';
	
	var _triggerClassOnScroll = __webpack_require__(119);
	
	$(function () {
	
	    /* * * * * * * * * * * * * * * * * * * * * * * * * * * * * *
	     To the top!
	     */
	
	    if (document.querySelector('.to-the-top')) {
	        var scroll_distance = 70;
	        if ($(window).width() >= 768) {
	            scroll_distance = 70;
	        }
	        if ($(window).width() >= 1024) {
	            scroll_distance = 125;
	        }
	        (0, _triggerClassOnScroll.triggerClassOnScroll)({
	            'scroll': scroll_distance,
	            'class_to_trigger': 'visible',
	            'element': document.querySelector('.to-the-top')
	        });
	    }
	
	    $('.to-the-top').on('click', function (e) {
	        var $this = $(this);
	        e.preventDefault();
	        var target = $this.attr('href');
	        window.location = target;
	    });
	}); /* * * * * * * * * * * * * * * * * * * * * * * * * * * * * *
	    
	    Scrolls to the top of the page
	    
	    */
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(2)))

/***/ }),
/* 132 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function($) {'use strict';
	
	$(function () {
	    // select topics drodown (important: we need to select the actual <select> element in order to get the value, not the dropdown)
	    var $topics_dropdown = $('.topics-dropdown.selectpicker');
	    // listen for the change event and open the URL
	    $topics_dropdown.on('change', function (e) {
	        var href = $(this).val();
	        window.location.href = href;
	    });
	});
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(2)))

/***/ }),
/* 133 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function($) {'use strict';
	
	$(function () {
	
	    function shuffleGridItems($grid_random_container, $grid_random_items) {
	
	        // init
	        var i, index1, index2, temp_val;
	
	        var count = $grid_random_items.length;
	        var shuffled_array = [];
	
	        // populate array of indexes
	        for (i = 0; i < count; i++) {
	            shuffled_array.push(i);
	        }
	
	        // shuffle indexes
	        for (i = 0; i < count; i++) {
	            index1 = Math.random() * count | 0;
	            index2 = Math.random() * count | 0;
	
	            temp_val = shuffled_array[index1];
	            shuffled_array[index1] = shuffled_array[index2];
	            shuffled_array[index2] = temp_val;
	        }
	
	        // apply random order to elements
	        $grid_random_items.detach();
	        for (i = 0; i < count; i++) {
	            $grid_random_container.append($grid_random_items.eq(shuffled_array[i]));
	        }
	    }
	
	    function startGridTransitions($grid_random_container, $grid_random_items) {
	
	        // init
	        var nr_of_items = $grid_random_items.length;
	
	        // config
	        var group_attr = 'data-group';
	        var position_attr = 'data-position';
	        var visible_class = 'visible';
	        var items_per_group = 8;
	        var counter = 1;
	        var group_counter = 1;
	
	        // store items for initial interval delay
	        var initial_interval_delay_items = nr_of_items - items_per_group;
	
	        // loop settings
	        var position_reveal_order = [1, 8, 5, 7, 3, 4, 2, 6];
	        var delay_between_items = 1500;
	
	        // hide elements that are not in the first set
	        $grid_random_items.each(function (i) {
	            // init
	            var $this = $(this);
	            // add group id
	            $this.attr(group_attr, group_counter);
	            $this.attr(position_attr, counter);
	            // mark as hidden if not in first set
	            if (group_counter === 1) {
	                $this.addClass(visible_class);
	            }
	            // end of group, reset counter and increase group counter
	            if (counter >= items_per_group) {
	                group_counter++;
	                counter = 0;
	            }
	            // increase counter
	            counter++;
	        });
	
	        var revealItem = function revealItem($lower_item, $activate_item, delay) {
	            setTimeout(function () {
	                $lower_item.removeClass(visible_class);
	                // set visible class on active item
	                $activate_item.addClass(visible_class);
	            }, delay);
	        };
	
	        var layerLoop = function layerLoop() {
	            var initial = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;
	
	            // init
	            var total_loop_counter = 1;
	            var loop_counter = 1;
	            var group_start = 1;
	
	            // in round 1, the first group is already revealed, so we want to start with group 2
	            if (initial) {
	                // start revealing the second group
	                group_start = 2;
	                // TBD
	                loop_counter = items_per_group + 1;
	                // update items for interval delay
	                $grid_random_container.attr('data-interval-delay-items', nr_of_items);
	            }
	            // loop group by group, starting with the second, as the first is already being displayed
	            for (var group = group_start; group <= group_counter; group++) {
	                // reveal item by item according to reveal order
	                position_reveal_order.forEach(function (position, i) {
	                    // try to get current item
	                    var $activate_item = $grid_random_container.find('[' + position_attr + '="' + position + '"][' + group_attr + '="' + group + '"]');
	                    // do stuff when element exists
	                    if ($activate_item.length > 0) {
	                        // calculate delay
	                        var delay = delay_between_items * total_loop_counter;
	                        // hide items in same position below
	                        var $lower_item = $grid_random_container.find('[' + position_attr + '="' + position + '"]').not('[' + group_attr + '="' + group + '"]');
	                        // reveal items
	                        revealItem($lower_item, $activate_item, delay);
	                        // keep going, increase counter
	                        loop_counter++;
	                        total_loop_counter++;
	                    }
	                });
	            }
	        };
	
	        // 1. start layering on page load
	        layerLoop();
	
	        // // 2. set interval for first round
	        var interval = setInterval(function () {
	            var initial = false;
	            layerLoop(initial);
	            clearInterval(interval);
	        }, delay_between_items * initial_interval_delay_items);
	
	        // // 3. set interval for any following rounds
	        var timeout = delay_between_items * (items_per_group + 1);
	        setTimeout(function () {
	            var interval = setInterval(function () {
	                var initial = false;
	                layerLoop(initial);
	            }, delay_between_items * nr_of_items);
	        }, timeout);
	    }
	
	    function initGridRandom() {
	
	        // init
	        var $grid_random_container = $('.grid-random-container');
	        var $grid_random_items = $grid_random_container.find('.grid-item').not('.branding');
	
	        // no grid? hit the road...
	        if ($grid_random_container.length === 0) {
	            return false;
	        }
	
	        // first of all, shuffle grid
	        shuffleGridItems($grid_random_container, $grid_random_items);
	
	        // then, delayed start the transitions
	        setTimeout(function () {
	            // re-select the items first
	            $grid_random_container = $('.grid-random-container');
	            $grid_random_items = $grid_random_container.find('.grid-item').not('.branding');
	            // start transitions
	            startGridTransitions($grid_random_container, $grid_random_items);
	        }, 500);
	
	        // brain storming:
	
	        // brand claim stays in position
	        // one image changes at a time
	        // working with z-index and visible classes
	        // check ID of visible elements in order to prevent a person being displayed twice
	        // make sure at least 1 of each data-position is visible
	        // layer on top (=never a missing picture)
	
	        // interval math
	        /* * * * * * * * * * * * * * * * * * * * * * * * * * * * * *
	         1. the first loop starts with group number 2, which means the next call of the loop function has to start delayed after 'nr_of_items(18)-items_per_group(8)=10'
	         */
	    }
	
	    // on page load
	    initGridRandom();
	
	    $(window).on('initGridRandom', function () {
	        initGridRandom();
	    });
	});
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(2)))

/***/ }),
/* 134 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function($) {'use strict';
	
	/* * * * * * * * * * * * * * * * * * * * * * * * * * * * * *
	
	CampusKMU Group-Containers
	
	*/
	
	$(function () {
	  // set first content active
	  $('.campuskmu-container__content').first().addClass('active');
	
	  $('.campuskmu-container__list__toggle, .campuskmu-container__item__toggle').on('click', function (event) {
	    event.preventDefault();
	    var content = $('' + $(this).attr('href'));
	    $('.campuskmu-container .active').removeClass('active');
	    content.addClass('active');
	  });
	});
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(2)))

/***/ }),
/* 135 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function($) {'use strict';
	
	var _jsCookie = __webpack_require__(136);
	
	var _jsCookie2 = _interopRequireDefault(_jsCookie);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	$(function () {
	
	    var info_modal_hidden = _jsCookie2.default.get('info-modal-hidden') === 'true' ? true : false;
	    var $info_modal = $('.info-modal');
	    var $info_modal_close_trigger = $('[data-hide-info-modal]');
	    var info_modal_visible_class = 'info-modal--visible';
	    // show modal when not hidden
	    if (info_modal_hidden === false) {
	        setTimeout(function () {
	            $info_modal.addClass(info_modal_visible_class);
	        }, 1000);
	    }
	    // hide modal on click
	    $info_modal_close_trigger.on('click', function (e) {
	        e.preventDefault();
	        $info_modal.removeClass(info_modal_visible_class);
	        // write cookie
	        _jsCookie2.default.set('info-modal-hidden', 'true', { expires: 365, path: '/' });
	    });
	});
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(2)))

/***/ }),
/* 136 */
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_RESULT__;/*!
	 * JavaScript Cookie v2.2.1
	 * https://github.com/js-cookie/js-cookie
	 *
	 * Copyright 2006, 2015 Klaus Hartl & Fagner Brack
	 * Released under the MIT license
	 */
	;(function (factory) {
		var registeredInModuleLoader;
		if (true) {
			!(__WEBPACK_AMD_DEFINE_FACTORY__ = (factory), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.call(exports, __webpack_require__, exports, module)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
			registeredInModuleLoader = true;
		}
		if (true) {
			module.exports = factory();
			registeredInModuleLoader = true;
		}
		if (!registeredInModuleLoader) {
			var OldCookies = window.Cookies;
			var api = window.Cookies = factory();
			api.noConflict = function () {
				window.Cookies = OldCookies;
				return api;
			};
		}
	}(function () {
		function extend () {
			var i = 0;
			var result = {};
			for (; i < arguments.length; i++) {
				var attributes = arguments[ i ];
				for (var key in attributes) {
					result[key] = attributes[key];
				}
			}
			return result;
		}
	
		function decode (s) {
			return s.replace(/(%[0-9A-Z]{2})+/g, decodeURIComponent);
		}
	
		function init (converter) {
			function api() {}
	
			function set (key, value, attributes) {
				if (typeof document === 'undefined') {
					return;
				}
	
				attributes = extend({
					path: '/'
				}, api.defaults, attributes);
	
				if (typeof attributes.expires === 'number') {
					attributes.expires = new Date(new Date() * 1 + attributes.expires * 864e+5);
				}
	
				// We're using "expires" because "max-age" is not supported by IE
				attributes.expires = attributes.expires ? attributes.expires.toUTCString() : '';
	
				try {
					var result = JSON.stringify(value);
					if (/^[\{\[]/.test(result)) {
						value = result;
					}
				} catch (e) {}
	
				value = converter.write ?
					converter.write(value, key) :
					encodeURIComponent(String(value))
						.replace(/%(23|24|26|2B|3A|3C|3E|3D|2F|3F|40|5B|5D|5E|60|7B|7D|7C)/g, decodeURIComponent);
	
				key = encodeURIComponent(String(key))
					.replace(/%(23|24|26|2B|5E|60|7C)/g, decodeURIComponent)
					.replace(/[\(\)]/g, escape);
	
				var stringifiedAttributes = '';
				for (var attributeName in attributes) {
					if (!attributes[attributeName]) {
						continue;
					}
					stringifiedAttributes += '; ' + attributeName;
					if (attributes[attributeName] === true) {
						continue;
					}
	
					// Considers RFC 6265 section 5.2:
					// ...
					// 3.  If the remaining unparsed-attributes contains a %x3B (";")
					//     character:
					// Consume the characters of the unparsed-attributes up to,
					// not including, the first %x3B (";") character.
					// ...
					stringifiedAttributes += '=' + attributes[attributeName].split(';')[0];
				}
	
				return (document.cookie = key + '=' + value + stringifiedAttributes);
			}
	
			function get (key, json) {
				if (typeof document === 'undefined') {
					return;
				}
	
				var jar = {};
				// To prevent the for loop in the first place assign an empty array
				// in case there are no cookies at all.
				var cookies = document.cookie ? document.cookie.split('; ') : [];
				var i = 0;
	
				for (; i < cookies.length; i++) {
					var parts = cookies[i].split('=');
					var cookie = parts.slice(1).join('=');
	
					if (!json && cookie.charAt(0) === '"') {
						cookie = cookie.slice(1, -1);
					}
	
					try {
						var name = decode(parts[0]);
						cookie = (converter.read || converter)(cookie, name) ||
							decode(cookie);
	
						if (json) {
							try {
								cookie = JSON.parse(cookie);
							} catch (e) {}
						}
	
						jar[name] = cookie;
	
						if (key === name) {
							break;
						}
					} catch (e) {}
				}
	
				return key ? jar[key] : jar;
			}
	
			api.set = set;
			api.get = function (key) {
				return get(key, false /* read as raw */);
			};
			api.getJSON = function (key) {
				return get(key, true /* read as json */);
			};
			api.remove = function (key, attributes) {
				set(key, '', extend(attributes, {
					expires: -1
				}));
			};
	
			api.defaults = {};
	
			api.withConverter = init;
	
			return api;
		}
	
		return init(function () {});
	}));


/***/ }),
/* 137 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function($) {'use strict';
	
	$(function () {
	
	    // Beat fragen
	
	    // on page load
	    function initSpecialRadioWidget() {
	        var $event_form = $('.event-register-form');
	        var $is_client = $event_form.find('#id_is_client');
	        $($is_client).on('click', function (e) {
	            var $billing_address = $('.event-register-form__billing-address');
	            if (this.checked) {
	                $billing_address.hide();
	                $billing_address.find(':input').each(function () {
	                    var $this = $(this);
	                    $this.prop('required', false);
	                    $this.removeClass('required');
	                });
	            } else {
	                $billing_address.show();
	                $billing_address.find(':input').each(function () {
	                    var $this = $(this);
	                    $this.prop('required', true);
	                    $this.addClass('required');
	                });
	            }
	        });
	    }
	
	    // on page load
	    initSpecialRadioWidget();
	
	    // re-init when softpage has been opened
	    $(window).on('form-modal:opened initAjaxForm', function (e) {
	        initSpecialRadioWidget();
	    });
	});
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(2)))

/***/ }),
/* 138 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function($) {'use strict';
	
	$(function () {
	
	    $('.information-tile__front').on('click', function () {
	        $(this).closest('.information-tile__item').addClass("information-tile__item--is-active");
	    });
	
	    $('.information-tile__back-header').on('click', function () {
	        $(this).closest('.information-tile__item').removeClass("information-tile__item--is-active");
	    });
	});
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(2)))

/***/ }),
/* 139 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function($) {'use strict';
	
	document.addEventListener("DOMContentLoaded", function (event) {
	
	    var songs = [];
	
	    $('.podcastplugin__track').each(function (index, element) {
	
	        var title = $(element).data('tracktitle');
	        var url = $(element).data('trackurl');
	        var downloadurl = $(element).data('downloadurl');
	        var songindex = index + 1;
	
	        songs.push({
	            "name": title,
	            "url": url
	        });
	
	        $(element).html('\n            <div class="player" id="single-song-player-' + index + '">\n                <div class="meta-container">\n\n                    <div class="control-container">\n                        <div class="amplitude-play-pause-custom icomoon-play" id="play-pause-' + index + '" data-amplitude-song-index="' + index + '"></div>\n                    </div>\n\n                    <div id="progress-container" class="progress-container"  data-amplitude-song-index="' + index + '">\n                        <input type="range" class="amplitude-song-slider"  data-amplitude-song-index="' + index + '"/>\n                        <progress class="amplitude-song-played-progress" id="song-played-progress-' + songindex + '" data-amplitude-song-index="' + index + '"></progress>\n                    </div>\n\n                    <div class="time-container">\n                        <span class="remainig-' + index + ' hidden">\n                           <span>-</span><span class="amplitude-time-remaining" data-amplitude-song-index="' + index + '"></span>\n                        </span>\n                        <span class="duration-' + index + '">\n                           <span class="amplitude-duration-time" data-amplitude-song-index="' + index + '"></span>\n                        </span>\n                    </div>\n\n                    <div class="download">\n                        <a class="downloadx icomoon-download" href="' + downloadurl + '" download="' + title + '.mp3"></a>\n                    </div>\n\n                </div>\n            </div>\n        ');
	
	        document.getElementById('podcast-' + title).addEventListener('click', podcastPlayerHandler);
	        document.getElementById('play-pause-' + index).addEventListener('click', podcastPlayerHandler);
	
	        document.getElementById('song-played-progress-' + songindex).addEventListener('click', function (e) {
	            if (Amplitude.getActiveIndex() == index) {
	                var offset = this.getBoundingClientRect();
	                var x = e.pageX - offset.left;
	
	                Amplitude.setSongPlayedPercentage(parseFloat(x) / parseFloat(this.offsetWidth) * 100);
	            }
	        });
	
	        function podcastPlayerHandler(e) {
	            if (Amplitude.getActiveSongMetadata().url === url) {
	                switch (Amplitude.getPlayerState()) {
	                    case "playing":
	                        Amplitude.pause();
	                        $('#play-pause-' + index).removeClass('amplitude-playing');
	                        $('.remainig-' + index).addClass('hidden');
	                        $('.duration-' + index).removeClass('hidden');
	                        break;
	                    case "stopped":
	                    case "paused":
	                        Amplitude.play();
	                        $('#play-pause-' + index).addClass('amplitude-playing');
	                        $('.remainig-' + index).removeClass('hidden');
	                        $('.duration-' + index).addClass('hidden');
	                        break;
	                }
	            } else {
	                Amplitude.pause();
	                $('.amplitude-playing').removeClass('amplitude-playing');
	                $('#play-pause-' + index).addClass('amplitude-playing');
	                $('.remainig-' + Amplitude.getActiveIndex()).addClass('hidden');
	                $('.duration-' + Amplitude.getActiveIndex()).removeClass('hidden');
	                $('.remainig-' + index).removeClass('hidden');
	                $('.duration-' + index).addClass('hidden');
	                Amplitude.playSongAtIndex(index);
	            }
	        }
	
	        function swapTime(e) {}
	    });
	
	    if (songs.length > 0) {
	        Amplitude.init({
	            "songs": songs,
	            "continue_next": false,
	            callbacks: {
	                ended: function ended() {
	                    $('.amplitude-playing').removeClass('amplitude-playing');
	                }
	            }
	        });
	    }
	});
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(2)))

/***/ }),
/* 140 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function($, jQuery) {'use strict';
	
	document.addEventListener("DOMContentLoaded", function (event) {
	    var el1 = $('#btn-apply-1');
	    var el2 = $('#btn-apply-2 .btn');
	
	    function isElementInViewport(el) {
	
	        if (typeof jQuery === "function" && el instanceof jQuery) {
	            el = el[0];
	        }
	        var rect = el.getBoundingClientRect();
	
	        return rect.top >= 0 && rect.left >= 0 && rect.bottom <= (window.innerHeight || document.documentElement.clientHeight) && /* or $(window).height() */
	        rect.right <= (window.innerWidth || document.documentElement.clientWidth) /* or $(window).width() */
	        ;
	    }
	
	    function onVisibilityChange(el, el2, callback) {
	        var isVisibleBtnTopOld;
	        var isVisibleBtnBottomOld;
	        if (isElementInViewport(el) || isElementInViewport(el2)) {
	            $('.bottom-fixed-container').removeClass('visible');
	        } else {
	            $('.bottom-fixed-container').addClass('visible');
	        }
	
	        return function () {
	            var isVisibleBtnTop = isElementInViewport(el);
	            var isVisibleBtnBottom = isElementInViewport(el2);
	
	            if (isVisibleBtnTop != isVisibleBtnTopOld) {
	                isVisibleBtnTopOld = isVisibleBtnTop;
	                if (typeof callback == 'function') {
	                    callback();
	                }
	            }
	
	            if (isVisibleBtnBottom != isVisibleBtnBottomOld) {
	                isVisibleBtnBottomOld = isVisibleBtnBottom;
	                if (typeof callback == 'function') {
	                    callback();
	                }
	            }
	        };
	    }
	
	    if (el1 || el2) {
	        var handler = onVisibilityChange(el1, el2, function () {
	            $('.bottom-fixed-container').toggleClass('visible');
	        });
	
	        $(window).on('DOMContentLoaded load resize scroll', handler);
	    }
	});
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(2), __webpack_require__(2)))

/***/ }),
/* 141 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function($) {'use strict';
	
	/* * * * * * * * * * * * * * * * * * * * * * * * * * * * * *
	
	Simple Smooth Scroll
	
	Inspired by: https://codepen.io/pawelgrzybek/pen/ZeomJB
	
	Basic usage:
	
	<a href="#id-of-target-element" data-smooth-scroll>Smooth Scroll Link</a>
	
	Custom duration (only numbers accepted, otherwise the script fails):
	
	<a href="#id-of-target-element" data-smooth-scroll data-scroll-duration="300">Smooth Scroll Link</a>
	
	Custom easing function (only predefined easing function will work, otherwise the script will fail):
	
	<a href="#id-of-target-element" data-smooth-scroll data-scroll-easing="linear">Smooth Scroll Link</a>
	
	*/
	
	// Browser support:
	
	// Chrome >= 24
	// Firefox >= 23
	// IE >= 10
	// Opera >= 15
	// Safari >= 8 (on previous versions it breaks on 'now' in window.performance)
	// Android 4.4
	// Firefox >= 23
	// IE Mobile >= 10
	// Opera Mobile >= 15
	// Safari iOS >= 9
	// Chrome for Android >= 35
	
	/**
	 *
	 * @param {(number|HTMLElement)} destination - Destination to scroll to (DOM element or number)
	 * @param {number} duration - Duration of scrolling animation
	 * @param {string} easing - Timing function name (Allowed values: 'linear', 'easeInQuad', 'easeOutQuad', 'easeInOutQuad', 'easeInCubic', 'easeOutCubic', 'easeInOutCubic', 'easeInQuart', 'easeOutQuart', 'easeInOutQuart', 'easeInQuint', 'easeOutQuint', 'easeInOutQuint')
	 * @param {function} callback - Optional callback invoked after animation
	 */
	function scrollIt(destination) {
	    var duration = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 200;
	    var easing = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 'linear';
	    var callback = arguments[3];
	
	
	    // Predefine list of available timing functions
	    // If you need more, tween js is full of great examples
	    // https://github.com/tweenjs/tween.js/blob/master/src/Tween.js#L421-L737
	    var easings = {
	        linear: function linear(t) {
	            return t;
	        },
	        easeInQuad: function easeInQuad(t) {
	            return t * t;
	        },
	        easeOutQuad: function easeOutQuad(t) {
	            return t * (2 - t);
	        },
	        easeInOutQuad: function easeInOutQuad(t) {
	            return t < 0.5 ? 2 * t * t : -1 + (4 - 2 * t) * t;
	        },
	        easeInCubic: function easeInCubic(t) {
	            return t * t * t;
	        },
	        easeOutCubic: function easeOutCubic(t) {
	            return --t * t * t + 1;
	        },
	        easeInOutCubic: function easeInOutCubic(t) {
	            return t < 0.5 ? 4 * t * t * t : (t - 1) * (2 * t - 2) * (2 * t - 2) + 1;
	        },
	        easeInQuart: function easeInQuart(t) {
	            return t * t * t * t;
	        },
	        easeOutQuart: function easeOutQuart(t) {
	            return 1 - --t * t * t * t;
	        },
	        easeInOutQuart: function easeInOutQuart(t) {
	            return t < 0.5 ? 8 * t * t * t * t : 1 - 8 * --t * t * t * t;
	        },
	        easeInQuint: function easeInQuint(t) {
	            return t * t * t * t * t;
	        },
	        easeOutQuint: function easeOutQuint(t) {
	            return 1 + --t * t * t * t * t;
	        },
	        easeInOutQuint: function easeInOutQuint(t) {
	            return t < 0.5 ? 16 * t * t * t * t * t : 1 + 16 * --t * t * t * t * t;
	        }
	    };
	
	    // Store initial position of a window and time
	    // If performance is not available in your browser
	    // It will fallback to new Date().getTime() - thanks IE < 10
	    var start = window.pageYOffset;
	    var startTime = 'now' in window.performance ? performance.now() : new Date().getTime();
	    // const startTime = typeof(window.performance['now']) == 'function' ? performance.now() : new Date().getTime();
	
	
	    // Take height of window and document to sesolve max scrollable value
	    // Prevent requestAnimationFrame() from scrolling below maximum scollable value
	    // Resolve destination type (node or number)
	    var documentHeight = Math.max(document.body.scrollHeight, document.body.offsetHeight, document.documentElement.clientHeight, document.documentElement.scrollHeight, document.documentElement.offsetHeight);
	    var windowHeight = window.innerHeight || document.documentElement.clientHeight || document.getElementsByTagName('body')[0].clientHeight;
	    var destinationOffset = typeof destination === 'number' ? destination : destination.offsetTop;
	    var destinationOffsetToScroll = Math.round(documentHeight - destinationOffset < windowHeight ? documentHeight - windowHeight : destinationOffset);
	
	    // If requestAnimationFrame is not supported
	    // Move window to destination position and trigger callback function
	    if ('requestAnimationFrame' in window === false) {
	        window.scroll(0, destinationOffsetToScroll);
	        if (callback) {
	            callback();
	        }
	        return;
	    }
	
	    // function resolves position of a window and moves to exact amount of pixels
	    // Resolved by calculating delta and timing function choosen by user
	    function scroll() {
	        var now = 'now' in window.performance ? performance.now() : new Date().getTime();
	        var time = Math.min(1, (now - startTime) / duration);
	        var timeFunction = easings[easing](time);
	        window.scroll(0, Math.ceil(timeFunction * (destinationOffsetToScroll - start) + start));
	
	        // Stop requesting animation when window reached its destination
	        // And run a callback function
	        if (Math.round(window.pageYOffset) === destinationOffsetToScroll) {
	            if (callback) {
	                callback();
	            }
	            return;
	        }
	
	        // If window still needs to scroll to reach destination
	        // Request another scroll invokation
	
	        requestAnimationFrame(scroll);
	    }
	
	    // Invoke scroll and sequential requestAnimationFrame
	    scroll();
	}
	
	function initSmoothScroll() {
	    // init
	    var $scroll_links = $('[data-smooth-scroll]');
	    if ($scroll_links.length > 0) {
	        $scroll_links.each(function () {
	            var $trigger = $(this);
	            var initialized_attr = 'data-trigger-initialized';
	            // check for initialized trigger
	            var trigger_initialized = $trigger.attr(initialized_attr);
	            // NOT initialized yet
	            if (typeof trigger_initialized === 'undefined') {
	                $trigger.on('click', function (e) {
	                    // init target
	                    e.preventDefault();
	                    var $trigger = $(this);
	                    var anchor = $trigger.attr('href');
	                    var $target = $(anchor);
	                    // optional: individual scroll duration
	                    var scroll_duration = 300;
	                    var scroll_duration_from_attribute = $trigger.attr('data-scroll-duration');
	                    if (scroll_duration_from_attribute) {
	                        scroll_duration = parseInt(scroll_duration_from_attribute);
	                    }
	                    // optional: individual easing function
	                    var scroll_easing = 'easeInOutQuad';
	                    var scroll_easing_from_attribute = $trigger.attr('data-scroll-easing');
	                    if (scroll_easing_from_attribute) {
	                        scroll_easing = scroll_easing_from_attribute;
	                    }
	                    // trigger custom event
	                    $(window).trigger('smooth-scroll:before');
	                    // scroll!
	                    scrollIt($target.get(0), scroll_duration, scroll_easing, function () {
	                        $(window).trigger('smooth-scroll:after');
	                    });
	                });
	                // mark as initialized
	                $trigger.attr(initialized_attr, '');
	            }
	        });
	    }
	}
	
	$(function () {
	    // on page load
	    initSmoothScroll();
	    // after certain events
	    $(window).on('initSmoothScroll', function () {
	        initSmoothScroll();
	    });
	});
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(2)))

/***/ }),
/* 142 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function($) {'use strict';
	
	$(function () {
	    $('.schedule-table').each(function (key, val) {
	        var $val = $(val);
	        var $inner = $val.find('.inner');
	        var initHeight = $inner.height();
	        if ($val.height() > 500) {
	            $val.addClass('cover');
	            $inner.height(500);
	            $val.find('.show-more-button a').click(function (event) {
	                event.preventDefault();
	                $inner.height(initHeight);
	                $val.addClass('show-full');
	            });
	        } else {
	            $val.addClass('show-full');
	        }
	    });
	});
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(2)))

/***/ }),
/* 143 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function($) {"use strict";
	
	$(document).ready(function () {
	    var faqEl = $(".faq-split-image");
	
	    if (faqEl.length > 0) {
	        init(faqEl);
	    }
	
	    function init(el) {
	        var faqItems = $(el).find(".faq-container__item__question");
	        // var faqImages = $(el).find(".faq-image");
	
	        // Show first item as open
	        $(faqEl).each(function () {
	            showFaqItem(0, $(this));
	        });
	
	        // Event Listener
	        $(faqItems).on("click", function () {
	            var currentEl = $(this).closest(".faq-split-image");
	            var itemID = parseInt($(this).parent(".faq-container__item").data("index"));
	            showFaqItem(itemID, currentEl);
	        });
	    }
	
	    function hideFaqItems(el, keepImage) {
	        // var faqItems = $(el).find(".faq-container__item").removeClass("faq-visible");
	
	        // Hide content
	        $(el).find(".faq-container__item__answer").removeClass("in");
	        $(el).find(".faq-container__item__answer").attr("aria-expanded", "false");
	        $(el).find(".faq-container__item").removeClass("faq-visible");
	
	        // Update Icon
	        $(el).find(".faq__icon").removeClass("faq__icon--open");
	
	        // Hide image
	        if (!keepImage) {
	            $(el).find(".faq-image").removeClass("image-visible");
	        }
	    }
	
	    function showFaqItem(id, el) {
	        var elParent = $(el).closest(".faq-split-image");
	        var content_area = $(el).find("[data-index='" + id + "']")[0];
	        var image_area = $(el).find("[data-index='" + id + "']")[1];
	
	        // Hide all items in instance
	
	        console.log(content_area);
	        if ($(content_area).hasClass("faq-visible")) {
	            hideFaqItems(el, true);
	            return;
	        }
	
	        hideFaqItems(el);
	
	        // Content handled by aria
	        $(content_area).find(".faq-container__item__answer").addClass("in");
	        $(content_area).addClass("faq-visible");
	
	        // Update icon
	        $(content_area).find(".faq__icon").addClass("faq__icon--open");
	
	        // Show image
	        $(image_area).addClass("image-visible");
	    }
	});
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(2)))

/***/ }),
/* 144 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function($) {'use strict';
	
	var _iphoneInlineVideo = __webpack_require__(145);
	
	var _iphoneInlineVideo2 = _interopRequireDefault(_iphoneInlineVideo);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	$(function () {
	
	    /* * * * * * * * * * * * * * * * * * * * * * * * * * * * * *
	     Helper Functions and Events
	     */
	
	    $.fn.videoIsOnScreen = function () {
	
	        var element = this.get(0);
	        var bounds = element.getBoundingClientRect();
	
	        return bounds.top < window.innerHeight && bounds.bottom > 0;
	    };
	
	    $.fn.videoScrollStopped = function (callback) {
	
	        // init
	        var timeout = 50;
	
	        // fire delayed scroll
	        $(this).scroll(function () {
	            var self = this,
	                $this = $(self);
	            if ($this.data('scrollTimeout')) {
	                clearTimeout($this.data('scrollTimeout'));
	            }
	            $this.data('scrollTimeout', setTimeout(callback, timeout, self));
	        });
	    };
	
	    /* * * * * * * * * * * * * * * * * * * * * * * * * * * * * *
	     Handle Video Playback
	     */
	
	    function initInlineVideo() {
	
	        // init
	        var $videos = $('.the-video');
	        var loaded_class = 'loaded';
	        var on_pause_class = 'on-pause';
	        var autoplay_class = 'autoplay-enabled';
	        var disable_remote_playback_attribute = 'disableRemotePlayback';
	        var controls_disabled_class = 'controls-disabled';
	        var initialized_attr = 'data-controls-initialized';
	        var window_width = $(window).width();
	        var mobile_max_width = 1024;
	        var mobile_class = 'is-mobile';
	        var ipad_class = 'is-ipad';
	        var is_iPad = navigator.userAgent.indexOf("iPad") != -1;
	
	        // general mobile check
	        var is_mobile = false;
	        // this includes tablet, EXPLUDING iPad
	        if (window_width <= mobile_max_width && is_iPad === false) {
	            is_mobile = false;
	        }
	
	        // loop through video sections
	        $videos.each(function () {
	
	            // init
	            var $vid = $(this);
	            var $plugin_container = $vid.parents('.app-content-plugin');
	            var $video_controls = $plugin_container.find('.video-controls');
	
	            // enable videos on iPads
	            if (is_iPad) {
	                (0, _iphoneInlineVideo2.default)($vid.get(0), {
	                    iPad: true
	                });
	            }
	
	            // add class to indicate we're on an iPad
	            if (is_iPad) {
	                $plugin_container.addClass(ipad_class);
	            }
	
	            // on mobile: make sure autoplay is disabled (data usage alert!)
	            if (is_mobile) {
	                $vid.removeAttr('autoplay');
	                $plugin_container.removeClass(autoplay_class);
	                // removing the attribute wasn't good enough, let's pause the video
	                $vid.get(0).pause();
	            }
	
	            // in case of mobile but not iPad, hide the controls
	            if (is_mobile && is_iPad === false) {
	                // hide controls with CSS
	                $plugin_container.addClass(controls_disabled_class);
	                // make sure there is no remote playback button (Android)
	                $vid.attr(disable_remote_playback_attribute, '');
	            } else {
	                $plugin_container.removeClass(controls_disabled_class);
	                disable_remote_playback_attribute;
	                $vid.removeAttr(disable_remote_playback_attribute);
	            }
	
	            // after checking for mobile devices, continue slightly delayed
	            setTimeout(function () {
	                // add event listener to video controls, but only continue if autplay is DISABLED
	                if ($plugin_container.hasClass(autoplay_class) === false) {
	                    var controls_initialized = $video_controls.attr(initialized_attr);
	                    // NOT initialized yet
	                    if (typeof controls_initialized === 'undefined') {
	                        $video_controls.on('click', function () {
	                            if ($plugin_container.hasClass(on_pause_class)) {
	                                // remove class
	                                $plugin_container.removeClass(on_pause_class);
	                                // let's play
	                                $vid.get(0).play();
	                                // and mark the video as loaded (for possible transitions)
	                                $plugin_container.addClass(loaded_class);
	                            } else {
	                                // pause the video and..
	                                $vid.get(0).pause();
	                                // ..add class
	                                $plugin_container.addClass(on_pause_class);
	                            }
	                        });
	                        // mark as initialized
	                        $video_controls.attr(initialized_attr, '');
	                    }
	                }
	
	                // only continue if autoplay is enabled
	                if ($plugin_container.hasClass(autoplay_class)) {
	                    // start video when element is on screen
	                    if ($vid.videoIsOnScreen()) {
	                        // per default, a video is "on pause" - let's remove this and don't come back here when there is no on_pause_class, because that means the video is playing
	                        if ($plugin_container.hasClass(on_pause_class)) {
	                            setTimeout(function () {
	                                // remove class
	                                $plugin_container.removeClass(on_pause_class);
	                                // let's play
	                                $vid.get(0).play();
	                                // and mark the video as loaded (for possible transitions)
	                                $plugin_container.addClass(loaded_class);
	                            }, 100);
	                        }
	                    }
	                    // not on screen? pause it
	                    else {
	                            // pause the video and..
	                            $vid.get(0).pause();
	                            // ..add class
	                            $plugin_container.addClass(on_pause_class);
	                        }
	                }
	            }, 100);
	        });
	    }
	
	    // on page load
	    initInlineVideo();
	
	    // when scrolling has stopped
	    $(window).videoScrollStopped(function () {
	        initInlineVideo();
	    });
	
	    // when resizing the window
	    $(window).on('viewportWidthHasChanged softpage:opened', function () {
	        initInlineVideo();
	    });
	}); /* * * * * * * * * * * * * * * * * * * * * * * * * * * * * *
	    
	    Video functionality for our "Content Plugin"
	    
	    */
	
	// Enable support for iPads
	// https://github.com/bfred-it/iphone-inline-video
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(2)))

/***/ }),
/* 145 */
/***/ (function(module, exports, __webpack_require__) {

	/*! npm.im/iphone-inline-video 2.2.2 */
	'use strict';
	
	var intervalometer = __webpack_require__(146);
	
	function preventEvent(element, eventName, test) {
		function handler(e) {
			if (!test || test(element, eventName)) {
				e.stopImmediatePropagation();
				// // console.log(eventName, 'prevented on', element);
			}
		}
		element.addEventListener(eventName, handler);
	
		// Return handler to allow to disable the prevention. Usage:
		// const preventionHandler = preventEvent(el, 'click');
		// el.removeEventHandler('click', preventionHandler);
		return handler;
	}
	
	function proxyProperty(object, propertyName, sourceObject, copyFirst) {
		function get() {
			return sourceObject[propertyName];
		}
		function set(value) {
			sourceObject[propertyName] = value;
		}
	
		if (copyFirst) {
			set(object[propertyName]);
		}
	
		Object.defineProperty(object, propertyName, {get: get, set: set});
	}
	
	function proxyEvent(object, eventName, sourceObject) {
		sourceObject.addEventListener(eventName, function () { return object.dispatchEvent(new Event(eventName)); });
	}
	
	function dispatchEventAsync(element, type) {
		Promise.resolve().then(function () {
			element.dispatchEvent(new Event(type));
		});
	}
	
	var iOS8or9 = typeof document === 'object' && 'object-fit' in document.head.style && !matchMedia('(-webkit-video-playable-inline)').matches;
	
	var IIV = 'bfred-it:iphone-inline-video';
	var IIVEvent = 'bfred-it:iphone-inline-video:event';
	var IIVPlay = 'bfred-it:iphone-inline-video:nativeplay';
	var IIVPause = 'bfred-it:iphone-inline-video:nativepause';
	
	/**
	 * UTILS
	 */
	
	function getAudioFromVideo(video) {
		var audio = new Audio();
		proxyEvent(video, 'play', audio);
		proxyEvent(video, 'playing', audio);
		proxyEvent(video, 'pause', audio);
		audio.crossOrigin = video.crossOrigin;
	
		// 'data:' causes audio.networkState > 0
		// which then allows to keep <audio> in a resumable playing state
		// i.e. once you set a real src it will keep playing if it was if .play() was called
		audio.src = video.src || video.currentSrc || 'data:';
	
		// // if (audio.src === 'data:') {
		//   TODO: wait for video to be selected
		// // }
		return audio;
	}
	
	var lastRequests = [];
	var requestIndex = 0;
	var lastTimeupdateEvent;
	
	function setTime(video, time, rememberOnly) {
		// Allow one timeupdate event every 200+ ms
		if ((lastTimeupdateEvent || 0) + 200 < Date.now()) {
			video[IIVEvent] = true;
			lastTimeupdateEvent = Date.now();
		}
		if (!rememberOnly) {
			video.currentTime = time;
		}
		lastRequests[++requestIndex % 3] = time * 100 | 0 / 100;
	}
	
	function isPlayerEnded(player) {
		return player.driver.currentTime >= player.video.duration;
	}
	
	function update(timeDiff) {
		var player = this;
		// // console.log('update', player.video.readyState, player.video.networkState, player.driver.readyState, player.driver.networkState, player.driver.paused);
		if (player.video.readyState >= player.video.HAVE_FUTURE_DATA) {
			if (!player.hasAudio) {
				player.driver.currentTime = player.video.currentTime + ((timeDiff * player.video.playbackRate) / 1000);
				if (player.video.loop && isPlayerEnded(player)) {
					player.driver.currentTime = 0;
				}
			}
			setTime(player.video, player.driver.currentTime);
		} else if (player.video.networkState === player.video.NETWORK_IDLE && player.video.buffered.length === 0) {
			// This should happen when the source is available but:
			// - it's potentially playing (.paused === false)
			// - it's not ready to play
			// - it's not loading
			// If it hasAudio, that will be loaded in the 'emptied' handler below
			player.video.load();
			// // console.log('Will load');
		}
	
		// // console.assert(player.video.currentTime === player.driver.currentTime, 'Video not updating!');
	
		if (player.video.ended) {
			delete player.video[IIVEvent]; // Allow timeupdate event
			player.video.pause(true);
		}
	}
	
	/**
	 * METHODS
	 */
	
	function play() {
		// // console.log('play');
		var video = this;
		var player = video[IIV];
	
		// If it's fullscreen, use the native player
		if (video.webkitDisplayingFullscreen) {
			video[IIVPlay]();
			return;
		}
	
		if (player.driver.src !== 'data:' && player.driver.src !== video.src) {
			// // console.log('src changed on play', video.src);
			setTime(video, 0, true);
			player.driver.src = video.src;
		}
	
		if (!video.paused) {
			return;
		}
		player.paused = false;
	
		if (video.buffered.length === 0) {
			// .load() causes the emptied event
			// the alternative is .play()+.pause() but that triggers play/pause events, even worse
			// possibly the alternative is preventing this event only once
			video.load();
		}
	
		player.driver.play();
		player.updater.start();
	
		if (!player.hasAudio) {
			dispatchEventAsync(video, 'play');
			if (player.video.readyState >= player.video.HAVE_ENOUGH_DATA) {
				// // console.log('onplay');
				dispatchEventAsync(video, 'playing');
			}
		}
	}
	function pause(forceEvents) {
		// // console.log('pause');
		var video = this;
		var player = video[IIV];
	
		player.driver.pause();
		player.updater.stop();
	
		// If it's fullscreen, the developer the native player.pause()
		// This is at the end of pause() because it also
		// needs to make sure that the simulation is paused
		if (video.webkitDisplayingFullscreen) {
			video[IIVPause]();
		}
	
		if (player.paused && !forceEvents) {
			return;
		}
	
		player.paused = true;
		if (!player.hasAudio) {
			dispatchEventAsync(video, 'pause');
		}
	
		// Handle the 'ended' event only if it's not fullscreen
		if (video.ended && !video.webkitDisplayingFullscreen) {
			video[IIVEvent] = true;
			dispatchEventAsync(video, 'ended');
		}
	}
	
	/**
	 * SETUP
	 */
	
	function addPlayer(video, hasAudio) {
		var player = {};
		video[IIV] = player;
		player.paused = true; // Track whether 'pause' events have been fired
		player.hasAudio = hasAudio;
		player.video = video;
		player.updater = intervalometer.frameIntervalometer(update.bind(player));
	
		if (hasAudio) {
			player.driver = getAudioFromVideo(video);
		} else {
			video.addEventListener('canplay', function () {
				if (!video.paused) {
					// // console.log('oncanplay');
					dispatchEventAsync(video, 'playing');
				}
			});
			player.driver = {
				src: video.src || video.currentSrc || 'data:',
				muted: true,
				paused: true,
				pause: function () {
					player.driver.paused = true;
				},
				play: function () {
					player.driver.paused = false;
					// Media automatically goes to 0 if .play() is called when it's done
					if (isPlayerEnded(player)) {
						setTime(video, 0);
					}
				},
				get ended() {
					return isPlayerEnded(player);
				}
			};
		}
	
		// .load() causes the emptied event
		video.addEventListener('emptied', function () {
			// // console.log('driver src is', player.driver.src);
			var wasEmpty = !player.driver.src || player.driver.src === 'data:';
			if (player.driver.src && player.driver.src !== video.src) {
				// // console.log('src changed to', video.src);
				setTime(video, 0, true);
				player.driver.src = video.src;
				// Playing videos will only keep playing if no src was present when .play()’ed
				if (wasEmpty || (!hasAudio && video.autoplay)) {
					player.driver.play();
				} else {
					player.updater.stop();
				}
			}
		}, false);
	
		// Stop programmatic player when OS takes over
		video.addEventListener('webkitbeginfullscreen', function () {
			if (!video.paused) {
				// Make sure that the <audio> and the syncer/updater are stopped
				video.pause();
	
				// Play video natively
				video[IIVPlay]();
			} else if (hasAudio && player.driver.buffered.length === 0) {
				// If the first play is native,
				// the <audio> needs to be buffered manually
				// so when the fullscreen ends, it can be set to the same current time
				player.driver.load();
			}
		});
		if (hasAudio) {
			video.addEventListener('webkitendfullscreen', function () {
				// Sync audio to new video position
				player.driver.currentTime = video.currentTime;
				// // console.assert(player.driver.currentTime === video.currentTime, 'Audio not synced');
			});
	
			// Allow seeking
			video.addEventListener('seeking', function () {
				if (lastRequests.indexOf(video.currentTime * 100 | 0 / 100) < 0) {
					// // console.log('User-requested seeking');
					player.driver.currentTime = video.currentTime;
				}
			});
		}
	}
	
	function preventWithPropOrFullscreen(el) {
		var isAllowed = el[IIVEvent];
		delete el[IIVEvent];
		return !el.webkitDisplayingFullscreen && !isAllowed;
	}
	
	function overloadAPI(video) {
		var player = video[IIV];
		video[IIVPlay] = video.play;
		video[IIVPause] = video.pause;
		video.play = play;
		video.pause = pause;
		proxyProperty(video, 'paused', player.driver);
		proxyProperty(video, 'muted', player.driver, true);
		proxyProperty(video, 'playbackRate', player.driver, true);
		proxyProperty(video, 'ended', player.driver);
		proxyProperty(video, 'loop', player.driver, true);
	
		// IIV works by seeking 60 times per second.
		// These events are now useless.
		preventEvent(video, 'seeking', function (el) { return !el.webkitDisplayingFullscreen; });
		preventEvent(video, 'seeked', function (el) { return !el.webkitDisplayingFullscreen; });
	
		// Limit timeupdate events
		preventEvent(video, 'timeupdate', preventWithPropOrFullscreen);
	
		// Prevent occasional native ended events
		preventEvent(video, 'ended', preventWithPropOrFullscreen);
	}
	
	function enableInlineVideo(video, opts) {
		if ( opts === void 0 ) opts = {};
	
		// Stop if already enabled
		if (video[IIV]) {
			return;
		}
	
		// Allow the user to skip detection
		if (!opts.everywhere) {
			// Only iOS8 and 9 are supported
			if (!iOS8or9) {
				return;
			}
	
			// Stop if it's not an allowed device
			if (!(opts.iPad || opts.ipad ? /iPhone|iPod|iPad/ : /iPhone|iPod/).test(navigator.userAgent)) {
				return;
			}
		}
	
		// Try to pause
		video.pause();
	
		// Prevent autoplay.
		// An non-started autoplaying video can't be .pause()'d
		var willAutoplay = video.autoplay;
		video.autoplay = false;
	
		addPlayer(video, !video.muted);
		overloadAPI(video);
		video.classList.add('IIV');
	
		// Autoplay
		if (video.muted && willAutoplay) {
			video.play();
			video.addEventListener('playing', function restoreAutoplay() {
				video.autoplay = true;
				video.removeEventListener('playing', restoreAutoplay);
			});
		}
	
		if (!/iPhone|iPod|iPad/.test(navigator.platform)) {
			console.warn('iphone-inline-video is not guaranteed to work in emulated environments');
		}
	}
	
	module.exports = enableInlineVideo;


/***/ }),
/* 146 */
/***/ (function(module, exports) {

	/*! npm.im/intervalometer */
	'use strict';
	
	Object.defineProperty(exports, '__esModule', { value: true });
	
	function intervalometer(cb, request, cancel, requestParameter) {
		var requestId;
		var previousLoopTime;
		function loop(now) {
			// Must be requested before cb() because that might call .stop()
			requestId = request(loop, requestParameter);
	
			// Called with "ms since last call". 0 on start()
			cb(now - (previousLoopTime || now));
	
			previousLoopTime = now;
		}
	
		return {
			start: function start() {
				if (!requestId) { // Prevent double starts
					loop(0);
				}
			},
			stop: function stop() {
				cancel(requestId);
				requestId = null;
				previousLoopTime = 0;
			}
		};
	}
	
	function frameIntervalometer(cb) {
		return intervalometer(cb, requestAnimationFrame, cancelAnimationFrame);
	}
	
	function timerIntervalometer(cb, delay) {
		return intervalometer(cb, setTimeout, clearTimeout, delay);
	}
	
	exports.intervalometer = intervalometer;
	exports.frameIntervalometer = frameIntervalometer;
	exports.timerIntervalometer = timerIntervalometer;

/***/ }),
/* 147 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function($) {"use strict";
	
	var _lottieWeb = __webpack_require__(148);
	
	var _lottieWeb2 = _interopRequireDefault(_lottieWeb);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	$(document).ready(function () {
	    function initializeLottieAnimation() {
	        // Prepare the Lottie animation
	        var animationData = { "v": "5.9.0", "meta": { "g": "LottieFiles AE ", "a": "", "k": "", "d": "", "tc": "" }, "fr": 60, "ip": 0, "op": 158, "w": 1080, "h": 1080, "nm": "HR-Campus-Icon-Confetti", "ddd": 0, "assets": [{ "id": "comp_0", "layers": [{ "ddd": 0, "ind": 1, "ty": 4, "nm": "Star-1 Outlines 2", "sr": 1, "ks": { "o": { "a": 0, "k": 100, "ix": 11 }, "r": { "a": 0, "k": 0, "ix": 10 }, "p": { "a": 0, "k": [451.749, 208.262, 0], "ix": 2 }, "a": { "a": 0, "k": [136.638, 46.78, 0], "ix": 1 }, "s": { "a": 1, "k": [{ "i": { "x": [0.4, 0.4, 0.4], "y": [1, 1, 1] }, "o": { "x": [0.6, 0.6, 0.6], "y": [0, 0, 0] }, "t": 32, "s": [270, 270, 100] }, { "i": { "x": [0.4, 0.4, 0.4], "y": [1, 1, 1] }, "o": { "x": [0.6, 0.6, 0.6], "y": [0, 0, 0] }, "t": 45.734, "s": [320, 320, 100] }, { "i": { "x": [0.4, 0.4, 0.4], "y": [1, 1, 1] }, "o": { "x": [0.6, 0.6, 0.6], "y": [0, 0, 0] }, "t": 59.471, "s": [0, 0, 100] }, { "i": { "x": [0.4, 0.4, 0.4], "y": [1, 1, 1] }, "o": { "x": [0.6, 0.6, 0.6], "y": [0, 0, 0] }, "t": 101.061, "s": [0, 0, 100] }, { "i": { "x": [0.4, 0.4, 0.4], "y": [1, 1, 1] }, "o": { "x": [0.6, 0.6, 0.6], "y": [0, 0, 0] }, "t": 114.795, "s": [320, 320, 100] }, { "t": 128.529296875, "s": [270, 270, 100] }], "ix": 6 } }, "ao": 0, "shapes": [{ "ty": "gr", "it": [{ "ind": 0, "ty": "sh", "ix": 1, "ks": { "a": 0, "k": { "i": [[0, 0], [0, 0], [0, 0], [0, 0], [0, 0], [0, 0], [0, 0], [0, 0], [0, 0], [0, 0]], "o": [[0, 0], [0, 0], [0, 0], [0, 0], [0, 0], [0, 0], [0, 0], [0, 0], [0, 0], [0, 0]], "v": [[-4.326, -20.177], [-25.138, -25.663], [-19.973, -4.769], [-31.622, 13.329], [-10.155, 14.873], [3.458, 31.546], [11.56, 11.605], [31.622, 3.811], [15.163, -10.057], [13.949, -31.546]], "c": true }, "ix": 2 }, "nm": "Path 1", "mn": "ADBE Vector Shape - Group", "hd": false }, { "ty": "st", "c": { "a": 0, "k": [0.956862804936, 0.898039275525, 0.211764720842, 1], "ix": 3 }, "o": { "a": 0, "k": 100, "ix": 4 }, "w": { "a": 0, "k": 20, "ix": 5 }, "lc": 1, "lj": 2, "bm": 0, "nm": "Stroke 1", "mn": "ADBE Vector Graphic - Stroke", "hd": false }, { "ty": "tr", "p": { "a": 0, "k": [138.047, 47.539], "ix": 2 }, "a": { "a": 0, "k": [0, 0], "ix": 1 }, "s": { "a": 0, "k": [100, 100], "ix": 3 }, "r": { "a": 0, "k": 0, "ix": 6 }, "o": { "a": 0, "k": 100, "ix": 7 }, "sk": { "a": 0, "k": 0, "ix": 4 }, "sa": { "a": 0, "k": 0, "ix": 5 }, "nm": "Transform" }], "nm": "Group 1", "np": 2, "cix": 2, "bm": 0, "ix": 1, "mn": "ADBE Vector Group", "hd": false }], "ip": 75, "op": 312, "st": 12, "bm": 0 }, { "ddd": 0, "ind": 2, "ty": 4, "nm": "Star-1 Outlines", "sr": 1, "ks": { "o": { "a": 0, "k": 100, "ix": 11 }, "r": { "a": 0, "k": 0, "ix": 10 }, "p": { "a": 0, "k": [451.749, 208.262, 0], "ix": 2 }, "a": { "a": 0, "k": [136.638, 46.78, 0], "ix": 1 }, "s": { "a": 1, "k": [{ "i": { "x": [0.4, 0.4, 0.4], "y": [1, 1, 1] }, "o": { "x": [0.6, 0.6, 0.6], "y": [0, 0, 0] }, "t": 32, "s": [270, 270, 100] }, { "i": { "x": [0.4, 0.4, 0.4], "y": [1, 1, 1] }, "o": { "x": [0.6, 0.6, 0.6], "y": [0, 0, 0] }, "t": 45.734, "s": [320, 320, 100] }, { "t": 59.470703125, "s": [0, 0, 100] }], "ix": 6 } }, "ao": 0, "shapes": [{ "ty": "gr", "it": [{ "ind": 0, "ty": "sh", "ix": 1, "ks": { "a": 0, "k": { "i": [[0, 0], [0, 0], [0, 0], [0, 0], [0, 0], [0, 0], [0, 0], [0, 0], [0, 0], [0, 0]], "o": [[0, 0], [0, 0], [0, 0], [0, 0], [0, 0], [0, 0], [0, 0], [0, 0], [0, 0], [0, 0]], "v": [[-4.326, -20.177], [-25.138, -25.663], [-19.973, -4.769], [-31.622, 13.329], [-10.155, 14.873], [3.458, 31.546], [11.56, 11.605], [31.622, 3.811], [15.163, -10.057], [13.949, -31.546]], "c": true }, "ix": 2 }, "nm": "Path 1", "mn": "ADBE Vector Shape - Group", "hd": false }, { "ty": "st", "c": { "a": 0, "k": [0.956862804936, 0.898039275525, 0.211764720842, 1], "ix": 3 }, "o": { "a": 0, "k": 100, "ix": 4 }, "w": { "a": 0, "k": 20, "ix": 5 }, "lc": 1, "lj": 2, "bm": 0, "nm": "Stroke 1", "mn": "ADBE Vector Graphic - Stroke", "hd": false }, { "ty": "tr", "p": { "a": 0, "k": [138.047, 47.539], "ix": 2 }, "a": { "a": 0, "k": [0, 0], "ix": 1 }, "s": { "a": 0, "k": [100, 100], "ix": 3 }, "r": { "a": 0, "k": 0, "ix": 6 }, "o": { "a": 0, "k": 100, "ix": 7 }, "sk": { "a": 0, "k": 0, "ix": 4 }, "sa": { "a": 0, "k": 0, "ix": 5 }, "nm": "Transform" }], "nm": "Group 1", "np": 2, "cix": 2, "bm": 0, "ix": 1, "mn": "ADBE Vector Group", "hd": false }], "ip": -40, "op": 75, "st": 12, "bm": 0 }, { "ddd": 0, "ind": 3, "ty": 4, "nm": "Line-1 Outlines 2", "sr": 1, "ks": { "o": { "a": 0, "k": 100, "ix": 11 }, "r": { "a": 0, "k": 0, "ix": 10 }, "p": { "a": 0, "k": [533.749, 428.262, 0], "ix": 2 }, "a": { "a": 0, "k": [167.008, 128.262, 0], "ix": 1 }, "s": { "a": 1, "k": [{ "i": { "x": [0.4, 0.4, 0.4], "y": [1, 1, 1] }, "o": { "x": [0.6, 0.6, 0.6], "y": [0, 0, 0] }, "t": 101.061, "s": [330, 330, 100] }, { "t": 129, "s": [270, 270, 100] }], "ix": 6 } }, "ao": 0, "shapes": [{ "ty": "gr", "it": [{ "ind": 0, "ty": "sh", "ix": 1, "ks": { "a": 0, "k": { "i": [[0, 0], [15.4, -15.4]], "o": [[15.4, 15.4], [0, 0]], "v": [[-7.7, -27.884], [-7.7, 27.884]], "c": false }, "ix": 2 }, "nm": "Path 1", "mn": "ADBE Vector Shape - Group", "hd": false }, { "ty": "st", "c": { "a": 0, "k": [0.956862804936, 0.898039275525, 0.211764720842, 1], "ix": 3 }, "o": { "a": 0, "k": 100, "ix": 4 }, "w": { "a": 0, "k": 20, "ix": 5 }, "lc": 1, "lj": 2, "bm": 0, "nm": "Stroke 1", "mn": "ADBE Vector Graphic - Stroke", "hd": false }, { "ty": "tr", "p": { "a": 0, "k": [174.18, 103.585], "ix": 2 }, "a": { "a": 0, "k": [0, 0], "ix": 1 }, "s": { "a": 0, "k": [100, 100], "ix": 3 }, "r": { "a": 0, "k": 0, "ix": 6 }, "o": { "a": 0, "k": 100, "ix": 7 }, "sk": { "a": 0, "k": 0, "ix": 4 }, "sa": { "a": 0, "k": 0, "ix": 5 }, "nm": "Transform" }], "nm": "Group 1", "np": 2, "cix": 2, "bm": 0, "ix": 1, "mn": "ADBE Vector Group", "hd": false }, { "ty": "tm", "s": { "a": 0, "k": 100, "ix": 1 }, "e": { "a": 0, "k": 0, "ix": 2 }, "o": { "a": 0, "k": 0, "ix": 3 }, "m": 1, "ix": 2, "nm": "Trim Out Path", "mn": "ADBE Vector Filter - Trim", "hd": false }, { "ty": "tm", "s": { "a": 0, "k": 0, "ix": 1 }, "e": { "a": 1, "k": [{ "i": { "x": [0.4], "y": [1] }, "o": { "x": [0.6], "y": [0] }, "t": 101.061, "s": [0] }, { "t": 129, "s": [100] }], "ix": 2 }, "o": { "a": 0, "k": 0, "ix": 3 }, "m": 1, "ix": 3, "nm": "Trim In Path", "mn": "ADBE Vector Filter - Trim", "hd": false }], "ip": 75, "op": 312, "st": 12, "bm": 0 }, { "ddd": 0, "ind": 4, "ty": 4, "nm": "Line-1 Outlines", "sr": 1, "ks": { "o": { "a": 0, "k": 100, "ix": 11 }, "r": { "a": 0, "k": 0, "ix": 10 }, "p": { "a": 0, "k": [533.749, 428.262, 0], "ix": 2 }, "a": { "a": 0, "k": [167.008, 128.262, 0], "ix": 1 }, "s": { "a": 1, "k": [{ "i": { "x": [0.4, 0.4, 0.4], "y": [1, 1, 1] }, "o": { "x": [0.6, 0.6, 0.6], "y": [0, 0, 0] }, "t": 32, "s": [270, 270, 100] }, { "t": 59.470703125, "s": [330, 330, 100] }], "ix": 6 } }, "ao": 0, "shapes": [{ "ty": "gr", "it": [{ "ind": 0, "ty": "sh", "ix": 1, "ks": { "a": 0, "k": { "i": [[0, 0], [15.4, 15.4]], "o": [[15.4, -15.4], [0, 0]], "v": [[-7.7, 27.884], [-7.7, -27.884]], "c": false }, "ix": 2 }, "nm": "Path 1", "mn": "ADBE Vector Shape - Group", "hd": false }, { "ty": "st", "c": { "a": 0, "k": [0.956862804936, 0.898039275525, 0.211764720842, 1], "ix": 3 }, "o": { "a": 0, "k": 100, "ix": 4 }, "w": { "a": 0, "k": 20, "ix": 5 }, "lc": 1, "lj": 2, "bm": 0, "nm": "Stroke 1", "mn": "ADBE Vector Graphic - Stroke", "hd": false }, { "ty": "tr", "p": { "a": 0, "k": [174.18, 103.585], "ix": 2 }, "a": { "a": 0, "k": [0, 0], "ix": 1 }, "s": { "a": 0, "k": [100, 100], "ix": 3 }, "r": { "a": 0, "k": 0, "ix": 6 }, "o": { "a": 0, "k": 100, "ix": 7 }, "sk": { "a": 0, "k": 0, "ix": 4 }, "sa": { "a": 0, "k": 0, "ix": 5 }, "nm": "Transform" }], "nm": "Group 1", "np": 2, "cix": 2, "bm": 0, "ix": 1, "mn": "ADBE Vector Group", "hd": false }, { "ty": "tm", "s": { "a": 0, "k": 100, "ix": 1 }, "e": { "a": 1, "k": [{ "i": { "x": [0.4], "y": [1] }, "o": { "x": [0.6], "y": [0] }, "t": 32, "s": [0] }, { "t": 59.470703125, "s": [100] }], "ix": 2 }, "o": { "a": 0, "k": 0, "ix": 3 }, "m": 1, "ix": 2, "nm": "Trim Out Path", "mn": "ADBE Vector Filter - Trim", "hd": false }], "ip": -30, "op": 75, "st": 12, "bm": 0 }, { "ddd": 0, "ind": 5, "ty": 4, "nm": "Star-2 Outlines 2", "sr": 1, "ks": { "o": { "a": 0, "k": 100, "ix": 11 }, "r": { "a": 0, "k": 0, "ix": 10 }, "p": { "a": 0, "k": [811.749, 266.262, 0], "ix": 2 }, "a": { "a": 0, "k": [269.971, 68.262, 0], "ix": 1 }, "s": { "a": 1, "k": [{ "i": { "x": [0.4, 0.4, 0.4], "y": [1, 1, 1] }, "o": { "x": [0.6, 0.6, 0.6], "y": [0, 0, 0] }, "t": 38.867, "s": [270, 270, 100] }, { "i": { "x": [0.4, 0.4, 0.4], "y": [1, 1, 1] }, "o": { "x": [0.6, 0.6, 0.6], "y": [0, 0, 0] }, "t": 52.602, "s": [320, 320, 100] }, { "i": { "x": [0.4, 0.4, 0.4], "y": [1, 1, 1] }, "o": { "x": [0.6, 0.6, 0.6], "y": [0, 0, 0] }, "t": 66.338, "s": [0, 0, 100] }, { "i": { "x": [0.4, 0.4, 0.4], "y": [1, 1, 1] }, "o": { "x": [0.6, 0.6, 0.6], "y": [0, 0, 0] }, "t": 114.795, "s": [0, 0, 100] }, { "i": { "x": [0.4, 0.4, 0.4], "y": [1, 1, 1] }, "o": { "x": [0.6, 0.6, 0.6], "y": [0, 0, 0] }, "t": 128.529, "s": [320, 320, 100] }, { "t": 142.265625, "s": [270, 270, 100] }], "ix": 6 } }, "ao": 0, "shapes": [{ "ty": "gr", "it": [{ "ind": 0, "ty": "sh", "ix": 1, "ks": { "a": 0, "k": { "i": [[0, 0], [0, 0], [0, 0], [0, 0], [0, 0], [0, 0], [0, 0], [0, 0], [0, 0], [0, 0]], "o": [[0, 0], [0, 0], [0, 0], [0, 0], [0, 0], [0, 0], [0, 0], [0, 0], [0, 0], [0, 0]], "v": [[6.371, -28.12], [35.582, -35.58], [28.122, -6.369], [44.243, 19.107], [14.157, 21.038], [-5.09, 44.243], [-16.225, 16.226], [-44.242, 5.092], [-21.037, -14.156], [-19.105, -44.243]], "c": true }, "ix": 2 }, "nm": "Path 1", "mn": "ADBE Vector Shape - Group", "hd": false }, { "ty": "st", "c": { "a": 0, "k": [0.956862804936, 0.898039275525, 0.211764720842, 1], "ix": 3 }, "o": { "a": 0, "k": 100, "ix": 4 }, "w": { "a": 0, "k": 20, "ix": 5 }, "lc": 1, "lj": 2, "bm": 0, "nm": "Stroke 1", "mn": "ADBE Vector Graphic - Stroke", "hd": false }, { "ty": "tr", "p": { "a": 0, "k": [268.525, 69.394], "ix": 2 }, "a": { "a": 0, "k": [0, 0], "ix": 1 }, "s": { "a": 0, "k": [100, 100], "ix": 3 }, "r": { "a": 0, "k": 0, "ix": 6 }, "o": { "a": 0, "k": 100, "ix": 7 }, "sk": { "a": 0, "k": 0, "ix": 4 }, "sa": { "a": 0, "k": 0, "ix": 5 }, "nm": "Transform" }], "nm": "Group 1", "np": 2, "cix": 2, "bm": 0, "ix": 1, "mn": "ADBE Vector Group", "hd": false }], "ip": 75, "op": 317, "st": 17, "bm": 0 }, { "ddd": 0, "ind": 6, "ty": 4, "nm": "Star-2 Outlines", "sr": 1, "ks": { "o": { "a": 0, "k": 100, "ix": 11 }, "r": { "a": 0, "k": 0, "ix": 10 }, "p": { "a": 0, "k": [811.749, 266.262, 0], "ix": 2 }, "a": { "a": 0, "k": [269.971, 68.262, 0], "ix": 1 }, "s": { "a": 1, "k": [{ "i": { "x": [0.4, 0.4, 0.4], "y": [1, 1, 1] }, "o": { "x": [0.6, 0.6, 0.6], "y": [0, 0, 0] }, "t": 38.867, "s": [270, 270, 100] }, { "i": { "x": [0.4, 0.4, 0.4], "y": [1, 1, 1] }, "o": { "x": [0.6, 0.6, 0.6], "y": [0, 0, 0] }, "t": 52.602, "s": [320, 320, 100] }, { "i": { "x": [0.4, 0.4, 0.4], "y": [1, 1, 1] }, "o": { "x": [0.6, 0.6, 0.6], "y": [0, 0, 0] }, "t": 66.338, "s": [0, 0, 100] }, { "i": { "x": [0.4, 0.4, 0.4], "y": [1, 1, 1] }, "o": { "x": [0.6, 0.6, 0.6], "y": [0, 0, 0] }, "t": 114.795, "s": [0, 0, 100] }, { "i": { "x": [0.4, 0.4, 0.4], "y": [1, 1, 1] }, "o": { "x": [0.6, 0.6, 0.6], "y": [0, 0, 0] }, "t": 128.529, "s": [320, 320, 100] }, { "t": 142.265625, "s": [270, 270, 100] }], "ix": 6 } }, "ao": 0, "shapes": [{ "ty": "gr", "it": [{ "ind": 0, "ty": "sh", "ix": 1, "ks": { "a": 0, "k": { "i": [[0, 0], [0, 0], [0, 0], [0, 0], [0, 0], [0, 0], [0, 0], [0, 0], [0, 0], [0, 0]], "o": [[0, 0], [0, 0], [0, 0], [0, 0], [0, 0], [0, 0], [0, 0], [0, 0], [0, 0], [0, 0]], "v": [[6.371, -28.12], [35.582, -35.58], [28.122, -6.369], [44.243, 19.107], [14.157, 21.038], [-5.09, 44.243], [-16.225, 16.226], [-44.242, 5.092], [-21.037, -14.156], [-19.105, -44.243]], "c": true }, "ix": 2 }, "nm": "Path 1", "mn": "ADBE Vector Shape - Group", "hd": false }, { "ty": "st", "c": { "a": 0, "k": [0.956862804936, 0.898039275525, 0.211764720842, 1], "ix": 3 }, "o": { "a": 0, "k": 100, "ix": 4 }, "w": { "a": 0, "k": 20, "ix": 5 }, "lc": 1, "lj": 2, "bm": 0, "nm": "Stroke 1", "mn": "ADBE Vector Graphic - Stroke", "hd": false }, { "ty": "tr", "p": { "a": 0, "k": [268.525, 69.394], "ix": 2 }, "a": { "a": 0, "k": [0, 0], "ix": 1 }, "s": { "a": 0, "k": [100, 100], "ix": 3 }, "r": { "a": 0, "k": 0, "ix": 6 }, "o": { "a": 0, "k": 100, "ix": 7 }, "sk": { "a": 0, "k": 0, "ix": 4 }, "sa": { "a": 0, "k": 0, "ix": 5 }, "nm": "Transform" }], "nm": "Group 1", "np": 2, "cix": 2, "bm": 0, "ix": 1, "mn": "ADBE Vector Group", "hd": false }], "ip": 0, "op": 75, "st": 17, "bm": 0 }, { "ddd": 0, "ind": 7, "ty": 4, "nm": "Line-2 Outlines 2", "sr": 1, "ks": { "o": { "a": 0, "k": 100, "ix": 11 }, "r": { "a": 0, "k": 0, "ix": 10 }, "p": { "a": 0, "k": [575.749, 506.262, 0], "ix": 2 }, "a": { "a": 0, "k": [182.564, 157.15, 0], "ix": 1 }, "s": { "a": 1, "k": [{ "i": { "x": [0.4, 0.4, 0.4], "y": [1, 1, 1] }, "o": { "x": [0.6, 0.6, 0.6], "y": [0, 0, 0] }, "t": 38.867, "s": [270, 270, 100] }, { "i": { "x": [0.4, 0.4, 0.4], "y": [1, 1, 1] }, "o": { "x": [0.6, 0.6, 0.6], "y": [0, 0, 0] }, "t": 66.338, "s": [330, 330, 100] }, { "i": { "x": [0.4, 0.4, 0.4], "y": [1, 1, 1] }, "o": { "x": [0.6, 0.6, 0.6], "y": [0, 0, 0] }, "t": 114.795, "s": [330, 330, 100] }, { "t": 142, "s": [270, 270, 100] }], "ix": 6 } }, "ao": 0, "shapes": [{ "ty": "gr", "it": [{ "ind": 0, "ty": "sh", "ix": 1, "ks": { "a": 0, "k": { "i": [[0, 0], [0, 0]], "o": [[0, 0], [0, 0]], "v": [[-21.657, 21.657], [21.657, -21.657]], "c": false }, "ix": 2 }, "nm": "Path 1", "mn": "ADBE Vector Shape - Group", "hd": false }, { "ty": "st", "c": { "a": 0, "k": [0.956862804936, 0.898039275525, 0.211764720842, 1], "ix": 3 }, "o": { "a": 0, "k": 100, "ix": 4 }, "w": { "a": 0, "k": 20, "ix": 5 }, "lc": 1, "lj": 2, "bm": 0, "nm": "Stroke 1", "mn": "ADBE Vector Graphic - Stroke", "hd": false }, { "ty": "tr", "p": { "a": 0, "k": [207.871, 130.048], "ix": 2 }, "a": { "a": 0, "k": [0, 0], "ix": 1 }, "s": { "a": 0, "k": [100, 100], "ix": 3 }, "r": { "a": 0, "k": 0, "ix": 6 }, "o": { "a": 0, "k": 100, "ix": 7 }, "sk": { "a": 0, "k": 0, "ix": 4 }, "sa": { "a": 0, "k": 0, "ix": 5 }, "nm": "Transform" }], "nm": "Group 1", "np": 2, "cix": 2, "bm": 0, "ix": 1, "mn": "ADBE Vector Group", "hd": false }, { "ty": "tm", "s": { "a": 0, "k": 100, "ix": 1 }, "e": { "a": 0, "k": 0, "ix": 2 }, "o": { "a": 0, "k": 0, "ix": 3 }, "m": 1, "ix": 2, "nm": "Trim Out Path", "mn": "ADBE Vector Filter - Trim", "hd": false }, { "ty": "tm", "s": { "a": 0, "k": 0, "ix": 1 }, "e": { "a": 1, "k": [{ "i": { "x": [0.4], "y": [1] }, "o": { "x": [0.6], "y": [0] }, "t": 114.795, "s": [0] }, { "t": 142, "s": [100] }], "ix": 2 }, "o": { "a": 0, "k": 0, "ix": 3 }, "m": 1, "ix": 3, "nm": "Trim Paths 1", "mn": "ADBE Vector Filter - Trim", "hd": false }], "ip": 75, "op": 317, "st": 17, "bm": 0 }, { "ddd": 0, "ind": 8, "ty": 4, "nm": "Line-2 Outlines", "sr": 1, "ks": { "o": { "a": 0, "k": 100, "ix": 11 }, "r": { "a": 0, "k": 0, "ix": 10 }, "p": { "a": 0, "k": [575.749, 506.262, 0], "ix": 2 }, "a": { "a": 0, "k": [182.564, 157.15, 0], "ix": 1 }, "s": { "a": 1, "k": [{ "i": { "x": [0.4, 0.4, 0.4], "y": [1, 1, 1] }, "o": { "x": [0.6, 0.6, 0.6], "y": [0, 0, 0] }, "t": 38.867, "s": [270, 270, 100] }, { "t": 66.337890625, "s": [330, 330, 100] }], "ix": 6 } }, "ao": 0, "shapes": [{ "ty": "gr", "it": [{ "ind": 0, "ty": "sh", "ix": 1, "ks": { "a": 0, "k": { "i": [[0, 0], [0, 0]], "o": [[0, 0], [0, 0]], "v": [[-21.657, 21.657], [21.657, -21.657]], "c": false }, "ix": 2 }, "nm": "Path 1", "mn": "ADBE Vector Shape - Group", "hd": false }, { "ty": "st", "c": { "a": 0, "k": [0.956862804936, 0.898039275525, 0.211764720842, 1], "ix": 3 }, "o": { "a": 0, "k": 100, "ix": 4 }, "w": { "a": 0, "k": 20, "ix": 5 }, "lc": 1, "lj": 2, "bm": 0, "nm": "Stroke 1", "mn": "ADBE Vector Graphic - Stroke", "hd": false }, { "ty": "tr", "p": { "a": 0, "k": [207.871, 130.048], "ix": 2 }, "a": { "a": 0, "k": [0, 0], "ix": 1 }, "s": { "a": 0, "k": [100, 100], "ix": 3 }, "r": { "a": 0, "k": 0, "ix": 6 }, "o": { "a": 0, "k": 100, "ix": 7 }, "sk": { "a": 0, "k": 0, "ix": 4 }, "sa": { "a": 0, "k": 0, "ix": 5 }, "nm": "Transform" }], "nm": "Group 1", "np": 2, "cix": 2, "bm": 0, "ix": 1, "mn": "ADBE Vector Group", "hd": false }, { "ty": "tm", "s": { "a": 0, "k": 100, "ix": 1 }, "e": { "a": 1, "k": [{ "i": { "x": [0.4], "y": [1] }, "o": { "x": [0.6], "y": [0] }, "t": 38.867, "s": [0] }, { "t": 66.337890625, "s": [100] }], "ix": 2 }, "o": { "a": 0, "k": 0, "ix": 3 }, "m": 1, "ix": 2, "nm": "Trim Out Path", "mn": "ADBE Vector Filter - Trim", "hd": false }], "ip": 0, "op": 75, "st": 17, "bm": 0 }, { "ddd": 0, "ind": 9, "ty": 4, "nm": "Star-3 Outlines 2", "sr": 1, "ks": { "o": { "a": 0, "k": 100, "ix": 11 }, "r": { "a": 0, "k": 0, "ix": 10 }, "p": { "a": 0, "k": [873.749, 630.262, 0], "ix": 2 }, "a": { "a": 0, "k": [292.934, 203.076, 0], "ix": 1 }, "s": { "a": 1, "k": [{ "i": { "x": [0.4, 0.4, 0.4], "y": [1, 1, 1] }, "o": { "x": [0.6, 0.6, 0.6], "y": [0, 0, 0] }, "t": 51.229, "s": [270, 270, 100] }, { "i": { "x": [0.4, 0.4, 0.4], "y": [1, 1, 1] }, "o": { "x": [0.6, 0.6, 0.6], "y": [0, 0, 0] }, "t": 64.963, "s": [320, 320, 100] }, { "i": { "x": [0.4, 0.4, 0.4], "y": [1, 1, 1] }, "o": { "x": [0.6, 0.6, 0.6], "y": [0, 0, 0] }, "t": 78.699, "s": [0, 0, 100] }, { "i": { "x": [0.4, 0.4, 0.4], "y": [1, 1, 1] }, "o": { "x": [0.6, 0.6, 0.6], "y": [0, 0, 0] }, "t": 128.529, "s": [0, 0, 100] }, { "i": { "x": [0.4, 0.4, 0.4], "y": [1, 1, 1] }, "o": { "x": [0.6, 0.6, 0.6], "y": [0, 0, 0] }, "t": 142.266, "s": [320, 320, 100] }, { "t": 156, "s": [270, 270, 100] }], "ix": 6 } }, "ao": 0, "shapes": [{ "ty": "gr", "it": [{ "ind": 0, "ty": "sh", "ix": 1, "ks": { "a": 0, "k": { "i": [[0, 0], [0, 0], [0, 0], [0, 0], [0, 0], [0, 0], [0, 0], [0, 0], [0, 0], [0, 0], [0, 0]], "o": [[0, 0], [0, 0], [0, 0], [0, 0], [0, 0], [0, 0], [0, 0], [0, 0], [0, 0], [0, 0], [0, 0]], "v": [[20.177, 4.326], [25.663, 25.138], [13.281, 22.077], [4.769, 19.973], [-13.329, 31.622], [-14.873, 10.155], [-31.545, -3.458], [-11.605, -11.56], [-3.811, -31.622], [10.057, -15.163], [31.546, -13.949]], "c": true }, "ix": 2 }, "nm": "Path 1", "mn": "ADBE Vector Shape - Group", "hd": false }, { "ty": "st", "c": { "a": 0, "k": [0.956862804936, 0.898039275525, 0.211764720842, 1], "ix": 3 }, "o": { "a": 0, "k": 100, "ix": 4 }, "w": { "a": 0, "k": 20, "ix": 5 }, "lc": 1, "lj": 2, "bm": 0, "nm": "Stroke 1", "mn": "ADBE Vector Graphic - Stroke", "hd": false }, { "ty": "tr", "p": { "a": 0, "k": [290.381, 199.873], "ix": 2 }, "a": { "a": 0, "k": [0, 0], "ix": 1 }, "s": { "a": 0, "k": [100, 100], "ix": 3 }, "r": { "a": 0, "k": 0, "ix": 6 }, "o": { "a": 0, "k": 100, "ix": 7 }, "sk": { "a": 0, "k": 0, "ix": 4 }, "sa": { "a": 0, "k": 0, "ix": 5 }, "nm": "Transform" }], "nm": "Group 1", "np": 2, "cix": 2, "bm": 0, "ix": 1, "mn": "ADBE Vector Group", "hd": false }], "ip": 75, "op": 326, "st": 26, "bm": 0 }, { "ddd": 0, "ind": 10, "ty": 4, "nm": "Star-3 Outlines", "sr": 1, "ks": { "o": { "a": 0, "k": 100, "ix": 11 }, "r": { "a": 0, "k": 0, "ix": 10 }, "p": { "a": 0, "k": [873.749, 630.262, 0], "ix": 2 }, "a": { "a": 0, "k": [292.934, 203.076, 0], "ix": 1 }, "s": { "a": 1, "k": [{ "i": { "x": [0.4, 0.4, 0.4], "y": [1, 1, 1] }, "o": { "x": [0.6, 0.6, 0.6], "y": [0, 0, 0] }, "t": 51.229, "s": [270, 270, 100] }, { "i": { "x": [0.4, 0.4, 0.4], "y": [1, 1, 1] }, "o": { "x": [0.6, 0.6, 0.6], "y": [0, 0, 0] }, "t": 64.963, "s": [320, 320, 100] }, { "i": { "x": [0.4, 0.4, 0.4], "y": [1, 1, 1] }, "o": { "x": [0.6, 0.6, 0.6], "y": [0, 0, 0] }, "t": 78.699, "s": [0, 0, 100] }, { "i": { "x": [0.4, 0.4, 0.4], "y": [1, 1, 1] }, "o": { "x": [0.6, 0.6, 0.6], "y": [0, 0, 0] }, "t": 128.529, "s": [0, 0, 100] }, { "i": { "x": [0.4, 0.4, 0.4], "y": [1, 1, 1] }, "o": { "x": [0.6, 0.6, 0.6], "y": [0, 0, 0] }, "t": 142.266, "s": [320, 320, 100] }, { "t": 156, "s": [270, 270, 100] }], "ix": 6 } }, "ao": 0, "shapes": [{ "ty": "gr", "it": [{ "ind": 0, "ty": "sh", "ix": 1, "ks": { "a": 0, "k": { "i": [[0, 0], [0, 0], [0, 0], [0, 0], [0, 0], [0, 0], [0, 0], [0, 0], [0, 0], [0, 0], [0, 0]], "o": [[0, 0], [0, 0], [0, 0], [0, 0], [0, 0], [0, 0], [0, 0], [0, 0], [0, 0], [0, 0], [0, 0]], "v": [[20.177, 4.326], [25.663, 25.138], [13.281, 22.077], [4.769, 19.973], [-13.329, 31.622], [-14.873, 10.155], [-31.545, -3.458], [-11.605, -11.56], [-3.811, -31.622], [10.057, -15.163], [31.546, -13.949]], "c": true }, "ix": 2 }, "nm": "Path 1", "mn": "ADBE Vector Shape - Group", "hd": false }, { "ty": "st", "c": { "a": 0, "k": [0.956862804936, 0.898039275525, 0.211764720842, 1], "ix": 3 }, "o": { "a": 0, "k": 100, "ix": 4 }, "w": { "a": 0, "k": 20, "ix": 5 }, "lc": 1, "lj": 2, "bm": 0, "nm": "Stroke 1", "mn": "ADBE Vector Graphic - Stroke", "hd": false }, { "ty": "tr", "p": { "a": 0, "k": [290.381, 199.873], "ix": 2 }, "a": { "a": 0, "k": [0, 0], "ix": 1 }, "s": { "a": 0, "k": [100, 100], "ix": 3 }, "r": { "a": 0, "k": 0, "ix": 6 }, "o": { "a": 0, "k": 100, "ix": 7 }, "sk": { "a": 0, "k": 0, "ix": 4 }, "sa": { "a": 0, "k": 0, "ix": 5 }, "nm": "Transform" }], "nm": "Group 1", "np": 2, "cix": 2, "bm": 0, "ix": 1, "mn": "ADBE Vector Group", "hd": false }], "ip": -8, "op": 75, "st": 26, "bm": 0 }, { "ddd": 0, "ind": 12, "ty": 4, "nm": "Line-3 Outlines 3", "sr": 1, "ks": { "o": { "a": 0, "k": 100, "ix": 11 }, "r": { "a": 0, "k": 0, "ix": 10 }, "p": { "a": 0, "k": [641.749, 546.262, 0], "ix": 2 }, "a": { "a": 0, "k": [207.008, 171.965, 0], "ix": 1 }, "s": { "a": 1, "k": [{ "i": { "x": [0.4, 0.4, 0.4], "y": [1, 1, 1] }, "o": { "x": [0.6, 0.6, 0.6], "y": [0, 0, 0] }, "t": 51.229, "s": [270, 270, 100] }, { "i": { "x": [0.4, 0.4, 0.4], "y": [1, 1, 1] }, "o": { "x": [0.167, 0.167, 0.167], "y": [0, 0, 0] }, "t": 78.699, "s": [330, 330, 100] }, { "i": { "x": [0.4, 0.4, 0.4], "y": [1, 1, 1] }, "o": { "x": [0.6, 0.6, 0.6], "y": [0, 0, 0] }, "t": 129, "s": [330, 330, 100] }, { "t": 156.470703125, "s": [270, 270, 100] }], "ix": 6 } }, "ao": 0, "shapes": [{ "ty": "gr", "it": [{ "ind": 0, "ty": "sh", "ix": 1, "ks": { "a": 0, "k": { "i": [[0, 0], [-15.4, -15.4]], "o": [[15.4, -15.4], [0, 0]], "v": [[-27.884, 7.7], [27.884, 7.7]], "c": false }, "ix": 2 }, "nm": "Path 1", "mn": "ADBE Vector Shape - Group", "hd": false }, { "ty": "st", "c": { "a": 0, "k": [0.956862804936, 0.898039275525, 0.211764720842, 1], "ix": 3 }, "o": { "a": 0, "k": 100, "ix": 4 }, "w": { "a": 0, "k": 20, "ix": 5 }, "lc": 1, "lj": 2, "bm": 0, "nm": "Stroke 1", "mn": "ADBE Vector Graphic - Stroke", "hd": false }, { "ty": "tr", "p": { "a": 0, "k": [234.335, 163.74], "ix": 2 }, "a": { "a": 0, "k": [0, 0], "ix": 1 }, "s": { "a": 0, "k": [100, 100], "ix": 3 }, "r": { "a": 0, "k": 0, "ix": 6 }, "o": { "a": 0, "k": 100, "ix": 7 }, "sk": { "a": 0, "k": 0, "ix": 4 }, "sa": { "a": 0, "k": 0, "ix": 5 }, "nm": "Transform" }], "nm": "Group 1", "np": 2, "cix": 2, "bm": 0, "ix": 1, "mn": "ADBE Vector Group", "hd": false }, { "ty": "tm", "s": { "a": 0, "k": 0, "ix": 1 }, "e": { "a": 1, "k": [{ "i": { "x": [0.4], "y": [1] }, "o": { "x": [0.6], "y": [0] }, "t": 129, "s": [0] }, { "t": 156.470703125, "s": [100] }], "ix": 2 }, "o": { "a": 0, "k": 0, "ix": 3 }, "m": 1, "ix": 2, "nm": "Trim Paths 1", "mn": "ADBE Vector Filter - Trim", "hd": false }], "ip": 75, "op": 184, "st": 26, "bm": 0 }, { "ddd": 0, "ind": 13, "ty": 4, "nm": "Line-3 Outlines", "sr": 1, "ks": { "o": { "a": 0, "k": 100, "ix": 11 }, "r": { "a": 0, "k": 0, "ix": 10 }, "p": { "a": 0, "k": [641.749, 546.262, 0], "ix": 2 }, "a": { "a": 0, "k": [207.008, 171.965, 0], "ix": 1 }, "s": { "a": 1, "k": [{ "i": { "x": [0.4, 0.4, 0.4], "y": [1, 1, 1] }, "o": { "x": [0.6, 0.6, 0.6], "y": [0, 0, 0] }, "t": 51.229, "s": [270, 270, 100] }, { "t": 78.69921875, "s": [330, 330, 100] }], "ix": 6 } }, "ao": 0, "shapes": [{ "ty": "gr", "it": [{ "ind": 0, "ty": "sh", "ix": 1, "ks": { "a": 0, "k": { "i": [[0, 0], [-15.4, -15.4]], "o": [[15.4, -15.4], [0, 0]], "v": [[-27.884, 7.7], [27.884, 7.7]], "c": false }, "ix": 2 }, "nm": "Path 1", "mn": "ADBE Vector Shape - Group", "hd": false }, { "ty": "st", "c": { "a": 0, "k": [0.956862804936, 0.898039275525, 0.211764720842, 1], "ix": 3 }, "o": { "a": 0, "k": 100, "ix": 4 }, "w": { "a": 0, "k": 20, "ix": 5 }, "lc": 1, "lj": 2, "bm": 0, "nm": "Stroke 1", "mn": "ADBE Vector Graphic - Stroke", "hd": false }, { "ty": "tr", "p": { "a": 0, "k": [234.335, 163.74], "ix": 2 }, "a": { "a": 0, "k": [0, 0], "ix": 1 }, "s": { "a": 0, "k": [100, 100], "ix": 3 }, "r": { "a": 0, "k": 0, "ix": 6 }, "o": { "a": 0, "k": 100, "ix": 7 }, "sk": { "a": 0, "k": 0, "ix": 4 }, "sa": { "a": 0, "k": 0, "ix": 5 }, "nm": "Transform" }], "nm": "Group 1", "np": 2, "cix": 2, "bm": 0, "ix": 1, "mn": "ADBE Vector Group", "hd": false }, { "ty": "tm", "s": { "a": 0, "k": 100, "ix": 1 }, "e": { "a": 1, "k": [{ "i": { "x": [0.4], "y": [1] }, "o": { "x": [0.6], "y": [0] }, "t": 51.229, "s": [0] }, { "t": 78.69921875, "s": [100] }], "ix": 2 }, "o": { "a": 0, "k": 0, "ix": 3 }, "m": 1, "ix": 2, "nm": "Trim Out Path", "mn": "ADBE Vector Filter - Trim", "hd": false }], "ip": -11, "op": 75, "st": 26, "bm": 0 }, { "ddd": 0, "ind": 14, "ty": 4, "nm": "Cone Outlines", "sr": 1, "ks": { "o": { "a": 0, "k": 100, "ix": 11 }, "r": { "a": 0, "k": 0, "ix": 10 }, "p": { "a": 0, "k": [129.749, 948.262, 0], "ix": 2 }, "a": { "a": 0, "k": [17.379, 320.854, 0], "ix": 1 }, "s": { "a": 1, "k": [{ "i": { "x": [0.833, 0.833, 0.833], "y": [0.833, 0.833, 0.833] }, "o": { "x": [0.167, 0.167, 0.167], "y": [0.167, 0.167, 0.167] }, "t": 34.746, "s": [270, 270, 100] }, { "i": { "x": [0.833, 0.833, 0.833], "y": [0.833, 0.833, 0.833] }, "o": { "x": [0.167, 0.167, 0.167], "y": [0.167, 0.167, 0.167] }, "t": 56.723, "s": [280, 280, 100] }, { "i": { "x": [0.833, 0.833, 0.833], "y": [0.833, 0.833, 0.833] }, "o": { "x": [0.167, 0.167, 0.167], "y": [0.167, 0.167, 0.167] }, "t": 78.699, "s": [270, 270, 100] }, { "i": { "x": [0.833, 0.833, 0.833], "y": [0.833, 0.833, 0.833] }, "o": { "x": [0.167, 0.167, 0.167], "y": [0.167, 0.167, 0.167] }, "t": 102.434, "s": [270, 270, 100] }, { "i": { "x": [0.833, 0.833, 0.833], "y": [0.833, 0.833, 0.833] }, "o": { "x": [0.167, 0.167, 0.167], "y": [0.167, 0.167, 0.167] }, "t": 121.662, "s": [280, 280, 100] }, { "t": 147.759765625, "s": [270, 270, 100] }], "ix": 6 } }, "ao": 0, "shapes": [{ "ty": "gr", "it": [{ "ind": 0, "ty": "sh", "ix": 1, "ks": { "a": 0, "k": { "i": [[0, 0], [0, 0]], "o": [[0, 0], [0, 0]], "v": [[73.271, 213.893], [73.271, 294.402]], "c": false }, "ix": 2 }, "nm": "Path 1", "mn": "ADBE Vector Shape - Group", "hd": false }, { "ty": "st", "c": { "a": 0, "k": [0.956862804936, 0.898039275525, 0.211764720842, 1], "ix": 3 }, "o": { "a": 0, "k": 100, "ix": 4 }, "w": { "a": 0, "k": 20, "ix": 5 }, "lc": 1, "lj": 1, "ml": 10, "bm": 0, "nm": "Stroke 1", "mn": "ADBE Vector Graphic - Stroke", "hd": false }, { "ty": "tr", "p": { "a": 0, "k": [0, 0], "ix": 2 }, "a": { "a": 0, "k": [0, 0], "ix": 1 }, "s": { "a": 0, "k": [100, 100], "ix": 3 }, "r": { "a": 0, "k": 0, "ix": 6 }, "o": { "a": 0, "k": 100, "ix": 7 }, "sk": { "a": 0, "k": 0, "ix": 4 }, "sa": { "a": 0, "k": 0, "ix": 5 }, "nm": "Transform" }], "nm": "Group 1", "np": 2, "cix": 2, "bm": 0, "ix": 1, "mn": "ADBE Vector Group", "hd": false }, { "ty": "gr", "it": [{ "ind": 0, "ty": "sh", "ix": 1, "ks": { "a": 0, "k": { "i": [[0, 0], [0, 0]], "o": [[0, 0], [0, 0]], "v": [[122.717, 263.583], [122.717, 130.084]], "c": false }, "ix": 2 }, "nm": "Path 1", "mn": "ADBE Vector Shape - Group", "hd": false }, { "ty": "st", "c": { "a": 0, "k": [0.956862804936, 0.898039275525, 0.211764720842, 1], "ix": 3 }, "o": { "a": 0, "k": 100, "ix": 4 }, "w": { "a": 0, "k": 20, "ix": 5 }, "lc": 1, "lj": 1, "ml": 10, "bm": 0, "nm": "Stroke 1", "mn": "ADBE Vector Graphic - Stroke", "hd": false }, { "ty": "tr", "p": { "a": 0, "k": [0, 0], "ix": 2 }, "a": { "a": 0, "k": [0, 0], "ix": 1 }, "s": { "a": 0, "k": [100, 100], "ix": 3 }, "r": { "a": 0, "k": 0, "ix": 6 }, "o": { "a": 0, "k": 100, "ix": 7 }, "sk": { "a": 0, "k": 0, "ix": 4 }, "sa": { "a": 0, "k": 0, "ix": 5 }, "nm": "Transform" }], "nm": "Group 2", "np": 2, "cix": 2, "bm": 0, "ix": 2, "mn": "ADBE Vector Group", "hd": false }, { "ty": "gr", "it": [{ "ind": 0, "ty": "sh", "ix": 1, "ks": { "a": 0, "k": { "i": [[0, 0], [0, 0]], "o": [[0, 0], [0, 0]], "v": [[174.508, 235.071], [174.508, 151.258]], "c": false }, "ix": 2 }, "nm": "Path 1", "mn": "ADBE Vector Shape - Group", "hd": false }, { "ty": "st", "c": { "a": 0, "k": [0.956862804936, 0.898039275525, 0.211764720842, 1], "ix": 3 }, "o": { "a": 0, "k": 100, "ix": 4 }, "w": { "a": 0, "k": 20, "ix": 5 }, "lc": 1, "lj": 1, "ml": 10, "bm": 0, "nm": "Stroke 1", "mn": "ADBE Vector Graphic - Stroke", "hd": false }, { "ty": "tr", "p": { "a": 0, "k": [0, 0], "ix": 2 }, "a": { "a": 0, "k": [0, 0], "ix": 1 }, "s": { "a": 0, "k": [100, 100], "ix": 3 }, "r": { "a": 0, "k": 0, "ix": 6 }, "o": { "a": 0, "k": 100, "ix": 7 }, "sk": { "a": 0, "k": 0, "ix": 4 }, "sa": { "a": 0, "k": 0, "ix": 5 }, "nm": "Transform" }], "nm": "Group 3", "np": 2, "cix": 2, "bm": 0, "ix": 3, "mn": "ADBE Vector Group", "hd": false }, { "ty": "gr", "it": [{ "ind": 0, "ty": "sh", "ix": 1, "ks": { "a": 0, "k": { "i": [[0, 0], [3.325, -1.672], [0, 0], [-4.13, 8.212], [0, 0], [-7.404, -7.404], [0, 0], [-0.647, -2.567]], "o": [[-1.376, 3.06], [0, 0], [-8.213, 4.13], [0, 0], [4.705, -9.354], [0, 0], [2.059, 2.059], [0, 0]], "v": [[100.954, -13.616], [93.855, -6.23], [-84.911, 99.406], [-97.723, 86.594], [7.912, -92.172], [32.5, -96.132], [97.816, -30.817], [101.853, -23.739]], "c": false }, "ix": 2 }, "nm": "Path 1", "mn": "ADBE Vector Shape - Group", "hd": false }, { "ty": "st", "c": { "a": 0, "k": [0.956862804936, 0.898039275525, 0.211764720842, 1], "ix": 3 }, "o": { "a": 0, "k": 100, "ix": 4 }, "w": { "a": 0, "k": 20, "ix": 5 }, "lc": 1, "lj": 1, "ml": 10, "bm": 0, "nm": "Stroke 1", "mn": "ADBE Vector Graphic - Stroke", "hd": false }, { "ty": "tr", "p": { "a": 0, "k": [115.586, 221.066], "ix": 2 }, "a": { "a": 0, "k": [0, 0], "ix": 1 }, "s": { "a": 0, "k": [100, 100], "ix": 3 }, "r": { "a": 0, "k": 0, "ix": 6 }, "o": { "a": 0, "k": 100, "ix": 7 }, "sk": { "a": 0, "k": 0, "ix": 4 }, "sa": { "a": 0, "k": 0, "ix": 5 }, "nm": "Transform" }], "nm": "Group 4", "np": 2, "cix": 2, "bm": 0, "ix": 4, "mn": "ADBE Vector Group", "hd": false }], "ip": -27, "op": 312, "st": 12, "bm": 0 }] }], "layers": [{ "ddd": 0, "ind": 1, "ty": 0, "nm": "Stars-Animated", "refId": "comp_0", "sr": 1, "ks": { "o": { "a": 0, "k": 100, "ix": 11 }, "r": { "a": 0, "k": 0, "ix": 10 }, "p": { "a": 0, "k": [128, 954, 0], "ix": 2 }, "a": { "a": 0, "k": [128, 954, 0], "ix": 1 }, "s": { "a": 1, "k": [{ "i": { "x": [0.4, 0.4, 0.4], "y": [1, 1, 1] }, "o": { "x": [0.6, 0.6, 0.6], "y": [0, 0, 0] }, "t": 10, "s": [100, 100, 100] }, { "i": { "x": [0.4, 0.4, 0.4], "y": [1, 1, 1] }, "o": { "x": [0.6, 0.6, 0.6], "y": [0, 0, 0] }, "t": 47, "s": [105, 105, 100] }, { "i": { "x": [0.4, 0.4, 0.4], "y": [1, 1, 1] }, "o": { "x": [0.167, 0.167, 0.167], "y": [0, 0, 0] }, "t": 70, "s": [100, 100, 100] }, { "i": { "x": [0.4, 0.4, 0.4], "y": [1, 1, 1] }, "o": { "x": [0.167, 0.167, 0.167], "y": [0, 0, 0] }, "t": 89, "s": [100, 100, 100] }, { "i": { "x": [0.4, 0.4, 0.4], "y": [1, 1, 1] }, "o": { "x": [0.6, 0.6, 0.6], "y": [0, 0, 0] }, "t": 111, "s": [105, 105, 100] }, { "t": 140.587890625, "s": [100, 100, 100] }], "ix": 6 } }, "ao": 0, "w": 1080, "h": 1080, "ip": -12, "op": 284, "st": -12, "bm": 0 }], "markers": [] };
	
	        // Load Lottie animation
	        _lottieWeb2.default.loadAnimation({
	            container: document.getElementById('countdown-lottie-animation'),
	            renderer: 'svg',
	            loop: true,
	            autoplay: true,
	            animationData: animationData
	        });
	    }
	
	    // Initialize the countdown
	    function updateCountdown() {
	        var today = new Date();
	        var targetDate = new Date('March 10, 2025');
	
	        // Calculate the difference in time
	        var timeDiff = targetDate - today;
	
	        // Calculate days remaining
	        var daysRemaining = Math.ceil(timeDiff / (1000 * 60 * 60 * 24));
	
	        // Update the countdown element
	        $('[data-teaser-modal-countdown]').text(daysRemaining);
	    }
	
	    function getCookie(name) {
	        var value = "; " + document.cookie;
	        var parts = value.split("; " + name + "=");
	        if (parts.length === 2) return parts.pop().split(';').shift();
	    }
	
	    function setCookie(name, value, days) {
	        var date = new Date();
	        date.setTime(date.getTime() + days * 24 * 60 * 60 * 1000);
	        var expires = "expires=" + date.toUTCString();
	        document.cookie = name + "=" + value + ";" + expires + ";path=/";
	    }
	
	    var modalKey = 'teaser_modal_display_count';
	    var maxDisplayCount = parseInt($('#teaser-modal').data('counter'), 10);
	    var displayCount = parseInt(getCookie(modalKey) || '0', 10);
	
	    function showModal() {
	        $('#teaser-modal').show();
	    }
	
	    function closeModal() {
	        $('#teaser-modal').hide();
	    }
	
	    $('.teaser-close-button, .teaser-modal').on('click', function () {
	        closeModal();
	        if (displayCount < maxDisplayCount) {
	            displayCount++;
	            setCookie(modalKey, displayCount, 7); // Store in cookies for 7 days
	        }
	    });
	
	    // Prevent modal content clicks from closing the modal
	    $('.teaser-modal-content').click(function (event) {
	        event.stopPropagation();
	    });
	
	    // Show the modal automatically on page load if not shown max times
	    if (displayCount < maxDisplayCount) {
	        showModal();
	    }
	
	    // Initialize
	    updateCountdown();
	    initializeLottieAnimation();
	});
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(2)))

/***/ }),
/* 148 */
/***/ (function(module, exports, __webpack_require__) {

	(typeof navigator !== "undefined") && (function (global, factory) {
	   true ? module.exports = factory() :
	  typeof define === 'function' && define.amd ? define(factory) :
	  (global = typeof globalThis !== 'undefined' ? globalThis : global || self, global.lottie = factory());
	})(this, (function () { 'use strict';
	
	  var svgNS = 'http://www.w3.org/2000/svg';
	  var locationHref = '';
	  var _useWebWorker = false;
	  var initialDefaultFrame = -999999;
	
	  var setWebWorker = function setWebWorker(flag) {
	    _useWebWorker = !!flag;
	  };
	
	  var getWebWorker = function getWebWorker() {
	    return _useWebWorker;
	  };
	
	  var setLocationHref = function setLocationHref(value) {
	    locationHref = value;
	  };
	
	  var getLocationHref = function getLocationHref() {
	    return locationHref;
	  };
	
	  function createTag(type) {
	    // return {appendChild:function(){},setAttribute:function(){},style:{}}
	    return document.createElement(type);
	  }
	
	  function extendPrototype(sources, destination) {
	    var i;
	    var len = sources.length;
	    var sourcePrototype;
	
	    for (i = 0; i < len; i += 1) {
	      sourcePrototype = sources[i].prototype;
	
	      for (var attr in sourcePrototype) {
	        if (Object.prototype.hasOwnProperty.call(sourcePrototype, attr)) destination.prototype[attr] = sourcePrototype[attr];
	      }
	    }
	  }
	
	  function getDescriptor(object, prop) {
	    return Object.getOwnPropertyDescriptor(object, prop);
	  }
	
	  function createProxyFunction(prototype) {
	    function ProxyFunction() {}
	
	    ProxyFunction.prototype = prototype;
	    return ProxyFunction;
	  }
	
	  // import Howl from '../../3rd_party/howler';
	  var audioControllerFactory = function () {
	    function AudioController(audioFactory) {
	      this.audios = [];
	      this.audioFactory = audioFactory;
	      this._volume = 1;
	      this._isMuted = false;
	    }
	
	    AudioController.prototype = {
	      addAudio: function addAudio(audio) {
	        this.audios.push(audio);
	      },
	      pause: function pause() {
	        var i;
	        var len = this.audios.length;
	
	        for (i = 0; i < len; i += 1) {
	          this.audios[i].pause();
	        }
	      },
	      resume: function resume() {
	        var i;
	        var len = this.audios.length;
	
	        for (i = 0; i < len; i += 1) {
	          this.audios[i].resume();
	        }
	      },
	      setRate: function setRate(rateValue) {
	        var i;
	        var len = this.audios.length;
	
	        for (i = 0; i < len; i += 1) {
	          this.audios[i].setRate(rateValue);
	        }
	      },
	      createAudio: function createAudio(assetPath) {
	        if (this.audioFactory) {
	          return this.audioFactory(assetPath);
	        }
	
	        if (window.Howl) {
	          return new window.Howl({
	            src: [assetPath]
	          });
	        }
	
	        return {
	          isPlaying: false,
	          play: function play() {
	            this.isPlaying = true;
	          },
	          seek: function seek() {
	            this.isPlaying = false;
	          },
	          playing: function playing() {},
	          rate: function rate() {},
	          setVolume: function setVolume() {}
	        };
	      },
	      setAudioFactory: function setAudioFactory(audioFactory) {
	        this.audioFactory = audioFactory;
	      },
	      setVolume: function setVolume(value) {
	        this._volume = value;
	
	        this._updateVolume();
	      },
	      mute: function mute() {
	        this._isMuted = true;
	
	        this._updateVolume();
	      },
	      unmute: function unmute() {
	        this._isMuted = false;
	
	        this._updateVolume();
	      },
	      getVolume: function getVolume() {
	        return this._volume;
	      },
	      _updateVolume: function _updateVolume() {
	        var i;
	        var len = this.audios.length;
	
	        for (i = 0; i < len; i += 1) {
	          this.audios[i].volume(this._volume * (this._isMuted ? 0 : 1));
	        }
	      }
	    };
	    return function () {
	      return new AudioController();
	    };
	  }();
	
	  var createTypedArray = function () {
	    function createRegularArray(type, len) {
	      var i = 0;
	      var arr = [];
	      var value;
	
	      switch (type) {
	        case 'int16':
	        case 'uint8c':
	          value = 1;
	          break;
	
	        default:
	          value = 1.1;
	          break;
	      }
	
	      for (i = 0; i < len; i += 1) {
	        arr.push(value);
	      }
	
	      return arr;
	    }
	
	    function createTypedArrayFactory(type, len) {
	      if (type === 'float32') {
	        return new Float32Array(len);
	      }
	
	      if (type === 'int16') {
	        return new Int16Array(len);
	      }
	
	      if (type === 'uint8c') {
	        return new Uint8ClampedArray(len);
	      }
	
	      return createRegularArray(type, len);
	    }
	
	    if (typeof Uint8ClampedArray === 'function' && typeof Float32Array === 'function') {
	      return createTypedArrayFactory;
	    }
	
	    return createRegularArray;
	  }();
	
	  function createSizedArray(len) {
	    return Array.apply(null, {
	      length: len
	    });
	  }
	
	  function _typeof$6(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof$6 = function _typeof(obj) { return typeof obj; }; } else { _typeof$6 = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof$6(obj); }
	  var subframeEnabled = true;
	  var expressionsPlugin = null;
	  var expressionsInterfaces = null;
	  var idPrefix$1 = '';
	  var isSafari = /^((?!chrome|android).)*safari/i.test(navigator.userAgent);
	  var _shouldRoundValues = false;
	  var bmPow = Math.pow;
	  var bmSqrt = Math.sqrt;
	  var bmFloor = Math.floor;
	  var bmMax = Math.max;
	  var bmMin = Math.min;
	  var BMMath = {};
	
	  (function () {
	    var propertyNames = ['abs', 'acos', 'acosh', 'asin', 'asinh', 'atan', 'atanh', 'atan2', 'ceil', 'cbrt', 'expm1', 'clz32', 'cos', 'cosh', 'exp', 'floor', 'fround', 'hypot', 'imul', 'log', 'log1p', 'log2', 'log10', 'max', 'min', 'pow', 'random', 'round', 'sign', 'sin', 'sinh', 'sqrt', 'tan', 'tanh', 'trunc', 'E', 'LN10', 'LN2', 'LOG10E', 'LOG2E', 'PI', 'SQRT1_2', 'SQRT2'];
	    var i;
	    var len = propertyNames.length;
	
	    for (i = 0; i < len; i += 1) {
	      BMMath[propertyNames[i]] = Math[propertyNames[i]];
	    }
	  })();
	
	  function ProjectInterface$1() {
	    return {};
	  }
	
	  BMMath.random = Math.random;
	
	  BMMath.abs = function (val) {
	    var tOfVal = _typeof$6(val);
	
	    if (tOfVal === 'object' && val.length) {
	      var absArr = createSizedArray(val.length);
	      var i;
	      var len = val.length;
	
	      for (i = 0; i < len; i += 1) {
	        absArr[i] = Math.abs(val[i]);
	      }
	
	      return absArr;
	    }
	
	    return Math.abs(val);
	  };
	
	  var defaultCurveSegments = 150;
	  var degToRads = Math.PI / 180;
	  var roundCorner = 0.5519;
	
	  function roundValues(flag) {
	    _shouldRoundValues = !!flag;
	  }
	
	  function bmRnd(value) {
	    if (_shouldRoundValues) {
	      return Math.round(value);
	    }
	
	    return value;
	  }
	
	  function styleDiv(element) {
	    element.style.position = 'absolute';
	    element.style.top = 0;
	    element.style.left = 0;
	    element.style.display = 'block';
	    element.style.transformOrigin = '0 0';
	    element.style.webkitTransformOrigin = '0 0';
	    element.style.backfaceVisibility = 'visible';
	    element.style.webkitBackfaceVisibility = 'visible';
	    element.style.transformStyle = 'preserve-3d';
	    element.style.webkitTransformStyle = 'preserve-3d';
	    element.style.mozTransformStyle = 'preserve-3d';
	  }
	
	  function BMEnterFrameEvent(type, currentTime, totalTime, frameMultiplier) {
	    this.type = type;
	    this.currentTime = currentTime;
	    this.totalTime = totalTime;
	    this.direction = frameMultiplier < 0 ? -1 : 1;
	  }
	
	  function BMCompleteEvent(type, frameMultiplier) {
	    this.type = type;
	    this.direction = frameMultiplier < 0 ? -1 : 1;
	  }
	
	  function BMCompleteLoopEvent(type, totalLoops, currentLoop, frameMultiplier) {
	    this.type = type;
	    this.currentLoop = currentLoop;
	    this.totalLoops = totalLoops;
	    this.direction = frameMultiplier < 0 ? -1 : 1;
	  }
	
	  function BMSegmentStartEvent(type, firstFrame, totalFrames) {
	    this.type = type;
	    this.firstFrame = firstFrame;
	    this.totalFrames = totalFrames;
	  }
	
	  function BMDestroyEvent(type, target) {
	    this.type = type;
	    this.target = target;
	  }
	
	  function BMRenderFrameErrorEvent(nativeError, currentTime) {
	    this.type = 'renderFrameError';
	    this.nativeError = nativeError;
	    this.currentTime = currentTime;
	  }
	
	  function BMConfigErrorEvent(nativeError) {
	    this.type = 'configError';
	    this.nativeError = nativeError;
	  }
	
	  function BMAnimationConfigErrorEvent(type, nativeError) {
	    this.type = type;
	    this.nativeError = nativeError;
	  }
	
	  var createElementID = function () {
	    var _count = 0;
	    return function createID() {
	      _count += 1;
	      return idPrefix$1 + '__lottie_element_' + _count;
	    };
	  }();
	
	  function HSVtoRGB(h, s, v) {
	    var r;
	    var g;
	    var b;
	    var i;
	    var f;
	    var p;
	    var q;
	    var t;
	    i = Math.floor(h * 6);
	    f = h * 6 - i;
	    p = v * (1 - s);
	    q = v * (1 - f * s);
	    t = v * (1 - (1 - f) * s);
	
	    switch (i % 6) {
	      case 0:
	        r = v;
	        g = t;
	        b = p;
	        break;
	
	      case 1:
	        r = q;
	        g = v;
	        b = p;
	        break;
	
	      case 2:
	        r = p;
	        g = v;
	        b = t;
	        break;
	
	      case 3:
	        r = p;
	        g = q;
	        b = v;
	        break;
	
	      case 4:
	        r = t;
	        g = p;
	        b = v;
	        break;
	
	      case 5:
	        r = v;
	        g = p;
	        b = q;
	        break;
	
	      default:
	        break;
	    }
	
	    return [r, g, b];
	  }
	
	  function RGBtoHSV(r, g, b) {
	    var max = Math.max(r, g, b);
	    var min = Math.min(r, g, b);
	    var d = max - min;
	    var h;
	    var s = max === 0 ? 0 : d / max;
	    var v = max / 255;
	
	    switch (max) {
	      case min:
	        h = 0;
	        break;
	
	      case r:
	        h = g - b + d * (g < b ? 6 : 0);
	        h /= 6 * d;
	        break;
	
	      case g:
	        h = b - r + d * 2;
	        h /= 6 * d;
	        break;
	
	      case b:
	        h = r - g + d * 4;
	        h /= 6 * d;
	        break;
	
	      default:
	        break;
	    }
	
	    return [h, s, v];
	  }
	
	  function addSaturationToRGB(color, offset) {
	    var hsv = RGBtoHSV(color[0] * 255, color[1] * 255, color[2] * 255);
	    hsv[1] += offset;
	
	    if (hsv[1] > 1) {
	      hsv[1] = 1;
	    } else if (hsv[1] <= 0) {
	      hsv[1] = 0;
	    }
	
	    return HSVtoRGB(hsv[0], hsv[1], hsv[2]);
	  }
	
	  function addBrightnessToRGB(color, offset) {
	    var hsv = RGBtoHSV(color[0] * 255, color[1] * 255, color[2] * 255);
	    hsv[2] += offset;
	
	    if (hsv[2] > 1) {
	      hsv[2] = 1;
	    } else if (hsv[2] < 0) {
	      hsv[2] = 0;
	    }
	
	    return HSVtoRGB(hsv[0], hsv[1], hsv[2]);
	  }
	
	  function addHueToRGB(color, offset) {
	    var hsv = RGBtoHSV(color[0] * 255, color[1] * 255, color[2] * 255);
	    hsv[0] += offset / 360;
	
	    if (hsv[0] > 1) {
	      hsv[0] -= 1;
	    } else if (hsv[0] < 0) {
	      hsv[0] += 1;
	    }
	
	    return HSVtoRGB(hsv[0], hsv[1], hsv[2]);
	  }
	
	  var rgbToHex = function () {
	    var colorMap = [];
	    var i;
	    var hex;
	
	    for (i = 0; i < 256; i += 1) {
	      hex = i.toString(16);
	      colorMap[i] = hex.length === 1 ? '0' + hex : hex;
	    }
	
	    return function (r, g, b) {
	      if (r < 0) {
	        r = 0;
	      }
	
	      if (g < 0) {
	        g = 0;
	      }
	
	      if (b < 0) {
	        b = 0;
	      }
	
	      return '#' + colorMap[r] + colorMap[g] + colorMap[b];
	    };
	  }();
	
	  var setSubframeEnabled = function setSubframeEnabled(flag) {
	    subframeEnabled = !!flag;
	  };
	
	  var getSubframeEnabled = function getSubframeEnabled() {
	    return subframeEnabled;
	  };
	
	  var setExpressionsPlugin = function setExpressionsPlugin(value) {
	    expressionsPlugin = value;
	  };
	
	  var getExpressionsPlugin = function getExpressionsPlugin() {
	    return expressionsPlugin;
	  };
	
	  var setExpressionInterfaces = function setExpressionInterfaces(value) {
	    expressionsInterfaces = value;
	  };
	
	  var getExpressionInterfaces = function getExpressionInterfaces() {
	    return expressionsInterfaces;
	  };
	
	  var setDefaultCurveSegments = function setDefaultCurveSegments(value) {
	    defaultCurveSegments = value;
	  };
	
	  var getDefaultCurveSegments = function getDefaultCurveSegments() {
	    return defaultCurveSegments;
	  };
	
	  var setIdPrefix = function setIdPrefix(value) {
	    idPrefix$1 = value;
	  };
	
	  var getIdPrefix = function getIdPrefix() {
	    return idPrefix$1;
	  };
	
	  function createNS(type) {
	    // return {appendChild:function(){},setAttribute:function(){},style:{}}
	    return document.createElementNS(svgNS, type);
	  }
	
	  function _typeof$5(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof$5 = function _typeof(obj) { return typeof obj; }; } else { _typeof$5 = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof$5(obj); }
	
	  var dataManager = function () {
	    var _counterId = 1;
	    var processes = [];
	    var workerFn;
	    var workerInstance;
	    var workerProxy = {
	      onmessage: function onmessage() {},
	      postMessage: function postMessage(path) {
	        workerFn({
	          data: path
	        });
	      }
	    };
	    var _workerSelf = {
	      postMessage: function postMessage(data) {
	        workerProxy.onmessage({
	          data: data
	        });
	      }
	    };
	
	    function createWorker(fn) {
	      if (window.Worker && window.Blob && getWebWorker()) {
	        var blob = new Blob(['var _workerSelf = self; self.onmessage = ', fn.toString()], {
	          type: 'text/javascript'
	        }); // var blob = new Blob(['self.onmessage = ', fn.toString()], { type: 'text/javascript' });
	
	        var url = URL.createObjectURL(blob);
	        return new Worker(url);
	      }
	
	      workerFn = fn;
	      return workerProxy;
	    }
	
	    function setupWorker() {
	      if (!workerInstance) {
	        workerInstance = createWorker(function workerStart(e) {
	          function dataFunctionManager() {
	            function completeLayers(layers, comps) {
	              var layerData;
	              var i;
	              var len = layers.length;
	              var j;
	              var jLen;
	              var k;
	              var kLen;
	
	              for (i = 0; i < len; i += 1) {
	                layerData = layers[i];
	
	                if ('ks' in layerData && !layerData.completed) {
	                  layerData.completed = true;
	
	                  if (layerData.hasMask) {
	                    var maskProps = layerData.masksProperties;
	                    jLen = maskProps.length;
	
	                    for (j = 0; j < jLen; j += 1) {
	                      if (maskProps[j].pt.k.i) {
	                        convertPathsToAbsoluteValues(maskProps[j].pt.k);
	                      } else {
	                        kLen = maskProps[j].pt.k.length;
	
	                        for (k = 0; k < kLen; k += 1) {
	                          if (maskProps[j].pt.k[k].s) {
	                            convertPathsToAbsoluteValues(maskProps[j].pt.k[k].s[0]);
	                          }
	
	                          if (maskProps[j].pt.k[k].e) {
	                            convertPathsToAbsoluteValues(maskProps[j].pt.k[k].e[0]);
	                          }
	                        }
	                      }
	                    }
	                  }
	
	                  if (layerData.ty === 0) {
	                    layerData.layers = findCompLayers(layerData.refId, comps);
	                    completeLayers(layerData.layers, comps);
	                  } else if (layerData.ty === 4) {
	                    completeShapes(layerData.shapes);
	                  } else if (layerData.ty === 5) {
	                    completeText(layerData);
	                  }
	                }
	              }
	            }
	
	            function completeChars(chars, assets) {
	              if (chars) {
	                var i = 0;
	                var len = chars.length;
	
	                for (i = 0; i < len; i += 1) {
	                  if (chars[i].t === 1) {
	                    // var compData = findComp(chars[i].data.refId, assets);
	                    chars[i].data.layers = findCompLayers(chars[i].data.refId, assets); // chars[i].data.ip = 0;
	                    // chars[i].data.op = 99999;
	                    // chars[i].data.st = 0;
	                    // chars[i].data.sr = 1;
	                    // chars[i].w = compData.w;
	                    // chars[i].data.ks = {
	                    //   a: { k: [0, 0, 0], a: 0 },
	                    //   p: { k: [0, -compData.h, 0], a: 0 },
	                    //   r: { k: 0, a: 0 },
	                    //   s: { k: [100, 100], a: 0 },
	                    //   o: { k: 100, a: 0 },
	                    // };
	
	                    completeLayers(chars[i].data.layers, assets);
	                  }
	                }
	              }
	            }
	
	            function findComp(id, comps) {
	              var i = 0;
	              var len = comps.length;
	
	              while (i < len) {
	                if (comps[i].id === id) {
	                  return comps[i];
	                }
	
	                i += 1;
	              }
	
	              return null;
	            }
	
	            function findCompLayers(id, comps) {
	              var comp = findComp(id, comps);
	
	              if (comp) {
	                if (!comp.layers.__used) {
	                  comp.layers.__used = true;
	                  return comp.layers;
	                }
	
	                return JSON.parse(JSON.stringify(comp.layers));
	              }
	
	              return null;
	            }
	
	            function completeShapes(arr) {
	              var i;
	              var len = arr.length;
	              var j;
	              var jLen;
	
	              for (i = len - 1; i >= 0; i -= 1) {
	                if (arr[i].ty === 'sh') {
	                  if (arr[i].ks.k.i) {
	                    convertPathsToAbsoluteValues(arr[i].ks.k);
	                  } else {
	                    jLen = arr[i].ks.k.length;
	
	                    for (j = 0; j < jLen; j += 1) {
	                      if (arr[i].ks.k[j].s) {
	                        convertPathsToAbsoluteValues(arr[i].ks.k[j].s[0]);
	                      }
	
	                      if (arr[i].ks.k[j].e) {
	                        convertPathsToAbsoluteValues(arr[i].ks.k[j].e[0]);
	                      }
	                    }
	                  }
	                } else if (arr[i].ty === 'gr') {
	                  completeShapes(arr[i].it);
	                }
	              }
	            }
	
	            function convertPathsToAbsoluteValues(path) {
	              var i;
	              var len = path.i.length;
	
	              for (i = 0; i < len; i += 1) {
	                path.i[i][0] += path.v[i][0];
	                path.i[i][1] += path.v[i][1];
	                path.o[i][0] += path.v[i][0];
	                path.o[i][1] += path.v[i][1];
	              }
	            }
	
	            function checkVersion(minimum, animVersionString) {
	              var animVersion = animVersionString ? animVersionString.split('.') : [100, 100, 100];
	
	              if (minimum[0] > animVersion[0]) {
	                return true;
	              }
	
	              if (animVersion[0] > minimum[0]) {
	                return false;
	              }
	
	              if (minimum[1] > animVersion[1]) {
	                return true;
	              }
	
	              if (animVersion[1] > minimum[1]) {
	                return false;
	              }
	
	              if (minimum[2] > animVersion[2]) {
	                return true;
	              }
	
	              if (animVersion[2] > minimum[2]) {
	                return false;
	              }
	
	              return null;
	            }
	
	            var checkText = function () {
	              var minimumVersion = [4, 4, 14];
	
	              function updateTextLayer(textLayer) {
	                var documentData = textLayer.t.d;
	                textLayer.t.d = {
	                  k: [{
	                    s: documentData,
	                    t: 0
	                  }]
	                };
	              }
	
	              function iterateLayers(layers) {
	                var i;
	                var len = layers.length;
	
	                for (i = 0; i < len; i += 1) {
	                  if (layers[i].ty === 5) {
	                    updateTextLayer(layers[i]);
	                  }
	                }
	              }
	
	              return function (animationData) {
	                if (checkVersion(minimumVersion, animationData.v)) {
	                  iterateLayers(animationData.layers);
	
	                  if (animationData.assets) {
	                    var i;
	                    var len = animationData.assets.length;
	
	                    for (i = 0; i < len; i += 1) {
	                      if (animationData.assets[i].layers) {
	                        iterateLayers(animationData.assets[i].layers);
	                      }
	                    }
	                  }
	                }
	              };
	            }();
	
	            var checkChars = function () {
	              var minimumVersion = [4, 7, 99];
	              return function (animationData) {
	                if (animationData.chars && !checkVersion(minimumVersion, animationData.v)) {
	                  var i;
	                  var len = animationData.chars.length;
	
	                  for (i = 0; i < len; i += 1) {
	                    var charData = animationData.chars[i];
	
	                    if (charData.data && charData.data.shapes) {
	                      completeShapes(charData.data.shapes);
	                      charData.data.ip = 0;
	                      charData.data.op = 99999;
	                      charData.data.st = 0;
	                      charData.data.sr = 1;
	                      charData.data.ks = {
	                        p: {
	                          k: [0, 0],
	                          a: 0
	                        },
	                        s: {
	                          k: [100, 100],
	                          a: 0
	                        },
	                        a: {
	                          k: [0, 0],
	                          a: 0
	                        },
	                        r: {
	                          k: 0,
	                          a: 0
	                        },
	                        o: {
	                          k: 100,
	                          a: 0
	                        }
	                      };
	
	                      if (!animationData.chars[i].t) {
	                        charData.data.shapes.push({
	                          ty: 'no'
	                        });
	                        charData.data.shapes[0].it.push({
	                          p: {
	                            k: [0, 0],
	                            a: 0
	                          },
	                          s: {
	                            k: [100, 100],
	                            a: 0
	                          },
	                          a: {
	                            k: [0, 0],
	                            a: 0
	                          },
	                          r: {
	                            k: 0,
	                            a: 0
	                          },
	                          o: {
	                            k: 100,
	                            a: 0
	                          },
	                          sk: {
	                            k: 0,
	                            a: 0
	                          },
	                          sa: {
	                            k: 0,
	                            a: 0
	                          },
	                          ty: 'tr'
	                        });
	                      }
	                    }
	                  }
	                }
	              };
	            }();
	
	            var checkPathProperties = function () {
	              var minimumVersion = [5, 7, 15];
	
	              function updateTextLayer(textLayer) {
	                var pathData = textLayer.t.p;
	
	                if (typeof pathData.a === 'number') {
	                  pathData.a = {
	                    a: 0,
	                    k: pathData.a
	                  };
	                }
	
	                if (typeof pathData.p === 'number') {
	                  pathData.p = {
	                    a: 0,
	                    k: pathData.p
	                  };
	                }
	
	                if (typeof pathData.r === 'number') {
	                  pathData.r = {
	                    a: 0,
	                    k: pathData.r
	                  };
	                }
	              }
	
	              function iterateLayers(layers) {
	                var i;
	                var len = layers.length;
	
	                for (i = 0; i < len; i += 1) {
	                  if (layers[i].ty === 5) {
	                    updateTextLayer(layers[i]);
	                  }
	                }
	              }
	
	              return function (animationData) {
	                if (checkVersion(minimumVersion, animationData.v)) {
	                  iterateLayers(animationData.layers);
	
	                  if (animationData.assets) {
	                    var i;
	                    var len = animationData.assets.length;
	
	                    for (i = 0; i < len; i += 1) {
	                      if (animationData.assets[i].layers) {
	                        iterateLayers(animationData.assets[i].layers);
	                      }
	                    }
	                  }
	                }
	              };
	            }();
	
	            var checkColors = function () {
	              var minimumVersion = [4, 1, 9];
	
	              function iterateShapes(shapes) {
	                var i;
	                var len = shapes.length;
	                var j;
	                var jLen;
	
	                for (i = 0; i < len; i += 1) {
	                  if (shapes[i].ty === 'gr') {
	                    iterateShapes(shapes[i].it);
	                  } else if (shapes[i].ty === 'fl' || shapes[i].ty === 'st') {
	                    if (shapes[i].c.k && shapes[i].c.k[0].i) {
	                      jLen = shapes[i].c.k.length;
	
	                      for (j = 0; j < jLen; j += 1) {
	                        if (shapes[i].c.k[j].s) {
	                          shapes[i].c.k[j].s[0] /= 255;
	                          shapes[i].c.k[j].s[1] /= 255;
	                          shapes[i].c.k[j].s[2] /= 255;
	                          shapes[i].c.k[j].s[3] /= 255;
	                        }
	
	                        if (shapes[i].c.k[j].e) {
	                          shapes[i].c.k[j].e[0] /= 255;
	                          shapes[i].c.k[j].e[1] /= 255;
	                          shapes[i].c.k[j].e[2] /= 255;
	                          shapes[i].c.k[j].e[3] /= 255;
	                        }
	                      }
	                    } else {
	                      shapes[i].c.k[0] /= 255;
	                      shapes[i].c.k[1] /= 255;
	                      shapes[i].c.k[2] /= 255;
	                      shapes[i].c.k[3] /= 255;
	                    }
	                  }
	                }
	              }
	
	              function iterateLayers(layers) {
	                var i;
	                var len = layers.length;
	
	                for (i = 0; i < len; i += 1) {
	                  if (layers[i].ty === 4) {
	                    iterateShapes(layers[i].shapes);
	                  }
	                }
	              }
	
	              return function (animationData) {
	                if (checkVersion(minimumVersion, animationData.v)) {
	                  iterateLayers(animationData.layers);
	
	                  if (animationData.assets) {
	                    var i;
	                    var len = animationData.assets.length;
	
	                    for (i = 0; i < len; i += 1) {
	                      if (animationData.assets[i].layers) {
	                        iterateLayers(animationData.assets[i].layers);
	                      }
	                    }
	                  }
	                }
	              };
	            }();
	
	            var checkShapes = function () {
	              var minimumVersion = [4, 4, 18];
	
	              function completeClosingShapes(arr) {
	                var i;
	                var len = arr.length;
	                var j;
	                var jLen;
	
	                for (i = len - 1; i >= 0; i -= 1) {
	                  if (arr[i].ty === 'sh') {
	                    if (arr[i].ks.k.i) {
	                      arr[i].ks.k.c = arr[i].closed;
	                    } else {
	                      jLen = arr[i].ks.k.length;
	
	                      for (j = 0; j < jLen; j += 1) {
	                        if (arr[i].ks.k[j].s) {
	                          arr[i].ks.k[j].s[0].c = arr[i].closed;
	                        }
	
	                        if (arr[i].ks.k[j].e) {
	                          arr[i].ks.k[j].e[0].c = arr[i].closed;
	                        }
	                      }
	                    }
	                  } else if (arr[i].ty === 'gr') {
	                    completeClosingShapes(arr[i].it);
	                  }
	                }
	              }
	
	              function iterateLayers(layers) {
	                var layerData;
	                var i;
	                var len = layers.length;
	                var j;
	                var jLen;
	                var k;
	                var kLen;
	
	                for (i = 0; i < len; i += 1) {
	                  layerData = layers[i];
	
	                  if (layerData.hasMask) {
	                    var maskProps = layerData.masksProperties;
	                    jLen = maskProps.length;
	
	                    for (j = 0; j < jLen; j += 1) {
	                      if (maskProps[j].pt.k.i) {
	                        maskProps[j].pt.k.c = maskProps[j].cl;
	                      } else {
	                        kLen = maskProps[j].pt.k.length;
	
	                        for (k = 0; k < kLen; k += 1) {
	                          if (maskProps[j].pt.k[k].s) {
	                            maskProps[j].pt.k[k].s[0].c = maskProps[j].cl;
	                          }
	
	                          if (maskProps[j].pt.k[k].e) {
	                            maskProps[j].pt.k[k].e[0].c = maskProps[j].cl;
	                          }
	                        }
	                      }
	                    }
	                  }
	
	                  if (layerData.ty === 4) {
	                    completeClosingShapes(layerData.shapes);
	                  }
	                }
	              }
	
	              return function (animationData) {
	                if (checkVersion(minimumVersion, animationData.v)) {
	                  iterateLayers(animationData.layers);
	
	                  if (animationData.assets) {
	                    var i;
	                    var len = animationData.assets.length;
	
	                    for (i = 0; i < len; i += 1) {
	                      if (animationData.assets[i].layers) {
	                        iterateLayers(animationData.assets[i].layers);
	                      }
	                    }
	                  }
	                }
	              };
	            }();
	
	            function completeData(animationData) {
	              if (animationData.__complete) {
	                return;
	              }
	
	              checkColors(animationData);
	              checkText(animationData);
	              checkChars(animationData);
	              checkPathProperties(animationData);
	              checkShapes(animationData);
	              completeLayers(animationData.layers, animationData.assets);
	              completeChars(animationData.chars, animationData.assets);
	              animationData.__complete = true;
	            }
	
	            function completeText(data) {
	              if (data.t.a.length === 0 && !('m' in data.t.p)) {// data.singleShape = true;
	              }
	            }
	
	            var moduleOb = {};
	            moduleOb.completeData = completeData;
	            moduleOb.checkColors = checkColors;
	            moduleOb.checkChars = checkChars;
	            moduleOb.checkPathProperties = checkPathProperties;
	            moduleOb.checkShapes = checkShapes;
	            moduleOb.completeLayers = completeLayers;
	            return moduleOb;
	          }
	
	          if (!_workerSelf.dataManager) {
	            _workerSelf.dataManager = dataFunctionManager();
	          }
	
	          if (!_workerSelf.assetLoader) {
	            _workerSelf.assetLoader = function () {
	              function formatResponse(xhr) {
	                // using typeof doubles the time of execution of this method,
	                // so if available, it's better to use the header to validate the type
	                var contentTypeHeader = xhr.getResponseHeader('content-type');
	
	                if (contentTypeHeader && xhr.responseType === 'json' && contentTypeHeader.indexOf('json') !== -1) {
	                  return xhr.response;
	                }
	
	                if (xhr.response && _typeof$5(xhr.response) === 'object') {
	                  return xhr.response;
	                }
	
	                if (xhr.response && typeof xhr.response === 'string') {
	                  return JSON.parse(xhr.response);
	                }
	
	                if (xhr.responseText) {
	                  return JSON.parse(xhr.responseText);
	                }
	
	                return null;
	              }
	
	              function loadAsset(path, fullPath, callback, errorCallback) {
	                var response;
	                var xhr = new XMLHttpRequest(); // set responseType after calling open or IE will break.
	
	                try {
	                  // This crashes on Android WebView prior to KitKat
	                  xhr.responseType = 'json';
	                } catch (err) {} // eslint-disable-line no-empty
	
	
	                xhr.onreadystatechange = function () {
	                  if (xhr.readyState === 4) {
	                    if (xhr.status === 200) {
	                      response = formatResponse(xhr);
	                      callback(response);
	                    } else {
	                      try {
	                        response = formatResponse(xhr);
	                        callback(response);
	                      } catch (err) {
	                        if (errorCallback) {
	                          errorCallback(err);
	                        }
	                      }
	                    }
	                  }
	                };
	
	                try {
	                  // Hack to workaround banner validation
	                  xhr.open(['G', 'E', 'T'].join(''), path, true);
	                } catch (error) {
	                  // Hack to workaround banner validation
	                  xhr.open(['G', 'E', 'T'].join(''), fullPath + '/' + path, true);
	                }
	
	                xhr.send();
	              }
	
	              return {
	                load: loadAsset
	              };
	            }();
	          }
	
	          if (e.data.type === 'loadAnimation') {
	            _workerSelf.assetLoader.load(e.data.path, e.data.fullPath, function (data) {
	              _workerSelf.dataManager.completeData(data);
	
	              _workerSelf.postMessage({
	                id: e.data.id,
	                payload: data,
	                status: 'success'
	              });
	            }, function () {
	              _workerSelf.postMessage({
	                id: e.data.id,
	                status: 'error'
	              });
	            });
	          } else if (e.data.type === 'complete') {
	            var animation = e.data.animation;
	
	            _workerSelf.dataManager.completeData(animation);
	
	            _workerSelf.postMessage({
	              id: e.data.id,
	              payload: animation,
	              status: 'success'
	            });
	          } else if (e.data.type === 'loadData') {
	            _workerSelf.assetLoader.load(e.data.path, e.data.fullPath, function (data) {
	              _workerSelf.postMessage({
	                id: e.data.id,
	                payload: data,
	                status: 'success'
	              });
	            }, function () {
	              _workerSelf.postMessage({
	                id: e.data.id,
	                status: 'error'
	              });
	            });
	          }
	        });
	
	        workerInstance.onmessage = function (event) {
	          var data = event.data;
	          var id = data.id;
	          var process = processes[id];
	          processes[id] = null;
	
	          if (data.status === 'success') {
	            process.onComplete(data.payload);
	          } else if (process.onError) {
	            process.onError();
	          }
	        };
	      }
	    }
	
	    function createProcess(onComplete, onError) {
	      _counterId += 1;
	      var id = 'processId_' + _counterId;
	      processes[id] = {
	        onComplete: onComplete,
	        onError: onError
	      };
	      return id;
	    }
	
	    function loadAnimation(path, onComplete, onError) {
	      setupWorker();
	      var processId = createProcess(onComplete, onError);
	      workerInstance.postMessage({
	        type: 'loadAnimation',
	        path: path,
	        fullPath: window.location.origin + window.location.pathname,
	        id: processId
	      });
	    }
	
	    function loadData(path, onComplete, onError) {
	      setupWorker();
	      var processId = createProcess(onComplete, onError);
	      workerInstance.postMessage({
	        type: 'loadData',
	        path: path,
	        fullPath: window.location.origin + window.location.pathname,
	        id: processId
	      });
	    }
	
	    function completeAnimation(anim, onComplete, onError) {
	      setupWorker();
	      var processId = createProcess(onComplete, onError);
	      workerInstance.postMessage({
	        type: 'complete',
	        animation: anim,
	        id: processId
	      });
	    }
	
	    return {
	      loadAnimation: loadAnimation,
	      loadData: loadData,
	      completeAnimation: completeAnimation
	    };
	  }();
	
	  var ImagePreloader = function () {
	    var proxyImage = function () {
	      var canvas = createTag('canvas');
	      canvas.width = 1;
	      canvas.height = 1;
	      var ctx = canvas.getContext('2d');
	      ctx.fillStyle = 'rgba(0,0,0,0)';
	      ctx.fillRect(0, 0, 1, 1);
	      return canvas;
	    }();
	
	    function imageLoaded() {
	      this.loadedAssets += 1;
	
	      if (this.loadedAssets === this.totalImages && this.loadedFootagesCount === this.totalFootages) {
	        if (this.imagesLoadedCb) {
	          this.imagesLoadedCb(null);
	        }
	      }
	    }
	
	    function footageLoaded() {
	      this.loadedFootagesCount += 1;
	
	      if (this.loadedAssets === this.totalImages && this.loadedFootagesCount === this.totalFootages) {
	        if (this.imagesLoadedCb) {
	          this.imagesLoadedCb(null);
	        }
	      }
	    }
	
	    function getAssetsPath(assetData, assetsPath, originalPath) {
	      var path = '';
	
	      if (assetData.e) {
	        path = assetData.p;
	      } else if (assetsPath) {
	        var imagePath = assetData.p;
	
	        if (imagePath.indexOf('images/') !== -1) {
	          imagePath = imagePath.split('/')[1];
	        }
	
	        path = assetsPath + imagePath;
	      } else {
	        path = originalPath;
	        path += assetData.u ? assetData.u : '';
	        path += assetData.p;
	      }
	
	      return path;
	    }
	
	    function testImageLoaded(img) {
	      var _count = 0;
	      var intervalId = setInterval(function () {
	        var box = img.getBBox();
	
	        if (box.width || _count > 500) {
	          this._imageLoaded();
	
	          clearInterval(intervalId);
	        }
	
	        _count += 1;
	      }.bind(this), 50);
	    }
	
	    function createImageData(assetData) {
	      var path = getAssetsPath(assetData, this.assetsPath, this.path);
	      var img = createNS('image');
	
	      if (isSafari) {
	        this.testImageLoaded(img);
	      } else {
	        img.addEventListener('load', this._imageLoaded, false);
	      }
	
	      img.addEventListener('error', function () {
	        ob.img = proxyImage;
	
	        this._imageLoaded();
	      }.bind(this), false);
	      img.setAttributeNS('http://www.w3.org/1999/xlink', 'href', path);
	
	      if (this._elementHelper.append) {
	        this._elementHelper.append(img);
	      } else {
	        this._elementHelper.appendChild(img);
	      }
	
	      var ob = {
	        img: img,
	        assetData: assetData
	      };
	      return ob;
	    }
	
	    function createImgData(assetData) {
	      var path = getAssetsPath(assetData, this.assetsPath, this.path);
	      var img = createTag('img');
	      img.crossOrigin = 'anonymous';
	      img.addEventListener('load', this._imageLoaded, false);
	      img.addEventListener('error', function () {
	        ob.img = proxyImage;
	
	        this._imageLoaded();
	      }.bind(this), false);
	      img.src = path;
	      var ob = {
	        img: img,
	        assetData: assetData
	      };
	      return ob;
	    }
	
	    function createFootageData(data) {
	      var ob = {
	        assetData: data
	      };
	      var path = getAssetsPath(data, this.assetsPath, this.path);
	      dataManager.loadData(path, function (footageData) {
	        ob.img = footageData;
	
	        this._footageLoaded();
	      }.bind(this), function () {
	        ob.img = {};
	
	        this._footageLoaded();
	      }.bind(this));
	      return ob;
	    }
	
	    function loadAssets(assets, cb) {
	      this.imagesLoadedCb = cb;
	      var i;
	      var len = assets.length;
	
	      for (i = 0; i < len; i += 1) {
	        if (!assets[i].layers) {
	          if (!assets[i].t || assets[i].t === 'seq') {
	            this.totalImages += 1;
	            this.images.push(this._createImageData(assets[i]));
	          } else if (assets[i].t === 3) {
	            this.totalFootages += 1;
	            this.images.push(this.createFootageData(assets[i]));
	          }
	        }
	      }
	    }
	
	    function setPath(path) {
	      this.path = path || '';
	    }
	
	    function setAssetsPath(path) {
	      this.assetsPath = path || '';
	    }
	
	    function getAsset(assetData) {
	      var i = 0;
	      var len = this.images.length;
	
	      while (i < len) {
	        if (this.images[i].assetData === assetData) {
	          return this.images[i].img;
	        }
	
	        i += 1;
	      }
	
	      return null;
	    }
	
	    function destroy() {
	      this.imagesLoadedCb = null;
	      this.images.length = 0;
	    }
	
	    function loadedImages() {
	      return this.totalImages === this.loadedAssets;
	    }
	
	    function loadedFootages() {
	      return this.totalFootages === this.loadedFootagesCount;
	    }
	
	    function setCacheType(type, elementHelper) {
	      if (type === 'svg') {
	        this._elementHelper = elementHelper;
	        this._createImageData = this.createImageData.bind(this);
	      } else {
	        this._createImageData = this.createImgData.bind(this);
	      }
	    }
	
	    function ImagePreloaderFactory() {
	      this._imageLoaded = imageLoaded.bind(this);
	      this._footageLoaded = footageLoaded.bind(this);
	      this.testImageLoaded = testImageLoaded.bind(this);
	      this.createFootageData = createFootageData.bind(this);
	      this.assetsPath = '';
	      this.path = '';
	      this.totalImages = 0;
	      this.totalFootages = 0;
	      this.loadedAssets = 0;
	      this.loadedFootagesCount = 0;
	      this.imagesLoadedCb = null;
	      this.images = [];
	    }
	
	    ImagePreloaderFactory.prototype = {
	      loadAssets: loadAssets,
	      setAssetsPath: setAssetsPath,
	      setPath: setPath,
	      loadedImages: loadedImages,
	      loadedFootages: loadedFootages,
	      destroy: destroy,
	      getAsset: getAsset,
	      createImgData: createImgData,
	      createImageData: createImageData,
	      imageLoaded: imageLoaded,
	      footageLoaded: footageLoaded,
	      setCacheType: setCacheType
	    };
	    return ImagePreloaderFactory;
	  }();
	
	  function BaseEvent() {}
	
	  BaseEvent.prototype = {
	    triggerEvent: function triggerEvent(eventName, args) {
	      if (this._cbs[eventName]) {
	        var callbacks = this._cbs[eventName];
	
	        for (var i = 0; i < callbacks.length; i += 1) {
	          callbacks[i](args);
	        }
	      }
	    },
	    addEventListener: function addEventListener(eventName, callback) {
	      if (!this._cbs[eventName]) {
	        this._cbs[eventName] = [];
	      }
	
	      this._cbs[eventName].push(callback);
	
	      return function () {
	        this.removeEventListener(eventName, callback);
	      }.bind(this);
	    },
	    removeEventListener: function removeEventListener(eventName, callback) {
	      if (!callback) {
	        this._cbs[eventName] = null;
	      } else if (this._cbs[eventName]) {
	        var i = 0;
	        var len = this._cbs[eventName].length;
	
	        while (i < len) {
	          if (this._cbs[eventName][i] === callback) {
	            this._cbs[eventName].splice(i, 1);
	
	            i -= 1;
	            len -= 1;
	          }
	
	          i += 1;
	        }
	
	        if (!this._cbs[eventName].length) {
	          this._cbs[eventName] = null;
	        }
	      }
	    }
	  };
	
	  var markerParser = function () {
	    function parsePayloadLines(payload) {
	      var lines = payload.split('\r\n');
	      var keys = {};
	      var line;
	      var keysCount = 0;
	
	      for (var i = 0; i < lines.length; i += 1) {
	        line = lines[i].split(':');
	
	        if (line.length === 2) {
	          keys[line[0]] = line[1].trim();
	          keysCount += 1;
	        }
	      }
	
	      if (keysCount === 0) {
	        throw new Error();
	      }
	
	      return keys;
	    }
	
	    return function (_markers) {
	      var markers = [];
	
	      for (var i = 0; i < _markers.length; i += 1) {
	        var _marker = _markers[i];
	        var markerData = {
	          time: _marker.tm,
	          duration: _marker.dr
	        };
	
	        try {
	          markerData.payload = JSON.parse(_markers[i].cm);
	        } catch (_) {
	          try {
	            markerData.payload = parsePayloadLines(_markers[i].cm);
	          } catch (__) {
	            markerData.payload = {
	              name: _markers[i].cm
	            };
	          }
	        }
	
	        markers.push(markerData);
	      }
	
	      return markers;
	    };
	  }();
	
	  var ProjectInterface = function () {
	    function registerComposition(comp) {
	      this.compositions.push(comp);
	    }
	
	    return function () {
	      function _thisProjectFunction(name) {
	        var i = 0;
	        var len = this.compositions.length;
	
	        while (i < len) {
	          if (this.compositions[i].data && this.compositions[i].data.nm === name) {
	            if (this.compositions[i].prepareFrame && this.compositions[i].data.xt) {
	              this.compositions[i].prepareFrame(this.currentFrame);
	            }
	
	            return this.compositions[i].compInterface;
	          }
	
	          i += 1;
	        }
	
	        return null;
	      }
	
	      _thisProjectFunction.compositions = [];
	      _thisProjectFunction.currentFrame = 0;
	      _thisProjectFunction.registerComposition = registerComposition;
	      return _thisProjectFunction;
	    };
	  }();
	
	  var renderers = {};
	
	  var registerRenderer = function registerRenderer(key, value) {
	    renderers[key] = value;
	  };
	
	  function getRenderer(key) {
	    return renderers[key];
	  }
	
	  function getRegisteredRenderer() {
	    // Returns canvas by default for compatibility
	    if (renderers.canvas) {
	      return 'canvas';
	    } // Returns any renderer that is registered
	
	
	    for (var key in renderers) {
	      if (renderers[key]) {
	        return key;
	      }
	    }
	
	    return '';
	  }
	
	  function _typeof$4(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof$4 = function _typeof(obj) { return typeof obj; }; } else { _typeof$4 = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof$4(obj); }
	
	  var AnimationItem = function AnimationItem() {
	    this._cbs = [];
	    this.name = '';
	    this.path = '';
	    this.isLoaded = false;
	    this.currentFrame = 0;
	    this.currentRawFrame = 0;
	    this.firstFrame = 0;
	    this.totalFrames = 0;
	    this.frameRate = 0;
	    this.frameMult = 0;
	    this.playSpeed = 1;
	    this.playDirection = 1;
	    this.playCount = 0;
	    this.animationData = {};
	    this.assets = [];
	    this.isPaused = true;
	    this.autoplay = false;
	    this.loop = true;
	    this.renderer = null;
	    this.animationID = createElementID();
	    this.assetsPath = '';
	    this.timeCompleted = 0;
	    this.segmentPos = 0;
	    this.isSubframeEnabled = getSubframeEnabled();
	    this.segments = [];
	    this._idle = true;
	    this._completedLoop = false;
	    this.projectInterface = ProjectInterface();
	    this.imagePreloader = new ImagePreloader();
	    this.audioController = audioControllerFactory();
	    this.markers = [];
	    this.configAnimation = this.configAnimation.bind(this);
	    this.onSetupError = this.onSetupError.bind(this);
	    this.onSegmentComplete = this.onSegmentComplete.bind(this);
	    this.drawnFrameEvent = new BMEnterFrameEvent('drawnFrame', 0, 0, 0);
	    this.expressionsPlugin = getExpressionsPlugin();
	  };
	
	  extendPrototype([BaseEvent], AnimationItem);
	
	  AnimationItem.prototype.setParams = function (params) {
	    if (params.wrapper || params.container) {
	      this.wrapper = params.wrapper || params.container;
	    }
	
	    var animType = 'svg';
	
	    if (params.animType) {
	      animType = params.animType;
	    } else if (params.renderer) {
	      animType = params.renderer;
	    }
	
	    var RendererClass = getRenderer(animType);
	    this.renderer = new RendererClass(this, params.rendererSettings);
	    this.imagePreloader.setCacheType(animType, this.renderer.globalData.defs);
	    this.renderer.setProjectInterface(this.projectInterface);
	    this.animType = animType;
	
	    if (params.loop === '' || params.loop === null || params.loop === undefined || params.loop === true) {
	      this.loop = true;
	    } else if (params.loop === false) {
	      this.loop = false;
	    } else {
	      this.loop = parseInt(params.loop, 10);
	    }
	
	    this.autoplay = 'autoplay' in params ? params.autoplay : true;
	    this.name = params.name ? params.name : '';
	    this.autoloadSegments = Object.prototype.hasOwnProperty.call(params, 'autoloadSegments') ? params.autoloadSegments : true;
	    this.assetsPath = params.assetsPath;
	    this.initialSegment = params.initialSegment;
	
	    if (params.audioFactory) {
	      this.audioController.setAudioFactory(params.audioFactory);
	    }
	
	    if (params.animationData) {
	      this.setupAnimation(params.animationData);
	    } else if (params.path) {
	      if (params.path.lastIndexOf('\\') !== -1) {
	        this.path = params.path.substr(0, params.path.lastIndexOf('\\') + 1);
	      } else {
	        this.path = params.path.substr(0, params.path.lastIndexOf('/') + 1);
	      }
	
	      this.fileName = params.path.substr(params.path.lastIndexOf('/') + 1);
	      this.fileName = this.fileName.substr(0, this.fileName.lastIndexOf('.json'));
	      dataManager.loadAnimation(params.path, this.configAnimation, this.onSetupError);
	    }
	  };
	
	  AnimationItem.prototype.onSetupError = function () {
	    this.trigger('data_failed');
	  };
	
	  AnimationItem.prototype.setupAnimation = function (data) {
	    dataManager.completeAnimation(data, this.configAnimation);
	  };
	
	  AnimationItem.prototype.setData = function (wrapper, animationData) {
	    if (animationData) {
	      if (_typeof$4(animationData) !== 'object') {
	        animationData = JSON.parse(animationData);
	      }
	    }
	
	    var params = {
	      wrapper: wrapper,
	      animationData: animationData
	    };
	    var wrapperAttributes = wrapper.attributes;
	    params.path = wrapperAttributes.getNamedItem('data-animation-path') // eslint-disable-line no-nested-ternary
	    ? wrapperAttributes.getNamedItem('data-animation-path').value : wrapperAttributes.getNamedItem('data-bm-path') // eslint-disable-line no-nested-ternary
	    ? wrapperAttributes.getNamedItem('data-bm-path').value : wrapperAttributes.getNamedItem('bm-path') ? wrapperAttributes.getNamedItem('bm-path').value : '';
	    params.animType = wrapperAttributes.getNamedItem('data-anim-type') // eslint-disable-line no-nested-ternary
	    ? wrapperAttributes.getNamedItem('data-anim-type').value : wrapperAttributes.getNamedItem('data-bm-type') // eslint-disable-line no-nested-ternary
	    ? wrapperAttributes.getNamedItem('data-bm-type').value : wrapperAttributes.getNamedItem('bm-type') // eslint-disable-line no-nested-ternary
	    ? wrapperAttributes.getNamedItem('bm-type').value : wrapperAttributes.getNamedItem('data-bm-renderer') // eslint-disable-line no-nested-ternary
	    ? wrapperAttributes.getNamedItem('data-bm-renderer').value : wrapperAttributes.getNamedItem('bm-renderer') ? wrapperAttributes.getNamedItem('bm-renderer').value : getRegisteredRenderer() || 'canvas';
	    var loop = wrapperAttributes.getNamedItem('data-anim-loop') // eslint-disable-line no-nested-ternary
	    ? wrapperAttributes.getNamedItem('data-anim-loop').value : wrapperAttributes.getNamedItem('data-bm-loop') // eslint-disable-line no-nested-ternary
	    ? wrapperAttributes.getNamedItem('data-bm-loop').value : wrapperAttributes.getNamedItem('bm-loop') ? wrapperAttributes.getNamedItem('bm-loop').value : '';
	
	    if (loop === 'false') {
	      params.loop = false;
	    } else if (loop === 'true') {
	      params.loop = true;
	    } else if (loop !== '') {
	      params.loop = parseInt(loop, 10);
	    }
	
	    var autoplay = wrapperAttributes.getNamedItem('data-anim-autoplay') // eslint-disable-line no-nested-ternary
	    ? wrapperAttributes.getNamedItem('data-anim-autoplay').value : wrapperAttributes.getNamedItem('data-bm-autoplay') // eslint-disable-line no-nested-ternary
	    ? wrapperAttributes.getNamedItem('data-bm-autoplay').value : wrapperAttributes.getNamedItem('bm-autoplay') ? wrapperAttributes.getNamedItem('bm-autoplay').value : true;
	    params.autoplay = autoplay !== 'false';
	    params.name = wrapperAttributes.getNamedItem('data-name') // eslint-disable-line no-nested-ternary
	    ? wrapperAttributes.getNamedItem('data-name').value : wrapperAttributes.getNamedItem('data-bm-name') // eslint-disable-line no-nested-ternary
	    ? wrapperAttributes.getNamedItem('data-bm-name').value : wrapperAttributes.getNamedItem('bm-name') ? wrapperAttributes.getNamedItem('bm-name').value : '';
	    var prerender = wrapperAttributes.getNamedItem('data-anim-prerender') // eslint-disable-line no-nested-ternary
	    ? wrapperAttributes.getNamedItem('data-anim-prerender').value : wrapperAttributes.getNamedItem('data-bm-prerender') // eslint-disable-line no-nested-ternary
	    ? wrapperAttributes.getNamedItem('data-bm-prerender').value : wrapperAttributes.getNamedItem('bm-prerender') ? wrapperAttributes.getNamedItem('bm-prerender').value : '';
	
	    if (prerender === 'false') {
	      params.prerender = false;
	    }
	
	    if (!params.path) {
	      this.trigger('destroy');
	    } else {
	      this.setParams(params);
	    }
	  };
	
	  AnimationItem.prototype.includeLayers = function (data) {
	    if (data.op > this.animationData.op) {
	      this.animationData.op = data.op;
	      this.totalFrames = Math.floor(data.op - this.animationData.ip);
	    }
	
	    var layers = this.animationData.layers;
	    var i;
	    var len = layers.length;
	    var newLayers = data.layers;
	    var j;
	    var jLen = newLayers.length;
	
	    for (j = 0; j < jLen; j += 1) {
	      i = 0;
	
	      while (i < len) {
	        if (layers[i].id === newLayers[j].id) {
	          layers[i] = newLayers[j];
	          break;
	        }
	
	        i += 1;
	      }
	    }
	
	    if (data.chars || data.fonts) {
	      this.renderer.globalData.fontManager.addChars(data.chars);
	      this.renderer.globalData.fontManager.addFonts(data.fonts, this.renderer.globalData.defs);
	    }
	
	    if (data.assets) {
	      len = data.assets.length;
	
	      for (i = 0; i < len; i += 1) {
	        this.animationData.assets.push(data.assets[i]);
	      }
	    }
	
	    this.animationData.__complete = false;
	    dataManager.completeAnimation(this.animationData, this.onSegmentComplete);
	  };
	
	  AnimationItem.prototype.onSegmentComplete = function (data) {
	    this.animationData = data;
	    var expressionsPlugin = getExpressionsPlugin();
	
	    if (expressionsPlugin) {
	      expressionsPlugin.initExpressions(this);
	    }
	
	    this.loadNextSegment();
	  };
	
	  AnimationItem.prototype.loadNextSegment = function () {
	    var segments = this.animationData.segments;
	
	    if (!segments || segments.length === 0 || !this.autoloadSegments) {
	      this.trigger('data_ready');
	      this.timeCompleted = this.totalFrames;
	      return;
	    }
	
	    var segment = segments.shift();
	    this.timeCompleted = segment.time * this.frameRate;
	    var segmentPath = this.path + this.fileName + '_' + this.segmentPos + '.json';
	    this.segmentPos += 1;
	    dataManager.loadData(segmentPath, this.includeLayers.bind(this), function () {
	      this.trigger('data_failed');
	    }.bind(this));
	  };
	
	  AnimationItem.prototype.loadSegments = function () {
	    var segments = this.animationData.segments;
	
	    if (!segments) {
	      this.timeCompleted = this.totalFrames;
	    }
	
	    this.loadNextSegment();
	  };
	
	  AnimationItem.prototype.imagesLoaded = function () {
	    this.trigger('loaded_images');
	    this.checkLoaded();
	  };
	
	  AnimationItem.prototype.preloadImages = function () {
	    this.imagePreloader.setAssetsPath(this.assetsPath);
	    this.imagePreloader.setPath(this.path);
	    this.imagePreloader.loadAssets(this.animationData.assets, this.imagesLoaded.bind(this));
	  };
	
	  AnimationItem.prototype.configAnimation = function (animData) {
	    if (!this.renderer) {
	      return;
	    }
	
	    try {
	      this.animationData = animData;
	
	      if (this.initialSegment) {
	        this.totalFrames = Math.floor(this.initialSegment[1] - this.initialSegment[0]);
	        this.firstFrame = Math.round(this.initialSegment[0]);
	      } else {
	        this.totalFrames = Math.floor(this.animationData.op - this.animationData.ip);
	        this.firstFrame = Math.round(this.animationData.ip);
	      }
	
	      this.renderer.configAnimation(animData);
	
	      if (!animData.assets) {
	        animData.assets = [];
	      }
	
	      this.assets = this.animationData.assets;
	      this.frameRate = this.animationData.fr;
	      this.frameMult = this.animationData.fr / 1000;
	      this.renderer.searchExtraCompositions(animData.assets);
	      this.markers = markerParser(animData.markers || []);
	      this.trigger('config_ready');
	      this.preloadImages();
	      this.loadSegments();
	      this.updaFrameModifier();
	      this.waitForFontsLoaded();
	
	      if (this.isPaused) {
	        this.audioController.pause();
	      }
	    } catch (error) {
	      this.triggerConfigError(error);
	    }
	  };
	
	  AnimationItem.prototype.waitForFontsLoaded = function () {
	    if (!this.renderer) {
	      return;
	    }
	
	    if (this.renderer.globalData.fontManager.isLoaded) {
	      this.checkLoaded();
	    } else {
	      setTimeout(this.waitForFontsLoaded.bind(this), 20);
	    }
	  };
	
	  AnimationItem.prototype.checkLoaded = function () {
	    if (!this.isLoaded && this.renderer.globalData.fontManager.isLoaded && (this.imagePreloader.loadedImages() || this.renderer.rendererType !== 'canvas') && this.imagePreloader.loadedFootages()) {
	      this.isLoaded = true;
	      var expressionsPlugin = getExpressionsPlugin();
	
	      if (expressionsPlugin) {
	        expressionsPlugin.initExpressions(this);
	      }
	
	      this.renderer.initItems();
	      setTimeout(function () {
	        this.trigger('DOMLoaded');
	      }.bind(this), 0);
	      this.gotoFrame();
	
	      if (this.autoplay) {
	        this.play();
	      }
	    }
	  };
	
	  AnimationItem.prototype.resize = function (width, height) {
	    // Adding this validation for backwards compatibility in case an event object was being passed down
	    var _width = typeof width === 'number' ? width : undefined;
	
	    var _height = typeof height === 'number' ? height : undefined;
	
	    this.renderer.updateContainerSize(_width, _height);
	  };
	
	  AnimationItem.prototype.setSubframe = function (flag) {
	    this.isSubframeEnabled = !!flag;
	  };
	
	  AnimationItem.prototype.gotoFrame = function () {
	    this.currentFrame = this.isSubframeEnabled ? this.currentRawFrame : ~~this.currentRawFrame; // eslint-disable-line no-bitwise
	
	    if (this.timeCompleted !== this.totalFrames && this.currentFrame > this.timeCompleted) {
	      this.currentFrame = this.timeCompleted;
	    }
	
	    this.trigger('enterFrame');
	    this.renderFrame();
	    this.trigger('drawnFrame');
	  };
	
	  AnimationItem.prototype.renderFrame = function () {
	    if (this.isLoaded === false || !this.renderer) {
	      return;
	    }
	
	    try {
	      if (this.expressionsPlugin) {
	        this.expressionsPlugin.resetFrame();
	      }
	
	      this.renderer.renderFrame(this.currentFrame + this.firstFrame);
	    } catch (error) {
	      this.triggerRenderFrameError(error);
	    }
	  };
	
	  AnimationItem.prototype.play = function (name) {
	    if (name && this.name !== name) {
	      return;
	    }
	
	    if (this.isPaused === true) {
	      this.isPaused = false;
	      this.trigger('_play');
	      this.audioController.resume();
	
	      if (this._idle) {
	        this._idle = false;
	        this.trigger('_active');
	      }
	    }
	  };
	
	  AnimationItem.prototype.pause = function (name) {
	    if (name && this.name !== name) {
	      return;
	    }
	
	    if (this.isPaused === false) {
	      this.isPaused = true;
	      this.trigger('_pause');
	      this._idle = true;
	      this.trigger('_idle');
	      this.audioController.pause();
	    }
	  };
	
	  AnimationItem.prototype.togglePause = function (name) {
	    if (name && this.name !== name) {
	      return;
	    }
	
	    if (this.isPaused === true) {
	      this.play();
	    } else {
	      this.pause();
	    }
	  };
	
	  AnimationItem.prototype.stop = function (name) {
	    if (name && this.name !== name) {
	      return;
	    }
	
	    this.pause();
	    this.playCount = 0;
	    this._completedLoop = false;
	    this.setCurrentRawFrameValue(0);
	  };
	
	  AnimationItem.prototype.getMarkerData = function (markerName) {
	    var marker;
	
	    for (var i = 0; i < this.markers.length; i += 1) {
	      marker = this.markers[i];
	
	      if (marker.payload && marker.payload.name === markerName) {
	        return marker;
	      }
	    }
	
	    return null;
	  };
	
	  AnimationItem.prototype.goToAndStop = function (value, isFrame, name) {
	    if (name && this.name !== name) {
	      return;
	    }
	
	    var numValue = Number(value);
	
	    if (isNaN(numValue)) {
	      var marker = this.getMarkerData(value);
	
	      if (marker) {
	        this.goToAndStop(marker.time, true);
	      }
	    } else if (isFrame) {
	      this.setCurrentRawFrameValue(value);
	    } else {
	      this.setCurrentRawFrameValue(value * this.frameModifier);
	    }
	
	    this.pause();
	  };
	
	  AnimationItem.prototype.goToAndPlay = function (value, isFrame, name) {
	    if (name && this.name !== name) {
	      return;
	    }
	
	    var numValue = Number(value);
	
	    if (isNaN(numValue)) {
	      var marker = this.getMarkerData(value);
	
	      if (marker) {
	        if (!marker.duration) {
	          this.goToAndStop(marker.time, true);
	        } else {
	          this.playSegments([marker.time, marker.time + marker.duration], true);
	        }
	      }
	    } else {
	      this.goToAndStop(numValue, isFrame, name);
	    }
	
	    this.play();
	  };
	
	  AnimationItem.prototype.advanceTime = function (value) {
	    if (this.isPaused === true || this.isLoaded === false) {
	      return;
	    }
	
	    var nextValue = this.currentRawFrame + value * this.frameModifier;
	    var _isComplete = false; // Checking if nextValue > totalFrames - 1 for addressing non looping and looping animations.
	    // If animation won't loop, it should stop at totalFrames - 1. If it will loop it should complete the last frame and then loop.
	
	    if (nextValue >= this.totalFrames - 1 && this.frameModifier > 0) {
	      if (!this.loop || this.playCount === this.loop) {
	        if (!this.checkSegments(nextValue > this.totalFrames ? nextValue % this.totalFrames : 0)) {
	          _isComplete = true;
	          nextValue = this.totalFrames - 1;
	        }
	      } else if (nextValue >= this.totalFrames) {
	        this.playCount += 1;
	
	        if (!this.checkSegments(nextValue % this.totalFrames)) {
	          this.setCurrentRawFrameValue(nextValue % this.totalFrames);
	          this._completedLoop = true;
	          this.trigger('loopComplete');
	        }
	      } else {
	        this.setCurrentRawFrameValue(nextValue);
	      }
	    } else if (nextValue < 0) {
	      if (!this.checkSegments(nextValue % this.totalFrames)) {
	        if (this.loop && !(this.playCount-- <= 0 && this.loop !== true)) {
	          // eslint-disable-line no-plusplus
	          this.setCurrentRawFrameValue(this.totalFrames + nextValue % this.totalFrames);
	
	          if (!this._completedLoop) {
	            this._completedLoop = true;
	          } else {
	            this.trigger('loopComplete');
	          }
	        } else {
	          _isComplete = true;
	          nextValue = 0;
	        }
	      }
	    } else {
	      this.setCurrentRawFrameValue(nextValue);
	    }
	
	    if (_isComplete) {
	      this.setCurrentRawFrameValue(nextValue);
	      this.pause();
	      this.trigger('complete');
	    }
	  };
	
	  AnimationItem.prototype.adjustSegment = function (arr, offset) {
	    this.playCount = 0;
	
	    if (arr[1] < arr[0]) {
	      if (this.frameModifier > 0) {
	        if (this.playSpeed < 0) {
	          this.setSpeed(-this.playSpeed);
	        } else {
	          this.setDirection(-1);
	        }
	      }
	
	      this.totalFrames = arr[0] - arr[1];
	      this.timeCompleted = this.totalFrames;
	      this.firstFrame = arr[1];
	      this.setCurrentRawFrameValue(this.totalFrames - 0.001 - offset);
	    } else if (arr[1] > arr[0]) {
	      if (this.frameModifier < 0) {
	        if (this.playSpeed < 0) {
	          this.setSpeed(-this.playSpeed);
	        } else {
	          this.setDirection(1);
	        }
	      }
	
	      this.totalFrames = arr[1] - arr[0];
	      this.timeCompleted = this.totalFrames;
	      this.firstFrame = arr[0];
	      this.setCurrentRawFrameValue(0.001 + offset);
	    }
	
	    this.trigger('segmentStart');
	  };
	
	  AnimationItem.prototype.setSegment = function (init, end) {
	    var pendingFrame = -1;
	
	    if (this.isPaused) {
	      if (this.currentRawFrame + this.firstFrame < init) {
	        pendingFrame = init;
	      } else if (this.currentRawFrame + this.firstFrame > end) {
	        pendingFrame = end - init;
	      }
	    }
	
	    this.firstFrame = init;
	    this.totalFrames = end - init;
	    this.timeCompleted = this.totalFrames;
	
	    if (pendingFrame !== -1) {
	      this.goToAndStop(pendingFrame, true);
	    }
	  };
	
	  AnimationItem.prototype.playSegments = function (arr, forceFlag) {
	    if (forceFlag) {
	      this.segments.length = 0;
	    }
	
	    if (_typeof$4(arr[0]) === 'object') {
	      var i;
	      var len = arr.length;
	
	      for (i = 0; i < len; i += 1) {
	        this.segments.push(arr[i]);
	      }
	    } else {
	      this.segments.push(arr);
	    }
	
	    if (this.segments.length && forceFlag) {
	      this.adjustSegment(this.segments.shift(), 0);
	    }
	
	    if (this.isPaused) {
	      this.play();
	    }
	  };
	
	  AnimationItem.prototype.resetSegments = function (forceFlag) {
	    this.segments.length = 0;
	    this.segments.push([this.animationData.ip, this.animationData.op]);
	
	    if (forceFlag) {
	      this.checkSegments(0);
	    }
	  };
	
	  AnimationItem.prototype.checkSegments = function (offset) {
	    if (this.segments.length) {
	      this.adjustSegment(this.segments.shift(), offset);
	      return true;
	    }
	
	    return false;
	  };
	
	  AnimationItem.prototype.destroy = function (name) {
	    if (name && this.name !== name || !this.renderer) {
	      return;
	    }
	
	    this.renderer.destroy();
	    this.imagePreloader.destroy();
	    this.trigger('destroy');
	    this._cbs = null;
	    this.onEnterFrame = null;
	    this.onLoopComplete = null;
	    this.onComplete = null;
	    this.onSegmentStart = null;
	    this.onDestroy = null;
	    this.renderer = null;
	    this.expressionsPlugin = null;
	    this.imagePreloader = null;
	    this.projectInterface = null;
	  };
	
	  AnimationItem.prototype.setCurrentRawFrameValue = function (value) {
	    this.currentRawFrame = value;
	    this.gotoFrame();
	  };
	
	  AnimationItem.prototype.setSpeed = function (val) {
	    this.playSpeed = val;
	    this.updaFrameModifier();
	  };
	
	  AnimationItem.prototype.setDirection = function (val) {
	    this.playDirection = val < 0 ? -1 : 1;
	    this.updaFrameModifier();
	  };
	
	  AnimationItem.prototype.setLoop = function (isLooping) {
	    this.loop = isLooping;
	  };
	
	  AnimationItem.prototype.setVolume = function (val, name) {
	    if (name && this.name !== name) {
	      return;
	    }
	
	    this.audioController.setVolume(val);
	  };
	
	  AnimationItem.prototype.getVolume = function () {
	    return this.audioController.getVolume();
	  };
	
	  AnimationItem.prototype.mute = function (name) {
	    if (name && this.name !== name) {
	      return;
	    }
	
	    this.audioController.mute();
	  };
	
	  AnimationItem.prototype.unmute = function (name) {
	    if (name && this.name !== name) {
	      return;
	    }
	
	    this.audioController.unmute();
	  };
	
	  AnimationItem.prototype.updaFrameModifier = function () {
	    this.frameModifier = this.frameMult * this.playSpeed * this.playDirection;
	    this.audioController.setRate(this.playSpeed * this.playDirection);
	  };
	
	  AnimationItem.prototype.getPath = function () {
	    return this.path;
	  };
	
	  AnimationItem.prototype.getAssetsPath = function (assetData) {
	    var path = '';
	
	    if (assetData.e) {
	      path = assetData.p;
	    } else if (this.assetsPath) {
	      var imagePath = assetData.p;
	
	      if (imagePath.indexOf('images/') !== -1) {
	        imagePath = imagePath.split('/')[1];
	      }
	
	      path = this.assetsPath + imagePath;
	    } else {
	      path = this.path;
	      path += assetData.u ? assetData.u : '';
	      path += assetData.p;
	    }
	
	    return path;
	  };
	
	  AnimationItem.prototype.getAssetData = function (id) {
	    var i = 0;
	    var len = this.assets.length;
	
	    while (i < len) {
	      if (id === this.assets[i].id) {
	        return this.assets[i];
	      }
	
	      i += 1;
	    }
	
	    return null;
	  };
	
	  AnimationItem.prototype.hide = function () {
	    this.renderer.hide();
	  };
	
	  AnimationItem.prototype.show = function () {
	    this.renderer.show();
	  };
	
	  AnimationItem.prototype.getDuration = function (isFrame) {
	    return isFrame ? this.totalFrames : this.totalFrames / this.frameRate;
	  };
	
	  AnimationItem.prototype.updateDocumentData = function (path, documentData, index) {
	    try {
	      var element = this.renderer.getElementByPath(path);
	      element.updateDocumentData(documentData, index);
	    } catch (error) {// TODO: decide how to handle catch case
	    }
	  };
	
	  AnimationItem.prototype.trigger = function (name) {
	    if (this._cbs && this._cbs[name]) {
	      switch (name) {
	        case 'enterFrame':
	          this.triggerEvent(name, new BMEnterFrameEvent(name, this.currentFrame, this.totalFrames, this.frameModifier));
	          break;
	
	        case 'drawnFrame':
	          this.drawnFrameEvent.currentTime = this.currentFrame;
	          this.drawnFrameEvent.totalTime = this.totalFrames;
	          this.drawnFrameEvent.direction = this.frameModifier;
	          this.triggerEvent(name, this.drawnFrameEvent);
	          break;
	
	        case 'loopComplete':
	          this.triggerEvent(name, new BMCompleteLoopEvent(name, this.loop, this.playCount, this.frameMult));
	          break;
	
	        case 'complete':
	          this.triggerEvent(name, new BMCompleteEvent(name, this.frameMult));
	          break;
	
	        case 'segmentStart':
	          this.triggerEvent(name, new BMSegmentStartEvent(name, this.firstFrame, this.totalFrames));
	          break;
	
	        case 'destroy':
	          this.triggerEvent(name, new BMDestroyEvent(name, this));
	          break;
	
	        default:
	          this.triggerEvent(name);
	      }
	    }
	
	    if (name === 'enterFrame' && this.onEnterFrame) {
	      this.onEnterFrame.call(this, new BMEnterFrameEvent(name, this.currentFrame, this.totalFrames, this.frameMult));
	    }
	
	    if (name === 'loopComplete' && this.onLoopComplete) {
	      this.onLoopComplete.call(this, new BMCompleteLoopEvent(name, this.loop, this.playCount, this.frameMult));
	    }
	
	    if (name === 'complete' && this.onComplete) {
	      this.onComplete.call(this, new BMCompleteEvent(name, this.frameMult));
	    }
	
	    if (name === 'segmentStart' && this.onSegmentStart) {
	      this.onSegmentStart.call(this, new BMSegmentStartEvent(name, this.firstFrame, this.totalFrames));
	    }
	
	    if (name === 'destroy' && this.onDestroy) {
	      this.onDestroy.call(this, new BMDestroyEvent(name, this));
	    }
	  };
	
	  AnimationItem.prototype.triggerRenderFrameError = function (nativeError) {
	    var error = new BMRenderFrameErrorEvent(nativeError, this.currentFrame);
	    this.triggerEvent('error', error);
	
	    if (this.onError) {
	      this.onError.call(this, error);
	    }
	  };
	
	  AnimationItem.prototype.triggerConfigError = function (nativeError) {
	    var error = new BMConfigErrorEvent(nativeError, this.currentFrame);
	    this.triggerEvent('error', error);
	
	    if (this.onError) {
	      this.onError.call(this, error);
	    }
	  };
	
	  var animationManager = function () {
	    var moduleOb = {};
	    var registeredAnimations = [];
	    var initTime = 0;
	    var len = 0;
	    var playingAnimationsNum = 0;
	    var _stopped = true;
	    var _isFrozen = false;
	
	    function removeElement(ev) {
	      var i = 0;
	      var animItem = ev.target;
	
	      while (i < len) {
	        if (registeredAnimations[i].animation === animItem) {
	          registeredAnimations.splice(i, 1);
	          i -= 1;
	          len -= 1;
	
	          if (!animItem.isPaused) {
	            subtractPlayingCount();
	          }
	        }
	
	        i += 1;
	      }
	    }
	
	    function registerAnimation(element, animationData) {
	      if (!element) {
	        return null;
	      }
	
	      var i = 0;
	
	      while (i < len) {
	        if (registeredAnimations[i].elem === element && registeredAnimations[i].elem !== null) {
	          return registeredAnimations[i].animation;
	        }
	
	        i += 1;
	      }
	
	      var animItem = new AnimationItem();
	      setupAnimation(animItem, element);
	      animItem.setData(element, animationData);
	      return animItem;
	    }
	
	    function getRegisteredAnimations() {
	      var i;
	      var lenAnims = registeredAnimations.length;
	      var animations = [];
	
	      for (i = 0; i < lenAnims; i += 1) {
	        animations.push(registeredAnimations[i].animation);
	      }
	
	      return animations;
	    }
	
	    function addPlayingCount() {
	      playingAnimationsNum += 1;
	      activate();
	    }
	
	    function subtractPlayingCount() {
	      playingAnimationsNum -= 1;
	    }
	
	    function setupAnimation(animItem, element) {
	      animItem.addEventListener('destroy', removeElement);
	      animItem.addEventListener('_active', addPlayingCount);
	      animItem.addEventListener('_idle', subtractPlayingCount);
	      registeredAnimations.push({
	        elem: element,
	        animation: animItem
	      });
	      len += 1;
	    }
	
	    function loadAnimation(params) {
	      var animItem = new AnimationItem();
	      setupAnimation(animItem, null);
	      animItem.setParams(params);
	      return animItem;
	    }
	
	    function setSpeed(val, animation) {
	      var i;
	
	      for (i = 0; i < len; i += 1) {
	        registeredAnimations[i].animation.setSpeed(val, animation);
	      }
	    }
	
	    function setDirection(val, animation) {
	      var i;
	
	      for (i = 0; i < len; i += 1) {
	        registeredAnimations[i].animation.setDirection(val, animation);
	      }
	    }
	
	    function play(animation) {
	      var i;
	
	      for (i = 0; i < len; i += 1) {
	        registeredAnimations[i].animation.play(animation);
	      }
	    }
	
	    function resume(nowTime) {
	      var elapsedTime = nowTime - initTime;
	      var i;
	
	      for (i = 0; i < len; i += 1) {
	        registeredAnimations[i].animation.advanceTime(elapsedTime);
	      }
	
	      initTime = nowTime;
	
	      if (playingAnimationsNum && !_isFrozen) {
	        window.requestAnimationFrame(resume);
	      } else {
	        _stopped = true;
	      }
	    }
	
	    function first(nowTime) {
	      initTime = nowTime;
	      window.requestAnimationFrame(resume);
	    }
	
	    function pause(animation) {
	      var i;
	
	      for (i = 0; i < len; i += 1) {
	        registeredAnimations[i].animation.pause(animation);
	      }
	    }
	
	    function goToAndStop(value, isFrame, animation) {
	      var i;
	
	      for (i = 0; i < len; i += 1) {
	        registeredAnimations[i].animation.goToAndStop(value, isFrame, animation);
	      }
	    }
	
	    function stop(animation) {
	      var i;
	
	      for (i = 0; i < len; i += 1) {
	        registeredAnimations[i].animation.stop(animation);
	      }
	    }
	
	    function togglePause(animation) {
	      var i;
	
	      for (i = 0; i < len; i += 1) {
	        registeredAnimations[i].animation.togglePause(animation);
	      }
	    }
	
	    function destroy(animation) {
	      var i;
	
	      for (i = len - 1; i >= 0; i -= 1) {
	        registeredAnimations[i].animation.destroy(animation);
	      }
	    }
	
	    function searchAnimations(animationData, standalone, renderer) {
	      var animElements = [].concat([].slice.call(document.getElementsByClassName('lottie')), [].slice.call(document.getElementsByClassName('bodymovin')));
	      var i;
	      var lenAnims = animElements.length;
	
	      for (i = 0; i < lenAnims; i += 1) {
	        if (renderer) {
	          animElements[i].setAttribute('data-bm-type', renderer);
	        }
	
	        registerAnimation(animElements[i], animationData);
	      }
	
	      if (standalone && lenAnims === 0) {
	        if (!renderer) {
	          renderer = 'svg';
	        }
	
	        var body = document.getElementsByTagName('body')[0];
	        body.innerText = '';
	        var div = createTag('div');
	        div.style.width = '100%';
	        div.style.height = '100%';
	        div.setAttribute('data-bm-type', renderer);
	        body.appendChild(div);
	        registerAnimation(div, animationData);
	      }
	    }
	
	    function resize() {
	      var i;
	
	      for (i = 0; i < len; i += 1) {
	        registeredAnimations[i].animation.resize();
	      }
	    }
	
	    function activate() {
	      if (!_isFrozen && playingAnimationsNum) {
	        if (_stopped) {
	          window.requestAnimationFrame(first);
	          _stopped = false;
	        }
	      }
	    }
	
	    function freeze() {
	      _isFrozen = true;
	    }
	
	    function unfreeze() {
	      _isFrozen = false;
	      activate();
	    }
	
	    function setVolume(val, animation) {
	      var i;
	
	      for (i = 0; i < len; i += 1) {
	        registeredAnimations[i].animation.setVolume(val, animation);
	      }
	    }
	
	    function mute(animation) {
	      var i;
	
	      for (i = 0; i < len; i += 1) {
	        registeredAnimations[i].animation.mute(animation);
	      }
	    }
	
	    function unmute(animation) {
	      var i;
	
	      for (i = 0; i < len; i += 1) {
	        registeredAnimations[i].animation.unmute(animation);
	      }
	    }
	
	    moduleOb.registerAnimation = registerAnimation;
	    moduleOb.loadAnimation = loadAnimation;
	    moduleOb.setSpeed = setSpeed;
	    moduleOb.setDirection = setDirection;
	    moduleOb.play = play;
	    moduleOb.pause = pause;
	    moduleOb.stop = stop;
	    moduleOb.togglePause = togglePause;
	    moduleOb.searchAnimations = searchAnimations;
	    moduleOb.resize = resize; // moduleOb.start = start;
	
	    moduleOb.goToAndStop = goToAndStop;
	    moduleOb.destroy = destroy;
	    moduleOb.freeze = freeze;
	    moduleOb.unfreeze = unfreeze;
	    moduleOb.setVolume = setVolume;
	    moduleOb.mute = mute;
	    moduleOb.unmute = unmute;
	    moduleOb.getRegisteredAnimations = getRegisteredAnimations;
	    return moduleOb;
	  }();
	
	  /* eslint-disable */
	  var BezierFactory = function () {
	    /**
	       * BezierEasing - use bezier curve for transition easing function
	       * by Gaëtan Renaudeau 2014 - 2015 – MIT License
	       *
	       * Credits: is based on Firefox's nsSMILKeySpline.cpp
	       * Usage:
	       * var spline = BezierEasing([ 0.25, 0.1, 0.25, 1.0 ])
	       * spline.get(x) => returns the easing value | x must be in [0, 1] range
	       *
	       */
	    var ob = {};
	    ob.getBezierEasing = getBezierEasing;
	    var beziers = {};
	
	    function getBezierEasing(a, b, c, d, nm) {
	      var str = nm || ('bez_' + a + '_' + b + '_' + c + '_' + d).replace(/\./g, 'p');
	
	      if (beziers[str]) {
	        return beziers[str];
	      }
	
	      var bezEasing = new BezierEasing([a, b, c, d]);
	      beziers[str] = bezEasing;
	      return bezEasing;
	    } // These values are established by empiricism with tests (tradeoff: performance VS precision)
	
	
	    var NEWTON_ITERATIONS = 4;
	    var NEWTON_MIN_SLOPE = 0.001;
	    var SUBDIVISION_PRECISION = 0.0000001;
	    var SUBDIVISION_MAX_ITERATIONS = 10;
	    var kSplineTableSize = 11;
	    var kSampleStepSize = 1.0 / (kSplineTableSize - 1.0);
	    var float32ArraySupported = typeof Float32Array === 'function';
	
	    function A(aA1, aA2) {
	      return 1.0 - 3.0 * aA2 + 3.0 * aA1;
	    }
	
	    function B(aA1, aA2) {
	      return 3.0 * aA2 - 6.0 * aA1;
	    }
	
	    function C(aA1) {
	      return 3.0 * aA1;
	    } // Returns x(t) given t, x1, and x2, or y(t) given t, y1, and y2.
	
	
	    function calcBezier(aT, aA1, aA2) {
	      return ((A(aA1, aA2) * aT + B(aA1, aA2)) * aT + C(aA1)) * aT;
	    } // Returns dx/dt given t, x1, and x2, or dy/dt given t, y1, and y2.
	
	
	    function getSlope(aT, aA1, aA2) {
	      return 3.0 * A(aA1, aA2) * aT * aT + 2.0 * B(aA1, aA2) * aT + C(aA1);
	    }
	
	    function binarySubdivide(aX, aA, aB, mX1, mX2) {
	      var currentX,
	          currentT,
	          i = 0;
	
	      do {
	        currentT = aA + (aB - aA) / 2.0;
	        currentX = calcBezier(currentT, mX1, mX2) - aX;
	
	        if (currentX > 0.0) {
	          aB = currentT;
	        } else {
	          aA = currentT;
	        }
	      } while (Math.abs(currentX) > SUBDIVISION_PRECISION && ++i < SUBDIVISION_MAX_ITERATIONS);
	
	      return currentT;
	    }
	
	    function newtonRaphsonIterate(aX, aGuessT, mX1, mX2) {
	      for (var i = 0; i < NEWTON_ITERATIONS; ++i) {
	        var currentSlope = getSlope(aGuessT, mX1, mX2);
	        if (currentSlope === 0.0) return aGuessT;
	        var currentX = calcBezier(aGuessT, mX1, mX2) - aX;
	        aGuessT -= currentX / currentSlope;
	      }
	
	      return aGuessT;
	    }
	    /**
	       * points is an array of [ mX1, mY1, mX2, mY2 ]
	       */
	
	
	    function BezierEasing(points) {
	      this._p = points;
	      this._mSampleValues = float32ArraySupported ? new Float32Array(kSplineTableSize) : new Array(kSplineTableSize);
	      this._precomputed = false;
	      this.get = this.get.bind(this);
	    }
	
	    BezierEasing.prototype = {
	      get: function get(x) {
	        var mX1 = this._p[0],
	            mY1 = this._p[1],
	            mX2 = this._p[2],
	            mY2 = this._p[3];
	        if (!this._precomputed) this._precompute();
	        if (mX1 === mY1 && mX2 === mY2) return x; // linear
	        // Because JavaScript number are imprecise, we should guarantee the extremes are right.
	
	        if (x === 0) return 0;
	        if (x === 1) return 1;
	        return calcBezier(this._getTForX(x), mY1, mY2);
	      },
	      // Private part
	      _precompute: function _precompute() {
	        var mX1 = this._p[0],
	            mY1 = this._p[1],
	            mX2 = this._p[2],
	            mY2 = this._p[3];
	        this._precomputed = true;
	
	        if (mX1 !== mY1 || mX2 !== mY2) {
	          this._calcSampleValues();
	        }
	      },
	      _calcSampleValues: function _calcSampleValues() {
	        var mX1 = this._p[0],
	            mX2 = this._p[2];
	
	        for (var i = 0; i < kSplineTableSize; ++i) {
	          this._mSampleValues[i] = calcBezier(i * kSampleStepSize, mX1, mX2);
	        }
	      },
	
	      /**
	           * getTForX chose the fastest heuristic to determine the percentage value precisely from a given X projection.
	           */
	      _getTForX: function _getTForX(aX) {
	        var mX1 = this._p[0],
	            mX2 = this._p[2],
	            mSampleValues = this._mSampleValues;
	        var intervalStart = 0.0;
	        var currentSample = 1;
	        var lastSample = kSplineTableSize - 1;
	
	        for (; currentSample !== lastSample && mSampleValues[currentSample] <= aX; ++currentSample) {
	          intervalStart += kSampleStepSize;
	        }
	
	        --currentSample; // Interpolate to provide an initial guess for t
	
	        var dist = (aX - mSampleValues[currentSample]) / (mSampleValues[currentSample + 1] - mSampleValues[currentSample]);
	        var guessForT = intervalStart + dist * kSampleStepSize;
	        var initialSlope = getSlope(guessForT, mX1, mX2);
	
	        if (initialSlope >= NEWTON_MIN_SLOPE) {
	          return newtonRaphsonIterate(aX, guessForT, mX1, mX2);
	        }
	
	        if (initialSlope === 0.0) {
	          return guessForT;
	        }
	
	        return binarySubdivide(aX, intervalStart, intervalStart + kSampleStepSize, mX1, mX2);
	      }
	    };
	    return ob;
	  }();
	
	  var pooling = function () {
	    function _double(arr) {
	      return arr.concat(createSizedArray(arr.length));
	    }
	
	    return {
	      "double": _double
	    };
	  }();
	
	  var poolFactory = function () {
	    return function (initialLength, _create, _release) {
	      var _length = 0;
	      var _maxLength = initialLength;
	      var pool = createSizedArray(_maxLength);
	      var ob = {
	        newElement: newElement,
	        release: release
	      };
	
	      function newElement() {
	        var element;
	
	        if (_length) {
	          _length -= 1;
	          element = pool[_length];
	        } else {
	          element = _create();
	        }
	
	        return element;
	      }
	
	      function release(element) {
	        if (_length === _maxLength) {
	          pool = pooling["double"](pool);
	          _maxLength *= 2;
	        }
	
	        if (_release) {
	          _release(element);
	        }
	
	        pool[_length] = element;
	        _length += 1;
	      }
	
	      return ob;
	    };
	  }();
	
	  var bezierLengthPool = function () {
	    function create() {
	      return {
	        addedLength: 0,
	        percents: createTypedArray('float32', getDefaultCurveSegments()),
	        lengths: createTypedArray('float32', getDefaultCurveSegments())
	      };
	    }
	
	    return poolFactory(8, create);
	  }();
	
	  var segmentsLengthPool = function () {
	    function create() {
	      return {
	        lengths: [],
	        totalLength: 0
	      };
	    }
	
	    function release(element) {
	      var i;
	      var len = element.lengths.length;
	
	      for (i = 0; i < len; i += 1) {
	        bezierLengthPool.release(element.lengths[i]);
	      }
	
	      element.lengths.length = 0;
	    }
	
	    return poolFactory(8, create, release);
	  }();
	
	  function bezFunction() {
	    var math = Math;
	
	    function pointOnLine2D(x1, y1, x2, y2, x3, y3) {
	      var det1 = x1 * y2 + y1 * x3 + x2 * y3 - x3 * y2 - y3 * x1 - x2 * y1;
	      return det1 > -0.001 && det1 < 0.001;
	    }
	
	    function pointOnLine3D(x1, y1, z1, x2, y2, z2, x3, y3, z3) {
	      if (z1 === 0 && z2 === 0 && z3 === 0) {
	        return pointOnLine2D(x1, y1, x2, y2, x3, y3);
	      }
	
	      var dist1 = math.sqrt(math.pow(x2 - x1, 2) + math.pow(y2 - y1, 2) + math.pow(z2 - z1, 2));
	      var dist2 = math.sqrt(math.pow(x3 - x1, 2) + math.pow(y3 - y1, 2) + math.pow(z3 - z1, 2));
	      var dist3 = math.sqrt(math.pow(x3 - x2, 2) + math.pow(y3 - y2, 2) + math.pow(z3 - z2, 2));
	      var diffDist;
	
	      if (dist1 > dist2) {
	        if (dist1 > dist3) {
	          diffDist = dist1 - dist2 - dist3;
	        } else {
	          diffDist = dist3 - dist2 - dist1;
	        }
	      } else if (dist3 > dist2) {
	        diffDist = dist3 - dist2 - dist1;
	      } else {
	        diffDist = dist2 - dist1 - dist3;
	      }
	
	      return diffDist > -0.0001 && diffDist < 0.0001;
	    }
	
	    var getBezierLength = function () {
	      return function (pt1, pt2, pt3, pt4) {
	        var curveSegments = getDefaultCurveSegments();
	        var k;
	        var i;
	        var len;
	        var ptCoord;
	        var perc;
	        var addedLength = 0;
	        var ptDistance;
	        var point = [];
	        var lastPoint = [];
	        var lengthData = bezierLengthPool.newElement();
	        len = pt3.length;
	
	        for (k = 0; k < curveSegments; k += 1) {
	          perc = k / (curveSegments - 1);
	          ptDistance = 0;
	
	          for (i = 0; i < len; i += 1) {
	            ptCoord = bmPow(1 - perc, 3) * pt1[i] + 3 * bmPow(1 - perc, 2) * perc * pt3[i] + 3 * (1 - perc) * bmPow(perc, 2) * pt4[i] + bmPow(perc, 3) * pt2[i];
	            point[i] = ptCoord;
	
	            if (lastPoint[i] !== null) {
	              ptDistance += bmPow(point[i] - lastPoint[i], 2);
	            }
	
	            lastPoint[i] = point[i];
	          }
	
	          if (ptDistance) {
	            ptDistance = bmSqrt(ptDistance);
	            addedLength += ptDistance;
	          }
	
	          lengthData.percents[k] = perc;
	          lengthData.lengths[k] = addedLength;
	        }
	
	        lengthData.addedLength = addedLength;
	        return lengthData;
	      };
	    }();
	
	    function getSegmentsLength(shapeData) {
	      var segmentsLength = segmentsLengthPool.newElement();
	      var closed = shapeData.c;
	      var pathV = shapeData.v;
	      var pathO = shapeData.o;
	      var pathI = shapeData.i;
	      var i;
	      var len = shapeData._length;
	      var lengths = segmentsLength.lengths;
	      var totalLength = 0;
	
	      for (i = 0; i < len - 1; i += 1) {
	        lengths[i] = getBezierLength(pathV[i], pathV[i + 1], pathO[i], pathI[i + 1]);
	        totalLength += lengths[i].addedLength;
	      }
	
	      if (closed && len) {
	        lengths[i] = getBezierLength(pathV[i], pathV[0], pathO[i], pathI[0]);
	        totalLength += lengths[i].addedLength;
	      }
	
	      segmentsLength.totalLength = totalLength;
	      return segmentsLength;
	    }
	
	    function BezierData(length) {
	      this.segmentLength = 0;
	      this.points = new Array(length);
	    }
	
	    function PointData(partial, point) {
	      this.partialLength = partial;
	      this.point = point;
	    }
	
	    var buildBezierData = function () {
	      var storedData = {};
	      return function (pt1, pt2, pt3, pt4) {
	        var bezierName = (pt1[0] + '_' + pt1[1] + '_' + pt2[0] + '_' + pt2[1] + '_' + pt3[0] + '_' + pt3[1] + '_' + pt4[0] + '_' + pt4[1]).replace(/\./g, 'p');
	
	        if (!storedData[bezierName]) {
	          var curveSegments = getDefaultCurveSegments();
	          var k;
	          var i;
	          var len;
	          var ptCoord;
	          var perc;
	          var addedLength = 0;
	          var ptDistance;
	          var point;
	          var lastPoint = null;
	
	          if (pt1.length === 2 && (pt1[0] !== pt2[0] || pt1[1] !== pt2[1]) && pointOnLine2D(pt1[0], pt1[1], pt2[0], pt2[1], pt1[0] + pt3[0], pt1[1] + pt3[1]) && pointOnLine2D(pt1[0], pt1[1], pt2[0], pt2[1], pt2[0] + pt4[0], pt2[1] + pt4[1])) {
	            curveSegments = 2;
	          }
	
	          var bezierData = new BezierData(curveSegments);
	          len = pt3.length;
	
	          for (k = 0; k < curveSegments; k += 1) {
	            point = createSizedArray(len);
	            perc = k / (curveSegments - 1);
	            ptDistance = 0;
	
	            for (i = 0; i < len; i += 1) {
	              ptCoord = bmPow(1 - perc, 3) * pt1[i] + 3 * bmPow(1 - perc, 2) * perc * (pt1[i] + pt3[i]) + 3 * (1 - perc) * bmPow(perc, 2) * (pt2[i] + pt4[i]) + bmPow(perc, 3) * pt2[i];
	              point[i] = ptCoord;
	
	              if (lastPoint !== null) {
	                ptDistance += bmPow(point[i] - lastPoint[i], 2);
	              }
	            }
	
	            ptDistance = bmSqrt(ptDistance);
	            addedLength += ptDistance;
	            bezierData.points[k] = new PointData(ptDistance, point);
	            lastPoint = point;
	          }
	
	          bezierData.segmentLength = addedLength;
	          storedData[bezierName] = bezierData;
	        }
	
	        return storedData[bezierName];
	      };
	    }();
	
	    function getDistancePerc(perc, bezierData) {
	      var percents = bezierData.percents;
	      var lengths = bezierData.lengths;
	      var len = percents.length;
	      var initPos = bmFloor((len - 1) * perc);
	      var lengthPos = perc * bezierData.addedLength;
	      var lPerc = 0;
	
	      if (initPos === len - 1 || initPos === 0 || lengthPos === lengths[initPos]) {
	        return percents[initPos];
	      }
	
	      var dir = lengths[initPos] > lengthPos ? -1 : 1;
	      var flag = true;
	
	      while (flag) {
	        if (lengths[initPos] <= lengthPos && lengths[initPos + 1] > lengthPos) {
	          lPerc = (lengthPos - lengths[initPos]) / (lengths[initPos + 1] - lengths[initPos]);
	          flag = false;
	        } else {
	          initPos += dir;
	        }
	
	        if (initPos < 0 || initPos >= len - 1) {
	          // FIX for TypedArrays that don't store floating point values with enough accuracy
	          if (initPos === len - 1) {
	            return percents[initPos];
	          }
	
	          flag = false;
	        }
	      }
	
	      return percents[initPos] + (percents[initPos + 1] - percents[initPos]) * lPerc;
	    }
	
	    function getPointInSegment(pt1, pt2, pt3, pt4, percent, bezierData) {
	      var t1 = getDistancePerc(percent, bezierData);
	      var u1 = 1 - t1;
	      var ptX = math.round((u1 * u1 * u1 * pt1[0] + (t1 * u1 * u1 + u1 * t1 * u1 + u1 * u1 * t1) * pt3[0] + (t1 * t1 * u1 + u1 * t1 * t1 + t1 * u1 * t1) * pt4[0] + t1 * t1 * t1 * pt2[0]) * 1000) / 1000;
	      var ptY = math.round((u1 * u1 * u1 * pt1[1] + (t1 * u1 * u1 + u1 * t1 * u1 + u1 * u1 * t1) * pt3[1] + (t1 * t1 * u1 + u1 * t1 * t1 + t1 * u1 * t1) * pt4[1] + t1 * t1 * t1 * pt2[1]) * 1000) / 1000;
	      return [ptX, ptY];
	    }
	
	    var bezierSegmentPoints = createTypedArray('float32', 8);
	
	    function getNewSegment(pt1, pt2, pt3, pt4, startPerc, endPerc, bezierData) {
	      if (startPerc < 0) {
	        startPerc = 0;
	      } else if (startPerc > 1) {
	        startPerc = 1;
	      }
	
	      var t0 = getDistancePerc(startPerc, bezierData);
	      endPerc = endPerc > 1 ? 1 : endPerc;
	      var t1 = getDistancePerc(endPerc, bezierData);
	      var i;
	      var len = pt1.length;
	      var u0 = 1 - t0;
	      var u1 = 1 - t1;
	      var u0u0u0 = u0 * u0 * u0;
	      var t0u0u0_3 = t0 * u0 * u0 * 3; // eslint-disable-line camelcase
	
	      var t0t0u0_3 = t0 * t0 * u0 * 3; // eslint-disable-line camelcase
	
	      var t0t0t0 = t0 * t0 * t0; //
	
	      var u0u0u1 = u0 * u0 * u1;
	      var t0u0u1_3 = t0 * u0 * u1 + u0 * t0 * u1 + u0 * u0 * t1; // eslint-disable-line camelcase
	
	      var t0t0u1_3 = t0 * t0 * u1 + u0 * t0 * t1 + t0 * u0 * t1; // eslint-disable-line camelcase
	
	      var t0t0t1 = t0 * t0 * t1; //
	
	      var u0u1u1 = u0 * u1 * u1;
	      var t0u1u1_3 = t0 * u1 * u1 + u0 * t1 * u1 + u0 * u1 * t1; // eslint-disable-line camelcase
	
	      var t0t1u1_3 = t0 * t1 * u1 + u0 * t1 * t1 + t0 * u1 * t1; // eslint-disable-line camelcase
	
	      var t0t1t1 = t0 * t1 * t1; //
	
	      var u1u1u1 = u1 * u1 * u1;
	      var t1u1u1_3 = t1 * u1 * u1 + u1 * t1 * u1 + u1 * u1 * t1; // eslint-disable-line camelcase
	
	      var t1t1u1_3 = t1 * t1 * u1 + u1 * t1 * t1 + t1 * u1 * t1; // eslint-disable-line camelcase
	
	      var t1t1t1 = t1 * t1 * t1;
	
	      for (i = 0; i < len; i += 1) {
	        bezierSegmentPoints[i * 4] = math.round((u0u0u0 * pt1[i] + t0u0u0_3 * pt3[i] + t0t0u0_3 * pt4[i] + t0t0t0 * pt2[i]) * 1000) / 1000; // eslint-disable-line camelcase
	
	        bezierSegmentPoints[i * 4 + 1] = math.round((u0u0u1 * pt1[i] + t0u0u1_3 * pt3[i] + t0t0u1_3 * pt4[i] + t0t0t1 * pt2[i]) * 1000) / 1000; // eslint-disable-line camelcase
	
	        bezierSegmentPoints[i * 4 + 2] = math.round((u0u1u1 * pt1[i] + t0u1u1_3 * pt3[i] + t0t1u1_3 * pt4[i] + t0t1t1 * pt2[i]) * 1000) / 1000; // eslint-disable-line camelcase
	
	        bezierSegmentPoints[i * 4 + 3] = math.round((u1u1u1 * pt1[i] + t1u1u1_3 * pt3[i] + t1t1u1_3 * pt4[i] + t1t1t1 * pt2[i]) * 1000) / 1000; // eslint-disable-line camelcase
	      }
	
	      return bezierSegmentPoints;
	    }
	
	    return {
	      getSegmentsLength: getSegmentsLength,
	      getNewSegment: getNewSegment,
	      getPointInSegment: getPointInSegment,
	      buildBezierData: buildBezierData,
	      pointOnLine2D: pointOnLine2D,
	      pointOnLine3D: pointOnLine3D
	    };
	  }
	
	  var bez = bezFunction();
	
	  var initFrame = initialDefaultFrame;
	  var mathAbs = Math.abs;
	
	  function interpolateValue(frameNum, caching) {
	    var offsetTime = this.offsetTime;
	    var newValue;
	
	    if (this.propType === 'multidimensional') {
	      newValue = createTypedArray('float32', this.pv.length);
	    }
	
	    var iterationIndex = caching.lastIndex;
	    var i = iterationIndex;
	    var len = this.keyframes.length - 1;
	    var flag = true;
	    var keyData;
	    var nextKeyData;
	    var keyframeMetadata;
	
	    while (flag) {
	      keyData = this.keyframes[i];
	      nextKeyData = this.keyframes[i + 1];
	
	      if (i === len - 1 && frameNum >= nextKeyData.t - offsetTime) {
	        if (keyData.h) {
	          keyData = nextKeyData;
	        }
	
	        iterationIndex = 0;
	        break;
	      }
	
	      if (nextKeyData.t - offsetTime > frameNum) {
	        iterationIndex = i;
	        break;
	      }
	
	      if (i < len - 1) {
	        i += 1;
	      } else {
	        iterationIndex = 0;
	        flag = false;
	      }
	    }
	
	    keyframeMetadata = this.keyframesMetadata[i] || {};
	    var k;
	    var kLen;
	    var perc;
	    var jLen;
	    var j;
	    var fnc;
	    var nextKeyTime = nextKeyData.t - offsetTime;
	    var keyTime = keyData.t - offsetTime;
	    var endValue;
	
	    if (keyData.to) {
	      if (!keyframeMetadata.bezierData) {
	        keyframeMetadata.bezierData = bez.buildBezierData(keyData.s, nextKeyData.s || keyData.e, keyData.to, keyData.ti);
	      }
	
	      var bezierData = keyframeMetadata.bezierData;
	
	      if (frameNum >= nextKeyTime || frameNum < keyTime) {
	        var ind = frameNum >= nextKeyTime ? bezierData.points.length - 1 : 0;
	        kLen = bezierData.points[ind].point.length;
	
	        for (k = 0; k < kLen; k += 1) {
	          newValue[k] = bezierData.points[ind].point[k];
	        } // caching._lastKeyframeIndex = -1;
	
	      } else {
	        if (keyframeMetadata.__fnct) {
	          fnc = keyframeMetadata.__fnct;
	        } else {
	          fnc = BezierFactory.getBezierEasing(keyData.o.x, keyData.o.y, keyData.i.x, keyData.i.y, keyData.n).get;
	          keyframeMetadata.__fnct = fnc;
	        }
	
	        perc = fnc((frameNum - keyTime) / (nextKeyTime - keyTime));
	        var distanceInLine = bezierData.segmentLength * perc;
	        var segmentPerc;
	        var addedLength = caching.lastFrame < frameNum && caching._lastKeyframeIndex === i ? caching._lastAddedLength : 0;
	        j = caching.lastFrame < frameNum && caching._lastKeyframeIndex === i ? caching._lastPoint : 0;
	        flag = true;
	        jLen = bezierData.points.length;
	
	        while (flag) {
	          addedLength += bezierData.points[j].partialLength;
	
	          if (distanceInLine === 0 || perc === 0 || j === bezierData.points.length - 1) {
	            kLen = bezierData.points[j].point.length;
	
	            for (k = 0; k < kLen; k += 1) {
	              newValue[k] = bezierData.points[j].point[k];
	            }
	
	            break;
	          } else if (distanceInLine >= addedLength && distanceInLine < addedLength + bezierData.points[j + 1].partialLength) {
	            segmentPerc = (distanceInLine - addedLength) / bezierData.points[j + 1].partialLength;
	            kLen = bezierData.points[j].point.length;
	
	            for (k = 0; k < kLen; k += 1) {
	              newValue[k] = bezierData.points[j].point[k] + (bezierData.points[j + 1].point[k] - bezierData.points[j].point[k]) * segmentPerc;
	            }
	
	            break;
	          }
	
	          if (j < jLen - 1) {
	            j += 1;
	          } else {
	            flag = false;
	          }
	        }
	
	        caching._lastPoint = j;
	        caching._lastAddedLength = addedLength - bezierData.points[j].partialLength;
	        caching._lastKeyframeIndex = i;
	      }
	    } else {
	      var outX;
	      var outY;
	      var inX;
	      var inY;
	      var keyValue;
	      len = keyData.s.length;
	      endValue = nextKeyData.s || keyData.e;
	
	      if (this.sh && keyData.h !== 1) {
	        if (frameNum >= nextKeyTime) {
	          newValue[0] = endValue[0];
	          newValue[1] = endValue[1];
	          newValue[2] = endValue[2];
	        } else if (frameNum <= keyTime) {
	          newValue[0] = keyData.s[0];
	          newValue[1] = keyData.s[1];
	          newValue[2] = keyData.s[2];
	        } else {
	          var quatStart = createQuaternion(keyData.s);
	          var quatEnd = createQuaternion(endValue);
	          var time = (frameNum - keyTime) / (nextKeyTime - keyTime);
	          quaternionToEuler(newValue, slerp(quatStart, quatEnd, time));
	        }
	      } else {
	        for (i = 0; i < len; i += 1) {
	          if (keyData.h !== 1) {
	            if (frameNum >= nextKeyTime) {
	              perc = 1;
	            } else if (frameNum < keyTime) {
	              perc = 0;
	            } else {
	              if (keyData.o.x.constructor === Array) {
	                if (!keyframeMetadata.__fnct) {
	                  keyframeMetadata.__fnct = [];
	                }
	
	                if (!keyframeMetadata.__fnct[i]) {
	                  outX = keyData.o.x[i] === undefined ? keyData.o.x[0] : keyData.o.x[i];
	                  outY = keyData.o.y[i] === undefined ? keyData.o.y[0] : keyData.o.y[i];
	                  inX = keyData.i.x[i] === undefined ? keyData.i.x[0] : keyData.i.x[i];
	                  inY = keyData.i.y[i] === undefined ? keyData.i.y[0] : keyData.i.y[i];
	                  fnc = BezierFactory.getBezierEasing(outX, outY, inX, inY).get;
	                  keyframeMetadata.__fnct[i] = fnc;
	                } else {
	                  fnc = keyframeMetadata.__fnct[i];
	                }
	              } else if (!keyframeMetadata.__fnct) {
	                outX = keyData.o.x;
	                outY = keyData.o.y;
	                inX = keyData.i.x;
	                inY = keyData.i.y;
	                fnc = BezierFactory.getBezierEasing(outX, outY, inX, inY).get;
	                keyData.keyframeMetadata = fnc;
	              } else {
	                fnc = keyframeMetadata.__fnct;
	              }
	
	              perc = fnc((frameNum - keyTime) / (nextKeyTime - keyTime));
	            }
	          }
	
	          endValue = nextKeyData.s || keyData.e;
	          keyValue = keyData.h === 1 ? keyData.s[i] : keyData.s[i] + (endValue[i] - keyData.s[i]) * perc;
	
	          if (this.propType === 'multidimensional') {
	            newValue[i] = keyValue;
	          } else {
	            newValue = keyValue;
	          }
	        }
	      }
	    }
	
	    caching.lastIndex = iterationIndex;
	    return newValue;
	  } // based on @Toji's https://github.com/toji/gl-matrix/
	
	
	  function slerp(a, b, t) {
	    var out = [];
	    var ax = a[0];
	    var ay = a[1];
	    var az = a[2];
	    var aw = a[3];
	    var bx = b[0];
	    var by = b[1];
	    var bz = b[2];
	    var bw = b[3];
	    var omega;
	    var cosom;
	    var sinom;
	    var scale0;
	    var scale1;
	    cosom = ax * bx + ay * by + az * bz + aw * bw;
	
	    if (cosom < 0.0) {
	      cosom = -cosom;
	      bx = -bx;
	      by = -by;
	      bz = -bz;
	      bw = -bw;
	    }
	
	    if (1.0 - cosom > 0.000001) {
	      omega = Math.acos(cosom);
	      sinom = Math.sin(omega);
	      scale0 = Math.sin((1.0 - t) * omega) / sinom;
	      scale1 = Math.sin(t * omega) / sinom;
	    } else {
	      scale0 = 1.0 - t;
	      scale1 = t;
	    }
	
	    out[0] = scale0 * ax + scale1 * bx;
	    out[1] = scale0 * ay + scale1 * by;
	    out[2] = scale0 * az + scale1 * bz;
	    out[3] = scale0 * aw + scale1 * bw;
	    return out;
	  }
	
	  function quaternionToEuler(out, quat) {
	    var qx = quat[0];
	    var qy = quat[1];
	    var qz = quat[2];
	    var qw = quat[3];
	    var heading = Math.atan2(2 * qy * qw - 2 * qx * qz, 1 - 2 * qy * qy - 2 * qz * qz);
	    var attitude = Math.asin(2 * qx * qy + 2 * qz * qw);
	    var bank = Math.atan2(2 * qx * qw - 2 * qy * qz, 1 - 2 * qx * qx - 2 * qz * qz);
	    out[0] = heading / degToRads;
	    out[1] = attitude / degToRads;
	    out[2] = bank / degToRads;
	  }
	
	  function createQuaternion(values) {
	    var heading = values[0] * degToRads;
	    var attitude = values[1] * degToRads;
	    var bank = values[2] * degToRads;
	    var c1 = Math.cos(heading / 2);
	    var c2 = Math.cos(attitude / 2);
	    var c3 = Math.cos(bank / 2);
	    var s1 = Math.sin(heading / 2);
	    var s2 = Math.sin(attitude / 2);
	    var s3 = Math.sin(bank / 2);
	    var w = c1 * c2 * c3 - s1 * s2 * s3;
	    var x = s1 * s2 * c3 + c1 * c2 * s3;
	    var y = s1 * c2 * c3 + c1 * s2 * s3;
	    var z = c1 * s2 * c3 - s1 * c2 * s3;
	    return [x, y, z, w];
	  }
	
	  function getValueAtCurrentTime() {
	    var frameNum = this.comp.renderedFrame - this.offsetTime;
	    var initTime = this.keyframes[0].t - this.offsetTime;
	    var endTime = this.keyframes[this.keyframes.length - 1].t - this.offsetTime;
	
	    if (!(frameNum === this._caching.lastFrame || this._caching.lastFrame !== initFrame && (this._caching.lastFrame >= endTime && frameNum >= endTime || this._caching.lastFrame < initTime && frameNum < initTime))) {
	      if (this._caching.lastFrame >= frameNum) {
	        this._caching._lastKeyframeIndex = -1;
	        this._caching.lastIndex = 0;
	      }
	
	      var renderResult = this.interpolateValue(frameNum, this._caching);
	      this.pv = renderResult;
	    }
	
	    this._caching.lastFrame = frameNum;
	    return this.pv;
	  }
	
	  function setVValue(val) {
	    var multipliedValue;
	
	    if (this.propType === 'unidimensional') {
	      multipliedValue = val * this.mult;
	
	      if (mathAbs(this.v - multipliedValue) > 0.00001) {
	        this.v = multipliedValue;
	        this._mdf = true;
	      }
	    } else {
	      var i = 0;
	      var len = this.v.length;
	
	      while (i < len) {
	        multipliedValue = val[i] * this.mult;
	
	        if (mathAbs(this.v[i] - multipliedValue) > 0.00001) {
	          this.v[i] = multipliedValue;
	          this._mdf = true;
	        }
	
	        i += 1;
	      }
	    }
	  }
	
	  function processEffectsSequence() {
	    if (this.elem.globalData.frameId === this.frameId || !this.effectsSequence.length) {
	      return;
	    }
	
	    if (this.lock) {
	      this.setVValue(this.pv);
	      return;
	    }
	
	    this.lock = true;
	    this._mdf = this._isFirstFrame;
	    var i;
	    var len = this.effectsSequence.length;
	    var finalValue = this.kf ? this.pv : this.data.k;
	
	    for (i = 0; i < len; i += 1) {
	      finalValue = this.effectsSequence[i](finalValue);
	    }
	
	    this.setVValue(finalValue);
	    this._isFirstFrame = false;
	    this.lock = false;
	    this.frameId = this.elem.globalData.frameId;
	  }
	
	  function addEffect(effectFunction) {
	    this.effectsSequence.push(effectFunction);
	    this.container.addDynamicProperty(this);
	  }
	
	  function ValueProperty(elem, data, mult, container) {
	    this.propType = 'unidimensional';
	    this.mult = mult || 1;
	    this.data = data;
	    this.v = mult ? data.k * mult : data.k;
	    this.pv = data.k;
	    this._mdf = false;
	    this.elem = elem;
	    this.container = container;
	    this.comp = elem.comp;
	    this.k = false;
	    this.kf = false;
	    this.vel = 0;
	    this.effectsSequence = [];
	    this._isFirstFrame = true;
	    this.getValue = processEffectsSequence;
	    this.setVValue = setVValue;
	    this.addEffect = addEffect;
	  }
	
	  function MultiDimensionalProperty(elem, data, mult, container) {
	    this.propType = 'multidimensional';
	    this.mult = mult || 1;
	    this.data = data;
	    this._mdf = false;
	    this.elem = elem;
	    this.container = container;
	    this.comp = elem.comp;
	    this.k = false;
	    this.kf = false;
	    this.frameId = -1;
	    var i;
	    var len = data.k.length;
	    this.v = createTypedArray('float32', len);
	    this.pv = createTypedArray('float32', len);
	    this.vel = createTypedArray('float32', len);
	
	    for (i = 0; i < len; i += 1) {
	      this.v[i] = data.k[i] * this.mult;
	      this.pv[i] = data.k[i];
	    }
	
	    this._isFirstFrame = true;
	    this.effectsSequence = [];
	    this.getValue = processEffectsSequence;
	    this.setVValue = setVValue;
	    this.addEffect = addEffect;
	  }
	
	  function KeyframedValueProperty(elem, data, mult, container) {
	    this.propType = 'unidimensional';
	    this.keyframes = data.k;
	    this.keyframesMetadata = [];
	    this.offsetTime = elem.data.st;
	    this.frameId = -1;
	    this._caching = {
	      lastFrame: initFrame,
	      lastIndex: 0,
	      value: 0,
	      _lastKeyframeIndex: -1
	    };
	    this.k = true;
	    this.kf = true;
	    this.data = data;
	    this.mult = mult || 1;
	    this.elem = elem;
	    this.container = container;
	    this.comp = elem.comp;
	    this.v = initFrame;
	    this.pv = initFrame;
	    this._isFirstFrame = true;
	    this.getValue = processEffectsSequence;
	    this.setVValue = setVValue;
	    this.interpolateValue = interpolateValue;
	    this.effectsSequence = [getValueAtCurrentTime.bind(this)];
	    this.addEffect = addEffect;
	  }
	
	  function KeyframedMultidimensionalProperty(elem, data, mult, container) {
	    this.propType = 'multidimensional';
	    var i;
	    var len = data.k.length;
	    var s;
	    var e;
	    var to;
	    var ti;
	
	    for (i = 0; i < len - 1; i += 1) {
	      if (data.k[i].to && data.k[i].s && data.k[i + 1] && data.k[i + 1].s) {
	        s = data.k[i].s;
	        e = data.k[i + 1].s;
	        to = data.k[i].to;
	        ti = data.k[i].ti;
	
	        if (s.length === 2 && !(s[0] === e[0] && s[1] === e[1]) && bez.pointOnLine2D(s[0], s[1], e[0], e[1], s[0] + to[0], s[1] + to[1]) && bez.pointOnLine2D(s[0], s[1], e[0], e[1], e[0] + ti[0], e[1] + ti[1]) || s.length === 3 && !(s[0] === e[0] && s[1] === e[1] && s[2] === e[2]) && bez.pointOnLine3D(s[0], s[1], s[2], e[0], e[1], e[2], s[0] + to[0], s[1] + to[1], s[2] + to[2]) && bez.pointOnLine3D(s[0], s[1], s[2], e[0], e[1], e[2], e[0] + ti[0], e[1] + ti[1], e[2] + ti[2])) {
	          data.k[i].to = null;
	          data.k[i].ti = null;
	        }
	
	        if (s[0] === e[0] && s[1] === e[1] && to[0] === 0 && to[1] === 0 && ti[0] === 0 && ti[1] === 0) {
	          if (s.length === 2 || s[2] === e[2] && to[2] === 0 && ti[2] === 0) {
	            data.k[i].to = null;
	            data.k[i].ti = null;
	          }
	        }
	      }
	    }
	
	    this.effectsSequence = [getValueAtCurrentTime.bind(this)];
	    this.data = data;
	    this.keyframes = data.k;
	    this.keyframesMetadata = [];
	    this.offsetTime = elem.data.st;
	    this.k = true;
	    this.kf = true;
	    this._isFirstFrame = true;
	    this.mult = mult || 1;
	    this.elem = elem;
	    this.container = container;
	    this.comp = elem.comp;
	    this.getValue = processEffectsSequence;
	    this.setVValue = setVValue;
	    this.interpolateValue = interpolateValue;
	    this.frameId = -1;
	    var arrLen = data.k[0].s.length;
	    this.v = createTypedArray('float32', arrLen);
	    this.pv = createTypedArray('float32', arrLen);
	
	    for (i = 0; i < arrLen; i += 1) {
	      this.v[i] = initFrame;
	      this.pv[i] = initFrame;
	    }
	
	    this._caching = {
	      lastFrame: initFrame,
	      lastIndex: 0,
	      value: createTypedArray('float32', arrLen)
	    };
	    this.addEffect = addEffect;
	  }
	
	  var PropertyFactory = function () {
	    function getProp(elem, data, type, mult, container) {
	      if (data.sid) {
	        data = elem.globalData.slotManager.getProp(data);
	      }
	
	      var p;
	
	      if (!data.k.length) {
	        p = new ValueProperty(elem, data, mult, container);
	      } else if (typeof data.k[0] === 'number') {
	        p = new MultiDimensionalProperty(elem, data, mult, container);
	      } else {
	        switch (type) {
	          case 0:
	            p = new KeyframedValueProperty(elem, data, mult, container);
	            break;
	
	          case 1:
	            p = new KeyframedMultidimensionalProperty(elem, data, mult, container);
	            break;
	
	          default:
	            break;
	        }
	      }
	
	      if (p.effectsSequence.length) {
	        container.addDynamicProperty(p);
	      }
	
	      return p;
	    }
	
	    var ob = {
	      getProp: getProp
	    };
	    return ob;
	  }();
	
	  function DynamicPropertyContainer() {}
	
	  DynamicPropertyContainer.prototype = {
	    addDynamicProperty: function addDynamicProperty(prop) {
	      if (this.dynamicProperties.indexOf(prop) === -1) {
	        this.dynamicProperties.push(prop);
	        this.container.addDynamicProperty(this);
	        this._isAnimated = true;
	      }
	    },
	    iterateDynamicProperties: function iterateDynamicProperties() {
	      this._mdf = false;
	      var i;
	      var len = this.dynamicProperties.length;
	
	      for (i = 0; i < len; i += 1) {
	        this.dynamicProperties[i].getValue();
	
	        if (this.dynamicProperties[i]._mdf) {
	          this._mdf = true;
	        }
	      }
	    },
	    initDynamicPropertyContainer: function initDynamicPropertyContainer(container) {
	      this.container = container;
	      this.dynamicProperties = [];
	      this._mdf = false;
	      this._isAnimated = false;
	    }
	  };
	
	  var pointPool = function () {
	    function create() {
	      return createTypedArray('float32', 2);
	    }
	
	    return poolFactory(8, create);
	  }();
	
	  function ShapePath() {
	    this.c = false;
	    this._length = 0;
	    this._maxLength = 8;
	    this.v = createSizedArray(this._maxLength);
	    this.o = createSizedArray(this._maxLength);
	    this.i = createSizedArray(this._maxLength);
	  }
	
	  ShapePath.prototype.setPathData = function (closed, len) {
	    this.c = closed;
	    this.setLength(len);
	    var i = 0;
	
	    while (i < len) {
	      this.v[i] = pointPool.newElement();
	      this.o[i] = pointPool.newElement();
	      this.i[i] = pointPool.newElement();
	      i += 1;
	    }
	  };
	
	  ShapePath.prototype.setLength = function (len) {
	    while (this._maxLength < len) {
	      this.doubleArrayLength();
	    }
	
	    this._length = len;
	  };
	
	  ShapePath.prototype.doubleArrayLength = function () {
	    this.v = this.v.concat(createSizedArray(this._maxLength));
	    this.i = this.i.concat(createSizedArray(this._maxLength));
	    this.o = this.o.concat(createSizedArray(this._maxLength));
	    this._maxLength *= 2;
	  };
	
	  ShapePath.prototype.setXYAt = function (x, y, type, pos, replace) {
	    var arr;
	    this._length = Math.max(this._length, pos + 1);
	
	    if (this._length >= this._maxLength) {
	      this.doubleArrayLength();
	    }
	
	    switch (type) {
	      case 'v':
	        arr = this.v;
	        break;
	
	      case 'i':
	        arr = this.i;
	        break;
	
	      case 'o':
	        arr = this.o;
	        break;
	
	      default:
	        arr = [];
	        break;
	    }
	
	    if (!arr[pos] || arr[pos] && !replace) {
	      arr[pos] = pointPool.newElement();
	    }
	
	    arr[pos][0] = x;
	    arr[pos][1] = y;
	  };
	
	  ShapePath.prototype.setTripleAt = function (vX, vY, oX, oY, iX, iY, pos, replace) {
	    this.setXYAt(vX, vY, 'v', pos, replace);
	    this.setXYAt(oX, oY, 'o', pos, replace);
	    this.setXYAt(iX, iY, 'i', pos, replace);
	  };
	
	  ShapePath.prototype.reverse = function () {
	    var newPath = new ShapePath();
	    newPath.setPathData(this.c, this._length);
	    var vertices = this.v;
	    var outPoints = this.o;
	    var inPoints = this.i;
	    var init = 0;
	
	    if (this.c) {
	      newPath.setTripleAt(vertices[0][0], vertices[0][1], inPoints[0][0], inPoints[0][1], outPoints[0][0], outPoints[0][1], 0, false);
	      init = 1;
	    }
	
	    var cnt = this._length - 1;
	    var len = this._length;
	    var i;
	
	    for (i = init; i < len; i += 1) {
	      newPath.setTripleAt(vertices[cnt][0], vertices[cnt][1], inPoints[cnt][0], inPoints[cnt][1], outPoints[cnt][0], outPoints[cnt][1], i, false);
	      cnt -= 1;
	    }
	
	    return newPath;
	  };
	
	  ShapePath.prototype.length = function () {
	    return this._length;
	  };
	
	  var shapePool = function () {
	    function create() {
	      return new ShapePath();
	    }
	
	    function release(shapePath) {
	      var len = shapePath._length;
	      var i;
	
	      for (i = 0; i < len; i += 1) {
	        pointPool.release(shapePath.v[i]);
	        pointPool.release(shapePath.i[i]);
	        pointPool.release(shapePath.o[i]);
	        shapePath.v[i] = null;
	        shapePath.i[i] = null;
	        shapePath.o[i] = null;
	      }
	
	      shapePath._length = 0;
	      shapePath.c = false;
	    }
	
	    function clone(shape) {
	      var cloned = factory.newElement();
	      var i;
	      var len = shape._length === undefined ? shape.v.length : shape._length;
	      cloned.setLength(len);
	      cloned.c = shape.c;
	
	      for (i = 0; i < len; i += 1) {
	        cloned.setTripleAt(shape.v[i][0], shape.v[i][1], shape.o[i][0], shape.o[i][1], shape.i[i][0], shape.i[i][1], i);
	      }
	
	      return cloned;
	    }
	
	    var factory = poolFactory(4, create, release);
	    factory.clone = clone;
	    return factory;
	  }();
	
	  function ShapeCollection() {
	    this._length = 0;
	    this._maxLength = 4;
	    this.shapes = createSizedArray(this._maxLength);
	  }
	
	  ShapeCollection.prototype.addShape = function (shapeData) {
	    if (this._length === this._maxLength) {
	      this.shapes = this.shapes.concat(createSizedArray(this._maxLength));
	      this._maxLength *= 2;
	    }
	
	    this.shapes[this._length] = shapeData;
	    this._length += 1;
	  };
	
	  ShapeCollection.prototype.releaseShapes = function () {
	    var i;
	
	    for (i = 0; i < this._length; i += 1) {
	      shapePool.release(this.shapes[i]);
	    }
	
	    this._length = 0;
	  };
	
	  var shapeCollectionPool = function () {
	    var ob = {
	      newShapeCollection: newShapeCollection,
	      release: release
	    };
	    var _length = 0;
	    var _maxLength = 4;
	    var pool = createSizedArray(_maxLength);
	
	    function newShapeCollection() {
	      var shapeCollection;
	
	      if (_length) {
	        _length -= 1;
	        shapeCollection = pool[_length];
	      } else {
	        shapeCollection = new ShapeCollection();
	      }
	
	      return shapeCollection;
	    }
	
	    function release(shapeCollection) {
	      var i;
	      var len = shapeCollection._length;
	
	      for (i = 0; i < len; i += 1) {
	        shapePool.release(shapeCollection.shapes[i]);
	      }
	
	      shapeCollection._length = 0;
	
	      if (_length === _maxLength) {
	        pool = pooling["double"](pool);
	        _maxLength *= 2;
	      }
	
	      pool[_length] = shapeCollection;
	      _length += 1;
	    }
	
	    return ob;
	  }();
	
	  var ShapePropertyFactory = function () {
	    var initFrame = -999999;
	
	    function interpolateShape(frameNum, previousValue, caching) {
	      var iterationIndex = caching.lastIndex;
	      var keyPropS;
	      var keyPropE;
	      var isHold;
	      var j;
	      var k;
	      var jLen;
	      var kLen;
	      var perc;
	      var vertexValue;
	      var kf = this.keyframes;
	
	      if (frameNum < kf[0].t - this.offsetTime) {
	        keyPropS = kf[0].s[0];
	        isHold = true;
	        iterationIndex = 0;
	      } else if (frameNum >= kf[kf.length - 1].t - this.offsetTime) {
	        keyPropS = kf[kf.length - 1].s ? kf[kf.length - 1].s[0] : kf[kf.length - 2].e[0];
	        /* if(kf[kf.length - 1].s){
	                  keyPropS = kf[kf.length - 1].s[0];
	              }else{
	                  keyPropS = kf[kf.length - 2].e[0];
	              } */
	
	        isHold = true;
	      } else {
	        var i = iterationIndex;
	        var len = kf.length - 1;
	        var flag = true;
	        var keyData;
	        var nextKeyData;
	        var keyframeMetadata;
	
	        while (flag) {
	          keyData = kf[i];
	          nextKeyData = kf[i + 1];
	
	          if (nextKeyData.t - this.offsetTime > frameNum) {
	            break;
	          }
	
	          if (i < len - 1) {
	            i += 1;
	          } else {
	            flag = false;
	          }
	        }
	
	        keyframeMetadata = this.keyframesMetadata[i] || {};
	        isHold = keyData.h === 1;
	        iterationIndex = i;
	
	        if (!isHold) {
	          if (frameNum >= nextKeyData.t - this.offsetTime) {
	            perc = 1;
	          } else if (frameNum < keyData.t - this.offsetTime) {
	            perc = 0;
	          } else {
	            var fnc;
	
	            if (keyframeMetadata.__fnct) {
	              fnc = keyframeMetadata.__fnct;
	            } else {
	              fnc = BezierFactory.getBezierEasing(keyData.o.x, keyData.o.y, keyData.i.x, keyData.i.y).get;
	              keyframeMetadata.__fnct = fnc;
	            }
	
	            perc = fnc((frameNum - (keyData.t - this.offsetTime)) / (nextKeyData.t - this.offsetTime - (keyData.t - this.offsetTime)));
	          }
	
	          keyPropE = nextKeyData.s ? nextKeyData.s[0] : keyData.e[0];
	        }
	
	        keyPropS = keyData.s[0];
	      }
	
	      jLen = previousValue._length;
	      kLen = keyPropS.i[0].length;
	      caching.lastIndex = iterationIndex;
	
	      for (j = 0; j < jLen; j += 1) {
	        for (k = 0; k < kLen; k += 1) {
	          vertexValue = isHold ? keyPropS.i[j][k] : keyPropS.i[j][k] + (keyPropE.i[j][k] - keyPropS.i[j][k]) * perc;
	          previousValue.i[j][k] = vertexValue;
	          vertexValue = isHold ? keyPropS.o[j][k] : keyPropS.o[j][k] + (keyPropE.o[j][k] - keyPropS.o[j][k]) * perc;
	          previousValue.o[j][k] = vertexValue;
	          vertexValue = isHold ? keyPropS.v[j][k] : keyPropS.v[j][k] + (keyPropE.v[j][k] - keyPropS.v[j][k]) * perc;
	          previousValue.v[j][k] = vertexValue;
	        }
	      }
	    }
	
	    function interpolateShapeCurrentTime() {
	      var frameNum = this.comp.renderedFrame - this.offsetTime;
	      var initTime = this.keyframes[0].t - this.offsetTime;
	      var endTime = this.keyframes[this.keyframes.length - 1].t - this.offsetTime;
	      var lastFrame = this._caching.lastFrame;
	
	      if (!(lastFrame !== initFrame && (lastFrame < initTime && frameNum < initTime || lastFrame > endTime && frameNum > endTime))) {
	        /// /
	        this._caching.lastIndex = lastFrame < frameNum ? this._caching.lastIndex : 0;
	        this.interpolateShape(frameNum, this.pv, this._caching); /// /
	      }
	
	      this._caching.lastFrame = frameNum;
	      return this.pv;
	    }
	
	    function resetShape() {
	      this.paths = this.localShapeCollection;
	    }
	
	    function shapesEqual(shape1, shape2) {
	      if (shape1._length !== shape2._length || shape1.c !== shape2.c) {
	        return false;
	      }
	
	      var i;
	      var len = shape1._length;
	
	      for (i = 0; i < len; i += 1) {
	        if (shape1.v[i][0] !== shape2.v[i][0] || shape1.v[i][1] !== shape2.v[i][1] || shape1.o[i][0] !== shape2.o[i][0] || shape1.o[i][1] !== shape2.o[i][1] || shape1.i[i][0] !== shape2.i[i][0] || shape1.i[i][1] !== shape2.i[i][1]) {
	          return false;
	        }
	      }
	
	      return true;
	    }
	
	    function setVValue(newPath) {
	      if (!shapesEqual(this.v, newPath)) {
	        this.v = shapePool.clone(newPath);
	        this.localShapeCollection.releaseShapes();
	        this.localShapeCollection.addShape(this.v);
	        this._mdf = true;
	        this.paths = this.localShapeCollection;
	      }
	    }
	
	    function processEffectsSequence() {
	      if (this.elem.globalData.frameId === this.frameId) {
	        return;
	      }
	
	      if (!this.effectsSequence.length) {
	        this._mdf = false;
	        return;
	      }
	
	      if (this.lock) {
	        this.setVValue(this.pv);
	        return;
	      }
	
	      this.lock = true;
	      this._mdf = false;
	      var finalValue;
	
	      if (this.kf) {
	        finalValue = this.pv;
	      } else if (this.data.ks) {
	        finalValue = this.data.ks.k;
	      } else {
	        finalValue = this.data.pt.k;
	      }
	
	      var i;
	      var len = this.effectsSequence.length;
	
	      for (i = 0; i < len; i += 1) {
	        finalValue = this.effectsSequence[i](finalValue);
	      }
	
	      this.setVValue(finalValue);
	      this.lock = false;
	      this.frameId = this.elem.globalData.frameId;
	    }
	
	    function ShapeProperty(elem, data, type) {
	      this.propType = 'shape';
	      this.comp = elem.comp;
	      this.container = elem;
	      this.elem = elem;
	      this.data = data;
	      this.k = false;
	      this.kf = false;
	      this._mdf = false;
	      var pathData = type === 3 ? data.pt.k : data.ks.k;
	      this.v = shapePool.clone(pathData);
	      this.pv = shapePool.clone(this.v);
	      this.localShapeCollection = shapeCollectionPool.newShapeCollection();
	      this.paths = this.localShapeCollection;
	      this.paths.addShape(this.v);
	      this.reset = resetShape;
	      this.effectsSequence = [];
	    }
	
	    function addEffect(effectFunction) {
	      this.effectsSequence.push(effectFunction);
	      this.container.addDynamicProperty(this);
	    }
	
	    ShapeProperty.prototype.interpolateShape = interpolateShape;
	    ShapeProperty.prototype.getValue = processEffectsSequence;
	    ShapeProperty.prototype.setVValue = setVValue;
	    ShapeProperty.prototype.addEffect = addEffect;
	
	    function KeyframedShapeProperty(elem, data, type) {
	      this.propType = 'shape';
	      this.comp = elem.comp;
	      this.elem = elem;
	      this.container = elem;
	      this.offsetTime = elem.data.st;
	      this.keyframes = type === 3 ? data.pt.k : data.ks.k;
	      this.keyframesMetadata = [];
	      this.k = true;
	      this.kf = true;
	      var len = this.keyframes[0].s[0].i.length;
	      this.v = shapePool.newElement();
	      this.v.setPathData(this.keyframes[0].s[0].c, len);
	      this.pv = shapePool.clone(this.v);
	      this.localShapeCollection = shapeCollectionPool.newShapeCollection();
	      this.paths = this.localShapeCollection;
	      this.paths.addShape(this.v);
	      this.lastFrame = initFrame;
	      this.reset = resetShape;
	      this._caching = {
	        lastFrame: initFrame,
	        lastIndex: 0
	      };
	      this.effectsSequence = [interpolateShapeCurrentTime.bind(this)];
	    }
	
	    KeyframedShapeProperty.prototype.getValue = processEffectsSequence;
	    KeyframedShapeProperty.prototype.interpolateShape = interpolateShape;
	    KeyframedShapeProperty.prototype.setVValue = setVValue;
	    KeyframedShapeProperty.prototype.addEffect = addEffect;
	
	    var EllShapeProperty = function () {
	      var cPoint = roundCorner;
	
	      function EllShapePropertyFactory(elem, data) {
	        this.v = shapePool.newElement();
	        this.v.setPathData(true, 4);
	        this.localShapeCollection = shapeCollectionPool.newShapeCollection();
	        this.paths = this.localShapeCollection;
	        this.localShapeCollection.addShape(this.v);
	        this.d = data.d;
	        this.elem = elem;
	        this.comp = elem.comp;
	        this.frameId = -1;
	        this.initDynamicPropertyContainer(elem);
	        this.p = PropertyFactory.getProp(elem, data.p, 1, 0, this);
	        this.s = PropertyFactory.getProp(elem, data.s, 1, 0, this);
	
	        if (this.dynamicProperties.length) {
	          this.k = true;
	        } else {
	          this.k = false;
	          this.convertEllToPath();
	        }
	      }
	
	      EllShapePropertyFactory.prototype = {
	        reset: resetShape,
	        getValue: function getValue() {
	          if (this.elem.globalData.frameId === this.frameId) {
	            return;
	          }
	
	          this.frameId = this.elem.globalData.frameId;
	          this.iterateDynamicProperties();
	
	          if (this._mdf) {
	            this.convertEllToPath();
	          }
	        },
	        convertEllToPath: function convertEllToPath() {
	          var p0 = this.p.v[0];
	          var p1 = this.p.v[1];
	          var s0 = this.s.v[0] / 2;
	          var s1 = this.s.v[1] / 2;
	
	          var _cw = this.d !== 3;
	
	          var _v = this.v;
	          _v.v[0][0] = p0;
	          _v.v[0][1] = p1 - s1;
	          _v.v[1][0] = _cw ? p0 + s0 : p0 - s0;
	          _v.v[1][1] = p1;
	          _v.v[2][0] = p0;
	          _v.v[2][1] = p1 + s1;
	          _v.v[3][0] = _cw ? p0 - s0 : p0 + s0;
	          _v.v[3][1] = p1;
	          _v.i[0][0] = _cw ? p0 - s0 * cPoint : p0 + s0 * cPoint;
	          _v.i[0][1] = p1 - s1;
	          _v.i[1][0] = _cw ? p0 + s0 : p0 - s0;
	          _v.i[1][1] = p1 - s1 * cPoint;
	          _v.i[2][0] = _cw ? p0 + s0 * cPoint : p0 - s0 * cPoint;
	          _v.i[2][1] = p1 + s1;
	          _v.i[3][0] = _cw ? p0 - s0 : p0 + s0;
	          _v.i[3][1] = p1 + s1 * cPoint;
	          _v.o[0][0] = _cw ? p0 + s0 * cPoint : p0 - s0 * cPoint;
	          _v.o[0][1] = p1 - s1;
	          _v.o[1][0] = _cw ? p0 + s0 : p0 - s0;
	          _v.o[1][1] = p1 + s1 * cPoint;
	          _v.o[2][0] = _cw ? p0 - s0 * cPoint : p0 + s0 * cPoint;
	          _v.o[2][1] = p1 + s1;
	          _v.o[3][0] = _cw ? p0 - s0 : p0 + s0;
	          _v.o[3][1] = p1 - s1 * cPoint;
	        }
	      };
	      extendPrototype([DynamicPropertyContainer], EllShapePropertyFactory);
	      return EllShapePropertyFactory;
	    }();
	
	    var StarShapeProperty = function () {
	      function StarShapePropertyFactory(elem, data) {
	        this.v = shapePool.newElement();
	        this.v.setPathData(true, 0);
	        this.elem = elem;
	        this.comp = elem.comp;
	        this.data = data;
	        this.frameId = -1;
	        this.d = data.d;
	        this.initDynamicPropertyContainer(elem);
	
	        if (data.sy === 1) {
	          this.ir = PropertyFactory.getProp(elem, data.ir, 0, 0, this);
	          this.is = PropertyFactory.getProp(elem, data.is, 0, 0.01, this);
	          this.convertToPath = this.convertStarToPath;
	        } else {
	          this.convertToPath = this.convertPolygonToPath;
	        }
	
	        this.pt = PropertyFactory.getProp(elem, data.pt, 0, 0, this);
	        this.p = PropertyFactory.getProp(elem, data.p, 1, 0, this);
	        this.r = PropertyFactory.getProp(elem, data.r, 0, degToRads, this);
	        this.or = PropertyFactory.getProp(elem, data.or, 0, 0, this);
	        this.os = PropertyFactory.getProp(elem, data.os, 0, 0.01, this);
	        this.localShapeCollection = shapeCollectionPool.newShapeCollection();
	        this.localShapeCollection.addShape(this.v);
	        this.paths = this.localShapeCollection;
	
	        if (this.dynamicProperties.length) {
	          this.k = true;
	        } else {
	          this.k = false;
	          this.convertToPath();
	        }
	      }
	
	      StarShapePropertyFactory.prototype = {
	        reset: resetShape,
	        getValue: function getValue() {
	          if (this.elem.globalData.frameId === this.frameId) {
	            return;
	          }
	
	          this.frameId = this.elem.globalData.frameId;
	          this.iterateDynamicProperties();
	
	          if (this._mdf) {
	            this.convertToPath();
	          }
	        },
	        convertStarToPath: function convertStarToPath() {
	          var numPts = Math.floor(this.pt.v) * 2;
	          var angle = Math.PI * 2 / numPts;
	          /* this.v.v.length = numPts;
	                  this.v.i.length = numPts;
	                  this.v.o.length = numPts; */
	
	          var longFlag = true;
	          var longRad = this.or.v;
	          var shortRad = this.ir.v;
	          var longRound = this.os.v;
	          var shortRound = this.is.v;
	          var longPerimSegment = 2 * Math.PI * longRad / (numPts * 2);
	          var shortPerimSegment = 2 * Math.PI * shortRad / (numPts * 2);
	          var i;
	          var rad;
	          var roundness;
	          var perimSegment;
	          var currentAng = -Math.PI / 2;
	          currentAng += this.r.v;
	          var dir = this.data.d === 3 ? -1 : 1;
	          this.v._length = 0;
	
	          for (i = 0; i < numPts; i += 1) {
	            rad = longFlag ? longRad : shortRad;
	            roundness = longFlag ? longRound : shortRound;
	            perimSegment = longFlag ? longPerimSegment : shortPerimSegment;
	            var x = rad * Math.cos(currentAng);
	            var y = rad * Math.sin(currentAng);
	            var ox = x === 0 && y === 0 ? 0 : y / Math.sqrt(x * x + y * y);
	            var oy = x === 0 && y === 0 ? 0 : -x / Math.sqrt(x * x + y * y);
	            x += +this.p.v[0];
	            y += +this.p.v[1];
	            this.v.setTripleAt(x, y, x - ox * perimSegment * roundness * dir, y - oy * perimSegment * roundness * dir, x + ox * perimSegment * roundness * dir, y + oy * perimSegment * roundness * dir, i, true);
	            /* this.v.v[i] = [x,y];
	                      this.v.i[i] = [x+ox*perimSegment*roundness*dir,y+oy*perimSegment*roundness*dir];
	                      this.v.o[i] = [x-ox*perimSegment*roundness*dir,y-oy*perimSegment*roundness*dir];
	                      this.v._length = numPts; */
	
	            longFlag = !longFlag;
	            currentAng += angle * dir;
	          }
	        },
	        convertPolygonToPath: function convertPolygonToPath() {
	          var numPts = Math.floor(this.pt.v);
	          var angle = Math.PI * 2 / numPts;
	          var rad = this.or.v;
	          var roundness = this.os.v;
	          var perimSegment = 2 * Math.PI * rad / (numPts * 4);
	          var i;
	          var currentAng = -Math.PI * 0.5;
	          var dir = this.data.d === 3 ? -1 : 1;
	          currentAng += this.r.v;
	          this.v._length = 0;
	
	          for (i = 0; i < numPts; i += 1) {
	            var x = rad * Math.cos(currentAng);
	            var y = rad * Math.sin(currentAng);
	            var ox = x === 0 && y === 0 ? 0 : y / Math.sqrt(x * x + y * y);
	            var oy = x === 0 && y === 0 ? 0 : -x / Math.sqrt(x * x + y * y);
	            x += +this.p.v[0];
	            y += +this.p.v[1];
	            this.v.setTripleAt(x, y, x - ox * perimSegment * roundness * dir, y - oy * perimSegment * roundness * dir, x + ox * perimSegment * roundness * dir, y + oy * perimSegment * roundness * dir, i, true);
	            currentAng += angle * dir;
	          }
	
	          this.paths.length = 0;
	          this.paths[0] = this.v;
	        }
	      };
	      extendPrototype([DynamicPropertyContainer], StarShapePropertyFactory);
	      return StarShapePropertyFactory;
	    }();
	
	    var RectShapeProperty = function () {
	      function RectShapePropertyFactory(elem, data) {
	        this.v = shapePool.newElement();
	        this.v.c = true;
	        this.localShapeCollection = shapeCollectionPool.newShapeCollection();
	        this.localShapeCollection.addShape(this.v);
	        this.paths = this.localShapeCollection;
	        this.elem = elem;
	        this.comp = elem.comp;
	        this.frameId = -1;
	        this.d = data.d;
	        this.initDynamicPropertyContainer(elem);
	        this.p = PropertyFactory.getProp(elem, data.p, 1, 0, this);
	        this.s = PropertyFactory.getProp(elem, data.s, 1, 0, this);
	        this.r = PropertyFactory.getProp(elem, data.r, 0, 0, this);
	
	        if (this.dynamicProperties.length) {
	          this.k = true;
	        } else {
	          this.k = false;
	          this.convertRectToPath();
	        }
	      }
	
	      RectShapePropertyFactory.prototype = {
	        convertRectToPath: function convertRectToPath() {
	          var p0 = this.p.v[0];
	          var p1 = this.p.v[1];
	          var v0 = this.s.v[0] / 2;
	          var v1 = this.s.v[1] / 2;
	          var round = bmMin(v0, v1, this.r.v);
	          var cPoint = round * (1 - roundCorner);
	          this.v._length = 0;
	
	          if (this.d === 2 || this.d === 1) {
	            this.v.setTripleAt(p0 + v0, p1 - v1 + round, p0 + v0, p1 - v1 + round, p0 + v0, p1 - v1 + cPoint, 0, true);
	            this.v.setTripleAt(p0 + v0, p1 + v1 - round, p0 + v0, p1 + v1 - cPoint, p0 + v0, p1 + v1 - round, 1, true);
	
	            if (round !== 0) {
	              this.v.setTripleAt(p0 + v0 - round, p1 + v1, p0 + v0 - round, p1 + v1, p0 + v0 - cPoint, p1 + v1, 2, true);
	              this.v.setTripleAt(p0 - v0 + round, p1 + v1, p0 - v0 + cPoint, p1 + v1, p0 - v0 + round, p1 + v1, 3, true);
	              this.v.setTripleAt(p0 - v0, p1 + v1 - round, p0 - v0, p1 + v1 - round, p0 - v0, p1 + v1 - cPoint, 4, true);
	              this.v.setTripleAt(p0 - v0, p1 - v1 + round, p0 - v0, p1 - v1 + cPoint, p0 - v0, p1 - v1 + round, 5, true);
	              this.v.setTripleAt(p0 - v0 + round, p1 - v1, p0 - v0 + round, p1 - v1, p0 - v0 + cPoint, p1 - v1, 6, true);
	              this.v.setTripleAt(p0 + v0 - round, p1 - v1, p0 + v0 - cPoint, p1 - v1, p0 + v0 - round, p1 - v1, 7, true);
	            } else {
	              this.v.setTripleAt(p0 - v0, p1 + v1, p0 - v0 + cPoint, p1 + v1, p0 - v0, p1 + v1, 2);
	              this.v.setTripleAt(p0 - v0, p1 - v1, p0 - v0, p1 - v1 + cPoint, p0 - v0, p1 - v1, 3);
	            }
	          } else {
	            this.v.setTripleAt(p0 + v0, p1 - v1 + round, p0 + v0, p1 - v1 + cPoint, p0 + v0, p1 - v1 + round, 0, true);
	
	            if (round !== 0) {
	              this.v.setTripleAt(p0 + v0 - round, p1 - v1, p0 + v0 - round, p1 - v1, p0 + v0 - cPoint, p1 - v1, 1, true);
	              this.v.setTripleAt(p0 - v0 + round, p1 - v1, p0 - v0 + cPoint, p1 - v1, p0 - v0 + round, p1 - v1, 2, true);
	              this.v.setTripleAt(p0 - v0, p1 - v1 + round, p0 - v0, p1 - v1 + round, p0 - v0, p1 - v1 + cPoint, 3, true);
	              this.v.setTripleAt(p0 - v0, p1 + v1 - round, p0 - v0, p1 + v1 - cPoint, p0 - v0, p1 + v1 - round, 4, true);
	              this.v.setTripleAt(p0 - v0 + round, p1 + v1, p0 - v0 + round, p1 + v1, p0 - v0 + cPoint, p1 + v1, 5, true);
	              this.v.setTripleAt(p0 + v0 - round, p1 + v1, p0 + v0 - cPoint, p1 + v1, p0 + v0 - round, p1 + v1, 6, true);
	              this.v.setTripleAt(p0 + v0, p1 + v1 - round, p0 + v0, p1 + v1 - round, p0 + v0, p1 + v1 - cPoint, 7, true);
	            } else {
	              this.v.setTripleAt(p0 - v0, p1 - v1, p0 - v0 + cPoint, p1 - v1, p0 - v0, p1 - v1, 1, true);
	              this.v.setTripleAt(p0 - v0, p1 + v1, p0 - v0, p1 + v1 - cPoint, p0 - v0, p1 + v1, 2, true);
	              this.v.setTripleAt(p0 + v0, p1 + v1, p0 + v0 - cPoint, p1 + v1, p0 + v0, p1 + v1, 3, true);
	            }
	          }
	        },
	        getValue: function getValue() {
	          if (this.elem.globalData.frameId === this.frameId) {
	            return;
	          }
	
	          this.frameId = this.elem.globalData.frameId;
	          this.iterateDynamicProperties();
	
	          if (this._mdf) {
	            this.convertRectToPath();
	          }
	        },
	        reset: resetShape
	      };
	      extendPrototype([DynamicPropertyContainer], RectShapePropertyFactory);
	      return RectShapePropertyFactory;
	    }();
	
	    function getShapeProp(elem, data, type) {
	      var prop;
	
	      if (type === 3 || type === 4) {
	        var dataProp = type === 3 ? data.pt : data.ks;
	        var keys = dataProp.k;
	
	        if (keys.length) {
	          prop = new KeyframedShapeProperty(elem, data, type);
	        } else {
	          prop = new ShapeProperty(elem, data, type);
	        }
	      } else if (type === 5) {
	        prop = new RectShapeProperty(elem, data);
	      } else if (type === 6) {
	        prop = new EllShapeProperty(elem, data);
	      } else if (type === 7) {
	        prop = new StarShapeProperty(elem, data);
	      }
	
	      if (prop.k) {
	        elem.addDynamicProperty(prop);
	      }
	
	      return prop;
	    }
	
	    function getConstructorFunction() {
	      return ShapeProperty;
	    }
	
	    function getKeyframedConstructorFunction() {
	      return KeyframedShapeProperty;
	    }
	
	    var ob = {};
	    ob.getShapeProp = getShapeProp;
	    ob.getConstructorFunction = getConstructorFunction;
	    ob.getKeyframedConstructorFunction = getKeyframedConstructorFunction;
	    return ob;
	  }();
	
	  /*!
	   Transformation Matrix v2.0
	   (c) Epistemex 2014-2015
	   www.epistemex.com
	   By Ken Fyrstenberg
	   Contributions by leeoniya.
	   License: MIT, header required.
	   */
	
	  /**
	   * 2D transformation matrix object initialized with identity matrix.
	   *
	   * The matrix can synchronize a canvas context by supplying the context
	   * as an argument, or later apply current absolute transform to an
	   * existing context.
	   *
	   * All values are handled as floating point values.
	   *
	   * @param {CanvasRenderingContext2D} [context] - Optional context to sync with Matrix
	   * @prop {number} a - scale x
	   * @prop {number} b - shear y
	   * @prop {number} c - shear x
	   * @prop {number} d - scale y
	   * @prop {number} e - translate x
	   * @prop {number} f - translate y
	   * @prop {CanvasRenderingContext2D|null} [context=null] - set or get current canvas context
	   * @constructor
	   */
	
	  var Matrix = function () {
	    var _cos = Math.cos;
	    var _sin = Math.sin;
	    var _tan = Math.tan;
	    var _rnd = Math.round;
	
	    function reset() {
	      this.props[0] = 1;
	      this.props[1] = 0;
	      this.props[2] = 0;
	      this.props[3] = 0;
	      this.props[4] = 0;
	      this.props[5] = 1;
	      this.props[6] = 0;
	      this.props[7] = 0;
	      this.props[8] = 0;
	      this.props[9] = 0;
	      this.props[10] = 1;
	      this.props[11] = 0;
	      this.props[12] = 0;
	      this.props[13] = 0;
	      this.props[14] = 0;
	      this.props[15] = 1;
	      return this;
	    }
	
	    function rotate(angle) {
	      if (angle === 0) {
	        return this;
	      }
	
	      var mCos = _cos(angle);
	
	      var mSin = _sin(angle);
	
	      return this._t(mCos, -mSin, 0, 0, mSin, mCos, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1);
	    }
	
	    function rotateX(angle) {
	      if (angle === 0) {
	        return this;
	      }
	
	      var mCos = _cos(angle);
	
	      var mSin = _sin(angle);
	
	      return this._t(1, 0, 0, 0, 0, mCos, -mSin, 0, 0, mSin, mCos, 0, 0, 0, 0, 1);
	    }
	
	    function rotateY(angle) {
	      if (angle === 0) {
	        return this;
	      }
	
	      var mCos = _cos(angle);
	
	      var mSin = _sin(angle);
	
	      return this._t(mCos, 0, mSin, 0, 0, 1, 0, 0, -mSin, 0, mCos, 0, 0, 0, 0, 1);
	    }
	
	    function rotateZ(angle) {
	      if (angle === 0) {
	        return this;
	      }
	
	      var mCos = _cos(angle);
	
	      var mSin = _sin(angle);
	
	      return this._t(mCos, -mSin, 0, 0, mSin, mCos, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1);
	    }
	
	    function shear(sx, sy) {
	      return this._t(1, sy, sx, 1, 0, 0);
	    }
	
	    function skew(ax, ay) {
	      return this.shear(_tan(ax), _tan(ay));
	    }
	
	    function skewFromAxis(ax, angle) {
	      var mCos = _cos(angle);
	
	      var mSin = _sin(angle);
	
	      return this._t(mCos, mSin, 0, 0, -mSin, mCos, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1)._t(1, 0, 0, 0, _tan(ax), 1, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1)._t(mCos, -mSin, 0, 0, mSin, mCos, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1); // return this._t(mCos, mSin, -mSin, mCos, 0, 0)._t(1, 0, _tan(ax), 1, 0, 0)._t(mCos, -mSin, mSin, mCos, 0, 0);
	    }
	
	    function scale(sx, sy, sz) {
	      if (!sz && sz !== 0) {
	        sz = 1;
	      }
	
	      if (sx === 1 && sy === 1 && sz === 1) {
	        return this;
	      }
	
	      return this._t(sx, 0, 0, 0, 0, sy, 0, 0, 0, 0, sz, 0, 0, 0, 0, 1);
	    }
	
	    function setTransform(a, b, c, d, e, f, g, h, i, j, k, l, m, n, o, p) {
	      this.props[0] = a;
	      this.props[1] = b;
	      this.props[2] = c;
	      this.props[3] = d;
	      this.props[4] = e;
	      this.props[5] = f;
	      this.props[6] = g;
	      this.props[7] = h;
	      this.props[8] = i;
	      this.props[9] = j;
	      this.props[10] = k;
	      this.props[11] = l;
	      this.props[12] = m;
	      this.props[13] = n;
	      this.props[14] = o;
	      this.props[15] = p;
	      return this;
	    }
	
	    function translate(tx, ty, tz) {
	      tz = tz || 0;
	
	      if (tx !== 0 || ty !== 0 || tz !== 0) {
	        return this._t(1, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1, 0, tx, ty, tz, 1);
	      }
	
	      return this;
	    }
	
	    function transform(a2, b2, c2, d2, e2, f2, g2, h2, i2, j2, k2, l2, m2, n2, o2, p2) {
	      var _p = this.props;
	
	      if (a2 === 1 && b2 === 0 && c2 === 0 && d2 === 0 && e2 === 0 && f2 === 1 && g2 === 0 && h2 === 0 && i2 === 0 && j2 === 0 && k2 === 1 && l2 === 0) {
	        // NOTE: commenting this condition because TurboFan deoptimizes code when present
	        // if(m2 !== 0 || n2 !== 0 || o2 !== 0){
	        _p[12] = _p[12] * a2 + _p[15] * m2;
	        _p[13] = _p[13] * f2 + _p[15] * n2;
	        _p[14] = _p[14] * k2 + _p[15] * o2;
	        _p[15] *= p2; // }
	
	        this._identityCalculated = false;
	        return this;
	      }
	
	      var a1 = _p[0];
	      var b1 = _p[1];
	      var c1 = _p[2];
	      var d1 = _p[3];
	      var e1 = _p[4];
	      var f1 = _p[5];
	      var g1 = _p[6];
	      var h1 = _p[7];
	      var i1 = _p[8];
	      var j1 = _p[9];
	      var k1 = _p[10];
	      var l1 = _p[11];
	      var m1 = _p[12];
	      var n1 = _p[13];
	      var o1 = _p[14];
	      var p1 = _p[15];
	      /* matrix order (canvas compatible):
	           * ace
	           * bdf
	           * 001
	           */
	
	      _p[0] = a1 * a2 + b1 * e2 + c1 * i2 + d1 * m2;
	      _p[1] = a1 * b2 + b1 * f2 + c1 * j2 + d1 * n2;
	      _p[2] = a1 * c2 + b1 * g2 + c1 * k2 + d1 * o2;
	      _p[3] = a1 * d2 + b1 * h2 + c1 * l2 + d1 * p2;
	      _p[4] = e1 * a2 + f1 * e2 + g1 * i2 + h1 * m2;
	      _p[5] = e1 * b2 + f1 * f2 + g1 * j2 + h1 * n2;
	      _p[6] = e1 * c2 + f1 * g2 + g1 * k2 + h1 * o2;
	      _p[7] = e1 * d2 + f1 * h2 + g1 * l2 + h1 * p2;
	      _p[8] = i1 * a2 + j1 * e2 + k1 * i2 + l1 * m2;
	      _p[9] = i1 * b2 + j1 * f2 + k1 * j2 + l1 * n2;
	      _p[10] = i1 * c2 + j1 * g2 + k1 * k2 + l1 * o2;
	      _p[11] = i1 * d2 + j1 * h2 + k1 * l2 + l1 * p2;
	      _p[12] = m1 * a2 + n1 * e2 + o1 * i2 + p1 * m2;
	      _p[13] = m1 * b2 + n1 * f2 + o1 * j2 + p1 * n2;
	      _p[14] = m1 * c2 + n1 * g2 + o1 * k2 + p1 * o2;
	      _p[15] = m1 * d2 + n1 * h2 + o1 * l2 + p1 * p2;
	      this._identityCalculated = false;
	      return this;
	    }
	
	    function multiply(matrix) {
	      var matrixProps = matrix.props;
	      return this.transform(matrixProps[0], matrixProps[1], matrixProps[2], matrixProps[3], matrixProps[4], matrixProps[5], matrixProps[6], matrixProps[7], matrixProps[8], matrixProps[9], matrixProps[10], matrixProps[11], matrixProps[12], matrixProps[13], matrixProps[14], matrixProps[15]);
	    }
	
	    function isIdentity() {
	      if (!this._identityCalculated) {
	        this._identity = !(this.props[0] !== 1 || this.props[1] !== 0 || this.props[2] !== 0 || this.props[3] !== 0 || this.props[4] !== 0 || this.props[5] !== 1 || this.props[6] !== 0 || this.props[7] !== 0 || this.props[8] !== 0 || this.props[9] !== 0 || this.props[10] !== 1 || this.props[11] !== 0 || this.props[12] !== 0 || this.props[13] !== 0 || this.props[14] !== 0 || this.props[15] !== 1);
	        this._identityCalculated = true;
	      }
	
	      return this._identity;
	    }
	
	    function equals(matr) {
	      var i = 0;
	
	      while (i < 16) {
	        if (matr.props[i] !== this.props[i]) {
	          return false;
	        }
	
	        i += 1;
	      }
	
	      return true;
	    }
	
	    function clone(matr) {
	      var i;
	
	      for (i = 0; i < 16; i += 1) {
	        matr.props[i] = this.props[i];
	      }
	
	      return matr;
	    }
	
	    function cloneFromProps(props) {
	      var i;
	
	      for (i = 0; i < 16; i += 1) {
	        this.props[i] = props[i];
	      }
	    }
	
	    function applyToPoint(x, y, z) {
	      return {
	        x: x * this.props[0] + y * this.props[4] + z * this.props[8] + this.props[12],
	        y: x * this.props[1] + y * this.props[5] + z * this.props[9] + this.props[13],
	        z: x * this.props[2] + y * this.props[6] + z * this.props[10] + this.props[14]
	      };
	      /* return {
	           x: x * me.a + y * me.c + me.e,
	           y: x * me.b + y * me.d + me.f
	           }; */
	    }
	
	    function applyToX(x, y, z) {
	      return x * this.props[0] + y * this.props[4] + z * this.props[8] + this.props[12];
	    }
	
	    function applyToY(x, y, z) {
	      return x * this.props[1] + y * this.props[5] + z * this.props[9] + this.props[13];
	    }
	
	    function applyToZ(x, y, z) {
	      return x * this.props[2] + y * this.props[6] + z * this.props[10] + this.props[14];
	    }
	
	    function getInverseMatrix() {
	      var determinant = this.props[0] * this.props[5] - this.props[1] * this.props[4];
	      var a = this.props[5] / determinant;
	      var b = -this.props[1] / determinant;
	      var c = -this.props[4] / determinant;
	      var d = this.props[0] / determinant;
	      var e = (this.props[4] * this.props[13] - this.props[5] * this.props[12]) / determinant;
	      var f = -(this.props[0] * this.props[13] - this.props[1] * this.props[12]) / determinant;
	      var inverseMatrix = new Matrix();
	      inverseMatrix.props[0] = a;
	      inverseMatrix.props[1] = b;
	      inverseMatrix.props[4] = c;
	      inverseMatrix.props[5] = d;
	      inverseMatrix.props[12] = e;
	      inverseMatrix.props[13] = f;
	      return inverseMatrix;
	    }
	
	    function inversePoint(pt) {
	      var inverseMatrix = this.getInverseMatrix();
	      return inverseMatrix.applyToPointArray(pt[0], pt[1], pt[2] || 0);
	    }
	
	    function inversePoints(pts) {
	      var i;
	      var len = pts.length;
	      var retPts = [];
	
	      for (i = 0; i < len; i += 1) {
	        retPts[i] = inversePoint(pts[i]);
	      }
	
	      return retPts;
	    }
	
	    function applyToTriplePoints(pt1, pt2, pt3) {
	      var arr = createTypedArray('float32', 6);
	
	      if (this.isIdentity()) {
	        arr[0] = pt1[0];
	        arr[1] = pt1[1];
	        arr[2] = pt2[0];
	        arr[3] = pt2[1];
	        arr[4] = pt3[0];
	        arr[5] = pt3[1];
	      } else {
	        var p0 = this.props[0];
	        var p1 = this.props[1];
	        var p4 = this.props[4];
	        var p5 = this.props[5];
	        var p12 = this.props[12];
	        var p13 = this.props[13];
	        arr[0] = pt1[0] * p0 + pt1[1] * p4 + p12;
	        arr[1] = pt1[0] * p1 + pt1[1] * p5 + p13;
	        arr[2] = pt2[0] * p0 + pt2[1] * p4 + p12;
	        arr[3] = pt2[0] * p1 + pt2[1] * p5 + p13;
	        arr[4] = pt3[0] * p0 + pt3[1] * p4 + p12;
	        arr[5] = pt3[0] * p1 + pt3[1] * p5 + p13;
	      }
	
	      return arr;
	    }
	
	    function applyToPointArray(x, y, z) {
	      var arr;
	
	      if (this.isIdentity()) {
	        arr = [x, y, z];
	      } else {
	        arr = [x * this.props[0] + y * this.props[4] + z * this.props[8] + this.props[12], x * this.props[1] + y * this.props[5] + z * this.props[9] + this.props[13], x * this.props[2] + y * this.props[6] + z * this.props[10] + this.props[14]];
	      }
	
	      return arr;
	    }
	
	    function applyToPointStringified(x, y) {
	      if (this.isIdentity()) {
	        return x + ',' + y;
	      }
	
	      var _p = this.props;
	      return Math.round((x * _p[0] + y * _p[4] + _p[12]) * 100) / 100 + ',' + Math.round((x * _p[1] + y * _p[5] + _p[13]) * 100) / 100;
	    }
	
	    function toCSS() {
	      // Doesn't make much sense to add this optimization. If it is an identity matrix, it's very likely this will get called only once since it won't be keyframed.
	
	      /* if(this.isIdentity()) {
	              return '';
	          } */
	      var i = 0;
	      var props = this.props;
	      var cssValue = 'matrix3d(';
	      var v = 10000;
	
	      while (i < 16) {
	        cssValue += _rnd(props[i] * v) / v;
	        cssValue += i === 15 ? ')' : ',';
	        i += 1;
	      }
	
	      return cssValue;
	    }
	
	    function roundMatrixProperty(val) {
	      var v = 10000;
	
	      if (val < 0.000001 && val > 0 || val > -0.000001 && val < 0) {
	        return _rnd(val * v) / v;
	      }
	
	      return val;
	    }
	
	    function to2dCSS() {
	      // Doesn't make much sense to add this optimization. If it is an identity matrix, it's very likely this will get called only once since it won't be keyframed.
	
	      /* if(this.isIdentity()) {
	              return '';
	          } */
	      var props = this.props;
	
	      var _a = roundMatrixProperty(props[0]);
	
	      var _b = roundMatrixProperty(props[1]);
	
	      var _c = roundMatrixProperty(props[4]);
	
	      var _d = roundMatrixProperty(props[5]);
	
	      var _e = roundMatrixProperty(props[12]);
	
	      var _f = roundMatrixProperty(props[13]);
	
	      return 'matrix(' + _a + ',' + _b + ',' + _c + ',' + _d + ',' + _e + ',' + _f + ')';
	    }
	
	    return function () {
	      this.reset = reset;
	      this.rotate = rotate;
	      this.rotateX = rotateX;
	      this.rotateY = rotateY;
	      this.rotateZ = rotateZ;
	      this.skew = skew;
	      this.skewFromAxis = skewFromAxis;
	      this.shear = shear;
	      this.scale = scale;
	      this.setTransform = setTransform;
	      this.translate = translate;
	      this.transform = transform;
	      this.multiply = multiply;
	      this.applyToPoint = applyToPoint;
	      this.applyToX = applyToX;
	      this.applyToY = applyToY;
	      this.applyToZ = applyToZ;
	      this.applyToPointArray = applyToPointArray;
	      this.applyToTriplePoints = applyToTriplePoints;
	      this.applyToPointStringified = applyToPointStringified;
	      this.toCSS = toCSS;
	      this.to2dCSS = to2dCSS;
	      this.clone = clone;
	      this.cloneFromProps = cloneFromProps;
	      this.equals = equals;
	      this.inversePoints = inversePoints;
	      this.inversePoint = inversePoint;
	      this.getInverseMatrix = getInverseMatrix;
	      this._t = this.transform;
	      this.isIdentity = isIdentity;
	      this._identity = true;
	      this._identityCalculated = false;
	      this.props = createTypedArray('float32', 16);
	      this.reset();
	    };
	  }();
	
	  function _typeof$3(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof$3 = function _typeof(obj) { return typeof obj; }; } else { _typeof$3 = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof$3(obj); }
	  var lottie = {};
	  var standalone = '__[STANDALONE]__';
	  var animationData = '__[ANIMATIONDATA]__';
	  var renderer = '';
	
	  function setLocation(href) {
	    setLocationHref(href);
	  }
	
	  function searchAnimations() {
	    if (standalone === true) {
	      animationManager.searchAnimations(animationData, standalone, renderer);
	    } else {
	      animationManager.searchAnimations();
	    }
	  }
	
	  function setSubframeRendering(flag) {
	    setSubframeEnabled(flag);
	  }
	
	  function setPrefix(prefix) {
	    setIdPrefix(prefix);
	  }
	
	  function loadAnimation(params) {
	    if (standalone === true) {
	      params.animationData = JSON.parse(animationData);
	    }
	
	    return animationManager.loadAnimation(params);
	  }
	
	  function setQuality(value) {
	    if (typeof value === 'string') {
	      switch (value) {
	        case 'high':
	          setDefaultCurveSegments(200);
	          break;
	
	        default:
	        case 'medium':
	          setDefaultCurveSegments(50);
	          break;
	
	        case 'low':
	          setDefaultCurveSegments(10);
	          break;
	      }
	    } else if (!isNaN(value) && value > 1) {
	      setDefaultCurveSegments(value);
	    }
	
	    if (getDefaultCurveSegments() >= 50) {
	      roundValues(false);
	    } else {
	      roundValues(true);
	    }
	  }
	
	  function inBrowser() {
	    return typeof navigator !== 'undefined';
	  }
	
	  function installPlugin(type, plugin) {
	    if (type === 'expressions') {
	      setExpressionsPlugin(plugin);
	    }
	  }
	
	  function getFactory(name) {
	    switch (name) {
	      case 'propertyFactory':
	        return PropertyFactory;
	
	      case 'shapePropertyFactory':
	        return ShapePropertyFactory;
	
	      case 'matrix':
	        return Matrix;
	
	      default:
	        return null;
	    }
	  }
	
	  lottie.play = animationManager.play;
	  lottie.pause = animationManager.pause;
	  lottie.setLocationHref = setLocation;
	  lottie.togglePause = animationManager.togglePause;
	  lottie.setSpeed = animationManager.setSpeed;
	  lottie.setDirection = animationManager.setDirection;
	  lottie.stop = animationManager.stop;
	  lottie.searchAnimations = searchAnimations;
	  lottie.registerAnimation = animationManager.registerAnimation;
	  lottie.loadAnimation = loadAnimation;
	  lottie.setSubframeRendering = setSubframeRendering;
	  lottie.resize = animationManager.resize; // lottie.start = start;
	
	  lottie.goToAndStop = animationManager.goToAndStop;
	  lottie.destroy = animationManager.destroy;
	  lottie.setQuality = setQuality;
	  lottie.inBrowser = inBrowser;
	  lottie.installPlugin = installPlugin;
	  lottie.freeze = animationManager.freeze;
	  lottie.unfreeze = animationManager.unfreeze;
	  lottie.setVolume = animationManager.setVolume;
	  lottie.mute = animationManager.mute;
	  lottie.unmute = animationManager.unmute;
	  lottie.getRegisteredAnimations = animationManager.getRegisteredAnimations;
	  lottie.useWebWorker = setWebWorker;
	  lottie.setIDPrefix = setPrefix;
	  lottie.__getFactory = getFactory;
	  lottie.version = '5.12.2';
	
	  function checkReady() {
	    if (document.readyState === 'complete') {
	      clearInterval(readyStateCheckInterval);
	      searchAnimations();
	    }
	  }
	
	  function getQueryVariable(variable) {
	    var vars = queryString.split('&');
	
	    for (var i = 0; i < vars.length; i += 1) {
	      var pair = vars[i].split('=');
	
	      if (decodeURIComponent(pair[0]) == variable) {
	        // eslint-disable-line eqeqeq
	        return decodeURIComponent(pair[1]);
	      }
	    }
	
	    return null;
	  }
	
	  var queryString = '';
	
	  if (standalone) {
	    var scripts = document.getElementsByTagName('script');
	    var index = scripts.length - 1;
	    var myScript = scripts[index] || {
	      src: ''
	    };
	    queryString = myScript.src ? myScript.src.replace(/^[^\?]+\??/, '') : ''; // eslint-disable-line no-useless-escape
	
	    renderer = getQueryVariable('renderer');
	  }
	
	  var readyStateCheckInterval = setInterval(checkReady, 100); // this adds bodymovin to the window object for backwards compatibility
	
	  try {
	    if (!(( false ? "undefined" : _typeof$3(exports)) === 'object' && typeof module !== 'undefined') && !("function" === 'function' && __webpack_require__(149)) // eslint-disable-line no-undef
	    ) {
	      window.bodymovin = lottie;
	    }
	  } catch (err) {//
	  }
	
	  var ShapeModifiers = function () {
	    var ob = {};
	    var modifiers = {};
	    ob.registerModifier = registerModifier;
	    ob.getModifier = getModifier;
	
	    function registerModifier(nm, factory) {
	      if (!modifiers[nm]) {
	        modifiers[nm] = factory;
	      }
	    }
	
	    function getModifier(nm, elem, data) {
	      return new modifiers[nm](elem, data);
	    }
	
	    return ob;
	  }();
	
	  function ShapeModifier() {}
	
	  ShapeModifier.prototype.initModifierProperties = function () {};
	
	  ShapeModifier.prototype.addShapeToModifier = function () {};
	
	  ShapeModifier.prototype.addShape = function (data) {
	    if (!this.closed) {
	      // Adding shape to dynamic properties. It covers the case where a shape has no effects applied, to reset it's _mdf state on every tick.
	      data.sh.container.addDynamicProperty(data.sh);
	      var shapeData = {
	        shape: data.sh,
	        data: data,
	        localShapeCollection: shapeCollectionPool.newShapeCollection()
	      };
	      this.shapes.push(shapeData);
	      this.addShapeToModifier(shapeData);
	
	      if (this._isAnimated) {
	        data.setAsAnimated();
	      }
	    }
	  };
	
	  ShapeModifier.prototype.init = function (elem, data) {
	    this.shapes = [];
	    this.elem = elem;
	    this.initDynamicPropertyContainer(elem);
	    this.initModifierProperties(elem, data);
	    this.frameId = initialDefaultFrame;
	    this.closed = false;
	    this.k = false;
	
	    if (this.dynamicProperties.length) {
	      this.k = true;
	    } else {
	      this.getValue(true);
	    }
	  };
	
	  ShapeModifier.prototype.processKeys = function () {
	    if (this.elem.globalData.frameId === this.frameId) {
	      return;
	    }
	
	    this.frameId = this.elem.globalData.frameId;
	    this.iterateDynamicProperties();
	  };
	
	  extendPrototype([DynamicPropertyContainer], ShapeModifier);
	
	  function TrimModifier() {}
	
	  extendPrototype([ShapeModifier], TrimModifier);
	
	  TrimModifier.prototype.initModifierProperties = function (elem, data) {
	    this.s = PropertyFactory.getProp(elem, data.s, 0, 0.01, this);
	    this.e = PropertyFactory.getProp(elem, data.e, 0, 0.01, this);
	    this.o = PropertyFactory.getProp(elem, data.o, 0, 0, this);
	    this.sValue = 0;
	    this.eValue = 0;
	    this.getValue = this.processKeys;
	    this.m = data.m;
	    this._isAnimated = !!this.s.effectsSequence.length || !!this.e.effectsSequence.length || !!this.o.effectsSequence.length;
	  };
	
	  TrimModifier.prototype.addShapeToModifier = function (shapeData) {
	    shapeData.pathsData = [];
	  };
	
	  TrimModifier.prototype.calculateShapeEdges = function (s, e, shapeLength, addedLength, totalModifierLength) {
	    var segments = [];
	
	    if (e <= 1) {
	      segments.push({
	        s: s,
	        e: e
	      });
	    } else if (s >= 1) {
	      segments.push({
	        s: s - 1,
	        e: e - 1
	      });
	    } else {
	      segments.push({
	        s: s,
	        e: 1
	      });
	      segments.push({
	        s: 0,
	        e: e - 1
	      });
	    }
	
	    var shapeSegments = [];
	    var i;
	    var len = segments.length;
	    var segmentOb;
	
	    for (i = 0; i < len; i += 1) {
	      segmentOb = segments[i];
	
	      if (!(segmentOb.e * totalModifierLength < addedLength || segmentOb.s * totalModifierLength > addedLength + shapeLength)) {
	        var shapeS;
	        var shapeE;
	
	        if (segmentOb.s * totalModifierLength <= addedLength) {
	          shapeS = 0;
	        } else {
	          shapeS = (segmentOb.s * totalModifierLength - addedLength) / shapeLength;
	        }
	
	        if (segmentOb.e * totalModifierLength >= addedLength + shapeLength) {
	          shapeE = 1;
	        } else {
	          shapeE = (segmentOb.e * totalModifierLength - addedLength) / shapeLength;
	        }
	
	        shapeSegments.push([shapeS, shapeE]);
	      }
	    }
	
	    if (!shapeSegments.length) {
	      shapeSegments.push([0, 0]);
	    }
	
	    return shapeSegments;
	  };
	
	  TrimModifier.prototype.releasePathsData = function (pathsData) {
	    var i;
	    var len = pathsData.length;
	
	    for (i = 0; i < len; i += 1) {
	      segmentsLengthPool.release(pathsData[i]);
	    }
	
	    pathsData.length = 0;
	    return pathsData;
	  };
	
	  TrimModifier.prototype.processShapes = function (_isFirstFrame) {
	    var s;
	    var e;
	
	    if (this._mdf || _isFirstFrame) {
	      var o = this.o.v % 360 / 360;
	
	      if (o < 0) {
	        o += 1;
	      }
	
	      if (this.s.v > 1) {
	        s = 1 + o;
	      } else if (this.s.v < 0) {
	        s = 0 + o;
	      } else {
	        s = this.s.v + o;
	      }
	
	      if (this.e.v > 1) {
	        e = 1 + o;
	      } else if (this.e.v < 0) {
	        e = 0 + o;
	      } else {
	        e = this.e.v + o;
	      }
	
	      if (s > e) {
	        var _s = s;
	        s = e;
	        e = _s;
	      }
	
	      s = Math.round(s * 10000) * 0.0001;
	      e = Math.round(e * 10000) * 0.0001;
	      this.sValue = s;
	      this.eValue = e;
	    } else {
	      s = this.sValue;
	      e = this.eValue;
	    }
	
	    var shapePaths;
	    var i;
	    var len = this.shapes.length;
	    var j;
	    var jLen;
	    var pathsData;
	    var pathData;
	    var totalShapeLength;
	    var totalModifierLength = 0;
	
	    if (e === s) {
	      for (i = 0; i < len; i += 1) {
	        this.shapes[i].localShapeCollection.releaseShapes();
	        this.shapes[i].shape._mdf = true;
	        this.shapes[i].shape.paths = this.shapes[i].localShapeCollection;
	
	        if (this._mdf) {
	          this.shapes[i].pathsData.length = 0;
	        }
	      }
	    } else if (!(e === 1 && s === 0 || e === 0 && s === 1)) {
	      var segments = [];
	      var shapeData;
	      var localShapeCollection;
	
	      for (i = 0; i < len; i += 1) {
	        shapeData = this.shapes[i]; // if shape hasn't changed and trim properties haven't changed, cached previous path can be used
	
	        if (!shapeData.shape._mdf && !this._mdf && !_isFirstFrame && this.m !== 2) {
	          shapeData.shape.paths = shapeData.localShapeCollection;
	        } else {
	          shapePaths = shapeData.shape.paths;
	          jLen = shapePaths._length;
	          totalShapeLength = 0;
	
	          if (!shapeData.shape._mdf && shapeData.pathsData.length) {
	            totalShapeLength = shapeData.totalShapeLength;
	          } else {
	            pathsData = this.releasePathsData(shapeData.pathsData);
	
	            for (j = 0; j < jLen; j += 1) {
	              pathData = bez.getSegmentsLength(shapePaths.shapes[j]);
	              pathsData.push(pathData);
	              totalShapeLength += pathData.totalLength;
	            }
	
	            shapeData.totalShapeLength = totalShapeLength;
	            shapeData.pathsData = pathsData;
	          }
	
	          totalModifierLength += totalShapeLength;
	          shapeData.shape._mdf = true;
	        }
	      }
	
	      var shapeS = s;
	      var shapeE = e;
	      var addedLength = 0;
	      var edges;
	
	      for (i = len - 1; i >= 0; i -= 1) {
	        shapeData = this.shapes[i];
	
	        if (shapeData.shape._mdf) {
	          localShapeCollection = shapeData.localShapeCollection;
	          localShapeCollection.releaseShapes(); // if m === 2 means paths are trimmed individually so edges need to be found for this specific shape relative to whoel group
	
	          if (this.m === 2 && len > 1) {
	            edges = this.calculateShapeEdges(s, e, shapeData.totalShapeLength, addedLength, totalModifierLength);
	            addedLength += shapeData.totalShapeLength;
	          } else {
	            edges = [[shapeS, shapeE]];
	          }
	
	          jLen = edges.length;
	
	          for (j = 0; j < jLen; j += 1) {
	            shapeS = edges[j][0];
	            shapeE = edges[j][1];
	            segments.length = 0;
	
	            if (shapeE <= 1) {
	              segments.push({
	                s: shapeData.totalShapeLength * shapeS,
	                e: shapeData.totalShapeLength * shapeE
	              });
	            } else if (shapeS >= 1) {
	              segments.push({
	                s: shapeData.totalShapeLength * (shapeS - 1),
	                e: shapeData.totalShapeLength * (shapeE - 1)
	              });
	            } else {
	              segments.push({
	                s: shapeData.totalShapeLength * shapeS,
	                e: shapeData.totalShapeLength
	              });
	              segments.push({
	                s: 0,
	                e: shapeData.totalShapeLength * (shapeE - 1)
	              });
	            }
	
	            var newShapesData = this.addShapes(shapeData, segments[0]);
	
	            if (segments[0].s !== segments[0].e) {
	              if (segments.length > 1) {
	                var lastShapeInCollection = shapeData.shape.paths.shapes[shapeData.shape.paths._length - 1];
	
	                if (lastShapeInCollection.c) {
	                  var lastShape = newShapesData.pop();
	                  this.addPaths(newShapesData, localShapeCollection);
	                  newShapesData = this.addShapes(shapeData, segments[1], lastShape);
	                } else {
	                  this.addPaths(newShapesData, localShapeCollection);
	                  newShapesData = this.addShapes(shapeData, segments[1]);
	                }
	              }
	
	              this.addPaths(newShapesData, localShapeCollection);
	            }
	          }
	
	          shapeData.shape.paths = localShapeCollection;
	        }
	      }
	    } else if (this._mdf) {
	      for (i = 0; i < len; i += 1) {
	        // Releasign Trim Cached paths data when no trim applied in case shapes are modified inbetween.
	        // Don't remove this even if it's losing cached info.
	        this.shapes[i].pathsData.length = 0;
	        this.shapes[i].shape._mdf = true;
	      }
	    }
	  };
	
	  TrimModifier.prototype.addPaths = function (newPaths, localShapeCollection) {
	    var i;
	    var len = newPaths.length;
	
	    for (i = 0; i < len; i += 1) {
	      localShapeCollection.addShape(newPaths[i]);
	    }
	  };
	
	  TrimModifier.prototype.addSegment = function (pt1, pt2, pt3, pt4, shapePath, pos, newShape) {
	    shapePath.setXYAt(pt2[0], pt2[1], 'o', pos);
	    shapePath.setXYAt(pt3[0], pt3[1], 'i', pos + 1);
	
	    if (newShape) {
	      shapePath.setXYAt(pt1[0], pt1[1], 'v', pos);
	    }
	
	    shapePath.setXYAt(pt4[0], pt4[1], 'v', pos + 1);
	  };
	
	  TrimModifier.prototype.addSegmentFromArray = function (points, shapePath, pos, newShape) {
	    shapePath.setXYAt(points[1], points[5], 'o', pos);
	    shapePath.setXYAt(points[2], points[6], 'i', pos + 1);
	
	    if (newShape) {
	      shapePath.setXYAt(points[0], points[4], 'v', pos);
	    }
	
	    shapePath.setXYAt(points[3], points[7], 'v', pos + 1);
	  };
	
	  TrimModifier.prototype.addShapes = function (shapeData, shapeSegment, shapePath) {
	    var pathsData = shapeData.pathsData;
	    var shapePaths = shapeData.shape.paths.shapes;
	    var i;
	    var len = shapeData.shape.paths._length;
	    var j;
	    var jLen;
	    var addedLength = 0;
	    var currentLengthData;
	    var segmentCount;
	    var lengths;
	    var segment;
	    var shapes = [];
	    var initPos;
	    var newShape = true;
	
	    if (!shapePath) {
	      shapePath = shapePool.newElement();
	      segmentCount = 0;
	      initPos = 0;
	    } else {
	      segmentCount = shapePath._length;
	      initPos = shapePath._length;
	    }
	
	    shapes.push(shapePath);
	
	    for (i = 0; i < len; i += 1) {
	      lengths = pathsData[i].lengths;
	      shapePath.c = shapePaths[i].c;
	      jLen = shapePaths[i].c ? lengths.length : lengths.length + 1;
	
	      for (j = 1; j < jLen; j += 1) {
	        currentLengthData = lengths[j - 1];
	
	        if (addedLength + currentLengthData.addedLength < shapeSegment.s) {
	          addedLength += currentLengthData.addedLength;
	          shapePath.c = false;
	        } else if (addedLength > shapeSegment.e) {
	          shapePath.c = false;
	          break;
	        } else {
	          if (shapeSegment.s <= addedLength && shapeSegment.e >= addedLength + currentLengthData.addedLength) {
	            this.addSegment(shapePaths[i].v[j - 1], shapePaths[i].o[j - 1], shapePaths[i].i[j], shapePaths[i].v[j], shapePath, segmentCount, newShape);
	            newShape = false;
	          } else {
	            segment = bez.getNewSegment(shapePaths[i].v[j - 1], shapePaths[i].v[j], shapePaths[i].o[j - 1], shapePaths[i].i[j], (shapeSegment.s - addedLength) / currentLengthData.addedLength, (shapeSegment.e - addedLength) / currentLengthData.addedLength, lengths[j - 1]);
	            this.addSegmentFromArray(segment, shapePath, segmentCount, newShape); // this.addSegment(segment.pt1, segment.pt3, segment.pt4, segment.pt2, shapePath, segmentCount, newShape);
	
	            newShape = false;
	            shapePath.c = false;
	          }
	
	          addedLength += currentLengthData.addedLength;
	          segmentCount += 1;
	        }
	      }
	
	      if (shapePaths[i].c && lengths.length) {
	        currentLengthData = lengths[j - 1];
	
	        if (addedLength <= shapeSegment.e) {
	          var segmentLength = lengths[j - 1].addedLength;
	
	          if (shapeSegment.s <= addedLength && shapeSegment.e >= addedLength + segmentLength) {
	            this.addSegment(shapePaths[i].v[j - 1], shapePaths[i].o[j - 1], shapePaths[i].i[0], shapePaths[i].v[0], shapePath, segmentCount, newShape);
	            newShape = false;
	          } else {
	            segment = bez.getNewSegment(shapePaths[i].v[j - 1], shapePaths[i].v[0], shapePaths[i].o[j - 1], shapePaths[i].i[0], (shapeSegment.s - addedLength) / segmentLength, (shapeSegment.e - addedLength) / segmentLength, lengths[j - 1]);
	            this.addSegmentFromArray(segment, shapePath, segmentCount, newShape); // this.addSegment(segment.pt1, segment.pt3, segment.pt4, segment.pt2, shapePath, segmentCount, newShape);
	
	            newShape = false;
	            shapePath.c = false;
	          }
	        } else {
	          shapePath.c = false;
	        }
	
	        addedLength += currentLengthData.addedLength;
	        segmentCount += 1;
	      }
	
	      if (shapePath._length) {
	        shapePath.setXYAt(shapePath.v[initPos][0], shapePath.v[initPos][1], 'i', initPos);
	        shapePath.setXYAt(shapePath.v[shapePath._length - 1][0], shapePath.v[shapePath._length - 1][1], 'o', shapePath._length - 1);
	      }
	
	      if (addedLength > shapeSegment.e) {
	        break;
	      }
	
	      if (i < len - 1) {
	        shapePath = shapePool.newElement();
	        newShape = true;
	        shapes.push(shapePath);
	        segmentCount = 0;
	      }
	    }
	
	    return shapes;
	  };
	
	  function PuckerAndBloatModifier() {}
	
	  extendPrototype([ShapeModifier], PuckerAndBloatModifier);
	
	  PuckerAndBloatModifier.prototype.initModifierProperties = function (elem, data) {
	    this.getValue = this.processKeys;
	    this.amount = PropertyFactory.getProp(elem, data.a, 0, null, this);
	    this._isAnimated = !!this.amount.effectsSequence.length;
	  };
	
	  PuckerAndBloatModifier.prototype.processPath = function (path, amount) {
	    var percent = amount / 100;
	    var centerPoint = [0, 0];
	    var pathLength = path._length;
	    var i = 0;
	
	    for (i = 0; i < pathLength; i += 1) {
	      centerPoint[0] += path.v[i][0];
	      centerPoint[1] += path.v[i][1];
	    }
	
	    centerPoint[0] /= pathLength;
	    centerPoint[1] /= pathLength;
	    var clonedPath = shapePool.newElement();
	    clonedPath.c = path.c;
	    var vX;
	    var vY;
	    var oX;
	    var oY;
	    var iX;
	    var iY;
	
	    for (i = 0; i < pathLength; i += 1) {
	      vX = path.v[i][0] + (centerPoint[0] - path.v[i][0]) * percent;
	      vY = path.v[i][1] + (centerPoint[1] - path.v[i][1]) * percent;
	      oX = path.o[i][0] + (centerPoint[0] - path.o[i][0]) * -percent;
	      oY = path.o[i][1] + (centerPoint[1] - path.o[i][1]) * -percent;
	      iX = path.i[i][0] + (centerPoint[0] - path.i[i][0]) * -percent;
	      iY = path.i[i][1] + (centerPoint[1] - path.i[i][1]) * -percent;
	      clonedPath.setTripleAt(vX, vY, oX, oY, iX, iY, i);
	    }
	
	    return clonedPath;
	  };
	
	  PuckerAndBloatModifier.prototype.processShapes = function (_isFirstFrame) {
	    var shapePaths;
	    var i;
	    var len = this.shapes.length;
	    var j;
	    var jLen;
	    var amount = this.amount.v;
	
	    if (amount !== 0) {
	      var shapeData;
	      var localShapeCollection;
	
	      for (i = 0; i < len; i += 1) {
	        shapeData = this.shapes[i];
	        localShapeCollection = shapeData.localShapeCollection;
	
	        if (!(!shapeData.shape._mdf && !this._mdf && !_isFirstFrame)) {
	          localShapeCollection.releaseShapes();
	          shapeData.shape._mdf = true;
	          shapePaths = shapeData.shape.paths.shapes;
	          jLen = shapeData.shape.paths._length;
	
	          for (j = 0; j < jLen; j += 1) {
	            localShapeCollection.addShape(this.processPath(shapePaths[j], amount));
	          }
	        }
	
	        shapeData.shape.paths = shapeData.localShapeCollection;
	      }
	    }
	
	    if (!this.dynamicProperties.length) {
	      this._mdf = false;
	    }
	  };
	
	  var TransformPropertyFactory = function () {
	    var defaultVector = [0, 0];
	
	    function applyToMatrix(mat) {
	      var _mdf = this._mdf;
	      this.iterateDynamicProperties();
	      this._mdf = this._mdf || _mdf;
	
	      if (this.a) {
	        mat.translate(-this.a.v[0], -this.a.v[1], this.a.v[2]);
	      }
	
	      if (this.s) {
	        mat.scale(this.s.v[0], this.s.v[1], this.s.v[2]);
	      }
	
	      if (this.sk) {
	        mat.skewFromAxis(-this.sk.v, this.sa.v);
	      }
	
	      if (this.r) {
	        mat.rotate(-this.r.v);
	      } else {
	        mat.rotateZ(-this.rz.v).rotateY(this.ry.v).rotateX(this.rx.v).rotateZ(-this.or.v[2]).rotateY(this.or.v[1]).rotateX(this.or.v[0]);
	      }
	
	      if (this.data.p.s) {
	        if (this.data.p.z) {
	          mat.translate(this.px.v, this.py.v, -this.pz.v);
	        } else {
	          mat.translate(this.px.v, this.py.v, 0);
	        }
	      } else {
	        mat.translate(this.p.v[0], this.p.v[1], -this.p.v[2]);
	      }
	    }
	
	    function processKeys(forceRender) {
	      if (this.elem.globalData.frameId === this.frameId) {
	        return;
	      }
	
	      if (this._isDirty) {
	        this.precalculateMatrix();
	        this._isDirty = false;
	      }
	
	      this.iterateDynamicProperties();
	
	      if (this._mdf || forceRender) {
	        var frameRate;
	        this.v.cloneFromProps(this.pre.props);
	
	        if (this.appliedTransformations < 1) {
	          this.v.translate(-this.a.v[0], -this.a.v[1], this.a.v[2]);
	        }
	
	        if (this.appliedTransformations < 2) {
	          this.v.scale(this.s.v[0], this.s.v[1], this.s.v[2]);
	        }
	
	        if (this.sk && this.appliedTransformations < 3) {
	          this.v.skewFromAxis(-this.sk.v, this.sa.v);
	        }
	
	        if (this.r && this.appliedTransformations < 4) {
	          this.v.rotate(-this.r.v);
	        } else if (!this.r && this.appliedTransformations < 4) {
	          this.v.rotateZ(-this.rz.v).rotateY(this.ry.v).rotateX(this.rx.v).rotateZ(-this.or.v[2]).rotateY(this.or.v[1]).rotateX(this.or.v[0]);
	        }
	
	        if (this.autoOriented) {
	          var v1;
	          var v2;
	          frameRate = this.elem.globalData.frameRate;
	
	          if (this.p && this.p.keyframes && this.p.getValueAtTime) {
	            if (this.p._caching.lastFrame + this.p.offsetTime <= this.p.keyframes[0].t) {
	              v1 = this.p.getValueAtTime((this.p.keyframes[0].t + 0.01) / frameRate, 0);
	              v2 = this.p.getValueAtTime(this.p.keyframes[0].t / frameRate, 0);
	            } else if (this.p._caching.lastFrame + this.p.offsetTime >= this.p.keyframes[this.p.keyframes.length - 1].t) {
	              v1 = this.p.getValueAtTime(this.p.keyframes[this.p.keyframes.length - 1].t / frameRate, 0);
	              v2 = this.p.getValueAtTime((this.p.keyframes[this.p.keyframes.length - 1].t - 0.05) / frameRate, 0);
	            } else {
	              v1 = this.p.pv;
	              v2 = this.p.getValueAtTime((this.p._caching.lastFrame + this.p.offsetTime - 0.01) / frameRate, this.p.offsetTime);
	            }
	          } else if (this.px && this.px.keyframes && this.py.keyframes && this.px.getValueAtTime && this.py.getValueAtTime) {
	            v1 = [];
	            v2 = [];
	            var px = this.px;
	            var py = this.py;
	
	            if (px._caching.lastFrame + px.offsetTime <= px.keyframes[0].t) {
	              v1[0] = px.getValueAtTime((px.keyframes[0].t + 0.01) / frameRate, 0);
	              v1[1] = py.getValueAtTime((py.keyframes[0].t + 0.01) / frameRate, 0);
	              v2[0] = px.getValueAtTime(px.keyframes[0].t / frameRate, 0);
	              v2[1] = py.getValueAtTime(py.keyframes[0].t / frameRate, 0);
	            } else if (px._caching.lastFrame + px.offsetTime >= px.keyframes[px.keyframes.length - 1].t) {
	              v1[0] = px.getValueAtTime(px.keyframes[px.keyframes.length - 1].t / frameRate, 0);
	              v1[1] = py.getValueAtTime(py.keyframes[py.keyframes.length - 1].t / frameRate, 0);
	              v2[0] = px.getValueAtTime((px.keyframes[px.keyframes.length - 1].t - 0.01) / frameRate, 0);
	              v2[1] = py.getValueAtTime((py.keyframes[py.keyframes.length - 1].t - 0.01) / frameRate, 0);
	            } else {
	              v1 = [px.pv, py.pv];
	              v2[0] = px.getValueAtTime((px._caching.lastFrame + px.offsetTime - 0.01) / frameRate, px.offsetTime);
	              v2[1] = py.getValueAtTime((py._caching.lastFrame + py.offsetTime - 0.01) / frameRate, py.offsetTime);
	            }
	          } else {
	            v2 = defaultVector;
	            v1 = v2;
	          }
	
	          this.v.rotate(-Math.atan2(v1[1] - v2[1], v1[0] - v2[0]));
	        }
	
	        if (this.data.p && this.data.p.s) {
	          if (this.data.p.z) {
	            this.v.translate(this.px.v, this.py.v, -this.pz.v);
	          } else {
	            this.v.translate(this.px.v, this.py.v, 0);
	          }
	        } else {
	          this.v.translate(this.p.v[0], this.p.v[1], -this.p.v[2]);
	        }
	      }
	
	      this.frameId = this.elem.globalData.frameId;
	    }
	
	    function precalculateMatrix() {
	      this.appliedTransformations = 0;
	      this.pre.reset();
	
	      if (!this.a.effectsSequence.length) {
	        this.pre.translate(-this.a.v[0], -this.a.v[1], this.a.v[2]);
	        this.appliedTransformations = 1;
	      } else {
	        return;
	      }
	
	      if (!this.s.effectsSequence.length) {
	        this.pre.scale(this.s.v[0], this.s.v[1], this.s.v[2]);
	        this.appliedTransformations = 2;
	      } else {
	        return;
	      }
	
	      if (this.sk) {
	        if (!this.sk.effectsSequence.length && !this.sa.effectsSequence.length) {
	          this.pre.skewFromAxis(-this.sk.v, this.sa.v);
	          this.appliedTransformations = 3;
	        } else {
	          return;
	        }
	      }
	
	      if (this.r) {
	        if (!this.r.effectsSequence.length) {
	          this.pre.rotate(-this.r.v);
	          this.appliedTransformations = 4;
	        }
	      } else if (!this.rz.effectsSequence.length && !this.ry.effectsSequence.length && !this.rx.effectsSequence.length && !this.or.effectsSequence.length) {
	        this.pre.rotateZ(-this.rz.v).rotateY(this.ry.v).rotateX(this.rx.v).rotateZ(-this.or.v[2]).rotateY(this.or.v[1]).rotateX(this.or.v[0]);
	        this.appliedTransformations = 4;
	      }
	    }
	
	    function autoOrient() {//
	      // var prevP = this.getValueAtTime();
	    }
	
	    function addDynamicProperty(prop) {
	      this._addDynamicProperty(prop);
	
	      this.elem.addDynamicProperty(prop);
	      this._isDirty = true;
	    }
	
	    function TransformProperty(elem, data, container) {
	      this.elem = elem;
	      this.frameId = -1;
	      this.propType = 'transform';
	      this.data = data;
	      this.v = new Matrix(); // Precalculated matrix with non animated properties
	
	      this.pre = new Matrix();
	      this.appliedTransformations = 0;
	      this.initDynamicPropertyContainer(container || elem);
	
	      if (data.p && data.p.s) {
	        this.px = PropertyFactory.getProp(elem, data.p.x, 0, 0, this);
	        this.py = PropertyFactory.getProp(elem, data.p.y, 0, 0, this);
	
	        if (data.p.z) {
	          this.pz = PropertyFactory.getProp(elem, data.p.z, 0, 0, this);
	        }
	      } else {
	        this.p = PropertyFactory.getProp(elem, data.p || {
	          k: [0, 0, 0]
	        }, 1, 0, this);
	      }
	
	      if (data.rx) {
	        this.rx = PropertyFactory.getProp(elem, data.rx, 0, degToRads, this);
	        this.ry = PropertyFactory.getProp(elem, data.ry, 0, degToRads, this);
	        this.rz = PropertyFactory.getProp(elem, data.rz, 0, degToRads, this);
	
	        if (data.or.k[0].ti) {
	          var i;
	          var len = data.or.k.length;
	
	          for (i = 0; i < len; i += 1) {
	            data.or.k[i].to = null;
	            data.or.k[i].ti = null;
	          }
	        }
	
	        this.or = PropertyFactory.getProp(elem, data.or, 1, degToRads, this); // sh Indicates it needs to be capped between -180 and 180
	
	        this.or.sh = true;
	      } else {
	        this.r = PropertyFactory.getProp(elem, data.r || {
	          k: 0
	        }, 0, degToRads, this);
	      }
	
	      if (data.sk) {
	        this.sk = PropertyFactory.getProp(elem, data.sk, 0, degToRads, this);
	        this.sa = PropertyFactory.getProp(elem, data.sa, 0, degToRads, this);
	      }
	
	      this.a = PropertyFactory.getProp(elem, data.a || {
	        k: [0, 0, 0]
	      }, 1, 0, this);
	      this.s = PropertyFactory.getProp(elem, data.s || {
	        k: [100, 100, 100]
	      }, 1, 0.01, this); // Opacity is not part of the transform properties, that's why it won't use this.dynamicProperties. That way transforms won't get updated if opacity changes.
	
	      if (data.o) {
	        this.o = PropertyFactory.getProp(elem, data.o, 0, 0.01, elem);
	      } else {
	        this.o = {
	          _mdf: false,
	          v: 1
	        };
	      }
	
	      this._isDirty = true;
	
	      if (!this.dynamicProperties.length) {
	        this.getValue(true);
	      }
	    }
	
	    TransformProperty.prototype = {
	      applyToMatrix: applyToMatrix,
	      getValue: processKeys,
	      precalculateMatrix: precalculateMatrix,
	      autoOrient: autoOrient
	    };
	    extendPrototype([DynamicPropertyContainer], TransformProperty);
	    TransformProperty.prototype.addDynamicProperty = addDynamicProperty;
	    TransformProperty.prototype._addDynamicProperty = DynamicPropertyContainer.prototype.addDynamicProperty;
	
	    function getTransformProperty(elem, data, container) {
	      return new TransformProperty(elem, data, container);
	    }
	
	    return {
	      getTransformProperty: getTransformProperty
	    };
	  }();
	
	  function RepeaterModifier() {}
	
	  extendPrototype([ShapeModifier], RepeaterModifier);
	
	  RepeaterModifier.prototype.initModifierProperties = function (elem, data) {
	    this.getValue = this.processKeys;
	    this.c = PropertyFactory.getProp(elem, data.c, 0, null, this);
	    this.o = PropertyFactory.getProp(elem, data.o, 0, null, this);
	    this.tr = TransformPropertyFactory.getTransformProperty(elem, data.tr, this);
	    this.so = PropertyFactory.getProp(elem, data.tr.so, 0, 0.01, this);
	    this.eo = PropertyFactory.getProp(elem, data.tr.eo, 0, 0.01, this);
	    this.data = data;
	
	    if (!this.dynamicProperties.length) {
	      this.getValue(true);
	    }
	
	    this._isAnimated = !!this.dynamicProperties.length;
	    this.pMatrix = new Matrix();
	    this.rMatrix = new Matrix();
	    this.sMatrix = new Matrix();
	    this.tMatrix = new Matrix();
	    this.matrix = new Matrix();
	  };
	
	  RepeaterModifier.prototype.applyTransforms = function (pMatrix, rMatrix, sMatrix, transform, perc, inv) {
	    var dir = inv ? -1 : 1;
	    var scaleX = transform.s.v[0] + (1 - transform.s.v[0]) * (1 - perc);
	    var scaleY = transform.s.v[1] + (1 - transform.s.v[1]) * (1 - perc);
	    pMatrix.translate(transform.p.v[0] * dir * perc, transform.p.v[1] * dir * perc, transform.p.v[2]);
	    rMatrix.translate(-transform.a.v[0], -transform.a.v[1], transform.a.v[2]);
	    rMatrix.rotate(-transform.r.v * dir * perc);
	    rMatrix.translate(transform.a.v[0], transform.a.v[1], transform.a.v[2]);
	    sMatrix.translate(-transform.a.v[0], -transform.a.v[1], transform.a.v[2]);
	    sMatrix.scale(inv ? 1 / scaleX : scaleX, inv ? 1 / scaleY : scaleY);
	    sMatrix.translate(transform.a.v[0], transform.a.v[1], transform.a.v[2]);
	  };
	
	  RepeaterModifier.prototype.init = function (elem, arr, pos, elemsData) {
	    this.elem = elem;
	    this.arr = arr;
	    this.pos = pos;
	    this.elemsData = elemsData;
	    this._currentCopies = 0;
	    this._elements = [];
	    this._groups = [];
	    this.frameId = -1;
	    this.initDynamicPropertyContainer(elem);
	    this.initModifierProperties(elem, arr[pos]);
	
	    while (pos > 0) {
	      pos -= 1; // this._elements.unshift(arr.splice(pos,1)[0]);
	
	      this._elements.unshift(arr[pos]);
	    }
	
	    if (this.dynamicProperties.length) {
	      this.k = true;
	    } else {
	      this.getValue(true);
	    }
	  };
	
	  RepeaterModifier.prototype.resetElements = function (elements) {
	    var i;
	    var len = elements.length;
	
	    for (i = 0; i < len; i += 1) {
	      elements[i]._processed = false;
	
	      if (elements[i].ty === 'gr') {
	        this.resetElements(elements[i].it);
	      }
	    }
	  };
	
	  RepeaterModifier.prototype.cloneElements = function (elements) {
	    var newElements = JSON.parse(JSON.stringify(elements));
	    this.resetElements(newElements);
	    return newElements;
	  };
	
	  RepeaterModifier.prototype.changeGroupRender = function (elements, renderFlag) {
	    var i;
	    var len = elements.length;
	
	    for (i = 0; i < len; i += 1) {
	      elements[i]._render = renderFlag;
	
	      if (elements[i].ty === 'gr') {
	        this.changeGroupRender(elements[i].it, renderFlag);
	      }
	    }
	  };
	
	  RepeaterModifier.prototype.processShapes = function (_isFirstFrame) {
	    var items;
	    var itemsTransform;
	    var i;
	    var dir;
	    var cont;
	    var hasReloaded = false;
	
	    if (this._mdf || _isFirstFrame) {
	      var copies = Math.ceil(this.c.v);
	
	      if (this._groups.length < copies) {
	        while (this._groups.length < copies) {
	          var group = {
	            it: this.cloneElements(this._elements),
	            ty: 'gr'
	          };
	          group.it.push({
	            a: {
	              a: 0,
	              ix: 1,
	              k: [0, 0]
	            },
	            nm: 'Transform',
	            o: {
	              a: 0,
	              ix: 7,
	              k: 100
	            },
	            p: {
	              a: 0,
	              ix: 2,
	              k: [0, 0]
	            },
	            r: {
	              a: 1,
	              ix: 6,
	              k: [{
	                s: 0,
	                e: 0,
	                t: 0
	              }, {
	                s: 0,
	                e: 0,
	                t: 1
	              }]
	            },
	            s: {
	              a: 0,
	              ix: 3,
	              k: [100, 100]
	            },
	            sa: {
	              a: 0,
	              ix: 5,
	              k: 0
	            },
	            sk: {
	              a: 0,
	              ix: 4,
	              k: 0
	            },
	            ty: 'tr'
	          });
	          this.arr.splice(0, 0, group);
	
	          this._groups.splice(0, 0, group);
	
	          this._currentCopies += 1;
	        }
	
	        this.elem.reloadShapes();
	        hasReloaded = true;
	      }
	
	      cont = 0;
	      var renderFlag;
	
	      for (i = 0; i <= this._groups.length - 1; i += 1) {
	        renderFlag = cont < copies;
	        this._groups[i]._render = renderFlag;
	        this.changeGroupRender(this._groups[i].it, renderFlag);
	
	        if (!renderFlag) {
	          var elems = this.elemsData[i].it;
	          var transformData = elems[elems.length - 1];
	
	          if (transformData.transform.op.v !== 0) {
	            transformData.transform.op._mdf = true;
	            transformData.transform.op.v = 0;
	          } else {
	            transformData.transform.op._mdf = false;
	          }
	        }
	
	        cont += 1;
	      }
	
	      this._currentCopies = copies; /// /
	
	      var offset = this.o.v;
	      var offsetModulo = offset % 1;
	      var roundOffset = offset > 0 ? Math.floor(offset) : Math.ceil(offset);
	      var pProps = this.pMatrix.props;
	      var rProps = this.rMatrix.props;
	      var sProps = this.sMatrix.props;
	      this.pMatrix.reset();
	      this.rMatrix.reset();
	      this.sMatrix.reset();
	      this.tMatrix.reset();
	      this.matrix.reset();
	      var iteration = 0;
	
	      if (offset > 0) {
	        while (iteration < roundOffset) {
	          this.applyTransforms(this.pMatrix, this.rMatrix, this.sMatrix, this.tr, 1, false);
	          iteration += 1;
	        }
	
	        if (offsetModulo) {
	          this.applyTransforms(this.pMatrix, this.rMatrix, this.sMatrix, this.tr, offsetModulo, false);
	          iteration += offsetModulo;
	        }
	      } else if (offset < 0) {
	        while (iteration > roundOffset) {
	          this.applyTransforms(this.pMatrix, this.rMatrix, this.sMatrix, this.tr, 1, true);
	          iteration -= 1;
	        }
	
	        if (offsetModulo) {
	          this.applyTransforms(this.pMatrix, this.rMatrix, this.sMatrix, this.tr, -offsetModulo, true);
	          iteration -= offsetModulo;
	        }
	      }
	
	      i = this.data.m === 1 ? 0 : this._currentCopies - 1;
	      dir = this.data.m === 1 ? 1 : -1;
	      cont = this._currentCopies;
	      var j;
	      var jLen;
	
	      while (cont) {
	        items = this.elemsData[i].it;
	        itemsTransform = items[items.length - 1].transform.mProps.v.props;
	        jLen = itemsTransform.length;
	        items[items.length - 1].transform.mProps._mdf = true;
	        items[items.length - 1].transform.op._mdf = true;
	        items[items.length - 1].transform.op.v = this._currentCopies === 1 ? this.so.v : this.so.v + (this.eo.v - this.so.v) * (i / (this._currentCopies - 1));
	
	        if (iteration !== 0) {
	          if (i !== 0 && dir === 1 || i !== this._currentCopies - 1 && dir === -1) {
	            this.applyTransforms(this.pMatrix, this.rMatrix, this.sMatrix, this.tr, 1, false);
	          }
	
	          this.matrix.transform(rProps[0], rProps[1], rProps[2], rProps[3], rProps[4], rProps[5], rProps[6], rProps[7], rProps[8], rProps[9], rProps[10], rProps[11], rProps[12], rProps[13], rProps[14], rProps[15]);
	          this.matrix.transform(sProps[0], sProps[1], sProps[2], sProps[3], sProps[4], sProps[5], sProps[6], sProps[7], sProps[8], sProps[9], sProps[10], sProps[11], sProps[12], sProps[13], sProps[14], sProps[15]);
	          this.matrix.transform(pProps[0], pProps[1], pProps[2], pProps[3], pProps[4], pProps[5], pProps[6], pProps[7], pProps[8], pProps[9], pProps[10], pProps[11], pProps[12], pProps[13], pProps[14], pProps[15]);
	
	          for (j = 0; j < jLen; j += 1) {
	            itemsTransform[j] = this.matrix.props[j];
	          }
	
	          this.matrix.reset();
	        } else {
	          this.matrix.reset();
	
	          for (j = 0; j < jLen; j += 1) {
	            itemsTransform[j] = this.matrix.props[j];
	          }
	        }
	
	        iteration += 1;
	        cont -= 1;
	        i += dir;
	      }
	    } else {
	      cont = this._currentCopies;
	      i = 0;
	      dir = 1;
	
	      while (cont) {
	        items = this.elemsData[i].it;
	        itemsTransform = items[items.length - 1].transform.mProps.v.props;
	        items[items.length - 1].transform.mProps._mdf = false;
	        items[items.length - 1].transform.op._mdf = false;
	        cont -= 1;
	        i += dir;
	      }
	    }
	
	    return hasReloaded;
	  };
	
	  RepeaterModifier.prototype.addShape = function () {};
	
	  function RoundCornersModifier() {}
	
	  extendPrototype([ShapeModifier], RoundCornersModifier);
	
	  RoundCornersModifier.prototype.initModifierProperties = function (elem, data) {
	    this.getValue = this.processKeys;
	    this.rd = PropertyFactory.getProp(elem, data.r, 0, null, this);
	    this._isAnimated = !!this.rd.effectsSequence.length;
	  };
	
	  RoundCornersModifier.prototype.processPath = function (path, round) {
	    var clonedPath = shapePool.newElement();
	    clonedPath.c = path.c;
	    var i;
	    var len = path._length;
	    var currentV;
	    var currentI;
	    var currentO;
	    var closerV;
	    var distance;
	    var newPosPerc;
	    var index = 0;
	    var vX;
	    var vY;
	    var oX;
	    var oY;
	    var iX;
	    var iY;
	
	    for (i = 0; i < len; i += 1) {
	      currentV = path.v[i];
	      currentO = path.o[i];
	      currentI = path.i[i];
	
	      if (currentV[0] === currentO[0] && currentV[1] === currentO[1] && currentV[0] === currentI[0] && currentV[1] === currentI[1]) {
	        if ((i === 0 || i === len - 1) && !path.c) {
	          clonedPath.setTripleAt(currentV[0], currentV[1], currentO[0], currentO[1], currentI[0], currentI[1], index);
	          /* clonedPath.v[index] = currentV;
	                  clonedPath.o[index] = currentO;
	                  clonedPath.i[index] = currentI; */
	
	          index += 1;
	        } else {
	          if (i === 0) {
	            closerV = path.v[len - 1];
	          } else {
	            closerV = path.v[i - 1];
	          }
	
	          distance = Math.sqrt(Math.pow(currentV[0] - closerV[0], 2) + Math.pow(currentV[1] - closerV[1], 2));
	          newPosPerc = distance ? Math.min(distance / 2, round) / distance : 0;
	          iX = currentV[0] + (closerV[0] - currentV[0]) * newPosPerc;
	          vX = iX;
	          iY = currentV[1] - (currentV[1] - closerV[1]) * newPosPerc;
	          vY = iY;
	          oX = vX - (vX - currentV[0]) * roundCorner;
	          oY = vY - (vY - currentV[1]) * roundCorner;
	          clonedPath.setTripleAt(vX, vY, oX, oY, iX, iY, index);
	          index += 1;
	
	          if (i === len - 1) {
	            closerV = path.v[0];
	          } else {
	            closerV = path.v[i + 1];
	          }
	
	          distance = Math.sqrt(Math.pow(currentV[0] - closerV[0], 2) + Math.pow(currentV[1] - closerV[1], 2));
	          newPosPerc = distance ? Math.min(distance / 2, round) / distance : 0;
	          oX = currentV[0] + (closerV[0] - currentV[0]) * newPosPerc;
	          vX = oX;
	          oY = currentV[1] + (closerV[1] - currentV[1]) * newPosPerc;
	          vY = oY;
	          iX = vX - (vX - currentV[0]) * roundCorner;
	          iY = vY - (vY - currentV[1]) * roundCorner;
	          clonedPath.setTripleAt(vX, vY, oX, oY, iX, iY, index);
	          index += 1;
	        }
	      } else {
	        clonedPath.setTripleAt(path.v[i][0], path.v[i][1], path.o[i][0], path.o[i][1], path.i[i][0], path.i[i][1], index);
	        index += 1;
	      }
	    }
	
	    return clonedPath;
	  };
	
	  RoundCornersModifier.prototype.processShapes = function (_isFirstFrame) {
	    var shapePaths;
	    var i;
	    var len = this.shapes.length;
	    var j;
	    var jLen;
	    var rd = this.rd.v;
	
	    if (rd !== 0) {
	      var shapeData;
	      var localShapeCollection;
	
	      for (i = 0; i < len; i += 1) {
	        shapeData = this.shapes[i];
	        localShapeCollection = shapeData.localShapeCollection;
	
	        if (!(!shapeData.shape._mdf && !this._mdf && !_isFirstFrame)) {
	          localShapeCollection.releaseShapes();
	          shapeData.shape._mdf = true;
	          shapePaths = shapeData.shape.paths.shapes;
	          jLen = shapeData.shape.paths._length;
	
	          for (j = 0; j < jLen; j += 1) {
	            localShapeCollection.addShape(this.processPath(shapePaths[j], rd));
	          }
	        }
	
	        shapeData.shape.paths = shapeData.localShapeCollection;
	      }
	    }
	
	    if (!this.dynamicProperties.length) {
	      this._mdf = false;
	    }
	  };
	
	  function floatEqual(a, b) {
	    return Math.abs(a - b) * 100000 <= Math.min(Math.abs(a), Math.abs(b));
	  }
	
	  function floatZero(f) {
	    return Math.abs(f) <= 0.00001;
	  }
	
	  function lerp(p0, p1, amount) {
	    return p0 * (1 - amount) + p1 * amount;
	  }
	
	  function lerpPoint(p0, p1, amount) {
	    return [lerp(p0[0], p1[0], amount), lerp(p0[1], p1[1], amount)];
	  }
	
	  function quadRoots(a, b, c) {
	    // no root
	    if (a === 0) return [];
	    var s = b * b - 4 * a * c; // Complex roots
	
	    if (s < 0) return [];
	    var singleRoot = -b / (2 * a); // 1 root
	
	    if (s === 0) return [singleRoot];
	    var delta = Math.sqrt(s) / (2 * a); // 2 roots
	
	    return [singleRoot - delta, singleRoot + delta];
	  }
	
	  function polynomialCoefficients(p0, p1, p2, p3) {
	    return [-p0 + 3 * p1 - 3 * p2 + p3, 3 * p0 - 6 * p1 + 3 * p2, -3 * p0 + 3 * p1, p0];
	  }
	
	  function singlePoint(p) {
	    return new PolynomialBezier(p, p, p, p, false);
	  }
	
	  function PolynomialBezier(p0, p1, p2, p3, linearize) {
	    if (linearize && pointEqual(p0, p1)) {
	      p1 = lerpPoint(p0, p3, 1 / 3);
	    }
	
	    if (linearize && pointEqual(p2, p3)) {
	      p2 = lerpPoint(p0, p3, 2 / 3);
	    }
	
	    var coeffx = polynomialCoefficients(p0[0], p1[0], p2[0], p3[0]);
	    var coeffy = polynomialCoefficients(p0[1], p1[1], p2[1], p3[1]);
	    this.a = [coeffx[0], coeffy[0]];
	    this.b = [coeffx[1], coeffy[1]];
	    this.c = [coeffx[2], coeffy[2]];
	    this.d = [coeffx[3], coeffy[3]];
	    this.points = [p0, p1, p2, p3];
	  }
	
	  PolynomialBezier.prototype.point = function (t) {
	    return [((this.a[0] * t + this.b[0]) * t + this.c[0]) * t + this.d[0], ((this.a[1] * t + this.b[1]) * t + this.c[1]) * t + this.d[1]];
	  };
	
	  PolynomialBezier.prototype.derivative = function (t) {
	    return [(3 * t * this.a[0] + 2 * this.b[0]) * t + this.c[0], (3 * t * this.a[1] + 2 * this.b[1]) * t + this.c[1]];
	  };
	
	  PolynomialBezier.prototype.tangentAngle = function (t) {
	    var p = this.derivative(t);
	    return Math.atan2(p[1], p[0]);
	  };
	
	  PolynomialBezier.prototype.normalAngle = function (t) {
	    var p = this.derivative(t);
	    return Math.atan2(p[0], p[1]);
	  };
	
	  PolynomialBezier.prototype.inflectionPoints = function () {
	    var denom = this.a[1] * this.b[0] - this.a[0] * this.b[1];
	    if (floatZero(denom)) return [];
	    var tcusp = -0.5 * (this.a[1] * this.c[0] - this.a[0] * this.c[1]) / denom;
	    var square = tcusp * tcusp - 1 / 3 * (this.b[1] * this.c[0] - this.b[0] * this.c[1]) / denom;
	    if (square < 0) return [];
	    var root = Math.sqrt(square);
	
	    if (floatZero(root)) {
	      if (root > 0 && root < 1) return [tcusp];
	      return [];
	    }
	
	    return [tcusp - root, tcusp + root].filter(function (r) {
	      return r > 0 && r < 1;
	    });
	  };
	
	  PolynomialBezier.prototype.split = function (t) {
	    if (t <= 0) return [singlePoint(this.points[0]), this];
	    if (t >= 1) return [this, singlePoint(this.points[this.points.length - 1])];
	    var p10 = lerpPoint(this.points[0], this.points[1], t);
	    var p11 = lerpPoint(this.points[1], this.points[2], t);
	    var p12 = lerpPoint(this.points[2], this.points[3], t);
	    var p20 = lerpPoint(p10, p11, t);
	    var p21 = lerpPoint(p11, p12, t);
	    var p3 = lerpPoint(p20, p21, t);
	    return [new PolynomialBezier(this.points[0], p10, p20, p3, true), new PolynomialBezier(p3, p21, p12, this.points[3], true)];
	  };
	
	  function extrema(bez, comp) {
	    var min = bez.points[0][comp];
	    var max = bez.points[bez.points.length - 1][comp];
	
	    if (min > max) {
	      var e = max;
	      max = min;
	      min = e;
	    } // Derivative roots to find min/max
	
	
	    var f = quadRoots(3 * bez.a[comp], 2 * bez.b[comp], bez.c[comp]);
	
	    for (var i = 0; i < f.length; i += 1) {
	      if (f[i] > 0 && f[i] < 1) {
	        var val = bez.point(f[i])[comp];
	        if (val < min) min = val;else if (val > max) max = val;
	      }
	    }
	
	    return {
	      min: min,
	      max: max
	    };
	  }
	
	  PolynomialBezier.prototype.bounds = function () {
	    return {
	      x: extrema(this, 0),
	      y: extrema(this, 1)
	    };
	  };
	
	  PolynomialBezier.prototype.boundingBox = function () {
	    var bounds = this.bounds();
	    return {
	      left: bounds.x.min,
	      right: bounds.x.max,
	      top: bounds.y.min,
	      bottom: bounds.y.max,
	      width: bounds.x.max - bounds.x.min,
	      height: bounds.y.max - bounds.y.min,
	      cx: (bounds.x.max + bounds.x.min) / 2,
	      cy: (bounds.y.max + bounds.y.min) / 2
	    };
	  };
	
	  function intersectData(bez, t1, t2) {
	    var box = bez.boundingBox();
	    return {
	      cx: box.cx,
	      cy: box.cy,
	      width: box.width,
	      height: box.height,
	      bez: bez,
	      t: (t1 + t2) / 2,
	      t1: t1,
	      t2: t2
	    };
	  }
	
	  function splitData(data) {
	    var split = data.bez.split(0.5);
	    return [intersectData(split[0], data.t1, data.t), intersectData(split[1], data.t, data.t2)];
	  }
	
	  function boxIntersect(b1, b2) {
	    return Math.abs(b1.cx - b2.cx) * 2 < b1.width + b2.width && Math.abs(b1.cy - b2.cy) * 2 < b1.height + b2.height;
	  }
	
	  function intersectsImpl(d1, d2, depth, tolerance, intersections, maxRecursion) {
	    if (!boxIntersect(d1, d2)) return;
	
	    if (depth >= maxRecursion || d1.width <= tolerance && d1.height <= tolerance && d2.width <= tolerance && d2.height <= tolerance) {
	      intersections.push([d1.t, d2.t]);
	      return;
	    }
	
	    var d1s = splitData(d1);
	    var d2s = splitData(d2);
	    intersectsImpl(d1s[0], d2s[0], depth + 1, tolerance, intersections, maxRecursion);
	    intersectsImpl(d1s[0], d2s[1], depth + 1, tolerance, intersections, maxRecursion);
	    intersectsImpl(d1s[1], d2s[0], depth + 1, tolerance, intersections, maxRecursion);
	    intersectsImpl(d1s[1], d2s[1], depth + 1, tolerance, intersections, maxRecursion);
	  }
	
	  PolynomialBezier.prototype.intersections = function (other, tolerance, maxRecursion) {
	    if (tolerance === undefined) tolerance = 2;
	    if (maxRecursion === undefined) maxRecursion = 7;
	    var intersections = [];
	    intersectsImpl(intersectData(this, 0, 1), intersectData(other, 0, 1), 0, tolerance, intersections, maxRecursion);
	    return intersections;
	  };
	
	  PolynomialBezier.shapeSegment = function (shapePath, index) {
	    var nextIndex = (index + 1) % shapePath.length();
	    return new PolynomialBezier(shapePath.v[index], shapePath.o[index], shapePath.i[nextIndex], shapePath.v[nextIndex], true);
	  };
	
	  PolynomialBezier.shapeSegmentInverted = function (shapePath, index) {
	    var nextIndex = (index + 1) % shapePath.length();
	    return new PolynomialBezier(shapePath.v[nextIndex], shapePath.i[nextIndex], shapePath.o[index], shapePath.v[index], true);
	  };
	
	  function crossProduct(a, b) {
	    return [a[1] * b[2] - a[2] * b[1], a[2] * b[0] - a[0] * b[2], a[0] * b[1] - a[1] * b[0]];
	  }
	
	  function lineIntersection(start1, end1, start2, end2) {
	    var v1 = [start1[0], start1[1], 1];
	    var v2 = [end1[0], end1[1], 1];
	    var v3 = [start2[0], start2[1], 1];
	    var v4 = [end2[0], end2[1], 1];
	    var r = crossProduct(crossProduct(v1, v2), crossProduct(v3, v4));
	    if (floatZero(r[2])) return null;
	    return [r[0] / r[2], r[1] / r[2]];
	  }
	
	  function polarOffset(p, angle, length) {
	    return [p[0] + Math.cos(angle) * length, p[1] - Math.sin(angle) * length];
	  }
	
	  function pointDistance(p1, p2) {
	    return Math.hypot(p1[0] - p2[0], p1[1] - p2[1]);
	  }
	
	  function pointEqual(p1, p2) {
	    return floatEqual(p1[0], p2[0]) && floatEqual(p1[1], p2[1]);
	  }
	
	  function ZigZagModifier() {}
	
	  extendPrototype([ShapeModifier], ZigZagModifier);
	
	  ZigZagModifier.prototype.initModifierProperties = function (elem, data) {
	    this.getValue = this.processKeys;
	    this.amplitude = PropertyFactory.getProp(elem, data.s, 0, null, this);
	    this.frequency = PropertyFactory.getProp(elem, data.r, 0, null, this);
	    this.pointsType = PropertyFactory.getProp(elem, data.pt, 0, null, this);
	    this._isAnimated = this.amplitude.effectsSequence.length !== 0 || this.frequency.effectsSequence.length !== 0 || this.pointsType.effectsSequence.length !== 0;
	  };
	
	  function setPoint(outputBezier, point, angle, direction, amplitude, outAmplitude, inAmplitude) {
	    var angO = angle - Math.PI / 2;
	    var angI = angle + Math.PI / 2;
	    var px = point[0] + Math.cos(angle) * direction * amplitude;
	    var py = point[1] - Math.sin(angle) * direction * amplitude;
	    outputBezier.setTripleAt(px, py, px + Math.cos(angO) * outAmplitude, py - Math.sin(angO) * outAmplitude, px + Math.cos(angI) * inAmplitude, py - Math.sin(angI) * inAmplitude, outputBezier.length());
	  }
	
	  function getPerpendicularVector(pt1, pt2) {
	    var vector = [pt2[0] - pt1[0], pt2[1] - pt1[1]];
	    var rot = -Math.PI * 0.5;
	    var rotatedVector = [Math.cos(rot) * vector[0] - Math.sin(rot) * vector[1], Math.sin(rot) * vector[0] + Math.cos(rot) * vector[1]];
	    return rotatedVector;
	  }
	
	  function getProjectingAngle(path, cur) {
	    var prevIndex = cur === 0 ? path.length() - 1 : cur - 1;
	    var nextIndex = (cur + 1) % path.length();
	    var prevPoint = path.v[prevIndex];
	    var nextPoint = path.v[nextIndex];
	    var pVector = getPerpendicularVector(prevPoint, nextPoint);
	    return Math.atan2(0, 1) - Math.atan2(pVector[1], pVector[0]);
	  }
	
	  function zigZagCorner(outputBezier, path, cur, amplitude, frequency, pointType, direction) {
	    var angle = getProjectingAngle(path, cur);
	    var point = path.v[cur % path._length];
	    var prevPoint = path.v[cur === 0 ? path._length - 1 : cur - 1];
	    var nextPoint = path.v[(cur + 1) % path._length];
	    var prevDist = pointType === 2 ? Math.sqrt(Math.pow(point[0] - prevPoint[0], 2) + Math.pow(point[1] - prevPoint[1], 2)) : 0;
	    var nextDist = pointType === 2 ? Math.sqrt(Math.pow(point[0] - nextPoint[0], 2) + Math.pow(point[1] - nextPoint[1], 2)) : 0;
	    setPoint(outputBezier, path.v[cur % path._length], angle, direction, amplitude, nextDist / ((frequency + 1) * 2), prevDist / ((frequency + 1) * 2), pointType);
	  }
	
	  function zigZagSegment(outputBezier, segment, amplitude, frequency, pointType, direction) {
	    for (var i = 0; i < frequency; i += 1) {
	      var t = (i + 1) / (frequency + 1);
	      var dist = pointType === 2 ? Math.sqrt(Math.pow(segment.points[3][0] - segment.points[0][0], 2) + Math.pow(segment.points[3][1] - segment.points[0][1], 2)) : 0;
	      var angle = segment.normalAngle(t);
	      var point = segment.point(t);
	      setPoint(outputBezier, point, angle, direction, amplitude, dist / ((frequency + 1) * 2), dist / ((frequency + 1) * 2), pointType);
	      direction = -direction;
	    }
	
	    return direction;
	  }
	
	  ZigZagModifier.prototype.processPath = function (path, amplitude, frequency, pointType) {
	    var count = path._length;
	    var clonedPath = shapePool.newElement();
	    clonedPath.c = path.c;
	
	    if (!path.c) {
	      count -= 1;
	    }
	
	    if (count === 0) return clonedPath;
	    var direction = -1;
	    var segment = PolynomialBezier.shapeSegment(path, 0);
	    zigZagCorner(clonedPath, path, 0, amplitude, frequency, pointType, direction);
	
	    for (var i = 0; i < count; i += 1) {
	      direction = zigZagSegment(clonedPath, segment, amplitude, frequency, pointType, -direction);
	
	      if (i === count - 1 && !path.c) {
	        segment = null;
	      } else {
	        segment = PolynomialBezier.shapeSegment(path, (i + 1) % count);
	      }
	
	      zigZagCorner(clonedPath, path, i + 1, amplitude, frequency, pointType, direction);
	    }
	
	    return clonedPath;
	  };
	
	  ZigZagModifier.prototype.processShapes = function (_isFirstFrame) {
	    var shapePaths;
	    var i;
	    var len = this.shapes.length;
	    var j;
	    var jLen;
	    var amplitude = this.amplitude.v;
	    var frequency = Math.max(0, Math.round(this.frequency.v));
	    var pointType = this.pointsType.v;
	
	    if (amplitude !== 0) {
	      var shapeData;
	      var localShapeCollection;
	
	      for (i = 0; i < len; i += 1) {
	        shapeData = this.shapes[i];
	        localShapeCollection = shapeData.localShapeCollection;
	
	        if (!(!shapeData.shape._mdf && !this._mdf && !_isFirstFrame)) {
	          localShapeCollection.releaseShapes();
	          shapeData.shape._mdf = true;
	          shapePaths = shapeData.shape.paths.shapes;
	          jLen = shapeData.shape.paths._length;
	
	          for (j = 0; j < jLen; j += 1) {
	            localShapeCollection.addShape(this.processPath(shapePaths[j], amplitude, frequency, pointType));
	          }
	        }
	
	        shapeData.shape.paths = shapeData.localShapeCollection;
	      }
	    }
	
	    if (!this.dynamicProperties.length) {
	      this._mdf = false;
	    }
	  };
	
	  function linearOffset(p1, p2, amount) {
	    var angle = Math.atan2(p2[0] - p1[0], p2[1] - p1[1]);
	    return [polarOffset(p1, angle, amount), polarOffset(p2, angle, amount)];
	  }
	
	  function offsetSegment(segment, amount) {
	    var p0;
	    var p1a;
	    var p1b;
	    var p2b;
	    var p2a;
	    var p3;
	    var e;
	    e = linearOffset(segment.points[0], segment.points[1], amount);
	    p0 = e[0];
	    p1a = e[1];
	    e = linearOffset(segment.points[1], segment.points[2], amount);
	    p1b = e[0];
	    p2b = e[1];
	    e = linearOffset(segment.points[2], segment.points[3], amount);
	    p2a = e[0];
	    p3 = e[1];
	    var p1 = lineIntersection(p0, p1a, p1b, p2b);
	    if (p1 === null) p1 = p1a;
	    var p2 = lineIntersection(p2a, p3, p1b, p2b);
	    if (p2 === null) p2 = p2a;
	    return new PolynomialBezier(p0, p1, p2, p3);
	  }
	
	  function joinLines(outputBezier, seg1, seg2, lineJoin, miterLimit) {
	    var p0 = seg1.points[3];
	    var p1 = seg2.points[0]; // Bevel
	
	    if (lineJoin === 3) return p0; // Connected, they don't need a joint
	
	    if (pointEqual(p0, p1)) return p0; // Round
	
	    if (lineJoin === 2) {
	      var angleOut = -seg1.tangentAngle(1);
	      var angleIn = -seg2.tangentAngle(0) + Math.PI;
	      var center = lineIntersection(p0, polarOffset(p0, angleOut + Math.PI / 2, 100), p1, polarOffset(p1, angleOut + Math.PI / 2, 100));
	      var radius = center ? pointDistance(center, p0) : pointDistance(p0, p1) / 2;
	      var tan = polarOffset(p0, angleOut, 2 * radius * roundCorner);
	      outputBezier.setXYAt(tan[0], tan[1], 'o', outputBezier.length() - 1);
	      tan = polarOffset(p1, angleIn, 2 * radius * roundCorner);
	      outputBezier.setTripleAt(p1[0], p1[1], p1[0], p1[1], tan[0], tan[1], outputBezier.length());
	      return p1;
	    } // Miter
	
	
	    var t0 = pointEqual(p0, seg1.points[2]) ? seg1.points[0] : seg1.points[2];
	    var t1 = pointEqual(p1, seg2.points[1]) ? seg2.points[3] : seg2.points[1];
	    var intersection = lineIntersection(t0, p0, p1, t1);
	
	    if (intersection && pointDistance(intersection, p0) < miterLimit) {
	      outputBezier.setTripleAt(intersection[0], intersection[1], intersection[0], intersection[1], intersection[0], intersection[1], outputBezier.length());
	      return intersection;
	    }
	
	    return p0;
	  }
	
	  function getIntersection(a, b) {
	    var intersect = a.intersections(b);
	    if (intersect.length && floatEqual(intersect[0][0], 1)) intersect.shift();
	    if (intersect.length) return intersect[0];
	    return null;
	  }
	
	  function pruneSegmentIntersection(a, b) {
	    var outa = a.slice();
	    var outb = b.slice();
	    var intersect = getIntersection(a[a.length - 1], b[0]);
	
	    if (intersect) {
	      outa[a.length - 1] = a[a.length - 1].split(intersect[0])[0];
	      outb[0] = b[0].split(intersect[1])[1];
	    }
	
	    if (a.length > 1 && b.length > 1) {
	      intersect = getIntersection(a[0], b[b.length - 1]);
	
	      if (intersect) {
	        return [[a[0].split(intersect[0])[0]], [b[b.length - 1].split(intersect[1])[1]]];
	      }
	    }
	
	    return [outa, outb];
	  }
	
	  function pruneIntersections(segments) {
	    var e;
	
	    for (var i = 1; i < segments.length; i += 1) {
	      e = pruneSegmentIntersection(segments[i - 1], segments[i]);
	      segments[i - 1] = e[0];
	      segments[i] = e[1];
	    }
	
	    if (segments.length > 1) {
	      e = pruneSegmentIntersection(segments[segments.length - 1], segments[0]);
	      segments[segments.length - 1] = e[0];
	      segments[0] = e[1];
	    }
	
	    return segments;
	  }
	
	  function offsetSegmentSplit(segment, amount) {
	    /*
	      We split each bezier segment into smaller pieces based
	      on inflection points, this ensures the control point
	      polygon is convex.
	        (A cubic bezier can have none, one, or two inflection points)
	    */
	    var flex = segment.inflectionPoints();
	    var left;
	    var right;
	    var split;
	    var mid;
	
	    if (flex.length === 0) {
	      return [offsetSegment(segment, amount)];
	    }
	
	    if (flex.length === 1 || floatEqual(flex[1], 1)) {
	      split = segment.split(flex[0]);
	      left = split[0];
	      right = split[1];
	      return [offsetSegment(left, amount), offsetSegment(right, amount)];
	    }
	
	    split = segment.split(flex[0]);
	    left = split[0];
	    var t = (flex[1] - flex[0]) / (1 - flex[0]);
	    split = split[1].split(t);
	    mid = split[0];
	    right = split[1];
	    return [offsetSegment(left, amount), offsetSegment(mid, amount), offsetSegment(right, amount)];
	  }
	
	  function OffsetPathModifier() {}
	
	  extendPrototype([ShapeModifier], OffsetPathModifier);
	
	  OffsetPathModifier.prototype.initModifierProperties = function (elem, data) {
	    this.getValue = this.processKeys;
	    this.amount = PropertyFactory.getProp(elem, data.a, 0, null, this);
	    this.miterLimit = PropertyFactory.getProp(elem, data.ml, 0, null, this);
	    this.lineJoin = data.lj;
	    this._isAnimated = this.amount.effectsSequence.length !== 0;
	  };
	
	  OffsetPathModifier.prototype.processPath = function (inputBezier, amount, lineJoin, miterLimit) {
	    var outputBezier = shapePool.newElement();
	    outputBezier.c = inputBezier.c;
	    var count = inputBezier.length();
	
	    if (!inputBezier.c) {
	      count -= 1;
	    }
	
	    var i;
	    var j;
	    var segment;
	    var multiSegments = [];
	
	    for (i = 0; i < count; i += 1) {
	      segment = PolynomialBezier.shapeSegment(inputBezier, i);
	      multiSegments.push(offsetSegmentSplit(segment, amount));
	    }
	
	    if (!inputBezier.c) {
	      for (i = count - 1; i >= 0; i -= 1) {
	        segment = PolynomialBezier.shapeSegmentInverted(inputBezier, i);
	        multiSegments.push(offsetSegmentSplit(segment, amount));
	      }
	    }
	
	    multiSegments = pruneIntersections(multiSegments); // Add bezier segments to the output and apply line joints
	
	    var lastPoint = null;
	    var lastSeg = null;
	
	    for (i = 0; i < multiSegments.length; i += 1) {
	      var multiSegment = multiSegments[i];
	      if (lastSeg) lastPoint = joinLines(outputBezier, lastSeg, multiSegment[0], lineJoin, miterLimit);
	      lastSeg = multiSegment[multiSegment.length - 1];
	
	      for (j = 0; j < multiSegment.length; j += 1) {
	        segment = multiSegment[j];
	
	        if (lastPoint && pointEqual(segment.points[0], lastPoint)) {
	          outputBezier.setXYAt(segment.points[1][0], segment.points[1][1], 'o', outputBezier.length() - 1);
	        } else {
	          outputBezier.setTripleAt(segment.points[0][0], segment.points[0][1], segment.points[1][0], segment.points[1][1], segment.points[0][0], segment.points[0][1], outputBezier.length());
	        }
	
	        outputBezier.setTripleAt(segment.points[3][0], segment.points[3][1], segment.points[3][0], segment.points[3][1], segment.points[2][0], segment.points[2][1], outputBezier.length());
	        lastPoint = segment.points[3];
	      }
	    }
	
	    if (multiSegments.length) joinLines(outputBezier, lastSeg, multiSegments[0][0], lineJoin, miterLimit);
	    return outputBezier;
	  };
	
	  OffsetPathModifier.prototype.processShapes = function (_isFirstFrame) {
	    var shapePaths;
	    var i;
	    var len = this.shapes.length;
	    var j;
	    var jLen;
	    var amount = this.amount.v;
	    var miterLimit = this.miterLimit.v;
	    var lineJoin = this.lineJoin;
	
	    if (amount !== 0) {
	      var shapeData;
	      var localShapeCollection;
	
	      for (i = 0; i < len; i += 1) {
	        shapeData = this.shapes[i];
	        localShapeCollection = shapeData.localShapeCollection;
	
	        if (!(!shapeData.shape._mdf && !this._mdf && !_isFirstFrame)) {
	          localShapeCollection.releaseShapes();
	          shapeData.shape._mdf = true;
	          shapePaths = shapeData.shape.paths.shapes;
	          jLen = shapeData.shape.paths._length;
	
	          for (j = 0; j < jLen; j += 1) {
	            localShapeCollection.addShape(this.processPath(shapePaths[j], amount, lineJoin, miterLimit));
	          }
	        }
	
	        shapeData.shape.paths = shapeData.localShapeCollection;
	      }
	    }
	
	    if (!this.dynamicProperties.length) {
	      this._mdf = false;
	    }
	  };
	
	  function getFontProperties(fontData) {
	    var styles = fontData.fStyle ? fontData.fStyle.split(' ') : [];
	    var fWeight = 'normal';
	    var fStyle = 'normal';
	    var len = styles.length;
	    var styleName;
	
	    for (var i = 0; i < len; i += 1) {
	      styleName = styles[i].toLowerCase();
	
	      switch (styleName) {
	        case 'italic':
	          fStyle = 'italic';
	          break;
	
	        case 'bold':
	          fWeight = '700';
	          break;
	
	        case 'black':
	          fWeight = '900';
	          break;
	
	        case 'medium':
	          fWeight = '500';
	          break;
	
	        case 'regular':
	        case 'normal':
	          fWeight = '400';
	          break;
	
	        case 'light':
	        case 'thin':
	          fWeight = '200';
	          break;
	
	        default:
	          break;
	      }
	    }
	
	    return {
	      style: fStyle,
	      weight: fontData.fWeight || fWeight
	    };
	  }
	
	  var FontManager = function () {
	    var maxWaitingTime = 5000;
	    var emptyChar = {
	      w: 0,
	      size: 0,
	      shapes: [],
	      data: {
	        shapes: []
	      }
	    };
	    var combinedCharacters = []; // Hindi characters
	
	    combinedCharacters = combinedCharacters.concat([2304, 2305, 2306, 2307, 2362, 2363, 2364, 2364, 2366, 2367, 2368, 2369, 2370, 2371, 2372, 2373, 2374, 2375, 2376, 2377, 2378, 2379, 2380, 2381, 2382, 2383, 2387, 2388, 2389, 2390, 2391, 2402, 2403]);
	    var BLACK_FLAG_CODE_POINT = 127988;
	    var CANCEL_TAG_CODE_POINT = 917631;
	    var A_TAG_CODE_POINT = 917601;
	    var Z_TAG_CODE_POINT = 917626;
	    var VARIATION_SELECTOR_16_CODE_POINT = 65039;
	    var ZERO_WIDTH_JOINER_CODE_POINT = 8205;
	    var REGIONAL_CHARACTER_A_CODE_POINT = 127462;
	    var REGIONAL_CHARACTER_Z_CODE_POINT = 127487;
	    var surrogateModifiers = ['d83cdffb', 'd83cdffc', 'd83cdffd', 'd83cdffe', 'd83cdfff'];
	
	    function trimFontOptions(font) {
	      var familyArray = font.split(',');
	      var i;
	      var len = familyArray.length;
	      var enabledFamilies = [];
	
	      for (i = 0; i < len; i += 1) {
	        if (familyArray[i] !== 'sans-serif' && familyArray[i] !== 'monospace') {
	          enabledFamilies.push(familyArray[i]);
	        }
	      }
	
	      return enabledFamilies.join(',');
	    }
	
	    function setUpNode(font, family) {
	      var parentNode = createTag('span'); // Node is invisible to screen readers.
	
	      parentNode.setAttribute('aria-hidden', true);
	      parentNode.style.fontFamily = family;
	      var node = createTag('span'); // Characters that vary significantly among different fonts
	
	      node.innerText = 'giItT1WQy@!-/#'; // Visible - so we can measure it - but not on the screen
	
	      parentNode.style.position = 'absolute';
	      parentNode.style.left = '-10000px';
	      parentNode.style.top = '-10000px'; // Large font size makes even subtle changes obvious
	
	      parentNode.style.fontSize = '300px'; // Reset any font properties
	
	      parentNode.style.fontVariant = 'normal';
	      parentNode.style.fontStyle = 'normal';
	      parentNode.style.fontWeight = 'normal';
	      parentNode.style.letterSpacing = '0';
	      parentNode.appendChild(node);
	      document.body.appendChild(parentNode); // Remember width with no applied web font
	
	      var width = node.offsetWidth;
	      node.style.fontFamily = trimFontOptions(font) + ', ' + family;
	      return {
	        node: node,
	        w: width,
	        parent: parentNode
	      };
	    }
	
	    function checkLoadedFonts() {
	      var i;
	      var len = this.fonts.length;
	      var node;
	      var w;
	      var loadedCount = len;
	
	      for (i = 0; i < len; i += 1) {
	        if (this.fonts[i].loaded) {
	          loadedCount -= 1;
	        } else if (this.fonts[i].fOrigin === 'n' || this.fonts[i].origin === 0) {
	          this.fonts[i].loaded = true;
	        } else {
	          node = this.fonts[i].monoCase.node;
	          w = this.fonts[i].monoCase.w;
	
	          if (node.offsetWidth !== w) {
	            loadedCount -= 1;
	            this.fonts[i].loaded = true;
	          } else {
	            node = this.fonts[i].sansCase.node;
	            w = this.fonts[i].sansCase.w;
	
	            if (node.offsetWidth !== w) {
	              loadedCount -= 1;
	              this.fonts[i].loaded = true;
	            }
	          }
	
	          if (this.fonts[i].loaded) {
	            this.fonts[i].sansCase.parent.parentNode.removeChild(this.fonts[i].sansCase.parent);
	            this.fonts[i].monoCase.parent.parentNode.removeChild(this.fonts[i].monoCase.parent);
	          }
	        }
	      }
	
	      if (loadedCount !== 0 && Date.now() - this.initTime < maxWaitingTime) {
	        setTimeout(this.checkLoadedFontsBinded, 20);
	      } else {
	        setTimeout(this.setIsLoadedBinded, 10);
	      }
	    }
	
	    function createHelper(fontData, def) {
	      var engine = document.body && def ? 'svg' : 'canvas';
	      var helper;
	      var fontProps = getFontProperties(fontData);
	
	      if (engine === 'svg') {
	        var tHelper = createNS('text');
	        tHelper.style.fontSize = '100px'; // tHelper.style.fontFamily = fontData.fFamily;
	
	        tHelper.setAttribute('font-family', fontData.fFamily);
	        tHelper.setAttribute('font-style', fontProps.style);
	        tHelper.setAttribute('font-weight', fontProps.weight);
	        tHelper.textContent = '1';
	
	        if (fontData.fClass) {
	          tHelper.style.fontFamily = 'inherit';
	          tHelper.setAttribute('class', fontData.fClass);
	        } else {
	          tHelper.style.fontFamily = fontData.fFamily;
	        }
	
	        def.appendChild(tHelper);
	        helper = tHelper;
	      } else {
	        var tCanvasHelper = new OffscreenCanvas(500, 500).getContext('2d');
	        tCanvasHelper.font = fontProps.style + ' ' + fontProps.weight + ' 100px ' + fontData.fFamily;
	        helper = tCanvasHelper;
	      }
	
	      function measure(text) {
	        if (engine === 'svg') {
	          helper.textContent = text;
	          return helper.getComputedTextLength();
	        }
	
	        return helper.measureText(text).width;
	      }
	
	      return {
	        measureText: measure
	      };
	    }
	
	    function addFonts(fontData, defs) {
	      if (!fontData) {
	        this.isLoaded = true;
	        return;
	      }
	
	      if (this.chars) {
	        this.isLoaded = true;
	        this.fonts = fontData.list;
	        return;
	      }
	
	      if (!document.body) {
	        this.isLoaded = true;
	        fontData.list.forEach(function (data) {
	          data.helper = createHelper(data);
	          data.cache = {};
	        });
	        this.fonts = fontData.list;
	        return;
	      }
	
	      var fontArr = fontData.list;
	      var i;
	      var len = fontArr.length;
	      var _pendingFonts = len;
	
	      for (i = 0; i < len; i += 1) {
	        var shouldLoadFont = true;
	        var loadedSelector;
	        var j;
	        fontArr[i].loaded = false;
	        fontArr[i].monoCase = setUpNode(fontArr[i].fFamily, 'monospace');
	        fontArr[i].sansCase = setUpNode(fontArr[i].fFamily, 'sans-serif');
	
	        if (!fontArr[i].fPath) {
	          fontArr[i].loaded = true;
	          _pendingFonts -= 1;
	        } else if (fontArr[i].fOrigin === 'p' || fontArr[i].origin === 3) {
	          loadedSelector = document.querySelectorAll('style[f-forigin="p"][f-family="' + fontArr[i].fFamily + '"], style[f-origin="3"][f-family="' + fontArr[i].fFamily + '"]');
	
	          if (loadedSelector.length > 0) {
	            shouldLoadFont = false;
	          }
	
	          if (shouldLoadFont) {
	            var s = createTag('style');
	            s.setAttribute('f-forigin', fontArr[i].fOrigin);
	            s.setAttribute('f-origin', fontArr[i].origin);
	            s.setAttribute('f-family', fontArr[i].fFamily);
	            s.type = 'text/css';
	            s.innerText = '@font-face {font-family: ' + fontArr[i].fFamily + "; font-style: normal; src: url('" + fontArr[i].fPath + "');}";
	            defs.appendChild(s);
	          }
	        } else if (fontArr[i].fOrigin === 'g' || fontArr[i].origin === 1) {
	          loadedSelector = document.querySelectorAll('link[f-forigin="g"], link[f-origin="1"]');
	
	          for (j = 0; j < loadedSelector.length; j += 1) {
	            if (loadedSelector[j].href.indexOf(fontArr[i].fPath) !== -1) {
	              // Font is already loaded
	              shouldLoadFont = false;
	            }
	          }
	
	          if (shouldLoadFont) {
	            var l = createTag('link');
	            l.setAttribute('f-forigin', fontArr[i].fOrigin);
	            l.setAttribute('f-origin', fontArr[i].origin);
	            l.type = 'text/css';
	            l.rel = 'stylesheet';
	            l.href = fontArr[i].fPath;
	            document.body.appendChild(l);
	          }
	        } else if (fontArr[i].fOrigin === 't' || fontArr[i].origin === 2) {
	          loadedSelector = document.querySelectorAll('script[f-forigin="t"], script[f-origin="2"]');
	
	          for (j = 0; j < loadedSelector.length; j += 1) {
	            if (fontArr[i].fPath === loadedSelector[j].src) {
	              // Font is already loaded
	              shouldLoadFont = false;
	            }
	          }
	
	          if (shouldLoadFont) {
	            var sc = createTag('link');
	            sc.setAttribute('f-forigin', fontArr[i].fOrigin);
	            sc.setAttribute('f-origin', fontArr[i].origin);
	            sc.setAttribute('rel', 'stylesheet');
	            sc.setAttribute('href', fontArr[i].fPath);
	            defs.appendChild(sc);
	          }
	        }
	
	        fontArr[i].helper = createHelper(fontArr[i], defs);
	        fontArr[i].cache = {};
	        this.fonts.push(fontArr[i]);
	      }
	
	      if (_pendingFonts === 0) {
	        this.isLoaded = true;
	      } else {
	        // On some cases even if the font is loaded, it won't load correctly when measuring text on canvas.
	        // Adding this timeout seems to fix it
	        setTimeout(this.checkLoadedFonts.bind(this), 100);
	      }
	    }
	
	    function addChars(chars) {
	      if (!chars) {
	        return;
	      }
	
	      if (!this.chars) {
	        this.chars = [];
	      }
	
	      var i;
	      var len = chars.length;
	      var j;
	      var jLen = this.chars.length;
	      var found;
	
	      for (i = 0; i < len; i += 1) {
	        j = 0;
	        found = false;
	
	        while (j < jLen) {
	          if (this.chars[j].style === chars[i].style && this.chars[j].fFamily === chars[i].fFamily && this.chars[j].ch === chars[i].ch) {
	            found = true;
	          }
	
	          j += 1;
	        }
	
	        if (!found) {
	          this.chars.push(chars[i]);
	          jLen += 1;
	        }
	      }
	    }
	
	    function getCharData(_char, style, font) {
	      var i = 0;
	      var len = this.chars.length;
	
	      while (i < len) {
	        if (this.chars[i].ch === _char && this.chars[i].style === style && this.chars[i].fFamily === font) {
	          return this.chars[i];
	        }
	
	        i += 1;
	      }
	
	      if ((typeof _char === 'string' && _char.charCodeAt(0) !== 13 || !_char) && console && console.warn // eslint-disable-line no-console
	      && !this._warned) {
	        this._warned = true;
	        console.warn('Missing character from exported characters list: ', _char, style, font); // eslint-disable-line no-console
	      }
	
	      return emptyChar;
	    }
	
	    function measureText(_char2, fontName, size) {
	      var fontData = this.getFontByName(fontName); // Using the char instead of char.charCodeAt(0)
	      // to avoid collisions between equal chars
	
	      var index = _char2;
	
	      if (!fontData.cache[index]) {
	        var tHelper = fontData.helper;
	
	        if (_char2 === ' ') {
	          var doubleSize = tHelper.measureText('|' + _char2 + '|');
	          var singleSize = tHelper.measureText('||');
	          fontData.cache[index] = (doubleSize - singleSize) / 100;
	        } else {
	          fontData.cache[index] = tHelper.measureText(_char2) / 100;
	        }
	      }
	
	      return fontData.cache[index] * size;
	    }
	
	    function getFontByName(name) {
	      var i = 0;
	      var len = this.fonts.length;
	
	      while (i < len) {
	        if (this.fonts[i].fName === name) {
	          return this.fonts[i];
	        }
	
	        i += 1;
	      }
	
	      return this.fonts[0];
	    }
	
	    function getCodePoint(string) {
	      var codePoint = 0;
	      var first = string.charCodeAt(0);
	
	      if (first >= 0xD800 && first <= 0xDBFF) {
	        var second = string.charCodeAt(1);
	
	        if (second >= 0xDC00 && second <= 0xDFFF) {
	          codePoint = (first - 0xD800) * 0x400 + second - 0xDC00 + 0x10000;
	        }
	      }
	
	      return codePoint;
	    } // Skin tone modifiers
	
	
	    function isModifier(firstCharCode, secondCharCode) {
	      var sum = firstCharCode.toString(16) + secondCharCode.toString(16);
	      return surrogateModifiers.indexOf(sum) !== -1;
	    }
	
	    function isZeroWidthJoiner(charCode) {
	      return charCode === ZERO_WIDTH_JOINER_CODE_POINT;
	    } // This codepoint may change the appearance of the preceding character.
	    // If that is a symbol, dingbat or emoji, U+FE0F forces it to be rendered
	    // as a colorful image as compared to a monochrome text variant.
	
	
	    function isVariationSelector(charCode) {
	      return charCode === VARIATION_SELECTOR_16_CODE_POINT;
	    } // The regional indicator symbols are a set of 26 alphabetic Unicode
	    /// characters (A–Z) intended to be used to encode ISO 3166-1 alpha-2
	    // two-letter country codes in a way that allows optional special treatment.
	
	
	    function isRegionalCode(string) {
	      var codePoint = getCodePoint(string);
	
	      if (codePoint >= REGIONAL_CHARACTER_A_CODE_POINT && codePoint <= REGIONAL_CHARACTER_Z_CODE_POINT) {
	        return true;
	      }
	
	      return false;
	    } // Some Emoji implementations represent combinations of
	    // two “regional indicator” letters as a single flag symbol.
	
	
	    function isFlagEmoji(string) {
	      return isRegionalCode(string.substr(0, 2)) && isRegionalCode(string.substr(2, 2));
	    }
	
	    function isCombinedCharacter(_char3) {
	      return combinedCharacters.indexOf(_char3) !== -1;
	    } // Regional flags start with a BLACK_FLAG_CODE_POINT
	    // folowed by 5 chars in the TAG range
	    // and end with a CANCEL_TAG_CODE_POINT
	
	
	    function isRegionalFlag(text, index) {
	      var codePoint = getCodePoint(text.substr(index, 2));
	
	      if (codePoint !== BLACK_FLAG_CODE_POINT) {
	        return false;
	      }
	
	      var count = 0;
	      index += 2;
	
	      while (count < 5) {
	        codePoint = getCodePoint(text.substr(index, 2));
	
	        if (codePoint < A_TAG_CODE_POINT || codePoint > Z_TAG_CODE_POINT) {
	          return false;
	        }
	
	        count += 1;
	        index += 2;
	      }
	
	      return getCodePoint(text.substr(index, 2)) === CANCEL_TAG_CODE_POINT;
	    }
	
	    function setIsLoaded() {
	      this.isLoaded = true;
	    }
	
	    var Font = function Font() {
	      this.fonts = [];
	      this.chars = null;
	      this.typekitLoaded = 0;
	      this.isLoaded = false;
	      this._warned = false;
	      this.initTime = Date.now();
	      this.setIsLoadedBinded = this.setIsLoaded.bind(this);
	      this.checkLoadedFontsBinded = this.checkLoadedFonts.bind(this);
	    };
	
	    Font.isModifier = isModifier;
	    Font.isZeroWidthJoiner = isZeroWidthJoiner;
	    Font.isFlagEmoji = isFlagEmoji;
	    Font.isRegionalCode = isRegionalCode;
	    Font.isCombinedCharacter = isCombinedCharacter;
	    Font.isRegionalFlag = isRegionalFlag;
	    Font.isVariationSelector = isVariationSelector;
	    Font.BLACK_FLAG_CODE_POINT = BLACK_FLAG_CODE_POINT;
	    var fontPrototype = {
	      addChars: addChars,
	      addFonts: addFonts,
	      getCharData: getCharData,
	      getFontByName: getFontByName,
	      measureText: measureText,
	      checkLoadedFonts: checkLoadedFonts,
	      setIsLoaded: setIsLoaded
	    };
	    Font.prototype = fontPrototype;
	    return Font;
	  }();
	
	  function SlotManager(animationData) {
	    this.animationData = animationData;
	  }
	
	  SlotManager.prototype.getProp = function (data) {
	    if (this.animationData.slots && this.animationData.slots[data.sid]) {
	      return Object.assign(data, this.animationData.slots[data.sid].p);
	    }
	
	    return data;
	  };
	
	  function slotFactory(animationData) {
	    return new SlotManager(animationData);
	  }
	
	  function RenderableElement() {}
	
	  RenderableElement.prototype = {
	    initRenderable: function initRenderable() {
	      // layer's visibility related to inpoint and outpoint. Rename isVisible to isInRange
	      this.isInRange = false; // layer's display state
	
	      this.hidden = false; // If layer's transparency equals 0, it can be hidden
	
	      this.isTransparent = false; // list of animated components
	
	      this.renderableComponents = [];
	    },
	    addRenderableComponent: function addRenderableComponent(component) {
	      if (this.renderableComponents.indexOf(component) === -1) {
	        this.renderableComponents.push(component);
	      }
	    },
	    removeRenderableComponent: function removeRenderableComponent(component) {
	      if (this.renderableComponents.indexOf(component) !== -1) {
	        this.renderableComponents.splice(this.renderableComponents.indexOf(component), 1);
	      }
	    },
	    prepareRenderableFrame: function prepareRenderableFrame(num) {
	      this.checkLayerLimits(num);
	    },
	    checkTransparency: function checkTransparency() {
	      if (this.finalTransform.mProp.o.v <= 0) {
	        if (!this.isTransparent && this.globalData.renderConfig.hideOnTransparent) {
	          this.isTransparent = true;
	          this.hide();
	        }
	      } else if (this.isTransparent) {
	        this.isTransparent = false;
	        this.show();
	      }
	    },
	
	    /**
	       * @function
	       * Initializes frame related properties.
	       *
	       * @param {number} num
	       * current frame number in Layer's time
	       *
	       */
	    checkLayerLimits: function checkLayerLimits(num) {
	      if (this.data.ip - this.data.st <= num && this.data.op - this.data.st > num) {
	        if (this.isInRange !== true) {
	          this.globalData._mdf = true;
	          this._mdf = true;
	          this.isInRange = true;
	          this.show();
	        }
	      } else if (this.isInRange !== false) {
	        this.globalData._mdf = true;
	        this.isInRange = false;
	        this.hide();
	      }
	    },
	    renderRenderable: function renderRenderable() {
	      var i;
	      var len = this.renderableComponents.length;
	
	      for (i = 0; i < len; i += 1) {
	        this.renderableComponents[i].renderFrame(this._isFirstFrame);
	      }
	      /* this.maskManager.renderFrame(this.finalTransform.mat);
	          this.renderableEffectsManager.renderFrame(this._isFirstFrame); */
	
	    },
	    sourceRectAtTime: function sourceRectAtTime() {
	      return {
	        top: 0,
	        left: 0,
	        width: 100,
	        height: 100
	      };
	    },
	    getLayerSize: function getLayerSize() {
	      if (this.data.ty === 5) {
	        return {
	          w: this.data.textData.width,
	          h: this.data.textData.height
	        };
	      }
	
	      return {
	        w: this.data.width,
	        h: this.data.height
	      };
	    }
	  };
	
	  var getBlendMode = function () {
	    var blendModeEnums = {
	      0: 'source-over',
	      1: 'multiply',
	      2: 'screen',
	      3: 'overlay',
	      4: 'darken',
	      5: 'lighten',
	      6: 'color-dodge',
	      7: 'color-burn',
	      8: 'hard-light',
	      9: 'soft-light',
	      10: 'difference',
	      11: 'exclusion',
	      12: 'hue',
	      13: 'saturation',
	      14: 'color',
	      15: 'luminosity'
	    };
	    return function (mode) {
	      return blendModeEnums[mode] || '';
	    };
	  }();
	
	  function SliderEffect(data, elem, container) {
	    this.p = PropertyFactory.getProp(elem, data.v, 0, 0, container);
	  }
	
	  function AngleEffect(data, elem, container) {
	    this.p = PropertyFactory.getProp(elem, data.v, 0, 0, container);
	  }
	
	  function ColorEffect(data, elem, container) {
	    this.p = PropertyFactory.getProp(elem, data.v, 1, 0, container);
	  }
	
	  function PointEffect(data, elem, container) {
	    this.p = PropertyFactory.getProp(elem, data.v, 1, 0, container);
	  }
	
	  function LayerIndexEffect(data, elem, container) {
	    this.p = PropertyFactory.getProp(elem, data.v, 0, 0, container);
	  }
	
	  function MaskIndexEffect(data, elem, container) {
	    this.p = PropertyFactory.getProp(elem, data.v, 0, 0, container);
	  }
	
	  function CheckboxEffect(data, elem, container) {
	    this.p = PropertyFactory.getProp(elem, data.v, 0, 0, container);
	  }
	
	  function NoValueEffect() {
	    this.p = {};
	  }
	
	  function EffectsManager(data, element) {
	    var effects = data.ef || [];
	    this.effectElements = [];
	    var i;
	    var len = effects.length;
	    var effectItem;
	
	    for (i = 0; i < len; i += 1) {
	      effectItem = new GroupEffect(effects[i], element);
	      this.effectElements.push(effectItem);
	    }
	  }
	
	  function GroupEffect(data, element) {
	    this.init(data, element);
	  }
	
	  extendPrototype([DynamicPropertyContainer], GroupEffect);
	  GroupEffect.prototype.getValue = GroupEffect.prototype.iterateDynamicProperties;
	
	  GroupEffect.prototype.init = function (data, element) {
	    this.data = data;
	    this.effectElements = [];
	    this.initDynamicPropertyContainer(element);
	    var i;
	    var len = this.data.ef.length;
	    var eff;
	    var effects = this.data.ef;
	
	    for (i = 0; i < len; i += 1) {
	      eff = null;
	
	      switch (effects[i].ty) {
	        case 0:
	          eff = new SliderEffect(effects[i], element, this);
	          break;
	
	        case 1:
	          eff = new AngleEffect(effects[i], element, this);
	          break;
	
	        case 2:
	          eff = new ColorEffect(effects[i], element, this);
	          break;
	
	        case 3:
	          eff = new PointEffect(effects[i], element, this);
	          break;
	
	        case 4:
	        case 7:
	          eff = new CheckboxEffect(effects[i], element, this);
	          break;
	
	        case 10:
	          eff = new LayerIndexEffect(effects[i], element, this);
	          break;
	
	        case 11:
	          eff = new MaskIndexEffect(effects[i], element, this);
	          break;
	
	        case 5:
	          eff = new EffectsManager(effects[i], element, this);
	          break;
	        // case 6:
	
	        default:
	          eff = new NoValueEffect(effects[i], element, this);
	          break;
	      }
	
	      if (eff) {
	        this.effectElements.push(eff);
	      }
	    }
	  };
	
	  function BaseElement() {}
	
	  BaseElement.prototype = {
	    checkMasks: function checkMasks() {
	      if (!this.data.hasMask) {
	        return false;
	      }
	
	      var i = 0;
	      var len = this.data.masksProperties.length;
	
	      while (i < len) {
	        if (this.data.masksProperties[i].mode !== 'n' && this.data.masksProperties[i].cl !== false) {
	          return true;
	        }
	
	        i += 1;
	      }
	
	      return false;
	    },
	    initExpressions: function initExpressions() {
	      var expressionsInterfaces = getExpressionInterfaces();
	
	      if (!expressionsInterfaces) {
	        return;
	      }
	
	      var LayerExpressionInterface = expressionsInterfaces('layer');
	      var EffectsExpressionInterface = expressionsInterfaces('effects');
	      var ShapeExpressionInterface = expressionsInterfaces('shape');
	      var TextExpressionInterface = expressionsInterfaces('text');
	      var CompExpressionInterface = expressionsInterfaces('comp');
	      this.layerInterface = LayerExpressionInterface(this);
	
	      if (this.data.hasMask && this.maskManager) {
	        this.layerInterface.registerMaskInterface(this.maskManager);
	      }
	
	      var effectsInterface = EffectsExpressionInterface.createEffectsInterface(this, this.layerInterface);
	      this.layerInterface.registerEffectsInterface(effectsInterface);
	
	      if (this.data.ty === 0 || this.data.xt) {
	        this.compInterface = CompExpressionInterface(this);
	      } else if (this.data.ty === 4) {
	        this.layerInterface.shapeInterface = ShapeExpressionInterface(this.shapesData, this.itemsData, this.layerInterface);
	        this.layerInterface.content = this.layerInterface.shapeInterface;
	      } else if (this.data.ty === 5) {
	        this.layerInterface.textInterface = TextExpressionInterface(this);
	        this.layerInterface.text = this.layerInterface.textInterface;
	      }
	    },
	    setBlendMode: function setBlendMode() {
	      var blendModeValue = getBlendMode(this.data.bm);
	      var elem = this.baseElement || this.layerElement;
	      elem.style['mix-blend-mode'] = blendModeValue;
	    },
	    initBaseData: function initBaseData(data, globalData, comp) {
	      this.globalData = globalData;
	      this.comp = comp;
	      this.data = data;
	      this.layerId = createElementID(); // Stretch factor for old animations missing this property.
	
	      if (!this.data.sr) {
	        this.data.sr = 1;
	      } // effects manager
	
	
	      this.effectsManager = new EffectsManager(this.data, this, this.dynamicProperties);
	    },
	    getType: function getType() {
	      return this.type;
	    },
	    sourceRectAtTime: function sourceRectAtTime() {}
	  };
	
	  /**
	   * @file
	   * Handles element's layer frame update.
	   * Checks layer in point and out point
	   *
	   */
	  function FrameElement() {}
	
	  FrameElement.prototype = {
	    /**
	       * @function
	       * Initializes frame related properties.
	       *
	       */
	    initFrame: function initFrame() {
	      // set to true when inpoint is rendered
	      this._isFirstFrame = false; // list of animated properties
	
	      this.dynamicProperties = []; // If layer has been modified in current tick this will be true
	
	      this._mdf = false;
	    },
	
	    /**
	       * @function
	       * Calculates all dynamic values
	       *
	       * @param {number} num
	       * current frame number in Layer's time
	       * @param {boolean} isVisible
	       * if layers is currently in range
	       *
	       */
	    prepareProperties: function prepareProperties(num, isVisible) {
	      var i;
	      var len = this.dynamicProperties.length;
	
	      for (i = 0; i < len; i += 1) {
	        if (isVisible || this._isParent && this.dynamicProperties[i].propType === 'transform') {
	          this.dynamicProperties[i].getValue();
	
	          if (this.dynamicProperties[i]._mdf) {
	            this.globalData._mdf = true;
	            this._mdf = true;
	          }
	        }
	      }
	    },
	    addDynamicProperty: function addDynamicProperty(prop) {
	      if (this.dynamicProperties.indexOf(prop) === -1) {
	        this.dynamicProperties.push(prop);
	      }
	    }
	  };
	
	  function FootageElement(data, globalData, comp) {
	    this.initFrame();
	    this.initRenderable();
	    this.assetData = globalData.getAssetData(data.refId);
	    this.footageData = globalData.imageLoader.getAsset(this.assetData);
	    this.initBaseData(data, globalData, comp);
	  }
	
	  FootageElement.prototype.prepareFrame = function () {};
	
	  extendPrototype([RenderableElement, BaseElement, FrameElement], FootageElement);
	
	  FootageElement.prototype.getBaseElement = function () {
	    return null;
	  };
	
	  FootageElement.prototype.renderFrame = function () {};
	
	  FootageElement.prototype.destroy = function () {};
	
	  FootageElement.prototype.initExpressions = function () {
	    var expressionsInterfaces = getExpressionInterfaces();
	
	    if (!expressionsInterfaces) {
	      return;
	    }
	
	    var FootageInterface = expressionsInterfaces('footage');
	    this.layerInterface = FootageInterface(this);
	  };
	
	  FootageElement.prototype.getFootageData = function () {
	    return this.footageData;
	  };
	
	  function AudioElement(data, globalData, comp) {
	    this.initFrame();
	    this.initRenderable();
	    this.assetData = globalData.getAssetData(data.refId);
	    this.initBaseData(data, globalData, comp);
	    this._isPlaying = false;
	    this._canPlay = false;
	    var assetPath = this.globalData.getAssetsPath(this.assetData);
	    this.audio = this.globalData.audioController.createAudio(assetPath);
	    this._currentTime = 0;
	    this.globalData.audioController.addAudio(this);
	    this._volumeMultiplier = 1;
	    this._volume = 1;
	    this._previousVolume = null;
	    this.tm = data.tm ? PropertyFactory.getProp(this, data.tm, 0, globalData.frameRate, this) : {
	      _placeholder: true
	    };
	    this.lv = PropertyFactory.getProp(this, data.au && data.au.lv ? data.au.lv : {
	      k: [100]
	    }, 1, 0.01, this);
	  }
	
	  AudioElement.prototype.prepareFrame = function (num) {
	    this.prepareRenderableFrame(num, true);
	    this.prepareProperties(num, true);
	
	    if (!this.tm._placeholder) {
	      var timeRemapped = this.tm.v;
	      this._currentTime = timeRemapped;
	    } else {
	      this._currentTime = num / this.data.sr;
	    }
	
	    this._volume = this.lv.v[0];
	    var totalVolume = this._volume * this._volumeMultiplier;
	
	    if (this._previousVolume !== totalVolume) {
	      this._previousVolume = totalVolume;
	      this.audio.volume(totalVolume);
	    }
	  };
	
	  extendPrototype([RenderableElement, BaseElement, FrameElement], AudioElement);
	
	  AudioElement.prototype.renderFrame = function () {
	    if (this.isInRange && this._canPlay) {
	      if (!this._isPlaying) {
	        this.audio.play();
	        this.audio.seek(this._currentTime / this.globalData.frameRate);
	        this._isPlaying = true;
	      } else if (!this.audio.playing() || Math.abs(this._currentTime / this.globalData.frameRate - this.audio.seek()) > 0.1) {
	        this.audio.seek(this._currentTime / this.globalData.frameRate);
	      }
	    }
	  };
	
	  AudioElement.prototype.show = function () {// this.audio.play()
	  };
	
	  AudioElement.prototype.hide = function () {
	    this.audio.pause();
	    this._isPlaying = false;
	  };
	
	  AudioElement.prototype.pause = function () {
	    this.audio.pause();
	    this._isPlaying = false;
	    this._canPlay = false;
	  };
	
	  AudioElement.prototype.resume = function () {
	    this._canPlay = true;
	  };
	
	  AudioElement.prototype.setRate = function (rateValue) {
	    this.audio.rate(rateValue);
	  };
	
	  AudioElement.prototype.volume = function (volumeValue) {
	    this._volumeMultiplier = volumeValue;
	    this._previousVolume = volumeValue * this._volume;
	    this.audio.volume(this._previousVolume);
	  };
	
	  AudioElement.prototype.getBaseElement = function () {
	    return null;
	  };
	
	  AudioElement.prototype.destroy = function () {};
	
	  AudioElement.prototype.sourceRectAtTime = function () {};
	
	  AudioElement.prototype.initExpressions = function () {};
	
	  function BaseRenderer() {}
	
	  BaseRenderer.prototype.checkLayers = function (num) {
	    var i;
	    var len = this.layers.length;
	    var data;
	    this.completeLayers = true;
	
	    for (i = len - 1; i >= 0; i -= 1) {
	      if (!this.elements[i]) {
	        data = this.layers[i];
	
	        if (data.ip - data.st <= num - this.layers[i].st && data.op - data.st > num - this.layers[i].st) {
	          this.buildItem(i);
	        }
	      }
	
	      this.completeLayers = this.elements[i] ? this.completeLayers : false;
	    }
	
	    this.checkPendingElements();
	  };
	
	  BaseRenderer.prototype.createItem = function (layer) {
	    switch (layer.ty) {
	      case 2:
	        return this.createImage(layer);
	
	      case 0:
	        return this.createComp(layer);
	
	      case 1:
	        return this.createSolid(layer);
	
	      case 3:
	        return this.createNull(layer);
	
	      case 4:
	        return this.createShape(layer);
	
	      case 5:
	        return this.createText(layer);
	
	      case 6:
	        return this.createAudio(layer);
	
	      case 13:
	        return this.createCamera(layer);
	
	      case 15:
	        return this.createFootage(layer);
	
	      default:
	        return this.createNull(layer);
	    }
	  };
	
	  BaseRenderer.prototype.createCamera = function () {
	    throw new Error('You\'re using a 3d camera. Try the html renderer.');
	  };
	
	  BaseRenderer.prototype.createAudio = function (data) {
	    return new AudioElement(data, this.globalData, this);
	  };
	
	  BaseRenderer.prototype.createFootage = function (data) {
	    return new FootageElement(data, this.globalData, this);
	  };
	
	  BaseRenderer.prototype.buildAllItems = function () {
	    var i;
	    var len = this.layers.length;
	
	    for (i = 0; i < len; i += 1) {
	      this.buildItem(i);
	    }
	
	    this.checkPendingElements();
	  };
	
	  BaseRenderer.prototype.includeLayers = function (newLayers) {
	    this.completeLayers = false;
	    var i;
	    var len = newLayers.length;
	    var j;
	    var jLen = this.layers.length;
	
	    for (i = 0; i < len; i += 1) {
	      j = 0;
	
	      while (j < jLen) {
	        if (this.layers[j].id === newLayers[i].id) {
	          this.layers[j] = newLayers[i];
	          break;
	        }
	
	        j += 1;
	      }
	    }
	  };
	
	  BaseRenderer.prototype.setProjectInterface = function (pInterface) {
	    this.globalData.projectInterface = pInterface;
	  };
	
	  BaseRenderer.prototype.initItems = function () {
	    if (!this.globalData.progressiveLoad) {
	      this.buildAllItems();
	    }
	  };
	
	  BaseRenderer.prototype.buildElementParenting = function (element, parentName, hierarchy) {
	    var elements = this.elements;
	    var layers = this.layers;
	    var i = 0;
	    var len = layers.length;
	
	    while (i < len) {
	      if (layers[i].ind == parentName) {
	        // eslint-disable-line eqeqeq
	        if (!elements[i] || elements[i] === true) {
	          this.buildItem(i);
	          this.addPendingElement(element);
	        } else {
	          hierarchy.push(elements[i]);
	          elements[i].setAsParent();
	
	          if (layers[i].parent !== undefined) {
	            this.buildElementParenting(element, layers[i].parent, hierarchy);
	          } else {
	            element.setHierarchy(hierarchy);
	          }
	        }
	      }
	
	      i += 1;
	    }
	  };
	
	  BaseRenderer.prototype.addPendingElement = function (element) {
	    this.pendingElements.push(element);
	  };
	
	  BaseRenderer.prototype.searchExtraCompositions = function (assets) {
	    var i;
	    var len = assets.length;
	
	    for (i = 0; i < len; i += 1) {
	      if (assets[i].xt) {
	        var comp = this.createComp(assets[i]);
	        comp.initExpressions();
	        this.globalData.projectInterface.registerComposition(comp);
	      }
	    }
	  };
	
	  BaseRenderer.prototype.getElementById = function (ind) {
	    var i;
	    var len = this.elements.length;
	
	    for (i = 0; i < len; i += 1) {
	      if (this.elements[i].data.ind === ind) {
	        return this.elements[i];
	      }
	    }
	
	    return null;
	  };
	
	  BaseRenderer.prototype.getElementByPath = function (path) {
	    var pathValue = path.shift();
	    var element;
	
	    if (typeof pathValue === 'number') {
	      element = this.elements[pathValue];
	    } else {
	      var i;
	      var len = this.elements.length;
	
	      for (i = 0; i < len; i += 1) {
	        if (this.elements[i].data.nm === pathValue) {
	          element = this.elements[i];
	          break;
	        }
	      }
	    }
	
	    if (path.length === 0) {
	      return element;
	    }
	
	    return element.getElementByPath(path);
	  };
	
	  BaseRenderer.prototype.setupGlobalData = function (animData, fontsContainer) {
	    this.globalData.fontManager = new FontManager();
	    this.globalData.slotManager = slotFactory(animData);
	    this.globalData.fontManager.addChars(animData.chars);
	    this.globalData.fontManager.addFonts(animData.fonts, fontsContainer);
	    this.globalData.getAssetData = this.animationItem.getAssetData.bind(this.animationItem);
	    this.globalData.getAssetsPath = this.animationItem.getAssetsPath.bind(this.animationItem);
	    this.globalData.imageLoader = this.animationItem.imagePreloader;
	    this.globalData.audioController = this.animationItem.audioController;
	    this.globalData.frameId = 0;
	    this.globalData.frameRate = animData.fr;
	    this.globalData.nm = animData.nm;
	    this.globalData.compSize = {
	      w: animData.w,
	      h: animData.h
	    };
	  };
	
	  var effectTypes = {
	    TRANSFORM_EFFECT: 'transformEFfect'
	  };
	
	  function TransformElement() {}
	
	  TransformElement.prototype = {
	    initTransform: function initTransform() {
	      var mat = new Matrix();
	      this.finalTransform = {
	        mProp: this.data.ks ? TransformPropertyFactory.getTransformProperty(this, this.data.ks, this) : {
	          o: 0
	        },
	        _matMdf: false,
	        _localMatMdf: false,
	        _opMdf: false,
	        mat: mat,
	        localMat: mat,
	        localOpacity: 1
	      };
	
	      if (this.data.ao) {
	        this.finalTransform.mProp.autoOriented = true;
	      } // TODO: check TYPE 11: Guided elements
	
	
	      if (this.data.ty !== 11) {// this.createElements();
	      }
	    },
	    renderTransform: function renderTransform() {
	      this.finalTransform._opMdf = this.finalTransform.mProp.o._mdf || this._isFirstFrame;
	      this.finalTransform._matMdf = this.finalTransform.mProp._mdf || this._isFirstFrame;
	
	      if (this.hierarchy) {
	        var mat;
	        var finalMat = this.finalTransform.mat;
	        var i = 0;
	        var len = this.hierarchy.length; // Checking if any of the transformation matrices in the hierarchy chain has changed.
	
	        if (!this.finalTransform._matMdf) {
	          while (i < len) {
	            if (this.hierarchy[i].finalTransform.mProp._mdf) {
	              this.finalTransform._matMdf = true;
	              break;
	            }
	
	            i += 1;
	          }
	        }
	
	        if (this.finalTransform._matMdf) {
	          mat = this.finalTransform.mProp.v.props;
	          finalMat.cloneFromProps(mat);
	
	          for (i = 0; i < len; i += 1) {
	            finalMat.multiply(this.hierarchy[i].finalTransform.mProp.v);
	          }
	        }
	      }
	
	      if (this.finalTransform._matMdf) {
	        this.finalTransform._localMatMdf = this.finalTransform._matMdf;
	      }
	
	      if (this.finalTransform._opMdf) {
	        this.finalTransform.localOpacity = this.finalTransform.mProp.o.v;
	      }
	    },
	    renderLocalTransform: function renderLocalTransform() {
	      if (this.localTransforms) {
	        var i = 0;
	        var len = this.localTransforms.length;
	        this.finalTransform._localMatMdf = this.finalTransform._matMdf;
	
	        if (!this.finalTransform._localMatMdf || !this.finalTransform._opMdf) {
	          while (i < len) {
	            if (this.localTransforms[i]._mdf) {
	              this.finalTransform._localMatMdf = true;
	            }
	
	            if (this.localTransforms[i]._opMdf && !this.finalTransform._opMdf) {
	              this.finalTransform.localOpacity = this.finalTransform.mProp.o.v;
	              this.finalTransform._opMdf = true;
	            }
	
	            i += 1;
	          }
	        }
	
	        if (this.finalTransform._localMatMdf) {
	          var localMat = this.finalTransform.localMat;
	          this.localTransforms[0].matrix.clone(localMat);
	
	          for (i = 1; i < len; i += 1) {
	            var lmat = this.localTransforms[i].matrix;
	            localMat.multiply(lmat);
	          }
	
	          localMat.multiply(this.finalTransform.mat);
	        }
	
	        if (this.finalTransform._opMdf) {
	          var localOp = this.finalTransform.localOpacity;
	
	          for (i = 0; i < len; i += 1) {
	            localOp *= this.localTransforms[i].opacity * 0.01;
	          }
	
	          this.finalTransform.localOpacity = localOp;
	        }
	      }
	    },
	    searchEffectTransforms: function searchEffectTransforms() {
	      if (this.renderableEffectsManager) {
	        var transformEffects = this.renderableEffectsManager.getEffects(effectTypes.TRANSFORM_EFFECT);
	
	        if (transformEffects.length) {
	          this.localTransforms = [];
	          this.finalTransform.localMat = new Matrix();
	          var i = 0;
	          var len = transformEffects.length;
	
	          for (i = 0; i < len; i += 1) {
	            this.localTransforms.push(transformEffects[i]);
	          }
	        }
	      }
	    },
	    globalToLocal: function globalToLocal(pt) {
	      var transforms = [];
	      transforms.push(this.finalTransform);
	      var flag = true;
	      var comp = this.comp;
	
	      while (flag) {
	        if (comp.finalTransform) {
	          if (comp.data.hasMask) {
	            transforms.splice(0, 0, comp.finalTransform);
	          }
	
	          comp = comp.comp;
	        } else {
	          flag = false;
	        }
	      }
	
	      var i;
	      var len = transforms.length;
	      var ptNew;
	
	      for (i = 0; i < len; i += 1) {
	        ptNew = transforms[i].mat.applyToPointArray(0, 0, 0); // ptNew = transforms[i].mat.applyToPointArray(pt[0],pt[1],pt[2]);
	
	        pt = [pt[0] - ptNew[0], pt[1] - ptNew[1], 0];
	      }
	
	      return pt;
	    },
	    mHelper: new Matrix()
	  };
	
	  function MaskElement(data, element, globalData) {
	    this.data = data;
	    this.element = element;
	    this.globalData = globalData;
	    this.storedData = [];
	    this.masksProperties = this.data.masksProperties || [];
	    this.maskElement = null;
	    var defs = this.globalData.defs;
	    var i;
	    var len = this.masksProperties ? this.masksProperties.length : 0;
	    this.viewData = createSizedArray(len);
	    this.solidPath = '';
	    var path;
	    var properties = this.masksProperties;
	    var count = 0;
	    var currentMasks = [];
	    var j;
	    var jLen;
	    var layerId = createElementID();
	    var rect;
	    var expansor;
	    var feMorph;
	    var x;
	    var maskType = 'clipPath';
	    var maskRef = 'clip-path';
	
	    for (i = 0; i < len; i += 1) {
	      if (properties[i].mode !== 'a' && properties[i].mode !== 'n' || properties[i].inv || properties[i].o.k !== 100 || properties[i].o.x) {
	        maskType = 'mask';
	        maskRef = 'mask';
	      }
	
	      if ((properties[i].mode === 's' || properties[i].mode === 'i') && count === 0) {
	        rect = createNS('rect');
	        rect.setAttribute('fill', '#ffffff');
	        rect.setAttribute('width', this.element.comp.data.w || 0);
	        rect.setAttribute('height', this.element.comp.data.h || 0);
	        currentMasks.push(rect);
	      } else {
	        rect = null;
	      }
	
	      path = createNS('path');
	
	      if (properties[i].mode === 'n') {
	        // TODO move this to a factory or to a constructor
	        this.viewData[i] = {
	          op: PropertyFactory.getProp(this.element, properties[i].o, 0, 0.01, this.element),
	          prop: ShapePropertyFactory.getShapeProp(this.element, properties[i], 3),
	          elem: path,
	          lastPath: ''
	        };
	        defs.appendChild(path);
	      } else {
	        count += 1;
	        path.setAttribute('fill', properties[i].mode === 's' ? '#000000' : '#ffffff');
	        path.setAttribute('clip-rule', 'nonzero');
	        var filterID;
	
	        if (properties[i].x.k !== 0) {
	          maskType = 'mask';
	          maskRef = 'mask';
	          x = PropertyFactory.getProp(this.element, properties[i].x, 0, null, this.element);
	          filterID = createElementID();
	          expansor = createNS('filter');
	          expansor.setAttribute('id', filterID);
	          feMorph = createNS('feMorphology');
	          feMorph.setAttribute('operator', 'erode');
	          feMorph.setAttribute('in', 'SourceGraphic');
	          feMorph.setAttribute('radius', '0');
	          expansor.appendChild(feMorph);
	          defs.appendChild(expansor);
	          path.setAttribute('stroke', properties[i].mode === 's' ? '#000000' : '#ffffff');
	        } else {
	          feMorph = null;
	          x = null;
	        } // TODO move this to a factory or to a constructor
	
	
	        this.storedData[i] = {
	          elem: path,
	          x: x,
	          expan: feMorph,
	          lastPath: '',
	          lastOperator: '',
	          filterId: filterID,
	          lastRadius: 0
	        };
	
	        if (properties[i].mode === 'i') {
	          jLen = currentMasks.length;
	          var g = createNS('g');
	
	          for (j = 0; j < jLen; j += 1) {
	            g.appendChild(currentMasks[j]);
	          }
	
	          var mask = createNS('mask');
	          mask.setAttribute('mask-type', 'alpha');
	          mask.setAttribute('id', layerId + '_' + count);
	          mask.appendChild(path);
	          defs.appendChild(mask);
	          g.setAttribute('mask', 'url(' + getLocationHref() + '#' + layerId + '_' + count + ')');
	          currentMasks.length = 0;
	          currentMasks.push(g);
	        } else {
	          currentMasks.push(path);
	        }
	
	        if (properties[i].inv && !this.solidPath) {
	          this.solidPath = this.createLayerSolidPath();
	        } // TODO move this to a factory or to a constructor
	
	
	        this.viewData[i] = {
	          elem: path,
	          lastPath: '',
	          op: PropertyFactory.getProp(this.element, properties[i].o, 0, 0.01, this.element),
	          prop: ShapePropertyFactory.getShapeProp(this.element, properties[i], 3),
	          invRect: rect
	        };
	
	        if (!this.viewData[i].prop.k) {
	          this.drawPath(properties[i], this.viewData[i].prop.v, this.viewData[i]);
	        }
	      }
	    }
	
	    this.maskElement = createNS(maskType);
	    len = currentMasks.length;
	
	    for (i = 0; i < len; i += 1) {
	      this.maskElement.appendChild(currentMasks[i]);
	    }
	
	    if (count > 0) {
	      this.maskElement.setAttribute('id', layerId);
	      this.element.maskedElement.setAttribute(maskRef, 'url(' + getLocationHref() + '#' + layerId + ')');
	      defs.appendChild(this.maskElement);
	    }
	
	    if (this.viewData.length) {
	      this.element.addRenderableComponent(this);
	    }
	  }
	
	  MaskElement.prototype.getMaskProperty = function (pos) {
	    return this.viewData[pos].prop;
	  };
	
	  MaskElement.prototype.renderFrame = function (isFirstFrame) {
	    var finalMat = this.element.finalTransform.mat;
	    var i;
	    var len = this.masksProperties.length;
	
	    for (i = 0; i < len; i += 1) {
	      if (this.viewData[i].prop._mdf || isFirstFrame) {
	        this.drawPath(this.masksProperties[i], this.viewData[i].prop.v, this.viewData[i]);
	      }
	
	      if (this.viewData[i].op._mdf || isFirstFrame) {
	        this.viewData[i].elem.setAttribute('fill-opacity', this.viewData[i].op.v);
	      }
	
	      if (this.masksProperties[i].mode !== 'n') {
	        if (this.viewData[i].invRect && (this.element.finalTransform.mProp._mdf || isFirstFrame)) {
	          this.viewData[i].invRect.setAttribute('transform', finalMat.getInverseMatrix().to2dCSS());
	        }
	
	        if (this.storedData[i].x && (this.storedData[i].x._mdf || isFirstFrame)) {
	          var feMorph = this.storedData[i].expan;
	
	          if (this.storedData[i].x.v < 0) {
	            if (this.storedData[i].lastOperator !== 'erode') {
	              this.storedData[i].lastOperator = 'erode';
	              this.storedData[i].elem.setAttribute('filter', 'url(' + getLocationHref() + '#' + this.storedData[i].filterId + ')');
	            }
	
	            feMorph.setAttribute('radius', -this.storedData[i].x.v);
	          } else {
	            if (this.storedData[i].lastOperator !== 'dilate') {
	              this.storedData[i].lastOperator = 'dilate';
	              this.storedData[i].elem.setAttribute('filter', null);
	            }
	
	            this.storedData[i].elem.setAttribute('stroke-width', this.storedData[i].x.v * 2);
	          }
	        }
	      }
	    }
	  };
	
	  MaskElement.prototype.getMaskelement = function () {
	    return this.maskElement;
	  };
	
	  MaskElement.prototype.createLayerSolidPath = function () {
	    var path = 'M0,0 ';
	    path += ' h' + this.globalData.compSize.w;
	    path += ' v' + this.globalData.compSize.h;
	    path += ' h-' + this.globalData.compSize.w;
	    path += ' v-' + this.globalData.compSize.h + ' ';
	    return path;
	  };
	
	  MaskElement.prototype.drawPath = function (pathData, pathNodes, viewData) {
	    var pathString = ' M' + pathNodes.v[0][0] + ',' + pathNodes.v[0][1];
	    var i;
	    var len;
	    len = pathNodes._length;
	
	    for (i = 1; i < len; i += 1) {
	      // pathString += " C"+pathNodes.o[i-1][0]+','+pathNodes.o[i-1][1] + " "+pathNodes.i[i][0]+','+pathNodes.i[i][1] + " "+pathNodes.v[i][0]+','+pathNodes.v[i][1];
	      pathString += ' C' + pathNodes.o[i - 1][0] + ',' + pathNodes.o[i - 1][1] + ' ' + pathNodes.i[i][0] + ',' + pathNodes.i[i][1] + ' ' + pathNodes.v[i][0] + ',' + pathNodes.v[i][1];
	    } // pathString += " C"+pathNodes.o[i-1][0]+','+pathNodes.o[i-1][1] + " "+pathNodes.i[0][0]+','+pathNodes.i[0][1] + " "+pathNodes.v[0][0]+','+pathNodes.v[0][1];
	
	
	    if (pathNodes.c && len > 1) {
	      pathString += ' C' + pathNodes.o[i - 1][0] + ',' + pathNodes.o[i - 1][1] + ' ' + pathNodes.i[0][0] + ',' + pathNodes.i[0][1] + ' ' + pathNodes.v[0][0] + ',' + pathNodes.v[0][1];
	    } // pathNodes.__renderedString = pathString;
	
	
	    if (viewData.lastPath !== pathString) {
	      var pathShapeValue = '';
	
	      if (viewData.elem) {
	        if (pathNodes.c) {
	          pathShapeValue = pathData.inv ? this.solidPath + pathString : pathString;
	        }
	
	        viewData.elem.setAttribute('d', pathShapeValue);
	      }
	
	      viewData.lastPath = pathString;
	    }
	  };
	
	  MaskElement.prototype.destroy = function () {
	    this.element = null;
	    this.globalData = null;
	    this.maskElement = null;
	    this.data = null;
	    this.masksProperties = null;
	  };
	
	  var filtersFactory = function () {
	    var ob = {};
	    ob.createFilter = createFilter;
	    ob.createAlphaToLuminanceFilter = createAlphaToLuminanceFilter;
	
	    function createFilter(filId, skipCoordinates) {
	      var fil = createNS('filter');
	      fil.setAttribute('id', filId);
	
	      if (skipCoordinates !== true) {
	        fil.setAttribute('filterUnits', 'objectBoundingBox');
	        fil.setAttribute('x', '0%');
	        fil.setAttribute('y', '0%');
	        fil.setAttribute('width', '100%');
	        fil.setAttribute('height', '100%');
	      }
	
	      return fil;
	    }
	
	    function createAlphaToLuminanceFilter() {
	      var feColorMatrix = createNS('feColorMatrix');
	      feColorMatrix.setAttribute('type', 'matrix');
	      feColorMatrix.setAttribute('color-interpolation-filters', 'sRGB');
	      feColorMatrix.setAttribute('values', '0 0 0 1 0  0 0 0 1 0  0 0 0 1 0  0 0 0 1 1');
	      return feColorMatrix;
	    }
	
	    return ob;
	  }();
	
	  var featureSupport = function () {
	    var ob = {
	      maskType: true,
	      svgLumaHidden: true,
	      offscreenCanvas: typeof OffscreenCanvas !== 'undefined'
	    };
	
	    if (/MSIE 10/i.test(navigator.userAgent) || /MSIE 9/i.test(navigator.userAgent) || /rv:11.0/i.test(navigator.userAgent) || /Edge\/\d./i.test(navigator.userAgent)) {
	      ob.maskType = false;
	    }
	
	    if (/firefox/i.test(navigator.userAgent)) {
	      ob.svgLumaHidden = false;
	    }
	
	    return ob;
	  }();
	
	  var registeredEffects$1 = {};
	  var idPrefix = 'filter_result_';
	
	  function SVGEffects(elem) {
	    var i;
	    var source = 'SourceGraphic';
	    var len = elem.data.ef ? elem.data.ef.length : 0;
	    var filId = createElementID();
	    var fil = filtersFactory.createFilter(filId, true);
	    var count = 0;
	    this.filters = [];
	    var filterManager;
	
	    for (i = 0; i < len; i += 1) {
	      filterManager = null;
	      var type = elem.data.ef[i].ty;
	
	      if (registeredEffects$1[type]) {
	        var Effect = registeredEffects$1[type].effect;
	        filterManager = new Effect(fil, elem.effectsManager.effectElements[i], elem, idPrefix + count, source);
	        source = idPrefix + count;
	
	        if (registeredEffects$1[type].countsAsEffect) {
	          count += 1;
	        }
	      }
	
	      if (filterManager) {
	        this.filters.push(filterManager);
	      }
	    }
	
	    if (count) {
	      elem.globalData.defs.appendChild(fil);
	      elem.layerElement.setAttribute('filter', 'url(' + getLocationHref() + '#' + filId + ')');
	    }
	
	    if (this.filters.length) {
	      elem.addRenderableComponent(this);
	    }
	  }
	
	  SVGEffects.prototype.renderFrame = function (_isFirstFrame) {
	    var i;
	    var len = this.filters.length;
	
	    for (i = 0; i < len; i += 1) {
	      this.filters[i].renderFrame(_isFirstFrame);
	    }
	  };
	
	  SVGEffects.prototype.getEffects = function (type) {
	    var i;
	    var len = this.filters.length;
	    var effects = [];
	
	    for (i = 0; i < len; i += 1) {
	      if (this.filters[i].type === type) {
	        effects.push(this.filters[i]);
	      }
	    }
	
	    return effects;
	  };
	
	  function registerEffect$1(id, effect, countsAsEffect) {
	    registeredEffects$1[id] = {
	      effect: effect,
	      countsAsEffect: countsAsEffect
	    };
	  }
	
	  function SVGBaseElement() {}
	
	  SVGBaseElement.prototype = {
	    initRendererElement: function initRendererElement() {
	      this.layerElement = createNS('g');
	    },
	    createContainerElements: function createContainerElements() {
	      this.matteElement = createNS('g');
	      this.transformedElement = this.layerElement;
	      this.maskedElement = this.layerElement;
	      this._sizeChanged = false;
	      var layerElementParent = null; // If this layer acts as a mask for the following layer
	
	      if (this.data.td) {
	        this.matteMasks = {};
	        var gg = createNS('g');
	        gg.setAttribute('id', this.layerId);
	        gg.appendChild(this.layerElement);
	        layerElementParent = gg;
	        this.globalData.defs.appendChild(gg);
	      } else if (this.data.tt) {
	        this.matteElement.appendChild(this.layerElement);
	        layerElementParent = this.matteElement;
	        this.baseElement = this.matteElement;
	      } else {
	        this.baseElement = this.layerElement;
	      }
	
	      if (this.data.ln) {
	        this.layerElement.setAttribute('id', this.data.ln);
	      }
	
	      if (this.data.cl) {
	        this.layerElement.setAttribute('class', this.data.cl);
	      } // Clipping compositions to hide content that exceeds boundaries. If collapsed transformations is on, component should not be clipped
	
	
	      if (this.data.ty === 0 && !this.data.hd) {
	        var cp = createNS('clipPath');
	        var pt = createNS('path');
	        pt.setAttribute('d', 'M0,0 L' + this.data.w + ',0 L' + this.data.w + ',' + this.data.h + ' L0,' + this.data.h + 'z');
	        var clipId = createElementID();
	        cp.setAttribute('id', clipId);
	        cp.appendChild(pt);
	        this.globalData.defs.appendChild(cp);
	
	        if (this.checkMasks()) {
	          var cpGroup = createNS('g');
	          cpGroup.setAttribute('clip-path', 'url(' + getLocationHref() + '#' + clipId + ')');
	          cpGroup.appendChild(this.layerElement);
	          this.transformedElement = cpGroup;
	
	          if (layerElementParent) {
	            layerElementParent.appendChild(this.transformedElement);
	          } else {
	            this.baseElement = this.transformedElement;
	          }
	        } else {
	          this.layerElement.setAttribute('clip-path', 'url(' + getLocationHref() + '#' + clipId + ')');
	        }
	      }
	
	      if (this.data.bm !== 0) {
	        this.setBlendMode();
	      }
	    },
	    renderElement: function renderElement() {
	      if (this.finalTransform._localMatMdf) {
	        this.transformedElement.setAttribute('transform', this.finalTransform.localMat.to2dCSS());
	      }
	
	      if (this.finalTransform._opMdf) {
	        this.transformedElement.setAttribute('opacity', this.finalTransform.localOpacity);
	      }
	    },
	    destroyBaseElement: function destroyBaseElement() {
	      this.layerElement = null;
	      this.matteElement = null;
	      this.maskManager.destroy();
	    },
	    getBaseElement: function getBaseElement() {
	      if (this.data.hd) {
	        return null;
	      }
	
	      return this.baseElement;
	    },
	    createRenderableComponents: function createRenderableComponents() {
	      this.maskManager = new MaskElement(this.data, this, this.globalData);
	      this.renderableEffectsManager = new SVGEffects(this);
	      this.searchEffectTransforms();
	    },
	    getMatte: function getMatte(matteType) {
	      // This should not be a common case. But for backward compatibility, we'll create the matte object.
	      // It solves animations that have two consecutive layers marked as matte masks.
	      // Which is an undefined behavior in AE.
	      if (!this.matteMasks) {
	        this.matteMasks = {};
	      }
	
	      if (!this.matteMasks[matteType]) {
	        var id = this.layerId + '_' + matteType;
	        var filId;
	        var fil;
	        var useElement;
	        var gg;
	
	        if (matteType === 1 || matteType === 3) {
	          var masker = createNS('mask');
	          masker.setAttribute('id', id);
	          masker.setAttribute('mask-type', matteType === 3 ? 'luminance' : 'alpha');
	          useElement = createNS('use');
	          useElement.setAttributeNS('http://www.w3.org/1999/xlink', 'href', '#' + this.layerId);
	          masker.appendChild(useElement);
	          this.globalData.defs.appendChild(masker);
	
	          if (!featureSupport.maskType && matteType === 1) {
	            masker.setAttribute('mask-type', 'luminance');
	            filId = createElementID();
	            fil = filtersFactory.createFilter(filId);
	            this.globalData.defs.appendChild(fil);
	            fil.appendChild(filtersFactory.createAlphaToLuminanceFilter());
	            gg = createNS('g');
	            gg.appendChild(useElement);
	            masker.appendChild(gg);
	            gg.setAttribute('filter', 'url(' + getLocationHref() + '#' + filId + ')');
	          }
	        } else if (matteType === 2) {
	          var maskGroup = createNS('mask');
	          maskGroup.setAttribute('id', id);
	          maskGroup.setAttribute('mask-type', 'alpha');
	          var maskGrouper = createNS('g');
	          maskGroup.appendChild(maskGrouper);
	          filId = createElementID();
	          fil = filtersFactory.createFilter(filId); /// /
	
	          var feCTr = createNS('feComponentTransfer');
	          feCTr.setAttribute('in', 'SourceGraphic');
	          fil.appendChild(feCTr);
	          var feFunc = createNS('feFuncA');
	          feFunc.setAttribute('type', 'table');
	          feFunc.setAttribute('tableValues', '1.0 0.0');
	          feCTr.appendChild(feFunc); /// /
	
	          this.globalData.defs.appendChild(fil);
	          var alphaRect = createNS('rect');
	          alphaRect.setAttribute('width', this.comp.data.w);
	          alphaRect.setAttribute('height', this.comp.data.h);
	          alphaRect.setAttribute('x', '0');
	          alphaRect.setAttribute('y', '0');
	          alphaRect.setAttribute('fill', '#ffffff');
	          alphaRect.setAttribute('opacity', '0');
	          maskGrouper.setAttribute('filter', 'url(' + getLocationHref() + '#' + filId + ')');
	          maskGrouper.appendChild(alphaRect);
	          useElement = createNS('use');
	          useElement.setAttributeNS('http://www.w3.org/1999/xlink', 'href', '#' + this.layerId);
	          maskGrouper.appendChild(useElement);
	
	          if (!featureSupport.maskType) {
	            maskGroup.setAttribute('mask-type', 'luminance');
	            fil.appendChild(filtersFactory.createAlphaToLuminanceFilter());
	            gg = createNS('g');
	            maskGrouper.appendChild(alphaRect);
	            gg.appendChild(this.layerElement);
	            maskGrouper.appendChild(gg);
	          }
	
	          this.globalData.defs.appendChild(maskGroup);
	        }
	
	        this.matteMasks[matteType] = id;
	      }
	
	      return this.matteMasks[matteType];
	    },
	    setMatte: function setMatte(id) {
	      if (!this.matteElement) {
	        return;
	      }
	
	      this.matteElement.setAttribute('mask', 'url(' + getLocationHref() + '#' + id + ')');
	    }
	  };
	
	  /**
	   * @file
	   * Handles AE's layer parenting property.
	   *
	   */
	  function HierarchyElement() {}
	
	  HierarchyElement.prototype = {
	    /**
	       * @function
	       * Initializes hierarchy properties
	       *
	       */
	    initHierarchy: function initHierarchy() {
	      // element's parent list
	      this.hierarchy = []; // if element is parent of another layer _isParent will be true
	
	      this._isParent = false;
	      this.checkParenting();
	    },
	
	    /**
	       * @function
	       * Sets layer's hierarchy.
	       * @param {array} hierarch
	       * layer's parent list
	       *
	       */
	    setHierarchy: function setHierarchy(hierarchy) {
	      this.hierarchy = hierarchy;
	    },
	
	    /**
	       * @function
	       * Sets layer as parent.
	       *
	       */
	    setAsParent: function setAsParent() {
	      this._isParent = true;
	    },
	
	    /**
	       * @function
	       * Searches layer's parenting chain
	       *
	       */
	    checkParenting: function checkParenting() {
	      if (this.data.parent !== undefined) {
	        this.comp.buildElementParenting(this, this.data.parent, []);
	      }
	    }
	  };
	
	  function RenderableDOMElement() {}
	
	  (function () {
	    var _prototype = {
	      initElement: function initElement(data, globalData, comp) {
	        this.initFrame();
	        this.initBaseData(data, globalData, comp);
	        this.initTransform(data, globalData, comp);
	        this.initHierarchy();
	        this.initRenderable();
	        this.initRendererElement();
	        this.createContainerElements();
	        this.createRenderableComponents();
	        this.createContent();
	        this.hide();
	      },
	      hide: function hide() {
	        // console.log('HIDE', this);
	        if (!this.hidden && (!this.isInRange || this.isTransparent)) {
	          var elem = this.baseElement || this.layerElement;
	          elem.style.display = 'none';
	          this.hidden = true;
	        }
	      },
	      show: function show() {
	        // console.log('SHOW', this);
	        if (this.isInRange && !this.isTransparent) {
	          if (!this.data.hd) {
	            var elem = this.baseElement || this.layerElement;
	            elem.style.display = 'block';
	          }
	
	          this.hidden = false;
	          this._isFirstFrame = true;
	        }
	      },
	      renderFrame: function renderFrame() {
	        // If it is exported as hidden (data.hd === true) no need to render
	        // If it is not visible no need to render
	        if (this.data.hd || this.hidden) {
	          return;
	        }
	
	        this.renderTransform();
	        this.renderRenderable();
	        this.renderLocalTransform();
	        this.renderElement();
	        this.renderInnerContent();
	
	        if (this._isFirstFrame) {
	          this._isFirstFrame = false;
	        }
	      },
	      renderInnerContent: function renderInnerContent() {},
	      prepareFrame: function prepareFrame(num) {
	        this._mdf = false;
	        this.prepareRenderableFrame(num);
	        this.prepareProperties(num, this.isInRange);
	        this.checkTransparency();
	      },
	      destroy: function destroy() {
	        this.innerElem = null;
	        this.destroyBaseElement();
	      }
	    };
	    extendPrototype([RenderableElement, createProxyFunction(_prototype)], RenderableDOMElement);
	  })();
	
	  function IImageElement(data, globalData, comp) {
	    this.assetData = globalData.getAssetData(data.refId);
	
	    if (this.assetData && this.assetData.sid) {
	      this.assetData = globalData.slotManager.getProp(this.assetData);
	    }
	
	    this.initElement(data, globalData, comp);
	    this.sourceRect = {
	      top: 0,
	      left: 0,
	      width: this.assetData.w,
	      height: this.assetData.h
	    };
	  }
	
	  extendPrototype([BaseElement, TransformElement, SVGBaseElement, HierarchyElement, FrameElement, RenderableDOMElement], IImageElement);
	
	  IImageElement.prototype.createContent = function () {
	    var assetPath = this.globalData.getAssetsPath(this.assetData);
	    this.innerElem = createNS('image');
	    this.innerElem.setAttribute('width', this.assetData.w + 'px');
	    this.innerElem.setAttribute('height', this.assetData.h + 'px');
	    this.innerElem.setAttribute('preserveAspectRatio', this.assetData.pr || this.globalData.renderConfig.imagePreserveAspectRatio);
	    this.innerElem.setAttributeNS('http://www.w3.org/1999/xlink', 'href', assetPath);
	    this.layerElement.appendChild(this.innerElem);
	  };
	
	  IImageElement.prototype.sourceRectAtTime = function () {
	    return this.sourceRect;
	  };
	
	  function ProcessedElement(element, position) {
	    this.elem = element;
	    this.pos = position;
	  }
	
	  function IShapeElement() {}
	
	  IShapeElement.prototype = {
	    addShapeToModifiers: function addShapeToModifiers(data) {
	      var i;
	      var len = this.shapeModifiers.length;
	
	      for (i = 0; i < len; i += 1) {
	        this.shapeModifiers[i].addShape(data);
	      }
	    },
	    isShapeInAnimatedModifiers: function isShapeInAnimatedModifiers(data) {
	      var i = 0;
	      var len = this.shapeModifiers.length;
	
	      while (i < len) {
	        if (this.shapeModifiers[i].isAnimatedWithShape(data)) {
	          return true;
	        }
	      }
	
	      return false;
	    },
	    renderModifiers: function renderModifiers() {
	      if (!this.shapeModifiers.length) {
	        return;
	      }
	
	      var i;
	      var len = this.shapes.length;
	
	      for (i = 0; i < len; i += 1) {
	        this.shapes[i].sh.reset();
	      }
	
	      len = this.shapeModifiers.length;
	      var shouldBreakProcess;
	
	      for (i = len - 1; i >= 0; i -= 1) {
	        shouldBreakProcess = this.shapeModifiers[i].processShapes(this._isFirstFrame); // workaround to fix cases where a repeater resets the shape so the following processes get called twice
	        // TODO: find a better solution for this
	
	        if (shouldBreakProcess) {
	          break;
	        }
	      }
	    },
	    searchProcessedElement: function searchProcessedElement(elem) {
	      var elements = this.processedElements;
	      var i = 0;
	      var len = elements.length;
	
	      while (i < len) {
	        if (elements[i].elem === elem) {
	          return elements[i].pos;
	        }
	
	        i += 1;
	      }
	
	      return 0;
	    },
	    addProcessedElement: function addProcessedElement(elem, pos) {
	      var elements = this.processedElements;
	      var i = elements.length;
	
	      while (i) {
	        i -= 1;
	
	        if (elements[i].elem === elem) {
	          elements[i].pos = pos;
	          return;
	        }
	      }
	
	      elements.push(new ProcessedElement(elem, pos));
	    },
	    prepareFrame: function prepareFrame(num) {
	      this.prepareRenderableFrame(num);
	      this.prepareProperties(num, this.isInRange);
	    }
	  };
	
	  var lineCapEnum = {
	    1: 'butt',
	    2: 'round',
	    3: 'square'
	  };
	  var lineJoinEnum = {
	    1: 'miter',
	    2: 'round',
	    3: 'bevel'
	  };
	
	  function SVGShapeData(transformers, level, shape) {
	    this.caches = [];
	    this.styles = [];
	    this.transformers = transformers;
	    this.lStr = '';
	    this.sh = shape;
	    this.lvl = level; // TODO find if there are some cases where _isAnimated can be false.
	    // For now, since shapes add up with other shapes. They have to be calculated every time.
	    // One way of finding out is checking if all styles associated to this shape depend only of this shape
	
	    this._isAnimated = !!shape.k; // TODO: commenting this for now since all shapes are animated
	
	    var i = 0;
	    var len = transformers.length;
	
	    while (i < len) {
	      if (transformers[i].mProps.dynamicProperties.length) {
	        this._isAnimated = true;
	        break;
	      }
	
	      i += 1;
	    }
	  }
	
	  SVGShapeData.prototype.setAsAnimated = function () {
	    this._isAnimated = true;
	  };
	
	  function SVGStyleData(data, level) {
	    this.data = data;
	    this.type = data.ty;
	    this.d = '';
	    this.lvl = level;
	    this._mdf = false;
	    this.closed = data.hd === true;
	    this.pElem = createNS('path');
	    this.msElem = null;
	  }
	
	  SVGStyleData.prototype.reset = function () {
	    this.d = '';
	    this._mdf = false;
	  };
	
	  function DashProperty(elem, data, renderer, container) {
	    this.elem = elem;
	    this.frameId = -1;
	    this.dataProps = createSizedArray(data.length);
	    this.renderer = renderer;
	    this.k = false;
	    this.dashStr = '';
	    this.dashArray = createTypedArray('float32', data.length ? data.length - 1 : 0);
	    this.dashoffset = createTypedArray('float32', 1);
	    this.initDynamicPropertyContainer(container);
	    var i;
	    var len = data.length || 0;
	    var prop;
	
	    for (i = 0; i < len; i += 1) {
	      prop = PropertyFactory.getProp(elem, data[i].v, 0, 0, this);
	      this.k = prop.k || this.k;
	      this.dataProps[i] = {
	        n: data[i].n,
	        p: prop
	      };
	    }
	
	    if (!this.k) {
	      this.getValue(true);
	    }
	
	    this._isAnimated = this.k;
	  }
	
	  DashProperty.prototype.getValue = function (forceRender) {
	    if (this.elem.globalData.frameId === this.frameId && !forceRender) {
	      return;
	    }
	
	    this.frameId = this.elem.globalData.frameId;
	    this.iterateDynamicProperties();
	    this._mdf = this._mdf || forceRender;
	
	    if (this._mdf) {
	      var i = 0;
	      var len = this.dataProps.length;
	
	      if (this.renderer === 'svg') {
	        this.dashStr = '';
	      }
	
	      for (i = 0; i < len; i += 1) {
	        if (this.dataProps[i].n !== 'o') {
	          if (this.renderer === 'svg') {
	            this.dashStr += ' ' + this.dataProps[i].p.v;
	          } else {
	            this.dashArray[i] = this.dataProps[i].p.v;
	          }
	        } else {
	          this.dashoffset[0] = this.dataProps[i].p.v;
	        }
	      }
	    }
	  };
	
	  extendPrototype([DynamicPropertyContainer], DashProperty);
	
	  function SVGStrokeStyleData(elem, data, styleOb) {
	    this.initDynamicPropertyContainer(elem);
	    this.getValue = this.iterateDynamicProperties;
	    this.o = PropertyFactory.getProp(elem, data.o, 0, 0.01, this);
	    this.w = PropertyFactory.getProp(elem, data.w, 0, null, this);
	    this.d = new DashProperty(elem, data.d || {}, 'svg', this);
	    this.c = PropertyFactory.getProp(elem, data.c, 1, 255, this);
	    this.style = styleOb;
	    this._isAnimated = !!this._isAnimated;
	  }
	
	  extendPrototype([DynamicPropertyContainer], SVGStrokeStyleData);
	
	  function SVGFillStyleData(elem, data, styleOb) {
	    this.initDynamicPropertyContainer(elem);
	    this.getValue = this.iterateDynamicProperties;
	    this.o = PropertyFactory.getProp(elem, data.o, 0, 0.01, this);
	    this.c = PropertyFactory.getProp(elem, data.c, 1, 255, this);
	    this.style = styleOb;
	  }
	
	  extendPrototype([DynamicPropertyContainer], SVGFillStyleData);
	
	  function SVGNoStyleData(elem, data, styleOb) {
	    this.initDynamicPropertyContainer(elem);
	    this.getValue = this.iterateDynamicProperties;
	    this.style = styleOb;
	  }
	
	  extendPrototype([DynamicPropertyContainer], SVGNoStyleData);
	
	  function GradientProperty(elem, data, container) {
	    this.data = data;
	    this.c = createTypedArray('uint8c', data.p * 4);
	    var cLength = data.k.k[0].s ? data.k.k[0].s.length - data.p * 4 : data.k.k.length - data.p * 4;
	    this.o = createTypedArray('float32', cLength);
	    this._cmdf = false;
	    this._omdf = false;
	    this._collapsable = this.checkCollapsable();
	    this._hasOpacity = cLength;
	    this.initDynamicPropertyContainer(container);
	    this.prop = PropertyFactory.getProp(elem, data.k, 1, null, this);
	    this.k = this.prop.k;
	    this.getValue(true);
	  }
	
	  GradientProperty.prototype.comparePoints = function (values, points) {
	    var i = 0;
	    var len = this.o.length / 2;
	    var diff;
	
	    while (i < len) {
	      diff = Math.abs(values[i * 4] - values[points * 4 + i * 2]);
	
	      if (diff > 0.01) {
	        return false;
	      }
	
	      i += 1;
	    }
	
	    return true;
	  };
	
	  GradientProperty.prototype.checkCollapsable = function () {
	    if (this.o.length / 2 !== this.c.length / 4) {
	      return false;
	    }
	
	    if (this.data.k.k[0].s) {
	      var i = 0;
	      var len = this.data.k.k.length;
	
	      while (i < len) {
	        if (!this.comparePoints(this.data.k.k[i].s, this.data.p)) {
	          return false;
	        }
	
	        i += 1;
	      }
	    } else if (!this.comparePoints(this.data.k.k, this.data.p)) {
	      return false;
	    }
	
	    return true;
	  };
	
	  GradientProperty.prototype.getValue = function (forceRender) {
	    this.prop.getValue();
	    this._mdf = false;
	    this._cmdf = false;
	    this._omdf = false;
	
	    if (this.prop._mdf || forceRender) {
	      var i;
	      var len = this.data.p * 4;
	      var mult;
	      var val;
	
	      for (i = 0; i < len; i += 1) {
	        mult = i % 4 === 0 ? 100 : 255;
	        val = Math.round(this.prop.v[i] * mult);
	
	        if (this.c[i] !== val) {
	          this.c[i] = val;
	          this._cmdf = !forceRender;
	        }
	      }
	
	      if (this.o.length) {
	        len = this.prop.v.length;
	
	        for (i = this.data.p * 4; i < len; i += 1) {
	          mult = i % 2 === 0 ? 100 : 1;
	          val = i % 2 === 0 ? Math.round(this.prop.v[i] * 100) : this.prop.v[i];
	
	          if (this.o[i - this.data.p * 4] !== val) {
	            this.o[i - this.data.p * 4] = val;
	            this._omdf = !forceRender;
	          }
	        }
	      }
	
	      this._mdf = !forceRender;
	    }
	  };
	
	  extendPrototype([DynamicPropertyContainer], GradientProperty);
	
	  function SVGGradientFillStyleData(elem, data, styleOb) {
	    this.initDynamicPropertyContainer(elem);
	    this.getValue = this.iterateDynamicProperties;
	    this.initGradientData(elem, data, styleOb);
	  }
	
	  SVGGradientFillStyleData.prototype.initGradientData = function (elem, data, styleOb) {
	    this.o = PropertyFactory.getProp(elem, data.o, 0, 0.01, this);
	    this.s = PropertyFactory.getProp(elem, data.s, 1, null, this);
	    this.e = PropertyFactory.getProp(elem, data.e, 1, null, this);
	    this.h = PropertyFactory.getProp(elem, data.h || {
	      k: 0
	    }, 0, 0.01, this);
	    this.a = PropertyFactory.getProp(elem, data.a || {
	      k: 0
	    }, 0, degToRads, this);
	    this.g = new GradientProperty(elem, data.g, this);
	    this.style = styleOb;
	    this.stops = [];
	    this.setGradientData(styleOb.pElem, data);
	    this.setGradientOpacity(data, styleOb);
	    this._isAnimated = !!this._isAnimated;
	  };
	
	  SVGGradientFillStyleData.prototype.setGradientData = function (pathElement, data) {
	    var gradientId = createElementID();
	    var gfill = createNS(data.t === 1 ? 'linearGradient' : 'radialGradient');
	    gfill.setAttribute('id', gradientId);
	    gfill.setAttribute('spreadMethod', 'pad');
	    gfill.setAttribute('gradientUnits', 'userSpaceOnUse');
	    var stops = [];
	    var stop;
	    var j;
	    var jLen;
	    jLen = data.g.p * 4;
	
	    for (j = 0; j < jLen; j += 4) {
	      stop = createNS('stop');
	      gfill.appendChild(stop);
	      stops.push(stop);
	    }
	
	    pathElement.setAttribute(data.ty === 'gf' ? 'fill' : 'stroke', 'url(' + getLocationHref() + '#' + gradientId + ')');
	    this.gf = gfill;
	    this.cst = stops;
	  };
	
	  SVGGradientFillStyleData.prototype.setGradientOpacity = function (data, styleOb) {
	    if (this.g._hasOpacity && !this.g._collapsable) {
	      var stop;
	      var j;
	      var jLen;
	      var mask = createNS('mask');
	      var maskElement = createNS('path');
	      mask.appendChild(maskElement);
	      var opacityId = createElementID();
	      var maskId = createElementID();
	      mask.setAttribute('id', maskId);
	      var opFill = createNS(data.t === 1 ? 'linearGradient' : 'radialGradient');
	      opFill.setAttribute('id', opacityId);
	      opFill.setAttribute('spreadMethod', 'pad');
	      opFill.setAttribute('gradientUnits', 'userSpaceOnUse');
	      jLen = data.g.k.k[0].s ? data.g.k.k[0].s.length : data.g.k.k.length;
	      var stops = this.stops;
	
	      for (j = data.g.p * 4; j < jLen; j += 2) {
	        stop = createNS('stop');
	        stop.setAttribute('stop-color', 'rgb(255,255,255)');
	        opFill.appendChild(stop);
	        stops.push(stop);
	      }
	
	      maskElement.setAttribute(data.ty === 'gf' ? 'fill' : 'stroke', 'url(' + getLocationHref() + '#' + opacityId + ')');
	
	      if (data.ty === 'gs') {
	        maskElement.setAttribute('stroke-linecap', lineCapEnum[data.lc || 2]);
	        maskElement.setAttribute('stroke-linejoin', lineJoinEnum[data.lj || 2]);
	
	        if (data.lj === 1) {
	          maskElement.setAttribute('stroke-miterlimit', data.ml);
	        }
	      }
	
	      this.of = opFill;
	      this.ms = mask;
	      this.ost = stops;
	      this.maskId = maskId;
	      styleOb.msElem = maskElement;
	    }
	  };
	
	  extendPrototype([DynamicPropertyContainer], SVGGradientFillStyleData);
	
	  function SVGGradientStrokeStyleData(elem, data, styleOb) {
	    this.initDynamicPropertyContainer(elem);
	    this.getValue = this.iterateDynamicProperties;
	    this.w = PropertyFactory.getProp(elem, data.w, 0, null, this);
	    this.d = new DashProperty(elem, data.d || {}, 'svg', this);
	    this.initGradientData(elem, data, styleOb);
	    this._isAnimated = !!this._isAnimated;
	  }
	
	  extendPrototype([SVGGradientFillStyleData, DynamicPropertyContainer], SVGGradientStrokeStyleData);
	
	  function ShapeGroupData() {
	    this.it = [];
	    this.prevViewData = [];
	    this.gr = createNS('g');
	  }
	
	  function SVGTransformData(mProps, op, container) {
	    this.transform = {
	      mProps: mProps,
	      op: op,
	      container: container
	    };
	    this.elements = [];
	    this._isAnimated = this.transform.mProps.dynamicProperties.length || this.transform.op.effectsSequence.length;
	  }
	
	  var buildShapeString = function buildShapeString(pathNodes, length, closed, mat) {
	    if (length === 0) {
	      return '';
	    }
	
	    var _o = pathNodes.o;
	    var _i = pathNodes.i;
	    var _v = pathNodes.v;
	    var i;
	    var shapeString = ' M' + mat.applyToPointStringified(_v[0][0], _v[0][1]);
	
	    for (i = 1; i < length; i += 1) {
	      shapeString += ' C' + mat.applyToPointStringified(_o[i - 1][0], _o[i - 1][1]) + ' ' + mat.applyToPointStringified(_i[i][0], _i[i][1]) + ' ' + mat.applyToPointStringified(_v[i][0], _v[i][1]);
	    }
	
	    if (closed && length) {
	      shapeString += ' C' + mat.applyToPointStringified(_o[i - 1][0], _o[i - 1][1]) + ' ' + mat.applyToPointStringified(_i[0][0], _i[0][1]) + ' ' + mat.applyToPointStringified(_v[0][0], _v[0][1]);
	      shapeString += 'z';
	    }
	
	    return shapeString;
	  };
	
	  var SVGElementsRenderer = function () {
	    var _identityMatrix = new Matrix();
	
	    var _matrixHelper = new Matrix();
	
	    var ob = {
	      createRenderFunction: createRenderFunction
	    };
	
	    function createRenderFunction(data) {
	      switch (data.ty) {
	        case 'fl':
	          return renderFill;
	
	        case 'gf':
	          return renderGradient;
	
	        case 'gs':
	          return renderGradientStroke;
	
	        case 'st':
	          return renderStroke;
	
	        case 'sh':
	        case 'el':
	        case 'rc':
	        case 'sr':
	          return renderPath;
	
	        case 'tr':
	          return renderContentTransform;
	
	        case 'no':
	          return renderNoop;
	
	        default:
	          return null;
	      }
	    }
	
	    function renderContentTransform(styleData, itemData, isFirstFrame) {
	      if (isFirstFrame || itemData.transform.op._mdf) {
	        itemData.transform.container.setAttribute('opacity', itemData.transform.op.v);
	      }
	
	      if (isFirstFrame || itemData.transform.mProps._mdf) {
	        itemData.transform.container.setAttribute('transform', itemData.transform.mProps.v.to2dCSS());
	      }
	    }
	
	    function renderNoop() {}
	
	    function renderPath(styleData, itemData, isFirstFrame) {
	      var j;
	      var jLen;
	      var pathStringTransformed;
	      var redraw;
	      var pathNodes;
	      var l;
	      var lLen = itemData.styles.length;
	      var lvl = itemData.lvl;
	      var paths;
	      var mat;
	      var iterations;
	      var k;
	
	      for (l = 0; l < lLen; l += 1) {
	        redraw = itemData.sh._mdf || isFirstFrame;
	
	        if (itemData.styles[l].lvl < lvl) {
	          mat = _matrixHelper.reset();
	          iterations = lvl - itemData.styles[l].lvl;
	          k = itemData.transformers.length - 1;
	
	          while (!redraw && iterations > 0) {
	            redraw = itemData.transformers[k].mProps._mdf || redraw;
	            iterations -= 1;
	            k -= 1;
	          }
	
	          if (redraw) {
	            iterations = lvl - itemData.styles[l].lvl;
	            k = itemData.transformers.length - 1;
	
	            while (iterations > 0) {
	              mat.multiply(itemData.transformers[k].mProps.v);
	              iterations -= 1;
	              k -= 1;
	            }
	          }
	        } else {
	          mat = _identityMatrix;
	        }
	
	        paths = itemData.sh.paths;
	        jLen = paths._length;
	
	        if (redraw) {
	          pathStringTransformed = '';
	
	          for (j = 0; j < jLen; j += 1) {
	            pathNodes = paths.shapes[j];
	
	            if (pathNodes && pathNodes._length) {
	              pathStringTransformed += buildShapeString(pathNodes, pathNodes._length, pathNodes.c, mat);
	            }
	          }
	
	          itemData.caches[l] = pathStringTransformed;
	        } else {
	          pathStringTransformed = itemData.caches[l];
	        }
	
	        itemData.styles[l].d += styleData.hd === true ? '' : pathStringTransformed;
	        itemData.styles[l]._mdf = redraw || itemData.styles[l]._mdf;
	      }
	    }
	
	    function renderFill(styleData, itemData, isFirstFrame) {
	      var styleElem = itemData.style;
	
	      if (itemData.c._mdf || isFirstFrame) {
	        styleElem.pElem.setAttribute('fill', 'rgb(' + bmFloor(itemData.c.v[0]) + ',' + bmFloor(itemData.c.v[1]) + ',' + bmFloor(itemData.c.v[2]) + ')');
	      }
	
	      if (itemData.o._mdf || isFirstFrame) {
	        styleElem.pElem.setAttribute('fill-opacity', itemData.o.v);
	      }
	    }
	
	    function renderGradientStroke(styleData, itemData, isFirstFrame) {
	      renderGradient(styleData, itemData, isFirstFrame);
	      renderStroke(styleData, itemData, isFirstFrame);
	    }
	
	    function renderGradient(styleData, itemData, isFirstFrame) {
	      var gfill = itemData.gf;
	      var hasOpacity = itemData.g._hasOpacity;
	      var pt1 = itemData.s.v;
	      var pt2 = itemData.e.v;
	
	      if (itemData.o._mdf || isFirstFrame) {
	        var attr = styleData.ty === 'gf' ? 'fill-opacity' : 'stroke-opacity';
	        itemData.style.pElem.setAttribute(attr, itemData.o.v);
	      }
	
	      if (itemData.s._mdf || isFirstFrame) {
	        var attr1 = styleData.t === 1 ? 'x1' : 'cx';
	        var attr2 = attr1 === 'x1' ? 'y1' : 'cy';
	        gfill.setAttribute(attr1, pt1[0]);
	        gfill.setAttribute(attr2, pt1[1]);
	
	        if (hasOpacity && !itemData.g._collapsable) {
	          itemData.of.setAttribute(attr1, pt1[0]);
	          itemData.of.setAttribute(attr2, pt1[1]);
	        }
	      }
	
	      var stops;
	      var i;
	      var len;
	      var stop;
	
	      if (itemData.g._cmdf || isFirstFrame) {
	        stops = itemData.cst;
	        var cValues = itemData.g.c;
	        len = stops.length;
	
	        for (i = 0; i < len; i += 1) {
	          stop = stops[i];
	          stop.setAttribute('offset', cValues[i * 4] + '%');
	          stop.setAttribute('stop-color', 'rgb(' + cValues[i * 4 + 1] + ',' + cValues[i * 4 + 2] + ',' + cValues[i * 4 + 3] + ')');
	        }
	      }
	
	      if (hasOpacity && (itemData.g._omdf || isFirstFrame)) {
	        var oValues = itemData.g.o;
	
	        if (itemData.g._collapsable) {
	          stops = itemData.cst;
	        } else {
	          stops = itemData.ost;
	        }
	
	        len = stops.length;
	
	        for (i = 0; i < len; i += 1) {
	          stop = stops[i];
	
	          if (!itemData.g._collapsable) {
	            stop.setAttribute('offset', oValues[i * 2] + '%');
	          }
	
	          stop.setAttribute('stop-opacity', oValues[i * 2 + 1]);
	        }
	      }
	
	      if (styleData.t === 1) {
	        if (itemData.e._mdf || isFirstFrame) {
	          gfill.setAttribute('x2', pt2[0]);
	          gfill.setAttribute('y2', pt2[1]);
	
	          if (hasOpacity && !itemData.g._collapsable) {
	            itemData.of.setAttribute('x2', pt2[0]);
	            itemData.of.setAttribute('y2', pt2[1]);
	          }
	        }
	      } else {
	        var rad;
	
	        if (itemData.s._mdf || itemData.e._mdf || isFirstFrame) {
	          rad = Math.sqrt(Math.pow(pt1[0] - pt2[0], 2) + Math.pow(pt1[1] - pt2[1], 2));
	          gfill.setAttribute('r', rad);
	
	          if (hasOpacity && !itemData.g._collapsable) {
	            itemData.of.setAttribute('r', rad);
	          }
	        }
	
	        if (itemData.e._mdf || itemData.h._mdf || itemData.a._mdf || isFirstFrame) {
	          if (!rad) {
	            rad = Math.sqrt(Math.pow(pt1[0] - pt2[0], 2) + Math.pow(pt1[1] - pt2[1], 2));
	          }
	
	          var ang = Math.atan2(pt2[1] - pt1[1], pt2[0] - pt1[0]);
	          var percent = itemData.h.v;
	
	          if (percent >= 1) {
	            percent = 0.99;
	          } else if (percent <= -1) {
	            percent = -0.99;
	          }
	
	          var dist = rad * percent;
	          var x = Math.cos(ang + itemData.a.v) * dist + pt1[0];
	          var y = Math.sin(ang + itemData.a.v) * dist + pt1[1];
	          gfill.setAttribute('fx', x);
	          gfill.setAttribute('fy', y);
	
	          if (hasOpacity && !itemData.g._collapsable) {
	            itemData.of.setAttribute('fx', x);
	            itemData.of.setAttribute('fy', y);
	          }
	        } // gfill.setAttribute('fy','200');
	
	      }
	    }
	
	    function renderStroke(styleData, itemData, isFirstFrame) {
	      var styleElem = itemData.style;
	      var d = itemData.d;
	
	      if (d && (d._mdf || isFirstFrame) && d.dashStr) {
	        styleElem.pElem.setAttribute('stroke-dasharray', d.dashStr);
	        styleElem.pElem.setAttribute('stroke-dashoffset', d.dashoffset[0]);
	      }
	
	      if (itemData.c && (itemData.c._mdf || isFirstFrame)) {
	        styleElem.pElem.setAttribute('stroke', 'rgb(' + bmFloor(itemData.c.v[0]) + ',' + bmFloor(itemData.c.v[1]) + ',' + bmFloor(itemData.c.v[2]) + ')');
	      }
	
	      if (itemData.o._mdf || isFirstFrame) {
	        styleElem.pElem.setAttribute('stroke-opacity', itemData.o.v);
	      }
	
	      if (itemData.w._mdf || isFirstFrame) {
	        styleElem.pElem.setAttribute('stroke-width', itemData.w.v);
	
	        if (styleElem.msElem) {
	          styleElem.msElem.setAttribute('stroke-width', itemData.w.v);
	        }
	      }
	    }
	
	    return ob;
	  }();
	
	  function SVGShapeElement(data, globalData, comp) {
	    // List of drawable elements
	    this.shapes = []; // Full shape data
	
	    this.shapesData = data.shapes; // List of styles that will be applied to shapes
	
	    this.stylesList = []; // List of modifiers that will be applied to shapes
	
	    this.shapeModifiers = []; // List of items in shape tree
	
	    this.itemsData = []; // List of items in previous shape tree
	
	    this.processedElements = []; // List of animated components
	
	    this.animatedContents = [];
	    this.initElement(data, globalData, comp); // Moving any property that doesn't get too much access after initialization because of v8 way of handling more than 10 properties.
	    // List of elements that have been created
	
	    this.prevViewData = []; // Moving any property that doesn't get too much access after initialization because of v8 way of handling more than 10 properties.
	  }
	
	  extendPrototype([BaseElement, TransformElement, SVGBaseElement, IShapeElement, HierarchyElement, FrameElement, RenderableDOMElement], SVGShapeElement);
	
	  SVGShapeElement.prototype.initSecondaryElement = function () {};
	
	  SVGShapeElement.prototype.identityMatrix = new Matrix();
	
	  SVGShapeElement.prototype.buildExpressionInterface = function () {};
	
	  SVGShapeElement.prototype.createContent = function () {
	    this.searchShapes(this.shapesData, this.itemsData, this.prevViewData, this.layerElement, 0, [], true);
	    this.filterUniqueShapes();
	  };
	  /*
	  This method searches for multiple shapes that affect a single element and one of them is animated
	  */
	
	
	  SVGShapeElement.prototype.filterUniqueShapes = function () {
	    var i;
	    var len = this.shapes.length;
	    var shape;
	    var j;
	    var jLen = this.stylesList.length;
	    var style;
	    var tempShapes = [];
	    var areAnimated = false;
	
	    for (j = 0; j < jLen; j += 1) {
	      style = this.stylesList[j];
	      areAnimated = false;
	      tempShapes.length = 0;
	
	      for (i = 0; i < len; i += 1) {
	        shape = this.shapes[i];
	
	        if (shape.styles.indexOf(style) !== -1) {
	          tempShapes.push(shape);
	          areAnimated = shape._isAnimated || areAnimated;
	        }
	      }
	
	      if (tempShapes.length > 1 && areAnimated) {
	        this.setShapesAsAnimated(tempShapes);
	      }
	    }
	  };
	
	  SVGShapeElement.prototype.setShapesAsAnimated = function (shapes) {
	    var i;
	    var len = shapes.length;
	
	    for (i = 0; i < len; i += 1) {
	      shapes[i].setAsAnimated();
	    }
	  };
	
	  SVGShapeElement.prototype.createStyleElement = function (data, level) {
	    // TODO: prevent drawing of hidden styles
	    var elementData;
	    var styleOb = new SVGStyleData(data, level);
	    var pathElement = styleOb.pElem;
	
	    if (data.ty === 'st') {
	      elementData = new SVGStrokeStyleData(this, data, styleOb);
	    } else if (data.ty === 'fl') {
	      elementData = new SVGFillStyleData(this, data, styleOb);
	    } else if (data.ty === 'gf' || data.ty === 'gs') {
	      var GradientConstructor = data.ty === 'gf' ? SVGGradientFillStyleData : SVGGradientStrokeStyleData;
	      elementData = new GradientConstructor(this, data, styleOb);
	      this.globalData.defs.appendChild(elementData.gf);
	
	      if (elementData.maskId) {
	        this.globalData.defs.appendChild(elementData.ms);
	        this.globalData.defs.appendChild(elementData.of);
	        pathElement.setAttribute('mask', 'url(' + getLocationHref() + '#' + elementData.maskId + ')');
	      }
	    } else if (data.ty === 'no') {
	      elementData = new SVGNoStyleData(this, data, styleOb);
	    }
	
	    if (data.ty === 'st' || data.ty === 'gs') {
	      pathElement.setAttribute('stroke-linecap', lineCapEnum[data.lc || 2]);
	      pathElement.setAttribute('stroke-linejoin', lineJoinEnum[data.lj || 2]);
	      pathElement.setAttribute('fill-opacity', '0');
	
	      if (data.lj === 1) {
	        pathElement.setAttribute('stroke-miterlimit', data.ml);
	      }
	    }
	
	    if (data.r === 2) {
	      pathElement.setAttribute('fill-rule', 'evenodd');
	    }
	
	    if (data.ln) {
	      pathElement.setAttribute('id', data.ln);
	    }
	
	    if (data.cl) {
	      pathElement.setAttribute('class', data.cl);
	    }
	
	    if (data.bm) {
	      pathElement.style['mix-blend-mode'] = getBlendMode(data.bm);
	    }
	
	    this.stylesList.push(styleOb);
	    this.addToAnimatedContents(data, elementData);
	    return elementData;
	  };
	
	  SVGShapeElement.prototype.createGroupElement = function (data) {
	    var elementData = new ShapeGroupData();
	
	    if (data.ln) {
	      elementData.gr.setAttribute('id', data.ln);
	    }
	
	    if (data.cl) {
	      elementData.gr.setAttribute('class', data.cl);
	    }
	
	    if (data.bm) {
	      elementData.gr.style['mix-blend-mode'] = getBlendMode(data.bm);
	    }
	
	    return elementData;
	  };
	
	  SVGShapeElement.prototype.createTransformElement = function (data, container) {
	    var transformProperty = TransformPropertyFactory.getTransformProperty(this, data, this);
	    var elementData = new SVGTransformData(transformProperty, transformProperty.o, container);
	    this.addToAnimatedContents(data, elementData);
	    return elementData;
	  };
	
	  SVGShapeElement.prototype.createShapeElement = function (data, ownTransformers, level) {
	    var ty = 4;
	
	    if (data.ty === 'rc') {
	      ty = 5;
	    } else if (data.ty === 'el') {
	      ty = 6;
	    } else if (data.ty === 'sr') {
	      ty = 7;
	    }
	
	    var shapeProperty = ShapePropertyFactory.getShapeProp(this, data, ty, this);
	    var elementData = new SVGShapeData(ownTransformers, level, shapeProperty);
	    this.shapes.push(elementData);
	    this.addShapeToModifiers(elementData);
	    this.addToAnimatedContents(data, elementData);
	    return elementData;
	  };
	
	  SVGShapeElement.prototype.addToAnimatedContents = function (data, element) {
	    var i = 0;
	    var len = this.animatedContents.length;
	
	    while (i < len) {
	      if (this.animatedContents[i].element === element) {
	        return;
	      }
	
	      i += 1;
	    }
	
	    this.animatedContents.push({
	      fn: SVGElementsRenderer.createRenderFunction(data),
	      element: element,
	      data: data
	    });
	  };
	
	  SVGShapeElement.prototype.setElementStyles = function (elementData) {
	    var arr = elementData.styles;
	    var j;
	    var jLen = this.stylesList.length;
	
	    for (j = 0; j < jLen; j += 1) {
	      if (!this.stylesList[j].closed) {
	        arr.push(this.stylesList[j]);
	      }
	    }
	  };
	
	  SVGShapeElement.prototype.reloadShapes = function () {
	    this._isFirstFrame = true;
	    var i;
	    var len = this.itemsData.length;
	
	    for (i = 0; i < len; i += 1) {
	      this.prevViewData[i] = this.itemsData[i];
	    }
	
	    this.searchShapes(this.shapesData, this.itemsData, this.prevViewData, this.layerElement, 0, [], true);
	    this.filterUniqueShapes();
	    len = this.dynamicProperties.length;
	
	    for (i = 0; i < len; i += 1) {
	      this.dynamicProperties[i].getValue();
	    }
	
	    this.renderModifiers();
	  };
	
	  SVGShapeElement.prototype.searchShapes = function (arr, itemsData, prevViewData, container, level, transformers, render) {
	    var ownTransformers = [].concat(transformers);
	    var i;
	    var len = arr.length - 1;
	    var j;
	    var jLen;
	    var ownStyles = [];
	    var ownModifiers = [];
	    var currentTransform;
	    var modifier;
	    var processedPos;
	
	    for (i = len; i >= 0; i -= 1) {
	      processedPos = this.searchProcessedElement(arr[i]);
	
	      if (!processedPos) {
	        arr[i]._render = render;
	      } else {
	        itemsData[i] = prevViewData[processedPos - 1];
	      }
	
	      if (arr[i].ty === 'fl' || arr[i].ty === 'st' || arr[i].ty === 'gf' || arr[i].ty === 'gs' || arr[i].ty === 'no') {
	        if (!processedPos) {
	          itemsData[i] = this.createStyleElement(arr[i], level);
	        } else {
	          itemsData[i].style.closed = false;
	        }
	
	        if (arr[i]._render) {
	          if (itemsData[i].style.pElem.parentNode !== container) {
	            container.appendChild(itemsData[i].style.pElem);
	          }
	        }
	
	        ownStyles.push(itemsData[i].style);
	      } else if (arr[i].ty === 'gr') {
	        if (!processedPos) {
	          itemsData[i] = this.createGroupElement(arr[i]);
	        } else {
	          jLen = itemsData[i].it.length;
	
	          for (j = 0; j < jLen; j += 1) {
	            itemsData[i].prevViewData[j] = itemsData[i].it[j];
	          }
	        }
	
	        this.searchShapes(arr[i].it, itemsData[i].it, itemsData[i].prevViewData, itemsData[i].gr, level + 1, ownTransformers, render);
	
	        if (arr[i]._render) {
	          if (itemsData[i].gr.parentNode !== container) {
	            container.appendChild(itemsData[i].gr);
	          }
	        }
	      } else if (arr[i].ty === 'tr') {
	        if (!processedPos) {
	          itemsData[i] = this.createTransformElement(arr[i], container);
	        }
	
	        currentTransform = itemsData[i].transform;
	        ownTransformers.push(currentTransform);
	      } else if (arr[i].ty === 'sh' || arr[i].ty === 'rc' || arr[i].ty === 'el' || arr[i].ty === 'sr') {
	        if (!processedPos) {
	          itemsData[i] = this.createShapeElement(arr[i], ownTransformers, level);
	        }
	
	        this.setElementStyles(itemsData[i]);
	      } else if (arr[i].ty === 'tm' || arr[i].ty === 'rd' || arr[i].ty === 'ms' || arr[i].ty === 'pb' || arr[i].ty === 'zz' || arr[i].ty === 'op') {
	        if (!processedPos) {
	          modifier = ShapeModifiers.getModifier(arr[i].ty);
	          modifier.init(this, arr[i]);
	          itemsData[i] = modifier;
	          this.shapeModifiers.push(modifier);
	        } else {
	          modifier = itemsData[i];
	          modifier.closed = false;
	        }
	
	        ownModifiers.push(modifier);
	      } else if (arr[i].ty === 'rp') {
	        if (!processedPos) {
	          modifier = ShapeModifiers.getModifier(arr[i].ty);
	          itemsData[i] = modifier;
	          modifier.init(this, arr, i, itemsData);
	          this.shapeModifiers.push(modifier);
	          render = false;
	        } else {
	          modifier = itemsData[i];
	          modifier.closed = true;
	        }
	
	        ownModifiers.push(modifier);
	      }
	
	      this.addProcessedElement(arr[i], i + 1);
	    }
	
	    len = ownStyles.length;
	
	    for (i = 0; i < len; i += 1) {
	      ownStyles[i].closed = true;
	    }
	
	    len = ownModifiers.length;
	
	    for (i = 0; i < len; i += 1) {
	      ownModifiers[i].closed = true;
	    }
	  };
	
	  SVGShapeElement.prototype.renderInnerContent = function () {
	    this.renderModifiers();
	    var i;
	    var len = this.stylesList.length;
	
	    for (i = 0; i < len; i += 1) {
	      this.stylesList[i].reset();
	    }
	
	    this.renderShape();
	
	    for (i = 0; i < len; i += 1) {
	      if (this.stylesList[i]._mdf || this._isFirstFrame) {
	        if (this.stylesList[i].msElem) {
	          this.stylesList[i].msElem.setAttribute('d', this.stylesList[i].d); // Adding M0 0 fixes same mask bug on all browsers
	
	          this.stylesList[i].d = 'M0 0' + this.stylesList[i].d;
	        }
	
	        this.stylesList[i].pElem.setAttribute('d', this.stylesList[i].d || 'M0 0');
	      }
	    }
	  };
	
	  SVGShapeElement.prototype.renderShape = function () {
	    var i;
	    var len = this.animatedContents.length;
	    var animatedContent;
	
	    for (i = 0; i < len; i += 1) {
	      animatedContent = this.animatedContents[i];
	
	      if ((this._isFirstFrame || animatedContent.element._isAnimated) && animatedContent.data !== true) {
	        animatedContent.fn(animatedContent.data, animatedContent.element, this._isFirstFrame);
	      }
	    }
	  };
	
	  SVGShapeElement.prototype.destroy = function () {
	    this.destroyBaseElement();
	    this.shapesData = null;
	    this.itemsData = null;
	  };
	
	  function LetterProps(o, sw, sc, fc, m, p) {
	    this.o = o;
	    this.sw = sw;
	    this.sc = sc;
	    this.fc = fc;
	    this.m = m;
	    this.p = p;
	    this._mdf = {
	      o: true,
	      sw: !!sw,
	      sc: !!sc,
	      fc: !!fc,
	      m: true,
	      p: true
	    };
	  }
	
	  LetterProps.prototype.update = function (o, sw, sc, fc, m, p) {
	    this._mdf.o = false;
	    this._mdf.sw = false;
	    this._mdf.sc = false;
	    this._mdf.fc = false;
	    this._mdf.m = false;
	    this._mdf.p = false;
	    var updated = false;
	
	    if (this.o !== o) {
	      this.o = o;
	      this._mdf.o = true;
	      updated = true;
	    }
	
	    if (this.sw !== sw) {
	      this.sw = sw;
	      this._mdf.sw = true;
	      updated = true;
	    }
	
	    if (this.sc !== sc) {
	      this.sc = sc;
	      this._mdf.sc = true;
	      updated = true;
	    }
	
	    if (this.fc !== fc) {
	      this.fc = fc;
	      this._mdf.fc = true;
	      updated = true;
	    }
	
	    if (this.m !== m) {
	      this.m = m;
	      this._mdf.m = true;
	      updated = true;
	    }
	
	    if (p.length && (this.p[0] !== p[0] || this.p[1] !== p[1] || this.p[4] !== p[4] || this.p[5] !== p[5] || this.p[12] !== p[12] || this.p[13] !== p[13])) {
	      this.p = p;
	      this._mdf.p = true;
	      updated = true;
	    }
	
	    return updated;
	  };
	
	  function TextProperty(elem, data) {
	    this._frameId = initialDefaultFrame;
	    this.pv = '';
	    this.v = '';
	    this.kf = false;
	    this._isFirstFrame = true;
	    this._mdf = false;
	
	    if (data.d && data.d.sid) {
	      data.d = elem.globalData.slotManager.getProp(data.d);
	    }
	
	    this.data = data;
	    this.elem = elem;
	    this.comp = this.elem.comp;
	    this.keysIndex = 0;
	    this.canResize = false;
	    this.minimumFontSize = 1;
	    this.effectsSequence = [];
	    this.currentData = {
	      ascent: 0,
	      boxWidth: this.defaultBoxWidth,
	      f: '',
	      fStyle: '',
	      fWeight: '',
	      fc: '',
	      j: '',
	      justifyOffset: '',
	      l: [],
	      lh: 0,
	      lineWidths: [],
	      ls: '',
	      of: '',
	      s: '',
	      sc: '',
	      sw: 0,
	      t: 0,
	      tr: 0,
	      sz: 0,
	      ps: null,
	      fillColorAnim: false,
	      strokeColorAnim: false,
	      strokeWidthAnim: false,
	      yOffset: 0,
	      finalSize: 0,
	      finalText: [],
	      finalLineHeight: 0,
	      __complete: false
	    };
	    this.copyData(this.currentData, this.data.d.k[0].s);
	
	    if (!this.searchProperty()) {
	      this.completeTextData(this.currentData);
	    }
	  }
	
	  TextProperty.prototype.defaultBoxWidth = [0, 0];
	
	  TextProperty.prototype.copyData = function (obj, data) {
	    for (var s in data) {
	      if (Object.prototype.hasOwnProperty.call(data, s)) {
	        obj[s] = data[s];
	      }
	    }
	
	    return obj;
	  };
	
	  TextProperty.prototype.setCurrentData = function (data) {
	    if (!data.__complete) {
	      this.completeTextData(data);
	    }
	
	    this.currentData = data;
	    this.currentData.boxWidth = this.currentData.boxWidth || this.defaultBoxWidth;
	    this._mdf = true;
	  };
	
	  TextProperty.prototype.searchProperty = function () {
	    return this.searchKeyframes();
	  };
	
	  TextProperty.prototype.searchKeyframes = function () {
	    this.kf = this.data.d.k.length > 1;
	
	    if (this.kf) {
	      this.addEffect(this.getKeyframeValue.bind(this));
	    }
	
	    return this.kf;
	  };
	
	  TextProperty.prototype.addEffect = function (effectFunction) {
	    this.effectsSequence.push(effectFunction);
	    this.elem.addDynamicProperty(this);
	  };
	
	  TextProperty.prototype.getValue = function (_finalValue) {
	    if ((this.elem.globalData.frameId === this.frameId || !this.effectsSequence.length) && !_finalValue) {
	      return;
	    }
	
	    this.currentData.t = this.data.d.k[this.keysIndex].s.t;
	    var currentValue = this.currentData;
	    var currentIndex = this.keysIndex;
	
	    if (this.lock) {
	      this.setCurrentData(this.currentData);
	      return;
	    }
	
	    this.lock = true;
	    this._mdf = false;
	    var i;
	    var len = this.effectsSequence.length;
	    var finalValue = _finalValue || this.data.d.k[this.keysIndex].s;
	
	    for (i = 0; i < len; i += 1) {
	      // Checking if index changed to prevent creating a new object every time the expression updates.
	      if (currentIndex !== this.keysIndex) {
	        finalValue = this.effectsSequence[i](finalValue, finalValue.t);
	      } else {
	        finalValue = this.effectsSequence[i](this.currentData, finalValue.t);
	      }
	    }
	
	    if (currentValue !== finalValue) {
	      this.setCurrentData(finalValue);
	    }
	
	    this.v = this.currentData;
	    this.pv = this.v;
	    this.lock = false;
	    this.frameId = this.elem.globalData.frameId;
	  };
	
	  TextProperty.prototype.getKeyframeValue = function () {
	    var textKeys = this.data.d.k;
	    var frameNum = this.elem.comp.renderedFrame;
	    var i = 0;
	    var len = textKeys.length;
	
	    while (i <= len - 1) {
	      if (i === len - 1 || textKeys[i + 1].t > frameNum) {
	        break;
	      }
	
	      i += 1;
	    }
	
	    if (this.keysIndex !== i) {
	      this.keysIndex = i;
	    }
	
	    return this.data.d.k[this.keysIndex].s;
	  };
	
	  TextProperty.prototype.buildFinalText = function (text) {
	    var charactersArray = [];
	    var i = 0;
	    var len = text.length;
	    var charCode;
	    var secondCharCode;
	    var shouldCombine = false;
	    var shouldCombineNext = false;
	    var currentChars = '';
	
	    while (i < len) {
	      shouldCombine = shouldCombineNext;
	      shouldCombineNext = false;
	      charCode = text.charCodeAt(i);
	      currentChars = text.charAt(i);
	
	      if (FontManager.isCombinedCharacter(charCode)) {
	        shouldCombine = true; // It's a potential surrogate pair (this is the High surrogate)
	      } else if (charCode >= 0xD800 && charCode <= 0xDBFF) {
	        if (FontManager.isRegionalFlag(text, i)) {
	          currentChars = text.substr(i, 14);
	        } else {
	          secondCharCode = text.charCodeAt(i + 1); // It's a surrogate pair (this is the Low surrogate)
	
	          if (secondCharCode >= 0xDC00 && secondCharCode <= 0xDFFF) {
	            if (FontManager.isModifier(charCode, secondCharCode)) {
	              currentChars = text.substr(i, 2);
	              shouldCombine = true;
	            } else if (FontManager.isFlagEmoji(text.substr(i, 4))) {
	              currentChars = text.substr(i, 4);
	            } else {
	              currentChars = text.substr(i, 2);
	            }
	          }
	        }
	      } else if (charCode > 0xDBFF) {
	        secondCharCode = text.charCodeAt(i + 1);
	
	        if (FontManager.isVariationSelector(charCode)) {
	          shouldCombine = true;
	        }
	      } else if (FontManager.isZeroWidthJoiner(charCode)) {
	        shouldCombine = true;
	        shouldCombineNext = true;
	      }
	
	      if (shouldCombine) {
	        charactersArray[charactersArray.length - 1] += currentChars;
	        shouldCombine = false;
	      } else {
	        charactersArray.push(currentChars);
	      }
	
	      i += currentChars.length;
	    }
	
	    return charactersArray;
	  };
	
	  TextProperty.prototype.completeTextData = function (documentData) {
	    documentData.__complete = true;
	    var fontManager = this.elem.globalData.fontManager;
	    var data = this.data;
	    var letters = [];
	    var i;
	    var len;
	    var newLineFlag;
	    var index = 0;
	    var val;
	    var anchorGrouping = data.m.g;
	    var currentSize = 0;
	    var currentPos = 0;
	    var currentLine = 0;
	    var lineWidths = [];
	    var lineWidth = 0;
	    var maxLineWidth = 0;
	    var j;
	    var jLen;
	    var fontData = fontManager.getFontByName(documentData.f);
	    var charData;
	    var cLength = 0;
	    var fontProps = getFontProperties(fontData);
	    documentData.fWeight = fontProps.weight;
	    documentData.fStyle = fontProps.style;
	    documentData.finalSize = documentData.s;
	    documentData.finalText = this.buildFinalText(documentData.t);
	    len = documentData.finalText.length;
	    documentData.finalLineHeight = documentData.lh;
	    var trackingOffset = documentData.tr / 1000 * documentData.finalSize;
	    var charCode;
	
	    if (documentData.sz) {
	      var flag = true;
	      var boxWidth = documentData.sz[0];
	      var boxHeight = documentData.sz[1];
	      var currentHeight;
	      var finalText;
	
	      while (flag) {
	        finalText = this.buildFinalText(documentData.t);
	        currentHeight = 0;
	        lineWidth = 0;
	        len = finalText.length;
	        trackingOffset = documentData.tr / 1000 * documentData.finalSize;
	        var lastSpaceIndex = -1;
	
	        for (i = 0; i < len; i += 1) {
	          charCode = finalText[i].charCodeAt(0);
	          newLineFlag = false;
	
	          if (finalText[i] === ' ') {
	            lastSpaceIndex = i;
	          } else if (charCode === 13 || charCode === 3) {
	            lineWidth = 0;
	            newLineFlag = true;
	            currentHeight += documentData.finalLineHeight || documentData.finalSize * 1.2;
	          }
	
	          if (fontManager.chars) {
	            charData = fontManager.getCharData(finalText[i], fontData.fStyle, fontData.fFamily);
	            cLength = newLineFlag ? 0 : charData.w * documentData.finalSize / 100;
	          } else {
	            // tCanvasHelper.font = documentData.s + 'px '+ fontData.fFamily;
	            cLength = fontManager.measureText(finalText[i], documentData.f, documentData.finalSize);
	          }
	
	          if (lineWidth + cLength > boxWidth && finalText[i] !== ' ') {
	            if (lastSpaceIndex === -1) {
	              len += 1;
	            } else {
	              i = lastSpaceIndex;
	            }
	
	            currentHeight += documentData.finalLineHeight || documentData.finalSize * 1.2;
	            finalText.splice(i, lastSpaceIndex === i ? 1 : 0, '\r'); // finalText = finalText.substr(0,i) + "\r" + finalText.substr(i === lastSpaceIndex ? i + 1 : i);
	
	            lastSpaceIndex = -1;
	            lineWidth = 0;
	          } else {
	            lineWidth += cLength;
	            lineWidth += trackingOffset;
	          }
	        }
	
	        currentHeight += fontData.ascent * documentData.finalSize / 100;
	
	        if (this.canResize && documentData.finalSize > this.minimumFontSize && boxHeight < currentHeight) {
	          documentData.finalSize -= 1;
	          documentData.finalLineHeight = documentData.finalSize * documentData.lh / documentData.s;
	        } else {
	          documentData.finalText = finalText;
	          len = documentData.finalText.length;
	          flag = false;
	        }
	      }
	    }
	
	    lineWidth = -trackingOffset;
	    cLength = 0;
	    var uncollapsedSpaces = 0;
	    var currentChar;
	
	    for (i = 0; i < len; i += 1) {
	      newLineFlag = false;
	      currentChar = documentData.finalText[i];
	      charCode = currentChar.charCodeAt(0);
	
	      if (charCode === 13 || charCode === 3) {
	        uncollapsedSpaces = 0;
	        lineWidths.push(lineWidth);
	        maxLineWidth = lineWidth > maxLineWidth ? lineWidth : maxLineWidth;
	        lineWidth = -2 * trackingOffset;
	        val = '';
	        newLineFlag = true;
	        currentLine += 1;
	      } else {
	        val = currentChar;
	      }
	
	      if (fontManager.chars) {
	        charData = fontManager.getCharData(currentChar, fontData.fStyle, fontManager.getFontByName(documentData.f).fFamily);
	        cLength = newLineFlag ? 0 : charData.w * documentData.finalSize / 100;
	      } else {
	        // var charWidth = fontManager.measureText(val, documentData.f, documentData.finalSize);
	        // tCanvasHelper.font = documentData.finalSize + 'px '+ fontManager.getFontByName(documentData.f).fFamily;
	        cLength = fontManager.measureText(val, documentData.f, documentData.finalSize);
	      } //
	
	
	      if (currentChar === ' ') {
	        uncollapsedSpaces += cLength + trackingOffset;
	      } else {
	        lineWidth += cLength + trackingOffset + uncollapsedSpaces;
	        uncollapsedSpaces = 0;
	      }
	
	      letters.push({
	        l: cLength,
	        an: cLength,
	        add: currentSize,
	        n: newLineFlag,
	        anIndexes: [],
	        val: val,
	        line: currentLine,
	        animatorJustifyOffset: 0
	      });
	
	      if (anchorGrouping == 2) {
	        // eslint-disable-line eqeqeq
	        currentSize += cLength;
	
	        if (val === '' || val === ' ' || i === len - 1) {
	          if (val === '' || val === ' ') {
	            currentSize -= cLength;
	          }
	
	          while (currentPos <= i) {
	            letters[currentPos].an = currentSize;
	            letters[currentPos].ind = index;
	            letters[currentPos].extra = cLength;
	            currentPos += 1;
	          }
	
	          index += 1;
	          currentSize = 0;
	        }
	      } else if (anchorGrouping == 3) {
	        // eslint-disable-line eqeqeq
	        currentSize += cLength;
	
	        if (val === '' || i === len - 1) {
	          if (val === '') {
	            currentSize -= cLength;
	          }
	
	          while (currentPos <= i) {
	            letters[currentPos].an = currentSize;
	            letters[currentPos].ind = index;
	            letters[currentPos].extra = cLength;
	            currentPos += 1;
	          }
	
	          currentSize = 0;
	          index += 1;
	        }
	      } else {
	        letters[index].ind = index;
	        letters[index].extra = 0;
	        index += 1;
	      }
	    }
	
	    documentData.l = letters;
	    maxLineWidth = lineWidth > maxLineWidth ? lineWidth : maxLineWidth;
	    lineWidths.push(lineWidth);
	
	    if (documentData.sz) {
	      documentData.boxWidth = documentData.sz[0];
	      documentData.justifyOffset = 0;
	    } else {
	      documentData.boxWidth = maxLineWidth;
	
	      switch (documentData.j) {
	        case 1:
	          documentData.justifyOffset = -documentData.boxWidth;
	          break;
	
	        case 2:
	          documentData.justifyOffset = -documentData.boxWidth / 2;
	          break;
	
	        default:
	          documentData.justifyOffset = 0;
	      }
	    }
	
	    documentData.lineWidths = lineWidths;
	    var animators = data.a;
	    var animatorData;
	    var letterData;
	    jLen = animators.length;
	    var based;
	    var ind;
	    var indexes = [];
	
	    for (j = 0; j < jLen; j += 1) {
	      animatorData = animators[j];
	
	      if (animatorData.a.sc) {
	        documentData.strokeColorAnim = true;
	      }
	
	      if (animatorData.a.sw) {
	        documentData.strokeWidthAnim = true;
	      }
	
	      if (animatorData.a.fc || animatorData.a.fh || animatorData.a.fs || animatorData.a.fb) {
	        documentData.fillColorAnim = true;
	      }
	
	      ind = 0;
	      based = animatorData.s.b;
	
	      for (i = 0; i < len; i += 1) {
	        letterData = letters[i];
	        letterData.anIndexes[j] = ind;
	
	        if (based == 1 && letterData.val !== '' || based == 2 && letterData.val !== '' && letterData.val !== ' ' || based == 3 && (letterData.n || letterData.val == ' ' || i == len - 1) || based == 4 && (letterData.n || i == len - 1)) {
	          // eslint-disable-line eqeqeq
	          if (animatorData.s.rn === 1) {
	            indexes.push(ind);
	          }
	
	          ind += 1;
	        }
	      }
	
	      data.a[j].s.totalChars = ind;
	      var currentInd = -1;
	      var newInd;
	
	      if (animatorData.s.rn === 1) {
	        for (i = 0; i < len; i += 1) {
	          letterData = letters[i];
	
	          if (currentInd != letterData.anIndexes[j]) {
	            // eslint-disable-line eqeqeq
	            currentInd = letterData.anIndexes[j];
	            newInd = indexes.splice(Math.floor(Math.random() * indexes.length), 1)[0];
	          }
	
	          letterData.anIndexes[j] = newInd;
	        }
	      }
	    }
	
	    documentData.yOffset = documentData.finalLineHeight || documentData.finalSize * 1.2;
	    documentData.ls = documentData.ls || 0;
	    documentData.ascent = fontData.ascent * documentData.finalSize / 100;
	  };
	
	  TextProperty.prototype.updateDocumentData = function (newData, index) {
	    index = index === undefined ? this.keysIndex : index;
	    var dData = this.copyData({}, this.data.d.k[index].s);
	    dData = this.copyData(dData, newData);
	    this.data.d.k[index].s = dData;
	    this.recalculate(index);
	    this.setCurrentData(dData);
	    this.elem.addDynamicProperty(this);
	  };
	
	  TextProperty.prototype.recalculate = function (index) {
	    var dData = this.data.d.k[index].s;
	    dData.__complete = false;
	    this.keysIndex = 0;
	    this._isFirstFrame = true;
	    this.getValue(dData);
	  };
	
	  TextProperty.prototype.canResizeFont = function (_canResize) {
	    this.canResize = _canResize;
	    this.recalculate(this.keysIndex);
	    this.elem.addDynamicProperty(this);
	  };
	
	  TextProperty.prototype.setMinimumFontSize = function (_fontValue) {
	    this.minimumFontSize = Math.floor(_fontValue) || 1;
	    this.recalculate(this.keysIndex);
	    this.elem.addDynamicProperty(this);
	  };
	
	  var TextSelectorProp = function () {
	    var max = Math.max;
	    var min = Math.min;
	    var floor = Math.floor;
	
	    function TextSelectorPropFactory(elem, data) {
	      this._currentTextLength = -1;
	      this.k = false;
	      this.data = data;
	      this.elem = elem;
	      this.comp = elem.comp;
	      this.finalS = 0;
	      this.finalE = 0;
	      this.initDynamicPropertyContainer(elem);
	      this.s = PropertyFactory.getProp(elem, data.s || {
	        k: 0
	      }, 0, 0, this);
	
	      if ('e' in data) {
	        this.e = PropertyFactory.getProp(elem, data.e, 0, 0, this);
	      } else {
	        this.e = {
	          v: 100
	        };
	      }
	
	      this.o = PropertyFactory.getProp(elem, data.o || {
	        k: 0
	      }, 0, 0, this);
	      this.xe = PropertyFactory.getProp(elem, data.xe || {
	        k: 0
	      }, 0, 0, this);
	      this.ne = PropertyFactory.getProp(elem, data.ne || {
	        k: 0
	      }, 0, 0, this);
	      this.sm = PropertyFactory.getProp(elem, data.sm || {
	        k: 100
	      }, 0, 0, this);
	      this.a = PropertyFactory.getProp(elem, data.a, 0, 0.01, this);
	
	      if (!this.dynamicProperties.length) {
	        this.getValue();
	      }
	    }
	
	    TextSelectorPropFactory.prototype = {
	      getMult: function getMult(ind) {
	        if (this._currentTextLength !== this.elem.textProperty.currentData.l.length) {
	          this.getValue();
	        }
	
	        var x1 = 0;
	        var y1 = 0;
	        var x2 = 1;
	        var y2 = 1;
	
	        if (this.ne.v > 0) {
	          x1 = this.ne.v / 100.0;
	        } else {
	          y1 = -this.ne.v / 100.0;
	        }
	
	        if (this.xe.v > 0) {
	          x2 = 1.0 - this.xe.v / 100.0;
	        } else {
	          y2 = 1.0 + this.xe.v / 100.0;
	        }
	
	        var easer = BezierFactory.getBezierEasing(x1, y1, x2, y2).get;
	        var mult = 0;
	        var s = this.finalS;
	        var e = this.finalE;
	        var type = this.data.sh;
	
	        if (type === 2) {
	          if (e === s) {
	            mult = ind >= e ? 1 : 0;
	          } else {
	            mult = max(0, min(0.5 / (e - s) + (ind - s) / (e - s), 1));
	          }
	
	          mult = easer(mult);
	        } else if (type === 3) {
	          if (e === s) {
	            mult = ind >= e ? 0 : 1;
	          } else {
	            mult = 1 - max(0, min(0.5 / (e - s) + (ind - s) / (e - s), 1));
	          }
	
	          mult = easer(mult);
	        } else if (type === 4) {
	          if (e === s) {
	            mult = 0;
	          } else {
	            mult = max(0, min(0.5 / (e - s) + (ind - s) / (e - s), 1));
	
	            if (mult < 0.5) {
	              mult *= 2;
	            } else {
	              mult = 1 - 2 * (mult - 0.5);
	            }
	          }
	
	          mult = easer(mult);
	        } else if (type === 5) {
	          if (e === s) {
	            mult = 0;
	          } else {
	            var tot = e - s;
	            /* ind += 0.5;
	                      mult = -4/(tot*tot)*(ind*ind)+(4/tot)*ind; */
	
	            ind = min(max(0, ind + 0.5 - s), e - s);
	            var x = -tot / 2 + ind;
	            var a = tot / 2;
	            mult = Math.sqrt(1 - x * x / (a * a));
	          }
	
	          mult = easer(mult);
	        } else if (type === 6) {
	          if (e === s) {
	            mult = 0;
	          } else {
	            ind = min(max(0, ind + 0.5 - s), e - s);
	            mult = (1 + Math.cos(Math.PI + Math.PI * 2 * ind / (e - s))) / 2; // eslint-disable-line
	          }
	
	          mult = easer(mult);
	        } else {
	          if (ind >= floor(s)) {
	            if (ind - s < 0) {
	              mult = max(0, min(min(e, 1) - (s - ind), 1));
	            } else {
	              mult = max(0, min(e - ind, 1));
	            }
	          }
	
	          mult = easer(mult);
	        } // Smoothness implementation.
	        // The smoothness represents a reduced range of the original [0; 1] range.
	        // if smoothness is 25%, the new range will be [0.375; 0.625]
	        // Steps are:
	        // - find the lower value of the new range (threshold)
	        // - if multiplier is smaller than that value, floor it to 0
	        // - if it is larger,
	        //     - subtract the threshold
	        //     - divide it by the smoothness (this will return the range to [0; 1])
	        // Note: If it doesn't work on some scenarios, consider applying it before the easer.
	
	
	        if (this.sm.v !== 100) {
	          var smoothness = this.sm.v * 0.01;
	
	          if (smoothness === 0) {
	            smoothness = 0.00000001;
	          }
	
	          var threshold = 0.5 - smoothness * 0.5;
	
	          if (mult < threshold) {
	            mult = 0;
	          } else {
	            mult = (mult - threshold) / smoothness;
	
	            if (mult > 1) {
	              mult = 1;
	            }
	          }
	        }
	
	        return mult * this.a.v;
	      },
	      getValue: function getValue(newCharsFlag) {
	        this.iterateDynamicProperties();
	        this._mdf = newCharsFlag || this._mdf;
	        this._currentTextLength = this.elem.textProperty.currentData.l.length || 0;
	
	        if (newCharsFlag && this.data.r === 2) {
	          this.e.v = this._currentTextLength;
	        }
	
	        var divisor = this.data.r === 2 ? 1 : 100 / this.data.totalChars;
	        var o = this.o.v / divisor;
	        var s = this.s.v / divisor + o;
	        var e = this.e.v / divisor + o;
	
	        if (s > e) {
	          var _s = s;
	          s = e;
	          e = _s;
	        }
	
	        this.finalS = s;
	        this.finalE = e;
	      }
	    };
	    extendPrototype([DynamicPropertyContainer], TextSelectorPropFactory);
	
	    function getTextSelectorProp(elem, data, arr) {
	      return new TextSelectorPropFactory(elem, data, arr);
	    }
	
	    return {
	      getTextSelectorProp: getTextSelectorProp
	    };
	  }();
	
	  function TextAnimatorDataProperty(elem, animatorProps, container) {
	    var defaultData = {
	      propType: false
	    };
	    var getProp = PropertyFactory.getProp;
	    var textAnimatorAnimatables = animatorProps.a;
	    this.a = {
	      r: textAnimatorAnimatables.r ? getProp(elem, textAnimatorAnimatables.r, 0, degToRads, container) : defaultData,
	      rx: textAnimatorAnimatables.rx ? getProp(elem, textAnimatorAnimatables.rx, 0, degToRads, container) : defaultData,
	      ry: textAnimatorAnimatables.ry ? getProp(elem, textAnimatorAnimatables.ry, 0, degToRads, container) : defaultData,
	      sk: textAnimatorAnimatables.sk ? getProp(elem, textAnimatorAnimatables.sk, 0, degToRads, container) : defaultData,
	      sa: textAnimatorAnimatables.sa ? getProp(elem, textAnimatorAnimatables.sa, 0, degToRads, container) : defaultData,
	      s: textAnimatorAnimatables.s ? getProp(elem, textAnimatorAnimatables.s, 1, 0.01, container) : defaultData,
	      a: textAnimatorAnimatables.a ? getProp(elem, textAnimatorAnimatables.a, 1, 0, container) : defaultData,
	      o: textAnimatorAnimatables.o ? getProp(elem, textAnimatorAnimatables.o, 0, 0.01, container) : defaultData,
	      p: textAnimatorAnimatables.p ? getProp(elem, textAnimatorAnimatables.p, 1, 0, container) : defaultData,
	      sw: textAnimatorAnimatables.sw ? getProp(elem, textAnimatorAnimatables.sw, 0, 0, container) : defaultData,
	      sc: textAnimatorAnimatables.sc ? getProp(elem, textAnimatorAnimatables.sc, 1, 0, container) : defaultData,
	      fc: textAnimatorAnimatables.fc ? getProp(elem, textAnimatorAnimatables.fc, 1, 0, container) : defaultData,
	      fh: textAnimatorAnimatables.fh ? getProp(elem, textAnimatorAnimatables.fh, 0, 0, container) : defaultData,
	      fs: textAnimatorAnimatables.fs ? getProp(elem, textAnimatorAnimatables.fs, 0, 0.01, container) : defaultData,
	      fb: textAnimatorAnimatables.fb ? getProp(elem, textAnimatorAnimatables.fb, 0, 0.01, container) : defaultData,
	      t: textAnimatorAnimatables.t ? getProp(elem, textAnimatorAnimatables.t, 0, 0, container) : defaultData
	    };
	    this.s = TextSelectorProp.getTextSelectorProp(elem, animatorProps.s, container);
	    this.s.t = animatorProps.s.t;
	  }
	
	  function TextAnimatorProperty(textData, renderType, elem) {
	    this._isFirstFrame = true;
	    this._hasMaskedPath = false;
	    this._frameId = -1;
	    this._textData = textData;
	    this._renderType = renderType;
	    this._elem = elem;
	    this._animatorsData = createSizedArray(this._textData.a.length);
	    this._pathData = {};
	    this._moreOptions = {
	      alignment: {}
	    };
	    this.renderedLetters = [];
	    this.lettersChangedFlag = false;
	    this.initDynamicPropertyContainer(elem);
	  }
	
	  TextAnimatorProperty.prototype.searchProperties = function () {
	    var i;
	    var len = this._textData.a.length;
	    var animatorProps;
	    var getProp = PropertyFactory.getProp;
	
	    for (i = 0; i < len; i += 1) {
	      animatorProps = this._textData.a[i];
	      this._animatorsData[i] = new TextAnimatorDataProperty(this._elem, animatorProps, this);
	    }
	
	    if (this._textData.p && 'm' in this._textData.p) {
	      this._pathData = {
	        a: getProp(this._elem, this._textData.p.a, 0, 0, this),
	        f: getProp(this._elem, this._textData.p.f, 0, 0, this),
	        l: getProp(this._elem, this._textData.p.l, 0, 0, this),
	        r: getProp(this._elem, this._textData.p.r, 0, 0, this),
	        p: getProp(this._elem, this._textData.p.p, 0, 0, this),
	        m: this._elem.maskManager.getMaskProperty(this._textData.p.m)
	      };
	      this._hasMaskedPath = true;
	    } else {
	      this._hasMaskedPath = false;
	    }
	
	    this._moreOptions.alignment = getProp(this._elem, this._textData.m.a, 1, 0, this);
	  };
	
	  TextAnimatorProperty.prototype.getMeasures = function (documentData, lettersChangedFlag) {
	    this.lettersChangedFlag = lettersChangedFlag;
	
	    if (!this._mdf && !this._isFirstFrame && !lettersChangedFlag && (!this._hasMaskedPath || !this._pathData.m._mdf)) {
	      return;
	    }
	
	    this._isFirstFrame = false;
	    var alignment = this._moreOptions.alignment.v;
	    var animators = this._animatorsData;
	    var textData = this._textData;
	    var matrixHelper = this.mHelper;
	    var renderType = this._renderType;
	    var renderedLettersCount = this.renderedLetters.length;
	    var xPos;
	    var yPos;
	    var i;
	    var len;
	    var letters = documentData.l;
	    var pathInfo;
	    var currentLength;
	    var currentPoint;
	    var segmentLength;
	    var flag;
	    var pointInd;
	    var segmentInd;
	    var prevPoint;
	    var points;
	    var segments;
	    var partialLength;
	    var totalLength;
	    var perc;
	    var tanAngle;
	    var mask;
	
	    if (this._hasMaskedPath) {
	      mask = this._pathData.m;
	
	      if (!this._pathData.n || this._pathData._mdf) {
	        var paths = mask.v;
	
	        if (this._pathData.r.v) {
	          paths = paths.reverse();
	        } // TODO: release bezier data cached from previous pathInfo: this._pathData.pi
	
	
	        pathInfo = {
	          tLength: 0,
	          segments: []
	        };
	        len = paths._length - 1;
	        var bezierData;
	        totalLength = 0;
	
	        for (i = 0; i < len; i += 1) {
	          bezierData = bez.buildBezierData(paths.v[i], paths.v[i + 1], [paths.o[i][0] - paths.v[i][0], paths.o[i][1] - paths.v[i][1]], [paths.i[i + 1][0] - paths.v[i + 1][0], paths.i[i + 1][1] - paths.v[i + 1][1]]);
	          pathInfo.tLength += bezierData.segmentLength;
	          pathInfo.segments.push(bezierData);
	          totalLength += bezierData.segmentLength;
	        }
	
	        i = len;
	
	        if (mask.v.c) {
	          bezierData = bez.buildBezierData(paths.v[i], paths.v[0], [paths.o[i][0] - paths.v[i][0], paths.o[i][1] - paths.v[i][1]], [paths.i[0][0] - paths.v[0][0], paths.i[0][1] - paths.v[0][1]]);
	          pathInfo.tLength += bezierData.segmentLength;
	          pathInfo.segments.push(bezierData);
	          totalLength += bezierData.segmentLength;
	        }
	
	        this._pathData.pi = pathInfo;
	      }
	
	      pathInfo = this._pathData.pi;
	      currentLength = this._pathData.f.v;
	      segmentInd = 0;
	      pointInd = 1;
	      segmentLength = 0;
	      flag = true;
	      segments = pathInfo.segments;
	
	      if (currentLength < 0 && mask.v.c) {
	        if (pathInfo.tLength < Math.abs(currentLength)) {
	          currentLength = -Math.abs(currentLength) % pathInfo.tLength;
	        }
	
	        segmentInd = segments.length - 1;
	        points = segments[segmentInd].points;
	        pointInd = points.length - 1;
	
	        while (currentLength < 0) {
	          currentLength += points[pointInd].partialLength;
	          pointInd -= 1;
	
	          if (pointInd < 0) {
	            segmentInd -= 1;
	            points = segments[segmentInd].points;
	            pointInd = points.length - 1;
	          }
	        }
	      }
	
	      points = segments[segmentInd].points;
	      prevPoint = points[pointInd - 1];
	      currentPoint = points[pointInd];
	      partialLength = currentPoint.partialLength;
	    }
	
	    len = letters.length;
	    xPos = 0;
	    yPos = 0;
	    var yOff = documentData.finalSize * 1.2 * 0.714;
	    var firstLine = true;
	    var animatorProps;
	    var animatorSelector;
	    var j;
	    var jLen;
	    var letterValue;
	    jLen = animators.length;
	    var mult;
	    var ind = -1;
	    var offf;
	    var xPathPos;
	    var yPathPos;
	    var initPathPos = currentLength;
	    var initSegmentInd = segmentInd;
	    var initPointInd = pointInd;
	    var currentLine = -1;
	    var elemOpacity;
	    var sc;
	    var sw;
	    var fc;
	    var k;
	    var letterSw;
	    var letterSc;
	    var letterFc;
	    var letterM = '';
	    var letterP = this.defaultPropsArray;
	    var letterO; //
	
	    if (documentData.j === 2 || documentData.j === 1) {
	      var animatorJustifyOffset = 0;
	      var animatorFirstCharOffset = 0;
	      var justifyOffsetMult = documentData.j === 2 ? -0.5 : -1;
	      var lastIndex = 0;
	      var isNewLine = true;
	
	      for (i = 0; i < len; i += 1) {
	        if (letters[i].n) {
	          if (animatorJustifyOffset) {
	            animatorJustifyOffset += animatorFirstCharOffset;
	          }
	
	          while (lastIndex < i) {
	            letters[lastIndex].animatorJustifyOffset = animatorJustifyOffset;
	            lastIndex += 1;
	          }
	
	          animatorJustifyOffset = 0;
	          isNewLine = true;
	        } else {
	          for (j = 0; j < jLen; j += 1) {
	            animatorProps = animators[j].a;
	
	            if (animatorProps.t.propType) {
	              if (isNewLine && documentData.j === 2) {
	                animatorFirstCharOffset += animatorProps.t.v * justifyOffsetMult;
	              }
	
	              animatorSelector = animators[j].s;
	              mult = animatorSelector.getMult(letters[i].anIndexes[j], textData.a[j].s.totalChars);
	
	              if (mult.length) {
	                animatorJustifyOffset += animatorProps.t.v * mult[0] * justifyOffsetMult;
	              } else {
	                animatorJustifyOffset += animatorProps.t.v * mult * justifyOffsetMult;
	              }
	            }
	          }
	
	          isNewLine = false;
	        }
	      }
	
	      if (animatorJustifyOffset) {
	        animatorJustifyOffset += animatorFirstCharOffset;
	      }
	
	      while (lastIndex < i) {
	        letters[lastIndex].animatorJustifyOffset = animatorJustifyOffset;
	        lastIndex += 1;
	      }
	    } //
	
	
	    for (i = 0; i < len; i += 1) {
	      matrixHelper.reset();
	      elemOpacity = 1;
	
	      if (letters[i].n) {
	        xPos = 0;
	        yPos += documentData.yOffset;
	        yPos += firstLine ? 1 : 0;
	        currentLength = initPathPos;
	        firstLine = false;
	
	        if (this._hasMaskedPath) {
	          segmentInd = initSegmentInd;
	          pointInd = initPointInd;
	          points = segments[segmentInd].points;
	          prevPoint = points[pointInd - 1];
	          currentPoint = points[pointInd];
	          partialLength = currentPoint.partialLength;
	          segmentLength = 0;
	        }
	
	        letterM = '';
	        letterFc = '';
	        letterSw = '';
	        letterO = '';
	        letterP = this.defaultPropsArray;
	      } else {
	        if (this._hasMaskedPath) {
	          if (currentLine !== letters[i].line) {
	            switch (documentData.j) {
	              case 1:
	                currentLength += totalLength - documentData.lineWidths[letters[i].line];
	                break;
	
	              case 2:
	                currentLength += (totalLength - documentData.lineWidths[letters[i].line]) / 2;
	                break;
	
	              default:
	                break;
	            }
	
	            currentLine = letters[i].line;
	          }
	
	          if (ind !== letters[i].ind) {
	            if (letters[ind]) {
	              currentLength += letters[ind].extra;
	            }
	
	            currentLength += letters[i].an / 2;
	            ind = letters[i].ind;
	          }
	
	          currentLength += alignment[0] * letters[i].an * 0.005;
	          var animatorOffset = 0;
	
	          for (j = 0; j < jLen; j += 1) {
	            animatorProps = animators[j].a;
	
	            if (animatorProps.p.propType) {
	              animatorSelector = animators[j].s;
	              mult = animatorSelector.getMult(letters[i].anIndexes[j], textData.a[j].s.totalChars);
	
	              if (mult.length) {
	                animatorOffset += animatorProps.p.v[0] * mult[0];
	              } else {
	                animatorOffset += animatorProps.p.v[0] * mult;
	              }
	            }
	
	            if (animatorProps.a.propType) {
	              animatorSelector = animators[j].s;
	              mult = animatorSelector.getMult(letters[i].anIndexes[j], textData.a[j].s.totalChars);
	
	              if (mult.length) {
	                animatorOffset += animatorProps.a.v[0] * mult[0];
	              } else {
	                animatorOffset += animatorProps.a.v[0] * mult;
	              }
	            }
	          }
	
	          flag = true; // Force alignment only works with a single line for now
	
	          if (this._pathData.a.v) {
	            currentLength = letters[0].an * 0.5 + (totalLength - this._pathData.f.v - letters[0].an * 0.5 - letters[letters.length - 1].an * 0.5) * ind / (len - 1);
	            currentLength += this._pathData.f.v;
	          }
	
	          while (flag) {
	            if (segmentLength + partialLength >= currentLength + animatorOffset || !points) {
	              perc = (currentLength + animatorOffset - segmentLength) / currentPoint.partialLength;
	              xPathPos = prevPoint.point[0] + (currentPoint.point[0] - prevPoint.point[0]) * perc;
	              yPathPos = prevPoint.point[1] + (currentPoint.point[1] - prevPoint.point[1]) * perc;
	              matrixHelper.translate(-alignment[0] * letters[i].an * 0.005, -(alignment[1] * yOff) * 0.01);
	              flag = false;
	            } else if (points) {
	              segmentLength += currentPoint.partialLength;
	              pointInd += 1;
	
	              if (pointInd >= points.length) {
	                pointInd = 0;
	                segmentInd += 1;
	
	                if (!segments[segmentInd]) {
	                  if (mask.v.c) {
	                    pointInd = 0;
	                    segmentInd = 0;
	                    points = segments[segmentInd].points;
	                  } else {
	                    segmentLength -= currentPoint.partialLength;
	                    points = null;
	                  }
	                } else {
	                  points = segments[segmentInd].points;
	                }
	              }
	
	              if (points) {
	                prevPoint = currentPoint;
	                currentPoint = points[pointInd];
	                partialLength = currentPoint.partialLength;
	              }
	            }
	          }
	
	          offf = letters[i].an / 2 - letters[i].add;
	          matrixHelper.translate(-offf, 0, 0);
	        } else {
	          offf = letters[i].an / 2 - letters[i].add;
	          matrixHelper.translate(-offf, 0, 0); // Grouping alignment
	
	          matrixHelper.translate(-alignment[0] * letters[i].an * 0.005, -alignment[1] * yOff * 0.01, 0);
	        }
	
	        for (j = 0; j < jLen; j += 1) {
	          animatorProps = animators[j].a;
	
	          if (animatorProps.t.propType) {
	            animatorSelector = animators[j].s;
	            mult = animatorSelector.getMult(letters[i].anIndexes[j], textData.a[j].s.totalChars); // This condition is to prevent applying tracking to first character in each line. Might be better to use a boolean "isNewLine"
	
	            if (xPos !== 0 || documentData.j !== 0) {
	              if (this._hasMaskedPath) {
	                if (mult.length) {
	                  currentLength += animatorProps.t.v * mult[0];
	                } else {
	                  currentLength += animatorProps.t.v * mult;
	                }
	              } else if (mult.length) {
	                xPos += animatorProps.t.v * mult[0];
	              } else {
	                xPos += animatorProps.t.v * mult;
	              }
	            }
	          }
	        }
	
	        if (documentData.strokeWidthAnim) {
	          sw = documentData.sw || 0;
	        }
	
	        if (documentData.strokeColorAnim) {
	          if (documentData.sc) {
	            sc = [documentData.sc[0], documentData.sc[1], documentData.sc[2]];
	          } else {
	            sc = [0, 0, 0];
	          }
	        }
	
	        if (documentData.fillColorAnim && documentData.fc) {
	          fc = [documentData.fc[0], documentData.fc[1], documentData.fc[2]];
	        }
	
	        for (j = 0; j < jLen; j += 1) {
	          animatorProps = animators[j].a;
	
	          if (animatorProps.a.propType) {
	            animatorSelector = animators[j].s;
	            mult = animatorSelector.getMult(letters[i].anIndexes[j], textData.a[j].s.totalChars);
	
	            if (mult.length) {
	              matrixHelper.translate(-animatorProps.a.v[0] * mult[0], -animatorProps.a.v[1] * mult[1], animatorProps.a.v[2] * mult[2]);
	            } else {
	              matrixHelper.translate(-animatorProps.a.v[0] * mult, -animatorProps.a.v[1] * mult, animatorProps.a.v[2] * mult);
	            }
	          }
	        }
	
	        for (j = 0; j < jLen; j += 1) {
	          animatorProps = animators[j].a;
	
	          if (animatorProps.s.propType) {
	            animatorSelector = animators[j].s;
	            mult = animatorSelector.getMult(letters[i].anIndexes[j], textData.a[j].s.totalChars);
	
	            if (mult.length) {
	              matrixHelper.scale(1 + (animatorProps.s.v[0] - 1) * mult[0], 1 + (animatorProps.s.v[1] - 1) * mult[1], 1);
	            } else {
	              matrixHelper.scale(1 + (animatorProps.s.v[0] - 1) * mult, 1 + (animatorProps.s.v[1] - 1) * mult, 1);
	            }
	          }
	        }
	
	        for (j = 0; j < jLen; j += 1) {
	          animatorProps = animators[j].a;
	          animatorSelector = animators[j].s;
	          mult = animatorSelector.getMult(letters[i].anIndexes[j], textData.a[j].s.totalChars);
	
	          if (animatorProps.sk.propType) {
	            if (mult.length) {
	              matrixHelper.skewFromAxis(-animatorProps.sk.v * mult[0], animatorProps.sa.v * mult[1]);
	            } else {
	              matrixHelper.skewFromAxis(-animatorProps.sk.v * mult, animatorProps.sa.v * mult);
	            }
	          }
	
	          if (animatorProps.r.propType) {
	            if (mult.length) {
	              matrixHelper.rotateZ(-animatorProps.r.v * mult[2]);
	            } else {
	              matrixHelper.rotateZ(-animatorProps.r.v * mult);
	            }
	          }
	
	          if (animatorProps.ry.propType) {
	            if (mult.length) {
	              matrixHelper.rotateY(animatorProps.ry.v * mult[1]);
	            } else {
	              matrixHelper.rotateY(animatorProps.ry.v * mult);
	            }
	          }
	
	          if (animatorProps.rx.propType) {
	            if (mult.length) {
	              matrixHelper.rotateX(animatorProps.rx.v * mult[0]);
	            } else {
	              matrixHelper.rotateX(animatorProps.rx.v * mult);
	            }
	          }
	
	          if (animatorProps.o.propType) {
	            if (mult.length) {
	              elemOpacity += (animatorProps.o.v * mult[0] - elemOpacity) * mult[0];
	            } else {
	              elemOpacity += (animatorProps.o.v * mult - elemOpacity) * mult;
	            }
	          }
	
	          if (documentData.strokeWidthAnim && animatorProps.sw.propType) {
	            if (mult.length) {
	              sw += animatorProps.sw.v * mult[0];
	            } else {
	              sw += animatorProps.sw.v * mult;
	            }
	          }
	
	          if (documentData.strokeColorAnim && animatorProps.sc.propType) {
	            for (k = 0; k < 3; k += 1) {
	              if (mult.length) {
	                sc[k] += (animatorProps.sc.v[k] - sc[k]) * mult[0];
	              } else {
	                sc[k] += (animatorProps.sc.v[k] - sc[k]) * mult;
	              }
	            }
	          }
	
	          if (documentData.fillColorAnim && documentData.fc) {
	            if (animatorProps.fc.propType) {
	              for (k = 0; k < 3; k += 1) {
	                if (mult.length) {
	                  fc[k] += (animatorProps.fc.v[k] - fc[k]) * mult[0];
	                } else {
	                  fc[k] += (animatorProps.fc.v[k] - fc[k]) * mult;
	                }
	              }
	            }
	
	            if (animatorProps.fh.propType) {
	              if (mult.length) {
	                fc = addHueToRGB(fc, animatorProps.fh.v * mult[0]);
	              } else {
	                fc = addHueToRGB(fc, animatorProps.fh.v * mult);
	              }
	            }
	
	            if (animatorProps.fs.propType) {
	              if (mult.length) {
	                fc = addSaturationToRGB(fc, animatorProps.fs.v * mult[0]);
	              } else {
	                fc = addSaturationToRGB(fc, animatorProps.fs.v * mult);
	              }
	            }
	
	            if (animatorProps.fb.propType) {
	              if (mult.length) {
	                fc = addBrightnessToRGB(fc, animatorProps.fb.v * mult[0]);
	              } else {
	                fc = addBrightnessToRGB(fc, animatorProps.fb.v * mult);
	              }
	            }
	          }
	        }
	
	        for (j = 0; j < jLen; j += 1) {
	          animatorProps = animators[j].a;
	
	          if (animatorProps.p.propType) {
	            animatorSelector = animators[j].s;
	            mult = animatorSelector.getMult(letters[i].anIndexes[j], textData.a[j].s.totalChars);
	
	            if (this._hasMaskedPath) {
	              if (mult.length) {
	                matrixHelper.translate(0, animatorProps.p.v[1] * mult[0], -animatorProps.p.v[2] * mult[1]);
	              } else {
	                matrixHelper.translate(0, animatorProps.p.v[1] * mult, -animatorProps.p.v[2] * mult);
	              }
	            } else if (mult.length) {
	              matrixHelper.translate(animatorProps.p.v[0] * mult[0], animatorProps.p.v[1] * mult[1], -animatorProps.p.v[2] * mult[2]);
	            } else {
	              matrixHelper.translate(animatorProps.p.v[0] * mult, animatorProps.p.v[1] * mult, -animatorProps.p.v[2] * mult);
	            }
	          }
	        }
	
	        if (documentData.strokeWidthAnim) {
	          letterSw = sw < 0 ? 0 : sw;
	        }
	
	        if (documentData.strokeColorAnim) {
	          letterSc = 'rgb(' + Math.round(sc[0] * 255) + ',' + Math.round(sc[1] * 255) + ',' + Math.round(sc[2] * 255) + ')';
	        }
	
	        if (documentData.fillColorAnim && documentData.fc) {
	          letterFc = 'rgb(' + Math.round(fc[0] * 255) + ',' + Math.round(fc[1] * 255) + ',' + Math.round(fc[2] * 255) + ')';
	        }
	
	        if (this._hasMaskedPath) {
	          matrixHelper.translate(0, -documentData.ls);
	          matrixHelper.translate(0, alignment[1] * yOff * 0.01 + yPos, 0);
	
	          if (this._pathData.p.v) {
	            tanAngle = (currentPoint.point[1] - prevPoint.point[1]) / (currentPoint.point[0] - prevPoint.point[0]);
	            var rot = Math.atan(tanAngle) * 180 / Math.PI;
	
	            if (currentPoint.point[0] < prevPoint.point[0]) {
	              rot += 180;
	            }
	
	            matrixHelper.rotate(-rot * Math.PI / 180);
	          }
	
	          matrixHelper.translate(xPathPos, yPathPos, 0);
	          currentLength -= alignment[0] * letters[i].an * 0.005;
	
	          if (letters[i + 1] && ind !== letters[i + 1].ind) {
	            currentLength += letters[i].an / 2;
	            currentLength += documentData.tr * 0.001 * documentData.finalSize;
	          }
	        } else {
	          matrixHelper.translate(xPos, yPos, 0);
	
	          if (documentData.ps) {
	            // matrixHelper.translate(documentData.ps[0],documentData.ps[1],0);
	            matrixHelper.translate(documentData.ps[0], documentData.ps[1] + documentData.ascent, 0);
	          }
	
	          switch (documentData.j) {
	            case 1:
	              matrixHelper.translate(letters[i].animatorJustifyOffset + documentData.justifyOffset + (documentData.boxWidth - documentData.lineWidths[letters[i].line]), 0, 0);
	              break;
	
	            case 2:
	              matrixHelper.translate(letters[i].animatorJustifyOffset + documentData.justifyOffset + (documentData.boxWidth - documentData.lineWidths[letters[i].line]) / 2, 0, 0);
	              break;
	
	            default:
	              break;
	          }
	
	          matrixHelper.translate(0, -documentData.ls);
	          matrixHelper.translate(offf, 0, 0);
	          matrixHelper.translate(alignment[0] * letters[i].an * 0.005, alignment[1] * yOff * 0.01, 0);
	          xPos += letters[i].l + documentData.tr * 0.001 * documentData.finalSize;
	        }
	
	        if (renderType === 'html') {
	          letterM = matrixHelper.toCSS();
	        } else if (renderType === 'svg') {
	          letterM = matrixHelper.to2dCSS();
	        } else {
	          letterP = [matrixHelper.props[0], matrixHelper.props[1], matrixHelper.props[2], matrixHelper.props[3], matrixHelper.props[4], matrixHelper.props[5], matrixHelper.props[6], matrixHelper.props[7], matrixHelper.props[8], matrixHelper.props[9], matrixHelper.props[10], matrixHelper.props[11], matrixHelper.props[12], matrixHelper.props[13], matrixHelper.props[14], matrixHelper.props[15]];
	        }
	
	        letterO = elemOpacity;
	      }
	
	      if (renderedLettersCount <= i) {
	        letterValue = new LetterProps(letterO, letterSw, letterSc, letterFc, letterM, letterP);
	        this.renderedLetters.push(letterValue);
	        renderedLettersCount += 1;
	        this.lettersChangedFlag = true;
	      } else {
	        letterValue = this.renderedLetters[i];
	        this.lettersChangedFlag = letterValue.update(letterO, letterSw, letterSc, letterFc, letterM, letterP) || this.lettersChangedFlag;
	      }
	    }
	  };
	
	  TextAnimatorProperty.prototype.getValue = function () {
	    if (this._elem.globalData.frameId === this._frameId) {
	      return;
	    }
	
	    this._frameId = this._elem.globalData.frameId;
	    this.iterateDynamicProperties();
	  };
	
	  TextAnimatorProperty.prototype.mHelper = new Matrix();
	  TextAnimatorProperty.prototype.defaultPropsArray = [];
	  extendPrototype([DynamicPropertyContainer], TextAnimatorProperty);
	
	  function ITextElement() {}
	
	  ITextElement.prototype.initElement = function (data, globalData, comp) {
	    this.lettersChangedFlag = true;
	    this.initFrame();
	    this.initBaseData(data, globalData, comp);
	    this.textProperty = new TextProperty(this, data.t, this.dynamicProperties);
	    this.textAnimator = new TextAnimatorProperty(data.t, this.renderType, this);
	    this.initTransform(data, globalData, comp);
	    this.initHierarchy();
	    this.initRenderable();
	    this.initRendererElement();
	    this.createContainerElements();
	    this.createRenderableComponents();
	    this.createContent();
	    this.hide();
	    this.textAnimator.searchProperties(this.dynamicProperties);
	  };
	
	  ITextElement.prototype.prepareFrame = function (num) {
	    this._mdf = false;
	    this.prepareRenderableFrame(num);
	    this.prepareProperties(num, this.isInRange);
	  };
	
	  ITextElement.prototype.createPathShape = function (matrixHelper, shapes) {
	    var j;
	    var jLen = shapes.length;
	    var pathNodes;
	    var shapeStr = '';
	
	    for (j = 0; j < jLen; j += 1) {
	      if (shapes[j].ty === 'sh') {
	        pathNodes = shapes[j].ks.k;
	        shapeStr += buildShapeString(pathNodes, pathNodes.i.length, true, matrixHelper);
	      }
	    }
	
	    return shapeStr;
	  };
	
	  ITextElement.prototype.updateDocumentData = function (newData, index) {
	    this.textProperty.updateDocumentData(newData, index);
	  };
	
	  ITextElement.prototype.canResizeFont = function (_canResize) {
	    this.textProperty.canResizeFont(_canResize);
	  };
	
	  ITextElement.prototype.setMinimumFontSize = function (_fontSize) {
	    this.textProperty.setMinimumFontSize(_fontSize);
	  };
	
	  ITextElement.prototype.applyTextPropertiesToMatrix = function (documentData, matrixHelper, lineNumber, xPos, yPos) {
	    if (documentData.ps) {
	      matrixHelper.translate(documentData.ps[0], documentData.ps[1] + documentData.ascent, 0);
	    }
	
	    matrixHelper.translate(0, -documentData.ls, 0);
	
	    switch (documentData.j) {
	      case 1:
	        matrixHelper.translate(documentData.justifyOffset + (documentData.boxWidth - documentData.lineWidths[lineNumber]), 0, 0);
	        break;
	
	      case 2:
	        matrixHelper.translate(documentData.justifyOffset + (documentData.boxWidth - documentData.lineWidths[lineNumber]) / 2, 0, 0);
	        break;
	
	      default:
	        break;
	    }
	
	    matrixHelper.translate(xPos, yPos, 0);
	  };
	
	  ITextElement.prototype.buildColor = function (colorData) {
	    return 'rgb(' + Math.round(colorData[0] * 255) + ',' + Math.round(colorData[1] * 255) + ',' + Math.round(colorData[2] * 255) + ')';
	  };
	
	  ITextElement.prototype.emptyProp = new LetterProps();
	
	  ITextElement.prototype.destroy = function () {};
	
	  ITextElement.prototype.validateText = function () {
	    if (this.textProperty._mdf || this.textProperty._isFirstFrame) {
	      this.buildNewText();
	      this.textProperty._isFirstFrame = false;
	      this.textProperty._mdf = false;
	    }
	  };
	
	  var emptyShapeData = {
	    shapes: []
	  };
	
	  function SVGTextLottieElement(data, globalData, comp) {
	    this.textSpans = [];
	    this.renderType = 'svg';
	    this.initElement(data, globalData, comp);
	  }
	
	  extendPrototype([BaseElement, TransformElement, SVGBaseElement, HierarchyElement, FrameElement, RenderableDOMElement, ITextElement], SVGTextLottieElement);
	
	  SVGTextLottieElement.prototype.createContent = function () {
	    if (this.data.singleShape && !this.globalData.fontManager.chars) {
	      this.textContainer = createNS('text');
	    }
	  };
	
	  SVGTextLottieElement.prototype.buildTextContents = function (textArray) {
	    var i = 0;
	    var len = textArray.length;
	    var textContents = [];
	    var currentTextContent = '';
	
	    while (i < len) {
	      if (textArray[i] === String.fromCharCode(13) || textArray[i] === String.fromCharCode(3)) {
	        textContents.push(currentTextContent);
	        currentTextContent = '';
	      } else {
	        currentTextContent += textArray[i];
	      }
	
	      i += 1;
	    }
	
	    textContents.push(currentTextContent);
	    return textContents;
	  };
	
	  SVGTextLottieElement.prototype.buildShapeData = function (data, scale) {
	    // data should probably be cloned to apply scale separately to each instance of a text on different layers
	    // but since text internal content gets only rendered once and then it's never rerendered,
	    // it's probably safe not to clone data and reuse always the same instance even if the object is mutated.
	    // Avoiding cloning is preferred since cloning each character shape data is expensive
	    if (data.shapes && data.shapes.length) {
	      var shape = data.shapes[0];
	
	      if (shape.it) {
	        var shapeItem = shape.it[shape.it.length - 1];
	
	        if (shapeItem.s) {
	          shapeItem.s.k[0] = scale;
	          shapeItem.s.k[1] = scale;
	        }
	      }
	    }
	
	    return data;
	  };
	
	  SVGTextLottieElement.prototype.buildNewText = function () {
	    this.addDynamicProperty(this);
	    var i;
	    var len;
	    var documentData = this.textProperty.currentData;
	    this.renderedLetters = createSizedArray(documentData ? documentData.l.length : 0);
	
	    if (documentData.fc) {
	      this.layerElement.setAttribute('fill', this.buildColor(documentData.fc));
	    } else {
	      this.layerElement.setAttribute('fill', 'rgba(0,0,0,0)');
	    }
	
	    if (documentData.sc) {
	      this.layerElement.setAttribute('stroke', this.buildColor(documentData.sc));
	      this.layerElement.setAttribute('stroke-width', documentData.sw);
	    }
	
	    this.layerElement.setAttribute('font-size', documentData.finalSize);
	    var fontData = this.globalData.fontManager.getFontByName(documentData.f);
	
	    if (fontData.fClass) {
	      this.layerElement.setAttribute('class', fontData.fClass);
	    } else {
	      this.layerElement.setAttribute('font-family', fontData.fFamily);
	      var fWeight = documentData.fWeight;
	      var fStyle = documentData.fStyle;
	      this.layerElement.setAttribute('font-style', fStyle);
	      this.layerElement.setAttribute('font-weight', fWeight);
	    }
	
	    this.layerElement.setAttribute('aria-label', documentData.t);
	    var letters = documentData.l || [];
	    var usesGlyphs = !!this.globalData.fontManager.chars;
	    len = letters.length;
	    var tSpan;
	    var matrixHelper = this.mHelper;
	    var shapeStr = '';
	    var singleShape = this.data.singleShape;
	    var xPos = 0;
	    var yPos = 0;
	    var firstLine = true;
	    var trackingOffset = documentData.tr * 0.001 * documentData.finalSize;
	
	    if (singleShape && !usesGlyphs && !documentData.sz) {
	      var tElement = this.textContainer;
	      var justify = 'start';
	
	      switch (documentData.j) {
	        case 1:
	          justify = 'end';
	          break;
	
	        case 2:
	          justify = 'middle';
	          break;
	
	        default:
	          justify = 'start';
	          break;
	      }
	
	      tElement.setAttribute('text-anchor', justify);
	      tElement.setAttribute('letter-spacing', trackingOffset);
	      var textContent = this.buildTextContents(documentData.finalText);
	      len = textContent.length;
	      yPos = documentData.ps ? documentData.ps[1] + documentData.ascent : 0;
	
	      for (i = 0; i < len; i += 1) {
	        tSpan = this.textSpans[i].span || createNS('tspan');
	        tSpan.textContent = textContent[i];
	        tSpan.setAttribute('x', 0);
	        tSpan.setAttribute('y', yPos);
	        tSpan.style.display = 'inherit';
	        tElement.appendChild(tSpan);
	
	        if (!this.textSpans[i]) {
	          this.textSpans[i] = {
	            span: null,
	            glyph: null
	          };
	        }
	
	        this.textSpans[i].span = tSpan;
	        yPos += documentData.finalLineHeight;
	      }
	
	      this.layerElement.appendChild(tElement);
	    } else {
	      var cachedSpansLength = this.textSpans.length;
	      var charData;
	
	      for (i = 0; i < len; i += 1) {
	        if (!this.textSpans[i]) {
	          this.textSpans[i] = {
	            span: null,
	            childSpan: null,
	            glyph: null
	          };
	        }
	
	        if (!usesGlyphs || !singleShape || i === 0) {
	          tSpan = cachedSpansLength > i ? this.textSpans[i].span : createNS(usesGlyphs ? 'g' : 'text');
	
	          if (cachedSpansLength <= i) {
	            tSpan.setAttribute('stroke-linecap', 'butt');
	            tSpan.setAttribute('stroke-linejoin', 'round');
	            tSpan.setAttribute('stroke-miterlimit', '4');
	            this.textSpans[i].span = tSpan;
	
	            if (usesGlyphs) {
	              var childSpan = createNS('g');
	              tSpan.appendChild(childSpan);
	              this.textSpans[i].childSpan = childSpan;
	            }
	
	            this.textSpans[i].span = tSpan;
	            this.layerElement.appendChild(tSpan);
	          }
	
	          tSpan.style.display = 'inherit';
	        }
	
	        matrixHelper.reset();
	
	        if (singleShape) {
	          if (letters[i].n) {
	            xPos = -trackingOffset;
	            yPos += documentData.yOffset;
	            yPos += firstLine ? 1 : 0;
	            firstLine = false;
	          }
	
	          this.applyTextPropertiesToMatrix(documentData, matrixHelper, letters[i].line, xPos, yPos);
	          xPos += letters[i].l || 0; // xPos += letters[i].val === ' ' ? 0 : trackingOffset;
	
	          xPos += trackingOffset;
	        }
	
	        if (usesGlyphs) {
	          charData = this.globalData.fontManager.getCharData(documentData.finalText[i], fontData.fStyle, this.globalData.fontManager.getFontByName(documentData.f).fFamily);
	          var glyphElement; // t === 1 means the character has been replaced with an animated shaped
	
	          if (charData.t === 1) {
	            glyphElement = new SVGCompElement(charData.data, this.globalData, this);
	          } else {
	            var data = emptyShapeData;
	
	            if (charData.data && charData.data.shapes) {
	              data = this.buildShapeData(charData.data, documentData.finalSize);
	            }
	
	            glyphElement = new SVGShapeElement(data, this.globalData, this);
	          }
	
	          if (this.textSpans[i].glyph) {
	            var glyph = this.textSpans[i].glyph;
	            this.textSpans[i].childSpan.removeChild(glyph.layerElement);
	            glyph.destroy();
	          }
	
	          this.textSpans[i].glyph = glyphElement;
	          glyphElement._debug = true;
	          glyphElement.prepareFrame(0);
	          glyphElement.renderFrame();
	          this.textSpans[i].childSpan.appendChild(glyphElement.layerElement); // when using animated shapes, the layer will be scaled instead of replacing the internal scale
	          // this might have issues with strokes and might need a different solution
	
	          if (charData.t === 1) {
	            this.textSpans[i].childSpan.setAttribute('transform', 'scale(' + documentData.finalSize / 100 + ',' + documentData.finalSize / 100 + ')');
	          }
	        } else {
	          if (singleShape) {
	            tSpan.setAttribute('transform', 'translate(' + matrixHelper.props[12] + ',' + matrixHelper.props[13] + ')');
	          }
	
	          tSpan.textContent = letters[i].val;
	          tSpan.setAttributeNS('http://www.w3.org/XML/1998/namespace', 'xml:space', 'preserve');
	        } //
	
	      }
	
	      if (singleShape && tSpan) {
	        tSpan.setAttribute('d', shapeStr);
	      }
	    }
	
	    while (i < this.textSpans.length) {
	      this.textSpans[i].span.style.display = 'none';
	      i += 1;
	    }
	
	    this._sizeChanged = true;
	  };
	
	  SVGTextLottieElement.prototype.sourceRectAtTime = function () {
	    this.prepareFrame(this.comp.renderedFrame - this.data.st);
	    this.renderInnerContent();
	
	    if (this._sizeChanged) {
	      this._sizeChanged = false;
	      var textBox = this.layerElement.getBBox();
	      this.bbox = {
	        top: textBox.y,
	        left: textBox.x,
	        width: textBox.width,
	        height: textBox.height
	      };
	    }
	
	    return this.bbox;
	  };
	
	  SVGTextLottieElement.prototype.getValue = function () {
	    var i;
	    var len = this.textSpans.length;
	    var glyphElement;
	    this.renderedFrame = this.comp.renderedFrame;
	
	    for (i = 0; i < len; i += 1) {
	      glyphElement = this.textSpans[i].glyph;
	
	      if (glyphElement) {
	        glyphElement.prepareFrame(this.comp.renderedFrame - this.data.st);
	
	        if (glyphElement._mdf) {
	          this._mdf = true;
	        }
	      }
	    }
	  };
	
	  SVGTextLottieElement.prototype.renderInnerContent = function () {
	    this.validateText();
	
	    if (!this.data.singleShape || this._mdf) {
	      this.textAnimator.getMeasures(this.textProperty.currentData, this.lettersChangedFlag);
	
	      if (this.lettersChangedFlag || this.textAnimator.lettersChangedFlag) {
	        this._sizeChanged = true;
	        var i;
	        var len;
	        var renderedLetters = this.textAnimator.renderedLetters;
	        var letters = this.textProperty.currentData.l;
	        len = letters.length;
	        var renderedLetter;
	        var textSpan;
	        var glyphElement;
	
	        for (i = 0; i < len; i += 1) {
	          if (!letters[i].n) {
	            renderedLetter = renderedLetters[i];
	            textSpan = this.textSpans[i].span;
	            glyphElement = this.textSpans[i].glyph;
	
	            if (glyphElement) {
	              glyphElement.renderFrame();
	            }
	
	            if (renderedLetter._mdf.m) {
	              textSpan.setAttribute('transform', renderedLetter.m);
	            }
	
	            if (renderedLetter._mdf.o) {
	              textSpan.setAttribute('opacity', renderedLetter.o);
	            }
	
	            if (renderedLetter._mdf.sw) {
	              textSpan.setAttribute('stroke-width', renderedLetter.sw);
	            }
	
	            if (renderedLetter._mdf.sc) {
	              textSpan.setAttribute('stroke', renderedLetter.sc);
	            }
	
	            if (renderedLetter._mdf.fc) {
	              textSpan.setAttribute('fill', renderedLetter.fc);
	            }
	          }
	        }
	      }
	    }
	  };
	
	  function ISolidElement(data, globalData, comp) {
	    this.initElement(data, globalData, comp);
	  }
	
	  extendPrototype([IImageElement], ISolidElement);
	
	  ISolidElement.prototype.createContent = function () {
	    var rect = createNS('rect'); /// /rect.style.width = this.data.sw;
	    /// /rect.style.height = this.data.sh;
	    /// /rect.style.fill = this.data.sc;
	
	    rect.setAttribute('width', this.data.sw);
	    rect.setAttribute('height', this.data.sh);
	    rect.setAttribute('fill', this.data.sc);
	    this.layerElement.appendChild(rect);
	  };
	
	  function NullElement(data, globalData, comp) {
	    this.initFrame();
	    this.initBaseData(data, globalData, comp);
	    this.initFrame();
	    this.initTransform(data, globalData, comp);
	    this.initHierarchy();
	  }
	
	  NullElement.prototype.prepareFrame = function (num) {
	    this.prepareProperties(num, true);
	  };
	
	  NullElement.prototype.renderFrame = function () {};
	
	  NullElement.prototype.getBaseElement = function () {
	    return null;
	  };
	
	  NullElement.prototype.destroy = function () {};
	
	  NullElement.prototype.sourceRectAtTime = function () {};
	
	  NullElement.prototype.hide = function () {};
	
	  extendPrototype([BaseElement, TransformElement, HierarchyElement, FrameElement], NullElement);
	
	  function SVGRendererBase() {}
	
	  extendPrototype([BaseRenderer], SVGRendererBase);
	
	  SVGRendererBase.prototype.createNull = function (data) {
	    return new NullElement(data, this.globalData, this);
	  };
	
	  SVGRendererBase.prototype.createShape = function (data) {
	    return new SVGShapeElement(data, this.globalData, this);
	  };
	
	  SVGRendererBase.prototype.createText = function (data) {
	    return new SVGTextLottieElement(data, this.globalData, this);
	  };
	
	  SVGRendererBase.prototype.createImage = function (data) {
	    return new IImageElement(data, this.globalData, this);
	  };
	
	  SVGRendererBase.prototype.createSolid = function (data) {
	    return new ISolidElement(data, this.globalData, this);
	  };
	
	  SVGRendererBase.prototype.configAnimation = function (animData) {
	    this.svgElement.setAttribute('xmlns', 'http://www.w3.org/2000/svg');
	    this.svgElement.setAttribute('xmlns:xlink', 'http://www.w3.org/1999/xlink');
	
	    if (this.renderConfig.viewBoxSize) {
	      this.svgElement.setAttribute('viewBox', this.renderConfig.viewBoxSize);
	    } else {
	      this.svgElement.setAttribute('viewBox', '0 0 ' + animData.w + ' ' + animData.h);
	    }
	
	    if (!this.renderConfig.viewBoxOnly) {
	      this.svgElement.setAttribute('width', animData.w);
	      this.svgElement.setAttribute('height', animData.h);
	      this.svgElement.style.width = '100%';
	      this.svgElement.style.height = '100%';
	      this.svgElement.style.transform = 'translate3d(0,0,0)';
	      this.svgElement.style.contentVisibility = this.renderConfig.contentVisibility;
	    }
	
	    if (this.renderConfig.width) {
	      this.svgElement.setAttribute('width', this.renderConfig.width);
	    }
	
	    if (this.renderConfig.height) {
	      this.svgElement.setAttribute('height', this.renderConfig.height);
	    }
	
	    if (this.renderConfig.className) {
	      this.svgElement.setAttribute('class', this.renderConfig.className);
	    }
	
	    if (this.renderConfig.id) {
	      this.svgElement.setAttribute('id', this.renderConfig.id);
	    }
	
	    if (this.renderConfig.focusable !== undefined) {
	      this.svgElement.setAttribute('focusable', this.renderConfig.focusable);
	    }
	
	    this.svgElement.setAttribute('preserveAspectRatio', this.renderConfig.preserveAspectRatio); // this.layerElement.style.transform = 'translate3d(0,0,0)';
	    // this.layerElement.style.transformOrigin = this.layerElement.style.mozTransformOrigin = this.layerElement.style.webkitTransformOrigin = this.layerElement.style['-webkit-transform'] = "0px 0px 0px";
	
	    this.animationItem.wrapper.appendChild(this.svgElement); // Mask animation
	
	    var defs = this.globalData.defs;
	    this.setupGlobalData(animData, defs);
	    this.globalData.progressiveLoad = this.renderConfig.progressiveLoad;
	    this.data = animData;
	    var maskElement = createNS('clipPath');
	    var rect = createNS('rect');
	    rect.setAttribute('width', animData.w);
	    rect.setAttribute('height', animData.h);
	    rect.setAttribute('x', 0);
	    rect.setAttribute('y', 0);
	    var maskId = createElementID();
	    maskElement.setAttribute('id', maskId);
	    maskElement.appendChild(rect);
	    this.layerElement.setAttribute('clip-path', 'url(' + getLocationHref() + '#' + maskId + ')');
	    defs.appendChild(maskElement);
	    this.layers = animData.layers;
	    this.elements = createSizedArray(animData.layers.length);
	  };
	
	  SVGRendererBase.prototype.destroy = function () {
	    if (this.animationItem.wrapper) {
	      this.animationItem.wrapper.innerText = '';
	    }
	
	    this.layerElement = null;
	    this.globalData.defs = null;
	    var i;
	    var len = this.layers ? this.layers.length : 0;
	
	    for (i = 0; i < len; i += 1) {
	      if (this.elements[i] && this.elements[i].destroy) {
	        this.elements[i].destroy();
	      }
	    }
	
	    this.elements.length = 0;
	    this.destroyed = true;
	    this.animationItem = null;
	  };
	
	  SVGRendererBase.prototype.updateContainerSize = function () {};
	
	  SVGRendererBase.prototype.findIndexByInd = function (ind) {
	    var i = 0;
	    var len = this.layers.length;
	
	    for (i = 0; i < len; i += 1) {
	      if (this.layers[i].ind === ind) {
	        return i;
	      }
	    }
	
	    return -1;
	  };
	
	  SVGRendererBase.prototype.buildItem = function (pos) {
	    var elements = this.elements;
	
	    if (elements[pos] || this.layers[pos].ty === 99) {
	      return;
	    }
	
	    elements[pos] = true;
	    var element = this.createItem(this.layers[pos]);
	    elements[pos] = element;
	
	    if (getExpressionsPlugin()) {
	      if (this.layers[pos].ty === 0) {
	        this.globalData.projectInterface.registerComposition(element);
	      }
	
	      element.initExpressions();
	    }
	
	    this.appendElementInPos(element, pos);
	
	    if (this.layers[pos].tt) {
	      var elementIndex = 'tp' in this.layers[pos] ? this.findIndexByInd(this.layers[pos].tp) : pos - 1;
	
	      if (elementIndex === -1) {
	        return;
	      }
	
	      if (!this.elements[elementIndex] || this.elements[elementIndex] === true) {
	        this.buildItem(elementIndex);
	        this.addPendingElement(element);
	      } else {
	        var matteElement = elements[elementIndex];
	        var matteMask = matteElement.getMatte(this.layers[pos].tt);
	        element.setMatte(matteMask);
	      }
	    }
	  };
	
	  SVGRendererBase.prototype.checkPendingElements = function () {
	    while (this.pendingElements.length) {
	      var element = this.pendingElements.pop();
	      element.checkParenting();
	
	      if (element.data.tt) {
	        var i = 0;
	        var len = this.elements.length;
	
	        while (i < len) {
	          if (this.elements[i] === element) {
	            var elementIndex = 'tp' in element.data ? this.findIndexByInd(element.data.tp) : i - 1;
	            var matteElement = this.elements[elementIndex];
	            var matteMask = matteElement.getMatte(this.layers[i].tt);
	            element.setMatte(matteMask);
	            break;
	          }
	
	          i += 1;
	        }
	      }
	    }
	  };
	
	  SVGRendererBase.prototype.renderFrame = function (num) {
	    if (this.renderedFrame === num || this.destroyed) {
	      return;
	    }
	
	    if (num === null) {
	      num = this.renderedFrame;
	    } else {
	      this.renderedFrame = num;
	    } // console.log('-------');
	    // console.log('FRAME ',num);
	
	
	    this.globalData.frameNum = num;
	    this.globalData.frameId += 1;
	    this.globalData.projectInterface.currentFrame = num;
	    this.globalData._mdf = false;
	    var i;
	    var len = this.layers.length;
	
	    if (!this.completeLayers) {
	      this.checkLayers(num);
	    }
	
	    for (i = len - 1; i >= 0; i -= 1) {
	      if (this.completeLayers || this.elements[i]) {
	        this.elements[i].prepareFrame(num - this.layers[i].st);
	      }
	    }
	
	    if (this.globalData._mdf) {
	      for (i = 0; i < len; i += 1) {
	        if (this.completeLayers || this.elements[i]) {
	          this.elements[i].renderFrame();
	        }
	      }
	    }
	  };
	
	  SVGRendererBase.prototype.appendElementInPos = function (element, pos) {
	    var newElement = element.getBaseElement();
	
	    if (!newElement) {
	      return;
	    }
	
	    var i = 0;
	    var nextElement;
	
	    while (i < pos) {
	      if (this.elements[i] && this.elements[i] !== true && this.elements[i].getBaseElement()) {
	        nextElement = this.elements[i].getBaseElement();
	      }
	
	      i += 1;
	    }
	
	    if (nextElement) {
	      this.layerElement.insertBefore(newElement, nextElement);
	    } else {
	      this.layerElement.appendChild(newElement);
	    }
	  };
	
	  SVGRendererBase.prototype.hide = function () {
	    this.layerElement.style.display = 'none';
	  };
	
	  SVGRendererBase.prototype.show = function () {
	    this.layerElement.style.display = 'block';
	  };
	
	  function ICompElement() {}
	
	  extendPrototype([BaseElement, TransformElement, HierarchyElement, FrameElement, RenderableDOMElement], ICompElement);
	
	  ICompElement.prototype.initElement = function (data, globalData, comp) {
	    this.initFrame();
	    this.initBaseData(data, globalData, comp);
	    this.initTransform(data, globalData, comp);
	    this.initRenderable();
	    this.initHierarchy();
	    this.initRendererElement();
	    this.createContainerElements();
	    this.createRenderableComponents();
	
	    if (this.data.xt || !globalData.progressiveLoad) {
	      this.buildAllItems();
	    }
	
	    this.hide();
	  };
	  /* ICompElement.prototype.hide = function(){
	      if(!this.hidden){
	          this.hideElement();
	          var i,len = this.elements.length;
	          for( i = 0; i < len; i+=1 ){
	              if(this.elements[i]){
	                  this.elements[i].hide();
	              }
	          }
	      }
	  }; */
	
	
	  ICompElement.prototype.prepareFrame = function (num) {
	    this._mdf = false;
	    this.prepareRenderableFrame(num);
	    this.prepareProperties(num, this.isInRange);
	
	    if (!this.isInRange && !this.data.xt) {
	      return;
	    }
	
	    if (!this.tm._placeholder) {
	      var timeRemapped = this.tm.v;
	
	      if (timeRemapped === this.data.op) {
	        timeRemapped = this.data.op - 1;
	      }
	
	      this.renderedFrame = timeRemapped;
	    } else {
	      this.renderedFrame = num / this.data.sr;
	    }
	
	    var i;
	    var len = this.elements.length;
	
	    if (!this.completeLayers) {
	      this.checkLayers(this.renderedFrame);
	    } // This iteration needs to be backwards because of how expressions connect between each other
	
	
	    for (i = len - 1; i >= 0; i -= 1) {
	      if (this.completeLayers || this.elements[i]) {
	        this.elements[i].prepareFrame(this.renderedFrame - this.layers[i].st);
	
	        if (this.elements[i]._mdf) {
	          this._mdf = true;
	        }
	      }
	    }
	  };
	
	  ICompElement.prototype.renderInnerContent = function () {
	    var i;
	    var len = this.layers.length;
	
	    for (i = 0; i < len; i += 1) {
	      if (this.completeLayers || this.elements[i]) {
	        this.elements[i].renderFrame();
	      }
	    }
	  };
	
	  ICompElement.prototype.setElements = function (elems) {
	    this.elements = elems;
	  };
	
	  ICompElement.prototype.getElements = function () {
	    return this.elements;
	  };
	
	  ICompElement.prototype.destroyElements = function () {
	    var i;
	    var len = this.layers.length;
	
	    for (i = 0; i < len; i += 1) {
	      if (this.elements[i]) {
	        this.elements[i].destroy();
	      }
	    }
	  };
	
	  ICompElement.prototype.destroy = function () {
	    this.destroyElements();
	    this.destroyBaseElement();
	  };
	
	  function SVGCompElement(data, globalData, comp) {
	    this.layers = data.layers;
	    this.supports3d = true;
	    this.completeLayers = false;
	    this.pendingElements = [];
	    this.elements = this.layers ? createSizedArray(this.layers.length) : [];
	    this.initElement(data, globalData, comp);
	    this.tm = data.tm ? PropertyFactory.getProp(this, data.tm, 0, globalData.frameRate, this) : {
	      _placeholder: true
	    };
	  }
	
	  extendPrototype([SVGRendererBase, ICompElement, SVGBaseElement], SVGCompElement);
	
	  SVGCompElement.prototype.createComp = function (data) {
	    return new SVGCompElement(data, this.globalData, this);
	  };
	
	  function SVGRenderer(animationItem, config) {
	    this.animationItem = animationItem;
	    this.layers = null;
	    this.renderedFrame = -1;
	    this.svgElement = createNS('svg');
	    var ariaLabel = '';
	
	    if (config && config.title) {
	      var titleElement = createNS('title');
	      var titleId = createElementID();
	      titleElement.setAttribute('id', titleId);
	      titleElement.textContent = config.title;
	      this.svgElement.appendChild(titleElement);
	      ariaLabel += titleId;
	    }
	
	    if (config && config.description) {
	      var descElement = createNS('desc');
	      var descId = createElementID();
	      descElement.setAttribute('id', descId);
	      descElement.textContent = config.description;
	      this.svgElement.appendChild(descElement);
	      ariaLabel += ' ' + descId;
	    }
	
	    if (ariaLabel) {
	      this.svgElement.setAttribute('aria-labelledby', ariaLabel);
	    }
	
	    var defs = createNS('defs');
	    this.svgElement.appendChild(defs);
	    var maskElement = createNS('g');
	    this.svgElement.appendChild(maskElement);
	    this.layerElement = maskElement;
	    this.renderConfig = {
	      preserveAspectRatio: config && config.preserveAspectRatio || 'xMidYMid meet',
	      imagePreserveAspectRatio: config && config.imagePreserveAspectRatio || 'xMidYMid slice',
	      contentVisibility: config && config.contentVisibility || 'visible',
	      progressiveLoad: config && config.progressiveLoad || false,
	      hideOnTransparent: !(config && config.hideOnTransparent === false),
	      viewBoxOnly: config && config.viewBoxOnly || false,
	      viewBoxSize: config && config.viewBoxSize || false,
	      className: config && config.className || '',
	      id: config && config.id || '',
	      focusable: config && config.focusable,
	      filterSize: {
	        width: config && config.filterSize && config.filterSize.width || '100%',
	        height: config && config.filterSize && config.filterSize.height || '100%',
	        x: config && config.filterSize && config.filterSize.x || '0%',
	        y: config && config.filterSize && config.filterSize.y || '0%'
	      },
	      width: config && config.width,
	      height: config && config.height,
	      runExpressions: !config || config.runExpressions === undefined || config.runExpressions
	    };
	    this.globalData = {
	      _mdf: false,
	      frameNum: -1,
	      defs: defs,
	      renderConfig: this.renderConfig
	    };
	    this.elements = [];
	    this.pendingElements = [];
	    this.destroyed = false;
	    this.rendererType = 'svg';
	  }
	
	  extendPrototype([SVGRendererBase], SVGRenderer);
	
	  SVGRenderer.prototype.createComp = function (data) {
	    return new SVGCompElement(data, this.globalData, this);
	  };
	
	  function ShapeTransformManager() {
	    this.sequences = {};
	    this.sequenceList = [];
	    this.transform_key_count = 0;
	  }
	
	  ShapeTransformManager.prototype = {
	    addTransformSequence: function addTransformSequence(transforms) {
	      var i;
	      var len = transforms.length;
	      var key = '_';
	
	      for (i = 0; i < len; i += 1) {
	        key += transforms[i].transform.key + '_';
	      }
	
	      var sequence = this.sequences[key];
	
	      if (!sequence) {
	        sequence = {
	          transforms: [].concat(transforms),
	          finalTransform: new Matrix(),
	          _mdf: false
	        };
	        this.sequences[key] = sequence;
	        this.sequenceList.push(sequence);
	      }
	
	      return sequence;
	    },
	    processSequence: function processSequence(sequence, isFirstFrame) {
	      var i = 0;
	      var len = sequence.transforms.length;
	      var _mdf = isFirstFrame;
	
	      while (i < len && !isFirstFrame) {
	        if (sequence.transforms[i].transform.mProps._mdf) {
	          _mdf = true;
	          break;
	        }
	
	        i += 1;
	      }
	
	      if (_mdf) {
	        sequence.finalTransform.reset();
	
	        for (i = len - 1; i >= 0; i -= 1) {
	          sequence.finalTransform.multiply(sequence.transforms[i].transform.mProps.v);
	        }
	      }
	
	      sequence._mdf = _mdf;
	    },
	    processSequences: function processSequences(isFirstFrame) {
	      var i;
	      var len = this.sequenceList.length;
	
	      for (i = 0; i < len; i += 1) {
	        this.processSequence(this.sequenceList[i], isFirstFrame);
	      }
	    },
	    getNewKey: function getNewKey() {
	      this.transform_key_count += 1;
	      return '_' + this.transform_key_count;
	    }
	  };
	
	  var lumaLoader = function lumaLoader() {
	    var id = '__lottie_element_luma_buffer';
	    var lumaBuffer = null;
	    var lumaBufferCtx = null;
	    var svg = null; // This alternate solution has a slight delay before the filter is applied, resulting in a flicker on the first frame.
	    // Keeping this here for reference, and in the future, if offscreen canvas supports url filters, this can be used.
	    // For now, neither of them work for offscreen canvas, so canvas workers can't support the luma track matte mask.
	    // Naming it solution 2 to mark the extra comment lines.
	
	    /*
	    var svgString = [
	      '<svg xmlns="http://www.w3.org/2000/svg">',
	      '<filter id="' + id + '">',
	      '<feColorMatrix type="matrix" color-interpolation-filters="sRGB" values="',
	      '0.3, 0.3, 0.3, 0, 0, ',
	      '0.3, 0.3, 0.3, 0, 0, ',
	      '0.3, 0.3, 0.3, 0, 0, ',
	      '0.3, 0.3, 0.3, 0, 0',
	      '"/>',
	      '</filter>',
	      '</svg>',
	    ].join('');
	    var blob = new Blob([svgString], { type: 'image/svg+xml' });
	    var url = URL.createObjectURL(blob);
	    */
	
	    function createLumaSvgFilter() {
	      var _svg = createNS('svg');
	
	      var fil = createNS('filter');
	      var matrix = createNS('feColorMatrix');
	      fil.setAttribute('id', id);
	      matrix.setAttribute('type', 'matrix');
	      matrix.setAttribute('color-interpolation-filters', 'sRGB');
	      matrix.setAttribute('values', '0.3, 0.3, 0.3, 0, 0, 0.3, 0.3, 0.3, 0, 0, 0.3, 0.3, 0.3, 0, 0, 0.3, 0.3, 0.3, 0, 0');
	      fil.appendChild(matrix);
	
	      _svg.appendChild(fil);
	
	      _svg.setAttribute('id', id + '_svg');
	
	      if (featureSupport.svgLumaHidden) {
	        _svg.style.display = 'none';
	      }
	
	      return _svg;
	    }
	
	    function loadLuma() {
	      if (!lumaBuffer) {
	        svg = createLumaSvgFilter();
	        document.body.appendChild(svg);
	        lumaBuffer = createTag('canvas');
	        lumaBufferCtx = lumaBuffer.getContext('2d'); // lumaBufferCtx.filter = `url('${url}#__lottie_element_luma_buffer')`; // part of solution 2
	
	        lumaBufferCtx.filter = 'url(#' + id + ')';
	        lumaBufferCtx.fillStyle = 'rgba(0,0,0,0)';
	        lumaBufferCtx.fillRect(0, 0, 1, 1);
	      }
	    }
	
	    function getLuma(canvas) {
	      if (!lumaBuffer) {
	        loadLuma();
	      }
	
	      lumaBuffer.width = canvas.width;
	      lumaBuffer.height = canvas.height; // lumaBufferCtx.filter = `url('${url}#__lottie_element_luma_buffer')`; // part of solution 2
	
	      lumaBufferCtx.filter = 'url(#' + id + ')';
	      return lumaBuffer;
	    }
	
	    return {
	      load: loadLuma,
	      get: getLuma
	    };
	  };
	
	  function createCanvas(width, height) {
	    if (featureSupport.offscreenCanvas) {
	      return new OffscreenCanvas(width, height);
	    }
	
	    var canvas = createTag('canvas');
	    canvas.width = width;
	    canvas.height = height;
	    return canvas;
	  }
	
	  var assetLoader = function () {
	    return {
	      loadLumaCanvas: lumaLoader.load,
	      getLumaCanvas: lumaLoader.get,
	      createCanvas: createCanvas
	    };
	  }();
	
	  var registeredEffects = {};
	
	  function CVEffects(elem) {
	    var i;
	    var len = elem.data.ef ? elem.data.ef.length : 0;
	    this.filters = [];
	    var filterManager;
	
	    for (i = 0; i < len; i += 1) {
	      filterManager = null;
	      var type = elem.data.ef[i].ty;
	
	      if (registeredEffects[type]) {
	        var Effect = registeredEffects[type].effect;
	        filterManager = new Effect(elem.effectsManager.effectElements[i], elem);
	      }
	
	      if (filterManager) {
	        this.filters.push(filterManager);
	      }
	    }
	
	    if (this.filters.length) {
	      elem.addRenderableComponent(this);
	    }
	  }
	
	  CVEffects.prototype.renderFrame = function (_isFirstFrame) {
	    var i;
	    var len = this.filters.length;
	
	    for (i = 0; i < len; i += 1) {
	      this.filters[i].renderFrame(_isFirstFrame);
	    }
	  };
	
	  CVEffects.prototype.getEffects = function (type) {
	    var i;
	    var len = this.filters.length;
	    var effects = [];
	
	    for (i = 0; i < len; i += 1) {
	      if (this.filters[i].type === type) {
	        effects.push(this.filters[i]);
	      }
	    }
	
	    return effects;
	  };
	
	  function registerEffect(id, effect) {
	    registeredEffects[id] = {
	      effect: effect
	    };
	  }
	
	  function CVMaskElement(data, element) {
	    this.data = data;
	    this.element = element;
	    this.masksProperties = this.data.masksProperties || [];
	    this.viewData = createSizedArray(this.masksProperties.length);
	    var i;
	    var len = this.masksProperties.length;
	    var hasMasks = false;
	
	    for (i = 0; i < len; i += 1) {
	      if (this.masksProperties[i].mode !== 'n') {
	        hasMasks = true;
	      }
	
	      this.viewData[i] = ShapePropertyFactory.getShapeProp(this.element, this.masksProperties[i], 3);
	    }
	
	    this.hasMasks = hasMasks;
	
	    if (hasMasks) {
	      this.element.addRenderableComponent(this);
	    }
	  }
	
	  CVMaskElement.prototype.renderFrame = function () {
	    if (!this.hasMasks) {
	      return;
	    }
	
	    var transform = this.element.finalTransform.mat;
	    var ctx = this.element.canvasContext;
	    var i;
	    var len = this.masksProperties.length;
	    var pt;
	    var pts;
	    var data;
	    ctx.beginPath();
	
	    for (i = 0; i < len; i += 1) {
	      if (this.masksProperties[i].mode !== 'n') {
	        if (this.masksProperties[i].inv) {
	          ctx.moveTo(0, 0);
	          ctx.lineTo(this.element.globalData.compSize.w, 0);
	          ctx.lineTo(this.element.globalData.compSize.w, this.element.globalData.compSize.h);
	          ctx.lineTo(0, this.element.globalData.compSize.h);
	          ctx.lineTo(0, 0);
	        }
	
	        data = this.viewData[i].v;
	        pt = transform.applyToPointArray(data.v[0][0], data.v[0][1], 0);
	        ctx.moveTo(pt[0], pt[1]);
	        var j;
	        var jLen = data._length;
	
	        for (j = 1; j < jLen; j += 1) {
	          pts = transform.applyToTriplePoints(data.o[j - 1], data.i[j], data.v[j]);
	          ctx.bezierCurveTo(pts[0], pts[1], pts[2], pts[3], pts[4], pts[5]);
	        }
	
	        pts = transform.applyToTriplePoints(data.o[j - 1], data.i[0], data.v[0]);
	        ctx.bezierCurveTo(pts[0], pts[1], pts[2], pts[3], pts[4], pts[5]);
	      }
	    }
	
	    this.element.globalData.renderer.save(true);
	    ctx.clip();
	  };
	
	  CVMaskElement.prototype.getMaskProperty = MaskElement.prototype.getMaskProperty;
	
	  CVMaskElement.prototype.destroy = function () {
	    this.element = null;
	  };
	
	  function CVBaseElement() {}
	
	  var operationsMap = {
	    1: 'source-in',
	    2: 'source-out',
	    3: 'source-in',
	    4: 'source-out'
	  };
	  CVBaseElement.prototype = {
	    createElements: function createElements() {},
	    initRendererElement: function initRendererElement() {},
	    createContainerElements: function createContainerElements() {
	      // If the layer is masked we will use two buffers to store each different states of the drawing
	      // This solution is not ideal for several reason. But unfortunately, because of the recursive
	      // nature of the render tree, it's the only simple way to make sure one inner mask doesn't override an outer mask.
	      // TODO: try to reduce the size of these buffers to the size of the composition contaning the layer
	      // It might be challenging because the layer most likely is transformed in some way
	      if (this.data.tt >= 1) {
	        this.buffers = [];
	        var canvasContext = this.globalData.canvasContext;
	        var bufferCanvas = assetLoader.createCanvas(canvasContext.canvas.width, canvasContext.canvas.height);
	        this.buffers.push(bufferCanvas);
	        var bufferCanvas2 = assetLoader.createCanvas(canvasContext.canvas.width, canvasContext.canvas.height);
	        this.buffers.push(bufferCanvas2);
	
	        if (this.data.tt >= 3 && !document._isProxy) {
	          assetLoader.loadLumaCanvas();
	        }
	      }
	
	      this.canvasContext = this.globalData.canvasContext;
	      this.transformCanvas = this.globalData.transformCanvas;
	      this.renderableEffectsManager = new CVEffects(this);
	      this.searchEffectTransforms();
	    },
	    createContent: function createContent() {},
	    setBlendMode: function setBlendMode() {
	      var globalData = this.globalData;
	
	      if (globalData.blendMode !== this.data.bm) {
	        globalData.blendMode = this.data.bm;
	        var blendModeValue = getBlendMode(this.data.bm);
	        globalData.canvasContext.globalCompositeOperation = blendModeValue;
	      }
	    },
	    createRenderableComponents: function createRenderableComponents() {
	      this.maskManager = new CVMaskElement(this.data, this);
	      this.transformEffects = this.renderableEffectsManager.getEffects(effectTypes.TRANSFORM_EFFECT);
	    },
	    hideElement: function hideElement() {
	      if (!this.hidden && (!this.isInRange || this.isTransparent)) {
	        this.hidden = true;
	      }
	    },
	    showElement: function showElement() {
	      if (this.isInRange && !this.isTransparent) {
	        this.hidden = false;
	        this._isFirstFrame = true;
	        this.maskManager._isFirstFrame = true;
	      }
	    },
	    clearCanvas: function clearCanvas(canvasContext) {
	      canvasContext.clearRect(this.transformCanvas.tx, this.transformCanvas.ty, this.transformCanvas.w * this.transformCanvas.sx, this.transformCanvas.h * this.transformCanvas.sy);
	    },
	    prepareLayer: function prepareLayer() {
	      if (this.data.tt >= 1) {
	        var buffer = this.buffers[0];
	        var bufferCtx = buffer.getContext('2d');
	        this.clearCanvas(bufferCtx); // on the first buffer we store the current state of the global drawing
	
	        bufferCtx.drawImage(this.canvasContext.canvas, 0, 0); // The next four lines are to clear the canvas
	        // TODO: Check if there is a way to clear the canvas without resetting the transform
	
	        this.currentTransform = this.canvasContext.getTransform();
	        this.canvasContext.setTransform(1, 0, 0, 1, 0, 0);
	        this.clearCanvas(this.canvasContext);
	        this.canvasContext.setTransform(this.currentTransform);
	      }
	    },
	    exitLayer: function exitLayer() {
	      if (this.data.tt >= 1) {
	        var buffer = this.buffers[1]; // On the second buffer we store the current state of the global drawing
	        // that only contains the content of this layer
	        // (if it is a composition, it also includes the nested layers)
	
	        var bufferCtx = buffer.getContext('2d');
	        this.clearCanvas(bufferCtx);
	        bufferCtx.drawImage(this.canvasContext.canvas, 0, 0); // We clear the canvas again
	
	        this.canvasContext.setTransform(1, 0, 0, 1, 0, 0);
	        this.clearCanvas(this.canvasContext);
	        this.canvasContext.setTransform(this.currentTransform); // We draw the mask
	
	        var mask = this.comp.getElementById('tp' in this.data ? this.data.tp : this.data.ind - 1);
	        mask.renderFrame(true); // We draw the second buffer (that contains the content of this layer)
	
	        this.canvasContext.setTransform(1, 0, 0, 1, 0, 0); // If the mask is a Luma matte, we need to do two extra painting operations
	        // the _isProxy check is to avoid drawing a fake canvas in workers that will throw an error
	
	        if (this.data.tt >= 3 && !document._isProxy) {
	          // We copy the painted mask to a buffer that has a color matrix filter applied to it
	          // that applies the rgb values to the alpha channel
	          var lumaBuffer = assetLoader.getLumaCanvas(this.canvasContext.canvas);
	          var lumaBufferCtx = lumaBuffer.getContext('2d');
	          lumaBufferCtx.drawImage(this.canvasContext.canvas, 0, 0);
	          this.clearCanvas(this.canvasContext); // we repaint the context with the mask applied to it
	
	          this.canvasContext.drawImage(lumaBuffer, 0, 0);
	        }
	
	        this.canvasContext.globalCompositeOperation = operationsMap[this.data.tt];
	        this.canvasContext.drawImage(buffer, 0, 0); // We finally draw the first buffer (that contains the content of the global drawing)
	        // We use destination-over to draw the global drawing below the current layer
	
	        this.canvasContext.globalCompositeOperation = 'destination-over';
	        this.canvasContext.drawImage(this.buffers[0], 0, 0);
	        this.canvasContext.setTransform(this.currentTransform); // We reset the globalCompositeOperation to source-over, the standard type of operation
	
	        this.canvasContext.globalCompositeOperation = 'source-over';
	      }
	    },
	    renderFrame: function renderFrame(forceRender) {
	      if (this.hidden || this.data.hd) {
	        return;
	      }
	
	      if (this.data.td === 1 && !forceRender) {
	        return;
	      }
	
	      this.renderTransform();
	      this.renderRenderable();
	      this.renderLocalTransform();
	      this.setBlendMode();
	      var forceRealStack = this.data.ty === 0;
	      this.prepareLayer();
	      this.globalData.renderer.save(forceRealStack);
	      this.globalData.renderer.ctxTransform(this.finalTransform.localMat.props);
	      this.globalData.renderer.ctxOpacity(this.finalTransform.localOpacity);
	      this.renderInnerContent();
	      this.globalData.renderer.restore(forceRealStack);
	      this.exitLayer();
	
	      if (this.maskManager.hasMasks) {
	        this.globalData.renderer.restore(true);
	      }
	
	      if (this._isFirstFrame) {
	        this._isFirstFrame = false;
	      }
	    },
	    destroy: function destroy() {
	      this.canvasContext = null;
	      this.data = null;
	      this.globalData = null;
	      this.maskManager.destroy();
	    },
	    mHelper: new Matrix()
	  };
	  CVBaseElement.prototype.hide = CVBaseElement.prototype.hideElement;
	  CVBaseElement.prototype.show = CVBaseElement.prototype.showElement;
	
	  function CVShapeData(element, data, styles, transformsManager) {
	    this.styledShapes = [];
	    this.tr = [0, 0, 0, 0, 0, 0];
	    var ty = 4;
	
	    if (data.ty === 'rc') {
	      ty = 5;
	    } else if (data.ty === 'el') {
	      ty = 6;
	    } else if (data.ty === 'sr') {
	      ty = 7;
	    }
	
	    this.sh = ShapePropertyFactory.getShapeProp(element, data, ty, element);
	    var i;
	    var len = styles.length;
	    var styledShape;
	
	    for (i = 0; i < len; i += 1) {
	      if (!styles[i].closed) {
	        styledShape = {
	          transforms: transformsManager.addTransformSequence(styles[i].transforms),
	          trNodes: []
	        };
	        this.styledShapes.push(styledShape);
	        styles[i].elements.push(styledShape);
	      }
	    }
	  }
	
	  CVShapeData.prototype.setAsAnimated = SVGShapeData.prototype.setAsAnimated;
	
	  function CVShapeElement(data, globalData, comp) {
	    this.shapes = [];
	    this.shapesData = data.shapes;
	    this.stylesList = [];
	    this.itemsData = [];
	    this.prevViewData = [];
	    this.shapeModifiers = [];
	    this.processedElements = [];
	    this.transformsManager = new ShapeTransformManager();
	    this.initElement(data, globalData, comp);
	  }
	
	  extendPrototype([BaseElement, TransformElement, CVBaseElement, IShapeElement, HierarchyElement, FrameElement, RenderableElement], CVShapeElement);
	  CVShapeElement.prototype.initElement = RenderableDOMElement.prototype.initElement;
	  CVShapeElement.prototype.transformHelper = {
	    opacity: 1,
	    _opMdf: false
	  };
	  CVShapeElement.prototype.dashResetter = [];
	
	  CVShapeElement.prototype.createContent = function () {
	    this.searchShapes(this.shapesData, this.itemsData, this.prevViewData, true, []);
	  };
	
	  CVShapeElement.prototype.createStyleElement = function (data, transforms) {
	    var styleElem = {
	      data: data,
	      type: data.ty,
	      preTransforms: this.transformsManager.addTransformSequence(transforms),
	      transforms: [],
	      elements: [],
	      closed: data.hd === true
	    };
	    var elementData = {};
	
	    if (data.ty === 'fl' || data.ty === 'st') {
	      elementData.c = PropertyFactory.getProp(this, data.c, 1, 255, this);
	
	      if (!elementData.c.k) {
	        styleElem.co = 'rgb(' + bmFloor(elementData.c.v[0]) + ',' + bmFloor(elementData.c.v[1]) + ',' + bmFloor(elementData.c.v[2]) + ')';
	      }
	    } else if (data.ty === 'gf' || data.ty === 'gs') {
	      elementData.s = PropertyFactory.getProp(this, data.s, 1, null, this);
	      elementData.e = PropertyFactory.getProp(this, data.e, 1, null, this);
	      elementData.h = PropertyFactory.getProp(this, data.h || {
	        k: 0
	      }, 0, 0.01, this);
	      elementData.a = PropertyFactory.getProp(this, data.a || {
	        k: 0
	      }, 0, degToRads, this);
	      elementData.g = new GradientProperty(this, data.g, this);
	    }
	
	    elementData.o = PropertyFactory.getProp(this, data.o, 0, 0.01, this);
	
	    if (data.ty === 'st' || data.ty === 'gs') {
	      styleElem.lc = lineCapEnum[data.lc || 2];
	      styleElem.lj = lineJoinEnum[data.lj || 2];
	
	      if (data.lj == 1) {
	        // eslint-disable-line eqeqeq
	        styleElem.ml = data.ml;
	      }
	
	      elementData.w = PropertyFactory.getProp(this, data.w, 0, null, this);
	
	      if (!elementData.w.k) {
	        styleElem.wi = elementData.w.v;
	      }
	
	      if (data.d) {
	        var d = new DashProperty(this, data.d, 'canvas', this);
	        elementData.d = d;
	
	        if (!elementData.d.k) {
	          styleElem.da = elementData.d.dashArray;
	          styleElem["do"] = elementData.d.dashoffset[0];
	        }
	      }
	    } else {
	      styleElem.r = data.r === 2 ? 'evenodd' : 'nonzero';
	    }
	
	    this.stylesList.push(styleElem);
	    elementData.style = styleElem;
	    return elementData;
	  };
	
	  CVShapeElement.prototype.createGroupElement = function () {
	    var elementData = {
	      it: [],
	      prevViewData: []
	    };
	    return elementData;
	  };
	
	  CVShapeElement.prototype.createTransformElement = function (data) {
	    var elementData = {
	      transform: {
	        opacity: 1,
	        _opMdf: false,
	        key: this.transformsManager.getNewKey(),
	        op: PropertyFactory.getProp(this, data.o, 0, 0.01, this),
	        mProps: TransformPropertyFactory.getTransformProperty(this, data, this)
	      }
	    };
	    return elementData;
	  };
	
	  CVShapeElement.prototype.createShapeElement = function (data) {
	    var elementData = new CVShapeData(this, data, this.stylesList, this.transformsManager);
	    this.shapes.push(elementData);
	    this.addShapeToModifiers(elementData);
	    return elementData;
	  };
	
	  CVShapeElement.prototype.reloadShapes = function () {
	    this._isFirstFrame = true;
	    var i;
	    var len = this.itemsData.length;
	
	    for (i = 0; i < len; i += 1) {
	      this.prevViewData[i] = this.itemsData[i];
	    }
	
	    this.searchShapes(this.shapesData, this.itemsData, this.prevViewData, true, []);
	    len = this.dynamicProperties.length;
	
	    for (i = 0; i < len; i += 1) {
	      this.dynamicProperties[i].getValue();
	    }
	
	    this.renderModifiers();
	    this.transformsManager.processSequences(this._isFirstFrame);
	  };
	
	  CVShapeElement.prototype.addTransformToStyleList = function (transform) {
	    var i;
	    var len = this.stylesList.length;
	
	    for (i = 0; i < len; i += 1) {
	      if (!this.stylesList[i].closed) {
	        this.stylesList[i].transforms.push(transform);
	      }
	    }
	  };
	
	  CVShapeElement.prototype.removeTransformFromStyleList = function () {
	    var i;
	    var len = this.stylesList.length;
	
	    for (i = 0; i < len; i += 1) {
	      if (!this.stylesList[i].closed) {
	        this.stylesList[i].transforms.pop();
	      }
	    }
	  };
	
	  CVShapeElement.prototype.closeStyles = function (styles) {
	    var i;
	    var len = styles.length;
	
	    for (i = 0; i < len; i += 1) {
	      styles[i].closed = true;
	    }
	  };
	
	  CVShapeElement.prototype.searchShapes = function (arr, itemsData, prevViewData, shouldRender, transforms) {
	    var i;
	    var len = arr.length - 1;
	    var j;
	    var jLen;
	    var ownStyles = [];
	    var ownModifiers = [];
	    var processedPos;
	    var modifier;
	    var currentTransform;
	    var ownTransforms = [].concat(transforms);
	
	    for (i = len; i >= 0; i -= 1) {
	      processedPos = this.searchProcessedElement(arr[i]);
	
	      if (!processedPos) {
	        arr[i]._shouldRender = shouldRender;
	      } else {
	        itemsData[i] = prevViewData[processedPos - 1];
	      }
	
	      if (arr[i].ty === 'fl' || arr[i].ty === 'st' || arr[i].ty === 'gf' || arr[i].ty === 'gs') {
	        if (!processedPos) {
	          itemsData[i] = this.createStyleElement(arr[i], ownTransforms);
	        } else {
	          itemsData[i].style.closed = false;
	        }
	
	        ownStyles.push(itemsData[i].style);
	      } else if (arr[i].ty === 'gr') {
	        if (!processedPos) {
	          itemsData[i] = this.createGroupElement(arr[i]);
	        } else {
	          jLen = itemsData[i].it.length;
	
	          for (j = 0; j < jLen; j += 1) {
	            itemsData[i].prevViewData[j] = itemsData[i].it[j];
	          }
	        }
	
	        this.searchShapes(arr[i].it, itemsData[i].it, itemsData[i].prevViewData, shouldRender, ownTransforms);
	      } else if (arr[i].ty === 'tr') {
	        if (!processedPos) {
	          currentTransform = this.createTransformElement(arr[i]);
	          itemsData[i] = currentTransform;
	        }
	
	        ownTransforms.push(itemsData[i]);
	        this.addTransformToStyleList(itemsData[i]);
	      } else if (arr[i].ty === 'sh' || arr[i].ty === 'rc' || arr[i].ty === 'el' || arr[i].ty === 'sr') {
	        if (!processedPos) {
	          itemsData[i] = this.createShapeElement(arr[i]);
	        }
	      } else if (arr[i].ty === 'tm' || arr[i].ty === 'rd' || arr[i].ty === 'pb' || arr[i].ty === 'zz' || arr[i].ty === 'op') {
	        if (!processedPos) {
	          modifier = ShapeModifiers.getModifier(arr[i].ty);
	          modifier.init(this, arr[i]);
	          itemsData[i] = modifier;
	          this.shapeModifiers.push(modifier);
	        } else {
	          modifier = itemsData[i];
	          modifier.closed = false;
	        }
	
	        ownModifiers.push(modifier);
	      } else if (arr[i].ty === 'rp') {
	        if (!processedPos) {
	          modifier = ShapeModifiers.getModifier(arr[i].ty);
	          itemsData[i] = modifier;
	          modifier.init(this, arr, i, itemsData);
	          this.shapeModifiers.push(modifier);
	          shouldRender = false;
	        } else {
	          modifier = itemsData[i];
	          modifier.closed = true;
	        }
	
	        ownModifiers.push(modifier);
	      }
	
	      this.addProcessedElement(arr[i], i + 1);
	    }
	
	    this.removeTransformFromStyleList();
	    this.closeStyles(ownStyles);
	    len = ownModifiers.length;
	
	    for (i = 0; i < len; i += 1) {
	      ownModifiers[i].closed = true;
	    }
	  };
	
	  CVShapeElement.prototype.renderInnerContent = function () {
	    this.transformHelper.opacity = 1;
	    this.transformHelper._opMdf = false;
	    this.renderModifiers();
	    this.transformsManager.processSequences(this._isFirstFrame);
	    this.renderShape(this.transformHelper, this.shapesData, this.itemsData, true);
	  };
	
	  CVShapeElement.prototype.renderShapeTransform = function (parentTransform, groupTransform) {
	    if (parentTransform._opMdf || groupTransform.op._mdf || this._isFirstFrame) {
	      groupTransform.opacity = parentTransform.opacity;
	      groupTransform.opacity *= groupTransform.op.v;
	      groupTransform._opMdf = true;
	    }
	  };
	
	  CVShapeElement.prototype.drawLayer = function () {
	    var i;
	    var len = this.stylesList.length;
	    var j;
	    var jLen;
	    var k;
	    var kLen;
	    var elems;
	    var nodes;
	    var renderer = this.globalData.renderer;
	    var ctx = this.globalData.canvasContext;
	    var type;
	    var currentStyle;
	
	    for (i = 0; i < len; i += 1) {
	      currentStyle = this.stylesList[i];
	      type = currentStyle.type; // Skipping style when
	      // Stroke width equals 0
	      // style should not be rendered (extra unused repeaters)
	      // current opacity equals 0
	      // global opacity equals 0
	
	      if (!((type === 'st' || type === 'gs') && currentStyle.wi === 0 || !currentStyle.data._shouldRender || currentStyle.coOp === 0 || this.globalData.currentGlobalAlpha === 0)) {
	        renderer.save();
	        elems = currentStyle.elements;
	
	        if (type === 'st' || type === 'gs') {
	          renderer.ctxStrokeStyle(type === 'st' ? currentStyle.co : currentStyle.grd); // ctx.strokeStyle = type === 'st' ? currentStyle.co : currentStyle.grd;
	
	          renderer.ctxLineWidth(currentStyle.wi); // ctx.lineWidth = currentStyle.wi;
	
	          renderer.ctxLineCap(currentStyle.lc); // ctx.lineCap = currentStyle.lc;
	
	          renderer.ctxLineJoin(currentStyle.lj); // ctx.lineJoin = currentStyle.lj;
	
	          renderer.ctxMiterLimit(currentStyle.ml || 0); // ctx.miterLimit = currentStyle.ml || 0;
	        } else {
	          renderer.ctxFillStyle(type === 'fl' ? currentStyle.co : currentStyle.grd); // ctx.fillStyle = type === 'fl' ? currentStyle.co : currentStyle.grd;
	        }
	
	        renderer.ctxOpacity(currentStyle.coOp);
	
	        if (type !== 'st' && type !== 'gs') {
	          ctx.beginPath();
	        }
	
	        renderer.ctxTransform(currentStyle.preTransforms.finalTransform.props);
	        jLen = elems.length;
	
	        for (j = 0; j < jLen; j += 1) {
	          if (type === 'st' || type === 'gs') {
	            ctx.beginPath();
	
	            if (currentStyle.da) {
	              ctx.setLineDash(currentStyle.da);
	              ctx.lineDashOffset = currentStyle["do"];
	            }
	          }
	
	          nodes = elems[j].trNodes;
	          kLen = nodes.length;
	
	          for (k = 0; k < kLen; k += 1) {
	            if (nodes[k].t === 'm') {
	              ctx.moveTo(nodes[k].p[0], nodes[k].p[1]);
	            } else if (nodes[k].t === 'c') {
	              ctx.bezierCurveTo(nodes[k].pts[0], nodes[k].pts[1], nodes[k].pts[2], nodes[k].pts[3], nodes[k].pts[4], nodes[k].pts[5]);
	            } else {
	              ctx.closePath();
	            }
	          }
	
	          if (type === 'st' || type === 'gs') {
	            // ctx.stroke();
	            renderer.ctxStroke();
	
	            if (currentStyle.da) {
	              ctx.setLineDash(this.dashResetter);
	            }
	          }
	        }
	
	        if (type !== 'st' && type !== 'gs') {
	          // ctx.fill(currentStyle.r);
	          this.globalData.renderer.ctxFill(currentStyle.r);
	        }
	
	        renderer.restore();
	      }
	    }
	  };
	
	  CVShapeElement.prototype.renderShape = function (parentTransform, items, data, isMain) {
	    var i;
	    var len = items.length - 1;
	    var groupTransform;
	    groupTransform = parentTransform;
	
	    for (i = len; i >= 0; i -= 1) {
	      if (items[i].ty === 'tr') {
	        groupTransform = data[i].transform;
	        this.renderShapeTransform(parentTransform, groupTransform);
	      } else if (items[i].ty === 'sh' || items[i].ty === 'el' || items[i].ty === 'rc' || items[i].ty === 'sr') {
	        this.renderPath(items[i], data[i]);
	      } else if (items[i].ty === 'fl') {
	        this.renderFill(items[i], data[i], groupTransform);
	      } else if (items[i].ty === 'st') {
	        this.renderStroke(items[i], data[i], groupTransform);
	      } else if (items[i].ty === 'gf' || items[i].ty === 'gs') {
	        this.renderGradientFill(items[i], data[i], groupTransform);
	      } else if (items[i].ty === 'gr') {
	        this.renderShape(groupTransform, items[i].it, data[i].it);
	      } else if (items[i].ty === 'tm') {//
	      }
	    }
	
	    if (isMain) {
	      this.drawLayer();
	    }
	  };
	
	  CVShapeElement.prototype.renderStyledShape = function (styledShape, shape) {
	    if (this._isFirstFrame || shape._mdf || styledShape.transforms._mdf) {
	      var shapeNodes = styledShape.trNodes;
	      var paths = shape.paths;
	      var i;
	      var len;
	      var j;
	      var jLen = paths._length;
	      shapeNodes.length = 0;
	      var groupTransformMat = styledShape.transforms.finalTransform;
	
	      for (j = 0; j < jLen; j += 1) {
	        var pathNodes = paths.shapes[j];
	
	        if (pathNodes && pathNodes.v) {
	          len = pathNodes._length;
	
	          for (i = 1; i < len; i += 1) {
	            if (i === 1) {
	              shapeNodes.push({
	                t: 'm',
	                p: groupTransformMat.applyToPointArray(pathNodes.v[0][0], pathNodes.v[0][1], 0)
	              });
	            }
	
	            shapeNodes.push({
	              t: 'c',
	              pts: groupTransformMat.applyToTriplePoints(pathNodes.o[i - 1], pathNodes.i[i], pathNodes.v[i])
	            });
	          }
	
	          if (len === 1) {
	            shapeNodes.push({
	              t: 'm',
	              p: groupTransformMat.applyToPointArray(pathNodes.v[0][0], pathNodes.v[0][1], 0)
	            });
	          }
	
	          if (pathNodes.c && len) {
	            shapeNodes.push({
	              t: 'c',
	              pts: groupTransformMat.applyToTriplePoints(pathNodes.o[i - 1], pathNodes.i[0], pathNodes.v[0])
	            });
	            shapeNodes.push({
	              t: 'z'
	            });
	          }
	        }
	      }
	
	      styledShape.trNodes = shapeNodes;
	    }
	  };
	
	  CVShapeElement.prototype.renderPath = function (pathData, itemData) {
	    if (pathData.hd !== true && pathData._shouldRender) {
	      var i;
	      var len = itemData.styledShapes.length;
	
	      for (i = 0; i < len; i += 1) {
	        this.renderStyledShape(itemData.styledShapes[i], itemData.sh);
	      }
	    }
	  };
	
	  CVShapeElement.prototype.renderFill = function (styleData, itemData, groupTransform) {
	    var styleElem = itemData.style;
	
	    if (itemData.c._mdf || this._isFirstFrame) {
	      styleElem.co = 'rgb(' + bmFloor(itemData.c.v[0]) + ',' + bmFloor(itemData.c.v[1]) + ',' + bmFloor(itemData.c.v[2]) + ')';
	    }
	
	    if (itemData.o._mdf || groupTransform._opMdf || this._isFirstFrame) {
	      styleElem.coOp = itemData.o.v * groupTransform.opacity;
	    }
	  };
	
	  CVShapeElement.prototype.renderGradientFill = function (styleData, itemData, groupTransform) {
	    var styleElem = itemData.style;
	    var grd;
	
	    if (!styleElem.grd || itemData.g._mdf || itemData.s._mdf || itemData.e._mdf || styleData.t !== 1 && (itemData.h._mdf || itemData.a._mdf)) {
	      var ctx = this.globalData.canvasContext;
	      var pt1 = itemData.s.v;
	      var pt2 = itemData.e.v;
	
	      if (styleData.t === 1) {
	        grd = ctx.createLinearGradient(pt1[0], pt1[1], pt2[0], pt2[1]);
	      } else {
	        var rad = Math.sqrt(Math.pow(pt1[0] - pt2[0], 2) + Math.pow(pt1[1] - pt2[1], 2));
	        var ang = Math.atan2(pt2[1] - pt1[1], pt2[0] - pt1[0]);
	        var percent = itemData.h.v;
	
	        if (percent >= 1) {
	          percent = 0.99;
	        } else if (percent <= -1) {
	          percent = -0.99;
	        }
	
	        var dist = rad * percent;
	        var x = Math.cos(ang + itemData.a.v) * dist + pt1[0];
	        var y = Math.sin(ang + itemData.a.v) * dist + pt1[1];
	        grd = ctx.createRadialGradient(x, y, 0, pt1[0], pt1[1], rad);
	      }
	
	      var i;
	      var len = styleData.g.p;
	      var cValues = itemData.g.c;
	      var opacity = 1;
	
	      for (i = 0; i < len; i += 1) {
	        if (itemData.g._hasOpacity && itemData.g._collapsable) {
	          opacity = itemData.g.o[i * 2 + 1];
	        }
	
	        grd.addColorStop(cValues[i * 4] / 100, 'rgba(' + cValues[i * 4 + 1] + ',' + cValues[i * 4 + 2] + ',' + cValues[i * 4 + 3] + ',' + opacity + ')');
	      }
	
	      styleElem.grd = grd;
	    }
	
	    styleElem.coOp = itemData.o.v * groupTransform.opacity;
	  };
	
	  CVShapeElement.prototype.renderStroke = function (styleData, itemData, groupTransform) {
	    var styleElem = itemData.style;
	    var d = itemData.d;
	
	    if (d && (d._mdf || this._isFirstFrame)) {
	      styleElem.da = d.dashArray;
	      styleElem["do"] = d.dashoffset[0];
	    }
	
	    if (itemData.c._mdf || this._isFirstFrame) {
	      styleElem.co = 'rgb(' + bmFloor(itemData.c.v[0]) + ',' + bmFloor(itemData.c.v[1]) + ',' + bmFloor(itemData.c.v[2]) + ')';
	    }
	
	    if (itemData.o._mdf || groupTransform._opMdf || this._isFirstFrame) {
	      styleElem.coOp = itemData.o.v * groupTransform.opacity;
	    }
	
	    if (itemData.w._mdf || this._isFirstFrame) {
	      styleElem.wi = itemData.w.v;
	    }
	  };
	
	  CVShapeElement.prototype.destroy = function () {
	    this.shapesData = null;
	    this.globalData = null;
	    this.canvasContext = null;
	    this.stylesList.length = 0;
	    this.itemsData.length = 0;
	  };
	
	  function CVTextElement(data, globalData, comp) {
	    this.textSpans = [];
	    this.yOffset = 0;
	    this.fillColorAnim = false;
	    this.strokeColorAnim = false;
	    this.strokeWidthAnim = false;
	    this.stroke = false;
	    this.fill = false;
	    this.justifyOffset = 0;
	    this.currentRender = null;
	    this.renderType = 'canvas';
	    this.values = {
	      fill: 'rgba(0,0,0,0)',
	      stroke: 'rgba(0,0,0,0)',
	      sWidth: 0,
	      fValue: ''
	    };
	    this.initElement(data, globalData, comp);
	  }
	
	  extendPrototype([BaseElement, TransformElement, CVBaseElement, HierarchyElement, FrameElement, RenderableElement, ITextElement], CVTextElement);
	  CVTextElement.prototype.tHelper = createTag('canvas').getContext('2d');
	
	  CVTextElement.prototype.buildNewText = function () {
	    var documentData = this.textProperty.currentData;
	    this.renderedLetters = createSizedArray(documentData.l ? documentData.l.length : 0);
	    var hasFill = false;
	
	    if (documentData.fc) {
	      hasFill = true;
	      this.values.fill = this.buildColor(documentData.fc);
	    } else {
	      this.values.fill = 'rgba(0,0,0,0)';
	    }
	
	    this.fill = hasFill;
	    var hasStroke = false;
	
	    if (documentData.sc) {
	      hasStroke = true;
	      this.values.stroke = this.buildColor(documentData.sc);
	      this.values.sWidth = documentData.sw;
	    }
	
	    var fontData = this.globalData.fontManager.getFontByName(documentData.f);
	    var i;
	    var len;
	    var letters = documentData.l;
	    var matrixHelper = this.mHelper;
	    this.stroke = hasStroke;
	    this.values.fValue = documentData.finalSize + 'px ' + this.globalData.fontManager.getFontByName(documentData.f).fFamily;
	    len = documentData.finalText.length; // this.tHelper.font = this.values.fValue;
	
	    var charData;
	    var shapeData;
	    var k;
	    var kLen;
	    var shapes;
	    var j;
	    var jLen;
	    var pathNodes;
	    var commands;
	    var pathArr;
	    var singleShape = this.data.singleShape;
	    var trackingOffset = documentData.tr * 0.001 * documentData.finalSize;
	    var xPos = 0;
	    var yPos = 0;
	    var firstLine = true;
	    var cnt = 0;
	
	    for (i = 0; i < len; i += 1) {
	      charData = this.globalData.fontManager.getCharData(documentData.finalText[i], fontData.fStyle, this.globalData.fontManager.getFontByName(documentData.f).fFamily);
	      shapeData = charData && charData.data || {};
	      matrixHelper.reset();
	
	      if (singleShape && letters[i].n) {
	        xPos = -trackingOffset;
	        yPos += documentData.yOffset;
	        yPos += firstLine ? 1 : 0;
	        firstLine = false;
	      }
	
	      shapes = shapeData.shapes ? shapeData.shapes[0].it : [];
	      jLen = shapes.length;
	      matrixHelper.scale(documentData.finalSize / 100, documentData.finalSize / 100);
	
	      if (singleShape) {
	        this.applyTextPropertiesToMatrix(documentData, matrixHelper, letters[i].line, xPos, yPos);
	      }
	
	      commands = createSizedArray(jLen - 1);
	      var commandsCounter = 0;
	
	      for (j = 0; j < jLen; j += 1) {
	        if (shapes[j].ty === 'sh') {
	          kLen = shapes[j].ks.k.i.length;
	          pathNodes = shapes[j].ks.k;
	          pathArr = [];
	
	          for (k = 1; k < kLen; k += 1) {
	            if (k === 1) {
	              pathArr.push(matrixHelper.applyToX(pathNodes.v[0][0], pathNodes.v[0][1], 0), matrixHelper.applyToY(pathNodes.v[0][0], pathNodes.v[0][1], 0));
	            }
	
	            pathArr.push(matrixHelper.applyToX(pathNodes.o[k - 1][0], pathNodes.o[k - 1][1], 0), matrixHelper.applyToY(pathNodes.o[k - 1][0], pathNodes.o[k - 1][1], 0), matrixHelper.applyToX(pathNodes.i[k][0], pathNodes.i[k][1], 0), matrixHelper.applyToY(pathNodes.i[k][0], pathNodes.i[k][1], 0), matrixHelper.applyToX(pathNodes.v[k][0], pathNodes.v[k][1], 0), matrixHelper.applyToY(pathNodes.v[k][0], pathNodes.v[k][1], 0));
	          }
	
	          pathArr.push(matrixHelper.applyToX(pathNodes.o[k - 1][0], pathNodes.o[k - 1][1], 0), matrixHelper.applyToY(pathNodes.o[k - 1][0], pathNodes.o[k - 1][1], 0), matrixHelper.applyToX(pathNodes.i[0][0], pathNodes.i[0][1], 0), matrixHelper.applyToY(pathNodes.i[0][0], pathNodes.i[0][1], 0), matrixHelper.applyToX(pathNodes.v[0][0], pathNodes.v[0][1], 0), matrixHelper.applyToY(pathNodes.v[0][0], pathNodes.v[0][1], 0));
	          commands[commandsCounter] = pathArr;
	          commandsCounter += 1;
	        }
	      }
	
	      if (singleShape) {
	        xPos += letters[i].l;
	        xPos += trackingOffset;
	      }
	
	      if (this.textSpans[cnt]) {
	        this.textSpans[cnt].elem = commands;
	      } else {
	        this.textSpans[cnt] = {
	          elem: commands
	        };
	      }
	
	      cnt += 1;
	    }
	  };
	
	  CVTextElement.prototype.renderInnerContent = function () {
	    this.validateText();
	    var ctx = this.canvasContext;
	    ctx.font = this.values.fValue;
	    this.globalData.renderer.ctxLineCap('butt'); // ctx.lineCap = 'butt';
	
	    this.globalData.renderer.ctxLineJoin('miter'); // ctx.lineJoin = 'miter';
	
	    this.globalData.renderer.ctxMiterLimit(4); // ctx.miterLimit = 4;
	
	    if (!this.data.singleShape) {
	      this.textAnimator.getMeasures(this.textProperty.currentData, this.lettersChangedFlag);
	    }
	
	    var i;
	    var len;
	    var j;
	    var jLen;
	    var k;
	    var kLen;
	    var renderedLetters = this.textAnimator.renderedLetters;
	    var letters = this.textProperty.currentData.l;
	    len = letters.length;
	    var renderedLetter;
	    var lastFill = null;
	    var lastStroke = null;
	    var lastStrokeW = null;
	    var commands;
	    var pathArr;
	    var renderer = this.globalData.renderer;
	
	    for (i = 0; i < len; i += 1) {
	      if (!letters[i].n) {
	        renderedLetter = renderedLetters[i];
	
	        if (renderedLetter) {
	          renderer.save();
	          renderer.ctxTransform(renderedLetter.p);
	          renderer.ctxOpacity(renderedLetter.o);
	        }
	
	        if (this.fill) {
	          if (renderedLetter && renderedLetter.fc) {
	            if (lastFill !== renderedLetter.fc) {
	              renderer.ctxFillStyle(renderedLetter.fc);
	              lastFill = renderedLetter.fc; // ctx.fillStyle = renderedLetter.fc;
	            }
	          } else if (lastFill !== this.values.fill) {
	            lastFill = this.values.fill;
	            renderer.ctxFillStyle(this.values.fill); // ctx.fillStyle = this.values.fill;
	          }
	
	          commands = this.textSpans[i].elem;
	          jLen = commands.length;
	          this.globalData.canvasContext.beginPath();
	
	          for (j = 0; j < jLen; j += 1) {
	            pathArr = commands[j];
	            kLen = pathArr.length;
	            this.globalData.canvasContext.moveTo(pathArr[0], pathArr[1]);
	
	            for (k = 2; k < kLen; k += 6) {
	              this.globalData.canvasContext.bezierCurveTo(pathArr[k], pathArr[k + 1], pathArr[k + 2], pathArr[k + 3], pathArr[k + 4], pathArr[k + 5]);
	            }
	          }
	
	          this.globalData.canvasContext.closePath();
	          renderer.ctxFill(); // this.globalData.canvasContext.fill();
	          /// ctx.fillText(this.textSpans[i].val,0,0);
	        }
	
	        if (this.stroke) {
	          if (renderedLetter && renderedLetter.sw) {
	            if (lastStrokeW !== renderedLetter.sw) {
	              lastStrokeW = renderedLetter.sw;
	              renderer.ctxLineWidth(renderedLetter.sw); // ctx.lineWidth = renderedLetter.sw;
	            }
	          } else if (lastStrokeW !== this.values.sWidth) {
	            lastStrokeW = this.values.sWidth;
	            renderer.ctxLineWidth(this.values.sWidth); // ctx.lineWidth = this.values.sWidth;
	          }
	
	          if (renderedLetter && renderedLetter.sc) {
	            if (lastStroke !== renderedLetter.sc) {
	              lastStroke = renderedLetter.sc;
	              renderer.ctxStrokeStyle(renderedLetter.sc); // ctx.strokeStyle = renderedLetter.sc;
	            }
	          } else if (lastStroke !== this.values.stroke) {
	            lastStroke = this.values.stroke;
	            renderer.ctxStrokeStyle(this.values.stroke); // ctx.strokeStyle = this.values.stroke;
	          }
	
	          commands = this.textSpans[i].elem;
	          jLen = commands.length;
	          this.globalData.canvasContext.beginPath();
	
	          for (j = 0; j < jLen; j += 1) {
	            pathArr = commands[j];
	            kLen = pathArr.length;
	            this.globalData.canvasContext.moveTo(pathArr[0], pathArr[1]);
	
	            for (k = 2; k < kLen; k += 6) {
	              this.globalData.canvasContext.bezierCurveTo(pathArr[k], pathArr[k + 1], pathArr[k + 2], pathArr[k + 3], pathArr[k + 4], pathArr[k + 5]);
	            }
	          }
	
	          this.globalData.canvasContext.closePath();
	          renderer.ctxStroke(); // this.globalData.canvasContext.stroke();
	          /// ctx.strokeText(letters[i].val,0,0);
	        }
	
	        if (renderedLetter) {
	          this.globalData.renderer.restore();
	        }
	      }
	    }
	  };
	
	  function CVImageElement(data, globalData, comp) {
	    this.assetData = globalData.getAssetData(data.refId);
	    this.img = globalData.imageLoader.getAsset(this.assetData);
	    this.initElement(data, globalData, comp);
	  }
	
	  extendPrototype([BaseElement, TransformElement, CVBaseElement, HierarchyElement, FrameElement, RenderableElement], CVImageElement);
	  CVImageElement.prototype.initElement = SVGShapeElement.prototype.initElement;
	  CVImageElement.prototype.prepareFrame = IImageElement.prototype.prepareFrame;
	
	  CVImageElement.prototype.createContent = function () {
	    if (this.img.width && (this.assetData.w !== this.img.width || this.assetData.h !== this.img.height)) {
	      var canvas = createTag('canvas');
	      canvas.width = this.assetData.w;
	      canvas.height = this.assetData.h;
	      var ctx = canvas.getContext('2d');
	      var imgW = this.img.width;
	      var imgH = this.img.height;
	      var imgRel = imgW / imgH;
	      var canvasRel = this.assetData.w / this.assetData.h;
	      var widthCrop;
	      var heightCrop;
	      var par = this.assetData.pr || this.globalData.renderConfig.imagePreserveAspectRatio;
	
	      if (imgRel > canvasRel && par === 'xMidYMid slice' || imgRel < canvasRel && par !== 'xMidYMid slice') {
	        heightCrop = imgH;
	        widthCrop = heightCrop * canvasRel;
	      } else {
	        widthCrop = imgW;
	        heightCrop = widthCrop / canvasRel;
	      }
	
	      ctx.drawImage(this.img, (imgW - widthCrop) / 2, (imgH - heightCrop) / 2, widthCrop, heightCrop, 0, 0, this.assetData.w, this.assetData.h);
	      this.img = canvas;
	    }
	  };
	
	  CVImageElement.prototype.renderInnerContent = function () {
	    this.canvasContext.drawImage(this.img, 0, 0);
	  };
	
	  CVImageElement.prototype.destroy = function () {
	    this.img = null;
	  };
	
	  function CVSolidElement(data, globalData, comp) {
	    this.initElement(data, globalData, comp);
	  }
	
	  extendPrototype([BaseElement, TransformElement, CVBaseElement, HierarchyElement, FrameElement, RenderableElement], CVSolidElement);
	  CVSolidElement.prototype.initElement = SVGShapeElement.prototype.initElement;
	  CVSolidElement.prototype.prepareFrame = IImageElement.prototype.prepareFrame;
	
	  CVSolidElement.prototype.renderInnerContent = function () {
	    // var ctx = this.canvasContext;
	    this.globalData.renderer.ctxFillStyle(this.data.sc); // ctx.fillStyle = this.data.sc;
	
	    this.globalData.renderer.ctxFillRect(0, 0, this.data.sw, this.data.sh); // ctx.fillRect(0, 0, this.data.sw, this.data.sh);
	    //
	  };
	
	  function CanvasRendererBase() {}
	
	  extendPrototype([BaseRenderer], CanvasRendererBase);
	
	  CanvasRendererBase.prototype.createShape = function (data) {
	    return new CVShapeElement(data, this.globalData, this);
	  };
	
	  CanvasRendererBase.prototype.createText = function (data) {
	    return new CVTextElement(data, this.globalData, this);
	  };
	
	  CanvasRendererBase.prototype.createImage = function (data) {
	    return new CVImageElement(data, this.globalData, this);
	  };
	
	  CanvasRendererBase.prototype.createSolid = function (data) {
	    return new CVSolidElement(data, this.globalData, this);
	  };
	
	  CanvasRendererBase.prototype.createNull = SVGRenderer.prototype.createNull;
	
	  CanvasRendererBase.prototype.ctxTransform = function (props) {
	    if (props[0] === 1 && props[1] === 0 && props[4] === 0 && props[5] === 1 && props[12] === 0 && props[13] === 0) {
	      return;
	    }
	
	    this.canvasContext.transform(props[0], props[1], props[4], props[5], props[12], props[13]);
	  };
	
	  CanvasRendererBase.prototype.ctxOpacity = function (op) {
	    this.canvasContext.globalAlpha *= op < 0 ? 0 : op;
	  };
	
	  CanvasRendererBase.prototype.ctxFillStyle = function (value) {
	    this.canvasContext.fillStyle = value;
	  };
	
	  CanvasRendererBase.prototype.ctxStrokeStyle = function (value) {
	    this.canvasContext.strokeStyle = value;
	  };
	
	  CanvasRendererBase.prototype.ctxLineWidth = function (value) {
	    this.canvasContext.lineWidth = value;
	  };
	
	  CanvasRendererBase.prototype.ctxLineCap = function (value) {
	    this.canvasContext.lineCap = value;
	  };
	
	  CanvasRendererBase.prototype.ctxLineJoin = function (value) {
	    this.canvasContext.lineJoin = value;
	  };
	
	  CanvasRendererBase.prototype.ctxMiterLimit = function (value) {
	    this.canvasContext.miterLimit = value;
	  };
	
	  CanvasRendererBase.prototype.ctxFill = function (rule) {
	    this.canvasContext.fill(rule);
	  };
	
	  CanvasRendererBase.prototype.ctxFillRect = function (x, y, w, h) {
	    this.canvasContext.fillRect(x, y, w, h);
	  };
	
	  CanvasRendererBase.prototype.ctxStroke = function () {
	    this.canvasContext.stroke();
	  };
	
	  CanvasRendererBase.prototype.reset = function () {
	    if (!this.renderConfig.clearCanvas) {
	      this.canvasContext.restore();
	      return;
	    }
	
	    this.contextData.reset();
	  };
	
	  CanvasRendererBase.prototype.save = function () {
	    this.canvasContext.save();
	  };
	
	  CanvasRendererBase.prototype.restore = function (actionFlag) {
	    if (!this.renderConfig.clearCanvas) {
	      this.canvasContext.restore();
	      return;
	    }
	
	    if (actionFlag) {
	      this.globalData.blendMode = 'source-over';
	    }
	
	    this.contextData.restore(actionFlag);
	  };
	
	  CanvasRendererBase.prototype.configAnimation = function (animData) {
	    if (this.animationItem.wrapper) {
	      this.animationItem.container = createTag('canvas');
	      var containerStyle = this.animationItem.container.style;
	      containerStyle.width = '100%';
	      containerStyle.height = '100%';
	      var origin = '0px 0px 0px';
	      containerStyle.transformOrigin = origin;
	      containerStyle.mozTransformOrigin = origin;
	      containerStyle.webkitTransformOrigin = origin;
	      containerStyle['-webkit-transform'] = origin;
	      containerStyle.contentVisibility = this.renderConfig.contentVisibility;
	      this.animationItem.wrapper.appendChild(this.animationItem.container);
	      this.canvasContext = this.animationItem.container.getContext('2d');
	
	      if (this.renderConfig.className) {
	        this.animationItem.container.setAttribute('class', this.renderConfig.className);
	      }
	
	      if (this.renderConfig.id) {
	        this.animationItem.container.setAttribute('id', this.renderConfig.id);
	      }
	    } else {
	      this.canvasContext = this.renderConfig.context;
	    }
	
	    this.contextData.setContext(this.canvasContext);
	    this.data = animData;
	    this.layers = animData.layers;
	    this.transformCanvas = {
	      w: animData.w,
	      h: animData.h,
	      sx: 0,
	      sy: 0,
	      tx: 0,
	      ty: 0
	    };
	    this.setupGlobalData(animData, document.body);
	    this.globalData.canvasContext = this.canvasContext;
	    this.globalData.renderer = this;
	    this.globalData.isDashed = false;
	    this.globalData.progressiveLoad = this.renderConfig.progressiveLoad;
	    this.globalData.transformCanvas = this.transformCanvas;
	    this.elements = createSizedArray(animData.layers.length);
	    this.updateContainerSize();
	  };
	
	  CanvasRendererBase.prototype.updateContainerSize = function (width, height) {
	    this.reset();
	    var elementWidth;
	    var elementHeight;
	
	    if (width) {
	      elementWidth = width;
	      elementHeight = height;
	      this.canvasContext.canvas.width = elementWidth;
	      this.canvasContext.canvas.height = elementHeight;
	    } else {
	      if (this.animationItem.wrapper && this.animationItem.container) {
	        elementWidth = this.animationItem.wrapper.offsetWidth;
	        elementHeight = this.animationItem.wrapper.offsetHeight;
	      } else {
	        elementWidth = this.canvasContext.canvas.width;
	        elementHeight = this.canvasContext.canvas.height;
	      }
	
	      this.canvasContext.canvas.width = elementWidth * this.renderConfig.dpr;
	      this.canvasContext.canvas.height = elementHeight * this.renderConfig.dpr;
	    }
	
	    var elementRel;
	    var animationRel;
	
	    if (this.renderConfig.preserveAspectRatio.indexOf('meet') !== -1 || this.renderConfig.preserveAspectRatio.indexOf('slice') !== -1) {
	      var par = this.renderConfig.preserveAspectRatio.split(' ');
	      var fillType = par[1] || 'meet';
	      var pos = par[0] || 'xMidYMid';
	      var xPos = pos.substr(0, 4);
	      var yPos = pos.substr(4);
	      elementRel = elementWidth / elementHeight;
	      animationRel = this.transformCanvas.w / this.transformCanvas.h;
	
	      if (animationRel > elementRel && fillType === 'meet' || animationRel < elementRel && fillType === 'slice') {
	        this.transformCanvas.sx = elementWidth / (this.transformCanvas.w / this.renderConfig.dpr);
	        this.transformCanvas.sy = elementWidth / (this.transformCanvas.w / this.renderConfig.dpr);
	      } else {
	        this.transformCanvas.sx = elementHeight / (this.transformCanvas.h / this.renderConfig.dpr);
	        this.transformCanvas.sy = elementHeight / (this.transformCanvas.h / this.renderConfig.dpr);
	      }
	
	      if (xPos === 'xMid' && (animationRel < elementRel && fillType === 'meet' || animationRel > elementRel && fillType === 'slice')) {
	        this.transformCanvas.tx = (elementWidth - this.transformCanvas.w * (elementHeight / this.transformCanvas.h)) / 2 * this.renderConfig.dpr;
	      } else if (xPos === 'xMax' && (animationRel < elementRel && fillType === 'meet' || animationRel > elementRel && fillType === 'slice')) {
	        this.transformCanvas.tx = (elementWidth - this.transformCanvas.w * (elementHeight / this.transformCanvas.h)) * this.renderConfig.dpr;
	      } else {
	        this.transformCanvas.tx = 0;
	      }
	
	      if (yPos === 'YMid' && (animationRel > elementRel && fillType === 'meet' || animationRel < elementRel && fillType === 'slice')) {
	        this.transformCanvas.ty = (elementHeight - this.transformCanvas.h * (elementWidth / this.transformCanvas.w)) / 2 * this.renderConfig.dpr;
	      } else if (yPos === 'YMax' && (animationRel > elementRel && fillType === 'meet' || animationRel < elementRel && fillType === 'slice')) {
	        this.transformCanvas.ty = (elementHeight - this.transformCanvas.h * (elementWidth / this.transformCanvas.w)) * this.renderConfig.dpr;
	      } else {
	        this.transformCanvas.ty = 0;
	      }
	    } else if (this.renderConfig.preserveAspectRatio === 'none') {
	      this.transformCanvas.sx = elementWidth / (this.transformCanvas.w / this.renderConfig.dpr);
	      this.transformCanvas.sy = elementHeight / (this.transformCanvas.h / this.renderConfig.dpr);
	      this.transformCanvas.tx = 0;
	      this.transformCanvas.ty = 0;
	    } else {
	      this.transformCanvas.sx = this.renderConfig.dpr;
	      this.transformCanvas.sy = this.renderConfig.dpr;
	      this.transformCanvas.tx = 0;
	      this.transformCanvas.ty = 0;
	    }
	
	    this.transformCanvas.props = [this.transformCanvas.sx, 0, 0, 0, 0, this.transformCanvas.sy, 0, 0, 0, 0, 1, 0, this.transformCanvas.tx, this.transformCanvas.ty, 0, 1];
	    /* var i, len = this.elements.length;
	      for(i=0;i<len;i+=1){
	          if(this.elements[i] && this.elements[i].data.ty === 0){
	              this.elements[i].resize(this.globalData.transformCanvas);
	          }
	      } */
	
	    this.ctxTransform(this.transformCanvas.props);
	    this.canvasContext.beginPath();
	    this.canvasContext.rect(0, 0, this.transformCanvas.w, this.transformCanvas.h);
	    this.canvasContext.closePath();
	    this.canvasContext.clip();
	    this.renderFrame(this.renderedFrame, true);
	  };
	
	  CanvasRendererBase.prototype.destroy = function () {
	    if (this.renderConfig.clearCanvas && this.animationItem.wrapper) {
	      this.animationItem.wrapper.innerText = '';
	    }
	
	    var i;
	    var len = this.layers ? this.layers.length : 0;
	
	    for (i = len - 1; i >= 0; i -= 1) {
	      if (this.elements[i] && this.elements[i].destroy) {
	        this.elements[i].destroy();
	      }
	    }
	
	    this.elements.length = 0;
	    this.globalData.canvasContext = null;
	    this.animationItem.container = null;
	    this.destroyed = true;
	  };
	
	  CanvasRendererBase.prototype.renderFrame = function (num, forceRender) {
	    if (this.renderedFrame === num && this.renderConfig.clearCanvas === true && !forceRender || this.destroyed || num === -1) {
	      return;
	    }
	
	    this.renderedFrame = num;
	    this.globalData.frameNum = num - this.animationItem._isFirstFrame;
	    this.globalData.frameId += 1;
	    this.globalData._mdf = !this.renderConfig.clearCanvas || forceRender;
	    this.globalData.projectInterface.currentFrame = num; // console.log('--------');
	    // console.log('NEW: ',num);
	
	    var i;
	    var len = this.layers.length;
	
	    if (!this.completeLayers) {
	      this.checkLayers(num);
	    }
	
	    for (i = len - 1; i >= 0; i -= 1) {
	      if (this.completeLayers || this.elements[i]) {
	        this.elements[i].prepareFrame(num - this.layers[i].st);
	      }
	    }
	
	    if (this.globalData._mdf) {
	      if (this.renderConfig.clearCanvas === true) {
	        this.canvasContext.clearRect(0, 0, this.transformCanvas.w, this.transformCanvas.h);
	      } else {
	        this.save();
	      }
	
	      for (i = len - 1; i >= 0; i -= 1) {
	        if (this.completeLayers || this.elements[i]) {
	          this.elements[i].renderFrame();
	        }
	      }
	
	      if (this.renderConfig.clearCanvas !== true) {
	        this.restore();
	      }
	    }
	  };
	
	  CanvasRendererBase.prototype.buildItem = function (pos) {
	    var elements = this.elements;
	
	    if (elements[pos] || this.layers[pos].ty === 99) {
	      return;
	    }
	
	    var element = this.createItem(this.layers[pos], this, this.globalData);
	    elements[pos] = element;
	    element.initExpressions();
	    /* if(this.layers[pos].ty === 0){
	          element.resize(this.globalData.transformCanvas);
	      } */
	  };
	
	  CanvasRendererBase.prototype.checkPendingElements = function () {
	    while (this.pendingElements.length) {
	      var element = this.pendingElements.pop();
	      element.checkParenting();
	    }
	  };
	
	  CanvasRendererBase.prototype.hide = function () {
	    this.animationItem.container.style.display = 'none';
	  };
	
	  CanvasRendererBase.prototype.show = function () {
	    this.animationItem.container.style.display = 'block';
	  };
	
	  function CanvasContext() {
	    this.opacity = -1;
	    this.transform = createTypedArray('float32', 16);
	    this.fillStyle = '';
	    this.strokeStyle = '';
	    this.lineWidth = '';
	    this.lineCap = '';
	    this.lineJoin = '';
	    this.miterLimit = '';
	    this.id = Math.random();
	  }
	
	  function CVContextData() {
	    this.stack = [];
	    this.cArrPos = 0;
	    this.cTr = new Matrix();
	    var i;
	    var len = 15;
	
	    for (i = 0; i < len; i += 1) {
	      var canvasContext = new CanvasContext();
	      this.stack[i] = canvasContext;
	    }
	
	    this._length = len;
	    this.nativeContext = null;
	    this.transformMat = new Matrix();
	    this.currentOpacity = 1; //
	
	    this.currentFillStyle = '';
	    this.appliedFillStyle = ''; //
	
	    this.currentStrokeStyle = '';
	    this.appliedStrokeStyle = ''; //
	
	    this.currentLineWidth = '';
	    this.appliedLineWidth = ''; //
	
	    this.currentLineCap = '';
	    this.appliedLineCap = ''; //
	
	    this.currentLineJoin = '';
	    this.appliedLineJoin = ''; //
	
	    this.appliedMiterLimit = '';
	    this.currentMiterLimit = '';
	  }
	
	  CVContextData.prototype.duplicate = function () {
	    var newLength = this._length * 2;
	    var i = 0;
	
	    for (i = this._length; i < newLength; i += 1) {
	      this.stack[i] = new CanvasContext();
	    }
	
	    this._length = newLength;
	  };
	
	  CVContextData.prototype.reset = function () {
	    this.cArrPos = 0;
	    this.cTr.reset();
	    this.stack[this.cArrPos].opacity = 1;
	  };
	
	  CVContextData.prototype.restore = function (forceRestore) {
	    this.cArrPos -= 1;
	    var currentContext = this.stack[this.cArrPos];
	    var transform = currentContext.transform;
	    var i;
	    var arr = this.cTr.props;
	
	    for (i = 0; i < 16; i += 1) {
	      arr[i] = transform[i];
	    }
	
	    if (forceRestore) {
	      this.nativeContext.restore();
	      var prevStack = this.stack[this.cArrPos + 1];
	      this.appliedFillStyle = prevStack.fillStyle;
	      this.appliedStrokeStyle = prevStack.strokeStyle;
	      this.appliedLineWidth = prevStack.lineWidth;
	      this.appliedLineCap = prevStack.lineCap;
	      this.appliedLineJoin = prevStack.lineJoin;
	      this.appliedMiterLimit = prevStack.miterLimit;
	    }
	
	    this.nativeContext.setTransform(transform[0], transform[1], transform[4], transform[5], transform[12], transform[13]);
	
	    if (forceRestore || currentContext.opacity !== -1 && this.currentOpacity !== currentContext.opacity) {
	      this.nativeContext.globalAlpha = currentContext.opacity;
	      this.currentOpacity = currentContext.opacity;
	    }
	
	    this.currentFillStyle = currentContext.fillStyle;
	    this.currentStrokeStyle = currentContext.strokeStyle;
	    this.currentLineWidth = currentContext.lineWidth;
	    this.currentLineCap = currentContext.lineCap;
	    this.currentLineJoin = currentContext.lineJoin;
	    this.currentMiterLimit = currentContext.miterLimit;
	  };
	
	  CVContextData.prototype.save = function (saveOnNativeFlag) {
	    if (saveOnNativeFlag) {
	      this.nativeContext.save();
	    }
	
	    var props = this.cTr.props;
	
	    if (this._length <= this.cArrPos) {
	      this.duplicate();
	    }
	
	    var currentStack = this.stack[this.cArrPos];
	    var i;
	
	    for (i = 0; i < 16; i += 1) {
	      currentStack.transform[i] = props[i];
	    }
	
	    this.cArrPos += 1;
	    var newStack = this.stack[this.cArrPos];
	    newStack.opacity = currentStack.opacity;
	    newStack.fillStyle = currentStack.fillStyle;
	    newStack.strokeStyle = currentStack.strokeStyle;
	    newStack.lineWidth = currentStack.lineWidth;
	    newStack.lineCap = currentStack.lineCap;
	    newStack.lineJoin = currentStack.lineJoin;
	    newStack.miterLimit = currentStack.miterLimit;
	  };
	
	  CVContextData.prototype.setOpacity = function (value) {
	    this.stack[this.cArrPos].opacity = value;
	  };
	
	  CVContextData.prototype.setContext = function (value) {
	    this.nativeContext = value;
	  };
	
	  CVContextData.prototype.fillStyle = function (value) {
	    if (this.stack[this.cArrPos].fillStyle !== value) {
	      this.currentFillStyle = value;
	      this.stack[this.cArrPos].fillStyle = value;
	    }
	  };
	
	  CVContextData.prototype.strokeStyle = function (value) {
	    if (this.stack[this.cArrPos].strokeStyle !== value) {
	      this.currentStrokeStyle = value;
	      this.stack[this.cArrPos].strokeStyle = value;
	    }
	  };
	
	  CVContextData.prototype.lineWidth = function (value) {
	    if (this.stack[this.cArrPos].lineWidth !== value) {
	      this.currentLineWidth = value;
	      this.stack[this.cArrPos].lineWidth = value;
	    }
	  };
	
	  CVContextData.prototype.lineCap = function (value) {
	    if (this.stack[this.cArrPos].lineCap !== value) {
	      this.currentLineCap = value;
	      this.stack[this.cArrPos].lineCap = value;
	    }
	  };
	
	  CVContextData.prototype.lineJoin = function (value) {
	    if (this.stack[this.cArrPos].lineJoin !== value) {
	      this.currentLineJoin = value;
	      this.stack[this.cArrPos].lineJoin = value;
	    }
	  };
	
	  CVContextData.prototype.miterLimit = function (value) {
	    if (this.stack[this.cArrPos].miterLimit !== value) {
	      this.currentMiterLimit = value;
	      this.stack[this.cArrPos].miterLimit = value;
	    }
	  };
	
	  CVContextData.prototype.transform = function (props) {
	    this.transformMat.cloneFromProps(props); // Taking the last transform value from the stored stack of transforms
	
	    var currentTransform = this.cTr; // Applying the last transform value after the new transform to respect the order of transformations
	
	    this.transformMat.multiply(currentTransform); // Storing the new transformed value in the stored transform
	
	    currentTransform.cloneFromProps(this.transformMat.props);
	    var trProps = currentTransform.props; // Applying the new transform to the canvas
	
	    this.nativeContext.setTransform(trProps[0], trProps[1], trProps[4], trProps[5], trProps[12], trProps[13]);
	  };
	
	  CVContextData.prototype.opacity = function (op) {
	    var currentOpacity = this.stack[this.cArrPos].opacity;
	    currentOpacity *= op < 0 ? 0 : op;
	
	    if (this.stack[this.cArrPos].opacity !== currentOpacity) {
	      if (this.currentOpacity !== op) {
	        this.nativeContext.globalAlpha = op;
	        this.currentOpacity = op;
	      }
	
	      this.stack[this.cArrPos].opacity = currentOpacity;
	    }
	  };
	
	  CVContextData.prototype.fill = function (rule) {
	    if (this.appliedFillStyle !== this.currentFillStyle) {
	      this.appliedFillStyle = this.currentFillStyle;
	      this.nativeContext.fillStyle = this.appliedFillStyle;
	    }
	
	    this.nativeContext.fill(rule);
	  };
	
	  CVContextData.prototype.fillRect = function (x, y, w, h) {
	    if (this.appliedFillStyle !== this.currentFillStyle) {
	      this.appliedFillStyle = this.currentFillStyle;
	      this.nativeContext.fillStyle = this.appliedFillStyle;
	    }
	
	    this.nativeContext.fillRect(x, y, w, h);
	  };
	
	  CVContextData.prototype.stroke = function () {
	    if (this.appliedStrokeStyle !== this.currentStrokeStyle) {
	      this.appliedStrokeStyle = this.currentStrokeStyle;
	      this.nativeContext.strokeStyle = this.appliedStrokeStyle;
	    }
	
	    if (this.appliedLineWidth !== this.currentLineWidth) {
	      this.appliedLineWidth = this.currentLineWidth;
	      this.nativeContext.lineWidth = this.appliedLineWidth;
	    }
	
	    if (this.appliedLineCap !== this.currentLineCap) {
	      this.appliedLineCap = this.currentLineCap;
	      this.nativeContext.lineCap = this.appliedLineCap;
	    }
	
	    if (this.appliedLineJoin !== this.currentLineJoin) {
	      this.appliedLineJoin = this.currentLineJoin;
	      this.nativeContext.lineJoin = this.appliedLineJoin;
	    }
	
	    if (this.appliedMiterLimit !== this.currentMiterLimit) {
	      this.appliedMiterLimit = this.currentMiterLimit;
	      this.nativeContext.miterLimit = this.appliedMiterLimit;
	    }
	
	    this.nativeContext.stroke();
	  };
	
	  function CVCompElement(data, globalData, comp) {
	    this.completeLayers = false;
	    this.layers = data.layers;
	    this.pendingElements = [];
	    this.elements = createSizedArray(this.layers.length);
	    this.initElement(data, globalData, comp);
	    this.tm = data.tm ? PropertyFactory.getProp(this, data.tm, 0, globalData.frameRate, this) : {
	      _placeholder: true
	    };
	  }
	
	  extendPrototype([CanvasRendererBase, ICompElement, CVBaseElement], CVCompElement);
	
	  CVCompElement.prototype.renderInnerContent = function () {
	    var ctx = this.canvasContext;
	    ctx.beginPath();
	    ctx.moveTo(0, 0);
	    ctx.lineTo(this.data.w, 0);
	    ctx.lineTo(this.data.w, this.data.h);
	    ctx.lineTo(0, this.data.h);
	    ctx.lineTo(0, 0);
	    ctx.clip();
	    var i;
	    var len = this.layers.length;
	
	    for (i = len - 1; i >= 0; i -= 1) {
	      if (this.completeLayers || this.elements[i]) {
	        this.elements[i].renderFrame();
	      }
	    }
	  };
	
	  CVCompElement.prototype.destroy = function () {
	    var i;
	    var len = this.layers.length;
	
	    for (i = len - 1; i >= 0; i -= 1) {
	      if (this.elements[i]) {
	        this.elements[i].destroy();
	      }
	    }
	
	    this.layers = null;
	    this.elements = null;
	  };
	
	  CVCompElement.prototype.createComp = function (data) {
	    return new CVCompElement(data, this.globalData, this);
	  };
	
	  function CanvasRenderer(animationItem, config) {
	    this.animationItem = animationItem;
	    this.renderConfig = {
	      clearCanvas: config && config.clearCanvas !== undefined ? config.clearCanvas : true,
	      context: config && config.context || null,
	      progressiveLoad: config && config.progressiveLoad || false,
	      preserveAspectRatio: config && config.preserveAspectRatio || 'xMidYMid meet',
	      imagePreserveAspectRatio: config && config.imagePreserveAspectRatio || 'xMidYMid slice',
	      contentVisibility: config && config.contentVisibility || 'visible',
	      className: config && config.className || '',
	      id: config && config.id || '',
	      runExpressions: !config || config.runExpressions === undefined || config.runExpressions
	    };
	    this.renderConfig.dpr = config && config.dpr || 1;
	
	    if (this.animationItem.wrapper) {
	      this.renderConfig.dpr = config && config.dpr || window.devicePixelRatio || 1;
	    }
	
	    this.renderedFrame = -1;
	    this.globalData = {
	      frameNum: -1,
	      _mdf: false,
	      renderConfig: this.renderConfig,
	      currentGlobalAlpha: -1
	    };
	    this.contextData = new CVContextData();
	    this.elements = [];
	    this.pendingElements = [];
	    this.transformMat = new Matrix();
	    this.completeLayers = false;
	    this.rendererType = 'canvas';
	
	    if (this.renderConfig.clearCanvas) {
	      this.ctxTransform = this.contextData.transform.bind(this.contextData);
	      this.ctxOpacity = this.contextData.opacity.bind(this.contextData);
	      this.ctxFillStyle = this.contextData.fillStyle.bind(this.contextData);
	      this.ctxStrokeStyle = this.contextData.strokeStyle.bind(this.contextData);
	      this.ctxLineWidth = this.contextData.lineWidth.bind(this.contextData);
	      this.ctxLineCap = this.contextData.lineCap.bind(this.contextData);
	      this.ctxLineJoin = this.contextData.lineJoin.bind(this.contextData);
	      this.ctxMiterLimit = this.contextData.miterLimit.bind(this.contextData);
	      this.ctxFill = this.contextData.fill.bind(this.contextData);
	      this.ctxFillRect = this.contextData.fillRect.bind(this.contextData);
	      this.ctxStroke = this.contextData.stroke.bind(this.contextData);
	      this.save = this.contextData.save.bind(this.contextData);
	    }
	  }
	
	  extendPrototype([CanvasRendererBase], CanvasRenderer);
	
	  CanvasRenderer.prototype.createComp = function (data) {
	    return new CVCompElement(data, this.globalData, this);
	  };
	
	  function HBaseElement() {}
	
	  HBaseElement.prototype = {
	    checkBlendMode: function checkBlendMode() {},
	    initRendererElement: function initRendererElement() {
	      this.baseElement = createTag(this.data.tg || 'div');
	
	      if (this.data.hasMask) {
	        this.svgElement = createNS('svg');
	        this.layerElement = createNS('g');
	        this.maskedElement = this.layerElement;
	        this.svgElement.appendChild(this.layerElement);
	        this.baseElement.appendChild(this.svgElement);
	      } else {
	        this.layerElement = this.baseElement;
	      }
	
	      styleDiv(this.baseElement);
	    },
	    createContainerElements: function createContainerElements() {
	      this.renderableEffectsManager = new CVEffects(this);
	      this.transformedElement = this.baseElement;
	      this.maskedElement = this.layerElement;
	
	      if (this.data.ln) {
	        this.layerElement.setAttribute('id', this.data.ln);
	      }
	
	      if (this.data.cl) {
	        this.layerElement.setAttribute('class', this.data.cl);
	      }
	
	      if (this.data.bm !== 0) {
	        this.setBlendMode();
	      }
	    },
	    renderElement: function renderElement() {
	      var transformedElementStyle = this.transformedElement ? this.transformedElement.style : {};
	
	      if (this.finalTransform._matMdf) {
	        var matrixValue = this.finalTransform.mat.toCSS();
	        transformedElementStyle.transform = matrixValue;
	        transformedElementStyle.webkitTransform = matrixValue;
	      }
	
	      if (this.finalTransform._opMdf) {
	        transformedElementStyle.opacity = this.finalTransform.mProp.o.v;
	      }
	    },
	    renderFrame: function renderFrame() {
	      // If it is exported as hidden (data.hd === true) no need to render
	      // If it is not visible no need to render
	      if (this.data.hd || this.hidden) {
	        return;
	      }
	
	      this.renderTransform();
	      this.renderRenderable();
	      this.renderElement();
	      this.renderInnerContent();
	
	      if (this._isFirstFrame) {
	        this._isFirstFrame = false;
	      }
	    },
	    destroy: function destroy() {
	      this.layerElement = null;
	      this.transformedElement = null;
	
	      if (this.matteElement) {
	        this.matteElement = null;
	      }
	
	      if (this.maskManager) {
	        this.maskManager.destroy();
	        this.maskManager = null;
	      }
	    },
	    createRenderableComponents: function createRenderableComponents() {
	      this.maskManager = new MaskElement(this.data, this, this.globalData);
	    },
	    addEffects: function addEffects() {},
	    setMatte: function setMatte() {}
	  };
	  HBaseElement.prototype.getBaseElement = SVGBaseElement.prototype.getBaseElement;
	  HBaseElement.prototype.destroyBaseElement = HBaseElement.prototype.destroy;
	  HBaseElement.prototype.buildElementParenting = BaseRenderer.prototype.buildElementParenting;
	
	  function HSolidElement(data, globalData, comp) {
	    this.initElement(data, globalData, comp);
	  }
	
	  extendPrototype([BaseElement, TransformElement, HBaseElement, HierarchyElement, FrameElement, RenderableDOMElement], HSolidElement);
	
	  HSolidElement.prototype.createContent = function () {
	    var rect;
	
	    if (this.data.hasMask) {
	      rect = createNS('rect');
	      rect.setAttribute('width', this.data.sw);
	      rect.setAttribute('height', this.data.sh);
	      rect.setAttribute('fill', this.data.sc);
	      this.svgElement.setAttribute('width', this.data.sw);
	      this.svgElement.setAttribute('height', this.data.sh);
	    } else {
	      rect = createTag('div');
	      rect.style.width = this.data.sw + 'px';
	      rect.style.height = this.data.sh + 'px';
	      rect.style.backgroundColor = this.data.sc;
	    }
	
	    this.layerElement.appendChild(rect);
	  };
	
	  function HShapeElement(data, globalData, comp) {
	    // List of drawable elements
	    this.shapes = []; // Full shape data
	
	    this.shapesData = data.shapes; // List of styles that will be applied to shapes
	
	    this.stylesList = []; // List of modifiers that will be applied to shapes
	
	    this.shapeModifiers = []; // List of items in shape tree
	
	    this.itemsData = []; // List of items in previous shape tree
	
	    this.processedElements = []; // List of animated components
	
	    this.animatedContents = [];
	    this.shapesContainer = createNS('g');
	    this.initElement(data, globalData, comp); // Moving any property that doesn't get too much access after initialization because of v8 way of handling more than 10 properties.
	    // List of elements that have been created
	
	    this.prevViewData = [];
	    this.currentBBox = {
	      x: 999999,
	      y: -999999,
	      h: 0,
	      w: 0
	    };
	  }
	
	  extendPrototype([BaseElement, TransformElement, HSolidElement, SVGShapeElement, HBaseElement, HierarchyElement, FrameElement, RenderableElement], HShapeElement);
	  HShapeElement.prototype._renderShapeFrame = HShapeElement.prototype.renderInnerContent;
	
	  HShapeElement.prototype.createContent = function () {
	    var cont;
	    this.baseElement.style.fontSize = 0;
	
	    if (this.data.hasMask) {
	      this.layerElement.appendChild(this.shapesContainer);
	      cont = this.svgElement;
	    } else {
	      cont = createNS('svg');
	      var size = this.comp.data ? this.comp.data : this.globalData.compSize;
	      cont.setAttribute('width', size.w);
	      cont.setAttribute('height', size.h);
	      cont.appendChild(this.shapesContainer);
	      this.layerElement.appendChild(cont);
	    }
	
	    this.searchShapes(this.shapesData, this.itemsData, this.prevViewData, this.shapesContainer, 0, [], true);
	    this.filterUniqueShapes();
	    this.shapeCont = cont;
	  };
	
	  HShapeElement.prototype.getTransformedPoint = function (transformers, point) {
	    var i;
	    var len = transformers.length;
	
	    for (i = 0; i < len; i += 1) {
	      point = transformers[i].mProps.v.applyToPointArray(point[0], point[1], 0);
	    }
	
	    return point;
	  };
	
	  HShapeElement.prototype.calculateShapeBoundingBox = function (item, boundingBox) {
	    var shape = item.sh.v;
	    var transformers = item.transformers;
	    var i;
	    var len = shape._length;
	    var vPoint;
	    var oPoint;
	    var nextIPoint;
	    var nextVPoint;
	
	    if (len <= 1) {
	      return;
	    }
	
	    for (i = 0; i < len - 1; i += 1) {
	      vPoint = this.getTransformedPoint(transformers, shape.v[i]);
	      oPoint = this.getTransformedPoint(transformers, shape.o[i]);
	      nextIPoint = this.getTransformedPoint(transformers, shape.i[i + 1]);
	      nextVPoint = this.getTransformedPoint(transformers, shape.v[i + 1]);
	      this.checkBounds(vPoint, oPoint, nextIPoint, nextVPoint, boundingBox);
	    }
	
	    if (shape.c) {
	      vPoint = this.getTransformedPoint(transformers, shape.v[i]);
	      oPoint = this.getTransformedPoint(transformers, shape.o[i]);
	      nextIPoint = this.getTransformedPoint(transformers, shape.i[0]);
	      nextVPoint = this.getTransformedPoint(transformers, shape.v[0]);
	      this.checkBounds(vPoint, oPoint, nextIPoint, nextVPoint, boundingBox);
	    }
	  };
	
	  HShapeElement.prototype.checkBounds = function (vPoint, oPoint, nextIPoint, nextVPoint, boundingBox) {
	    this.getBoundsOfCurve(vPoint, oPoint, nextIPoint, nextVPoint);
	    var bounds = this.shapeBoundingBox;
	    boundingBox.x = bmMin(bounds.left, boundingBox.x);
	    boundingBox.xMax = bmMax(bounds.right, boundingBox.xMax);
	    boundingBox.y = bmMin(bounds.top, boundingBox.y);
	    boundingBox.yMax = bmMax(bounds.bottom, boundingBox.yMax);
	  };
	
	  HShapeElement.prototype.shapeBoundingBox = {
	    left: 0,
	    right: 0,
	    top: 0,
	    bottom: 0
	  };
	  HShapeElement.prototype.tempBoundingBox = {
	    x: 0,
	    xMax: 0,
	    y: 0,
	    yMax: 0,
	    width: 0,
	    height: 0
	  };
	
	  HShapeElement.prototype.getBoundsOfCurve = function (p0, p1, p2, p3) {
	    var bounds = [[p0[0], p3[0]], [p0[1], p3[1]]];
	
	    for (var a, b, c, t, b2ac, t1, t2, i = 0; i < 2; ++i) {
	      // eslint-disable-line no-plusplus
	      b = 6 * p0[i] - 12 * p1[i] + 6 * p2[i];
	      a = -3 * p0[i] + 9 * p1[i] - 9 * p2[i] + 3 * p3[i];
	      c = 3 * p1[i] - 3 * p0[i];
	      b |= 0; // eslint-disable-line no-bitwise
	
	      a |= 0; // eslint-disable-line no-bitwise
	
	      c |= 0; // eslint-disable-line no-bitwise
	
	      if (a === 0 && b === 0) {//
	      } else if (a === 0) {
	        t = -c / b;
	
	        if (t > 0 && t < 1) {
	          bounds[i].push(this.calculateF(t, p0, p1, p2, p3, i));
	        }
	      } else {
	        b2ac = b * b - 4 * c * a;
	
	        if (b2ac >= 0) {
	          t1 = (-b + bmSqrt(b2ac)) / (2 * a);
	          if (t1 > 0 && t1 < 1) bounds[i].push(this.calculateF(t1, p0, p1, p2, p3, i));
	          t2 = (-b - bmSqrt(b2ac)) / (2 * a);
	          if (t2 > 0 && t2 < 1) bounds[i].push(this.calculateF(t2, p0, p1, p2, p3, i));
	        }
	      }
	    }
	
	    this.shapeBoundingBox.left = bmMin.apply(null, bounds[0]);
	    this.shapeBoundingBox.top = bmMin.apply(null, bounds[1]);
	    this.shapeBoundingBox.right = bmMax.apply(null, bounds[0]);
	    this.shapeBoundingBox.bottom = bmMax.apply(null, bounds[1]);
	  };
	
	  HShapeElement.prototype.calculateF = function (t, p0, p1, p2, p3, i) {
	    return bmPow(1 - t, 3) * p0[i] + 3 * bmPow(1 - t, 2) * t * p1[i] + 3 * (1 - t) * bmPow(t, 2) * p2[i] + bmPow(t, 3) * p3[i];
	  };
	
	  HShapeElement.prototype.calculateBoundingBox = function (itemsData, boundingBox) {
	    var i;
	    var len = itemsData.length;
	
	    for (i = 0; i < len; i += 1) {
	      if (itemsData[i] && itemsData[i].sh) {
	        this.calculateShapeBoundingBox(itemsData[i], boundingBox);
	      } else if (itemsData[i] && itemsData[i].it) {
	        this.calculateBoundingBox(itemsData[i].it, boundingBox);
	      } else if (itemsData[i] && itemsData[i].style && itemsData[i].w) {
	        this.expandStrokeBoundingBox(itemsData[i].w, boundingBox);
	      }
	    }
	  };
	
	  HShapeElement.prototype.expandStrokeBoundingBox = function (widthProperty, boundingBox) {
	    var width = 0;
	
	    if (widthProperty.keyframes) {
	      for (var i = 0; i < widthProperty.keyframes.length; i += 1) {
	        var kfw = widthProperty.keyframes[i].s;
	
	        if (kfw > width) {
	          width = kfw;
	        }
	      }
	
	      width *= widthProperty.mult;
	    } else {
	      width = widthProperty.v * widthProperty.mult;
	    }
	
	    boundingBox.x -= width;
	    boundingBox.xMax += width;
	    boundingBox.y -= width;
	    boundingBox.yMax += width;
	  };
	
	  HShapeElement.prototype.currentBoxContains = function (box) {
	    return this.currentBBox.x <= box.x && this.currentBBox.y <= box.y && this.currentBBox.width + this.currentBBox.x >= box.x + box.width && this.currentBBox.height + this.currentBBox.y >= box.y + box.height;
	  };
	
	  HShapeElement.prototype.renderInnerContent = function () {
	    this._renderShapeFrame();
	
	    if (!this.hidden && (this._isFirstFrame || this._mdf)) {
	      var tempBoundingBox = this.tempBoundingBox;
	      var max = 999999;
	      tempBoundingBox.x = max;
	      tempBoundingBox.xMax = -max;
	      tempBoundingBox.y = max;
	      tempBoundingBox.yMax = -max;
	      this.calculateBoundingBox(this.itemsData, tempBoundingBox);
	      tempBoundingBox.width = tempBoundingBox.xMax < tempBoundingBox.x ? 0 : tempBoundingBox.xMax - tempBoundingBox.x;
	      tempBoundingBox.height = tempBoundingBox.yMax < tempBoundingBox.y ? 0 : tempBoundingBox.yMax - tempBoundingBox.y; // var tempBoundingBox = this.shapeCont.getBBox();
	
	      if (this.currentBoxContains(tempBoundingBox)) {
	        return;
	      }
	
	      var changed = false;
	
	      if (this.currentBBox.w !== tempBoundingBox.width) {
	        this.currentBBox.w = tempBoundingBox.width;
	        this.shapeCont.setAttribute('width', tempBoundingBox.width);
	        changed = true;
	      }
	
	      if (this.currentBBox.h !== tempBoundingBox.height) {
	        this.currentBBox.h = tempBoundingBox.height;
	        this.shapeCont.setAttribute('height', tempBoundingBox.height);
	        changed = true;
	      }
	
	      if (changed || this.currentBBox.x !== tempBoundingBox.x || this.currentBBox.y !== tempBoundingBox.y) {
	        this.currentBBox.w = tempBoundingBox.width;
	        this.currentBBox.h = tempBoundingBox.height;
	        this.currentBBox.x = tempBoundingBox.x;
	        this.currentBBox.y = tempBoundingBox.y;
	        this.shapeCont.setAttribute('viewBox', this.currentBBox.x + ' ' + this.currentBBox.y + ' ' + this.currentBBox.w + ' ' + this.currentBBox.h);
	        var shapeStyle = this.shapeCont.style;
	        var shapeTransform = 'translate(' + this.currentBBox.x + 'px,' + this.currentBBox.y + 'px)';
	        shapeStyle.transform = shapeTransform;
	        shapeStyle.webkitTransform = shapeTransform;
	      }
	    }
	  };
	
	  function HTextElement(data, globalData, comp) {
	    this.textSpans = [];
	    this.textPaths = [];
	    this.currentBBox = {
	      x: 999999,
	      y: -999999,
	      h: 0,
	      w: 0
	    };
	    this.renderType = 'svg';
	    this.isMasked = false;
	    this.initElement(data, globalData, comp);
	  }
	
	  extendPrototype([BaseElement, TransformElement, HBaseElement, HierarchyElement, FrameElement, RenderableDOMElement, ITextElement], HTextElement);
	
	  HTextElement.prototype.createContent = function () {
	    this.isMasked = this.checkMasks();
	
	    if (this.isMasked) {
	      this.renderType = 'svg';
	      this.compW = this.comp.data.w;
	      this.compH = this.comp.data.h;
	      this.svgElement.setAttribute('width', this.compW);
	      this.svgElement.setAttribute('height', this.compH);
	      var g = createNS('g');
	      this.maskedElement.appendChild(g);
	      this.innerElem = g;
	    } else {
	      this.renderType = 'html';
	      this.innerElem = this.layerElement;
	    }
	
	    this.checkParenting();
	  };
	
	  HTextElement.prototype.buildNewText = function () {
	    var documentData = this.textProperty.currentData;
	    this.renderedLetters = createSizedArray(documentData.l ? documentData.l.length : 0);
	    var innerElemStyle = this.innerElem.style;
	    var textColor = documentData.fc ? this.buildColor(documentData.fc) : 'rgba(0,0,0,0)';
	    innerElemStyle.fill = textColor;
	    innerElemStyle.color = textColor;
	
	    if (documentData.sc) {
	      innerElemStyle.stroke = this.buildColor(documentData.sc);
	      innerElemStyle.strokeWidth = documentData.sw + 'px';
	    }
	
	    var fontData = this.globalData.fontManager.getFontByName(documentData.f);
	
	    if (!this.globalData.fontManager.chars) {
	      innerElemStyle.fontSize = documentData.finalSize + 'px';
	      innerElemStyle.lineHeight = documentData.finalSize + 'px';
	
	      if (fontData.fClass) {
	        this.innerElem.className = fontData.fClass;
	      } else {
	        innerElemStyle.fontFamily = fontData.fFamily;
	        var fWeight = documentData.fWeight;
	        var fStyle = documentData.fStyle;
	        innerElemStyle.fontStyle = fStyle;
	        innerElemStyle.fontWeight = fWeight;
	      }
	    }
	
	    var i;
	    var len;
	    var letters = documentData.l;
	    len = letters.length;
	    var tSpan;
	    var tParent;
	    var tCont;
	    var matrixHelper = this.mHelper;
	    var shapes;
	    var shapeStr = '';
	    var cnt = 0;
	
	    for (i = 0; i < len; i += 1) {
	      if (this.globalData.fontManager.chars) {
	        if (!this.textPaths[cnt]) {
	          tSpan = createNS('path');
	          tSpan.setAttribute('stroke-linecap', lineCapEnum[1]);
	          tSpan.setAttribute('stroke-linejoin', lineJoinEnum[2]);
	          tSpan.setAttribute('stroke-miterlimit', '4');
	        } else {
	          tSpan = this.textPaths[cnt];
	        }
	
	        if (!this.isMasked) {
	          if (this.textSpans[cnt]) {
	            tParent = this.textSpans[cnt];
	            tCont = tParent.children[0];
	          } else {
	            tParent = createTag('div');
	            tParent.style.lineHeight = 0;
	            tCont = createNS('svg');
	            tCont.appendChild(tSpan);
	            styleDiv(tParent);
	          }
	        }
	      } else if (!this.isMasked) {
	        if (this.textSpans[cnt]) {
	          tParent = this.textSpans[cnt];
	          tSpan = this.textPaths[cnt];
	        } else {
	          tParent = createTag('span');
	          styleDiv(tParent);
	          tSpan = createTag('span');
	          styleDiv(tSpan);
	          tParent.appendChild(tSpan);
	        }
	      } else {
	        tSpan = this.textPaths[cnt] ? this.textPaths[cnt] : createNS('text');
	      } // tSpan.setAttribute('visibility', 'hidden');
	
	
	      if (this.globalData.fontManager.chars) {
	        var charData = this.globalData.fontManager.getCharData(documentData.finalText[i], fontData.fStyle, this.globalData.fontManager.getFontByName(documentData.f).fFamily);
	        var shapeData;
	
	        if (charData) {
	          shapeData = charData.data;
	        } else {
	          shapeData = null;
	        }
	
	        matrixHelper.reset();
	
	        if (shapeData && shapeData.shapes && shapeData.shapes.length) {
	          shapes = shapeData.shapes[0].it;
	          matrixHelper.scale(documentData.finalSize / 100, documentData.finalSize / 100);
	          shapeStr = this.createPathShape(matrixHelper, shapes);
	          tSpan.setAttribute('d', shapeStr);
	        }
	
	        if (!this.isMasked) {
	          this.innerElem.appendChild(tParent);
	
	          if (shapeData && shapeData.shapes) {
	            // document.body.appendChild is needed to get exact measure of shape
	            document.body.appendChild(tCont);
	            var boundingBox = tCont.getBBox();
	            tCont.setAttribute('width', boundingBox.width + 2);
	            tCont.setAttribute('height', boundingBox.height + 2);
	            tCont.setAttribute('viewBox', boundingBox.x - 1 + ' ' + (boundingBox.y - 1) + ' ' + (boundingBox.width + 2) + ' ' + (boundingBox.height + 2));
	            var tContStyle = tCont.style;
	            var tContTranslation = 'translate(' + (boundingBox.x - 1) + 'px,' + (boundingBox.y - 1) + 'px)';
	            tContStyle.transform = tContTranslation;
	            tContStyle.webkitTransform = tContTranslation;
	            letters[i].yOffset = boundingBox.y - 1;
	          } else {
	            tCont.setAttribute('width', 1);
	            tCont.setAttribute('height', 1);
	          }
	
	          tParent.appendChild(tCont);
	        } else {
	          this.innerElem.appendChild(tSpan);
	        }
	      } else {
	        tSpan.textContent = letters[i].val;
	        tSpan.setAttributeNS('http://www.w3.org/XML/1998/namespace', 'xml:space', 'preserve');
	
	        if (!this.isMasked) {
	          this.innerElem.appendChild(tParent); //
	
	          var tStyle = tSpan.style;
	          var tSpanTranslation = 'translate3d(0,' + -documentData.finalSize / 1.2 + 'px,0)';
	          tStyle.transform = tSpanTranslation;
	          tStyle.webkitTransform = tSpanTranslation;
	        } else {
	          this.innerElem.appendChild(tSpan);
	        }
	      } //
	
	
	      if (!this.isMasked) {
	        this.textSpans[cnt] = tParent;
	      } else {
	        this.textSpans[cnt] = tSpan;
	      }
	
	      this.textSpans[cnt].style.display = 'block';
	      this.textPaths[cnt] = tSpan;
	      cnt += 1;
	    }
	
	    while (cnt < this.textSpans.length) {
	      this.textSpans[cnt].style.display = 'none';
	      cnt += 1;
	    }
	  };
	
	  HTextElement.prototype.renderInnerContent = function () {
	    this.validateText();
	    var svgStyle;
	
	    if (this.data.singleShape) {
	      if (!this._isFirstFrame && !this.lettersChangedFlag) {
	        return;
	      }
	
	      if (this.isMasked && this.finalTransform._matMdf) {
	        // Todo Benchmark if using this is better than getBBox
	        this.svgElement.setAttribute('viewBox', -this.finalTransform.mProp.p.v[0] + ' ' + -this.finalTransform.mProp.p.v[1] + ' ' + this.compW + ' ' + this.compH);
	        svgStyle = this.svgElement.style;
	        var translation = 'translate(' + -this.finalTransform.mProp.p.v[0] + 'px,' + -this.finalTransform.mProp.p.v[1] + 'px)';
	        svgStyle.transform = translation;
	        svgStyle.webkitTransform = translation;
	      }
	    }
	
	    this.textAnimator.getMeasures(this.textProperty.currentData, this.lettersChangedFlag);
	
	    if (!this.lettersChangedFlag && !this.textAnimator.lettersChangedFlag) {
	      return;
	    }
	
	    var i;
	    var len;
	    var count = 0;
	    var renderedLetters = this.textAnimator.renderedLetters;
	    var letters = this.textProperty.currentData.l;
	    len = letters.length;
	    var renderedLetter;
	    var textSpan;
	    var textPath;
	
	    for (i = 0; i < len; i += 1) {
	      if (letters[i].n) {
	        count += 1;
	      } else {
	        textSpan = this.textSpans[i];
	        textPath = this.textPaths[i];
	        renderedLetter = renderedLetters[count];
	        count += 1;
	
	        if (renderedLetter._mdf.m) {
	          if (!this.isMasked) {
	            textSpan.style.webkitTransform = renderedLetter.m;
	            textSpan.style.transform = renderedLetter.m;
	          } else {
	            textSpan.setAttribute('transform', renderedLetter.m);
	          }
	        } /// /textSpan.setAttribute('opacity',renderedLetter.o);
	
	
	        textSpan.style.opacity = renderedLetter.o;
	
	        if (renderedLetter.sw && renderedLetter._mdf.sw) {
	          textPath.setAttribute('stroke-width', renderedLetter.sw);
	        }
	
	        if (renderedLetter.sc && renderedLetter._mdf.sc) {
	          textPath.setAttribute('stroke', renderedLetter.sc);
	        }
	
	        if (renderedLetter.fc && renderedLetter._mdf.fc) {
	          textPath.setAttribute('fill', renderedLetter.fc);
	          textPath.style.color = renderedLetter.fc;
	        }
	      }
	    }
	
	    if (this.innerElem.getBBox && !this.hidden && (this._isFirstFrame || this._mdf)) {
	      var boundingBox = this.innerElem.getBBox();
	
	      if (this.currentBBox.w !== boundingBox.width) {
	        this.currentBBox.w = boundingBox.width;
	        this.svgElement.setAttribute('width', boundingBox.width);
	      }
	
	      if (this.currentBBox.h !== boundingBox.height) {
	        this.currentBBox.h = boundingBox.height;
	        this.svgElement.setAttribute('height', boundingBox.height);
	      }
	
	      var margin = 1;
	
	      if (this.currentBBox.w !== boundingBox.width + margin * 2 || this.currentBBox.h !== boundingBox.height + margin * 2 || this.currentBBox.x !== boundingBox.x - margin || this.currentBBox.y !== boundingBox.y - margin) {
	        this.currentBBox.w = boundingBox.width + margin * 2;
	        this.currentBBox.h = boundingBox.height + margin * 2;
	        this.currentBBox.x = boundingBox.x - margin;
	        this.currentBBox.y = boundingBox.y - margin;
	        this.svgElement.setAttribute('viewBox', this.currentBBox.x + ' ' + this.currentBBox.y + ' ' + this.currentBBox.w + ' ' + this.currentBBox.h);
	        svgStyle = this.svgElement.style;
	        var svgTransform = 'translate(' + this.currentBBox.x + 'px,' + this.currentBBox.y + 'px)';
	        svgStyle.transform = svgTransform;
	        svgStyle.webkitTransform = svgTransform;
	      }
	    }
	  };
	
	  function HCameraElement(data, globalData, comp) {
	    this.initFrame();
	    this.initBaseData(data, globalData, comp);
	    this.initHierarchy();
	    var getProp = PropertyFactory.getProp;
	    this.pe = getProp(this, data.pe, 0, 0, this);
	
	    if (data.ks.p.s) {
	      this.px = getProp(this, data.ks.p.x, 1, 0, this);
	      this.py = getProp(this, data.ks.p.y, 1, 0, this);
	      this.pz = getProp(this, data.ks.p.z, 1, 0, this);
	    } else {
	      this.p = getProp(this, data.ks.p, 1, 0, this);
	    }
	
	    if (data.ks.a) {
	      this.a = getProp(this, data.ks.a, 1, 0, this);
	    }
	
	    if (data.ks.or.k.length && data.ks.or.k[0].to) {
	      var i;
	      var len = data.ks.or.k.length;
	
	      for (i = 0; i < len; i += 1) {
	        data.ks.or.k[i].to = null;
	        data.ks.or.k[i].ti = null;
	      }
	    }
	
	    this.or = getProp(this, data.ks.or, 1, degToRads, this);
	    this.or.sh = true;
	    this.rx = getProp(this, data.ks.rx, 0, degToRads, this);
	    this.ry = getProp(this, data.ks.ry, 0, degToRads, this);
	    this.rz = getProp(this, data.ks.rz, 0, degToRads, this);
	    this.mat = new Matrix();
	    this._prevMat = new Matrix();
	    this._isFirstFrame = true; // TODO: find a better way to make the HCamera element to be compatible with the LayerInterface and TransformInterface.
	
	    this.finalTransform = {
	      mProp: this
	    };
	  }
	
	  extendPrototype([BaseElement, FrameElement, HierarchyElement], HCameraElement);
	
	  HCameraElement.prototype.setup = function () {
	    var i;
	    var len = this.comp.threeDElements.length;
	    var comp;
	    var perspectiveStyle;
	    var containerStyle;
	
	    for (i = 0; i < len; i += 1) {
	      // [perspectiveElem,container]
	      comp = this.comp.threeDElements[i];
	
	      if (comp.type === '3d') {
	        perspectiveStyle = comp.perspectiveElem.style;
	        containerStyle = comp.container.style;
	        var perspective = this.pe.v + 'px';
	        var origin = '0px 0px 0px';
	        var matrix = 'matrix3d(1,0,0,0,0,1,0,0,0,0,1,0,0,0,0,1)';
	        perspectiveStyle.perspective = perspective;
	        perspectiveStyle.webkitPerspective = perspective;
	        containerStyle.transformOrigin = origin;
	        containerStyle.mozTransformOrigin = origin;
	        containerStyle.webkitTransformOrigin = origin;
	        perspectiveStyle.transform = matrix;
	        perspectiveStyle.webkitTransform = matrix;
	      }
	    }
	  };
	
	  HCameraElement.prototype.createElements = function () {};
	
	  HCameraElement.prototype.hide = function () {};
	
	  HCameraElement.prototype.renderFrame = function () {
	    var _mdf = this._isFirstFrame;
	    var i;
	    var len;
	
	    if (this.hierarchy) {
	      len = this.hierarchy.length;
	
	      for (i = 0; i < len; i += 1) {
	        _mdf = this.hierarchy[i].finalTransform.mProp._mdf || _mdf;
	      }
	    }
	
	    if (_mdf || this.pe._mdf || this.p && this.p._mdf || this.px && (this.px._mdf || this.py._mdf || this.pz._mdf) || this.rx._mdf || this.ry._mdf || this.rz._mdf || this.or._mdf || this.a && this.a._mdf) {
	      this.mat.reset();
	
	      if (this.hierarchy) {
	        len = this.hierarchy.length - 1;
	
	        for (i = len; i >= 0; i -= 1) {
	          var mTransf = this.hierarchy[i].finalTransform.mProp;
	          this.mat.translate(-mTransf.p.v[0], -mTransf.p.v[1], mTransf.p.v[2]);
	          this.mat.rotateX(-mTransf.or.v[0]).rotateY(-mTransf.or.v[1]).rotateZ(mTransf.or.v[2]);
	          this.mat.rotateX(-mTransf.rx.v).rotateY(-mTransf.ry.v).rotateZ(mTransf.rz.v);
	          this.mat.scale(1 / mTransf.s.v[0], 1 / mTransf.s.v[1], 1 / mTransf.s.v[2]);
	          this.mat.translate(mTransf.a.v[0], mTransf.a.v[1], mTransf.a.v[2]);
	        }
	      }
	
	      if (this.p) {
	        this.mat.translate(-this.p.v[0], -this.p.v[1], this.p.v[2]);
	      } else {
	        this.mat.translate(-this.px.v, -this.py.v, this.pz.v);
	      }
	
	      if (this.a) {
	        var diffVector;
	
	        if (this.p) {
	          diffVector = [this.p.v[0] - this.a.v[0], this.p.v[1] - this.a.v[1], this.p.v[2] - this.a.v[2]];
	        } else {
	          diffVector = [this.px.v - this.a.v[0], this.py.v - this.a.v[1], this.pz.v - this.a.v[2]];
	        }
	
	        var mag = Math.sqrt(Math.pow(diffVector[0], 2) + Math.pow(diffVector[1], 2) + Math.pow(diffVector[2], 2)); // var lookDir = getNormalizedPoint(getDiffVector(this.a.v,this.p.v));
	
	        var lookDir = [diffVector[0] / mag, diffVector[1] / mag, diffVector[2] / mag];
	        var lookLengthOnXZ = Math.sqrt(lookDir[2] * lookDir[2] + lookDir[0] * lookDir[0]);
	        var mRotationX = Math.atan2(lookDir[1], lookLengthOnXZ);
	        var mRotationY = Math.atan2(lookDir[0], -lookDir[2]);
	        this.mat.rotateY(mRotationY).rotateX(-mRotationX);
	      }
	
	      this.mat.rotateX(-this.rx.v).rotateY(-this.ry.v).rotateZ(this.rz.v);
	      this.mat.rotateX(-this.or.v[0]).rotateY(-this.or.v[1]).rotateZ(this.or.v[2]);
	      this.mat.translate(this.globalData.compSize.w / 2, this.globalData.compSize.h / 2, 0);
	      this.mat.translate(0, 0, this.pe.v);
	      var hasMatrixChanged = !this._prevMat.equals(this.mat);
	
	      if ((hasMatrixChanged || this.pe._mdf) && this.comp.threeDElements) {
	        len = this.comp.threeDElements.length;
	        var comp;
	        var perspectiveStyle;
	        var containerStyle;
	
	        for (i = 0; i < len; i += 1) {
	          comp = this.comp.threeDElements[i];
	
	          if (comp.type === '3d') {
	            if (hasMatrixChanged) {
	              var matValue = this.mat.toCSS();
	              containerStyle = comp.container.style;
	              containerStyle.transform = matValue;
	              containerStyle.webkitTransform = matValue;
	            }
	
	            if (this.pe._mdf) {
	              perspectiveStyle = comp.perspectiveElem.style;
	              perspectiveStyle.perspective = this.pe.v + 'px';
	              perspectiveStyle.webkitPerspective = this.pe.v + 'px';
	            }
	          }
	        }
	
	        this.mat.clone(this._prevMat);
	      }
	    }
	
	    this._isFirstFrame = false;
	  };
	
	  HCameraElement.prototype.prepareFrame = function (num) {
	    this.prepareProperties(num, true);
	  };
	
	  HCameraElement.prototype.destroy = function () {};
	
	  HCameraElement.prototype.getBaseElement = function () {
	    return null;
	  };
	
	  function HImageElement(data, globalData, comp) {
	    this.assetData = globalData.getAssetData(data.refId);
	    this.initElement(data, globalData, comp);
	  }
	
	  extendPrototype([BaseElement, TransformElement, HBaseElement, HSolidElement, HierarchyElement, FrameElement, RenderableElement], HImageElement);
	
	  HImageElement.prototype.createContent = function () {
	    var assetPath = this.globalData.getAssetsPath(this.assetData);
	    var img = new Image();
	
	    if (this.data.hasMask) {
	      this.imageElem = createNS('image');
	      this.imageElem.setAttribute('width', this.assetData.w + 'px');
	      this.imageElem.setAttribute('height', this.assetData.h + 'px');
	      this.imageElem.setAttributeNS('http://www.w3.org/1999/xlink', 'href', assetPath);
	      this.layerElement.appendChild(this.imageElem);
	      this.baseElement.setAttribute('width', this.assetData.w);
	      this.baseElement.setAttribute('height', this.assetData.h);
	    } else {
	      this.layerElement.appendChild(img);
	    }
	
	    img.crossOrigin = 'anonymous';
	    img.src = assetPath;
	
	    if (this.data.ln) {
	      this.baseElement.setAttribute('id', this.data.ln);
	    }
	  };
	
	  function HybridRendererBase(animationItem, config) {
	    this.animationItem = animationItem;
	    this.layers = null;
	    this.renderedFrame = -1;
	    this.renderConfig = {
	      className: config && config.className || '',
	      imagePreserveAspectRatio: config && config.imagePreserveAspectRatio || 'xMidYMid slice',
	      hideOnTransparent: !(config && config.hideOnTransparent === false),
	      filterSize: {
	        width: config && config.filterSize && config.filterSize.width || '400%',
	        height: config && config.filterSize && config.filterSize.height || '400%',
	        x: config && config.filterSize && config.filterSize.x || '-100%',
	        y: config && config.filterSize && config.filterSize.y || '-100%'
	      }
	    };
	    this.globalData = {
	      _mdf: false,
	      frameNum: -1,
	      renderConfig: this.renderConfig
	    };
	    this.pendingElements = [];
	    this.elements = [];
	    this.threeDElements = [];
	    this.destroyed = false;
	    this.camera = null;
	    this.supports3d = true;
	    this.rendererType = 'html';
	  }
	
	  extendPrototype([BaseRenderer], HybridRendererBase);
	  HybridRendererBase.prototype.buildItem = SVGRenderer.prototype.buildItem;
	
	  HybridRendererBase.prototype.checkPendingElements = function () {
	    while (this.pendingElements.length) {
	      var element = this.pendingElements.pop();
	      element.checkParenting();
	    }
	  };
	
	  HybridRendererBase.prototype.appendElementInPos = function (element, pos) {
	    var newDOMElement = element.getBaseElement();
	
	    if (!newDOMElement) {
	      return;
	    }
	
	    var layer = this.layers[pos];
	
	    if (!layer.ddd || !this.supports3d) {
	      if (this.threeDElements) {
	        this.addTo3dContainer(newDOMElement, pos);
	      } else {
	        var i = 0;
	        var nextDOMElement;
	        var nextLayer;
	        var tmpDOMElement;
	
	        while (i < pos) {
	          if (this.elements[i] && this.elements[i] !== true && this.elements[i].getBaseElement) {
	            nextLayer = this.elements[i];
	            tmpDOMElement = this.layers[i].ddd ? this.getThreeDContainerByPos(i) : nextLayer.getBaseElement();
	            nextDOMElement = tmpDOMElement || nextDOMElement;
	          }
	
	          i += 1;
	        }
	
	        if (nextDOMElement) {
	          if (!layer.ddd || !this.supports3d) {
	            this.layerElement.insertBefore(newDOMElement, nextDOMElement);
	          }
	        } else if (!layer.ddd || !this.supports3d) {
	          this.layerElement.appendChild(newDOMElement);
	        }
	      }
	    } else {
	      this.addTo3dContainer(newDOMElement, pos);
	    }
	  };
	
	  HybridRendererBase.prototype.createShape = function (data) {
	    if (!this.supports3d) {
	      return new SVGShapeElement(data, this.globalData, this);
	    }
	
	    return new HShapeElement(data, this.globalData, this);
	  };
	
	  HybridRendererBase.prototype.createText = function (data) {
	    if (!this.supports3d) {
	      return new SVGTextLottieElement(data, this.globalData, this);
	    }
	
	    return new HTextElement(data, this.globalData, this);
	  };
	
	  HybridRendererBase.prototype.createCamera = function (data) {
	    this.camera = new HCameraElement(data, this.globalData, this);
	    return this.camera;
	  };
	
	  HybridRendererBase.prototype.createImage = function (data) {
	    if (!this.supports3d) {
	      return new IImageElement(data, this.globalData, this);
	    }
	
	    return new HImageElement(data, this.globalData, this);
	  };
	
	  HybridRendererBase.prototype.createSolid = function (data) {
	    if (!this.supports3d) {
	      return new ISolidElement(data, this.globalData, this);
	    }
	
	    return new HSolidElement(data, this.globalData, this);
	  };
	
	  HybridRendererBase.prototype.createNull = SVGRenderer.prototype.createNull;
	
	  HybridRendererBase.prototype.getThreeDContainerByPos = function (pos) {
	    var i = 0;
	    var len = this.threeDElements.length;
	
	    while (i < len) {
	      if (this.threeDElements[i].startPos <= pos && this.threeDElements[i].endPos >= pos) {
	        return this.threeDElements[i].perspectiveElem;
	      }
	
	      i += 1;
	    }
	
	    return null;
	  };
	
	  HybridRendererBase.prototype.createThreeDContainer = function (pos, type) {
	    var perspectiveElem = createTag('div');
	    var style;
	    var containerStyle;
	    styleDiv(perspectiveElem);
	    var container = createTag('div');
	    styleDiv(container);
	
	    if (type === '3d') {
	      style = perspectiveElem.style;
	      style.width = this.globalData.compSize.w + 'px';
	      style.height = this.globalData.compSize.h + 'px';
	      var center = '50% 50%';
	      style.webkitTransformOrigin = center;
	      style.mozTransformOrigin = center;
	      style.transformOrigin = center;
	      containerStyle = container.style;
	      var matrix = 'matrix3d(1,0,0,0,0,1,0,0,0,0,1,0,0,0,0,1)';
	      containerStyle.transform = matrix;
	      containerStyle.webkitTransform = matrix;
	    }
	
	    perspectiveElem.appendChild(container); // this.resizerElem.appendChild(perspectiveElem);
	
	    var threeDContainerData = {
	      container: container,
	      perspectiveElem: perspectiveElem,
	      startPos: pos,
	      endPos: pos,
	      type: type
	    };
	    this.threeDElements.push(threeDContainerData);
	    return threeDContainerData;
	  };
	
	  HybridRendererBase.prototype.build3dContainers = function () {
	    var i;
	    var len = this.layers.length;
	    var lastThreeDContainerData;
	    var currentContainer = '';
	
	    for (i = 0; i < len; i += 1) {
	      if (this.layers[i].ddd && this.layers[i].ty !== 3) {
	        if (currentContainer !== '3d') {
	          currentContainer = '3d';
	          lastThreeDContainerData = this.createThreeDContainer(i, '3d');
	        }
	
	        lastThreeDContainerData.endPos = Math.max(lastThreeDContainerData.endPos, i);
	      } else {
	        if (currentContainer !== '2d') {
	          currentContainer = '2d';
	          lastThreeDContainerData = this.createThreeDContainer(i, '2d');
	        }
	
	        lastThreeDContainerData.endPos = Math.max(lastThreeDContainerData.endPos, i);
	      }
	    }
	
	    len = this.threeDElements.length;
	
	    for (i = len - 1; i >= 0; i -= 1) {
	      this.resizerElem.appendChild(this.threeDElements[i].perspectiveElem);
	    }
	  };
	
	  HybridRendererBase.prototype.addTo3dContainer = function (elem, pos) {
	    var i = 0;
	    var len = this.threeDElements.length;
	
	    while (i < len) {
	      if (pos <= this.threeDElements[i].endPos) {
	        var j = this.threeDElements[i].startPos;
	        var nextElement;
	
	        while (j < pos) {
	          if (this.elements[j] && this.elements[j].getBaseElement) {
	            nextElement = this.elements[j].getBaseElement();
	          }
	
	          j += 1;
	        }
	
	        if (nextElement) {
	          this.threeDElements[i].container.insertBefore(elem, nextElement);
	        } else {
	          this.threeDElements[i].container.appendChild(elem);
	        }
	
	        break;
	      }
	
	      i += 1;
	    }
	  };
	
	  HybridRendererBase.prototype.configAnimation = function (animData) {
	    var resizerElem = createTag('div');
	    var wrapper = this.animationItem.wrapper;
	    var style = resizerElem.style;
	    style.width = animData.w + 'px';
	    style.height = animData.h + 'px';
	    this.resizerElem = resizerElem;
	    styleDiv(resizerElem);
	    style.transformStyle = 'flat';
	    style.mozTransformStyle = 'flat';
	    style.webkitTransformStyle = 'flat';
	
	    if (this.renderConfig.className) {
	      resizerElem.setAttribute('class', this.renderConfig.className);
	    }
	
	    wrapper.appendChild(resizerElem);
	    style.overflow = 'hidden';
	    var svg = createNS('svg');
	    svg.setAttribute('width', '1');
	    svg.setAttribute('height', '1');
	    styleDiv(svg);
	    this.resizerElem.appendChild(svg);
	    var defs = createNS('defs');
	    svg.appendChild(defs);
	    this.data = animData; // Mask animation
	
	    this.setupGlobalData(animData, svg);
	    this.globalData.defs = defs;
	    this.layers = animData.layers;
	    this.layerElement = this.resizerElem;
	    this.build3dContainers();
	    this.updateContainerSize();
	  };
	
	  HybridRendererBase.prototype.destroy = function () {
	    if (this.animationItem.wrapper) {
	      this.animationItem.wrapper.innerText = '';
	    }
	
	    this.animationItem.container = null;
	    this.globalData.defs = null;
	    var i;
	    var len = this.layers ? this.layers.length : 0;
	
	    for (i = 0; i < len; i += 1) {
	      if (this.elements[i] && this.elements[i].destroy) {
	        this.elements[i].destroy();
	      }
	    }
	
	    this.elements.length = 0;
	    this.destroyed = true;
	    this.animationItem = null;
	  };
	
	  HybridRendererBase.prototype.updateContainerSize = function () {
	    var elementWidth = this.animationItem.wrapper.offsetWidth;
	    var elementHeight = this.animationItem.wrapper.offsetHeight;
	    var elementRel = elementWidth / elementHeight;
	    var animationRel = this.globalData.compSize.w / this.globalData.compSize.h;
	    var sx;
	    var sy;
	    var tx;
	    var ty;
	
	    if (animationRel > elementRel) {
	      sx = elementWidth / this.globalData.compSize.w;
	      sy = elementWidth / this.globalData.compSize.w;
	      tx = 0;
	      ty = (elementHeight - this.globalData.compSize.h * (elementWidth / this.globalData.compSize.w)) / 2;
	    } else {
	      sx = elementHeight / this.globalData.compSize.h;
	      sy = elementHeight / this.globalData.compSize.h;
	      tx = (elementWidth - this.globalData.compSize.w * (elementHeight / this.globalData.compSize.h)) / 2;
	      ty = 0;
	    }
	
	    var style = this.resizerElem.style;
	    style.webkitTransform = 'matrix3d(' + sx + ',0,0,0,0,' + sy + ',0,0,0,0,1,0,' + tx + ',' + ty + ',0,1)';
	    style.transform = style.webkitTransform;
	  };
	
	  HybridRendererBase.prototype.renderFrame = SVGRenderer.prototype.renderFrame;
	
	  HybridRendererBase.prototype.hide = function () {
	    this.resizerElem.style.display = 'none';
	  };
	
	  HybridRendererBase.prototype.show = function () {
	    this.resizerElem.style.display = 'block';
	  };
	
	  HybridRendererBase.prototype.initItems = function () {
	    this.buildAllItems();
	
	    if (this.camera) {
	      this.camera.setup();
	    } else {
	      var cWidth = this.globalData.compSize.w;
	      var cHeight = this.globalData.compSize.h;
	      var i;
	      var len = this.threeDElements.length;
	
	      for (i = 0; i < len; i += 1) {
	        var style = this.threeDElements[i].perspectiveElem.style;
	        style.webkitPerspective = Math.sqrt(Math.pow(cWidth, 2) + Math.pow(cHeight, 2)) + 'px';
	        style.perspective = style.webkitPerspective;
	      }
	    }
	  };
	
	  HybridRendererBase.prototype.searchExtraCompositions = function (assets) {
	    var i;
	    var len = assets.length;
	    var floatingContainer = createTag('div');
	
	    for (i = 0; i < len; i += 1) {
	      if (assets[i].xt) {
	        var comp = this.createComp(assets[i], floatingContainer, this.globalData.comp, null);
	        comp.initExpressions();
	        this.globalData.projectInterface.registerComposition(comp);
	      }
	    }
	  };
	
	  function HCompElement(data, globalData, comp) {
	    this.layers = data.layers;
	    this.supports3d = !data.hasMask;
	    this.completeLayers = false;
	    this.pendingElements = [];
	    this.elements = this.layers ? createSizedArray(this.layers.length) : [];
	    this.initElement(data, globalData, comp);
	    this.tm = data.tm ? PropertyFactory.getProp(this, data.tm, 0, globalData.frameRate, this) : {
	      _placeholder: true
	    };
	  }
	
	  extendPrototype([HybridRendererBase, ICompElement, HBaseElement], HCompElement);
	  HCompElement.prototype._createBaseContainerElements = HCompElement.prototype.createContainerElements;
	
	  HCompElement.prototype.createContainerElements = function () {
	    this._createBaseContainerElements(); // divElement.style.clip = 'rect(0px, '+this.data.w+'px, '+this.data.h+'px, 0px)';
	
	
	    if (this.data.hasMask) {
	      this.svgElement.setAttribute('width', this.data.w);
	      this.svgElement.setAttribute('height', this.data.h);
	      this.transformedElement = this.baseElement;
	    } else {
	      this.transformedElement = this.layerElement;
	    }
	  };
	
	  HCompElement.prototype.addTo3dContainer = function (elem, pos) {
	    var j = 0;
	    var nextElement;
	
	    while (j < pos) {
	      if (this.elements[j] && this.elements[j].getBaseElement) {
	        nextElement = this.elements[j].getBaseElement();
	      }
	
	      j += 1;
	    }
	
	    if (nextElement) {
	      this.layerElement.insertBefore(elem, nextElement);
	    } else {
	      this.layerElement.appendChild(elem);
	    }
	  };
	
	  HCompElement.prototype.createComp = function (data) {
	    if (!this.supports3d) {
	      return new SVGCompElement(data, this.globalData, this);
	    }
	
	    return new HCompElement(data, this.globalData, this);
	  };
	
	  function HybridRenderer(animationItem, config) {
	    this.animationItem = animationItem;
	    this.layers = null;
	    this.renderedFrame = -1;
	    this.renderConfig = {
	      className: config && config.className || '',
	      imagePreserveAspectRatio: config && config.imagePreserveAspectRatio || 'xMidYMid slice',
	      hideOnTransparent: !(config && config.hideOnTransparent === false),
	      filterSize: {
	        width: config && config.filterSize && config.filterSize.width || '400%',
	        height: config && config.filterSize && config.filterSize.height || '400%',
	        x: config && config.filterSize && config.filterSize.x || '-100%',
	        y: config && config.filterSize && config.filterSize.y || '-100%'
	      },
	      runExpressions: !config || config.runExpressions === undefined || config.runExpressions
	    };
	    this.globalData = {
	      _mdf: false,
	      frameNum: -1,
	      renderConfig: this.renderConfig
	    };
	    this.pendingElements = [];
	    this.elements = [];
	    this.threeDElements = [];
	    this.destroyed = false;
	    this.camera = null;
	    this.supports3d = true;
	    this.rendererType = 'html';
	  }
	
	  extendPrototype([HybridRendererBase], HybridRenderer);
	
	  HybridRenderer.prototype.createComp = function (data) {
	    if (!this.supports3d) {
	      return new SVGCompElement(data, this.globalData, this);
	    }
	
	    return new HCompElement(data, this.globalData, this);
	  };
	
	  var CompExpressionInterface = function () {
	    return function (comp) {
	      function _thisLayerFunction(name) {
	        var i = 0;
	        var len = comp.layers.length;
	
	        while (i < len) {
	          if (comp.layers[i].nm === name || comp.layers[i].ind === name) {
	            return comp.elements[i].layerInterface;
	          }
	
	          i += 1;
	        }
	
	        return null; // return {active:false};
	      }
	
	      Object.defineProperty(_thisLayerFunction, '_name', {
	        value: comp.data.nm
	      });
	      _thisLayerFunction.layer = _thisLayerFunction;
	      _thisLayerFunction.pixelAspect = 1;
	      _thisLayerFunction.height = comp.data.h || comp.globalData.compSize.h;
	      _thisLayerFunction.width = comp.data.w || comp.globalData.compSize.w;
	      _thisLayerFunction.pixelAspect = 1;
	      _thisLayerFunction.frameDuration = 1 / comp.globalData.frameRate;
	      _thisLayerFunction.displayStartTime = 0;
	      _thisLayerFunction.numLayers = comp.layers.length;
	      return _thisLayerFunction;
	    };
	  }();
	
	  function _typeof$2(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof$2 = function _typeof(obj) { return typeof obj; }; } else { _typeof$2 = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof$2(obj); }
	
	  /* eslint-disable */
	
	  /*
	   Copyright 2014 David Bau.
	
	   Permission is hereby granted, free of charge, to any person obtaining
	   a copy of this software and associated documentation files (the
	   "Software"), to deal in the Software without restriction, including
	   without limitation the rights to use, copy, modify, merge, publish,
	   distribute, sublicense, and/or sell copies of the Software, and to
	   permit persons to whom the Software is furnished to do so, subject to
	   the following conditions:
	
	   The above copyright notice and this permission notice shall be
	   included in all copies or substantial portions of the Software.
	
	   THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND,
	   EXPRESS OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
	   MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT.
	   IN NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY
	   CLAIM, DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT,
	   TORT OR OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE
	   SOFTWARE OR THE USE OR OTHER DEALINGS IN THE SOFTWARE.
	
	   */
	  function seedRandom(pool, math) {
	    //
	    // The following constants are related to IEEE 754 limits.
	    //
	    var global = this,
	        width = 256,
	        // each RC4 output is 0 <= x < 256
	    chunks = 6,
	        // at least six RC4 outputs for each double
	    digits = 52,
	        // there are 52 significant digits in a double
	    rngname = 'random',
	        // rngname: name for Math.random and Math.seedrandom
	    startdenom = math.pow(width, chunks),
	        significance = math.pow(2, digits),
	        overflow = significance * 2,
	        mask = width - 1,
	        nodecrypto; // node.js crypto module, initialized at the bottom.
	    //
	    // seedrandom()
	    // This is the seedrandom function described above.
	    //
	
	    function seedrandom(seed, options, callback) {
	      var key = [];
	      options = options === true ? {
	        entropy: true
	      } : options || {}; // Flatten the seed string or build one from local entropy if needed.
	
	      var shortseed = mixkey(flatten(options.entropy ? [seed, tostring(pool)] : seed === null ? autoseed() : seed, 3), key); // Use the seed to initialize an ARC4 generator.
	
	      var arc4 = new ARC4(key); // This function returns a random double in [0, 1) that contains
	      // randomness in every bit of the mantissa of the IEEE 754 value.
	
	      var prng = function prng() {
	        var n = arc4.g(chunks),
	            // Start with a numerator n < 2 ^ 48
	        d = startdenom,
	            //   and denominator d = 2 ^ 48.
	        x = 0; //   and no 'extra last byte'.
	
	        while (n < significance) {
	          // Fill up all significant digits by
	          n = (n + x) * width; //   shifting numerator and
	
	          d *= width; //   denominator and generating a
	
	          x = arc4.g(1); //   new least-significant-byte.
	        }
	
	        while (n >= overflow) {
	          // To avoid rounding up, before adding
	          n /= 2; //   last byte, shift everything
	
	          d /= 2; //   right using integer math until
	
	          x >>>= 1; //   we have exactly the desired bits.
	        }
	
	        return (n + x) / d; // Form the number within [0, 1).
	      };
	
	      prng.int32 = function () {
	        return arc4.g(4) | 0;
	      };
	
	      prng.quick = function () {
	        return arc4.g(4) / 0x100000000;
	      };
	
	      prng["double"] = prng; // Mix the randomness into accumulated entropy.
	
	      mixkey(tostring(arc4.S), pool); // Calling convention: what to return as a function of prng, seed, is_math.
	
	      return (options.pass || callback || function (prng, seed, is_math_call, state) {
	        if (state) {
	          // Load the arc4 state from the given state if it has an S array.
	          if (state.S) {
	            copy(state, arc4);
	          } // Only provide the .state method if requested via options.state.
	
	
	          prng.state = function () {
	            return copy(arc4, {});
	          };
	        } // If called as a method of Math (Math.seedrandom()), mutate
	        // Math.random because that is how seedrandom.js has worked since v1.0.
	
	
	        if (is_math_call) {
	          math[rngname] = prng;
	          return seed;
	        } // Otherwise, it is a newer calling convention, so return the
	        // prng directly.
	        else return prng;
	      })(prng, shortseed, 'global' in options ? options.global : this == math, options.state);
	    }
	
	    math['seed' + rngname] = seedrandom; //
	    // ARC4
	    //
	    // An ARC4 implementation.  The constructor takes a key in the form of
	    // an array of at most (width) integers that should be 0 <= x < (width).
	    //
	    // The g(count) method returns a pseudorandom integer that concatenates
	    // the next (count) outputs from ARC4.  Its return value is a number x
	    // that is in the range 0 <= x < (width ^ count).
	    //
	
	    function ARC4(key) {
	      var t,
	          keylen = key.length,
	          me = this,
	          i = 0,
	          j = me.i = me.j = 0,
	          s = me.S = []; // The empty key [] is treated as [0].
	
	      if (!keylen) {
	        key = [keylen++];
	      } // Set up S using the standard key scheduling algorithm.
	
	
	      while (i < width) {
	        s[i] = i++;
	      }
	
	      for (i = 0; i < width; i++) {
	        s[i] = s[j = mask & j + key[i % keylen] + (t = s[i])];
	        s[j] = t;
	      } // The "g" method returns the next (count) outputs as one number.
	
	
	      me.g = function (count) {
	        // Using instance members instead of closure state nearly doubles speed.
	        var t,
	            r = 0,
	            i = me.i,
	            j = me.j,
	            s = me.S;
	
	        while (count--) {
	          t = s[i = mask & i + 1];
	          r = r * width + s[mask & (s[i] = s[j = mask & j + t]) + (s[j] = t)];
	        }
	
	        me.i = i;
	        me.j = j;
	        return r; // For robust unpredictability, the function call below automatically
	        // discards an initial batch of values.  This is called RC4-drop[256].
	        // See http://google.com/search?q=rsa+fluhrer+response&btnI
	      };
	    } //
	    // copy()
	    // Copies internal state of ARC4 to or from a plain object.
	    //
	
	
	    function copy(f, t) {
	      t.i = f.i;
	      t.j = f.j;
	      t.S = f.S.slice();
	      return t;
	    } //
	    // flatten()
	    // Converts an object tree to nested arrays of strings.
	    //
	
	
	    function flatten(obj, depth) {
	      var result = [],
	          typ = _typeof$2(obj),
	          prop;
	
	      if (depth && typ == 'object') {
	        for (prop in obj) {
	          try {
	            result.push(flatten(obj[prop], depth - 1));
	          } catch (e) {}
	        }
	      }
	
	      return result.length ? result : typ == 'string' ? obj : obj + '\0';
	    } //
	    // mixkey()
	    // Mixes a string seed into a key that is an array of integers, and
	    // returns a shortened string seed that is equivalent to the result key.
	    //
	
	
	    function mixkey(seed, key) {
	      var stringseed = seed + '',
	          smear,
	          j = 0;
	
	      while (j < stringseed.length) {
	        key[mask & j] = mask & (smear ^= key[mask & j] * 19) + stringseed.charCodeAt(j++);
	      }
	
	      return tostring(key);
	    } //
	    // autoseed()
	    // Returns an object for autoseeding, using window.crypto and Node crypto
	    // module if available.
	    //
	
	
	    function autoseed() {
	      try {
	        if (nodecrypto) {
	          return tostring(nodecrypto.randomBytes(width));
	        }
	
	        var out = new Uint8Array(width);
	        (global.crypto || global.msCrypto).getRandomValues(out);
	        return tostring(out);
	      } catch (e) {
	        var browser = global.navigator,
	            plugins = browser && browser.plugins;
	        return [+new Date(), global, plugins, global.screen, tostring(pool)];
	      }
	    } //
	    // tostring()
	    // Converts an array of charcodes to a string
	    //
	
	
	    function tostring(a) {
	      return String.fromCharCode.apply(0, a);
	    } //
	    // When seedrandom.js is loaded, we immediately mix a few bits
	    // from the built-in RNG into the entropy pool.  Because we do
	    // not want to interfere with deterministic PRNG state later,
	    // seedrandom will not call math.random on its own again after
	    // initialization.
	    //
	
	
	    mixkey(math.random(), pool); //
	    // Nodejs and AMD support: export the implementation as a module using
	    // either convention.
	    //
	    // End anonymous scope, and pass initial values.
	  }
	
	  ;
	
	  function initialize$2(BMMath) {
	    seedRandom([], BMMath);
	  }
	
	  var propTypes = {
	    SHAPE: 'shape'
	  };
	
	  function _typeof$1(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof$1 = function _typeof(obj) { return typeof obj; }; } else { _typeof$1 = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof$1(obj); }
	
	  var ExpressionManager = function () {
	    'use strict';
	
	    var ob = {};
	    var Math = BMMath;
	    var window = null;
	    var document = null;
	    var XMLHttpRequest = null;
	    var fetch = null;
	    var frames = null;
	    var _lottieGlobal = {};
	    initialize$2(BMMath);
	
	    function resetFrame() {
	      _lottieGlobal = {};
	    }
	
	    function $bm_isInstanceOfArray(arr) {
	      return arr.constructor === Array || arr.constructor === Float32Array;
	    }
	
	    function isNumerable(tOfV, v) {
	      return tOfV === 'number' || v instanceof Number || tOfV === 'boolean' || tOfV === 'string';
	    }
	
	    function $bm_neg(a) {
	      var tOfA = _typeof$1(a);
	
	      if (tOfA === 'number' || a instanceof Number || tOfA === 'boolean') {
	        return -a;
	      }
	
	      if ($bm_isInstanceOfArray(a)) {
	        var i;
	        var lenA = a.length;
	        var retArr = [];
	
	        for (i = 0; i < lenA; i += 1) {
	          retArr[i] = -a[i];
	        }
	
	        return retArr;
	      }
	
	      if (a.propType) {
	        return a.v;
	      }
	
	      return -a;
	    }
	
	    var easeInBez = BezierFactory.getBezierEasing(0.333, 0, 0.833, 0.833, 'easeIn').get;
	    var easeOutBez = BezierFactory.getBezierEasing(0.167, 0.167, 0.667, 1, 'easeOut').get;
	    var easeInOutBez = BezierFactory.getBezierEasing(0.33, 0, 0.667, 1, 'easeInOut').get;
	
	    function sum(a, b) {
	      var tOfA = _typeof$1(a);
	
	      var tOfB = _typeof$1(b);
	
	      if (isNumerable(tOfA, a) && isNumerable(tOfB, b) || tOfA === 'string' || tOfB === 'string') {
	        return a + b;
	      }
	
	      if ($bm_isInstanceOfArray(a) && isNumerable(tOfB, b)) {
	        a = a.slice(0);
	        a[0] += b;
	        return a;
	      }
	
	      if (isNumerable(tOfA, a) && $bm_isInstanceOfArray(b)) {
	        b = b.slice(0);
	        b[0] = a + b[0];
	        return b;
	      }
	
	      if ($bm_isInstanceOfArray(a) && $bm_isInstanceOfArray(b)) {
	        var i = 0;
	        var lenA = a.length;
	        var lenB = b.length;
	        var retArr = [];
	
	        while (i < lenA || i < lenB) {
	          if ((typeof a[i] === 'number' || a[i] instanceof Number) && (typeof b[i] === 'number' || b[i] instanceof Number)) {
	            retArr[i] = a[i] + b[i];
	          } else {
	            retArr[i] = b[i] === undefined ? a[i] : a[i] || b[i];
	          }
	
	          i += 1;
	        }
	
	        return retArr;
	      }
	
	      return 0;
	    }
	
	    var add = sum;
	
	    function sub(a, b) {
	      var tOfA = _typeof$1(a);
	
	      var tOfB = _typeof$1(b);
	
	      if (isNumerable(tOfA, a) && isNumerable(tOfB, b)) {
	        if (tOfA === 'string') {
	          a = parseInt(a, 10);
	        }
	
	        if (tOfB === 'string') {
	          b = parseInt(b, 10);
	        }
	
	        return a - b;
	      }
	
	      if ($bm_isInstanceOfArray(a) && isNumerable(tOfB, b)) {
	        a = a.slice(0);
	        a[0] -= b;
	        return a;
	      }
	
	      if (isNumerable(tOfA, a) && $bm_isInstanceOfArray(b)) {
	        b = b.slice(0);
	        b[0] = a - b[0];
	        return b;
	      }
	
	      if ($bm_isInstanceOfArray(a) && $bm_isInstanceOfArray(b)) {
	        var i = 0;
	        var lenA = a.length;
	        var lenB = b.length;
	        var retArr = [];
	
	        while (i < lenA || i < lenB) {
	          if ((typeof a[i] === 'number' || a[i] instanceof Number) && (typeof b[i] === 'number' || b[i] instanceof Number)) {
	            retArr[i] = a[i] - b[i];
	          } else {
	            retArr[i] = b[i] === undefined ? a[i] : a[i] || b[i];
	          }
	
	          i += 1;
	        }
	
	        return retArr;
	      }
	
	      return 0;
	    }
	
	    function mul(a, b) {
	      var tOfA = _typeof$1(a);
	
	      var tOfB = _typeof$1(b);
	
	      var arr;
	
	      if (isNumerable(tOfA, a) && isNumerable(tOfB, b)) {
	        return a * b;
	      }
	
	      var i;
	      var len;
	
	      if ($bm_isInstanceOfArray(a) && isNumerable(tOfB, b)) {
	        len = a.length;
	        arr = createTypedArray('float32', len);
	
	        for (i = 0; i < len; i += 1) {
	          arr[i] = a[i] * b;
	        }
	
	        return arr;
	      }
	
	      if (isNumerable(tOfA, a) && $bm_isInstanceOfArray(b)) {
	        len = b.length;
	        arr = createTypedArray('float32', len);
	
	        for (i = 0; i < len; i += 1) {
	          arr[i] = a * b[i];
	        }
	
	        return arr;
	      }
	
	      return 0;
	    }
	
	    function div(a, b) {
	      var tOfA = _typeof$1(a);
	
	      var tOfB = _typeof$1(b);
	
	      var arr;
	
	      if (isNumerable(tOfA, a) && isNumerable(tOfB, b)) {
	        return a / b;
	      }
	
	      var i;
	      var len;
	
	      if ($bm_isInstanceOfArray(a) && isNumerable(tOfB, b)) {
	        len = a.length;
	        arr = createTypedArray('float32', len);
	
	        for (i = 0; i < len; i += 1) {
	          arr[i] = a[i] / b;
	        }
	
	        return arr;
	      }
	
	      if (isNumerable(tOfA, a) && $bm_isInstanceOfArray(b)) {
	        len = b.length;
	        arr = createTypedArray('float32', len);
	
	        for (i = 0; i < len; i += 1) {
	          arr[i] = a / b[i];
	        }
	
	        return arr;
	      }
	
	      return 0;
	    }
	
	    function mod(a, b) {
	      if (typeof a === 'string') {
	        a = parseInt(a, 10);
	      }
	
	      if (typeof b === 'string') {
	        b = parseInt(b, 10);
	      }
	
	      return a % b;
	    }
	
	    var $bm_sum = sum;
	    var $bm_sub = sub;
	    var $bm_mul = mul;
	    var $bm_div = div;
	    var $bm_mod = mod;
	
	    function clamp(num, min, max) {
	      if (min > max) {
	        var mm = max;
	        max = min;
	        min = mm;
	      }
	
	      return Math.min(Math.max(num, min), max);
	    }
	
	    function radiansToDegrees(val) {
	      return val / degToRads;
	    }
	
	    var radians_to_degrees = radiansToDegrees;
	
	    function degreesToRadians(val) {
	      return val * degToRads;
	    }
	
	    var degrees_to_radians = radiansToDegrees;
	    var helperLengthArray = [0, 0, 0, 0, 0, 0];
	
	    function length(arr1, arr2) {
	      if (typeof arr1 === 'number' || arr1 instanceof Number) {
	        arr2 = arr2 || 0;
	        return Math.abs(arr1 - arr2);
	      }
	
	      if (!arr2) {
	        arr2 = helperLengthArray;
	      }
	
	      var i;
	      var len = Math.min(arr1.length, arr2.length);
	      var addedLength = 0;
	
	      for (i = 0; i < len; i += 1) {
	        addedLength += Math.pow(arr2[i] - arr1[i], 2);
	      }
	
	      return Math.sqrt(addedLength);
	    }
	
	    function normalize(vec) {
	      return div(vec, length(vec));
	    }
	
	    function rgbToHsl(val) {
	      var r = val[0];
	      var g = val[1];
	      var b = val[2];
	      var max = Math.max(r, g, b);
	      var min = Math.min(r, g, b);
	      var h;
	      var s;
	      var l = (max + min) / 2;
	
	      if (max === min) {
	        h = 0; // achromatic
	
	        s = 0; // achromatic
	      } else {
	        var d = max - min;
	        s = l > 0.5 ? d / (2 - max - min) : d / (max + min);
	
	        switch (max) {
	          case r:
	            h = (g - b) / d + (g < b ? 6 : 0);
	            break;
	
	          case g:
	            h = (b - r) / d + 2;
	            break;
	
	          case b:
	            h = (r - g) / d + 4;
	            break;
	
	          default:
	            break;
	        }
	
	        h /= 6;
	      }
	
	      return [h, s, l, val[3]];
	    }
	
	    function hue2rgb(p, q, t) {
	      if (t < 0) t += 1;
	      if (t > 1) t -= 1;
	      if (t < 1 / 6) return p + (q - p) * 6 * t;
	      if (t < 1 / 2) return q;
	      if (t < 2 / 3) return p + (q - p) * (2 / 3 - t) * 6;
	      return p;
	    }
	
	    function hslToRgb(val) {
	      var h = val[0];
	      var s = val[1];
	      var l = val[2];
	      var r;
	      var g;
	      var b;
	
	      if (s === 0) {
	        r = l; // achromatic
	
	        b = l; // achromatic
	
	        g = l; // achromatic
	      } else {
	        var q = l < 0.5 ? l * (1 + s) : l + s - l * s;
	        var p = 2 * l - q;
	        r = hue2rgb(p, q, h + 1 / 3);
	        g = hue2rgb(p, q, h);
	        b = hue2rgb(p, q, h - 1 / 3);
	      }
	
	      return [r, g, b, val[3]];
	    }
	
	    function linear(t, tMin, tMax, value1, value2) {
	      if (value1 === undefined || value2 === undefined) {
	        value1 = tMin;
	        value2 = tMax;
	        tMin = 0;
	        tMax = 1;
	      }
	
	      if (tMax < tMin) {
	        var _tMin = tMax;
	        tMax = tMin;
	        tMin = _tMin;
	      }
	
	      if (t <= tMin) {
	        return value1;
	      }
	
	      if (t >= tMax) {
	        return value2;
	      }
	
	      var perc = tMax === tMin ? 0 : (t - tMin) / (tMax - tMin);
	
	      if (!value1.length) {
	        return value1 + (value2 - value1) * perc;
	      }
	
	      var i;
	      var len = value1.length;
	      var arr = createTypedArray('float32', len);
	
	      for (i = 0; i < len; i += 1) {
	        arr[i] = value1[i] + (value2[i] - value1[i]) * perc;
	      }
	
	      return arr;
	    }
	
	    function random(min, max) {
	      if (max === undefined) {
	        if (min === undefined) {
	          min = 0;
	          max = 1;
	        } else {
	          max = min;
	          min = undefined;
	        }
	      }
	
	      if (max.length) {
	        var i;
	        var len = max.length;
	
	        if (!min) {
	          min = createTypedArray('float32', len);
	        }
	
	        var arr = createTypedArray('float32', len);
	        var rnd = BMMath.random();
	
	        for (i = 0; i < len; i += 1) {
	          arr[i] = min[i] + rnd * (max[i] - min[i]);
	        }
	
	        return arr;
	      }
	
	      if (min === undefined) {
	        min = 0;
	      }
	
	      var rndm = BMMath.random();
	      return min + rndm * (max - min);
	    }
	
	    function createPath(points, inTangents, outTangents, closed) {
	      var i;
	      var len = points.length;
	      var path = shapePool.newElement();
	      path.setPathData(!!closed, len);
	      var arrPlaceholder = [0, 0];
	      var inVertexPoint;
	      var outVertexPoint;
	
	      for (i = 0; i < len; i += 1) {
	        inVertexPoint = inTangents && inTangents[i] ? inTangents[i] : arrPlaceholder;
	        outVertexPoint = outTangents && outTangents[i] ? outTangents[i] : arrPlaceholder;
	        path.setTripleAt(points[i][0], points[i][1], outVertexPoint[0] + points[i][0], outVertexPoint[1] + points[i][1], inVertexPoint[0] + points[i][0], inVertexPoint[1] + points[i][1], i, true);
	      }
	
	      return path;
	    }
	
	    function initiateExpression(elem, data, property) {
	      // Bail out if we don't want expressions
	      function noOp(_value) {
	        return _value;
	      }
	
	      if (!elem.globalData.renderConfig.runExpressions) {
	        return noOp;
	      }
	
	      var val = data.x;
	      var needsVelocity = /velocity(?![\w\d])/.test(val);
	
	      var _needsRandom = val.indexOf('random') !== -1;
	
	      var elemType = elem.data.ty;
	      var transform;
	      var $bm_transform;
	      var content;
	      var effect;
	      var thisProperty = property;
	      thisProperty.valueAtTime = thisProperty.getValueAtTime;
	      Object.defineProperty(thisProperty, 'value', {
	        get: function get() {
	          return thisProperty.v;
	        }
	      });
	      elem.comp.frameDuration = 1 / elem.comp.globalData.frameRate;
	      elem.comp.displayStartTime = 0;
	      var inPoint = elem.data.ip / elem.comp.globalData.frameRate;
	      var outPoint = elem.data.op / elem.comp.globalData.frameRate;
	      var width = elem.data.sw ? elem.data.sw : 0;
	      var height = elem.data.sh ? elem.data.sh : 0;
	      var name = elem.data.nm;
	      var loopIn;
	      var loop_in;
	      var loopOut;
	      var loop_out;
	      var smooth;
	      var toWorld;
	      var fromWorld;
	      var fromComp;
	      var toComp;
	      var fromCompToSurface;
	      var position;
	      var rotation;
	      var anchorPoint;
	      var scale;
	      var thisLayer;
	      var thisComp;
	      var mask;
	      var valueAtTime;
	      var velocityAtTime;
	      var scoped_bm_rt; // val = val.replace(/(\\?"|')((http)(s)?(:\/))?\/.*?(\\?"|')/g, "\"\""); // deter potential network calls
	
	      var expression_function = eval('[function _expression_function(){' + val + ';scoped_bm_rt=$bm_rt}]')[0]; // eslint-disable-line no-eval
	
	      var numKeys = property.kf ? data.k.length : 0;
	      var active = !this.data || this.data.hd !== true;
	
	      var wiggle = function wiggle(freq, amp) {
	        var iWiggle;
	        var j;
	        var lenWiggle = this.pv.length ? this.pv.length : 1;
	        var addedAmps = createTypedArray('float32', lenWiggle);
	        freq = 5;
	        var iterations = Math.floor(time * freq);
	        iWiggle = 0;
	        j = 0;
	
	        while (iWiggle < iterations) {
	          // var rnd = BMMath.random();
	          for (j = 0; j < lenWiggle; j += 1) {
	            addedAmps[j] += -amp + amp * 2 * BMMath.random(); // addedAmps[j] += -amp + amp*2*rnd;
	          }
	
	          iWiggle += 1;
	        } // var rnd2 = BMMath.random();
	
	
	        var periods = time * freq;
	        var perc = periods - Math.floor(periods);
	        var arr = createTypedArray('float32', lenWiggle);
	
	        if (lenWiggle > 1) {
	          for (j = 0; j < lenWiggle; j += 1) {
	            arr[j] = this.pv[j] + addedAmps[j] + (-amp + amp * 2 * BMMath.random()) * perc; // arr[j] = this.pv[j] + addedAmps[j] + (-amp + amp*2*rnd)*perc;
	            // arr[i] = this.pv[i] + addedAmp + amp1*perc + amp2*(1-perc);
	          }
	
	          return arr;
	        }
	
	        return this.pv + addedAmps[0] + (-amp + amp * 2 * BMMath.random()) * perc;
	      }.bind(this);
	
	      if (thisProperty.loopIn) {
	        loopIn = thisProperty.loopIn.bind(thisProperty);
	        loop_in = loopIn;
	      }
	
	      if (thisProperty.loopOut) {
	        loopOut = thisProperty.loopOut.bind(thisProperty);
	        loop_out = loopOut;
	      }
	
	      if (thisProperty.smooth) {
	        smooth = thisProperty.smooth.bind(thisProperty);
	      }
	
	      function loopInDuration(type, duration) {
	        return loopIn(type, duration, true);
	      }
	
	      function loopOutDuration(type, duration) {
	        return loopOut(type, duration, true);
	      }
	
	      if (this.getValueAtTime) {
	        valueAtTime = this.getValueAtTime.bind(this);
	      }
	
	      if (this.getVelocityAtTime) {
	        velocityAtTime = this.getVelocityAtTime.bind(this);
	      }
	
	      var comp = elem.comp.globalData.projectInterface.bind(elem.comp.globalData.projectInterface);
	
	      function lookAt(elem1, elem2) {
	        var fVec = [elem2[0] - elem1[0], elem2[1] - elem1[1], elem2[2] - elem1[2]];
	        var pitch = Math.atan2(fVec[0], Math.sqrt(fVec[1] * fVec[1] + fVec[2] * fVec[2])) / degToRads;
	        var yaw = -Math.atan2(fVec[1], fVec[2]) / degToRads;
	        return [yaw, pitch, 0];
	      }
	
	      function easeOut(t, tMin, tMax, val1, val2) {
	        return applyEase(easeOutBez, t, tMin, tMax, val1, val2);
	      }
	
	      function easeIn(t, tMin, tMax, val1, val2) {
	        return applyEase(easeInBez, t, tMin, tMax, val1, val2);
	      }
	
	      function ease(t, tMin, tMax, val1, val2) {
	        return applyEase(easeInOutBez, t, tMin, tMax, val1, val2);
	      }
	
	      function applyEase(fn, t, tMin, tMax, val1, val2) {
	        if (val1 === undefined) {
	          val1 = tMin;
	          val2 = tMax;
	        } else {
	          t = (t - tMin) / (tMax - tMin);
	        }
	
	        if (t > 1) {
	          t = 1;
	        } else if (t < 0) {
	          t = 0;
	        }
	
	        var mult = fn(t);
	
	        if ($bm_isInstanceOfArray(val1)) {
	          var iKey;
	          var lenKey = val1.length;
	          var arr = createTypedArray('float32', lenKey);
	
	          for (iKey = 0; iKey < lenKey; iKey += 1) {
	            arr[iKey] = (val2[iKey] - val1[iKey]) * mult + val1[iKey];
	          }
	
	          return arr;
	        }
	
	        return (val2 - val1) * mult + val1;
	      }
	
	      function nearestKey(time) {
	        var iKey;
	        var lenKey = data.k.length;
	        var index;
	        var keyTime;
	
	        if (!data.k.length || typeof data.k[0] === 'number') {
	          index = 0;
	          keyTime = 0;
	        } else {
	          index = -1;
	          time *= elem.comp.globalData.frameRate;
	
	          if (time < data.k[0].t) {
	            index = 1;
	            keyTime = data.k[0].t;
	          } else {
	            for (iKey = 0; iKey < lenKey - 1; iKey += 1) {
	              if (time === data.k[iKey].t) {
	                index = iKey + 1;
	                keyTime = data.k[iKey].t;
	                break;
	              } else if (time > data.k[iKey].t && time < data.k[iKey + 1].t) {
	                if (time - data.k[iKey].t > data.k[iKey + 1].t - time) {
	                  index = iKey + 2;
	                  keyTime = data.k[iKey + 1].t;
	                } else {
	                  index = iKey + 1;
	                  keyTime = data.k[iKey].t;
	                }
	
	                break;
	              }
	            }
	
	            if (index === -1) {
	              index = iKey + 1;
	              keyTime = data.k[iKey].t;
	            }
	          }
	        }
	
	        var obKey = {};
	        obKey.index = index;
	        obKey.time = keyTime / elem.comp.globalData.frameRate;
	        return obKey;
	      }
	
	      function key(ind) {
	        var obKey;
	        var iKey;
	        var lenKey;
	
	        if (!data.k.length || typeof data.k[0] === 'number') {
	          throw new Error('The property has no keyframe at index ' + ind);
	        }
	
	        ind -= 1;
	        obKey = {
	          time: data.k[ind].t / elem.comp.globalData.frameRate,
	          value: []
	        };
	        var arr = Object.prototype.hasOwnProperty.call(data.k[ind], 's') ? data.k[ind].s : data.k[ind - 1].e;
	        lenKey = arr.length;
	
	        for (iKey = 0; iKey < lenKey; iKey += 1) {
	          obKey[iKey] = arr[iKey];
	          obKey.value[iKey] = arr[iKey];
	        }
	
	        return obKey;
	      }
	
	      function framesToTime(fr, fps) {
	        if (!fps) {
	          fps = elem.comp.globalData.frameRate;
	        }
	
	        return fr / fps;
	      }
	
	      function timeToFrames(t, fps) {
	        if (!t && t !== 0) {
	          t = time;
	        }
	
	        if (!fps) {
	          fps = elem.comp.globalData.frameRate;
	        }
	
	        return t * fps;
	      }
	
	      function seedRandom(seed) {
	        BMMath.seedrandom(randSeed + seed);
	      }
	
	      function sourceRectAtTime() {
	        return elem.sourceRectAtTime();
	      }
	
	      function substring(init, end) {
	        if (typeof value === 'string') {
	          if (end === undefined) {
	            return value.substring(init);
	          }
	
	          return value.substring(init, end);
	        }
	
	        return '';
	      }
	
	      function substr(init, end) {
	        if (typeof value === 'string') {
	          if (end === undefined) {
	            return value.substr(init);
	          }
	
	          return value.substr(init, end);
	        }
	
	        return '';
	      }
	
	      function posterizeTime(framesPerSecond) {
	        time = framesPerSecond === 0 ? 0 : Math.floor(time * framesPerSecond) / framesPerSecond;
	        value = valueAtTime(time);
	      }
	
	      var time;
	      var velocity;
	      var value;
	      var text;
	      var textIndex;
	      var textTotal;
	      var selectorValue;
	      var index = elem.data.ind;
	      var hasParent = !!(elem.hierarchy && elem.hierarchy.length);
	      var parent;
	      var randSeed = Math.floor(Math.random() * 1000000);
	      var globalData = elem.globalData;
	
	      function executeExpression(_value) {
	        // globalData.pushExpression();
	        value = _value;
	
	        if (this.frameExpressionId === elem.globalData.frameId && this.propType !== 'textSelector') {
	          return value;
	        }
	
	        if (this.propType === 'textSelector') {
	          textIndex = this.textIndex;
	          textTotal = this.textTotal;
	          selectorValue = this.selectorValue;
	        }
	
	        if (!thisLayer) {
	          text = elem.layerInterface.text;
	          thisLayer = elem.layerInterface;
	          thisComp = elem.comp.compInterface;
	          toWorld = thisLayer.toWorld.bind(thisLayer);
	          fromWorld = thisLayer.fromWorld.bind(thisLayer);
	          fromComp = thisLayer.fromComp.bind(thisLayer);
	          toComp = thisLayer.toComp.bind(thisLayer);
	          mask = thisLayer.mask ? thisLayer.mask.bind(thisLayer) : null;
	          fromCompToSurface = fromComp;
	        }
	
	        if (!transform) {
	          transform = elem.layerInterface('ADBE Transform Group');
	          $bm_transform = transform;
	
	          if (transform) {
	            anchorPoint = transform.anchorPoint;
	            /* position = transform.position;
	                      rotation = transform.rotation;
	                      scale = transform.scale; */
	          }
	        }
	
	        if (elemType === 4 && !content) {
	          content = thisLayer('ADBE Root Vectors Group');
	        }
	
	        if (!effect) {
	          effect = thisLayer(4);
	        }
	
	        hasParent = !!(elem.hierarchy && elem.hierarchy.length);
	
	        if (hasParent && !parent) {
	          parent = elem.hierarchy[0].layerInterface;
	        }
	
	        time = this.comp.renderedFrame / this.comp.globalData.frameRate;
	
	        if (_needsRandom) {
	          seedRandom(randSeed + time);
	        }
	
	        if (needsVelocity) {
	          velocity = velocityAtTime(time);
	        }
	
	        expression_function();
	        this.frameExpressionId = elem.globalData.frameId; // TODO: Check if it's possible to return on ShapeInterface the .v value
	        // Changed this to a ternary operation because Rollup failed compiling it correctly
	
	        scoped_bm_rt = scoped_bm_rt.propType === propTypes.SHAPE ? scoped_bm_rt.v : scoped_bm_rt;
	        return scoped_bm_rt;
	      } // Bundlers will see these as dead code and unless we reference them
	
	
	      executeExpression.__preventDeadCodeRemoval = [$bm_transform, anchorPoint, time, velocity, inPoint, outPoint, width, height, name, loop_in, loop_out, smooth, toComp, fromCompToSurface, toWorld, fromWorld, mask, position, rotation, scale, thisComp, numKeys, active, wiggle, loopInDuration, loopOutDuration, comp, lookAt, easeOut, easeIn, ease, nearestKey, key, text, textIndex, textTotal, selectorValue, framesToTime, timeToFrames, sourceRectAtTime, substring, substr, posterizeTime, index, globalData];
	      return executeExpression;
	    }
	
	    ob.initiateExpression = initiateExpression;
	    ob.__preventDeadCodeRemoval = [window, document, XMLHttpRequest, fetch, frames, $bm_neg, add, $bm_sum, $bm_sub, $bm_mul, $bm_div, $bm_mod, clamp, radians_to_degrees, degreesToRadians, degrees_to_radians, normalize, rgbToHsl, hslToRgb, linear, random, createPath, _lottieGlobal];
	    ob.resetFrame = resetFrame;
	    return ob;
	  }();
	
	  var Expressions = function () {
	    var ob = {};
	    ob.initExpressions = initExpressions;
	    ob.resetFrame = ExpressionManager.resetFrame;
	
	    function initExpressions(animation) {
	      var stackCount = 0;
	      var registers = [];
	
	      function pushExpression() {
	        stackCount += 1;
	      }
	
	      function popExpression() {
	        stackCount -= 1;
	
	        if (stackCount === 0) {
	          releaseInstances();
	        }
	      }
	
	      function registerExpressionProperty(expression) {
	        if (registers.indexOf(expression) === -1) {
	          registers.push(expression);
	        }
	      }
	
	      function releaseInstances() {
	        var i;
	        var len = registers.length;
	
	        for (i = 0; i < len; i += 1) {
	          registers[i].release();
	        }
	
	        registers.length = 0;
	      }
	
	      animation.renderer.compInterface = CompExpressionInterface(animation.renderer);
	      animation.renderer.globalData.projectInterface.registerComposition(animation.renderer);
	      animation.renderer.globalData.pushExpression = pushExpression;
	      animation.renderer.globalData.popExpression = popExpression;
	      animation.renderer.globalData.registerExpressionProperty = registerExpressionProperty;
	    }
	
	    return ob;
	  }();
	
	  var MaskManagerInterface = function () {
	    function MaskInterface(mask, data) {
	      this._mask = mask;
	      this._data = data;
	    }
	
	    Object.defineProperty(MaskInterface.prototype, 'maskPath', {
	      get: function get() {
	        if (this._mask.prop.k) {
	          this._mask.prop.getValue();
	        }
	
	        return this._mask.prop;
	      }
	    });
	    Object.defineProperty(MaskInterface.prototype, 'maskOpacity', {
	      get: function get() {
	        if (this._mask.op.k) {
	          this._mask.op.getValue();
	        }
	
	        return this._mask.op.v * 100;
	      }
	    });
	
	    var MaskManager = function MaskManager(maskManager) {
	      var _masksInterfaces = createSizedArray(maskManager.viewData.length);
	
	      var i;
	      var len = maskManager.viewData.length;
	
	      for (i = 0; i < len; i += 1) {
	        _masksInterfaces[i] = new MaskInterface(maskManager.viewData[i], maskManager.masksProperties[i]);
	      }
	
	      var maskFunction = function maskFunction(name) {
	        i = 0;
	
	        while (i < len) {
	          if (maskManager.masksProperties[i].nm === name) {
	            return _masksInterfaces[i];
	          }
	
	          i += 1;
	        }
	
	        return null;
	      };
	
	      return maskFunction;
	    };
	
	    return MaskManager;
	  }();
	
	  var ExpressionPropertyInterface = function () {
	    var defaultUnidimensionalValue = {
	      pv: 0,
	      v: 0,
	      mult: 1
	    };
	    var defaultMultidimensionalValue = {
	      pv: [0, 0, 0],
	      v: [0, 0, 0],
	      mult: 1
	    };
	
	    function completeProperty(expressionValue, property, type) {
	      Object.defineProperty(expressionValue, 'velocity', {
	        get: function get() {
	          return property.getVelocityAtTime(property.comp.currentFrame);
	        }
	      });
	      expressionValue.numKeys = property.keyframes ? property.keyframes.length : 0;
	
	      expressionValue.key = function (pos) {
	        if (!expressionValue.numKeys) {
	          return 0;
	        }
	
	        var value = '';
	
	        if ('s' in property.keyframes[pos - 1]) {
	          value = property.keyframes[pos - 1].s;
	        } else if ('e' in property.keyframes[pos - 2]) {
	          value = property.keyframes[pos - 2].e;
	        } else {
	          value = property.keyframes[pos - 2].s;
	        }
	
	        var valueProp = type === 'unidimensional' ? new Number(value) : Object.assign({}, value); // eslint-disable-line no-new-wrappers
	
	        valueProp.time = property.keyframes[pos - 1].t / property.elem.comp.globalData.frameRate;
	        valueProp.value = type === 'unidimensional' ? value[0] : value;
	        return valueProp;
	      };
	
	      expressionValue.valueAtTime = property.getValueAtTime;
	      expressionValue.speedAtTime = property.getSpeedAtTime;
	      expressionValue.velocityAtTime = property.getVelocityAtTime;
	      expressionValue.propertyGroup = property.propertyGroup;
	    }
	
	    function UnidimensionalPropertyInterface(property) {
	      if (!property || !('pv' in property)) {
	        property = defaultUnidimensionalValue;
	      }
	
	      var mult = 1 / property.mult;
	      var val = property.pv * mult;
	      var expressionValue = new Number(val); // eslint-disable-line no-new-wrappers
	
	      expressionValue.value = val;
	      completeProperty(expressionValue, property, 'unidimensional');
	      return function () {
	        if (property.k) {
	          property.getValue();
	        }
	
	        val = property.v * mult;
	
	        if (expressionValue.value !== val) {
	          expressionValue = new Number(val); // eslint-disable-line no-new-wrappers
	
	          expressionValue.value = val;
	          completeProperty(expressionValue, property, 'unidimensional');
	        }
	
	        return expressionValue;
	      };
	    }
	
	    function MultidimensionalPropertyInterface(property) {
	      if (!property || !('pv' in property)) {
	        property = defaultMultidimensionalValue;
	      }
	
	      var mult = 1 / property.mult;
	      var len = property.data && property.data.l || property.pv.length;
	      var expressionValue = createTypedArray('float32', len);
	      var arrValue = createTypedArray('float32', len);
	      expressionValue.value = arrValue;
	      completeProperty(expressionValue, property, 'multidimensional');
	      return function () {
	        if (property.k) {
	          property.getValue();
	        }
	
	        for (var i = 0; i < len; i += 1) {
	          arrValue[i] = property.v[i] * mult;
	          expressionValue[i] = arrValue[i];
	        }
	
	        return expressionValue;
	      };
	    } // TODO: try to avoid using this getter
	
	
	    function defaultGetter() {
	      return defaultUnidimensionalValue;
	    }
	
	    return function (property) {
	      if (!property) {
	        return defaultGetter;
	      }
	
	      if (property.propType === 'unidimensional') {
	        return UnidimensionalPropertyInterface(property);
	      }
	
	      return MultidimensionalPropertyInterface(property);
	    };
	  }();
	
	  var TransformExpressionInterface = function () {
	    return function (transform) {
	      function _thisFunction(name) {
	        switch (name) {
	          case 'scale':
	          case 'Scale':
	          case 'ADBE Scale':
	          case 6:
	            return _thisFunction.scale;
	
	          case 'rotation':
	          case 'Rotation':
	          case 'ADBE Rotation':
	          case 'ADBE Rotate Z':
	          case 10:
	            return _thisFunction.rotation;
	
	          case 'ADBE Rotate X':
	            return _thisFunction.xRotation;
	
	          case 'ADBE Rotate Y':
	            return _thisFunction.yRotation;
	
	          case 'position':
	          case 'Position':
	          case 'ADBE Position':
	          case 2:
	            return _thisFunction.position;
	
	          case 'ADBE Position_0':
	            return _thisFunction.xPosition;
	
	          case 'ADBE Position_1':
	            return _thisFunction.yPosition;
	
	          case 'ADBE Position_2':
	            return _thisFunction.zPosition;
	
	          case 'anchorPoint':
	          case 'AnchorPoint':
	          case 'Anchor Point':
	          case 'ADBE AnchorPoint':
	          case 1:
	            return _thisFunction.anchorPoint;
	
	          case 'opacity':
	          case 'Opacity':
	          case 11:
	            return _thisFunction.opacity;
	
	          default:
	            return null;
	        }
	      }
	
	      Object.defineProperty(_thisFunction, 'rotation', {
	        get: ExpressionPropertyInterface(transform.r || transform.rz)
	      });
	      Object.defineProperty(_thisFunction, 'zRotation', {
	        get: ExpressionPropertyInterface(transform.rz || transform.r)
	      });
	      Object.defineProperty(_thisFunction, 'xRotation', {
	        get: ExpressionPropertyInterface(transform.rx)
	      });
	      Object.defineProperty(_thisFunction, 'yRotation', {
	        get: ExpressionPropertyInterface(transform.ry)
	      });
	      Object.defineProperty(_thisFunction, 'scale', {
	        get: ExpressionPropertyInterface(transform.s)
	      });
	
	      var _px;
	
	      var _py;
	
	      var _pz;
	
	      var _transformFactory;
	
	      if (transform.p) {
	        _transformFactory = ExpressionPropertyInterface(transform.p);
	      } else {
	        _px = ExpressionPropertyInterface(transform.px);
	        _py = ExpressionPropertyInterface(transform.py);
	
	        if (transform.pz) {
	          _pz = ExpressionPropertyInterface(transform.pz);
	        }
	      }
	
	      Object.defineProperty(_thisFunction, 'position', {
	        get: function get() {
	          if (transform.p) {
	            return _transformFactory();
	          }
	
	          return [_px(), _py(), _pz ? _pz() : 0];
	        }
	      });
	      Object.defineProperty(_thisFunction, 'xPosition', {
	        get: ExpressionPropertyInterface(transform.px)
	      });
	      Object.defineProperty(_thisFunction, 'yPosition', {
	        get: ExpressionPropertyInterface(transform.py)
	      });
	      Object.defineProperty(_thisFunction, 'zPosition', {
	        get: ExpressionPropertyInterface(transform.pz)
	      });
	      Object.defineProperty(_thisFunction, 'anchorPoint', {
	        get: ExpressionPropertyInterface(transform.a)
	      });
	      Object.defineProperty(_thisFunction, 'opacity', {
	        get: ExpressionPropertyInterface(transform.o)
	      });
	      Object.defineProperty(_thisFunction, 'skew', {
	        get: ExpressionPropertyInterface(transform.sk)
	      });
	      Object.defineProperty(_thisFunction, 'skewAxis', {
	        get: ExpressionPropertyInterface(transform.sa)
	      });
	      Object.defineProperty(_thisFunction, 'orientation', {
	        get: ExpressionPropertyInterface(transform.or)
	      });
	      return _thisFunction;
	    };
	  }();
	
	  var LayerExpressionInterface = function () {
	    function getMatrix(time) {
	      var toWorldMat = new Matrix();
	
	      if (time !== undefined) {
	        var propMatrix = this._elem.finalTransform.mProp.getValueAtTime(time);
	
	        propMatrix.clone(toWorldMat);
	      } else {
	        var transformMat = this._elem.finalTransform.mProp;
	        transformMat.applyToMatrix(toWorldMat);
	      }
	
	      return toWorldMat;
	    }
	
	    function toWorldVec(arr, time) {
	      var toWorldMat = this.getMatrix(time);
	      toWorldMat.props[12] = 0;
	      toWorldMat.props[13] = 0;
	      toWorldMat.props[14] = 0;
	      return this.applyPoint(toWorldMat, arr);
	    }
	
	    function toWorld(arr, time) {
	      var toWorldMat = this.getMatrix(time);
	      return this.applyPoint(toWorldMat, arr);
	    }
	
	    function fromWorldVec(arr, time) {
	      var toWorldMat = this.getMatrix(time);
	      toWorldMat.props[12] = 0;
	      toWorldMat.props[13] = 0;
	      toWorldMat.props[14] = 0;
	      return this.invertPoint(toWorldMat, arr);
	    }
	
	    function fromWorld(arr, time) {
	      var toWorldMat = this.getMatrix(time);
	      return this.invertPoint(toWorldMat, arr);
	    }
	
	    function applyPoint(matrix, arr) {
	      if (this._elem.hierarchy && this._elem.hierarchy.length) {
	        var i;
	        var len = this._elem.hierarchy.length;
	
	        for (i = 0; i < len; i += 1) {
	          this._elem.hierarchy[i].finalTransform.mProp.applyToMatrix(matrix);
	        }
	      }
	
	      return matrix.applyToPointArray(arr[0], arr[1], arr[2] || 0);
	    }
	
	    function invertPoint(matrix, arr) {
	      if (this._elem.hierarchy && this._elem.hierarchy.length) {
	        var i;
	        var len = this._elem.hierarchy.length;
	
	        for (i = 0; i < len; i += 1) {
	          this._elem.hierarchy[i].finalTransform.mProp.applyToMatrix(matrix);
	        }
	      }
	
	      return matrix.inversePoint(arr);
	    }
	
	    function fromComp(arr) {
	      var toWorldMat = new Matrix();
	      toWorldMat.reset();
	
	      this._elem.finalTransform.mProp.applyToMatrix(toWorldMat);
	
	      if (this._elem.hierarchy && this._elem.hierarchy.length) {
	        var i;
	        var len = this._elem.hierarchy.length;
	
	        for (i = 0; i < len; i += 1) {
	          this._elem.hierarchy[i].finalTransform.mProp.applyToMatrix(toWorldMat);
	        }
	
	        return toWorldMat.inversePoint(arr);
	      }
	
	      return toWorldMat.inversePoint(arr);
	    }
	
	    function sampleImage() {
	      return [1, 1, 1, 1];
	    }
	
	    return function (elem) {
	      var transformInterface;
	
	      function _registerMaskInterface(maskManager) {
	        _thisLayerFunction.mask = new MaskManagerInterface(maskManager, elem);
	      }
	
	      function _registerEffectsInterface(effects) {
	        _thisLayerFunction.effect = effects;
	      }
	
	      function _thisLayerFunction(name) {
	        switch (name) {
	          case 'ADBE Root Vectors Group':
	          case 'Contents':
	          case 2:
	            return _thisLayerFunction.shapeInterface;
	
	          case 1:
	          case 6:
	          case 'Transform':
	          case 'transform':
	          case 'ADBE Transform Group':
	            return transformInterface;
	
	          case 4:
	          case 'ADBE Effect Parade':
	          case 'effects':
	          case 'Effects':
	            return _thisLayerFunction.effect;
	
	          case 'ADBE Text Properties':
	            return _thisLayerFunction.textInterface;
	
	          default:
	            return null;
	        }
	      }
	
	      _thisLayerFunction.getMatrix = getMatrix;
	      _thisLayerFunction.invertPoint = invertPoint;
	      _thisLayerFunction.applyPoint = applyPoint;
	      _thisLayerFunction.toWorld = toWorld;
	      _thisLayerFunction.toWorldVec = toWorldVec;
	      _thisLayerFunction.fromWorld = fromWorld;
	      _thisLayerFunction.fromWorldVec = fromWorldVec;
	      _thisLayerFunction.toComp = toWorld;
	      _thisLayerFunction.fromComp = fromComp;
	      _thisLayerFunction.sampleImage = sampleImage;
	      _thisLayerFunction.sourceRectAtTime = elem.sourceRectAtTime.bind(elem);
	      _thisLayerFunction._elem = elem;
	      transformInterface = TransformExpressionInterface(elem.finalTransform.mProp);
	      var anchorPointDescriptor = getDescriptor(transformInterface, 'anchorPoint');
	      Object.defineProperties(_thisLayerFunction, {
	        hasParent: {
	          get: function get() {
	            return elem.hierarchy.length;
	          }
	        },
	        parent: {
	          get: function get() {
	            return elem.hierarchy[0].layerInterface;
	          }
	        },
	        rotation: getDescriptor(transformInterface, 'rotation'),
	        scale: getDescriptor(transformInterface, 'scale'),
	        position: getDescriptor(transformInterface, 'position'),
	        opacity: getDescriptor(transformInterface, 'opacity'),
	        anchorPoint: anchorPointDescriptor,
	        anchor_point: anchorPointDescriptor,
	        transform: {
	          get: function get() {
	            return transformInterface;
	          }
	        },
	        active: {
	          get: function get() {
	            return elem.isInRange;
	          }
	        }
	      });
	      _thisLayerFunction.startTime = elem.data.st;
	      _thisLayerFunction.index = elem.data.ind;
	      _thisLayerFunction.source = elem.data.refId;
	      _thisLayerFunction.height = elem.data.ty === 0 ? elem.data.h : 100;
	      _thisLayerFunction.width = elem.data.ty === 0 ? elem.data.w : 100;
	      _thisLayerFunction.inPoint = elem.data.ip / elem.comp.globalData.frameRate;
	      _thisLayerFunction.outPoint = elem.data.op / elem.comp.globalData.frameRate;
	      _thisLayerFunction._name = elem.data.nm;
	      _thisLayerFunction.registerMaskInterface = _registerMaskInterface;
	      _thisLayerFunction.registerEffectsInterface = _registerEffectsInterface;
	      return _thisLayerFunction;
	    };
	  }();
	
	  var propertyGroupFactory = function () {
	    return function (interfaceFunction, parentPropertyGroup) {
	      return function (val) {
	        val = val === undefined ? 1 : val;
	
	        if (val <= 0) {
	          return interfaceFunction;
	        }
	
	        return parentPropertyGroup(val - 1);
	      };
	    };
	  }();
	
	  var PropertyInterface = function () {
	    return function (propertyName, propertyGroup) {
	      var interfaceFunction = {
	        _name: propertyName
	      };
	
	      function _propertyGroup(val) {
	        val = val === undefined ? 1 : val;
	
	        if (val <= 0) {
	          return interfaceFunction;
	        }
	
	        return propertyGroup(val - 1);
	      }
	
	      return _propertyGroup;
	    };
	  }();
	
	  var EffectsExpressionInterface = function () {
	    var ob = {
	      createEffectsInterface: createEffectsInterface
	    };
	
	    function createEffectsInterface(elem, propertyGroup) {
	      if (elem.effectsManager) {
	        var effectElements = [];
	        var effectsData = elem.data.ef;
	        var i;
	        var len = elem.effectsManager.effectElements.length;
	
	        for (i = 0; i < len; i += 1) {
	          effectElements.push(createGroupInterface(effectsData[i], elem.effectsManager.effectElements[i], propertyGroup, elem));
	        }
	
	        var effects = elem.data.ef || [];
	
	        var groupInterface = function groupInterface(name) {
	          i = 0;
	          len = effects.length;
	
	          while (i < len) {
	            if (name === effects[i].nm || name === effects[i].mn || name === effects[i].ix) {
	              return effectElements[i];
	            }
	
	            i += 1;
	          }
	
	          return null;
	        };
	
	        Object.defineProperty(groupInterface, 'numProperties', {
	          get: function get() {
	            return effects.length;
	          }
	        });
	        return groupInterface;
	      }
	
	      return null;
	    }
	
	    function createGroupInterface(data, elements, propertyGroup, elem) {
	      function groupInterface(name) {
	        var effects = data.ef;
	        var i = 0;
	        var len = effects.length;
	
	        while (i < len) {
	          if (name === effects[i].nm || name === effects[i].mn || name === effects[i].ix) {
	            if (effects[i].ty === 5) {
	              return effectElements[i];
	            }
	
	            return effectElements[i]();
	          }
	
	          i += 1;
	        }
	
	        throw new Error();
	      }
	
	      var _propertyGroup = propertyGroupFactory(groupInterface, propertyGroup);
	
	      var effectElements = [];
	      var i;
	      var len = data.ef.length;
	
	      for (i = 0; i < len; i += 1) {
	        if (data.ef[i].ty === 5) {
	          effectElements.push(createGroupInterface(data.ef[i], elements.effectElements[i], elements.effectElements[i].propertyGroup, elem));
	        } else {
	          effectElements.push(createValueInterface(elements.effectElements[i], data.ef[i].ty, elem, _propertyGroup));
	        }
	      }
	
	      if (data.mn === 'ADBE Color Control') {
	        Object.defineProperty(groupInterface, 'color', {
	          get: function get() {
	            return effectElements[0]();
	          }
	        });
	      }
	
	      Object.defineProperties(groupInterface, {
	        numProperties: {
	          get: function get() {
	            return data.np;
	          }
	        },
	        _name: {
	          value: data.nm
	        },
	        propertyGroup: {
	          value: _propertyGroup
	        }
	      });
	      groupInterface.enabled = data.en !== 0;
	      groupInterface.active = groupInterface.enabled;
	      return groupInterface;
	    }
	
	    function createValueInterface(element, type, elem, propertyGroup) {
	      var expressionProperty = ExpressionPropertyInterface(element.p);
	
	      function interfaceFunction() {
	        if (type === 10) {
	          return elem.comp.compInterface(element.p.v);
	        }
	
	        return expressionProperty();
	      }
	
	      if (element.p.setGroupProperty) {
	        element.p.setGroupProperty(PropertyInterface('', propertyGroup));
	      }
	
	      return interfaceFunction;
	    }
	
	    return ob;
	  }();
	
	  var ShapePathInterface = function () {
	    return function pathInterfaceFactory(shape, view, propertyGroup) {
	      var prop = view.sh;
	
	      function interfaceFunction(val) {
	        if (val === 'Shape' || val === 'shape' || val === 'Path' || val === 'path' || val === 'ADBE Vector Shape' || val === 2) {
	          return interfaceFunction.path;
	        }
	
	        return null;
	      }
	
	      var _propertyGroup = propertyGroupFactory(interfaceFunction, propertyGroup);
	
	      prop.setGroupProperty(PropertyInterface('Path', _propertyGroup));
	      Object.defineProperties(interfaceFunction, {
	        path: {
	          get: function get() {
	            if (prop.k) {
	              prop.getValue();
	            }
	
	            return prop;
	          }
	        },
	        shape: {
	          get: function get() {
	            if (prop.k) {
	              prop.getValue();
	            }
	
	            return prop;
	          }
	        },
	        _name: {
	          value: shape.nm
	        },
	        ix: {
	          value: shape.ix
	        },
	        propertyIndex: {
	          value: shape.ix
	        },
	        mn: {
	          value: shape.mn
	        },
	        propertyGroup: {
	          value: propertyGroup
	        }
	      });
	      return interfaceFunction;
	    };
	  }();
	
	  var ShapeExpressionInterface = function () {
	    function iterateElements(shapes, view, propertyGroup) {
	      var arr = [];
	      var i;
	      var len = shapes ? shapes.length : 0;
	
	      for (i = 0; i < len; i += 1) {
	        if (shapes[i].ty === 'gr') {
	          arr.push(groupInterfaceFactory(shapes[i], view[i], propertyGroup));
	        } else if (shapes[i].ty === 'fl') {
	          arr.push(fillInterfaceFactory(shapes[i], view[i], propertyGroup));
	        } else if (shapes[i].ty === 'st') {
	          arr.push(strokeInterfaceFactory(shapes[i], view[i], propertyGroup));
	        } else if (shapes[i].ty === 'tm') {
	          arr.push(trimInterfaceFactory(shapes[i], view[i], propertyGroup));
	        } else if (shapes[i].ty === 'tr') {// arr.push(transformInterfaceFactory(shapes[i],view[i],propertyGroup));
	        } else if (shapes[i].ty === 'el') {
	          arr.push(ellipseInterfaceFactory(shapes[i], view[i], propertyGroup));
	        } else if (shapes[i].ty === 'sr') {
	          arr.push(starInterfaceFactory(shapes[i], view[i], propertyGroup));
	        } else if (shapes[i].ty === 'sh') {
	          arr.push(ShapePathInterface(shapes[i], view[i], propertyGroup));
	        } else if (shapes[i].ty === 'rc') {
	          arr.push(rectInterfaceFactory(shapes[i], view[i], propertyGroup));
	        } else if (shapes[i].ty === 'rd') {
	          arr.push(roundedInterfaceFactory(shapes[i], view[i], propertyGroup));
	        } else if (shapes[i].ty === 'rp') {
	          arr.push(repeaterInterfaceFactory(shapes[i], view[i], propertyGroup));
	        } else if (shapes[i].ty === 'gf') {
	          arr.push(gradientFillInterfaceFactory(shapes[i], view[i], propertyGroup));
	        } else {
	          arr.push(defaultInterfaceFactory(shapes[i], view[i], propertyGroup));
	        }
	      }
	
	      return arr;
	    }
	
	    function contentsInterfaceFactory(shape, view, propertyGroup) {
	      var interfaces;
	
	      var interfaceFunction = function _interfaceFunction(value) {
	        var i = 0;
	        var len = interfaces.length;
	
	        while (i < len) {
	          if (interfaces[i]._name === value || interfaces[i].mn === value || interfaces[i].propertyIndex === value || interfaces[i].ix === value || interfaces[i].ind === value) {
	            return interfaces[i];
	          }
	
	          i += 1;
	        }
	
	        if (typeof value === 'number') {
	          return interfaces[value - 1];
	        }
	
	        return null;
	      };
	
	      interfaceFunction.propertyGroup = propertyGroupFactory(interfaceFunction, propertyGroup);
	      interfaces = iterateElements(shape.it, view.it, interfaceFunction.propertyGroup);
	      interfaceFunction.numProperties = interfaces.length;
	      var transformInterface = transformInterfaceFactory(shape.it[shape.it.length - 1], view.it[view.it.length - 1], interfaceFunction.propertyGroup);
	      interfaceFunction.transform = transformInterface;
	      interfaceFunction.propertyIndex = shape.cix;
	      interfaceFunction._name = shape.nm;
	      return interfaceFunction;
	    }
	
	    function groupInterfaceFactory(shape, view, propertyGroup) {
	      var interfaceFunction = function _interfaceFunction(value) {
	        switch (value) {
	          case 'ADBE Vectors Group':
	          case 'Contents':
	          case 2:
	            return interfaceFunction.content;
	          // Not necessary for now. Keeping them here in case a new case appears
	          // case 'ADBE Vector Transform Group':
	          // case 3:
	
	          default:
	            return interfaceFunction.transform;
	        }
	      };
	
	      interfaceFunction.propertyGroup = propertyGroupFactory(interfaceFunction, propertyGroup);
	      var content = contentsInterfaceFactory(shape, view, interfaceFunction.propertyGroup);
	      var transformInterface = transformInterfaceFactory(shape.it[shape.it.length - 1], view.it[view.it.length - 1], interfaceFunction.propertyGroup);
	      interfaceFunction.content = content;
	      interfaceFunction.transform = transformInterface;
	      Object.defineProperty(interfaceFunction, '_name', {
	        get: function get() {
	          return shape.nm;
	        }
	      }); // interfaceFunction.content = interfaceFunction;
	
	      interfaceFunction.numProperties = shape.np;
	      interfaceFunction.propertyIndex = shape.ix;
	      interfaceFunction.nm = shape.nm;
	      interfaceFunction.mn = shape.mn;
	      return interfaceFunction;
	    }
	
	    function fillInterfaceFactory(shape, view, propertyGroup) {
	      function interfaceFunction(val) {
	        if (val === 'Color' || val === 'color') {
	          return interfaceFunction.color;
	        }
	
	        if (val === 'Opacity' || val === 'opacity') {
	          return interfaceFunction.opacity;
	        }
	
	        return null;
	      }
	
	      Object.defineProperties(interfaceFunction, {
	        color: {
	          get: ExpressionPropertyInterface(view.c)
	        },
	        opacity: {
	          get: ExpressionPropertyInterface(view.o)
	        },
	        _name: {
	          value: shape.nm
	        },
	        mn: {
	          value: shape.mn
	        }
	      });
	      view.c.setGroupProperty(PropertyInterface('Color', propertyGroup));
	      view.o.setGroupProperty(PropertyInterface('Opacity', propertyGroup));
	      return interfaceFunction;
	    }
	
	    function gradientFillInterfaceFactory(shape, view, propertyGroup) {
	      function interfaceFunction(val) {
	        if (val === 'Start Point' || val === 'start point') {
	          return interfaceFunction.startPoint;
	        }
	
	        if (val === 'End Point' || val === 'end point') {
	          return interfaceFunction.endPoint;
	        }
	
	        if (val === 'Opacity' || val === 'opacity') {
	          return interfaceFunction.opacity;
	        }
	
	        return null;
	      }
	
	      Object.defineProperties(interfaceFunction, {
	        startPoint: {
	          get: ExpressionPropertyInterface(view.s)
	        },
	        endPoint: {
	          get: ExpressionPropertyInterface(view.e)
	        },
	        opacity: {
	          get: ExpressionPropertyInterface(view.o)
	        },
	        type: {
	          get: function get() {
	            return 'a';
	          }
	        },
	        _name: {
	          value: shape.nm
	        },
	        mn: {
	          value: shape.mn
	        }
	      });
	      view.s.setGroupProperty(PropertyInterface('Start Point', propertyGroup));
	      view.e.setGroupProperty(PropertyInterface('End Point', propertyGroup));
	      view.o.setGroupProperty(PropertyInterface('Opacity', propertyGroup));
	      return interfaceFunction;
	    }
	
	    function defaultInterfaceFactory() {
	      function interfaceFunction() {
	        return null;
	      }
	
	      return interfaceFunction;
	    }
	
	    function strokeInterfaceFactory(shape, view, propertyGroup) {
	      var _propertyGroup = propertyGroupFactory(interfaceFunction, propertyGroup);
	
	      var _dashPropertyGroup = propertyGroupFactory(dashOb, _propertyGroup);
	
	      function addPropertyToDashOb(i) {
	        Object.defineProperty(dashOb, shape.d[i].nm, {
	          get: ExpressionPropertyInterface(view.d.dataProps[i].p)
	        });
	      }
	
	      var i;
	      var len = shape.d ? shape.d.length : 0;
	      var dashOb = {};
	
	      for (i = 0; i < len; i += 1) {
	        addPropertyToDashOb(i);
	        view.d.dataProps[i].p.setGroupProperty(_dashPropertyGroup);
	      }
	
	      function interfaceFunction(val) {
	        if (val === 'Color' || val === 'color') {
	          return interfaceFunction.color;
	        }
	
	        if (val === 'Opacity' || val === 'opacity') {
	          return interfaceFunction.opacity;
	        }
	
	        if (val === 'Stroke Width' || val === 'stroke width') {
	          return interfaceFunction.strokeWidth;
	        }
	
	        return null;
	      }
	
	      Object.defineProperties(interfaceFunction, {
	        color: {
	          get: ExpressionPropertyInterface(view.c)
	        },
	        opacity: {
	          get: ExpressionPropertyInterface(view.o)
	        },
	        strokeWidth: {
	          get: ExpressionPropertyInterface(view.w)
	        },
	        dash: {
	          get: function get() {
	            return dashOb;
	          }
	        },
	        _name: {
	          value: shape.nm
	        },
	        mn: {
	          value: shape.mn
	        }
	      });
	      view.c.setGroupProperty(PropertyInterface('Color', _propertyGroup));
	      view.o.setGroupProperty(PropertyInterface('Opacity', _propertyGroup));
	      view.w.setGroupProperty(PropertyInterface('Stroke Width', _propertyGroup));
	      return interfaceFunction;
	    }
	
	    function trimInterfaceFactory(shape, view, propertyGroup) {
	      function interfaceFunction(val) {
	        if (val === shape.e.ix || val === 'End' || val === 'end') {
	          return interfaceFunction.end;
	        }
	
	        if (val === shape.s.ix) {
	          return interfaceFunction.start;
	        }
	
	        if (val === shape.o.ix) {
	          return interfaceFunction.offset;
	        }
	
	        return null;
	      }
	
	      var _propertyGroup = propertyGroupFactory(interfaceFunction, propertyGroup);
	
	      interfaceFunction.propertyIndex = shape.ix;
	      view.s.setGroupProperty(PropertyInterface('Start', _propertyGroup));
	      view.e.setGroupProperty(PropertyInterface('End', _propertyGroup));
	      view.o.setGroupProperty(PropertyInterface('Offset', _propertyGroup));
	      interfaceFunction.propertyIndex = shape.ix;
	      interfaceFunction.propertyGroup = propertyGroup;
	      Object.defineProperties(interfaceFunction, {
	        start: {
	          get: ExpressionPropertyInterface(view.s)
	        },
	        end: {
	          get: ExpressionPropertyInterface(view.e)
	        },
	        offset: {
	          get: ExpressionPropertyInterface(view.o)
	        },
	        _name: {
	          value: shape.nm
	        }
	      });
	      interfaceFunction.mn = shape.mn;
	      return interfaceFunction;
	    }
	
	    function transformInterfaceFactory(shape, view, propertyGroup) {
	      function interfaceFunction(value) {
	        if (shape.a.ix === value || value === 'Anchor Point') {
	          return interfaceFunction.anchorPoint;
	        }
	
	        if (shape.o.ix === value || value === 'Opacity') {
	          return interfaceFunction.opacity;
	        }
	
	        if (shape.p.ix === value || value === 'Position') {
	          return interfaceFunction.position;
	        }
	
	        if (shape.r.ix === value || value === 'Rotation' || value === 'ADBE Vector Rotation') {
	          return interfaceFunction.rotation;
	        }
	
	        if (shape.s.ix === value || value === 'Scale') {
	          return interfaceFunction.scale;
	        }
	
	        if (shape.sk && shape.sk.ix === value || value === 'Skew') {
	          return interfaceFunction.skew;
	        }
	
	        if (shape.sa && shape.sa.ix === value || value === 'Skew Axis') {
	          return interfaceFunction.skewAxis;
	        }
	
	        return null;
	      }
	
	      var _propertyGroup = propertyGroupFactory(interfaceFunction, propertyGroup);
	
	      view.transform.mProps.o.setGroupProperty(PropertyInterface('Opacity', _propertyGroup));
	      view.transform.mProps.p.setGroupProperty(PropertyInterface('Position', _propertyGroup));
	      view.transform.mProps.a.setGroupProperty(PropertyInterface('Anchor Point', _propertyGroup));
	      view.transform.mProps.s.setGroupProperty(PropertyInterface('Scale', _propertyGroup));
	      view.transform.mProps.r.setGroupProperty(PropertyInterface('Rotation', _propertyGroup));
	
	      if (view.transform.mProps.sk) {
	        view.transform.mProps.sk.setGroupProperty(PropertyInterface('Skew', _propertyGroup));
	        view.transform.mProps.sa.setGroupProperty(PropertyInterface('Skew Angle', _propertyGroup));
	      }
	
	      view.transform.op.setGroupProperty(PropertyInterface('Opacity', _propertyGroup));
	      Object.defineProperties(interfaceFunction, {
	        opacity: {
	          get: ExpressionPropertyInterface(view.transform.mProps.o)
	        },
	        position: {
	          get: ExpressionPropertyInterface(view.transform.mProps.p)
	        },
	        anchorPoint: {
	          get: ExpressionPropertyInterface(view.transform.mProps.a)
	        },
	        scale: {
	          get: ExpressionPropertyInterface(view.transform.mProps.s)
	        },
	        rotation: {
	          get: ExpressionPropertyInterface(view.transform.mProps.r)
	        },
	        skew: {
	          get: ExpressionPropertyInterface(view.transform.mProps.sk)
	        },
	        skewAxis: {
	          get: ExpressionPropertyInterface(view.transform.mProps.sa)
	        },
	        _name: {
	          value: shape.nm
	        }
	      });
	      interfaceFunction.ty = 'tr';
	      interfaceFunction.mn = shape.mn;
	      interfaceFunction.propertyGroup = propertyGroup;
	      return interfaceFunction;
	    }
	
	    function ellipseInterfaceFactory(shape, view, propertyGroup) {
	      function interfaceFunction(value) {
	        if (shape.p.ix === value) {
	          return interfaceFunction.position;
	        }
	
	        if (shape.s.ix === value) {
	          return interfaceFunction.size;
	        }
	
	        return null;
	      }
	
	      var _propertyGroup = propertyGroupFactory(interfaceFunction, propertyGroup);
	
	      interfaceFunction.propertyIndex = shape.ix;
	      var prop = view.sh.ty === 'tm' ? view.sh.prop : view.sh;
	      prop.s.setGroupProperty(PropertyInterface('Size', _propertyGroup));
	      prop.p.setGroupProperty(PropertyInterface('Position', _propertyGroup));
	      Object.defineProperties(interfaceFunction, {
	        size: {
	          get: ExpressionPropertyInterface(prop.s)
	        },
	        position: {
	          get: ExpressionPropertyInterface(prop.p)
	        },
	        _name: {
	          value: shape.nm
	        }
	      });
	      interfaceFunction.mn = shape.mn;
	      return interfaceFunction;
	    }
	
	    function starInterfaceFactory(shape, view, propertyGroup) {
	      function interfaceFunction(value) {
	        if (shape.p.ix === value) {
	          return interfaceFunction.position;
	        }
	
	        if (shape.r.ix === value) {
	          return interfaceFunction.rotation;
	        }
	
	        if (shape.pt.ix === value) {
	          return interfaceFunction.points;
	        }
	
	        if (shape.or.ix === value || value === 'ADBE Vector Star Outer Radius') {
	          return interfaceFunction.outerRadius;
	        }
	
	        if (shape.os.ix === value) {
	          return interfaceFunction.outerRoundness;
	        }
	
	        if (shape.ir && (shape.ir.ix === value || value === 'ADBE Vector Star Inner Radius')) {
	          return interfaceFunction.innerRadius;
	        }
	
	        if (shape.is && shape.is.ix === value) {
	          return interfaceFunction.innerRoundness;
	        }
	
	        return null;
	      }
	
	      var _propertyGroup = propertyGroupFactory(interfaceFunction, propertyGroup);
	
	      var prop = view.sh.ty === 'tm' ? view.sh.prop : view.sh;
	      interfaceFunction.propertyIndex = shape.ix;
	      prop.or.setGroupProperty(PropertyInterface('Outer Radius', _propertyGroup));
	      prop.os.setGroupProperty(PropertyInterface('Outer Roundness', _propertyGroup));
	      prop.pt.setGroupProperty(PropertyInterface('Points', _propertyGroup));
	      prop.p.setGroupProperty(PropertyInterface('Position', _propertyGroup));
	      prop.r.setGroupProperty(PropertyInterface('Rotation', _propertyGroup));
	
	      if (shape.ir) {
	        prop.ir.setGroupProperty(PropertyInterface('Inner Radius', _propertyGroup));
	        prop.is.setGroupProperty(PropertyInterface('Inner Roundness', _propertyGroup));
	      }
	
	      Object.defineProperties(interfaceFunction, {
	        position: {
	          get: ExpressionPropertyInterface(prop.p)
	        },
	        rotation: {
	          get: ExpressionPropertyInterface(prop.r)
	        },
	        points: {
	          get: ExpressionPropertyInterface(prop.pt)
	        },
	        outerRadius: {
	          get: ExpressionPropertyInterface(prop.or)
	        },
	        outerRoundness: {
	          get: ExpressionPropertyInterface(prop.os)
	        },
	        innerRadius: {
	          get: ExpressionPropertyInterface(prop.ir)
	        },
	        innerRoundness: {
	          get: ExpressionPropertyInterface(prop.is)
	        },
	        _name: {
	          value: shape.nm
	        }
	      });
	      interfaceFunction.mn = shape.mn;
	      return interfaceFunction;
	    }
	
	    function rectInterfaceFactory(shape, view, propertyGroup) {
	      function interfaceFunction(value) {
	        if (shape.p.ix === value) {
	          return interfaceFunction.position;
	        }
	
	        if (shape.r.ix === value) {
	          return interfaceFunction.roundness;
	        }
	
	        if (shape.s.ix === value || value === 'Size' || value === 'ADBE Vector Rect Size') {
	          return interfaceFunction.size;
	        }
	
	        return null;
	      }
	
	      var _propertyGroup = propertyGroupFactory(interfaceFunction, propertyGroup);
	
	      var prop = view.sh.ty === 'tm' ? view.sh.prop : view.sh;
	      interfaceFunction.propertyIndex = shape.ix;
	      prop.p.setGroupProperty(PropertyInterface('Position', _propertyGroup));
	      prop.s.setGroupProperty(PropertyInterface('Size', _propertyGroup));
	      prop.r.setGroupProperty(PropertyInterface('Rotation', _propertyGroup));
	      Object.defineProperties(interfaceFunction, {
	        position: {
	          get: ExpressionPropertyInterface(prop.p)
	        },
	        roundness: {
	          get: ExpressionPropertyInterface(prop.r)
	        },
	        size: {
	          get: ExpressionPropertyInterface(prop.s)
	        },
	        _name: {
	          value: shape.nm
	        }
	      });
	      interfaceFunction.mn = shape.mn;
	      return interfaceFunction;
	    }
	
	    function roundedInterfaceFactory(shape, view, propertyGroup) {
	      function interfaceFunction(value) {
	        if (shape.r.ix === value || value === 'Round Corners 1') {
	          return interfaceFunction.radius;
	        }
	
	        return null;
	      }
	
	      var _propertyGroup = propertyGroupFactory(interfaceFunction, propertyGroup);
	
	      var prop = view;
	      interfaceFunction.propertyIndex = shape.ix;
	      prop.rd.setGroupProperty(PropertyInterface('Radius', _propertyGroup));
	      Object.defineProperties(interfaceFunction, {
	        radius: {
	          get: ExpressionPropertyInterface(prop.rd)
	        },
	        _name: {
	          value: shape.nm
	        }
	      });
	      interfaceFunction.mn = shape.mn;
	      return interfaceFunction;
	    }
	
	    function repeaterInterfaceFactory(shape, view, propertyGroup) {
	      function interfaceFunction(value) {
	        if (shape.c.ix === value || value === 'Copies') {
	          return interfaceFunction.copies;
	        }
	
	        if (shape.o.ix === value || value === 'Offset') {
	          return interfaceFunction.offset;
	        }
	
	        return null;
	      }
	
	      var _propertyGroup = propertyGroupFactory(interfaceFunction, propertyGroup);
	
	      var prop = view;
	      interfaceFunction.propertyIndex = shape.ix;
	      prop.c.setGroupProperty(PropertyInterface('Copies', _propertyGroup));
	      prop.o.setGroupProperty(PropertyInterface('Offset', _propertyGroup));
	      Object.defineProperties(interfaceFunction, {
	        copies: {
	          get: ExpressionPropertyInterface(prop.c)
	        },
	        offset: {
	          get: ExpressionPropertyInterface(prop.o)
	        },
	        _name: {
	          value: shape.nm
	        }
	      });
	      interfaceFunction.mn = shape.mn;
	      return interfaceFunction;
	    }
	
	    return function (shapes, view, propertyGroup) {
	      var interfaces;
	
	      function _interfaceFunction(value) {
	        if (typeof value === 'number') {
	          value = value === undefined ? 1 : value;
	
	          if (value === 0) {
	            return propertyGroup;
	          }
	
	          return interfaces[value - 1];
	        }
	
	        var i = 0;
	        var len = interfaces.length;
	
	        while (i < len) {
	          if (interfaces[i]._name === value) {
	            return interfaces[i];
	          }
	
	          i += 1;
	        }
	
	        return null;
	      }
	
	      function parentGroupWrapper() {
	        return propertyGroup;
	      }
	
	      _interfaceFunction.propertyGroup = propertyGroupFactory(_interfaceFunction, parentGroupWrapper);
	      interfaces = iterateElements(shapes, view, _interfaceFunction.propertyGroup);
	      _interfaceFunction.numProperties = interfaces.length;
	      _interfaceFunction._name = 'Contents';
	      return _interfaceFunction;
	    };
	  }();
	
	  var TextExpressionInterface = function () {
	    return function (elem) {
	      var _sourceText;
	
	      function _thisLayerFunction(name) {
	        switch (name) {
	          case 'ADBE Text Document':
	            return _thisLayerFunction.sourceText;
	
	          default:
	            return null;
	        }
	      }
	
	      Object.defineProperty(_thisLayerFunction, 'sourceText', {
	        get: function get() {
	          elem.textProperty.getValue();
	          var stringValue = elem.textProperty.currentData.t;
	
	          if (!_sourceText || stringValue !== _sourceText.value) {
	            _sourceText = new String(stringValue); // eslint-disable-line no-new-wrappers
	            // If stringValue is an empty string, eval returns undefined, so it has to be returned as a String primitive
	
	            _sourceText.value = stringValue || new String(stringValue); // eslint-disable-line no-new-wrappers
	
	            Object.defineProperty(_sourceText, 'style', {
	              get: function get() {
	                return {
	                  fillColor: elem.textProperty.currentData.fc
	                };
	              }
	            });
	          }
	
	          return _sourceText;
	        }
	      });
	      return _thisLayerFunction;
	    };
	  }();
	
	  function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }
	
	  var FootageInterface = function () {
	    var outlineInterfaceFactory = function outlineInterfaceFactory(elem) {
	      var currentPropertyName = '';
	      var currentProperty = elem.getFootageData();
	
	      function init() {
	        currentPropertyName = '';
	        currentProperty = elem.getFootageData();
	        return searchProperty;
	      }
	
	      function searchProperty(value) {
	        if (currentProperty[value]) {
	          currentPropertyName = value;
	          currentProperty = currentProperty[value];
	
	          if (_typeof(currentProperty) === 'object') {
	            return searchProperty;
	          }
	
	          return currentProperty;
	        }
	
	        var propertyNameIndex = value.indexOf(currentPropertyName);
	
	        if (propertyNameIndex !== -1) {
	          var index = parseInt(value.substr(propertyNameIndex + currentPropertyName.length), 10);
	          currentProperty = currentProperty[index];
	
	          if (_typeof(currentProperty) === 'object') {
	            return searchProperty;
	          }
	
	          return currentProperty;
	        }
	
	        return '';
	      }
	
	      return init;
	    };
	
	    var dataInterfaceFactory = function dataInterfaceFactory(elem) {
	      function interfaceFunction(value) {
	        if (value === 'Outline') {
	          return interfaceFunction.outlineInterface();
	        }
	
	        return null;
	      }
	
	      interfaceFunction._name = 'Outline';
	      interfaceFunction.outlineInterface = outlineInterfaceFactory(elem);
	      return interfaceFunction;
	    };
	
	    return function (elem) {
	      function _interfaceFunction(value) {
	        if (value === 'Data') {
	          return _interfaceFunction.dataInterface;
	        }
	
	        return null;
	      }
	
	      _interfaceFunction._name = 'Data';
	      _interfaceFunction.dataInterface = dataInterfaceFactory(elem);
	      return _interfaceFunction;
	    };
	  }();
	
	  var interfaces = {
	    layer: LayerExpressionInterface,
	    effects: EffectsExpressionInterface,
	    comp: CompExpressionInterface,
	    shape: ShapeExpressionInterface,
	    text: TextExpressionInterface,
	    footage: FootageInterface
	  };
	
	  function getInterface(type) {
	    return interfaces[type] || null;
	  }
	
	  var expressionHelpers = function () {
	    function searchExpressions(elem, data, prop) {
	      if (data.x) {
	        prop.k = true;
	        prop.x = true;
	        prop.initiateExpression = ExpressionManager.initiateExpression;
	        prop.effectsSequence.push(prop.initiateExpression(elem, data, prop).bind(prop));
	      }
	    }
	
	    function getValueAtTime(frameNum) {
	      frameNum *= this.elem.globalData.frameRate;
	      frameNum -= this.offsetTime;
	
	      if (frameNum !== this._cachingAtTime.lastFrame) {
	        this._cachingAtTime.lastIndex = this._cachingAtTime.lastFrame < frameNum ? this._cachingAtTime.lastIndex : 0;
	        this._cachingAtTime.value = this.interpolateValue(frameNum, this._cachingAtTime);
	        this._cachingAtTime.lastFrame = frameNum;
	      }
	
	      return this._cachingAtTime.value;
	    }
	
	    function getSpeedAtTime(frameNum) {
	      var delta = -0.01;
	      var v1 = this.getValueAtTime(frameNum);
	      var v2 = this.getValueAtTime(frameNum + delta);
	      var speed = 0;
	
	      if (v1.length) {
	        var i;
	
	        for (i = 0; i < v1.length; i += 1) {
	          speed += Math.pow(v2[i] - v1[i], 2);
	        }
	
	        speed = Math.sqrt(speed) * 100;
	      } else {
	        speed = 0;
	      }
	
	      return speed;
	    }
	
	    function getVelocityAtTime(frameNum) {
	      if (this.vel !== undefined) {
	        return this.vel;
	      }
	
	      var delta = -0.001; // frameNum += this.elem.data.st;
	
	      var v1 = this.getValueAtTime(frameNum);
	      var v2 = this.getValueAtTime(frameNum + delta);
	      var velocity;
	
	      if (v1.length) {
	        velocity = createTypedArray('float32', v1.length);
	        var i;
	
	        for (i = 0; i < v1.length; i += 1) {
	          // removing frameRate
	          // if needed, don't add it here
	          // velocity[i] = this.elem.globalData.frameRate*((v2[i] - v1[i])/delta);
	          velocity[i] = (v2[i] - v1[i]) / delta;
	        }
	      } else {
	        velocity = (v2 - v1) / delta;
	      }
	
	      return velocity;
	    }
	
	    function getStaticValueAtTime() {
	      return this.pv;
	    }
	
	    function setGroupProperty(propertyGroup) {
	      this.propertyGroup = propertyGroup;
	    }
	
	    return {
	      searchExpressions: searchExpressions,
	      getSpeedAtTime: getSpeedAtTime,
	      getVelocityAtTime: getVelocityAtTime,
	      getValueAtTime: getValueAtTime,
	      getStaticValueAtTime: getStaticValueAtTime,
	      setGroupProperty: setGroupProperty
	    };
	  }();
	
	  function addPropertyDecorator() {
	    function loopOut(type, duration, durationFlag) {
	      if (!this.k || !this.keyframes) {
	        return this.pv;
	      }
	
	      type = type ? type.toLowerCase() : '';
	      var currentFrame = this.comp.renderedFrame;
	      var keyframes = this.keyframes;
	      var lastKeyFrame = keyframes[keyframes.length - 1].t;
	
	      if (currentFrame <= lastKeyFrame) {
	        return this.pv;
	      }
	
	      var cycleDuration;
	      var firstKeyFrame;
	
	      if (!durationFlag) {
	        if (!duration || duration > keyframes.length - 1) {
	          duration = keyframes.length - 1;
	        }
	
	        firstKeyFrame = keyframes[keyframes.length - 1 - duration].t;
	        cycleDuration = lastKeyFrame - firstKeyFrame;
	      } else {
	        if (!duration) {
	          cycleDuration = Math.max(0, lastKeyFrame - this.elem.data.ip);
	        } else {
	          cycleDuration = Math.abs(lastKeyFrame - this.elem.comp.globalData.frameRate * duration);
	        }
	
	        firstKeyFrame = lastKeyFrame - cycleDuration;
	      }
	
	      var i;
	      var len;
	      var ret;
	
	      if (type === 'pingpong') {
	        var iterations = Math.floor((currentFrame - firstKeyFrame) / cycleDuration);
	
	        if (iterations % 2 !== 0) {
	          return this.getValueAtTime((cycleDuration - (currentFrame - firstKeyFrame) % cycleDuration + firstKeyFrame) / this.comp.globalData.frameRate, 0); // eslint-disable-line
	        }
	      } else if (type === 'offset') {
	        var initV = this.getValueAtTime(firstKeyFrame / this.comp.globalData.frameRate, 0);
	        var endV = this.getValueAtTime(lastKeyFrame / this.comp.globalData.frameRate, 0);
	        var current = this.getValueAtTime(((currentFrame - firstKeyFrame) % cycleDuration + firstKeyFrame) / this.comp.globalData.frameRate, 0); // eslint-disable-line
	
	        var repeats = Math.floor((currentFrame - firstKeyFrame) / cycleDuration);
	
	        if (this.pv.length) {
	          ret = new Array(initV.length);
	          len = ret.length;
	
	          for (i = 0; i < len; i += 1) {
	            ret[i] = (endV[i] - initV[i]) * repeats + current[i];
	          }
	
	          return ret;
	        }
	
	        return (endV - initV) * repeats + current;
	      } else if (type === 'continue') {
	        var lastValue = this.getValueAtTime(lastKeyFrame / this.comp.globalData.frameRate, 0);
	        var nextLastValue = this.getValueAtTime((lastKeyFrame - 0.001) / this.comp.globalData.frameRate, 0);
	
	        if (this.pv.length) {
	          ret = new Array(lastValue.length);
	          len = ret.length;
	
	          for (i = 0; i < len; i += 1) {
	            ret[i] = lastValue[i] + (lastValue[i] - nextLastValue[i]) * ((currentFrame - lastKeyFrame) / this.comp.globalData.frameRate) / 0.0005; // eslint-disable-line
	          }
	
	          return ret;
	        }
	
	        return lastValue + (lastValue - nextLastValue) * ((currentFrame - lastKeyFrame) / 0.001);
	      }
	
	      return this.getValueAtTime(((currentFrame - firstKeyFrame) % cycleDuration + firstKeyFrame) / this.comp.globalData.frameRate, 0); // eslint-disable-line
	    }
	
	    function loopIn(type, duration, durationFlag) {
	      if (!this.k) {
	        return this.pv;
	      }
	
	      type = type ? type.toLowerCase() : '';
	      var currentFrame = this.comp.renderedFrame;
	      var keyframes = this.keyframes;
	      var firstKeyFrame = keyframes[0].t;
	
	      if (currentFrame >= firstKeyFrame) {
	        return this.pv;
	      }
	
	      var cycleDuration;
	      var lastKeyFrame;
	
	      if (!durationFlag) {
	        if (!duration || duration > keyframes.length - 1) {
	          duration = keyframes.length - 1;
	        }
	
	        lastKeyFrame = keyframes[duration].t;
	        cycleDuration = lastKeyFrame - firstKeyFrame;
	      } else {
	        if (!duration) {
	          cycleDuration = Math.max(0, this.elem.data.op - firstKeyFrame);
	        } else {
	          cycleDuration = Math.abs(this.elem.comp.globalData.frameRate * duration);
	        }
	
	        lastKeyFrame = firstKeyFrame + cycleDuration;
	      }
	
	      var i;
	      var len;
	      var ret;
	
	      if (type === 'pingpong') {
	        var iterations = Math.floor((firstKeyFrame - currentFrame) / cycleDuration);
	
	        if (iterations % 2 === 0) {
	          return this.getValueAtTime(((firstKeyFrame - currentFrame) % cycleDuration + firstKeyFrame) / this.comp.globalData.frameRate, 0); // eslint-disable-line
	        }
	      } else if (type === 'offset') {
	        var initV = this.getValueAtTime(firstKeyFrame / this.comp.globalData.frameRate, 0);
	        var endV = this.getValueAtTime(lastKeyFrame / this.comp.globalData.frameRate, 0);
	        var current = this.getValueAtTime((cycleDuration - (firstKeyFrame - currentFrame) % cycleDuration + firstKeyFrame) / this.comp.globalData.frameRate, 0);
	        var repeats = Math.floor((firstKeyFrame - currentFrame) / cycleDuration) + 1;
	
	        if (this.pv.length) {
	          ret = new Array(initV.length);
	          len = ret.length;
	
	          for (i = 0; i < len; i += 1) {
	            ret[i] = current[i] - (endV[i] - initV[i]) * repeats;
	          }
	
	          return ret;
	        }
	
	        return current - (endV - initV) * repeats;
	      } else if (type === 'continue') {
	        var firstValue = this.getValueAtTime(firstKeyFrame / this.comp.globalData.frameRate, 0);
	        var nextFirstValue = this.getValueAtTime((firstKeyFrame + 0.001) / this.comp.globalData.frameRate, 0);
	
	        if (this.pv.length) {
	          ret = new Array(firstValue.length);
	          len = ret.length;
	
	          for (i = 0; i < len; i += 1) {
	            ret[i] = firstValue[i] + (firstValue[i] - nextFirstValue[i]) * (firstKeyFrame - currentFrame) / 0.001;
	          }
	
	          return ret;
	        }
	
	        return firstValue + (firstValue - nextFirstValue) * (firstKeyFrame - currentFrame) / 0.001;
	      }
	
	      return this.getValueAtTime((cycleDuration - ((firstKeyFrame - currentFrame) % cycleDuration + firstKeyFrame)) / this.comp.globalData.frameRate, 0); // eslint-disable-line
	    }
	
	    function smooth(width, samples) {
	      if (!this.k) {
	        return this.pv;
	      }
	
	      width = (width || 0.4) * 0.5;
	      samples = Math.floor(samples || 5);
	
	      if (samples <= 1) {
	        return this.pv;
	      }
	
	      var currentTime = this.comp.renderedFrame / this.comp.globalData.frameRate;
	      var initFrame = currentTime - width;
	      var endFrame = currentTime + width;
	      var sampleFrequency = samples > 1 ? (endFrame - initFrame) / (samples - 1) : 1;
	      var i = 0;
	      var j = 0;
	      var value;
	
	      if (this.pv.length) {
	        value = createTypedArray('float32', this.pv.length);
	      } else {
	        value = 0;
	      }
	
	      var sampleValue;
	
	      while (i < samples) {
	        sampleValue = this.getValueAtTime(initFrame + i * sampleFrequency);
	
	        if (this.pv.length) {
	          for (j = 0; j < this.pv.length; j += 1) {
	            value[j] += sampleValue[j];
	          }
	        } else {
	          value += sampleValue;
	        }
	
	        i += 1;
	      }
	
	      if (this.pv.length) {
	        for (j = 0; j < this.pv.length; j += 1) {
	          value[j] /= samples;
	        }
	      } else {
	        value /= samples;
	      }
	
	      return value;
	    }
	
	    function getTransformValueAtTime(time) {
	      if (!this._transformCachingAtTime) {
	        this._transformCachingAtTime = {
	          v: new Matrix()
	        };
	      } /// /
	
	
	      var matrix = this._transformCachingAtTime.v;
	      matrix.cloneFromProps(this.pre.props);
	
	      if (this.appliedTransformations < 1) {
	        var anchor = this.a.getValueAtTime(time);
	        matrix.translate(-anchor[0] * this.a.mult, -anchor[1] * this.a.mult, anchor[2] * this.a.mult);
	      }
	
	      if (this.appliedTransformations < 2) {
	        var scale = this.s.getValueAtTime(time);
	        matrix.scale(scale[0] * this.s.mult, scale[1] * this.s.mult, scale[2] * this.s.mult);
	      }
	
	      if (this.sk && this.appliedTransformations < 3) {
	        var skew = this.sk.getValueAtTime(time);
	        var skewAxis = this.sa.getValueAtTime(time);
	        matrix.skewFromAxis(-skew * this.sk.mult, skewAxis * this.sa.mult);
	      }
	
	      if (this.r && this.appliedTransformations < 4) {
	        var rotation = this.r.getValueAtTime(time);
	        matrix.rotate(-rotation * this.r.mult);
	      } else if (!this.r && this.appliedTransformations < 4) {
	        var rotationZ = this.rz.getValueAtTime(time);
	        var rotationY = this.ry.getValueAtTime(time);
	        var rotationX = this.rx.getValueAtTime(time);
	        var orientation = this.or.getValueAtTime(time);
	        matrix.rotateZ(-rotationZ * this.rz.mult).rotateY(rotationY * this.ry.mult).rotateX(rotationX * this.rx.mult).rotateZ(-orientation[2] * this.or.mult).rotateY(orientation[1] * this.or.mult).rotateX(orientation[0] * this.or.mult);
	      }
	
	      if (this.data.p && this.data.p.s) {
	        var positionX = this.px.getValueAtTime(time);
	        var positionY = this.py.getValueAtTime(time);
	
	        if (this.data.p.z) {
	          var positionZ = this.pz.getValueAtTime(time);
	          matrix.translate(positionX * this.px.mult, positionY * this.py.mult, -positionZ * this.pz.mult);
	        } else {
	          matrix.translate(positionX * this.px.mult, positionY * this.py.mult, 0);
	        }
	      } else {
	        var position = this.p.getValueAtTime(time);
	        matrix.translate(position[0] * this.p.mult, position[1] * this.p.mult, -position[2] * this.p.mult);
	      }
	
	      return matrix; /// /
	    }
	
	    function getTransformStaticValueAtTime() {
	      return this.v.clone(new Matrix());
	    }
	
	    var getTransformProperty = TransformPropertyFactory.getTransformProperty;
	
	    TransformPropertyFactory.getTransformProperty = function (elem, data, container) {
	      var prop = getTransformProperty(elem, data, container);
	
	      if (prop.dynamicProperties.length) {
	        prop.getValueAtTime = getTransformValueAtTime.bind(prop);
	      } else {
	        prop.getValueAtTime = getTransformStaticValueAtTime.bind(prop);
	      }
	
	      prop.setGroupProperty = expressionHelpers.setGroupProperty;
	      return prop;
	    };
	
	    var propertyGetProp = PropertyFactory.getProp;
	
	    PropertyFactory.getProp = function (elem, data, type, mult, container) {
	      var prop = propertyGetProp(elem, data, type, mult, container); // prop.getVelocityAtTime = getVelocityAtTime;
	      // prop.loopOut = loopOut;
	      // prop.loopIn = loopIn;
	
	      if (prop.kf) {
	        prop.getValueAtTime = expressionHelpers.getValueAtTime.bind(prop);
	      } else {
	        prop.getValueAtTime = expressionHelpers.getStaticValueAtTime.bind(prop);
	      }
	
	      prop.setGroupProperty = expressionHelpers.setGroupProperty;
	      prop.loopOut = loopOut;
	      prop.loopIn = loopIn;
	      prop.smooth = smooth;
	      prop.getVelocityAtTime = expressionHelpers.getVelocityAtTime.bind(prop);
	      prop.getSpeedAtTime = expressionHelpers.getSpeedAtTime.bind(prop);
	      prop.numKeys = data.a === 1 ? data.k.length : 0;
	      prop.propertyIndex = data.ix;
	      var value = 0;
	
	      if (type !== 0) {
	        value = createTypedArray('float32', data.a === 1 ? data.k[0].s.length : data.k.length);
	      }
	
	      prop._cachingAtTime = {
	        lastFrame: initialDefaultFrame,
	        lastIndex: 0,
	        value: value
	      };
	      expressionHelpers.searchExpressions(elem, data, prop);
	
	      if (prop.k) {
	        container.addDynamicProperty(prop);
	      }
	
	      return prop;
	    };
	
	    function getShapeValueAtTime(frameNum) {
	      // For now this caching object is created only when needed instead of creating it when the shape is initialized.
	      if (!this._cachingAtTime) {
	        this._cachingAtTime = {
	          shapeValue: shapePool.clone(this.pv),
	          lastIndex: 0,
	          lastTime: initialDefaultFrame
	        };
	      }
	
	      frameNum *= this.elem.globalData.frameRate;
	      frameNum -= this.offsetTime;
	
	      if (frameNum !== this._cachingAtTime.lastTime) {
	        this._cachingAtTime.lastIndex = this._cachingAtTime.lastTime < frameNum ? this._caching.lastIndex : 0;
	        this._cachingAtTime.lastTime = frameNum;
	        this.interpolateShape(frameNum, this._cachingAtTime.shapeValue, this._cachingAtTime);
	      }
	
	      return this._cachingAtTime.shapeValue;
	    }
	
	    var ShapePropertyConstructorFunction = ShapePropertyFactory.getConstructorFunction();
	    var KeyframedShapePropertyConstructorFunction = ShapePropertyFactory.getKeyframedConstructorFunction();
	
	    function ShapeExpressions() {}
	
	    ShapeExpressions.prototype = {
	      vertices: function vertices(prop, time) {
	        if (this.k) {
	          this.getValue();
	        }
	
	        var shapePath = this.v;
	
	        if (time !== undefined) {
	          shapePath = this.getValueAtTime(time, 0);
	        }
	
	        var i;
	        var len = shapePath._length;
	        var vertices = shapePath[prop];
	        var points = shapePath.v;
	        var arr = createSizedArray(len);
	
	        for (i = 0; i < len; i += 1) {
	          if (prop === 'i' || prop === 'o') {
	            arr[i] = [vertices[i][0] - points[i][0], vertices[i][1] - points[i][1]];
	          } else {
	            arr[i] = [vertices[i][0], vertices[i][1]];
	          }
	        }
	
	        return arr;
	      },
	      points: function points(time) {
	        return this.vertices('v', time);
	      },
	      inTangents: function inTangents(time) {
	        return this.vertices('i', time);
	      },
	      outTangents: function outTangents(time) {
	        return this.vertices('o', time);
	      },
	      isClosed: function isClosed() {
	        return this.v.c;
	      },
	      pointOnPath: function pointOnPath(perc, time) {
	        var shapePath = this.v;
	
	        if (time !== undefined) {
	          shapePath = this.getValueAtTime(time, 0);
	        }
	
	        if (!this._segmentsLength) {
	          this._segmentsLength = bez.getSegmentsLength(shapePath);
	        }
	
	        var segmentsLength = this._segmentsLength;
	        var lengths = segmentsLength.lengths;
	        var lengthPos = segmentsLength.totalLength * perc;
	        var i = 0;
	        var len = lengths.length;
	        var accumulatedLength = 0;
	        var pt;
	
	        while (i < len) {
	          if (accumulatedLength + lengths[i].addedLength > lengthPos) {
	            var initIndex = i;
	            var endIndex = shapePath.c && i === len - 1 ? 0 : i + 1;
	            var segmentPerc = (lengthPos - accumulatedLength) / lengths[i].addedLength;
	            pt = bez.getPointInSegment(shapePath.v[initIndex], shapePath.v[endIndex], shapePath.o[initIndex], shapePath.i[endIndex], segmentPerc, lengths[i]);
	            break;
	          } else {
	            accumulatedLength += lengths[i].addedLength;
	          }
	
	          i += 1;
	        }
	
	        if (!pt) {
	          pt = shapePath.c ? [shapePath.v[0][0], shapePath.v[0][1]] : [shapePath.v[shapePath._length - 1][0], shapePath.v[shapePath._length - 1][1]];
	        }
	
	        return pt;
	      },
	      vectorOnPath: function vectorOnPath(perc, time, vectorType) {
	        // perc doesn't use triple equality because it can be a Number object as well as a primitive.
	        if (perc == 1) {
	          // eslint-disable-line eqeqeq
	          perc = this.v.c;
	        } else if (perc == 0) {
	          // eslint-disable-line eqeqeq
	          perc = 0.999;
	        }
	
	        var pt1 = this.pointOnPath(perc, time);
	        var pt2 = this.pointOnPath(perc + 0.001, time);
	        var xLength = pt2[0] - pt1[0];
	        var yLength = pt2[1] - pt1[1];
	        var magnitude = Math.sqrt(Math.pow(xLength, 2) + Math.pow(yLength, 2));
	
	        if (magnitude === 0) {
	          return [0, 0];
	        }
	
	        var unitVector = vectorType === 'tangent' ? [xLength / magnitude, yLength / magnitude] : [-yLength / magnitude, xLength / magnitude];
	        return unitVector;
	      },
	      tangentOnPath: function tangentOnPath(perc, time) {
	        return this.vectorOnPath(perc, time, 'tangent');
	      },
	      normalOnPath: function normalOnPath(perc, time) {
	        return this.vectorOnPath(perc, time, 'normal');
	      },
	      setGroupProperty: expressionHelpers.setGroupProperty,
	      getValueAtTime: expressionHelpers.getStaticValueAtTime
	    };
	    extendPrototype([ShapeExpressions], ShapePropertyConstructorFunction);
	    extendPrototype([ShapeExpressions], KeyframedShapePropertyConstructorFunction);
	    KeyframedShapePropertyConstructorFunction.prototype.getValueAtTime = getShapeValueAtTime;
	    KeyframedShapePropertyConstructorFunction.prototype.initiateExpression = ExpressionManager.initiateExpression;
	    var propertyGetShapeProp = ShapePropertyFactory.getShapeProp;
	
	    ShapePropertyFactory.getShapeProp = function (elem, data, type, arr, trims) {
	      var prop = propertyGetShapeProp(elem, data, type, arr, trims);
	      prop.propertyIndex = data.ix;
	      prop.lock = false;
	
	      if (type === 3) {
	        expressionHelpers.searchExpressions(elem, data.pt, prop);
	      } else if (type === 4) {
	        expressionHelpers.searchExpressions(elem, data.ks, prop);
	      }
	
	      if (prop.k) {
	        elem.addDynamicProperty(prop);
	      }
	
	      return prop;
	    };
	  }
	
	  function initialize$1() {
	    addPropertyDecorator();
	  }
	
	  function addDecorator() {
	    function searchExpressions() {
	      if (this.data.d.x) {
	        this.calculateExpression = ExpressionManager.initiateExpression.bind(this)(this.elem, this.data.d, this);
	        this.addEffect(this.getExpressionValue.bind(this));
	        return true;
	      }
	
	      return null;
	    }
	
	    TextProperty.prototype.getExpressionValue = function (currentValue, text) {
	      var newValue = this.calculateExpression(text);
	
	      if (currentValue.t !== newValue) {
	        var newData = {};
	        this.copyData(newData, currentValue);
	        newData.t = newValue.toString();
	        newData.__complete = false;
	        return newData;
	      }
	
	      return currentValue;
	    };
	
	    TextProperty.prototype.searchProperty = function () {
	      var isKeyframed = this.searchKeyframes();
	      var hasExpressions = this.searchExpressions();
	      this.kf = isKeyframed || hasExpressions;
	      return this.kf;
	    };
	
	    TextProperty.prototype.searchExpressions = searchExpressions;
	  }
	
	  function initialize() {
	    addDecorator();
	  }
	
	  function SVGComposableEffect() {}
	
	  SVGComposableEffect.prototype = {
	    createMergeNode: function createMergeNode(resultId, ins) {
	      var feMerge = createNS('feMerge');
	      feMerge.setAttribute('result', resultId);
	      var feMergeNode;
	      var i;
	
	      for (i = 0; i < ins.length; i += 1) {
	        feMergeNode = createNS('feMergeNode');
	        feMergeNode.setAttribute('in', ins[i]);
	        feMerge.appendChild(feMergeNode);
	        feMerge.appendChild(feMergeNode);
	      }
	
	      return feMerge;
	    }
	  };
	
	  var linearFilterValue = '0.3333 0.3333 0.3333 0 0 0.3333 0.3333 0.3333 0 0 0.3333 0.3333 0.3333 0 0 0 0 0';
	
	  function SVGTintFilter(filter, filterManager, elem, id, source) {
	    this.filterManager = filterManager;
	    var feColorMatrix = createNS('feColorMatrix');
	    feColorMatrix.setAttribute('type', 'matrix');
	    feColorMatrix.setAttribute('color-interpolation-filters', 'linearRGB');
	    feColorMatrix.setAttribute('values', linearFilterValue + ' 1 0');
	    this.linearFilter = feColorMatrix;
	    feColorMatrix.setAttribute('result', id + '_tint_1');
	    filter.appendChild(feColorMatrix);
	    feColorMatrix = createNS('feColorMatrix');
	    feColorMatrix.setAttribute('type', 'matrix');
	    feColorMatrix.setAttribute('color-interpolation-filters', 'sRGB');
	    feColorMatrix.setAttribute('values', '1 0 0 0 0 0 1 0 0 0 0 0 1 0 0 0 0 0 1 0');
	    feColorMatrix.setAttribute('result', id + '_tint_2');
	    filter.appendChild(feColorMatrix);
	    this.matrixFilter = feColorMatrix;
	    var feMerge = this.createMergeNode(id, [source, id + '_tint_1', id + '_tint_2']);
	    filter.appendChild(feMerge);
	  }
	
	  extendPrototype([SVGComposableEffect], SVGTintFilter);
	
	  SVGTintFilter.prototype.renderFrame = function (forceRender) {
	    if (forceRender || this.filterManager._mdf) {
	      var colorBlack = this.filterManager.effectElements[0].p.v;
	      var colorWhite = this.filterManager.effectElements[1].p.v;
	      var opacity = this.filterManager.effectElements[2].p.v / 100;
	      this.linearFilter.setAttribute('values', linearFilterValue + ' ' + opacity + ' 0');
	      this.matrixFilter.setAttribute('values', colorWhite[0] - colorBlack[0] + ' 0 0 0 ' + colorBlack[0] + ' ' + (colorWhite[1] - colorBlack[1]) + ' 0 0 0 ' + colorBlack[1] + ' ' + (colorWhite[2] - colorBlack[2]) + ' 0 0 0 ' + colorBlack[2] + ' 0 0 0 1 0');
	    }
	  };
	
	  function SVGFillFilter(filter, filterManager, elem, id) {
	    this.filterManager = filterManager;
	    var feColorMatrix = createNS('feColorMatrix');
	    feColorMatrix.setAttribute('type', 'matrix');
	    feColorMatrix.setAttribute('color-interpolation-filters', 'sRGB');
	    feColorMatrix.setAttribute('values', '1 0 0 0 0 0 1 0 0 0 0 0 1 0 0 0 0 0 1 0');
	    feColorMatrix.setAttribute('result', id);
	    filter.appendChild(feColorMatrix);
	    this.matrixFilter = feColorMatrix;
	  }
	
	  SVGFillFilter.prototype.renderFrame = function (forceRender) {
	    if (forceRender || this.filterManager._mdf) {
	      var color = this.filterManager.effectElements[2].p.v;
	      var opacity = this.filterManager.effectElements[6].p.v;
	      this.matrixFilter.setAttribute('values', '0 0 0 0 ' + color[0] + ' 0 0 0 0 ' + color[1] + ' 0 0 0 0 ' + color[2] + ' 0 0 0 ' + opacity + ' 0');
	    }
	  };
	
	  function SVGStrokeEffect(fil, filterManager, elem) {
	    this.initialized = false;
	    this.filterManager = filterManager;
	    this.elem = elem;
	    this.paths = [];
	  }
	
	  SVGStrokeEffect.prototype.initialize = function () {
	    var elemChildren = this.elem.layerElement.children || this.elem.layerElement.childNodes;
	    var path;
	    var groupPath;
	    var i;
	    var len;
	
	    if (this.filterManager.effectElements[1].p.v === 1) {
	      len = this.elem.maskManager.masksProperties.length;
	      i = 0;
	    } else {
	      i = this.filterManager.effectElements[0].p.v - 1;
	      len = i + 1;
	    }
	
	    groupPath = createNS('g');
	    groupPath.setAttribute('fill', 'none');
	    groupPath.setAttribute('stroke-linecap', 'round');
	    groupPath.setAttribute('stroke-dashoffset', 1);
	
	    for (i; i < len; i += 1) {
	      path = createNS('path');
	      groupPath.appendChild(path);
	      this.paths.push({
	        p: path,
	        m: i
	      });
	    }
	
	    if (this.filterManager.effectElements[10].p.v === 3) {
	      var mask = createNS('mask');
	      var id = createElementID();
	      mask.setAttribute('id', id);
	      mask.setAttribute('mask-type', 'alpha');
	      mask.appendChild(groupPath);
	      this.elem.globalData.defs.appendChild(mask);
	      var g = createNS('g');
	      g.setAttribute('mask', 'url(' + getLocationHref() + '#' + id + ')');
	
	      while (elemChildren[0]) {
	        g.appendChild(elemChildren[0]);
	      }
	
	      this.elem.layerElement.appendChild(g);
	      this.masker = mask;
	      groupPath.setAttribute('stroke', '#fff');
	    } else if (this.filterManager.effectElements[10].p.v === 1 || this.filterManager.effectElements[10].p.v === 2) {
	      if (this.filterManager.effectElements[10].p.v === 2) {
	        elemChildren = this.elem.layerElement.children || this.elem.layerElement.childNodes;
	
	        while (elemChildren.length) {
	          this.elem.layerElement.removeChild(elemChildren[0]);
	        }
	      }
	
	      this.elem.layerElement.appendChild(groupPath);
	      this.elem.layerElement.removeAttribute('mask');
	      groupPath.setAttribute('stroke', '#fff');
	    }
	
	    this.initialized = true;
	    this.pathMasker = groupPath;
	  };
	
	  SVGStrokeEffect.prototype.renderFrame = function (forceRender) {
	    if (!this.initialized) {
	      this.initialize();
	    }
	
	    var i;
	    var len = this.paths.length;
	    var mask;
	    var path;
	
	    for (i = 0; i < len; i += 1) {
	      if (this.paths[i].m !== -1) {
	        mask = this.elem.maskManager.viewData[this.paths[i].m];
	        path = this.paths[i].p;
	
	        if (forceRender || this.filterManager._mdf || mask.prop._mdf) {
	          path.setAttribute('d', mask.lastPath);
	        }
	
	        if (forceRender || this.filterManager.effectElements[9].p._mdf || this.filterManager.effectElements[4].p._mdf || this.filterManager.effectElements[7].p._mdf || this.filterManager.effectElements[8].p._mdf || mask.prop._mdf) {
	          var dasharrayValue;
	
	          if (this.filterManager.effectElements[7].p.v !== 0 || this.filterManager.effectElements[8].p.v !== 100) {
	            var s = Math.min(this.filterManager.effectElements[7].p.v, this.filterManager.effectElements[8].p.v) * 0.01;
	            var e = Math.max(this.filterManager.effectElements[7].p.v, this.filterManager.effectElements[8].p.v) * 0.01;
	            var l = path.getTotalLength();
	            dasharrayValue = '0 0 0 ' + l * s + ' ';
	            var lineLength = l * (e - s);
	            var segment = 1 + this.filterManager.effectElements[4].p.v * 2 * this.filterManager.effectElements[9].p.v * 0.01;
	            var units = Math.floor(lineLength / segment);
	            var j;
	
	            for (j = 0; j < units; j += 1) {
	              dasharrayValue += '1 ' + this.filterManager.effectElements[4].p.v * 2 * this.filterManager.effectElements[9].p.v * 0.01 + ' ';
	            }
	
	            dasharrayValue += '0 ' + l * 10 + ' 0 0';
	          } else {
	            dasharrayValue = '1 ' + this.filterManager.effectElements[4].p.v * 2 * this.filterManager.effectElements[9].p.v * 0.01;
	          }
	
	          path.setAttribute('stroke-dasharray', dasharrayValue);
	        }
	      }
	    }
	
	    if (forceRender || this.filterManager.effectElements[4].p._mdf) {
	      this.pathMasker.setAttribute('stroke-width', this.filterManager.effectElements[4].p.v * 2);
	    }
	
	    if (forceRender || this.filterManager.effectElements[6].p._mdf) {
	      this.pathMasker.setAttribute('opacity', this.filterManager.effectElements[6].p.v);
	    }
	
	    if (this.filterManager.effectElements[10].p.v === 1 || this.filterManager.effectElements[10].p.v === 2) {
	      if (forceRender || this.filterManager.effectElements[3].p._mdf) {
	        var color = this.filterManager.effectElements[3].p.v;
	        this.pathMasker.setAttribute('stroke', 'rgb(' + bmFloor(color[0] * 255) + ',' + bmFloor(color[1] * 255) + ',' + bmFloor(color[2] * 255) + ')');
	      }
	    }
	  };
	
	  function SVGTritoneFilter(filter, filterManager, elem, id) {
	    this.filterManager = filterManager;
	    var feColorMatrix = createNS('feColorMatrix');
	    feColorMatrix.setAttribute('type', 'matrix');
	    feColorMatrix.setAttribute('color-interpolation-filters', 'linearRGB');
	    feColorMatrix.setAttribute('values', '0.3333 0.3333 0.3333 0 0 0.3333 0.3333 0.3333 0 0 0.3333 0.3333 0.3333 0 0 0 0 0 1 0');
	    filter.appendChild(feColorMatrix);
	    var feComponentTransfer = createNS('feComponentTransfer');
	    feComponentTransfer.setAttribute('color-interpolation-filters', 'sRGB');
	    feComponentTransfer.setAttribute('result', id);
	    this.matrixFilter = feComponentTransfer;
	    var feFuncR = createNS('feFuncR');
	    feFuncR.setAttribute('type', 'table');
	    feComponentTransfer.appendChild(feFuncR);
	    this.feFuncR = feFuncR;
	    var feFuncG = createNS('feFuncG');
	    feFuncG.setAttribute('type', 'table');
	    feComponentTransfer.appendChild(feFuncG);
	    this.feFuncG = feFuncG;
	    var feFuncB = createNS('feFuncB');
	    feFuncB.setAttribute('type', 'table');
	    feComponentTransfer.appendChild(feFuncB);
	    this.feFuncB = feFuncB;
	    filter.appendChild(feComponentTransfer);
	  }
	
	  SVGTritoneFilter.prototype.renderFrame = function (forceRender) {
	    if (forceRender || this.filterManager._mdf) {
	      var color1 = this.filterManager.effectElements[0].p.v;
	      var color2 = this.filterManager.effectElements[1].p.v;
	      var color3 = this.filterManager.effectElements[2].p.v;
	      var tableR = color3[0] + ' ' + color2[0] + ' ' + color1[0];
	      var tableG = color3[1] + ' ' + color2[1] + ' ' + color1[1];
	      var tableB = color3[2] + ' ' + color2[2] + ' ' + color1[2];
	      this.feFuncR.setAttribute('tableValues', tableR);
	      this.feFuncG.setAttribute('tableValues', tableG);
	      this.feFuncB.setAttribute('tableValues', tableB);
	    }
	  };
	
	  function SVGProLevelsFilter(filter, filterManager, elem, id) {
	    this.filterManager = filterManager;
	    var effectElements = this.filterManager.effectElements;
	    var feComponentTransfer = createNS('feComponentTransfer'); // Red
	
	    if (effectElements[10].p.k || effectElements[10].p.v !== 0 || effectElements[11].p.k || effectElements[11].p.v !== 1 || effectElements[12].p.k || effectElements[12].p.v !== 1 || effectElements[13].p.k || effectElements[13].p.v !== 0 || effectElements[14].p.k || effectElements[14].p.v !== 1) {
	      this.feFuncR = this.createFeFunc('feFuncR', feComponentTransfer);
	    } // Green
	
	
	    if (effectElements[17].p.k || effectElements[17].p.v !== 0 || effectElements[18].p.k || effectElements[18].p.v !== 1 || effectElements[19].p.k || effectElements[19].p.v !== 1 || effectElements[20].p.k || effectElements[20].p.v !== 0 || effectElements[21].p.k || effectElements[21].p.v !== 1) {
	      this.feFuncG = this.createFeFunc('feFuncG', feComponentTransfer);
	    } // Blue
	
	
	    if (effectElements[24].p.k || effectElements[24].p.v !== 0 || effectElements[25].p.k || effectElements[25].p.v !== 1 || effectElements[26].p.k || effectElements[26].p.v !== 1 || effectElements[27].p.k || effectElements[27].p.v !== 0 || effectElements[28].p.k || effectElements[28].p.v !== 1) {
	      this.feFuncB = this.createFeFunc('feFuncB', feComponentTransfer);
	    } // Alpha
	
	
	    if (effectElements[31].p.k || effectElements[31].p.v !== 0 || effectElements[32].p.k || effectElements[32].p.v !== 1 || effectElements[33].p.k || effectElements[33].p.v !== 1 || effectElements[34].p.k || effectElements[34].p.v !== 0 || effectElements[35].p.k || effectElements[35].p.v !== 1) {
	      this.feFuncA = this.createFeFunc('feFuncA', feComponentTransfer);
	    } // RGB
	
	
	    if (this.feFuncR || this.feFuncG || this.feFuncB || this.feFuncA) {
	      feComponentTransfer.setAttribute('color-interpolation-filters', 'sRGB');
	      filter.appendChild(feComponentTransfer);
	    }
	
	    if (effectElements[3].p.k || effectElements[3].p.v !== 0 || effectElements[4].p.k || effectElements[4].p.v !== 1 || effectElements[5].p.k || effectElements[5].p.v !== 1 || effectElements[6].p.k || effectElements[6].p.v !== 0 || effectElements[7].p.k || effectElements[7].p.v !== 1) {
	      feComponentTransfer = createNS('feComponentTransfer');
	      feComponentTransfer.setAttribute('color-interpolation-filters', 'sRGB');
	      feComponentTransfer.setAttribute('result', id);
	      filter.appendChild(feComponentTransfer);
	      this.feFuncRComposed = this.createFeFunc('feFuncR', feComponentTransfer);
	      this.feFuncGComposed = this.createFeFunc('feFuncG', feComponentTransfer);
	      this.feFuncBComposed = this.createFeFunc('feFuncB', feComponentTransfer);
	    }
	  }
	
	  SVGProLevelsFilter.prototype.createFeFunc = function (type, feComponentTransfer) {
	    var feFunc = createNS(type);
	    feFunc.setAttribute('type', 'table');
	    feComponentTransfer.appendChild(feFunc);
	    return feFunc;
	  };
	
	  SVGProLevelsFilter.prototype.getTableValue = function (inputBlack, inputWhite, gamma, outputBlack, outputWhite) {
	    var cnt = 0;
	    var segments = 256;
	    var perc;
	    var min = Math.min(inputBlack, inputWhite);
	    var max = Math.max(inputBlack, inputWhite);
	    var table = Array.call(null, {
	      length: segments
	    });
	    var colorValue;
	    var pos = 0;
	    var outputDelta = outputWhite - outputBlack;
	    var inputDelta = inputWhite - inputBlack;
	
	    while (cnt <= 256) {
	      perc = cnt / 256;
	
	      if (perc <= min) {
	        colorValue = inputDelta < 0 ? outputWhite : outputBlack;
	      } else if (perc >= max) {
	        colorValue = inputDelta < 0 ? outputBlack : outputWhite;
	      } else {
	        colorValue = outputBlack + outputDelta * Math.pow((perc - inputBlack) / inputDelta, 1 / gamma);
	      }
	
	      table[pos] = colorValue;
	      pos += 1;
	      cnt += 256 / (segments - 1);
	    }
	
	    return table.join(' ');
	  };
	
	  SVGProLevelsFilter.prototype.renderFrame = function (forceRender) {
	    if (forceRender || this.filterManager._mdf) {
	      var val;
	      var effectElements = this.filterManager.effectElements;
	
	      if (this.feFuncRComposed && (forceRender || effectElements[3].p._mdf || effectElements[4].p._mdf || effectElements[5].p._mdf || effectElements[6].p._mdf || effectElements[7].p._mdf)) {
	        val = this.getTableValue(effectElements[3].p.v, effectElements[4].p.v, effectElements[5].p.v, effectElements[6].p.v, effectElements[7].p.v);
	        this.feFuncRComposed.setAttribute('tableValues', val);
	        this.feFuncGComposed.setAttribute('tableValues', val);
	        this.feFuncBComposed.setAttribute('tableValues', val);
	      }
	
	      if (this.feFuncR && (forceRender || effectElements[10].p._mdf || effectElements[11].p._mdf || effectElements[12].p._mdf || effectElements[13].p._mdf || effectElements[14].p._mdf)) {
	        val = this.getTableValue(effectElements[10].p.v, effectElements[11].p.v, effectElements[12].p.v, effectElements[13].p.v, effectElements[14].p.v);
	        this.feFuncR.setAttribute('tableValues', val);
	      }
	
	      if (this.feFuncG && (forceRender || effectElements[17].p._mdf || effectElements[18].p._mdf || effectElements[19].p._mdf || effectElements[20].p._mdf || effectElements[21].p._mdf)) {
	        val = this.getTableValue(effectElements[17].p.v, effectElements[18].p.v, effectElements[19].p.v, effectElements[20].p.v, effectElements[21].p.v);
	        this.feFuncG.setAttribute('tableValues', val);
	      }
	
	      if (this.feFuncB && (forceRender || effectElements[24].p._mdf || effectElements[25].p._mdf || effectElements[26].p._mdf || effectElements[27].p._mdf || effectElements[28].p._mdf)) {
	        val = this.getTableValue(effectElements[24].p.v, effectElements[25].p.v, effectElements[26].p.v, effectElements[27].p.v, effectElements[28].p.v);
	        this.feFuncB.setAttribute('tableValues', val);
	      }
	
	      if (this.feFuncA && (forceRender || effectElements[31].p._mdf || effectElements[32].p._mdf || effectElements[33].p._mdf || effectElements[34].p._mdf || effectElements[35].p._mdf)) {
	        val = this.getTableValue(effectElements[31].p.v, effectElements[32].p.v, effectElements[33].p.v, effectElements[34].p.v, effectElements[35].p.v);
	        this.feFuncA.setAttribute('tableValues', val);
	      }
	    }
	  };
	
	  function SVGDropShadowEffect(filter, filterManager, elem, id, source) {
	    var globalFilterSize = filterManager.container.globalData.renderConfig.filterSize;
	    var filterSize = filterManager.data.fs || globalFilterSize;
	    filter.setAttribute('x', filterSize.x || globalFilterSize.x);
	    filter.setAttribute('y', filterSize.y || globalFilterSize.y);
	    filter.setAttribute('width', filterSize.width || globalFilterSize.width);
	    filter.setAttribute('height', filterSize.height || globalFilterSize.height);
	    this.filterManager = filterManager;
	    var feGaussianBlur = createNS('feGaussianBlur');
	    feGaussianBlur.setAttribute('in', 'SourceAlpha');
	    feGaussianBlur.setAttribute('result', id + '_drop_shadow_1');
	    feGaussianBlur.setAttribute('stdDeviation', '0');
	    this.feGaussianBlur = feGaussianBlur;
	    filter.appendChild(feGaussianBlur);
	    var feOffset = createNS('feOffset');
	    feOffset.setAttribute('dx', '25');
	    feOffset.setAttribute('dy', '0');
	    feOffset.setAttribute('in', id + '_drop_shadow_1');
	    feOffset.setAttribute('result', id + '_drop_shadow_2');
	    this.feOffset = feOffset;
	    filter.appendChild(feOffset);
	    var feFlood = createNS('feFlood');
	    feFlood.setAttribute('flood-color', '#00ff00');
	    feFlood.setAttribute('flood-opacity', '1');
	    feFlood.setAttribute('result', id + '_drop_shadow_3');
	    this.feFlood = feFlood;
	    filter.appendChild(feFlood);
	    var feComposite = createNS('feComposite');
	    feComposite.setAttribute('in', id + '_drop_shadow_3');
	    feComposite.setAttribute('in2', id + '_drop_shadow_2');
	    feComposite.setAttribute('operator', 'in');
	    feComposite.setAttribute('result', id + '_drop_shadow_4');
	    filter.appendChild(feComposite);
	    var feMerge = this.createMergeNode(id, [id + '_drop_shadow_4', source]);
	    filter.appendChild(feMerge); //
	  }
	
	  extendPrototype([SVGComposableEffect], SVGDropShadowEffect);
	
	  SVGDropShadowEffect.prototype.renderFrame = function (forceRender) {
	    if (forceRender || this.filterManager._mdf) {
	      if (forceRender || this.filterManager.effectElements[4].p._mdf) {
	        this.feGaussianBlur.setAttribute('stdDeviation', this.filterManager.effectElements[4].p.v / 4);
	      }
	
	      if (forceRender || this.filterManager.effectElements[0].p._mdf) {
	        var col = this.filterManager.effectElements[0].p.v;
	        this.feFlood.setAttribute('flood-color', rgbToHex(Math.round(col[0] * 255), Math.round(col[1] * 255), Math.round(col[2] * 255)));
	      }
	
	      if (forceRender || this.filterManager.effectElements[1].p._mdf) {
	        this.feFlood.setAttribute('flood-opacity', this.filterManager.effectElements[1].p.v / 255);
	      }
	
	      if (forceRender || this.filterManager.effectElements[2].p._mdf || this.filterManager.effectElements[3].p._mdf) {
	        var distance = this.filterManager.effectElements[3].p.v;
	        var angle = (this.filterManager.effectElements[2].p.v - 90) * degToRads;
	        var x = distance * Math.cos(angle);
	        var y = distance * Math.sin(angle);
	        this.feOffset.setAttribute('dx', x);
	        this.feOffset.setAttribute('dy', y);
	      }
	    }
	  };
	
	  var _svgMatteSymbols = [];
	
	  function SVGMatte3Effect(filterElem, filterManager, elem) {
	    this.initialized = false;
	    this.filterManager = filterManager;
	    this.filterElem = filterElem;
	    this.elem = elem;
	    elem.matteElement = createNS('g');
	    elem.matteElement.appendChild(elem.layerElement);
	    elem.matteElement.appendChild(elem.transformedElement);
	    elem.baseElement = elem.matteElement;
	  }
	
	  SVGMatte3Effect.prototype.findSymbol = function (mask) {
	    var i = 0;
	    var len = _svgMatteSymbols.length;
	
	    while (i < len) {
	      if (_svgMatteSymbols[i] === mask) {
	        return _svgMatteSymbols[i];
	      }
	
	      i += 1;
	    }
	
	    return null;
	  };
	
	  SVGMatte3Effect.prototype.replaceInParent = function (mask, symbolId) {
	    var parentNode = mask.layerElement.parentNode;
	
	    if (!parentNode) {
	      return;
	    }
	
	    var children = parentNode.children;
	    var i = 0;
	    var len = children.length;
	
	    while (i < len) {
	      if (children[i] === mask.layerElement) {
	        break;
	      }
	
	      i += 1;
	    }
	
	    var nextChild;
	
	    if (i <= len - 2) {
	      nextChild = children[i + 1];
	    }
	
	    var useElem = createNS('use');
	    useElem.setAttribute('href', '#' + symbolId);
	
	    if (nextChild) {
	      parentNode.insertBefore(useElem, nextChild);
	    } else {
	      parentNode.appendChild(useElem);
	    }
	  };
	
	  SVGMatte3Effect.prototype.setElementAsMask = function (elem, mask) {
	    if (!this.findSymbol(mask)) {
	      var symbolId = createElementID();
	      var masker = createNS('mask');
	      masker.setAttribute('id', mask.layerId);
	      masker.setAttribute('mask-type', 'alpha');
	
	      _svgMatteSymbols.push(mask);
	
	      var defs = elem.globalData.defs;
	      defs.appendChild(masker);
	      var symbol = createNS('symbol');
	      symbol.setAttribute('id', symbolId);
	      this.replaceInParent(mask, symbolId);
	      symbol.appendChild(mask.layerElement);
	      defs.appendChild(symbol);
	      var useElem = createNS('use');
	      useElem.setAttribute('href', '#' + symbolId);
	      masker.appendChild(useElem);
	      mask.data.hd = false;
	      mask.show();
	    }
	
	    elem.setMatte(mask.layerId);
	  };
	
	  SVGMatte3Effect.prototype.initialize = function () {
	    var ind = this.filterManager.effectElements[0].p.v;
	    var elements = this.elem.comp.elements;
	    var i = 0;
	    var len = elements.length;
	
	    while (i < len) {
	      if (elements[i] && elements[i].data.ind === ind) {
	        this.setElementAsMask(this.elem, elements[i]);
	      }
	
	      i += 1;
	    }
	
	    this.initialized = true;
	  };
	
	  SVGMatte3Effect.prototype.renderFrame = function () {
	    if (!this.initialized) {
	      this.initialize();
	    }
	  };
	
	  function SVGGaussianBlurEffect(filter, filterManager, elem, id) {
	    // Outset the filter region by 100% on all sides to accommodate blur expansion.
	    filter.setAttribute('x', '-100%');
	    filter.setAttribute('y', '-100%');
	    filter.setAttribute('width', '300%');
	    filter.setAttribute('height', '300%');
	    this.filterManager = filterManager;
	    var feGaussianBlur = createNS('feGaussianBlur');
	    feGaussianBlur.setAttribute('result', id);
	    filter.appendChild(feGaussianBlur);
	    this.feGaussianBlur = feGaussianBlur;
	  }
	
	  SVGGaussianBlurEffect.prototype.renderFrame = function (forceRender) {
	    if (forceRender || this.filterManager._mdf) {
	      // Empirical value, matching AE's blur appearance.
	      var kBlurrinessToSigma = 0.3;
	      var sigma = this.filterManager.effectElements[0].p.v * kBlurrinessToSigma; // Dimensions mapping:
	      //
	      //   1 -> horizontal & vertical
	      //   2 -> horizontal only
	      //   3 -> vertical only
	      //
	
	      var dimensions = this.filterManager.effectElements[1].p.v;
	      var sigmaX = dimensions == 3 ? 0 : sigma; // eslint-disable-line eqeqeq
	
	      var sigmaY = dimensions == 2 ? 0 : sigma; // eslint-disable-line eqeqeq
	
	      this.feGaussianBlur.setAttribute('stdDeviation', sigmaX + ' ' + sigmaY); // Repeat edges mapping:
	      //
	      //   0 -> off -> duplicate
	      //   1 -> on  -> wrap
	
	      var edgeMode = this.filterManager.effectElements[2].p.v == 1 ? 'wrap' : 'duplicate'; // eslint-disable-line eqeqeq
	
	      this.feGaussianBlur.setAttribute('edgeMode', edgeMode);
	    }
	  };
	
	  function TransformEffect() {}
	
	  TransformEffect.prototype.init = function (effectsManager) {
	    this.effectsManager = effectsManager;
	    this.type = effectTypes.TRANSFORM_EFFECT;
	    this.matrix = new Matrix();
	    this.opacity = -1;
	    this._mdf = false;
	    this._opMdf = false;
	  };
	
	  TransformEffect.prototype.renderFrame = function (forceFrame) {
	    this._opMdf = false;
	    this._mdf = false;
	
	    if (forceFrame || this.effectsManager._mdf) {
	      var effectElements = this.effectsManager.effectElements;
	      var anchor = effectElements[0].p.v;
	      var position = effectElements[1].p.v;
	      var isUniformScale = effectElements[2].p.v === 1;
	      var scaleHeight = effectElements[3].p.v;
	      var scaleWidth = isUniformScale ? scaleHeight : effectElements[4].p.v;
	      var skew = effectElements[5].p.v;
	      var skewAxis = effectElements[6].p.v;
	      var rotation = effectElements[7].p.v;
	      this.matrix.reset();
	      this.matrix.translate(-anchor[0], -anchor[1], anchor[2]);
	      this.matrix.scale(scaleWidth * 0.01, scaleHeight * 0.01, 1);
	      this.matrix.rotate(-rotation * degToRads);
	      this.matrix.skewFromAxis(-skew * degToRads, (skewAxis + 90) * degToRads);
	      this.matrix.translate(position[0], position[1], 0);
	      this._mdf = true;
	
	      if (this.opacity !== effectElements[8].p.v) {
	        this.opacity = effectElements[8].p.v;
	        this._opMdf = true;
	      }
	    }
	  };
	
	  function SVGTransformEffect(_, filterManager) {
	    this.init(filterManager);
	  }
	
	  extendPrototype([TransformEffect], SVGTransformEffect);
	
	  function CVTransformEffect(effectsManager) {
	    this.init(effectsManager);
	  }
	
	  extendPrototype([TransformEffect], CVTransformEffect);
	
	  registerRenderer('canvas', CanvasRenderer);
	  registerRenderer('html', HybridRenderer);
	  registerRenderer('svg', SVGRenderer); // Registering shape modifiers
	
	  ShapeModifiers.registerModifier('tm', TrimModifier);
	  ShapeModifiers.registerModifier('pb', PuckerAndBloatModifier);
	  ShapeModifiers.registerModifier('rp', RepeaterModifier);
	  ShapeModifiers.registerModifier('rd', RoundCornersModifier);
	  ShapeModifiers.registerModifier('zz', ZigZagModifier);
	  ShapeModifiers.registerModifier('op', OffsetPathModifier); // Registering expression plugin
	
	  setExpressionsPlugin(Expressions);
	  setExpressionInterfaces(getInterface);
	  initialize$1();
	  initialize(); // Registering svg effects
	
	  registerEffect$1(20, SVGTintFilter, true);
	  registerEffect$1(21, SVGFillFilter, true);
	  registerEffect$1(22, SVGStrokeEffect, false);
	  registerEffect$1(23, SVGTritoneFilter, true);
	  registerEffect$1(24, SVGProLevelsFilter, true);
	  registerEffect$1(25, SVGDropShadowEffect, true);
	  registerEffect$1(28, SVGMatte3Effect, false);
	  registerEffect$1(29, SVGGaussianBlurEffect, true);
	  registerEffect$1(35, SVGTransformEffect, false);
	  registerEffect(35, CVTransformEffect);
	
	  return lottie;
	
	}));


/***/ }),
/* 149 */
/***/ (function(module, exports) {

	/* WEBPACK VAR INJECTION */(function(__webpack_amd_options__) {module.exports = __webpack_amd_options__;
	
	/* WEBPACK VAR INJECTION */}.call(exports, {}))

/***/ }),
/* 150 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function($) {'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var OffCanvas = exports.OffCanvas = function () {
	    // rewrite the below class for jquery:
	    function OffCanvas(el) {
	        _classCallCheck(this, OffCanvas);
	
	        this.selector = el;
	        this.isOpen = false;
	        this.addListeners();
	    }
	
	    _createClass(OffCanvas, [{
	        key: 'addListeners',
	        value: function addListeners() {
	            var _this = this;
	
	            $(document).on("click.canvas", '[data-open-canvas]', function (e) {
	                e.preventDefault();
	                _this.target = $(e.target).closest('[data-open-canvas]');
	
	                if (_this.target && !_this.isOpen) {
	                    _this.openCanvas(_this.target);
	                }
	            });
	
	            $(document).on("click.canvas", '[data-close-canvas]', function (e) {
	                e.preventDefault();
	                _this.target = $(e.target).closest('[data-close-canvas]');
	
	                if (_this.target && _this.isOpen) {
	                    _this.closeCanvas();
	                }
	            });
	
	            document.addEventListener('keydown', function (e) {
	                if (e.key === "Escape") {
	                    _this.closeCanvas();
	                }
	            });
	        }
	    }, {
	        key: 'openCanvas',
	        value: function openCanvas(target) {
	            this.isOpen = true;
	            this.selector.addClass('offcanvas--open');
	            $("html").addClass('offcanvas--open');
	        }
	    }, {
	        key: 'closeCanvas',
	        value: function closeCanvas() {
	            this.isOpen = false;
	            this.selector.removeClass('offcanvas--open');
	            $("html").removeClass('offcanvas--open');
	        }
	    }]);

	    return OffCanvas;
	}();
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(2)))

/***/ }),
/* 151 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ })
/******/ ]);


// WEBPACK FOOTER //
// app.min.9420a39f33e70b5a1ad0.js